var mA = Object.defineProperty;
var fA = Object.getPrototypeOf;
var vA = Reflect.get;
var Cp = (a) => {
  throw TypeError(a);
};
var AA = (a, t, e) => t in a ? mA(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var id = (a, t, e) => AA(a, typeof t != "symbol" ? t + "" : t, e), ad = (a, t, e) => t.has(a) || Cp("Cannot " + e);
var Te = (a, t, e) => (ad(a, t, "read from private field"), e ? e.call(a) : t.get(a)), Ie = (a, t, e) => t.has(a) ? Cp("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), Be = (a, t, e, i) => (ad(a, t, "write to private field"), i ? i.call(a, e) : t.set(a, e), e), Ue = (a, t, e) => (ad(a, t, "access private method"), e);
var Sp = (a, t, e) => vA(fA(a), e, t);
const yA = "0.5rem", xA = "#0C2A4DCC", wA = "0.25rem", Jd = "0.5rem", kA = "1rem", CA = "1.5rem", SA = "320px", $h = "640px", Em = "960px", Mm = "1280px", EA = "0.5rem";
var MA = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ri(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var Tm = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t, e) {
    a.exports ? (e.default = e, a.exports = t && t.document ? e(t) : e) : (t.Highcharts && t.Highcharts.error(16, !0), t.Highcharts = e(t));
  })(typeof window < "u" ? window : MA, function(t) {
    var e = {};
    function i(o, n, l, L) {
      !o.hasOwnProperty(n) && (o[n] = L.apply(null, l), t && typeof CustomEvent == "function" && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    return i(e, "Core/Globals.js", [], function() {
      var o, n;
      return (n = o || (o = {})).SVG_NS = "http://www.w3.org/2000/svg", n.product = "Highcharts", n.version = "11.4.8", n.win = t !== void 0 ? t : {}, n.doc = n.win.document, n.svg = n.doc && n.doc.createElementNS && !!n.doc.createElementNS(n.SVG_NS, "svg").createSVGRect, n.userAgent = n.win.navigator && n.win.navigator.userAgent || "", n.isChrome = n.win.chrome, n.isFirefox = n.userAgent.indexOf("Firefox") !== -1, n.isMS = /(edge|msie|trident)/i.test(n.userAgent) && !n.win.opera, n.isSafari = !n.isChrome && n.userAgent.indexOf("Safari") !== -1, n.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(n.userAgent), n.isWebKit = n.userAgent.indexOf("AppleWebKit") !== -1, n.deg2rad = 2 * Math.PI / 360, n.hasBidiBug = n.isFirefox && 4 > parseInt(n.userAgent.split("Firefox/")[1], 10), n.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], n.noop = function() {
      }, n.supportsPassiveEvents = function() {
        let l = !1;
        if (!n.isMS) {
          let L = Object.defineProperty({}, "passive", { get: function() {
            l = !0;
          } });
          n.win.addEventListener && n.win.removeEventListener && (n.win.addEventListener("testPassive", n.noop, L), n.win.removeEventListener("testPassive", n.noop, L));
        }
        return l;
      }(), n.charts = [], n.composed = [], n.dateFormats = {}, n.seriesTypes = {}, n.symbolSizes = {}, n.chartCount = 0, o;
    }), i(e, "Core/Utilities.js", [e["Core/Globals.js"]], function(o) {
      let n, { charts: l, doc: L, win: D } = o;
      function j(r, s, p, b) {
        let c = s ? "Highcharts error" : "Highcharts warning";
        r === 32 && (r = `${c}: Deprecated member`);
        let h = y(r), g = h ? `${c} #${r}: www.highcharts.com/errors/${r}/` : r.toString();
        if (b !== void 0) {
          let k = "";
          h && (g += "?"), E(b, function(P, O) {
            k += `
 - ${O}: ${P}`, h && (g += encodeURI(O) + "=" + encodeURI(P));
          }), g += k;
        }
        w(o, "displayError", { chart: p, code: r, message: g, params: b }, function() {
          if (s) throw Error(g);
          D.console && j.messages.indexOf(g) === -1 && console.warn(g);
        }), j.messages.push(g);
      }
      function I(r, s) {
        return parseInt(r, s || 10);
      }
      function B(r) {
        return typeof r == "string";
      }
      function R(r) {
        let s = Object.prototype.toString.call(r);
        return s === "[object Array]" || s === "[object Array Iterator]";
      }
      function N(r, s) {
        return !!r && typeof r == "object" && (!s || !R(r));
      }
      function x(r) {
        return N(r) && typeof r.nodeType == "number";
      }
      function T(r) {
        let s = r && r.constructor;
        return !!(N(r, !0) && !x(r) && s && s.name && s.name !== "Object");
      }
      function y(r) {
        return typeof r == "number" && !isNaN(r) && r < 1 / 0 && r > -1 / 0;
      }
      function S(r) {
        return r != null;
      }
      function u(r, s, p) {
        let b, c = B(s) && !S(p), h = (g, k) => {
          S(g) ? r.setAttribute(k, g) : c ? (b = r.getAttribute(k)) || k !== "class" || (b = r.getAttribute(k + "Name")) : r.removeAttribute(k);
        };
        return B(s) ? h(p, s) : E(s, h), b;
      }
      function A(r) {
        return R(r) ? r : [r];
      }
      function M(r, s) {
        let p;
        for (p in r || (r = {}), s) r[p] = s[p];
        return r;
      }
      function f() {
        let r = arguments, s = r.length;
        for (let p = 0; p < s; p++) {
          let b = r[p];
          if (b != null) return b;
        }
      }
      function m(r, s) {
        M(r.style, s);
      }
      function C(r) {
        return Math.pow(10, Math.floor(Math.log(r) / Math.LN10));
      }
      function F(r, s) {
        return r > 1e14 ? r : parseFloat(r.toPrecision(s || 14));
      }
      (j || (j = {})).messages = [], Math.easeInOutSine = function(r) {
        return -0.5 * (Math.cos(Math.PI * r) - 1);
      };
      let _ = Array.prototype.find ? function(r, s) {
        return r.find(s);
      } : function(r, s) {
        let p, b = r.length;
        for (p = 0; p < b; p++) if (s(r[p], p)) return r[p];
      };
      function E(r, s, p) {
        for (let b in r) Object.hasOwnProperty.call(r, b) && s.call(p || r[b], r[b], b, r);
      }
      function v(r, s, p) {
        function b(g, k) {
          let P = r.removeEventListener;
          P && P.call(r, g, k, !1);
        }
        function c(g) {
          let k, P;
          r.nodeName && (s ? (k = {})[s] = !0 : k = g, E(k, function(O, z) {
            if (g[z]) for (P = g[z].length; P--; ) b(z, g[z][P].fn);
          }));
        }
        let h = typeof r == "function" && r.prototype || r;
        if (Object.hasOwnProperty.call(h, "hcEvents")) {
          let g = h.hcEvents;
          if (s) {
            let k = g[s] || [];
            p ? (g[s] = k.filter(function(P) {
              return p !== P.fn;
            }), b(s, p)) : (c(g), g[s] = []);
          } else c(g), delete h.hcEvents;
        }
      }
      function w(r, s, p, b) {
        if (p = p || {}, L.createEvent && (r.dispatchEvent || r.fireEvent && r !== o)) {
          let c = L.createEvent("Events");
          c.initEvent(s, !0, !0), p = M(c, p), r.dispatchEvent ? r.dispatchEvent(p) : r.fireEvent(s, p);
        } else if (r.hcEvents) {
          p.target || M(p, { preventDefault: function() {
            p.defaultPrevented = !0;
          }, target: r, type: s });
          let c = [], h = r, g = !1;
          for (; h.hcEvents; ) Object.hasOwnProperty.call(h, "hcEvents") && h.hcEvents[s] && (c.length && (g = !0), c.unshift.apply(c, h.hcEvents[s])), h = Object.getPrototypeOf(h);
          g && c.sort((k, P) => k.order - P.order), c.forEach((k) => {
            k.fn.call(r, p) === !1 && p.preventDefault();
          });
        }
        b && !p.defaultPrevented && b.call(r, p);
      }
      E({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(r, s) {
        o[s] = function(p) {
          return j(32, !1, void 0, { [`Highcharts.${s}`]: `use Array.${r}` }), Array.prototype[r].apply(p, [].slice.call(arguments, 1));
        };
      });
      let d = function() {
        let r = Math.random().toString(36).substring(2, 9) + "-", s = 0;
        return function() {
          return "highcharts-" + (n ? "" : r) + s++;
        };
      }();
      return D.jQuery && (D.jQuery.fn.highcharts = function() {
        let r = [].slice.call(arguments);
        if (this[0]) return r[0] ? (new o[B(r[0]) ? r.shift() : "Chart"](this[0], r[0], r[1]), this) : l[u(this[0], "data-highcharts-chart")];
      }), { addEvent: function(r, s, p, b = {}) {
        let c = typeof r == "function" && r.prototype || r;
        Object.hasOwnProperty.call(c, "hcEvents") || (c.hcEvents = {});
        let h = c.hcEvents;
        o.Point && r instanceof o.Point && r.series && r.series.chart && (r.series.chart.runTrackerClick = !0);
        let g = r.addEventListener;
        g && g.call(r, s, p, !!o.supportsPassiveEvents && { passive: b.passive === void 0 ? s.indexOf("touch") !== -1 : b.passive, capture: !1 }), h[s] || (h[s] = []);
        let k = { fn: p, order: typeof b.order == "number" ? b.order : 1 / 0 };
        return h[s].push(k), h[s].sort((P, O) => P.order - O.order), function() {
          v(r, s, p);
        };
      }, arrayMax: function(r) {
        let s = r.length, p = r[0];
        for (; s--; ) r[s] > p && (p = r[s]);
        return p;
      }, arrayMin: function(r) {
        let s = r.length, p = r[0];
        for (; s--; ) r[s] < p && (p = r[s]);
        return p;
      }, attr: u, clamp: function(r, s, p) {
        return r > s ? r < p ? r : p : s;
      }, clearTimeout: function(r) {
        S(r) && clearTimeout(r);
      }, correctFloat: F, createElement: function(r, s, p, b, c) {
        let h = L.createElement(r);
        return s && M(h, s), c && m(h, { padding: "0", border: "none", margin: "0" }), p && m(h, p), b && b.appendChild(h), h;
      }, crisp: (r, s = 0, p) => {
        let b = s % 2 / 2, c = p ? -1 : 1;
        return (Math.round(r * c - b) + b) * c;
      }, css: m, defined: S, destroyObjectProperties: function(r, s, p) {
        E(r, function(b, c) {
          b !== s && (b != null && b.destroy) && b.destroy(), (b != null && b.destroy || !p) && delete r[c];
        });
      }, diffObjects: function(r, s, p, b) {
        let c = {};
        return function h(g, k, P, O) {
          let z = p ? k : g;
          E(g, function(W, G) {
            if (!O && b && b.indexOf(G) > -1 && k[G]) {
              W = A(W), P[G] = [];
              for (let Y = 0; Y < Math.max(W.length, k[G].length); Y++) k[G][Y] && (W[Y] === void 0 ? P[G][Y] = k[G][Y] : (P[G][Y] = {}, h(W[Y], k[G][Y], P[G][Y], O + 1)));
            } else N(W, !0) && !W.nodeType ? (P[G] = R(W) ? [] : {}, h(W, k[G] || {}, P[G], O + 1), Object.keys(P[G]).length !== 0 || G === "colorAxis" && O === 0 || delete P[G]) : (g[G] !== k[G] || G in g && !(G in k)) && G !== "__proto__" && G !== "constructor" && (P[G] = z[G]);
          });
        }(r, s, c, 0), c;
      }, discardElement: function(r) {
        r && r.parentElement && r.parentElement.removeChild(r);
      }, erase: function(r, s) {
        let p = r.length;
        for (; p--; ) if (r[p] === s) {
          r.splice(p, 1);
          break;
        }
      }, error: j, extend: M, extendClass: function(r, s) {
        let p = function() {
        };
        return p.prototype = new r(), M(p.prototype, s), p;
      }, find: _, fireEvent: w, getClosestDistance: function(r, s) {
        let p, b, c, h = !s;
        return r.forEach((g) => {
          if (g.length > 1) for (c = g.length - 1; c > 0; c--) (b = g[c] - g[c - 1]) < 0 && !h ? (s == null || s(), s = void 0) : b && (p === void 0 || b < p) && (p = b);
        }), p;
      }, getMagnitude: C, getNestedProperty: function(r, s) {
        let p = r.split(".");
        for (; p.length && S(s); ) {
          let b = p.shift();
          if (b === void 0 || b === "__proto__") return;
          if (b === "this") {
            let h;
            return N(s) && (h = s["@this"]), h != null ? h : s;
          }
          let c = s[b];
          if (!S(c) || typeof c == "function" || typeof c.nodeType == "number" || c === D) return;
          s = c;
        }
        return s;
      }, getStyle: function r(s, p, b) {
        let c;
        if (p === "width") {
          let g = Math.min(s.offsetWidth, s.scrollWidth), k = s.getBoundingClientRect && s.getBoundingClientRect().width;
          return k < g && k >= g - 1 && (g = Math.floor(k)), Math.max(0, g - (r(s, "padding-left", !0) || 0) - (r(s, "padding-right", !0) || 0));
        }
        if (p === "height") return Math.max(0, Math.min(s.offsetHeight, s.scrollHeight) - (r(s, "padding-top", !0) || 0) - (r(s, "padding-bottom", !0) || 0));
        let h = D.getComputedStyle(s, void 0);
        return h && (c = h.getPropertyValue(p), f(b, p !== "opacity") && (c = I(c))), c;
      }, inArray: function(r, s, p) {
        return j(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), s.indexOf(r, p);
      }, insertItem: function(r, s) {
        let p, b = r.options.index, c = s.length;
        for (p = r.options.isInternal ? c : 0; p < c + 1; p++) if (!s[p] || y(b) && b < f(s[p].options.index, s[p]._i) || s[p].options.isInternal) {
          s.splice(p, 0, r);
          break;
        }
        return p;
      }, isArray: R, isClass: T, isDOMElement: x, isFunction: function(r) {
        return typeof r == "function";
      }, isNumber: y, isObject: N, isString: B, keys: function(r) {
        return j(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(r);
      }, merge: function() {
        let r, s = arguments, p = {}, b = function(h, g) {
          return typeof h != "object" && (h = {}), E(g, function(k, P) {
            P !== "__proto__" && P !== "constructor" && (!N(k, !0) || T(k) || x(k) ? h[P] = g[P] : h[P] = b(h[P] || {}, k));
          }), h;
        };
        s[0] === !0 && (p = s[1], s = Array.prototype.slice.call(s, 2));
        let c = s.length;
        for (r = 0; r < c; r++) p = b(p, s[r]);
        return p;
      }, normalizeTickInterval: function(r, s, p, b, c) {
        let h, g = r;
        p = f(p, C(r));
        let k = r / p;
        for (!s && (s = c ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], b === !1 && (p === 1 ? s = s.filter(function(P) {
          return P % 1 == 0;
        }) : p <= 0.1 && (s = [1 / p]))), h = 0; h < s.length && (g = s[h], (!c || !(g * p >= r)) && (c || !(k <= (s[h] + (s[h + 1] || s[h])) / 2))); h++) ;
        return F(g * p, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: E, offset: function(r) {
        let s = L.documentElement, p = r.parentElement || r.parentNode ? r.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: p.top + (D.pageYOffset || s.scrollTop) - (s.clientTop || 0), left: p.left + (D.pageXOffset || s.scrollLeft) - (s.clientLeft || 0), width: p.width, height: p.height };
      }, pad: function(r, s, p) {
        return Array((s || 2) + 1 - String(r).replace("-", "").length).join(p || "0") + r;
      }, pick: f, pInt: I, pushUnique: function(r, s) {
        return 0 > r.indexOf(s) && !!r.push(s);
      }, relativeLength: function(r, s, p) {
        return /%$/.test(r) ? s * parseFloat(r) / 100 + (p || 0) : parseFloat(r);
      }, removeEvent: v, replaceNested: function(r, ...s) {
        let p, b;
        do
          for (b of (p = r, s)) r = r.replace(b[0], b[1]);
        while (r !== p);
        return r;
      }, splat: A, stableSort: function(r, s) {
        let p, b, c = r.length;
        for (b = 0; b < c; b++) r[b].safeI = b;
        for (r.sort(function(h, g) {
          return (p = s(h, g)) === 0 ? h.safeI - g.safeI : p;
        }), b = 0; b < c; b++) delete r[b].safeI;
      }, syncTimeout: function(r, s, p) {
        return s > 0 ? setTimeout(r, s, p) : (r.call(0, p), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: d, useSerialIds: function(r) {
        return n = f(r, n);
      }, wrap: function(r, s, p) {
        let b = r[s];
        r[s] = function() {
          let c = arguments, h = this;
          return p.apply(this, [function() {
            return b.apply(h, arguments.length ? arguments : c);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), i(e, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), i(e, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), i(e, "Core/Time.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: l } = o, { defined: L, error: D, extend: j, isNumber: I, isObject: B, merge: R, objectEach: N, pad: x, pick: T, splat: y, timeUnits: S } = n, u = o.isSafari && l.Intl && l.Intl.DateTimeFormat.prototype.formatRange, A = o.isSafari && l.Intl && !l.Intl.DateTimeFormat.prototype.formatRange;
      class M {
        constructor(m) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = l.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(m);
        }
        get(m, C) {
          if (this.variableTimezone || this.timezoneOffset) {
            let F = C.getTime(), _ = F - this.getTimezoneOffset(C);
            C.setTime(_);
            let E = C["getUTC" + m]();
            return C.setTime(F), E;
          }
          return this.useUTC ? C["getUTC" + m]() : C["get" + m]();
        }
        set(m, C, F) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (m === "Milliseconds" || m === "Seconds" || m === "Minutes" && this.getTimezoneOffset(C) % 36e5 == 0) return C["setUTC" + m](F);
            let _ = this.getTimezoneOffset(C), E = C.getTime() - _;
            C.setTime(E), C["setUTC" + m](F);
            let v = this.getTimezoneOffset(C);
            return E = C.getTime() + v, C.setTime(E);
          }
          return this.useUTC || u && m === "FullYear" ? C["setUTC" + m](F) : C["set" + m](F);
        }
        update(m = {}) {
          let C = T(m.useUTC, !0);
          this.options = m = R(!0, this.options, m), this.Date = m.Date || l.Date || Date, this.useUTC = C, this.timezoneOffset = C && m.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = C && !!(m.getTimezoneOffset || m.timezone);
        }
        makeTime(m, C, F, _, E, v) {
          let w, d, r;
          return this.useUTC ? (w = this.Date.UTC.apply(0, arguments), d = this.getTimezoneOffset(w), w += d, d !== (r = this.getTimezoneOffset(w)) ? w += r - d : d - 36e5 !== this.getTimezoneOffset(w - 36e5) || A || (w -= 36e5)) : w = new this.Date(m, C, T(F, 1), T(_, 0), T(E, 0), T(v, 0)).getTime(), w;
        }
        timezoneOffsetFunction() {
          let m = this, C = this.options, F = C.getTimezoneOffset;
          return this.useUTC ? C.timezone ? (_) => {
            try {
              let E = `shortOffset,${C.timezone || ""}`, [v, w, d, r, s = 0] = (M.formatCache[E] = M.formatCache[E] || Intl.DateTimeFormat("en", { timeZone: C.timezone, timeZoneName: "shortOffset" })).format(_).split(/(GMT|:)/).map(Number), p = -(36e5 * (d + s / 60));
              if (I(p)) return p;
            } catch {
              D(34);
            }
            return 0;
          } : this.useUTC && F ? (_) => 6e4 * F(_.valueOf()) : () => 6e4 * (m.timezoneOffset || 0) : (_) => 6e4 * new Date(_.toString()).getTimezoneOffset();
        }
        dateFormat(m, C, F) {
          if (!L(C) || isNaN(C)) return o.defaultOptions.lang && o.defaultOptions.lang.invalidDate || "";
          m = T(m, "%Y-%m-%d %H:%M:%S");
          let _ = this, E = new this.Date(C), v = this.get("Hours", E), w = this.get("Day", E), d = this.get("Date", E), r = this.get("Month", E), s = this.get("FullYear", E), p = o.defaultOptions.lang, b = p && p.weekdays, c = p && p.shortWeekdays;
          return N(j({ a: c ? c[w] : b[w].substr(0, 3), A: b[w], d: x(d), e: x(d, 2, " "), w, b: p.shortMonths[r], B: p.months[r], m: x(r + 1), o: r + 1, y: s.toString().substr(2, 2), Y: s, H: x(v), k: v, I: x(v % 12 || 12), l: v % 12 || 12, M: x(this.get("Minutes", E)), p: v < 12 ? "AM" : "PM", P: v < 12 ? "am" : "pm", S: x(this.get("Seconds", E)), L: x(Math.floor(C % 1e3), 3) }, o.dateFormats), function(h, g) {
            for (; m.indexOf("%" + g) !== -1; ) m = m.replace("%" + g, typeof h == "function" ? h.call(_, C) : h);
          }), F ? m.substr(0, 1).toUpperCase() + m.substr(1) : m;
        }
        resolveDTLFormat(m) {
          return B(m, !0) ? m : { main: (m = y(m))[0], from: m[1], to: m[2] };
        }
        getTimeTicks(m, C, F, _) {
          let E, v, w, d, r = this, s = r.Date, p = [], b = {}, c = new s(C), h = m.unitRange, g = m.count || 1;
          if (_ = T(_, 1), L(C)) {
            r.set("Milliseconds", c, h >= S.second ? 0 : g * Math.floor(r.get("Milliseconds", c) / g)), h >= S.second && r.set("Seconds", c, h >= S.minute ? 0 : g * Math.floor(r.get("Seconds", c) / g)), h >= S.minute && r.set("Minutes", c, h >= S.hour ? 0 : g * Math.floor(r.get("Minutes", c) / g)), h >= S.hour && r.set("Hours", c, h >= S.day ? 0 : g * Math.floor(r.get("Hours", c) / g)), h >= S.day && r.set("Date", c, h >= S.month ? 1 : Math.max(1, g * Math.floor(r.get("Date", c) / g))), h >= S.month && (r.set("Month", c, h >= S.year ? 0 : g * Math.floor(r.get("Month", c) / g)), v = r.get("FullYear", c)), h >= S.year && (v -= v % g, r.set("FullYear", c, v)), h === S.week && (d = r.get("Day", c), r.set("Date", c, r.get("Date", c) - d + _ + (d < _ ? -7 : 0))), v = r.get("FullYear", c);
            let k = r.get("Month", c), P = r.get("Date", c), O = r.get("Hours", c);
            C = c.getTime(), (r.variableTimezone || !r.useUTC) && L(F) && (w = F - C > 4 * S.month || r.getTimezoneOffset(C) !== r.getTimezoneOffset(F));
            let z = c.getTime();
            for (E = 1; z < F; ) p.push(z), h === S.year ? z = r.makeTime(v + E * g, 0) : h === S.month ? z = r.makeTime(v, k + E * g) : w && (h === S.day || h === S.week) ? z = r.makeTime(v, k, P + E * g * (h === S.day ? 1 : 7)) : w && h === S.hour && g > 1 ? z = r.makeTime(v, k, P, O + E * g) : z += h * g, E++;
            p.push(z), h <= S.hour && p.length < 1e4 && p.forEach(function(W) {
              W % 18e5 == 0 && r.dateFormat("%H%M%S%L", W) === "000000000" && (b[W] = "day");
            });
          }
          return p.info = j(m, { higherRanks: b, totalRange: h * g }), p;
        }
        getDateFormat(m, C, F, _) {
          let E = this.dateFormat("%m-%d %H:%M:%S.%L", C), v = "01-01 00:00:00.000", w = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, d = "millisecond", r = d;
          for (d in S) {
            if (m === S.week && +this.dateFormat("%w", C) === F && E.substr(6) === v.substr(6)) {
              d = "week";
              break;
            }
            if (S[d] > m) {
              d = r;
              break;
            }
            if (w[d] && E.substr(w[d]) !== v.substr(w[d])) break;
            d !== "week" && (r = d);
          }
          return this.resolveDTLFormat(_[d]).main;
        }
      }
      return M.formatCache = {}, M;
    }), i(e, "Core/Defaults.js", [e["Core/Chart/ChartDefaults.js"], e["Core/Globals.js"], e["Core/Color/Palettes.js"], e["Core/Time.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { isTouchDevice: j } = n, { fireEvent: I, merge: B } = D, R = { colors: l.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: o, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: j ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      R.chart.styledMode = !1;
      let N = new L(R.time);
      return { defaultOptions: R, defaultTime: N, getOptions: function() {
        return R;
      }, setOptions: function(x) {
        return I(n, "setOptions", { options: x }), B(!0, R, x), (x.time || x.global) && (n.time ? n.time.update(B(R.global, R.time, x.global, x.time)) : n.time = N), R;
      } };
    }), i(e, "Core/Color/Color.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isNumber: l, merge: L, pInt: D } = n;
      class j {
        static parse(B) {
          return B ? new j(B) : j.None;
        }
        constructor(B) {
          let R, N, x, T;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = B;
          let y = o.Color;
          if (y && y !== j) return new y(B);
          if (typeof B == "object" && B.stops !== void 0) this.stops = B.stops.map((S) => new j(S[1]));
          else if (typeof B == "string") {
            if (this.input = B = j.names[B.toLowerCase()] || B, B.charAt(0) === "#") {
              let S = B.length, u = parseInt(B.substr(1), 16);
              S === 7 ? N = [(16711680 & u) >> 16, (65280 & u) >> 8, 255 & u, 1] : S === 4 && (N = [(3840 & u) >> 4 | (3840 & u) >> 8, (240 & u) >> 4 | 240 & u, (15 & u) << 4 | 15 & u, 1]);
            }
            if (!N) for (x = j.parsers.length; x-- && !N; ) (R = (T = j.parsers[x]).regex.exec(B)) && (N = T.parse(R));
          }
          N && (this.rgba = N);
        }
        get(B) {
          let R = this.input, N = this.rgba;
          if (typeof R == "object" && this.stops !== void 0) {
            let x = L(R);
            return x.stops = [].slice.call(x.stops), this.stops.forEach((T, y) => {
              x.stops[y] = [x.stops[y][0], T.get(B)];
            }), x;
          }
          return N && l(N[0]) ? B !== "rgb" && (B || N[3] !== 1) ? B === "a" ? `${N[3]}` : "rgba(" + N.join(",") + ")" : "rgb(" + N[0] + "," + N[1] + "," + N[2] + ")" : R;
        }
        brighten(B) {
          let R = this.rgba;
          if (this.stops) this.stops.forEach(function(N) {
            N.brighten(B);
          });
          else if (l(B) && B !== 0) for (let N = 0; N < 3; N++) R[N] += D(255 * B), R[N] < 0 && (R[N] = 0), R[N] > 255 && (R[N] = 255);
          return this;
        }
        setOpacity(B) {
          return this.rgba[3] = B, this;
        }
        tweenTo(B, R) {
          let N = this.rgba, x = B.rgba;
          if (!l(N[0]) || !l(x[0])) return B.input || "none";
          let T = x[3] !== 1 || N[3] !== 1;
          return (T ? "rgba(" : "rgb(") + Math.round(x[0] + (N[0] - x[0]) * (1 - R)) + "," + Math.round(x[1] + (N[1] - x[1]) * (1 - R)) + "," + Math.round(x[2] + (N[2] - x[2]) * (1 - R)) + (T ? "," + (x[3] + (N[3] - x[3]) * (1 - R)) : "") + ")";
        }
      }
      return j.names = { white: "#ffffff", black: "#000000" }, j.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(I) {
        return [D(I[1]), D(I[2]), D(I[3]), parseFloat(I[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(I) {
        return [D(I[1]), D(I[2]), D(I[3]), 1];
      } }], j.None = new j(""), j;
    }), i(e, "Core/Animation/Fx.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { parse: L } = o, { win: D } = n, { isNumber: j, objectEach: I } = l;
      class B {
        constructor(N, x, T) {
          this.pos = NaN, this.options = x, this.elem = N, this.prop = T;
        }
        dSetter() {
          let N = this.paths, x = N && N[0], T = N && N[1], y = this.now || 0, S = [];
          if (y !== 1 && x && T)
            if (x.length === T.length && y < 1) for (let u = 0; u < T.length; u++) {
              let A = x[u], M = T[u], f = [];
              for (let m = 0; m < M.length; m++) {
                let C = A[m], F = M[m];
                j(C) && j(F) && !(M[0] === "A" && (m === 4 || m === 5)) ? f[m] = C + y * (F - C) : f[m] = F;
              }
              S.push(f);
            }
            else S = T;
          else S = this.toD || [];
          this.elem.attr("d", S, void 0, !0);
        }
        update() {
          let N = this.elem, x = this.prop, T = this.now, y = this.options.step;
          this[x + "Setter"] ? this[x + "Setter"]() : N.attr ? N.element && N.attr(x, T, null, !0) : N.style[x] = T + this.unit, y && y.call(N, T, this);
        }
        run(N, x, T) {
          let y = this, S = y.options, u = function(f) {
            return !u.stopped && y.step(f);
          }, A = D.requestAnimationFrame || function(f) {
            setTimeout(f, 13);
          }, M = function() {
            for (let f = 0; f < B.timers.length; f++) B.timers[f]() || B.timers.splice(f--, 1);
            B.timers.length && A(M);
          };
          N !== x || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = N, this.end = x, this.unit = T, this.now = this.start, this.pos = 0, u.elem = this.elem, u.prop = this.prop, u() && B.timers.push(u) === 1 && A(M)) : (delete S.curAnim[this.prop], S.complete && Object.keys(S.curAnim).length === 0 && S.complete.call(this.elem));
        }
        step(N) {
          let x, T, y = +/* @__PURE__ */ new Date(), S = this.options, u = this.elem, A = S.complete, M = S.duration, f = S.curAnim;
          return u.attr && !u.element ? x = !1 : N || y >= M + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), f[this.prop] = !0, T = !0, I(f, function(m) {
            m !== !0 && (T = !1);
          }), T && A && A.call(u), x = !1) : (this.pos = S.easing((y - this.startTime) / M), this.now = this.start + (this.end - this.start) * this.pos, this.update(), x = !0), x;
        }
        initPath(N, x, T) {
          let y = N.startX, S = N.endX, u = T.slice(), A = N.isArea, M = A ? 2 : 1, f = x && T.length > x.length && T.hasStackedCliffs, m, C, F, _, E = x && x.slice();
          if (!E || f) return [u, u];
          function v(d, r) {
            for (; d.length < C; ) {
              let s = d[0], p = r[C - d.length];
              if (p && s[0] === "M" && (p[0] === "C" ? d[0] = ["C", s[1], s[2], s[1], s[2], s[1], s[2]] : d[0] = ["L", s[1], s[2]]), d.unshift(s), A) {
                let b = d.pop();
                d.push(d[d.length - 1], b);
              }
            }
          }
          function w(d) {
            for (; d.length < C; ) {
              let r = d[Math.floor(d.length / M) - 1].slice();
              if (r[0] === "C" && (r[1] = r[5], r[2] = r[6]), A) {
                let s = d[Math.floor(d.length / M)].slice();
                d.splice(d.length / 2, 0, r, s);
              } else d.push(r);
            }
          }
          if (y && S && S.length) {
            for (F = 0; F < y.length; F++) {
              if (y[F] === S[0]) {
                m = F;
                break;
              }
              if (y[0] === S[S.length - y.length + F]) {
                m = F, _ = !0;
                break;
              }
              if (y[y.length - 1] === S[S.length - y.length + F]) {
                m = y.length - F;
                break;
              }
            }
            m === void 0 && (E = []);
          }
          return E.length && j(m) && (C = u.length + m * M, _ ? (v(E, u), w(u)) : (v(u, E), w(E))), [E, u];
        }
        fillSetter() {
          B.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, L(this.start).tweenTo(L(this.end), this.pos), void 0, !0);
        }
      }
      return B.timers = [], B;
    }), i(e, "Core/Animation/AnimationUtilities.js", [e["Core/Animation/Fx.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defined: l, getStyle: L, isArray: D, isNumber: j, isObject: I, merge: B, objectEach: R, pick: N } = n;
      function x(y) {
        return I(y) ? B({ duration: 500, defer: 0 }, y) : { duration: y ? 500 : 0, defer: 0 };
      }
      function T(y, S) {
        let u = o.timers.length;
        for (; u--; ) o.timers[u].elem !== y || S && S !== o.timers[u].prop || (o.timers[u].stopped = !0);
      }
      return { animate: function(y, S, u) {
        let A, M = "", f, m, C;
        I(u) || (C = arguments, u = { duration: C[2], easing: C[3], complete: C[4] }), j(u.duration) || (u.duration = 400), u.easing = typeof u.easing == "function" ? u.easing : Math[u.easing] || Math.easeInOutSine, u.curAnim = B(S), R(S, function(F, _) {
          T(y, _), m = new o(y, u, _), f = void 0, _ === "d" && D(S.d) ? (m.paths = m.initPath(y, y.pathArray, S.d), m.toD = S.d, A = 0, f = 1) : y.attr ? A = y.attr(_) : (A = parseFloat(L(y, _)) || 0, _ !== "opacity" && (M = "px")), f || (f = F), typeof f == "string" && f.match("px") && (f = f.replace(/px/g, "")), m.run(A, f, M);
        });
      }, animObject: x, getDeferredAnimation: function(y, S, u) {
        let A = x(S), M = u ? [u] : y.series, f = 0, m = 0;
        return M.forEach((C) => {
          let F = x(C.options.animation);
          f = I(S) && l(S.defer) ? A.defer : Math.max(f, F.duration + F.defer), m = Math.min(A.duration, F.duration);
        }), y.renderer.forExport && (f = 0), { defer: Math.max(0, f - m), duration: Math.min(f, m) };
      }, setAnimation: function(y, S) {
        S.renderer.globalAnimation = N(y, S.options.chart.animation, !0);
      }, stop: T };
    }), i(e, "Core/Renderer/HTML/AST.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { SVG_NS: l, win: L } = o, { attr: D, createElement: j, css: I, error: B, isFunction: R, isString: N, objectEach: x, splat: T } = n, { trustedTypes: y } = L, S = y && R(y.createPolicy) && y.createPolicy("highcharts", { createHTML: (f) => f }), u = S ? S.createHTML("") : "", A = function() {
        try {
          return !!new DOMParser().parseFromString(u, "text/html");
        } catch {
          return !1;
        }
      }();
      class M {
        static filterUserAttributes(m) {
          return x(m, (C, F) => {
            let _ = !0;
            M.allowedAttributes.indexOf(F) === -1 && (_ = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(F) !== -1 && (_ = N(C) && M.allowedReferences.some((E) => C.indexOf(E) === 0)), _ || (B(33, !1, void 0, { "Invalid attribute in config": `${F}` }), delete m[F]), N(C) && m[F] && (m[F] = C.replace(/</g, "&lt;"));
          }), m;
        }
        static parseStyle(m) {
          return m.split(";").reduce((C, F) => {
            let _ = F.split(":").map((v) => v.trim()), E = _.shift();
            return E && _.length && (C[E.replace(/-([a-z])/g, (v) => v[1].toUpperCase())] = _.join(":")), C;
          }, {});
        }
        static setElementHTML(m, C) {
          m.innerHTML = M.emptyHTML, C && new M(C).addToDOM(m);
        }
        constructor(m) {
          this.nodes = typeof m == "string" ? this.parseMarkup(m) : m;
        }
        addToDOM(m) {
          return function C(F, _) {
            let E;
            return T(F).forEach(function(v) {
              let w, d = v.tagName, r = v.textContent ? o.doc.createTextNode(v.textContent) : void 0, s = M.bypassHTMLFiltering;
              if (d)
                if (d === "#text") w = r;
                else if (M.allowedTags.indexOf(d) !== -1 || s) {
                  let p = d === "svg" ? l : _.namespaceURI || l, b = o.doc.createElementNS(p, d), c = v.attributes || {};
                  x(v, function(h, g) {
                    g !== "tagName" && g !== "attributes" && g !== "children" && g !== "style" && g !== "textContent" && (c[g] = h);
                  }), D(b, s ? c : M.filterUserAttributes(c)), v.style && I(b, v.style), r && b.appendChild(r), C(v.children || [], b), w = b;
                } else B(33, !1, void 0, { "Invalid tagName in config": d });
              w && _.appendChild(w), E = w;
            }), E;
          }(this.nodes, m);
        }
        parseMarkup(m) {
          let C, F = [];
          if (m = m.trim().replace(/ style=(["'])/g, " data-style=$1"), A) C = new DOMParser().parseFromString(S ? S.createHTML(m) : m, "text/html");
          else {
            let E = j("div");
            E.innerHTML = m, C = { body: E };
          }
          let _ = (E, v) => {
            let w = E.nodeName.toLowerCase(), d = { tagName: w };
            w === "#text" && (d.textContent = E.textContent || "");
            let r = E.attributes;
            if (r) {
              let s = {};
              [].forEach.call(r, (p) => {
                p.name === "data-style" ? d.style = M.parseStyle(p.value) : s[p.name] = p.value;
              }), d.attributes = s;
            }
            if (E.childNodes.length) {
              let s = [];
              [].forEach.call(E.childNodes, (p) => {
                _(p, s);
              }), s.length && (d.children = s);
            }
            v.push(d);
          };
          return [].forEach.call(C.body.childNodes, (E) => _(E, F)), F;
        }
      }
      return M.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], M.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], M.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], M.emptyHTML = u, M.bypassHTMLFiltering = !1, M;
    }), i(e, "Core/Templating.js", [e["Core/Defaults.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defaultOptions: l, defaultTime: L } = o, { extend: D, getNestedProperty: j, isArray: I, isNumber: B, isObject: R, pick: N, pInt: x } = n, T = { add: (u, A) => u + A, divide: (u, A) => A !== 0 ? u / A : "", eq: (u, A) => u == A, each: function(u) {
        let A = arguments[arguments.length - 1];
        return !!I(u) && u.map((M, f) => y(A.body, D(R(M) ? M : { "@this": M }, { "@index": f, "@first": f === 0, "@last": f === u.length - 1 }))).join("");
      }, ge: (u, A) => u >= A, gt: (u, A) => u > A, if: (u) => !!u, le: (u, A) => u <= A, lt: (u, A) => u < A, multiply: (u, A) => u * A, ne: (u, A) => u != A, subtract: (u, A) => u - A, unless: (u) => !u };
      function y(u = "", A, M) {
        let f = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, m = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, C = [], F = /f$/, _ = /\.(\d)/, E = l.lang, v = M && M.time || L, w = M && M.numberFormatter || S, d = (c = "") => {
          let h;
          return c === "true" || c !== "false" && ((h = Number(c)).toString() === c ? h : j(c, A));
        }, r, s, p = 0, b;
        for (; (r = f.exec(u)) !== null; ) {
          let c = m.exec(r[1]);
          c && (r = c, b = !0), s && s.isBlock || (s = { ctx: A, expression: r[1], find: r[0], isBlock: r[1].charAt(0) === "#", start: r.index, startInner: r.index + r[0].length, length: r[0].length });
          let h = r[1].split(" ")[0].replace("#", "");
          T[h] && (s.isBlock && h === s.fn && p++, s.fn || (s.fn = h));
          let g = r[1] === "else";
          if (s.isBlock && s.fn && (r[1] === `/${s.fn}` || g))
            if (p) !g && p--;
            else {
              let k = s.startInner, P = u.substr(k, r.index - k);
              s.body === void 0 ? (s.body = P, s.startInner = r.index + r[0].length) : s.elseBody = P, s.find += P + r[0], g || (C.push(s), s = void 0);
            }
          else s.isBlock || C.push(s);
          if (c && !(s != null && s.isBlock)) break;
        }
        return C.forEach((c) => {
          let h, g, { body: k, elseBody: P, expression: O, fn: z } = c;
          if (z) {
            let W = [c], G = O.split(" ");
            for (g = T[z].length; g--; ) W.unshift(d(G[g + 1]));
            h = T[z].apply(A, W), c.isBlock && typeof h == "boolean" && (h = y(h ? k : P, A, M));
          } else {
            let W = O.split(":");
            if (h = d(W.shift() || ""), W.length && typeof h == "number") {
              let G = W.join(":");
              if (F.test(G)) {
                let Y = parseInt((G.match(_) || ["", "-1"])[1], 10);
                h !== null && (h = w(h, Y, E.decimalPoint, G.indexOf(",") > -1 ? E.thousandsSep : ""));
              } else h = v.dateFormat(G, h);
            }
          }
          u = u.replace(c.find, N(h, ""));
        }), b ? y(u, A, M) : u;
      }
      function S(u, A, M, f) {
        let m, C;
        u = +u || 0, A = +A;
        let F = l.lang, _ = (u.toString().split(".")[1] || "").split("e")[0].length, E = u.toString().split("e"), v = A;
        A === -1 ? A = Math.min(_, 20) : B(A) ? A && E[1] && E[1] < 0 && ((C = A + +E[1]) >= 0 ? (E[0] = (+E[0]).toExponential(C).split("e")[0], A = C) : (E[0] = E[0].split(".")[0] || 0, u = A < 20 ? (E[0] * Math.pow(10, E[1])).toFixed(A) : 0, E[1] = 0)) : A = 2;
        let w = (Math.abs(E[1] ? E[0] : u) + Math.pow(10, -Math.max(A, _) - 1)).toFixed(A), d = String(x(w)), r = d.length > 3 ? d.length % 3 : 0;
        return M = N(M, F.decimalPoint), f = N(f, F.thousandsSep), m = (u < 0 ? "-" : "") + (r ? d.substr(0, r) + f : ""), 0 > +E[1] && !v ? m = "0" : m += d.substr(r).replace(/(\d{3})(?=\d)/g, "$1" + f), A ? m += M + w.slice(-A) : +m == 0 && (m = "0"), E[1] && +m != 0 && (m += "e" + E[1]), m;
      }
      return { dateFormat: function(u, A, M) {
        return L.dateFormat(u, A, M);
      }, format: y, helpers: T, numberFormat: S };
    }), i(e, "Core/Renderer/RendererRegistry.js", [e["Core/Globals.js"]], function(o) {
      var n, l;
      let L;
      return (l = n || (n = {})).rendererTypes = {}, l.getRendererType = function(D = L) {
        return l.rendererTypes[D] || l.rendererTypes[L];
      }, l.registerRendererType = function(D, j, I) {
        l.rendererTypes[D] = j, (!L || I) && (L = D, o.Renderer = j);
      }, n;
    }), i(e, "Core/Renderer/RendererUtilities.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { clamp: l, pick: L, pushUnique: D, stableSort: j } = o;
      return (n || (n = {})).distribute = function I(B, R, N) {
        let x = B, T = x.reducedLen || R, y = (d, r) => d.target - r.target, S = [], u = B.length, A = [], M = S.push, f, m, C, F = !0, _, E, v = 0, w;
        for (f = u; f--; ) v += B[f].size;
        if (v > T) {
          for (j(B, (d, r) => (r.rank || 0) - (d.rank || 0)), C = (w = B[0].rank === B[B.length - 1].rank) ? u / 2 : -1, m = w ? C : u - 1; C && v > T; ) _ = B[f = Math.floor(m)], D(A, f) && (v -= _.size), m += C, w && m >= B.length && (C /= 2, m = C);
          A.sort((d, r) => r - d).forEach((d) => M.apply(S, B.splice(d, 1)));
        }
        for (j(B, y), B = B.map((d) => ({ size: d.size, targets: [d.target], align: L(d.align, 0.5) })); F; ) {
          for (f = B.length; f--; ) _ = B[f], E = (Math.min.apply(0, _.targets) + Math.max.apply(0, _.targets)) / 2, _.pos = l(E - _.size * _.align, 0, R - _.size);
          for (f = B.length, F = !1; f--; ) f > 0 && B[f - 1].pos + B[f - 1].size > B[f].pos && (B[f - 1].size += B[f].size, B[f - 1].targets = B[f - 1].targets.concat(B[f].targets), B[f - 1].align = 0.5, B[f - 1].pos + B[f - 1].size > R && (B[f - 1].pos = R - B[f - 1].size), B.splice(f, 1), F = !0);
        }
        return M.apply(x, S), f = 0, B.some((d) => {
          let r = 0;
          return (d.targets || []).some(() => (x[f].pos = d.pos + r, N !== void 0 && Math.abs(x[f].pos - x[f].target) > N ? (x.slice(0, f + 1).forEach((s) => delete s.pos), x.reducedLen = (x.reducedLen || R) - 0.1 * R, x.reducedLen > 0.1 * R && I(x, R, N), !0) : (r += x[f].size, f++, !1)));
        }), j(x, y), x;
      }, n;
    }), i(e, "Core/Renderer/SVG/SVGElement.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { animate: D, animObject: j, stop: I } = o, { deg2rad: B, doc: R, svg: N, SVG_NS: x, win: T } = l, { addEvent: y, attr: S, createElement: u, crisp: A, css: M, defined: f, erase: m, extend: C, fireEvent: F, isArray: _, isFunction: E, isObject: v, isString: w, merge: d, objectEach: r, pick: s, pInt: p, pushUnique: b, replaceNested: c, syncTimeout: h, uniqueKey: g } = L;
      class k {
        _defaultGetter(O) {
          let z = s(this[O + "Value"], this[O], this.element ? this.element.getAttribute(O) : null, 0);
          return /^-?[\d\.]+$/.test(z) && (z = parseFloat(z)), z;
        }
        _defaultSetter(O, z, W) {
          W.setAttribute(z, O);
        }
        add(O) {
          let z, W = this.renderer, G = this.element;
          return O && (this.parentGroup = O), this.textStr !== void 0 && this.element.nodeName === "text" && W.buildText(this), this.added = !0, (!O || O.handleZ || this.zIndex) && (z = this.zIndexSetter()), z || (O ? O.element : W.box).appendChild(G), this.onAdd && this.onAdd(), this;
        }
        addClass(O, z) {
          let W = z ? "" : this.attr("class") || "";
          return (O = (O || "").split(/ /g).reduce(function(G, Y) {
            return W.indexOf(Y) === -1 && G.push(Y), G;
          }, W ? [W] : []).join(" ")) !== W && this.attr("class", O), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(O, z, W, G = !0) {
          let Y, U, H, q, X = {}, $ = this.renderer, K = $.alignedObjects, V = !!O;
          O ? (this.alignOptions = O, this.alignByTranslate = z, this.alignTo = W) : (O = this.alignOptions || {}, z = this.alignByTranslate, W = this.alignTo);
          let Q = !W || w(W) ? W || "renderer" : void 0;
          Q && (V && b(K, this), W = void 0);
          let Z = s(W, $[Q], $), ee = O.align, J = O.verticalAlign;
          return Y = (Z.x || 0) + (O.x || 0), U = (Z.y || 0) + (O.y || 0), ee === "right" ? H = 1 : ee === "center" && (H = 2), H && (Y += ((Z.width || 0) - (O.width || 0)) / H), X[z ? "translateX" : "x"] = Math.round(Y), J === "bottom" ? q = 1 : J === "middle" && (q = 2), q && (U += ((Z.height || 0) - (O.height || 0)) / q), X[z ? "translateY" : "y"] = Math.round(U), G && (this[this.placed ? "animate" : "attr"](X), this.placed = !0), this.alignAttr = X, this;
        }
        alignSetter(O) {
          let z = { left: "start", center: "middle", right: "end" };
          z[O] && (this.alignValue = O, this.element.setAttribute("text-anchor", z[O]));
        }
        animate(O, z, W) {
          let G = j(s(z, this.renderer.globalAnimation, !0)), Y = G.defer;
          return R.hidden && (G.duration = 0), G.duration !== 0 ? (W && (G.complete = W), h(() => {
            this.element && D(this, O, G);
          }, Y)) : (this.attr(O, void 0, W || G.complete), r(O, function(U, H) {
            G.step && G.step.call(this, U, { prop: H, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(O) {
          let z = this.element;
          O.indexOf("contrast") !== -1 && (O = O.replace(/contrast/g, this.renderer.getContrast(z.style.fill)));
          let W = O.split(" "), G = W[W.length - 1], Y = W[0];
          if (Y && Y !== "none" && l.svg) {
            this.fakeTS = !0, Y = Y.replace(/(^[\d\.]+)(.*?)$/g, function($, K, V) {
              return 2 * Number(K) + V;
            }), this.removeTextOutline();
            let U = R.createElementNS(x, "tspan");
            S(U, { class: "highcharts-text-outline", fill: G, stroke: G, "stroke-width": Y, "stroke-linejoin": "round" });
            let H = z.querySelector("textPath") || z;
            [].forEach.call(H.childNodes, ($) => {
              let K = $.cloneNode(!0);
              K.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((V) => K.removeAttribute(V)), U.appendChild(K);
            });
            let q = 0;
            [].forEach.call(H.querySelectorAll("text tspan"), ($) => {
              q += Number($.getAttribute("dy"));
            });
            let X = R.createElementNS(x, "tspan");
            X.textContent = "​", S(X, { x: Number(z.getAttribute("x")), dy: -q }), U.appendChild(X), H.insertBefore(U, H.firstChild);
          }
        }
        attr(O, z, W, G) {
          let { element: Y } = this, U = k.symbolCustomAttribs, H, q, X = this, $;
          return typeof O == "string" && z !== void 0 && (H = O, (O = {})[H] = z), typeof O == "string" ? X = (this[O + "Getter"] || this._defaultGetter).call(this, O, Y) : (r(O, function(K, V) {
            $ = !1, G || I(this, V), this.symbolName && U.indexOf(V) !== -1 && (q || (this.symbolAttr(O), q = !0), $ = !0), this.rotation && (V === "x" || V === "y") && (this.doTransform = !0), $ || (this[V + "Setter"] || this._defaultSetter).call(this, K, V, Y);
          }, this), this.afterSetters()), W && W.call(this), X;
        }
        clip(O) {
          if (O && !O.clipPath) {
            let z = g() + "-", W = this.renderer.createElement("clipPath").attr({ id: z }).add(this.renderer.defs);
            C(O, { clipPath: W, id: z, count: 0 }), O.add(W);
          }
          return this.attr("clip-path", O ? `url(${this.renderer.url}#${O.id})` : "none");
        }
        crisp(O, z) {
          z = Math.round(z || O.strokeWidth || 0);
          let W = O.x || this.x || 0, G = O.y || this.y || 0, Y = (O.width || this.width || 0) + W, U = (O.height || this.height || 0) + G, H = A(W, z), q = A(G, z);
          return C(O, { x: H, y: q, width: A(Y, z) - H, height: A(U, z) - q }), f(O.strokeWidth) && (O.strokeWidth = z), O;
        }
        complexColor(O, z, W) {
          let G = this.renderer, Y, U, H, q, X, $, K, V, Q, Z, ee = [], J;
          F(this.renderer, "complexColor", { args: arguments }, function() {
            if (O.radialGradient ? U = "radialGradient" : O.linearGradient && (U = "linearGradient"), U) {
              if (H = O[U], X = G.gradients, $ = O.stops, Q = W.radialReference, _(H) && (O[U] = H = { x1: H[0], y1: H[1], x2: H[2], y2: H[3], gradientUnits: "userSpaceOnUse" }), U === "radialGradient" && Q && !f(H.gradientUnits) && (q = H, H = d(H, G.getRadialAttr(Q, q), { gradientUnits: "userSpaceOnUse" })), r(H, function(ie, re) {
                re !== "id" && ee.push(re, ie);
              }), r($, function(ie) {
                ee.push(ie);
              }), X[ee = ee.join(",")]) Z = X[ee].attr("id");
              else {
                H.id = Z = g();
                let ie = X[ee] = G.createElement(U).attr(H).add(G.defs);
                ie.radAttr = q, ie.stops = [], $.forEach(function(re) {
                  re[1].indexOf("rgba") === 0 ? (K = (Y = n.parse(re[1])).get("rgb"), V = Y.get("a")) : (K = re[1], V = 1);
                  let ce = G.createElement("stop").attr({ offset: re[0], "stop-color": K, "stop-opacity": V }).add(ie);
                  ie.stops.push(ce);
                });
              }
              J = "url(" + G.url + "#" + Z + ")", W.setAttribute(z, J), W.gradient = ee, O.toString = function() {
                return J;
              };
            }
          });
        }
        css(O) {
          let z = this.styles, W = {}, G = this.element, Y, U = !z;
          if (z && r(O, function(H, q) {
            z && z[q] !== H && (W[q] = H, U = !0);
          }), U) {
            z && (O = C(z, W)), O.width === null || O.width === "auto" ? delete this.textWidth : G.nodeName.toLowerCase() === "text" && O.width && (Y = this.textWidth = p(O.width)), C(this.styles, O), Y && !N && this.renderer.forExport && delete O.width;
            let H = d(O);
            G.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((q) => H && delete H[q]), H.color && (H.fill = H.color)), M(G, H);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), O.textOutline && this.applyTextOutline(O.textOutline)), this;
        }
        dashstyleSetter(O) {
          let z, W = this["stroke-width"];
          if (W === "inherit" && (W = 1), O = O && O.toLowerCase()) {
            let G = O.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (z = G.length; z--; ) G[z] = "" + p(G[z]) * s(W, NaN);
            O = G.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", O);
          }
        }
        destroy() {
          var q;
          let O = this, z = O.element || {}, W = O.renderer, G = z.ownerSVGElement, Y = z.nodeName === "SPAN" && O.parentGroup || void 0, U, H;
          if (z.onclick = z.onmouseout = z.onmouseover = z.onmousemove = z.point = null, I(O), O.clipPath && G) {
            let X = O.clipPath;
            [].forEach.call(G.querySelectorAll("[clip-path],[CLIP-PATH]"), function($) {
              $.getAttribute("clip-path").indexOf(X.element.id) > -1 && $.removeAttribute("clip-path");
            }), O.clipPath = X.destroy();
          }
          if (O.connector = (q = O.connector) == null ? void 0 : q.destroy(), O.stops) {
            for (H = 0; H < O.stops.length; H++) O.stops[H].destroy();
            O.stops.length = 0, O.stops = void 0;
          }
          for (O.safeRemoveChild(z); Y && Y.div && Y.div.childNodes.length === 0; ) U = Y.parentGroup, O.safeRemoveChild(Y.div), delete Y.div, Y = U;
          O.alignOptions && m(W.alignedObjects, O), r(O, function(X, $) {
            O[$] && O[$].parentGroup === O && O[$].destroy && O[$].destroy(), delete O[$];
          });
        }
        dSetter(O, z, W) {
          _(O) && (typeof O[0] == "string" && (O = this.renderer.pathToSegments(O)), this.pathArray = O, O = O.reduce((G, Y, U) => Y && Y.join ? (U ? G + " " : "") + Y.join(" ") : (Y || "").toString(), "")), /(NaN| {2}|^$)/.test(O) && (O = "M 0 0"), this[z] !== O && (W.setAttribute(z, O), this[z] = O);
        }
        fillSetter(O, z, W) {
          typeof O == "string" ? W.setAttribute(z, O) : O && this.complexColor(O, z, W);
        }
        hrefSetter(O, z, W) {
          W.setAttributeNS("http://www.w3.org/1999/xlink", z, O);
        }
        getBBox(O, z) {
          let W, G, Y, U, { alignValue: H, element: q, renderer: X, styles: $, textStr: K } = this, { cache: V, cacheKeys: Q } = X, Z = q.namespaceURI === this.SVG_NS, ee = s(z, this.rotation, 0), J = X.styledMode ? q && k.prototype.getStyle.call(q, "font-size") : $.fontSize;
          if (f(K) && ((U = K.toString()).indexOf("<") === -1 && (U = U.replace(/\d/g, "0")), U += ["", X.rootFontSize, J, ee, this.textWidth, H, $.textOverflow, $.fontWeight].join(",")), U && !O && (W = V[U]), !W || W.polygon) {
            if (Z || X.forExport) {
              try {
                Y = this.fakeTS && function(re) {
                  let ce = q.querySelector(".highcharts-text-outline");
                  ce && M(ce, { display: re });
                }, E(Y) && Y("none"), W = q.getBBox ? C({}, q.getBBox()) : { width: q.offsetWidth, height: q.offsetHeight, x: 0, y: 0 }, E(Y) && Y("");
              } catch {
              }
              (!W || W.width < 0) && (W = { x: 0, y: 0, width: 0, height: 0 });
            } else W = this.htmlGetBBox();
            G = W.height, Z && (W.height = G = { "11px,17": 14, "13px,20": 16 }[`${J || ""},${Math.round(G)}`] || G), ee && (W = this.getRotatedBox(W, ee));
            let ie = { bBox: W };
            F(this, "afterGetBBox", ie), W = ie.bBox;
          }
          if (U && (K === "" || W.height > 0)) {
            for (; Q.length > 250; ) delete V[Q.shift()];
            V[U] || Q.push(U), V[U] = W;
          }
          return W;
        }
        getRotatedBox(O, z) {
          let { x: W, y: G, width: Y, height: U } = O, { alignValue: H, translateY: q, rotationOriginX: X = 0, rotationOriginY: $ = 0 } = this, K = { right: 1, center: 0.5 }[H || 0] || 0, V = Number(this.element.getAttribute("y") || 0) - (q ? 0 : G), Q = z * B, Z = (z - 90) * B, ee = Math.cos(Q), J = Math.sin(Q), ie = Y * ee, re = Y * J, ce = Math.cos(Z), he = Math.sin(Z), [[ne, oe], [se, te]] = [X, $].map((Oe) => [Oe - Oe * ee, Oe * J]), ae = W + K * (Y - ie) + ne + te + V * ce, le = ae + ie, de = le - U * ce, be = de - ie, ge = G + V - K * re - oe + se + V * he, me = ge + re, fe = me - U * he, Ae = fe - re, ye = Math.min(ae, le, de, be), xe = Math.min(ge, me, fe, Ae), we = Math.max(ae, le, de, be) - ye, ke = Math.max(ge, me, fe, Ae) - xe;
          return { x: ye, y: xe, width: we, height: ke, polygon: [[ae, ge], [le, me], [de, fe], [be, Ae]] };
        }
        getStyle(O) {
          return T.getComputedStyle(this.element || this, "").getPropertyValue(O);
        }
        hasClass(O) {
          return ("" + this.attr("class")).split(" ").indexOf(O) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(O, z) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = x, this.element = z === "span" || z === "body" ? u(z) : R.createElementNS(this.SVG_NS, z), this.renderer = O, this.styles = {}, F(this, "afterInit");
        }
        on(O, z) {
          let { onEvents: W } = this;
          return W[O] && W[O](), W[O] = y(this.element, O, z), this;
        }
        opacitySetter(O, z, W) {
          let G = Number(Number(O).toFixed(3));
          this.opacity = G, W.setAttribute(z, G);
        }
        reAlign() {
          var O;
          (O = this.alignOptions) != null && O.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(O) {
          return this.attr("class", ("" + this.attr("class")).replace(w(O) ? RegExp(`(^| )${O}( |$)`) : O, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let O = this.element.querySelector("tspan.highcharts-text-outline");
          O && this.safeRemoveChild(O);
        }
        safeRemoveChild(O) {
          let z = O.parentNode;
          z && z.removeChild(O);
        }
        setRadialReference(O) {
          let z = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = O, z && z.radAttr && z.animate(this.renderer.getRadialAttr(O, z.radAttr)), this;
        }
        shadow(O) {
          var Y;
          let { renderer: z } = this, W = d(((Y = this.parentGroup) == null ? void 0 : Y.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, v(O) ? O : {}), G = z.shadowDefinition(W);
          return this.attr({ filter: O ? `url(${z.url}#${G})` : "none" });
        }
        show(O = !0) {
          return this.attr({ visibility: O ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(O, z, W) {
          this[z] = O, W.setAttribute(z, O);
        }
        strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          let O = this.getStyle("stroke-width"), z = 0, W;
          return /px$/.test(O) ? z = p(O) : O !== "" && (S(W = R.createElementNS(x, "rect"), { width: O, "stroke-width": 0 }), this.element.parentNode.appendChild(W), z = W.getBBox().width, W.parentNode.removeChild(W)), z;
        }
        symbolAttr(O) {
          let z = this;
          k.symbolCustomAttribs.forEach(function(W) {
            z[W] = s(O[W], z[W]);
          }), z.attr({ d: z.renderer.symbols[z.symbolName](z.x, z.y, z.width, z.height, z) });
        }
        textSetter(O) {
          O !== this.textStr && (delete this.textPxLength, this.textStr = O, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(O) {
          let z = this.element, W = z.getElementsByTagName("title")[0] || R.createElementNS(this.SVG_NS, "title");
          z.insertBefore ? z.insertBefore(W, z.firstChild) : z.appendChild(W), W.textContent = c(s(O, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let O = this.element;
          return O.parentNode.appendChild(O), this;
        }
        translate(O, z) {
          return this.attr({ translateX: O, translateY: z });
        }
        updateTransform(O = "transform") {
          var V;
          let { element: z, matrix: W, rotation: G = 0, rotationOriginX: Y, rotationOriginY: U, scaleX: H, scaleY: q, translateX: X = 0, translateY: $ = 0 } = this, K = ["translate(" + X + "," + $ + ")"];
          f(W) && K.push("matrix(" + W.join(",") + ")"), G && (K.push("rotate(" + G + " " + s(Y, z.getAttribute("x"), 0) + " " + s(U, z.getAttribute("y") || 0) + ")"), ((V = this.text) == null ? void 0 : V.element.tagName) === "SPAN" && this.text.attr({ rotation: G, rotationOriginX: (Y || 0) - this.padding, rotationOriginY: (U || 0) - this.padding })), (f(H) || f(q)) && K.push("scale(" + s(H, 1) + " " + s(q, 1) + ")"), K.length && !(this.text || this).textPath && z.setAttribute(O, K.join(" "));
        }
        visibilitySetter(O, z, W) {
          O === "inherit" ? W.removeAttribute(z) : this[z] !== O && W.setAttribute(z, O), this[z] = O;
        }
        xGetter(O) {
          return this.element.nodeName === "circle" && (O === "x" ? O = "cx" : O === "y" && (O = "cy")), this._defaultGetter(O);
        }
        zIndexSetter(O, z) {
          let W = this.renderer, G = this.parentGroup, Y = (G || W).element || W.box, U = this.element, H = Y === W.box, q, X, $, K = !1, V, Q = this.added, Z;
          if (f(O) ? (U.setAttribute("data-z-index", O), O = +O, this[z] === O && (Q = !1)) : f(this[z]) && U.removeAttribute("data-z-index"), this[z] = O, Q) {
            for ((O = this.zIndex) && G && (G.handleZ = !0), Z = (q = Y.childNodes).length - 1; Z >= 0 && !K; Z--) V = !f($ = (X = q[Z]).getAttribute("data-z-index")), X !== U && (O < 0 && V && !H && !Z ? (Y.insertBefore(U, q[Z]), K = !0) : (p($) <= O || V && (!f(O) || O >= 0)) && (Y.insertBefore(U, q[Z + 1]), K = !0));
            K || (Y.insertBefore(U, q[H ? 3 : 0]), K = !0);
          }
          return K;
        }
      }
      return k.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], k.prototype.strokeSetter = k.prototype.fillSetter, k.prototype.yGetter = k.prototype.xGetter, k.prototype.matrixSetter = k.prototype.rotationOriginXSetter = k.prototype.rotationOriginYSetter = k.prototype.rotationSetter = k.prototype.scaleXSetter = k.prototype.scaleYSetter = k.prototype.translateXSetter = k.prototype.translateYSetter = k.prototype.verticalAlignSetter = function(P, O) {
        this[O] = P, this.doTransform = !0;
      }, k;
    }), i(e, "Core/Renderer/SVG/SVGLabel.js", [e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n) {
      let { defined: l, extend: L, isNumber: D, merge: j, pick: I, removeEvent: B } = n;
      class R extends o {
        constructor(x, T, y, S, u, A, M, f, m, C) {
          let F;
          super(x, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = T, this.x = y, this.y = S, this.anchorX = A, this.anchorY = M, this.baseline = m, this.className = C, this.addClass(C === "button" ? "highcharts-no-tooltip" : "highcharts-label"), C && this.addClass("highcharts-" + C), this.text = x.text(void 0, 0, 0, f).attr({ zIndex: 1 }), typeof u == "string" && ((F = /^url\((.*?)\)$/.test(u)) || this.renderer.symbols[u]) && (this.symbolKey = u), this.bBox = R.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = x.styledMode || F, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(x) {
          let T = { left: 0, center: 0.5, right: 1 }[x];
          T !== this.alignFactor && (this.alignFactor = T, this.bBox && D(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(x, T) {
          this.anchorX = x, this.boxAttr(T, Math.round(x) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(x, T) {
          this.anchorY = x, this.boxAttr(T, x - this.ySetting);
        }
        boxAttr(x, T) {
          this.box ? this.box.attr(x, T) : this.deferredAttr[x] = T;
        }
        css(x) {
          if (x) {
            let T = {};
            x = j(x), R.textProps.forEach((y) => {
              x[y] !== void 0 && (T[y] = x[y], delete x[y]);
            }), this.text.css(T), "fontSize" in T || "fontWeight" in T ? this.updateTextPadding() : ("width" in T || "textOverflow" in T) && this.updateBoxSize();
          }
          return o.prototype.css.call(this, x);
        }
        destroy() {
          B(this.element, "mouseenter"), B(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), o.prototype.destroy.call(this);
        }
        fillSetter(x, T) {
          x && (this.needsBox = !0), this.fill = x, this.boxAttr(T, x);
        }
        getBBox(x, T) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: y, height: S = 0, translateX: u = 0, translateY: A = 0, width: M = 0 } = this, f = I(this.paddingLeft, y), m = T != null ? T : this.rotation || 0, C = { width: M, height: S, x: u + this.bBox.x - f, y: A + this.bBox.y - y + this.baselineOffset };
          return m && (C = this.getRotatedBox(C, m)), C;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(x) {
          this.heightSetting = x, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: I(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && l(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(x, T) {
          D(x) ? x !== this[T] && (this[T] = x, this.updateTextPadding()) : this[T] = void 0;
        }
        rSetter(x, T) {
          this.boxAttr(T, x);
        }
        strokeSetter(x, T) {
          this.stroke = x, this.boxAttr(T, x);
        }
        "stroke-widthSetter"(x, T) {
          x && (this.needsBox = !0), this["stroke-width"] = x, this.boxAttr(T, x);
        }
        "text-alignSetter"(x) {
          this.textAlign = x;
        }
        textSetter(x) {
          x !== void 0 && this.text.attr({ text: x }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let x, T = this.text, y = {}, S = this.padding, u = this.bBox = (!D(this.widthSetting) || !D(this.heightSetting) || this.textAlign) && l(T.textStr) ? T.getBBox(void 0, 0) : R.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || u.height || 0) + 2 * S;
          let A = this.renderer.fontMetrics(T);
          if (this.baselineOffset = S + Math.min((this.text.firstLineMetrics || A).b, u.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - A.h) / 2), this.needsBox && !T.textPath) {
            if (!this.box) {
              let M = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              M.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), M.add(this);
            }
            x = this.getCrispAdjust(), y.x = x, y.y = (this.baseline ? -this.baselineOffset : 0) + x, y.width = Math.round(this.width), y.height = Math.round(this.height), this.box.attr(L(y, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let x = this.text;
          if (!x.textPath) {
            this.updateBoxSize();
            let T = this.baseline ? 0 : this.baselineOffset, y = I(this.paddingLeft, this.padding);
            l(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (y += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (y !== x.x || T !== x.y) && (x.attr("x", y), x.hasBoxWidthChanged && (this.bBox = x.getBBox(!0)), T !== void 0 && x.attr("y", T)), x.x = y, x.y = T;
          }
        }
        widthSetter(x) {
          this.widthSetting = D(x) ? x : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let x = this.padding, T = I(this.paddingLeft, x), y = I(this.paddingRight, x);
          return (this.widthSetting || this.bBox.width || 0) + T + y;
        }
        xSetter(x) {
          this.x = x, this.alignFactor && (x -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(x), this.attr("translateX", this.xSetting);
        }
        ySetter(x) {
          this.ySetting = this.y = Math.round(x), this.attr("translateY", this.ySetting);
        }
      }
      return R.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, R.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], R;
    }), i(e, "Core/Renderer/SVG/Symbols.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n, isNumber: l, pick: L } = o;
      function D(B, R, N, x, T) {
        let y = [];
        if (T) {
          let S = T.start || 0, u = L(T.r, N), A = L(T.r, x || N), M = 2e-4 / (T.borderRadius ? 1 : Math.max(u, 1)), f = Math.abs((T.end || 0) - S - 2 * Math.PI) < M, m = (T.end || 0) - (f ? M : 0), C = T.innerR, F = L(T.open, f), _ = Math.cos(S), E = Math.sin(S), v = Math.cos(m), w = Math.sin(m), d = L(T.longArc, m - S - Math.PI < M ? 0 : 1), r = ["A", u, A, 0, d, L(T.clockwise, 1), B + u * v, R + A * w];
          r.params = { start: S, end: m, cx: B, cy: R }, y.push(["M", B + u * _, R + A * E], r), n(C) && ((r = ["A", C, C, 0, d, n(T.clockwise) ? 1 - T.clockwise : 0, B + C * _, R + C * E]).params = { start: m, end: S, cx: B, cy: R }, y.push(F ? ["M", B + C * v, R + C * w] : ["L", B + C * v, R + C * w], r)), F || y.push(["Z"]);
        }
        return y;
      }
      function j(B, R, N, x, T) {
        return T && T.r ? I(B, R, N, x, T) : [["M", B, R], ["L", B + N, R], ["L", B + N, R + x], ["L", B, R + x], ["Z"]];
      }
      function I(B, R, N, x, T) {
        let y = (T == null ? void 0 : T.r) || 0;
        return [["M", B + y, R], ["L", B + N - y, R], ["A", y, y, 0, 0, 1, B + N, R + y], ["L", B + N, R + x - y], ["A", y, y, 0, 0, 1, B + N - y, R + x], ["L", B + y, R + x], ["A", y, y, 0, 0, 1, B, R + x - y], ["L", B, R + y], ["A", y, y, 0, 0, 1, B + y, R], ["Z"]];
      }
      return { arc: D, callout: function(B, R, N, x, T) {
        let y = Math.min(T && T.r || 0, N, x), S = y + 6, u = T && T.anchorX, A = T && T.anchorY || 0, M = I(B, R, N, x, { r: y });
        if (!l(u) || u < N && u > 0 && A < x && A > 0) return M;
        if (B + u > N - S)
          if (A > R + S && A < R + x - S) M.splice(3, 1, ["L", B + N, A - 6], ["L", B + N + 6, A], ["L", B + N, A + 6], ["L", B + N, R + x - y]);
          else if (u < N) {
            let f = A < R + S, m = f ? R : R + x;
            M.splice(f ? 2 : 5, 0, ["L", u, A], ["L", B + N - y, m]);
          } else M.splice(3, 1, ["L", B + N, x / 2], ["L", u, A], ["L", B + N, x / 2], ["L", B + N, R + x - y]);
        else if (B + u < S)
          if (A > R + S && A < R + x - S) M.splice(7, 1, ["L", B, A + 6], ["L", B - 6, A], ["L", B, A - 6], ["L", B, R + y]);
          else if (u > 0) {
            let f = A < R + S, m = f ? R : R + x;
            M.splice(f ? 1 : 6, 0, ["L", u, A], ["L", B + y, m]);
          } else M.splice(7, 1, ["L", B, x / 2], ["L", u, A], ["L", B, x / 2], ["L", B, R + y]);
        else A > x && u < N - S ? M.splice(5, 1, ["L", u + 6, R + x], ["L", u, R + x + 6], ["L", u - 6, R + x], ["L", B + y, R + x]) : A < 0 && u > S && M.splice(1, 1, ["L", u - 6, R], ["L", u, R - 6], ["L", u + 6, R], ["L", N - y, R]);
        return M;
      }, circle: function(B, R, N, x) {
        return D(B + N / 2, R + x / 2, N / 2, x / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(B, R, N, x) {
        return [["M", B + N / 2, R], ["L", B + N, R + x / 2], ["L", B + N / 2, R + x], ["L", B, R + x / 2], ["Z"]];
      }, rect: j, roundedRect: I, square: j, triangle: function(B, R, N, x) {
        return [["M", B + N / 2, R], ["L", B + N, R + x], ["L", B, R + x], ["Z"]];
      }, "triangle-down": function(B, R, N, x) {
        return [["M", B, R], ["L", B + N, R], ["L", B + N / 2, R + x], ["Z"]];
      } };
    }), i(e, "Core/Renderer/SVG/TextBuilder.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { doc: L, SVG_NS: D, win: j } = n, { attr: I, extend: B, fireEvent: R, isString: N, objectEach: x, pick: T } = l;
      return class {
        constructor(y) {
          let S = y.styles;
          this.renderer = y.renderer, this.svgElement = y, this.width = y.textWidth, this.textLineHeight = S && S.lineHeight, this.textOutline = S && S.textOutline, this.ellipsis = !!(S && S.textOverflow === "ellipsis"), this.noWrap = !!(S && S.whiteSpace === "nowrap");
        }
        buildSVG() {
          let y = this.svgElement, S = y.element, u = y.renderer, A = T(y.textStr, "").toString(), M = A.indexOf("<") !== -1, f = S.childNodes, m = !y.added && u.box, C = [A, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, y.getStyle("font-size"), this.width].join(",");
          if (C !== y.textCache) {
            y.textCache = C, delete y.actualWidth;
            for (let F = f.length; F--; ) S.removeChild(f[F]);
            if (M || this.ellipsis || this.width || y.textPath || A.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(A))) {
              if (A !== "") {
                m && m.appendChild(S);
                let F = new o(A);
                this.modifyTree(F.nodes), F.addToDOM(S), this.modifyDOM(), this.ellipsis && (S.textContent || "").indexOf("…") !== -1 && y.attr("title", this.unescapeEntities(y.textStr || "", ["&lt;", "&gt;"])), m && m.removeChild(S);
              }
            } else S.appendChild(L.createTextNode(this.unescapeEntities(A)));
            N(this.textOutline) && y.applyTextOutline && y.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let y, S = this.svgElement, u = I(S.element, "x");
          for (S.firstLineMetrics = void 0; (y = S.element.firstChild) && /^[\s\u200B]*$/.test(y.textContent || " "); ) S.element.removeChild(y);
          [].forEach.call(S.element.querySelectorAll("tspan.highcharts-br"), (m, C) => {
            m.nextSibling && m.previousSibling && (C === 0 && m.previousSibling.nodeType === 1 && (S.firstLineMetrics = S.renderer.fontMetrics(m.previousSibling)), I(m, { dy: this.getLineHeight(m.nextSibling), x: u }));
          });
          let A = this.width || 0;
          if (!A) return;
          let M = (m, C) => {
            let F = m.textContent || "", _ = F.replace(/([^\^])-/g, "$1- ").split(" "), E = !this.noWrap && (_.length > 1 || S.element.childNodes.length > 1), v = this.getLineHeight(C), w = 0, d = S.actualWidth;
            if (this.ellipsis) F && this.truncate(m, F, void 0, 0, Math.max(0, A - 0.8 * v), (r, s) => r.substring(0, s) + "…");
            else if (E) {
              let r = [], s = [];
              for (; C.firstChild && C.firstChild !== m; ) s.push(C.firstChild), C.removeChild(C.firstChild);
              for (; _.length; ) _.length && !this.noWrap && w > 0 && (r.push(m.textContent || ""), m.textContent = _.join(" ").replace(/- /g, "-")), this.truncate(m, void 0, _, w === 0 && d || 0, A, (p, b) => _.slice(0, b).join(" ").replace(/- /g, "-")), d = S.actualWidth, w++;
              s.forEach((p) => {
                C.insertBefore(p, m);
              }), r.forEach((p) => {
                C.insertBefore(L.createTextNode(p), m);
                let b = L.createElementNS(D, "tspan");
                b.textContent = "​", I(b, { dy: v, x: u }), C.insertBefore(b, m);
              });
            }
          }, f = (m) => {
            [].slice.call(m.childNodes).forEach((C) => {
              C.nodeType === j.Node.TEXT_NODE ? M(C, m) : (C.className.baseVal.indexOf("highcharts-br") !== -1 && (S.actualWidth = 0), f(C));
            });
          };
          f(S.element);
        }
        getLineHeight(y) {
          let S = y.nodeType === j.Node.TEXT_NODE ? y.parentElement : y;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(S || this.svgElement.element).h;
        }
        modifyTree(y) {
          let S = (u, A) => {
            let { attributes: M = {}, children: f, style: m = {}, tagName: C } = u, F = this.renderer.styledMode;
            if (C === "b" || C === "strong" ? F ? M.class = "highcharts-strong" : m.fontWeight = "bold" : (C === "i" || C === "em") && (F ? M.class = "highcharts-emphasized" : m.fontStyle = "italic"), m && m.color && (m.fill = m.color), C === "br") {
              M.class = "highcharts-br", u.textContent = "​";
              let _ = y[A + 1];
              _ && _.textContent && (_.textContent = _.textContent.replace(/^ +/gm, ""));
            } else C === "a" && f && f.some((_) => _.tagName === "#text") && (u.children = [{ children: f, tagName: "tspan" }]);
            C !== "#text" && C !== "a" && (u.tagName = "tspan"), B(u, { attributes: M, style: m }), f && f.filter((_) => _.tagName !== "#text").forEach(S);
          };
          y.forEach(S), R(this.svgElement, "afterModifyTree", { nodes: y });
        }
        truncate(y, S, u, A, M, f) {
          let m, C, F = this.svgElement, { rotation: _ } = F, E = [], v = u ? 1 : 0, w = (S || u || "").length, d = w, r = function(s, p) {
            let b = p || s, c = y.parentNode;
            if (c && E[b] === void 0 && c.getSubStringLength) try {
              E[b] = A + c.getSubStringLength(0, u ? b + 1 : b);
            } catch {
            }
            return E[b];
          };
          if (F.rotation = 0, A + (C = r(y.textContent.length)) > M) {
            for (; v <= w; ) d = Math.ceil((v + w) / 2), u && (m = f(u, d)), C = r(d, m && m.length - 1), v === w ? v = w + 1 : C > M ? w = d - 1 : v = d;
            w === 0 ? y.textContent = "" : S && w === S.length - 1 || (y.textContent = m || f(S || u, d));
          }
          u && u.splice(0, d), F.actualWidth = C, F.rotation = _;
        }
        unescapeEntities(y, S) {
          return x(this.renderer.escapes, function(u, A) {
            S && S.indexOf(u) !== -1 || (y = y.toString().replace(RegExp(u, "g"), A));
          }), y;
        }
      };
    }), i(e, "Core/Renderer/SVG/SVGRenderer.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Defaults.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGLabel.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Renderer/SVG/TextBuilder.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R, N) {
      let x, { defaultOptions: T } = n, { charts: y, deg2rad: S, doc: u, isFirefox: A, isMS: M, isWebKit: f, noop: m, SVG_NS: C, symbolSizes: F, win: _ } = L, { addEvent: E, attr: v, createElement: w, crisp: d, css: r, defined: s, destroyObjectProperties: p, extend: b, isArray: c, isNumber: h, isObject: g, isString: k, merge: P, pick: O, pInt: z, replaceNested: W, uniqueKey: G } = N;
      class Y {
        constructor(H, q, X, $, K, V, Q) {
          let Z, ee, J = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), ie = J.element;
          Q || J.css(this.getStyle($ || {})), H.appendChild(ie), v(H, "dir", "ltr"), H.innerHTML.indexOf("xmlns") === -1 && v(ie, "xmlns", this.SVG_NS), this.box = ie, this.boxWrapper = J, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(u.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = V, this.forExport = K, this.styledMode = Q, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = J.getStyle("font-size"), this.setSize(q, X, !1), A && H.getBoundingClientRect && ((Z = function() {
            r(H, { left: 0, top: 0 }), ee = H.getBoundingClientRect(), r(H, { left: Math.ceil(ee.left) - ee.left + "px", top: Math.ceil(ee.top) - ee.top + "px" });
          })(), this.unSubPixelFix = E(_, "resize", Z));
        }
        definition(H) {
          return new o([H]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((A || f) && u.getElementsByTagName("base").length) {
            if (!s(x)) {
              let H = G(), q = new o([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: H }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${H})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(u.body);
              r(q, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let X = u.elementFromPoint(6, 6);
              x = (X && X.id) === "hitme", u.body.removeChild(q);
            }
            if (x) return W(_.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(H) {
          return this.style = b({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, H), this.style;
        }
        setStyle(H) {
          this.boxWrapper.css(this.getStyle(H));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let H = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), p(this.gradients || {}), this.gradients = null, this.defs = H.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(H) {
          return new this.Element(this, H);
        }
        getRadialAttr(H, q) {
          return { cx: H[0] - H[2] / 2 + (q.cx || 0) * H[2], cy: H[1] - H[2] / 2 + (q.cy || 0) * H[2], r: (q.r || 0) * H[2] };
        }
        shadowDefinition(H) {
          let q = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(H).map(($) => `${$}-${H[$]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), X = P({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, H);
          return this.defs.element.querySelector(`#${q}`) || this.definition({ tagName: "filter", attributes: { id: q, filterUnits: X.filterUnits }, children: this.getShadowFilterContent(X) }), q;
        }
        getShadowFilterContent(H) {
          return [{ tagName: "feDropShadow", attributes: { dx: H.offsetX, dy: H.offsetY, "flood-color": H.color, "flood-opacity": Math.min(5 * H.opacity, 1), stdDeviation: H.width / 2 } }];
        }
        buildText(H) {
          new R(H).buildSVG();
        }
        getContrast(H) {
          let q = l.parse(H).rgba.map(($) => {
            let K = $ / 255;
            return K <= 0.03928 ? K / 12.92 : Math.pow((K + 0.055) / 1.055, 2.4);
          }), X = 0.2126 * q[0] + 0.7152 * q[1] + 0.0722 * q[2];
          return 1.05 / (X + 0.05) > (X + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(H, q, X, $, K = {}, V, Q, Z, ee, J) {
          let ie = this.label(H, q, X, ee, void 0, void 0, J, void 0, "button"), re = this.styledMode, ce = arguments, he = 0;
          K = P(T.global.buttonTheme, K), re && (delete K.fill, delete K.stroke, delete K["stroke-width"]);
          let ne = K.states || {}, oe = K.style || {};
          delete K.states, delete K.style;
          let se = [o.filterUserAttributes(K)], te = [oe];
          return re || ["hover", "select", "disabled"].forEach((ae, le) => {
            se.push(P(se[0], o.filterUserAttributes(ce[le + 5] || ne[ae] || {}))), te.push(se[le + 1].style), delete se[le + 1].style;
          }), E(ie.element, M ? "mouseover" : "mouseenter", function() {
            he !== 3 && ie.setState(1);
          }), E(ie.element, M ? "mouseout" : "mouseleave", function() {
            he !== 3 && ie.setState(he);
          }), ie.setState = (ae = 0) => {
            if (ae !== 1 && (ie.state = he = ae), ie.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ae]), !re) {
              ie.attr(se[ae]);
              let le = te[ae];
              g(le) && ie.css(le);
            }
          }, ie.attr(se[0]), !re && (ie.css(b({ cursor: "default" }, oe)), J && ie.text.css({ pointerEvents: "none" })), ie.on("touchstart", (ae) => ae.stopPropagation()).on("click", function(ae) {
            he !== 3 && $.call(ie, ae);
          });
        }
        crispLine(H, q) {
          let [X, $] = H;
          return s(X[1]) && X[1] === $[1] && (X[1] = $[1] = d(X[1], q)), s(X[2]) && X[2] === $[2] && (X[2] = $[2] = d(X[2], q)), H;
        }
        path(H) {
          let q = this.styledMode ? {} : { fill: "none" };
          return c(H) ? q.d = H : g(H) && b(q, H), this.createElement("path").attr(q);
        }
        circle(H, q, X) {
          let $ = g(H) ? H : H === void 0 ? {} : { x: H, y: q, r: X }, K = this.createElement("circle");
          return K.xSetter = K.ySetter = function(V, Q, Z) {
            Z.setAttribute("c" + Q, V);
          }, K.attr($);
        }
        arc(H, q, X, $, K, V) {
          let Q;
          g(H) ? (q = (Q = H).y, X = Q.r, $ = Q.innerR, K = Q.start, V = Q.end, H = Q.x) : Q = { innerR: $, start: K, end: V };
          let Z = this.symbol("arc", H, q, X, X, Q);
          return Z.r = X, Z;
        }
        rect(H, q, X, $, K, V) {
          let Q = g(H) ? H : H === void 0 ? {} : { x: H, y: q, r: K, width: Math.max(X || 0, 0), height: Math.max($ || 0, 0) }, Z = this.createElement("rect");
          return this.styledMode || (V !== void 0 && (Q["stroke-width"] = V, b(Q, Z.crisp(Q))), Q.fill = "none"), Z.rSetter = function(ee, J, ie) {
            Z.r = ee, v(ie, { rx: ee, ry: ee });
          }, Z.rGetter = function() {
            return Z.r || 0;
          }, Z.attr(Q);
        }
        roundedRect(H) {
          return this.symbol("roundedRect").attr(H);
        }
        setSize(H, q, X) {
          this.width = H, this.height = q, this.boxWrapper.animate({ width: H, height: q }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: O(X, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(H) {
          let q = this.createElement("g");
          return H ? q.attr({ class: "highcharts-" + H }) : q;
        }
        image(H, q, X, $, K, V) {
          let Q = { preserveAspectRatio: "none" };
          h(q) && (Q.x = q), h(X) && (Q.y = X), h($) && (Q.width = $), h(K) && (Q.height = K);
          let Z = this.createElement("image").attr(Q), ee = function(J) {
            Z.attr({ href: H }), V.call(Z, J);
          };
          if (V) {
            Z.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let J = new _.Image();
            E(J, "load", ee), J.src = H, J.complete && ee({});
          } else Z.attr({ href: H });
          return Z;
        }
        symbol(H, q, X, $, K, V) {
          let Q, Z, ee, J, ie = this, re = /^url\((.*?)\)$/, ce = re.test(H), he = !ce && (this.symbols[H] ? H : "circle"), ne = he && this.symbols[he];
          if (ne) typeof q == "number" && (Z = ne.call(this.symbols, q || 0, X || 0, $ || 0, K || 0, V)), Q = this.path(Z), ie.styledMode || Q.attr("fill", "none"), b(Q, { symbolName: he || void 0, x: q, y: X, width: $, height: K }), V && b(Q, V);
          else if (ce) {
            ee = H.match(re)[1];
            let oe = Q = this.image(ee);
            oe.imgwidth = O(V && V.width, F[ee] && F[ee].width), oe.imgheight = O(V && V.height, F[ee] && F[ee].height), J = (se) => se.attr({ width: se.width, height: se.height }), ["width", "height"].forEach((se) => {
              oe[`${se}Setter`] = function(te, ae) {
                this[ae] = te;
                let { alignByTranslate: le, element: de, width: be, height: ge, imgwidth: me, imgheight: fe } = this, Ae = ae === "width" ? me : fe, ye = 1;
                V && V.backgroundSize === "within" && be && ge && me && fe ? (ye = Math.min(be / me, ge / fe), v(de, { width: Math.round(me * ye), height: Math.round(fe * ye) })) : de && Ae && de.setAttribute(ae, Ae), !le && me && fe && this.translate(((be || 0) - me * ye) / 2, ((ge || 0) - fe * ye) / 2);
              };
            }), s(q) && oe.attr({ x: q, y: X }), oe.isImg = !0, oe.symbolUrl = H, s(oe.imgwidth) && s(oe.imgheight) ? J(oe) : (oe.attr({ width: 0, height: 0 }), w("img", { onload: function() {
              let se = y[ie.chartIndex];
              this.width === 0 && (r(this, { position: "absolute", top: "-999em" }), u.body.appendChild(this)), F[ee] = { width: this.width, height: this.height }, oe.imgwidth = this.width, oe.imgheight = this.height, oe.element && J(oe), this.parentNode && this.parentNode.removeChild(this), ie.imgCount--, ie.imgCount || !se || se.hasLoaded || se.onload();
            }, src: ee }), this.imgCount++);
          }
          return Q;
        }
        clipRect(H, q, X, $) {
          return this.rect(H, q, X, $, 0);
        }
        text(H, q, X, $) {
          let K = {};
          if ($ && (this.allowHTML || !this.forExport)) return this.html(H, q, X);
          K.x = Math.round(q || 0), X && (K.y = Math.round(X)), s(H) && (K.text = H);
          let V = this.createElement("text").attr(K);
          return $ && (!this.forExport || this.allowHTML) || (V.xSetter = function(Q, Z, ee) {
            let J = ee.getElementsByTagName("tspan"), ie = ee.getAttribute(Z);
            for (let re = 0, ce; re < J.length; re++) (ce = J[re]).getAttribute(Z) === ie && ce.setAttribute(Z, Q);
            ee.setAttribute(Z, Q);
          }), V;
        }
        fontMetrics(H) {
          let q = z(j.prototype.getStyle.call(H, "font-size") || 0), X = q < 24 ? q + 3 : Math.round(1.2 * q), $ = Math.round(0.8 * X);
          return { h: X, b: $, f: q };
        }
        rotCorr(H, q, X) {
          let $ = H;
          return q && X && ($ = Math.max($ * Math.cos(q * S), 4)), { x: -H / 3 * Math.sin(q * S), y: $ };
        }
        pathToSegments(H) {
          let q = [], X = [], $ = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let K = 0; K < H.length; K++) k(X[0]) && h(H[K]) && X.length === $[X[0].toUpperCase()] && H.splice(K, 0, X[0].replace("M", "L").replace("m", "l")), typeof H[K] == "string" && (X.length && q.push(X.slice(0)), X.length = 0), X.push(H[K]);
          return q.push(X.slice(0)), q;
        }
        label(H, q, X, $, K, V, Q, Z, ee) {
          return new I(this, H, q, X, $, K, V, Q, Z, ee);
        }
        alignElements() {
          this.alignedObjects.forEach((H) => H.align());
        }
      }
      return b(Y.prototype, { Element: j, SVG_NS: C, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: B, draw: m }), D.registerRendererType("svg", Y, !0), Y;
    }), i(e, "Core/Renderer/HTML/HTMLElement.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { composed: D } = n, { attr: j, css: I, createElement: B, defined: R, extend: N, pInt: x, pushUnique: T } = L;
      function y(M, f, m) {
        var F;
        let C = ((F = this.div) == null ? void 0 : F.style) || m.style;
        l.prototype[`${f}Setter`].call(this, M, f, m), C && (C[f] = M);
      }
      let S = (M, f) => {
        var m;
        if (!M.div) {
          let C = j(M.element, "class"), F = M.css, _ = B("div", C ? { className: C } : void 0, { position: "absolute", left: `${M.translateX || 0}px`, top: `${M.translateY || 0}px`, ...M.styles, display: M.display, opacity: M.opacity, visibility: M.visibility }, ((m = M.parentGroup) == null ? void 0 : m.div) || f);
          M.classSetter = (E, v, w) => {
            w.setAttribute("class", E), _.className = E;
          }, M.translateXSetter = M.translateYSetter = (E, v) => {
            M[v] = E, _.style[v === "translateX" ? "left" : "top"] = `${E}px`, M.doTransform = !0;
          }, M.opacitySetter = M.visibilitySetter = y, M.css = (E) => (F.call(M, E), E.cursor && (_.style.cursor = E.cursor), E.pointerEvents && (_.style.pointerEvents = E.pointerEvents), M), M.on = function() {
            return l.prototype.on.apply({ element: _, onEvents: M.onEvents }, arguments), M;
          }, M.div = _;
        }
        return M.div;
      };
      class u extends l {
        static compose(f) {
          T(D, this.compose) && (f.prototype.html = function(m, C, F) {
            return new u(this, "span").attr({ text: m, x: Math.round(C), y: Math.round(F) });
          });
        }
        constructor(f, m) {
          super(f, m), this.css({ position: "absolute", ...f.styledMode ? {} : { fontFamily: f.style.fontFamily, fontSize: f.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(f, m, C) {
          this.xCorr = -f * C, this.yCorr = -m;
        }
        css(f) {
          let m, { element: C } = this, F = C.tagName === "SPAN" && f && "width" in f, _ = F && f.width;
          return F && (delete f.width, this.textWidth = x(_) || void 0, m = !0), (f == null ? void 0 : f.textOverflow) === "ellipsis" && (f.whiteSpace = "nowrap", f.overflow = "hidden"), N(this.styles, f), I(C, f), m && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: f } = this;
          return { x: f.offsetLeft, y: f.offsetTop, width: f.offsetWidth, height: f.offsetHeight };
        }
        updateTransform() {
          var h;
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: f, renderer: m, rotation: C, rotationOriginX: F, rotationOriginY: _, styles: E, textAlign: v = "left", textWidth: w, translateX: d = 0, translateY: r = 0, x: s = 0, y: p = 0 } = this, b = { left: 0, center: 0.5, right: 1 }[v], c = E.whiteSpace;
          if (I(f, { marginLeft: `${d}px`, marginTop: `${r}px` }), f.tagName === "SPAN") {
            let g = [C, v, f.innerHTML, w, this.textAlign].join(","), k = -(((h = this.parentGroup) == null ? void 0 : h.padding) * 1) || 0, P, O = !1;
            if (w !== this.oldTextWidth) {
              let U = this.textPxLength ? this.textPxLength : (I(f, { width: "", whiteSpace: c || "nowrap" }), f.offsetWidth), H = w || 0;
              (H > this.oldTextWidth || U > H) && (/[ \-]/.test(f.textContent || f.innerText) || f.style.textOverflow === "ellipsis") && (I(f, { width: U > H || C ? w + "px" : "auto", display: "block", whiteSpace: c || "normal" }), this.oldTextWidth = w, O = !0);
            }
            this.hasBoxWidthChanged = O, g !== this.cTT && (P = m.fontMetrics(f).b, R(C) && (C !== (this.oldRotation || 0) || v !== this.oldAlign) && this.setSpanRotation(C, k, k), this.getSpanCorrection(!R(C) && this.textPxLength || f.offsetWidth, P, b));
            let { xCorr: z = 0, yCorr: W = 0 } = this, G = (F != null ? F : s) - z - s - k, Y = (_ != null ? _ : p) - W - p - k;
            I(f, { left: `${s + z}px`, top: `${p + W}px`, transformOrigin: `${G}px ${Y}px` }), this.cTT = g, this.oldRotation = C, this.oldAlign = v;
          }
        }
        setSpanRotation(f, m, C) {
          I(this.element, { transform: `rotate(${f}deg)`, transformOrigin: `${m}% ${C}px` });
        }
        add(f) {
          let m, C = this.renderer.box.parentNode, F = [];
          if (this.parentGroup = f, f && !(m = f.div)) {
            let _ = f;
            for (; _; ) F.push(_), _ = _.parentGroup;
            for (let E of F.reverse()) m = S(E, C);
          }
          return (m || C).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(f) {
          f !== this.textStr && (delete this.bBox, delete this.oldTextWidth, o.setElementHTML(this.element, f != null ? f : ""), this.textStr = f, this.doTransform = !0);
        }
        alignSetter(f) {
          this.alignValue = this.textAlign = f, this.doTransform = !0;
        }
        xSetter(f, m) {
          this[m] = f, this.doTransform = !0;
        }
      }
      let A = u.prototype;
      return A.visibilitySetter = A.opacitySetter = y, A.ySetter = A.rotationSetter = A.rotationOriginXSetter = A.rotationOriginYSetter = A.xSetter, u;
    }), i(e, "Core/Axis/AxisDefaults.js", [], function() {
      var o, n;
      return (n = o || (o = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, n.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: l } = this.axis.chart;
        return l(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, o;
    }), i(e, "Core/Foundation.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: l, isFunction: L, objectEach: D, removeEvent: j } = o;
      return (n || (n = {})).registerEventOptions = function(I, B) {
        I.eventOptions = I.eventOptions || {}, D(B.events, function(R, N) {
          I.eventOptions[N] !== R && (I.eventOptions[N] && (j(I, N, I.eventOptions[N]), delete I.eventOptions[N]), L(R) && (I.eventOptions[N] = R, l(I, N, R, { order: 0 })));
        });
      }, n;
    }), i(e, "Core/Axis/Tick.js", [e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { deg2rad: L } = n, { clamp: D, correctFloat: j, defined: I, destroyObjectProperties: B, extend: R, fireEvent: N, isNumber: x, merge: T, objectEach: y, pick: S } = l;
      return class {
        constructor(u, A, M, f, m) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = u, this.pos = A, this.type = M || "", this.parameters = m || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, N(this, "init"), M || f || this.addLabel();
        }
        addLabel() {
          let u = this, A = u.axis, M = A.options, f = A.chart, m = A.categories, C = A.logarithmic, F = A.names, _ = u.pos, E = S(u.options && u.options.labels, M.labels), v = A.tickPositions, w = _ === v[0], d = _ === v[v.length - 1], r = (!E.step || E.step === 1) && A.tickInterval === 1, s = v.info, p = u.label, b, c, h, g = this.parameters.category || (m ? S(m[_], F[_], _) : _);
          C && x(g) && (g = j(C.lin2log(g))), A.dateTime && (s ? b = (c = f.time.resolveDTLFormat(M.dateTimeLabelFormats[!M.grid && s.higherRanks[_] || s.unitName])).main : x(g) && (b = A.dateTime.getXDateFormat(g, M.dateTimeLabelFormats || {}))), u.isFirst = w, u.isLast = d;
          let k = { axis: A, chart: f, dateTimeLabelFormat: b, isFirst: w, isLast: d, pos: _, tick: u, tickPositionInfo: s, value: g };
          N(this, "labelFormat", k);
          let P = (W) => E.formatter ? E.formatter.call(W, W) : E.format ? (W.text = A.defaultLabelFormatter.call(W), o.format(E.format, W, f)) : A.defaultLabelFormatter.call(W), O = P.call(k, k), z = c && c.list;
          z ? u.shortenLabel = function() {
            for (h = 0; h < z.length; h++) if (R(k, { dateTimeLabelFormat: z[h] }), p.attr({ text: P.call(k, k) }), p.getBBox().width < A.getSlotWidth(u) - 2 * (E.padding || 0)) return;
            p.attr({ text: "" });
          } : u.shortenLabel = void 0, r && A._addedPlotLB && u.moveLabel(O, E), I(p) || u.movedLabel ? p && p.textStr !== O && !r && (!p.textWidth || E.style.width || p.styles.width || p.css({ width: null }), p.attr({ text: O }), p.textPxLength = p.getBBox().width) : (u.label = p = u.createLabel(O, E), u.rotation = 0);
        }
        createLabel(u, A, M) {
          let f = this.axis, m = f.chart, C = I(u) && A.enabled ? m.renderer.text(u, M == null ? void 0 : M.x, M == null ? void 0 : M.y, A.useHTML).add(f.labelGroup) : void 0;
          return C && (m.styledMode || C.css(T(A.style)), C.textPxLength = C.getBBox().width), C;
        }
        destroy() {
          B(this, this.axis);
        }
        getPosition(u, A, M, f) {
          let m = this.axis, C = m.chart, F = f && C.oldChartHeight || C.chartHeight, _ = { x: u ? j(m.translate(A + M, void 0, void 0, f) + m.transB) : m.left + m.offset + (m.opposite ? (f && C.oldChartWidth || C.chartWidth) - m.right - m.left : 0), y: u ? F - m.bottom + m.offset - (m.opposite ? m.height : 0) : j(F - m.translate(A + M, void 0, void 0, f) - m.transB) };
          return _.y = D(_.y, -1e9, 1e9), N(this, "afterGetPosition", { pos: _ }), _;
        }
        getLabelPosition(u, A, M, f, m, C, F, _) {
          let E, v, w = this.axis, d = w.transA, r = w.isLinked && w.linkedParent ? w.linkedParent.reversed : w.reversed, s = w.staggerLines, p = w.tickRotCorr || { x: 0, y: 0 }, b = f || w.reserveSpaceDefault ? 0 : -w.labelOffset * (w.labelAlign === "center" ? 0.5 : 1), c = m.distance, h = {};
          return E = w.side === 0 ? M.rotation ? -c : -M.getBBox().height : w.side === 2 ? p.y + c : Math.cos(M.rotation * L) * (p.y - M.getBBox(!1, 0).height / 2), I(m.y) && (E = w.side === 0 && w.horiz ? m.y + E : m.y), u = u + S(m.x, [0, 1, 0, -1][w.side] * c) + b + p.x - (C && f ? C * d * (r ? -1 : 1) : 0), A = A + E - (C && !f ? C * d * (r ? 1 : -1) : 0), s && (v = F / (_ || 1) % s, w.opposite && (v = s - v - 1), A += v * (w.labelOffset / s)), h.x = u, h.y = Math.round(A), N(this, "afterGetLabelPosition", { pos: h, tickmarkOffset: C, index: F }), h;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(u, A, M, f, m = !1, C) {
          return C.crispLine([["M", u, A], ["L", u + (m ? 0 : -M), A + (m ? M : 0)]], f);
        }
        handleOverflow(u) {
          let A = this.axis, M = A.options.labels, f = u.x, m = A.chart.chartWidth, C = A.chart.spacing, F = S(A.labelLeft, Math.min(A.pos, C[3])), _ = S(A.labelRight, Math.max(A.isRadial ? 0 : A.pos + A.len, m - C[1])), E = this.label, v = this.rotation, w = { left: 0, center: 0.5, right: 1 }[A.labelAlign || E.attr("align")], d = E.getBBox().width, r = A.getSlotWidth(this), s = {}, p = r, b = 1, c, h, g;
          v || M.overflow !== "justify" ? v < 0 && f - w * d < F ? g = Math.round(f / Math.cos(v * L) - F) : v > 0 && f + w * d > _ && (g = Math.round((m - f) / Math.cos(v * L))) : (c = f - w * d, h = f + (1 - w) * d, c < F ? p = u.x + p * (1 - w) - F : h > _ && (p = _ - u.x + p * w, b = -1), (p = Math.min(r, p)) < r && A.labelAlign === "center" && (u.x += b * (r - p - w * (r - Math.min(d, p)))), (d > p || A.autoRotation && (E.styles || {}).width) && (g = p)), g && (this.shortenLabel ? this.shortenLabel() : (s.width = Math.floor(g) + "px", (M.style || {}).textOverflow || (s.textOverflow = "ellipsis"), E.css(s)));
        }
        moveLabel(u, A) {
          let M = this, f = M.label, m = M.axis, C = !1, F;
          f && f.textStr === u ? (M.movedLabel = f, C = !0, delete M.label) : y(m.ticks, function(_) {
            C || _.isNew || _ === M || !_.label || _.label.textStr !== u || (M.movedLabel = _.label, C = !0, _.labelPos = M.movedLabel.xy, delete _.label);
          }), !C && (M.labelPos || f) && (F = M.labelPos || f.xy, M.movedLabel = M.createLabel(u, A, F), M.movedLabel && M.movedLabel.attr({ opacity: 0 }));
        }
        render(u, A, M) {
          let f = this.axis, m = f.horiz, C = this.pos, F = S(this.tickmarkOffset, f.tickmarkOffset), _ = this.getPosition(m, C, F, A), E = _.x, v = _.y, w = f.pos, d = w + f.len, r = m ? E : v;
          !f.chart.polar && this.isNew && (j(r) < w || r > d) && (M = 0);
          let s = S(M, this.label && this.label.newOpacity, 1);
          M = S(M, 1), this.isActive = !0, this.renderGridLine(A, M), this.renderMark(_, M), this.renderLabel(_, A, s, u), this.isNew = !1, N(this, "afterRender");
        }
        renderGridLine(u, A) {
          let M = this.axis, f = M.options, m = {}, C = this.pos, F = this.type, _ = S(this.tickmarkOffset, M.tickmarkOffset), E = M.chart.renderer, v = this.gridLine, w, d = f.gridLineWidth, r = f.gridLineColor, s = f.gridLineDashStyle;
          this.type === "minor" && (d = f.minorGridLineWidth, r = f.minorGridLineColor, s = f.minorGridLineDashStyle), v || (M.chart.styledMode || (m.stroke = r, m["stroke-width"] = d || 0, m.dashstyle = s), F || (m.zIndex = 1), u && (A = 0), this.gridLine = v = E.path().attr(m).addClass("highcharts-" + (F ? F + "-" : "") + "grid-line").add(M.gridGroup)), v && (w = M.getPlotLinePath({ value: C + _, lineWidth: v.strokeWidth(), force: "pass", old: u, acrossPanes: !1 })) && v[u || this.isNew ? "attr" : "animate"]({ d: w, opacity: A });
        }
        renderMark(u, A) {
          let M = this.axis, f = M.options, m = M.chart.renderer, C = this.type, F = M.tickSize(C ? C + "Tick" : "tick"), _ = u.x, E = u.y, v = S(f[C !== "minor" ? "tickWidth" : "minorTickWidth"], !C && M.isXAxis ? 1 : 0), w = f[C !== "minor" ? "tickColor" : "minorTickColor"], d = this.mark, r = !d;
          F && (M.opposite && (F[0] = -F[0]), d || (this.mark = d = m.path().addClass("highcharts-" + (C ? C + "-" : "") + "tick").add(M.axisGroup), M.chart.styledMode || d.attr({ stroke: w, "stroke-width": v })), d[r ? "attr" : "animate"]({ d: this.getMarkPath(_, E, F[0], d.strokeWidth(), M.horiz, m), opacity: A }));
        }
        renderLabel(u, A, M, f) {
          let m = this.axis, C = m.horiz, F = m.options, _ = this.label, E = F.labels, v = E.step, w = S(this.tickmarkOffset, m.tickmarkOffset), d = u.x, r = u.y, s = !0;
          _ && x(d) && (_.xy = u = this.getLabelPosition(d, r, _, C, E, w, f, v), (!this.isFirst || this.isLast || F.showFirstLabel) && (!this.isLast || this.isFirst || F.showLastLabel) ? !C || E.step || E.rotation || A || M === 0 || this.handleOverflow(u) : s = !1, v && f % v && (s = !1), s && x(u.y) ? (u.opacity = M, _[this.isNewLabel ? "attr" : "animate"](u).show(!0), this.isNewLabel = !1) : (_.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let u = this.label, A = this.axis;
          u && !this.isNew && (u.animate({ opacity: 0 }, void 0, u.destroy), delete this.label), A.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), i(e, "Core/Axis/Axis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/AxisDefaults.js"], e["Core/Color/Color.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Axis/Tick.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { animObject: R } = o, { xAxis: N, yAxis: x } = n, { defaultOptions: T } = L, { registerEventOptions: y } = D, { deg2rad: S } = j, { arrayMax: u, arrayMin: A, clamp: M, correctFloat: f, defined: m, destroyObjectProperties: C, erase: F, error: _, extend: E, fireEvent: v, getClosestDistance: w, insertItem: d, isArray: r, isNumber: s, isString: p, merge: b, normalizeTickInterval: c, objectEach: h, pick: g, relativeLength: k, removeEvent: P, splat: O, syncTimeout: z } = B, W = (Y, U) => c(U, void 0, void 0, g(Y.options.allowDecimals, U < 0.5 || Y.tickAmount !== void 0), !!Y.tickAmount);
      E(T, { xAxis: N, yAxis: b(N, x) });
      class G {
        constructor(U, H, q) {
          this.init(U, H, q);
        }
        init(U, H, q = this.coll) {
          var Z, ee, J, ie;
          let X = q === "xAxis", $ = this.isZAxis || (U.inverted ? !X : X);
          this.chart = U, this.horiz = $, this.isXAxis = X, this.coll = q, v(this, "init", { userOptions: H }), this.opposite = g(H.opposite, this.opposite), this.side = g(H.side, this.side, $ ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(H);
          let K = this.options, V = K.labels;
          (Z = this.type) != null || (this.type = K.type || "linear"), (J = this.uniqueNames) != null || (this.uniqueNames = (ee = K.uniqueNames) != null ? ee : !0), v(this, "afterSetType"), this.userOptions = H, this.minPixelPadding = 0, this.reversed = g(K.reversed, this.reversed), this.visible = K.visible, this.zoomEnabled = K.zoomEnabled, this.hasNames = this.type === "category" || K.categories === !0, this.categories = r(K.categories) && K.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = m(K.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, (ie = this.len) != null || (this.len = 0), this.minRange = this.userMinRange = K.minRange || K.maxZoom, this.range = K.range, this.offset = K.offset || 0, this.max = void 0, this.min = void 0;
          let Q = g(K.crosshair, O(U.options.tooltip.crosshairs)[X ? 0 : 1]);
          this.crosshair = Q === !0 ? {} : Q, U.axes.indexOf(this) === -1 && (X ? U.axes.splice(U.xAxis.length, 0, this) : U.axes.push(this), d(this, U[this.coll])), U.orderItems(this.coll), this.series = this.series || [], U.inverted && !this.isZAxis && X && !m(this.reversed) && (this.reversed = !0), this.labelRotation = s(V.rotation) ? V.rotation : void 0, y(this, K), v(this, "afterInit");
        }
        setOptions(U) {
          let H = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = b(H, T[this.coll], U), v(this, "afterSetOptions", { userOptions: U });
        }
        defaultLabelFormatter() {
          let U = this.axis, { numberFormatter: H } = this.chart, q = s(this.value) ? this.value : NaN, X = U.chart.time, $ = U.categories, K = this.dateTimeLabelFormat, V = T.lang, Q = V.numericSymbols, Z = V.numericSymbolMagnitude || 1e3, ee = U.logarithmic ? Math.abs(q) : U.tickInterval, J = Q && Q.length, ie, re;
          if ($) re = `${this.value}`;
          else if (K) re = X.dateFormat(K, q);
          else if (J && Q && ee >= 1e3) for (; J-- && re === void 0; ) ee >= (ie = Math.pow(Z, J + 1)) && 10 * q % ie == 0 && Q[J] !== null && q !== 0 && (re = H(q / ie, -1) + Q[J]);
          return re === void 0 && (re = Math.abs(q) >= 1e4 ? H(q, -1) : H(q, -1, void 0, "")), re;
        }
        getSeriesExtremes() {
          let U, H = this;
          v(this, "getSeriesExtremes", null, function() {
            H.hasVisibleSeries = !1, H.dataMin = H.dataMax = H.threshold = void 0, H.softThreshold = !H.isXAxis, H.series.forEach((q) => {
              if (q.reserveSpace()) {
                let X = q.options, $, K = X.threshold, V, Q;
                if (H.hasVisibleSeries = !0, H.positiveValuesOnly && 0 >= (K || 0) && (K = void 0), H.isXAxis) ($ = q.xData) && $.length && ($ = H.logarithmic ? $.filter((Z) => Z > 0) : $, V = (U = q.getXExtremes($)).min, Q = U.max, s(V) || V instanceof Date || ($ = $.filter(s), V = (U = q.getXExtremes($)).min, Q = U.max), $.length && (H.dataMin = Math.min(g(H.dataMin, V), V), H.dataMax = Math.max(g(H.dataMax, Q), Q)));
                else {
                  let Z = q.applyExtremes();
                  s(Z.dataMin) && (V = Z.dataMin, H.dataMin = Math.min(g(H.dataMin, V), V)), s(Z.dataMax) && (Q = Z.dataMax, H.dataMax = Math.max(g(H.dataMax, Q), Q)), m(K) && (H.threshold = K), (!X.softThreshold || H.positiveValuesOnly) && (H.softThreshold = !1);
                }
              }
            });
          }), v(this, "afterGetSeriesExtremes");
        }
        translate(U, H, q, X, $, K) {
          var he;
          let V = this.linkedParent || this, Q = X && V.old ? V.old.min : V.min;
          if (!s(Q)) return NaN;
          let Z = V.minPixelPadding, ee = (V.isOrdinal || ((he = V.brokenAxis) == null ? void 0 : he.hasBreaks) || V.logarithmic && $) && V.lin2val, J = 1, ie = 0, re = X && V.old ? V.old.transA : V.transA, ce = 0;
          return re || (re = V.transA), q && (J *= -1, ie = V.len), V.reversed && (J *= -1, ie -= J * (V.sector || V.len)), H ? (ce = (U = U * J + ie - Z) / re + Q, ee && (ce = V.lin2val(ce))) : (ee && (U = V.val2lin(U)), ce = J * (U - Q) * re + ie + J * Z + (s(K) ? re * K : 0), V.isRadial || (ce = f(ce))), ce;
        }
        toPixels(U, H) {
          return this.translate(U, !1, !this.horiz, void 0, !0) + (H ? 0 : this.pos);
        }
        toValue(U, H) {
          return this.translate(U - (H ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(U) {
          let H = this, q = H.chart, X = H.left, $ = H.top, K = U.old, V = U.value, Q = U.lineWidth, Z = K && q.oldChartHeight || q.chartHeight, ee = K && q.oldChartWidth || q.chartWidth, J = H.transB, ie = U.translatedValue, re = U.force, ce, he, ne, oe, se;
          function te(le, de, be) {
            return re !== "pass" && (le < de || le > be) && (re ? le = M(le, de, be) : se = !0), le;
          }
          let ae = { value: V, lineWidth: Q, old: K, force: re, acrossPanes: U.acrossPanes, translatedValue: ie };
          return v(this, "getPlotLinePath", ae, function(le) {
            ce = ne = (ie = M(ie = g(ie, H.translate(V, void 0, void 0, K)), -1e9, 1e9)) + J, he = oe = Z - ie - J, s(ie) ? H.horiz ? (he = $, oe = Z - H.bottom + (H.options.isInternal ? 0 : q.scrollablePixelsY || 0), ce = ne = te(ce, X, X + H.width)) : (ce = X, ne = ee - H.right + (q.scrollablePixelsX || 0), he = oe = te(he, $, $ + H.height)) : (se = !0, re = !1), le.path = se && !re ? void 0 : q.renderer.crispLine([["M", ce, he], ["L", ne, oe]], Q || 1);
          }), ae.path;
        }
        getLinearTickPositions(U, H, q) {
          let X, $, K, V = f(Math.floor(H / U) * U), Q = f(Math.ceil(q / U) * U), Z = [];
          if (f(V + U) === V && (K = 20), this.single) return [H];
          for (X = V; X <= Q && (Z.push(X), (X = f(X + U, K)) !== $); ) $ = X;
          return Z;
        }
        getMinorTickInterval() {
          let { minorTicks: U, minorTickInterval: H } = this.options;
          return U === !0 ? g(H, "auto") : U !== !1 ? H : void 0;
        }
        getMinorTickPositions() {
          let U = this.options, H = this.tickPositions, q = this.minorTickInterval, X = this.pointRangePadding || 0, $ = (this.min || 0) - X, K = (this.max || 0) + X, V = K - $, Q = [], Z;
          if (V && V / q < this.len / 3) {
            let ee = this.logarithmic;
            if (ee) this.paddedTicks.forEach(function(J, ie, re) {
              ie && Q.push.apply(Q, ee.getLogTickPositions(q, re[ie - 1], re[ie], !0));
            });
            else if (this.dateTime && this.getMinorTickInterval() === "auto") Q = Q.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(q), $, K, U.startOfWeek));
            else for (Z = $ + (H[0] - $) % q; Z <= K && Z !== Q[0]; Z += q) Q.push(Z);
          }
          return Q.length !== 0 && this.trimTicks(Q), Q;
        }
        adjustForMinRange() {
          let U = this.options, H = this.logarithmic, { max: q, min: X, minRange: $ } = this, K, V, Q, Z;
          this.isXAxis && $ === void 0 && !H && ($ = m(U.min) || m(U.max) || m(U.floor) || m(U.ceiling) ? null : Math.min(5 * (w(this.series.map((ee) => {
            var J;
            return (ee.xIncrement ? (J = ee.xData) == null ? void 0 : J.slice(0, 2) : ee.xData) || [];
          })) || 0), this.dataMax - this.dataMin)), s(q) && s(X) && s($) && q - X < $ && (V = this.dataMax - this.dataMin >= $, K = ($ - q + X) / 2, Q = [X - K, g(U.min, X - K)], V && (Q[2] = H ? H.log2lin(this.dataMin) : this.dataMin), Z = [(X = u(Q)) + $, g(U.max, X + $)], V && (Z[2] = H ? H.log2lin(this.dataMax) : this.dataMax), (q = A(Z)) - X < $ && (Q[0] = q - $, Q[1] = g(U.min, q - $), X = u(Q))), this.minRange = $, this.min = X, this.max = q;
        }
        getClosest() {
          let U, H;
          if (this.categories) H = 1;
          else {
            let q = [];
            this.series.forEach(function(X) {
              var K;
              let $ = X.closestPointRange;
              ((K = X.xData) == null ? void 0 : K.length) === 1 ? q.push(X.xData[0]) : !X.noSharedTooltip && m($) && X.reserveSpace() && (H = m(H) ? Math.min(H, $) : $);
            }), q.length && (q.sort((X, $) => X - $), U = w([q]));
          }
          return U && H ? Math.min(U, H) : U || H;
        }
        nameToX(U) {
          let H = r(this.options.categories), q = H ? this.categories : this.names, X = U.options.x, $;
          return U.series.requireSorting = !1, m(X) || (X = this.uniqueNames && q ? H ? q.indexOf(U.name) : g(q.keys[U.name], -1) : U.series.autoIncrement()), X === -1 ? !H && q && ($ = q.length) : $ = X, $ !== void 0 ? (this.names[$] = U.name, this.names.keys[U.name] = $) : U.x && ($ = U.x), $;
        }
        updateNames() {
          let U = this, H = this.names;
          H.length > 0 && (Object.keys(H.keys).forEach(function(q) {
            delete H.keys[q];
          }), H.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((q) => {
            q.xIncrement = null, (!q.points || q.isDirtyData) && (U.max = Math.max(U.max, q.xData.length - 1), q.processData(), q.generatePoints()), q.data.forEach(function(X, $) {
              let K;
              X != null && X.options && X.name !== void 0 && (K = U.nameToX(X)) !== void 0 && K !== X.x && (X.x = K, q.xData[$] = K);
            });
          }));
        }
        setAxisTranslation() {
          let U = this, H = U.max - U.min, q = U.linkedParent, X = !!U.categories, $ = U.isXAxis, K = U.axisPointRange || 0, V, Q = 0, Z = 0, ee, J = U.transA;
          ($ || X || K) && (V = U.getClosest(), q ? (Q = q.minPointOffset, Z = q.pointRangePadding) : U.series.forEach(function(ie) {
            let re = X ? 1 : $ ? g(ie.options.pointRange, V, 0) : U.axisPointRange || 0, ce = ie.options.pointPlacement;
            if (K = Math.max(K, re), !U.single || X) {
              let he = ie.is("xrange") ? !$ : $;
              Q = Math.max(Q, he && p(ce) ? 0 : re / 2), Z = Math.max(Z, he && ce === "on" ? 0 : re);
            }
          }), ee = U.ordinal && U.ordinal.slope && V ? U.ordinal.slope / V : 1, U.minPointOffset = Q *= ee, U.pointRangePadding = Z *= ee, U.pointRange = Math.min(K, U.single && X ? 1 : H), $ && V && (U.closestPointRange = V)), U.translationSlope = U.transA = J = U.staticScale || U.len / (H + Z || 1), U.transB = U.horiz ? U.left : U.bottom, U.minPixelPadding = J * Q, v(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: U, min: H } = this;
          return s(U) && s(H) && U - H || void 0;
        }
        setTickInterval(U) {
          var we, ke, Oe, Me;
          let { categories: H, chart: q, dataMax: X, dataMin: $, dateTime: K, isXAxis: V, logarithmic: Q, options: Z, softThreshold: ee } = this, J = s(this.threshold) ? this.threshold : void 0, ie = this.minRange || 0, { ceiling: re, floor: ce, linkedTo: he, softMax: ne, softMin: oe } = Z, se = s(he) && ((we = q[this.coll]) == null ? void 0 : we[he]), te = Z.tickPixelInterval, ae = Z.maxPadding, le = Z.minPadding, de = 0, be, ge = s(Z.tickInterval) && Z.tickInterval >= 0 ? Z.tickInterval : void 0, me, fe, Ae, ye;
          if (K || H || se || this.getTickAmount(), Ae = g(this.userMin, Z.min), ye = g(this.userMax, Z.max), se ? (this.linkedParent = se, be = se.getExtremes(), this.min = g(be.min, be.dataMin), this.max = g(be.max, be.dataMax), this.type !== se.type && _(11, !0, q)) : (ee && m(J) && s(X) && s($) && ($ >= J ? (me = J, le = 0) : X <= J && (fe = J, ae = 0)), this.min = g(Ae, me, $), this.max = g(ye, fe, X)), s(this.max) && s(this.min) && (Q && (this.positiveValuesOnly && !U && 0 >= Math.min(this.min, g($, this.min)) && _(10, !0, q), this.min = f(Q.log2lin(this.min), 16), this.max = f(Q.log2lin(this.max), 16)), this.range && s($) && (this.userMin = this.min = Ae = Math.max($, this.minFromRange() || 0), this.userMax = ye = this.max, this.range = void 0)), v(this, "foundExtremes"), this.adjustForMinRange(), s(this.min) && s(this.max)) {
            if (!s(this.userMin) && s(oe) && oe < this.min && (this.min = Ae = oe), !s(this.userMax) && s(ne) && ne > this.max && (this.max = ye = ne), H || this.axisPointRange || (ke = this.stacking) != null && ke.usePercentage || se || !(de = this.max - this.min) || (!m(Ae) && le && (this.min -= de * le), m(ye) || !ae || (this.max += de * ae)), !s(this.userMin) && s(ce) && (this.min = Math.max(this.min, ce)), !s(this.userMax) && s(re) && (this.max = Math.min(this.max, re)), ee && s($) && s(X)) {
              let Ne = J || 0;
              !m(Ae) && this.min < Ne && $ >= Ne ? this.min = Z.minRange ? Math.min(Ne, this.max - ie) : Ne : !m(ye) && this.max > Ne && X <= Ne && (this.max = Z.minRange ? Math.max(Ne, this.min + ie) : Ne);
            }
            !q.polar && this.min > this.max && (m(Z.min) ? this.max = this.min : m(Z.max) && (this.min = this.max)), de = this.max - this.min;
          }
          if (this.min !== this.max && s(this.min) && s(this.max) ? se && !ge && te === se.options.tickPixelInterval ? this.tickInterval = ge = se.tickInterval : this.tickInterval = g(ge, this.tickAmount ? de / Math.max(this.tickAmount - 1, 1) : void 0, H ? 1 : de * te / Math.max(this.len, te)) : this.tickInterval = 1, V && !U) {
            let Ne = this.min !== ((Oe = this.old) == null ? void 0 : Oe.min) || this.max !== ((Me = this.old) == null ? void 0 : Me.max);
            this.series.forEach(function(Ke) {
              var He;
              Ke.forceCrop = (He = Ke.forceCropping) == null ? void 0 : He.call(Ke), Ke.processData(Ne);
            }), v(this, "postProcessData", { hasExtremesChanged: Ne });
          }
          this.setAxisTranslation(), v(this, "initialAxisTranslation"), this.pointRange && !ge && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let xe = g(Z.minTickInterval, K && !this.series.some((Ne) => Ne.noSharedTooltip) ? this.closestPointRange : 0);
          !ge && this.tickInterval < xe && (this.tickInterval = xe), K || Q || ge || (this.tickInterval = W(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          var ee, J;
          let U = this.options, H = U.tickPositions, q = U.tickPositioner, X = this.getMinorTickInterval(), $ = !this.isPanning, K = $ && U.startOnTick, V = $ && U.endOnTick, Q = [], Z;
          if (this.tickmarkOffset = this.categories && U.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && m(this.min) && !this.tickAmount && (this.min % 1 == 0 || U.allowDecimals !== !1), H) Q = H.slice();
          else if (s(this.min) && s(this.max)) {
            if (!((ee = this.ordinal) != null && ee.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) Q = [this.min, this.max], _(19, !1, this.chart);
            else if (this.dateTime) Q = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, U.units), this.min, this.max, U.startOfWeek, (J = this.ordinal) == null ? void 0 : J.positions, this.closestPointRange, !0);
            else if (this.logarithmic) Q = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let ie = this.tickInterval, re = ie;
              for (; re <= 2 * ie && (Q = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && Q.length > this.tickAmount); ) this.tickInterval = W(this, re *= 1.1);
            }
            Q.length > this.len && (Q = [Q[0], Q[Q.length - 1]])[0] === Q[1] && (Q.length = 1), q && (this.tickPositions = Q, (Z = q.apply(this, [this.min, this.max])) && (Q = Z));
          }
          this.tickPositions = Q, this.minorTickInterval = X === "auto" && this.tickInterval ? this.tickInterval / U.minorTicksPerMajor : X, this.paddedTicks = Q.slice(0), this.trimTicks(Q, K, V), !this.isLinked && s(this.min) && s(this.max) && (this.single && Q.length < 2 && !this.categories && !this.series.some((ie) => ie.is("heatmap") && ie.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), H || Z || this.adjustTickAmount()), v(this, "afterSetTickPositions");
        }
        trimTicks(U, H, q) {
          let X = U[0], $ = U[U.length - 1], K = !this.isOrdinal && this.minPointOffset || 0;
          if (v(this, "trimTicks"), !this.isLinked) {
            if (H && X !== -1 / 0) this.min = X;
            else for (; this.min - K > U[0]; ) U.shift();
            if (q) this.max = $;
            else for (; this.max + K < U[U.length - 1]; ) U.pop();
            U.length === 0 && m(X) && !this.options.tickPositions && U.push(($ + X) / 2);
          }
        }
        alignToOthers() {
          let U, H = this, q = H.chart, X = [this], $ = H.options, K = q.options.chart, V = this.coll === "yAxis" && K.alignThresholds, Q = [];
          if (H.thresholdAlignment = void 0, (K.alignTicks !== !1 && $.alignTicks || V) && $.startOnTick !== !1 && $.endOnTick !== !1 && !H.logarithmic) {
            let Z = (J) => {
              let { horiz: ie, options: re } = J;
              return [ie ? re.left : re.top, re.width, re.height, re.pane].join(",");
            }, ee = Z(this);
            q[this.coll].forEach(function(J) {
              let { series: ie } = J;
              ie.length && ie.some((re) => re.visible) && J !== H && Z(J) === ee && (U = !0, X.push(J));
            });
          }
          if (U && V) {
            X.forEach((ee) => {
              let J = ee.getThresholdAlignment(H);
              s(J) && Q.push(J);
            });
            let Z = Q.length > 1 ? Q.reduce((ee, J) => ee += J, 0) / Q.length : void 0;
            X.forEach((ee) => {
              ee.thresholdAlignment = Z;
            });
          }
          return U;
        }
        getThresholdAlignment(U) {
          if ((!s(this.dataMin) || this !== U && this.series.some((H) => H.isDirty || H.isDirtyData)) && this.getSeriesExtremes(), s(this.threshold)) {
            let H = M((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (H = 1 - H), H;
          }
        }
        getTickAmount() {
          let U = this.options, H = U.tickPixelInterval, q = U.tickAmount;
          m(U.tickInterval) || q || !(this.len < H) || this.isRadial || this.logarithmic || !U.startOnTick || !U.endOnTick || (q = 2), !q && this.alignToOthers() && (q = Math.ceil(this.len / H) + 1), q < 4 && (this.finalTickAmt = q, q = 5), this.tickAmount = q;
        }
        adjustTickAmount() {
          let U = this, { finalTickAmt: H, max: q, min: X, options: $, tickPositions: K, tickAmount: V, thresholdAlignment: Q } = U, Z = K == null ? void 0 : K.length, ee = g(U.threshold, U.softThreshold ? 0 : null), J, ie, re = U.tickInterval, ce, he = () => K.push(f(K[K.length - 1] + re)), ne = () => K.unshift(f(K[0] - re));
          if (s(Q) && (ce = Q < 0.5 ? Math.ceil(Q * (V - 1)) : Math.floor(Q * (V - 1)), $.reversed && (ce = V - 1 - ce)), U.hasData() && s(X) && s(q)) {
            let oe = () => {
              U.transA *= (Z - 1) / (V - 1), U.min = $.startOnTick ? K[0] : Math.min(X, K[0]), U.max = $.endOnTick ? K[K.length - 1] : Math.max(q, K[K.length - 1]);
            };
            if (s(ce) && s(U.threshold)) {
              for (; K[ce] !== ee || K.length !== V || K[0] > X || K[K.length - 1] < q; ) {
                for (K.length = 0, K.push(U.threshold); K.length < V; ) K[ce] === void 0 || K[ce] > U.threshold ? ne() : he();
                if (re > 8 * U.tickInterval) break;
                re *= 2;
              }
              oe();
            } else if (Z < V) {
              for (; K.length < V; ) K.length % 2 || X === ee ? he() : ne();
              oe();
            }
            if (m(H)) {
              for (ie = J = K.length; ie--; ) (H === 3 && ie % 2 == 1 || H <= 2 && ie > 0 && ie < J - 1) && K.splice(ie, 1);
              U.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          var K, V;
          let { coll: U, stacking: H } = this, q = !1, X = !1;
          this.series.forEach((Q) => {
            q = q || Q.isDirtyData || Q.isDirty, X = X || Q.xAxis && Q.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let $ = this.len !== (this.old && this.old.len);
          $ || q || X || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (H && U === "yAxis" && H.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), H && U === "xAxis" && H.buildStacks(), this.isDirty || (this.isDirty = $ || this.min !== ((K = this.old) == null ? void 0 : K.min) || this.max !== ((V = this.old) == null ? void 0 : V.max))) : H && H.cleanStacks(), q && delete this.allExtremes, v(this, "afterSetScale");
        }
        setExtremes(U, H, q = !0, X, $) {
          this.series.forEach((K) => {
            delete K.kdTree;
          }), v(this, "setExtremes", $ = E($, { min: U, max: H }), (K) => {
            this.userMin = K.min, this.userMax = K.max, this.eventArgs = K, q && this.chart.redraw(X);
          });
        }
        setAxisSize() {
          let U = this.chart, H = this.options, q = H.offsets || [0, 0, 0, 0], X = this.horiz, $ = this.width = Math.round(k(g(H.width, U.plotWidth - q[3] + q[1]), U.plotWidth)), K = this.height = Math.round(k(g(H.height, U.plotHeight - q[0] + q[2]), U.plotHeight)), V = this.top = Math.round(k(g(H.top, U.plotTop + q[0]), U.plotHeight, U.plotTop)), Q = this.left = Math.round(k(g(H.left, U.plotLeft + q[3]), U.plotWidth, U.plotLeft));
          this.bottom = U.chartHeight - K - V, this.right = U.chartWidth - $ - Q, this.len = Math.max(X ? $ : K, 0), this.pos = X ? Q : V;
        }
        getExtremes() {
          let U = this.logarithmic;
          return { min: U ? f(U.lin2log(this.min)) : this.min, max: U ? f(U.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(U) {
          let H = this.logarithmic, q = H ? H.lin2log(this.min) : this.min, X = H ? H.lin2log(this.max) : this.max;
          return U === null || U === -1 / 0 ? U = q : U === 1 / 0 ? U = X : q > U ? U = q : X < U && (U = X), this.translate(U, 0, 1, 0, 1);
        }
        autoLabelAlign(U) {
          let H = (g(U, 0) - 90 * this.side + 720) % 360, q = { align: "center" };
          return v(this, "autoLabelAlign", q, function(X) {
            H > 15 && H < 165 ? X.align = "right" : H > 195 && H < 345 && (X.align = "left");
          }), q.align;
        }
        tickSize(U) {
          let H = this.options, q = g(H[U === "tick" ? "tickWidth" : "minorTickWidth"], U === "tick" && this.isXAxis && !this.categories ? 1 : 0), X = H[U === "tick" ? "tickLength" : "minorTickLength"], $;
          q && X && (H[U + "Position"] === "inside" && (X = -X), $ = [X, q]);
          let K = { tickSize: $ };
          return v(this, "afterTickSize", K), K.tickSize;
        }
        labelMetrics() {
          let U = this.chart.renderer, H = this.ticks, q = H[Object.keys(H)[0]] || {};
          return this.chart.renderer.fontMetrics(q.label || q.movedLabel || U.box);
        }
        unsquish() {
          let U = this.options.labels, H = U.padding || 0, q = this.horiz, X = this.tickInterval, $ = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / X), K = U.rotation, V = f(0.8 * this.labelMetrics().h), Q = Math.max(this.max - this.min, 0), Z = function(ce) {
            let he = (ce + 2 * H) / ($ || 1);
            return (he = he > 1 ? Math.ceil(he) : 1) * X > Q && ce !== 1 / 0 && $ !== 1 / 0 && Q && (he = Math.ceil(Q / X)), f(he * X);
          }, ee = X, J, ie = Number.MAX_VALUE, re;
          if (q) {
            if (!U.staggerLines && (s(K) ? re = [K] : $ < U.autoRotationLimit && (re = U.autoRotation)), re) {
              let ce, he;
              for (let ne of re) (ne === K || ne && ne >= -90 && ne <= 90) && (he = (ce = Z(Math.abs(V / Math.sin(S * ne)))) + Math.abs(ne / 360)) < ie && (ie = he, J = ne, ee = ce);
            }
          } else ee = Z(0.75 * V);
          return this.autoRotation = re, this.labelRotation = g(J, s(K) ? K : 0), U.step ? X : ee;
        }
        getSlotWidth(U) {
          let H = this.chart, q = this.horiz, X = this.options.labels, $ = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), K = H.margin[3];
          if (U && s(U.slotWidth)) return U.slotWidth;
          if (q && X.step < 2) return X.rotation ? 0 : (this.staggerLines || 1) * this.len / $;
          if (!q) {
            let V = X.style.width;
            if (V !== void 0) return parseInt(String(V), 10);
            if (K) return K - H.spacing[3];
          }
          return 0.33 * H.chartWidth;
        }
        renderUnsquish() {
          let U = this.chart, H = U.renderer, q = this.tickPositions, X = this.ticks, $ = this.options.labels, K = $.style, V = this.horiz, Q = this.getSlotWidth(), Z = Math.max(1, Math.round(Q - (V ? 2 * ($.padding || 0) : $.distance || 0))), ee = {}, J = this.labelMetrics(), ie = K.textOverflow, re, ce, he = 0, ne, oe;
          if (p($.rotation) || (ee.rotation = $.rotation || 0), q.forEach(function(se) {
            let te = X[se];
            te.movedLabel && te.replaceMovedLabel(), te && te.label && te.label.textPxLength > he && (he = te.label.textPxLength);
          }), this.maxLabelLength = he, this.autoRotation) he > Z && he > J.h ? ee.rotation = this.labelRotation : this.labelRotation = 0;
          else if (Q && (re = Z, !ie)) for (ce = "clip", oe = q.length; !V && oe--; ) (ne = X[q[oe]].label) && (ne.styles.textOverflow === "ellipsis" ? ne.css({ textOverflow: "clip" }) : ne.textPxLength > Q && ne.css({ width: Q + "px" }), ne.getBBox().height > this.len / q.length - (J.h - J.f) && (ne.specificTextOverflow = "ellipsis"));
          ee.rotation && (re = he > 0.5 * U.chartHeight ? 0.33 * U.chartHeight : he, ie || (ce = "ellipsis")), this.labelAlign = $.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (ee.align = this.labelAlign), q.forEach(function(se) {
            let te = X[se], ae = te && te.label, le = K.width, de = {};
            ae && (ae.attr(ee), te.shortenLabel ? te.shortenLabel() : re && !le && K.whiteSpace !== "nowrap" && (re < ae.textPxLength || ae.element.tagName === "SPAN") ? (de.width = re + "px", ie || (de.textOverflow = ae.specificTextOverflow || ce), ae.css(de)) : !ae.styles.width || de.width || le || ae.css({ width: null }), delete ae.specificTextOverflow, te.rotation = ee.rotation);
          }, this), this.tickRotCorr = H.rotCorr(J.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(U) {
            return U.hasData();
          }) || this.options.showEmpty && m(this.min) && m(this.max);
        }
        addTitle(U) {
          let H, q = this.chart.renderer, X = this.horiz, $ = this.opposite, K = this.options.title, V = this.chart.styledMode;
          this.axisTitle || ((H = K.textAlign) || (H = (X ? { low: "left", middle: "center", high: "right" } : { low: $ ? "right" : "left", middle: "center", high: $ ? "left" : "right" })[K.align]), this.axisTitle = q.text(K.text || "", 0, 0, K.useHTML).attr({ zIndex: 7, rotation: K.rotation || 0, align: H }).addClass("highcharts-axis-title"), V || this.axisTitle.css(b(K.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), V || K.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[U ? "show" : "hide"](U);
        }
        generateTick(U) {
          let H = this.ticks;
          H[U] ? H[U].addLabel() : H[U] = new I(this, U);
        }
        createGroups() {
          let { axisParent: U, chart: H, coll: q, options: X } = this, $ = H.renderer, K = (V, Q, Z) => $.g(V).attr({ zIndex: Z }).addClass(`highcharts-${q.toLowerCase()}${Q} ` + (this.isRadial ? `highcharts-radial-axis${Q} ` : "") + (X.className || "")).add(U);
          this.axisGroup || (this.gridGroup = K("grid", "-grid", X.gridZIndex), this.axisGroup = K("axis", "", X.zIndex), this.labelGroup = K("axis-labels", "-labels", X.labels.zIndex));
        }
        getOffset() {
          let U = this, { chart: H, horiz: q, options: X, side: $, ticks: K, tickPositions: V, coll: Q } = U, Z = H.inverted && !U.isZAxis ? [1, 0, 3, 2][$] : $, ee = U.hasData(), J = X.title, ie = X.labels, re = s(X.crossing), ce = H.axisOffset, he = H.clipOffset, ne = [-1, 1, 1, -1][$], oe, se = 0, te, ae = 0, le = 0, de, be;
          if (U.showAxis = oe = ee || X.showEmpty, U.staggerLines = U.horiz && ie.staggerLines || void 0, U.createGroups(), ee || U.isLinked ? (V.forEach(function(ge) {
            U.generateTick(ge);
          }), U.renderUnsquish(), U.reserveSpaceDefault = $ === 0 || $ === 2 || { 1: "left", 3: "right" }[$] === U.labelAlign, g(ie.reserveSpace, !re && null, U.labelAlign === "center" || null, U.reserveSpaceDefault) && V.forEach(function(ge) {
            le = Math.max(K[ge].getLabelSize(), le);
          }), U.staggerLines && (le *= U.staggerLines), U.labelOffset = le * (U.opposite ? -1 : 1)) : h(K, function(ge, me) {
            ge.destroy(), delete K[me];
          }), J != null && J.text && J.enabled !== !1 && (U.addTitle(oe), oe && !re && J.reserveSpace !== !1 && (U.titleOffset = se = U.axisTitle.getBBox()[q ? "height" : "width"], ae = m(te = J.offset) ? 0 : g(J.margin, q ? 5 : 10))), U.renderLine(), U.offset = ne * g(X.offset, ce[$] ? ce[$] + (X.margin || 0) : 0), U.tickRotCorr = U.tickRotCorr || { x: 0, y: 0 }, be = $ === 0 ? -U.labelMetrics().h : $ === 2 ? U.tickRotCorr.y : 0, de = Math.abs(le) + ae, le && (de -= be, de += ne * (q ? g(ie.y, U.tickRotCorr.y + ne * ie.distance) : g(ie.x, ne * ie.distance))), U.axisTitleMargin = g(te, de), U.getMaxLabelDimensions && (U.maxLabelDimensions = U.getMaxLabelDimensions(K, V)), Q !== "colorAxis" && he) {
            let ge = this.tickSize("tick");
            ce[$] = Math.max(ce[$], (U.axisTitleMargin || 0) + se + ne * U.offset, de, V && V.length && ge ? ge[0] + ne * U.offset : 0);
            let me = !U.axisLine || X.offset ? 0 : U.axisLine.strokeWidth() / 2;
            he[Z] = Math.max(he[Z], me);
          }
          v(this, "afterGetOffset");
        }
        getLinePath(U) {
          let H = this.chart, q = this.opposite, X = this.offset, $ = this.horiz, K = this.left + (q ? this.width : 0) + X, V = H.chartHeight - this.bottom - (q ? this.height : 0) + X;
          return q && (U *= -1), H.renderer.crispLine([["M", $ ? this.left : K, $ ? V : this.top], ["L", $ ? H.chartWidth - this.right : K, $ ? V : H.chartHeight - this.bottom]], U);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(U) {
          let H = this.horiz, q = this.left, X = this.top, $ = this.len, K = this.options.title, V = H ? q : X, Q = this.opposite, Z = this.offset, ee = K.x, J = K.y, ie = this.chart.renderer.fontMetrics(U), re = U ? Math.max(U.getBBox(!1, 0).height - ie.h - 1, 0) : 0, ce = { low: V + (H ? 0 : $), middle: V + $ / 2, high: V + (H ? $ : 0) }[K.align], he = (H ? X + this.height : q) + (H ? 1 : -1) * (Q ? -1 : 1) * (this.axisTitleMargin || 0) + [-re, re, ie.f, -re][this.side], ne = { x: H ? ce + ee : he + (Q ? this.width : 0) + Z + ee, y: H ? he + J - (Q ? this.height : 0) + Z : ce + J };
          return v(this, "afterGetTitlePosition", { titlePosition: ne }), ne;
        }
        renderMinorTick(U, H) {
          let q = this.minorTicks;
          q[U] || (q[U] = new I(this, U, "minor")), H && q[U].isNew && q[U].render(null, !0), q[U].render(null, !1, 1);
        }
        renderTick(U, H, q) {
          let X = this.isLinked, $ = this.ticks;
          (!X || U >= this.min && U <= this.max || this.grid && this.grid.isColumn) && ($[U] || ($[U] = new I(this, U)), q && $[U].isNew && $[U].render(H, !0, -1), $[U].render(H));
        }
        render() {
          let U, H, q = this, X = q.chart, $ = q.logarithmic, K = X.renderer, V = q.options, Q = q.isLinked, Z = q.tickPositions, ee = q.axisTitle, J = q.ticks, ie = q.minorTicks, re = q.alternateBands, ce = V.stackLabels, he = V.alternateGridColor, ne = V.crossing, oe = q.tickmarkOffset, se = q.axisLine, te = q.showAxis, ae = R(K.globalAnimation);
          if (q.labelEdge.length = 0, q.overlap = !1, [J, ie, re].forEach(function(le) {
            h(le, function(de) {
              de.isActive = !1;
            });
          }), s(ne)) {
            let le = this.isXAxis ? X.yAxis[0] : X.xAxis[0], de = [1, -1, -1, 1][this.side];
            if (le) {
              let be = le.toPixels(ne, !0);
              q.horiz && (be = le.len - be), q.offset = de * be;
            }
          }
          if (q.hasData() || Q) {
            let le = q.chart.hasRendered && q.old && s(q.old.min);
            q.minorTickInterval && !q.categories && q.getMinorTickPositions().forEach(function(de) {
              q.renderMinorTick(de, le);
            }), Z.length && (Z.forEach(function(de, be) {
              q.renderTick(de, be, le);
            }), oe && (q.min === 0 || q.single) && (J[-1] || (J[-1] = new I(q, -1, null, !0)), J[-1].render(-1))), he && Z.forEach(function(de, be) {
              H = Z[be + 1] !== void 0 ? Z[be + 1] + oe : q.max - oe, be % 2 == 0 && de < q.max && H <= q.max + (X.polar ? -oe : oe) && (re[de] || (re[de] = new j.PlotLineOrBand(q, {})), U = de + oe, re[de].options = { from: $ ? $.lin2log(U) : U, to: $ ? $.lin2log(H) : H, color: he, className: "highcharts-alternate-grid" }, re[de].render(), re[de].isActive = !0);
            }), q._addedPlotLB || (q._addedPlotLB = !0, (V.plotLines || []).concat(V.plotBands || []).forEach(function(de) {
              q.addPlotBandOrLine(de);
            }));
          }
          [J, ie, re].forEach(function(le) {
            let de = [], be = ae.duration;
            h(le, function(ge, me) {
              ge.isActive || (ge.render(me, !1, 0), ge.isActive = !1, de.push(me));
            }), z(function() {
              let ge = de.length;
              for (; ge--; ) le[de[ge]] && !le[de[ge]].isActive && (le[de[ge]].destroy(), delete le[de[ge]]);
            }, le !== re && X.hasRendered && be ? be : 0);
          }), se && (se[se.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(se.strokeWidth()) }), se.isPlaced = !0, se[te ? "show" : "hide"](te)), ee && te && (ee[ee.isNew ? "attr" : "animate"](q.getTitlePosition(ee)), ee.isNew = !1), ce && ce.enabled && q.stacking && q.stacking.renderStackTotals(), q.old = { len: q.len, max: q.max, min: q.min, transA: q.transA, userMax: q.userMax, userMin: q.userMin }, q.isDirty = !1, v(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(U) {
            U.render();
          })), this.series.forEach(function(U) {
            U.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || G.keepProps;
        }
        destroy(U) {
          let H = this, q = H.plotLinesAndBands, X = this.eventOptions;
          if (v(this, "destroy", { keepEvents: U }), U || P(H), [H.ticks, H.minorTicks, H.alternateBands].forEach(function($) {
            C($);
          }), q) {
            let $ = q.length;
            for (; $--; ) q[$].destroy();
          }
          for (let $ in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(K) {
            H[K] && (H[K] = H[K].destroy());
          }), H.plotLinesAndBandsGroups) H.plotLinesAndBandsGroups[$] = H.plotLinesAndBandsGroups[$].destroy();
          h(H, function($, K) {
            H.getKeepProps().indexOf(K) === -1 && delete H[K];
          }), this.eventOptions = X;
        }
        drawCrosshair(U, H) {
          let q = this.crosshair, X = g(q && q.snap, !0), $ = this.chart, K, V, Q, Z = this.cross, ee;
          if (v(this, "drawCrosshair", { e: U, point: H }), U || (U = this.cross && this.cross.e), q && (m(H) || !X) !== !1) {
            if (X ? m(H) && (V = g(this.coll !== "colorAxis" ? H.crosshairPos : null, this.isXAxis ? H.plotX : this.len - H.plotY)) : V = U && (this.horiz ? U.chartX - this.pos : this.len - U.chartY + this.pos), m(V) && (ee = { value: H && (this.isXAxis ? H.x : g(H.stackY, H.y)), translatedValue: V }, $.polar && E(ee, { isCrosshair: !0, chartX: U && U.chartX, chartY: U && U.chartY, point: H }), K = this.getPlotLinePath(ee) || null), !m(K)) {
              this.hideCrosshair();
              return;
            }
            Q = this.categories && !this.isRadial, Z || (this.cross = Z = $.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (Q ? "category " : "thin ") + (q.className || "")).attr({ zIndex: g(q.zIndex, 2) }).add(), !$.styledMode && (Z.attr({ stroke: q.color || (Q ? l.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": g(q.width, 1) }).css({ "pointer-events": "none" }), q.dashStyle && Z.attr({ dashstyle: q.dashStyle }))), Z.show().attr({ d: K }), Q && !q.width && Z.attr({ "stroke-width": this.transA }), this.cross.e = U;
          } else this.hideCrosshair();
          v(this, "afterDrawCrosshair", { e: U, point: H });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), v(this, "afterHideCrosshair");
        }
        update(U, H) {
          let q = this.chart;
          U = b(this.userOptions, U), this.destroy(!0), this.init(q, U), q.isDirtyBox = !0, g(H, !0) && q.redraw();
        }
        remove(U) {
          let H = this.chart, q = this.coll, X = this.series, $ = X.length;
          for (; $--; ) X[$] && X[$].remove(!1);
          F(H.axes, this), F(H[q] || [], this), H.orderItems(q), this.destroy(), H.isDirtyBox = !0, g(U, !0) && H.redraw();
        }
        setTitle(U, H) {
          this.update({ title: U }, H);
        }
        setCategories(U, H) {
          this.update({ categories: U }, H);
        }
      }
      return G.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], G;
    }), i(e, "Core/Axis/DateTimeAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: l, getMagnitude: L, normalizeTickInterval: D, timeUnits: j } = o;
      return function(I) {
        function B() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function R() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new N(this));
        }
        I.compose = function(x) {
          return x.keepProps.includes("dateTime") || (x.keepProps.push("dateTime"), x.prototype.getTimeTicks = B, l(x, "afterSetType", R)), x;
        };
        class N {
          constructor(T) {
            this.axis = T;
          }
          normalizeTimeTickInterval(T, y) {
            let S = y || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], u = S[S.length - 1], A = j[u[0]], M = u[1], f;
            for (f = 0; f < S.length && (A = j[(u = S[f])[0]], M = u[1], !S[f + 1] || !(T <= (A * M[M.length - 1] + j[S[f + 1][0]]) / 2)); f++) ;
            A === j.year && T < 5 * A && (M = [1, 2, 5]);
            let m = D(T / A, M, u[0] === "year" ? Math.max(L(T / A), 1) : 1);
            return { unitRange: A, count: m, unitName: u[0] };
          }
          getXDateFormat(T, y) {
            let { axis: S } = this, u = S.chart.time;
            return S.closestPointRange ? u.getDateFormat(S.closestPointRange, T, S.options.startOfWeek, y) || u.resolveDTLFormat(y.year).main : u.resolveDTLFormat(y.day).main;
          }
        }
        I.Additions = N;
      }(n || (n = {})), n;
    }), i(e, "Core/Axis/LogarithmicAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: l, normalizeTickInterval: L, pick: D } = o;
      return function(j) {
        function I() {
          var N;
          this.type !== "logarithmic" ? this.logarithmic = void 0 : (N = this.logarithmic) != null || (this.logarithmic = new R(this));
        }
        function B() {
          let N = this.logarithmic;
          N && (this.lin2val = function(x) {
            return N.lin2log(x);
          }, this.val2lin = function(x) {
            return N.log2lin(x);
          });
        }
        j.compose = function(N) {
          return N.keepProps.includes("logarithmic") || (N.keepProps.push("logarithmic"), l(N, "afterSetType", I), l(N, "afterInit", B)), N;
        };
        class R {
          constructor(x) {
            this.axis = x;
          }
          getLogTickPositions(x, T, y, S) {
            let u = this.axis, A = u.len, M = u.options, f = [];
            if (S || (this.minorAutoInterval = void 0), x >= 0.5) x = Math.round(x), f = u.getLinearTickPositions(x, T, y);
            else if (x >= 0.08) {
              let m, C, F, _, E, v, w, d = Math.floor(T);
              for (m = x > 0.3 ? [1, 2, 4] : x > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], C = d; C < y + 1 && !w; C++) for (F = 0, _ = m.length; F < _ && !w; F++) (E = this.log2lin(this.lin2log(C) * m[F])) > T && (!S || v <= y) && v !== void 0 && f.push(v), v > y && (w = !0), v = E;
            } else {
              let m = this.lin2log(T), C = this.lin2log(y), F = S ? u.getMinorTickInterval() : M.tickInterval, _ = M.tickPixelInterval / (S ? 5 : 1), E = S ? A / u.tickPositions.length : A;
              x = L(x = D(F === "auto" ? null : F, this.minorAutoInterval, (C - m) * _ / (E || 1))), f = u.getLinearTickPositions(x, m, C).map(this.log2lin), S || (this.minorAutoInterval = x / 5);
            }
            return S || (u.tickInterval = x), f;
          }
          lin2log(x) {
            return Math.pow(10, x);
          }
          log2lin(x) {
            return Math.log(x) / Math.LN10;
          }
        }
        j.Additions = R;
      }(n || (n = {})), n;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { erase: l, extend: L, isNumber: D } = o;
      return function(j) {
        let I;
        function B(u) {
          return this.addPlotBandOrLine(u, "plotBands");
        }
        function R(u, A) {
          let M = this.userOptions, f = new I(this, u);
          if (this.visible && (f = f.render()), f) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (M.plotLines || []).concat(M.plotBands || []).forEach((m) => {
              this.addPlotBandOrLine(m);
            })), A) {
              let m = M[A] || [];
              m.push(u), M[A] = m;
            }
            this.plotLinesAndBands.push(f);
          }
          return f;
        }
        function N(u) {
          return this.addPlotBandOrLine(u, "plotLines");
        }
        function x(u, A, M) {
          M = M || this.options;
          let f = this.getPlotLinePath({ value: A, force: !0, acrossPanes: M.acrossPanes }), m = [], C = this.horiz, F = !D(this.min) || !D(this.max) || u < this.min && A < this.min || u > this.max && A > this.max, _ = this.getPlotLinePath({ value: u, force: !0, acrossPanes: M.acrossPanes }), E, v = 1, w;
          if (_ && f) for (F && (w = _.toString() === f.toString(), v = 0), E = 0; E < _.length; E += 2) {
            let d = _[E], r = _[E + 1], s = f[E], p = f[E + 1];
            (d[0] === "M" || d[0] === "L") && (r[0] === "M" || r[0] === "L") && (s[0] === "M" || s[0] === "L") && (p[0] === "M" || p[0] === "L") && (C && s[1] === d[1] ? (s[1] += v, p[1] += v) : C || s[2] !== d[2] || (s[2] += v, p[2] += v), m.push(["M", d[1], d[2]], ["L", r[1], r[2]], ["L", p[1], p[2]], ["L", s[1], s[2]], ["Z"])), m.isFlat = w;
          }
          return m;
        }
        function T(u) {
          this.removePlotBandOrLine(u);
        }
        function y(u) {
          let A = this.plotLinesAndBands, M = this.options, f = this.userOptions;
          if (A) {
            let m = A.length;
            for (; m--; ) A[m].id === u && A[m].destroy();
            [M.plotLines || [], f.plotLines || [], M.plotBands || [], f.plotBands || []].forEach(function(C) {
              for (m = C.length; m--; ) (C[m] || {}).id === u && l(C, C[m]);
            });
          }
        }
        function S(u) {
          this.removePlotBandOrLine(u);
        }
        j.compose = function(u, A) {
          let M = A.prototype;
          return M.addPlotBand || (I = u, L(M, { addPlotBand: B, addPlotLine: N, addPlotBandOrLine: R, getPlotBandPath: x, removePlotBand: T, removePlotLine: S, removePlotBandOrLine: y })), A;
        };
      }(n || (n = {})), n;
    }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], e["Core/Utilities.js"]], function(o, n) {
      let { addEvent: l, arrayMax: L, arrayMin: D, defined: j, destroyObjectProperties: I, erase: B, fireEvent: R, merge: N, objectEach: x, pick: T } = n;
      class y {
        static compose(u, A) {
          return l(u, "afterInit", function() {
            this.labelCollectors.push(() => {
              var f;
              let M = [];
              for (let m of this.axes) for (let { label: C, options: F } of m.plotLinesAndBands) C && !((f = F == null ? void 0 : F.label) != null && f.allowOverlap) && M.push(C);
              return M;
            });
          }), o.compose(y, A);
        }
        constructor(u, A) {
          this.axis = u, this.options = A, this.id = A.id;
        }
        render() {
          var W, G, Y;
          R(this, "render");
          let { axis: u, options: A } = this, { horiz: M, logarithmic: f } = u, { color: m, events: C, zIndex: F = 0 } = A, _ = {}, E = u.chart.renderer, v = A.to, w = A.from, d = A.value, r = A.borderWidth, s = A.label, { label: p, svgElem: b } = this, c = [], h, g = j(w) && j(v), k = j(d), P = !b, O = { class: "highcharts-plot-" + (g ? "band " : "line ") + (A.className || "") }, z = g ? "bands" : "lines";
          if (!u.chart.styledMode && (k ? (O.stroke = m || "#999999", O["stroke-width"] = T(A.width, 1), A.dashStyle && (O.dashstyle = A.dashStyle)) : g && (O.fill = m || "#e6e9ff", r && (O.stroke = A.borderColor, O["stroke-width"] = r))), _.zIndex = F, z += "-" + F, (h = u.plotLinesAndBandsGroups[z]) || (u.plotLinesAndBandsGroups[z] = h = E.g("plot-" + z).attr(_).add()), b || (this.svgElem = b = E.path().attr(O).add(h)), j(d)) c = u.getPlotLinePath({ value: (W = f == null ? void 0 : f.log2lin(d)) != null ? W : d, lineWidth: b.strokeWidth(), acrossPanes: A.acrossPanes });
          else {
            if (!(j(w) && j(v))) return;
            c = u.getPlotBandPath((G = f == null ? void 0 : f.log2lin(w)) != null ? G : w, (Y = f == null ? void 0 : f.log2lin(v)) != null ? Y : v, A);
          }
          return !this.eventsAdded && C && (x(C, (U, H) => {
            b == null || b.on(H, (q) => {
              C[H].apply(this, [q]);
            });
          }), this.eventsAdded = !0), (P || !b.d) && (c != null && c.length) ? b.attr({ d: c }) : b && (c ? (b.show(), b.animate({ d: c })) : b.d && (b.hide(), p && (this.label = p = p.destroy()))), s && (j(s.text) || j(s.formatter)) && (c != null && c.length) && u.width > 0 && u.height > 0 && !c.isFlat ? (s = N({ align: M && g ? "center" : void 0, x: M ? !g && 4 : 10, verticalAlign: !M && g ? "middle" : void 0, y: M ? g ? 16 : 10 : g ? 6 : -4, rotation: M && !g ? 90 : 0, ...g ? { inside: !0 } : {} }, s), this.renderLabel(s, c, g, F)) : p && p.hide(), this;
        }
        renderLabel(u, A, M, f) {
          var s;
          let m = this.axis, C = m.chart.renderer, F = u.inside, _ = this.label;
          _ || (this.label = _ = C.text(this.getLabelText(u), 0, 0, u.useHTML).attr({ align: u.textAlign || u.align, rotation: u.rotation, class: "highcharts-plot-" + (M ? "band" : "line") + "-label " + (u.className || ""), zIndex: f }), m.chart.styledMode || _.css(N({ fontSize: "0.8em", textOverflow: M && !F ? "" : "ellipsis" }, u.style)), _.add());
          let E = A.xBounds || [A[0][1], A[1][1], M ? A[2][1] : A[0][1]], v = A.yBounds || [A[0][2], A[1][2], M ? A[2][2] : A[0][2]], w = D(E), d = D(v), r = L(E) - w;
          _.align(u, !1, { x: w, y: d, width: r, height: L(v) - d }), (!_.alignValue || _.alignValue === "left" || j(F)) && _.css({ width: (((s = u.style) == null ? void 0 : s.width) || (M && F ? r : _.rotation === 90 ? m.height - (_.alignAttr.y - m.top) : (u.clip ? m.width : m.chart.chartWidth) - (_.alignAttr.x - m.left))) + "px" }), _.show(!0);
        }
        getLabelText(u) {
          return j(u.formatter) ? u.formatter.call(this) : u.text;
        }
        destroy() {
          B(this.axis.plotLinesAndBands, this), delete this.axis, I(this);
        }
      }
      return y;
    }), i(e, "Core/Tooltip.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      var I;
      let { animObject: B } = o, { format: R } = n, { composed: N, doc: x, isSafari: T } = l, { distribute: y } = L, { addEvent: S, clamp: u, css: A, discardElement: M, extend: f, fireEvent: m, isArray: C, isNumber: F, isString: _, merge: E, pick: v, pushUnique: w, splat: d, syncTimeout: r } = j;
      class s {
        constructor(b, c, h) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = b, this.init(b, c), this.pointer = h;
        }
        bodyFormatter(b) {
          return b.map(function(c) {
            let h = c.series.tooltipOptions;
            return (h[(c.point.formatPrefix || "point") + "Formatter"] || c.point.tooltipFormatter).call(c.point, h[(c.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(b) {
          this.chart.series.forEach(function(c) {
            let h = c && c.tt;
            h && (!h.isActive || b ? c.tt = h.destroy() : h.isActive = !1);
          });
        }
        defaultFormatter(b) {
          let c, h = this.points || d(this);
          return (c = (c = [b.tooltipFooterHeaderFormatter(h[0])]).concat(b.bodyFormatter(h))).push(b.tooltipFooterHeaderFormatter(h[0], !0)), c;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), M(this.container)), j.clearTimeout(this.hideTimer);
        }
        getAnchor(b, c) {
          let h, { chart: g, pointer: k } = this, P = g.inverted, O = g.plotTop, z = g.plotLeft;
          if ((b = d(b))[0].series && b[0].series.yAxis && !b[0].series.yAxis.options.reversedStacks && (b = b.slice().reverse()), this.followPointer && c) c.chartX === void 0 && (c = k.normalize(c)), h = [c.chartX - z, c.chartY - O];
          else if (b[0].tooltipPos) h = b[0].tooltipPos;
          else {
            let W = 0, G = 0;
            b.forEach(function(Y) {
              let U = Y.pos(!0);
              U && (W += U[0], G += U[1]);
            }), W /= b.length, G /= b.length, this.shared && b.length > 1 && c && (P ? W = c.chartX : G = c.chartY), h = [W - z, G - O];
          }
          return h.map(Math.round);
        }
        getClassName(b, c, h) {
          let g = this.options, k = b.series, P = k.options;
          return [g.className, "highcharts-label", h && "highcharts-tooltip-header", c ? "highcharts-tooltip-box" : "highcharts-tooltip", !h && "highcharts-color-" + v(b.colorIndex, k.colorIndex), P && P.className].filter(_).join(" ");
        }
        getLabel({ anchorX: b, anchorY: c } = { anchorX: 0, anchorY: 0 }) {
          let h = this, g = this.chart.styledMode, k = this.options, P = this.split && this.allowShared, O = this.container, z = this.chart.renderer;
          if (this.label) {
            let W = !this.label.hasClass("highcharts-label");
            (!P && W || P && !W) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let W = this.chart.options.chart.style, G = D.getRendererType();
              this.container = O = l.doc.createElement("div"), O.className = "highcharts-tooltip-container", A(O, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (W && W.zIndex || 0) + 3) }), this.renderer = z = new G(O, 0, 0, W, void 0, void 0, z.styledMode);
            }
            if (P ? this.label = z.g("tooltip") : (this.label = z.label("", b, c, k.shape, void 0, void 0, k.useHTML, void 0, "tooltip").attr({ padding: k.padding, r: k.borderRadius }), g || this.label.attr({ fill: k.backgroundColor, "stroke-width": k.borderWidth || 0 }).css(k.style).css({ pointerEvents: k.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), h.outside) {
              let W = this.label;
              [W.xSetter, W.ySetter].forEach((G, Y) => {
                W[Y ? "ySetter" : "xSetter"] = (U) => {
                  G.call(W, h.distance), W[Y ? "y" : "x"] = U, O && (O.style[Y ? "top" : "left"] = `${U}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(k.shadow).add();
          }
          return O && !O.parentElement && l.doc.body.appendChild(O), this.label;
        }
        getPlayingField() {
          let { body: b, documentElement: c } = x, { chart: h, distance: g, outside: k } = this;
          return { width: k ? Math.max(b.scrollWidth, c.scrollWidth, b.offsetWidth, c.offsetWidth, c.clientWidth) - 2 * g : h.chartWidth, height: k ? Math.max(b.scrollHeight, c.scrollHeight, b.offsetHeight, c.offsetHeight, c.clientHeight) : h.chartHeight };
        }
        getPosition(b, c, h) {
          var ae, le;
          let { distance: g, chart: k, outside: P, pointer: O } = this, { inverted: z, plotLeft: W, plotTop: G, polar: Y } = k, { plotX: U = 0, plotY: H = 0 } = h, q = {}, X = z && h.h || 0, { height: $, width: K } = this.getPlayingField(), V = O.getChartPosition(), Q = (de) => de * V.scaleX, Z = (de) => de * V.scaleY, ee = (de) => {
            let be = de === "x";
            return [de, be ? K : $, be ? b : c].concat(P ? [be ? Q(b) : Z(c), be ? V.left - g + Q(U + W) : V.top - g + Z(H + G), 0, be ? K : $] : [be ? b : c, be ? U + W : H + G, be ? W : G, be ? W + k.plotWidth : G + k.plotHeight]);
          }, J = ee("y"), ie = ee("x"), re, ce = !!h.negative;
          !Y && ((le = (ae = k.hoverSeries) == null ? void 0 : ae.yAxis) != null && le.reversed) && (ce = !ce);
          let he = !this.followPointer && v(h.ttBelow, !Y && !z === ce), ne = function(de, be, ge, me, fe, Ae, ye) {
            let xe = P ? de === "y" ? Z(g) : Q(g) : g, we = (ge - me) / 2, ke = me < fe - g, Oe = fe + g + me < be, Me = fe - xe - ge + we, Ne = fe + xe - we;
            if (he && Oe) q[de] = Ne;
            else if (!he && ke) q[de] = Me;
            else if (ke) q[de] = Math.min(ye - me, Me - X < 0 ? Me : Me - X);
            else {
              if (!Oe) return !1;
              q[de] = Math.max(Ae, Ne + X + ge > be ? Ne : Ne + X);
            }
          }, oe = function(de, be, ge, me, fe) {
            if (fe < g || fe > be - g) return !1;
            fe < ge / 2 ? q[de] = 1 : fe > be - me / 2 ? q[de] = be - me - 2 : q[de] = fe - ge / 2;
          }, se = function(de) {
            [J, ie] = [ie, J], re = de;
          }, te = () => {
            ne.apply(0, J) !== !1 ? oe.apply(0, ie) !== !1 || re || (se(!0), te()) : re ? q.x = q.y = 0 : (se(!0), te());
          };
          return (z && !Y || this.len > 1) && se(), te(), q;
        }
        hide(b) {
          let c = this;
          j.clearTimeout(this.hideTimer), b = v(b, this.options.hideDelay), this.isHidden || (this.hideTimer = r(function() {
            let h = c.getLabel();
            c.getLabel().animate({ opacity: 0 }, { duration: b && 150, complete: () => {
              h.hide(), c.container && c.container.remove();
            } }), c.isHidden = !0;
          }, b));
        }
        init(b, c) {
          this.chart = b, this.options = c, this.crosshairs = [], this.isHidden = !0, this.split = c.split && !b.inverted && !b.polar, this.shared = c.shared || this.split, this.outside = v(c.outside, !!(b.scrollablePixelsX || b.scrollablePixelsY));
        }
        shouldStickOnContact(b) {
          return !!(!this.followPointer && this.options.stickOnContact && (!b || this.pointer.inClass(b.target, "highcharts-tooltip")));
        }
        move(b, c, h, g) {
          let k = this, P = B(!k.isHidden && k.options.animation), O = k.followPointer || (k.len || 0) > 1, z = { x: b, y: c };
          O || (z.anchorX = h, z.anchorY = g), P.step = () => k.drawTracker(), k.getLabel().animate(z, P);
        }
        refresh(b, c) {
          let { chart: h, options: g, pointer: k, shared: P } = this, O = d(b), z = O[0], W = [], G = g.format, Y = g.formatter || this.defaultFormatter, U = h.styledMode, H = {}, q = this.allowShared;
          if (!g.enabled || !z.series) return;
          j.clearTimeout(this.hideTimer), this.allowShared = !(!C(b) && b.series && b.series.noSharedTooltip), q = q && !this.allowShared, this.followPointer = !this.split && z.series.tooltipOptions.followPointer;
          let X = this.getAnchor(b, c), $ = X[0], K = X[1];
          P && this.allowShared ? (k.applyInactiveState(O), O.forEach(function(Z) {
            Z.setState("hover"), W.push(Z.getLabelConfig());
          }), (H = z.getLabelConfig()).points = W) : H = z.getLabelConfig(), this.len = W.length;
          let V = _(G) ? R(G, H, h) : Y.call(H, this), Q = z.series;
          if (this.distance = v(Q.tooltipOptions.distance, 16), V === !1) this.hide();
          else {
            if (this.split && this.allowShared) this.renderSplit(V, O);
            else {
              let Z = $, ee = K;
              if (c && k.isDirectTouch && (Z = c.chartX - h.plotLeft, ee = c.chartY - h.plotTop), h.polar || Q.options.clip === !1 || O.some((J) => k.isDirectTouch || J.series.shouldShowTooltip(Z, ee))) {
                let J = this.getLabel(q && this.tt || {});
                (!g.style.width || U) && J.css({ width: (this.outside ? this.getPlayingField() : h.spacingBox).width + "px" }), J.attr({ class: this.getClassName(z), text: V && V.join ? V.join("") : V }), this.outside && J.attr({ x: u(J.x || 0, 0, this.getPlayingField().width - (J.width || 0)) }), U || J.attr({ stroke: g.borderColor || z.color || Q.color || "#666666" }), this.updatePosition({ plotX: $, plotY: K, negative: z.negative, ttBelow: z.ttBelow, h: X[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          m(this, "refresh");
        }
        renderSplit(b, c) {
          var be;
          let h = this, { chart: g, chart: { chartWidth: k, chartHeight: P, plotHeight: O, plotLeft: z, plotTop: W, scrollablePixelsY: G = 0, scrollablePixelsX: Y, styledMode: U }, distance: H, options: q, options: { positioner: X }, pointer: $ } = h, { scrollLeft: K = 0, scrollTop: V = 0 } = ((be = g.scrollablePlotArea) == null ? void 0 : be.scrollingContainer) || {}, Q = h.outside && typeof Y != "number" ? x.documentElement.getBoundingClientRect() : { left: K, right: K + k }, Z = h.getLabel(), ee = this.renderer || g.renderer, J = !!(g.xAxis[0] && g.xAxis[0].opposite), { left: ie, top: re } = $.getChartPosition(), ce = W + V, he = 0, ne = O - G;
          function oe(ge, me, fe, Ae, ye = !0) {
            let xe, we;
            return fe ? (xe = J ? 0 : ne, we = u(ge - Ae / 2, Q.left, Q.right - Ae - (h.outside ? ie : 0))) : (xe = me - ce, we = u(we = ye ? ge - Ae - H : ge + H, ye ? we : Q.left, Q.right)), { x: we, y: xe };
          }
          _(b) && (b = [!1, b]);
          let se = b.slice(0, c.length + 1).reduce(function(ge, me, fe) {
            if (me !== !1 && me !== "") {
              let Ae = c[fe - 1] || { isHeader: !0, plotX: c[0].plotX, plotY: O, series: {} }, ye = Ae.isHeader, xe = ye ? h : Ae.series, we = xe.tt = function(Ke, He, bt) {
                var bi;
                let xt = Ke, { isHeader: Wi, series: Pa } = He;
                if (!xt) {
                  let pi = { padding: q.padding, r: q.borderRadius };
                  U || (pi.fill = q.backgroundColor, pi["stroke-width"] = (bi = q.borderWidth) != null ? bi : 1), xt = ee.label("", 0, 0, q[Wi ? "headerShape" : "shape"], void 0, void 0, q.useHTML).addClass(h.getClassName(He, !0, Wi)).attr(pi).add(Z);
                }
                return xt.isActive = !0, xt.attr({ text: bt }), U || xt.css(q.style).attr({ stroke: q.borderColor || He.color || Pa.color || "#333333" }), xt;
              }(xe.tt, Ae, me.toString()), ke = we.getBBox(), Oe = ke.width + we.strokeWidth();
              ye && (he = ke.height, ne += he, J && (ce -= he));
              let { anchorX: Me, anchorY: Ne } = function(Ke) {
                let He, bt, { isHeader: xt, plotX: Wi = 0, plotY: Pa = 0, series: bi } = Ke;
                if (xt) He = Math.max(z + Wi, z), bt = W + O / 2;
                else {
                  let { xAxis: pi, yAxis: fo } = bi;
                  He = pi.pos + u(Wi, -H, pi.len + H), bi.shouldShowTooltip(0, fo.pos - W + Pa, { ignoreX: !0 }) && (bt = fo.pos + Pa);
                }
                return { anchorX: He = u(He, Q.left - H, Q.right + H), anchorY: bt };
              }(Ae);
              if (typeof Ne == "number") {
                let Ke = ke.height + 1, He = X ? X.call(h, Oe, Ke, Ae) : oe(Me, Ne, ye, Oe);
                ge.push({ align: X ? 0 : void 0, anchorX: Me, anchorY: Ne, boxWidth: Oe, point: Ae, rank: v(He.rank, ye ? 1 : 0), size: Ke, target: He.y, tt: we, x: He.x });
              } else we.isActive = !1;
            }
            return ge;
          }, []);
          !X && se.some((ge) => {
            let { outside: me } = h, fe = (me ? ie : 0) + ge.anchorX;
            return fe < Q.left && fe + ge.boxWidth < Q.right || fe < ie - Q.left + ge.boxWidth && Q.right - fe > fe;
          }) && (se = se.map((ge) => {
            let { x: me, y: fe } = oe(ge.anchorX, ge.anchorY, ge.point.isHeader, ge.boxWidth, !1);
            return f(ge, { target: fe, x: me });
          })), h.cleanSplit(), y(se, ne);
          let te = { left: ie, right: ie };
          se.forEach(function(ge) {
            let { x: me, boxWidth: fe, isHeader: Ae } = ge;
            !Ae && (h.outside && ie + me < te.left && (te.left = ie + me), !Ae && h.outside && te.left + fe > te.right && (te.right = ie + me));
          }), se.forEach(function(ge) {
            let { x: me, anchorX: fe, anchorY: Ae, pos: ye, point: { isHeader: xe } } = ge, we = { visibility: ye === void 0 ? "hidden" : "inherit", x: me, y: (ye || 0) + ce, anchorX: fe, anchorY: Ae };
            if (h.outside && me < fe) {
              let ke = ie - te.left;
              ke > 0 && (xe || (we.x = me + ke, we.anchorX = fe + ke), xe && (we.x = (te.right - te.left) / 2, we.anchorX = fe + ke));
            }
            ge.tt.attr(we);
          });
          let { container: ae, outside: le, renderer: de } = h;
          if (le && ae && de) {
            let { width: ge, height: me, x: fe, y: Ae } = Z.getBBox();
            de.setSize(ge + fe, me + Ae, !1), ae.style.left = te.left + "px", ae.style.top = re + "px";
          }
          T && Z.attr({ opacity: Z.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let b = this.chart, c = this.label, h = this.shared ? b.hoverPoints : b.hoverPoint;
          if (!c || !h) return;
          let g = { x: 0, y: 0, width: 0, height: 0 }, k = this.getAnchor(h), P = c.getBBox();
          k[0] += b.plotLeft - (c.translateX || 0), k[1] += b.plotTop - (c.translateY || 0), g.x = Math.min(0, k[0]), g.y = Math.min(0, k[1]), g.width = k[0] < 0 ? Math.max(Math.abs(k[0]), P.width - k[0]) : Math.max(Math.abs(k[0]), P.width), g.height = k[1] < 0 ? Math.max(Math.abs(k[1]), P.height - Math.abs(k[1])) : Math.max(Math.abs(k[1]), P.height), this.tracker ? this.tracker.attr(g) : (this.tracker = c.renderer.rect(g).addClass("highcharts-tracker").add(c), b.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(b) {
          return b.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(b, c) {
          let h = b.series, g = h.tooltipOptions, k = h.xAxis, P = k && k.dateTime, O = { isFooter: c, labelConfig: b }, z = g.xDateFormat, W = g[c ? "footerFormat" : "headerFormat"];
          return m(this, "headerFormatter", O, function(G) {
            P && !z && F(b.key) && (z = P.getXDateFormat(b.key, g.dateTimeLabelFormats)), P && z && (b.point && b.point.tooltipDateKeys || ["key"]).forEach(function(Y) {
              W = W.replace("{point." + Y + "}", "{point." + Y + ":" + z + "}");
            }), h.chart.styledMode && (W = this.styledModeFormat(W)), G.text = R(W, { point: b, series: h }, this.chart);
          }), O.text;
        }
        update(b) {
          this.destroy(), this.init(this.chart, E(!0, this.options, b));
        }
        updatePosition(b) {
          let { chart: c, container: h, distance: g, options: k, pointer: P, renderer: O } = this, { height: z = 0, width: W = 0 } = this.getLabel(), { left: G, top: Y, scaleX: U, scaleY: H } = P.getChartPosition(), q = (k.positioner || this.getPosition).call(this, W, z, b), X = (b.plotX || 0) + c.plotLeft, $ = (b.plotY || 0) + c.plotTop, K;
          O && h && (k.positioner && (q.x += G - g, q.y += Y - g), K = (k.borderWidth || 0) + 2 * g + 2, O.setSize(W + K, z + K, !1), (U !== 1 || H !== 1) && (A(h, { transform: `scale(${U}, ${H})` }), X *= U, $ *= H), X += G - q.x, $ += Y - q.y), this.move(Math.round(q.x), Math.round(q.y || 0), X, $);
        }
      }
      return (I = s || (s = {})).compose = function(p) {
        w(N, "Core.Tooltip") && S(p, "afterInit", function() {
          let b = this.chart;
          b.options.tooltip && (b.tooltip = new I(b, b.options.tooltip, this));
        });
      }, s;
    }), i(e, "Core/Series/Point.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { animObject: j } = n, { defaultOptions: I } = l, { format: B } = L, { addEvent: R, crisp: N, erase: x, extend: T, fireEvent: y, getNestedProperty: S, isArray: u, isFunction: A, isNumber: M, isObject: f, merge: m, pick: C, syncTimeout: F, removeEvent: _, uniqueKey: E } = D;
      class v {
        animateBeforeDestroy() {
          let d = this, r = { x: d.startXPos, opacity: 0 }, s = d.getGraphicalProps();
          s.singular.forEach(function(p) {
            d[p] = d[p].animate(p === "dataLabel" ? { x: d[p].startXPos, y: d[p].startYPos, opacity: 0 } : r);
          }), s.plural.forEach(function(p) {
            d[p].forEach(function(b) {
              b.element && b.animate(T({ x: d.startXPos }, b.startYPos ? { x: b.startXPos, y: b.startYPos } : {}));
            });
          });
        }
        applyOptions(d, r) {
          let s = this.series, p = s.options.pointValKey || s.pointValKey;
          return T(this, d = v.prototype.optionsToObject.call(this, d)), this.options = this.options ? T(this.options, d) : d, d.group && delete this.group, d.dataLabels && delete this.dataLabels, p && (this.y = v.prototype.getNestedProperty.call(this, p)), this.selected && (this.state = "select"), "name" in this && r === void 0 && s.xAxis && s.xAxis.hasNames && (this.x = s.xAxis.nameToX(this)), this.x === void 0 && s ? this.x = r != null ? r : s.autoIncrement() : M(d.x) && s.options.relativeXValue && (this.x = s.autoIncrement(d.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let d = this, r = d.series, s = r.chart, p = r.options.dataSorting, b = s.hoverPoints, c = j(d.series.chart.renderer.globalAnimation), h = () => {
              for (let g in (d.graphic || d.graphics || d.dataLabel || d.dataLabels) && (_(d), d.destroyElements()), d) delete d[g];
            };
            d.legendItem && s.legend.destroyItem(d), b && (d.setState(), x(b, d), b.length || (s.hoverPoints = null)), d === s.hoverPoint && d.onMouseOut(), p && p.enabled ? (this.animateBeforeDestroy(), F(h, c.duration)) : h(), s.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(d) {
          let r = this, s = r.getGraphicalProps(d);
          s.singular.forEach(function(p) {
            r[p] = r[p].destroy();
          }), s.plural.forEach(function(p) {
            r[p].forEach(function(b) {
              b && b.element && b.destroy();
            }), delete r[p];
          });
        }
        firePointEvent(d, r, s) {
          let p = this, b = this.series.options;
          p.manageEvent(d), d === "click" && b.allowPointSelect && (s = function(c) {
            !p.destroyed && p.select && p.select(null, c.ctrlKey || c.metaKey || c.shiftKey);
          }), y(p, d, r, s);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(d) {
          let r, s, p = this, b = [], c = { singular: [], plural: [] };
          for ((d = d || { graphic: 1, dataLabel: 1 }).graphic && b.push("graphic", "connector"), d.dataLabel && b.push("dataLabel", "dataLabelPath", "dataLabelUpper"), s = b.length; s--; ) p[r = b[s]] && c.singular.push(r);
          return ["graphic", "dataLabel"].forEach(function(h) {
            let g = h + "s";
            d[h] && p[g] && c.plural.push(g);
          }), c;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(d) {
          return d ? d.indexOf("custom.") === 0 ? S(d, this.options) : this[d] : void 0;
        }
        getZone() {
          let d = this.series, r = d.zones, s = d.zoneAxis || "y", p, b = 0;
          for (p = r[0]; this[s] >= p.value; ) p = r[++b];
          return this.nonZonedColor || (this.nonZonedColor = this.color), p && p.color && !this.options.color ? this.color = p.color : this.color = this.nonZonedColor, p;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(d, r, s) {
          var p;
          this.formatPrefix = "point", this.visible = !0, this.series = d, this.applyOptions(r, s), (p = this.id) != null || (this.id = E()), this.resolveColor(), d.chart.pointCount++, y(this, "afterInit");
        }
        isValid() {
          return (M(this.x) || this.x instanceof Date) && M(this.y);
        }
        optionsToObject(d) {
          let r = this.series, s = r.options.keys, p = s || r.pointArrayMap || ["y"], b = p.length, c = {}, h, g = 0, k = 0;
          if (M(d) || d === null) c[p[0]] = d;
          else if (u(d)) for (!s && d.length > b && ((h = typeof d[0]) == "string" ? c.name = d[0] : h === "number" && (c.x = d[0]), g++); k < b; ) s && d[g] === void 0 || (p[k].indexOf(".") > 0 ? v.prototype.setNestedProperty(c, d[g], p[k]) : c[p[k]] = d[g]), g++, k++;
          else typeof d == "object" && (c = d, d.dataLabels && (r.hasDataLabels = () => !0), d.marker && (r._hasPointMarkers = !0));
          return c;
        }
        pos(d, r = this.plotY) {
          if (!this.destroyed) {
            let { plotX: s, series: p } = this, { chart: b, xAxis: c, yAxis: h } = p, g = 0, k = 0;
            if (M(s) && M(r)) return d && (g = c ? c.pos : b.plotLeft, k = h ? h.pos : b.plotTop), b.inverted && c && h ? [h.len - r + k, c.len - s + g] : [s + g, r + k];
          }
        }
        resolveColor() {
          let d = this.series, r = d.chart.options.chart, s = d.chart.styledMode, p, b, c = r.colorCount, h;
          delete this.nonZonedColor, d.options.colorByPoint ? (s || (p = (b = d.options.colors || d.chart.options.colors)[d.colorCounter], c = b.length), h = d.colorCounter, d.colorCounter++, d.colorCounter === c && (d.colorCounter = 0)) : (s || (p = d.color), h = d.colorIndex), this.colorIndex = C(this.options.colorIndex, h), this.color = C(this.options.color, p);
        }
        setNestedProperty(d, r, s) {
          return s.split(".").reduce(function(p, b, c, h) {
            let g = h.length - 1 === c;
            return p[b] = g ? r : f(p[b], !0) ? p[b] : {}, p[b];
          }, d), d;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(d) {
          let r = this.series, s = r.tooltipOptions, p = C(s.valueDecimals, ""), b = s.valuePrefix || "", c = s.valueSuffix || "";
          return r.chart.styledMode && (d = r.chart.tooltip.styledModeFormat(d)), (r.pointArrayMap || ["y"]).forEach(function(h) {
            h = "{point." + h, (b || c) && (d = d.replace(RegExp(h + "}", "g"), b + h + "}" + c)), d = d.replace(RegExp(h + "}", "g"), h + ":,." + p + "f}");
          }), B(d, { point: this, series: this.series }, r.chart);
        }
        update(d, r, s, p) {
          let b, c = this, h = c.series, g = c.graphic, k = h.chart, P = h.options;
          function O() {
            c.applyOptions(d);
            let z = g && c.hasMockGraphic, W = c.y === null ? !z : z;
            g && W && (c.graphic = g.destroy(), delete c.hasMockGraphic), f(d, !0) && (g && g.element && d && d.marker && d.marker.symbol !== void 0 && (c.graphic = g.destroy()), d != null && d.dataLabels && c.dataLabel && (c.dataLabel = c.dataLabel.destroy())), b = c.index, h.updateParallelArrays(c, b), P.data[b] = f(P.data[b], !0) || f(d, !0) ? c.options : C(d, P.data[b]), h.isDirty = h.isDirtyData = !0, !h.fixedBox && h.hasCartesianSeries && (k.isDirtyBox = !0), P.legendType === "point" && (k.isDirtyLegend = !0), r && k.redraw(s);
          }
          r = C(r, !0), p === !1 ? O() : c.firePointEvent("update", { options: d }, O);
        }
        remove(d, r) {
          this.series.removePoint(this.series.data.indexOf(this), d, r);
        }
        select(d, r) {
          let s = this, p = s.series, b = p.chart;
          d = C(d, !s.selected), this.selectedStaging = d, s.firePointEvent(d ? "select" : "unselect", { accumulate: r }, function() {
            s.selected = s.options.selected = d, p.options.data[p.data.indexOf(s)] = s.options, s.setState(d && "select"), r || b.getSelectedPoints().forEach(function(c) {
              let h = c.series;
              c.selected && c !== s && (c.selected = c.options.selected = !1, h.options.data[h.data.indexOf(c)] = c.options, c.setState(b.hoverPoints && h.options.inactiveOtherPoints ? "inactive" : ""), c.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(d) {
          let { inverted: r, pointer: s } = this.series.chart;
          s && (d = d ? s.normalize(d) : s.getChartCoordinatesFromPoint(this, r), s.runPointActions(d, this));
        }
        onMouseOut() {
          let d = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (d.hoverPoints || []).forEach(function(r) {
            r.setState();
          }), d.hoverPoints = d.hoverPoint = null;
        }
        manageEvent(d) {
          var p, b, c, h, g, k;
          let r = m(this.series.options.point, this.options), s = (p = r.events) == null ? void 0 : p[d];
          A(s) && (!((b = this.hcEvents) != null && b[d]) || ((h = (c = this.hcEvents) == null ? void 0 : c[d]) == null ? void 0 : h.map((P) => P.fn).indexOf(s)) === -1) ? ((g = this.importedUserEvent) == null || g.call(this), this.importedUserEvent = R(this, d, s)) : this.importedUserEvent && !s && ((k = this.hcEvents) != null && k[d]) && (_(this, d), delete this.hcEvents[d], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(d, r) {
          var V;
          let s = this.series, p = this.state, b = s.options.states[d || "normal"] || {}, c = I.plotOptions[s.type].marker && s.options.marker, h = c && c.enabled === !1, g = c && c.states && c.states[d || "normal"] || {}, k = g.enabled === !1, P = this.marker || {}, O = s.chart, z = c && s.markerAttribs, W = s.halo, G, Y, U, H = s.stateMarkerGraphic, q;
          if ((d = d || "") === this.state && !r || this.selected && d !== "select" || b.enabled === !1 || d && (k || h && g.enabled === !1) || d && P.states && P.states[d] && P.states[d].enabled === !1) return;
          if (this.state = d, z && (G = s.markerAttribs(this, d)), this.graphic && !this.hasMockGraphic) {
            if (p && this.graphic.removeClass("highcharts-point-" + p), d && this.graphic.addClass("highcharts-point-" + d), !O.styledMode) {
              Y = s.pointAttribs(this, d), U = C(O.options.chart.animation, b.animation);
              let Q = Y.opacity;
              s.options.inactiveOtherPoints && M(Q) && (this.dataLabels || []).forEach(function(Z) {
                Z && !Z.hasClass("highcharts-data-label-hidden") && (Z.animate({ opacity: Q }, U), Z.connector && Z.connector.animate({ opacity: Q }, U));
              }), this.graphic.animate(Y, U);
            }
            G && this.graphic.animate(G, C(O.options.chart.animation, g.animation, c.animation)), H && H.hide();
          } else d && g && (q = P.symbol || s.symbol, H && H.currentSymbol !== q && (H = H.destroy()), G && (H ? H[r ? "animate" : "attr"]({ x: G.x, y: G.y }) : q && (s.stateMarkerGraphic = H = O.renderer.symbol(q, G.x, G.y, G.width, G.height).add(s.markerGroup), H.currentSymbol = q)), !O.styledMode && H && this.state !== "inactive" && H.attr(s.pointAttribs(this, d))), H && (H[d && this.isInside ? "show" : "hide"](), H.element.point = this, H.addClass(this.getClassName(), !0));
          let X = b.halo, $ = this.graphic || H, K = $ && $.visibility || "inherit";
          X && X.size && $ && K !== "hidden" && !this.isCluster ? (W || (s.halo = W = O.renderer.path().add($.parentGroup)), W.show()[r ? "animate" : "attr"]({ d: this.haloPath(X.size) }), W.attr({ class: "highcharts-halo highcharts-color-" + C(this.colorIndex, s.colorIndex) + (this.className ? " " + this.className : ""), visibility: K, zIndex: -1 }), W.point = this, O.styledMode || W.attr(T({ fill: this.color || s.color, "fill-opacity": X.opacity }, o.filterUserAttributes(X.attributes || {})))) : (V = W == null ? void 0 : W.point) != null && V.haloPath && !W.point.destroyed && W.animate({ d: W.point.haloPath(0) }, null, W.hide), y(this, "afterSetState", { state: d });
        }
        haloPath(d) {
          let r = this.pos();
          return r ? this.series.chart.renderer.symbols.circle(N(r[0], 1) - d, r[1] - d, 2 * d, 2 * d) : [];
        }
      }
      return v;
    }), i(e, "Core/Pointer.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L;
      let { parse: D } = o, { charts: j, composed: I, isTouchDevice: B } = n, { addEvent: R, attr: N, css: x, extend: T, find: y, fireEvent: S, isNumber: u, isObject: A, objectEach: M, offset: f, pick: m, pushUnique: C, splat: F } = l;
      class _ {
        applyInactiveState(v) {
          let w = [], d;
          (v || []).forEach(function(r) {
            d = r.series, w.push(d), d.linkedParent && w.push(d.linkedParent), d.linkedSeries && (w = w.concat(d.linkedSeries)), d.navigatorSeries && w.push(d.navigatorSeries);
          }), this.chart.series.forEach(function(r) {
            w.indexOf(r) === -1 ? r.setState("inactive", !0) : r.options.inactiveOtherPoints && r.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let v = this;
          this.eventsToUnbind.forEach((w) => w()), this.eventsToUnbind = [], !n.chartCount && (_.unbindDocumentMouseUp && _.unbindDocumentMouseUp.forEach((w) => w()), _.unbindDocumentTouchEnd && (_.unbindDocumentTouchEnd = _.unbindDocumentTouchEnd())), clearInterval(v.tooltipTimeout), M(v, function(w, d) {
            v[d] = void 0;
          });
        }
        getSelectionMarkerAttrs(v, w) {
          let d = { args: { chartX: v, chartY: w }, attrs: {}, shapeType: "rect" };
          return S(this, "getSelectionMarkerAttrs", d, (r) => {
            let s, { chart: p, zoomHor: b, zoomVert: c } = this, { mouseDownX: h = 0, mouseDownY: g = 0 } = p, k = r.attrs;
            k.x = p.plotLeft, k.y = p.plotTop, k.width = b ? 1 : p.plotWidth, k.height = c ? 1 : p.plotHeight, b && (s = v - h, k.width = Math.max(1, Math.abs(s)), k.x = (s > 0 ? 0 : s) + h), c && (s = w - g, k.height = Math.max(1, Math.abs(s)), k.y = (s > 0 ? 0 : s) + g);
          }), d;
        }
        drag(v) {
          let { chart: w } = this, { mouseDownX: d = 0, mouseDownY: r = 0 } = w, { panning: s, panKey: p, selectionMarkerFill: b } = w.options.chart, c = w.plotLeft, h = w.plotTop, g = w.plotWidth, k = w.plotHeight, P = A(s) ? s.enabled : s, O = p && v[`${p}Key`], z = v.chartX, W = v.chartY, G, Y = this.selectionMarker;
          if ((!Y || !Y.touch) && (z < c ? z = c : z > c + g && (z = c + g), W < h ? W = h : W > h + k && (W = h + k), this.hasDragged = Math.sqrt(Math.pow(d - z, 2) + Math.pow(r - W, 2)), this.hasDragged > 10)) {
            G = w.isInsidePlot(d - c, r - h, { visiblePlotOnly: !0 });
            let { shapeType: U, attrs: H } = this.getSelectionMarkerAttrs(z, W);
            (w.hasCartesianSeries || w.mapView) && this.hasZoom && G && !O && !Y && (this.selectionMarker = Y = w.renderer[U](), Y.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), w.styledMode || Y.attr({ fill: b || D("#334eff").setOpacity(0.25).get() })), Y && Y.attr(H), G && !Y && P && w.pan(v, s);
          }
        }
        dragStart(v) {
          let w = this.chart;
          w.mouseIsDown = v.type, w.cancelClick = !1, w.mouseDownX = v.chartX, w.mouseDownY = v.chartY;
        }
        getSelectionBox(v) {
          let w = { args: { marker: v }, result: v.getBBox() };
          return S(this, "getSelectionBox", w), w.result;
        }
        drop(v) {
          let w, { chart: d, selectionMarker: r } = this;
          for (let s of d.axes) s.isPanning && (s.isPanning = !1, (s.options.startOnTick || s.options.endOnTick || s.series.some((p) => p.boosted)) && (s.forceRedraw = !0, s.setExtremes(s.userMin, s.userMax, !1), w = !0));
          if (w && d.redraw(), r && v) {
            if (this.hasDragged) {
              let s = this.getSelectionBox(r);
              d.transform({ axes: d.axes.filter((p) => p.zoomEnabled && (p.coll === "xAxis" && this.zoomX || p.coll === "yAxis" && this.zoomY)), selection: { originalEvent: v, xAxis: [], yAxis: [], ...s }, from: s });
            }
            u(d.index) && (this.selectionMarker = r.destroy());
          }
          d && u(d.index) && (x(d.container, { cursor: d._cursor }), d.cancelClick = this.hasDragged > 10, d.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(v, w, d) {
          let r;
          return v.forEach(function(s) {
            let p = !(s.noSharedTooltip && w) && 0 > s.options.findNearestPointBy.indexOf("y"), b = s.searchPoint(d, p);
            A(b, !0) && b.series && (!A(r, !0) || function(c, h) {
              var O, z;
              let g = c.distX - h.distX, k = c.dist - h.dist, P = ((O = h.series.group) == null ? void 0 : O.zIndex) - ((z = c.series.group) == null ? void 0 : z.zIndex);
              return g !== 0 && w ? g : k !== 0 ? k : P !== 0 ? P : c.series.index > h.series.index ? -1 : 1;
            }(r, b) > 0) && (r = b);
          }), r;
        }
        getChartCoordinatesFromPoint(v, w) {
          var p, b;
          let { xAxis: d, yAxis: r } = v.series, s = v.shapeArgs;
          if (d && r) {
            let c = (b = (p = v.clientX) != null ? p : v.plotX) != null ? b : 0, h = v.plotY || 0;
            return v.isNode && s && u(s.x) && u(s.y) && (c = s.x, h = s.y), w ? { chartX: r.len + r.pos - h, chartY: d.len + d.pos - c } : { chartX: c + d.pos, chartY: h + r.pos };
          }
          if (s && s.x && s.y) return { chartX: s.x, chartY: s.y };
        }
        getChartPosition() {
          if (this.chartPosition) return this.chartPosition;
          let { container: v } = this.chart, w = f(v);
          this.chartPosition = { left: w.left, top: w.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: d, offsetWidth: r } = v;
          return r > 2 && d > 2 && (this.chartPosition.scaleX = w.width / r, this.chartPosition.scaleY = w.height / d), this.chartPosition;
        }
        getCoordinates(v) {
          let w = { xAxis: [], yAxis: [] };
          for (let d of this.chart.axes) w[d.isXAxis ? "xAxis" : "yAxis"].push({ axis: d, value: d.toValue(v[d.horiz ? "chartX" : "chartY"]) });
          return w;
        }
        getHoverData(v, w, d, r, s, p) {
          let b = [], c = function(O) {
            return O.visible && !(!s && O.directTouch) && m(O.options.enableMouseTracking, !0);
          }, h = w, g, k = { chartX: p ? p.chartX : void 0, chartY: p ? p.chartY : void 0, shared: s };
          S(this, "beforeGetHoverData", k), g = h && !h.stickyTracking ? [h] : d.filter((O) => O.stickyTracking && (k.filter || c)(O));
          let P = r && v || !p ? v : this.findNearestKDPoint(g, s, p);
          return h = P && P.series, P && (s && !h.noSharedTooltip ? (g = d.filter(function(O) {
            return k.filter ? k.filter(O) : c(O) && !O.noSharedTooltip;
          })).forEach(function(O) {
            let z = y(O.points, function(W) {
              return W.x === P.x && !W.isNull;
            });
            A(z) && (O.boosted && O.boost && (z = O.boost.getPoint(z)), b.push(z));
          }) : b.push(P)), S(this, "afterGetHoverData", k = { hoverPoint: P }), { hoverPoint: k.hoverPoint, hoverSeries: h, hoverPoints: b };
        }
        getPointFromEvent(v) {
          let w = v.target, d;
          for (; w && !d; ) d = w.point, w = w.parentNode;
          return d;
        }
        onTrackerMouseOut(v) {
          let w = this.chart, d = v.relatedTarget, r = w.hoverSeries;
          this.isDirectTouch = !1, !r || !d || r.stickyTracking || this.inClass(d, "highcharts-tooltip") || this.inClass(d, "highcharts-series-" + r.index) && this.inClass(d, "highcharts-tracker") || r.onMouseOut();
        }
        inClass(v, w) {
          let d = v, r;
          for (; d; ) {
            if (r = N(d, "class")) {
              if (r.indexOf(w) !== -1) return !0;
              if (r.indexOf("highcharts-container") !== -1) return !1;
            }
            d = d.parentElement;
          }
        }
        constructor(v, w) {
          var d;
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = w, this.chart = v, this.runChartClick = !!((d = w.chart.events) != null && d.click), this.pinchDown = [], this.setDOMEvents(), S(this, "afterInit");
        }
        normalize(v, w) {
          let d = v.touches, r = d ? d.length ? d.item(0) : m(d.changedTouches, v.changedTouches)[0] : v;
          w || (w = this.getChartPosition());
          let s = r.pageX - w.left, p = r.pageY - w.top;
          return T(v, { chartX: Math.round(s /= w.scaleX), chartY: Math.round(p /= w.scaleY) });
        }
        onContainerClick(v) {
          let w = this.chart, d = w.hoverPoint, r = this.normalize(v), s = w.plotLeft, p = w.plotTop;
          !w.cancelClick && (d && this.inClass(r.target, "highcharts-tracker") ? (S(d.series, "click", T(r, { point: d })), w.hoverPoint && d.firePointEvent("click", r)) : (T(r, this.getCoordinates(r)), w.isInsidePlot(r.chartX - s, r.chartY - p, { visiblePlotOnly: !0 }) && S(w, "click", r)));
        }
        onContainerMouseDown(v) {
          var d;
          let w = (1 & (v.buttons || v.button)) == 1;
          v = this.normalize(v), n.isFirefox && v.button !== 0 && this.onContainerMouseMove(v), (v.button === void 0 || w) && (this.zoomOption(v), w && ((d = v.preventDefault) == null || d.call(v)), this.dragStart(v));
        }
        onContainerMouseLeave(v) {
          let { pointer: w } = j[m(_.hoverChartIndex, -1)] || {};
          v = this.normalize(v), this.onContainerMouseMove(v), w && !this.inClass(v.relatedTarget, "highcharts-tooltip") && (w.reset(), w.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(v) {
          let w = this.chart, d = w.tooltip, r = this.normalize(v);
          this.setHoverChartIndex(v), (w.mouseIsDown === "mousedown" || this.touchSelect(r)) && this.drag(r), !w.openMenu && (this.inClass(r.target, "highcharts-tracker") || w.isInsidePlot(r.chartX - w.plotLeft, r.chartY - w.plotTop, { visiblePlotOnly: !0 })) && !(d && d.shouldStickOnContact(r)) && (this.inClass(r.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(r));
        }
        onDocumentTouchEnd(v) {
          this.onDocumentMouseUp(v);
        }
        onContainerTouchMove(v) {
          this.touchSelect(v) ? this.onContainerMouseMove(v) : this.touch(v);
        }
        onContainerTouchStart(v) {
          this.touchSelect(v) ? this.onContainerMouseDown(v) : (this.zoomOption(v), this.touch(v, !0));
        }
        onDocumentMouseMove(v) {
          let w = this.chart, d = w.tooltip, r = this.chartPosition, s = this.normalize(v, r);
          !r || w.isInsidePlot(s.chartX - w.plotLeft, s.chartY - w.plotTop, { visiblePlotOnly: !0 }) || d && d.shouldStickOnContact(s) || s.target !== w.container.ownerDocument && this.inClass(s.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(v) {
          var w, d;
          (d = (w = j[m(_.hoverChartIndex, -1)]) == null ? void 0 : w.pointer) == null || d.drop(v);
        }
        pinch(v) {
          let w = this, { chart: d, hasZoom: r, lastTouches: s } = w, p = [].map.call(v.touches || [], (k) => w.normalize(k)), b = p.length, c = b === 1 && (w.inClass(v.target, "highcharts-tracker") && d.runTrackerClick || w.runChartClick), h = d.tooltip, g = b === 1 && m(h == null ? void 0 : h.options.followTouchMove, !0);
          b > 1 ? w.initiated = !0 : g && (w.initiated = !1), r && w.initiated && !c && v.cancelable !== !1 && v.preventDefault(), v.type === "touchstart" ? (w.pinchDown = p, w.res = !0, d.mouseDownX = v.chartX) : g ? this.runPointActions(w.normalize(v)) : s && (S(d, "touchpan", { originalEvent: v, touches: p }, () => {
            let k = (P) => {
              let O = P[0], z = P[1] || O;
              return { x: O.chartX, y: O.chartY, width: z.chartX - O.chartX, height: z.chartY - O.chartY };
            };
            d.transform({ axes: d.axes.filter((P) => P.zoomEnabled && (this.zoomHor && P.horiz || this.zoomVert && !P.horiz)), to: k(p), from: k(s), trigger: v.type });
          }), w.res && (w.res = !1, this.reset(!1, 0))), w.lastTouches = p;
        }
        reset(v, w) {
          let d = this.chart, r = d.hoverSeries, s = d.hoverPoint, p = d.hoverPoints, b = d.tooltip, c = b && b.shared ? p : s;
          v && c && F(c).forEach(function(h) {
            h.series.isCartesian && h.plotX === void 0 && (v = !1);
          }), v ? b && c && F(c).length && (b.refresh(c), b.shared && p ? p.forEach(function(h) {
            h.setState(h.state, !0), h.series.isCartesian && (h.series.xAxis.crosshair && h.series.xAxis.drawCrosshair(null, h), h.series.yAxis.crosshair && h.series.yAxis.drawCrosshair(null, h));
          }) : s && (s.setState(s.state, !0), d.axes.forEach(function(h) {
            h.crosshair && s.series[h.coll] === h && h.drawCrosshair(null, s);
          }))) : (s && s.onMouseOut(), p && p.forEach(function(h) {
            h.setState();
          }), r && r.onMouseOut(), b && b.hide(w), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), d.axes.forEach(function(h) {
            h.hideCrosshair();
          }), d.hoverPoints = d.hoverPoint = void 0);
        }
        runPointActions(v, w, d) {
          let r = this.chart, s = r.series, p = r.tooltip && r.tooltip.options.enabled ? r.tooltip : void 0, b = !!p && p.shared, c = w || r.hoverPoint, h = c && c.series || r.hoverSeries, g = (!v || v.type !== "touchmove") && (!!w || h && h.directTouch && this.isDirectTouch), k = this.getHoverData(c, h, s, g, b, v);
          c = k.hoverPoint, h = k.hoverSeries;
          let P = k.hoverPoints, O = h && h.tooltipOptions.followPointer && !h.tooltipOptions.split, z = b && h && !h.noSharedTooltip;
          if (c && (d || c !== r.hoverPoint || p && p.isHidden)) {
            if ((r.hoverPoints || []).forEach(function(W) {
              P.indexOf(W) === -1 && W.setState();
            }), r.hoverSeries !== h && h.onMouseOver(), this.applyInactiveState(P), (P || []).forEach(function(W) {
              W.setState("hover");
            }), r.hoverPoint && r.hoverPoint.firePointEvent("mouseOut"), !c.series) return;
            r.hoverPoints = P, r.hoverPoint = c, c.firePointEvent("mouseOver", void 0, () => {
              p && c && p.refresh(z ? P : c, v);
            });
          } else if (O && p && !p.isHidden) {
            let W = p.getAnchor([{}], v);
            r.isInsidePlot(W[0], W[1], { visiblePlotOnly: !0 }) && p.updatePosition({ plotX: W[0], plotY: W[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = R(r.container.ownerDocument, "mousemove", (W) => {
            var G, Y, U;
            return (U = (Y = j[(G = _.hoverChartIndex) != null ? G : -1]) == null ? void 0 : Y.pointer) == null ? void 0 : U.onDocumentMouseMove(W);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), r.axes.forEach(function(W) {
            let G, Y = m((W.crosshair || {}).snap, !0);
            !Y || (G = r.hoverPoint) && G.series[W.coll] === W || (G = y(P, (U) => U.series && U.series[W.coll] === W)), G || !Y ? W.drawCrosshair(v, G) : W.hideCrosshair();
          });
        }
        setDOMEvents() {
          let v = this.chart.container, w = v.ownerDocument;
          v.onmousedown = this.onContainerMouseDown.bind(this), v.onmousemove = this.onContainerMouseMove.bind(this), v.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(R(v, "mouseenter", this.onContainerMouseEnter.bind(this)), R(v, "mouseleave", this.onContainerMouseLeave.bind(this))), _.unbindDocumentMouseUp || (_.unbindDocumentMouseUp = []), _.unbindDocumentMouseUp.push(R(w, "mouseup", this.onDocumentMouseUp.bind(this)));
          let d = this.chart.renderTo.parentElement;
          for (; d && d.tagName !== "BODY"; ) this.eventsToUnbind.push(R(d, "scroll", () => {
            delete this.chartPosition;
          })), d = d.parentElement;
          this.eventsToUnbind.push(R(v, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), R(v, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), _.unbindDocumentTouchEnd || (_.unbindDocumentTouchEnd = R(w, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), R(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          var s, p;
          if (!B) return;
          let v = this.pointerCaptureEventsToUnbind, w = this.chart, d = w.container, r = m((s = w.options.tooltip) == null ? void 0 : s.followTouchMove, !0) && w.series.some((b) => b.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && r ? (v.push(R(d, "pointerdown", (b) => {
            var c, h;
            (c = b.target) != null && c.hasPointerCapture(b.pointerId) && ((h = b.target) == null || h.releasePointerCapture(b.pointerId));
          }), R(d, "pointermove", (b) => {
            var c, h;
            (h = (c = w.pointer) == null ? void 0 : c.getPointFromEvent(b)) == null || h.onMouseOver(b);
          })), w.styledMode || x(d, { "touch-action": "none" }), d.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !r && (v.forEach((b) => b()), v.length = 0, w.styledMode || x(d, { "touch-action": m((p = w.options.chart.style) == null ? void 0 : p["touch-action"], "manipulation") }), d.className = d.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(v) {
          var r;
          let w = this.chart, d = n.charts[m(_.hoverChartIndex, -1)];
          if (d && d !== w) {
            let s = { relatedTarget: w.container };
            v && !(v != null && v.relatedTarget) && (v = { ...s, ...v }), (r = d.pointer) == null || r.onContainerMouseLeave(v || s);
          }
          d && d.mouseIsDown || (_.hoverChartIndex = w.index);
        }
        touch(v, w) {
          let d, { chart: r, pinchDown: s = [] } = this;
          this.setHoverChartIndex(), (v = this.normalize(v)).touches.length === 1 ? r.isInsidePlot(v.chartX - r.plotLeft, v.chartY - r.plotTop, { visiblePlotOnly: !0 }) && !r.openMenu ? (w && this.runPointActions(v), v.type === "touchmove" && (d = !!s[0] && Math.pow(s[0].chartX - v.chartX, 2) + Math.pow(s[0].chartY - v.chartY, 2) >= 16), m(d, !0) && this.pinch(v)) : w && this.reset() : v.touches.length === 2 && this.pinch(v);
        }
        touchSelect(v) {
          return !!(this.chart.zooming.singleTouch && v.touches && v.touches.length === 1);
        }
        zoomOption(v) {
          let w = this.chart, d = w.inverted, r = w.zooming.type || "", s, p;
          /touch/.test(v.type) && (r = m(w.zooming.pinchType, r)), this.zoomX = s = /x/.test(r), this.zoomY = p = /y/.test(r), this.zoomHor = s && !d || p && d, this.zoomVert = p && !d || s && d, this.hasZoom = s || p;
        }
      }
      return (L = _ || (_ = {})).compose = function(E) {
        C(I, "Core.Pointer") && R(E, "beforeRender", function() {
          this.pointer = new L(this, this.options);
        });
      }, _;
    }), i(e, "Core/Legend/LegendSymbol.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { extend: l, merge: L, pick: D } = o;
      return function(j) {
        function I(B, R, N) {
          var d, r;
          let x = this.legendItem = this.legendItem || {}, { chart: T, options: y } = this, { baseline: S = 0, symbolWidth: u, symbolHeight: A } = B, M = this.symbol || "circle", f = A / 2, m = T.renderer, C = x.group, F = S - Math.round((((d = B.fontMetrics) == null ? void 0 : d.b) || A) * (N ? 0.4 : 0.3)), _ = {}, E, v = y.marker, w = 0;
          if (T.styledMode || (_["stroke-width"] = Math.min(y.lineWidth || 0, 24), y.dashStyle ? _.dashstyle = y.dashStyle : y.linecap === "square" || (_["stroke-linecap"] = "round")), x.line = m.path().addClass("highcharts-graph").attr(_).add(C), N && (x.area = m.path().addClass("highcharts-area").add(C)), _["stroke-linecap"] && (w = Math.min(x.line.strokeWidth(), u) / 2), u) {
            let s = [["M", w, F], ["L", u - w, F]];
            x.line.attr({ d: s }), (r = x.area) == null || r.attr({ d: [...s, ["L", u - w, S], ["L", w, S]] });
          }
          if (v && v.enabled !== !1 && u) {
            let s = Math.min(D(v.radius, f), f);
            M.indexOf("url") === 0 && (v = L(v, { width: A, height: A }), s = 0), x.symbol = E = m.symbol(M, u / 2 - s, F - s, 2 * s, 2 * s, l({ context: "legend" }, v)).addClass("highcharts-point").add(C), E.isMarker = !0;
          }
        }
        j.areaMarker = function(B, R) {
          I.call(this, B, R, !0);
        }, j.lineMarker = I, j.rectangle = function(B, R) {
          let N = R.legendItem || {}, x = B.options, T = B.symbolHeight, y = x.squareSymbol, S = y ? T : B.symbolWidth;
          N.symbol = this.chart.renderer.rect(y ? (B.symbolWidth - T) / 2 : 0, B.baseline - T + 1, S, T, D(B.options.symbolRadius, T / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(N.group);
        };
      }(n || (n = {})), n;
    }), i(e, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: o } = this.series.chart;
        return typeof this.y != "number" ? "" : o(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), i(e, "Core/Series/SeriesRegistry.js", [e["Core/Globals.js"], e["Core/Defaults.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { defaultOptions: j } = n, { extend: I, extendClass: B, merge: R } = L;
      return function(N) {
        function x(T, y) {
          let S = j.plotOptions || {}, u = y.defaultOptions, A = y.prototype;
          return A.type = T, A.pointClass || (A.pointClass = l), !N.seriesTypes[T] && (u && (S[T] = u), N.seriesTypes[T] = y, !0);
        }
        N.seriesTypes = o.seriesTypes, N.registerSeriesType = x, N.seriesType = function(T, y, S, u, A) {
          let M = j.plotOptions || {};
          if (y = y || "", M[T] = R(M[y], S), delete N.seriesTypes[T], x(T, B(N.seriesTypes[y] || function() {
          }, u)), N.seriesTypes[T].prototype.type = T, A) {
            class f extends l {
            }
            I(f.prototype, A), N.seriesTypes[T].prototype.pointClass = f;
          }
          return N.seriesTypes[T];
        };
      }(D || (D = {})), D;
    }), i(e, "Core/Series/Series.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R, N) {
      let { animObject: x, setAnimation: T } = o, { defaultOptions: y } = n, { registerEventOptions: S } = l, { svg: u, win: A } = L, { seriesTypes: M } = B, { arrayMax: f, arrayMin: m, clamp: C, correctFloat: F, crisp: _, defined: E, destroyObjectProperties: v, diffObjects: w, erase: d, error: r, extend: s, find: p, fireEvent: b, getClosestDistance: c, getNestedProperty: h, insertItem: g, isArray: k, isNumber: P, isString: O, merge: z, objectEach: W, pick: G, removeEvent: Y, splat: U, syncTimeout: H } = N;
      class q {
        constructor() {
          this.zoneAxis = "y";
        }
        init($, K) {
          let V;
          b(this, "init", { options: K });
          let Q = this, Z = $.series;
          this.eventsToUnbind = [], Q.chart = $, Q.options = Q.setOptions(K);
          let ee = Q.options, J = ee.visible !== !1;
          Q.linkedSeries = [], Q.bindAxes(), s(Q, { name: ee.name, state: "", visible: J, selected: ee.selected === !0 }), S(this, ee);
          let ie = ee.events;
          (ie && ie.click || ee.point && ee.point.events && ee.point.events.click || ee.allowPointSelect) && ($.runTrackerClick = !0), Q.getColor(), Q.getSymbol(), Q.parallelArrays.forEach(function(re) {
            Q[re + "Data"] || (Q[re + "Data"] = []);
          }), Q.isCartesian && ($.hasCartesianSeries = !0), Z.length && (V = Z[Z.length - 1]), Q._i = G(V && V._i, -1) + 1, Q.opacity = Q.options.opacity, $.orderItems("series", g(this, Z)), ee.dataSorting && ee.dataSorting.enabled ? Q.setDataSortingOptions() : Q.points || Q.data || Q.setData(ee.data, !1), b(this, "afterInit");
        }
        is($) {
          return M[$] && this instanceof M[$];
        }
        bindAxes() {
          let $, K = this, V = K.options, Q = K.chart;
          b(this, "bindAxes", null, function() {
            (K.axisTypes || []).forEach(function(Z) {
              (Q[Z] || []).forEach(function(ee) {
                $ = ee.options, (G(V[Z], 0) === ee.index || V[Z] !== void 0 && V[Z] === $.id) && (g(K, ee.series), K[Z] = ee, ee.isDirty = !0);
              }), K[Z] || K.optionalAxis === Z || r(18, !0, Q);
            });
          }), b(this, "afterBindAxes");
        }
        updateParallelArrays($, K, V) {
          let Q = $.series, Z = P(K) ? function(ee) {
            let J = ee === "y" && Q.toYData ? Q.toYData($) : $[ee];
            Q[ee + "Data"][K] = J;
          } : function(ee) {
            Array.prototype[K].apply(Q[ee + "Data"], V);
          };
          Q.parallelArrays.forEach(Z);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged($, K) {
          let V = $.marker, Q = K.marker || {};
          return V && (Q.enabled && !V.enabled || Q.symbol !== V.symbol || Q.height !== V.height || Q.width !== V.width);
        }
        autoIncrement($) {
          let K = this.options, V = K.pointIntervalUnit, Q = K.relativeXValue, Z = this.chart.time, ee = this.xIncrement, J, ie;
          return ee = G(ee, K.pointStart, 0), this.pointInterval = ie = G(this.pointInterval, K.pointInterval, 1), Q && P($) && (ie *= $), V && (J = new Z.Date(ee), V === "day" ? Z.set("Date", J, Z.get("Date", J) + ie) : V === "month" ? Z.set("Month", J, Z.get("Month", J) + ie) : V === "year" && Z.set("FullYear", J, Z.get("FullYear", J) + ie), ie = J.getTime() - ee), Q && P($) ? ee + ie : (this.xIncrement = ee + ie, ee);
        }
        setDataSortingOptions() {
          let $ = this.options;
          s(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), E($.pointRange) || ($.pointRange = 1);
        }
        setOptions($) {
          var ae, le;
          let K, V = this.chart, Q = V.options.plotOptions, Z = V.userOptions || {}, ee = z($), J = V.styledMode, ie = { plotOptions: Q, userOptions: ee };
          b(this, "setOptions", ie);
          let re = ie.plotOptions[this.type], ce = Z.plotOptions || {}, he = ce.series || {}, ne = y.plotOptions[this.type] || {}, oe = ce[this.type] || {};
          this.userOptions = ie.userOptions;
          let se = z(re, Q.series, oe, ee);
          this.tooltipOptions = z(y.tooltip, (ae = y.plotOptions.series) == null ? void 0 : ae.tooltip, ne == null ? void 0 : ne.tooltip, V.userOptions.tooltip, (le = ce.series) == null ? void 0 : le.tooltip, oe.tooltip, ee.tooltip), this.stickyTracking = G(ee.stickyTracking, oe.stickyTracking, he.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || se.stickyTracking), re.marker === null && delete se.marker, this.zoneAxis = se.zoneAxis || "y";
          let te = this.zones = (se.zones || []).map((de) => ({ ...de }));
          return (se.negativeColor || se.negativeFillColor) && !se.zones && (K = { value: se[this.zoneAxis + "Threshold"] || se.threshold || 0, className: "highcharts-negative" }, J || (K.color = se.negativeColor, K.fillColor = se.negativeFillColor), te.push(K)), te.length && E(te[te.length - 1].value) && te.push(J ? {} : { color: this.color, fillColor: this.fillColor }), b(this, "afterSetOptions", { options: se }), se;
        }
        getName() {
          return G(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic($, K, V) {
          let Q, Z, ee = this.chart, J = `${$}Index`, ie = `${$}Counter`, re = (V == null ? void 0 : V.length) || ee.options.chart.colorCount;
          !K && (E(Z = G($ === "color" ? this.options.colorIndex : void 0, this[J])) ? Q = Z : (ee.series.length || (ee[ie] = 0), Q = ee[ie] % re, ee[ie] += 1), V && (K = V[Q])), Q !== void 0 && (this[J] = Q), this[$] = K;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || y.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let $ = this.options.marker;
          this.getCyclic("symbol", $.symbol, this.chart.options.symbols);
        }
        findPointIndex($, K) {
          let V, Q, Z, ee = $.id, J = $.x, ie = this.points, re = this.options.dataSorting;
          if (ee) {
            let ce = this.chart.get(ee);
            ce instanceof j && (V = ce);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let ce = (he) => !he.touched && he.index === $.index;
            if (re && re.matchByName ? ce = (he) => !he.touched && he.name === $.name : this.options.relativeXValue && (ce = (he) => !he.touched && he.options.x === $.x), !(V = p(ie, ce))) return;
          }
          return V && (Z = V && V.index) !== void 0 && (Q = !0), Z === void 0 && P(J) && (Z = this.xData.indexOf(J, K)), Z !== -1 && Z !== void 0 && this.cropped && (Z = Z >= this.cropStart ? Z - this.cropStart : Z), !Q && P(Z) && ie[Z] && ie[Z].touched && (Z = void 0), Z;
        }
        updateData($, K) {
          let V = this.options, Q = V.dataSorting, Z = this.points, ee = [], J = this.requireSorting, ie = $.length === Z.length, re, ce, he, ne, oe = !0;
          if (this.xIncrement = null, $.forEach(function(se, te) {
            let ae, le = E(se) && this.pointClass.prototype.optionsToObject.call({ series: this }, se) || {}, de = le.x;
            le.id || P(de) ? ((ae = this.findPointIndex(le, ne)) === -1 || ae === void 0 ? ee.push(se) : Z[ae] && se !== V.data[ae] ? (Z[ae].update(se, !1, null, !1), Z[ae].touched = !0, J && (ne = ae + 1)) : Z[ae] && (Z[ae].touched = !0), (!ie || te !== ae || Q && Q.enabled || this.hasDerivedData) && (re = !0)) : ee.push(se);
          }, this), re) for (ce = Z.length; ce--; ) (he = Z[ce]) && !he.touched && he.remove && he.remove(!1, K);
          else !ie || Q && Q.enabled ? oe = !1 : ($.forEach(function(se, te) {
            se === Z[te].y || Z[te].destroyed || Z[te].update(se, !1, null, !1);
          }), ee.length = 0);
          return Z.forEach(function(se) {
            se && (se.touched = !1);
          }), !!oe && (ee.forEach(function(se) {
            this.addPoint(se, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = f(this.xData), this.autoIncrement()), !0);
        }
        setData($, K = !0, V, Q) {
          var xe;
          let Z = this, ee = Z.points, J = ee && ee.length || 0, ie = Z.options, re = Z.chart, ce = ie.dataSorting, he = Z.xAxis, ne = ie.turboThreshold, oe = this.xData, se = this.yData, te = Z.pointArrayMap, ae = te && te.length, le = ie.keys, de, be, ge, me = 0, fe = 1, Ae;
          re.options.chart.allowMutatingData || (ie.data && delete Z.options.data, Z.userOptions.data && delete Z.userOptions.data, Ae = z(!0, $));
          let ye = ($ = Ae || $ || []).length;
          if (ce && ce.enabled && ($ = this.sortData($)), re.options.chart.allowMutatingData && Q !== !1 && ye && J && !Z.cropped && !Z.hasGroupedData && Z.visible && !Z.boosted && (ge = this.updateData($, V)), !ge) {
            Z.xIncrement = null, Z.colorCounter = 0, this.parallelArrays.forEach(function(ke) {
              Z[ke + "Data"].length = 0;
            });
            let we = ne && ye > ne;
            if (we) {
              let ke = Z.getFirstValidPoint($), Oe = Z.getFirstValidPoint($, ye - 1, -1), Me = (Ne) => !!(k(Ne) && (le || P(Ne[0])));
              if (P(ke) && P(Oe)) for (de = 0; de < ye; de++) oe[de] = this.autoIncrement(), se[de] = $[de];
              else if (Me(ke) && Me(Oe))
                if (ae)
                  if (ke.length === ae) for (de = 0; de < ye; de++) oe[de] = this.autoIncrement(), se[de] = $[de];
                  else for (de = 0; de < ye; de++) be = $[de], oe[de] = be[0], se[de] = be.slice(1, ae + 1);
                else if (le && (me = le.indexOf("x"), fe = le.indexOf("y"), me = me >= 0 ? me : 0, fe = fe >= 0 ? fe : 1), ke.length === 1 && (fe = 0), me === fe) for (de = 0; de < ye; de++) oe[de] = this.autoIncrement(), se[de] = $[de][fe];
                else for (de = 0; de < ye; de++) be = $[de], oe[de] = be[me], se[de] = be[fe];
              else we = !1;
            }
            if (!we) for (de = 0; de < ye; de++) be = { series: Z }, Z.pointClass.prototype.applyOptions.apply(be, [$[de]]), Z.updateParallelArrays(be, de);
            for (se && O(se[0]) && r(14, !0, re), Z.data = [], Z.options.data = Z.userOptions.data = $, de = J; de--; ) (xe = ee[de]) == null || xe.destroy();
            he && (he.minRange = he.userMinRange), Z.isDirty = re.isDirtyBox = !0, Z.isDirtyData = !!ee, V = !1;
          }
          ie.legendType === "point" && (this.processData(), this.generatePoints()), K && re.redraw(V);
        }
        sortData($) {
          let K = this, V = K.options.dataSorting.sortKey || "y", Q = function(Z, ee) {
            return E(ee) && Z.pointClass.prototype.optionsToObject.call({ series: Z }, ee) || {};
          };
          return $.forEach(function(Z, ee) {
            $[ee] = Q(K, Z), $[ee].index = ee;
          }, this), $.concat().sort((Z, ee) => {
            let J = h(V, Z), ie = h(V, ee);
            return ie < J ? -1 : ie > J ? 1 : 0;
          }).forEach(function(Z, ee) {
            Z.x = ee;
          }, this), K.linkedSeries && K.linkedSeries.forEach(function(Z) {
            let ee = Z.options, J = ee.data;
            ee.dataSorting && ee.dataSorting.enabled || !J || (J.forEach(function(ie, re) {
              J[re] = Q(Z, ie), $[re] && (J[re].x = $[re].x, J[re].index = re);
            }), Z.setData(J, !1));
          }), $;
        }
        getProcessedData($) {
          let K = this, V = K.xAxis, Q = K.options.cropThreshold, Z = V == null ? void 0 : V.logarithmic, ee = K.isCartesian, J, ie, re = 0, ce, he, ne, oe = K.xData, se = K.yData, te = !1, ae = oe.length;
          V && (he = (ce = V.getExtremes()).min, ne = ce.max, te = !!(V.categories && !V.names.length)), ee && K.sorted && !$ && (!Q || ae > Q || K.forceCrop) && (oe[ae - 1] < he || oe[0] > ne ? (oe = [], se = []) : K.yData && (oe[0] < he || oe[ae - 1] > ne) && (oe = (J = this.cropData(K.xData, K.yData, he, ne)).xData, se = J.yData, re = J.start, ie = !0));
          let le = c([Z ? oe.map(Z.log2lin) : oe], () => K.requireSorting && !te && r(15, !1, K.chart));
          return { xData: oe, yData: se, cropped: ie, cropStart: re, closestPointRange: le };
        }
        processData($) {
          let K = this.xAxis;
          if (this.isCartesian && !this.isDirty && !K.isDirty && !this.yAxis.isDirty && !$) return !1;
          let V = this.getProcessedData();
          this.cropped = V.cropped, this.cropStart = V.cropStart, this.processedXData = V.xData, this.processedYData = V.yData, this.closestPointRange = this.basePointRange = V.closestPointRange, b(this, "afterProcessData");
        }
        cropData($, K, V, Q) {
          let Z = $.length, ee, J, ie = 0, re = Z;
          for (ee = 0; ee < Z; ee++) if ($[ee] >= V) {
            ie = Math.max(0, ee - 1);
            break;
          }
          for (J = ee; J < Z; J++) if ($[J] > Q) {
            re = J + 1;
            break;
          }
          return { xData: $.slice(ie, re), yData: K.slice(ie, re), start: ie, end: re };
        }
        generatePoints() {
          let $ = this.options, K = this.processedData || $.data, V = this.processedXData, Q = this.processedYData, Z = this.pointClass, ee = V.length, J = this.cropStart || 0, ie = this.hasGroupedData, re = $.keys, ce = [], he = $.dataGrouping && $.dataGrouping.groupAll ? J : 0, ne, oe, se, te, ae = this.data;
          if (!ae && !ie) {
            let le = [];
            le.length = K.length, ae = this.data = le;
          }
          for (re && ie && (this.options.keys = !1), te = 0; te < ee; te++) oe = J + te, ie ? ((se = new Z(this, [V[te]].concat(U(Q[te])))).dataGroup = this.groupMap[he + te], se.dataGroup.options && (se.options = se.dataGroup.options, s(se, se.dataGroup.options), delete se.dataLabels)) : (se = ae[oe]) || K[oe] === void 0 || (ae[oe] = se = new Z(this, K[oe], V[te])), se && (se.index = ie ? he + te : oe, ce[te] = se);
          if (this.options.keys = re, ae && (ee !== (ne = ae.length) || ie)) for (te = 0; te < ne; te++) te !== J || ie || (te += ee), ae[te] && (ae[te].destroyElements(), ae[te].plotX = void 0);
          this.data = ae, this.points = ce, b(this, "afterGeneratePoints");
        }
        getXExtremes($) {
          return { min: m($), max: f($) };
        }
        getExtremes($, K) {
          let V = this.xAxis, Q = this.yAxis, Z = [], ee = this.requireSorting && !this.is("column") ? 1 : 0, J = !!Q && Q.positiveValuesOnly, ie = K || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: re, processedYData: ce } = this, he, ne, oe, se, te, ae, le, de = 0, be = 0, ge = 0;
          if (this.cropped && ie) {
            let ye = this.getProcessedData(!0);
            re = ye.xData, ce = ye.yData;
          }
          let me = ($ = $ || this.stackedYData || ce || []).length, fe = re || this.xData;
          for (V && (de = (he = V.getExtremes()).min, be = he.max), ae = 0; ae < me; ae++) if (se = fe[ae], ne = (P(te = $[ae]) || k(te)) && ((P(te) ? te > 0 : te.length) || !J), oe = K || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !V || (fe[ae + ee] || se) >= de && (fe[ae - ee] || se) <= be, ne && oe)
            if (le = te.length) for (; le--; ) P(te[le]) && (Z[ge++] = te[le]);
            else Z[ge++] = te;
          let Ae = { activeYData: Z, dataMin: m(Z), dataMax: f(Z) };
          return b(this, "afterGetExtremes", { dataExtremes: Ae }), Ae;
        }
        applyExtremes() {
          let $ = this.getExtremes();
          return this.dataMin = $.dataMin, this.dataMax = $.dataMax, $;
        }
        getFirstValidPoint($, K = 0, V = 1) {
          let Q = $.length, Z = K;
          for (; Z >= 0 && Z < Q; ) {
            if (E($[Z])) return $[Z];
            Z += V;
          }
        }
        translate() {
          var be;
          this.processedXData || this.processData(), this.generatePoints();
          let $ = this.options, K = $.stacking, V = this.xAxis, Q = V.categories, Z = this.enabledDataSorting, ee = this.yAxis, J = this.points, ie = J.length, re = this.pointPlacementToXValue(), ce = !!re, he = $.threshold, ne = $.startFromThreshold ? he : 0, oe, se, te, ae, le = Number.MAX_VALUE;
          function de(ge) {
            return C(ge, -1e9, 1e9);
          }
          for (oe = 0; oe < ie; oe++) {
            let ge, me = J[oe], fe = me.x, Ae, ye, xe = me.y, we = me.low, ke = K && ((be = ee.stacking) == null ? void 0 : be.stacks[(this.negStacks && xe < (ne ? 0 : he) ? "-" : "") + this.stackKey]);
            se = V.translate(fe, !1, !1, !1, !0, re), me.plotX = P(se) ? F(de(se)) : void 0, K && this.visible && ke && ke[fe] && (ae = this.getStackIndicator(ae, fe, this.index), !me.isNull && ae.key && (ye = (Ae = ke[fe]).points[ae.key]), Ae && k(ye) && (we = ye[0], xe = ye[1], we === ne && ae.key === ke[fe].base && (we = G(P(he) ? he : ee.min)), ee.positiveValuesOnly && E(we) && we <= 0 && (we = void 0), me.total = me.stackTotal = G(Ae.total), me.percentage = E(me.y) && Ae.total ? me.y / Ae.total * 100 : void 0, me.stackY = xe, this.irregularWidths || Ae.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), me.yBottom = E(we) ? de(ee.translate(we, !1, !0, !1, !0)) : void 0, this.dataModify && (xe = this.dataModify.modifyValue(xe, oe)), P(xe) && me.plotX !== void 0 && (ge = P(ge = ee.translate(xe, !1, !0, !1, !0)) ? de(ge) : void 0), me.plotY = ge, me.isInside = this.isPointInside(me), me.clientX = ce ? F(V.translate(fe, !1, !1, !1, !0, re)) : se, me.negative = (me.y || 0) < (he || 0), me.category = G(Q && Q[me.x], me.x), me.isNull || me.visible === !1 || (te !== void 0 && (le = Math.min(le, Math.abs(se - te))), te = se), me.zone = this.zones.length ? me.getZone() : void 0, !me.graphic && this.group && Z && (me.isNew = !0);
          }
          this.closestPointRangePx = le, b(this, "afterTranslate");
        }
        getValidPoints($, K, V) {
          let Q = this.chart;
          return ($ || this.points || []).filter(function(Z) {
            let { plotX: ee, plotY: J } = Z;
            return !!((V || !Z.isNull && P(J)) && (!K || Q.isInsidePlot(ee, J, { inverted: Q.inverted }))) && Z.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: $, xAxis: K, yAxis: V } = this, { x: Q, y: Z, width: ee, height: J } = z($.clipBox);
          return K && K.len !== $.plotSizeX && (ee = K.len), V && V.len !== $.plotSizeY && (J = V.len), $.inverted && !this.invertible && ([ee, J] = [J, ee]), { x: Q, y: Z, width: ee, height: J };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: $, group: K, markerGroup: V } = this, Q = $.sharedClips, Z = $.renderer, ee = this.getClipBox(), J = this.getSharedClipKey(), ie = Q[J];
          ie ? ie.animate(ee) : Q[J] = ie = Z.clipRect(ee), K && K.clip(this.options.clip === !1 ? void 0 : ie), V && V.clip();
        }
        animate($) {
          let { chart: K, group: V, markerGroup: Q } = this, Z = K.inverted, ee = x(this.options.animation), J = [this.getSharedClipKey(), ee.duration, ee.easing, ee.defer].join(","), ie = K.sharedClips[J], re = K.sharedClips[J + "m"];
          if ($ && V) {
            let ce = this.getClipBox();
            if (ie) ie.attr("height", ce.height);
            else {
              ce.width = 0, Z && (ce.x = K.plotHeight), ie = K.renderer.clipRect(ce), K.sharedClips[J] = ie;
              let he = { x: -99, y: -99, width: Z ? K.plotWidth + 199 : 99, height: Z ? 99 : K.plotHeight + 199 };
              re = K.renderer.clipRect(he), K.sharedClips[J + "m"] = re;
            }
            V.clip(ie), Q == null || Q.clip(re);
          } else if (ie && !ie.hasClass("highcharts-animating")) {
            let ce = this.getClipBox(), he = ee.step;
            (Q != null && Q.element.childNodes.length || K.series.length > 1) && (ee.step = function(ne, oe) {
              he && he.apply(oe, arguments), oe.prop === "width" && (re != null && re.element) && re.attr(Z ? "height" : "width", ne + 99);
            }), ie.addClass("highcharts-animating").animate(ce, ee);
          }
        }
        afterAnimate() {
          this.setClip(), W(this.chart.sharedClips, ($, K, V) => {
            $ && !this.chart.container.querySelector(`[clip-path="url(#${$.id})"]`) && ($.destroy(), delete V[K]);
          }), this.finishedAnimating = !0, b(this, "afterAnimate");
        }
        drawPoints($ = this.points) {
          let K, V, Q, Z, ee, J, ie, re = this.chart, ce = re.styledMode, { colorAxis: he, options: ne } = this, oe = ne.marker, se = this[this.specialGroup || "markerGroup"], te = this.xAxis, ae = G(oe.enabled, !te || !!te.isRadial || null, this.closestPointRangePx >= oe.enabledThreshold * oe.radius);
          if (oe.enabled !== !1 || this._hasPointMarkers) for (K = 0; K < $.length; K++) if (Z = (Q = (V = $[K]).graphic) ? "animate" : "attr", ee = V.marker || {}, J = !!V.marker, (ae && ee.enabled === void 0 || ee.enabled) && !V.isNull && V.visible !== !1) {
            let le = G(ee.symbol, this.symbol, "rect");
            ie = this.markerAttribs(V, V.selected && "select"), this.enabledDataSorting && (V.startXPos = te.reversed ? -(ie.width || 0) : te.width);
            let de = V.isInside !== !1;
            if (!Q && de && ((ie.width || 0) > 0 || V.hasImage) && (V.graphic = Q = re.renderer.symbol(le, ie.x, ie.y, ie.width, ie.height, J ? ee : oe).add(se), this.enabledDataSorting && re.hasRendered && (Q.attr({ x: V.startXPos }), Z = "animate")), Q && Z === "animate" && Q[de ? "show" : "hide"](de).animate(ie), Q) {
              let be = this.pointAttribs(V, ce || !V.selected ? void 0 : "select");
              ce ? he && Q.css({ fill: be.fill }) : Q[Z](be);
            }
            Q && Q.addClass(V.getClassName(), !0);
          } else Q && (V.graphic = Q.destroy());
        }
        markerAttribs($, K) {
          let V = this.options, Q = V.marker, Z = $.marker || {}, ee = Z.symbol || Q.symbol, J = {}, ie, re, ce = G(Z.radius, Q && Q.radius);
          K && (ie = Q.states[K], ce = G((re = Z.states && Z.states[K]) && re.radius, ie && ie.radius, ce && ce + (ie && ie.radiusPlus || 0))), $.hasImage = ee && ee.indexOf("url") === 0, $.hasImage && (ce = 0);
          let he = $.pos();
          return P(ce) && he && (V.crisp && (he[0] = _(he[0], $.hasImage ? 0 : ee === "rect" ? (Q == null ? void 0 : Q.lineWidth) || 0 : 1)), J.x = he[0] - ce, J.y = he[1] - ce), ce && (J.width = J.height = 2 * ce), J;
        }
        pointAttribs($, K) {
          let V = this.options.marker, Q = $ && $.options, Z = Q && Q.marker || {}, ee = Q && Q.color, J = $ && $.color, ie = $ && $.zone && $.zone.color, re, ce, he = this.color, ne, oe, se = G(Z.lineWidth, V.lineWidth), te = 1;
          return he = ee || ie || J || he, ne = Z.fillColor || V.fillColor || he, oe = Z.lineColor || V.lineColor || he, K = K || "normal", re = V.states[K] || {}, se = G((ce = Z.states && Z.states[K] || {}).lineWidth, re.lineWidth, se + G(ce.lineWidthPlus, re.lineWidthPlus, 0)), ne = ce.fillColor || re.fillColor || ne, { stroke: oe = ce.lineColor || re.lineColor || oe, "stroke-width": se, fill: ne, opacity: te = G(ce.opacity, re.opacity, te) };
        }
        destroy($) {
          let K, V, Q, Z = this, ee = Z.chart, J = /AppleWebKit\/533/.test(A.navigator.userAgent), ie = Z.data || [];
          for (b(Z, "destroy", { keepEventsForUpdate: $ }), this.removeEvents($), (Z.axisTypes || []).forEach(function(re) {
            (Q = Z[re]) && Q.series && (d(Q.series, Z), Q.isDirty = Q.forceRedraw = !0);
          }), Z.legendItem && Z.chart.legend.destroyItem(Z), K = ie.length; K--; ) (V = ie[K]) && V.destroy && V.destroy();
          for (let re of Z.zones) v(re, void 0, !0);
          N.clearTimeout(Z.animationTimeout), W(Z, function(re, ce) {
            re instanceof R && !re.survive && re[J && ce === "group" ? "hide" : "destroy"]();
          }), ee.hoverSeries === Z && (ee.hoverSeries = void 0), d(ee.series, Z), ee.orderItems("series"), W(Z, function(re, ce) {
            $ && ce === "hcEvents" || delete Z[ce];
          });
        }
        applyZones() {
          let { area: $, chart: K, graph: V, zones: Q, points: Z, xAxis: ee, yAxis: J, zoneAxis: ie } = this, { inverted: re, renderer: ce } = K, he = this[`${ie}Axis`], { isXAxis: ne, len: oe = 0 } = he || {}, se = ((V == null ? void 0 : V.strokeWidth()) || 0) / 2 + 1, te = (ae, le = 0, de = 0) => {
            re && (de = oe - de);
            let { translated: be = 0, lineClip: ge } = ae, me = de - be;
            ge == null || ge.push(["L", le, Math.abs(me) < se ? de - se * (me <= 0 ? -1 : 1) : be]);
          };
          if (Q.length && (V || $) && he && P(he.min)) {
            let ae = he.getExtremes().max, le = (ge) => {
              ge.forEach((me, fe) => {
                (me[0] === "M" || me[0] === "L") && (ge[fe] = [me[0], ne ? oe - me[1] : me[1], ne ? me[2] : oe - me[2]]);
              });
            };
            if (Q.forEach((ge) => {
              ge.lineClip = [], ge.translated = C(he.toPixels(G(ge.value, ae), !0) || 0, 0, oe);
            }), V && !this.showLine && V.hide(), $ && $.hide(), ie === "y" && Z.length < ee.len) for (let ge of Z) {
              let { plotX: me, plotY: fe, zone: Ae } = ge, ye = Ae && Q[Q.indexOf(Ae) - 1];
              Ae && te(Ae, me, fe), ye && te(ye, me, fe);
            }
            let de = [], be = he.toPixels(he.getExtremes().min, !0);
            Q.forEach((ge) => {
              var Ke, He;
              let me = ge.lineClip || [], fe = Math.round(ge.translated || 0);
              ee.reversed && me.reverse();
              let { clip: Ae, simpleClip: ye } = ge, xe = 0, we = 0, ke = ee.len, Oe = J.len;
              ne ? (xe = fe, ke = be) : (we = fe, Oe = be);
              let Me = [["M", xe, we], ["L", ke, we], ["L", ke, Oe], ["L", xe, Oe], ["Z"]], Ne = [Me[0], ...me, Me[1], Me[2], ...de, Me[3], Me[4]];
              de = me.reverse(), be = fe, re && (le(Ne), $ && le(Me)), Ae ? (Ae.animate({ d: Ne }), ye == null || ye.animate({ d: Me })) : (Ae = ge.clip = ce.path(Ne), $ && (ye = ge.simpleClip = ce.path(Me))), V && ((Ke = ge.graph) == null || Ke.clip(Ae)), $ && ((He = ge.area) == null || He.clip(ye));
            });
          } else this.visible && (V && V.show(), $ && $.show());
        }
        plotGroup($, K, V, Q, Z) {
          let ee = this[$], J = !ee, ie = { visibility: V, zIndex: Q || 0.1 };
          return E(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (ie.opacity = this.opacity), ee || (this[$] = ee = this.chart.renderer.g().add(Z)), ee.addClass("highcharts-" + K + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (E(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (ee.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), ee.attr(ie)[J ? "attr" : "animate"](this.getPlotBox(K)), ee;
        }
        getPlotBox($) {
          let K = this.xAxis, V = this.yAxis, Q = this.chart, Z = Q.inverted && !Q.polar && K && this.invertible && $ === "series";
          return Q.inverted && (K = V, V = this.xAxis), { translateX: K ? K.left : Q.plotLeft, translateY: V ? V.top : Q.plotTop, rotation: Z ? 90 : 0, rotationOriginX: Z ? (K.len - V.len) / 2 : 0, rotationOriginY: Z ? (K.len + V.len) / 2 : 0, scaleX: Z ? -1 : 1, scaleY: 1 };
        }
        removeEvents($) {
          let { eventsToUnbind: K } = this;
          $ || Y(this), K.length && (K.forEach((V) => {
            V();
          }), K.length = 0);
        }
        render() {
          var ce, he, ne, oe, se;
          let $ = this, { chart: K, options: V, hasRendered: Q } = $, Z = x(V.animation), ee = $.visible ? "inherit" : "hidden", J = V.zIndex, ie = K.seriesGroup, re = $.finishedAnimating ? 0 : Z.duration;
          b(this, "render"), $.plotGroup("group", "series", ee, J, ie), $.markerGroup = $.plotGroup("markerGroup", "markers", ee, J, ie), V.clip !== !1 && $.setClip(), re && ((ce = $.animate) == null || ce.call($, !0)), $.drawGraph && ($.drawGraph(), $.applyZones()), $.visible && $.drawPoints(), (he = $.drawDataLabels) == null || he.call($), (ne = $.redrawPoints) == null || ne.call($), V.enableMouseTracking && ((oe = $.drawTracker) == null || oe.call($)), re && ((se = $.animate) == null || se.call($)), Q || (re && Z.defer && (re += Z.defer), $.animationTimeout = H(() => {
            $.afterAnimate();
          }, re || 0)), $.isDirty = !1, $.hasRendered = !0, b($, "afterRender");
        }
        redraw() {
          let $ = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), $ && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint($, K) {
          let { xAxis: V, yAxis: Q } = this, Z = this.chart.inverted;
          return this.searchKDTree({ clientX: Z ? V.len - $.chartY + V.pos : $.chartX - V.pos, plotY: Z ? Q.len - $.chartX + Q.pos : $.chartY - Q.pos }, K, $);
        }
        buildKDTree($) {
          this.buildingKdTree = !0;
          let K = this, V = K.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete K.kdTree, H(function() {
            K.kdTree = function Q(Z, ee, J) {
              let ie, re, ce = Z == null ? void 0 : Z.length;
              if (ce) return ie = K.kdAxisArray[ee % J], Z.sort((he, ne) => (he[ie] || 0) - (ne[ie] || 0)), { point: Z[re = Math.floor(ce / 2)], left: Q(Z.slice(0, re), ee + 1, J), right: Q(Z.slice(re + 1), ee + 1, J) };
            }(K.getValidPoints(void 0, !K.directTouch), V, V), K.buildingKdTree = !1;
          }, K.options.kdNow || ($ == null ? void 0 : $.type) === "touchstart" ? 0 : 1);
        }
        searchKDTree($, K, V) {
          let Q = this, [Z, ee] = this.kdAxisArray, J = K ? "distX" : "dist", ie = (Q.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, re = !!Q.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(V), this.kdTree) return function ce(he, ne, oe, se) {
            var Ae;
            let te = ne.point, ae = Q.kdAxisArray[oe % se], le, de, be = te;
            (function(ye, xe) {
              var bt;
              let we = ye[Z], ke = xe[Z], Oe = E(we) && E(ke) ? we - ke : null, Me = ye[ee], Ne = xe[ee], Ke = E(Me) && E(Ne) ? Me - Ne : 0, He = re && ((bt = xe.marker) == null ? void 0 : bt.radius) || 0;
              xe.dist = Math.sqrt((Oe && Oe * Oe || 0) + Ke * Ke) - He, xe.distX = E(Oe) ? Math.abs(Oe) - He : Number.MAX_VALUE;
            })(he, te);
            let ge = (he[ae] || 0) - (te[ae] || 0) + (re && ((Ae = te.marker) == null ? void 0 : Ae.radius) || 0), me = ge < 0 ? "left" : "right", fe = ge < 0 ? "right" : "left";
            return ne[me] && (be = (le = ce(he, ne[me], oe + 1, se))[J] < be[J] ? le : te), ne[fe] && Math.sqrt(ge * ge) < be[J] && (be = (de = ce(he, ne[fe], oe + 1, se))[J] < be[J] ? de : be), be;
          }($, this.kdTree, ie, ie);
        }
        pointPlacementToXValue() {
          let { options: $, xAxis: K } = this, V = $.pointPlacement;
          return V === "between" && (V = K.reversed ? -0.5 : 0.5), P(V) ? V * ($.pointRange || K.pointRange) : 0;
        }
        isPointInside($) {
          let { chart: K, xAxis: V, yAxis: Q } = this, { plotX: Z = -1, plotY: ee = -1 } = $;
          return ee >= 0 && ee <= (Q ? Q.len : K.plotHeight) && Z >= 0 && Z <= (V ? V.len : K.plotWidth);
        }
        drawTracker() {
          var ne;
          let $ = this, K = $.options, V = K.trackByArea, Q = [].concat((V ? $.areaPath : $.graphPath) || []), Z = $.chart, ee = Z.pointer, J = Z.renderer, ie = ((ne = Z.options.tooltip) == null ? void 0 : ne.snap) || 0, re = () => {
            K.enableMouseTracking && Z.hoverSeries !== $ && $.onMouseOver();
          }, ce = "rgba(192,192,192," + (u ? 1e-4 : 2e-3) + ")", he = $.tracker;
          he ? he.attr({ d: Q }) : $.graph && ($.tracker = he = J.path(Q).attr({ visibility: $.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(V ? "highcharts-tracker-area" : "highcharts-tracker-line").add($.group), Z.styledMode || he.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: ce, fill: V ? ce : "none", "stroke-width": $.graph.strokeWidth() + (V ? 0 : 2 * ie) }), [$.tracker, $.markerGroup, $.dataLabelsGroup].forEach((oe) => {
            oe && (oe.addClass("highcharts-tracker").on("mouseover", re).on("mouseout", (se) => {
              ee == null || ee.onTrackerMouseOut(se);
            }), K.cursor && !Z.styledMode && oe.css({ cursor: K.cursor }), oe.on("touchstart", re));
          })), b(this, "afterDrawTracker");
        }
        addPoint($, K, V, Q, Z) {
          let ee, J, ie = this.options, re = this.data, ce = this.chart, he = this.xAxis, ne = he && he.hasNames && he.names, oe = ie.data, se = this.xData;
          K = G(K, !0);
          let te = { series: this };
          this.pointClass.prototype.applyOptions.apply(te, [$]);
          let ae = te.x;
          if (J = se.length, this.requireSorting && ae < se[J - 1]) for (ee = !0; J && se[J - 1] > ae; ) J--;
          this.updateParallelArrays(te, "splice", [J, 0, 0]), this.updateParallelArrays(te, J), ne && te.name && (ne[ae] = te.name), oe.splice(J, 0, $), (ee || this.processedData) && (this.data.splice(J, 0, null), this.processData()), ie.legendType === "point" && this.generatePoints(), V && (re[0] && re[0].remove ? re[0].remove(!1) : (re.shift(), this.updateParallelArrays(te, "shift"), oe.shift())), Z !== !1 && b(this, "addPoint", { point: te }), this.isDirty = !0, this.isDirtyData = !0, K && ce.redraw(Q);
        }
        removePoint($, K, V) {
          let Q = this, Z = Q.data, ee = Z[$], J = Q.points, ie = Q.chart, re = function() {
            J && J.length === Z.length && J.splice($, 1), Z.splice($, 1), Q.options.data.splice($, 1), Q.updateParallelArrays(ee || { series: Q }, "splice", [$, 1]), ee && ee.destroy(), Q.isDirty = !0, Q.isDirtyData = !0, K && ie.redraw();
          };
          T(V, ie), K = G(K, !0), ee ? ee.firePointEvent("remove", null, re) : re();
        }
        remove($, K, V, Q) {
          let Z = this, ee = Z.chart;
          function J() {
            Z.destroy(Q), ee.isDirtyLegend = ee.isDirtyBox = !0, ee.linkSeries(Q), G($, !0) && ee.redraw(K);
          }
          V !== !1 ? b(Z, "remove", null, J) : J();
        }
        update($, K) {
          var le, de, be, ge, me;
          b(this, "update", { options: $ = w($, this.userOptions) });
          let V = this, Q = V.chart, Z = V.userOptions, ee = V.initialType || V.type, J = Q.options.plotOptions, ie = M[ee].prototype, re = V.finishedAnimating && { animation: !1 }, ce = {}, he, ne, oe = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], se = $.type || Z.type || Q.options.chart.type, te = !(this.hasDerivedData || se && se !== this.type || $.pointStart !== void 0 || $.pointInterval !== void 0 || $.relativeXValue !== void 0 || $.joinBy || $.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((fe) => V.hasOptionChanged(fe)));
          se = se || ee, te && (oe.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), $.visible !== !1 && oe.push("area", "graph"), V.parallelArrays.forEach(function(fe) {
            oe.push(fe + "Data");
          }), $.data && ($.dataSorting && s(V.options.dataSorting, $.dataSorting), this.setData($.data, !1))), $ = z(Z, { index: Z.index === void 0 ? V.index : Z.index, pointStart: (ge = (de = (le = J == null ? void 0 : J.series) == null ? void 0 : le.pointStart) != null ? de : Z.pointStart) != null ? ge : (be = V.xData) == null ? void 0 : be[0] }, !te && { data: V.options.data }, $, re), te && $.data && ($.data = V.options.data), (oe = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(oe)).forEach(function(fe) {
            oe[fe] = V[fe], delete V[fe];
          });
          let ae = !1;
          if (M[se]) {
            if (ae = se !== V.type, V.remove(!1, !1, !1, !0), ae)
              if (Q.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(V, M[se].prototype);
              else {
                let fe = Object.hasOwnProperty.call(V, "hcEvents") && V.hcEvents;
                for (ne in ie) V[ne] = void 0;
                s(V, M[se].prototype), fe ? V.hcEvents = fe : delete V.hcEvents;
              }
          } else r(17, !0, Q, { missingModuleFor: se });
          if (oe.forEach(function(fe) {
            V[fe] = oe[fe];
          }), V.init(Q, $), te && this.points) for (let fe of ((he = V.options).visible === !1 ? (ce.graphic = 1, ce.dataLabel = 1) : (this.hasMarkerChanged(he, Z) && (ce.graphic = 1), (me = V.hasDataLabels) != null && me.call(V) || (ce.dataLabel = 1)), this.points)) fe && fe.series && (fe.resolveColor(), Object.keys(ce).length && fe.destroyElements(ce), he.showInLegend === !1 && fe.legendItem && Q.legend.destroyItem(fe));
          V.initialType = ee, Q.linkSeries(), Q.setSortedData(), ae && V.linkedSeries.length && (V.isDirtyData = !0), b(this, "afterUpdate"), G(K, !0) && Q.redraw(!!te && void 0);
        }
        setName($) {
          this.name = this.options.name = this.userOptions.name = $, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged($) {
          var J, ie;
          let K = this.chart, V = this.options[$], Q = K.options.plotOptions, Z = this.userOptions[$], ee = G((J = Q == null ? void 0 : Q[this.type]) == null ? void 0 : J[$], (ie = Q == null ? void 0 : Q.series) == null ? void 0 : ie[$]);
          return Z && !E(ee) ? V !== Z : V !== G(ee, V);
        }
        onMouseOver() {
          let $ = this.chart, K = $.hoverSeries, V = $.pointer;
          V == null || V.setHoverChartIndex(), K && K !== this && K.onMouseOut(), this.options.events.mouseOver && b(this, "mouseOver"), this.setState("hover"), $.hoverSeries = this;
        }
        onMouseOut() {
          let $ = this.options, K = this.chart, V = K.tooltip, Q = K.hoverPoint;
          K.hoverSeries = null, Q && Q.onMouseOut(), this && $.events.mouseOut && b(this, "mouseOut"), V && !this.stickyTracking && (!V.shared || this.noSharedTooltip) && V.hide(), K.series.forEach(function(Z) {
            Z.setState("", !0);
          });
        }
        setState($, K) {
          let V = this, Q = V.options, Z = V.graph, ee = Q.inactiveOtherPoints, J = Q.states, ie = G(J[$ || "normal"] && J[$ || "normal"].animation, V.chart.options.chart.animation), re = Q.lineWidth, ce = Q.opacity;
          if ($ = $ || "", V.state !== $ && ([V.group, V.markerGroup, V.dataLabelsGroup].forEach(function(he) {
            he && (V.state && he.removeClass("highcharts-series-" + V.state), $ && he.addClass("highcharts-series-" + $));
          }), V.state = $, !V.chart.styledMode)) {
            if (J[$] && J[$].enabled === !1) return;
            if ($ && (re = J[$].lineWidth || re + (J[$].lineWidthPlus || 0), ce = G(J[$].opacity, ce)), Z && !Z.dashstyle && P(re)) for (let he of [Z, ...this.zones.map((ne) => ne.graph)]) he == null || he.animate({ "stroke-width": re }, ie);
            ee || [V.group, V.markerGroup, V.dataLabelsGroup, V.labelBySeries].forEach(function(he) {
              he && he.animate({ opacity: ce }, ie);
            });
          }
          K && ee && V.points && V.setAllPointsToState($ || void 0);
        }
        setAllPointsToState($) {
          this.points.forEach(function(K) {
            K.setState && K.setState($);
          });
        }
        setVisible($, K) {
          var ie;
          let V = this, Q = V.chart, Z = Q.options.chart.ignoreHiddenSeries, ee = V.visible;
          V.visible = $ = V.options.visible = V.userOptions.visible = $ === void 0 ? !ee : $;
          let J = $ ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((re) => {
            var ce;
            (ce = V[re]) == null || ce[J]();
          }), (Q.hoverSeries === V || ((ie = Q.hoverPoint) == null ? void 0 : ie.series) === V) && V.onMouseOut(), V.legendItem && Q.legend.colorizeItem(V, $), V.isDirty = !0, V.options.stacking && Q.series.forEach((re) => {
            re.options.stacking && re.visible && (re.isDirty = !0);
          }), V.linkedSeries.forEach((re) => {
            re.setVisible($, !1);
          }), Z && (Q.isDirtyBox = !0), b(V, J), K !== !1 && Q.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select($) {
          this.selected = $ = this.options.selected = $ === void 0 ? !this.selected : $, this.checkbox && (this.checkbox.checked = $), b(this, $ ? "select" : "unselect");
        }
        shouldShowTooltip($, K, V = {}) {
          return V.series = this, V.visiblePlotOnly = !0, this.chart.isInsidePlot($, K, V);
        }
        drawLegendSymbol($, K) {
          var V;
          (V = D[this.options.legendSymbol || "rectangle"]) == null || V.call(this, $, K);
        }
      }
      return q.defaultOptions = I, q.types = B.seriesTypes, q.registerType = B.registerSeriesType, s(q.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: j, requireSorting: !0, sorted: !0 }), B.series = q, q;
    }), i(e, "Core/Legend/Legend.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Series/Point.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      var R;
      let { animObject: N, setAnimation: x } = o, { registerEventOptions: T } = n, { composed: y, marginNames: S } = l, { distribute: u } = j, { format: A } = I, { addEvent: M, createElement: f, css: m, defined: C, discardElement: F, find: _, fireEvent: E, isNumber: v, merge: w, pick: d, pushUnique: r, relativeLength: s, stableSort: p, syncTimeout: b } = B;
      class c {
        constructor(g, k) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = g, this.setOptions(k), k.enabled && (this.render(), T(this, k), M(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), M(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(g) {
          let k = d(g.padding, 8);
          this.options = g, this.chart.styledMode || (this.itemStyle = g.itemStyle, this.itemHiddenStyle = w(this.itemStyle, g.itemHiddenStyle)), this.itemMarginTop = g.itemMarginTop, this.itemMarginBottom = g.itemMarginBottom, this.padding = k, this.initialItemY = k - 5, this.symbolWidth = d(g.symbolWidth, 16), this.pages = [], this.proximate = g.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(g, k) {
          let P = this.chart;
          this.setOptions(w(!0, this.options, g)), "events" in this.options && T(this, this.options), this.destroy(), P.isDirtyLegend = P.isDirtyBox = !0, d(k, !0) && P.redraw(), E(this, "afterUpdate", { redraw: k });
        }
        colorizeItem(g, k) {
          let { area: P, group: O, label: z, line: W, symbol: G } = g.legendItem || {};
          if (O == null || O[k ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: Y = {} } = this, U = Y.color, { fillColor: H, fillOpacity: q, lineColor: X, marker: $ } = g.options, K = (V) => (!k && (V.fill && (V.fill = U), V.stroke && (V.stroke = U)), V);
            z == null || z.css(w(k ? this.itemStyle : Y)), W == null || W.attr(K({ stroke: X || g.color })), G && G.attr(K($ && G.isMarker ? g.pointAttribs() : { fill: g.color })), P == null || P.attr(K({ fill: H || g.color, "fill-opacity": H ? 1 : q != null ? q : 0.75 }));
          }
          E(this, "afterColorizeItem", { item: g, visible: k });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(g) {
          let { group: k, x: P = 0, y: O = 0 } = g.legendItem || {}, z = this.options, W = z.symbolPadding, G = !z.rtl, Y = g.checkbox;
          if (k && k.element) {
            let U = { translateX: G ? P : this.legendWidth - P - 2 * W - 4, translateY: O };
            k[C(k.translateY) ? "animate" : "attr"](U, void 0, () => {
              E(this, "afterPositionItem", { item: g });
            });
          }
          Y && (Y.x = P, Y.y = O);
        }
        destroyItem(g) {
          let k = g.checkbox, P = g.legendItem || {};
          for (let O of ["group", "label", "line", "symbol"]) P[O] && (P[O] = P[O].destroy());
          k && F(k), g.legendItem = void 0;
        }
        destroy() {
          for (let g of this.getAllItems()) this.destroyItem(g);
          for (let g of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[g] && (this[g] = this[g].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let g, k = this.group && this.group.alignAttr, P = this.clipHeight || this.legendHeight, O = this.titleHeight;
          k && (g = k.translateY, this.allItems.forEach(function(z) {
            let W, G = z.checkbox;
            G && (W = g + O + G.y + (this.scrollOffset || 0) + 3, m(G, { left: k.translateX + z.checkboxOffset + G.x - 20 + "px", top: W + "px", display: this.proximate || W > g - 6 && W < g + P - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let g = this.options, k = this.padding, P = g.title, O, z = 0;
          P.text && (this.title || (this.title = this.chart.renderer.label(P.text, k - 3, k - 4, void 0, void 0, void 0, g.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(P.style), this.title.add(this.group)), P.width || this.title.css({ width: this.maxLegendWidth + "px" }), z = (O = this.title.getBBox()).height, this.offsetWidth = O.width, this.contentGroup.attr({ translateY: z })), this.titleHeight = z;
        }
        setText(g) {
          let k = this.options;
          g.legendItem.label.attr({ text: k.labelFormat ? A(k.labelFormat, g, this.chart) : k.labelFormatter.call(g) });
        }
        renderItem(g) {
          let k = g.legendItem = g.legendItem || {}, P = this.chart, O = P.renderer, z = this.options, W = z.layout === "horizontal", G = this.symbolWidth, Y = z.symbolPadding || 0, U = this.itemStyle, H = this.itemHiddenStyle, q = W ? d(z.itemDistance, 20) : 0, X = !z.rtl, $ = !g.series, K = !$ && g.series.drawLegendSymbol ? g.series : g, V = K.options, Q = !!this.createCheckboxForItem && V && V.showCheckbox, Z = z.useHTML, ee = g.options.className, J = k.label, ie = G + Y + q + (Q ? 20 : 0);
          !J && (k.group = O.g("legend-item").addClass("highcharts-" + K.type + "-series highcharts-color-" + g.colorIndex + (ee ? " " + ee : "") + ($ ? " highcharts-series-" + g.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), k.label = J = O.text("", X ? G + Y : -Y, this.baseline || 0, Z), P.styledMode || J.css(w(g.visible ? U : H)), J.attr({ align: X ? "left" : "right", zIndex: 2 }).add(k.group), !this.baseline && (this.fontMetrics = O.fontMetrics(J), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, J.attr("y", this.baseline), this.symbolHeight = d(z.symbolHeight, this.fontMetrics.f), z.squareSymbol && (this.symbolWidth = d(z.symbolWidth, Math.max(this.symbolHeight, 16)), ie = this.symbolWidth + Y + q + (Q ? 20 : 0), X && J.attr("x", this.symbolWidth + Y))), K.drawLegendSymbol(this, g), this.setItemEvents && this.setItemEvents(g, J, Z)), Q && !g.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(g), this.colorizeItem(g, g.visible), (P.styledMode || !U.width) && J.css({ width: (z.itemWidth || this.widthOption || P.spacingBox.width) - ie + "px" }), this.setText(g);
          let re = J.getBBox(), ce = this.fontMetrics && this.fontMetrics.h || 0;
          g.itemWidth = g.checkboxOffset = z.itemWidth || k.labelWidth || re.width + ie, this.maxItemWidth = Math.max(this.maxItemWidth, g.itemWidth), this.totalItemWidth += g.itemWidth, this.itemHeight = g.itemHeight = Math.round(k.labelHeight || (re.height > 1.5 * ce ? re.height : ce));
        }
        layoutItem(g) {
          let k = this.options, P = this.padding, O = k.layout === "horizontal", z = g.itemHeight, W = this.itemMarginBottom, G = this.itemMarginTop, Y = O ? d(k.itemDistance, 20) : 0, U = this.maxLegendWidth, H = k.alignColumns && this.totalItemWidth > U ? this.maxItemWidth : g.itemWidth, q = g.legendItem || {};
          O && this.itemX - P + H > U && (this.itemX = P, this.lastLineHeight && (this.itemY += G + this.lastLineHeight + W), this.lastLineHeight = 0), this.lastItemY = G + this.itemY + W, this.lastLineHeight = Math.max(z, this.lastLineHeight), q.x = this.itemX, q.y = this.itemY, O ? this.itemX += H : (this.itemY += G + z + W, this.lastLineHeight = z), this.offsetWidth = this.widthOption || Math.max((O ? this.itemX - P - (g.checkbox ? 0 : Y) : H) + P, this.offsetWidth);
        }
        getAllItems() {
          let g = [];
          return this.chart.series.forEach(function(k) {
            let P = k && k.options;
            k && d(P.showInLegend, !C(P.linkedTo) && void 0, !0) && (g = g.concat((k.legendItem || {}).labels || (P.legendType === "point" ? k.data : k)));
          }), E(this, "afterGetAllItems", { allItems: g }), g;
        }
        getAlignment() {
          let g = this.options;
          return this.proximate ? g.align.charAt(0) + "tv" : g.floating ? "" : g.align.charAt(0) + g.verticalAlign.charAt(0) + g.layout.charAt(0);
        }
        adjustMargins(g, k) {
          let P = this.chart, O = this.options, z = this.getAlignment();
          z && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(W, G) {
            W.test(z) && !C(g[G]) && (P[S[G]] = Math.max(P[S[G]], P.legend[(G + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][G] * O[G % 2 ? "x" : "y"] + d(O.margin, 12) + k[G] + (P.titleOffset[G] || 0)));
          });
        }
        proximatePositions() {
          let g, k = this.chart, P = [], O = this.options.align === "left";
          for (let z of (this.allItems.forEach(function(W) {
            let G, Y, U = O, H, q;
            W.yAxis && (W.xAxis.options.reversed && (U = !U), W.points && (G = _(U ? W.points : W.points.slice(0).reverse(), function(X) {
              return v(X.plotY);
            })), Y = this.itemMarginTop + W.legendItem.label.getBBox().height + this.itemMarginBottom, q = W.yAxis.top - k.plotTop, H = W.visible ? (G ? G.plotY : W.yAxis.height) + (q - 0.3 * Y) : q + W.yAxis.height, P.push({ target: H, size: Y, item: W }));
          }, this), u(P, k.plotHeight))) g = z.item.legendItem || {}, v(z.pos) && (g.y = k.plotTop - k.spacing[0] + z.pos);
        }
        render() {
          let g = this.chart, k = g.renderer, P = this.options, O = this.padding, z = this.getAllItems(), W, G, Y, U = this.group, H, q = this.box;
          this.itemX = O, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = s(P.width, g.spacingBox.width - O), H = g.spacingBox.width - 2 * O - P.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (H /= 2), this.maxLegendWidth = this.widthOption || H, U || (this.group = U = k.g("legend").addClass(P.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = k.g().attr({ zIndex: 1 }).add(U), this.scrollGroup = k.g().add(this.contentGroup)), this.renderTitle(), p(z, (X, $) => (X.options && X.options.legendIndex || 0) - ($.options && $.options.legendIndex || 0)), P.reversed && z.reverse(), this.allItems = z, this.display = W = !!z.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, z.forEach(this.renderItem, this), z.forEach(this.layoutItem, this), G = (this.widthOption || this.offsetWidth) + O, Y = this.lastItemY + this.lastLineHeight + this.titleHeight, Y = this.handleOverflow(Y) + O, q || (this.box = q = k.rect().addClass("highcharts-legend-box").attr({ r: P.borderRadius }).add(U)), g.styledMode || q.attr({ stroke: P.borderColor, "stroke-width": P.borderWidth || 0, fill: P.backgroundColor || "none" }).shadow(P.shadow), G > 0 && Y > 0 && q[q.placed ? "animate" : "attr"](q.crisp.call({}, { x: 0, y: 0, width: G, height: Y }, q.strokeWidth())), U[W ? "show" : "hide"](), g.styledMode && U.getStyle("display") === "none" && (G = Y = 0), this.legendWidth = G, this.legendHeight = Y, W && this.align(), this.proximate || this.positionItems(), E(this, "afterRender");
        }
        align(g = this.chart.spacingBox) {
          let k = this.chart, P = this.options, O = g.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && k.titleOffset[0] > 0 ? O += k.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && k.titleOffset[2] > 0 && (O -= k.titleOffset[2]), O !== g.y && (g = w(g, { y: O })), k.hasRendered || (this.group.placed = !1), this.group.align(w(P, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : P.verticalAlign }), !0, g);
        }
        handleOverflow(g) {
          let k = this, P = this.chart, O = P.renderer, z = this.options, W = z.y, G = z.verticalAlign === "top", Y = this.padding, U = z.maxHeight, H = z.navigation, q = d(H.animation, !0), X = H.arrowSize || 12, $ = this.pages, K = this.allItems, V = function(he) {
            typeof he == "number" ? ce.attr({ height: he }) : ce && (k.clipRect = ce.destroy(), k.contentGroup.clip()), k.contentGroup.div && (k.contentGroup.div.style.clip = he ? "rect(" + Y + "px,9999px," + (Y + he) + "px,0)" : "auto");
          }, Q = function(he) {
            return k[he] = O.circle(0, 0, 1.3 * X).translate(X / 2, X / 2).add(re), P.styledMode || k[he].attr("fill", "rgba(0,0,0,0.0001)"), k[he];
          }, Z, ee, J, ie = P.spacingBox.height + (G ? -W : W) - Y, re = this.nav, ce = this.clipRect;
          return z.layout !== "horizontal" || z.verticalAlign === "middle" || z.floating || (ie /= 2), U && (ie = Math.min(ie, U)), $.length = 0, g && ie > 0 && g > ie && H.enabled !== !1 ? (this.clipHeight = Z = Math.max(ie - 20 - this.titleHeight - Y, 0), this.currentPage = d(this.currentPage, 1), this.fullHeight = g, K.forEach((he, ne) => {
            let oe = (J = he.legendItem || {}).y || 0, se = Math.round(J.label.getBBox().height), te = $.length;
            (!te || oe - $[te - 1] > Z && (ee || oe) !== $[te - 1]) && ($.push(ee || oe), te++), J.pageIx = te - 1, ee && ((K[ne - 1].legendItem || {}).pageIx = te - 1), ne === K.length - 1 && oe + se - $[te - 1] > Z && oe > $[te - 1] && ($.push(oe), J.pageIx = te), oe !== ee && (ee = oe);
          }), ce || (ce = k.clipRect = O.clipRect(0, Y - 2, 9999, 0), k.contentGroup.clip(ce)), V(Z), re || (this.nav = re = O.g().attr({ zIndex: 1 }).add(this.group), this.up = O.symbol("triangle", 0, 0, X, X).add(re), Q("upTracker").on("click", function() {
            k.scroll(-1, q);
          }), this.pager = O.text("", 15, 10).addClass("highcharts-legend-navigation"), !P.styledMode && H.style && this.pager.css(H.style), this.pager.add(re), this.down = O.symbol("triangle-down", 0, 0, X, X).add(re), Q("downTracker").on("click", function() {
            k.scroll(1, q);
          })), k.scroll(0), g = ie) : re && (V(), this.nav = re.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), g;
        }
        scroll(g, k) {
          let P = this.chart, O = this.pages, z = O.length, W = this.clipHeight, G = this.options.navigation, Y = this.pager, U = this.padding, H = this.currentPage + g;
          H > z && (H = z), H > 0 && (k !== void 0 && x(k, P), this.nav.attr({ translateX: U, translateY: W + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(q) {
            q.attr({ class: H === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), Y.attr({ text: H + "/" + z }), [this.down, this.downTracker].forEach(function(q) {
            q.attr({ x: 18 + this.pager.getBBox().width, class: H === z ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), P.styledMode || (this.up.attr({ fill: H === 1 ? G.inactiveColor : G.activeColor }), this.upTracker.css({ cursor: H === 1 ? "default" : "pointer" }), this.down.attr({ fill: H === z ? G.inactiveColor : G.activeColor }), this.downTracker.css({ cursor: H === z ? "default" : "pointer" })), this.scrollOffset = -O[H - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = H, this.positionCheckboxes(), b(() => {
            E(this, "afterScroll", { currentPage: H });
          }, N(d(k, P.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(g, k, P) {
          let O = this, z = g.legendItem || {}, W = O.chart.renderer.boxWrapper, G = g instanceof D, Y = g instanceof L, U = "highcharts-legend-" + (G ? "point" : "series") + "-active", H = O.chart.styledMode, q = P ? [k, z.symbol] : [z.group], X = ($) => {
            O.allItems.forEach((K) => {
              g !== K && [K].concat(K.linkedSeries || []).forEach((V) => {
                V.setState($, !G);
              });
            });
          };
          for (let $ of q) $ && $.on("mouseover", function() {
            g.visible && X("inactive"), g.setState("hover"), g.visible && W.addClass(U), H || k.css(O.options.itemHoverStyle);
          }).on("mouseout", function() {
            O.chart.styledMode || k.css(w(g.visible ? O.itemStyle : O.itemHiddenStyle)), X(""), W.removeClass(U), g.setState();
          }).on("click", function(K) {
            let V = function() {
              g.setVisible && g.setVisible(), X(g.visible ? "inactive" : "");
            };
            W.removeClass(U), E(O, "itemClick", { browserEvent: K, legendItem: g }, V), G ? g.firePointEvent("legendItemClick", { browserEvent: K }) : Y && E(g, "legendItemClick", { browserEvent: K });
          });
        }
        createCheckboxForItem(g) {
          g.checkbox = f("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: g.selected, defaultChecked: g.selected }, this.options.itemCheckboxStyle, this.chart.container), M(g.checkbox, "click", function(k) {
            let P = k.target;
            E(g.series || g, "checkboxClick", { checked: P.checked, item: g }, function() {
              g.select();
            });
          });
        }
      }
      return (R = c || (c = {})).compose = function(h) {
        r(y, "Core.Legend") && M(h, "beforeMargins", function() {
          this.legend = new R(this, this.options.legend);
        });
      }, c;
    }), i(e, "Core/Chart/Chart.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Defaults.js"], e["Core/Templating.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Time.js"], e["Core/Utilities.js"], e["Core/Renderer/HTML/AST.js"], e["Core/Axis/Tick.js"]], function(o, n, l, L, D, j, I, B, R, N, x, T, y, S) {
      let { animate: u, animObject: A, setAnimation: M } = o, { defaultOptions: f, defaultTime: m } = l, { numberFormat: C } = L, { registerEventOptions: F } = D, { charts: _, doc: E, marginNames: v, svg: w, win: d } = j, { seriesTypes: r } = R, { addEvent: s, attr: p, createElement: b, css: c, defined: h, diffObjects: g, discardElement: k, erase: P, error: O, extend: z, find: W, fireEvent: G, getStyle: Y, isArray: U, isNumber: H, isObject: q, isString: X, merge: $, objectEach: K, pick: V, pInt: Q, relativeLength: Z, removeEvent: ee, splat: J, syncTimeout: ie, uniqueKey: re } = T;
      class ce {
        static chart(ne, oe, se) {
          return new ce(ne, oe, se);
        }
        constructor(ne, oe, se) {
          this.sharedClips = {};
          let te = [...arguments];
          (X(ne) || ne.nodeName) && (this.renderTo = te.shift()), this.init(te[0], te[1]);
        }
        setZoomOptions() {
          let ne = this.options.chart, oe = ne.zooming;
          this.zooming = { ...oe, type: V(ne.zoomType, oe.type), key: V(ne.zoomKey, oe.key), pinchType: V(ne.pinchType, oe.pinchType), singleTouch: V(ne.zoomBySingleTouch, oe.singleTouch, !1), resetButton: $(oe.resetButton, ne.resetZoomButton) };
        }
        init(ne, oe) {
          G(this, "init", { args: arguments }, function() {
            let se = $(f, ne), te = se.chart;
            this.userOptions = z({}, ne), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = oe, this.isResizing = 0, this.options = se, this.axes = [], this.series = [], this.time = ne.time && Object.keys(ne.time).length ? new x(ne.time) : j.time, this.numberFormatter = te.numberFormatter || C, this.styledMode = te.styledMode, this.hasCartesianSeries = te.showAxes, this.index = _.length, _.push(this), j.chartCount++, F(this, te), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), G(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(ne) {
          let oe = this.options.chart, se = ne.type || oe.type, te = r[se];
          te || O(17, !0, this, { missingModuleFor: se });
          let ae = new te();
          return typeof ae.init == "function" && ae.init(this, ne), ae;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(ne) {
            ne.points || ne.data || !ne.enabledDataSorting || ne.setData(ne.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(ne, oe) {
            return ne.linkedSeries.length || oe.linkedSeries.length ? oe.linkedSeries.length - ne.linkedSeries.length : 0;
          });
        }
        orderItems(ne, oe = 0) {
          let se = this[ne], te = this.options[ne] = J(this.options[ne]).slice(), ae = this.userOptions[ne] = this.userOptions[ne] ? J(this.userOptions[ne]).slice() : [];
          if (this.hasRendered && (te.splice(oe), ae.splice(oe)), se) for (let le = oe, de = se.length; le < de; ++le) {
            let be = se[le];
            be && (be.index = le, be instanceof B && (be.name = be.getName()), be.options.isInternal || (te[le] = be.options, ae[le] = be.userOptions));
          }
        }
        isInsidePlot(ne, oe, se = {}) {
          var ke;
          let { inverted: te, plotBox: ae, plotLeft: le, plotTop: de, scrollablePlotBox: be } = this, { scrollLeft: ge = 0, scrollTop: me = 0 } = se.visiblePlotOnly && ((ke = this.scrollablePlotArea) == null ? void 0 : ke.scrollingContainer) || {}, fe = se.series, Ae = se.visiblePlotOnly && be || ae, ye = se.inverted ? oe : ne, xe = se.inverted ? ne : oe, we = { x: ye, y: xe, isInsidePlot: !0, options: se };
          if (!se.ignoreX) {
            let Oe = fe && (te && !this.polar ? fe.yAxis : fe.xAxis) || { pos: le, len: 1 / 0 }, Me = se.paneCoordinates ? Oe.pos + ye : le + ye;
            Me >= Math.max(ge + le, Oe.pos) && Me <= Math.min(ge + le + Ae.width, Oe.pos + Oe.len) || (we.isInsidePlot = !1);
          }
          if (!se.ignoreY && we.isInsidePlot) {
            let Oe = !te && se.axis && !se.axis.isXAxis && se.axis || fe && (te ? fe.xAxis : fe.yAxis) || { pos: de, len: 1 / 0 }, Me = se.paneCoordinates ? Oe.pos + xe : de + xe;
            Me >= Math.max(me + de, Oe.pos) && Me <= Math.min(me + de + Ae.height, Oe.pos + Oe.len) || (we.isInsidePlot = !1);
          }
          return G(this, "afterIsInsidePlot", we), we.isInsidePlot;
        }
        redraw(ne) {
          G(this, "beforeRedraw");
          let oe = this.hasCartesianSeries ? this.axes : this.colorAxis || [], se = this.series, te = this.pointer, ae = this.legend, le = this.userOptions.legend, de = this.renderer, be = de.isHidden(), ge = [], me, fe, Ae, ye = this.isDirtyBox, xe = this.isDirtyLegend, we;
          for (de.rootFontSize = de.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), M(!!this.hasRendered && ne, this), be && this.temporaryDisplay(), this.layOutTitles(!1), Ae = se.length; Ae--; ) if (((we = se[Ae]).options.stacking || we.options.centerInCategory) && (fe = !0, we.isDirty)) {
            me = !0;
            break;
          }
          if (me) for (Ae = se.length; Ae--; ) (we = se[Ae]).options.stacking && (we.isDirty = !0);
          se.forEach(function(ke) {
            ke.isDirty && (ke.options.legendType === "point" ? (typeof ke.updateTotals == "function" && ke.updateTotals(), xe = !0) : le && (le.labelFormatter || le.labelFormat) && (xe = !0)), ke.isDirtyData && G(ke, "updatedData");
          }), xe && ae && ae.options.enabled && (ae.render(), this.isDirtyLegend = !1), fe && this.getStacks(), oe.forEach(function(ke) {
            ke.updateNames(), ke.setScale();
          }), this.getMargins(), oe.forEach(function(ke) {
            ke.isDirty && (ye = !0);
          }), oe.forEach(function(ke) {
            let Oe = ke.min + "," + ke.max;
            ke.extKey !== Oe && (ke.extKey = Oe, ge.push(function() {
              G(ke, "afterSetExtremes", z(ke.eventArgs, ke.getExtremes())), delete ke.eventArgs;
            })), (ye || fe) && ke.redraw();
          }), ye && this.drawChartBox(), G(this, "predraw"), se.forEach(function(ke) {
            (ye || ke.isDirty) && ke.visible && ke.redraw(), ke.isDirtyData = !1;
          }), te && te.reset(!0), de.draw(), G(this, "redraw"), G(this, "render"), be && this.temporaryDisplay(!0), ge.forEach(function(ke) {
            ke.call();
          });
        }
        get(ne) {
          let oe = this.series;
          function se(ae) {
            return ae.id === ne || ae.options && ae.options.id === ne;
          }
          let te = W(this.axes, se) || W(this.series, se);
          for (let ae = 0; !te && ae < oe.length; ae++) te = W(oe[ae].points || [], se);
          return te;
        }
        getAxes() {
          let ne = this.userOptions;
          for (let oe of (G(this, "getAxes"), ["xAxis", "yAxis"])) for (let se of ne[oe] = J(ne[oe] || {})) new n(this, se, oe);
          G(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((ne, oe) => (oe.getPointsCollection().forEach((se) => {
            V(se.selectedStaging, se.selected) && ne.push(se);
          }), ne), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(ne) {
            return ne.selected;
          });
        }
        setTitle(ne, oe, se) {
          this.applyDescription("title", ne), this.applyDescription("subtitle", oe), this.applyDescription("caption", void 0), this.layOutTitles(se);
        }
        applyDescription(ne, oe) {
          let se = this, te = this.options[ne] = $(this.options[ne], oe), ae = this[ne];
          ae && oe && (this[ne] = ae = ae.destroy()), te && !ae && ((ae = this.renderer.text(te.text, 0, 0, te.useHTML).attr({ align: te.align, class: "highcharts-" + ne, zIndex: te.zIndex || 4 }).add()).update = function(le, de) {
            se.applyDescription(ne, le), se.layOutTitles(de);
          }, this.styledMode || ae.css(z(ne === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, te.style)), this[ne] = ae);
        }
        layOutTitles(ne = !0) {
          let oe = [0, 0, 0], se = this.renderer, te = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(le) {
            let de = this[le], be = this.options[le], ge = be.verticalAlign || "top", me = le === "title" ? ge === "top" ? -3 : 0 : ge === "top" ? oe[0] + 2 : 0;
            if (de) {
              de.css({ width: (be.width || te.width + (be.widthAdjust || 0)) + "px" });
              let fe = se.fontMetrics(de).b, Ae = Math.round(de.getBBox(be.useHTML).height);
              de.align(z({ y: ge === "bottom" ? fe : me + fe, height: Ae }, be), !1, "spacingBox"), be.floating || (ge === "top" ? oe[0] = Math.ceil(oe[0] + Ae) : ge === "bottom" && (oe[2] = Math.ceil(oe[2] + Ae)));
            }
          }, this), oe[0] && (this.options.title.verticalAlign || "top") === "top" && (oe[0] += this.options.title.margin), oe[2] && this.options.caption.verticalAlign === "bottom" && (oe[2] += this.options.caption.margin);
          let ae = !this.titleOffset || this.titleOffset.join(",") !== oe.join(",");
          this.titleOffset = oe, G(this, "afterLayOutTitles"), !this.isDirtyBox && ae && (this.isDirtyBox = this.isDirtyLegend = ae, this.hasRendered && ne && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let ne = [].map.call(this.renderTo.children, (se) => {
            if (se !== this.container) {
              let te = se.style.display;
              return se.style.display = "none", [se, te];
            }
          }), oe = { width: Y(this.renderTo, "width", !0) || 0, height: Y(this.renderTo, "height", !0) || 0 };
          return ne.filter(Boolean).forEach(([se, te]) => {
            se.style.display = te;
          }), oe;
        }
        getChartSize() {
          var le;
          let ne = this.options.chart, oe = ne.width, se = ne.height, te = this.getContainerBox(), ae = te.height > 1 && !(!((le = this.renderTo.parentElement) != null && le.style.height) && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, oe || te.width || 600), this.chartHeight = Math.max(0, Z(se, this.chartWidth) || (ae ? te.height : 400)), this.containerBox = te;
        }
        temporaryDisplay(ne) {
          let oe = this.renderTo, se;
          if (ne) for (; oe && oe.style; ) oe.hcOrigStyle && (c(oe, oe.hcOrigStyle), delete oe.hcOrigStyle), oe.hcOrigDetached && (E.body.removeChild(oe), oe.hcOrigDetached = !1), oe = oe.parentNode;
          else for (; oe && oe.style && (E.body.contains(oe) || oe.parentNode || (oe.hcOrigDetached = !0, E.body.appendChild(oe)), (Y(oe, "display", !1) === "none" || oe.hcOricDetached) && (oe.hcOrigStyle = { display: oe.style.display, height: oe.style.height, overflow: oe.style.overflow }, se = { display: "block", overflow: "hidden" }, oe !== this.renderTo && (se.height = 0), c(oe, se), oe.offsetWidth || oe.style.setProperty("display", "block", "important")), (oe = oe.parentNode) !== E.body); ) ;
        }
        setClassName(ne) {
          this.container.className = "highcharts-container " + (ne || "");
        }
        getContainer() {
          var Ae;
          let ne = this.options, oe = ne.chart, se = "data-highcharts-chart", te = re(), ae, le = this.renderTo;
          le || (this.renderTo = le = oe.renderTo), X(le) && (this.renderTo = le = E.getElementById(le)), le || O(13, !0, this);
          let de = Q(p(le, se));
          H(de) && _[de] && _[de].hasRendered && _[de].destroy(), p(le, se, this.index), le.innerHTML = y.emptyHTML, oe.skipClone || le.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let be = this.chartHeight, ge = this.chartWidth;
          c(le, { overflow: "hidden" }), this.styledMode || (ae = z({ position: "relative", overflow: "hidden", width: ge + "px", height: be + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, oe.style || {}));
          let me = b("div", { id: te }, ae, le);
          this.container = me, this.getChartSize(), ge === this.chartWidth || (ge = this.chartWidth, this.styledMode || c(me, { width: V((Ae = oe.style) == null ? void 0 : Ae.width, ge + "px") })), this.containerBox = this.getContainerBox(), this._cursor = me.style.cursor;
          let fe = oe.renderer || !w ? I.getRendererType(oe.renderer) : N;
          if (this.renderer = new fe(me, ge, be, void 0, oe.forExport, ne.exporting && ne.exporting.allowHTML, this.styledMode), M(void 0, this), this.setClassName(oe.className), this.styledMode) for (let ye in ne.defs) this.renderer.definition(ne.defs[ye]);
          else this.renderer.setStyle(oe.style);
          this.renderer.chartIndex = this.index, G(this, "afterGetContainer");
        }
        getMargins(ne) {
          let { spacing: oe, margin: se, titleOffset: te } = this;
          this.resetMargins(), te[0] && !h(se[0]) && (this.plotTop = Math.max(this.plotTop, te[0] + oe[0])), te[2] && !h(se[2]) && (this.marginBottom = Math.max(this.marginBottom, te[2] + oe[2])), this.legend && this.legend.display && this.legend.adjustMargins(se, oe), G(this, "getMargins"), ne || this.getAxisMargins();
        }
        getAxisMargins() {
          let ne = this, oe = ne.axisOffset = [0, 0, 0, 0], se = ne.colorAxis, te = ne.margin, ae = function(le) {
            le.forEach(function(de) {
              de.visible && de.getOffset();
            });
          };
          ne.hasCartesianSeries ? ae(ne.axes) : se && se.length && ae(se), v.forEach(function(le, de) {
            h(te[de]) || (ne[le] += oe[de]);
          }), ne.setChartSize();
        }
        getOptions() {
          return g(this.userOptions, f);
        }
        reflow(ne) {
          var ae;
          let oe = this, se = oe.containerBox, te = oe.getContainerBox();
          (ae = oe.pointer) == null || delete ae.chartPosition, !oe.isPrinting && !oe.isResizing && se && te.width && ((te.width !== se.width || te.height !== se.height) && (T.clearTimeout(oe.reflowTimeout), oe.reflowTimeout = ie(function() {
            oe.container && oe.setSize(void 0, void 0, !1);
          }, ne ? 100 : 0)), oe.containerBox = te);
        }
        setReflow() {
          let ne = this, oe = (se) => {
            var te;
            (te = ne.options) != null && te.chart.reflow && ne.hasLoaded && ne.reflow(se);
          };
          if (typeof ResizeObserver == "function") new ResizeObserver(oe).observe(ne.renderTo);
          else {
            let se = s(d, "resize", oe);
            s(this, "destroy", se);
          }
        }
        setSize(ne, oe, se) {
          let te = this, ae = te.renderer;
          te.isResizing += 1, M(se, te);
          let le = ae.globalAnimation;
          te.oldChartHeight = te.chartHeight, te.oldChartWidth = te.chartWidth, ne !== void 0 && (te.options.chart.width = ne), oe !== void 0 && (te.options.chart.height = oe), te.getChartSize();
          let { chartWidth: de, chartHeight: be, scrollablePixelsX: ge = 0, scrollablePixelsY: me = 0 } = te;
          (te.isDirtyBox || de !== te.oldChartWidth || be !== te.oldChartHeight) && (te.styledMode || (le ? u : c)(te.container, { width: `${de + ge}px`, height: `${be + me}px` }, le), te.setChartSize(!0), ae.setSize(de, be, le), te.axes.forEach(function(fe) {
            fe.isDirty = !0, fe.setScale();
          }), te.isDirtyLegend = !0, te.isDirtyBox = !0, te.layOutTitles(), te.getMargins(), te.redraw(le), te.oldChartHeight = void 0, G(te, "resize"), setTimeout(() => {
            te && G(te, "endResize");
          }, A(le).duration)), te.isResizing -= 1;
        }
        setChartSize(ne) {
          let oe, se, te, ae, { chartHeight: le, chartWidth: de, inverted: be, spacing: ge, renderer: me } = this, fe = this.clipOffset, Ae = Math[be ? "floor" : "round"];
          this.plotLeft = oe = Math.round(this.plotLeft), this.plotTop = se = Math.round(this.plotTop), this.plotWidth = te = Math.max(0, Math.round(de - oe - this.marginRight)), this.plotHeight = ae = Math.max(0, Math.round(le - se - this.marginBottom)), this.plotSizeX = be ? ae : te, this.plotSizeY = be ? te : ae, this.spacingBox = me.spacingBox = { x: ge[3], y: ge[0], width: de - ge[3] - ge[1], height: le - ge[0] - ge[2] }, this.plotBox = me.plotBox = { x: oe, y: se, width: te, height: ae }, fe && (this.clipBox = { x: Ae(fe[3]), y: Ae(fe[0]), width: Ae(this.plotSizeX - fe[1] - fe[3]), height: Ae(this.plotSizeY - fe[0] - fe[2]) }), ne || (this.axes.forEach(function(ye) {
            ye.setAxisSize(), ye.setAxisTranslation();
          }), me.alignElements()), G(this, "afterSetChartSize", { skipAxes: ne });
        }
        resetMargins() {
          G(this, "resetMargins");
          let ne = this, oe = ne.options.chart, se = oe.plotBorderWidth || 0, te = se / 2;
          ["margin", "spacing"].forEach(function(ae) {
            let le = oe[ae], de = q(le) ? le : [le, le, le, le];
            ["Top", "Right", "Bottom", "Left"].forEach(function(be, ge) {
              ne[ae][ge] = V(oe[ae + be], de[ge]);
            });
          }), v.forEach(function(ae, le) {
            ne[ae] = V(ne.margin[le], ne.spacing[le]);
          }), ne.axisOffset = [0, 0, 0, 0], ne.clipOffset = [te, te, te, te], ne.plotBorderWidth = se;
        }
        drawChartBox() {
          let ne = this.options.chart, oe = this.renderer, se = this.chartWidth, te = this.chartHeight, ae = this.styledMode, le = this.plotBGImage, de = ne.backgroundColor, be = ne.plotBackgroundColor, ge = ne.plotBackgroundImage, me = this.plotLeft, fe = this.plotTop, Ae = this.plotWidth, ye = this.plotHeight, xe = this.plotBox, we = this.clipRect, ke = this.clipBox, Oe = this.chartBackground, Me = this.plotBackground, Ne = this.plotBorder, Ke, He, bt, xt = "animate";
          Oe || (this.chartBackground = Oe = oe.rect().addClass("highcharts-background").add(), xt = "attr"), ae ? Ke = He = Oe.strokeWidth() : (He = (Ke = ne.borderWidth || 0) + (ne.shadow ? 8 : 0), bt = { fill: de || "none" }, (Ke || Oe["stroke-width"]) && (bt.stroke = ne.borderColor, bt["stroke-width"] = Ke), Oe.attr(bt).shadow(ne.shadow)), Oe[xt]({ x: He / 2, y: He / 2, width: se - He - Ke % 2, height: te - He - Ke % 2, r: ne.borderRadius }), xt = "animate", Me || (xt = "attr", this.plotBackground = Me = oe.rect().addClass("highcharts-plot-background").add()), Me[xt](xe), !ae && (Me.attr({ fill: be || "none" }).shadow(ne.plotShadow), ge && (le ? (ge !== le.attr("href") && le.attr("href", ge), le.animate(xe)) : this.plotBGImage = oe.image(ge, me, fe, Ae, ye).add())), we ? we.animate({ width: ke.width, height: ke.height }) : this.clipRect = oe.clipRect(ke), xt = "animate", Ne || (xt = "attr", this.plotBorder = Ne = oe.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ae || Ne.attr({ stroke: ne.plotBorderColor, "stroke-width": ne.plotBorderWidth || 0, fill: "none" }), Ne[xt](Ne.crisp({ x: me, y: fe, width: Ae, height: ye }, -Ne.strokeWidth())), this.isDirtyBox = !1, G(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let ne, oe, se, te = this, ae = te.options.chart, le = te.options.series;
          ["inverted", "angular", "polar"].forEach(function(de) {
            for (oe = r[ae.type], se = ae[de] || oe && oe.prototype[de], ne = le && le.length; !se && ne--; ) (oe = r[le[ne].type]) && oe.prototype[de] && (se = !0);
            te[de] = se;
          });
        }
        linkSeries(ne) {
          let oe = this, se = oe.series;
          se.forEach(function(te) {
            te.linkedSeries.length = 0;
          }), se.forEach(function(te) {
            let { linkedTo: ae } = te.options;
            if (X(ae)) {
              let le;
              (le = ae === ":previous" ? oe.series[te.index - 1] : oe.get(ae)) && le.linkedParent !== te && (le.linkedSeries.push(te), te.linkedParent = le, le.enabledDataSorting && te.setDataSortingOptions(), te.visible = V(te.options.visible, le.options.visible, te.visible));
            }
          }), G(this, "afterLinkSeries", { isUpdating: ne });
        }
        renderSeries() {
          this.series.forEach(function(ne) {
            ne.translate(), ne.render();
          });
        }
        render() {
          var me;
          let ne = this.axes, oe = this.colorAxis, se = this.renderer, te = this.options.chart.axisLayoutRuns || 2, ae = (fe) => {
            fe.forEach((Ae) => {
              Ae.visible && Ae.render();
            });
          }, le = 0, de = !0, be, ge = 0;
          for (let fe of (this.setTitle(), G(this, "beforeMargins"), (me = this.getStacks) == null || me.call(this), this.getMargins(!0), this.setChartSize(), ne)) {
            let { options: Ae } = fe, { labels: ye } = Ae;
            if (this.hasCartesianSeries && fe.horiz && fe.visible && ye.enabled && fe.series.length && fe.coll !== "colorAxis" && !this.polar) {
              le = Ae.tickLength, fe.createGroups();
              let xe = new S(fe, 0, "", !0), we = xe.createLabel("x", ye);
              if (xe.destroy(), we && V(ye.reserveSpace, !H(Ae.crossing)) && (le = we.getBBox().height + ye.distance + Math.max(Ae.offset || 0, 0)), le) {
                we == null || we.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - le, 0); (de || be || te > 1) && ge < te; ) {
            let fe = this.plotWidth, Ae = this.plotHeight;
            for (let ye of ne) ge === 0 ? ye.setScale() : (ye.horiz && de || !ye.horiz && be) && ye.setTickInterval(!0);
            ge === 0 ? this.getAxisMargins() : this.getMargins(), de = fe / this.plotWidth > (ge ? 1 : 1.1), be = Ae / this.plotHeight > (ge ? 1 : 1.05), ge++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ae(ne) : oe && oe.length && ae(oe), this.seriesGroup || (this.seriesGroup = se.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(ne) {
          let oe = this, se = $(!0, this.options.credits, ne);
          se.enabled && !this.credits && (this.credits = this.renderer.text(se.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            se.href && (d.location.href = se.href);
          }).attr({ align: se.position.align, zIndex: 8 }), oe.styledMode || this.credits.css(se.style), this.credits.add().align(se.position), this.credits.update = function(te) {
            oe.credits = oe.credits.destroy(), oe.addCredits(te);
          });
        }
        destroy() {
          let ne, oe = this, se = oe.axes, te = oe.series, ae = oe.container, le = ae && ae.parentNode;
          for (G(oe, "destroy"), oe.renderer.forExport ? P(_, oe) : _[oe.index] = void 0, j.chartCount--, oe.renderTo.removeAttribute("data-highcharts-chart"), ee(oe), ne = se.length; ne--; ) se[ne] = se[ne].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), ne = te.length; ne--; ) te[ne] = te[ne].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(de) {
            let be = oe[de];
            be && be.destroy && (oe[de] = be.destroy());
          }), ae && (ae.innerHTML = y.emptyHTML, ee(ae), le && k(ae)), K(oe, function(de, be) {
            delete oe[be];
          });
        }
        firstRender() {
          var te;
          let ne = this, oe = ne.options;
          ne.getContainer(), ne.resetMargins(), ne.setChartSize(), ne.propFromSeries(), ne.getAxes();
          let se = U(oe.series) ? oe.series : [];
          oe.series = [], se.forEach(function(ae) {
            ne.initSeries(ae);
          }), ne.linkSeries(), ne.setSortedData(), G(ne, "beforeRender"), ne.render(), (te = ne.pointer) == null || te.getChartPosition(), ne.renderer.imgCount || ne.hasLoaded || ne.onload(), ne.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(ne) {
            ne && this.index !== void 0 && ne.apply(this, [this]);
          }, this), G(this, "load"), G(this, "render"), h(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: ne, title: oe } = this;
          !ne || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (oe && oe.element.textContent || "").replace(/</g, "&lt;") }), ne.accessibility && ne.accessibility.enabled === !1 || O('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(ne, oe, se) {
          let te, ae = this;
          return ne && (oe = V(oe, !0), G(ae, "addSeries", { options: ne }, function() {
            te = ae.initSeries(ne), ae.isDirtyLegend = !0, ae.linkSeries(), te.enabledDataSorting && te.setData(ne.data, !1), G(ae, "afterAddSeries", { series: te }), oe && ae.redraw(se);
          })), te;
        }
        addAxis(ne, oe, se, te) {
          return this.createAxis(oe ? "xAxis" : "yAxis", { axis: ne, redraw: se, animation: te });
        }
        addColorAxis(ne, oe, se) {
          return this.createAxis("colorAxis", { axis: ne, redraw: oe, animation: se });
        }
        createAxis(ne, oe) {
          let se = new n(this, oe.axis, ne);
          return V(oe.redraw, !0) && this.redraw(oe.animation), se;
        }
        showLoading(ne) {
          let oe = this, se = oe.options, te = se.loading, ae = function() {
            le && c(le, { left: oe.plotLeft + "px", top: oe.plotTop + "px", width: oe.plotWidth + "px", height: oe.plotHeight + "px" });
          }, le = oe.loadingDiv, de = oe.loadingSpan;
          le || (oe.loadingDiv = le = b("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, oe.container)), de || (oe.loadingSpan = de = b("span", { className: "highcharts-loading-inner" }, null, le), s(oe, "redraw", ae)), le.className = "highcharts-loading", y.setElementHTML(de, V(ne, se.lang.loading, "")), oe.styledMode || (c(le, z(te.style, { zIndex: 10 })), c(de, te.labelStyle), oe.loadingShown || (c(le, { opacity: 0, display: "" }), u(le, { opacity: te.style.opacity || 0.5 }, { duration: te.showDuration || 0 }))), oe.loadingShown = !0, ae();
        }
        hideLoading() {
          let ne = this.options, oe = this.loadingDiv;
          oe && (oe.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || u(oe, { opacity: 0 }, { duration: ne.loading.hideDuration || 100, complete: function() {
            c(oe, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(ne, oe, se, te) {
          let ae, le, de, be = this, ge = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, me = ne.isResponsiveOptions, fe = [];
          G(be, "update", { options: ne }), me || be.setResponsive(!1, !0), ne = g(ne, be.options), be.userOptions = $(be.userOptions, ne);
          let Ae = ne.chart;
          Ae && ($(!0, be.options.chart, Ae), this.setZoomOptions(), "className" in Ae && be.setClassName(Ae.className), ("inverted" in Ae || "polar" in Ae || "type" in Ae) && (be.propFromSeries(), ae = !0), "alignTicks" in Ae && (ae = !0), "events" in Ae && F(this, Ae), K(Ae, function(we, ke) {
            be.propsRequireUpdateSeries.indexOf("chart." + ke) !== -1 && (le = !0), be.propsRequireDirtyBox.indexOf(ke) !== -1 && (be.isDirtyBox = !0), be.propsRequireReflow.indexOf(ke) === -1 || (be.isDirtyBox = !0, me || (de = !0));
          }), !be.styledMode && Ae.style && be.renderer.setStyle(be.options.chart.style || {})), !be.styledMode && ne.colors && (this.options.colors = ne.colors), ne.time && (this.time === m && (this.time = new x(ne.time)), $(!0, be.options.time, ne.time)), K(ne, function(we, ke) {
            be[ke] && typeof be[ke].update == "function" ? be[ke].update(we, !1) : typeof be[ge[ke]] == "function" ? be[ge[ke]](we) : ke !== "colors" && be.collectionsWithUpdate.indexOf(ke) === -1 && $(!0, be.options[ke], ne[ke]), ke !== "chart" && be.propsRequireUpdateSeries.indexOf(ke) !== -1 && (le = !0);
          }), this.collectionsWithUpdate.forEach(function(we) {
            ne[we] && (J(ne[we]).forEach(function(ke, Oe) {
              let Me, Ne = h(ke.id);
              Ne && (Me = be.get(ke.id)), !Me && be[we] && (Me = be[we][V(ke.index, Oe)]) && (Ne && h(Me.options.id) || Me.options.isInternal) && (Me = void 0), Me && Me.coll === we && (Me.update(ke, !1), se && (Me.touched = !0)), !Me && se && be.collectionsWithInit[we] && (be.collectionsWithInit[we][0].apply(be, [ke].concat(be.collectionsWithInit[we][1] || []).concat([!1])).touched = !0);
            }), se && be[we].forEach(function(ke) {
              ke.touched || ke.options.isInternal ? delete ke.touched : fe.push(ke);
            }));
          }), fe.forEach(function(we) {
            we.chart && we.remove && we.remove(!1);
          }), ae && be.axes.forEach(function(we) {
            we.update({}, !1);
          }), le && be.getSeriesOrderByLinks().forEach(function(we) {
            we.chart && we.update({}, !1);
          }, this);
          let ye = Ae && Ae.width, xe = Ae && (X(Ae.height) ? Z(Ae.height, ye || be.chartWidth) : Ae.height);
          de || H(ye) && ye !== be.chartWidth || H(xe) && xe !== be.chartHeight ? be.setSize(ye, xe, te) : V(oe, !0) && be.redraw(te), G(be, "afterUpdate", { options: ne, redraw: oe, animation: te });
        }
        setSubtitle(ne, oe) {
          this.applyDescription("subtitle", ne), this.layOutTitles(oe);
        }
        setCaption(ne, oe) {
          this.applyDescription("caption", ne), this.layOutTitles(oe);
        }
        showResetZoom() {
          let ne = this, oe = f.lang, se = ne.zooming.resetButton, te = se.theme, ae = se.relativeTo === "chart" || se.relativeTo === "spacingBox" ? null : "plotBox";
          function le() {
            ne.zoomOut();
          }
          G(this, "beforeShowResetZoom", null, function() {
            ne.resetZoomButton = ne.renderer.button(oe.resetZoom, null, null, le, te).attr({ align: se.position.align, title: oe.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(se.position, !1, ae);
          }), G(this, "afterShowResetZoom");
        }
        zoomOut() {
          G(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(ne, oe) {
          let se = this, te = typeof oe == "object" ? oe : { enabled: oe, type: "x" }, ae = te.type, le = ae && se[{ x: "xAxis", xy: "axes", y: "yAxis" }[ae]].filter((be) => be.options.panningEnabled && !be.options.isInternal), de = se.options.chart;
          de != null && de.panning && (de.panning = te), G(this, "pan", { originalEvent: ne }, () => {
            se.transform({ axes: le, event: ne, to: { x: ne.chartX - (se.mouseDownX || 0), y: ne.chartY - (se.mouseDownY || 0) }, trigger: "pan" }), c(se.container, { cursor: "move" });
          });
        }
        transform(ne) {
          var ye, xe, we, ke, Oe;
          let { axes: oe = this.axes, event: se, from: te = {}, reset: ae, selection: le, to: de = {}, trigger: be } = ne, { inverted: ge } = this, me = !1, fe, Ae;
          for (let Me of ((ye = this.hoverPoints) == null || ye.forEach((Ne) => Ne.setState()), oe)) {
            let { horiz: Ne, len: Ke, minPointOffset: He = 0, options: bt, reversed: xt } = Me, Wi = Ne ? "width" : "height", Pa = Ne ? "x" : "y", bi = V(de[Wi], Me.len), pi = V(te[Wi], Me.len), fo = 10 > Math.abs(bi) ? 1 : bi / pi, Xc = (te[Pa] || 0) + pi / 2 - Me.pos, Qc = Xc - (((xe = de[Pa]) != null ? xe : Me.pos) + bi / 2 - Me.pos) / fo, mp = xt && !ge || !xt && ge ? -1 : 1;
            if (!ae && (Xc < 0 || Xc > Me.len)) continue;
            let ho = Me.toValue(Qc, !0) + (le || Me.isOrdinal ? 0 : He * mp), bo = Me.toValue(Qc + Ke / fo, !0) - (le || Me.isOrdinal ? 0 : He * mp || 0), Do = Me.allExtremes;
            if (ho > bo && ([ho, bo] = [bo, ho]), fo === 1 && !ae && Me.coll === "yAxis" && !Do) {
              for (let kp of Me.series) {
                let dl = kp.getExtremes(kp.getProcessedData(!0).yData, !0);
                Do != null || (Do = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), H(dl.dataMin) && H(dl.dataMax) && (Do.dataMin = Math.min(dl.dataMin, Do.dataMin), Do.dataMax = Math.max(dl.dataMax, Do.dataMax));
              }
              Me.allExtremes = Do;
            }
            let { dataMin: Zc, dataMax: Jc, min: fp, max: vp } = z(Me.getExtremes(), Do || {}), Ap = Zc != null ? Zc : bt.min, yp = Jc != null ? Jc : bt.max, ed = bo - ho, xp = Me.categories ? 0 : Math.min(ed, yp - Ap), td = Ap - xp * (h(bt.min) ? 0 : bt.minPadding), od = yp + xp * (h(bt.max) ? 0 : bt.maxPadding), wp = Me.allowZoomOutside || fo === 1 || be !== "zoom" && fo > 1, ll = Math.min((we = bt.min) != null ? we : td, td, wp ? fp : td), cl = Math.max((ke = bt.max) != null ? ke : od, od, wp ? vp : od);
            (!Me.isOrdinal || Me.options.overscroll || fo !== 1 || ae) && (ho < ll && (ho = ll, fo >= 1 && (bo = ho + ed)), bo > cl && (bo = cl, fo >= 1 && (ho = bo - ed)), (ae || Me.series.length && (ho !== fp || bo !== vp) && ho >= ll && bo <= cl) && (le ? le[Me.coll].push({ axis: Me, min: ho, max: bo }) : (Me.isPanning = be !== "zoom", Me.isPanning && (Ae = !0), Me.setExtremes(ae ? void 0 : ho, ae ? void 0 : bo, !1, !1, { move: Qc, trigger: be, scale: fo }), !ae && (ho > ll || bo < cl) && be !== "mousewheel" && (fe = !0)), me = !0), se && (this[Ne ? "mouseDownX" : "mouseDownY"] = se[Ne ? "chartX" : "chartY"]));
          }
          return me && (le ? G(this, "selection", le, () => {
            delete ne.selection, ne.trigger = "zoom", this.transform(ne);
          }) : (!fe || Ae || this.resetZoomButton ? !fe && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(be === "zoom" && ((Oe = this.options.chart.animation) != null ? Oe : this.pointCount < 100)))), me;
        }
      }
      return z(ce.prototype, { callbacks: [], collectionsWithInit: { xAxis: [ce.prototype.addAxis, [!0]], yAxis: [ce.prototype.addAxis, [!1]], series: [ce.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), ce;
    }), i(e, "Extensions/ScrollablePlotArea.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { stop: D } = o, { composed: j } = n, { addEvent: I, createElement: B, css: R, defined: N, merge: x, pushUnique: T } = L;
      function y() {
        let A = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !A && (this.scrollablePlotArea = A = new u(this)), A == null || A.applyFixed();
      }
      function S() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class u {
        static compose(M, f, m) {
          T(j, this.compose) && (I(M, "afterInit", S), I(f, "afterSetChartSize", (C) => this.afterSetSize(C.target, C)), I(f, "render", y), I(m, "show", S));
        }
        static afterSetSize(M, f) {
          let m, C, F, { minWidth: _, minHeight: E } = M.options.chart.scrollablePlotArea || {}, { clipBox: v, plotBox: w, inverted: d, renderer: r } = M;
          if (!r.forExport && (_ ? (M.scrollablePixelsX = m = Math.max(0, _ - M.chartWidth), m && (M.scrollablePlotBox = x(M.plotBox), w.width = M.plotWidth += m, v[d ? "height" : "width"] += m, F = !0)) : E && (M.scrollablePixelsY = C = Math.max(0, E - M.chartHeight), N(C) && (M.scrollablePlotBox = x(M.plotBox), w.height = M.plotHeight += C, v[d ? "width" : "height"] += C, F = !1)), N(F) && !f.skipAxes)) for (let s of M.axes) s.horiz === F && (s.setAxisSize(), s.setAxisTranslation());
        }
        constructor(M) {
          var p, b;
          let f, m = M.options.chart, C = l.getRendererType(), F = m.scrollablePlotArea || {}, _ = this.moveFixedElements.bind(this), E = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          M.scrollablePixelsX && (E.overflowX = "auto"), M.scrollablePixelsY && (E.overflowY = "auto"), this.chart = M;
          let v = this.parentDiv = B("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, M.renderTo), w = this.scrollingContainer = B("div", { className: "highcharts-scrolling" }, E, v), d = this.innerContainer = B("div", { className: "highcharts-inner-container" }, void 0, w), r = this.fixedDiv = B("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((p = m.style) == null ? void 0 : p.zIndex) || 0) + 2, top: 0 }, void 0, !0), s = this.fixedRenderer = new C(r, M.chartWidth, M.chartHeight, m.style);
          this.mask = s.path().attr({ fill: m.backgroundColor || "#fff", "fill-opacity": (b = F.opacity) != null ? b : 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), w.parentNode.insertBefore(r, w), R(M.renderTo, { overflow: "visible" }), I(M, "afterShowResetZoom", _), I(M, "afterApplyDrilldown", _), I(M, "afterLayOutTitles", _), I(w, "scroll", () => {
            let { pointer: c, hoverPoint: h } = M;
            c && (delete c.chartPosition, h && (f = h), c.runPointActions(void 0, f, !0));
          }), d.appendChild(M.container);
        }
        applyFixed() {
          var H;
          let { chart: M, fixedRenderer: f, isDirty: m, scrollingContainer: C } = this, { axisOffset: F, chartWidth: _, chartHeight: E, container: v, plotHeight: w, plotLeft: d, plotTop: r, plotWidth: s, scrollablePixelsX: p = 0, scrollablePixelsY: b = 0 } = M, { scrollPositionX: c = 0, scrollPositionY: h = 0 } = M.options.chart.scrollablePlotArea || {}, g = _ + p, k = E + b;
          f.setSize(_, E), (m == null || m) && (this.isDirty = !1, this.moveFixedElements()), D(M.container), R(v, { width: `${g}px`, height: `${k}px` }), M.renderer.boxWrapper.attr({ width: g, height: k, viewBox: [0, 0, g, k].join(" ") }), (H = M.chartBackground) == null || H.attr({ width: g, height: k }), R(C, { width: `${_}px`, height: `${E}px` }), N(m) || (C.scrollLeft = p * c, C.scrollTop = b * h);
          let P = r - F[0] - 1, O = d - F[3] - 1, z = r + w + F[2] + 1, W = d + s + F[1] + 1, G = d + s - p, Y = r + w - b, U = [["M", 0, 0]];
          p ? U = [["M", 0, P], ["L", d - 1, P], ["L", d - 1, z], ["L", 0, z], ["Z"], ["M", G, P], ["L", _, P], ["L", _, z], ["L", G, z], ["Z"]] : b && (U = [["M", O, 0], ["L", O, r - 1], ["L", W, r - 1], ["L", W, 0], ["Z"], ["M", O, Y], ["L", O, E], ["L", W, E], ["L", W, Y], ["Z"]]), M.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: U });
        }
        moveFixedElements() {
          let M, { container: f, inverted: m, scrollablePixelsX: C, scrollablePixelsY: F } = this.chart, _ = this.fixedRenderer, E = u.fixedSelectors;
          for (let v of (C && !m ? M = ".highcharts-yaxis" : C && m || F && !m ? M = ".highcharts-xaxis" : F && m && (M = ".highcharts-yaxis"), M && E.push(`${M}:not(.highcharts-radial-axis)`, `${M}-labels:not(.highcharts-radial-axis-labels)`), E)) [].forEach.call(f.querySelectorAll(v), (w) => {
            (w.namespaceURI === _.SVG_NS ? _.box : _.box.parentNode).appendChild(w), w.style.pointerEvents = "auto";
          });
        }
      }
      return u.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], u;
    }), i(e, "Core/Axis/Stacking/StackItem.js", [e["Core/Templating.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { format: L } = o, { series: D } = n, { destroyObjectProperties: j, fireEvent: I, isNumber: B, pick: R } = l;
      return class {
        constructor(N, x, T, y, S) {
          let u = N.chart.inverted, A = N.reversed;
          this.axis = N;
          let M = this.isNegative = !!T != !!A;
          this.options = x = x || {}, this.x = y, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = S, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: x.align || (u ? M ? "left" : "right" : "center"), verticalAlign: x.verticalAlign || (u ? "middle" : M ? "bottom" : "top"), y: x.y, x: x.x }, this.textAlign = x.textAlign || (u ? M ? "right" : "left" : "center");
        }
        destroy() {
          j(this, this.axis);
        }
        render(N) {
          let x = this.axis.chart, T = this.options, y = T.format, S = y ? L(y, this, x) : T.formatter.call(this);
          if (this.label) this.label.attr({ text: S, visibility: "hidden" });
          else {
            this.label = x.renderer.label(S, null, void 0, T.shape, void 0, void 0, T.useHTML, !1, "stack-labels");
            let u = { r: T.borderRadius || 0, text: S, padding: R(T.padding, 5), visibility: "hidden" };
            x.styledMode || (u.fill = T.backgroundColor, u.stroke = T.borderColor, u["stroke-width"] = T.borderWidth, this.label.css(T.style || {})), this.label.attr(u), this.label.added || this.label.add(N);
          }
          this.label.labelrank = x.plotSizeY, I(this, "afterRender");
        }
        setOffset(N, x, T, y, S, u) {
          let { alignOptions: A, axis: M, label: f, options: m, textAlign: C } = this, F = M.chart, _ = this.getStackBox({ xOffset: N, width: x, boxBottom: T, boxTop: y, defaultX: S, xAxis: u }), { verticalAlign: E } = A;
          if (f && _) {
            let v = f.getBBox(void 0, 0), w = f.padding, d = R(m.overflow, "justify") === "justify", r;
            A.x = m.x || 0, A.y = m.y || 0;
            let { x: s, y: p } = this.adjustStackPosition({ labelBox: v, verticalAlign: E, textAlign: C });
            _.x -= s, _.y -= p, f.align(A, !1, _), (r = F.isInsidePlot(f.alignAttr.x + A.x + s, f.alignAttr.y + A.y + p)) || (d = !1), d && D.prototype.justifyDataLabel.call(M, f, A, f.alignAttr, v, _), f.attr({ x: f.alignAttr.x, y: f.alignAttr.y, rotation: m.rotation, rotationOriginX: v.width * { left: 0, center: 0.5, right: 1 }[m.textAlign || "center"], rotationOriginY: v.height / 2 }), R(!d && m.crop, !0) && (r = B(f.x) && B(f.y) && F.isInsidePlot(f.x - w + (f.width || 0), f.y) && F.isInsidePlot(f.x + w, f.y)), f[r ? "show" : "hide"]();
          }
          I(this, "afterSetOffset", { xOffset: N, width: x });
        }
        adjustStackPosition({ labelBox: N, verticalAlign: x, textAlign: T }) {
          let y = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, S = y[x], u = y[T];
          return { x: N.width / 2 + N.width / 2 * u, y: N.height / 2 * S };
        }
        getStackBox(N) {
          let x = this.axis, T = x.chart, { boxTop: y, defaultX: S, xOffset: u, width: A, boxBottom: M } = N, f = x.stacking.usePercentage ? 100 : R(y, this.total, 0), m = x.toPixels(f), C = N.xAxis || T.xAxis[0], F = R(S, C.translate(this.x)) + u, _ = Math.abs(m - x.toPixels(M || B(x.min) && x.logarithmic && x.logarithmic.lin2log(x.min) || 0)), E = T.inverted, v = this.isNegative;
          return E ? { x: (v ? m : m - _) - T.plotLeft, y: C.height - F - A + C.top - T.plotTop, width: _, height: A } : { x: F + C.transB - T.plotLeft, y: (v ? m - _ : m) - T.plotTop, width: A, height: _ };
        }
      };
    }), i(e, "Core/Axis/Stacking/StackingAxis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      var j;
      let { getDeferredAnimation: I } = o, { series: { prototype: B } } = l, { addEvent: R, correctFloat: N, defined: x, destroyObjectProperties: T, fireEvent: y, isArray: S, isNumber: u, objectEach: A, pick: M } = D;
      function f() {
        let r = this.inverted;
        this.axes.forEach((s) => {
          s.stacking && s.stacking.stacks && s.hasVisibleSeries && (s.stacking.oldStacks = s.stacking.stacks);
        }), this.series.forEach((s) => {
          let p = s.xAxis && s.xAxis.options || {};
          s.options.stacking && s.reserveSpace() && (s.stackKey = [s.type, M(s.options.stack, ""), r ? p.top : p.left, r ? p.height : p.width].join(","));
        });
      }
      function m() {
        var s;
        let r = this.stacking;
        if (r) {
          let p = r.stacks;
          A(p, (b, c) => {
            T(b), delete p[c];
          }), (s = r.stackTotalGroup) == null || s.destroy();
        }
      }
      function C() {
        this.stacking || (this.stacking = new d(this));
      }
      function F(r, s, p, b) {
        return !x(r) || r.x !== s || b && r.stackKey !== b ? r = { x: s, index: 0, key: b, stackKey: b } : r.index++, r.key = [p, s, r.index].join(","), r;
      }
      function _() {
        let r, s = this, p = s.yAxis, b = s.stackKey || "", c = p.stacking.stacks, h = s.processedXData, g = s.options.stacking, k = s[g + "Stacker"];
        k && [b, "-" + b].forEach((P) => {
          var Y;
          let O = h.length, z, W, G;
          for (; O--; ) z = h[O], r = s.getStackIndicator(r, z, s.index, P), W = (Y = c[P]) == null ? void 0 : Y[z], (G = W == null ? void 0 : W.points[r.key || ""]) && k.call(s, G, W, O);
        });
      }
      function E(r, s, p) {
        let b = s.total ? 100 / s.total : 0;
        r[0] = N(r[0] * b), r[1] = N(r[1] * b), this.stackedYData[p] = r[1];
      }
      function v(r) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? B.setStackedPoints.call(this, r, "group") : r.stacking.resetStacks());
      }
      function w(r, s) {
        var re, ce;
        let p, b, c, h, g, k, P, O, z, W = s || this.options.stacking;
        if (!W || !this.reserveSpace() || ({ group: "xAxis" }[W] || "yAxis") !== r.coll) return;
        let G = this.processedXData, Y = this.processedYData, U = [], H = Y.length, q = this.options, X = q.threshold || 0, $ = q.startFromThreshold ? X : 0, K = q.stack, V = s ? `${this.type},${W}` : this.stackKey || "", Q = "-" + V, Z = this.negStacks, ee = r.stacking, J = ee.stacks, ie = ee.oldStacks;
        for (ee.stacksTouched += 1, P = 0; P < H; P++) {
          O = G[P], z = Y[P], k = (p = this.getStackIndicator(p, O, this.index)).key || "", J[g = (b = Z && z < ($ ? 0 : X)) ? Q : V] || (J[g] = {}), J[g][O] || ((re = ie[g]) != null && re[O] ? (J[g][O] = ie[g][O], J[g][O].total = null) : J[g][O] = new L(r, r.options.stackLabels, !!b, O, K)), c = J[g][O], z !== null ? (c.points[k] = c.points[this.index] = [M(c.cumulative, $)], x(c.cumulative) || (c.base = k), c.touched = ee.stacksTouched, p.index > 0 && this.singleStacks === !1 && (c.points[k][0] = c.points[this.index + "," + O + ",0"][0])) : (delete c.points[k], delete c.points[this.index]);
          let he = c.total || 0;
          W === "percent" ? (h = b ? V : Q, he = Z && ((ce = J[h]) != null && ce[O]) ? (h = J[h][O]).total = Math.max(h.total || 0, he) + Math.abs(z) || 0 : N(he + (Math.abs(z) || 0))) : W === "group" ? (S(z) && (z = z[0]), z !== null && he++) : he = N(he + (z || 0)), W === "group" ? c.cumulative = (he || 1) - 1 : c.cumulative = N(M(c.cumulative, $) + (z || 0)), c.total = he, z !== null && (c.points[k].push(c.cumulative), U[P] = c.cumulative, c.hasValidPoints = !0);
        }
        W === "percent" && (ee.usePercentage = !0), W !== "group" && (this.stackedYData = U), ee.oldStacks = {};
      }
      class d {
        constructor(s) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = s;
        }
        buildStacks() {
          let s, p, b = this.axis, c = b.series, h = b.coll === "xAxis", g = b.options.reversedStacks, k = c.length;
          for (this.resetStacks(), this.usePercentage = !1, p = k; p--; ) s = c[g ? p : k - p - 1], h && s.setGroupedPoints(b), s.setStackedPoints(b);
          if (!h) for (p = 0; p < k; p++) c[p].modifyStacks();
          y(b, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, A(this.stacks, (s) => {
            A(s, (p) => {
              p.cumulative = p.total;
            });
          }));
        }
        resetStacks() {
          A(this.stacks, (s) => {
            A(s, (p, b) => {
              u(p.touched) && p.touched < this.stacksTouched ? (p.destroy(), delete s[b]) : (p.total = null, p.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          var k;
          let s = this.axis, p = s.chart, b = p.renderer, c = this.stacks, h = I(p, ((k = s.options.stackLabels) == null ? void 0 : k.animation) || !1), g = this.stackTotalGroup = this.stackTotalGroup || b.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          g.translate(p.plotLeft, p.plotTop), A(c, (P) => {
            A(P, (O) => {
              O.render(g);
            });
          }), g.animate({ opacity: 1 }, h);
        }
      }
      return (j || (j = {})).compose = function(r, s, p) {
        let b = s.prototype, c = p.prototype;
        b.getStacks || (R(r, "init", C), R(r, "destroy", m), b.getStacks = f, c.getStackIndicator = F, c.modifyStacks = _, c.percentStacker = E, c.setGroupedPoints = v, c.setStackedPoints = w);
      }, j;
    }), i(e, "Series/Line/LineSeries.js", [e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { defined: L, merge: D, isObject: j } = l;
      class I extends o {
        drawGraph() {
          let R = this.options, N = (this.gappedPath || this.getGraphPath).call(this), x = this.chart.styledMode;
          [this, ...this.zones].forEach((T, y) => {
            let S, u = T.graph, A = u ? "animate" : "attr", M = T.dashStyle || R.dashStyle;
            u ? (u.endX = this.preventGraphAnimation ? null : N.xMap, u.animate({ d: N })) : N.length && (T.graph = u = this.chart.renderer.path(N).addClass("highcharts-graph" + (y ? ` highcharts-zone-graph-${y - 1} ` : " ") + (y && T.className || "")).attr({ zIndex: 1 }).add(this.group)), u && !x && (S = { stroke: !y && R.lineColor || T.color || this.color || "#cccccc", "stroke-width": R.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, M ? S.dashstyle = M : R.linecap !== "square" && (S["stroke-linecap"] = S["stroke-linejoin"] = "round"), u[A](S).shadow(y < 2 && R.shadow && D({ filterUnits: "userSpaceOnUse" }, j(R.shadow) ? R.shadow : {}))), u && (u.startX = N.xMap, u.isArea = N.isArea);
          });
        }
        getGraphPath(R, N, x) {
          let T = this, y = T.options, S = [], u = [], A, M = y.step, f = (R = R || T.points).reversed;
          return f && R.reverse(), (M = { right: 1, center: 2 }[M] || M && 3) && f && (M = 4 - M), (R = this.getValidPoints(R, !1, !(y.connectNulls && !N && !x))).forEach(function(m, C) {
            let F, _ = m.plotX, E = m.plotY, v = R[C - 1], w = m.isNull || typeof E != "number";
            (m.leftCliff || v && v.rightCliff) && !x && (A = !0), w && !L(N) && C > 0 ? A = !y.connectNulls : w && !N ? A = !0 : (C === 0 || A ? F = [["M", m.plotX, m.plotY]] : T.getPointSpline ? F = [T.getPointSpline(R, m, C)] : M ? (F = M === 1 ? [["L", v.plotX, E]] : M === 2 ? [["L", (v.plotX + _) / 2, v.plotY], ["L", (v.plotX + _) / 2, E]] : [["L", _, v.plotY]]).push(["L", _, E]) : F = [["L", _, E]], u.push(m.x), M && (u.push(m.x), M === 2 && u.push(m.x)), S.push.apply(S, F), A = !1);
          }), S.xMap = u, T.graphPath = S, S;
        }
      }
      return I.defaultOptions = D(o.defaultOptions, { legendSymbol: "lineMarker" }), n.registerSeriesType("line", I), I;
    }), i(e, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), i(e, "Series/Area/AreaSeries.js", [e["Series/Area/AreaSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { seriesTypes: { line: L } } = n, { extend: D, merge: j, objectEach: I, pick: B } = l;
      class R extends L {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: x, options: T } = this;
          [this, ...this.zones].forEach((y, S) => {
            var m;
            let u = {}, A = y.fillColor || T.fillColor, M = y.area, f = M ? "animate" : "attr";
            M ? (M.endX = this.preventGraphAnimation ? null : x.xMap, M.animate({ d: x })) : (u.zIndex = 0, (M = y.area = this.chart.renderer.path(x).addClass("highcharts-area" + (S ? ` highcharts-zone-area-${S - 1} ` : " ") + (S && y.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (u.fill = A || y.color || this.color, u["fill-opacity"] = A ? 1 : (m = T.fillOpacity) != null ? m : 0.75, M.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), M[f](u), M.startX = x.xMap, M.shiftUnit = T.step ? 2 : 1;
          });
        }
        getGraphPath(x) {
          let T, y, S, u = L.prototype.getGraphPath, A = this.options, M = A.stacking, f = this.yAxis, m = [], C = [], F = this.index, _ = f.stacking.stacks[this.stackKey], E = A.threshold, v = Math.round(f.getThreshold(A.threshold)), w = B(A.connectNulls, M === "percent"), d = function(h, g, k) {
            let P = x[h], O = M && _[P.x].points[F], z = P[k + "Null"] || 0, W = P[k + "Cliff"] || 0, G, Y, U = !0;
            W || z ? (G = (z ? O[0] : O[1]) + W, Y = O[0] + W, U = !!z) : !M && x[g] && x[g].isNull && (G = Y = E), G !== void 0 && (C.push({ plotX: T, plotY: G === null ? v : f.getThreshold(G), isNull: U, isCliff: !0 }), m.push({ plotX: T, plotY: Y === null ? v : f.getThreshold(Y), doCurve: !1 }));
          };
          x = x || this.points, M && (x = this.getStackPoints(x));
          for (let h = 0, g = x.length; h < g; ++h) M || (x[h].leftCliff = x[h].rightCliff = x[h].leftNull = x[h].rightNull = void 0), y = x[h].isNull, T = B(x[h].rectPlotX, x[h].plotX), S = M ? B(x[h].yBottom, v) : v, y && !w || (w || d(h, h - 1, "left"), y && !M && w || (C.push(x[h]), m.push({ x: h, plotX: T, plotY: S })), w || d(h, h + 1, "right"));
          let r = u.call(this, C, !0, !0);
          m.reversed = !0;
          let s = u.call(this, m, !0, !0), p = s[0];
          p && p[0] === "M" && (s[0] = ["L", p[1], p[2]]);
          let b = r.concat(s);
          b.length && b.push(["Z"]);
          let c = u.call(this, C, !1, w);
          return this.chart.series.length > 1 && M && C.some((h) => h.isCliff) && (b.hasStackedCliffs = c.hasStackedCliffs = !0), b.xMap = r.xMap, this.areaPath = b, c;
        }
        getStackPoints(x) {
          let T = this, y = [], S = [], u = this.xAxis, A = this.yAxis, M = A.stacking.stacks[this.stackKey], f = {}, m = A.series, C = m.length, F = A.options.reversedStacks ? 1 : -1, _ = m.indexOf(T);
          if (x = x || this.points, this.options.stacking) {
            for (let v = 0; v < x.length; v++) x[v].leftNull = x[v].rightNull = void 0, f[x[v].x] = x[v];
            I(M, function(v, w) {
              v.total !== null && S.push(w);
            }), S.sort(function(v, w) {
              return v - w;
            });
            let E = m.map((v) => v.visible);
            S.forEach(function(v, w) {
              let d = 0, r, s;
              if (f[v] && !f[v].isNull) y.push(f[v]), [-1, 1].forEach(function(p) {
                let b = p === 1 ? "rightNull" : "leftNull", c = M[S[w + p]], h = 0;
                if (c) {
                  let g = _;
                  for (; g >= 0 && g < C; ) {
                    let k = m[g].index;
                    !(r = c.points[k]) && (k === T.index ? f[v][b] = !0 : E[g] && (s = M[v].points[k]) && (h -= s[1] - s[0])), g += F;
                  }
                }
                f[v][p === 1 ? "rightCliff" : "leftCliff"] = h;
              });
              else {
                let p = _;
                for (; p >= 0 && p < C; ) {
                  let b = m[p].index;
                  if (r = M[v].points[b]) {
                    d = r[1];
                    break;
                  }
                  p += F;
                }
                d = B(d, 0), d = A.translate(d, 0, 1, 0, 1), y.push({ isNull: !0, plotX: u.translate(v, 0, 0, 0, 1), x: v, plotY: d, yBottom: d });
              }
            });
          }
          return y;
        }
      }
      return R.defaultOptions = j(L.defaultOptions, o), D(R.prototype, { singleStacks: !1 }), n.registerSeriesType("area", R), R;
    }), i(e, "Series/Spline/SplineSeries.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { line: l } = o.seriesTypes, { merge: L, pick: D } = n;
      class j extends l {
        getPointSpline(B, R, N) {
          let x, T, y, S, u = R.plotX || 0, A = R.plotY || 0, M = B[N - 1], f = B[N + 1];
          function m(F) {
            return F && !F.isNull && F.doCurve !== !1 && !R.isCliff;
          }
          if (m(M) && m(f)) {
            let F = M.plotX || 0, _ = M.plotY || 0, E = f.plotX || 0, v = f.plotY || 0, w = 0;
            x = (1.5 * u + F) / 2.5, T = (1.5 * A + _) / 2.5, y = (1.5 * u + E) / 2.5, S = (1.5 * A + v) / 2.5, y !== x && (w = (S - T) * (y - u) / (y - x) + A - S), T += w, S += w, T > _ && T > A ? (T = Math.max(_, A), S = 2 * A - T) : T < _ && T < A && (T = Math.min(_, A), S = 2 * A - T), S > v && S > A ? (S = Math.max(v, A), T = 2 * A - S) : S < v && S < A && (S = Math.min(v, A), T = 2 * A - S), R.rightContX = y, R.rightContY = S, R.controlPoints = { low: [x, T], high: [y, S] };
          }
          let C = ["C", D(M.rightContX, M.plotX, 0), D(M.rightContY, M.plotY, 0), D(x, u, 0), D(T, A, 0), u, A];
          return M.rightContX = M.rightContY = void 0, C;
        }
      }
      return j.defaultOptions = L(l.defaultOptions), o.registerSeriesType("spline", j), j;
    }), i(e, "Series/AreaSpline/AreaSplineSeries.js", [e["Series/Spline/SplineSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { area: L, area: { prototype: D } } = n.seriesTypes, { extend: j, merge: I } = l;
      class B extends o {
      }
      return B.defaultOptions = I(o.defaultOptions, L.defaultOptions), j(B.prototype, { getGraphPath: D.getGraphPath, getStackPoints: D.getStackPoints, drawGraph: D.drawGraph }), n.registerSeriesType("areaspline", B), B;
    }), i(e, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), i(e, "Series/Column/ColumnSeries.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Series/Column/ColumnSeriesDefaults.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I) {
      let { animObject: B } = o, { parse: R } = n, { noop: N } = L, { clamp: x, crisp: T, defined: y, extend: S, fireEvent: u, isArray: A, isNumber: M, merge: f, pick: m, objectEach: C } = I;
      class F extends D {
        animate(E) {
          let v, w, d = this, r = this.yAxis, s = r.pos, p = r.reversed, b = d.options, { clipOffset: c, inverted: h } = this.chart, g = {}, k = h ? "translateX" : "translateY";
          E && c ? (g.scaleY = 1e-3, w = x(r.toPixels(b.threshold), s, s + r.len), h ? (w += p ? -Math.floor(c[0]) : Math.ceil(c[2]), g.translateX = w - r.len) : (w += p ? Math.ceil(c[0]) : -Math.floor(c[2]), g.translateY = w), d.clipBox && d.setClip(), d.group.attr(g)) : (v = Number(d.group.attr(k)), d.group.animate({ scaleY: 1 }, S(B(d.options.animation), { step: function(P, O) {
            d.group && (g[k] = v + O.pos * (s - v), d.group.attr(g));
          } })));
        }
        init(E, v) {
          super.init.apply(this, arguments);
          let w = this;
          (E = w.chart).hasRendered && E.series.forEach(function(d) {
            d.type === w.type && (d.isDirty = !0);
          });
        }
        getColumnMetrics() {
          var z, W;
          let E = this, v = E.options, w = E.xAxis, d = E.yAxis, r = w.options.reversedStacks, s = w.reversed && !r || !w.reversed && r, p = {}, b, c = 0;
          v.grouping === !1 ? c = 1 : E.chart.series.forEach(function(G) {
            let Y, U = G.yAxis, H = G.options;
            G.type === E.type && G.reserveSpace() && d.len === U.len && d.pos === U.pos && (H.stacking && H.stacking !== "group" ? (p[b = G.stackKey] === void 0 && (p[b] = c++), Y = p[b]) : H.grouping !== !1 && (Y = c++), G.columnIndex = Y);
          });
          let h = Math.min(Math.abs(w.transA) * (!((z = w.brokenAxis) != null && z.hasBreaks) && ((W = w.ordinal) == null ? void 0 : W.slope) || v.pointRange || w.closestPointRange || w.tickInterval || 1), w.len), g = h * v.groupPadding, k = (h - 2 * g) / (c || 1), P = Math.min(v.maxPointWidth || w.len, m(v.pointWidth, k * (1 - 2 * v.pointPadding))), O = (E.columnIndex || 0) + (s ? 1 : 0);
          return E.columnMetrics = { width: P, offset: (k - P) / 2 + (g + O * k - h / 2) * (s ? -1 : 1), paddedWidth: k, columnCount: c }, E.columnMetrics;
        }
        crispCol(E, v, w, d) {
          let r = this.borderWidth, s = this.chart.inverted;
          return d = T(v + d, r, s) - (v = T(v, r, s)), this.options.crisp && (w = T(E + w, r) - (E = T(E, r))), { x: E, y: v, width: w, height: d };
        }
        adjustForMissingColumns(E, v, w, d) {
          var r;
          if (!w.isNull && d.columnCount > 1) {
            let s = this.xAxis.series.filter((h) => h.visible).map((h) => h.index), p = 0, b = 0;
            C((r = this.xAxis.stacking) == null ? void 0 : r.stacks, (h) => {
              if (typeof w.x == "number") {
                let g = h[w.x.toString()];
                if (g && A(g.points[this.index])) {
                  let k = Object.keys(g.points).filter((P) => !P.match(",") && g.points[P] && g.points[P].length > 1).map(parseFloat).filter((P) => s.indexOf(P) !== -1).sort((P, O) => O - P);
                  p = k.indexOf(this.index), b = k.length;
                }
              }
            }), p = this.xAxis.reversed ? b - 1 - p : p;
            let c = (b - 1) * d.paddedWidth + v;
            E = (w.plotX || 0) + c / 2 - v - p * d.paddedWidth;
          }
          return E;
        }
        translate() {
          let E = this, v = E.chart, w = E.options, d = E.dense = E.closestPointRange * E.xAxis.transA < 2, r = E.borderWidth = m(w.borderWidth, d ? 0 : 1), s = E.xAxis, p = E.yAxis, b = w.threshold, c = m(w.minPointLength, 5), h = E.getColumnMetrics(), g = h.width, k = E.pointXOffset = h.offset, P = E.dataMin, O = E.dataMax, z = E.translatedThreshold = p.getThreshold(b), W = E.barW = Math.max(g, 1 + 2 * r);
          w.pointPadding && (W = Math.ceil(W)), D.prototype.translate.apply(E), E.points.forEach(function(G) {
            let Y = m(G.yBottom, z), U = 999 + Math.abs(Y), H = G.plotX || 0, q = x(G.plotY, -U, p.len + U), X, $ = Math.min(q, Y), K = Math.max(q, Y) - $, V = g, Q = H + k, Z = W;
            c && Math.abs(K) < c && (K = c, X = !p.reversed && !G.negative || p.reversed && G.negative, M(b) && M(O) && G.y === b && O <= b && (p.min || 0) < b && (P !== O || (p.max || 0) <= b) && (X = !X, G.negative = !G.negative), $ = Math.abs($ - z) > c ? Y - c : z - (X ? c : 0)), y(G.options.pointWidth) && (Q -= Math.round(((V = Z = Math.ceil(G.options.pointWidth)) - g) / 2)), w.centerInCategory && !w.stacking && (Q = E.adjustForMissingColumns(Q, V, G, h)), G.barX = Q, G.pointWidth = V, G.tooltipPos = v.inverted ? [x(p.len + p.pos - v.plotLeft - q, p.pos - v.plotLeft, p.len + p.pos - v.plotLeft), s.len + s.pos - v.plotTop - Q - Z / 2, K] : [s.left - v.plotLeft + Q + Z / 2, x(q + p.pos - v.plotTop, p.pos - v.plotTop, p.len + p.pos - v.plotTop), K], G.shapeType = E.pointClass.prototype.shapeType || "roundedRect", G.shapeArgs = E.crispCol(Q, G.isNull ? z : $, Z, G.isNull ? 0 : K);
          }), u(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(E, v) {
          let w = this.options, d = this.pointAttrToOptions || {}, r = d.stroke || "borderColor", s = d["stroke-width"] || "borderWidth", p, b, c, h = E && E.color || this.color, g = E && E[r] || w[r] || h, k = E && E.options.dashStyle || w.dashStyle, P = E && E[s] || w[s] || this[s] || 0, O = m(E && E.opacity, w.opacity, 1);
          E && this.zones.length && (b = E.getZone(), h = E.options.color || b && (b.color || E.nonZonedColor) || this.color, b && (g = b.borderColor || g, k = b.dashStyle || k, P = b.borderWidth || P)), v && E && (c = (p = f(w.states[v], E.options.states && E.options.states[v] || {})).brightness, h = p.color || c !== void 0 && R(h).brighten(p.brightness).get() || h, g = p[r] || g, P = p[s] || P, k = p.dashStyle || k, O = m(p.opacity, O));
          let z = { fill: h, stroke: g, "stroke-width": P, opacity: O };
          return k && (z.dashstyle = k), z;
        }
        drawPoints(E = this.points) {
          let v, w = this, d = this.chart, r = w.options, s = d.renderer, p = r.animationLimit || 250;
          E.forEach(function(b) {
            let c = b.plotY, h = b.graphic, g = !!h, k = h && d.pointCount < p ? "animate" : "attr";
            M(c) && b.y !== null ? (v = b.shapeArgs, h && b.hasNewShapeType() && (h = h.destroy()), w.enabledDataSorting && (b.startXPos = w.xAxis.reversed ? -(v && v.width || 0) : w.xAxis.width), !h && (b.graphic = h = s[b.shapeType](v).add(b.group || w.group), h && w.enabledDataSorting && d.hasRendered && d.pointCount < p && (h.attr({ x: b.startXPos }), g = !0, k = "animate")), h && g && h[k](f(v)), d.styledMode || h[k](w.pointAttribs(b, b.selected && "select")).shadow(b.allowShadow !== !1 && r.shadow), h && (h.addClass(b.getClassName(), !0), h.attr({ visibility: b.visible ? "inherit" : "hidden" }))) : h && (b.graphic = h.destroy());
          });
        }
        drawTracker(E = this.points) {
          let v, w = this, d = w.chart, r = d.pointer, s = function(p) {
            let b = r == null ? void 0 : r.getPointFromEvent(p);
            r && b && w.options.enableMouseTracking && (r.isDirectTouch = !0, b.onMouseOver(p));
          };
          E.forEach(function(p) {
            v = A(p.dataLabels) ? p.dataLabels : p.dataLabel ? [p.dataLabel] : [], p.graphic && (p.graphic.element.point = p), v.forEach(function(b) {
              (b.div || b.element).point = p;
            });
          }), w._hasTracking || (w.trackerGroups.forEach(function(p) {
            w[p] && (w[p].addClass("highcharts-tracker").on("mouseover", s).on("mouseout", function(b) {
              r == null || r.onTrackerMouseOut(b);
            }).on("touchstart", s), !d.styledMode && w.options.cursor && w[p].css({ cursor: w.options.cursor }));
          }), w._hasTracking = !0), u(this, "afterDrawTracker");
        }
        remove() {
          let E = this, v = E.chart;
          v.hasRendered && v.series.forEach(function(w) {
            w.type === E.type && (w.isDirty = !0);
          }), D.prototype.remove.apply(E, arguments);
        }
      }
      return F.defaultOptions = f(D.defaultOptions, l), S(F.prototype, { directTouch: !0, getSymbol: N, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), j.registerSeriesType("column", F), F;
    }), i(e, "Core/Series/DataLabel.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L;
      let { getDeferredAnimation: D } = o, { format: j } = n, { defined: I, extend: B, fireEvent: R, isArray: N, isString: x, merge: T, objectEach: y, pick: S, pInt: u, splat: A } = l;
      return function(M) {
        function f() {
          return w(this).some((r) => r == null ? void 0 : r.enabled);
        }
        function m(r, s, p, b, c) {
          var q;
          let { chart: h, enabledDataSorting: g } = this, k = this.isCartesian && h.inverted, P = r.plotX, O = r.plotY, z = p.rotation || 0, W = I(P) && I(O) && h.isInsidePlot(P, Math.round(O), { inverted: k, paneCoordinates: !0, series: this }), G = z === 0 && S(p.overflow, g ? "none" : "justify") === "justify", Y = this.visible && r.visible !== !1 && I(P) && (r.series.forceDL || g && !G || W || S(p.inside, !!this.options.stacking) && b && h.isInsidePlot(P, k ? b.x + 1 : b.y + b.height - 1, { inverted: k, paneCoordinates: !0, series: this })), U = r.pos();
          if (Y && U) {
            var H;
            let X = s.getBBox(), $ = s.getBBox(void 0, 0), K = { right: 1, center: 0.5 }[p.align || 0] || 0, V = { bottom: 1, middle: 0.5 }[p.verticalAlign || 0] || 0;
            if (b = B({ x: U[0], y: Math.round(U[1]), width: 0, height: 0 }, b || {}), p.alignTo === "plotEdges" && this.isCartesian && (b[k ? "x" : "y"] = 0, b[k ? "width" : "height"] = ((q = this.yAxis) == null ? void 0 : q.len) || 0), B(p, { width: X.width, height: X.height }), H = b, g && this.xAxis && !G && this.setDataLabelStartPos(r, s, c, W, H), s.align(T(p, { width: $.width, height: $.height }), !1, b, !1), s.alignAttr.x += K * ($.width - X.width), s.alignAttr.y += V * ($.height - X.height), s[s.placed ? "animate" : "attr"]({ x: s.alignAttr.x + (X.width - $.width) / 2, y: s.alignAttr.y + (X.height - $.height) / 2, rotationOriginX: (s.width || 0) / 2, rotationOriginY: (s.height || 0) / 2 }), G && b.height >= 0) this.justifyDataLabel(s, p, s.alignAttr, X, b, c);
            else if (S(p.crop, !0)) {
              let { x: Q, y: Z } = s.alignAttr;
              Y = h.isInsidePlot(Q, Z, { paneCoordinates: !0, series: this }) && h.isInsidePlot(Q + X.width - 1, Z + X.height - 1, { paneCoordinates: !0, series: this });
            }
            p.shape && !z && s[c ? "attr" : "animate"]({ anchorX: U[0], anchorY: U[1] });
          }
          c && g && (s.placed = !1), Y || g && !G ? (s.show(), s.placed = !0) : (s.hide(), s.placed = !1);
        }
        function C() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function F(r) {
          let s = this.hasRendered || 0, p = this.initDataLabelsGroup().attr({ opacity: +s });
          return !s && p && (this.visible && p.show(), this.options.animation ? p.animate({ opacity: 1 }, r) : p.attr({ opacity: 1 })), p;
        }
        function _(r) {
          var Y;
          let s;
          r = r || this.points;
          let p = this, b = p.chart, c = p.options, h = b.renderer, { backgroundColor: g, plotBackgroundColor: k } = b.options.chart, P = h.getContrast(x(k) && k || x(g) && g || "#000000"), O = w(p), { animation: z, defer: W } = O[0], G = W ? D(b, z, p) : { defer: 0, duration: 0 };
          R(this, "drawDataLabels"), (Y = p.hasDataLabels) != null && Y.call(p) && (s = this.initDataLabels(G), r.forEach((U) => {
            var X, $;
            let H = U.dataLabels || [];
            A(v(O, U.dlOptions || ((X = U.options) == null ? void 0 : X.dataLabels))).forEach((K, V) => {
              let Q = K.enabled && (U.visible || U.dataLabelOnHidden) && (!U.isNull || U.dataLabelOnNull) && function(le, de) {
                let be = de.filter;
                if (be) {
                  let ge = be.operator, me = le[be.property], fe = be.value;
                  return ge === ">" && me > fe || ge === "<" && me < fe || ge === ">=" && me >= fe || ge === "<=" && me <= fe || ge === "==" && me == fe || ge === "===" && me === fe || ge === "!=" && me != fe || ge === "!==" && me !== fe;
                }
                return !0;
              }(U, K), { backgroundColor: Z, borderColor: ee, distance: J, style: ie = {} } = K, re, ce, he, ne, oe = {}, se = H[V], te = !se, ae;
              Q && (ce = S(K[U.formatPrefix + "Format"], K.format), re = U.getLabelConfig(), he = I(ce) ? j(ce, re, b) : (K[U.formatPrefix + "Formatter"] || K.formatter).call(re, K), ne = K.rotation, !b.styledMode && (ie.color = S(K.color, ie.color, x(p.color) ? p.color : void 0, "#000000"), ie.color === "contrast" ? (Z !== "none" && (ae = Z), U.contrastColor = h.getContrast(ae !== "auto" && ae || U.color || p.color), ie.color = ae || !I(J) && K.inside || 0 > u(J || 0) || c.stacking ? U.contrastColor : P) : delete U.contrastColor, c.cursor && (ie.cursor = c.cursor)), oe = { r: K.borderRadius || 0, rotation: ne, padding: K.padding, zIndex: 1 }, b.styledMode || (oe.fill = Z === "auto" ? U.color : Z, oe.stroke = ee === "auto" ? U.color : ee, oe["stroke-width"] = K.borderWidth), y(oe, (le, de) => {
                le === void 0 && delete oe[de];
              })), !se || Q && I(he) && !!se.div == !!K.useHTML && (se.rotation && K.rotation || se.rotation === K.rotation) || (se = void 0, te = !0), Q && I(he) && (se ? oe.text = he : (se = h.label(he, 0, 0, K.shape, void 0, void 0, K.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + U.colorIndex + " " + (K.className || "") + (K.useHTML ? " highcharts-tracker" : "")), se && (se.options = K, se.attr(oe), b.styledMode ? ie.width && se.css({ width: ie.width, textOverflow: ie.textOverflow }) : se.css(ie).shadow(K.shadow), R(se, "beforeAddingDataLabel", { labelOptions: K, point: U }), se.added || se.add(s), p.alignDataLabel(U, se, K, void 0, te), se.isActive = !0, H[V] && H[V] !== se && H[V].destroy(), H[V] = se));
            });
            let q = H.length;
            for (; q--; ) H[q] && H[q].isActive ? H[q].isActive = !1 : (($ = H[q]) == null || $.destroy(), H.splice(q, 1));
            U.dataLabel = H[0], U.dataLabels = H;
          })), R(this, "afterDrawDataLabels");
        }
        function E(r, s, p, b, c, h) {
          let g = this.chart, k = s.align, P = s.verticalAlign, O = r.box ? 0 : r.padding || 0, z = g.inverted ? this.yAxis : this.xAxis, W = z ? z.left - g.plotLeft : 0, G = g.inverted ? this.xAxis : this.yAxis, Y = G ? G.top - g.plotTop : 0, { x: U = 0, y: H = 0 } = s, q, X;
          return (q = (p.x || 0) + O + W) < 0 && (k === "right" && U >= 0 ? (s.align = "left", s.inside = !0) : U -= q, X = !0), (q = (p.x || 0) + b.width - O + W) > g.plotWidth && (k === "left" && U <= 0 ? (s.align = "right", s.inside = !0) : U += g.plotWidth - q, X = !0), (q = p.y + O + Y) < 0 && (P === "bottom" && H >= 0 ? (s.verticalAlign = "top", s.inside = !0) : H -= q, X = !0), (q = (p.y || 0) + b.height - O + Y) > g.plotHeight && (P === "top" && H <= 0 ? (s.verticalAlign = "bottom", s.inside = !0) : H += g.plotHeight - q, X = !0), X && (s.x = U, s.y = H, r.placed = !h, r.align(s, void 0, c)), X;
        }
        function v(r, s) {
          let p = [], b;
          if (N(r) && !N(s)) p = r.map(function(c) {
            return T(c, s);
          });
          else if (N(s) && !N(r)) p = s.map(function(c) {
            return T(r, c);
          });
          else if (N(r) || N(s)) {
            if (N(r) && N(s)) for (b = Math.max(r.length, s.length); b--; ) p[b] = T(r[b], s[b]);
          } else p = T(r, s);
          return p;
        }
        function w(r) {
          var p, b;
          let s = r.chart.options.plotOptions;
          return A(v(v((p = s == null ? void 0 : s.series) == null ? void 0 : p.dataLabels, (b = s == null ? void 0 : s[r.type]) == null ? void 0 : b.dataLabels), r.options.dataLabels));
        }
        function d(r, s, p, b, c) {
          let h = this.chart, g = h.inverted, k = this.xAxis, P = k.reversed, O = ((g ? s.height : s.width) || 0) / 2, z = r.pointWidth, W = z ? z / 2 : 0;
          s.startXPos = g ? c.x : P ? -O - W : k.width - O + W, s.startYPos = g ? P ? this.yAxis.height - O + W : -O - W : c.y, b ? s.visibility === "hidden" && (s.show(), s.attr({ opacity: 0 }).animate({ opacity: 1 })) : s.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, s.hide), h.hasRendered && (p && s.attr({ x: s.startXPos, y: s.startYPos }), s.placed = !0);
        }
        M.compose = function(r) {
          let s = r.prototype;
          s.initDataLabels || (s.initDataLabels = F, s.initDataLabelsGroup = C, s.alignDataLabel = m, s.drawDataLabels = _, s.justifyDataLabel = E, s.setDataLabelStartPos = d, s.hasDataLabels = f);
        };
      }(L || (L = {})), L;
    }), i(e, "Series/Column/ColumnDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { composed: j } = n, { series: I } = l, { merge: B, pick: R, pushUnique: N } = L;
      return function(x) {
        function T(y, S, u, A, M) {
          let f = this.chart.inverted, m = y.series, C = (m.xAxis ? m.xAxis.len : this.chart.plotSizeX) || 0, F = (m.yAxis ? m.yAxis.len : this.chart.plotSizeY) || 0, _ = y.dlBox || y.shapeArgs, E = R(y.below, y.plotY > R(this.translatedThreshold, F)), v = R(u.inside, !!this.options.stacking);
          if (_) {
            if (A = B(_), !(u.overflow === "allow" && u.crop === !1)) {
              A.y < 0 && (A.height += A.y, A.y = 0);
              let w = A.y + A.height - F;
              w > 0 && w < A.height - 1 && (A.height -= w);
            }
            f && (A = { x: F - A.y - A.height, y: C - A.x - A.width, width: A.height, height: A.width }), v || (f ? (A.x += E ? 0 : A.width, A.width = 0) : (A.y += E ? A.height : 0, A.height = 0));
          }
          u.align = R(u.align, !f || v ? "center" : E ? "right" : "left"), u.verticalAlign = R(u.verticalAlign, f || v ? "middle" : E ? "top" : "bottom"), I.prototype.alignDataLabel.call(this, y, S, u, A, M), u.inside && y.contrastColor && S.css({ color: y.contrastColor });
        }
        x.compose = function(y) {
          o.compose(I), N(j, "ColumnDataLabel") && (y.prototype.alignDataLabel = T);
        };
      }(D || (D = {})), D;
    }), i(e, "Series/Bar/BarSeries.js", [e["Series/Column/ColumnSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { extend: L, merge: D } = l;
      class j extends o {
      }
      return j.defaultOptions = D(o.defaultOptions, {}), L(j.prototype, { inverted: !0 }), n.registerSeriesType("bar", j), j;
    }), i(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), i(e, "Series/Scatter/ScatterSeries.js", [e["Series/Scatter/ScatterSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { column: L, line: D } = n.seriesTypes, { addEvent: j, extend: I, merge: B } = l;
      class R extends D {
        applyJitter() {
          let x = this, T = this.options.jitter, y = this.points.length;
          T && this.points.forEach(function(S, u) {
            ["x", "y"].forEach(function(A, M) {
              if (T[A] && !S.isNull) {
                let f = `plot${A.toUpperCase()}`, m = x[`${A}Axis`], C = T[A] * m.transA;
                if (m && !m.logarithmic) {
                  let F = Math.max(0, (S[f] || 0) - C), _ = Math.min(m.len, (S[f] || 0) + C);
                  S[f] = F + (_ - F) * function(E) {
                    let v = 1e4 * Math.sin(E);
                    return v - Math.floor(v);
                  }(u + M * y), A === "x" && (S.clientX = S.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return R.defaultOptions = B(D.defaultOptions, o), I(R.prototype, { drawTracker: L.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), j(R, "afterTranslate", function() {
        this.applyJitter();
      }), n.registerSeriesType("scatter", R), R;
    }), i(e, "Series/CenteredUtilities.js", [e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L, D;
      let { deg2rad: j } = o, { fireEvent: I, isNumber: B, pick: R, relativeLength: N } = l;
      return (D = L || (L = {})).getCenter = function() {
        let x = this.options, T = this.chart, y = 2 * (x.slicedOffset || 0), S = T.plotWidth - 2 * y, u = T.plotHeight - 2 * y, A = x.center, M = Math.min(S, u), f = x.thickness, m, C = x.size, F = x.innerSize || 0, _, E;
        typeof C == "string" && (C = parseFloat(C)), typeof F == "string" && (F = parseFloat(F));
        let v = [R(A[0], "50%"), R(A[1], "50%"), R(C && C < 0 ? void 0 : x.size, "100%"), R(F && F < 0 ? void 0 : x.innerSize || 0, "0%")];
        for (!T.angular || this instanceof n || (v[3] = 0), _ = 0; _ < 4; ++_) E = v[_], m = _ < 2 || _ === 2 && /%$/.test(E), v[_] = N(E, [S, u, M, v[2]][_]) + (m ? y : 0);
        return v[3] > v[2] && (v[3] = v[2]), B(f) && 2 * f < v[2] && f > 0 && (v[3] = v[2] - 2 * f), I(this, "afterGetCenter", { positions: v }), v;
      }, D.getStartAndEndRadians = function(x, T) {
        let y = B(x) ? x : 0, S = B(T) && T > y && T - y < 360 ? T : y + 360;
        return { start: j * (y + -90), end: j * (S + -90) };
      }, L;
    }), i(e, "Series/Pie/PiePoint.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { setAnimation: L } = o, { addEvent: D, defined: j, extend: I, isNumber: B, pick: R, relativeLength: N } = l;
      class x extends n {
        getConnectorPath(y) {
          let S = y.dataLabelPosition, u = y.options || {}, A = u.connectorShape, M = this.connectorShapes[A] || A;
          return S && M.call(this, { ...S.computed, alignment: S.alignment }, S.connectorPosition, u) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(y) {
          let S = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(S.x, S.y, S.r + y, S.r + y, { innerR: S.r - 1, start: S.start, end: S.end, borderRadius: S.borderRadius });
        }
        constructor(y, S, u) {
          var M;
          super(y, S, u), this.half = 0, (M = this.name) != null || (this.name = "Slice");
          let A = (f) => {
            this.slice(f.type === "select");
          };
          D(this, "select", A), D(this, "unselect", A);
        }
        isValid() {
          return B(this.y) && this.y >= 0;
        }
        setVisible(y, S = !0) {
          y !== this.visible && this.update({ visible: y != null ? y : !this.visible }, S, void 0, !1);
        }
        slice(y, S, u) {
          let A = this.series;
          L(u, A.chart), S = R(S, !0), this.sliced = this.options.sliced = y = j(y) ? y : !this.sliced, A.options.data[A.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return I(x.prototype, { connectorShapes: { fixedOffset: function(T, y, S) {
        let u = y.breakAt, A = y.touchingSliceAt, M = S.softConnector ? ["C", T.x + (T.alignment === "left" ? -5 : 5), T.y, 2 * u.x - A.x, 2 * u.y - A.y, u.x, u.y] : ["L", u.x, u.y];
        return [["M", T.x, T.y], M, ["L", A.x, A.y]];
      }, straight: function(T, y) {
        let S = y.touchingSliceAt;
        return [["M", T.x, T.y], ["L", S.x, S.y]];
      }, crookedLine: function(T, y, S) {
        let { breakAt: u, touchingSliceAt: A } = y, { series: M } = this, [f, m, C] = M.center, F = C / 2, { plotLeft: _, plotWidth: E } = M.chart, v = T.alignment === "left", { x: w, y: d } = T, r = u.x;
        if (S.crookDistance) {
          let p = N(S.crookDistance, 1);
          r = v ? f + F + (E + _ - f - F) * (1 - p) : _ + (f - F) * p;
        } else r = f + (m - d) * Math.tan((this.angle || 0) - Math.PI / 2);
        let s = [["M", w, d]];
        return (v ? r <= w && r >= u.x : r >= w && r <= u.x) && s.push(["L", r, d]), s.push(["L", u.x, u.y], ["L", A.x, A.y]), s;
      } } }), x;
    }), i(e, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), i(e, "Series/Pie/PieSeries.js", [e["Series/CenteredUtilities.js"], e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Series/Pie/PiePoint.js"], e["Series/Pie/PieSeriesDefaults.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R) {
      let { getStartAndEndRadians: N } = o, { noop: x } = l, { clamp: T, extend: y, fireEvent: S, merge: u, pick: A } = R;
      class M extends j {
        animate(m) {
          let C = this, F = C.points, _ = C.startAngleRad;
          m || F.forEach(function(E) {
            let v = E.graphic, w = E.shapeArgs;
            v && w && (v.attr({ r: A(E.startR, C.center && C.center[3] / 2), start: _, end: _ }), v.animate({ r: w.r, start: w.start, end: w.end }, C.options.animation));
          });
        }
        drawEmpty() {
          let m, C, F = this.startAngleRad, _ = this.endAngleRad, E = this.options;
          this.total === 0 && this.center ? (m = this.center[0], C = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(m, C, this.center[1] / 2, 0, F, _).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: B.arc(m, C, this.center[2] / 2, 0, { start: F, end: _, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": E.borderWidth, fill: E.fillColor || "none", stroke: E.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let m = this.chart.renderer;
          this.points.forEach(function(C) {
            C.graphic && C.hasNewShapeType() && (C.graphic = C.graphic.destroy()), C.graphic || (C.graphic = m[C.shapeType](C.shapeArgs).add(C.series.group), C.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(m, C, F, _) {
          let E = this.center, v = this.radii ? this.radii[F.index] || 0 : E[2] / 2, w = _.dataLabelPosition, d = (w == null ? void 0 : w.distance) || 0, r = Math.asin(T((m - E[1]) / (v + d), -1, 1));
          return E[0] + Math.cos(r) * (v + d) * (C ? -1 : 1) + (d > 0 ? (C ? -1 : 1) * (_.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let m, C, F, _, E = this, v = E.chart;
          this.drawEmpty(), E.group && !v.styledMode && E.group.shadow(E.options.shadow), E.points.forEach(function(w) {
            let d = {};
            C = w.graphic, !w.isNull && C ? (_ = w.shapeArgs, m = w.getTranslate(), v.styledMode || (F = E.pointAttribs(w, w.selected && "select")), w.delayedRendering ? (C.setRadialReference(E.center).attr(_).attr(m), v.styledMode || C.attr(F).attr({ "stroke-linejoin": "round" }), w.delayedRendering = !1) : (C.setRadialReference(E.center), v.styledMode || u(!0, d, F), u(!0, d, _, m), C.animate(d)), C.attr({ visibility: w.visible ? "inherit" : "hidden" }), C.addClass(w.getClassName(), !0)) : C && (w.graphic = C.destroy());
          });
        }
        sortByAngle(m, C) {
          m.sort(function(F, _) {
            return F.angle !== void 0 && (_.angle - F.angle) * C;
          });
        }
        translate(m) {
          S(this, "translate"), this.generatePoints();
          let C = this.options, F = C.slicedOffset, _ = N(C.startAngle, C.endAngle), E = this.startAngleRad = _.start, v = (this.endAngleRad = _.end) - E, w = this.points, d = C.ignoreHiddenPoint, r = w.length, s, p, b, c, h, g, k, P = 0;
          for (m || (this.center = m = this.getCenter()), g = 0; g < r; g++) {
            k = w[g], s = E + P * v, k.isValid() && (!d || k.visible) && (P += k.percentage / 100), p = E + P * v;
            let O = { x: m[0], y: m[1], r: m[2] / 2, innerR: m[3] / 2, start: Math.round(1e3 * s) / 1e3, end: Math.round(1e3 * p) / 1e3 };
            k.shapeType = "arc", k.shapeArgs = O, (b = (p + s) / 2) > 1.5 * Math.PI ? b -= 2 * Math.PI : b < -Math.PI / 2 && (b += 2 * Math.PI), k.slicedTranslation = { translateX: Math.round(Math.cos(b) * F), translateY: Math.round(Math.sin(b) * F) }, c = Math.cos(b) * m[2] / 2, h = Math.sin(b) * m[2] / 2, k.tooltipPos = [m[0] + 0.7 * c, m[1] + 0.7 * h], k.half = b < -Math.PI / 2 || b > Math.PI / 2 ? 1 : 0, k.angle = b;
          }
          S(this, "afterTranslate");
        }
        updateTotals() {
          let m = this.points, C = m.length, F = this.options.ignoreHiddenPoint, _, E, v = 0;
          for (_ = 0; _ < C; _++) (E = m[_]).isValid() && (!F || E.visible) && (v += E.y);
          for (_ = 0, this.total = v; _ < C; _++) (E = m[_]).percentage = v > 0 && (E.visible || !F) ? E.y / v * 100 : 0, E.total = v;
        }
      }
      return M.defaultOptions = u(j.defaultOptions, D), y(M.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: n.prototype.drawTracker, getCenter: o.getCenter, getSymbol: x, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: n.prototype.pointAttribs, pointClass: L, requireSorting: !1, searchPoint: x, trackerGroups: ["group", "dataLabelsGroup"] }), I.registerSeriesType("pie", M), M;
    }), i(e, "Series/Pie/PieDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      var j;
      let { composed: I, noop: B } = n, { distribute: R } = l, { series: N } = L, { arrayMax: x, clamp: T, defined: y, pick: S, pushUnique: u, relativeLength: A } = D;
      return function(M) {
        let f = { radialDistributionY: function(E, v) {
          var w;
          return (((w = v.dataLabelPosition) == null ? void 0 : w.top) || 0) + E.distributeBox.pos;
        }, radialDistributionX: function(E, v, w, d, r) {
          let s = r.dataLabelPosition;
          return E.getX(w < ((s == null ? void 0 : s.top) || 0) + 2 || w > ((s == null ? void 0 : s.bottom) || 0) - 2 ? d : w, v.half, v, r);
        }, justify: function(E, v, w, d) {
          var r;
          return d[0] + (E.half ? -1 : 1) * (w + (((r = v.dataLabelPosition) == null ? void 0 : r.distance) || 0));
        }, alignToPlotEdges: function(E, v, w, d) {
          let r = E.getBBox().width;
          return v ? r + d : w - r - d;
        }, alignToConnectors: function(E, v, w, d) {
          let r = 0, s;
          return E.forEach(function(p) {
            (s = p.dataLabel.getBBox().width) > r && (r = s);
          }), v ? r + d : w - r - d;
        } };
        function m(E, v) {
          let { center: w, options: d } = this, r = w[2] / 2, s = E.angle || 0, p = Math.cos(s), b = Math.sin(s), c = w[0] + p * r, h = w[1] + b * r, g = Math.min((d.slicedOffset || 0) + (d.borderWidth || 0), v / 5);
          return { natural: { x: c + p * v, y: h + b * v }, computed: {}, alignment: v < 0 ? "center" : E.half ? "right" : "left", connectorPosition: { breakAt: { x: c + p * g, y: h + b * g }, touchingSliceAt: { x: c, y: h } }, distance: v };
        }
        function C() {
          var Y;
          let E = this, v = E.points, w = E.chart, d = w.plotWidth, r = w.plotHeight, s = w.plotLeft, p = Math.round(w.chartWidth / 3), b = E.center, c = b[2] / 2, h = b[1], g = [[], []], k = [0, 0, 0, 0], P = E.dataLabelPositioners, O, z, W, G = 0;
          E.visible && ((Y = E.hasDataLabels) != null && Y.call(E)) && (v.forEach((U) => {
            (U.dataLabels || []).forEach((H) => {
              H.shortened && (H.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), H.shortened = !1);
            });
          }), N.prototype.drawDataLabels.apply(E), v.forEach((U) => {
            (U.dataLabels || []).forEach((H, q) => {
              var V;
              let X = b[2] / 2, $ = H.options, K = A(($ == null ? void 0 : $.distance) || 0, X);
              q === 0 && g[U.half].push(U), !y((V = $ == null ? void 0 : $.style) == null ? void 0 : V.width) && H.getBBox().width > p && (H.css({ width: Math.round(0.7 * p) + "px" }), H.shortened = !0), H.dataLabelPosition = this.getDataLabelPosition(U, K), G = Math.max(G, K);
            });
          }), g.forEach((U, H) => {
            let q = U.length, X = [], $, K, V = 0, Q;
            q && (E.sortByAngle(U, H - 0.5), G > 0 && ($ = Math.max(0, h - c - G), K = Math.min(h + c + G, w.plotHeight), U.forEach((Z) => {
              (Z.dataLabels || []).forEach((ee) => {
                var ie;
                let J = ee.dataLabelPosition;
                J && J.distance > 0 && (J.top = Math.max(0, h - c - J.distance), J.bottom = Math.min(h + c + J.distance, w.plotHeight), V = ee.getBBox().height || 21, ee.lineHeight = w.renderer.fontMetrics(ee.text || ee).h + 2 * ee.padding, Z.distributeBox = { target: (((ie = ee.dataLabelPosition) == null ? void 0 : ie.natural.y) || 0) - J.top + ee.lineHeight / 2, size: V, rank: Z.y }, X.push(Z.distributeBox));
              });
            }), R(X, Q = K + V - $, Q / 5)), U.forEach((Z) => {
              (Z.dataLabels || []).forEach((ee) => {
                let J = ee.options || {}, ie = Z.distributeBox, re = ee.dataLabelPosition, ce = (re == null ? void 0 : re.natural.y) || 0, he = J.connectorPadding || 0, ne = ee.lineHeight || 21, oe = (ne - ee.getBBox().height) / 2, se = 0, te = ce, ae = "inherit";
                if (re) {
                  if (X && y(ie) && re.distance > 0 && (ie.pos === void 0 ? ae = "hidden" : (W = ie.size, te = P.radialDistributionY(Z, ee))), J.justify) se = P.justify(Z, ee, c, b);
                  else switch (J.alignTo) {
                    case "connectors":
                      se = P.alignToConnectors(U, H, d, s);
                      break;
                    case "plotEdges":
                      se = P.alignToPlotEdges(ee, H, d, s);
                      break;
                    default:
                      se = P.radialDistributionX(E, Z, te - oe, ce, ee);
                  }
                  if (re.attribs = { visibility: ae, align: re.alignment }, re.posAttribs = { x: se + (J.x || 0) + ({ left: he, right: -he }[re.alignment] || 0), y: te + (J.y || 0) - ne / 2 }, re.computed.x = se, re.computed.y = te - oe, S(J.crop, !0)) {
                    let le;
                    se - (z = ee.getBBox().width) < he && H === 1 ? (le = Math.round(z - se + he), k[3] = Math.max(le, k[3])) : se + z > d - he && H === 0 && (le = Math.round(se + z - d + he), k[1] = Math.max(le, k[1])), te - W / 2 < 0 ? k[0] = Math.max(Math.round(-te + W / 2), k[0]) : te + W / 2 > r && (k[2] = Math.max(Math.round(te + W / 2 - r), k[2])), re.sideOverflow = le;
                  }
                }
              });
            }));
          }), (x(k) === 0 || this.verifyDataLabelOverflow(k)) && (this.placeDataLabels(), this.points.forEach((U) => {
            (U.dataLabels || []).forEach((H) => {
              var K;
              let { connectorColor: q, connectorWidth: X = 1 } = H.options || {}, $ = H.dataLabelPosition;
              if (X) {
                let V;
                O = H.connector, $ && $.distance > 0 ? (V = !O, O || (H.connector = O = w.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + U.colorIndex + (U.className ? " " + U.className : "")).add(E.dataLabelsGroup)), w.styledMode || O.attr({ "stroke-width": X, stroke: q || U.color || "#666666" }), O[V ? "attr" : "animate"]({ d: U.getConnectorPath(H) }), O.attr({ visibility: (K = $.attribs) == null ? void 0 : K.visibility })) : O && (H.connector = O.destroy());
              }
            });
          })));
        }
        function F() {
          this.points.forEach((E) => {
            (E.dataLabels || []).forEach((v) => {
              var d;
              let w = v.dataLabelPosition;
              w ? (w.sideOverflow && (v.css({ width: Math.max(v.getBBox().width - w.sideOverflow, 0) + "px", textOverflow: (((d = v.options) == null ? void 0 : d.style) || {}).textOverflow || "ellipsis" }), v.shortened = !0), v.attr(w.attribs), v[v.moved ? "animate" : "attr"](w.posAttribs), v.moved = !0) : v && v.attr({ y: -9999 });
            }), delete E.distributeBox;
          }, this);
        }
        function _(E) {
          let v = this.center, w = this.options, d = w.center, r = w.minSize || 80, s = r, p = w.size !== null;
          return !p && (d[0] !== null ? s = Math.max(v[2] - Math.max(E[1], E[3]), r) : (s = Math.max(v[2] - E[1] - E[3], r), v[0] += (E[3] - E[1]) / 2), d[1] !== null ? s = T(s, r, v[2] - Math.max(E[0], E[2])) : (s = T(s, r, v[2] - E[0] - E[2]), v[1] += (E[0] - E[2]) / 2), s < v[2] ? (v[2] = s, v[3] = Math.min(w.thickness ? Math.max(0, s - 2 * w.thickness) : Math.max(0, A(w.innerSize || 0, s)), s), this.translate(v), this.drawDataLabels && this.drawDataLabels()) : p = !0), p;
        }
        M.compose = function(E) {
          if (o.compose(N), u(I, "PieDataLabel")) {
            let v = E.prototype;
            v.dataLabelPositioners = f, v.alignDataLabel = B, v.drawDataLabels = C, v.getDataLabelPosition = m, v.placeDataLabels = F, v.verifyDataLabelOverflow = _;
          }
        };
      }(j || (j = {})), j;
    }), i(e, "Core/Geometry/GeometryUtilities.js", [], function() {
      var o, n;
      return (n = o || (o = {})).getCenterOfPoints = function(l) {
        let L = l.reduce((D, j) => (D.x += j.x, D.y += j.y, D), { x: 0, y: 0 });
        return { x: L.x / l.length, y: L.y / l.length };
      }, n.getDistanceBetweenPoints = function(l, L) {
        return Math.sqrt(Math.pow(L.x - l.x, 2) + Math.pow(L.y - l.y, 2));
      }, n.getAngleBetweenPoints = function(l, L) {
        return Math.atan2(L.x - l.x, L.y - l.y);
      }, n.pointInPolygon = function({ x: l, y: L }, D) {
        let j = D.length, I, B, R = !1;
        for (I = 0, B = j - 1; I < j; B = I++) {
          let [N, x] = D[I], [T, y] = D[B];
          x > L != y > L && l < (T - N) * (L - x) / (y - x) + N && (R = !R);
        }
        return R;
      }, o;
    }), i(e, "Extensions/OverlappingDataLabels.js", [e["Core/Geometry/GeometryUtilities.js"], e["Core/Utilities.js"]], function(o, n) {
      let { pointInPolygon: l } = o, { addEvent: L, fireEvent: D, objectEach: j, pick: I } = n;
      function B(x) {
        let T = x.length, y = (F, _) => !(_.x >= F.x + F.width || _.x + _.width <= F.x || _.y >= F.y + F.height || _.y + _.height <= F.y), S = (F, _) => {
          for (let E of F) if (l({ x: E[0], y: E[1] }, _)) return !0;
          return !1;
        }, u, A, M, f, m, C = !1;
        for (let F = 0; F < T; F++) (u = x[F]) && (u.oldOpacity = u.opacity, u.newOpacity = 1, u.absoluteBox = function(_) {
          var E, v;
          if (_ && (!_.alignAttr || _.placed)) {
            let w = _.box ? 0 : _.padding || 0, d = _.alignAttr || { x: _.attr("x"), y: _.attr("y") }, r = _.getBBox();
            return _.width = r.width, _.height = r.height, { x: d.x + (((E = _.parentGroup) == null ? void 0 : E.translateX) || 0) + w, y: d.y + (((v = _.parentGroup) == null ? void 0 : v.translateY) || 0) + w, width: (_.width || 0) - 2 * w, height: (_.height || 0) - 2 * w, polygon: r == null ? void 0 : r.polygon };
          }
        }(u));
        x.sort((F, _) => (_.labelrank || 0) - (F.labelrank || 0));
        for (let F = 0; F < T; ++F) {
          f = (A = x[F]) && A.absoluteBox;
          let _ = f == null ? void 0 : f.polygon;
          for (let E = F + 1; E < T; ++E) {
            m = (M = x[E]) && M.absoluteBox;
            let v = !1;
            if (f && m && A !== M && A.newOpacity !== 0 && M.newOpacity !== 0 && A.visibility !== "hidden" && M.visibility !== "hidden") {
              let w = m.polygon;
              if (_ && w && _ !== w ? S(_, w) && (v = !0) : y(f, m) && (v = !0), v) {
                let d = A.labelrank < M.labelrank ? A : M, r = d.text;
                d.newOpacity = 0, r != null && r.element.querySelector("textPath") && r.hide();
              }
            }
          }
        }
        for (let F of x) R(F, this) && (C = !0);
        C && D(this, "afterHideAllOverlappingLabels");
      }
      function R(x, T) {
        let y, S, u = !1;
        return x && (S = x.newOpacity, x.oldOpacity !== S && (x.hasClass("highcharts-data-label") ? (x[S ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), y = function() {
          T.styledMode || x.css({ pointerEvents: S ? "auto" : "none" });
        }, u = !0, x[x.isOld ? "animate" : "attr"]({ opacity: S }, void 0, y), D(T, "afterHideOverlappingLabel")) : x.attr({ opacity: S })), x.isOld = !0), u;
      }
      function N() {
        var y;
        let x = this, T = [];
        for (let S of x.labelCollectors || []) T = T.concat(S());
        for (let S of x.yAxis || []) S.stacking && S.options.stackLabels && !S.options.stackLabels.allowOverlap && j(S.stacking.stacks, (u) => {
          j(u, (A) => {
            A.label && T.push(A.label);
          });
        });
        for (let S of x.series || []) if (S.visible && ((y = S.hasDataLabels) != null && y.call(S))) {
          let u = (A) => {
            for (let M of A) M.visible && (M.dataLabels || []).forEach((f) => {
              var C, F;
              let m = f.options || {};
              f.labelrank = I(m.labelrank, M.labelrank, (C = M.shapeArgs) == null ? void 0 : C.height), ((F = m.allowOverlap) != null ? F : Number(m.distance) > 0) ? (f.oldOpacity = f.opacity, f.newOpacity = 1, R(f, x)) : T.push(f);
            });
          };
          u(S.nodes || []), u(S.points);
        }
        this.hideOverlappingLabels(T);
      }
      return { compose: function(x) {
        let T = x.prototype;
        T.hideOverlappingLabels || (T.hideOverlappingLabels = B, L(x, "render", N));
      } };
    }), i(e, "Extensions/BorderRadius.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { defaultOptions: L } = o, { noop: D } = n, { addEvent: j, extend: I, isObject: B, merge: R, relativeLength: N } = l, x = { radius: 0, scope: "stack", where: void 0 }, T = D, y = D;
      function S(m, C, F, _, E = {}) {
        let v = T(m, C, F, _, E), { innerR: w = 0, r: d = F, start: r = 0, end: s = 0 } = E;
        if (E.open || !E.borderRadius) return v;
        let p = s - r, b = Math.sin(p / 2), c = Math.max(Math.min(N(E.borderRadius || 0, d - w), (d - w) / 2, d * b / (1 + b)), 0), h = Math.min(c, p / Math.PI * 2 * w), g = v.length - 1;
        for (; g--; ) (function(k, P, O) {
          let z, W, G, Y = k[P], U = k[P + 1];
          if (U[0] === "Z" && (U = k[0]), (Y[0] === "M" || Y[0] === "L") && U[0] === "A" ? (z = Y, W = U, G = !0) : Y[0] === "A" && (U[0] === "M" || U[0] === "L") && (z = U, W = Y), z && W && W.params) {
            let H = W[1], q = W[5], X = W.params, { start: $, end: K, cx: V, cy: Q } = X, Z = q ? H - O : H + O, ee = Z ? Math.asin(O / Z) : 0, J = q ? ee : -ee, ie = Math.cos(ee) * Z;
            G ? (X.start = $ + J, z[1] = V + ie * Math.cos($), z[2] = Q + ie * Math.sin($), k.splice(P + 1, 0, ["A", O, O, 0, 0, 1, V + H * Math.cos(X.start), Q + H * Math.sin(X.start)])) : (X.end = K - J, W[6] = V + H * Math.cos(X.end), W[7] = Q + H * Math.sin(X.end), k.splice(P + 1, 0, ["A", O, O, 0, 0, 1, V + ie * Math.cos(K), Q + ie * Math.sin(K)])), W[4] = Math.abs(X.end - X.start) < Math.PI ? 0 : 1;
          }
        })(v, g, g > 1 ? h : c);
        return v;
      }
      function u() {
        var m, C;
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: F, yAxis: _ } = this, E = F.stacking === "percent", v = (C = (m = L.plotOptions) == null ? void 0 : m[this.type]) == null ? void 0 : C.borderRadius, w = A(F.borderRadius, B(v) ? v : {}), d = _.options.reversed;
          for (let r of this.points) {
            let { shapeArgs: s } = r;
            if (r.shapeType === "roundedRect" && s) {
              let { width: p = 0, height: b = 0, y: c = 0 } = s, h = c, g = b;
              if (w.scope === "stack" && r.stackTotal) {
                let z = _.translate(E ? 100 : r.stackTotal, !1, !0, !1, !0), W = _.translate(F.threshold || 0, !1, !0, !1, !0), G = this.crispCol(0, Math.min(z, W), 0, Math.abs(z - W));
                h = G.y, g = G.height;
              }
              let k = (r.negative ? -1 : 1) * (d ? -1 : 1) == -1, P = w.where;
              !P && this.is("waterfall") && Math.abs((r.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (P = "all"), P || (P = "end");
              let O = Math.min(N(w.radius, p), p / 2, P === "all" ? b / 2 : 1 / 0) || 0;
              P === "end" && (k && (h -= O), g += O), I(s, { brBoxHeight: g, brBoxY: h, r: O });
            }
          }
        }
      }
      function A(m, C) {
        return B(m) || (m = { radius: m || 0 }), R(x, C, m);
      }
      function M() {
        let m = A(this.options.borderRadius);
        for (let C of this.points) {
          let F = C.shapeArgs;
          F && (F.borderRadius = N(m.radius, (F.r || 0) - (F.innerR || 0)));
        }
      }
      function f(m, C, F, _, E = {}) {
        let v = y(m, C, F, _, E), { r: w = 0, brBoxHeight: d = _, brBoxY: r = C } = E, s = C - r, p = r + d - (C + _), b = s - w > -0.1 ? 0 : w, c = p - w > -0.1 ? 0 : w, h = Math.max(b && s, 0), g = Math.max(c && p, 0), k = [m + b, C], P = [m + F - b, C], O = [m + F, C + b], z = [m + F, C + _ - c], W = [m + F - c, C + _], G = [m + c, C + _], Y = [m, C + _ - c], U = [m, C + b], H = (q, X) => Math.sqrt(Math.pow(q, 2) - Math.pow(X, 2));
        if (h) {
          let q = H(b, b - h);
          k[0] -= q, P[0] += q, O[1] = U[1] = C + b - h;
        }
        if (_ < b - h) {
          let q = H(b, b - h - _);
          O[0] = z[0] = m + F - b + q, W[0] = Math.min(O[0], W[0]), G[0] = Math.max(z[0], G[0]), Y[0] = U[0] = m + b - q, O[1] = U[1] = C + _;
        }
        if (g) {
          let q = H(c, c - g);
          W[0] += q, G[0] -= q, z[1] = Y[1] = C + _ - c + g;
        }
        if (_ < c - g) {
          let q = H(c, c - g - _);
          O[0] = z[0] = m + F - c + q, P[0] = Math.min(O[0], P[0]), k[0] = Math.max(z[0], k[0]), Y[0] = U[0] = m + c - q, z[1] = Y[1] = C;
        }
        return v.length = 0, v.push(["M", ...k], ["L", ...P], ["A", b, b, 0, 0, 1, ...O], ["L", ...z], ["A", c, c, 0, 0, 1, ...W], ["L", ...G], ["A", c, c, 0, 0, 1, ...Y], ["L", ...U], ["A", b, b, 0, 0, 1, ...k], ["Z"]), v;
      }
      return { compose: function(m, C, F) {
        let _ = m.types.pie;
        if (!C.symbolCustomAttribs.includes("borderRadius")) {
          let E = F.prototype.symbols;
          j(m, "afterColumnTranslate", u, { order: 9 }), j(_, "afterTranslate", M), C.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), T = E.arc, y = E.roundedRect, E.arc = S, E.roundedRect = f;
        }
      }, optionsToObject: A };
    }), i(e, "Core/Responsive.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { diffObjects: l, extend: L, find: D, merge: j, pick: I, uniqueKey: B } = o;
      return function(R) {
        function N(T, y) {
          let S = T.condition;
          (S.callback || function() {
            return this.chartWidth <= I(S.maxWidth, Number.MAX_VALUE) && this.chartHeight <= I(S.maxHeight, Number.MAX_VALUE) && this.chartWidth >= I(S.minWidth, 0) && this.chartHeight >= I(S.minHeight, 0);
          }).call(this) && y.push(T._id);
        }
        function x(T, y) {
          let S = this.options.responsive, u = this.currentResponsive, A = [], M;
          !y && S && S.rules && S.rules.forEach((C) => {
            C._id === void 0 && (C._id = B()), this.matchResponsiveRule(C, A);
          }, this);
          let f = j(...A.map((C) => D((S || {}).rules || [], (F) => F._id === C)).map((C) => C && C.chartOptions));
          f.isResponsiveOptions = !0, A = A.toString() || void 0;
          let m = u && u.ruleIds;
          A === m || (u && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(u.undoOptions, T, !0), this.updatingResponsive = !1), A ? ((M = l(f, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: A, mergedOptions: f, undoOptions: M }, this.updatingResponsive || this.update(f, T, !0)) : this.currentResponsive = void 0);
        }
        R.compose = function(T) {
          let y = T.prototype;
          return y.matchResponsiveRule || L(y, { matchResponsiveRule: N, setResponsive: x }), T;
        };
      }(n || (n = {})), n;
    }), i(e, "masters/highcharts.src.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Core/Defaults.js"], e["Core/Animation/Fx.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Renderer/HTML/AST.js"], e["Core/Templating.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Renderer/HTML/HTMLElement.js"], e["Core/Axis/Axis.js"], e["Core/Axis/DateTimeAxis.js"], e["Core/Axis/LogarithmicAxis.js"], e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], e["Core/Axis/Tick.js"], e["Core/Tooltip.js"], e["Core/Series/Point.js"], e["Core/Pointer.js"], e["Core/Legend/Legend.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Chart/Chart.js"], e["Extensions/ScrollablePlotArea.js"], e["Core/Axis/Stacking/StackingAxis.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Series/Column/ColumnDataLabel.js"], e["Series/Pie/PieDataLabel.js"], e["Core/Series/DataLabel.js"], e["Extensions/OverlappingDataLabels.js"], e["Extensions/BorderRadius.js"], e["Core/Responsive.js"], e["Core/Color/Color.js"], e["Core/Time.js"]], function(o, n, l, L, D, j, I, B, R, N, x, T, y, S, u, A, M, f, m, C, F, _, E, v, w, d, r, s, p, b, c, h, g, k, P, O) {
      return o.AST = j, o.Axis = y, o.Chart = E, o.Color = P, o.DataLabel = c, o.Fx = L, o.HTMLElement = T, o.Legend = F, o.LegendSymbol = _, o.OverlappingDataLabels = o.OverlappingDataLabels || h, o.PlotLineOrBand = A, o.Point = m, o.Pointer = C, o.RendererRegistry = B, o.Series = r, o.SeriesRegistry = s, o.StackItem = d, o.SVGElement = N, o.SVGRenderer = x, o.Templating = I, o.Tick = M, o.Time = O, o.Tooltip = f, o.animate = D.animate, o.animObject = D.animObject, o.chart = E.chart, o.color = P.parse, o.dateFormat = I.dateFormat, o.defaultOptions = l.defaultOptions, o.distribute = R.distribute, o.format = I.format, o.getDeferredAnimation = D.getDeferredAnimation, o.getOptions = l.getOptions, o.numberFormat = I.numberFormat, o.seriesType = s.seriesType, o.setAnimation = D.setAnimation, o.setOptions = l.setOptions, o.stop = D.stop, o.time = l.defaultTime, o.timers = L.timers, g.compose(o.Series, o.SVGElement, o.SVGRenderer), p.compose(o.Series.types.column), c.compose(o.Series), S.compose(o.Axis), T.compose(o.SVGRenderer), F.compose(o.Chart), u.compose(o.Axis), h.compose(o.Chart), b.compose(o.Series.types.pie), A.compose(o.Chart, o.Axis), C.compose(o.Chart), k.compose(o.Chart), v.compose(o.Axis, o.Chart, o.Series), w.compose(o.Axis, o.Chart, o.Series), f.compose(o.Pointer), n.extend(o, n), o;
    }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
  });
})(Tm);
var yi = Tm.exports;
const vt = /* @__PURE__ */ ri(yi);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ml = globalThis, Ua = Ml.ShadowRoot && (Ml.ShadyCSS === void 0 || Ml.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Hh = Symbol(), Ep = /* @__PURE__ */ new WeakMap();
let Lm = class {
  constructor(t, e, i) {
    if (this._$cssResult$ = !0, i !== Hh) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (Ua && t === void 0) {
      const i = e !== void 0 && e.length === 1;
      i && (t = Ep.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), i && Ep.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const TA = (a) => new Lm(typeof a == "string" ? a : a + "", void 0, Hh), ve = (a, ...t) => {
  const e = a.length === 1 ? a[0] : t.reduce((i, o, n) => i + ((l) => {
    if (l._$cssResult$ === !0) return l.cssText;
    if (typeof l == "number") return l;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + l + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(o) + a[n + 1], a[0]);
  return new Lm(e, a, Hh);
}, LA = (a, t) => {
  if (Ua) a.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
  else for (const e of t) {
    const i = document.createElement("style"), o = Ml.litNonce;
    o !== void 0 && i.setAttribute("nonce", o), i.textContent = e.cssText, a.appendChild(i);
  }
}, Mp = Ua ? (a) => a : (a) => a instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const i of t.cssRules) e += i.cssText;
  return TA(e);
})(a) : a;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: OA, defineProperty: PA, getOwnPropertyDescriptor: DA, getOwnPropertyNames: zA, getOwnPropertySymbols: IA, getPrototypeOf: BA } = Object, da = globalThis, Tp = da.trustedTypes, RA = Tp ? Tp.emptyScript : "", nd = da.reactiveElementPolyfillSupport, ts = (a, t) => a, zl = { toAttribute(a, t) {
  switch (t) {
    case Boolean:
      a = a ? RA : null;
      break;
    case Object:
    case Array:
      a = a == null ? a : JSON.stringify(a);
  }
  return a;
}, fromAttribute(a, t) {
  let e = a;
  switch (t) {
    case Boolean:
      e = a !== null;
      break;
    case Number:
      e = a === null ? null : Number(a);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(a);
      } catch {
        e = null;
      }
  }
  return e;
} }, Cc = (a, t) => !OA(a, t), Lp = { attribute: !0, type: String, converter: zl, reflect: !1, useDefault: !1, hasChanged: Cc };
var ym, xm;
(ym = Symbol.metadata) != null || (Symbol.metadata = Symbol("metadata")), (xm = da.litPropertyMetadata) != null || (da.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let Un = class extends HTMLElement {
  static addInitializer(t) {
    var e;
    this._$Ei(), ((e = this.l) != null ? e : this.l = []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = Lp) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((e = Object.create(e)).wrapped = !0), this.elementProperties.set(t, e), !e.noAccessor) {
      const i = Symbol(), o = this.getPropertyDescriptor(t, i, e);
      o !== void 0 && PA(this.prototype, t, o);
    }
  }
  static getPropertyDescriptor(t, e, i) {
    var l;
    const { get: o, set: n } = (l = DA(this.prototype, t)) != null ? l : { get() {
      return this[e];
    }, set(L) {
      this[e] = L;
    } };
    return { get: o, set(L) {
      const D = o == null ? void 0 : o.call(this);
      n == null || n.call(this, L), this.requestUpdate(t, D, i);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    var e;
    return (e = this.elementProperties.get(t)) != null ? e : Lp;
  }
  static _$Ei() {
    if (this.hasOwnProperty(ts("elementProperties"))) return;
    const t = BA(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(ts("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(ts("properties"))) {
      const e = this.properties, i = [...zA(e), ...IA(e)];
      for (const o of i) this.createProperty(o, e[o]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [i, o] of e) this.elementProperties.set(i, o);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, i] of this.elementProperties) {
      const o = this._$Eu(e, i);
      o !== void 0 && this._$Eh.set(o, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const i = new Set(t.flat(1 / 0).reverse());
      for (const o of i) e.unshift(Mp(o));
    } else t !== void 0 && e.push(Mp(t));
    return e;
  }
  static _$Eu(t, e) {
    const i = e.attribute;
    return i === !1 ? void 0 : typeof i == "string" ? i : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, i;
    ((e = this._$EO) != null ? e : this._$EO = /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && ((i = t.hostConnected) == null || i.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$EO) == null || e.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const i of e.keys()) this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return LA(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t, e;
    (t = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((i) => {
      var o;
      return (o = i.hostConnected) == null ? void 0 : o.call(i);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((e) => {
      var i;
      return (i = e.hostDisconnected) == null ? void 0 : i.call(e);
    });
  }
  attributeChangedCallback(t, e, i) {
    this._$AK(t, i);
  }
  _$ET(t, e) {
    var n;
    const i = this.constructor.elementProperties.get(t), o = this.constructor._$Eu(t, i);
    if (o !== void 0 && i.reflect === !0) {
      const l = (((n = i.converter) == null ? void 0 : n.toAttribute) !== void 0 ? i.converter : zl).toAttribute(e, i.type);
      this._$Em = t, l == null ? this.removeAttribute(o) : this.setAttribute(o, l), this._$Em = null;
    }
  }
  _$AK(t, e) {
    var n, l, L, D;
    const i = this.constructor, o = i._$Eh.get(t);
    if (o !== void 0 && this._$Em !== o) {
      const j = i.getPropertyOptions(o), I = typeof j.converter == "function" ? { fromAttribute: j.converter } : ((n = j.converter) == null ? void 0 : n.fromAttribute) !== void 0 ? j.converter : zl;
      this._$Em = o, this[o] = (D = (L = I.fromAttribute(e, j.type)) != null ? L : (l = this._$Ej) == null ? void 0 : l.get(o)) != null ? D : null, this._$Em = null;
    }
  }
  requestUpdate(t, e, i) {
    var o, n;
    if (t !== void 0) {
      const l = this.constructor, L = this[t];
      if (i != null || (i = l.getPropertyOptions(t)), !(((o = i.hasChanged) != null ? o : Cc)(L, e) || i.useDefault && i.reflect && L === ((n = this._$Ej) == null ? void 0 : n.get(t)) && !this.hasAttribute(l._$Eu(t, i)))) return;
      this.C(t, e, i);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, e, { useDefault: i, reflect: o, wrapped: n }, l) {
    var L, D, j;
    i && !((L = this._$Ej) != null ? L : this._$Ej = /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, (D = l != null ? l : e) != null ? D : this[t]), n !== !0 || l !== void 0) || (this._$AL.has(t) || (this.hasUpdated || i || (e = void 0), this._$AL.set(t, e)), o === !0 && this._$Em !== t && ((j = this._$Eq) != null ? j : this._$Eq = /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var i, o;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if ((i = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [l, L] of this._$Ep) this[l] = L;
        this._$Ep = void 0;
      }
      const n = this.constructor.elementProperties;
      if (n.size > 0) for (const [l, L] of n) {
        const { wrapped: D } = L, j = this[l];
        D !== !0 || this._$AL.has(l) || j === void 0 || this.C(l, void 0, L, j);
      }
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), (o = this._$EO) == null || o.forEach((n) => {
        var l;
        return (l = n.hostUpdate) == null ? void 0 : l.call(n);
      }), this.update(e)) : this._$EM();
    } catch (n) {
      throw t = !1, this._$EM(), n;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$EO) == null || e.forEach((i) => {
      var o;
      return (o = i.hostUpdated) == null ? void 0 : o.call(i);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq && (this._$Eq = this._$Eq.forEach((e) => this._$ET(e, this[e]))), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
var wm;
Un.elementStyles = [], Un.shadowRootOptions = { mode: "open" }, Un[ts("elementProperties")] = /* @__PURE__ */ new Map(), Un[ts("finalized")] = /* @__PURE__ */ new Map(), nd == null || nd({ ReactiveElement: Un }), ((wm = da.reactiveElementVersions) != null ? wm : da.reactiveElementVersions = []).push("2.1.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const os = globalThis, Il = os.trustedTypes, Op = Il ? Il.createPolicy("lit-html", { createHTML: (a) => a }) : void 0, Om = "$lit$", aa = `lit$${Math.random().toFixed(9).slice(2)}$`, Pm = "?" + aa, NA = `<${Pm}>`, rn = document, hs = () => rn.createComment(""), bs = (a) => a === null || typeof a != "object" && typeof a != "function", Kh = Array.isArray, FA = (a) => Kh(a) || typeof (a == null ? void 0 : a[Symbol.iterator]) == "function", rd = `[ 	
\f\r]`, jr = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Pp = /-->/g, Dp = />/g, Da = RegExp(`>|${rd}(?:([^\\s"'>=/]+)(${rd}*=${rd}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), zp = /'/g, Ip = /"/g, Dm = /^(?:script|style|textarea|title)$/i, jA = (a) => (t, ...e) => ({ _$litType$: a, strings: t, values: e }), pe = jA(1), ei = Symbol.for("lit-noChange"), je = Symbol.for("lit-nothing"), Bp = /* @__PURE__ */ new WeakMap(), $a = rn.createTreeWalker(rn, 129);
function zm(a, t) {
  if (!Kh(a) || !a.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return Op !== void 0 ? Op.createHTML(t) : t;
}
const _A = (a, t) => {
  const e = a.length - 1, i = [];
  let o, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", l = jr;
  for (let L = 0; L < e; L++) {
    const D = a[L];
    let j, I, B = -1, R = 0;
    for (; R < D.length && (l.lastIndex = R, I = l.exec(D), I !== null); ) R = l.lastIndex, l === jr ? I[1] === "!--" ? l = Pp : I[1] !== void 0 ? l = Dp : I[2] !== void 0 ? (Dm.test(I[2]) && (o = RegExp("</" + I[2], "g")), l = Da) : I[3] !== void 0 && (l = Da) : l === Da ? I[0] === ">" ? (l = o != null ? o : jr, B = -1) : I[1] === void 0 ? B = -2 : (B = l.lastIndex - I[2].length, j = I[1], l = I[3] === void 0 ? Da : I[3] === '"' ? Ip : zp) : l === Ip || l === zp ? l = Da : l === Pp || l === Dp ? l = jr : (l = Da, o = void 0);
    const N = l === Da && a[L + 1].startsWith("/>") ? " " : "";
    n += l === jr ? D + NA : B >= 0 ? (i.push(j), D.slice(0, B) + Om + D.slice(B) + aa + N) : D + aa + (B === -2 ? L : N);
  }
  return [zm(a, n + (a[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), i];
};
class ps {
  constructor({ strings: t, _$litType$: e }, i) {
    let o;
    this.parts = [];
    let n = 0, l = 0;
    const L = t.length - 1, D = this.parts, [j, I] = _A(t, e);
    if (this.el = ps.createElement(j, i), $a.currentNode = this.el.content, e === 2 || e === 3) {
      const B = this.el.content.firstChild;
      B.replaceWith(...B.childNodes);
    }
    for (; (o = $a.nextNode()) !== null && D.length < L; ) {
      if (o.nodeType === 1) {
        if (o.hasAttributes()) for (const B of o.getAttributeNames()) if (B.endsWith(Om)) {
          const R = I[l++], N = o.getAttribute(B).split(aa), x = /([.?@])?(.*)/.exec(R);
          D.push({ type: 1, index: n, name: x[2], strings: N, ctor: x[1] === "." ? $A : x[1] === "?" ? HA : x[1] === "@" ? KA : Sc }), o.removeAttribute(B);
        } else B.startsWith(aa) && (D.push({ type: 6, index: n }), o.removeAttribute(B));
        if (Dm.test(o.tagName)) {
          const B = o.textContent.split(aa), R = B.length - 1;
          if (R > 0) {
            o.textContent = Il ? Il.emptyScript : "";
            for (let N = 0; N < R; N++) o.append(B[N], hs()), $a.nextNode(), D.push({ type: 2, index: ++n });
            o.append(B[R], hs());
          }
        }
      } else if (o.nodeType === 8) if (o.data === Pm) D.push({ type: 2, index: n });
      else {
        let B = -1;
        for (; (B = o.data.indexOf(aa, B + 1)) !== -1; ) D.push({ type: 7, index: n }), B += aa.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const i = rn.createElement("template");
    return i.innerHTML = t, i;
  }
}
function rr(a, t, e = a, i) {
  var l, L, D;
  if (t === ei) return t;
  let o = i !== void 0 ? (l = e._$Co) == null ? void 0 : l[i] : e._$Cl;
  const n = bs(t) ? void 0 : t._$litDirective$;
  return (o == null ? void 0 : o.constructor) !== n && ((L = o == null ? void 0 : o._$AO) == null || L.call(o, !1), n === void 0 ? o = void 0 : (o = new n(a), o._$AT(a, e, i)), i !== void 0 ? ((D = e._$Co) != null ? D : e._$Co = [])[i] = o : e._$Cl = o), o !== void 0 && (t = rr(a, o._$AS(a, t.values), o, i)), t;
}
let UA = class {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var j;
    const { el: { content: e }, parts: i } = this._$AD, o = ((j = t == null ? void 0 : t.creationScope) != null ? j : rn).importNode(e, !0);
    $a.currentNode = o;
    let n = $a.nextNode(), l = 0, L = 0, D = i[0];
    for (; D !== void 0; ) {
      if (l === D.index) {
        let I;
        D.type === 2 ? I = new kr(n, n.nextSibling, this, t) : D.type === 1 ? I = new D.ctor(n, D.name, D.strings, this, t) : D.type === 6 && (I = new GA(n, this, t)), this._$AV.push(I), D = i[++L];
      }
      l !== (D == null ? void 0 : D.index) && (n = $a.nextNode(), l++);
    }
    return $a.currentNode = rn, o;
  }
  p(t) {
    let e = 0;
    for (const i of this._$AV) i !== void 0 && (i.strings !== void 0 ? (i._$AI(t, i, e), e += i.strings.length - 2) : i._$AI(t[e])), e++;
  }
};
class kr {
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) == null ? void 0 : t._$AU) != null ? e : this._$Cv;
  }
  constructor(t, e, i, o) {
    var n;
    this.type = 2, this._$AH = je, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = i, this.options = o, this._$Cv = (n = o == null ? void 0 : o.isConnected) != null ? n : !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = rr(this, t, e), bs(t) ? t === je || t == null || t === "" ? (this._$AH !== je && this._$AR(), this._$AH = je) : t !== this._$AH && t !== ei && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : FA(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== je && bs(this._$AH) ? this._$AA.nextSibling.data = t : this.T(rn.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var n;
    const { values: e, _$litType$: i } = t, o = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = ps.createElement(zm(i.h, i.h[0]), this.options)), i);
    if (((n = this._$AH) == null ? void 0 : n._$AD) === o) this._$AH.p(e);
    else {
      const l = new UA(o, this), L = l.u(this.options);
      l.p(e), this.T(L), this._$AH = l;
    }
  }
  _$AC(t) {
    let e = Bp.get(t.strings);
    return e === void 0 && Bp.set(t.strings, e = new ps(t)), e;
  }
  k(t) {
    Kh(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let i, o = 0;
    for (const n of t) o === e.length ? e.push(i = new kr(this.O(hs()), this.O(hs()), this, this.options)) : i = e[o], i._$AI(n), o++;
    o < e.length && (this._$AR(i && i._$AB.nextSibling, o), e.length = o);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var i;
    for ((i = this._$AP) == null ? void 0 : i.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const o = t.nextSibling;
      t.remove(), t = o;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cv = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class Sc {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, i, o, n) {
    this.type = 1, this._$AH = je, this._$AN = void 0, this.element = t, this.name = e, this._$AM = o, this.options = n, i.length > 2 || i[0] !== "" || i[1] !== "" ? (this._$AH = Array(i.length - 1).fill(new String()), this.strings = i) : this._$AH = je;
  }
  _$AI(t, e = this, i, o) {
    const n = this.strings;
    let l = !1;
    if (n === void 0) t = rr(this, t, e, 0), l = !bs(t) || t !== this._$AH && t !== ei, l && (this._$AH = t);
    else {
      const L = t;
      let D, j;
      for (t = n[0], D = 0; D < n.length - 1; D++) j = rr(this, L[i + D], e, D), j === ei && (j = this._$AH[D]), l || (l = !bs(j) || j !== this._$AH[D]), j === je ? t = je : t !== je && (t += (j != null ? j : "") + n[D + 1]), this._$AH[D] = j;
    }
    l && !o && this.j(t);
  }
  j(t) {
    t === je ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class $A extends Sc {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === je ? void 0 : t;
  }
}
class HA extends Sc {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== je);
  }
}
class KA extends Sc {
  constructor(t, e, i, o, n) {
    super(t, e, i, o, n), this.type = 5;
  }
  _$AI(t, e = this) {
    var l;
    if ((t = (l = rr(this, t, e, 0)) != null ? l : je) === ei) return;
    const i = this._$AH, o = t === je && i !== je || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, n = t !== je && (i === je || o);
    o && this.element.removeEventListener(this.name, this, i), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, i;
    typeof this._$AH == "function" ? this._$AH.call((i = (e = this.options) == null ? void 0 : e.host) != null ? i : this.element, t) : this._$AH.handleEvent(t);
  }
}
class GA {
  constructor(t, e, i) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = i;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    rr(this, t);
  }
}
const WA = { I: kr }, sd = os.litHtmlPolyfillSupport;
var km;
sd == null || sd(ps, kr), ((km = os.litHtmlVersions) != null ? km : os.litHtmlVersions = []).push("3.3.0");
const Ws = (a, t, e) => {
  var n, l;
  const i = (n = e == null ? void 0 : e.renderBefore) != null ? n : t;
  let o = i._$litPart$;
  if (o === void 0) {
    const L = (l = e == null ? void 0 : e.renderBefore) != null ? l : null;
    i._$litPart$ = o = new kr(t.insertBefore(hs(), L), L, void 0, e != null ? e : {});
  }
  return o._$AI(a), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Qa = globalThis;
let Gn = class extends Un {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, i;
    const t = super.createRenderRoot();
    return (i = (e = this.renderOptions).renderBefore) != null || (e.renderBefore = t.firstChild), t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Ws(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) == null || t.setConnected(!1);
  }
  render() {
    return ei;
  }
};
var Cm;
Gn._$litElement$ = !0, Gn.finalized = !0, (Cm = Qa.litElementHydrateSupport) == null || Cm.call(Qa, { LitElement: Gn });
const ld = Qa.litElementPolyfillSupport;
ld == null || ld({ LitElement: Gn });
var Sm;
((Sm = Qa.litElementVersions) != null ? Sm : Qa.litElementVersions = []).push("4.2.0");
const VA = ve`/**
 * @license Highcharts
 *
 * (c) 2009-2022 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */:root,.highcharts-light{--highcharts-color-0: #2caffe;--highcharts-color-1: #544fc5;--highcharts-color-2: #00e272;--highcharts-color-3: #fe6a35;--highcharts-color-4: #6b8abc;--highcharts-color-5: #d568fb;--highcharts-color-6: #2ee0ca;--highcharts-color-7: #fa4b42;--highcharts-color-8: #feb56a;--highcharts-color-9: #91e8e1;--highcharts-background-color: #ffffff;--highcharts-neutral-color-100: #000000;--highcharts-neutral-color-80: #333333;--highcharts-neutral-color-60: #666666;--highcharts-neutral-color-40: #999999;--highcharts-neutral-color-20: #cccccc;--highcharts-neutral-color-10: #e6e6e6;--highcharts-neutral-color-5: #f2f2f2;--highcharts-neutral-color-3: #f7f7f7;--highcharts-highlight-color-100: #0022ff;--highcharts-highlight-color-80: #334eff;--highcharts-highlight-color-60: #667aff;--highcharts-highlight-color-20: #ccd3ff;--highcharts-highlight-color-10: #e6e9ff;--highcharts-positive-color: #06b535;--highcharts-negative-color: #f21313;--highcharts-annotation-color-0: rgba(130, 170, 255, .4);--highcharts-annotation-color-1: rgba(139, 191, 216, .4);--highcharts-annotation-color-2: rgba(150, 216, 192, .4);--highcharts-annotation-color-3: rgba(156, 229, 161, .4);--highcharts-annotation-color-4: rgba(162, 241, 130, .4);--highcharts-annotation-color-5: rgba(169, 255, 101, .4)}@media (prefers-color-scheme: dark){:root{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}}.highcharts-dark{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:1rem;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-no-touch-action{touch-action:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:var(--highcharts-background-color)}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-label text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:var(--highcharts-neutral-color-80);font-size:1.2em;font-weight:700}.highcharts-subtitle{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-line{fill:none;stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-labels{fill:var(--highcharts-neutral-color-80);cursor:default;font-size:.8em}.highcharts-grid-line{fill:none;stroke:var(--highcharts-neutral-color-10)}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0}.highcharts-tick{stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:var(--highcharts-neutral-color-5)}.highcharts-crosshair-thin{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}.highcharts-crosshair-category{stroke:var(--highcharts-highlight-color-20);stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:var(--highcharts-neutral-color-40);font-size:.6em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:var(--highcharts-neutral-color-100);font-size:.7em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip .highcharts-tracker{fill:none;stroke:none}.highcharts-tooltip text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-tooltip .highcharts-header{font-size:.8em}.highcharts-tooltip-box{stroke-width:1px;fill:var(--highcharts-background-color)}.highcharts-tooltip-box{stroke-width:0;fill:var(--highcharts-background-color)}.highcharts-tooltip-box .highcharts-label-box{fill:var(--highcharts-background-color)}div.highcharts-tooltip{filter:none;font-size:.8em}.highcharts-selection-marker{fill:var(--highcharts-highlight-color-80);fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:var(--highcharts-neutral-color-20)}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover,.highcharts-point-select),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:var(--highcharts-color-0);stroke:var(--highcharts-color-0)}.highcharts-color-1{fill:var(--highcharts-color-1);stroke:var(--highcharts-color-1)}.highcharts-color-2{fill:var(--highcharts-color-2);stroke:var(--highcharts-color-2)}.highcharts-color-3{fill:var(--highcharts-color-3);stroke:var(--highcharts-color-3)}.highcharts-color-4{fill:var(--highcharts-color-4);stroke:var(--highcharts-color-4)}.highcharts-color-5{fill:var(--highcharts-color-5);stroke:var(--highcharts-color-5)}.highcharts-color-6{fill:var(--highcharts-color-6);stroke:var(--highcharts-color-6)}.highcharts-color-7{fill:var(--highcharts-color-7);stroke:var(--highcharts-color-7)}.highcharts-color-8{fill:var(--highcharts-color-8);stroke:var(--highcharts-color-8)}.highcharts-color-9{fill:var(--highcharts-color-9);stroke:var(--highcharts-color-9)}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:var(--highcharts-background-color)}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover,.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{font-size:.7em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:var(--highcharts-neutral-color-80)}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series-label text{fill:inherit;font-weight:700}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-100)}.highcharts-column-series path.highcharts-point,.highcharts-bar-series path.highcharts-point{stroke:var(--highcharts-background-color)}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:var(--highcharts-neutral-color-10);transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:var(--highcharts-neutral-color-40);transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:var(--highcharts-neutral-color-100)}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:var(--highcharts-neutral-color-80);font-weight:700;font-size:.8em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:var(--highcharts-neutral-color-100)}.highcharts-legend-item-hidden *{fill:var(--highcharts-neutral-color-60)!important;stroke:var(--highcharts-neutral-color-60)!important;transition:fill .25s;text-decoration:line-through}.highcharts-legend-nav-active{fill:var(--highcharts-highlight-color-100);cursor:pointer}.highcharts-legend-nav-inactive{fill:var(--highcharts-neutral-color-20)}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:var(--highcharts-neutral-color-80);font-size:.7em}.highcharts-loading{position:absolute;background-color:var(--highcharts-background-color);opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:var(--highcharts-neutral-color-100);fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:var(--highcharts-neutral-color-40);stroke-width:1px}.highcharts-plot-line-label{font-size:.8em}.highcharts-boxplot-box{fill:var(--highcharts-background-color)}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:var(--highcharts-neutral-color-100)}.highcharts-gauge-series .highcharts-data-label-box{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:var(--highcharts-neutral-color-100);stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:var(--highcharts-neutral-color-80);stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:var(--highcharts-neutral-color-20);transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:var(--highcharts-neutral-color-20)}.highcharts-timeline-series .highcharts-graph{stroke:var(--highcharts-neutral-color-20)}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:var(--highcharts-highlight-color-60);fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:var(--highcharts-neutral-color-40);fill:none}.highcharts-navigator-handle{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-neutral-color-5);cursor:ew-resize}.highcharts-navigator-series{fill:var(--highcharts-highlight-color-80);stroke:var(--highcharts-highlight-color-80)}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-10)}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:var(--highcharts-neutral-color-100);font-size:.7em;opacity:.6}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-20);stroke-width:0}.highcharts-scrollbar-button{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-scrollbar-arrow{fill:var(--highcharts-neutral-color-60)}.highcharts-scrollbar-rifles{stroke:none;stroke-width:1px}.highcharts-scrollbar-track{fill:#fff0;stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-button{fill:var(--highcharts-neutral-color-3);stroke:var(--highcharts-neutral-color-20);cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-hover{transition:fill 0ms;fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-hover text{fill:var(--highcharts-neutral-color-80)}.highcharts-button-pressed{font-weight:700;fill:var(--highcharts-highlight-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-pressed text{fill:var(--highcharts-neutral-color-80);font-weight:700}.highcharts-button-disabled text{fill:var(--highcharts-neutral-color-80)}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:var(--highcharts-neutral-color-60)}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-range-input{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:var(--highcharts-background-color);font-size:1.7em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:var(--highcharts-neutral-color-100);stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:var(--highcharts-background-color)}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:var(--highcharts-negative-color);stroke:var(--highcharts-negative-color)}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:var(--highcharts-positive-color);stroke:var(--highcharts-positive-color)}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:var(--highcharts-positive-color)}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-background-color);transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-highlight-color-20)}.highcharts-flags-series .highcharts-point text{fill:var(--highcharts-neutral-color-100);font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:var(--highcharts-neutral-color-20);stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-map-navigation.highcharts-button{fill:var(--highcharts-background-color);stroke:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button:hover{fill:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button .highcharts-button-symbol{stroke-width:2px}.highcharts-mapview-inset-border{stroke:var(--highcharts-neutral-color-20);stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:var(--highcharts-neutral-color-40)}.highcharts-null-point{fill:var(--highcharts-neutral-color-3)}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:var(--highcharts-background-color);stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-10)}.highcharts-button-symbol{stroke:var(--highcharts-neutral-color-60);stroke-width:3px}.highcharts-menu{border:none;background:var(--highcharts-background-color);border-radius:3px;padding:.5em;box-shadow:3px 3px 10px #888}.highcharts-menu-item{background:none;border-radius:3px;color:var(--highcharts-neutral-color-80);cursor:pointer;font-size:.8em;list-style-type:none;padding:.5em;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:var(--highcharts-neutral-color-5)}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:var(--highcharts-neutral-color-60)}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:var(--highcharts-highlight-color-100);font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:.8em;fill:var(--highcharts-neutral-color-60)}.highcharts-axis-resizer{cursor:ns-resize;stroke:var(--highcharts-neutral-color-100);stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-80)}.highcharts-fibonacci-background-0,.highcharts-pitchfork-inner-background,.highcharts-measure-background{fill:var(--highcharts-annotation-color-0)}.highcharts-fibonacci-background-1{fill:var(--highcharts-annotation-color-1)}.highcharts-fibonacci-background-2{fill:var(--highcharts-annotation-color-2)}.highcharts-fibonacci-background-3,.highcharts-pitchfork-outer-background{fill:var(--highcharts-annotation-color-3)}.highcharts-fibonacci-background-4{fill:var(--highcharts-annotation-color-4)}.highcharts-fibonacci-background-5{fill:var(--highcharts-annotation-color-5)}.highcharts-fibonacci-line{stroke:var(--highcharts-neutral-color-40)}.highcharts-crooked-lines,.highcharts-tunnel-lines,.highcharts-infinity-lines,.highcharts-timecycles-lines,.highcharts-fibonacci-timezones-lines,.highcharts-pitchfork-lines,.highcharts-vertical-line,.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke:var(--highcharts-neutral-color-100);stroke-opacity:.75;fill:none}.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke-dasharray:1,3}.highcharts-tunnel-background{fill:var(--highcharts-color-0)}.highcharts-annotation-shapes{cursor:move}.highcharts-basic-shape{fill:var(--highcharts-neutral-color-100);stroke:var(--highcharts-neutral-color-100);opacity:.74}.highcharts-annotation-label-box{stroke-width:1px;stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-neutral-color-100);fill-opacity:.75}.highcharts-annotation-label text{fill:var(--highcharts-neutral-color-10);font-size:.8em}.highcharts-a11y-proxy-element{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}`;
var Im = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Accessibility module
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Accessibility/Utils/HTMLUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { doc: l, win: L } = o, { css: D } = n, j = L.EventTarget && new L.EventTarget() || "none";
      function I(R) {
        if (typeof L.MouseEvent == "function") return new L.MouseEvent(R.type, R);
        if (l.createEvent) {
          let N = l.createEvent("MouseEvent");
          if (N.initMouseEvent) return N.initMouseEvent(R.type, R.bubbles, R.cancelable, R.view || L, R.detail, R.screenX, R.screenY, R.clientX, R.clientY, R.ctrlKey, R.altKey, R.shiftKey, R.metaKey, R.button, R.relatedTarget), N;
        }
        return B(R.type);
      }
      function B(R, N, x) {
        let T = N || { x: 0, y: 0 };
        if (typeof L.MouseEvent == "function") return new L.MouseEvent(R, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: x || j, view: L, detail: R === "click" ? 1 : 0, screenX: T.x, screenY: T.y, clientX: T.x, clientY: T.y });
        if (l.createEvent) {
          let y = l.createEvent("MouseEvent");
          if (y.initMouseEvent) return y.initMouseEvent(R, !0, !0, L, R === "click" ? 1 : 0, T.x, T.y, T.x, T.y, !1, !1, !1, !1, 0, null), y;
        }
        return { type: R };
      }
      return { addClass: function(R, N) {
        R.classList ? R.classList.add(N) : 0 > R.className.indexOf(N) && (R.className += " " + N);
      }, cloneMouseEvent: I, cloneTouchEvent: function(R) {
        let N = (T) => {
          let y = [];
          for (let S = 0; S < T.length; ++S) {
            let u = T.item(S);
            u && y.push(u);
          }
          return y;
        };
        if (typeof L.TouchEvent == "function") {
          let T = new L.TouchEvent(R.type, { touches: N(R.touches), targetTouches: N(R.targetTouches), changedTouches: N(R.changedTouches), ctrlKey: R.ctrlKey, shiftKey: R.shiftKey, altKey: R.altKey, metaKey: R.metaKey, bubbles: R.bubbles, cancelable: R.cancelable, composed: R.composed, detail: R.detail, view: R.view });
          return R.defaultPrevented && T.preventDefault(), T;
        }
        let x = I(R);
        return x.touches = R.touches, x.changedTouches = R.changedTouches, x.targetTouches = R.targetTouches, x;
      }, escapeStringForHTML: function(R) {
        return R.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(R) {
        return l.getElementById(R);
      }, getFakeMouseEvent: B, getHeadingTagNameForElement: function(R) {
        let N = (S) => "h" + Math.min(6, parseInt(S.slice(1), 10) + 1), x = (S) => /^H[1-6]$/i.test(S), T = (S) => {
          let u = S;
          for (; u = u.previousSibling; ) {
            let A = u.tagName || "";
            if (x(A)) return A;
          }
          return "";
        }, y = (S) => {
          let u = T(S);
          if (u) return N(u);
          let A = S.parentElement;
          if (!A) return "p";
          let M = A.tagName;
          return x(M) ? N(M) : y(A);
        };
        return y(R);
      }, removeChildNodes: function(R) {
        for (; R.lastChild; ) R.removeChild(R.lastChild);
      }, removeClass: function(R, N) {
        R.classList ? R.classList.remove(N) : R.className = R.className.replace(RegExp(N, "g"), "");
      }, removeElement: function(R) {
        R && R.parentNode && R.parentNode.removeChild(R);
      }, reverseChildNodes: function(R) {
        let N = R.childNodes.length;
        for (; N--; ) R.appendChild(R.childNodes[N]);
      }, simulatedEventTarget: j, stripHTMLTagsFromString: function(R, N = !1) {
        return typeof R == "string" ? N ? R.replace(/<\/?[^>]+(>|$)/g, "") : R.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : R;
      }, visuallyHideElement: function(R) {
        D(R, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), i(e, "Accessibility/A11yI18n.js", [e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { format: L } = o, { getNestedProperty: D, pick: j } = n;
      return function(I) {
        function B(N, x, T) {
          let y = (f, m) => {
            let C = f.slice(m || 0), F = C.indexOf("{"), _ = C.indexOf("}");
            if (F > -1 && _ > F) return { statement: C.substring(F + 1, _), begin: m + F + 1, end: m + _ };
          }, S = [], u, A, M = 0;
          do
            u = y(N, M), (A = N.substring(M, u && u.begin - 1)).length && S.push({ value: A, type: "constant" }), u && S.push({ value: u.statement, type: "statement" }), M = u ? u.end + 1 : M + 1;
          while (u);
          return S.forEach((f) => {
            f.type === "statement" && (f.value = function(m, C) {
              let F, _, E = m.indexOf("#each("), v = m.indexOf("#plural("), w = m.indexOf("["), d = m.indexOf("]");
              if (E > -1) {
                let s = m.slice(E).indexOf(")") + E, p = m.substring(0, E), b = m.substring(s + 1), c = m.substring(E + 6, s).split(","), h = Number(c[1]), g;
                if (_ = "", F = D(c[0], C)) {
                  g = (h = isNaN(h) ? F.length : h) < 0 ? F.length + h : Math.min(h, F.length);
                  for (let k = 0; k < g; ++k) _ += p + F[k] + b;
                }
                return _.length ? _ : "";
              }
              if (v > -1) {
                var r;
                let s = m.slice(v).indexOf(")") + v, p = m.substring(v + 8, s).split(",");
                switch (Number(D(p[0], C))) {
                  case 0:
                    _ = j(p[4], p[1]);
                    break;
                  case 1:
                    _ = j(p[2], p[1]);
                    break;
                  case 2:
                    _ = j(p[3], p[1]);
                    break;
                  default:
                    _ = p[1];
                }
                return _ ? (r = _).trim && r.trim() || r.replace(/^\s+|\s+$/g, "") : "";
              }
              if (w > -1) {
                let s, p = m.substring(0, w), b = Number(m.substring(w + 1, d));
                return F = D(p, C), !isNaN(b) && F && (b < 0 ? (s = F[F.length + b]) === void 0 && (s = F[0]) : (s = F[b]) === void 0 && (s = F[F.length - 1])), s !== void 0 ? s : "";
              }
              return "{" + m + "}";
            }(f.value, x));
          }), L(S.reduce((f, m) => f + m.value, ""), x, T);
        }
        function R(N, x) {
          let T = N.split("."), y = this.options.lang, S = 0;
          for (; S < T.length; ++S) y = y && y[T[S]];
          return typeof y == "string" ? B(y, x, this) : "";
        }
        I.compose = function(N) {
          let x = N.prototype;
          x.langFormat || (x.langFormat = R);
        }, I.i18nFormat = B;
      }(l || (l = {})), l;
    }), i(e, "Accessibility/Utils/ChartUtilities.js", [e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { doc: L } = o, { stripHTMLTagsFromString: D } = n, { defined: j, find: I, fireEvent: B } = l;
      function R(x) {
        if (x.points && x.points.length) {
          let T = I(x.points, (y) => !!y.graphic);
          return T && T.graphic && T.graphic.element;
        }
      }
      function N(x) {
        let T = R(x);
        return T && T.parentNode || x.graph && x.graph.element || x.group && x.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function x(T, y) {
        let S = y.type, u = T.hcEvents;
        L.createEvent && (T.dispatchEvent || T.fireEvent) ? T.dispatchEvent ? T.dispatchEvent(y) : T.fireEvent(S, y) : u && u[S] ? B(T, S, y) : T.element && x(T.element, y);
      }, getChartTitle: function(x) {
        return D(x.options.title.text || x.langFormat("accessibility.defaultChartTitle", { chart: x }), x.renderer.forExport);
      }, getAxisDescription: function(x) {
        var T, y;
        return x && (((T = x.options.accessibility) == null ? void 0 : T.description) || ((y = x.axisTitle) == null ? void 0 : y.textStr) || x.options.id || x.categories && "categories" || x.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(x) {
        let T = x.options || {};
        return T.accessibility && T.accessibility.rangeDescription !== void 0 ? T.accessibility.rangeDescription : x.categories ? function(y) {
          let S = y.chart;
          return y.dataMax && y.dataMin ? S.langFormat("accessibility.axis.rangeCategories", { chart: S, axis: y, numCategories: y.dataMax - y.dataMin + 1 }) : "";
        }(x) : x.dateTime && (x.min === 0 || x.dataMin === 0) ? function(y) {
          let S = y.chart, u = {}, A = y.dataMin || y.min || 0, M = y.dataMax || y.max || 0, f = "Seconds";
          u.Seconds = (M - A) / 1e3, u.Minutes = u.Seconds / 60, u.Hours = u.Minutes / 60, u.Days = u.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(C) {
            u[C] > 2 && (f = C);
          });
          let m = u[f].toFixed(f !== "Seconds" && f !== "Minutes" ? 1 : 0);
          return S.langFormat("accessibility.axis.timeRange" + f, { chart: S, axis: y, range: m.replace(".0", "") });
        }(x) : function(y) {
          let S = y.chart, u = S.options, A = u && u.accessibility && u.accessibility.screenReaderSection.axisRangeDateFormat || "", M = { min: y.dataMin || y.min || 0, max: y.dataMax || y.max || 0 }, f = function(m) {
            return y.dateTime ? S.time.dateFormat(A, M[m]) : M[m].toString();
          };
          return S.langFormat("accessibility.axis.rangeFromTo", { chart: S, axis: y, rangeFrom: f("min"), rangeTo: f("max") });
        }(x);
      }, getPointFromXY: function(x, T, y) {
        let S = x.length, u;
        for (; S--; ) if (u = I(x[S].points || [], function(A) {
          return A.x === T && A.y === y;
        })) return u;
      }, getSeriesFirstPointElement: R, getSeriesFromName: function(x, T) {
        return T ? (x.series || []).filter(function(y) {
          return y.name === T;
        }) : x.series;
      }, getSeriesA11yElement: N, unhideChartElementFromAT: function x(T, y) {
        y.setAttribute("aria-hidden", !1), y !== T.renderTo && y.parentNode && y.parentNode !== L.body && (Array.prototype.forEach.call(y.parentNode.childNodes, function(S) {
          S.hasAttribute("aria-hidden") || S.setAttribute("aria-hidden", !0);
        }), x(T, y.parentNode));
      }, hideSeriesFromAT: function(x) {
        let T = N(x);
        T && T.setAttribute("aria-hidden", !0);
      }, scrollAxisToPoint: function(x) {
        let T = x.series.xAxis, y = x.series.yAxis, S = T && T.scrollbar ? T : y, u = S && S.scrollbar;
        if (u && j(u.to) && j(u.from)) {
          let A = u.to - u.from, M = function(f, m) {
            if (!j(f.dataMin) || !j(f.dataMax)) return 0;
            let C = f.toPixels(f.dataMin), F = f.toPixels(f.dataMax), _ = f.coll === "xAxis" ? "x" : "y";
            return (f.toPixels(m[_] || 0) - C) / (F - C);
          }(S, x);
          u.updatePosition(M - A / 2, M + A / 2), B(u, "changed", { from: u.from, to: u.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), i(e, "Accessibility/Utils/DOMElementProvider.js", [e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n) {
      let { doc: l } = o, { removeElement: L } = n;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let D = l.createElement.apply(l, arguments);
          return this.elements.push(D), D;
        }
        removeElement(D) {
          L(D), this.elements.splice(this.elements.indexOf(D), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(D) {
            L(D);
          }), this.elements = [];
        }
      };
    }), i(e, "Accessibility/Utils/EventProvider.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { addEvent: l } = n;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let L = l.apply(o, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: L }), L;
        }
        removeEvent(L) {
          let D = this.eventRemovers.map((j) => j.remover).indexOf(L);
          this.eventRemovers[D].remover(), this.eventRemovers.splice(D, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((L) => L.remover).forEach((L) => L()), this.eventRemovers = [];
        }
      };
    }), i(e, "Accessibility/AccessibilityComponent.js", [e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L) {
      let { fireEventOnWrappedOrUnwrappedElement: D } = o, { getFakeMouseEvent: j } = L;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(I, B) {
          this.chart = I, this.eventProvider = new l(), this.domElementProvider = new n(), this.proxyProvider = B, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(I, B, R, N) {
          return this.eventProvider.addEvent(I, B, R, N);
        }
        createElement(I, B) {
          return this.domElementProvider.createElement(I, B);
        }
        fakeClickEvent(I) {
          D(I, j("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), i(e, "Accessibility/KeyboardNavigationHandler.js", [e["Core/Utilities.js"]], function(o) {
      let { find: n } = o;
      return class {
        constructor(l, L) {
          this.chart = l, this.keyCodeMap = L.keyCodeMap || [], this.validate = L.validate, this.init = L.init, this.terminate = L.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(l) {
          let L = l.which || l.keyCode, D = this.response.noHandler, j = n(this.keyCodeMap, function(I) {
            return I[0].indexOf(L) > -1;
          });
          return j ? D = j[1].call(this, L, l) : L === 9 && (D = this.response[l.shiftKey ? "prev" : "next"]), D;
        }
      };
    }), i(e, "Accessibility/Components/ContainerComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L, D) {
      let { unhideChartElementFromAT: j, getChartTitle: I } = l, { doc: B } = L, { stripHTMLTagsFromString: R } = D;
      return class extends o {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let N = this.chart, x = "highcharts-title-" + N.index, T = R(N.langFormat("accessibility.svgContainerTitle", { chartTitle: I(N) }));
          if (T.length) {
            let y = this.svgTitleElement = this.svgTitleElement || B.createElementNS("http://www.w3.org/2000/svg", "title");
            y.textContent = T, y.id = x, N.renderTo.insertBefore(y, N.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let N = this.chart, x = N.langFormat("accessibility.svgContainerLabel", { chartTitle: I(N) });
          N.renderer.box && x.length && N.renderer.box.setAttribute("aria-label", x);
        }
        setGraphicContainerAttrs() {
          let N = this.chart, x = N.langFormat("accessibility.graphicContainerLabel", { chartTitle: I(N) });
          x.length && N.container.setAttribute("aria-label", x);
        }
        setRenderToAttrs() {
          let N = this.chart, x = N.options.accessibility.landmarkVerbosity !== "disabled", T = N.langFormat("accessibility.chartContainerLabel", { title: I(N), chart: N });
          T && (N.renderTo.setAttribute("role", x ? "region" : "group"), N.renderTo.setAttribute("aria-label", T));
        }
        makeCreditsAccessible() {
          let N = this.chart, x = N.credits;
          x && (x.textStr && x.element.setAttribute("aria-label", N.langFormat("accessibility.credits", { creditsStr: R(x.textStr, N.renderer.forExport) })), j(N, x.element));
        }
        getKeyboardNavigation() {
          let N = this.chart;
          return new n(N, { keyCodeMap: [], validate: function() {
            return !0;
          }, init: function() {
            let x = N.accessibility;
            x && x.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }
      };
    }), i(e, "Accessibility/FocusBorder.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { addEvent: l, pick: L } = o;
      return function(D) {
        let j = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function I() {
          let x = this.focusElement, T = this.options.accessibility.keyboardNavigation.focusBorder;
          x && (x.removeFocusBorder(), T.enabled && x.addFocusBorder(T.margin, { stroke: T.style.color, strokeWidth: T.style.lineWidth, r: T.style.borderRadius }));
        }
        function B(x, T) {
          let y = this.options.accessibility.keyboardNavigation.focusBorder, S = T || x.element;
          S && S.focus && (S.hcEvents && S.hcEvents.focusin || l(S, "focusin", function() {
          }), S.focus(), y.hideBrowserFocusOutline && (S.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = x, this.renderFocusBorder();
        }
        function R(x, T) {
          this.focusBorder && this.removeFocusBorder();
          let y = this.getBBox(), S = L(x, 3), u = this.parentGroup, A = this.scaleX || u && u.scaleX, M = this.scaleY || u && u.scaleY, f = (A ? !M : M) ? Math.abs(A || M || 1) : (Math.abs(A || 1) + Math.abs(M || 1)) / 2;
          y.x += this.translateX ? this.translateX : 0, y.y += this.translateY ? this.translateY : 0;
          let m = y.x - S, C = y.y - S, F = y.width + 2 * S, _ = y.height + 2 * S, E = !!this.text;
          if (this.element.nodeName === "text" || E) {
            let v, w, d = !!this.rotation, r = E ? { x: d ? 1 : 0, y: 0 } : (v = 0, w = 0, this.attr("text-anchor") === "middle" ? v = w = 0.5 : this.rotation ? v = 0.25 : w = 0.75, { x: v, y: w }), s = +this.attr("x"), p = +this.attr("y");
            if (isNaN(s) || (m = s - y.width * r.x - S), isNaN(p) || (C = p - y.height * r.y - S), E && d) {
              let b = F;
              F = _, _ = b, isNaN(s) || (m = s - y.height * r.x - S), isNaN(p) || (C = p - y.width * r.y - S);
            }
          }
          this.focusBorder = this.renderer.rect(m, C, F, _, parseInt((T && T.r || 0).toString(), 10) / f).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(u), this.renderer.styledMode || this.focusBorder.attr({ stroke: T && T.stroke, "stroke-width": (T && T.strokeWidth || 0) / f }), function(v, ...w) {
            v.focusBorderUpdateHooks || (v.focusBorderUpdateHooks = {}, j.forEach((d) => {
              let r = d + "Setter", s = v[r] || v._defaultSetter;
              v.focusBorderUpdateHooks[r] = s, v[r] = function() {
                let p = s.apply(v, arguments);
                return v.addFocusBorder.apply(v, w), p;
              };
            }));
          }(this, x, T), function(v) {
            if (v.focusBorderDestroyHook) return;
            let w = v.destroy;
            v.destroy = function() {
              return v.focusBorder && v.focusBorder.destroy && v.focusBorder.destroy(), w.apply(v, arguments);
            }, v.focusBorderDestroyHook = w;
          }(this);
        }
        function N() {
          var x;
          x = this, x.focusBorderUpdateHooks && (Object.keys(x.focusBorderUpdateHooks).forEach((T) => {
            let y = x.focusBorderUpdateHooks[T];
            y === x._defaultSetter ? delete x[T] : x[T] = y;
          }), delete x.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        D.compose = function(x, T) {
          let y = x.prototype, S = T.prototype;
          y.renderFocusBorder || (y.renderFocusBorder = I, y.setFocusToElement = B), S.addFocusBorder || (S.addFocusBorder = R, S.removeFocusBorder = N);
        };
      }(n || (n = {})), n;
    }), i(e, "Accessibility/Utils/Announcer.js", [e["Core/Renderer/HTML/AST.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { doc: j } = l, { addClass: I, visuallyHideElement: B } = L, { attr: R } = D;
      return class {
        constructor(N, x) {
          this.chart = N, this.domElementProvider = new n(), this.announceRegion = this.addAnnounceRegion(x);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(N) {
          o.setElementHTML(this.announceRegion, N), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = o.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(N) {
          let x = this.chart.announcerContainer || this.createAnnouncerContainer(), T = this.domElementProvider.createElement("div");
          return R(T, { "aria-hidden": !1, "aria-live": N, "aria-atomic": !0 }), this.chart.styledMode ? I(T, "highcharts-visually-hidden") : B(T), x.appendChild(T), T;
        }
        createAnnouncerContainer() {
          let N = this.chart, x = j.createElement("div");
          return R(x, { "aria-hidden": !1, class: "highcharts-announcer-container" }), x.style.position = "relative", N.renderTo.insertBefore(x, N.renderTo.firstChild), N.announcerContainer = x, x;
        }
      };
    }), i(e, "Accessibility/Components/AnnotationsA11y.js", [e["Accessibility/Utils/HTMLUtilities.js"]], function(o) {
      let { escapeStringForHTML: n, stripHTMLTagsFromString: l } = o;
      function L(B) {
        return (B.annotations || []).reduce((R, N) => (N.options && N.options.visible !== !1 && (R = R.concat(N.labels)), R), []);
      }
      function D(B) {
        return B.options && B.options.accessibility && B.options.accessibility.description || B.graphic && B.graphic.text && B.graphic.text.textStr || "";
      }
      function j(B) {
        let R = B.options && B.options.accessibility && B.options.accessibility.description;
        if (R) return R;
        let N = B.chart, x = D(B), T = B.points, y = (f) => f.graphic && f.graphic.element && f.graphic.element.getAttribute("aria-label") || "", S = T.filter((f) => !!f.graphic).map((f) => {
          let m = f.accessibility && f.accessibility.valueDescription || y(f), C = f && f.series.name || "";
          return (C ? C + ", " : "") + "data point " + m;
        }).filter((f) => !!f), u = S.length, A = u > 1 ? "MultiplePoints" : u ? "SinglePoint" : "NoPoints", M = { annotationText: x, annotation: B, numPoints: u, annotationPoint: S[0], additionalAnnotationPoints: S.slice(1) };
        return N.langFormat("accessibility.screenReaderSection.annotations.description" + A, M);
      }
      function I(B) {
        return L(B).map((R) => {
          let N = n(l(j(R), B.renderer.forExport));
          return N ? `<li>${N}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(B) {
        let R = B.annotations;
        return R && R.length ? `<ul style="list-style-type: none">${I(B).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: j, getAnnotationListItems: I, getPointAnnotationTexts: function(B) {
        let R = L(B.series.chart).filter((N) => N.points.indexOf(B) > -1);
        return R.length ? R.map((N) => `${D(N)}`) : [];
      } };
    }), i(e, "Accessibility/Components/InfoRegionsComponent.js", [e["Accessibility/A11yI18n.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Components/AnnotationsA11y.js"], e["Core/Renderer/HTML/AST.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R, N) {
      let { getAnnotationsInfoHTML: x } = L, { getAxisDescription: T, getAxisRangeDescription: y, getChartTitle: S, unhideChartElementFromAT: u } = j, { format: A } = I, { doc: M } = B, { addClass: f, getElement: m, getHeadingTagNameForElement: C, stripHTMLTagsFromString: F, visuallyHideElement: _ } = R, { attr: E, pick: v, replaceNested: w } = N;
      function d(r) {
        return w(r, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends n {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let r = this.chart, s = this;
          this.initRegionsDefinitions(), this.addEvent(r, "aftergetTableAST", function(p) {
            s.onDataTableCreated(p);
          }), this.addEvent(r, "afterViewData", function(p) {
            p.wasHidden && (s.dataTableDiv = p.element, setTimeout(function() {
              s.focusDataTable();
            }, 300));
          }), this.addEvent(r, "afterHideData", function() {
            s.viewDataTableButton && s.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), r.exporting && this.addEvent(r, "afterPrint", function() {
            s.updateAllScreenReaderSections();
          }), this.announcer = new l(r, "assertive");
        }
        initRegionsDefinitions() {
          let r = this, s = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(p) {
            let b = s.screenReaderSection.beforeChartFormatter;
            return b ? b(p) : r.defaultBeforeChartFormatter(p);
          }, insertIntoDOM: function(p, b) {
            b.renderTo.insertBefore(p, b.renderTo.firstChild);
          }, afterInserted: function() {
            r.sonifyButtonId !== void 0 && r.initSonifyButton(r.sonifyButtonId), r.dataTableButtonId !== void 0 && r.initDataTableButton(r.dataTableButtonId);
          } }, after: { element: null, buildContent: function(p) {
            let b = s.screenReaderSection.afterChartFormatter;
            return b ? b(p) : r.defaultAfterChartFormatter();
          }, insertIntoDOM: function(p, b) {
            b.renderTo.insertBefore(p, b.container.nextSibling);
          }, afterInserted: function() {
            r.chart.accessibility && s.keyboardNavigation.enabled && r.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let r = this;
          Object.keys(this.screenReaderSections).forEach(function(s) {
            r.updateScreenReaderSection(s);
          });
        }
        getLinkedDescriptionElement() {
          let r = this.chart.options.accessibility.linkedDescription;
          if (!r) return;
          if (typeof r != "string") return r;
          let s = A(r, this.chart), p = M.querySelectorAll(s);
          if (p.length === 1) return p[0];
        }
        setLinkedDescriptionAttrs() {
          let r = this.linkedDescriptionElement;
          r && (r.setAttribute("aria-hidden", "true"), f(r, "highcharts-linked-description"));
        }
        updateScreenReaderSection(r) {
          let s = this.chart, p = this.screenReaderSections[r], b = p.buildContent(s), c = p.element = p.element || this.createElement("div"), h = c.firstChild || this.createElement("div");
          b ? (this.setScreenReaderSectionAttribs(c, r), D.setElementHTML(h, b), c.appendChild(h), p.insertIntoDOM(c, s), s.styledMode ? f(h, "highcharts-visually-hidden") : _(h), u(s, h), p.afterInserted && p.afterInserted()) : (c.parentNode && c.parentNode.removeChild(c), p.element = null);
        }
        setScreenReaderSectionAttribs(r, s) {
          let p = this.chart, b = p.langFormat("accessibility.screenReaderSection." + s + "RegionLabel", { chart: p, chartTitle: S(p) });
          E(r, { id: `highcharts-screen-reader-region-${s}-${p.index}`, "aria-label": b || void 0 }), r.style.position = "relative", b && r.setAttribute("role", p.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let r = this.chart, s = r.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!s) return "";
          let p = this.getAxesDescription(), b = r.sonify && r.options.sonification && r.options.sonification.enabled, c = "highcharts-a11y-sonify-data-btn-" + r.index, h = "hc-linkto-highcharts-data-table-" + r.index, g = x(r), k = r.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: r }), P = { headingTagName: C(r.renderTo), chartTitle: S(r), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: p.xAxis, yAxisDescription: p.yAxis, playAsSoundButton: b ? this.getSonifyButtonText(c) : "", viewTableButton: r.getCSV ? this.getDataTableButtonText(h) : "", annotationsTitle: g ? k : "", annotationsList: g }, O = o.i18nFormat(s, P, r);
          return this.dataTableButtonId = h, this.sonifyButtonId = c, d(O);
        }
        defaultAfterChartFormatter() {
          let r = this.chart, s = r.options.accessibility.screenReaderSection.afterChartFormat;
          if (!s) return "";
          let p = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return d(o.i18nFormat(s, p, r));
        }
        getLinkedDescription() {
          let r = this.linkedDescriptionElement;
          return F(r && r.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let r = this.chart.options, s = r.caption, p = s && s.text, b = this.getLinkedDescription();
          return r.accessibility.description || b || p || "";
        }
        getTypeDescriptionText() {
          let r = this.chart;
          return r.types ? r.options.accessibility.typeDescription || function(s, p) {
            let b = p[0], c = s.series && s.series[0] || {}, h = s.mapView && s.mapView.geoMap && s.mapView.geoMap.title, g = { numSeries: s.series.length, numPoints: c.points && c.points.length, chart: s, mapTitle: h };
            return b ? b === "map" || b === "tiledwebmap" ? g.mapTitle ? s.langFormat("accessibility.chartTypes.mapTypeDescription", g) : s.langFormat("accessibility.chartTypes.unknownMap", g) : s.types.length > 1 ? s.langFormat("accessibility.chartTypes.combinationChart", g) : function(k, P, O) {
              let z = P[0], W = k.langFormat("accessibility.seriesTypeDescriptions." + z, O), G = k.series && k.series.length < 2 ? "Single" : "Multiple";
              return (k.langFormat("accessibility.chartTypes." + z + G, O) || k.langFormat("accessibility.chartTypes.default" + G, O)) + (W ? " " + W : "");
            }(s, p, g) : s.langFormat("accessibility.chartTypes.emptyChart", g);
          }(r, r.types) : "";
        }
        getDataTableButtonText(r) {
          let s = this.chart;
          return '<button id="' + r + '">' + s.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: s, chartTitle: S(s) }) + "</button>";
        }
        getSonifyButtonText(r) {
          let s = this.chart;
          return s.options.sonification && s.options.sonification.enabled === !1 ? "" : '<button id="' + r + '">' + s.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: s, chartTitle: S(s) }) + "</button>";
        }
        getSubtitleText() {
          let r = this.chart.options.subtitle;
          return F(r && r.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let r = m(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (r) return r.outerHTML;
          let s = this.chart, p = s.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: s });
          return '<div id="highcharts-end-of-chart-marker-' + s.index + '">' + p + "</div>";
        }
        onDataTableCreated(r) {
          let s = this.chart;
          if (s.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let p = r.tree.attributes || {};
            p.tabindex = -1, p.summary = s.langFormat("accessibility.table.tableSummary", { chart: s }), r.tree.attributes = p;
          }
        }
        focusDataTable() {
          let r = this.dataTableDiv, s = r && r.getElementsByTagName("table")[0];
          s && s.focus && s.focus();
        }
        initSonifyButton(r) {
          let s = this.sonifyButton = m(r), p = this.chart, b = (c) => {
            s && (s.setAttribute("aria-hidden", "true"), s.setAttribute("aria-label", "")), c.preventDefault(), c.stopPropagation();
            let h = p.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: p });
            this.announcer.announce(h), setTimeout(() => {
              s && (s.removeAttribute("aria-hidden"), s.removeAttribute("aria-label")), p.sonify && p.sonify();
            }, 1e3);
          };
          s && p && (s.setAttribute("tabindex", -1), s.onclick = function(c) {
            (p.options.accessibility && p.options.accessibility.screenReaderSection.onPlayAsSoundClick || b).call(this, c, p);
          });
        }
        initDataTableButton(r) {
          let s = this.viewDataTableButton = m(r), p = this.chart, b = r.replace("hc-linkto-", "");
          s && (E(s, { tabindex: -1, "aria-expanded": !!m(b) }), s.onclick = p.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            p.viewData();
          });
        }
        getAxesDescription() {
          let r = this.chart, s = function(k, P) {
            let O = r[k];
            return O.length > 1 || O[0] && v(O[0].options.accessibility && O[0].options.accessibility.enabled, P);
          }, p = !!r.types && 0 > r.types.indexOf("map") && 0 > r.types.indexOf("treemap") && 0 > r.types.indexOf("tilemap"), b = !!r.hasCartesianSeries, c = s("xAxis", !r.angular && b && p), h = s("yAxis", b && p), g = {};
          return c && (g.xAxis = this.getAxisDescriptionText("xAxis")), h && (g.yAxis = this.getAxisDescriptionText("yAxis")), g;
        }
        getAxisDescriptionText(r) {
          let s = this.chart, p = s[r];
          return s.langFormat("accessibility.axis." + r + "Description" + (p.length > 1 ? "Plural" : "Singular"), { chart: s, names: p.map(function(b) {
            return T(b);
          }), ranges: p.map(function(b) {
            return y(b);
          }), numAxes: p.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), i(e, "Accessibility/Components/MenuComponent.js", [e["Core/Utilities.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L, D) {
      let { attr: j } = o, { getChartTitle: I, unhideChartElementFromAT: B } = L, { getFakeMouseEvent: R } = D;
      function N(T) {
        return T.exportSVGElements && T.exportSVGElements[0];
      }
      class x extends n {
        init() {
          let y = this.chart, S = this;
          this.addEvent(y, "exportMenuShown", function() {
            S.onMenuShown();
          }), this.addEvent(y, "exportMenuHidden", function() {
            S.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let y = this.chart.exportContextMenu;
          y && y.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let y = this.chart, S = y.exportContextMenu;
          S && (this.addAccessibleContextMenuAttribs(), B(y, S)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(y) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", y);
        }
        onChartRender() {
          let y = this.chart, S = y.focusElement, u = y.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && S && S === y.exportingGroup && (S.focusBorder ? y.setFocusToElement(S, this.exportButtonProxy.innerElement) : u && u.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let y = this.chart, S = this.proxyProvider, u = N(y);
          (function(A) {
            let M = A.options.exporting, f = N(A);
            return !!(M && M.enabled !== !1 && M.accessibility && M.accessibility.enabled && f && f.element);
          })(y) && u && (this.exportButtonProxy = S.addProxyElement("chartMenu", { click: u }, "button", { "aria-label": y.langFormat("accessibility.exporting.menuButtonLabel", { chart: y, chartTitle: I(y) }), "aria-expanded": !1, title: y.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let y = this.chart, S = y.exportDivElements;
          if (S && S.length) {
            S.forEach((A) => {
              A && (A.tagName !== "LI" || A.children && A.children.length ? A.setAttribute("aria-hidden", "true") : A.setAttribute("tabindex", -1));
            });
            let u = S[0] && S[0].parentNode;
            u && j(u, { "aria-hidden": void 0, "aria-label": y.langFormat("accessibility.exporting.chartMenuLabel", { chart: y }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let y = this.keyCodes, S = this.chart, u = this;
          return new l(S, { keyCodeMap: [[[y.left, y.up], function() {
            return u.onKbdPrevious(this);
          }], [[y.right, y.down], function() {
            return u.onKbdNext(this);
          }], [[y.enter, y.space], function() {
            return u.onKbdClick(this);
          }]], validate: function() {
            return !!S.exporting && S.options.exporting.enabled !== !1 && S.options.exporting.accessibility.enabled !== !1;
          }, init: function() {
            let A = u.exportButtonProxy, M = u.chart.exportingGroup;
            A && M && S.setFocusToElement(M, A.innerElement);
          }, terminate: function() {
            S.hideExportMenu();
          } });
        }
        onKbdPrevious(y) {
          let S = this.chart, u = S.options.accessibility, A = y.response, M = S.highlightedExportItemIx || 0;
          for (; M--; ) if (S.highlightExportItem(M)) return A.success;
          return u.keyboardNavigation.wrapAround ? (S.highlightLastExportItem(), A.success) : A.prev;
        }
        onKbdNext(y) {
          let S = this.chart, u = S.options.accessibility, A = y.response;
          for (let M = (S.highlightedExportItemIx || 0) + 1; M < S.exportDivElements.length; ++M) if (S.highlightExportItem(M)) return A.success;
          return u.keyboardNavigation.wrapAround ? (S.highlightExportItem(0), A.success) : A.next;
        }
        onKbdClick(y) {
          let S = this.chart, u = S.exportDivElements[S.highlightedExportItemIx], A = N(S).element;
          return S.openMenu ? this.fakeClickEvent(u) : (this.fakeClickEvent(A), S.highlightExportItem(0)), y.response.success;
        }
      }
      return function(T) {
        function y() {
          let M = N(this);
          if (M) {
            let f = M.element;
            f.onclick && f.onclick(R("click"));
          }
        }
        function S() {
          let M = this.exportDivElements;
          M && this.exportContextMenu && this.openMenu && (M.forEach((f) => {
            f && f.className === "highcharts-menu-item" && f.onmouseout && f.onmouseout(R("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function u(M) {
          let f = this.exportDivElements && this.exportDivElements[M], m = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (f && f.tagName === "LI" && !(f.children && f.children.length)) {
            let C = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return f.focus && C && f.focus(), m && m.onmouseout && m.onmouseout(R("mouseout")), f.onmouseover && f.onmouseover(R("mouseover")), this.highlightedExportItemIx = M, !0;
          }
          return !1;
        }
        function A() {
          if (this.exportDivElements) {
            let M = this.exportDivElements.length;
            for (; M--; ) if (this.highlightExportItem(M)) return !0;
          }
          return !1;
        }
        T.compose = function(M) {
          let f = M.prototype;
          f.hideExportMenu || (f.hideExportMenu = S, f.highlightExportItem = u, f.highlightLastExportItem = A, f.showExportMenu = y);
        };
      }(x || (x = {})), x;
    }), i(e, "Accessibility/KeyboardNavigation.js", [e["Core/Globals.js"], e["Accessibility/Components/MenuComponent.js"], e["Core/Utilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L, D) {
      let { doc: j, win: I } = o, { addEvent: B, defined: R, fireEvent: N } = l, { getElement: x, simulatedEventTarget: T } = D;
      class y {
        constructor(u, A) {
          this.currentModuleIx = NaN, this.modules = [], this.init(u, A);
        }
        init(u, A) {
          let M = this.eventProvider = new L();
          this.chart = u, this.components = A, this.modules = [], this.currentModuleIx = 0, this.update(), M.addEvent(this.tabindexContainer, "keydown", (f) => this.onKeydown(f)), M.addEvent(this.tabindexContainer, "focus", (f) => this.onFocus(f)), ["mouseup", "touchend"].forEach((f) => M.addEvent(j, f, (m) => this.onMouseUp(m))), ["mousedown", "touchstart"].forEach((f) => M.addEvent(u.renderTo, f, () => {
            this.isClickingChart = !0;
          }));
        }
        update(u) {
          let A = this.chart.options.accessibility, M = A && A.keyboardNavigation, f = this.components;
          this.updateContainerTabindex(), M && M.enabled && u && u.length ? (this.modules = u.reduce(function(m, C) {
            let F = f[C].getKeyboardNavigation();
            return m.concat(F);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let u = x(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), u ? (this.makeElementAnExitAnchor(u), this.exitAnchor = u) : this.createExitAnchor();
        }
        move(u) {
          let A = this.modules && this.modules[this.currentModuleIx];
          A && A.terminate && A.terminate(u), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += u;
          let M = this.modules && this.modules[this.currentModuleIx];
          if (M) {
            if (M.validate && !M.validate()) return this.move(u);
            if (M.init) return M.init(u), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, u > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }
        onFocus(u) {
          let A = this.chart, M = u.relatedTarget && A.container.contains(u.relatedTarget), f = A.options.accessibility, m = f && f.keyboardNavigation;
          if (m && m.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !M) {
            let C = this.getFirstValidModuleIx();
            C !== null && (this.currentModuleIx = C, this.modules[C].init(1));
          }
          this.keyboardReset = !1, this.exiting = !1;
        }
        onMouseUp(u) {
          if (delete this.isClickingChart, !this.keyboardReset && u.relatedTarget !== T) {
            let A = this.chart;
            if (!u.target || !A.container.contains(u.target)) {
              let M = this.modules && this.modules[this.currentModuleIx || 0];
              M && M.terminate && M.terminate(), this.currentModuleIx = 0;
            }
            A.focusElement && (A.focusElement.removeFocusBorder(), delete A.focusElement), this.keyboardReset = !0;
          }
        }
        onKeydown(u) {
          let A, M = u || I.event, f = this.modules && this.modules.length && this.modules[this.currentModuleIx], m = M.target;
          if ((!m || m.nodeName !== "INPUT" || m.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, f)) {
            let C = f.run(M);
            C === f.response.success ? A = !0 : C === f.response.prev ? A = this.move(-1) : C === f.response.next && (A = this.move(1)), A && (M.preventDefault(), M.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let u, A = this.chart.options.accessibility, M = A && A.keyboardNavigation, f = !(M && M.enabled === !1), m = this.chart, C = m.container;
          m.renderTo.hasAttribute("tabindex") ? (C.removeAttribute("tabindex"), u = m.renderTo) : u = C, this.tabindexContainer = u;
          let F = u.getAttribute("tabindex");
          f && !F ? u.setAttribute("tabindex", "0") : f || m.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let u = this.chart, A = this.exitAnchor = j.createElement("div");
          u.renderTo.appendChild(A), this.makeElementAnExitAnchor(A);
        }
        makeElementAnExitAnchor(u) {
          let A = this.tabindexContainer.getAttribute("tabindex") || 0;
          u.setAttribute("class", "highcharts-exit-anchor"), u.setAttribute("tabindex", A), u.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(u);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let u = this.eventProvider.eventRemovers.find((A) => A.element === this.exitAnchor);
            u && R(u.remover) && this.eventProvider.removeEvent(u.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(u) {
          let A = this.chart, M = this;
          this.eventProvider.addEvent(u, "focus", function(f) {
            let m = f || I.event, C = !(m.relatedTarget && A.container.contains(m.relatedTarget) || M.exiting);
            if (A.focusElement && delete A.focusElement, C) {
              if (M.tabbingInBackwards = !0, M.tabindexContainer.focus(), delete M.tabbingInBackwards, m.preventDefault(), M.modules && M.modules.length) {
                M.currentModuleIx = M.modules.length - 1;
                let F = M.modules[M.currentModuleIx];
                F && F.validate && !F.validate() ? M.move(-1) : F && F.init(-1);
              }
            } else M.exiting = !1;
          });
        }
        getFirstValidModuleIx() {
          let u = this.modules.length;
          for (let A = 0; A < u; ++A) {
            let M = this.modules[A];
            if (!M.validate || M.validate()) return A;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(S) {
        function u() {
          let M = this;
          N(this, "dismissPopupContent", {}, function() {
            M.tooltip && M.tooltip.hide(0), M.hideExportMenu();
          });
        }
        function A(M) {
          (M.which || M.keyCode) === 27 && o.charts && o.charts.forEach((f) => {
            f && f.dismissPopupContent && f.dismissPopupContent();
          });
        }
        S.compose = function(M) {
          n.compose(M);
          let f = M.prototype;
          return f.dismissPopupContent || (f.dismissPopupContent = u, B(j, "keydown", A)), M;
        };
      }(y || (y = {})), y;
    }), i(e, "Accessibility/Components/LegendComponent.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Legend/Legend.js"], e["Core/Utilities.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { animObject: R } = o, { doc: N } = n, { addEvent: x, fireEvent: T, isNumber: y, pick: S, syncTimeout: u } = L, { getChartTitle: A } = I, { stripHTMLTagsFromString: M, addClass: f, removeClass: m } = B;
      function C(E) {
        let v = E.legend && E.legend.allItems, w = E.options.legend.accessibility || {}, d = E.colorAxis && E.colorAxis.some((r) => !r.dataClasses || !r.dataClasses.length);
        return !!(v && v.length && !d && w.enabled !== !1);
      }
      function F(E, v) {
        let w = v.legendItem || {};
        for (let d of (v.setState(E ? "hover" : "", !0), ["group", "label", "symbol"])) {
          let r = w[d], s = r && r.element || r;
          s && T(s, E ? "mouseover" : "mouseout");
        }
      }
      class _ extends D {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let v = this;
          this.recreateProxies(), this.addEvent(l, "afterScroll", function() {
            this.chart === v.chart && (v.proxyProvider.updateGroupProxyElementPositions("legend"), v.updateLegendItemProxyVisibility(), v.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(v.highlightedLegendItemIx));
          }), this.addEvent(l, "afterPositionItem", function(w) {
            this.chart === v.chart && this.chart.renderer && v.updateProxyPositionForItem(w.item);
          }), this.addEvent(l, "afterRender", function() {
            this.chart === v.chart && this.chart.renderer && v.recreateProxies() && u(() => v.proxyProvider.updateGroupProxyElementPositions("legend"), R(S(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let v, w = this.chart, d = w.legend, r = d.allItems || [], s = d.currentPage || 1, p = d.clipHeight || 0;
          r.forEach((b) => {
            if (b.a11yProxyElement) {
              let c = d.pages && d.pages.length, h = b.a11yProxyElement.element, g = !1;
              if (v = b.legendItem || {}, c) {
                let k = v.pageIx || 0;
                g = (v.y || 0) + (v.label ? Math.round(v.label.getBBox().height) : 0) - d.pages[k] > p || k !== s - 1;
              }
              g ? w.styledMode ? f(h, "highcharts-a11y-invisible") : h.style.visibility = "hidden" : (m(h, "highcharts-a11y-invisible"), h.style.visibility = "");
            }
          });
        }
        onChartRender() {
          C(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(v) {
          let w = this.chart, d = w.legend, r = (d.currentPage || 1) + v, s = d.pages || [];
          if (r > 0 && r <= s.length) {
            let p = 0;
            for (let b of d.allItems) ((b.legendItem || {}).pageIx || 0) + 1 === r && w.highlightLegendItem(p) && (this.highlightedLegendItemIx = p), ++p;
          }
        }
        updateProxyPositionForItem(v) {
          v.a11yProxyElement && v.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let v = N.activeElement, w = this.proxyGroup, d = v && w && w.contains(v);
          return this.removeProxies(), !!C(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), d && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let v = this.chart, w = M((v.legend && v.legend.options.title && v.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), v.renderer.forExport), d = v.langFormat("accessibility.legend.legendLabel" + (w ? "" : "NoTitle"), { chart: v, legendTitle: w, chartTitle: A(v) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": d });
        }
        addLegendProxyGroup() {
          let v = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: v });
        }
        proxyLegendItems() {
          let v, w = this;
          ((this.chart.legend || {}).allItems || []).forEach((d) => {
            (v = d.legendItem || {}).label && v.label.element && w.proxyLegendItem(d);
          });
        }
        proxyLegendItem(v) {
          let w = v.legendItem || {};
          if (!w.label || !w.group) return;
          let d = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: M(v.name, this.chart.renderer.forExport), item: v }), r = { tabindex: -1, "aria-pressed": v.visible, "aria-label": d }, s = w.group.div ? w.label : w.group;
          v.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: w.label, visual: s.element }, "button", r);
        }
        getKeyboardNavigation() {
          let v = this.keyCodes, w = this, d = this.chart;
          return new j(d, { keyCodeMap: [[[v.left, v.right, v.up, v.down], function(r) {
            return w.onKbdArrowKey(this, r);
          }], [[v.enter, v.space], function() {
            return w.onKbdClick(this);
          }], [[v.pageDown, v.pageUp], function(r) {
            let s = r === v.pageDown ? 1 : -1;
            return w.highlightAdjacentLegendPage(s), this.response.success;
          }]], validate: function() {
            return w.shouldHaveLegendNavigation();
          }, init: function() {
            d.highlightLegendItem(0), w.highlightedLegendItemIx = 0;
          }, terminate: function() {
            w.highlightedLegendItemIx = -1, d.legend.allItems.forEach((r) => F(!1, r));
          } });
        }
        onKbdArrowKey(v, w) {
          let { keyCodes: { left: d, up: r }, highlightedLegendItemIx: s, chart: p } = this, b = p.legend.allItems.length, c = p.options.accessibility.keyboardNavigation.wrapAround, h = w === d || w === r ? -1 : 1;
          return p.highlightLegendItem(s + h) ? this.highlightedLegendItemIx += h : c && b > 1 && (this.highlightedLegendItemIx = h > 0 ? 0 : b - 1, p.highlightLegendItem(this.highlightedLegendItemIx)), v.response.success;
        }
        onKbdClick(v) {
          let w = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return w && w.a11yProxyElement && w.a11yProxyElement.click(), v.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!C(this.chart)) return !1;
          let v = this.chart, w = (v.options.legend || {}).accessibility || {};
          return !!(v.legend.display && w.keyboardNavigation && w.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(E) {
        function v(d) {
          let r = this.legend.allItems, s = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, p = r[d], b = (p == null ? void 0 : p.legendItem) || {};
          if (p) {
            y(s) && r[s] && F(!1, r[s]), function(g, k) {
              let P = (g.allItems[k].legendItem || {}).pageIx, O = g.currentPage;
              P !== void 0 && P + 1 !== O && g.scroll(1 + P - O);
            }(this.legend, d);
            let c = b.label, h = p.a11yProxyElement && p.a11yProxyElement.innerElement;
            return c && c.element && h && this.setFocusToElement(c, h), F(!0, p), !0;
          }
          return !1;
        }
        function w(d) {
          let r = this.chart.options.accessibility, s = d.item;
          r.enabled && s && s.a11yProxyElement && s.a11yProxyElement.innerElement.setAttribute("aria-pressed", d.visible ? "true" : "false");
        }
        E.compose = function(d, r) {
          let s = d.prototype;
          s.highlightLegendItem || (s.highlightLegendItem = v, x(r, "afterColorizeItem", w));
        };
      }(_ || (_ = {})), _;
    }), i(e, "Stock/Navigator/ChartNavigatorComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let l, { isTouchDevice: L } = o, { addEvent: D, merge: j, pick: I } = n, B = [];
      function R() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function N() {
        var F;
        let A, M, f, m = this.legend, C = this.navigator;
        if (C) {
          A = m && m.options, M = C.xAxis, f = C.yAxis;
          let { scrollbarHeight: _, scrollButtonSize: E } = C;
          this.inverted ? (C.left = C.opposite ? this.chartWidth - _ - C.height : this.spacing[3] + _, C.top = this.plotTop + E) : (C.left = I(M.left, this.plotLeft + E), C.top = C.navigatorOptions.top || this.chartHeight - C.height - _ - (((F = this.scrollbar) == null ? void 0 : F.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (A && A.verticalAlign === "bottom" && A.layout !== "proximate" && A.enabled && !A.floating ? m.legendHeight + I(A.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), M && f && (this.inverted ? M.options.left = f.options.left = C.left : M.options.top = f.options.top = C.top, M.setAxisSize(), f.setAxisSize());
        }
      }
      function x(A) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new l(this), I(A.redraw, !0) && this.redraw(A.animation));
      }
      function T() {
        let A = this.options;
        (A.navigator.enabled || A.scrollbar.enabled) && (this.scroller = this.navigator = new l(this));
      }
      function y() {
        let A = this.options, M = A.navigator, f = A.rangeSelector;
        if ((M && M.enabled || f && f.enabled) && (!L && this.zooming.type === "x" || L && this.zooming.pinchType === "x")) return !1;
      }
      function S(A) {
        let M = A.navigator;
        if (M && A.xAxis[0]) {
          let f = A.xAxis[0].getExtremes();
          M.render(f.min, f.max);
        }
      }
      function u(A) {
        let M = A.options.navigator || {}, f = A.options.scrollbar || {};
        !this.navigator && !this.scroller && (M.enabled || f.enabled) && (j(!0, this.options.navigator, M), j(!0, this.options.scrollbar, f), delete A.options.navigator, delete A.options.scrollbar);
      }
      return { compose: function(A, M) {
        if (n.pushUnique(B, A)) {
          let f = A.prototype;
          l = M, f.callbacks.push(S), D(A, "afterAddSeries", R), D(A, "afterSetChartSize", N), D(A, "afterUpdate", x), D(A, "beforeRender", T), D(A, "beforeShowResetZoom", y), D(A, "update", u);
        }
      } };
    }), i(e, "Core/Axis/NavigatorAxisComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isTouchDevice: l } = o, { addEvent: L, correctFloat: D, defined: j, isNumber: I, pick: B } = n;
      function R() {
        this.navigatorAxis || (this.navigatorAxis = new x(this));
      }
      function N(T) {
        let y, S = this.chart, u = S.options, A = u.navigator, M = this.navigatorAxis, f = S.zooming.pinchType, m = u.rangeSelector, C = S.zooming.type;
        if (this.isXAxis && (A != null && A.enabled || m != null && m.enabled)) {
          if (C === "y" && T.trigger === "zoom") y = !1;
          else if ((T.trigger === "zoom" && C === "xy" || l && f === "xy") && this.options.range) {
            let F = M.previousZoom;
            j(T.min) ? M.previousZoom = [this.min, this.max] : F && (T.min = F[0], T.max = F[1], M.previousZoom = void 0);
          }
        }
        y !== void 0 && T.preventDefault();
      }
      class x {
        static compose(y) {
          y.keepProps.includes("navigatorAxis") || (y.keepProps.push("navigatorAxis"), L(y, "init", R), L(y, "setExtremes", N));
        }
        constructor(y) {
          this.axis = y;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(y, S, u, A) {
          let M = this.axis, f = (M.pointRange || 0) / 2, m = B(u, M.translate(y, !0, !M.horiz)), C = B(A, M.translate(S, !0, !M.horiz));
          return j(u) || (m = D(m + f)), j(A) || (C = D(C - f)), I(m) && I(C) || (m = C = void 0), { min: m, max: C };
        }
      }
      return x;
    }), i(e, "Stock/Navigator/NavigatorDefaults.js", [e["Core/Color/Color.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n) {
      let { parse: l } = o, { seriesTypes: L } = n;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: l("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: L.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), i(e, "Stock/Navigator/NavigatorSymbols.js", [e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n) {
      let { relativeLength: l } = n;
      return { "navigator-handle": function(L, D, j, I, B = {}) {
        let R = B.width ? B.width / 2 : j, N = l(B.borderRadius || 0, Math.min(2 * R, I));
        return [["M", -1.5, (I = B.height || I) / 2 - 3.5], ["L", -1.5, I / 2 + 4.5], ["M", 0.5, I / 2 - 3.5], ["L", 0.5, I / 2 + 4.5], ...o.rect(-R - 1, 0.5, 2 * R + 1, I, { r: N })];
      } };
    }), i(e, "Stock/Utilities/StockUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n } = o;
      return { setFixedRange: function(l) {
        let L = this.xAxis[0];
        n(L.dataMax) && n(L.dataMin) && l ? this.fixedRange = Math.min(l, L.dataMax - L.dataMin) : this.fixedRange = l;
      } };
    }), i(e, "Stock/Navigator/NavigatorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/Navigator/NavigatorSymbols.js"], e["Core/Renderer/RendererRegistry.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { setOptions: R } = o, { composed: N } = n, { getRendererType: x } = j, { setFixedRange: T } = I, { addEvent: y, extend: S, pushUnique: u } = B;
      function A() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(M, f, m) {
        l.compose(f), u(N, "Navigator") && (M.prototype.setFixedRange = T, S(x().prototype.symbols, D), y(m, "afterUpdate", A), R({ navigator: L }));
      } };
    }), i(e, "Core/Axis/ScrollbarAxis.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { composed: L } = o, { addEvent: D, defined: j, pick: I, pushUnique: B } = n;
      return function(R) {
        let N;
        function x(u) {
          let A = I(u.options && u.options.min, u.min), M = I(u.options && u.options.max, u.max);
          return { axisMin: A, axisMax: M, scrollMin: j(u.dataMin) ? Math.min(A, u.min, u.dataMin, I(u.threshold, 1 / 0)) : A, scrollMax: j(u.dataMax) ? Math.max(M, u.max, u.dataMax, I(u.threshold, -1 / 0)) : M };
        }
        function T() {
          let u = this.scrollbar, A = u && !u.options.opposite, M = this.horiz ? 2 : A ? 3 : 1;
          u && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[M] += u.size + (u.options.margin || 0));
        }
        function y() {
          let u = this;
          u.options && u.options.scrollbar && u.options.scrollbar.enabled && (u.options.scrollbar.vertical = !u.horiz, u.options.startOnTick = u.options.endOnTick = !1, u.scrollbar = new N(u.chart.renderer, u.options.scrollbar, u.chart), D(u.scrollbar, "changed", function(A) {
            let M, f, { axisMin: m, axisMax: C, scrollMin: F, scrollMax: _ } = x(u), E = _ - F;
            if (j(m) && j(C))
              if (u.horiz && !u.reversed || !u.horiz && u.reversed ? (M = F + E * this.to, f = F + E * this.from) : (M = F + E * (1 - this.from), f = F + E * (1 - this.to)), this.shouldUpdateExtremes(A.DOMType)) {
                let v = A.DOMType !== "mousemove" && A.DOMType !== "touchmove" && void 0;
                u.setExtremes(f, M, !0, v, A);
              } else this.setRange(this.from, this.to);
          }));
        }
        function S() {
          let u, A, M, { scrollMin: f, scrollMax: m } = x(this), C = this.scrollbar, F = this.axisTitleMargin + (this.titleOffset || 0), _ = this.chart.scrollbarsOffsets, E = this.options.margin || 0;
          if (C && _) {
            if (this.horiz) this.opposite || (_[1] += F), C.position(this.left, this.top + this.height + 2 + _[1] - (this.opposite ? E : 0), this.width, this.height), this.opposite || (_[1] += E), u = 1;
            else {
              let v;
              this.opposite && (_[0] += F), v = C.options.opposite ? this.left + this.width + 2 + _[0] - (this.opposite ? 0 : E) : this.opposite ? 0 : E, C.position(v, this.top, this.width, this.height), this.opposite && (_[0] += E), u = 0;
            }
            if (_[u] += C.size + (C.options.margin || 0), isNaN(f) || isNaN(m) || !j(this.min) || !j(this.max) || this.dataMin === this.dataMax) C.setRange(0, 1);
            else if (this.min === this.max) {
              let v = this.pointRange / (this.dataMax + 1);
              A = v * this.min, M = v * (this.max + 1), C.setRange(A, M);
            } else A = (this.min - f) / (m - f), M = (this.max - f) / (m - f), this.horiz && !this.reversed || !this.horiz && this.reversed ? C.setRange(A, M) : C.setRange(1 - M, 1 - A);
          }
        }
        R.compose = function(u, A) {
          B(L, "Axis.Scrollbar") && (N = A, D(u, "afterGetOffset", T), D(u, "afterInit", y), D(u, "afterRender", S));
        };
      }(l || (l = {})), l;
    }), i(e, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), i(e, "Stock/Scrollbar/Scrollbar.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/ScrollbarAxis.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { defaultOptions: j } = o, { addEvent: I, correctFloat: B, crisp: R, defined: N, destroyObjectProperties: x, fireEvent: T, merge: y, pick: S, removeEvent: u } = D;
      class A {
        static compose(f) {
          l.compose(f, A);
        }
        static swapXY(f, m) {
          return m && f.forEach((C) => {
            let F, _ = C.length;
            for (let E = 0; E < _; E += 2) typeof (F = C[E + 1]) == "number" && (C[E + 1] = C[E + 2], C[E + 2] = F);
          }), f;
        }
        constructor(f, m, C) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(f, m, C);
        }
        addEvents() {
          let f = this.options.inverted ? [1, 0] : [0, 1], m = this.scrollbarButtons, C = this.scrollbarGroup.element, F = this.track.element, _ = this.mouseDownHandler.bind(this), E = this.mouseMoveHandler.bind(this), v = this.mouseUpHandler.bind(this), w = [[m[f[0]].element, "click", this.buttonToMinClick.bind(this)], [m[f[1]].element, "click", this.buttonToMaxClick.bind(this)], [F, "click", this.trackClick.bind(this)], [C, "mousedown", _], [C.ownerDocument, "mousemove", E], [C.ownerDocument, "mouseup", v], [C, "touchstart", _], [C.ownerDocument, "touchmove", E], [C.ownerDocument, "touchend", v]];
          w.forEach(function(d) {
            I.apply(null, d);
          }), this._events = w;
        }
        buttonToMaxClick(f) {
          let m = (this.to - this.from) * S(this.options.step, 0.2);
          this.updatePosition(this.from + m, this.to + m), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        buttonToMinClick(f) {
          let m = B(this.to - this.from) * S(this.options.step, 0.2);
          this.updatePosition(B(this.from - m), B(this.to - m)), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        cursorToScrollbarPosition(f) {
          let m = this.options, C = m.minWidth > this.calculatedWidth ? m.minWidth : 0;
          return { chartX: (f.chartX - this.x - this.xOffset) / (this.barWidth - C), chartY: (f.chartY - this.y - this.yOffset) / (this.barWidth - C) };
        }
        destroy() {
          let f = this, m = f.chart.scroller;
          f.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(C) {
            f[C] && f[C].destroy && (f[C] = f[C].destroy());
          }), m && f === m.scrollbar && (m.scrollbar = null, x(m.scrollbarButtons));
        }
        drawScrollbarButton(f) {
          let m = this.renderer, C = this.scrollbarButtons, F = this.options, _ = this.size, E = m.g().add(this.group);
          if (C.push(E), F.buttonsEnabled) {
            let v = m.rect().addClass("highcharts-scrollbar-button").add(E);
            this.chart.styledMode || v.attr({ stroke: F.buttonBorderColor, "stroke-width": F.buttonBorderWidth, fill: F.buttonBackgroundColor }), v.attr(v.crisp({ x: -0.5, y: -0.5, width: _, height: _, r: F.buttonBorderRadius }, v.strokeWidth()));
            let w = m.path(A.swapXY([["M", _ / 2 + (f ? -1 : 1), _ / 2 - 3], ["L", _ / 2 + (f ? -1 : 1), _ / 2 + 3], ["L", _ / 2 + (f ? 2 : -2), _ / 2]], F.vertical)).addClass("highcharts-scrollbar-arrow").add(C[f]);
            this.chart.styledMode || w.attr({ fill: F.buttonArrowColor });
          }
        }
        init(f, m, C) {
          this.scrollbarButtons = [], this.renderer = f, this.userOptions = m, this.options = y(L, j.scrollbar, m), this.options.margin = S(this.options.margin, 10), this.chart = C, this.size = S(this.options.size, this.options.height), m.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(f) {
          var F;
          let m = ((F = this.chart.pointer) == null ? void 0 : F.normalize(f)) || f, C = this.cursorToScrollbarPosition(m);
          this.chartX = C.chartX, this.chartY = C.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(f) {
          var E;
          let m, C = ((E = this.chart.pointer) == null ? void 0 : E.normalize(f)) || f, F = this.options.vertical ? "chartY" : "chartX", _ = this.initPositions || [];
          this.grabbedCenter && (!f.touches || f.touches[0][F] !== 0) && (m = this.cursorToScrollbarPosition(C)[F] - this[F], this.hasDragged = !0, this.updatePosition(_[0] + m, _[1] + m), this.hasDragged && T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: f.type, DOMEvent: f }));
        }
        mouseUpHandler(f) {
          this.hasDragged && T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: f.type, DOMEvent: f }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(f, m, C, F) {
          let { buttonsEnabled: _, margin: E = 0, vertical: v } = this.options, w = this.rendered ? "animate" : "attr", d = F, r = 0;
          this.group.show(), this.x = f, this.y = m + this.trackBorderWidth, this.width = C, this.height = F, this.xOffset = d, this.yOffset = r, v ? (this.width = this.yOffset = C = r = this.size, this.xOffset = d = 0, this.yOffset = r = _ ? this.size : 0, this.barWidth = F - (_ ? 2 * C : 0), this.x = f += E) : (this.height = F = this.size, this.xOffset = d = _ ? this.size : 0, this.barWidth = C - (_ ? 2 * F : 0), this.y = this.y + E), this.group[w]({ translateX: f, translateY: this.y }), this.track[w]({ width: C, height: F }), this.scrollbarButtons[1][w]({ translateX: v ? 0 : C - d, translateY: v ? F - r : 0 });
        }
        removeEvents() {
          this._events.forEach(function(f) {
            u.apply(null, f);
          }), this._events.length = 0;
        }
        render() {
          let f = this.renderer, m = this.options, C = this.size, F = this.chart.styledMode, _ = f.g("scrollbar").attr({ zIndex: m.zIndex }).hide().add();
          this.group = _, this.track = f.rect().addClass("highcharts-scrollbar-track").attr({ r: m.trackBorderRadius || 0, height: C, width: C }).add(_), F || this.track.attr({ fill: m.trackBackgroundColor, stroke: m.trackBorderColor, "stroke-width": m.trackBorderWidth });
          let E = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -R(0, E), y: -R(0, E) }), this.scrollbarGroup = f.g().add(_), this.scrollbar = f.rect().addClass("highcharts-scrollbar-thumb").attr({ height: C - E, width: C - E, r: m.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = f.path(A.swapXY([["M", -3, C / 4], ["L", -3, 2 * C / 3], ["M", 0, C / 4], ["L", 0, 2 * C / 3], ["M", 3, C / 4], ["L", 3, 2 * C / 3]], m.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), F || (this.scrollbar.attr({ fill: m.barBackgroundColor, stroke: m.barBorderColor, "stroke-width": m.barBorderWidth }), this.scrollbarRifles.attr({ stroke: m.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-R(0, this.scrollbarStrokeWidth), -R(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(f, m) {
          let C, F, _ = this.options, E = _.vertical, v = _.minWidth, w = this.barWidth, d = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!N(w)) return;
          let r = w * Math.min(m, 1);
          C = Math.ceil(w * (f = Math.max(f, 0))), this.calculatedWidth = F = B(r - C), F < v && (C = (w - v + F) * f, F = v);
          let s = Math.floor(C + this.xOffset + this.yOffset), p = F / 2 - 0.5;
          this.from = f, this.to = m, E ? (this.scrollbarGroup[d]({ translateY: s }), this.scrollbar[d]({ height: F }), this.scrollbarRifles[d]({ translateY: p }), this.scrollbarTop = s, this.scrollbarLeft = 0) : (this.scrollbarGroup[d]({ translateX: s }), this.scrollbar[d]({ width: F }), this.scrollbarRifles[d]({ translateX: p }), this.scrollbarLeft = s, this.scrollbarTop = 0), F <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), _.showFull === !1 && (f <= 0 && m >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(f) {
          return S(this.options.liveRedraw, n.svg && !n.isTouchDevice && !this.chart.boosted) || f === "mouseup" || f === "touchend" || !N(f);
        }
        trackClick(f) {
          var E;
          let m = ((E = this.chart.pointer) == null ? void 0 : E.normalize(f)) || f, C = this.to - this.from, F = this.y + this.scrollbarTop, _ = this.x + this.scrollbarLeft;
          this.options.vertical && m.chartY > F || !this.options.vertical && m.chartX > _ ? this.updatePosition(this.from + C, this.to + C) : this.updatePosition(this.from - C, this.to - C), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        update(f) {
          this.destroy(), this.init(this.chart.renderer, y(!0, this.options, f), this.chart);
        }
        updatePosition(f, m) {
          m > 1 && (f = B(1 - B(m - f)), m = 1), f < 0 && (m = B(m - f), f = 0), this.from = f, this.to = m;
        }
      }
      return A.defaultOptions = L, j.scrollbar = y(!0, A.defaultOptions, j.scrollbar), A;
    }), i(e, "Stock/Navigator/Navigator.js", [e["Core/Axis/Axis.js"], e["Stock/Navigator/ChartNavigatorComposition.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorComposition.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R) {
      let { defaultOptions: N } = l, { isTouchDevice: x } = L, { prototype: { symbols: T } } = B, { addEvent: y, clamp: S, correctFloat: u, defined: A, destroyObjectProperties: M, erase: f, extend: m, find: C, fireEvent: F, isArray: _, isNumber: E, merge: v, pick: w, removeEvent: d, splat: r } = R;
      function s(b, ...c) {
        let h = [].filter.call(c, E);
        if (h.length) return Math[b].apply(0, h);
      }
      class p {
        static compose(c, h, g) {
          n.compose(c, p), j.compose(c, h, g);
        }
        constructor(c) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(c);
        }
        drawHandle(c, h, g, k) {
          let P = this.navigatorOptions.handles.height;
          this.handles[h][k](g ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(c, 10) + 0.5 - P) } : { translateX: Math.round(this.left + parseInt(c, 10)), translateY: Math.round(this.top + this.height / 2 - P / 2 - 1) });
        }
        drawOutline(c, h, g, k) {
          let P = this.navigatorOptions.maskInside, O = this.outline.strokeWidth(), z = O / 2, W = O % 2 / 2, G = this.scrollButtonSize, Y = this.size, U = this.top, H = this.height, q = U - z, X = U + H, $ = this.left, K, V;
          g ? (K = U + h + W, h = U + c + W, V = [["M", $ + H, U - G - W], ["L", $ + H, K], ["L", $, K], ["M", $, h], ["L", $ + H, h], ["L", $ + H, U + Y + G]], P && V.push(["M", $ + H, K - z], ["L", $ + H, h + z])) : ($ -= G, c += $ + G - W, h += $ + G - W, V = [["M", $, q], ["L", c, q], ["L", c, X], ["M", h, X], ["L", h, q], ["L", $ + Y + 2 * G, q]], P && V.push(["M", c - z, q], ["L", h + z, q])), this.outline[k]({ d: V });
        }
        drawMasks(c, h, g, k) {
          let P, O, z, W, G = this.left, Y = this.top, U = this.height;
          g ? (z = [G, G, G], W = [Y, Y + c, Y + h], O = [U, U, U], P = [c, h - c, this.size - h]) : (z = [G, G + c, G + h], W = [Y, Y, Y], O = [c, h - c, this.size - h], P = [U, U, U]), this.shades.forEach((H, q) => {
            H[k]({ x: z[q], y: W[q], width: O[q], height: P[q] });
          });
        }
        renderElements() {
          var G, Y;
          let c = this, h = c.navigatorOptions, g = h.maskInside, k = c.chart, P = k.inverted, O = k.renderer, z = { cursor: P ? "ns-resize" : "ew-resize" }, W = (G = c.navigatorGroup) != null ? G : c.navigatorGroup = O.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!g, g, !g].forEach((U, H) => {
            var X;
            let q = (X = c.shades[H]) != null ? X : c.shades[H] = O.rect().addClass("highcharts-navigator-mask" + (H === 1 ? "-inside" : "-outside")).add(W);
            k.styledMode || (q.attr({ fill: U ? h.maskFill : "rgba(0,0,0,0)" }), H === 1 && q.css(z));
          }), c.outline || (c.outline = O.path().addClass("highcharts-navigator-outline").add(W)), k.styledMode || c.outline.attr({ "stroke-width": h.outlineWidth, stroke: h.outlineColor }), (Y = h.handles) == null ? void 0 : Y.enabled) {
            let U = h.handles, { height: H, width: q } = U;
            [0, 1].forEach((X) => {
              var K;
              let $ = U.symbols[X];
              if (c.handles[X] && c.handles[X].symbolUrl === $) {
                if (!c.handles[X].isImg && c.handles[X].symbolName !== $) {
                  let V = T[$].call(T, -q / 2 - 1, 0, q, H);
                  c.handles[X].attr({ d: V }), c.handles[X].symbolName = $;
                }
              } else (K = c.handles[X]) == null || K.destroy(), c.handles[X] = O.symbol($, -q / 2 - 1, 0, q, H, U), c.handles[X].attr({ zIndex: 7 - X }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][X]).add(W), c.addMouseEvents();
              k.inverted && c.handles[X].attr({ rotation: 90, rotationOriginX: Math.floor(-q / 2), rotationOriginY: (H + q) / 2 }), k.styledMode || c.handles[X].attr({ fill: U.backgroundColor, stroke: U.borderColor, "stroke-width": U.lineWidth, width: U.width, height: U.height, x: -q / 2 - 1, y: 0 }).css(z);
            });
          }
        }
        update(c, h = !1) {
          var P, O;
          let g = this.chart, k = g.options.chart.inverted !== ((P = g.scrollbar) == null ? void 0 : P.options.vertical);
          if (v(!0, g.options.navigator, c), this.navigatorOptions = g.options.navigator || {}, this.setOpposite(), A(c.enabled) || k) return this.destroy(), this.navigatorEnabled = c.enabled || this.navigatorEnabled, this.init(g);
          if (this.navigatorEnabled && (this.isDirty = !0, c.adaptToUpdatedData === !1 && this.baseSeries.forEach((z) => {
            d(z, "updatedData", this.updatedDataHandler);
          }, this), c.adaptToUpdatedData && this.baseSeries.forEach((z) => {
            z.eventsToUnbind.push(y(z, "updatedData", this.updatedDataHandler));
          }, this), (c.series || c.baseSeries) && this.setBaseSeries(void 0, !1), c.height || c.xAxis || c.yAxis)) {
            this.height = (O = c.height) != null ? O : this.height;
            let z = this.getXAxisOffsets();
            this.xAxis.update({ ...c.xAxis, offsets: z, [g.inverted ? "width" : "height"]: this.height, [g.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...c.yAxis, [g.inverted ? "width" : "height"]: this.height }, !1);
          }
          h && g.redraw();
        }
        render(c, h, g, k) {
          let P = this.chart, O = this.xAxis, z = O.pointRange || 0, W = O.navigatorAxis.fake ? P.xAxis[0] : O, G = this.navigatorEnabled, Y = this.rendered, U = P.inverted, H = P.xAxis[0].minRange, q = P.xAxis[0].options.maxRange, X = this.scrollButtonSize, $, K, V, Q = this.scrollbarHeight, Z, ee;
          if (this.hasDragged && !A(g)) return;
          if (this.isDirty && this.renderElements(), c = u(c - z / 2), h = u(h + z / 2), !E(c) || !E(h)) {
            if (!Y) return;
            g = 0, k = w(O.width, W.width);
          }
          this.left = w(O.left, P.plotLeft + X + (U ? P.plotWidth : 0));
          let J = this.size = Z = w(O.len, (U ? P.plotHeight : P.plotWidth) - 2 * X);
          $ = U ? Q : Z + 2 * X, g = w(g, O.toPixels(c, !0)), k = w(k, O.toPixels(h, !0)), E(g) && Math.abs(g) !== 1 / 0 || (g = 0, k = $);
          let ie = O.toValue(g, !0), re = O.toValue(k, !0), ce = Math.abs(u(re - ie));
          ce < H ? this.grabbedLeft ? g = O.toPixels(re - H - z, !0) : this.grabbedRight && (k = O.toPixels(ie + H + z, !0)) : A(q) && u(ce - z) > q && (this.grabbedLeft ? g = O.toPixels(re - q - z, !0) : this.grabbedRight && (k = O.toPixels(ie + q + z, !0))), this.zoomedMax = S(Math.max(g, k), 0, J), this.zoomedMin = S(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(g, k), 0, J), this.range = this.zoomedMax - this.zoomedMin, J = Math.round(this.zoomedMax);
          let he = Math.round(this.zoomedMin);
          G && (this.navigatorGroup.attr({ visibility: "inherit" }), ee = Y && !this.hasDragged ? "animate" : "attr", this.drawMasks(he, J, U, ee), this.drawOutline(he, J, U, ee), this.navigatorOptions.handles.enabled && (this.drawHandle(he, 0, U, ee), this.drawHandle(J, 1, U, ee))), this.scrollbar && (U ? (V = this.top - X, K = this.left - Q + (G || !W.opposite ? 0 : (W.titleOffset || 0) + W.axisTitleMargin), Q = Z + 2 * X) : (V = this.top + (G ? this.height : -Q), K = this.left - X), this.scrollbar.position(K, V, $, Q), this.scrollbar.setRange(this.zoomedMin / (Z || 1), this.zoomedMax / (Z || 1))), this.rendered = !0, this.isDirty = !1, F(this, "afterRender");
        }
        addMouseEvents() {
          let c = this, h = c.chart, g = h.container, k = [], P, O;
          c.mouseMoveHandler = P = function(z) {
            c.onMouseMove(z);
          }, c.mouseUpHandler = O = function(z) {
            c.onMouseUp(z);
          }, (k = c.getPartsEvents("mousedown")).push(y(h.renderTo, "mousemove", P), y(g.ownerDocument, "mouseup", O), y(h.renderTo, "touchmove", P), y(g.ownerDocument, "touchend", O)), k.concat(c.getPartsEvents("touchstart")), c.eventsToUnbind = k, c.series && c.series[0] && k.push(y(c.series[0].xAxis, "foundExtremes", function() {
            h.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(c) {
          let h = this, g = [];
          return ["shades", "handles"].forEach(function(k) {
            h[k].forEach(function(P, O) {
              g.push(y(P.element, c, function(z) {
                h[k + "Mousedown"](z, O);
              }));
            });
          }), g;
        }
        shadesMousedown(c, h) {
          var X;
          c = ((X = this.chart.pointer) == null ? void 0 : X.normalize(c)) || c;
          let g = this.chart, k = this.xAxis, P = this.zoomedMin, O = this.size, z = this.range, W = this.left, G = c.chartX, Y, U, H, q;
          g.inverted && (G = c.chartY, W = this.top), h === 1 ? (this.grabbedCenter = G, this.fixedWidth = z, this.dragOffset = G - P) : (q = G - W - z / 2, h === 0 ? q = Math.max(0, q) : h === 2 && q + z >= O && (q = O - z, this.reversedExtremes ? (q -= z, U = this.getUnionExtremes().dataMin) : Y = this.getUnionExtremes().dataMax), q !== P && (this.fixedWidth = z, A((H = k.navigatorAxis.toFixedRange(q, q + z, U, Y)).min) && F(this, "setRange", { min: Math.min(H.min, H.max), max: Math.max(H.min, H.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(c, h) {
          var O;
          c = ((O = this.chart.pointer) == null ? void 0 : O.normalize(c)) || c;
          let g = this.chart, k = g.xAxis[0], P = this.reversedExtremes;
          h === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = P ? k.min : k.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = P ? k.max : k.min), g.setFixedRange(void 0);
        }
        onMouseMove(c) {
          var Y;
          let h = this, g = h.chart, k = h.navigatorSize, P = h.range, O = h.dragOffset, z = g.inverted, W = h.left, G;
          (!c.touches || c.touches[0].pageX !== 0) && (G = (c = ((Y = g.pointer) == null ? void 0 : Y.normalize(c)) || c).chartX, z && (W = h.top, G = c.chartY), h.grabbedLeft ? (h.hasDragged = !0, h.render(0, 0, G - W, h.otherHandlePos)) : h.grabbedRight ? (h.hasDragged = !0, h.render(0, 0, h.otherHandlePos, G - W)) : h.grabbedCenter && (h.hasDragged = !0, G < O ? G = O : G > k + O - P && (G = k + O - P), h.render(0, 0, G - O, G - O + P)), h.hasDragged && h.scrollbar && w(h.scrollbar.options.liveRedraw, !x && !this.chart.boosted) && (c.DOMType = c.type, setTimeout(function() {
            h.onMouseUp(c);
          }, 0)));
        }
        onMouseUp(c) {
          let h, g, k, P, O, z, W = this.chart, G = this.xAxis, Y = this.scrollbar, U = c.DOMEvent || c, H = W.inverted, q = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Y || !Y.hasDragged) || c.trigger === "scrollbar") && (k = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? P = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (O = this.fixedExtreme), this.zoomedMax === this.size && (O = this.reversedExtremes ? k.dataMin : k.dataMax), this.zoomedMin === 0 && (P = this.reversedExtremes ? k.dataMax : k.dataMin), A((z = G.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, P, O)).min) && F(this, "setRange", { min: Math.min(z.min, z.max), max: Math.max(z.min, z.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: U } })), c.DOMType !== "mousemove" && c.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && E(this.zoomedMin) && E(this.zoomedMax) && (g = Math.round(this.zoomedMin), h = Math.round(this.zoomedMax), this.shades && this.drawMasks(g, h, H, q), this.outline && this.drawOutline(g, h, H, q), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(g, 0, H, q), this.drawHandle(h, 1, H, q)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(c) {
            c();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let c = this.baseSeries || [];
          this.navigatorEnabled && c[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && c.forEach(function(h) {
            d(h, "updatedData", this.updatedDataHandler);
          }, this), c[0].xAxis && d(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(c) {
          var $;
          let h = c.options, g = h.navigator || {}, k = g.enabled, P = h.scrollbar || {}, O = P.enabled, z = k && g.height || 0, W = O && P.height || 0, G = P.buttonsEnabled && W || 0;
          this.handles = [], this.shades = [], this.chart = c, this.setBaseSeries(), this.height = z, this.scrollbarHeight = W, this.scrollButtonSize = G, this.scrollbarEnabled = O, this.navigatorEnabled = k, this.navigatorOptions = g, this.scrollbarOptions = P, this.setOpposite();
          let Y = this, U = Y.baseSeries, H = c.xAxis.length, q = c.yAxis.length, X = U && U[0] && U[0].xAxis || c.xAxis[0] || { options: {} };
          if (c.isDirtyBox = !0, Y.navigatorEnabled) {
            let K = this.getXAxisOffsets();
            Y.xAxis = new o(c, v({ breaks: X.options.breaks, ordinal: X.options.ordinal, overscroll: X.options.overscroll }, g.xAxis, { type: "datetime", yAxis: ($ = g.yAxis) == null ? void 0 : $.id, index: H, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: X.options.ordinal ? 0 : X.options.minPadding, maxPadding: X.options.ordinal ? 0 : X.options.maxPadding, zoomEnabled: !1 }, c.inverted ? { offsets: K, width: z } : { offsets: K, height: z }), "xAxis"), Y.yAxis = new o(c, v(g.yAxis, { alignTicks: !1, offset: 0, index: q, isInternal: !0, reversed: w(g.yAxis && g.yAxis.reversed, c.yAxis[0] && c.yAxis[0].reversed, !1), zoomEnabled: !1 }, c.inverted ? { width: z } : { height: z }), "yAxis"), U || g.series.data ? Y.updateNavigatorSeries(!1) : c.series.length === 0 && (Y.unbindRedraw = y(c, "beforeRedraw", function() {
              c.series.length > 0 && !Y.series && (Y.setBaseSeries(), Y.unbindRedraw());
            })), Y.reversedExtremes = c.inverted && !Y.xAxis.reversed || !c.inverted && Y.xAxis.reversed, Y.renderElements(), Y.addMouseEvents();
          } else Y.xAxis = { chart: c, navigatorAxis: { fake: !0 }, translate: function(K, V) {
            let Q = c.xAxis[0], Z = Q.getExtremes(), ee = Q.len - 2 * G, J = s("min", Q.options.min, Z.dataMin), ie = s("max", Q.options.max, Z.dataMax) - J;
            return V ? K * ie / ee + J : ee * (K - J) / ie;
          }, toPixels: function(K) {
            return this.translate(K);
          }, toValue: function(K) {
            return this.translate(K, !0);
          } }, Y.xAxis.navigatorAxis.axis = Y.xAxis, Y.xAxis.navigatorAxis.toFixedRange = D.prototype.toFixedRange.bind(Y.xAxis.navigatorAxis);
          if (c.options.scrollbar.enabled) {
            let K = v(c.options.scrollbar, { vertical: c.inverted });
            !E(K.margin) && Y.navigatorEnabled && (K.margin = c.inverted ? -3 : 3), c.scrollbar = Y.scrollbar = new I(c.renderer, K, c), y(Y.scrollbar, "changed", function(V) {
              let Q = Y.size, Z = Q * this.to, ee = Q * this.from;
              Y.hasDragged = Y.scrollbar.hasDragged, Y.render(0, 0, ee, Z), this.shouldUpdateExtremes(V.DOMType) && setTimeout(function() {
                Y.onMouseUp(V);
              });
            });
          }
          Y.addBaseSeriesEvents(), Y.addChartEvents();
        }
        setOpposite() {
          let c = this.navigatorOptions, h = this.navigatorEnabled, g = this.chart;
          this.opposite = w(c.opposite, !!(!h && g.inverted));
        }
        getUnionExtremes(c) {
          let h, g = this.chart.xAxis[0], k = this.xAxis, P = k.options, O = g.options;
          return c && g.dataMin === null || (h = { dataMin: w(P && P.min, s("min", O.min, g.dataMin, k.dataMin, k.min)), dataMax: w(P && P.max, s("max", O.max, g.dataMax, k.dataMax, k.max)) }), h;
        }
        setBaseSeries(c, h) {
          let g = this.chart, k = this.baseSeries = [];
          c = c || g.options && g.options.navigator.baseSeries || (g.series.length ? C(g.series, (P) => !P.options.isInternal).index : 0), (g.series || []).forEach((P, O) => {
            !P.options.isInternal && (P.options.showInNavigator || (O === c || P.options.id === c) && P.options.showInNavigator !== !1) && k.push(P);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, h);
        }
        updateNavigatorSeries(c, h) {
          var H, q;
          let g = this, k = g.chart, P = g.baseSeries, O = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (H = this.navigatorOptions.xAxis) == null ? void 0 : H.id, yAxis: (q = this.navigatorOptions.yAxis) == null ? void 0 : q.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, z = g.series = (g.series || []).filter((X) => {
            let $ = X.baseSeries;
            return !(0 > P.indexOf($)) || ($ && (d($, "updatedData", g.updatedDataHandler), delete $.navigatorSeries), X.chart && X.destroy(), !1);
          }), W, G, Y = g.navigatorOptions.series, U;
          P && P.length && P.forEach((X) => {
            let $ = X.navigatorSeries, K = m({ color: X.color, visible: X.visible }, _(Y) ? N.navigator.series : Y);
            if ($ && g.navigatorOptions.adaptToUpdatedData === !1) return;
            O.name = "Navigator " + P.length, U = (W = X.options || {}).navigatorOptions || {}, K.dataLabels = r(K.dataLabels), (G = v(W, O, K, U)).pointRange = w(K.pointRange, U.pointRange, N.plotOptions[G.type || "line"].pointRange);
            let V = U.data || K.data;
            g.hasNavigatorData = g.hasNavigatorData || !!V, G.data = V || W.data && W.data.slice(0), $ && $.options ? $.update(G, h) : (X.navigatorSeries = k.initSeries(G), k.setSortedData(), X.navigatorSeries.baseSeries = X, z.push(X.navigatorSeries));
          }), (Y.data && !(P && P.length) || _(Y)) && (g.hasNavigatorData = !1, (Y = r(Y)).forEach((X, $) => {
            O.name = "Navigator " + (z.length + 1), (G = v(N.navigator.series, { color: k.series[$] && !k.series[$].options.isInternal && k.series[$].color || k.options.colors[$] || k.options.colors[0] }, O, X)).data = X.data, G.data && (g.hasNavigatorData = !0, z.push(k.initSeries(G)));
          })), c && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let c = this, h = c.baseSeries || [];
          h[0] && h[0].xAxis && h[0].eventsToUnbind.push(y(h[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), h.forEach((g) => {
            g.eventsToUnbind.push(y(g, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), g.eventsToUnbind.push(y(g, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && g.xAxis && g.eventsToUnbind.push(y(g, "updatedData", this.updatedDataHandler)), g.eventsToUnbind.push(y(g, "remove", function() {
              h && f(h, g), this.navigatorSeries && (f(c.series, this.navigatorSeries), A(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(c) {
          return this.baseSeries.reduce(function(h, g) {
            return Math.min(h, g.xData && g.xData.length ? g.xData[0] : h);
          }, c);
        }
        modifyNavigatorAxisExtremes() {
          let c = this.xAxis;
          if (c.getExtremes !== void 0) {
            let h = this.getUnionExtremes(!0);
            h && (h.dataMin !== c.min || h.dataMax !== c.max) && (c.min = h.dataMin, c.max = h.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var $;
          let c, h, g = this.chart.navigator, k = this.getExtremes(), P = k.min, O = k.max, z = k.dataMin, W = k.dataMax, G = O - P, Y = g.stickToMin, U = g.stickToMax, H = w(($ = this.ordinal) == null ? void 0 : $.convertOverscroll(this.options.overscroll), 0), q = g.series && g.series[0], X = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (Y && (c = (h = z) + G), U && (c = W + H, Y || (h = Math.max(z, c - G, g.getBaseSeriesMin(q && q.xData ? q.xData[0] : -Number.MAX_VALUE)))), X && (Y || U) && E(h) && (this.min = this.userMin = h, this.max = this.userMax = c)), g.stickToMin = g.stickToMax = null;
        }
        updatedDataHandler() {
          let c = this.chart.navigator, h = this.navigatorSeries, g = c.reversedExtremes ? Math.round(c.zoomedMin) === 0 : Math.round(c.zoomedMax) >= Math.round(c.size);
          c.stickToMax = w(this.chart.options.navigator && this.chart.options.navigator.stickToMax, g), c.stickToMin = c.shouldStickToMin(this, c), h && !c.hasNavigatorData && (h.options.pointStart = this.xData[0], h.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(c, h) {
          let g = h.getBaseSeriesMin(c.xData[0]), k = c.xAxis, P = k.max, O = k.min, z = k.options.range;
          return !!(E(P) && E(O)) && (z && P - g > 0 ? P - g < z : O <= g);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(y(this.chart, "redraw", function() {
            let c = this.navigator, h = c && (c.baseSeries && c.baseSeries[0] && c.baseSeries[0].xAxis || this.xAxis[0]);
            h && c.render(h.min, h.max);
          }), y(this.chart, "getMargins", function() {
            let c = this.navigator, h = c.opposite ? "plotTop" : "marginBottom";
            this.inverted && (h = c.opposite ? "marginRight" : "plotLeft"), this[h] = (this[h] || 0) + (c.navigatorEnabled || !this.inverted ? c.height + c.scrollbarHeight : 0) + c.navigatorOptions.margin;
          }), y(p, "setRange", function(c) {
            this.chart.xAxis[0].setExtremes(c.min, c.max, c.redraw, c.animation, c.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (f(this.chart.xAxis, this.xAxis), f(this.chart.axes, this.xAxis)), this.yAxis && (f(this.chart.yAxis, this.yAxis), f(this.chart.axes, this.yAxis)), (this.series || []).forEach((c) => {
            c.destroy && c.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((c) => {
            this[c] && this[c].destroy && this[c].destroy(), this[c] = null;
          }), [this.handles].forEach((c) => {
            M(c);
          }), this.navigatorEnabled = !1;
        }
      }
      return p;
    }), i(e, "Accessibility/Components/NavigatorComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Stock/Navigator/Navigator.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Templating.js"], e["Core/Utilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/Utils/ChartUtilities.js"]], function(o, n, l, L, D, j, I, B, R) {
      let { animObject: N } = D, { format: x } = j, { clamp: T, pick: y, syncTimeout: S } = I, { getFakeMouseEvent: u } = B, { getAxisRangeDescription: A, fireEventOnWrappedOrUnwrappedElement: M } = R;
      return class extends o {
        init() {
          let f = this.chart, m = this;
          this.announcer = new n(f, "polite"), this.addEvent(L, "afterRender", function() {
            this.chart === m.chart && this.chart.renderer && S(() => {
              m.proxyProvider.updateGroupProxyElementPositions("navigator"), m.updateHandleValues();
            }, N(y(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        onChartUpdate() {
          var F, _, E;
          let f = this.chart, m = f.options, C = m.navigator;
          if (C.enabled && ((F = C.accessibility) != null && F.enabled)) {
            let v = m.accessibility.landmarkVerbosity, w = (_ = m.lang.accessibility) == null ? void 0 : _.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: v === "all" ? "region" : "group", "aria-label": x(w, { chart: f }, f) });
            let d = (E = m.lang.accessibility) == null ? void 0 : E.navigator.handleLabel;
            [0, 1].forEach((r) => {
              let s = this.getHandleByIx(r);
              if (s) {
                let p = this.proxyProvider.addProxyElement("navigator", { click: s }, "input", { type: "range", "aria-label": x(d, { handleIx: r, chart: f }, f) });
                this[r ? "maxHandleProxy" : "minHandleProxy"] = p.innerElement, p.innerElement.style.pointerEvents = "none", p.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(f) {
          let m = this, C = this.chart, F = f ? this.maxHandleProxy : this.minHandleProxy, _ = this.keyCodes;
          return new l(C, { keyCodeMap: [[[_.left, _.right, _.up, _.down], function(E) {
            if (F) {
              let v = E === _.left || E === _.up ? -1 : 1;
              F.value = "" + T(parseFloat(F.value) + v, 0, 100), m.updateNavigator(() => {
                let w = m.getHandleByIx(f);
                w && C.setFocusToElement(w, F);
              });
            }
            return this.response.success;
          }]], init: () => {
            C.setFocusToElement(this.getHandleByIx(f), F);
          }, validate: () => {
            var E;
            return !!(this.getHandleByIx(f) && F && ((E = C.options.navigator.accessibility) != null && E.enabled));
          } });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let f = this.chart.navigator;
          if (f && this.minHandleProxy && this.maxHandleProxy) {
            let m = f.size;
            this.minHandleProxy.value = "" + Math.round(f.zoomedMin / m * 100), this.maxHandleProxy.value = "" + Math.round(f.zoomedMax / m * 100);
          }
        }
        getHandleByIx(f) {
          let m = this.chart.navigator;
          return m && m.handles && m.handles[f];
        }
        updateNavigator(f) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((m) => {
            var E;
            let C = this.chart, { navigator: F, pointer: _ } = C;
            if (F && _ && this.minHandleProxy && this.maxHandleProxy) {
              let v = _.getChartPosition(), w = parseFloat(this.minHandleProxy.value) / 100 * F.size, d = parseFloat(this.maxHandleProxy.value) / 100 * F.size;
              [[0, "mousedown", F.zoomedMin], [0, "mousemove", w], [0, "mouseup", w], [1, "mousedown", F.zoomedMax], [1, "mousemove", d], [1, "mouseup", d]].forEach(([p, b, c]) => {
                var g;
                let h = (g = this.getHandleByIx(p)) == null ? void 0 : g.element;
                h && M(h, u(b, { x: v.left + F.left + c, y: v.top + F.top }, h));
              }), m && m();
              let r = (E = C.options.lang.accessibility) == null ? void 0 : E.navigator.changeAnnouncement, s = A(C.xAxis[0]);
              this.announcer.announce(x(r, { axisRangeDescription: s, chart: C }, C));
            }
          }).bind(this, f), 20);
        }
      };
    }), i(e, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [e["Accessibility/Components/AnnotationsA11y.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Core/Templating.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { getPointAnnotationTexts: j } = o, { getAxisDescription: I, getSeriesFirstPointElement: B, getSeriesA11yElement: R, unhideChartElementFromAT: N } = n, { format: x, numberFormat: T } = l, { reverseChildNodes: y, stripHTMLTagsFromString: S } = L, { find: u, isNumber: A, isString: M, pick: f, defined: m } = D;
      function C(w) {
        let d = w.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(d !== !1 && w.points && w.points.length >= +d);
      }
      function F(w, d) {
        let r = w.series, s = r.chart, p = s.options.accessibility.point || {}, b = r.options.accessibility && r.options.accessibility.point || {}, c = r.tooltipOptions || {}, h = s.options.lang;
        return A(d) ? T(d, b.valueDecimals || p.valueDecimals || c.valueDecimals || -1, h.decimalPoint, h.accessibility.thousandsSep || h.thousandsSep) : d;
      }
      function _(w, d) {
        let r = w[d];
        return w.chart.langFormat("accessibility.series." + d + "Description", { name: I(r), series: w });
      }
      function E(w) {
        let d = w.series, r = d.chart.series.length > 1 || d.options.name, s = function(h) {
          let g = h.series, k = g.chart, P = g.options.accessibility, O = P && P.point && P.point.valueDescriptionFormat || k.options.accessibility.point.valueDescriptionFormat, z = f(g.xAxis && g.xAxis.options.accessibility && g.xAxis.options.accessibility.enabled, !k.angular && g.type !== "flowmap"), W = z ? function(G) {
            let Y = function(X) {
              let $ = X.series, K = $.chart, V = $.options.accessibility && $.options.accessibility.point || {}, Q = K.options.accessibility.point || {}, Z = $.xAxis && $.xAxis.dateTime;
              if (Z) {
                let ee = Z.getXDateFormat(X.x || 0, K.options.tooltip.dateTimeLabelFormats), J = V.dateFormatter && V.dateFormatter(X) || Q.dateFormatter && Q.dateFormatter(X) || V.dateFormat || Q.dateFormat || ee;
                return K.time.dateFormat(J, X.x || 0, void 0);
              }
            }(G), U = (G.series.xAxis || {}).categories && m(G.category) && ("" + G.category).replace("<br/>", " "), H = m(G.id) && 0 > ("" + G.id).indexOf("highcharts-"), q = "x, " + G.x;
            return G.name || Y || U || (H ? G.id : q);
          }(h) : "";
          return x(O, { point: h, index: m(h.index) ? h.index + 1 : "", xDescription: W, value: function(G) {
            let Y = G.series, U = Y.chart.options.accessibility.point || {}, H = Y.chart.options.accessibility && Y.chart.options.accessibility.point || {}, q = Y.tooltipOptions || {}, X = H.valuePrefix || U.valuePrefix || q.valuePrefix || "", $ = H.valueSuffix || U.valueSuffix || q.valueSuffix || "", K = G.value !== void 0 ? "value" : "y", V = F(G, G[K]);
            return G.isNull ? Y.chart.langFormat("accessibility.series.nullPointValue", { point: G }) : Y.pointArrayMap ? function(Q, Z, ee) {
              let J = Z || "", ie = ee || "", re = function(ce) {
                let he = F(Q, f(Q[ce], Q.options[ce]));
                return he !== void 0 ? ce + ": " + J + he + ie : he;
              };
              return Q.series.pointArrayMap.reduce(function(ce, he) {
                let ne = re(he);
                return ne ? ce + (ce.length ? ", " : "") + ne : ce;
              }, "");
            }(G, X, $) : X + V + $;
          }(h), separator: z ? ", " : "" }, k);
        }(w), p = w.options && w.options.accessibility && w.options.accessibility.description, b = r ? " " + d.name + "." : "", c = function(h) {
          let g = h.series.chart, k = j(h);
          return k.length ? g.langFormat("accessibility.series.pointAnnotationsDescription", { point: h, annotations: k }) : "";
        }(w);
        return w.accessibility = w.accessibility || {}, w.accessibility.valueDescription = s, s + (p ? " " + p : "") + b + (c ? " " + c : "");
      }
      function v(w) {
        let d = w.chart, r = d.types || [], s = function(z) {
          let W = (z.options.accessibility || {}).description;
          return W && z.chart.langFormat("accessibility.series.description", { description: W, series: z }) || "";
        }(w), p = function(z) {
          return d[z] && d[z].length > 1 && w[z];
        }, b = w.index + 1, c = _(w, "xAxis"), h = _(w, "yAxis"), g = { seriesNumber: b, series: w, chart: d }, k = r.length > 1 ? "Combination" : "", P = d.langFormat("accessibility.series.summary." + w.type + k, g) || d.langFormat("accessibility.series.summary.default" + k, g), O = (p("yAxis") ? " " + h + "." : "") + (p("xAxis") ? " " + c + "." : "");
        return x(f(w.options.accessibility && w.options.accessibility.descriptionFormat, d.options.accessibility.series.descriptionFormat, ""), { seriesDescription: P, authorDescription: s ? " " + s : "", axisDescription: O, series: w, chart: d, seriesNumber: b }, void 0);
      }
      return { defaultPointDescriptionFormatter: E, defaultSeriesDescriptionFormatter: v, describeSeries: function(w) {
        let d = w.chart, r = B(w), s = R(w), p = d.is3d && d.is3d();
        s && (s.lastChild !== r || p || y(s), function(b) {
          let c = function(k) {
            let P = k.options.accessibility || {};
            return !C(k) && !P.exposeAsGroupOnly;
          }(b), h = function(k) {
            let P = k.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(k.points && (k.points.length < +P.pointNavigationEnabledThreshold || P.pointNavigationEnabledThreshold === !1));
          }(b), g = b.chart.options.accessibility.point.describeNull;
          (c || h) && b.points.forEach((k) => {
            let P = k.graphic && k.graphic.element || function(z) {
              let W = z.series, G = W && W.chart, Y = W && W.is("sunburst"), U = z.isNull, H = G && G.options.accessibility.point.describeNull;
              return U && !Y && H;
            }(k) && function(z) {
              let W = z.series, G = function(X) {
                let $ = X.index;
                return X.series && X.series.data && m($) && u(X.series.data, function(K) {
                  return !!(K && K.index !== void 0 && K.index > $ && K.graphic && K.graphic.element);
                }) || null;
              }(z), Y = G && G.graphic, U = Y ? Y.parentGroup : W.graph || W.group, H = G ? { x: f(z.plotX, G.plotX, 0), y: f(z.plotY, G.plotY, 0) } : { x: f(z.plotX, 0), y: f(z.plotY, 0) }, q = function(X, $) {
                let K = X.series.chart.renderer.rect($.x, $.y, 1, 1);
                return K.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), K;
              }(z, H);
              if (U && U.element) return z.graphic = q, z.hasMockGraphic = !0, q.add(U), U.element.insertBefore(q.element, Y ? Y.element : null), q.element;
            }(k), O = k.options && k.options.accessibility && k.options.accessibility.enabled === !1;
            if (P) {
              if (k.isNull && !g) {
                P.setAttribute("aria-hidden", !0);
                return;
              }
              P.setAttribute("tabindex", "-1"), b.chart.styledMode || (P.style.outline = "none"), c && !O ? function(z, W) {
                var q, X, $;
                let G = z.series, Y = ((q = G.options.accessibility) == null ? void 0 : q.point) || {}, U = G.chart.options.accessibility.point || {}, H = S(M(Y.descriptionFormat) && x(Y.descriptionFormat, z, G.chart) || ((X = Y.descriptionFormatter) == null ? void 0 : X.call(Y, z)) || M(U.descriptionFormat) && x(U.descriptionFormat, z, G.chart) || (($ = U.descriptionFormatter) == null ? void 0 : $.call(U, z)) || E(z), G.chart.renderer.forExport);
                W.setAttribute("role", "img"), W.setAttribute("aria-label", H);
              }(k, P) : P.setAttribute("aria-hidden", !0);
            }
          });
        }(w), N(d, s), function(b) {
          let c = b.chart, h = c.options.chart, g = h.options3d && h.options3d.enabled, k = c.series.length > 1, P = c.options.accessibility.series.describeSingleSeries, O = (b.options.accessibility || {}).exposeAsGroupOnly;
          return !(g && k) && (k || P || O || C(b));
        }(w) ? function(b, c) {
          let h = b.options.accessibility || {}, g = b.chart.options.accessibility, k = g.landmarkVerbosity;
          h.exposeAsGroupOnly ? c.setAttribute("role", "img") : k === "all" ? c.setAttribute("role", "region") : c.setAttribute("role", "group"), c.setAttribute("tabindex", "-1"), b.chart.styledMode || (c.style.outline = "none"), c.setAttribute("aria-label", S(g.series.descriptionFormatter && g.series.descriptionFormatter(b) || v(b), b.chart.renderer.forExport));
        }(w, s) : s.removeAttribute("aria-label"));
      } };
    }), i(e, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, n, l, L, D, j) {
      let { composed: I } = o, { addEvent: B, defined: R, pushUnique: N } = n, { getChartTitle: x } = L, { defaultPointDescriptionFormatter: T, defaultSeriesDescriptionFormatter: y } = j;
      function S(A) {
        return !!A.options.accessibility.announceNewData.enabled;
      }
      class u {
        constructor(M) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = M;
        }
        init() {
          let M = this.chart, f = M.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new D(), this.announcer = new l(M, f), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let M = this, f = this.chart, m = this.eventProvider;
          m.addEvent(f, "afterApplyDrilldown", function() {
            M.lastAnnouncementTime = 0;
          }), m.addEvent(f, "afterAddSeries", function(C) {
            M.onSeriesAdded(C.series);
          }), m.addEvent(f, "redraw", function() {
            M.announceDirtyData();
          });
        }
        onSeriesAdded(M) {
          S(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[M.name + M.index] = M, this.dirty.newSeries = R(this.dirty.newSeries) ? void 0 : M);
        }
        announceDirtyData() {
          let M = this.chart, f = this;
          if (M.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let m = this.dirty.newPoint;
            m && (m = function(C) {
              let F = C.series.data.filter((_) => C.x === _.x && C.y === _.y);
              return F.length === 1 ? F[0] : C;
            }(m)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((C) => f.dirty.allSeries[C]), this.dirty.newSeries, m), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(M, f, m) {
          let C = this.chart.options.accessibility.announceNewData;
          if (C.enabled) {
            let F = +/* @__PURE__ */ new Date(), _ = F - this.lastAnnouncementTime, E = Math.max(0, C.minAnnounceInterval - _), v = function(d, r) {
              let s = (d || []).concat(r || []).reduce((p, b) => (p[b.name + b.index] = b, p), {});
              return Object.keys(s).map((p) => s[p]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, M), w = this.buildAnnouncementMessage(v, f, m);
            w && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: F, message: w, series: v }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, E));
          }
        }
        buildAnnouncementMessage(M, f, m) {
          let C = this.chart, F = C.options.accessibility.announceNewData;
          if (F.announcementFormatter) {
            let w = F.announcementFormatter(M, f, m);
            if (w !== !1) return w.length ? w : null;
          }
          let _ = o.charts && o.charts.length > 1 ? "Multiple" : "Single", E = f ? "newSeriesAnnounce" + _ : m ? "newPointAnnounce" + _ : "newDataAnnounce", v = x(C);
          return C.langFormat("accessibility.announceNewData." + E, { chartTitle: v, seriesDesc: f ? y(f) : null, pointDesc: m ? T(m) : null, point: m, series: f });
        }
      }
      return function(A) {
        function M(m) {
          var _;
          let C = this.chart, F = (_ = C.accessibility) == null ? void 0 : _.components.series.newDataAnnouncer;
          F && F.chart === C && S(C) && (F.dirty.newPoint = R(F.dirty.newPoint) ? void 0 : m.point);
        }
        function f() {
          var F;
          let m = this.chart, C = (F = m.accessibility) == null ? void 0 : F.components.series.newDataAnnouncer;
          C && C.chart === m && S(m) && (C.dirty.hasDirty = !0, C.dirty.allSeries[this.name + this.index] = this);
        }
        A.compose = function(m) {
          N(I, "A11y.NDA") && (B(m, "addPoint", M), B(m, "updatedData", f));
        };
      }(u || (u = {})), u;
    }), i(e, "Accessibility/ProxyElement.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"]], function(o, n, l, L, D) {
      let { doc: j } = o, { attr: I, css: B, merge: R } = n, { fireEventOnWrappedOrUnwrappedElement: N } = L, { cloneMouseEvent: x, cloneTouchEvent: T, getFakeMouseEvent: y, removeElement: S } = D;
      return class {
        constructor(u, A, M = "button", f, m) {
          this.chart = u, this.target = A, this.eventProvider = new l();
          let C = this.innerElement = j.createElement(M), F = this.element = f ? j.createElement(f) : C;
          u.styledMode || this.hideElementVisually(C), f && (f !== "li" || u.styledMode || (F.style.listStyle = "none"), F.appendChild(C), this.element = F), this.updateTarget(A, m);
        }
        click() {
          let u = this.getTargetPosition();
          u.x += u.width / 2, u.y += u.height / 2;
          let A = y("click", u);
          N(this.target.click, A);
        }
        updateTarget(u, A) {
          this.target = u, this.updateCSSClassName();
          let M = A || {};
          Object.keys(M).forEach((m) => {
            M[m] === null && delete M[m];
          });
          let f = this.getTargetAttr(u.click, "aria-label");
          I(this.innerElement, R(f ? { "aria-label": f } : {}, M)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, u.click), this.refreshPosition();
        }
        refreshPosition() {
          let u = this.getTargetPosition();
          B(this.innerElement, { width: (u.width || 1) + "px", height: (u.height || 1) + "px", left: (Math.round(u.x) || 0) + "px", top: (Math.round(u.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), S(this.element);
        }
        updateCSSClassName() {
          let u = (C) => C.indexOf("highcharts-no-tooltip") > -1, A = this.chart.legend, M = A.group && A.group.div, f = u(M && M.className || ""), m = u(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = f || m ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(u, A) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((M) => {
            let f = M.indexOf("touch") === 0;
            this.eventProvider.addEvent(u, M, (m) => {
              let C = f ? T(m) : x(m);
              A && N(A, C), m.stopPropagation(), f || m.preventDefault();
            }, { passive: !1 });
          });
        }
        hideElementVisually(u) {
          B(u, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let u = this.target.click, A = u.element ? u.element : u, M = this.target.visual || A, f = this.chart.renderTo, m = this.chart.pointer;
          if (f && (M != null && M.getBoundingClientRect) && m) {
            let C = M.getBoundingClientRect(), F = m.getChartPosition();
            return { x: (C.left - F.left) / F.scaleX, y: (C.top - F.top) / F.scaleY, width: C.right / F.scaleX - C.left / F.scaleX, height: C.bottom / F.scaleY - C.top / F.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(u, A) {
          return u.element ? u.element.getAttribute(A) : u.getAttribute(A);
        }
      };
    }), i(e, "Accessibility/ProxyProvider.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/DOMElementProvider.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/ProxyElement.js"]], function(o, n, l, L, D, j) {
      let { doc: I } = o, { attr: B, css: R } = n, { unhideChartElementFromAT: N } = l, { removeChildNodes: x } = D;
      return class {
        constructor(T) {
          this.chart = T, this.domElementProvider = new L(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(T, y, S = "button", u) {
          let A = this.groups[T];
          if (!A) throw Error("ProxyProvider.addProxyElement: Invalid group key " + T);
          let M = A.type === "ul" || A.type === "ol" ? "li" : void 0, f = new j(this.chart, y, S, M, u);
          return A.proxyContainerElement.appendChild(f.element), A.proxyElements.push(f), f;
        }
        addGroup(T, y = "div", S) {
          let u, A = this.groups[T];
          if (A) return A.groupElement;
          let M = this.domElementProvider.createElement(y);
          return S && S.role && y !== "div" ? (u = this.domElementProvider.createElement("div")).appendChild(M) : u = M, u.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + T.replace(/\W/g, "-"), this.groups[T] = { proxyContainerElement: M, groupElement: u, type: y, proxyElements: [] }, B(u, S || {}), y === "ul" && M.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(u), this.updateGroupOrder(this.groupOrder), u;
        }
        updateGroupAttrs(T, y) {
          let S = this.groups[T];
          if (!S) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + T);
          B(S.groupElement, y);
        }
        updateGroupOrder(T) {
          if (this.groupOrder = T.slice(), this.isDOMOrderGroupOrder()) return;
          let y = T.indexOf("series"), S = y > -1 ? T.slice(0, y) : T, u = y > -1 ? T.slice(y + 1) : [], A = I.activeElement;
          ["before", "after"].forEach((M) => {
            let f = this[M === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            x(f), (M === "before" ? S : u).forEach((m) => {
              let C = this.groups[m];
              C && f.appendChild(C.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(A) || this.afterChartProxyPosContainer.contains(A)) && A && A.focus && A.focus();
        }
        clearGroup(T) {
          let y = this.groups[T];
          if (!y) throw Error("ProxyProvider.clearGroup: Invalid group key " + T);
          x(y.proxyContainerElement);
        }
        removeGroup(T) {
          let y = this.groups[T];
          y && (this.domElementProvider.removeElement(y.groupElement), y.groupElement !== y.proxyContainerElement && this.domElementProvider.removeElement(y.proxyContainerElement), delete this.groups[T]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(T) {
          let y = this.groups[T];
          y && y.proxyElements.forEach((S) => S.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(T) {
          let y = this.domElementProvider.createElement("div");
          return y.setAttribute("aria-hidden", "false"), y.className = "highcharts-a11y-proxy-container" + (T ? "-" + T : ""), R(y, { top: "0", left: "0" }), this.chart.styledMode || (y.style.whiteSpace = "nowrap", y.style.position = "absolute"), y;
        }
        getCurrentGroupOrderInDOM() {
          let T = (A) => {
            let M = Object.keys(this.groups), f = M.length;
            for (; f--; ) {
              let m = M[f], C = this.groups[m];
              if (C && A === C.groupElement) return m;
            }
          }, y = (A) => {
            let M = [], f = A.children;
            for (let m = 0; m < f.length; ++m) {
              let C = T(f[m]);
              C && M.push(C);
            }
            return M;
          }, S = y(this.beforeChartProxyPosContainer), u = y(this.afterChartProxyPosContainer);
          return S.push("series"), S.concat(u);
        }
        isDOMOrderGroupOrder() {
          let T = this.getCurrentGroupOrderInDOM(), y = this.groupOrder.filter((u) => u === "series" || !!this.groups[u]), S = T.length;
          if (S !== y.length) return !1;
          for (; S--; ) if (T[S] !== y[S]) return !1;
          return !0;
        }
        updatePosContainerPositions() {
          let T = this.chart;
          if (T.renderer.forExport) return;
          let y = T.renderer.box;
          T.container.insertBefore(this.afterChartProxyPosContainer, y.nextSibling), T.container.insertBefore(this.beforeChartProxyPosContainer, y), N(this.chart, this.afterChartProxyPosContainer), N(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), i(e, "Accessibility/Components/RangeSelectorComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/Announcer.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { unhideChartElementFromAT: j, getAxisRangeDescription: I } = l, { addEvent: B, attr: R } = D;
      class N extends o {
        init() {
          let T = this.chart;
          this.announcer = new n(T, "polite");
        }
        onChartUpdate() {
          let T = this.chart, y = this, S = T.rangeSelector;
          S && (this.updateSelectorVisibility(), this.setDropdownAttrs(), S.buttons && S.buttons.length && S.buttons.forEach((u) => {
            y.setRangeButtonAttrs(u);
          }), S.maxInput && S.minInput && ["minInput", "maxInput"].forEach(function(u, A) {
            let M = S[u];
            M && (j(T, M), y.setRangeInputAttrs(M, "accessibility.rangeSelector." + (A ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let T = this.chart, y = T.rangeSelector, S = y && y.dropdown, u = y && y.buttons || [], A = (M) => M.setAttribute("aria-hidden", !0);
          y && y.hasVisibleDropdown && S ? (j(T, S), u.forEach((M) => A(M.element))) : (S && A(S), u.forEach((M) => j(T, M.element)));
        }
        setDropdownAttrs() {
          let T = this.chart, y = T.rangeSelector && T.rangeSelector.dropdown;
          if (y) {
            let S = T.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: T.options.lang.rangeSelectorZoom });
            y.setAttribute("aria-label", S), y.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(T) {
          R(T.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(T, y) {
          let S = this.chart;
          R(T, { tabindex: -1, "aria-label": S.langFormat(y, { chart: S }) });
        }
        onButtonNavKbdArrowKey(T, y) {
          let S = T.response, u = this.keyCodes, A = this.chart, M = A.options.accessibility.keyboardNavigation.wrapAround, f = y === u.left || y === u.up ? -1 : 1;
          return A.highlightRangeSelectorButton(A.highlightedRangeSelectorItemIx + f) ? S.success : M ? (T.init(f), S.success) : S[f > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(T) {
          let y = T.response, S = this.chart;
          return S.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(S.rangeSelector.buttons[S.highlightedRangeSelectorItemIx].element), y.success;
        }
        onAfterBtnClick() {
          let T = this.chart, y = I(T.xAxis[0]), S = T.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: T, axisRangeDescription: y });
          S && this.announcer.announce(S);
        }
        onInputKbdMove(T) {
          let y = this.chart, S = y.rangeSelector, u = y.highlightedInputRangeIx = (y.highlightedInputRangeIx || 0) + T;
          if (u > 1 || u < 0) {
            if (y.accessibility) return y.accessibility.keyboardNavigation.exiting = !0, y.accessibility.keyboardNavigation.tabindexContainer.focus(), y.accessibility.keyboardNavigation.move(T);
          } else if (S) {
            let A = S[u ? "maxDateBox" : "minDateBox"], M = S[u ? "maxInput" : "minInput"];
            A && M && y.setFocusToElement(A, M);
          }
          return !0;
        }
        onInputNavInit(T) {
          let y = this, S = this.chart, u = T > 0 ? 0 : 1, A = S.rangeSelector, M = A && A[u ? "maxDateBox" : "minDateBox"], f = A && A.minInput, m = A && A.maxInput;
          if (S.highlightedInputRangeIx = u, M && f && m) {
            S.setFocusToElement(M, u ? m : f), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let C = (E) => {
              (E.which || E.keyCode) === this.keyCodes.tab && y.onInputKbdMove(E.shiftKey ? -1 : 1) && (E.preventDefault(), E.stopPropagation());
            }, F = B(f, "keydown", C), _ = B(m, "keydown", C);
            this.removeInputKeydownHandler = () => {
              F(), _();
            };
          }
        }
        onInputNavTerminate() {
          let T = this.chart.rangeSelector || {};
          T.maxInput && T.hideInput("max"), T.minInput && T.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let T = this.chart, y = T.rangeSelector, S = y && y.dropdown;
          y && S && (T.setFocusToElement(y.buttonGroup, S), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = B(S, "keydown", (u) => {
            let A = (u.which || u.keyCode) === this.keyCodes.tab, M = T.accessibility;
            A && (u.preventDefault(), u.stopPropagation(), M && (M.keyboardNavigation.tabindexContainer.focus(), M.keyboardNavigation.move(u.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let T = this.chart, y = this.keyCodes, S = this;
          return new L(T, { keyCodeMap: [[[y.left, y.right, y.up, y.down], function(u) {
            return S.onButtonNavKbdArrowKey(this, u);
          }], [[y.enter, y.space], function() {
            return S.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(T.rangeSelector && T.rangeSelector.buttons && T.rangeSelector.buttons.length);
          }, init: function(u) {
            let A = T.rangeSelector;
            if (A && A.hasVisibleDropdown) S.initDropdownNav();
            else if (A) {
              let M = A.buttons.length - 1;
              T.highlightRangeSelectorButton(u > 0 ? 0 : M);
            }
          }, terminate: function() {
            S.removeDropdownKeydownHandler && (S.removeDropdownKeydownHandler(), delete S.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let T = this.chart, y = this;
          return new L(T, { keyCodeMap: [], validate: function() {
            return !!(T.rangeSelector && T.rangeSelector.inputGroup && T.rangeSelector.inputGroup.element.style.visibility !== "hidden" && T.options.rangeSelector.inputEnabled !== !1 && T.rangeSelector.minInput && T.rangeSelector.maxInput);
          }, init: function(S) {
            y.onInputNavInit(S);
          }, terminate: function() {
            y.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(x) {
        function T(S) {
          let u = this.rangeSelector && this.rangeSelector.buttons || [], A = this.highlightedRangeSelectorItemIx, M = this.rangeSelector && this.rangeSelector.selected;
          return A !== void 0 && u[A] && A !== M && u[A].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = S, !!u[S] && (this.setFocusToElement(u[S].box, u[S].element), S !== M && (this.oldRangeSelectorItemState = u[S].state, u[S].setState(1)), !0);
        }
        function y() {
          let S = this.chart.accessibility;
          if (S && S.components.rangeSelector) return S.components.rangeSelector.onAfterBtnClick();
        }
        x.compose = function(S, u) {
          let A = S.prototype;
          A.highlightRangeSelectorButton || (A.highlightRangeSelectorButton = T, B(u, "afterBtnClick", y));
        };
      }(N || (N = {})), N;
    }), i(e, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { composed: L } = o, { addEvent: D, merge: j, pushUnique: I } = n;
      return function(B) {
        function R(A) {
          j(!0, A, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
        }
        function N(A) {
          return A.marker.states && A.marker.states.normal && A.marker.states.normal.opacity;
        }
        function x(A) {
          return !!(A._hasPointMarkers && A.points && A.points.length);
        }
        function T() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), x(this) && this.points.forEach((A) => {
            A.graphic && (A.graphic[A.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), A.graphic[A.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function y(A) {
          this.resetA11yMarkerOptions = j(A.options.marker || {}, this.userOptions.marker || {});
        }
        function S() {
          let A = this.options;
          (function(M) {
            let f = M.chart.options.accessibility.enabled, m = (M.options.accessibility && M.options.accessibility.enabled) !== !1;
            return f && m && function(C) {
              let F = C.chart.options.accessibility;
              return C.points.length < F.series.pointDescriptionEnabledThreshold || F.series.pointDescriptionEnabledThreshold === !1;
            }(M);
          })(this) ? (A.marker && A.marker.enabled === !1 && (this.a11yMarkersForced = !0, R(this.options)), x(this) && function(M) {
            let f = M.points.length;
            for (; f--; ) {
              let m = M.points[f], C = m.options, F = m.hasForcedA11yMarker;
              if (delete m.hasForcedA11yMarker, C.marker) {
                let _ = F && N(C) === 0;
                C.marker.enabled && !_ ? (j(!0, C.marker, { states: { normal: { opacity: N(C) || 1 } } }), m.hasForcedA11yMarker = !1) : C.marker.enabled === !1 && (R(C), m.hasForcedA11yMarker = !0);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(M) {
            let f = M.resetA11yMarkerOptions;
            if (f) {
              let m = f.states && f.states.normal && f.states.normal.opacity;
              M.userOptions && M.userOptions.marker && (M.userOptions.marker.enabled = !0), M.update({ marker: { enabled: f.enabled, states: { normal: { opacity: m } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function u() {
          this.boosted && this.a11yMarkersForced && (j(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
        }
        B.compose = function(A) {
          I(L, "A11y.FM") && (D(A, "afterSetOptions", y), D(A, "render", S), D(A, "afterRender", T), D(A, "renderCanvas", u));
        };
      }(l || (l = {})), l;
    }), i(e, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [e["Core/Series/Point.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Utils/EventProvider.js"], e["Accessibility/Utils/ChartUtilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { seriesTypes: R } = l, { doc: N } = L, { defined: x, fireEvent: T } = D, { getPointFromXY: y, getSeriesFromName: S, scrollAxisToPoint: u } = B;
      function A(E) {
        let v = E.index, w = E.series.points, d = w.length;
        if (w[v] === E) return v;
        for (; d--; ) if (w[d] === E) return d;
      }
      function M(E) {
        let v = E.chart.options.accessibility.keyboardNavigation.seriesNavigation, w = E.options.accessibility || {}, d = w.keyboardNavigation;
        return d && d.enabled === !1 || w.enabled === !1 || E.options.enableMouseTracking === !1 || !E.visible || v.pointNavigationEnabledThreshold && +v.pointNavigationEnabledThreshold <= E.points.length;
      }
      function f(E) {
        let v = E.series.chart.options.accessibility, w = E.options.accessibility && E.options.accessibility.enabled === !1;
        return E.isNull && v.keyboardNavigation.seriesNavigation.skipNullPoints || E.visible === !1 || E.isInside === !1 || w || M(E.series);
      }
      function m(E) {
        let v = E.series || [], w = v.length;
        for (let d = 0; d < w; ++d) if (!M(v[d])) {
          let r = function(s) {
            let p = s.points || [], b = p.length;
            for (let c = 0; c < b; ++c) if (!f(p[c])) return p[c];
            return null;
          }(v[d]);
          if (r) return r;
        }
        return null;
      }
      function C(E) {
        let v = E.series.length, w = !1;
        for (; v-- && (E.highlightedPoint = E.series[v].points[E.series[v].points.length - 1], !(w = E.series[v].highlightNextValidPoint())); ) ;
        return w;
      }
      function F(E) {
        delete E.highlightedPoint;
        let v = m(E);
        return !!v && v.highlight();
      }
      class _ {
        constructor(v, w) {
          this.keyCodes = w, this.chart = v;
        }
        init() {
          let v = this, w = this.chart, d = this.eventProvider = new I();
          d.addEvent(n, "destroy", function() {
            return v.onSeriesDestroy(this);
          }), d.addEvent(w, "afterApplyDrilldown", function() {
            (function(r) {
              let s = m(r);
              s && s.highlight(!1);
            })(this);
          }), d.addEvent(w, "drilldown", function(r) {
            let s = r.point, p = s.series;
            v.lastDrilledDownPoint = { x: s.x, y: s.y, seriesName: p ? p.name : "" };
          }), d.addEvent(w, "drillupall", function() {
            setTimeout(function() {
              v.onDrillupAll();
            }, 10);
          }), d.addEvent(o, "afterSetState", function() {
            let r = this.graphic && this.graphic.element, s = N.activeElement, p = s && s.getAttribute("class"), b = p && p.indexOf("highcharts-a11y-proxy-element") > -1;
            w.highlightedPoint === this && s !== r && !b && r && r.focus && r.focus();
          });
        }
        onDrillupAll() {
          let v, w = this.lastDrilledDownPoint, d = this.chart, r = w && S(d, w.seriesName);
          w && r && x(w.x) && x(w.y) && (v = y(r, w.x, w.y)), v = v || m(d), d.container && d.container.focus(), v && v.highlight && v.highlight(!1);
        }
        getKeyboardNavigationHandler() {
          let v = this, w = this.keyCodes, d = this.chart, r = d.inverted;
          return new j(d, { keyCodeMap: [[r ? [w.up, w.down] : [w.left, w.right], function(s) {
            return v.onKbdSideways(this, s);
          }], [r ? [w.left, w.right] : [w.up, w.down], function(s) {
            return v.onKbdVertical(this, s);
          }], [[w.enter, w.space], function(s, p) {
            var c;
            let b = d.highlightedPoint;
            if (b) {
              let { plotLeft: h, plotTop: g } = this.chart, { plotX: k = 0, plotY: P = 0 } = b;
              p = { ...p, chartX: h + k, chartY: g + P, point: b, target: ((c = b.graphic) == null ? void 0 : c.element) || p.target }, T(b.series, "click", p), b.firePointEvent("click", p);
            }
            return this.response.success;
          }], [[w.home], function() {
            return F(d), this.response.success;
          }], [[w.end], function() {
            return C(d), this.response.success;
          }], [[w.pageDown, w.pageUp], function(s) {
            return d.highlightAdjacentSeries(s === w.pageDown), this.response.success;
          }]], init: function() {
            return v.onHandlerInit(this);
          }, validate: function() {
            return !!m(d);
          }, terminate: function() {
            return v.onHandlerTerminate();
          } });
        }
        onKbdSideways(v, w) {
          let d = this.keyCodes, r = w === d.right || w === d.down;
          return this.attemptHighlightAdjacentPoint(v, r);
        }
        onHandlerInit(v) {
          let w = this.chart;
          return w.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && w.highlightedPoint ? w.highlightedPoint.highlight() : F(w), v.response.success;
        }
        onKbdVertical(v, w) {
          let d = this.chart, r = this.keyCodes, s = w === r.down || w === r.right, p = d.options.accessibility.keyboardNavigation.seriesNavigation;
          if (p.mode && p.mode === "serialize") return this.attemptHighlightAdjacentPoint(v, s);
          let b = d.highlightedPoint && d.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return d[b](s), v.response.success;
        }
        onHandlerTerminate() {
          let v = this.chart, w = v.options.accessibility.keyboardNavigation;
          v.tooltip && v.tooltip.hide(0);
          let d = v.highlightedPoint && v.highlightedPoint.series;
          d && d.onMouseOut && d.onMouseOut(), v.highlightedPoint && v.highlightedPoint.onMouseOut && v.highlightedPoint.onMouseOut(), w.seriesNavigation.rememberPointFocus || delete v.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(v, w) {
          let d = this.chart, r = d.options.accessibility.keyboardNavigation.wrapAround;
          return d.highlightAdjacentPoint(w) || r && (w ? F(d) : C(d)) ? v.response.success : v.response[w ? "next" : "prev"];
        }
        onSeriesDestroy(v) {
          let w = this.chart;
          w.highlightedPoint && w.highlightedPoint.series === v && (delete w.highlightedPoint, w.focusElement && w.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(E) {
        function v(p) {
          let b, c, h = this.series, g = this.highlightedPoint, k = g && A(g) || 0, P = g && g.series.points || [], O = this.series && this.series[this.series.length - 1], z = O && O.points && O.points[O.points.length - 1];
          if (!h[0] || !h[0].points) return !1;
          if (g) {
            if (b = h[g.series.index + (p ? 1 : -1)], (c = P[k + (p ? 1 : -1)]) || !b || (c = b.points[p ? 0 : b.points.length - 1]), !c) return !1;
          } else c = p ? h[0].points[0] : z;
          return f(c) ? (M(b = c.series) ? this.highlightedPoint = p ? b.points[b.points.length - 1] : b.points[0] : this.highlightedPoint = c, this.highlightAdjacentPoint(p)) : c.highlight();
        }
        function w(p) {
          let b = this.highlightedPoint, c = 1 / 0, h;
          return !!(x(b.plotX) && x(b.plotY)) && (this.series.forEach((g) => {
            M(g) || g.points.forEach((k) => {
              if (!x(k.plotY) || !x(k.plotX) || k === b) return;
              let P = k.plotY - b.plotY, O = Math.abs(k.plotX - b.plotX), z = Math.abs(P) * Math.abs(P) + O * O * 4;
              g.yAxis && g.yAxis.reversed && (P *= -1), !(P <= 0 && p || P >= 0 && !p || z < 5 || f(k)) && z < c && (c = z, h = k);
            });
          }), !!h && h.highlight());
        }
        function d(p) {
          let b, c, h, g = this.highlightedPoint, k = this.series && this.series[this.series.length - 1], P = k && k.points && k.points[k.points.length - 1];
          return this.highlightedPoint ? !!((b = this.series[g.series.index + (p ? -1 : 1)]) && (c = function(O, z, W, G) {
            let Y = 1 / 0, U, H, q, X = z.points.length, $ = (K) => !(x(K.plotX) && x(K.plotY));
            if (!$(O)) {
              for (; X--; ) !$(U = z.points[X]) && (q = (O.plotX - U.plotX) * (O.plotX - U.plotX) * 4 + (O.plotY - U.plotY) * (O.plotY - U.plotY) * 1) < Y && (Y = q, H = X);
              return x(H) ? z.points[H] : void 0;
            }
          }(g, b))) && (M(b) ? (c.highlight(), (h = this.highlightAdjacentSeries(p)) ? h : (g.highlight(), !1)) : (c.highlight(), c.series.highlightNextValidPoint())) : (b = p ? this.series && this.series[0] : k, !!(c = p ? b && b.points && b.points[0] : P) && c.highlight());
        }
        function r(p = !0) {
          var g, k;
          let b = this.series.chart, c = (k = (g = b.tooltip) == null ? void 0 : g.label) == null ? void 0 : k.element;
          !this.isNull && p ? this.onMouseOver() : b.tooltip && b.tooltip.hide(0), u(this), this.graphic && (b.setFocusToElement(this.graphic), !p && b.focusElement && b.focusElement.removeFocusBorder()), b.highlightedPoint = this;
          let h = c == null ? void 0 : c.getBoundingClientRect().top;
          if (c && h && h < 0) {
            let P = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: P + h });
          }
          return this;
        }
        function s() {
          let p = this.chart.highlightedPoint, b = (p && p.series) === this ? A(p) : 0, c = this.points, h = c.length;
          if (c && h) {
            for (let g = b; g < h; ++g) if (!f(c[g])) return c[g].highlight();
            for (let g = b; g >= 0; --g) if (!f(c[g])) return c[g].highlight();
          }
          return !1;
        }
        E.compose = function(p, b, c) {
          let h = p.prototype, g = b.prototype, k = c.prototype;
          h.highlightAdjacentPoint || (h.highlightAdjacentPoint = v, h.highlightAdjacentPointVertical = w, h.highlightAdjacentSeries = d, g.highlight = r, k.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((P) => {
            R[P] && (R[P].prototype.keyboardMoveVertical = !1);
          }), k.highlightNextValidPoint = s);
        };
      }(_ || (_ = {})), _;
    }), i(e, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], e["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(o, n, l, L, D, j) {
      let { hideSeriesFromAT: I } = n, { describeSeries: B } = D;
      return class extends o {
        static compose(R, N, x) {
          L.compose(x), l.compose(x), j.compose(R, N, x);
        }
        init() {
          this.newDataAnnouncer = new L(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new j(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let R = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === R.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(R) {
              R.labelBySeries && R.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(R) {
            (R.options.accessibility && R.options.accessibility.enabled) !== !1 && R.visible && R.getPointsCollection().length !== 0 ? B(R) : I(R);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), i(e, "Accessibility/Components/ZoomComponent.js", [e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { unhideChartElementFromAT: j } = n, { getFakeMouseEvent: I } = l, { attr: B, pick: R } = D;
      return class extends o {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let N = this, x = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((T) => {
            N.addEvent(x, T, function() {
              N.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let N = this.chart, x = this;
          N.mapNavigation && N.mapNavigation.navButtons.forEach((T, y) => {
            j(N, T.element), x.setMapNavButtonAttrs(T.element, "accessibility.zoom.mapZoom" + (y ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(N, x) {
          let T = this.chart;
          B(N, { tabindex: -1, role: "button", "aria-label": T.langFormat(x, { chart: T }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let N = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), N.resetZoomButton && this.createZoomProxyButton(N.resetZoomButton, "resetZoomProxyButton", N.langFormat("accessibility.zoom.resetZoomButton", { chart: N })), N.drillUpButton && N.breadcrumbs && N.breadcrumbs.list) {
            let x = N.breadcrumbs.list[N.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(N.drillUpButton, "drillUpProxyButton", N.langFormat("accessibility.drillUpButton", { chart: N, buttonText: N.breadcrumbs.getButtonText(x) }));
          }
        }
        createZoomProxyButton(N, x, T) {
          this[x] = this.proxyProvider.addProxyElement("zoom", { click: N }, "button", { "aria-label": T, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let N = this.keyCodes, x = this.chart, T = this;
          return new L(x, { keyCodeMap: [[[N.up, N.down, N.left, N.right], function(y) {
            return T.onMapKbdArrow(this, y);
          }], [[N.tab], function(y, S) {
            return T.onMapKbdTab(this, S);
          }], [[N.space, N.enter], function() {
            return T.onMapKbdClick(this);
          }]], validate: function() {
            return !!(x.mapView && x.mapNavigation && x.mapNavigation.navButtons.length);
          }, init: function(y) {
            return T.onMapNavInit(y);
          } });
        }
        onMapKbdArrow(N, x) {
          let T = this.chart, y = this.keyCodes, S = T.container, u = x === y.up || x === y.down, A = x === y.left || x === y.up ? 1 : -1, M = (u ? T.plotHeight : T.plotWidth) / 10 * A, f = 10 * Math.random(), m = { x: S.offsetLeft + T.plotLeft + T.plotWidth / 2 + f, y: S.offsetTop + T.plotTop + T.plotHeight / 2 + f }, C = u ? { x: m.x, y: m.y + M } : { x: m.x + M, y: m.y };
          return [I("mousedown", m), I("mousemove", C), I("mouseup", C)].forEach((F) => S.dispatchEvent(F)), N.response.success;
        }
        onMapKbdTab(N, x) {
          let T = this.chart, y = N.response, S = x.shiftKey, u = S && !this.focusedMapNavButtonIx || !S && this.focusedMapNavButtonIx;
          if (T.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), u) return T.mapView && T.mapView.zoomBy(), y[S ? "prev" : "next"];
          this.focusedMapNavButtonIx += S ? -1 : 1;
          let A = T.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return T.setFocusToElement(A.box, A.element), A.setState(2), y.success;
        }
        onMapKbdClick(N) {
          let x = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(x), N.response.success;
        }
        onMapNavInit(N) {
          let x = this.chart, T = x.mapNavigation.navButtons[0], y = x.mapNavigation.navButtons[1], S = N > 0 ? T : y;
          x.setFocusToElement(S.box, S.element), S.setState(2), this.focusedMapNavButtonIx = N > 0 ? 0 : 1;
        }
        simpleButtonNavigation(N, x, T) {
          let y = this.keyCodes, S = this, u = this.chart;
          return new L(u, { keyCodeMap: [[[y.tab, y.up, y.down, y.left, y.right], function(A, M) {
            let f = A === y.tab && M.shiftKey || A === y.left || A === y.up;
            return this.response[f ? "prev" : "next"];
          }], [[y.space, y.enter], function() {
            return R(T(this, u), this.response.success);
          }]], validate: function() {
            return u[N] && u[N].box && S[x].innerElement;
          }, init: function() {
            u.setFocusToElement(u[N].box, S[x].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(N, x) {
            x.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(N, x) {
            return x.drillUp(), N.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), i(e, "Accessibility/HighContrastMode.js", [e["Core/Globals.js"]], function(o) {
      let { doc: n, isMS: l, win: L } = o;
      return { isHighContrastModeActive: function() {
        let D = /(Edg)/.test(L.navigator.userAgent);
        if (L.matchMedia && D) return L.matchMedia("(-ms-high-contrast: active)").matches;
        if (l && L.getComputedStyle) {
          let j = n.createElement("div");
          j.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", n.body.appendChild(j);
          let I = (j.currentStyle || L.getComputedStyle(j)).backgroundImage;
          return n.body.removeChild(j), I === "none";
        }
        return L.matchMedia && L.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(D) {
        var B;
        D.highContrastModeActive = !0;
        let j = D.options.accessibility.highContrastTheme;
        D.update(j, !1);
        let I = ((B = j.colors) == null ? void 0 : B.length) > 1;
        D.series.forEach(function(R) {
          let N = j.plotOptions[R.type] || {}, x = I && R.colorIndex !== void 0 ? j.colors[R.colorIndex] : N.color || "window", T = { color: N.color || "windowText", colors: I ? j.colors : [N.color || "windowText"], borderColor: N.borderColor || "window", fillColor: x };
          R.update(T, !1), R.points && R.points.forEach(function(y) {
            y.options && y.options.color && y.update({ color: N.color || "windowText", borderColor: N.borderColor || "window" }, !1);
          });
        }), D.redraw();
      } };
    }), i(e, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), i(e, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
    }), i(e, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), i(e, "Accessibility/Options/DeprecatedOptions.js", [e["Core/Utilities.js"]], function(o) {
      let { error: n, pick: l } = o;
      function L(j, I, B) {
        let R = j, N, x = 0;
        for (; x < I.length - 1; ++x) R = R[N = I[x]] = l(R[N], {});
        R[I[I.length - 1]] = B;
      }
      function D(j, I, B, R) {
        function N(y, S) {
          return S.reduce(function(u, A) {
            return u[A];
          }, y);
        }
        let x = N(j.options, I), T = N(j.options, B);
        Object.keys(R).forEach(function(y) {
          let S = x[y];
          S !== void 0 && (L(T, R[y], S), n(32, !1, j, { [I.join(".") + "." + y]: B.join(".") + "." + R[y].join(".") }));
        });
      }
      return function(j) {
        (function(I) {
          let B = I.options.chart, R = I.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(N) {
            B[N] && (R[N] = B[N], n(32, !1, I, { [`chart.${N}`]: `use accessibility.${N}` }));
          });
        })(j), function(I) {
          I.axes.forEach(function(B) {
            let R = B.options;
            R && R.description && (R.accessibility = R.accessibility || {}, R.accessibility.description = R.description, n(32, !1, I, { "axis.description": "use axis.accessibility.description" }));
          });
        }(j), j.series && function(I) {
          let B = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          I.series.forEach(function(R) {
            Object.keys(B).forEach(function(N) {
              let x = R.options[N];
              N === "accessibility.pointDescriptionFormatter" && (x = R.options.accessibility && R.options.accessibility.pointDescriptionFormatter), x !== void 0 && (L(R.options, B[N], N === "skipKeyboardNavigation" ? !x : x), n(32, !1, I, { [`series.${N}`]: "series." + B[N].join(".") }));
            });
          });
        }(j), D(j, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), D(j, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), D(j, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), i(e, "Accessibility/Accessibility.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/A11yI18n.js"], e["Accessibility/Components/ContainerComponent.js"], e["Accessibility/FocusBorder.js"], e["Accessibility/Components/InfoRegionsComponent.js"], e["Accessibility/KeyboardNavigation.js"], e["Accessibility/Components/LegendComponent.js"], e["Accessibility/Components/MenuComponent.js"], e["Accessibility/Components/NavigatorComponent.js"], e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], e["Accessibility/ProxyProvider.js"], e["Accessibility/Components/RangeSelectorComponent.js"], e["Accessibility/Components/SeriesComponent/SeriesComponent.js"], e["Accessibility/Components/ZoomComponent.js"], e["Accessibility/HighContrastMode.js"], e["Accessibility/HighContrastTheme.js"], e["Accessibility/Options/A11yDefaults.js"], e["Accessibility/Options/LangDefaults.js"], e["Accessibility/Options/DeprecatedOptions.js"]], function(o, n, l, L, D, j, I, B, R, N, x, T, y, S, u, A, M, f, m, C, F, _) {
      let { defaultOptions: E } = o, { doc: v } = n, { addEvent: w, extend: d, fireEvent: r, merge: s } = l, { removeElement: p } = L;
      class b {
        constructor(h) {
          this.init(h);
        }
        init(h) {
          if (this.chart = h, !v.addEventListener) {
            this.zombie = !0, this.components = {}, h.renderTo.setAttribute("aria-hidden", !0);
            return;
          }
          _(h), this.proxyProvider = new S(this.chart), this.initComponents(), this.keyboardNavigation = new R(h, this.components);
        }
        initComponents() {
          let h = this.chart, g = this.proxyProvider, k = h.options.accessibility;
          this.components = { container: new j(), infoRegions: new B(), legend: new N(), chartMenu: new x(), rangeSelector: new u(), series: new A(), zoom: new M(), navigator: new T() }, k.customComponents && d(this.components, k.customComponents);
          let P = this.components;
          this.getComponentOrder().forEach(function(O) {
            P[O].initBase(h, g), P[O].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((h) => h !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let h = this.components, g = this.chart, k = g.options.accessibility;
          r(g, "beforeA11yUpdate"), g.types = this.getChartTypes();
          let P = k.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(P), this.getComponentOrder().forEach(function(O) {
            h[O].onChartUpdate(), r(g, "afterA11yComponentUpdate", { name: O, component: h[O] });
          }), this.keyboardNavigation.update(P), !g.highContrastModeActive && k.highContrastMode !== !1 && (f.isHighContrastModeActive() || k.highContrastMode === !0) && f.setHighContrastTheme(g), r(g, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let h = this.chart || {}, g = this.components;
          Object.keys(g).forEach(function(k) {
            g[k].destroy(), g[k].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), h.announcerContainer && p(h.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), h.renderTo && h.renderTo.setAttribute("aria-hidden", !0), h.focusElement && h.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let h = {};
          return this.chart.series.forEach(function(g) {
            h[g.type] = 1;
          }), Object.keys(h);
        }
      }
      return function(c) {
        function h() {
          this.accessibility && this.accessibility.destroy();
        }
        function g() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let z = this.accessibility;
          z && !z.zombie && (z.proxyProvider.updateProxyElementPositions(), z.getComponentOrder().forEach(function(W) {
            z.components[W].onChartRender();
          }));
        }
        function k(z) {
          let W = z.options.accessibility;
          W && (W.customComponents && (this.options.accessibility.customComponents = W.customComponents, delete W.customComponents), s(!0, this.options.accessibility, W), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function P() {
          let z = this.accessibility, W = this.options.accessibility, G = this.renderer.boxWrapper.element, Y = this.title;
          if (W && W.enabled) z && !z.zombie ? z.update() : (this.accessibility = z = new c(this), z && !z.zombie && z.update(), G.getAttribute("role") === "img" && G.removeAttribute("role"));
          else if (z) z.destroy && z.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (Y && Y.element.textContent || "").replace(/</g, "&lt;")), G.setAttribute("aria-hidden", !0);
            let U = document.getElementsByClassName("highcharts-description")[0];
            U && (U.setAttribute("aria-hidden", !1), U.classList.remove("highcharts-linked-description"));
          }
        }
        function O() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        c.i18nFormat = D.i18nFormat, c.compose = function(z, W, G, Y, U, H) {
          R.compose(z), y.compose(Y), N.compose(z, W), x.compose(z), A.compose(z, G, Y), D.compose(z), I.compose(z, U), H && u.compose(z, H);
          let q = z.prototype;
          q.updateA11yEnabled || (q.updateA11yEnabled = P, w(z, "destroy", h), w(z, "render", g), w(z, "update", k), ["addSeries", "init"].forEach((X) => {
            w(z, X, function() {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((X) => {
            w(z, X, function() {
              let $ = this.accessibility;
              $ && !$.zombie && $.update();
            });
          }), w(G, "update", O), ["update", "updatedData", "remove"].forEach((X) => {
            w(Y, X, function() {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(b || (b = {})), s(!0, E, C, { accessibility: { highContrastTheme: m }, lang: F }), b;
    }), i(e, "masters/modules/accessibility.src.js", [e["Core/Globals.js"], e["Accessibility/Accessibility.js"], e["Accessibility/AccessibilityComponent.js"], e["Accessibility/Utils/ChartUtilities.js"], e["Accessibility/Utils/HTMLUtilities.js"], e["Accessibility/KeyboardNavigationHandler.js"], e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(o, n, l, L, D, j, I) {
      return o.i18nFormat = n.i18nFormat, o.A11yChartUtilities = L, o.A11yHTMLUtilities = D, o.AccessibilityComponent = l, o.KeyboardNavigationHandler = j, o.SeriesAccessibilityDescriber = I, n.compose(o.Chart, o.Legend, o.Point, o.Series, o.SVGElement, o.RangeSelector), o;
    });
  });
})(Im);
var qA = Im.exports;
const YA = /* @__PURE__ */ ri(qA);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const XA = { attribute: !0, type: String, converter: zl, reflect: !1, hasChanged: Cc }, QA = (a = XA, t, e) => {
  const { kind: i, metadata: o } = e;
  let n = globalThis.litPropertyMetadata.get(o);
  if (n === void 0 && globalThis.litPropertyMetadata.set(o, n = /* @__PURE__ */ new Map()), i === "setter" && ((a = Object.create(a)).wrapped = !0), n.set(e.name, a), i === "accessor") {
    const { name: l } = e;
    return { set(L) {
      const D = t.get.call(this);
      t.set.call(this, L), this.requestUpdate(l, D, a);
    }, init(L) {
      return L !== void 0 && this.C(l, void 0, a, L), L;
    } };
  }
  if (i === "setter") {
    const { name: l } = e;
    return function(L) {
      const D = this[l];
      t.call(this, L), this.requestUpdate(l, D, a);
    };
  }
  throw Error("Unsupported decorator location: " + i);
};
function ue(a) {
  return (t, e) => typeof e == "object" ? QA(a, t, e) : ((i, o, n) => {
    const l = o.hasOwnProperty(n);
    return o.constructor.createProperty(n, i), l ? Object.getOwnPropertyDescriptor(o, n) : void 0;
  })(a, t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Ce(a) {
  return ue({ ...a, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ec = (a, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(a, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function We(a, t) {
  return (e, i, o) => {
    const n = (l) => {
      var L, D;
      return (D = (L = l.renderRoot) == null ? void 0 : L.querySelector(a)) != null ? D : null;
    };
    return Ec(e, i, { get() {
      return n(this);
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let cd;
function Cr(a) {
  return (t, e) => Ec(t, e, { get() {
    var i;
    return ((i = this.renderRoot) != null ? i : cd != null ? cd : cd = document.createDocumentFragment()).querySelectorAll(a);
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Ct(a) {
  return (t, e) => {
    const { slot: i, selector: o } = a != null ? a : {}, n = "slot" + (i ? `[name=${i}]` : ":not([name])");
    return Ec(t, e, { get() {
      var D, j;
      const l = (D = this.renderRoot) == null ? void 0 : D.querySelector(n), L = (j = l == null ? void 0 : l.assignedElements(a)) != null ? j : [];
      return o === void 0 ? L : L.filter((I) => I.matches(o));
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Ho(a) {
  return (t, e) => {
    const { slot: i } = a != null ? a : {}, o = "slot" + (i ? `[name=${i}]` : ":not([name])");
    return Ec(t, e, { get() {
      var l, L;
      const n = (l = this.renderRoot) == null ? void 0 : l.querySelector(o);
      return (L = n == null ? void 0 : n.assignedNodes(a)) != null ? L : [];
    } });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const gn = { ATTRIBUTE: 1, CHILD: 2, EVENT: 5, ELEMENT: 6 }, Ri = (a) => (...t) => ({ _$litDirective$: a, values: t });
let Ni = class {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, e, i) {
    this._$Ct = t, this._$AM = e, this._$Ci = i;
  }
  _$AS(t, e) {
    return this.update(t, e);
  }
  update(t, e) {
    return this.render(...e);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Pe = Ri(class extends Ni {
  constructor(a) {
    var t;
    if (super(a), a.type !== gn.ATTRIBUTE || a.name !== "class" || ((t = a.strings) == null ? void 0 : t.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(a) {
    return " " + Object.keys(a).filter((t) => a[t]).join(" ") + " ";
  }
  update(a, [t]) {
    var i, o;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), a.strings !== void 0 && (this.nt = new Set(a.strings.join(" ").split(/\s/).filter((n) => n !== "")));
      for (const n in t) t[n] && !((i = this.nt) != null && i.has(n)) && this.st.add(n);
      return this.render(t);
    }
    const e = a.element.classList;
    for (const n of this.st) n in t || (e.remove(n), this.st.delete(n));
    for (const n in t) {
      const l = !!t[n];
      l === this.st.has(n) || (o = this.nt) != null && o.has(n) || (l ? (e.add(n), this.st.add(n)) : (e.remove(n), this.st.delete(n)));
    }
    return ei;
  }
});
var Bm = typeof global == "object" && global && global.Object === Object && global, ZA = typeof self == "object" && self && self.Object === Object && self, si = Bm || ZA || Function("return this")(), fa = si.Symbol, Rm = Object.prototype, JA = Rm.hasOwnProperty, ey = Rm.toString, _r = fa ? fa.toStringTag : void 0;
function ty(a) {
  var t = JA.call(a, _r), e = a[_r];
  try {
    a[_r] = void 0;
    var i = !0;
  } catch {
  }
  var o = ey.call(a);
  return i && (t ? a[_r] = e : delete a[_r]), o;
}
var oy = Object.prototype, iy = oy.toString;
function ay(a) {
  return iy.call(a);
}
var ny = "[object Null]", ry = "[object Undefined]", Rp = fa ? fa.toStringTag : void 0;
function mn(a) {
  return a == null ? a === void 0 ? ry : ny : Rp && Rp in Object(a) ? ty(a) : ay(a);
}
function va(a) {
  return a != null && typeof a == "object";
}
var sy = "[object Symbol]";
function Gh(a) {
  return typeof a == "symbol" || va(a) && mn(a) == sy;
}
function Nm(a, t) {
  for (var e = -1, i = a == null ? 0 : a.length, o = Array(i); ++e < i; )
    o[e] = t(a[e], e, a);
  return o;
}
var ko = Array.isArray, Np = fa ? fa.prototype : void 0, Fp = Np ? Np.toString : void 0;
function Fm(a) {
  if (typeof a == "string")
    return a;
  if (ko(a))
    return Nm(a, Fm) + "";
  if (Gh(a))
    return Fp ? Fp.call(a) : "";
  var t = a + "";
  return t == "0" && 1 / a == -1 / 0 ? "-0" : t;
}
function ti(a) {
  var t = typeof a;
  return a != null && (t == "object" || t == "function");
}
function Wh(a) {
  return a;
}
var ly = "[object AsyncFunction]", cy = "[object Function]", dy = "[object GeneratorFunction]", hy = "[object Proxy]";
function Vh(a) {
  if (!ti(a))
    return !1;
  var t = mn(a);
  return t == cy || t == dy || t == ly || t == hy;
}
var dd = si["__core-js_shared__"], jp = function() {
  var a = /[^.]+$/.exec(dd && dd.keys && dd.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}();
function by(a) {
  return !!jp && jp in a;
}
var py = Function.prototype, uy = py.toString;
function fn(a) {
  if (a != null) {
    try {
      return uy.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
var gy = /[\\^$.*+?()[\]{}|]/g, my = /^\[object .+?Constructor\]$/, fy = Function.prototype, vy = Object.prototype, Ay = fy.toString, yy = vy.hasOwnProperty, xy = RegExp(
  "^" + Ay.call(yy).replace(gy, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function wy(a) {
  if (!ti(a) || by(a))
    return !1;
  var t = Vh(a) ? xy : my;
  return t.test(fn(a));
}
function ky(a, t) {
  return a == null ? void 0 : a[t];
}
function vn(a, t) {
  var e = ky(a, t);
  return wy(e) ? e : void 0;
}
var eh = vn(si, "WeakMap"), _p = Object.create, Cy = /* @__PURE__ */ function() {
  function a() {
  }
  return function(t) {
    if (!ti(t))
      return {};
    if (_p)
      return _p(t);
    a.prototype = t;
    var e = new a();
    return a.prototype = void 0, e;
  };
}();
function Sy(a, t, e) {
  switch (e.length) {
    case 0:
      return a.call(t);
    case 1:
      return a.call(t, e[0]);
    case 2:
      return a.call(t, e[0], e[1]);
    case 3:
      return a.call(t, e[0], e[1], e[2]);
  }
  return a.apply(t, e);
}
function Ey(a, t) {
  var e = -1, i = a.length;
  for (t || (t = Array(i)); ++e < i; )
    t[e] = a[e];
  return t;
}
var My = 800, Ty = 16, Ly = Date.now;
function Oy(a) {
  var t = 0, e = 0;
  return function() {
    var i = Ly(), o = Ty - (i - e);
    if (e = i, o > 0) {
      if (++t >= My)
        return arguments[0];
    } else
      t = 0;
    return a.apply(void 0, arguments);
  };
}
function Py(a) {
  return function() {
    return a;
  };
}
var Bl = function() {
  try {
    var a = vn(Object, "defineProperty");
    return a({}, "", {}), a;
  } catch {
  }
}(), Dy = Bl ? function(a, t) {
  return Bl(a, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Py(t),
    writable: !0
  });
} : Wh, zy = Oy(Dy), Iy = 9007199254740991, By = /^(?:0|[1-9]\d*)$/;
function Mc(a, t) {
  var e = typeof a;
  return t = t == null ? Iy : t, !!t && (e == "number" || e != "symbol" && By.test(a)) && a > -1 && a % 1 == 0 && a < t;
}
function qh(a, t, e) {
  t == "__proto__" && Bl ? Bl(a, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : a[t] = e;
}
function Vs(a, t) {
  return a === t || a !== a && t !== t;
}
var Ry = Object.prototype, Ny = Ry.hasOwnProperty;
function jm(a, t, e) {
  var i = a[t];
  (!(Ny.call(a, t) && Vs(i, e)) || e === void 0 && !(t in a)) && qh(a, t, e);
}
function Fy(a, t, e, i) {
  var o = !e;
  e || (e = {});
  for (var n = -1, l = t.length; ++n < l; ) {
    var L = t[n], D = void 0;
    D === void 0 && (D = a[L]), o ? qh(e, L, D) : jm(e, L, D);
  }
  return e;
}
var Up = Math.max;
function jy(a, t, e) {
  return t = Up(t === void 0 ? a.length - 1 : t, 0), function() {
    for (var i = arguments, o = -1, n = Up(i.length - t, 0), l = Array(n); ++o < n; )
      l[o] = i[t + o];
    o = -1;
    for (var L = Array(t + 1); ++o < t; )
      L[o] = i[o];
    return L[t] = e(l), Sy(a, this, L);
  };
}
function _y(a, t) {
  return zy(jy(a, t, Wh), a + "");
}
var Uy = 9007199254740991;
function Yh(a) {
  return typeof a == "number" && a > -1 && a % 1 == 0 && a <= Uy;
}
function Tc(a) {
  return a != null && Yh(a.length) && !Vh(a);
}
function $y(a, t, e) {
  if (!ti(e))
    return !1;
  var i = typeof t;
  return (i == "number" ? Tc(e) && Mc(t, e.length) : i == "string" && t in e) ? Vs(e[t], a) : !1;
}
function Hy(a) {
  return _y(function(t, e) {
    var i = -1, o = e.length, n = o > 1 ? e[o - 1] : void 0, l = o > 2 ? e[2] : void 0;
    for (n = a.length > 3 && typeof n == "function" ? (o--, n) : void 0, l && $y(e[0], e[1], l) && (n = o < 3 ? void 0 : n, o = 1), t = Object(t); ++i < o; ) {
      var L = e[i];
      L && a(t, L, i, n);
    }
    return t;
  });
}
var Ky = Object.prototype;
function Xh(a) {
  var t = a && a.constructor, e = typeof t == "function" && t.prototype || Ky;
  return a === e;
}
function Gy(a, t) {
  for (var e = -1, i = Array(a); ++e < a; )
    i[e] = t(e);
  return i;
}
var Wy = "[object Arguments]";
function $p(a) {
  return va(a) && mn(a) == Wy;
}
var _m = Object.prototype, Vy = _m.hasOwnProperty, qy = _m.propertyIsEnumerable, Rl = $p(/* @__PURE__ */ function() {
  return arguments;
}()) ? $p : function(a) {
  return va(a) && Vy.call(a, "callee") && !qy.call(a, "callee");
};
function Yy() {
  return !1;
}
var Um = typeof exports == "object" && exports && !exports.nodeType && exports, Hp = Um && typeof module == "object" && module && !module.nodeType && module, Xy = Hp && Hp.exports === Um, Kp = Xy ? si.Buffer : void 0, Qy = Kp ? Kp.isBuffer : void 0, Nl = Qy || Yy, Zy = "[object Arguments]", Jy = "[object Array]", e0 = "[object Boolean]", t0 = "[object Date]", o0 = "[object Error]", i0 = "[object Function]", a0 = "[object Map]", n0 = "[object Number]", r0 = "[object Object]", s0 = "[object RegExp]", l0 = "[object Set]", c0 = "[object String]", d0 = "[object WeakMap]", h0 = "[object ArrayBuffer]", b0 = "[object DataView]", p0 = "[object Float32Array]", u0 = "[object Float64Array]", g0 = "[object Int8Array]", m0 = "[object Int16Array]", f0 = "[object Int32Array]", v0 = "[object Uint8Array]", A0 = "[object Uint8ClampedArray]", y0 = "[object Uint16Array]", x0 = "[object Uint32Array]", nt = {};
nt[p0] = nt[u0] = nt[g0] = nt[m0] = nt[f0] = nt[v0] = nt[A0] = nt[y0] = nt[x0] = !0;
nt[Zy] = nt[Jy] = nt[h0] = nt[e0] = nt[b0] = nt[t0] = nt[o0] = nt[i0] = nt[a0] = nt[n0] = nt[r0] = nt[s0] = nt[l0] = nt[c0] = nt[d0] = !1;
function w0(a) {
  return va(a) && Yh(a.length) && !!nt[mn(a)];
}
function k0(a) {
  return function(t) {
    return a(t);
  };
}
var $m = typeof exports == "object" && exports && !exports.nodeType && exports, is = $m && typeof module == "object" && module && !module.nodeType && module, C0 = is && is.exports === $m, hd = C0 && Bm.process, Gp = function() {
  try {
    var a = is && is.require && is.require("util").types;
    return a || hd && hd.binding && hd.binding("util");
  } catch {
  }
}(), Wp = Gp && Gp.isTypedArray, Qh = Wp ? k0(Wp) : w0, S0 = Object.prototype, E0 = S0.hasOwnProperty;
function Hm(a, t) {
  var e = ko(a), i = !e && Rl(a), o = !e && !i && Nl(a), n = !e && !i && !o && Qh(a), l = e || i || o || n, L = l ? Gy(a.length, String) : [], D = L.length;
  for (var j in a)
    (t || E0.call(a, j)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (j == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (j == "offset" || j == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (j == "buffer" || j == "byteLength" || j == "byteOffset") || // Skip index properties.
    Mc(j, D))) && L.push(j);
  return L;
}
function Km(a, t) {
  return function(e) {
    return a(t(e));
  };
}
var M0 = Km(Object.keys, Object), T0 = Object.prototype, L0 = T0.hasOwnProperty;
function O0(a) {
  if (!Xh(a))
    return M0(a);
  var t = [];
  for (var e in Object(a))
    L0.call(a, e) && e != "constructor" && t.push(e);
  return t;
}
function Gm(a) {
  return Tc(a) ? Hm(a) : O0(a);
}
function P0(a) {
  var t = [];
  if (a != null)
    for (var e in Object(a))
      t.push(e);
  return t;
}
var D0 = Object.prototype, z0 = D0.hasOwnProperty;
function I0(a) {
  if (!ti(a))
    return P0(a);
  var t = Xh(a), e = [];
  for (var i in a)
    i == "constructor" && (t || !z0.call(a, i)) || e.push(i);
  return e;
}
function Zh(a) {
  return Tc(a) ? Hm(a, !0) : I0(a);
}
var B0 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, R0 = /^\w*$/;
function Jh(a, t) {
  if (ko(a))
    return !1;
  var e = typeof a;
  return e == "number" || e == "symbol" || e == "boolean" || a == null || Gh(a) ? !0 : R0.test(a) || !B0.test(a) || t != null && a in Object(t);
}
var us = vn(Object, "create");
function N0() {
  this.__data__ = us ? us(null) : {}, this.size = 0;
}
function F0(a) {
  var t = this.has(a) && delete this.__data__[a];
  return this.size -= t ? 1 : 0, t;
}
var j0 = "__lodash_hash_undefined__", _0 = Object.prototype, U0 = _0.hasOwnProperty;
function $0(a) {
  var t = this.__data__;
  if (us) {
    var e = t[a];
    return e === j0 ? void 0 : e;
  }
  return U0.call(t, a) ? t[a] : void 0;
}
var H0 = Object.prototype, K0 = H0.hasOwnProperty;
function G0(a) {
  var t = this.__data__;
  return us ? t[a] !== void 0 : K0.call(t, a);
}
var W0 = "__lodash_hash_undefined__";
function V0(a, t) {
  var e = this.__data__;
  return this.size += this.has(a) ? 0 : 1, e[a] = us && t === void 0 ? W0 : t, this;
}
function sn(a) {
  var t = -1, e = a == null ? 0 : a.length;
  for (this.clear(); ++t < e; ) {
    var i = a[t];
    this.set(i[0], i[1]);
  }
}
sn.prototype.clear = N0;
sn.prototype.delete = F0;
sn.prototype.get = $0;
sn.prototype.has = G0;
sn.prototype.set = V0;
function q0() {
  this.__data__ = [], this.size = 0;
}
function Lc(a, t) {
  for (var e = a.length; e--; )
    if (Vs(a[e][0], t))
      return e;
  return -1;
}
var Y0 = Array.prototype, X0 = Y0.splice;
function Q0(a) {
  var t = this.__data__, e = Lc(t, a);
  if (e < 0)
    return !1;
  var i = t.length - 1;
  return e == i ? t.pop() : X0.call(t, e, 1), --this.size, !0;
}
function Z0(a) {
  var t = this.__data__, e = Lc(t, a);
  return e < 0 ? void 0 : t[e][1];
}
function J0(a) {
  return Lc(this.__data__, a) > -1;
}
function ex(a, t) {
  var e = this.__data__, i = Lc(e, a);
  return i < 0 ? (++this.size, e.push([a, t])) : e[i][1] = t, this;
}
function Fi(a) {
  var t = -1, e = a == null ? 0 : a.length;
  for (this.clear(); ++t < e; ) {
    var i = a[t];
    this.set(i[0], i[1]);
  }
}
Fi.prototype.clear = q0;
Fi.prototype.delete = Q0;
Fi.prototype.get = Z0;
Fi.prototype.has = J0;
Fi.prototype.set = ex;
var gs = vn(si, "Map");
function tx() {
  this.size = 0, this.__data__ = {
    hash: new sn(),
    map: new (gs || Fi)(),
    string: new sn()
  };
}
function ox(a) {
  var t = typeof a;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? a !== "__proto__" : a === null;
}
function Oc(a, t) {
  var e = a.__data__;
  return ox(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
function ix(a) {
  var t = Oc(this, a).delete(a);
  return this.size -= t ? 1 : 0, t;
}
function ax(a) {
  return Oc(this, a).get(a);
}
function nx(a) {
  return Oc(this, a).has(a);
}
function rx(a, t) {
  var e = Oc(this, a), i = e.size;
  return e.set(a, t), this.size += e.size == i ? 0 : 1, this;
}
function ji(a) {
  var t = -1, e = a == null ? 0 : a.length;
  for (this.clear(); ++t < e; ) {
    var i = a[t];
    this.set(i[0], i[1]);
  }
}
ji.prototype.clear = tx;
ji.prototype.delete = ix;
ji.prototype.get = ax;
ji.prototype.has = nx;
ji.prototype.set = rx;
var sx = "Expected a function";
function eb(a, t) {
  if (typeof a != "function" || t != null && typeof t != "function")
    throw new TypeError(sx);
  var e = function() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], n = e.cache;
    if (n.has(o))
      return n.get(o);
    var l = a.apply(this, i);
    return e.cache = n.set(o, l) || n, l;
  };
  return e.cache = new (eb.Cache || ji)(), e;
}
eb.Cache = ji;
var lx = 500;
function cx(a) {
  var t = eb(a, function(i) {
    return e.size === lx && e.clear(), i;
  }), e = t.cache;
  return t;
}
var dx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hx = /\\(\\)?/g, bx = cx(function(a) {
  var t = [];
  return a.charCodeAt(0) === 46 && t.push(""), a.replace(dx, function(e, i, o, n) {
    t.push(o ? n.replace(hx, "$1") : i || e);
  }), t;
});
function px(a) {
  return a == null ? "" : Fm(a);
}
function Pc(a, t) {
  return ko(a) ? a : Jh(a, t) ? [a] : bx(px(a));
}
function qs(a) {
  if (typeof a == "string" || Gh(a))
    return a;
  var t = a + "";
  return t == "0" && 1 / a == -1 / 0 ? "-0" : t;
}
function tb(a, t) {
  t = Pc(t, a);
  for (var e = 0, i = t.length; a != null && e < i; )
    a = a[qs(t[e++])];
  return e && e == i ? a : void 0;
}
function ux(a, t, e) {
  var i = a == null ? void 0 : tb(a, t);
  return i === void 0 ? e : i;
}
function Wm(a, t) {
  for (var e = -1, i = t.length, o = a.length; ++e < i; )
    a[o + e] = t[e];
  return a;
}
var ob = Km(Object.getPrototypeOf, Object), gx = "[object Object]", mx = Function.prototype, fx = Object.prototype, Vm = mx.toString, vx = fx.hasOwnProperty, Ax = Vm.call(Object);
function yx(a) {
  if (!va(a) || mn(a) != gx)
    return !1;
  var t = ob(a);
  if (t === null)
    return !0;
  var e = vx.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && Vm.call(e) == Ax;
}
function xx() {
  this.__data__ = new Fi(), this.size = 0;
}
function wx(a) {
  var t = this.__data__, e = t.delete(a);
  return this.size = t.size, e;
}
function kx(a) {
  return this.__data__.get(a);
}
function Cx(a) {
  return this.__data__.has(a);
}
var Sx = 200;
function Ex(a, t) {
  var e = this.__data__;
  if (e instanceof Fi) {
    var i = e.__data__;
    if (!gs || i.length < Sx - 1)
      return i.push([a, t]), this.size = ++e.size, this;
    e = this.__data__ = new ji(i);
  }
  return e.set(a, t), this.size = e.size, this;
}
function Zo(a) {
  var t = this.__data__ = new Fi(a);
  this.size = t.size;
}
Zo.prototype.clear = xx;
Zo.prototype.delete = wx;
Zo.prototype.get = kx;
Zo.prototype.has = Cx;
Zo.prototype.set = Ex;
var qm = typeof exports == "object" && exports && !exports.nodeType && exports, Vp = qm && typeof module == "object" && module && !module.nodeType && module, Mx = Vp && Vp.exports === qm, qp = Mx ? si.Buffer : void 0;
qp && qp.allocUnsafe;
function Tx(a, t) {
  return a.slice();
}
function Lx(a, t) {
  for (var e = -1, i = a == null ? 0 : a.length, o = 0, n = []; ++e < i; ) {
    var l = a[e];
    t(l, e, a) && (n[o++] = l);
  }
  return n;
}
function Ym() {
  return [];
}
var Ox = Object.prototype, Px = Ox.propertyIsEnumerable, Yp = Object.getOwnPropertySymbols, Xm = Yp ? function(a) {
  return a == null ? [] : (a = Object(a), Lx(Yp(a), function(t) {
    return Px.call(a, t);
  }));
} : Ym, Dx = Object.getOwnPropertySymbols, zx = Dx ? function(a) {
  for (var t = []; a; )
    Wm(t, Xm(a)), a = ob(a);
  return t;
} : Ym;
function Qm(a, t, e) {
  var i = t(a);
  return ko(a) ? i : Wm(i, e(a));
}
function Xp(a) {
  return Qm(a, Gm, Xm);
}
function Ix(a) {
  return Qm(a, Zh, zx);
}
var th = vn(si, "DataView"), oh = vn(si, "Promise"), ih = vn(si, "Set"), Qp = "[object Map]", Bx = "[object Object]", Zp = "[object Promise]", Jp = "[object Set]", eu = "[object WeakMap]", tu = "[object DataView]", Rx = fn(th), Nx = fn(gs), Fx = fn(oh), jx = fn(ih), _x = fn(eh), Ji = mn;
(th && Ji(new th(new ArrayBuffer(1))) != tu || gs && Ji(new gs()) != Qp || oh && Ji(oh.resolve()) != Zp || ih && Ji(new ih()) != Jp || eh && Ji(new eh()) != eu) && (Ji = function(a) {
  var t = mn(a), e = t == Bx ? a.constructor : void 0, i = e ? fn(e) : "";
  if (i)
    switch (i) {
      case Rx:
        return tu;
      case Nx:
        return Qp;
      case Fx:
        return Zp;
      case jx:
        return Jp;
      case _x:
        return eu;
    }
  return t;
});
var Fl = si.Uint8Array;
function Ux(a) {
  var t = new a.constructor(a.byteLength);
  return new Fl(t).set(new Fl(a)), t;
}
function $x(a, t) {
  var e = Ux(a.buffer);
  return new a.constructor(e, a.byteOffset, a.length);
}
function Hx(a) {
  return typeof a.constructor == "function" && !Xh(a) ? Cy(ob(a)) : {};
}
var Kx = "__lodash_hash_undefined__";
function Gx(a) {
  return this.__data__.set(a, Kx), this;
}
function Wx(a) {
  return this.__data__.has(a);
}
function jl(a) {
  var t = -1, e = a == null ? 0 : a.length;
  for (this.__data__ = new ji(); ++t < e; )
    this.add(a[t]);
}
jl.prototype.add = jl.prototype.push = Gx;
jl.prototype.has = Wx;
function Vx(a, t) {
  for (var e = -1, i = a == null ? 0 : a.length; ++e < i; )
    if (t(a[e], e, a))
      return !0;
  return !1;
}
function qx(a, t) {
  return a.has(t);
}
var Yx = 1, Xx = 2;
function Zm(a, t, e, i, o, n) {
  var l = e & Yx, L = a.length, D = t.length;
  if (L != D && !(l && D > L))
    return !1;
  var j = n.get(a), I = n.get(t);
  if (j && I)
    return j == t && I == a;
  var B = -1, R = !0, N = e & Xx ? new jl() : void 0;
  for (n.set(a, t), n.set(t, a); ++B < L; ) {
    var x = a[B], T = t[B];
    if (i)
      var y = l ? i(T, x, B, t, a, n) : i(x, T, B, a, t, n);
    if (y !== void 0) {
      if (y)
        continue;
      R = !1;
      break;
    }
    if (N) {
      if (!Vx(t, function(S, u) {
        if (!qx(N, u) && (x === S || o(x, S, e, i, n)))
          return N.push(u);
      })) {
        R = !1;
        break;
      }
    } else if (!(x === T || o(x, T, e, i, n))) {
      R = !1;
      break;
    }
  }
  return n.delete(a), n.delete(t), R;
}
function Qx(a) {
  var t = -1, e = Array(a.size);
  return a.forEach(function(i, o) {
    e[++t] = [o, i];
  }), e;
}
function Zx(a) {
  var t = -1, e = Array(a.size);
  return a.forEach(function(i) {
    e[++t] = i;
  }), e;
}
var Jx = 1, e1 = 2, t1 = "[object Boolean]", o1 = "[object Date]", i1 = "[object Error]", a1 = "[object Map]", n1 = "[object Number]", r1 = "[object RegExp]", s1 = "[object Set]", l1 = "[object String]", c1 = "[object Symbol]", d1 = "[object ArrayBuffer]", h1 = "[object DataView]", ou = fa ? fa.prototype : void 0, bd = ou ? ou.valueOf : void 0;
function b1(a, t, e, i, o, n, l) {
  switch (e) {
    case h1:
      if (a.byteLength != t.byteLength || a.byteOffset != t.byteOffset)
        return !1;
      a = a.buffer, t = t.buffer;
    case d1:
      return !(a.byteLength != t.byteLength || !n(new Fl(a), new Fl(t)));
    case t1:
    case o1:
    case n1:
      return Vs(+a, +t);
    case i1:
      return a.name == t.name && a.message == t.message;
    case r1:
    case l1:
      return a == t + "";
    case a1:
      var L = Qx;
    case s1:
      var D = i & Jx;
      if (L || (L = Zx), a.size != t.size && !D)
        return !1;
      var j = l.get(a);
      if (j)
        return j == t;
      i |= e1, l.set(a, t);
      var I = Zm(L(a), L(t), i, o, n, l);
      return l.delete(a), I;
    case c1:
      if (bd)
        return bd.call(a) == bd.call(t);
  }
  return !1;
}
var p1 = 1, u1 = Object.prototype, g1 = u1.hasOwnProperty;
function m1(a, t, e, i, o, n) {
  var l = e & p1, L = Xp(a), D = L.length, j = Xp(t), I = j.length;
  if (D != I && !l)
    return !1;
  for (var B = D; B--; ) {
    var R = L[B];
    if (!(l ? R in t : g1.call(t, R)))
      return !1;
  }
  var N = n.get(a), x = n.get(t);
  if (N && x)
    return N == t && x == a;
  var T = !0;
  n.set(a, t), n.set(t, a);
  for (var y = l; ++B < D; ) {
    R = L[B];
    var S = a[R], u = t[R];
    if (i)
      var A = l ? i(u, S, R, t, a, n) : i(S, u, R, a, t, n);
    if (!(A === void 0 ? S === u || o(S, u, e, i, n) : A)) {
      T = !1;
      break;
    }
    y || (y = R == "constructor");
  }
  if (T && !y) {
    var M = a.constructor, f = t.constructor;
    M != f && "constructor" in a && "constructor" in t && !(typeof M == "function" && M instanceof M && typeof f == "function" && f instanceof f) && (T = !1);
  }
  return n.delete(a), n.delete(t), T;
}
var f1 = 1, iu = "[object Arguments]", au = "[object Array]", hl = "[object Object]", v1 = Object.prototype, nu = v1.hasOwnProperty;
function A1(a, t, e, i, o, n) {
  var l = ko(a), L = ko(t), D = l ? au : Ji(a), j = L ? au : Ji(t);
  D = D == iu ? hl : D, j = j == iu ? hl : j;
  var I = D == hl, B = j == hl, R = D == j;
  if (R && Nl(a)) {
    if (!Nl(t))
      return !1;
    l = !0, I = !1;
  }
  if (R && !I)
    return n || (n = new Zo()), l || Qh(a) ? Zm(a, t, e, i, o, n) : b1(a, t, D, e, i, o, n);
  if (!(e & f1)) {
    var N = I && nu.call(a, "__wrapped__"), x = B && nu.call(t, "__wrapped__");
    if (N || x) {
      var T = N ? a.value() : a, y = x ? t.value() : t;
      return n || (n = new Zo()), o(T, y, e, i, n);
    }
  }
  return R ? (n || (n = new Zo()), m1(a, t, e, i, o, n)) : !1;
}
function ib(a, t, e, i, o) {
  return a === t ? !0 : a == null || t == null || !va(a) && !va(t) ? a !== a && t !== t : A1(a, t, e, i, ib, o);
}
var y1 = 1, x1 = 2;
function w1(a, t, e, i) {
  var o = e.length, n = o;
  if (a == null)
    return !n;
  for (a = Object(a); o--; ) {
    var l = e[o];
    if (l[2] ? l[1] !== a[l[0]] : !(l[0] in a))
      return !1;
  }
  for (; ++o < n; ) {
    l = e[o];
    var L = l[0], D = a[L], j = l[1];
    if (l[2]) {
      if (D === void 0 && !(L in a))
        return !1;
    } else {
      var I = new Zo(), B;
      if (!(B === void 0 ? ib(j, D, y1 | x1, i, I) : B))
        return !1;
    }
  }
  return !0;
}
function Jm(a) {
  return a === a && !ti(a);
}
function k1(a) {
  for (var t = Gm(a), e = t.length; e--; ) {
    var i = t[e], o = a[i];
    t[e] = [i, o, Jm(o)];
  }
  return t;
}
function ef(a, t) {
  return function(e) {
    return e == null ? !1 : e[a] === t && (t !== void 0 || a in Object(e));
  };
}
function C1(a) {
  var t = k1(a);
  return t.length == 1 && t[0][2] ? ef(t[0][0], t[0][1]) : function(e) {
    return e === a || w1(e, a, t);
  };
}
function S1(a, t) {
  return a != null && t in Object(a);
}
function E1(a, t, e) {
  t = Pc(t, a);
  for (var i = -1, o = t.length, n = !1; ++i < o; ) {
    var l = qs(t[i]);
    if (!(n = a != null && e(a, l)))
      break;
    a = a[l];
  }
  return n || ++i != o ? n : (o = a == null ? 0 : a.length, !!o && Yh(o) && Mc(l, o) && (ko(a) || Rl(a)));
}
function M1(a, t) {
  return a != null && E1(a, t, S1);
}
var T1 = 1, L1 = 2;
function O1(a, t) {
  return Jh(a) && Jm(t) ? ef(qs(a), t) : function(e) {
    var i = ux(e, a);
    return i === void 0 && i === t ? M1(e, a) : ib(t, i, T1 | L1);
  };
}
function P1(a) {
  return function(t) {
    return t == null ? void 0 : t[a];
  };
}
function D1(a) {
  return function(t) {
    return tb(t, a);
  };
}
function z1(a) {
  return Jh(a) ? P1(qs(a)) : D1(a);
}
function I1(a) {
  return typeof a == "function" ? a : a == null ? Wh : typeof a == "object" ? ko(a) ? O1(a[0], a[1]) : C1(a) : z1(a);
}
function B1(a) {
  return function(t, e, i) {
    for (var o = -1, n = Object(t), l = i(t), L = l.length; L--; ) {
      var D = l[++o];
      if (e(n[D], D, n) === !1)
        break;
    }
    return t;
  };
}
var R1 = B1();
function ah(a, t, e) {
  (e !== void 0 && !Vs(a[t], e) || e === void 0 && !(t in a)) && qh(a, t, e);
}
function N1(a) {
  return va(a) && Tc(a);
}
function nh(a, t) {
  if (!(t === "constructor" && typeof a[t] == "function") && t != "__proto__")
    return a[t];
}
function F1(a) {
  return Fy(a, Zh(a));
}
function j1(a, t, e, i, o, n, l) {
  var L = nh(a, e), D = nh(t, e), j = l.get(D);
  if (j) {
    ah(a, e, j);
    return;
  }
  var I = n ? n(L, D, e + "", a, t, l) : void 0, B = I === void 0;
  if (B) {
    var R = ko(D), N = !R && Nl(D), x = !R && !N && Qh(D);
    I = D, R || N || x ? ko(L) ? I = L : N1(L) ? I = Ey(L) : N ? (B = !1, I = Tx(D)) : x ? (B = !1, I = $x(D)) : I = [] : yx(D) || Rl(D) ? (I = L, Rl(L) ? I = F1(L) : (!ti(L) || Vh(L)) && (I = Hx(D))) : B = !1;
  }
  B && (l.set(D, I), o(I, D, i, n, l), l.delete(D)), ah(a, e, I);
}
function tf(a, t, e, i, o) {
  a !== t && R1(t, function(n, l) {
    if (o || (o = new Zo()), ti(n))
      j1(a, t, l, e, tf, i, o);
    else {
      var L = i ? i(nh(a, l), n, l + "", a, t, o) : void 0;
      L === void 0 && (L = n), ah(a, l, L);
    }
  }, Zh);
}
var _1 = Hy(function(a, t, e, i) {
  tf(a, t, e, i);
});
function U1(a, t, e, i) {
  if (!ti(a))
    return a;
  t = Pc(t, a);
  for (var o = -1, n = t.length, l = n - 1, L = a; L != null && ++o < n; ) {
    var D = qs(t[o]), j = e;
    if (D === "__proto__" || D === "constructor" || D === "prototype")
      return a;
    if (o != l) {
      var I = L[D];
      j = void 0, j === void 0 && (j = ti(I) ? I : Mc(t[o + 1]) ? [] : {});
    }
    jm(L, D, j), L = L[D];
  }
  return a;
}
function $1(a, t, e) {
  for (var i = -1, o = t.length, n = {}; ++i < o; ) {
    var l = t[i], L = tb(a, l);
    e(L, l) && U1(n, Pc(l, a), L);
  }
  return n;
}
function H1(a, t) {
  if (a == null)
    return {};
  var e = Nm(Ix(a), function(i) {
    return [i];
  });
  return t = I1(t), $1(a, e, function(i, o) {
    return t(i, o[0]);
  });
}
var na = /* @__PURE__ */ ((a) => (a.CIRCLE = "circle", a.TRIANGLE = "triangle", a.SQUARE = "square", a.DIAMOND = "diamond", a.TRIANGLE_DOWN = "triangle-down", a))(na || {}), Wr = /* @__PURE__ */ ((a) => (a.SINGLE_LINE = "single-line", a.MULTI_LINE = "multi-line", a.MULTI_LEVEL = "multi-level", a))(Wr || {}), $t = /* @__PURE__ */ ((a) => (a.LINE = "line", a.BAR = "bar", a.COLUMN = "column", a.SCATTER = "scatter", a.PIE = "pie", a.GAUGE = "gauge", a.AREA = "area", a.MAP = "map", a))($t || {}), as = /* @__PURE__ */ ((a) => (a.HORIZONTAL = "horizontal", a.VERTICAL = "vertical", a))(as || {}), _l = /* @__PURE__ */ ((a) => (a[a.HEIGHT = 480] = "HEIGHT", a))(_l || {}), mi = /* @__PURE__ */ ((a) => (a.STANDARD = "standard-set", a.EXTENDED = "extended-set", a))(mi || {});
function qe(a, t, e) {
  const i = a.prerender;
  a.prerender = function(...o) {
    e.value.apply(this, o), i.apply(this, o);
  };
}
function Re(a, t, e) {
  const i = a.postrender;
  a.postrender = function(...o) {
    e.value.apply(this, o), i.apply(this, o);
  };
}
function Pt(a, t, e) {
  const i = a.destroy;
  a.destroy = function(...o) {
    e.value.apply(this, o), i.apply(this, o);
  };
}
const $e = (a) => (t) => {
  t.mixins && Array.isArray(t.mixins) && (t.mixins = [...t.mixins, a]);
};
function Gt(a, t) {
  const e = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (i, o) => {
    const { update: n } = i, l = Array.isArray(a) ? a : [a];
    i.update = function(L) {
      l.forEach((D) => {
        const j = D;
        if (L.has(j)) {
          const I = L.get(j), B = this[j];
          I !== B && (!e.waitUntilFirstUpdate || this.hasUpdated) && this[o](
            I,
            B
          );
        }
      }), n.call(this, L);
    };
  };
}
const Dc = ({
  finisher: a,
  descriptor: t
}) => (e, i) => {
  var o;
  if (i !== void 0) {
    const n = e.constructor;
    t !== void 0 && Object.defineProperty(e, i, t(i)), a == null || a(n, i);
  } else {
    const n = (o = e.originalKey) != null ? o : e.key, l = t !== void 0 ? {
      kind: "method",
      placement: "prototype",
      key: n,
      descriptor: t(e.key)
    } : { ...e, key: n };
    return a && (l.finisher = function(L) {
      a(L, n);
    }), l;
  }
};
function ms(a, t, e = {}, i = !1) {
  var l;
  const o = `slot${t ? `[name=${t}]` : ":not([name])"}`, n = (l = a.renderRoot) == null ? void 0 : l.querySelector(o);
  return n ? i ? n.assignedNodes(e).filter((L) => L.nodeType !== Node.COMMENT_NODE) : n.assignedElements(e) : [];
}
function of(a) {
  return typeof a == "string" ? { version: a } : a.alternateSlot !== void 0 && a.alternateSlot !== null ? {
    alternateSlot: a.alternateSlot,
    version: a.version
  } : {
    alternateAttribute: a.alternateAttribute,
    version: a.version
  };
}
function De(a, t = !1) {
  const { slot: e, selector: i, deprecated: o, flatten: n } = a != null ? a : {};
  let l;
  return o && (l = of(o)), Dc({
    descriptor: (L) => ({
      get() {
        let D = ms(this, e, { flatten: n });
        return D.length === 0 && o && l && l.alternateSlot && (D = ms(this, l.alternateSlot, {
          flatten: n
        })), i ? D == null ? void 0 : D.filter((j) => {
          var I;
          return t ? ((I = j == null ? void 0 : j.nodeName) == null ? void 0 : I.toLowerCase()) === this.getScopedTagName(i) : j.matches(i);
        }) : D;
      },
      set() {
        if (o) {
          const D = e != null ? e : "";
          this.alternateSlots.set(D, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function ot(a) {
  return function(t, e) {
    return We(a)(t, e);
  };
}
function An(a, t) {
  return Dc({
    descriptor: (e) => ({
      get() {
        var o;
        return (o = this.querySelector(a)) != null ? o : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function K1({ slot: a, defaultValue: t }) {
  return Dc({
    descriptor: (e) => ({
      get() {
        var n, l, L;
        const o = ms(this, a)[0];
        return (L = (l = (n = o == null ? void 0 : o.textContent) == null ? void 0 : n.trim()) != null ? l : t) != null ? L : "";
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function G1(a) {
  return function(t, e) {
    return Cr(a)(t, e);
  };
}
function zc(a) {
  const { slot: t, deprecated: e, flatten: i } = a != null ? a : {};
  let o;
  return e && (o = of(e)), Dc({
    descriptor: (n) => ({
      get() {
        let l = ms(this, t, { flatten: i }, !0);
        return l.length === 0 && e && o && o.alternateSlot && (l = ms(
          this,
          o.alternateSlot,
          { flatten: i },
          !0
        )), l;
      },
      set() {
        if (e) {
          const l = t != null ? t : "";
          this.alternateSlots.set(l, o);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function _i() {
  return `${Math.floor(Math.random() * 1e10)}`.padStart(4, "0");
}
const zo = class zo extends Ni {
  constructor() {
    super(...arguments), this.uuid = _i(), this.slotHasEvent = !1, this.usingParentElement = !1, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (t) => {
      if (t.eventPhase !== 2)
        return;
      const e = t.target, i = e == null ? void 0 : e.assignedElements();
      let o;
      this.totalSlottedElements = i.length, this.containerSelector ? o = this.findContainerElement(e) : o = this.usingParentElement ? e.parentElement : e, this.totalSlottedElements < 1 ? (o == null || o.classList.add(zo.defaultClassName), o == null || o.classList.remove(this.hasSlottedClassName)) : (o == null || o.classList.remove(zo.defaultClassName), o == null || o.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(t) {
    if (this.containerSelector)
      return t.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(t) {
    const e = document.createElement("style");
    e.innerHTML = `.${zo.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, e.id = zo.stylesID, t.appendChild(e);
  }
  update(t, [e = { useParent: !1 }]) {
    const { useParent: i, container: o } = e, n = t.element, l = n.getRootNode(), { parentElement: L } = n;
    i && (this.usingParentElement = !0), o && (this.containerSelector = o);
    const D = {};
    return this.containerSelector ? D.element = this.findContainerElement(n) : i && L ? D.element = L : D.element = n, l.querySelector(`#${zo.stylesID}`) || zo.createStyleElement(l), this.slotHasEvent || (n.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(D);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ element: t } = { useParent: !1 }) {
    t && this.totalSlottedElements < 1 && (t.classList.add(zo.defaultClassName), t.classList.remove(this.hasSlottedClassName)), t && this.totalSlottedElements >= 1 && t.classList.add(this.hasSlottedClassName);
  }
};
zo.defaultClassName = "hide-slot-area", zo.stylesID = "show-if-used-directive-styles";
let rh = zo;
const _e = Ri(rh), ru = " ";
function af(a, t = ru) {
  return typeof t != "string" && (t = ru), a == null ? void 0 : a.split(t).map((e) => e.trim());
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* No(a, t) {
  if (a !== void 0) {
    let e = 0;
    for (const i of a) yield t(i, e++);
  }
}
(function() {
  (function(a) {
    const t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap(), y = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, S = (te, ae) => {
      for (let le in y) {
        ae[le] = null;
        let de = null;
        const be = y[le];
        Object.defineProperty(ae, le, {
          get() {
            return de;
          },
          set(ge) {
            de = ge, te.isConnected ? E(te, be, ge) : I.set(te, ae);
          }
        });
      }
    };
    function u(te) {
      const ae = o.get(te), { form: le } = ae;
      k(te, le, ae), s(te, ae.labels);
    }
    const A = (te, ae = !1) => {
      const le = document.createTreeWalker(te, NodeFilter.SHOW_ELEMENT, {
        acceptNode(ge) {
          return o.has(ge) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let de = le.nextNode();
      const be = !ae || te.disabled;
      for (; de; )
        de.formDisabledCallback && be && v(de, te.disabled), de = le.nextNode();
    }, M = { attributes: !0, attributeFilter: ["disabled", "name"] }, f = G() ? new MutationObserver((te) => {
      for (const ae of te) {
        const le = ae.target;
        if (ae.attributeName === "disabled" && (le.constructor.formAssociated ? v(le, le.hasAttribute("disabled")) : le.localName === "fieldset" && A(le)), ae.attributeName === "name" && le.constructor.formAssociated) {
          const de = o.get(le), be = j.get(le);
          de.setFormValue(be);
        }
      }
    }) : {};
    function m(te) {
      te.forEach((ae) => {
        const { addedNodes: le, removedNodes: de } = ae, be = Array.from(le), ge = Array.from(de);
        be.forEach((me) => {
          var fe;
          if (o.has(me) && me.constructor.formAssociated && u(me), I.has(me)) {
            const Ae = I.get(me);
            Object.keys(y).filter((xe) => Ae[xe] !== null).forEach((xe) => {
              E(me, y[xe], Ae[xe]);
            }), I.delete(me);
          }
          if (T.has(me)) {
            const Ae = T.get(me);
            E(me, "internals-valid", Ae.validity.valid.toString()), E(me, "internals-invalid", (!Ae.validity.valid).toString()), E(me, "aria-invalid", (!Ae.validity.valid).toString()), T.delete(me);
          }
          if (me.localName === "form") {
            const Ae = D.get(me), ye = document.createTreeWalker(me, NodeFilter.SHOW_ELEMENT, {
              acceptNode(we) {
                return o.has(we) && we.constructor.formAssociated && !(Ae && Ae.has(we)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let xe = ye.nextNode();
            for (; xe; )
              u(xe), xe = ye.nextNode();
          }
          me.localName === "fieldset" && ((fe = f.observe) === null || fe === void 0 || fe.call(f, me, M), A(me, !0));
        }), ge.forEach((me) => {
          const fe = o.get(me);
          fe && i.get(fe) && w(fe), L.has(me) && L.get(me).disconnect();
        });
      });
    }
    function C(te) {
      te.forEach((ae) => {
        const { removedNodes: le } = ae;
        le.forEach((de) => {
          const be = N.get(ae.target);
          o.has(de) && W(de), be.disconnect();
        });
      });
    }
    const F = (te) => {
      var ae, le;
      const de = new MutationObserver(C);
      !((ae = window == null ? void 0 : window.ShadyDOM) === null || ae === void 0) && ae.inUse && te.mode && te.host && (te = te.host), (le = de.observe) === null || le === void 0 || le.call(de, te, { childList: !0 }), N.set(te, de);
    };
    G() && new MutationObserver(m);
    const _ = {
      childList: !0,
      subtree: !0
    }, E = (te, ae, le) => {
      te.getAttribute(ae) !== le && te.setAttribute(ae, le);
    }, v = (te, ae) => {
      te.toggleAttribute("internals-disabled", ae), ae ? E(te, "aria-disabled", "true") : te.removeAttribute("aria-disabled"), te.formDisabledCallback && te.formDisabledCallback.apply(te, [ae]);
    }, w = (te) => {
      i.get(te).forEach((le) => {
        le.remove();
      }), i.set(te, []);
    }, d = (te, ae) => {
      const le = document.createElement("input");
      return le.type = "hidden", le.name = te.getAttribute("name"), te.after(le), i.get(ae).push(le), le;
    }, r = (te, ae) => {
      var le;
      i.set(ae, []), (le = f.observe) === null || le === void 0 || le.call(f, te, M);
    }, s = (te, ae) => {
      if (ae.length) {
        Array.from(ae).forEach((de) => de.addEventListener("click", te.click.bind(te)));
        let le = ae[0].id;
        ae[0].id || (le = `${ae[0].htmlFor}_Label`, ae[0].id = le), E(te, "aria-labelledby", le);
      }
    }, p = (te) => {
      const ae = Array.from(te.elements).filter((ge) => !ge.tagName.includes("-") && ge.validity).map((ge) => ge.validity.valid), le = D.get(te) || [], de = Array.from(le).filter((ge) => ge.isConnected).map((ge) => o.get(ge).validity.valid), be = [...ae, ...de].includes(!1);
      te.toggleAttribute("internals-invalid", be), te.toggleAttribute("internals-valid", !be);
    }, b = (te) => {
      p(P(te.target));
    }, c = (te) => {
      p(P(te.target));
    }, h = (te) => {
      const ae = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((le) => `${le}:not([disabled])`).map((le) => `${le}:not([form])${te.id ? `,${le}[form='${te.id}']` : ""}`).join(",");
      te.addEventListener("click", (le) => {
        if (le.target.closest(ae)) {
          const be = D.get(te);
          if (te.noValidate)
            return;
          be.size && Array.from(be).reverse().map((fe) => o.get(fe).reportValidity()).includes(!1) && le.preventDefault();
        }
      });
    }, g = (te) => {
      const ae = D.get(te.target);
      ae && ae.size && ae.forEach((le) => {
        le.constructor.formAssociated && le.formResetCallback && le.formResetCallback.apply(le);
      });
    }, k = (te, ae, le) => {
      if (ae) {
        const de = D.get(ae);
        if (de)
          de.add(te);
        else {
          const be = /* @__PURE__ */ new Set();
          be.add(te), D.set(ae, be), h(ae), ae.addEventListener("reset", g), ae.addEventListener("input", b), ae.addEventListener("change", c);
        }
        l.set(ae, { ref: te, internals: le }), te.constructor.formAssociated && te.formAssociatedCallback && setTimeout(() => {
          te.formAssociatedCallback.apply(te, [ae]);
        }, 0), p(ae);
      }
    }, P = (te) => {
      let ae = te.parentNode;
      return ae && ae.tagName !== "FORM" && (ae = P(ae)), ae;
    }, O = (te, ae, le = DOMException) => {
      if (!te.constructor.formAssociated)
        throw new le(ae);
    }, z = (te, ae, le) => {
      const de = D.get(te);
      return de && de.size && de.forEach((be) => {
        o.get(be)[le]() || (ae = !1);
      }), ae;
    }, W = (te) => {
      if (te.constructor.formAssociated) {
        const ae = o.get(te), { labels: le, form: de } = ae;
        s(te, le), k(te, de, ae);
      }
    };
    function G() {
      return typeof MutationObserver < "u";
    }
    class Y {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const U = (te) => (te.badInput = !1, te.customError = !1, te.patternMismatch = !1, te.rangeOverflow = !1, te.rangeUnderflow = !1, te.stepMismatch = !1, te.tooLong = !1, te.tooShort = !1, te.typeMismatch = !1, te.valid = !0, te.valueMissing = !1, te), H = (te, ae, le) => (te.valid = q(ae), Object.keys(ae).forEach((de) => te[de] = ae[de]), le && p(le), te), q = (te) => {
      let ae = !0;
      for (let le in te)
        le !== "valid" && te[le] !== !1 && (ae = !1);
      return ae;
    }, X = /* @__PURE__ */ new WeakMap();
    function $(te, ae) {
      te.toggleAttribute(ae, !0), te.part && te.part.add(ae);
    }
    class K extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(ae) {
        if (super(), !ae || !ae.tagName || ae.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        X.set(this, ae);
      }
      add(ae) {
        if (!/^--/.test(ae) || typeof ae != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${ae} must start with '--'.`);
        const le = super.add(ae), de = X.get(this), be = `state${ae}`;
        return de.isConnected ? $(de, be) : setTimeout(() => {
          $(de, be);
        }), le;
      }
      clear() {
        for (let [ae] of this.entries())
          this.delete(ae);
        super.clear();
      }
      delete(ae) {
        const le = super.delete(ae), de = X.get(this);
        return de.isConnected ? (de.toggleAttribute(`state${ae}`, !1), de.part && de.part.remove(`state${ae}`)) : setTimeout(() => {
          de.toggleAttribute(`state${ae}`, !1), de.part && de.part.remove(`state${ae}`);
        }), le;
      }
    }
    function V(te, ae, le, de) {
      if (typeof ae == "function" ? te !== ae || !0 : !ae.has(te)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return le === "m" ? de : le === "a" ? de.call(te) : de ? de.value : ae.get(te);
    }
    function Q(te, ae, le, de, be) {
      if (typeof ae == "function" ? te !== ae || !0 : !ae.has(te)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return ae.set(te, le), le;
    }
    var Z;
    class ee {
      constructor(ae) {
        Z.set(this, void 0), Q(this, Z, ae);
        for (let le = 0; le < ae.length; le++) {
          let de = ae[le];
          this[le] = de, de.hasAttribute("name") && (this[de.getAttribute("name")] = de);
        }
        Object.freeze(this);
      }
      get length() {
        return V(this, Z, "f").length;
      }
      [(Z = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return V(this, Z, "f")[Symbol.iterator]();
      }
      item(ae) {
        return this[ae] == null ? null : this[ae];
      }
      namedItem(ae) {
        return this[ae] == null ? null : this[ae];
      }
    }
    function J() {
      const te = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = le;
      const ae = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = de;
      function le(...ge) {
        let me = te.apply(this, ge);
        return z(this, me, "checkValidity");
      }
      function de(...ge) {
        let me = ae.apply(this, ge);
        return z(this, me, "reportValidity");
      }
      const { get: be } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...ge) {
          const me = be.call(this, ...ge), fe = Array.from(D.get(this) || []);
          if (fe.length === 0)
            return me;
          const Ae = Array.from(me).concat(fe).sort((ye, xe) => ye.compareDocumentPosition ? ye.compareDocumentPosition(xe) & 2 ? 1 : -1 : 0);
          return new ee(Ae);
        }
      });
    }
    class ie {
      static get isPolyfilled() {
        return !0;
      }
      constructor(ae) {
        if (!ae || !ae.tagName || ae.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const le = ae.getRootNode(), de = new Y();
        this.states = new K(ae), t.set(this, ae), e.set(this, de), o.set(ae, this), S(ae, this), r(ae, this), Object.seal(this), le instanceof DocumentFragment && F(le);
      }
      checkValidity() {
        const ae = t.get(this);
        if (O(ae, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const le = e.get(this);
        if (!le.valid) {
          const de = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          ae.dispatchEvent(de);
        }
        return le.valid;
      }
      get form() {
        const ae = t.get(this);
        O(ae, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let le;
        return ae.constructor.formAssociated === !0 && (le = P(ae)), le;
      }
      get labels() {
        const ae = t.get(this);
        O(ae, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const le = ae.getAttribute("id"), de = ae.getRootNode();
        return de && le ? de.querySelectorAll(`[for="${le}"]`) : [];
      }
      reportValidity() {
        const ae = t.get(this);
        if (O(ae, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const le = this.checkValidity(), de = R.get(this);
        if (de && !ae.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !le && de && (ae.focus(), de.focus()), le;
      }
      setFormValue(ae) {
        const le = t.get(this);
        if (O(le, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), w(this), ae != null && !(ae instanceof FormData)) {
          if (le.getAttribute("name")) {
            const de = d(le, this);
            de.value = ae;
          }
        } else ae != null && ae instanceof FormData && Array.from(ae).reverse().forEach(([de, be]) => {
          if (typeof be == "string") {
            const ge = d(le, this);
            ge.name = de, ge.value = be;
          }
        });
        j.set(le, ae);
      }
      setValidity(ae, le, de) {
        const be = t.get(this);
        if (O(be, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !ae)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        R.set(this, de);
        const ge = e.get(this), me = {};
        for (const ye in ae)
          me[ye] = ae[ye];
        Object.keys(me).length === 0 && U(ge);
        const fe = Object.assign(Object.assign({}, ge), me);
        delete fe.valid;
        const { valid: Ae } = H(ge, fe, this.form);
        if (!Ae && !le)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        n.set(this, Ae ? "" : le), be.isConnected ? (be.toggleAttribute("internals-invalid", !Ae), be.toggleAttribute("internals-valid", Ae), E(be, "aria-invalid", `${!Ae}`)) : T.set(be, this);
      }
      get shadowRoot() {
        const ae = t.get(this), le = B.get(ae);
        return le || null;
      }
      get validationMessage() {
        const ae = t.get(this);
        return O(ae, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), n.get(this);
      }
      get validity() {
        const ae = t.get(this);
        return O(ae, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), e.get(this);
      }
      get willValidate() {
        const ae = t.get(this);
        return O(ae, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(ae.disabled || ae.hasAttribute("disabled") || ae.hasAttribute("readonly"));
      }
    }
    function re() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class te extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const ae = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(ae, te);
      const le = new te();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((de) => de in le.internals);
    }
    let ce = !1, he = !1;
    function ne(te) {
      he || (he = !0, window.CustomStateSet = K, te && (HTMLElement.prototype.attachInternals = function(...ae) {
        const le = te.call(this, ae);
        return le.states = new K(this), le;
      }));
    }
    function oe(te = !0) {
      if (!ce) {
        if (ce = !0, typeof window < "u" && (window.ElementInternals = ie), typeof CustomElementRegistry < "u") {
          const ae = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(le, de, be) {
            if (de.formAssociated) {
              const ge = de.prototype.connectedCallback;
              de.prototype.connectedCallback = function() {
                x.has(this) || (x.set(this, !0), this.hasAttribute("disabled") && v(this, !0)), ge != null && ge.apply(this), W(this);
              };
            }
            ae.call(this, le, de, be);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (o.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new ie(this);
        }), typeof Element < "u") {
          let ae = function(...de) {
            const be = le.apply(this, de);
            if (B.set(this, be), G()) {
              const ge = new MutationObserver(m);
              window.ShadyDOM ? ge.observe(this, _) : ge.observe(be, _), L.set(this, ge);
            }
            return be;
          };
          const le = Element.prototype.attachShadow;
          Element.prototype.attachShadow = ae;
        }
        G() && typeof document < "u" && new MutationObserver(m).observe(document.documentElement, _), typeof HTMLFormElement < "u" && J(), (te || typeof window < "u" && !window.CustomStateSet) && ne();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (re() ? typeof window < "u" && !window.CustomStateSet && ne(HTMLElement.prototype.attachInternals) : oe(!1)), a.forceCustomStateSetPolyfill = ne, a.forceElementInternalsPolyfill = oe, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  })({});
})();
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const nf = Symbol.for(""), W1 = (a) => {
  if ((a == null ? void 0 : a.r) === nf) return a == null ? void 0 : a._$litStatic$;
}, sh = (a) => ({ _$litStatic$: a, r: nf }), su = /* @__PURE__ */ new Map(), V1 = (a) => (t, ...e) => {
  const i = e.length;
  let o, n;
  const l = [], L = [];
  let D, j = 0, I = !1;
  for (; j < i; ) {
    for (D = t[j]; j < i && (n = e[j], (o = W1(n)) !== void 0); ) D += o + t[++j], I = !0;
    j !== i && L.push(n), l.push(D), j++;
  }
  if (j === i && l.push(t[i]), I) {
    const B = l.join("$$lit$$");
    (t = su.get(B)) === void 0 && (l.raw = l, su.set(B, t = l)), e = L;
  }
  return a(t, ...e);
}, ze = V1(pe);
var Tl = /* @__PURE__ */ ((a) => (a.NO_SYNC = "no-sync", a))(Tl || {}), Wn = /* @__PURE__ */ ((a) => (a.VISIBLE = "visible", a.IDLE = "idle", a.INTERACTION = "interaction", a.MEDIA = "media", a.DEFINED = "defined", a))(Wn || {}), Ee = /* @__PURE__ */ ((a) => (a.BLUR = "beacon-event-blur", a.CHANGE = "beacon-event-change", a.CLICK = "beacon-event-click", a.FOCUS = "beacon-event-focus", a.HIDE = "beacon-event-hide", a.INPUT = "beacon-event-input", a.KEYDOWN = "beacon-event-keydown", a.MOUSEDOWN = "beacon-event-mousedown", a.MOUSEENTER = "beacon-event-mouseenter", a.MOUSELEAVE = "beacon-event-mouseleave", a.RENDER = "beacon-event-render", a.SORT = "beacon-event-sort", a.DEFERRED_CHILD = "beacon-event-deferred-child", a.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", a.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", a.LANGUAGE_SELECT = "beacon-event-language-select", a.CLOSE = "beacon-event-close", a.OPEN = "beacon-event-open", a.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", a.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", a.ELEMENT_READY = "beacon-event-element-ready", a.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", a.DRILLDOWN = "beacon-event-drilldown", a.DRILLUP = "beacon-event-drillup", a.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", a.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", a.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", a.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", a.HAS_CURRENT_LINK = "beacon-event-has-current-link", a.REGISTER = "beacon-event-register", a.SKIP_LINK_CLICK = "beacon-event-skip-link-click", a.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", a.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", a.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", a.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", a.DISMISS = "beacon-event-dismiss", a.TOGGLE = "beacon-event-toggle", a.CONTROL_SET = "beacon-event-control-set", a.PAGINATE = "beacon-event-paginate", a.VIDEO_BRIGHTCOVE_READY = "beacon-event-video-brightcove-ready", a.ADD_FOOTNOTE = "beacon-event-add-footnote", a.REMOVE_FOOTNOTE = "beacon-event-remove-footnote", a))(Ee || {}), et = /* @__PURE__ */ ((a) => (a.CLOSE = "close", a.KEYDOWN = "keydown", a.SCROLL = "scroll", a.CLICK = "click", a.FOCUSOUT = "focusout", a))(et || {});
const q1 = ve`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])):not(dialog){position:relative}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, rf = ve`:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible:not(dialog){position:relative}:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, Y1 = ve`:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-small);--motion-translate-intro-micro: 3rem}@media (width >= 640px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-medium);--motion-translate-intro-micro: 4rem}}@media (width >= 960px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-large);--motion-translate-intro-micro: 5rem}}@media (width >= 1280px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-x-large);--motion-translate-intro-micro: 6rem}}@media (width >= 1600px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xx-large);--motion-translate-intro-micro: 8rem}}@media (width >= 1920px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xxx-large);--motion-translate-intro-micro: 9rem}}`, X1 = ve`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, sf = ve`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}::slotted(:is(ul,ol)[role=list]){list-style:none;padding:0}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, lf = ve`.has-cell-padding,.has-component-padding{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-3)}:host{color:var(--beacon-system-color-text-standard);font-family:var(--beacon-system-font-family-body);-webkit-font-smoothing:antialiased;font-weight:var(--beacon-system-font-weight-light)}a,::slotted(a){color:var(--beacon-system-color-text-link)}a:not([class],:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var wo = /* @__PURE__ */ ((a) => (a.CLICKABLE = "data-metrics-clickable", a.TYPE = "data-metrics-type", a.TEXT = "data-metrics-link-text", a.LOCATION = "data-metrics-location", a))(wo || {});
const ia = class ia {
};
ia.setPropertyOnEvent = (t, e, i, o) => {
  try {
    Object.defineProperty(t, i, {
      value: o || e[`${i}`],
      writable: !1
    });
  } catch (n) {
    console.warn(n);
  }
}, ia.getAnalyticsEvents = () => {
  const t = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(t.join("|")).test(e) && e !== "onscrollsnapchange");
}, ia.setHostEventHandlerForAnalytics = (t, e) => {
  var n;
  const i = ia.getAnalyticsEvents(), o = "beaconVersion";
  for (const l of i) {
    const L = l.slice(2);
    (n = t.shadowRoot) == null || n.addEventListener(
      L,
      (D) => {
        var I;
        const j = new D.constructor(
          L,
          D
        );
        ia.setPropertyOnEvent(
          j,
          null,
          o,
          e
        );
        for (const B in D)
          B !== "isTrusted" && ia.setPropertyOnEvent(j, D, B);
        (I = t.shadowRoot) != null && I.contains(D.target) && t.dispatchEvent(j);
      },
      !0
    );
  }
};
let lh = ia;
function ns(a, t) {
  !a || !t || a instanceof SVGElement && (a.setAttribute(wo.CLICKABLE, "true"), a.setAttribute(wo.TYPE, "BTN"), a.getAttribute(wo.TEXT) || a.setAttribute(wo.TEXT, t));
}
function Q1(a) {
  return !!a.updateAnalytics;
}
function Fe(a, t, e, i) {
  const o = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return a.dispatchEvent(o), i && i(), o;
}
const lu = (a) => !!a.deferrable, Z1 = (a) => {
  var t, e;
  return (!!((t = a.deferList) != null && t.includes(Wn.VISIBLE)) || !!((e = a.getAttribute("defer-until")) != null && e.includes(Wn.VISIBLE))) && a.isDeferUntilParent;
}, cu = (a) => !!navigator.vendor && navigator.vendor.indexOf(a) > -1;
function J1(a) {
  return `${a}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (t, e, i) => `${e.toUpperCase() + i}`
  ).replace(new RegExp(/\w/), (t) => t.toUpperCase());
}
const ew = "4.4.0", tw = {
  rootMargin: "1500px",
  threshold: 0
}, ui = {
  version: ew,
  hidden: "hidden",
  safari: "Apple",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: tw
}, pd = (a) => {
  for (const t of a)
    if (t !== void 0) return t;
};
class ud extends CSSStyleSheet {
  constructor(t, e) {
    super(), this.name = t, this.replaceSync(e);
  }
}
var ow = Object.defineProperty, ka = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && ow(t, e, o), o;
};
const iw = [sf, lf, rf];
var Xn, _t;
const Ui = (_t = class extends Gn {
  constructor() {
    super();
    Ie(this, Xn);
    Be(this, Xn, !1), this.isDeferUntilParent = !1, this.deferrable = !1, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = ui.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      const { target: i } = e, o = i.name;
      this.slotDeprecationWarn(o);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: ui.defaultDeferOptions.rootMargin,
      threshold: ui.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const i = new IntersectionObserver((o) => {
          const [n] = o;
          n.isIntersecting && (i.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        i.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((i) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => i(), { once: !0 }) : i();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((i) => {
          requestIdleCallback(() => {
            i();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((i) => {
      var o;
      e instanceof CustomEvent && ((o = e.detail) != null && o.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => i())) : i();
    }), this.renderStyles = (e, i) => {
      const o = [], n = new Set(
        this.constructor[e].flat(1 / 0)
      );
      for (const l of n)
        o.push(l);
      Ua ? o.forEach((l, L) => {
        var B, R, N;
        const D = this.getClosestHost(), j = `${i}-${L}`, I = new ud(j, l.toString());
        if (D) {
          if (!((B = D.shadowRoot) == null ? void 0 : B.adoptedStyleSheets.find(
            (T) => T.name === j
          )))
            if (I.name.includes("global-light")) {
              const T = parseInt(I.name.slice(-1), 10);
              (R = D.shadowRoot) == null || R.adoptedStyleSheets.splice(
                iw.length + T,
                0,
                I
              );
            } else
              (N = D.shadowRoot) == null || N.adoptedStyleSheets.push(I);
        } else if (!document.adoptedStyleSheets.find(
          (x) => x.name === j
        ))
          if (I.name.includes("global-light")) {
            const x = parseInt(I.name.slice(-1), 10) + 1, T = document.adoptedStyleSheets.findLastIndex(
              (y) => y.name.includes("global-root")
            );
            document.adoptedStyleSheets.splice(T + x, 0, I);
          } else
            document.adoptedStyleSheets.push(I);
      }) : o.toReversed().forEach((l, L) => {
        var I;
        const D = document.createElement("style");
        D.setAttribute("slot", "lightDOM");
        let j = !1;
        if (D.textContent = l.toString(), i) {
          const B = Math.abs(L - o.length), R = `${i}-${B}`, N = this.getClosestHost();
          D.id = R, (N && ((I = N == null ? void 0 : N.shadowRoot) != null && I.querySelector(`#${R}`)) || !N && document.querySelector(`#${R}`)) && (j = !0);
        }
        j || this.prepend(D);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var i, o;
      Ua ? (i = this.componentModeStyles) == null || i.forEach(
        (n, l) => {
          if (!document.adoptedStyleSheets.find(
            (L) => L.name === `${e}-${l}`
          )) {
            const L = new ud(
              `${e}-${l}`,
              n.toString()
            );
            document.adoptedStyleSheets.push(L);
          }
        }
      ) : (o = this.componentModeStyles) == null || o.forEach((n, l) => {
        const L = document.createElement("style");
        L.textContent = n.toString();
        const D = `${e}-${l}`;
        L.id = D, !document.querySelector(`#${D}`) && document.head.append(L);
      });
    }, this.getScopedTag = (e) => {
      if (!e) return null;
      const i = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return sh(i);
    }, this._internals = this.attachInternals ? this.attachInternals() : void 0;
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((i, o) => {
      this.elementProperties.has(i) && e.push(o);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, i, o) {
    const {
      alternateAttributesMap: n,
      hasDeprecatedProperties: l,
      elementProperties: L
    } = this.constructor;
    if (l && n.size > 0) {
      const D = n.get(e), j = this.getPropertyOptions(e).alternateSlot;
      if (D) {
        const I = L.get(D);
        if (D !== Tl.NO_SYNC && (o === null ? this.removeAttribute(
          (I == null ? void 0 : I.attribute) || D
        ) : this.setAttribute(
          (I == null ? void 0 : I.attribute) || D,
          o || ""
        )), j) {
          const B = this.createPropertyDeprecationForSlotMessage(e, j);
          console.warn(B);
        } else
          console.warn(
            this.createPropertyDeprecationMessage(
              e,
              D,
              I == null ? void 0 : I.attribute
            )
          );
      }
    }
    super.attributeChangedCallback(e, i, o);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param prop property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, i, o) {
    let n = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return i !== Tl.NO_SYNC && (n += ` Start using [${o || i}] instead to avoid future disruptions.`), n;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, i) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${i}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, i) {
    if (i) {
      const { alternateAttributes: o, attribute: n } = i, l = Object.prototype.hasOwnProperty.call(
        i,
        "sync"
      );
      if (ui.deprecatedPropertyKeys.forEach((L) => {
        Object.prototype.hasOwnProperty.call(i, L) && (this.hasDeprecatedProperties = !0);
      }), o && o.forEach((L) => {
        this.alternateAttributesMap.set(L, e);
      }), l && !i.sync) {
        const L = n != null ? n : e;
        this.alternateAttributesMap.set(
          L,
          Tl.NO_SYNC
        );
      }
    }
    super.createProperty(e, i);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var o;
    const { elementProperties: i } = this.constructor;
    return (o = i.get(e)) != null ? o : [...i.values()].find(
      (n) => n.attribute === e
    );
  }
  /**
   * @deprecated, to be removed in v5
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /** callback method for the beacon-on-click event*/
  onBeaconClick() {
  }
  /** callback method for the beacon-on-keydown event*/
  onBeaconKeydown() {
  }
  /** callback method for the beacon-on-toggle event*/
  onBeaconToggle() {
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, i;
    return (i = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((o) => o).filter((o) => !!o)) != null ? i : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const i = this.alternateSlots.get(e);
    if (i !== void 0) {
      let o;
      const n = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(i).some((l) => l.match("alternate")) ? i.alternateAttribute ? o = `will be replaced by the element property '${i.alternateAttribute}'` : o = `will be replaced by the '${i.alternateSlots}' slot` : o = "will be removed", console.warn(
        `Beacon Deprecation Warning: ${n} ${o} in foundation@${i.version}`
      );
    }
  }
  /**
   * @deprecated, to be removed in v5
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e) return;
    const i = { ...this.resolvedDeferOptions }, o = pd([
      e == null ? void 0 : e.root,
      i == null ? void 0 : i.root
    ]), n = pd([
      e == null ? void 0 : e.rootMargin,
      i == null ? void 0 : i.rootMargin
    ]), l = pd([
      e == null ? void 0 : e.threshold,
      i == null ? void 0 : i.threshold
    ]);
    this.resolvedDeferOptions = {
      root: o instanceof Document || o instanceof Element ? o : document,
      rootMargin: typeof n == "string" ? n : ui.defaultDeferOptions.rootMargin,
      threshold: Array.isArray(l) || typeof l == "number" ? l : ui.defaultDeferOptions.threshold
    };
  }
  /**
   * @deprecated, to be removed in v5
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    cu(ui.safari) || (this.style.visibility = ui.hidden);
  }
  /**
   * @deprecated, to be removed in v5
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    cu(ui.safari) || this.style.removeProperty("visibility");
  }
  /**
   * @deprecated, to be removed in v5
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', i = this.closest(
      e
    );
    if (i && lu(i))
      return i;
    const o = this.getClosestHost();
    if (o) {
      const n = o.closest(
        e
      );
      if (n && lu(n))
        return n;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * @deprecated, to be removed in v5
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((i) => {
      e.includes(Wn.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), i();
      })) : e.includes(Wn.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), i();
      })) : i();
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((i) => {
      if (e === null)
        i();
      else if (Z1(e))
        this.selectDeferUntilHandler(e.deferList).then(
          () => i()
        );
      else {
        const o = (n) => {
          this.deferredChildEventHandler(n).then(() => {
            e.removeEventListener(
              Ee.DEFERRED_CHILD,
              o
            ), i();
          });
        };
        e.addEventListener(
          Ee.DEFERRED_CHILD,
          o
        );
      }
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Now that it is deprecated the only components that will respond to deferUntil="visible"
   * are the beacon-table and its subcomponents
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const i = this.getClosestDeferredParent();
        i ? this.handleParentalDeferUntil(i).then(
          () => e()
        ) : e();
      }
    });
  }
  /**
   * @deprecated, to be removed in v5
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(Wn.VISIBLE)) {
      const e = new IntersectionObserver((i) => {
        for (const o of i)
          o.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const i = `${e ? `${e}-` : ""}${this.tagName}`;
      if (this.nestedComponents.forEach(
        (o) => o.registerComponent(e)
      ), !customElements.get(i)) {
        const o = class extends this {
        };
        Object.defineProperty(o, "name", {
          value: J1(i)
        }), customElements.define(i, o), customElements.whenDefined(i).then(() => {
          const n = new CustomEvent(Ee.REGISTER, {
            detail: i
          });
          document.dispatchEvent(n);
        }).catch((n) => {
          console.error(
            `Error defining Beacon Component ${i} in CustomElementsRegistry: `,
            n
          );
        });
      }
    }
  }
  static renderGlobalRootStyles() {
    Ua ? this.globalRootStyles.forEach(
      (e, i) => {
        if (!document.adoptedStyleSheets.find(
          (o) => o.name === `beacon-global-root-styles-${i}`
        )) {
          const o = new ud(
            `beacon-global-root-styles-${i}`,
            e.toString()
          );
          document.adoptedStyleSheets.push(o);
        }
      }
    ) : this.globalRootStyles.forEach((e, i) => {
      if (document.getElementById(`beacon-global-root-styles-${i}`))
        return;
      const o = document.createElement("template");
      o.innerHTML = `
        <style id="beacon-global-root-styles-${i}">
          ${e.toString()}
        </style>
      `;
      const n = o.content.cloneNode(!0);
      document.head.append(n);
    });
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick() {
    Fe(this, Ee.CLICK, void 0, this.onBeaconClick);
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown() {
    Fe(this, Ee.KEYDOWN, void 0, this.onBeaconKeydown);
  }
  emitToggle() {
    Fe(this, Ee.TOGGLE, void 0, this.onBeaconToggle);
  }
  /**
   * @deprecated, to be removed in v5
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild() {
    Fe(this, Ee.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown();
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var i;
    try {
      if (!((i = this.constructor().mixins) == null ? void 0 : i.includes(e))) throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, i) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === i;
    } catch (o) {
      return console.error(o), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender(...e) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy(...e) {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), i = e == null ? void 0 : e.getAttribute("motion-state");
    i && (i === "enabled" || i === "disabled") && (this.motionState = i);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const e = this.getAttribute("defer-until");
    if (e) {
      const o = e.split(" ").filter((L) => L), n = o.length;
      if (n === 1 && o.includes("defined") || n === 0)
        this.removeAttribute("defer-until");
      else {
        const L = o.filter((D) => D !== "defined").join(" ");
        this.setAttribute("defer-until", L);
      }
    } else this.hasAttribute("defer-until") && !e && this.removeAttribute("defer-until");
  }
  renderLightDOMStyles() {
    Ua ? (this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    )) : (this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ));
  }
  /**
   * Set custom state (using ElementInternals) on a component.
   *
   * A fallback when custom state isn't supported toggles a custom attribute that matches the state.
   *
   * States can be styled in CSS without the need to reflect a property.
   *
   * element-internals-polyfill will do the work of setting fallback attributes.
   *
   * @example
   * ```css
   * :host(:state(--custom-state)),
   * :host([state--custom-state]) {
   *  rule: value;
   * }
   * ```
   */
  setState(e, i = !0) {
    this._internals ? i ? this._internals.states.add(e) : this._internals.states.delete(e) : console.error(
      `Attempted to set state ${Ce} on ${this.tagName} but internals are not available.`
    );
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), Te(this, Xn) || (lh.setHostEventHandlerForAnalytics(this, this.version), Be(this, Xn, !0)), _t.renderGlobalRootStyles(), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), Fe(this, Ee.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
}, Xn = new WeakMap(), _t.styles = [sf, lf, rf], _t.tagName = "", _t.nestedComponents = [], _t.shadowRootOptions = {
  ...Gn.shadowRootOptions,
  delegatesFocus: !0
}, _t.alternateAttributesMap = /* @__PURE__ */ new Map(), _t.hasDeprecatedProperties = !1, _t.mixins = [], _t.lightDOMStyles = [], _t.globalLightDOMStyles = [
  X1,
  q1
], _t.globalRootStyles = [Y1], _t);
ka([
  ue({ attribute: "focus-override", type: Boolean, reflect: !0 })
], Ui.prototype, "focusOverride");
ka([
  ue({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], Ui.prototype, "resetSpacing");
ka([
  ue({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], Ui.prototype, "beaconTagName");
ka([
  ue({ attribute: "beacon-version", reflect: !0 })
], Ui.prototype, "version");
ka([
  ue({ attribute: "defer-until" })
], Ui.prototype, "deferUntil");
ka([
  ue({ attribute: "defer-options" })
], Ui.prototype, "deferOptions");
ka([
  ue({ attribute: "motion-state", reflect: !0 })
], Ui.prototype, "motionState");
ka([
  Ce()
], Ui.prototype, "prefersReducedMotion");
let Le = Ui;
var Mt = /* @__PURE__ */ ((a) => (a.ONE = "1", a.TWO = "2", a.THREE = "3", a))(Mt || {}), Xt = /* @__PURE__ */ ((a) => (a.ASCENDING = "ascending", a.DESCENDING = "descending", a))(Xt || {}), cf = /* @__PURE__ */ ((a) => (a.NORMAL = "normal", a.GROUP = "group", a.JUMBO = "jumbo", a))(cf || {}), xi = /* @__PURE__ */ ((a) => (a.TEXT = "text", a.NUMERAL = "numeral", a.DATE = "date", a.ICONS = "icons", a))(xi || {}), Ll = /* @__PURE__ */ ((a) => (a.MOVABLE = "movable", a.FIXED = "fixed", a.FLOATING = "floating", a))(Ll || {});
const ch = "__mixwith_appliedMixin", dh = "__mixwith_wrappedMixin", du = "__mixwith_cachedApplications", hu = "__mixwith_instanceOf", aw = (a, t) => {
  const e = t(a);
  return e.prototype[ch] = hf(t), e;
}, nw = (a, t) => Object.hasOwn(a, ch) && a[ch] === hf(t), df = (a, t) => {
  for (; a != null; ) {
    if (nw(a, t)) return !0;
    a = Object.getPrototypeOf(a);
  }
  return !1;
}, ab = (a, t) => (Object.setPrototypeOf(t, a), a[dh] || (a[dh] = a), t), hf = (a) => a[dh] || a, rw = (a) => ab(a, (t) => {
  let e = t[du];
  e || (e = t[du] = /* @__PURE__ */ new Map());
  let i = e.get(a);
  return i || (i = a(t), e.set(a, i)), i;
}), sw = (a) => ab(a, (e) => df(e.prototype, a) ? e : a(e)), lw = (a) => (a[hu] || (a[hu] = !0, Object.defineProperty(a, Symbol.hasInstance, {
  value(t) {
    return df(t, a);
  }
})), a), cw = (a) => ab(a, (t) => aw(t, a)), On = (a) => sw(rw(cw(lw(a)))), Ge = (a) => new dw(a);
class dw {
  constructor(t) {
    this.superclass = t;
  }
  /**
   * Applies a chain of mixins to a base class. The method supports up to six mixins.
   * The mixins are applied in reverse sequence (e.g. the right most mixin is applied first, etc.)
   *
   * @param {mixin<Base, A>} a - A mixin to apply.
   * @param {mixin<A, B>} [b] - A mixin to apply (optional).
   * @param {mixin<B, C>} [c] - A mixin to apply (optional).
   * @param {mixin<C, D>} [d] - A mixin to apply (optional).
   * @param {mixin<D, E>} [e] - A mixin to apply (optional).
   * @param {mixin<E, F>} [f] - A mixin to apply (optional).
   *
   * @returns {Base & A & B & C & D & E & F} - A new class constructor that includes the functionalities
   *                                           of all mixins and the base class.
   */
  with(t, e, i, o, n, l) {
    var N;
    this.superclass = (N = this.superclass) != null ? N : class {
    };
    const L = On(t), D = e ? On(e) : void 0, j = i ? On(i) : void 0, I = o ? On(o) : void 0, B = n ? On(n) : void 0, R = l ? On(l) : void 0;
    return R && B && I && j && D && L ? R(B(I(j(D(L(this.superclass)))))) : B && I && j && D && L ? B(I(j(D(L(this.superclass))))) : I && j && D && L ? I(j(D(L(this.superclass)))) : j && D && L ? j(D(L(this.superclass))) : D && L ? D(L(this.superclass)) : L(this.superclass);
  }
}
var no = ((a) => (a[a.DEFAULT = parseInt(SA, 10)] = "DEFAULT", a[a.MEDIUM = parseInt($h, 10)] = "MEDIUM", a[a.LARGE = parseInt(Em, 10)] = "LARGE", a[a.XLARGE = parseInt(Mm, 10)] = "XLARGE", a))(no || {}), hw = Object.defineProperty, bw = Object.getOwnPropertyDescriptor, bf = (a) => {
  throw TypeError(a);
}, Pn = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? bw(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && hw(t, e, o), o;
}, pw = (a, t, e) => t.has(a) || bf("Cannot " + e), bl = (a, t, e) => (pw(a, t, "read from private field"), e ? e.call(a) : t.get(a)), pl = (a, t, e) => t.has(a) ? bf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e);
function $i(a) {
  var t, e, i, o;
  let n = class extends a {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(no.DEFAULT)
      ), this.mediumBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(no.MEDIUM)
      ), this.largeBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(no.LARGE)
      ), this.xLargeBreakpointWatcher = window.matchMedia(
        n.createMediaQueryString(no.XLARGE)
      ), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, pl(this, t, ({ matches: l }) => {
        this.isSmallBreakpoint = l;
      }), pl(this, e, ({ matches: l }) => {
        this.isMediumBreakpoint = l;
      }), pl(this, i, ({ matches: l }) => {
        this.isLargeBreakpoint = l;
      }), pl(this, o, ({ matches: l }) => {
        this.isXLargeBreakpoint = l;
      });
    }
    static createMediaQueryString(l) {
      return `(min-width: ${l}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener(
        "change",
        bl(this, t)
      ), this.mediumBreakpointWatcher.addEventListener(
        "change",
        bl(this, e)
      ), this.largeBreakpointWatcher.addEventListener(
        "change",
        bl(this, i)
      ), this.xLargeBreakpointWatcher.addEventListener(
        "change",
        bl(this, o)
      );
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), Pn([
    Ce()
  ], n.prototype, "isSmallBreakpoint", 2), Pn([
    Ce()
  ], n.prototype, "isMediumBreakpoint", 2), Pn([
    Ce()
  ], n.prototype, "isLargeBreakpoint", 2), Pn([
    Ce()
  ], n.prototype, "isXLargeBreakpoint", 2), Pn([
    qe
  ], n.prototype, "prerenderWatchMediaSetup", 1), n = Pn([
    $e("WatchMedia")
  ], n), n;
}
function Za(a, t, e) {
  const i = a[t];
  if (i !== void 0) return i;
  const o = e();
  return a[t] = o, o;
}
function bu(a, t, e) {
  a != 0 ? t == null || t.classList.add(e) : t == null || t.classList.remove(e);
}
function uw(a, t) {
  if (a) {
    if (t && t.includes(a.localName))
      return a.id;
    if (a.parentElement)
      return a.parentElement.id;
  }
  return "";
}
const gw = "headers";
function hh(a, t, e, i, o, n, l) {
  var I, B, R, N, x;
  const L = t ? (x = (N = (R = a == null ? void 0 : a.parentElement) == null ? void 0 : R.parentElement) == null ? void 0 : N.nextElementSibling) == null ? void 0 : x.children : (B = (I = a == null ? void 0 : a.parentElement) == null ? void 0 : I.nextElementSibling) == null ? void 0 : B.children, D = uw(a, i);
  let j;
  if (L && D) {
    const T = Array.from(L);
    if (T && T.length && (j = T.filter((y) => {
      const S = y.getAttribute(gw);
      let u;
      return y && S && S === D && (e && o && o(y), u = y), u;
    })), j)
      return l && l(j, a), n && n(j, a), j;
  }
}
class mw extends Ni {
  constructor(t) {
    if (super(t), this.observing = !1, this.tabindex = -1, t.type !== gn.ATTRIBUTE || t.name !== "tabindex")
      throw new Error(
        "The `scrollableRegion` directive must be used in the `tabindex` attribute"
      );
    this.part = t, this.resizeObserver = this.setupResizeObserver();
  }
  setupResizeObserver() {
    if (!this.resizeObserver)
      return new ResizeObserver((e) => {
        for (const i of e) {
          const {
            target: { scrollHeight: o, clientHeight: n }
          } = i;
          this.tabindex = Number(o) > Number(n) ? 0 : -1, this.render();
        }
      });
  }
  render() {
    this.part && this.part.name === "tabindex" && (this.part.element.tabIndex = this.tabindex);
  }
  update(t) {
    this.resizeObserver && !this.observing && this.resizeObserver.observe(t.element);
  }
}
const Ja = Ri(mw), fw = "td", vw = "table";
function Aw(a) {
  var l;
  if (!a) return;
  const t = a.closest(fw);
  if (!t) return;
  const e = Array.prototype.indexOf.call(
    (l = t == null ? void 0 : t.parentNode) == null ? void 0 : l.children,
    t
  );
  if (!e) return;
  const i = t.closest(vw);
  if (!i || !i.rows) return;
  let o = 0, n;
  for (n = 0; o <= e; n += 1) {
    const L = i.rows[0].cells[n];
    if (!L) break;
    L.dataset.colSpan ? o += parseInt(L.dataset.colSpan, 10) : o += L.colSpan;
  }
  return i.rows[0].cells[n - 1];
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const mt = (a) => a != null ? a : je;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function pf(a, t, e) {
  return a ? t(a) : e == null ? void 0 : e(a);
}
const yw = ["id"], pu = [...yw];
var Es, Ar, uf, gf;
class Ic {
  constructor(t, e) {
    Ie(this, Ar);
    Ie(this, Es);
    this.attributes = /* @__PURE__ */ new Map(), (this.host = t).addController(this), Be(this, Es, e);
  }
  hostConnected() {
    Ue(this, Ar, uf).call(this), Ue(this, Ar, gf).call(this);
  }
}
Es = new WeakMap(), Ar = new WeakSet(), uf = function() {
  var t, e;
  if (this.host instanceof HTMLElement) {
    for (const i of pu)
      this.attributes.set(
        i,
        (e = this.host.getAttribute(i)) != null ? e : (t = Te(this, Es)) == null ? void 0 : t[i]
      );
    this.host.requestUpdate();
  }
}, gf = function() {
  const t = new MutationObserver(
    (e, i) => {
      for (const { attributeName: o, target: n } of e)
        o === "id" && this.attributes.set("id", n.id);
      this.host.requestUpdate();
    }
  );
  this.host instanceof HTMLElement && t.observe(this.host, {
    attributes: !0,
    attributeFilter: pu
  });
};
var nb = /* @__PURE__ */ ((a) => (a.LOADING = "loading", a.PROGRESS = "progress", a.SUCCESS = "success", a.RESULT = "result", a.NONE = "", a))(nb || {}), rs = /* @__PURE__ */ ((a) => (a.SUBMIT = "submit", a.BUTTON = "button", a.RESET = "reset", a.MENU = "menu", a))(rs || {}), rb = /* @__PURE__ */ ((a) => (a.PRIMARY = "primary", a.SECONDARY = "secondary", a.TERTIARY = "tertiary", a.POSITIVE = "positive", a.NEGATIVE = "negative", a))(rb || {}), xw = Object.defineProperty, ww = Object.getOwnPropertyDescriptor, ul = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? ww(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && xw(t, e, o), o;
};
function mf(a = { clean: !1 }) {
  return function(e) {
    let i = class extends e {
      /**
       * Removes any whitespace from the default slot.
       *
       * Default slots can see whitespace or new line characters as node slotted in, which can cause presentational issues when there's fallback content in the slot's position.
       *
       * This issue is commonly seen in AEM applications but can be a result of any templating syntax that doesn't trim whitespace from HTML nodes the whole way.
       */
      cleanDefaultSlot() {
        this.defaultSlotNodes.forEach((o) => {
          var n;
          !o.slot && !((n = o.textContent) != null && n.trim()) && o.remove();
        });
      }
      /** Sets internal state for slot text and existance of slot content */
      setDefaultSlotText() {
        this.defaultSlotText = this.getDefaultSlotText(), a.clean && this.cleanDefaultSlot();
      }
      /** Grabs slotted text and sets the state defaultSlotText property. */
      getDefaultSlotText() {
        if (this.defaultSlotNodes.length > 0)
          return this.defaultSlotNodes.map((o) => {
            var n, l;
            return (l = (n = o.textContent) == null ? void 0 : n.trim()) != null ? l : "";
          }).join("");
      }
      postrenderSetDefaultSlotText() {
        this.setDefaultSlotText();
      }
    };
    return ul([
      Ce()
    ], i.prototype, "defaultSlotText", 2), ul([
      zc({ flatten: !0 })
    ], i.prototype, "defaultSlotNodes", 2), ul([
      Re
    ], i.prototype, "postrenderSetDefaultSlotText", 1), i = ul([
      $e("TracksDefaultSlot")
    ], i), i;
  };
}
const kw = ve`.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7))}`, Cw = ve`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var Sw = Object.getOwnPropertyDescriptor, Ew = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Sw(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function Mw(a) {
  let t = class extends a {
    static get ButtonBaseMotionStyles() {
      return [Cw];
    }
  };
  return t = Ew([
    $e("ButtonBaseMotion")
  ], t), t;
}
const Tw = ve`:host(:not(.skip-focus-override)) :is(button,a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not(.skip-focus-override)) :is(button,a):focus-visible:not(dialog){position:relative}:host(:not(.skip-focus-override)) :is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo) + var(--beacon-system-width-border-normal));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:0;position:relative;z-index:1}`;
var Lw = Object.defineProperty, Eo = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && Lw(t, e, o), o;
};
const Ur = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, Ow = "stroke";
var Si;
const go = (Si = class extends Ge(Le).with(
  Mw,
  mf({ clean: !0 })
) {
  constructor() {
    super(...arguments), this._passthroughs = new Ic(this), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = rs.BUTTON, this.variant = rb.PRIMARY, this.state = nb.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, Tw, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, kw];
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(t, e, i = this.formAnchor) {
    this._internals && this._internals.setValidity(t, e, i);
  }
  get prefixIcon() {
    return this.prefixIconElements[this.SLOTTED_ICON_INDEX];
  }
  get suffixIcon() {
    return this.suffixIconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(t) {
    var e, i;
    if (this.disabled)
      t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation();
    else if (this.emitClick(), this._internals)
      switch (this.type) {
        case rs.SUBMIT:
          (e = this._internals.form) == null || e.requestSubmit();
          break;
        case rs.RESET:
          (i = this._internals.form) == null || i.reset();
          break;
      }
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  static applySVGClass(t) {
    t && Array.from(t.children).forEach((e) => {
      if (e) {
        const i = e.getAttribute(Ow) ? Ur.strokeFill : Ur.iconFill;
        e.classList.add(i);
      }
    });
  }
  handleIconSlotchange() {
    if (this.iconElements.length > 0)
      for (const t of this.iconElements) {
        t.classList.add(Ur.icon);
        const e = this.defaultSlotText;
        ns(t, e), Si.applySVGClass(t);
      }
  }
  handleAffixSlotChanges({ target: t }) {
    if (t instanceof HTMLSlotElement) {
      const e = t.name;
      if (e === "suffix" && this.suffixIcon) {
        this.suffixIcon.classList.add(Ur.icon);
        const i = this.defaultSlotText;
        ns(this.suffixIcon, i), Si.applySVGClass(this.suffixIcon);
      } else if (e === "prefix" && this.prefixIcon) {
        this.prefixIcon.classList.add(Ur.icon);
        const i = this.defaultSlotText;
        ns(this.prefixIcon, i), Si.applySVGClass(this.prefixIcon);
      }
    }
  }
}, Si.formAssociated = !0, Si);
Eo([
  ot(".form-anchor")
], go.prototype, "formAnchor");
Eo([
  ue({ reflect: !0 })
], go.prototype, "type");
Eo([
  ue()
], go.prototype, "variant");
Eo([
  ue()
], go.prototype, "state");
Eo([
  ue({ type: Boolean })
], go.prototype, "disabled");
Eo([
  ue({ attribute: "link-href" })
], go.prototype, "linkHref");
Eo([
  ue({ attribute: "link-download" })
], go.prototype, "linkDownload");
Eo([
  ue({ attribute: "link-target" })
], go.prototype, "linkTarget");
Eo([
  De({ flatten: !0, slot: "icon", selector: "svg" })
], go.prototype, "iconElements");
Eo([
  De({
    flatten: !0,
    slot: "prefix",
    selector: "svg"
  })
], go.prototype, "prefixIconElements");
Eo([
  De({
    flatten: !0,
    slot: "suffix",
    selector: "svg"
  })
], go.prototype, "suffixIconElements");
Eo([
  ot("button, a")
], go.prototype, "button");
let Ha = go;
const Ol = {
  beaconTagName: "beacon-popover",
  DATA_METRICS_LOCATION_POPOVER: "PU",
  DATA_METRICS_LOCATION_BODY: "BDY"
}, Pw = ve`:host([motion-state=enabled]) .icon-button{--button-base-transition-duration: var(--beacon-reference-motion-duration-5);--scale-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) .icon-button:is(:hover,:active){transform:scale(var(--scale-value))}:host([motion-state=enabled]) .icon-button:is(:hover,:active) .contents{transform:scale(calc(1 / var(--scale-value)))}`;
var Dw = Object.getOwnPropertyDescriptor, zw = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Dw(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function Iw(a) {
  let t = class extends a {
    static get IconButtonMotionStyles() {
      return [Pw];
    }
  };
  return t = zw([
    $e("IconButtonMotion")
  ], t), t;
}
const Bw = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{display:var(--override-icon-button-display, inline-block)}.icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;padding:var(--override-icon-button-padding, 0)}.icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.icon-button svg,.icon-button [beacon-tag-name=beacon-icon]{position:absolute}.icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.icon-button.primary{--active-bg: var(--override-icon-button-bg-color-pressed, var(--default-active-bg));--active-icon: var(--beacon-system-color-icon-primary);--bg-color: var(--override-icon-button-bg-color, var(--default-bg));--default-active-bg: var(--beacon-system-color-background-primary-pressed);--default-bg: var(--beacon-system-color-background-primary);--default-hover-bg: var(--beacon-system-color-background-primary-hover);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--override-icon-button-bg-color-hover, var(--default-hover-bg));--hover-icon: var(--beacon-system-color-icon-primary);--icon-color: var(--beacon-system-color-icon-primary);border:0}.icon-button.secondary{--active-bg: var(--beacon-system-color-background-secondary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--disabled-bg: transparent;--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-secondary-inactive);--hover-bg: var(--beacon-system-color-background-secondary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-secondary)}.icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}`;
var Rw = Object.defineProperty, Nw = Object.getOwnPropertyDescriptor, Fw = (a, t, e, i) => {
  for (var o = Nw(t, e), n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && Rw(t, e, o), o;
};
const uu = "beacon-icon-button", zb = class zb extends Ge(Ha).with(
  Iw
) {
  constructor() {
    super(...arguments), this.beaconTagName = uu;
  }
  static get styles() {
    return [super.styles, Bw, this.IconButtonMotionStyles];
  }
  /**
   * Returns the closest beacon-popover parent to determine if the related data-metrics-location attribute should apply
   */
  get isPopoverChild() {
    return !!this.closest('[beacon-tag-name="beacon-popover"]');
  }
  applyDataMetricsLocation() {
    this.isPopoverChild && this.setAttribute(
      "data-metrics-location",
      Ol.DATA_METRICS_LOCATION_BODY
    );
  }
  /**
   * Render function for the default slot that is reused between link and button variants
   *
   * @returns {TemplateResult} slot wrapped in a visually-hidden span
   */
  renderDefaultSlot() {
    return pe`<span class="visually-hidden"><slot></slot></span>`;
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    return pe` <a
      part="icon-link"
      id="${mt(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${mt(this.linkDownload)}"
      target="${mt(this.linkTarget)}"
      class="icon-button ${this.variant}"
      aria-disabled="${this.disabled}">
      ${this.renderDefaultSlot()}
      <span class="contents">
        <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    return pe`
      <button
        part="icon-button"
        id="${mt(this._passthroughs.attributes.get("id"))}"
        @click=${this.handleClick}
        class="icon-button ${this.variant}"
        aria-disabled="${this.disabled}">
        ${this.renderDefaultSlot()}
        <span class="contents">
          <slot name="icon" @slotchange=${this.handleIconSlotchange}></slot>
        </span>
      </button>
    `;
  }
  render() {
    return pe` ${pf(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
};
zb.tagName = uu;
let Qt = zb;
Fw([
  Re
], Qt.prototype, "applyDataMetricsLocation");
var jw = Object.defineProperty, ff = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && jw(t, e, o), o;
};
const _w = "beacon-table";
class Ys extends Le {
  constructor() {
    super(...arguments), this.deferrable = !0, this.isOriginal = !0, this.uuid = _i();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: t, uuid: e } = this, i = `[uuid="${e}"]`, o = `${this.getScopedTagName(t)}${i}`;
    if (this.isOriginal) {
      const n = this.closest(
        this.getScopedTagName(_w)
      );
      if (!n) return;
      const l = n._transformedCardsContainer;
      return l ? Array.from(l.querySelectorAll(o)) : void 0;
    }
    return Array.from(document.querySelectorAll(o));
  }
  willUpdate(t) {
    t.forEach((e, i) => {
      this.pairedNodes && i !== "isOriginal" && (!this.isOriginal && i === "bold" || this.pairedNodes.forEach((o) => {
        i && (o[i] = e);
      }));
    });
  }
}
ff([
  Ce()
], Ys.prototype, "isOriginal");
ff([
  ue({ reflect: !0 })
], Ys.prototype, "uuid");
const Uw = ve`:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-space-zero-value: 0;--table-header-sort-icon-size: var(--beacon-reference-space-5);--table-header-dropdown-space-padding-block-start-jumbo: 0;--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-nth-cell-space-padding-block-start-jumbo: 5px;--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-1);--table-header-sort-wrapper-space-padding-block-start-jumbo: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-0);--beacon-table-header-action-zone-space-padding-block-start-jumbo: 0;--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-0)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-dropdown-space-padding-block-start-normal: var(--beacon-reference-space-0);--table-header-nth-cell-space-padding-block-start-jumbo: var(--beacon-reference-space-2);--table-header-nth-cell-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-sort-wrapper-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-1);--beacon-table-header-action-zone-space-padding-block-start-jumbo: var(--beacon-reference-space-0);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-1)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-header],:root [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-header],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-header]{--table-header-dropdown-space-padding-block-start-jumbo: var(--beacon-reference-space-1);--table-header-dropdown-space-padding-block-start-normal: 0;--table-header-sort-wrapper-space-padding-block-start-normal: var(--beacon-reference-space-2);--table-header-action-zone-space-padding-block-start-normal: var(--beacon-reference-space-2)}}`, $w = ve`:host{--cell-wrapper-padding-inline-end: 0;--override-icon-button-wrapper-inline-size: var(--table-header-sort-icon-size);--override-icon-button-wrapper-block-size: var(--table-header-sort-icon-size);font:inherit;inline-size:inherit;overflow:inherit;text-align:inherit;text-transform:inherit;word-break:initial}.hide{display:none}.has-cell-padding{padding-block:var(--table-header-space-zero-value);padding-inline:var(--table-header-space-zero-value)}.table-header-wrapper{display:flex;gap:var(--beacon-reference-space-5);inline-size:var(--table-override-header-wrapper-inline-size, inherit);padding-inline-end:var(--cell-wrapper-padding-inline-end)}.table-header-wrapper .text-cell{display:flex;gap:var(--beacon-reference-space-3);inline-size:100%}.table-header-wrapper .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-normal);color:var(--beacon-system-color-text-standard);display:grid;gap:var(--beacon-reference-space-1);inline-size:inherit;padding-block-start:var(--table-header-space-zero-value);padding-inline-start:var(--table-header-space-zero-value)}.table-header-wrapper .text-cell__text .title{margin:0;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.table-header-wrapper .text-cell__text .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0}.table-header-wrapper .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-normal);display:var(--table-override-header-sort-icon-display, initial);padding-block-start:var(--table-header-space-zero-value)}.table-header-wrapper ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-normal);padding-block-start:0}.table-header-wrapper select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-origin:content-box;background-position:right center;background-repeat:no-repeat;border:0;cursor:inherit;inline-size:100%;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:break-spaces;word-break:break-word}.table-header-wrapper select:hover{text-decoration:underline}.table-header-wrapper .selected-value{position:absolute;visibility:hidden;white-space:nowrap}.table-header-wrapper.jumbo select,.table-header-wrapper.jumbo .selected-value,.table-header-wrapper.jumbo .title,.table-header-wrapper.jumbo .table-dropdown{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .subtitle{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.table-header-wrapper.jumbo .text-cell__text{--text-cell-padding-block-start: var(--table-header-nth-cell-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo .sort-icon{--sort-icon-padding-block-start: var(--table-header-sort-wrapper-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo ::slotted([slot=action-zone]){--action-zone-padding-block-start: var(--table-header-action-zone-space-padding-block-start-jumbo)}.table-header-wrapper .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-normal);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);background-color:transparent;background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 6L8 10L4 6" stroke="%230063AD" stroke-linecap="round" stroke-linejoin="round"/></svg>');color:var(--beacon-system-color-text-link);cursor:pointer;display:var(--table-override-header-dropdown-display, flex);padding-block-start:0}.table-header-wrapper.jumbo .table-dropdown{--dropdown-padding-block-start: var(--table-header-dropdown-space-padding-block-start-jumbo)}`;
var Hw = Object.defineProperty, Kw = Object.getOwnPropertyDescriptor, Wt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Kw(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && Hw(t, e, o), o;
};
const gd = "beacon-table-header", gu = "aria-sort", Gw = ".beacon-table", Ww = ".cell", Vw = "has-dropdown", qw = "headers", mu = "display: none", Dn = "beacon-icon-button", $r = "number-of-headers", md = "selected", Yw = ".selected-value", fu = "sorted", Xw = "sort-direction", Qw = "sort-inactive", fd = "style";
var dt;
const Rt = (dt = class extends Ys {
  constructor() {
    super(...arguments), this.subtitle = "", this.variant = cf.NORMAL, this.dropdown = !1, this.sortable = !1, this.hasActionZone = !1, this.hasSubtitle = !1, this.sortInactive = !1, this.selectedValue = "select", this.selectedWidth = 0, this.nestedHeaders = [], this.beaconTagName = gd, this.compare = (t, e) => this.sortDirection === Xt.ASCENDING ? t.value === e.value ? 0 : typeof t.value == "number" && typeof e.value == "number" ? t.value - e.value : t.value < e.value ? -1 : 1 : this.sortDirection === Xt.DESCENDING ? t.value === e.value ? 0 : typeof t.value == "number" && typeof e.value == "number" ? e.value - t.value : t.value > e.value ? -1 : 1 : 0, this.processNestedHeaders = (t) => {
      var e, i;
      if (t) {
        const o = (i = (e = this.parentElement) == null ? void 0 : e.parentElement) == null ? void 0 : i.children, n = o && Array.from(o);
        let l = 0;
        n && (l = this.findStartingIndex(n, t));
        for (const [L, D] of t.entries())
          D.id && this.nestedHeaders.push({
            value: D.id,
            selected: D.hasAttribute(md),
            colId: L + l
          });
        l && this.prepStyleObj(this.nestedHeaders);
      }
    }, this.prepStyleObj = (t) => {
      const e = document.querySelector(Gw), i = e == null ? void 0 : e.querySelector(
        `${fd}[${$r}='${this.currentIndex}']`
      );
      i && (e == null || e.removeChild(i));
      const o = `{${mu}}`;
      let n = "";
      for (const L of t)
        L.selected || (n = `${n + dt.prepareStyleString(L.colId)},`);
      n = dt.removeLastCharacter(n);
      const l = n + o;
      e && (e.classList.contains("beacon-table--has-selected-columns") || e.classList.add("beacon-table--has-selected-columns"), dt.createStyleTag(e, l, this.currentIndex));
    };
  }
  static get styles() {
    return [super.styles, $w];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Uw];
  }
  postrenderTableHeaderSetup() {
    var t;
    if (this.dropdown) {
      hh(
        this,
        !0,
        !0,
        void 0,
        dt.setDropdownAttributes,
        dt.setSelectedAttributes,
        dt.siblingCollectionCallback
      );
      const e = (t = this.nestedHeaders.find(
        (i) => i.selected
      )) == null ? void 0 : t.value;
      this.selectedValue = e || this.selectedValue, this.adjustSelectWidth(), this.setColSpanForDropdowns();
      return;
    }
    hh(
      this,
      !0,
      !1,
      void 0,
      void 0,
      void 0,
      dt.siblingCollectionCallback
    );
  }
  /** Sets a data attribute on the parent element equal to the columns it would span if it wasn't using the dropdown feature. */
  setColSpanForDropdowns() {
    var t;
    this.parentElement && ((t = this.subHeaderNodes) == null ? void 0 : t.length) > 0 && (this.parentElement.dataset.colSpan = this.subHeaderNodes.length.toString());
  }
  /**
   * Process while on column sort happens.
   */
  onSort() {
    var t;
    if (this.sortable) {
      const e = ((t = this.parentElement) == null ? void 0 : t.id) || "", i = dt.getParentElementHeaders(this);
      this.sortDirection === Xt.ASCENDING ? this.sortDirection = Xt.DESCENDING : this.sortDirection = Xt.ASCENDING, Fe(this, Ee.SORT, { detail: { id: e, headers: i } }), this.setSortedAttr();
    }
  }
  /**
   * Sets related ARIA_SORT attribute to the parentElement th. This being used when sort happens.
   */
  setSortedAttr() {
    var t, e;
    (t = this.parentElement) == null || t.setAttribute(
      gu,
      this.sortDirection
    ), (e = this.parentElement) == null || e.classList.add(fu), this.sortInactive = !1;
  }
  /**
   * When Sorting happens on another columns this removes any sort attributes applied to parentElement th.
   * @param ele HTMLElement| Element
   */
  resetSortedAttr() {
    var t, e;
    this && (this.setAttribute(Qw, "true"), this.removeAttribute(Xw), (t = this.parentElement) == null || t.removeAttribute(gu), (e = this.parentElement) == null || e.classList.remove(fu));
  }
  /**
   * Based on sortInactive returns token value.
   * @returns token value.
   */
  applySvgToken() {
    return this.sortInactive ? "var(--beacon-reference-palette-grayscale-medium-gray-2)" : "var(--beacon-system-color-icon-link)";
  }
  /**
   *
   * @returns TemplateResult
   */
  handleSortIcon() {
    let t;
    return this.sortable && (this.sortDirection === Xt.ASCENDING ? t = ze`<${this.getScopedTag(Dn)}
          @beacon-event-click="${this.onSort}"
          id="${Xt.ASCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Ascending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(Dn)}>` : this.sortDirection === Xt.DESCENDING ? t = ze`<${this.getScopedTag(Dn)}
          @beacon-event-click="${this.onSort}"
          id="${Xt.DESCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          Sorted Descending
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
              style="fill: ${this.applySvgToken()}"
            />
          </svg>
        </${this.getScopedTag(Dn)}> ` : t = ze`<${this.getScopedTag(Dn)}
          @beacon-event-click="${this.onSort}"
          id="sort"
          variant="tertiary"
          class="sort-icon"
        >
          Sort
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(Dn)}>`), t || pe``;
  }
  /**
   * Triggers when selection change happens to dropdown.
   * @param event
   */
  async handleSelectChange(t) {
    const { target: e } = t;
    e && (this.selectedValue = e.value), this.resetSortedAttr(), await this.updateComplete.then(() => (this.updateNestedHeaders(), this.prepStyleObj(this.nestedHeaders), this.adjustSelectWidth()));
  }
  /**
   * It processes nestedHeaders based on provided array.
   */
  updateNestedHeaders() {
    this.nestedHeaders && this.nestedHeaders.forEach((t) => {
      t.selected ? t.selected = !1 : t.value === this.selectedValue && (t.selected = !0);
    });
  }
  /**
   * While Dropdown is true, this will update correct spacing for the arrow icon and text.
   */
  async adjustSelectWidth() {
    var i, o, n;
    await this.updateComplete;
    const t = this.shadowRoot && ((i = this.shadowRoot) == null ? void 0 : i.querySelector(Yw)), e = this.shadowRoot && ((o = this.shadowRoot) == null ? void 0 : o.querySelector(Ww));
    if (t && e) {
      const l = (n = window.getComputedStyle(e)) == null ? void 0 : n.paddingLeft, L = l && parseInt(l, 10) || 0, D = t.offsetWidth;
      D < e.offsetWidth - L ? this.selectedWidth = D + 4 : this.selectedWidth = 0;
    }
  }
  /**
   * Pass collection of below elements to return from what could be the starting index for particular table-header.
   * @param parentElsArr Element[] - Collection of parentElement[]
   * @param currentEl Element[] - Collection of currentElement[]
   * @returns number
   */
  findStartingIndex(t, e) {
    this.setAttribute($r, e.length.toString()), this.currentIndex = t == null ? void 0 : t.findIndex(
      (o) => o === this.parentElement
    );
    let i = 0;
    for (let o = 0; o < this.currentIndex; o += 1) {
      const n = t[o];
      if (n) {
        const l = n.firstElementChild;
        if (l && l.hasAttribute($r)) {
          const L = l.getAttribute($r);
          L && (i = parseInt(L, 10) + i);
        } else
          i = i + 1;
      }
    }
    return i;
  }
  /**
   * Provided string to be checked if it has any extra comma available at the end and it will remove it.
   * @param str string
   * @returns string
   */
  static removeLastCharacter(t) {
    let e = "";
    return t && t.lastIndexOf(",") === t.length - 1 && (e = t.substring(0, t.length - 1)), e;
  }
  /**
   * Based on index will prepare string to hide column.
   * @param index number
   * @returns string
   */
  static prepareStyleString(t) {
    return `.beacon-table--has-selected-columns td:nth-of-type(${t})`;
  }
  /**
   * Sets state variable dependent on slotted action-zone elements
   */
  actionZoneSlotChange() {
    var t;
    this.hasActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  /**
   * Action zone render method that conditionally hides padding based on `hasActionZone` state variable
   */
  renderActionZone() {
    const t = {
      "has-cell-padding": !0,
      "action-cell": !0,
      hide: !this.hasActionZone
    };
    return pe`
      <div class=${Pe(t)}>
        <slot
          name="action-zone"
          @slotchange=${this.actionZoneSlotChange}></slot>
      </div>
    `;
  }
  /**
   * Sets state variable dependent on slotted subtitle element or property content
   *
   */
  subtitleSlotChange() {
    var t;
    this.hasSubtitle = !!((t = this.slottedSubtitle) != null && t.length) || !!this.subtitle;
  }
  /**
   * Renders subtitle html with conditional rendering of `.hide` class
   * Need to hide subtitle to prevent css from adding `gap` space within elements of `text-cell__text`
   */
  renderSubtitle() {
    const t = {
      subtitle: !0,
      hide: !this.hasSubtitle
    };
    return pe`
      <p class=${Pe(t)}>
        <slot @slotchange=${this.subtitleSlotChange} name="subtitle"
          >${this.subtitle}</slot
        >
      </p>
    `;
  }
  render() {
    return pe`<div class="table-header-wrapper ${this.variant}">
      <div class="has-cell-padding text-cell" part="text-cell">
        <div class="text-cell__text">
          <p class="title" id="header-title">
            <slot></slot>
          </p>
          ${this.renderSubtitle()}
          ${this.dropdown ? pe`<select
                  id="select"
                  @change="${this.handleSelectChange}"
                  style="background-position: ${this.selectedWidth ? `${this.selectedWidth}px` : "left 100% top 50%"};
                width: ${this.selectedWidth ? "100%" : "calc(100% + 4px)"}"
                  name="dropdown"
                  class="table-dropdown"
                  value=${this.selectedValue}
                  aria-label="${this.selectedValue}">
                  ${this.nestedHeaders ? this.nestedHeaders.map(
      (t) => pe`<option ?selected=${t.selected}>
                            ${t.value}
                          </option>`
    ) : je}
                </select>
                <span class="selected-value" aria-hidden="true"
                  >${this.selectedValue}</span
                >` : je}
        </div>
        ${this.sortable ? this.handleSortIcon() : je}
      </div>
      ${this.renderActionZone()}
    </div> `;
  }
}, dt.tagName = gd, dt.nestedComponents = [Qt], dt.getParentElementHeaders = (t) => {
  let e = "";
  return t && t.parentElement && (e = t.parentElement.getAttribute(qw) || ""), e;
}, dt.getSelectedFromElements = (t) => {
  let e;
  return t && t.length && (e = (t == null ? void 0 : t.find((i) => i.hasAttribute(md))) || t[0]), e;
}, dt.createStyleTag = (t, e, i) => {
  if (t) {
    const o = document.createElement(fd);
    o.innerText = `${e}`, o.setAttribute($r, i.toString()), t == null || t.appendChild(o);
  }
}, dt.setDropdownAttributes = (t) => {
  var e;
  t.setAttribute(fd, mu), (e = t.parentElement) == null || e.setAttribute(Vw, "");
}, dt.siblingCollectionCallback = (t, e) => {
  const i = [];
  t.map(
    (n) => n.querySelector(e.getScopedTagName(gd))
  ).forEach((n) => {
    n && n instanceof dt && i.push(n);
  }), e.subHeaderNodes = i;
}, dt.setSelectedAttributes = (t, e) => {
  const i = dt.getSelectedFromElements(t);
  i == null || i.setAttribute(md, ""), e.processNestedHeaders(t);
}, dt);
Wt([
  ue({
    reflect: !0,
    alternateSlot: "subtitle",
    sync: !1
  })
], Rt.prototype, "subtitle", 2);
Wt([
  ue({ reflect: !0 })
], Rt.prototype, "variant", 2);
Wt([
  ue({ attribute: "dropdown", type: Boolean, reflect: !0 })
], Rt.prototype, "dropdown", 2);
Wt([
  ue({ attribute: "sortable", type: Boolean, reflect: !0 })
], Rt.prototype, "sortable", 2);
Wt([
  Ce()
], Rt.prototype, "hasActionZone", 2);
Wt([
  Ce()
], Rt.prototype, "hasSubtitle", 2);
Wt([
  ue({ attribute: "sort-direction", reflect: !0 })
], Rt.prototype, "sortDirection", 2);
Wt([
  ue({ attribute: "sort-inactive", type: Boolean, reflect: !0 })
], Rt.prototype, "sortInactive", 2);
Wt([
  De({ flatten: !0, slot: "action-zone" })
], Rt.prototype, "slottedActionZone", 2);
Wt([
  De({ flatten: !0, slot: "subtitle" })
], Rt.prototype, "slottedSubtitle", 2);
Wt([
  Ce()
], Rt.prototype, "selectedValue", 2);
Wt([
  Ce()
], Rt.prototype, "selectedWidth", 2);
Wt([
  Ce()
], Rt.prototype, "subHeaderNodes", 2);
Wt([
  Ce()
], Rt.prototype, "nestedHeaders", 2);
Wt([
  Ce()
], Rt.prototype, "currentIndex", 2);
Wt([
  Re
], Rt.prototype, "postrenderTableHeaderSetup", 1);
let vd = Rt;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let bh = class extends Ni {
  constructor(t) {
    if (super(t), this.it = je, t.type !== gn.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === je || t == null) return this._t = void 0, this.it = t;
    if (t === ei) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const e = [t];
    return e.raw = e, this._t = { _$litType$: this.constructor.resultType, strings: e, values: [] };
  }
};
bh.directiveName = "unsafeHTML", bh.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let ph = class extends bh {
};
ph.directiveName = "unsafeSVG", ph.resultType = 2;
const gt = Ri(ph), Zw = `<svg role="img" aria-label="down" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11.5L3 4L13 4L8 11.5Z" fill="var(--beacon-system-color-icon-error, #DD3636)"/>
</svg>`, Jw = `<svg role="img" aria-label="up" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4L13 11.5H3L8 4Z" fill="var(--beacon-system-color-icon-positive, #248647)"/>
</svg>`, ek = ve`:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-zero-value: 0;--table-record-inline-size-content: fit-content;--table-record-unset: unset;--table-record-numeral-gap: 0 var(--beacon-reference-space-4);--table-record-space-margin-inline-end-default: var(--beacon-reference-space-2);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-start-default: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-end-default: var(--beacon-reference-space-4);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-4)}}`, tk = ve`[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-reference-space-5))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table-record] p{margin:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]{padding:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]:not(:last-child){margin-inline-end:var(--beacon-reference-space-2)}`, ok = ve`:host{color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}.has-cell-padding{padding-block:0;padding-inline:0}.record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default);display:flex;gap:var(--beacon-reference-space-5);margin-inline:0}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-reference-space-7)}.record-numeral{align-items:flex-end;display:flex;flex-wrap:wrap;gap:var(--table-record-numeral-gap);justify-content:end;margin-block-end:0}.no-content{color:var(--beacon-system-color-text-inactive)}.record-na{color:var(--beacon-system-color-text-standard)}.record-cell{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);flex-grow:1;margin-block-start:0}.record-cell:is(.numeral,.date){display:grid;gap:var(--beacon-reference-space-1);text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold .record-na,.record-cell.sorted .record-na{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.record-delta{align-items:center;display:flex;gap:var(--beacon-reference-space-1)}.record-delta-value{color:var(--beacon-system-color-text-standard)}.record-delta-icon{block-size:var(--beacon-reference-space-5);display:inline-block;inline-size:var(--beacon-reference-space-5)}.record-footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);color:var(--beacon-system-color-text-standard);margin:0}.empty{display:none}.action-zone:not(.empty){display:var(--table-record-zero-value, grid);grid-template-rows:0;inline-size:var(--table-record-inline-size-content);margin-block-start:0;place-items:center}.hide{display:none}`;
var ik = Object.defineProperty, ak = Object.getOwnPropertyDescriptor, Ko = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? ak(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && ik(t, e, o), o;
};
const vu = "beacon-table-record", nk = pe`&#8212`;
var ha;
const Mo = (ha = class extends Ys {
  constructor() {
    super(...arguments), this.beaconTagName = vu, this.variant = xi.TEXT, this.sorted = !1, this.hasActionZoneContent = !1;
  }
  static get styles() {
    return [super.styles, ok];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, tk, ek];
  }
  /**
   * Returns sign of delta to determine delta icon styles
   *
   * @returns true/false for positive/negative respectively
   */
  get deltaPositive() {
    return this.slottedDelta > 0;
  }
  setActionZoneStatus() {
    this.hasActionZoneContent = this.actionZone.length > 0;
  }
  deltaSlotChange() {
    let t;
    this.slottedDeltaNodes.length > 0 && (t = this.slottedDeltaNodes.map((e) => {
      var i, o;
      return (o = (i = e.textContent) == null ? void 0 : i.trim()) != null ? o : "";
    }).join("")), t && (this.slottedDelta = parseFloat(t));
  }
  /**
   * Renders slot element with default styles
   * @returns default empty slot styles
   */
  static renderSlot() {
    return pe`<span class="record-na"
      ><slot><span class="no-content">${nk}</span></slot></span
    >`;
  }
  /**
   * Renders numeral and delta with proper spacing
   * @returns HTML template for numeral element in numeral record
   */
  renderNumeral() {
    const t = this.slottedDelta && !this.hideDeltaIcon ? pe`<span class="record-delta-icon">
            ${this.deltaPositive ? gt(Jw) : gt(Zw)}
          </span>` : pe``, e = {
      "record-delta-value": !0,
      hide: !this.slottedDelta || this.hideDeltaValue
    };
    return pe` <span class="record-delta"> ${t}<span class=${Pe(e)}><slot name="delta" @slotchange=${this.deltaSlotChange}></span></slot></span>${ha.renderSlot()}`;
  }
  /**
   * Conditionally renders cell contents
   * @returns HTML template according to variant type
   */
  renderCell() {
    switch (this.variant) {
      case xi.NUMERAL:
        return pe`<div class="record-numeral">${this.renderNumeral()}</div>
          <p class="record-footnote"><slot name="footnote"></slot></p>`;
      case xi.DATE:
      case xi.TEXT:
      case xi.ICONS:
      default:
        return ha.renderSlot();
    }
  }
  /**
   * Default render function
   * @returns HTML template for table record component
   */
  render() {
    return pe`<div class="record-cell-wrapper" part="cell-wrapper">
      <div
        class="has-cell-padding record-cell ${this.bold ? "bold" : ""} ${this.sorted ? "sorted" : ""} ${this.variant}"
        part="cell">
        ${this.renderCell()}
      </div>
      ${this.variant === xi.NUMERAL ? pe`<div
            class="action-zone ${Pe({
      empty: !this.hasActionZoneContent
    })}"
            part="action-zone">
            <slot name="action-zone"></slot>
          </div>` : pe``}
    </div>`;
  }
}, ha.tagName = vu, ha);
Ko([
  ue({ reflect: !0 })
], Mo.prototype, "variant", 2);
Ko([
  Ce()
], Mo.prototype, "slottedDelta", 2);
Ko([
  zc({ flatten: !0, slot: "delta" })
], Mo.prototype, "slottedDeltaNodes", 2);
Ko([
  ue({ attribute: "sort-value", reflect: !0 })
], Mo.prototype, "sortValue", 2);
Ko([
  ue({ type: Boolean, reflect: !0 })
], Mo.prototype, "bold", 2);
Ko([
  ue({ type: Boolean, reflect: !0 })
], Mo.prototype, "sorted", 2);
Ko([
  ue({ type: Boolean, reflect: !0, attribute: "hide-delta-icon" })
], Mo.prototype, "hideDeltaIcon", 2);
Ko([
  ue({
    type: Boolean,
    reflect: !0,
    attribute: "hide-delta-value"
  })
], Mo.prototype, "hideDeltaValue", 2);
Ko([
  Ce()
], Mo.prototype, "hasActionZoneContent", 2);
Ko([
  De({ slot: "action-zone" })
], Mo.prototype, "actionZone", 2);
Ko([
  Re
], Mo.prototype, "setActionZoneStatus", 1);
let Ad = Mo;
var Fo = /* @__PURE__ */ ((a) => (a.NORMAL = "normal", a.MINI = "mini", a.JUMBO = "jumbo", a.MAXI = "maxi", a))(Fo || {}), ln = /* @__PURE__ */ ((a) => (a.NORMAL = "normal", a.MINI = "mini", a.JUMBO = "jumbo", a))(ln || {});
const vf = `<svg slot="suffix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M12 6L8 10L4 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, rk = `<svg slot="suffix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M4 10L8 6L12 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, sk = (a, t, e) => {
  const i = a[t];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((o, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== e ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const lk = Symbol();
let ck = class {
  get taskComplete() {
    return this.t || (this.i === 1 ? this.t = new Promise((t, e) => {
      this.o = t, this.h = e;
    }) : this.i === 3 ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(t, e, i) {
    var n, l, L;
    this.p = 0, this.i = 0, (this._ = t).addController(this);
    const o = typeof e == "object" ? e : { task: e, args: i };
    this.v = o.task, this.j = o.args, this.m = (n = o.argsEqual) != null ? n : dk, this.k = o.onComplete, this.A = o.onError, this.autoRun = (l = o.autoRun) != null ? l : !0, "initialValue" in o && (this.u = o.initialValue, this.i = 2, this.O = (L = this.T) == null ? void 0 : L.call(this));
  }
  hostUpdate() {
    this.autoRun === !0 && this.S();
  }
  hostUpdated() {
    this.autoRun === "afterUpdate" && this.S();
  }
  T() {
    if (this.j === void 0) return;
    const t = this.j();
    if (!Array.isArray(t)) throw Error("The args function must return an array");
    return t;
  }
  async S() {
    const t = this.T(), e = this.O;
    this.O = t, t === e || t === void 0 || e !== void 0 && this.m(e, t) || await this.run(t);
  }
  async run(t) {
    var l, L, D, j, I;
    let e, i;
    t != null || (t = this.T()), this.O = t, this.i === 1 ? (l = this.q) == null || l.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, this.autoRun === "afterUpdate" ? queueMicrotask(() => this._.requestUpdate()) : this._.requestUpdate();
    const o = ++this.p;
    this.q = new AbortController();
    let n = !1;
    try {
      e = await this.v(t, { signal: this.q.signal });
    } catch (B) {
      n = !0, i = B;
    }
    if (this.p === o) {
      if (e === lk) this.i = 0;
      else {
        if (n === !1) {
          try {
            (L = this.k) == null || L.call(this, e);
          } catch {
          }
          this.i = 2, (D = this.o) == null || D.call(this, e);
        } else {
          try {
            (j = this.A) == null || j.call(this, i);
          } catch {
          }
          this.i = 3, (I = this.h) == null || I.call(this, i);
        }
        this.u = e, this.l = i;
      }
      this._.requestUpdate();
    }
  }
  abort(t) {
    var e;
    this.i === 1 && ((e = this.q) == null || e.abort(t));
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(t) {
    var e, i, o, n;
    switch (this.i) {
      case 0:
        return (e = t.initial) == null ? void 0 : e.call(t);
      case 1:
        return (i = t.pending) == null ? void 0 : i.call(t);
      case 2:
        return (o = t.complete) == null ? void 0 : o.call(t, this.value);
      case 3:
        return (n = t.error) == null ? void 0 : n.call(t, this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
};
const dk = (a, t) => a === t || a.length === t.length && a.every((e, i) => !Cc(e, t[i])), Af = /* @__PURE__ */ new Map([["facebook", "social"], ["instagram", "social"], ["linkedin", "social"], ["twitter", "social"], ["x", "social"], ["youtube", "social"], ["account", "functional"], ["add", "functional"], ["alert", "functional"], ["audio", "functional"], ["bookmark", "functional"], ["bookmark_filled", "functional"], ["calculator", "functional"], ["calendar", "functional"], ["card", "functional"], ["chart_area", "functional"], ["chart_bar_horizontal", "functional"], ["chart_bar_vertical", "functional"], ["chart_distribution", "functional"], ["chart_line", "functional"], ["chart_pie", "functional"], ["chat", "functional"], ["chevron_down", "functional"], ["chevron_left", "functional"], ["chevron_left_small", "functional"], ["chevron_right", "functional"], ["chevron_right_small", "functional"], ["chevron_up", "functional"], ["clear", "functional"], ["close", "functional"], ["close_small", "functional"], ["collapse", "functional"], ["collection", "functional"], ["correct", "functional"], ["dashboard", "functional"], ["decrease", "functional"], ["download", "functional"], ["edit", "functional"], ["email", "functional"], ["expand", "functional"], ["external_link", "functional"], ["filetype_doc", "functional"], ["filetype_pdf", "functional"], ["filetype_pdf_icon", "functional"], ["filetype_pps", "functional"], ["filetype_ppt", "functional"], ["filetype_rar", "functional"], ["filetype_rtf", "functional"], ["filetype_txt", "functional"], ["filetype_xls", "functional"], ["filetype_zip", "functional"], ["filter", "functional"], ["first", "functional"], ["folder", "functional"], ["full_screen", "functional"], ["full_screen_exit", "functional"], ["globe", "functional"], ["grid", "functional"], ["help", "functional"], ["hide", "functional"], ["home", "functional"], ["incorrect", "functional"], ["increase", "functional"], ["information", "functional"], ["language", "functional"], ["last", "functional"], ["link", "functional"], ["list", "functional"], ["locked", "functional"], ["login", "functional"], ["logout", "functional"], ["menu", "functional"], ["new_window", "functional"], ["notification", "functional"], ["overflow", "functional"], ["overflow_horizontal", "functional"], ["pause", "functional"], ["phone", "functional"], ["pin", "functional"], ["placeholder", "functional"], ["play", "functional"], ["playlist_video", "functional"], ["print", "functional"], ["reload", "functional"], ["remove", "functional"], ["rotate", "functional"], ["save", "functional"], ["search", "functional"], ["settings", "functional"], ["share", "functional"], ["share_ios", "functional"], ["show", "functional"], ["sort", "functional"], ["sorted_down", "functional"], ["sorted_up", "functional"], ["star", "functional"], ["star_filled", "functional"], ["support", "functional"], ["table", "functional"], ["trash", "functional"], ["unlocked", "functional"], ["upload", "functional"], ["user", "functional"], ["validation", "functional"], ["video", "functional"], ["zoom_in", "functional"], ["zoom_out", "functional"], ["apac", "flags"], ["australia", "flags"], ["austria", "flags"], ["belgium", "flags"], ["canada", "flags"], ["chile", "flags"], ["china", "flags"], ["colombia", "flags"], ["denmark", "flags"], ["estonia", "flags"], ["finland", "flags"], ["france", "flags"], ["germany", "flags"], ["greece", "flags"], ["guernsey", "flags"], ["hong_kong", "flags"], ["iceland", "flags"], ["ireland", "flags"], ["italy", "flags"], ["japan", "flags"], ["jersey", "flags"], ["latvia", "flags"], ["liechtenstein", "flags"], ["lithuania", "flags"], ["luxembourg", "flags"], ["malaysia", "flags"], ["mexico", "flags"], ["netherlands", "flags"], ["new_zealand", "flags"], ["norway", "flags"], ["portugal", "flags"], ["singapore", "flags"], ["south_africa", "flags"], ["south_korea", "flags"], ["spain", "flags"], ["sweden", "flags"], ["switzerland", "flags"], ["taiwan", "flags"], ["thailand", "flags"], ["uae", "flags"], ["united_kingdom", "flags"], ["usa", "flags"], ["trusty", "brand"]]), hk = {
  skipPreRender: !1
};
var Ga, Ms, Ts, gh;
const cs = class cs extends Ni {
  constructor(e) {
    super(e);
    Ie(this, Ga);
    Ie(this, Ms);
    const { type: i, element: o, options: n } = e;
    if (i !== gn.ELEMENT || !(o instanceof HTMLSlotElement))
      throw new Error(
        "The `whiteSpaceSensitive` directive must be used on a `<slot>` element."
      );
    if (Be(this, Ga, o), Te(this, Ga).name)
      throw new Error(
        "The `whiteSpaceSensitive` directive should only go on default slots."
      );
    n != null && n.host && Be(this, Ms, n.host);
  }
  render(e) {
    var n;
    const i = Object.assign({ ...hk }, e), { skipPreRender: o } = i;
    o || Ue(n = cs, Ts, gh).call(n, Te(this, Ms).childNodes), Te(this, Ga).addEventListener("slotchange", (l) => {
      var D;
      const L = Te(this, Ga).assignedNodes();
      Ue(D = cs, Ts, gh).call(D, L);
    });
  }
};
Ga = new WeakMap(), Ms = new WeakMap(), Ts = new WeakSet(), gh = function(e) {
  e.forEach((i) => {
    var o;
    i.nodeType !== Node.COMMENT_NODE && (i instanceof HTMLElement && i.slot || !((o = i.textContent) != null && o.trim()) && i instanceof Text && i.remove());
  });
}, Ie(cs, Ts);
let uh = cs;
const sb = Ri(uh), Au = {
  beaconTagName: "beacon-icon"
}, yd = {
  Small: "s",
  Medium: "m",
  Large: "l"
}, bk = ve`.beacon-on-dark,.beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],.beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],.beacon-on-darker,.beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],.beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-icon],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-icon]{--beacon-icon-g-path-1877F2: #fff;--beacon-icon-g-path-fff: none;--beacon-icon-g-path-000: #fff;--beacon-icon-svg-path-ED1D24: #fff;--beacon-icon-g-path-1D9BF0: #fff;--beacon-icon-g-path-0A66C2: #fff;--beacon-icon-g-path-urlg: #fff}`, pk = ve`:host{--icon-size-small: 16px;--icon-size-medium: 24px;--icon-size-large: 40px;--icon-size-small-pictogram: 48px;--icon-size-large-pictogram: 64px;--icon-size-flag: 20px;color:inherit;display:inline-block;pointer-events:none}.icon{inline-size:var(--icon-size, var(--icon-size-small))}.icon:is(.functional,.brand).sm{--icon-size: var(--icon-size-small)}.icon:is(.functional,.brand).md{--icon-size: var(--icon-size-medium)}.icon:is(.functional,.brand).lg{--icon-size: var(--icon-size-large)}.icon.flags{--icon-size: var(--icon-size-flag)}.icon.social.sm{--icon-size: var(--icon-size-small)}.icon.social:is(.md,.lg){--icon-size: var(--icon-size-medium)}svg{block-size:100%;display:block;fill:currentcolor;inline-size:100%}`;
var uk = Object.defineProperty, gk = Object.getOwnPropertyDescriptor, Xs = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? gk(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && uk(t, e, o), o;
}, Ls, Io;
const Sr = (Io = class extends Le {
  constructor() {
    super(...arguments);
    Ie(this, Ls);
    this.beaconTagName = Au.beaconTagName, this.componentModeStyles = [bk], this.label = "", this.size = yd.Small, Be(this, Ls, new ck(this, {
      args: () => [this.name],
      task: async ([e]) => e ? await sk(/* @__PURE__ */ Object.assign({ "../../icons/assets/brand/trusty.svg": () => import("./trusty-CLxP9xBt.js"), "../../icons/assets/flags/apac.svg": () => import("./apac-fSDtE4Hl.js"), "../../icons/assets/flags/australia.svg": () => import("./australia-gEnerx5I.js"), "../../icons/assets/flags/austria.svg": () => import("./austria-B1Z7YXZA.js"), "../../icons/assets/flags/belgium.svg": () => import("./belgium-Ck5q8G-e.js"), "../../icons/assets/flags/canada.svg": () => import("./canada-DB_gE70m.js"), "../../icons/assets/flags/chile.svg": () => import("./chile-Cv47HTqq.js"), "../../icons/assets/flags/china.svg": () => import("./china-DpsrhAnj.js"), "../../icons/assets/flags/colombia.svg": () => import("./colombia-C2U2OIK0.js"), "../../icons/assets/flags/denmark.svg": () => import("./denmark-tkSciTPR.js"), "../../icons/assets/flags/estonia.svg": () => import("./estonia-DJKWgrWe.js"), "../../icons/assets/flags/finland.svg": () => import("./finland-D162hwnK.js"), "../../icons/assets/flags/france.svg": () => import("./france-B-UVZUom.js"), "../../icons/assets/flags/germany.svg": () => import("./germany-MSzMT8rL.js"), "../../icons/assets/flags/greece.svg": () => import("./greece-BuKtTo2r.js"), "../../icons/assets/flags/guernsey.svg": () => import("./guernsey-B1p49K7f.js"), "../../icons/assets/flags/hong_kong.svg": () => import("./hong_kong-6jw7arc4.js"), "../../icons/assets/flags/iceland.svg": () => import("./iceland-DfSx4Tbt.js"), "../../icons/assets/flags/ireland.svg": () => import("./ireland-BVJXIiF_.js"), "../../icons/assets/flags/italy.svg": () => import("./italy-BYIg_kjJ.js"), "../../icons/assets/flags/japan.svg": () => import("./japan-C0jb46ja.js"), "../../icons/assets/flags/jersey.svg": () => import("./jersey-DUgzd-C3.js"), "../../icons/assets/flags/latvia.svg": () => import("./latvia--0h4WoPQ.js"), "../../icons/assets/flags/liechtenstein.svg": () => import("./liechtenstein-DIbj1820.js"), "../../icons/assets/flags/lithuania.svg": () => import("./lithuania-El_0rTxn.js"), "../../icons/assets/flags/luxembourg.svg": () => import("./luxembourg-Dgtrn686.js"), "../../icons/assets/flags/malaysia.svg": () => import("./malaysia-bFrHGvAn.js"), "../../icons/assets/flags/mexico.svg": () => import("./mexico-CptgWUl0.js"), "../../icons/assets/flags/netherlands.svg": () => import("./netherlands-5emYjBLf.js"), "../../icons/assets/flags/new_zealand.svg": () => import("./new_zealand-EPiaTnTq.js"), "../../icons/assets/flags/norway.svg": () => import("./norway-jRvMHiyq.js"), "../../icons/assets/flags/portugal.svg": () => import("./portugal-BR4bPmOQ.js"), "../../icons/assets/flags/singapore.svg": () => import("./singapore-B4STdeWA.js"), "../../icons/assets/flags/south_africa.svg": () => import("./south_africa-BYePFimX.js"), "../../icons/assets/flags/south_korea.svg": () => import("./south_korea-BvhwmGp1.js"), "../../icons/assets/flags/spain.svg": () => import("./spain-CqwnOkJw.js"), "../../icons/assets/flags/sweden.svg": () => import("./sweden-DapcDvCx.js"), "../../icons/assets/flags/switzerland.svg": () => import("./switzerland-BkfzVz5w.js"), "../../icons/assets/flags/taiwan.svg": () => import("./taiwan-hmIucA5s.js"), "../../icons/assets/flags/thailand.svg": () => import("./thailand-CqnVHFeC.js"), "../../icons/assets/flags/uae.svg": () => import("./uae-BspYiGih.js"), "../../icons/assets/flags/united_kingdom.svg": () => import("./united_kingdom-DCGXWNbA.js"), "../../icons/assets/flags/usa.svg": () => import("./usa-CDNFY5a9.js"), "../../icons/assets/functional/account.svg": () => import("./account-CQ4tbYjx.js"), "../../icons/assets/functional/add.svg": () => import("./add-DCmO1JJ0.js"), "../../icons/assets/functional/alert.svg": () => import("./alert-CcwmXEsq.js"), "../../icons/assets/functional/audio.svg": () => import("./audio-Bx5m4166.js"), "../../icons/assets/functional/bookmark.svg": () => import("./bookmark-DHdqc2Ng.js"), "../../icons/assets/functional/bookmark_filled.svg": () => import("./bookmark_filled-74mn6NIr.js"), "../../icons/assets/functional/calculator.svg": () => import("./calculator-CX5sw0LO.js"), "../../icons/assets/functional/calendar.svg": () => import("./calendar-BbJfaIyx.js"), "../../icons/assets/functional/card.svg": () => import("./card-BFjTTffG.js"), "../../icons/assets/functional/chart_area.svg": () => import("./chart_area--8EuhNuX.js"), "../../icons/assets/functional/chart_bar_horizontal.svg": () => import("./chart_bar_horizontal-CVa4msNE.js"), "../../icons/assets/functional/chart_bar_vertical.svg": () => import("./chart_bar_vertical-dx4dcGiq.js"), "../../icons/assets/functional/chart_distribution.svg": () => import("./chart_distribution-v47m0hr1.js"), "../../icons/assets/functional/chart_line.svg": () => import("./chart_line-AS9EoPZ6.js"), "../../icons/assets/functional/chart_pie.svg": () => import("./chart_pie-hBwadVNA.js"), "../../icons/assets/functional/chat.svg": () => import("./chat-allAfZwG.js"), "../../icons/assets/functional/chevron_down.svg": () => import("./chevron_down-Dl25sPLQ.js"), "../../icons/assets/functional/chevron_left.svg": () => import("./chevron_left-DWWPgwoC.js"), "../../icons/assets/functional/chevron_left_small.svg": () => import("./chevron_left_small-Cv1KlZm1.js"), "../../icons/assets/functional/chevron_right.svg": () => import("./chevron_right-BBCFUnvE.js"), "../../icons/assets/functional/chevron_right_small.svg": () => import("./chevron_right_small-baKK4T0K.js"), "../../icons/assets/functional/chevron_up.svg": () => import("./chevron_up-Bdj8BNLZ.js"), "../../icons/assets/functional/clear.svg": () => import("./clear-Be3aHupx.js"), "../../icons/assets/functional/close.svg": () => import("./close-DWVCPK4a.js"), "../../icons/assets/functional/close_small.svg": () => import("./close_small-BuefwUsD.js"), "../../icons/assets/functional/collapse.svg": () => import("./collapse-Des3hDL7.js"), "../../icons/assets/functional/collection.svg": () => import("./collection-Dxemkmd7.js"), "../../icons/assets/functional/correct.svg": () => import("./correct-RdBy7HYd.js"), "../../icons/assets/functional/dashboard.svg": () => import("./dashboard-xo3TQCnh.js"), "../../icons/assets/functional/decrease.svg": () => import("./decrease-D5dPCJlG.js"), "../../icons/assets/functional/download.svg": () => import("./download-DV0Ms4Op.js"), "../../icons/assets/functional/edit.svg": () => import("./edit-qpr9H6ut.js"), "../../icons/assets/functional/email.svg": () => import("./email-Dbp04rNr.js"), "../../icons/assets/functional/expand.svg": () => import("./expand-BvWEc8fv.js"), "../../icons/assets/functional/external_link.svg": () => import("./external_link-CLawBAb7.js"), "../../icons/assets/functional/filetype_doc.svg": () => import("./filetype_doc-C92ybn3H.js"), "../../icons/assets/functional/filetype_pdf.svg": () => import("./filetype_pdf-C9Mf-DEG.js"), "../../icons/assets/functional/filetype_pdf_icon.svg": () => import("./filetype_pdf_icon-C6Pd193v.js"), "../../icons/assets/functional/filetype_pps.svg": () => import("./filetype_pps-DHta0pyB.js"), "../../icons/assets/functional/filetype_ppt.svg": () => import("./filetype_ppt-CoSkE4F_.js"), "../../icons/assets/functional/filetype_rar.svg": () => import("./filetype_rar-DCdv8_wt.js"), "../../icons/assets/functional/filetype_rtf.svg": () => import("./filetype_rtf-DQAOn87q.js"), "../../icons/assets/functional/filetype_txt.svg": () => import("./filetype_txt-BVX9K2KM.js"), "../../icons/assets/functional/filetype_xls.svg": () => import("./filetype_xls-B9WNVcU2.js"), "../../icons/assets/functional/filetype_zip.svg": () => import("./filetype_zip-BpEdFczY.js"), "../../icons/assets/functional/filter.svg": () => import("./filter-qFvkKBRv.js"), "../../icons/assets/functional/first.svg": () => import("./first-CQrgQlwW.js"), "../../icons/assets/functional/folder.svg": () => import("./folder-CZkZd2CY.js"), "../../icons/assets/functional/full_screen.svg": () => import("./full_screen-3fy-Nxk7.js"), "../../icons/assets/functional/full_screen_exit.svg": () => import("./full_screen_exit-BOY6HYDs.js"), "../../icons/assets/functional/globe.svg": () => import("./globe-MeDjNXWh.js"), "../../icons/assets/functional/grid.svg": () => import("./grid-BLqTHjrL.js"), "../../icons/assets/functional/help.svg": () => import("./help-KPlEF8kQ.js"), "../../icons/assets/functional/hide.svg": () => import("./hide-5NjakTzs.js"), "../../icons/assets/functional/home.svg": () => import("./home-DDL8vR8u.js"), "../../icons/assets/functional/incorrect.svg": () => import("./incorrect-6JNuovJt.js"), "../../icons/assets/functional/increase.svg": () => import("./increase-57b2Kc-F.js"), "../../icons/assets/functional/information.svg": () => import("./information-DNlfVfHc.js"), "../../icons/assets/functional/language.svg": () => import("./language-LlY7ZUPG.js"), "../../icons/assets/functional/last.svg": () => import("./last-DrhCFJ6V.js"), "../../icons/assets/functional/link.svg": () => import("./link-BPguixX7.js"), "../../icons/assets/functional/list.svg": () => import("./list-rKwwvO0o.js"), "../../icons/assets/functional/locked.svg": () => import("./locked-DDIHOS3J.js"), "../../icons/assets/functional/login.svg": () => import("./login-aek5nlzR.js"), "../../icons/assets/functional/logout.svg": () => import("./logout-CszSu_Jq.js"), "../../icons/assets/functional/menu.svg": () => import("./menu-CtFmPbhC.js"), "../../icons/assets/functional/new_window.svg": () => import("./new_window-DlfgZHbL.js"), "../../icons/assets/functional/notification.svg": () => import("./notification-DQCiQ7la.js"), "../../icons/assets/functional/overflow.svg": () => import("./overflow-Di1X5mMO.js"), "../../icons/assets/functional/overflow_horizontal.svg": () => import("./overflow_horizontal-64-HaJrQ.js"), "../../icons/assets/functional/pause.svg": () => import("./pause-Hn4r0RLJ.js"), "../../icons/assets/functional/phone.svg": () => import("./phone-D7oNx5-g.js"), "../../icons/assets/functional/pin.svg": () => import("./pin-S967QMPt.js"), "../../icons/assets/functional/placeholder.svg": () => import("./placeholder-DW2RIpI5.js"), "../../icons/assets/functional/play.svg": () => import("./play-BLRVUiOH.js"), "../../icons/assets/functional/playlist_video.svg": () => import("./playlist_video-CFi0y8ZR.js"), "../../icons/assets/functional/print.svg": () => import("./print-C0nozzJi.js"), "../../icons/assets/functional/reload.svg": () => import("./reload-GzyOXd2i.js"), "../../icons/assets/functional/remove.svg": () => import("./remove-DbPFAtHS.js"), "../../icons/assets/functional/rotate.svg": () => import("./rotate-CPlos1PY.js"), "../../icons/assets/functional/save.svg": () => import("./save-D-6knrtu.js"), "../../icons/assets/functional/search.svg": () => import("./search-CfWuUnkk.js"), "../../icons/assets/functional/settings.svg": () => import("./settings-CS9FRmf3.js"), "../../icons/assets/functional/share.svg": () => import("./share-D6o1J--q.js"), "../../icons/assets/functional/share_ios.svg": () => import("./share_ios-BIJN0STc.js"), "../../icons/assets/functional/show.svg": () => import("./show-BdVb7QzL.js"), "../../icons/assets/functional/sort.svg": () => import("./sort-3U-jbRjo.js"), "../../icons/assets/functional/sorted_down.svg": () => import("./sorted_down-DhwlMhsc.js"), "../../icons/assets/functional/sorted_up.svg": () => import("./sorted_up-uQndrlYP.js"), "../../icons/assets/functional/star.svg": () => import("./star-4KyWHyO_.js"), "../../icons/assets/functional/star_filled.svg": () => import("./star_filled-CPKrSHqT.js"), "../../icons/assets/functional/support.svg": () => import("./support-CQ08RJTm.js"), "../../icons/assets/functional/table.svg": () => import("./table-BRcbtbUF.js"), "../../icons/assets/functional/trash.svg": () => import("./trash-CRk6Qoh7.js"), "../../icons/assets/functional/unlocked.svg": () => import("./unlocked-qUHpeQBH.js"), "../../icons/assets/functional/upload.svg": () => import("./upload-BMNN9nnp.js"), "../../icons/assets/functional/user.svg": () => import("./user-B4WbhIpQ.js"), "../../icons/assets/functional/validation.svg": () => import("./validation-DCgAc1uK.js"), "../../icons/assets/functional/video.svg": () => import("./video-BUAl5AdS.js"), "../../icons/assets/functional/zoom_in.svg": () => import("./zoom_in-m4h6Va0-.js"), "../../icons/assets/functional/zoom_out.svg": () => import("./zoom_out-DtSN6myF.js"), "../../icons/assets/social/facebook.svg": () => import("./facebook-8SrECXb5.js"), "../../icons/assets/social/instagram.svg": () => import("./instagram-f4C7Xnds.js"), "../../icons/assets/social/linkedin.svg": () => import("./linkedin-mqwQhlm0.js"), "../../icons/assets/social/twitter.svg": () => import("./twitter-BdqIEi_y.js"), "../../icons/assets/social/x.svg": () => import("./x-o9ssdrff.js"), "../../icons/assets/social/youtube.svg": () => import("./youtube-iOBR7GrH.js") }), `../../icons/assets/${this.category}/${e}.svg`, 6).then((o) => o.default) : ""
    })), this.completedFetchIconRender = (e) => pe`
      <div
        class="icon ${this.name} ${this.category} ${Io.iconSizeClassName(this.size)}"
        part="internal--icon">
        <slot ${sb()}>${gt(e)}</slot>
      </div>
    `, this.erroredFetchIconRender = (e) => ze`<${this.getScopedTag("beacon-error")}>${e}</${this.getScopedTag("beacon-error")}>`;
  }
  static get styles() {
    return [super.styles, pk];
  }
  get category() {
    var e;
    return (e = Af.get(this.name)) != null ? e : "functional";
  }
  makePresentational() {
    this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label), this.removeAttribute("aria-hidden");
  }
  makeDecorative() {
    this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true");
  }
  static iconSizeClassName(e) {
    return e === yd.Medium ? "md" : e === yd.Large ? "lg" : "sm";
  }
  _handleLabelChange() {
    typeof this.label == "string" && this.label.length > 0 ? this.makePresentational() : this.makeDecorative();
  }
  loadModeStyles() {
    this.renderComponentModeStyles();
  }
  render() {
    return Te(this, Ls).render({
      initial: Io.preFetchIconRender,
      pending: Io.pendingFetchIconRender,
      complete: this.completedFetchIconRender,
      error: this.erroredFetchIconRender
    });
  }
}, Ls = new WeakMap(), Io.tagName = Au.beaconTagName, Io.preFetchIconRender = () => pe`<slot></slot>`, Io.pendingFetchIconRender = () => pe`<slot></slot>`, Io);
Xs([
  ue()
], Sr.prototype, "name", 2);
Xs([
  ue()
], Sr.prototype, "label", 2);
Xs([
  ue()
], Sr.prototype, "size", 2);
Xs([
  Gt("label")
], Sr.prototype, "_handleLabelChange", 1);
Xs([
  Re
], Sr.prototype, "loadModeStyles", 1);
let ro = Sr;
const mk = ve`:host([motion-state=enabled]) :is(a,button){--button-base-transition-duration: var(--beacon-reference-motion-duration-3);--scale-x-value: 1.05;--scale-y-value: 1.1;transition-property:var(--button-base-transition-property),transform}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary){transform:scale(var(--scale-x-value),var(--scale-y-value))}:host([motion-state=enabled]) :is(a,button):is(:active,:hover):not(.tertiary) .contents{transform:scale(calc(1 / var(--scale-x-value)),calc(1 / var(--scale-y-value)))}:host([state=success]){--button-flex-direction: row}:host([state=success]) button{background-color:var(--beacon-system-color-background-positive);border-color:var(--beacon-system-color-background-positive);overflow:hidden}:host([state=success]) button ::slotted([slot=icon]){display:none}:host([state=success]) button .contents{margin-inline-start:-1rem;padding-inline-start:1rem;transition:padding-inline-start var(--beacon-reference-motion-duration-2) ease-in}:host([state=success]) button .checkmark{opacity:1;position:relative;transform:translate(0);transition:opacity var(--beacon-reference-motion-duration-3) ease-in var(--beacon-reference-motion-duration-3),transform var(--beacon-reference-motion-duration-5) ease-in var(--beacon-reference-motion-duration-3);visibility:visible}:host([state=success]) button:hover{--scale-x-value: 1;--scale-y-value: 1;background-color:var(--beacon-system-color-background-positive-hover);border-color:var(--beacon-system-color-background-positive)}:host(:not([state=success])) button .checkmark{max-inline-size:0;opacity:0;position:absolute;transform:translate(-40%);visibility:hidden}`;
var fk = Object.getOwnPropertyDescriptor, vk = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? fk(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function Ak(a) {
  let t = class extends a {
    static get ButtonMotionStyles() {
      return [mk];
    }
  };
  return t = vk([
    $e("ButtonMotion")
  ], t), t;
}
const yk = ve`:host{display:inline-block;inline-size:var(--override-button-inline-size)}a,button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;text-decoration:none;word-break:initial}a .contents,button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}a[aria-disabled=true],button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}a:is(:hover,:focus-visible):not([aria-disabled=true]),button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}a:active:not([aria-disabled=true]),button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.tertiary{--standard-default-color: var(--beacon-system-color-text-tertiary);--standard-hover-color: var(--beacon-system-color-text-tertiary-hover);--standard-active-color: var(--beacon-system-color-text-tertiary-pressed);--standard-disabled-color: var(--beacon-system-color-text-tertiary-inactive);--bg-color: var(--override-button-color-background-tertiary-default, transparent);--border-color: var(--override-button-color-border-error, var(--override-button-color-border-tertiary-default, var(--bg-color)));--text-color: var(--override-button-color-text-tertiary-default, var(--standard-default-color));--hover-bg-color: var(--bg-color);--disabled-border-color: var(--bg-color);--hover-text-color: var(--override-button-color-text-tertiary-default, var(--standard-hover-color));--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--override-button-color-text-tertiary-inactive, var(--standard-disabled-color));--active-bg-color: var(--bg-color);--active-text-color: var(--override-button-color-text-tertiary-default, var(--standard-active-color));padding-inline:var(--override-button-space-padding-tertiary, 0)}.positive{--bg-color: var(--beacon-system-color-background-positive);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-positive-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-positive-pressed);--active-text-color: var(--text-color)}.negative{--bg-color: var(--beacon-system-color-background-negative);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-set-white);--hover-bg-color: var(--beacon-system-color-background-negative-hover);--hover-text-color: var(--text-color);--active-bg-color: var(--beacon-system-color-background-negative-pressed);--active-text-color: var(--text-color)}`;
var xk = Object.defineProperty, wk = Object.getOwnPropertyDescriptor, lb = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? wk(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && xk(t, e, o), o;
}, Ei, nc;
const Bc = (Ei = class extends Ge(Ha).with(Ak) {
  constructor() {
    super(...arguments), this.beaconTagName = "beacon-button", this.scale = Fo.NORMAL, this.state = nb.NONE;
  }
  static get styles() {
    return [super.styles, yk, this.ButtonMotionStyles];
  }
  /**
   * Render function for beacon-button if link-href propety is passed in to support links as buttons
   *
   * @returns {TemplateResult} returns an `<a>` tag styled as a button
   */
  renderAnchorTag() {
    var t;
    return pe`<a
      id="${mt(this._passthroughs.attributes.get("id"))}"
      @click=${this.handleClick}
      href="${this.linkHref}"
      download="${mt(this.linkDownload)}"
      target="${mt(this.linkTarget)}"
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      data-metrics-link-text="${(t = this.defaultSlotText) != null ? t : je}">
      <span class="contents">
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}>
          ${this.defaultSlotText}
        </slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </a>`;
  }
  /**
   * Render function for beacon-button as a `<button>` element
   *
   * @returns {TemplateResult} returns a `<button>` tag as the template
   */
  renderButtonTag() {
    var t;
    return ze`<button
      id="${mt(this._passthroughs.attributes.get("id"))}"
      part="standard-button"
      @click=${this.handleClick}
      class="${this.variant} ${this.scale}"
      aria-disabled="${this.disabled}"
      type="${this.type}"
      data-metrics-link-text="${(t = this.defaultSlotText) != null ? t : je}">
      <span class="contents">
        <${this.getScopedTag("beacon-icon")} name='correct' class="checkmark"></${this.getScopedTag("beacon-icon")}>
        <slot name="prefix" @slotchange=${this.handleAffixSlotChanges}></slot>
        <slot @slotchange=${this.setDefaultSlotText}></slot>
        <slot name="suffix" @slotchange=${this.handleAffixSlotChanges}></slot>
      </span>
    </button>`;
  }
  _attachFormElementsClickEvents() {
    if (this._internals) {
      const { form: t } = this._internals;
      if (t && this.type === rs.SUBMIT)
        for (const e of t.elements)
          e instanceof HTMLInputElement && !Te(Ei, nc).get(e.type) && e.addEventListener(
            "keydown",
            (i) => {
              i.key === "Enter" && this.button.click();
            }
          );
    }
  }
  render() {
    return pe` ${pf(
      this.linkHref,
      () => this.renderAnchorTag(),
      () => this.renderButtonTag()
    )}`;
  }
}, nc = new WeakMap(), Ei.tagName = "beacon-button", Ei.nestedComponents = [ro], /**
 * Form elements which shouldn't respond to our Enter key listener.
 * @see _attachFormElementsClickEvents
 */
Ie(Ei, nc, /* @__PURE__ */ new Map([["date", !0]])), Ei);
lb([
  ue({ reflect: !0 })
], Bc.prototype, "scale", 2);
lb([
  ue({ reflect: !0 })
], Bc.prototype, "state", 2);
lb([
  Re
], Bc.prototype, "_attachFormElementsClickEvents", 1);
let Er = Bc;
const kk = ve`:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-variable-unset: unset;--table-stub-space-zero-value: 0;--table-stub-category-icon-margin-block-start: 0;--table-stub-title-icon-margin-block-start: 0;--table-stub-space-margin-inline-start: var(--beacon-reference-space-3);--table-stub-space-margin-inline-end: var(--beacon-reference-space-3);--table-base-stub-space-padding-block: var(--beacon-reference-space-2);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-2);--table-stub-category-space-margin-inline: var(--beacon-reference-space-1);--table-stub-category-icon-space-margin-block: 0}@media (width >= 640px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-title-icon-margin-block-start: var(--beacon-reference-space-1);--table-stub-space-margin-inline-start: var(--beacon-reference-space-5);--table-base-stub-space-padding-block: var(--beacon-reference-space-3);--table-stub-floating-space-padding-inline: 6px;--table-stub-category-space-margin-inline: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-space-margin-inline-end: var(--beacon-reference-space-4);--table-base-stub-space-padding-block: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table-stub],:root [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-stub],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-stub]{--table-stub-category-icon-margin-block-start: var(--beacon-reference-space-0);--table-stub-floating-space-padding-inline: var(--beacon-reference-space-3);--table-stub-category-icon-space-margin-block: var(--beacon-reference-space-1)}}`, Ck = ve`[beacon-tag-name=beacon-table-stub] [slot=action-zone-right]{margin:var(--table-override-stub-action-zone-right-space, 0)}[beacon-tag-name=beacon-table-stub] [slot=action-zone-left]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);margin-block-start:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon{margin-block-start:var(--table-stub-title-icon-margin-block-start);margin-inline-start:var(--beacon-reference-space-2);vertical-align:text-top}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon,[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);min-inline-size:fit-content}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category{--category-text-margin-block-start: var(--beacon-reference-space-2);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:0}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{margin-block:0;margin-block-start:var(--table-stub-category-icon-margin-block-start)}`, Sk = ve`@charset "UTF-8";:host{--override-button-space-padding-tertiary: var(--beacon-reference-space-4);--override-button-font-size-mini: var(--beacon-reference-font-scale-1);--override-button-font-line-height-mini: 1.6;--override-button-color-text-tertiary-default: var(--beacon-system-color-text-link);--override-button-icon-space-margin: var(--beacon-reference-space-2);--content-grid-template: "value-prop" "standard";--content-grid-template-columns: initial;--value-prop-margin-inline-end: 0;--value-prop-margin-block-end: var(--beacon-reference-space-2);--action-zone-left-margin-block-start: var(--beacon-reference-space-3);--stub-content-margin-inline-start: var(--table-stub-space-margin-inline-start);--stub-content-margin-inline-end: var(--table-stub-space-margin-inline-end);color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}:host([value-prop-left]){--content-grid-template-columns: auto 1fr;--content-grid-template: "value-prop standard";--value-prop-margin-inline-end: var(--beacon-reference-space-3);--value-prop-margin-block-end: 0}p{margin:0}.has-cell-padding{padding-block:0;padding-inline:0}.title{display:flex;grid-area:title}.title-footnote,::slotted(sup){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.category{display:flex;grid-area:category}.title,.category{font-weight:var(--beacon-system-font-weight-bold)}.value-prop{grid-area:value-prop;margin-block-end:var(--value-prop-margin-block-end);margin-inline-end:var(--value-prop-margin-inline-end);padding:0}.content{display:grid;grid-template-areas:var(--content-grid-template);grid-template-columns:var(--content-grid-template-columns);inline-size:100%}.content .hide{display:none}.standard{display:grid;grid-template-areas:"category" "title" "attributes" "status" "description" "footnote"}.standard *:not(:last-child){margin-block-end:var(--beacon-reference-space-1)}.standard .title{margin-block-start:0}.standard>*,.standard .category+.title{margin-block-start:0}.standard .status{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);background-color:var(--beacon-system-color-background-2);border-radius:var(--beacon-system-radius-corner-standard);grid-area:status;inline-size:fit-content;margin-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-1);padding-inline:var(--beacon-reference-space-3)}.standard .status+*{margin-block-start:0}.content-wrapper{display:flex;gap:var(--beacon-reference-space-3)}.stub{display:grid;margin-inline:0}.stub.level-2 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-2 .title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}.stub.level-2 ::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--table-stub-category-icon-space-margin-block)}.stub.level-3 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-reference-space-5))}.stub.level-3 .title-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.dropdown{display:var(--table-override-stub-dropdown-display, initial);justify-self:end}.attributes{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);grid-area:attributes}.category-text{--category-text-margin-block-start: var(--beacon-reference-space-1);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);margin-block-start:var(--category-text-margin-block-start)}.description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);grid-area:description;margin-block-start:var(--beacon-reference-space-3)}.footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);grid-area:footnote}@media (prefers-reduced-motion){.floating-stub{display:none}}@media (prefers-reduced-motion: no-preference){.floating-stub{background:var(--beacon-system-color-background-2);color:var(--beacon-system-color-text-standard);display:grid;grid-template-areas:"category title";inline-size:max-content;inset-block-start:0;inset-inline-start:var(--table-stub-floating-override-inset-inline-start, 0);margin-block-start:calc(-1 * var(--table-base-stub-space-padding-block));margin-inline-start:var(--table-stub-floating-override-margin-inline-start, -500%);padding-block-start:var(--beacon-reference-space-2);padding-inline:var(--table-stub-floating-space-padding-inline);place-items:center;position:absolute;transform:translateY(-50%);transition:margin-inline-start 1s;z-index:2}.floating-stub .category:after{content:"·";margin-inline:var(--table-stub-category-space-margin-inline)}.floating-stub .category-text{margin:0}.floating-stub .category .category-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.floating-stub .category-icon{margin-block:var(--table-stub-category-icon-space-margin-block)}}.wrapper{position:relative}@media (width >= 1280px){.category-text{--category-text-margin-block-start: 0}}`;
var Ek = Object.defineProperty, Mk = Object.getOwnPropertyDescriptor, Qe = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Mk(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && Ek(t, e, o), o;
};
const zn = "beacon-table-stub", yu = "1px solid var(--beacon-system-color-border-0)", gl = "0", Tk = "calc(var(--beacon-reference-space-3) + var(--table-row-space-padding))", Vi = "th", Lk = "tr", ml = "border-block-end", Ok = "beacon-table", xu = "display", Pk = "none", Dk = "padding-block-end", zk = "--inset-divider-border", Ik = "--inset-divider-padding-block-start", Bk = "table-row", wu = "--inset-divider-margin-start", Rk = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", Nk = "calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-5) + var(--table-stub-space-margin-inline-start))", ku = "--inset-divider-margin-end", Fk = "13px", Cu = "BEACON-CHECKBOX", jk = "--action-zone-left-margin-block-start", _k = "checkbox", Uk = 'input[type="checkbox"]', $k = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-start))", Hk = "calc(var(--beacon-reference-space-3) + var(--table-stub-space-margin-inline-end))";
var Mi;
const Ye = (Mi = class extends Ys {
  constructor() {
    super(...arguments), this.beaconTagName = zn, this.nextStub = null, this.level = Mt.ONE, this.valuePropLeft = !1, this.withDropdown = !1, this.highlighted = !1, this.showDropdown = !1, this.hasCategory = !1, this.hasStatus = !1, this.hasValueProp = !1, this.hasDescription = !1, this.hasFootnote = !1, this.hasAttributeList = !1;
  }
  static get styles() {
    return [super.styles, Sk];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Ck, kk];
  }
  onBeaconRenderActionZone() {
  }
  /**
   * Used when the current instance is a level 2 stub
   * Triggers the visibility of possible level 3 children
   * @param {boolean} show - Boolean parameter that shows children on true
   */
  triggerChildren(t) {
    var i, o, n, l;
    let e = this.next;
    if (t) {
      for (; e; )
        e == null || e.showRow(), e = e.next;
      (o = (i = this.parentTableRow) == null ? void 0 : i.querySelector(Vi)) == null || o.style.setProperty(ml, gl);
    } else {
      for (; e; )
        e == null || e.hideRow(), e = e.next;
      (l = (n = this.parentTableRow) == null ? void 0 : n.querySelector(Vi)) == null || l.style.setProperty(ml, yu);
    }
  }
  /**
   * Used to trigger the state of the dropdown and visibility of level 3 children in a level 2 stub instance
   */
  handleClick() {
    this.showDropdown = !this.showDropdown, this.triggerChildren(this.showDropdown);
  }
  /**
   * Use to receive a reference to the next table stub in multi-level context
   *
   * @return {BeaconTableStub} contains a level 2 or level 3 stub
   */
  get next() {
    return this.nextStub;
  }
  /**
   * sets the parentTableRow class variable
   * Searches up the DOM tree to look for the first instance of a table `<tr>` element
   */
  setParentTableRow() {
    const t = this.closest(Lk);
    t && (this.parentTableRow = t);
  }
  /**
   * sets the nextStub class variable
   * Searches for the current stub sibling to maintain a linked-list between level 2 and level 3 stubs
   */
  setNextStub(t = null) {
    var i, o;
    if (t) {
      this.nextStub = t;
      return;
    }
    const e = (o = (i = this.parentTableRow) == null ? void 0 : i.nextElementSibling) == null ? void 0 : o.querySelector(
      zn
    );
    this.level !== Mt.ONE && (this.level === Mt.TWO && (e == null ? void 0 : e.level) !== Mt.THREE || this.level === Mt.THREE && (e == null ? void 0 : e.level) !== Mt.THREE || (this.nextStub = e));
  }
  setParentTableRowAndSetNextStub() {
    this.setParentTableRow(), this.setNextStub();
  }
  /**
   * Hides parent table row by setting display to none
   */
  hideRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(xu, Pk);
  }
  /**
   * Shows parent table row by setting display to default table-row
   */
  showRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(xu, Bk);
  }
  /**
   * Sets the hasMultiLevel property of parent beacon-table component to trigger vertical divider styles
   * in multi-level stub context
   */
  setMultiLevelTableProp() {
    const t = this.closest(
      Ok
    );
    t && t._setMultiLevel(!0);
  }
  /**
   * addInsetRowBorders() removes the default full width borders of table header elements and instead adds
   * inset borders in multi-level stub context
   */
  addInsetRowBorders() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(Vi);
    t && (t.style.setProperty(ml, gl), t.style.setProperty(Dk, gl), t.style.setProperty(zk, yu), t.style.setProperty(
      Ik,
      Tk
    ));
  }
  /**
   * Clones passed in childEl and inserts it before the first child of parentEl
   * @param  {HTMLElement} parentEl: Element that will hold childEl
   * @param  {Array<HTMLElement>} childEl: Element to be cloned and prepended to parentEl
   * @returns void
   */
  static cloneAndPrepend(t, e) {
    if (t && (e != null && e.length)) {
      const i = e.find((o) => o);
      if (i) {
        const o = i.cloneNode(!0);
        t.prepend(o);
      }
    }
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render-action-zone - emits when the action zone is rendered inside a table
   */
  emitRenderActionZone() {
    Fe(
      this,
      Ee.RENDER_ACTION_ZONE,
      void 0,
      this.onBeaconRenderActionZone
    );
  }
  /**
   * change action-zone-left slot padding if it contains a checkbox
   */
  handleActionZone() {
    if (this.actionZoneLeft && this.actionZoneLeft.length) {
      this.emitRenderActionZone();
      const t = this.actionZoneLeft.find((o) => o), e = (t == null ? void 0 : t.getAttribute("type")) === _k || (t == null ? void 0 : t.tagName) === Cu, i = (t == null ? void 0 : t.querySelector(Uk)) || (t == null ? void 0 : t.querySelector(Cu));
      (e || i) && this.style.setProperty(
        jk,
        Fk
      );
    }
  }
  /**
   * Sets stub styles based on level and trailing nextStubs
   */
  setStubStyles() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(Vi);
    t && (this == null ? void 0 : this.level) === Mt.TWO && this != null && this.showDropdown && (t == null || t.style.setProperty(
      ml,
      gl
    )), this.level === Mt.TWO && this.setLevelOneInsetBorder();
  }
  /**
   * Sets inset borders for sibling level 1 stub if current instance is a level 2 stub
   */
  setLevelOneInsetBorder() {
    var e, i, o, n, l, L;
    const t = (i = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : i.querySelector(
      zn
    );
    t == null || t.addInsetRowBorders(), (n = (o = t == null ? void 0 : t.parentTableRow) == null ? void 0 : o.querySelector(Vi)) == null || n.style.setProperty(
      wu,
      $k
    ), (L = (l = t == null ? void 0 : t.parentTableRow) == null ? void 0 : l.querySelector(Vi)) == null || L.style.setProperty(
      ku,
      Hk
    );
  }
  /**
   * Styles set when current instance is a level 3 stub
   */
  levelThreeStubStyles() {
    var t, e, i, o, n;
    this.nextStub && ((t = this.nextStub) == null ? void 0 : t.level) === (this == null ? void 0 : this.level) && this.addInsetRowBorders(), (i = (e = this.parentTableRow) == null ? void 0 : e.querySelector(Vi)) == null || i.style.setProperty(
      wu,
      Rk
    ), (n = (o = this.parentTableRow) == null ? void 0 : o.querySelector(Vi)) == null || n.style.setProperty(
      ku,
      Nk
    );
  }
  /**
   * Sets the previous stub's next if a new row is inserted into the table
   */
  updatePreviousNext() {
    var e, i;
    const t = (i = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : i.querySelector(
      zn
    );
    t && t.setNextStub();
  }
  tearDownTableStub() {
    var t, e;
    if (this.level === Mt.THREE) {
      const i = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(
        zn
      );
      i && i.setNextStub(this.nextStub);
    }
  }
  render() {
    return pe`
      <div class="wrapper">
        <div class="floating-stub">
          <div class="title"></div>
        </div>
        <div class="stub level-${this.level}">
          <div class="content-wrapper">
            <slot
              name="action-zone-left"
              @slotchange="${this.handleActionZone}"></slot>
            <div class="content has-cell-padding" part="content">
              ${this.renderValueProp()}
              <div class="standard">
                ${this.renderCategory()}
                <div class="title">
                  <slot></slot>
                  <slot class="title-text" name="title"></slot>
                  <slot class="title-footnote" name="title-footnote"></slot>
                  <slot name="title-icon"></slot>
                </div>
                ${this.renderAttributes()} ${this.renderStatus()}
                ${this.renderDescription()} ${this.renderFootnote()}
              </div>
            </div>
            <slot name="action-zone-right"></slot>
          </div>
          ${this.withDropdown ? pe`${ze`<${this.getScopedTag("beacon-button")}
          class="dropdown"
          @beacon-event-click="${this.handleClick}"
          variant=${rb.TERTIARY}
          scale="${Fo.MINI}">
          ${this.showDropdown ? "Hide Items" : "Show Items"}
          ${this.showDropdown ? pe`${gt(rk)}` : pe`${gt(vf)}`}</${this.getScopedTag("beacon-button")}>`}` : je}
        </div>
      </div>
    `;
  }
  categorySlotChange() {
    var t;
    this.hasCategory = !!((t = this.slottedCategory) != null && t.length);
  }
  renderCategory() {
    const t = {
      category: !0,
      hide: !this.hasCategory
    };
    return pe` <div class=${Pe(t)}>
      <slot name="category-icon"></slot>
      <slot name="category" @slotchange=${this.categorySlotChange}></slot>
    </div>`;
  }
  statusSlotChange() {
    var t;
    this.hasStatus = !!((t = this.slottedStatus) != null && t.length);
  }
  renderStatus() {
    const t = {
      status: !0,
      hide: !this.hasStatus
    };
    return pe` <div class=${Pe(t)}>
      <slot name="status" @slotchange=${this.statusSlotChange}></slot>
    </div>`;
  }
  valuePropSlotChange() {
    var t;
    this.hasValueProp = !!((t = this.slottedValueProp) != null && t.length);
  }
  renderValueProp() {
    const t = {
      "value-prop": !0,
      hide: !this.hasValueProp
    };
    return pe` <span
      class=${Pe(t)}
      @slotchange=${this.valuePropSlotChange}
      ><slot name="value-prop"></slot
    ></span>`;
  }
  descriptionSlotChange() {
    var t;
    this.hasDescription = !!((t = this.slottedDescription) != null && t.length);
  }
  renderDescription() {
    const t = {
      description: !0,
      hide: !this.hasDescription
    };
    return pe` <div class=${Pe(t)}>
      <slot name="description" @slotchange=${this.descriptionSlotChange}></slot>
    </div>`;
  }
  footnoteSlotChange() {
    var t;
    this.hasFootnote = !!((t = this.slottedFootnote) != null && t.length);
  }
  renderFootnote() {
    const t = {
      footnote: !0,
      hide: !this.hasFootnote
    };
    return pe` <div class=${Pe(t)}>
      <slot name="footnote" @slotchange=${this.footnoteSlotChange}></slot>
    </div>`;
  }
  attributesSlotChange() {
    var t;
    this.hasAttributeList = !!((t = this.slottedAttributes) != null && t.length);
  }
  renderAttributes() {
    const t = {
      attributes: !0,
      hide: !this.hasAttributeList
    };
    return pe` <div class=${Pe(t)}>
      <slot name="attributes" @slotchange=${this.attributesSlotChange}></slot>
    </div>`;
  }
  postrenderTableStubSetup() {
    Mi.cloneAndPrepend(this.floatingTitle, this.titleText), Mi.cloneAndPrepend(this.floatingCategory, this.categoryIcon), (this == null ? void 0 : this.level) !== Mt.ONE && Promise.resolve(this.setNextStub()).then(() => {
      (this == null ? void 0 : this.level) === Mt.TWO && this.showDropdown && this.triggerChildren(this.showDropdown);
    }), this.level === Mt.TWO && this.setMultiLevelTableProp(), this.level === Mt.THREE && (this.levelThreeStubStyles(), this.updatePreviousNext(), this.hideRow());
  }
}, Mi.tagName = zn, Mi.nestedComponents = [Er], Mi);
Qe([
  ue({ reflect: !0 })
], Ye.prototype, "level", 2);
Qe([
  ue({ attribute: "value-prop-left", type: Boolean, reflect: !0 })
], Ye.prototype, "valuePropLeft", 2);
Qe([
  ue({ attribute: "with-dropdown", type: Boolean, reflect: !0 })
], Ye.prototype, "withDropdown", 2);
Qe([
  ue({ type: Boolean, reflect: !0 })
], Ye.prototype, "highlighted", 2);
Qe([
  ue({ attribute: "show-dropdown", type: Boolean, reflect: !0 })
], Ye.prototype, "showDropdown", 2);
Qe([
  ue({ attribute: "sort-value", reflect: !0 })
], Ye.prototype, "sortValue", 2);
Qe([
  De({ slot: "title-footnote" })
], Ye.prototype, "titleFootnote", 2);
Qe([
  De({ slot: "title-icon" })
], Ye.prototype, "titleIcon", 2);
Qe([
  De({ slot: "action-zone-left" })
], Ye.prototype, "actionZoneLeft", 2);
Qe([
  De({ slot: "category-icon" })
], Ye.prototype, "categoryIcon", 2);
Qe([
  De({ slot: "" })
], Ye.prototype, "titleText", 2);
Qe([
  We(".title-text")
], Ye.prototype, "titleElement", 2);
Qe([
  We(".floating-stub .category .category-icon")
], Ye.prototype, "floatingCategory", 2);
Qe([
  We(".floating-stub .title")
], Ye.prototype, "floatingTitle", 2);
Qe([
  Ce()
], Ye.prototype, "hasCategory", 2);
Qe([
  De({ flatten: !0, slot: "category" })
], Ye.prototype, "slottedCategory", 2);
Qe([
  Ce()
], Ye.prototype, "hasStatus", 2);
Qe([
  De({ flatten: !0, slot: "status" })
], Ye.prototype, "slottedStatus", 2);
Qe([
  Ce()
], Ye.prototype, "hasValueProp", 2);
Qe([
  De({ flatten: !0, slot: "value-prop" })
], Ye.prototype, "slottedValueProp", 2);
Qe([
  Ce()
], Ye.prototype, "hasDescription", 2);
Qe([
  De({ flatten: !0, slot: "description" })
], Ye.prototype, "slottedDescription", 2);
Qe([
  Ce()
], Ye.prototype, "hasFootnote", 2);
Qe([
  De({ flatten: !0, slot: "footnote" })
], Ye.prototype, "slottedFootnote", 2);
Qe([
  Ce()
], Ye.prototype, "hasAttributeList", 2);
Qe([
  De({ flatten: !0, slot: "attributes" })
], Ye.prototype, "slottedAttributes", 2);
Qe([
  Re
], Ye.prototype, "setParentTableRowAndSetNextStub", 1);
Qe([
  Pt
], Ye.prototype, "tearDownTableStub", 1);
Qe([
  Re
], Ye.prototype, "postrenderTableStubSetup", 1);
let fl = Ye;
const Kk = ve`:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][beacon-tag-name=beacon-table],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-3);--table-caption-summary-spacer: var(--beacon-reference-space-5);--table-caption-spacer-jumbo: var(--beacon-reference-space-5);--table-caption-spacer-normal: var(--beacon-reference-space-3);--table-row-space-padding: var(--beacon-reference-space-2)}@media (width >= 640px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][beacon-tag-name=beacon-table],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-4);--table-row-space-padding: var(--beacon-reference-space-3)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][beacon-tag-name=beacon-table],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table]{--table-caption-summary-spacer: var(--beacon-reference-space-7);--table-caption-spacer-jumbo: var(--beacon-reference-space-7);--table-caption-spacer-normal: var(--beacon-reference-space-5);--table-row-space-padding: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table],[beacon-version="4.4.0"][beacon-tag-name=beacon-table],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-2)}}`, Su = {
  beaconTagName: "beacon-table"
}, Gk = {
  Standard: "standard"
}, Wk = ve`[beacon-tag-name=beacon-table]{--layer-base: 1;--layer-headers: calc(var(--layer-base) + 1);--layer-headers-sticky: calc(var(--layer-headers) + 1);--layer-popover: calc(var(--layer-headers-sticky) + 1);--table-thead-position: sticky;background-color:transparent}[beacon-tag-name=beacon-table][static-header]{--table-thead-position: relative;--layer-headers: auto}[beacon-tag-name=beacon-table]:is(.beacon-on-light,.beacon-on-dark){background-color:transparent}[beacon-tag-name=beacon-table] .beacon-table{box-sizing:border-box;border:inherit;color:inherit;letter-spacing:inherit;line-height:inherit;white-space:inherit;word-spacing:inherit;font-family:inherit;font-size:inherit;font-style:inherit;font-variant:inherit;font-weight:inherit;text-align:inherit;text-indent:inherit;text-transform:inherit;background-color:var(--beacon-system-color-background-1);border-collapse:separate;border-spacing:0;min-inline-size:100%;overflow-wrap:break-word;position:relative;table-layout:var(--beacon-table-layout, fixed)}[beacon-tag-name=beacon-table] .beacon-table *,[beacon-tag-name=beacon-table] .beacon-table *:after,[beacon-tag-name=beacon-table] .beacon-table *:before{box-sizing:inherit}[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-radius:var(--beacon-system-radius-corner-standard)}}[beacon-tag-name=beacon-table] .beacon-table.container-has-left-border{border-inline-start:none}[beacon-tag-name=beacon-table] .beacon-table.container-has-right-border{border-inline-end:none}[beacon-tag-name=beacon-table] .beacon-table a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-table] .beacon-table caption{background-color:var(--beacon-system-color-background-1);padding-block-end:var(--beacon-reference-space-5);text-align:start}[beacon-tag-name=beacon-table] .beacon-table thead{inset-block-start:0;position:var(--table-thead-position);z-index:var(--layer-headers)}[beacon-tag-name=beacon-table] .beacon-table :is(th,td){--cell-color: var(--beacon-system-color-text-standard);--cell-text-alignment: initial;--modern-outlook-table-cell-padding: calc(var(--beacon-component-table-space-cell) + var(--beacon-system-space-cell-contained));background-color:var(--beacon-system-color-background-1);color:var(--cell-color);padding-block:var(--modern-outlook-table-cell-padding);padding-inline:var(--modern-outlook-table-cell-padding);position:relative;text-align:var(--cell-text-alignment);vertical-align:top}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot){--divider-border-color: var(--beacon-component-table-color-border)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) :is(th,td){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) th{--cell-text-alignment: start}[beacon-tag-name=beacon-table] .beacon-table tbody th:after{border-block-end:var(--inset-divider-border);content:"";display:block;margin-block:0;margin-inline:var(--inset-divider-margin-start) var(--inset-divider-margin-end);padding-block-start:var(--inset-divider-padding-block-start)}[beacon-tag-name=beacon-table] .beacon-table thead th{--cell-background: var(--beacon-system-color-background-2);--cell-color: var(--beacon-system-color-text-standard);--divider-border-color: var(--beacon-component-table-color-border);background-color:var(--cell-background);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan]{padding-block-end:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table] .beacon-table thead th:not([colspan]),[beacon-tag-name=beacon-table] .beacon-table thead th[colspan][has-dropdown]{border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:not(:first-of-type) th,[beacon-tag-name=beacon-table] .beacon-table thead tr:first-of-type th:not(:last-of-type){border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:first-child{border-start-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:last-child{border-start-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child th:first-child{border-end-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child td:last-child{border-end-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:not(:last-of-type)>:is(th,td){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tfoot tr>:is(th,td){border-block-start-color:var(--divider-border-color);border-block-start-style:var(--border-style);border-block-start-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tr:is([data-beacon-selected]) th:first-of-type:before{background-color:var(--beacon-system-color-border-brand);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-jumbo);inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-highlighted] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-selected] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-highlighted] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-selected] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-header thead{z-index:var(--layer-headers-sticky)}[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end th,[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end td{border-block-end-color:transparent!important}[beacon-tag-name=beacon-table][multi-level] .beacon-table :is(tbody,tfoot) th{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{inset-inline-start:0;position:sticky}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th{z-index:var(--layer-base)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th:has([is-open]){z-index:var(--layer-popover)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{z-index:var(--layer-headers)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column{--sticky-cell-elevation: auto;--sticky-cell-elevation-stub: auto}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type{filter:drop-shadow(var(--sticky-cell-elevation, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end:0;filter:drop-shadow(var(--sticky-cell-elevation-stub, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub{--table-stub-floating-override-margin-inline-start: 0%}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub :is(tbody,tfoot) th{padding:0}[beacon-tag-name=beacon-table] [data-beacon-sort-state=false] [data-beacon-sort]{display:none}[beacon-tag-name=beacon-table] [data-beacon-sort]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-5);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-table] [data-beacon-sort] svg{fill:var(--beacon-system-color-icon-tertiary)}[beacon-tag-name=beacon-table] [aria-sort=ascending] [data-beacon-sort] svg:not(.ascending){display:none}[beacon-tag-name=beacon-table] [aria-sort=descending] [data-beacon-sort] svg:not(.descending){display:none}[beacon-tag-name=beacon-table] [aria-sort]:not([aria-sort=none]){background-color:var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-table] th:is(:not([aria-sort]),[aria-sort=none]) [data-beacon-sort] svg:not(.default){display:none}[beacon-tag-name=beacon-table][sortable] .beacon-table :is(td,th)[data-beacon-sorted=true]{font-weight:var(--beacon-system-font-weight-bold)}`, Vk = ve`:host{--border-style: solid;word-break:initial}.table-container{block-size:var(--beacon-custom-table-container-block-size, auto);display:var(--table-container-display, block);inline-size:var(--beacon-custom-table-container-inline-size, auto);margin-inline:var(--inline-margin, 0);overflow-x:var(--beacon-custom-table-container-overflow-x, initial);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track)}.table-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}.table-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}.table-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container.full-bleed{--inline-margin: calc(50% - 50vw) }.table-container.add-full-border{border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){.table-container.add-full-border{border-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-bottom-border{border-block-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-bottom-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-left-border{border-inline-start:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-left-border{border-end-start-radius:var(--beacon-system-radius-corner-standard);border-start-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-right-border{border-inline-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-right-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-start-end-radius:var(--beacon-system-radius-corner-standard)}}.transformed-cards{--beacon-body-font-size-100: var(--beacon-reference-space-4);--table-override-header-sort-icon-display: none;--table-override-header-wrapper-inline-size: fit-content;--table-override-stub-action-zone-right-space: 0;--table-override-stub-content-space-margin-inline-start: 0;--table-override-stub-dropdown-display: none;--table-override-header-dropdown-display: none;display:var(--transformed-cards-display, none)}.transformed-cards [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: 0;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.transformed-cards [beacon-tag-name=beacon-table-header]::part(text-cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell-wrapper){margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(action-zone){margin-inline-start:var(--beacon-reference-space-3)}.transformed-cards [beacon-tag-name=beacon-table-stub]{--stub-content-margin-inline-end: 0;--stub-content-margin-inline-start: 0}.transformed-cards [beacon-tag-name=beacon-table-stub]::part(content){padding:0}.transformed-cards [beacon-tag-name=beacon-table-header],.transformed-cards [beacon-tag-name=beacon-table-record],.transformed-cards .stub,.transformed-cards .header,.transformed-cards .record{color:var(--beacon-system-color-text-standard);font-size:var(--beacon-reference-space-4)}.transformed-cards .card{background-color:var(--beacon-system-color-background-primary);border-radius:var(--beacon-system-radius-corner-circle);display:grid;gap:var(--beacon-reference-space-5);padding:var(--beacon-reference-space-5)}.transformed-cards .card:not(:last-of-type){margin-block-end:var(--beacon-reference-space-5)}.transformed-cards .card .stub{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.transformed-cards .card-data{display:grid;font-size:var(--beacon-reference-space-3);gap:var(--beacon-reference-space-5)}.transformed-cards .card-row{padding-block-end:var(--padding-block-end)}.transformed-cards .card-row .header{flex:1;line-height:1.6}.transformed-cards .card-row .record{font-weight:var(--beacon-system-font-weight-bold);line-height:1.43}.transformed-cards .card-row:not(.grouped){align-items:center}.transformed-cards .card-row.grouped{--padding-block-end: var(--beacon-reference-space-5);display:flex;flex-direction:column}.transformed-cards .card-row:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-secondary)}.transformed-cards .card-row.single{--padding-block-end: var(--beacon-reference-space-5)}.transformed-cards .grid{display:grid;grid-template-columns:1fr 1fr}.transformed-cards .grid .record,.transformed-cards .grid [beacon-tag-name=beacon-table-record]{justify-self:end}.transformed-cards .header-children :is(.header,[beacon-tag-name=beacon-table-header]){text-indent:var(--beacon-reference-space-5)}:host([is-scrolling-block]) .table-container{block-size:calc(var(--js-component-size-block) - var(--table-space-padding) * 4)}:host([use-cards]){--table-container-display: none;--transformed-cards-display: block}:host([use-cards]) a{color:var(--beacon-system-color-text-link)}@media (width >= 640px){.table-container.full-bleed{--inline-margin: 0}:host([use-cards]){--table-container-display: block;--transformed-cards-display: none}}`;
var qk = Object.defineProperty, Yk = Object.getOwnPropertyDescriptor, Zt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Yk(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && qk(t, e, o), o;
}, wi, ki, Qn, Bi, Je, yf, xf, pn, mh, fh, wf;
const Vt = (Je = class extends Ge(Le).with($i) {
  constructor() {
    super(...arguments);
    Ie(this, pn);
    Ie(this, wi);
    Ie(this, ki);
    Ie(this, Qn);
    this.beaconTagName = Su.beaconTagName, this.deferrable = !0, this.deferOptions = { rootMargin: "3000px" }, Be(this, wi, {
      stickyStub: "has-sticky-stub-column",
      stickyHeader: "has-sticky-header",
      lightDOMTable: "beacon-table",
      floatingStub: "floating-stub"
    }), this.variant = Ll.MOVABLE, this.sortable = !1, this.useCards = !1, this.hasMultiLevel = !1, this.mobileFullBleed = !1, this.density = Gk.Standard, this.staticHeader = !1, this.scrollPositionBlock = 0, this.scrollPositionInline = 0, Be(this, Qn, !1), this.sortRows = (e) => {
      var L, D, j;
      const { target: i } = e;
      if (!i) return;
      this.mutationObserver.disconnect(), this.querySelectorAll("[aria-sort]").forEach((I) => {
        var B;
        i !== I && Ue(B = Je, Bi, fh).call(B, I, "none");
      });
      let n;
      if (i instanceof vd) {
        const I = i.parentElement, B = (L = this.table) == null ? void 0 : L.querySelector("tbody"), R = I instanceof HTMLTableCellElement;
        if (!I || !B || !R)
          return;
        const N = Je.getOrderedHeaders(this.headers);
        if (i.dropdown && i.selectedValue) {
          const y = i.selectedValue;
          n = N.map((S) => S.id).indexOf(y);
        } else
          n = N.indexOf(
            I
          );
        const x = Je.sortRowData(
          this,
          B,
          i,
          n
        );
        Je.renderSortedRows(B, x);
        const T = e.target instanceof vd ? (D = e == null ? void 0 : e.detail) == null ? void 0 : D.id : null;
        this.updateSortAttributes(T);
      } else {
        const I = i, B = (j = this.table) == null ? void 0 : j.tBodies[0];
        n = Je.getOrderedHeaders(this.headers).indexOf(
          I
        );
        const N = Je.sortRowData(
          this,
          B,
          I,
          n
        );
        Je.renderSortedRows(B, N);
      }
    }, this.mutationObserver = new MutationObserver(
      (e) => {
        if (this.useCards) {
          const i = ["table", "thead", "tbody", "tr"];
          e.forEach((o) => {
            const { target: n, type: l } = o;
            l === "childList" && (n.assignedSlot || i.includes(n.nodeName.toLowerCase())) && this.renderTransformedCards();
          });
        }
      }
    ), this.compare = (e, i) => Te(this, ki) === Xt.ASCENDING ? e.value === i.value ? 0 : typeof e.value == "number" && typeof i.value == "number" ? e.value - i.value : e.value < i.value ? -1 : 1 : Te(this, ki) === Xt.DESCENDING ? e.value === i.value ? 0 : typeof e.value == "number" && typeof i.value == "number" ? i.value - e.value : e.value > i.value ? -1 : 1 : 0;
  }
  static get styles() {
    return [super.styles, Vk];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Wk, Kk];
  }
  /**
   * Public getter for sortDirection to create a readyonly property.
   * Used by consumers overriding our `compare()` method to implement custom table sorting
   */
  get sortDirection() {
    return Te(this, ki);
  }
  get headers() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("thead th");
  }
  get stubs() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("tbody tr th:first-of-type");
  }
  get records() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("td");
  }
  get table() {
    return Za(
      this,
      "_table",
      () => this.querySelector("table")
    );
  }
  /**
   * @deprecated since version 4.3.0. Prefer to select the table using CSS.
   * It is a slotted element, so this does not need to be public.
   * @todo Remove this getter entirely in the next major version upgrade.
   */
  get slottedTable() {
    return this.table;
  }
  static getSortValue(e) {
    const { firstElementChild: i } = e;
    return i instanceof Ad ? Ue(this, Bi, yf).call(this, i) : Ue(this, Bi, xf).call(this, e);
  }
  /**
   * Iterates through a Nodelist of BeaconTableRecords and sets 'bold' prop to false.
   * Otherwise, updates the data attribute from standard table cells.
   * @param tableRecords list of Elements
   */
  static resetRecordBoldSortStyles(e) {
    e.forEach((i) => {
      i.firstElementChild instanceof Ad ? i.firstElementChild.sorted = !1 : i.dataset.beaconSorted = "false";
    });
  }
  /**
   * Sorts the `<tr>` 'rowNodes' of a `<tbody>` element. It retrieves sorting criteria from a BeaconTableHeader and sorts all records in a given column.
   * The function has several sorting exceptions for unsortable elements such as level-2 and level-3 BeaconTableStubs and their respective rows which
   * must remain directly below their parental level-1 BeaconTableStub and its row.
   * @param tableBodyElement a `<tbody>` element
   * @param tableHeaderElement a BeaconTableHeader
   * @param columnIndex index of the column where records are sorted
   * @returns a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   *
   * @todo: Need a concrete API decision for how to distinguish the different levels of stubs so native tables can account for them in sorting
   */
  static sortRowData(e, i, o, n) {
    const l = [], L = [], D = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap();
    let I = 0, B = i == null ? void 0 : i.firstElementChild, R = null, N = null, x = [];
    for (; B; ) {
      const S = B.querySelectorAll("th, td"), u = S[0].firstElementChild;
      Je.resetRecordBoldSortStyles(S);
      const A = S[n], M = A.firstElementChild;
      if (M instanceof Ad ? M.sorted = !0 : A.dataset.beaconSorted = "true", u instanceof fl && u.level === Mt.ONE || !(u instanceof fl)) {
        N && x.length && (j.set(N, [
          ...x
        ]), N = null, x = []), l.push(B);
        const f = Je.getSortValue(A), m = {
          index: I,
          columnIndex: n,
          value: f
        };
        L.push(m), I += 1;
      }
      u instanceof fl && (u.level === Mt.ONE && (R = u), u.level === Mt.TWO && R && (N = u, D.set(
        R,
        u
      )), u.level === Mt.THREE && N && x.push(u)), B = B.nextElementSibling;
    }
    N && x.length && j.set(N, [
      ...x
    ]);
    const T = {
      levelOne: D,
      levelTwo: j
    }, y = o instanceof vd ? o.compare : e.compare;
    return L.sort(y), {
      rowNodes: l,
      dataCells: L,
      tableStubMap: T
    };
  }
  /**
   * Rendering function that appends the sorted rowNode `<tr>`s to the `<tbody>`.
   * @param tableBodyElement a `<tbody>` element
   * @param sortData a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   */
  static renderSortedRows(e, i) {
    const { rowNodes: o, dataCells: n, tableStubMap: l } = i;
    !n || !o.length || n.forEach((L) => {
      var D, j;
      if (L) {
        const I = o[L.index], B = (D = I.firstElementChild) == null ? void 0 : D.firstElementChild;
        if (e == null || e.appendChild(I), B instanceof fl && B.level === Mt.ONE) {
          const R = l.levelOne.get(
            B
          ), N = (j = R == null ? void 0 : R.parentElement) == null ? void 0 : j.parentElement;
          if (R && N) {
            e == null || e.appendChild(N);
            const x = l.levelTwo.get(R);
            x && x.length && x.forEach(
              (T) => {
                var S;
                const y = (S = T.parentElement) == null ? void 0 : S.parentElement;
                y && (e == null || e.appendChild(
                  y
                ));
              }
            );
          }
        }
      }
    });
  }
  /**
   * A function that takes a NodeList of header TableCellElements sifts through them in search of nested headers.
   * When it finds nestedHeaders it splices them in the appropriate column order so that each header's index matches
   * its corresponding column of tableRecords.
   * @param headersNodeList a Nodelist of `<th>`'s
   * @returns sorted array of headers.
   */
  static getOrderedHeaders(e) {
    const i = [], o = {};
    e == null || e.forEach((n) => {
      n instanceof HTMLTableCellElement && (n.headers ? o[n.headers] ? o[n.headers].push(n) : o[n.headers] = [n] : i.push(n));
    });
    for (const [n, l] of Object.entries(o)) {
      const L = i.map((D) => D.id).indexOf(n);
      i.splice(L, 1, ...l);
    }
    return i;
  }
  /** Attribute triggers vertical-divider styles for `<th>` elements in `<tbody>` in multi-level stub context. */
  _setMultiLevelAttribute() {
    this.toggleAttribute("multi-level", this.hasMultiLevel);
  }
  // this is called by table stubs
  _setMultiLevel(e) {
    this.hasMultiLevel = e;
  }
  /** Receive scroll events on the component and set scroll position states. */
  captureScrollPosition(e) {
    var l, L, D;
    const { target: i } = e, { scrollLeft: o, scrollTop: n } = i;
    if (this.scrollPositionInline = o, this.scrollPositionBlock = n, this.variant === Ll.FLOATING) {
      const j = (L = (l = this.table) == null ? void 0 : l.querySelector("thead th")) == null ? void 0 : L.clientWidth, I = Math.abs(this.scrollPositionInline) + "px";
      this.style.setProperty(
        "--table-stub-floating-override-inset-inline-start",
        I
      ), j && j * 0.8 < this.scrollPositionInline ? this.table.classList.add(Te(this, wi).floatingStub) : (D = this.table) == null || D.classList.remove(Te(this, wi).floatingStub);
    }
    this.variant === Ll.FIXED && bu(
      this.scrollPositionInline,
      this.table,
      Te(this, wi).stickyStub
    ), bu(
      this.scrollPositionBlock,
      this.table,
      Te(this, wi).stickyHeader
    ), this.updateTableBorders();
  }
  getTableAndContainerRects() {
    var R, N, x;
    const e = (N = (R = this.table) == null ? void 0 : R.getBoundingClientRect()) != null ? N : new DOMRect(), i = this.tableContainer.getBoundingClientRect(), o = e.top - i.top, n = e.left - i.left, l = e.right - i.right, L = e.bottom, j = i.bottom - L, I = (x = this.table) == null ? void 0 : x.querySelector("caption");
    let B = 0;
    return I && (B = I.getBoundingClientRect().top - i.top), {
      tableRect: e,
      containerRect: i,
      tableDistanceFromContainerTop: o,
      tableDistanceFromContainerLeft: n,
      tableDistanceFromContainerRight: l,
      distanceFromContainerBottom: j,
      captionElement: I,
      captionDistanceFromContainerTop: B
    };
  }
  addContainerLeftRightBorders({
    tableDistanceFromContainerLeft: e,
    tableDistanceFromContainerRight: i
  }) {
    var o, n;
    this.tableContainer.classList.toggle(
      "add-left-border",
      e < 0
    ), (o = this.table) == null || o.classList.toggle(
      "container-has-left-border",
      e < 0
    ), this.tableContainer.classList.toggle(
      "add-right-border",
      i >= 0
    ), (n = this.table) == null || n.classList.toggle(
      "container-has-right-border",
      i >= 0
    );
  }
  /**
   * Updates the table borders based on the table and container bounding rectangles
   */
  updateTableBorders() {
    var B, R, N, x, T, y, S, u, A;
    const {
      containerRect: e,
      tableDistanceFromContainerTop: i,
      tableDistanceFromContainerLeft: o,
      tableDistanceFromContainerRight: n,
      captionElement: l,
      captionDistanceFromContainerTop: L
    } = this.getTableAndContainerRects(), D = (R = (B = this.table) == null ? void 0 : B.querySelector("thead")) == null ? void 0 : R.getBoundingClientRect(), j = (x = (N = this.table) == null ? void 0 : N.querySelector("tbody")) == null ? void 0 : x.getBoundingClientRect(), I = D ? D.top - e.top : j ? j.top - e.top : 0;
    l ? (L <= 0 && I === 0 && (this.tableContainer.classList.contains("add-full-border") || this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (T = this.table) != null && T.classList.contains("container-has-border") || (y = this.table) == null || y.classList.add("container-has-border")), L <= 0 && I > 1 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (S = this.table) == null || S.classList.remove("container-has-border"))) : (I <= 0 && i < 0 && (this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (u = this.table) == null || u.classList.add("container-has-border")), i >= 0 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (A = this.table) == null || A.classList.remove("container-has-border"))), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: o,
      tableDistanceFromContainerRight: n
    });
  }
  /** Adds a bottom, left or right border to the table container on initial load if the table overflows. */
  addContainerBorders() {
    const {
      distanceFromContainerBottom: e,
      tableDistanceFromContainerLeft: i,
      tableDistanceFromContainerRight: o
    } = this.getTableAndContainerRects();
    e < 0 && this.tableContainer.classList.add("add-bottom-border"), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: i,
      tableDistanceFromContainerRight: o
    });
  }
  /** Handler to render transformed cards when table is resized to mobile view. */
  _handleBreakpointChanges() {
    !this.isMediumBreakpoint && this.useCards && (this.renderTransformedCards(), this.table && this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    }));
  }
  /**
   * Creates content for the cards from the stub, header, or record parent elements.
   * @param start Element to use as the reference node
   * @param type The type of component the final result is, such as 'stub' or 'header' or 'record'
   * @returns A new element made from the children of the starting element
   */
  static generateCardContent(e, i) {
    const o = document.createElement("div"), n = Array.from(
      e.childNodes,
      (D) => D.cloneNode(!0)
    );
    n && o.append(...n);
    const l = _i(), L = "uuid";
    return e.setAttribute(L, l), o.setAttribute(L, l), o.classList.add(i), o;
  }
  /**
   * Clones a Beacon Table Cell and changes its state.
   * @param component Beacon Table component to be cloned
   * @returns Clone of the node with its state changed
   */
  static cloneComponent(e) {
    const i = e.cloneNode(!0);
    return i.isOriginal = !1, i;
  }
  /** For mobile card view, iterate over all child components and clone them into cards. */
  async renderTransformedCards() {
    await this.updateComplete;
    const e = "stub", i = "header", o = "record", n = No(
      this.stubs,
      (l) => {
        if (!this.records) return;
        const L = Array.from(this.records).filter(
          (I) => {
            var B;
            return (B = l.parentNode) == null ? void 0 : B.contains(I);
          }
        ), D = l.querySelector(
          this.getScopedTagName("beacon-table-stub")
        ), j = D ? Je.cloneComponent(D) : Je.generateCardContent(l, e);
        return pe`
          <div class="card">
            ${j}
            <div class="card-data">
              ${No(
          this.headers,
          (I, B) => {
            if (!this.records || B === 0) return;
            let R = pe``, N = "single grid", x;
            const T = Array.from(this.records).filter(
              (f) => Aw(f) === I
            );
            if (!T) return R;
            const y = T.find(
              (f) => L.includes(f)
            );
            if (!y) return R;
            const u = hh(
              I,
              !1,
              !1,
              ["th"]
            ), A = I.querySelector(
              this.getScopedTagName("beacon-table-header")
            ), M = A ? Je.cloneComponent(A) : Je.generateCardContent(I, i);
            if (u && u.length > 0)
              N = "grouped", R = pe`${M}
                    ${No(
                u,
                (f, m) => {
                  const C = L.indexOf(y) + m, F = L[C], _ = f.querySelector(
                    this.getScopedTagName("beacon-table-header")
                  ), E = _ ? Je.cloneComponent(_) : Je.generateCardContent(
                    f,
                    i
                  ), v = F.querySelector(
                    this.getScopedTagName("beacon-table-record")
                  );
                  return x = v ? Je.cloneComponent(v) : Je.generateCardContent(
                    F,
                    o
                  ), pe`
                          <div class="header-children grid">
                            ${E} ${x}
                          </div>
                        `;
                }
              )} `;
            else {
              const f = y.querySelector(
                this.getScopedTagName("beacon-table-record")
              );
              x = f ? Je.cloneComponent(f) : Je.generateCardContent(
                y,
                o
              ), R = pe` ${M} ${x} `;
            }
            return pe`
                    <div class="card-row ${N}">${R}</div>
                  `;
          }
        )}
            </div>
          </div>
        `;
      }
    );
    Ws(n, this._transformedCardsContainer), Fe(this, Ee.RENDER_TABLE_CARDS), this.triggerRecordActionZoneStatus();
  }
  /**
   * Manually calls `setActionZoneStatus` on each BeaconTableRecord component in the cards to make sure the slot area is visible or hidden as needed.
   */
  async triggerRecordActionZoneStatus() {
    this._transformedCardsContainer.querySelectorAll(
      this.getScopedTagName("beacon-table-record")
    ).forEach(
      async (i) => {
        await i.updateComplete, i.setActionZoneStatus();
      }
    );
  }
  _handleCardChanges() {
    this.isMobile && this.useCards && this.renderTransformedCards();
  }
  _handleSortChanges() {
    this.sortable ? Ue(this, pn, wf).call(this) : Ue(this, pn, mh).call(this);
  }
  /**
   * This updates sort-inactive attributes on all BeaconTableHeaders except the one that triggered the sort event.
   * @param targetId Id of BeaconTableHeader that triggered the sort event
   */
  updateSortAttributes(e) {
    var o;
    const i = this.querySelectorAll(
      this.getScopedTagName("beacon-table-header")
    );
    for (const n of i)
      ((o = n.parentElement) == null ? void 0 : o.id) !== e && n.resetSortedAttr();
  }
  // Not using @prerender here because table needs to be able to sort in defer-until=visible context.
  connectedCallback() {
    setTimeout(
      () => this.addEventListener(
        Ee.SORT,
        this.sortRows
      ),
      100
    ), super.connectedCallback();
  }
  async firstUpdated() {
    this.table && (this.table.classList.add(Te(this, wi).lightDOMTable), await this.updateComplete, this.useCards && this.isMobile && (this.renderTransformedCards(), this.mutationObserver.observe(this.table, {
      childList: !0,
      characterData: !0,
      subtree: !0
    })), this.addContainerBorders()), super.firstUpdated();
  }
  render() {
    return pe`
      <div class="transformed-cards"></div>
      <div
        class="table-container ${this.mobileFullBleed ? "full-bleed" : "contained"}"
        tabindex=${Ja()}
        @scroll=${this.captureScrollPosition}>
        <slot></slot>
      </div>
    `;
  }
}, wi = new WeakMap(), ki = new WeakMap(), Qn = new WeakMap(), Bi = new WeakSet(), yf = function(e) {
  const { variant: i, sortValue: o } = e;
  return o && (i === xi.NUMERAL || i === xi.DATE) ? parseFloat(o) : o;
}, xf = function(e) {
  var L;
  const {
    innerText: i,
    dataset: { beaconSortValue: o, beaconSortType: n }
  } = e, l = (L = i == null ? void 0 : i.toLowerCase().trim()) != null ? L : "";
  return n === "number" ? parseFloat(o || l) : o != null ? o : l;
}, pn = new WeakSet(), /** Updates the sort state for sortable headers that aren't a BeaconTableHeader. */
mh = function() {
  const e = this.querySelectorAll(
    "[data-beacon-sort-state]"
  );
  for (const i of e)
    i.dataset.beaconSortState = String(this.sortable);
}, fh = function(e, i) {
  const o = e.querySelector("[data-beacon-sort]"), n = o == null ? void 0 : o.querySelector(".sort-text");
  if (n) {
    switch (i) {
      case "ascending":
      case "descending":
        n.innerHTML = `Sorted ${i}`;
        break;
      case "none":
        n.innerHTML = "Sort";
        break;
    }
    e.setAttribute("aria-sort", i);
  }
}, wf = function() {
  if (Ue(this, pn, mh).call(this), Te(this, Qn)) return;
  const e = this.querySelector("thead"), i = e == null ? void 0 : e.querySelectorAll("th"), o = document.createElement("template");
  o.innerHTML = `
      <style>
        .base {
          display: grid;
          grid-template-columns: 1fr auto;
        }
      </style>
      <div class="base">
        <div class="default-slot"><slot></slot></div>
        <div class="sort-row"><slot name="sort"></slot></div>
      </div>
    `, i == null || i.forEach((n) => {
    if (!("beaconSortable" in n.dataset)) return;
    const l = document.createElement("div");
    l.dataset.beaconSortState = String(this.sortable), n.childNodes.forEach(
      (B) => l.appendChild(B)
    ), n.appendChild(l), l.attachShadow({ mode: "open" }).appendChild(
      o.content.cloneNode(!0)
    );
    const D = document.createElement("template");
    D.innerHTML = `
        <${this.getScopedTagName("beacon-icon-button")} slot="sort" variant="tertiary" data-beacon-sort>
          <svg data-metrics-link-text="Sort ascending" class="ascending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z"/>
          </svg>
          <svg data-metrics-link-text="Sort descending" class="descending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
            />
          </svg>
          <svg class="default" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" />
          </svg>
          <span class="sort-text">Sort</span>
        </${this.getScopedTagName("beacon-icon-button")}>
        `;
    const j = D.content.cloneNode(!0);
    l.appendChild(j);
    const I = l.querySelector(
      this.getScopedTagName("beacon-icon-button")
    );
    I == null || I.addEventListener(Ee.CLICK, () => {
      var B;
      Be(this, ki, Te(this, ki) === Xt.ASCENDING ? Xt.DESCENDING : Xt.ASCENDING), Ue(B = Je, Bi, fh).call(B, n, Te(this, ki)), Fe(n, Ee.SORT);
    });
  }), Be(this, Qn, !0);
}, Ie(Je, Bi), Je.tagName = Su.beaconTagName, Je.nestedComponents = [Qt], Je);
Zt([
  ue({ reflect: !0 })
], Vt.prototype, "variant", 2);
Zt([
  ue({ type: Boolean })
], Vt.prototype, "sortable", 2);
Zt([
  ue({ type: Boolean, attribute: "use-cards" })
], Vt.prototype, "useCards", 2);
Zt([
  Ce()
], Vt.prototype, "hasMultiLevel", 2);
Zt([
  ue({ attribute: "mobile-full-bleed", type: Boolean })
], Vt.prototype, "mobileFullBleed", 2);
Zt([
  ue({ reflect: !0 })
], Vt.prototype, "density", 2);
Zt([
  ue({ attribute: "static-header", type: Boolean, reflect: !0 })
], Vt.prototype, "staticHeader", 2);
Zt([
  Ce()
], Vt.prototype, "scrollPositionBlock", 2);
Zt([
  Ce()
], Vt.prototype, "scrollPositionInline", 2);
Zt([
  We(".table-container")
], Vt.prototype, "tableContainer", 2);
Zt([
  We(".transformed-cards")
], Vt.prototype, "_transformedCardsContainer", 2);
Zt([
  Gt("hasMultiLevel")
], Vt.prototype, "_setMultiLevelAttribute", 1);
Zt([
  Gt("isMediumBreakpoint")
], Vt.prototype, "_handleBreakpointChanges", 1);
Zt([
  Gt("useCards")
], Vt.prototype, "_handleCardChanges", 1);
Zt([
  Gt("sortable")
], Vt.prototype, "_handleSortChanges", 1);
let Xk = Vt;
var kf = /* @__PURE__ */ ((a) => (a.HORIZONTAL = "row", a.VERTICAL = "column", a))(kf || {}), Cf = /* @__PURE__ */ ((a) => (a.CENTER = "center", a.LEFT = "left", a.RIGHT = "right", a))(Cf || {}), Sf = /* @__PURE__ */ ((a) => (a.BOTTOM = "bottom", a.TOP = "top", a.MIDDLE = "middle", a))(Sf || {});
Sf.TOP, Cf.CENTER, kf.HORIZONTAL;
const Qk = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, Zk = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, Jk = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, eC = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, tC = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, oC = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`;
pe` <beacon-table id="datatable">
  <table>
    <thead>
      <tr>
        <th>Year</th>
        <th>Company A</th>
        <th>Company B</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>2016</th>
        <td>30386</td>
        <td>28504</td>
      </tr>
      <tr>
        <th>2017</th>
        <td>29173</td>
        <td>27460</td>
      </tr>
      <tr>
        <th>2018</th>
        <td>28430</td>
        <td>26690</td>
      </tr>
      <tr>
        <th>2019</th>
        <td>28042</td>
        <td>26453</td>
      </tr>
      <tr>
        <th>2020</th>
        <td>27063</td>
        <td>25916</td>
      </tr>
      <tr>
        <th>2021</th>
        <td>28684</td>
        <td>27376</td>
      </tr>
    </tbody>
  </table>
</beacon-table>`;
const qi = {
  multiLevel: Qk,
  circle: Zk,
  triangle: oC,
  square: eC,
  diamond: Jk,
  triangleDown: tC
};
function iC(a) {
  const t = [...Object.values(na)], e = a % t.length;
  return t[e];
}
function xd(a, t, e) {
  if (t)
    return qi.multiLevel;
  const i = [
    $t.LINE,
    $t.SCATTER,
    $t.AREA
  ];
  if (e && i.includes(e))
    switch (iC(a)) {
      case na.CIRCLE:
        return qi.circle;
      case na.TRIANGLE:
        return qi.triangle;
      case na.SQUARE:
        return qi.square;
      case na.DIAMOND:
        return qi.diamond;
      case na.TRIANGLE_DOWN:
        return qi.triangleDown;
      default:
        return qi.circle;
    }
  else
    return qi.circle;
}
const vl = ve`[beacon-tag-name$=chart] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}[beacon-tag-name$=chart] [slot=subtitle],[beacon-tag-name$=chart] [slot=caption]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}.highcharts-tooltip-container{z-index:1200!important}.highcharts-tooltip-container svg{max-inline-size:unset}.beacon-chart-tooltip{background-color:var(--beacon-system-color-background-1);color:var(--beacon-system-color-text-standard);fill:var(--beacon-system-color-background-1)}.beacon-chart-tooltip .highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.beacon-chart-tooltip .highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.beacon-chart-tooltip .highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.beacon-chart-tooltip .highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.beacon-chart-tooltip .highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.beacon-chart-tooltip .highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.beacon-chart-tooltip .highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.beacon-chart-tooltip .highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.beacon-chart-tooltip .highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.beacon-chart-tooltip .highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.beacon-chart-tooltip .highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.beacon-chart-tooltip .highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.negative{fill:var(--beacon-reference-palette-functional-red-3);stroke:var(--beacon-reference-palette-functional-red-3)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.positive{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}.beacon-chart-tooltip__title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.beacon-chart-tooltip__point,.beacon-chart-tooltip-point__label{align-items:center;display:flex}.beacon-chart-tooltip__point{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);gap:var(--beacon-reference-space-3)}.beacon-chart-tooltip__point:not(:first-of-type){margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip__separator{border:0;border-block-start-color:var(--beacon-system-color-icon-primary-inactive);border-block-start-style:solid;border-block-start-width:var(--beacon-system-width-border-mini)}.beacon-chart-tooltip__point--multi-level .beacon-legend-item__icon{fill:var(--beacon-system-color-icon-primary-inactive)}.beacon-chart-tooltip__footer,.beacon-chart-tooltip__additional-content{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip-point__label{gap:var(--beacon-reference-space-4)}.beacon-chart-tooltip__point-value{font-weight:var(--beacon-system-font-weight-bold)}`, aC = ve`*{margin:0;padding:0}:host{--component-background-color: transparent;--component-gap-space: var(--beacon-system-space-micro-jumbo);background-color:var(--component-background-color)}.base{padding-block:var(--beacon-reference-space-3)}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.header{margin-block-end:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.caption{margin-block-start:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.highcharts-background{fill:var(--component-background-color)}.highcharts-focus-border{stroke:var(--beacon-system-color-border-focus-outer);stroke-width:var(--beacon-system-width-border-jumbo)}.highcharts-container{color:inherit;font-family:inherit}.highcharts-container :not(.highcharts-tooltip,.highcharts-tooltip-box,.highcharts-button)>text{fill:currentcolor}.highcharts-legend-item .highcharts-focus-border{display:none}.highcharts-legend-navigation{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}.highcharts-legend-nav-active{fill:var(--beacon-system-color-icon-secondary)}.highcharts-legend-nav-inactive{fill:var(--beacon-system-color-icon-secondary-inactive)}.beacon-legend-item{--background-color: var(--beacon-system-color-background-1);--legend-item-padding: var(--beacon-system-space-cell-contained);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;background-color:var(--background-color);border-color:transparent;border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-normal, 2px);display:flex;gap:var(--beacon-reference-space-3);padding:var(--legend-item-padding)}.beacon-legend-item .beacon-legend-item__label{align-items:center;display:flex;gap:var(--beacon-reference-space-4)}.beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.beacon-legend-item.beacon-legend-item--hover .beacon-legend-item__label-text{text-decoration:underline}.beacon-legend-item.beacon-legend-item--focus{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.beacon-legend-item.beacon-legend-item--focus:not(dialog){position:relative}.beacon-legend-item .beacon-legend-item__value{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-legend-item-hidden *{text-decoration:none}.highcharts-legend-item-hidden .beacon-legend-item{--background-color: transparent}.highcharts-legend-item-hidden .beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.static-legend .highcharts-legend{pointer-events:none}.static-legend .highcharts-a11y-proxy-group-legend button{cursor:default;pointer-events:none}.static-legend .beacon-legend-item{--background-color: transparent;--legend-item-padding: 0;border-radius:0}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-inline-end:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-inline-start:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-block-start:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-10)}@media (width >= 640px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-11)}}@media (width >= 960px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-13)}}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var nC = Object.defineProperty, rC = Object.getOwnPropertyDescriptor, Dt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? rC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && nC(t, e, o), o;
};
const sC = ["top", "middle", "bottom"], lC = ["center", "right"], cC = ["horizontal", "vertical"];
function dC(a) {
  return typeof a.legendWidth == "number";
}
function hC(a) {
  return typeof a.maxLegendWidth == "number";
}
function Eu(a) {
  return a.a11yProxyElement !== void 0;
}
function Mu(a) {
  return a.a11yProxyElement !== void 0;
}
var Ve;
const kt = (Ve = class extends Le {
  constructor() {
    super(...arguments), this.resetSpacing = !0, this._type = $t.LINE, this.series = [], this.options = {}, this.staticLegend = !1, this.disableLegend = !1, this.hideLegendMetric = !1, this.legendLayout = Ve.defaultLegendLayout, this.tooltipTitle = "", this.tooltipFooter = "", this.tooltipVariant = Wr.SINGLE_LINE, this.disableMarkers = !1, this.percentage = !1, this.decimal = !1, this.decimalPlaces = 1, this.chart = null, this.filteredOptions = {}, this.colorOrder = mi.STANDARD;
  }
  static get styles() {
    return [super.styles, VA, aC];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, vl];
  }
  /**
   * The type of chart being rendered. Follows Highcharts chart types.
   * @abstract
   */
  get type() {
    return this._type;
  }
  /**
   * Local options defined on the component-level.
   * @abstract
   */
  get localComponentOptions() {
    return {};
  }
  /**
   * This getter ensures that the chart type is included in the series data
   * when it's passed to highcharts. This ensures that data passed to highcharts
   * is type-safe for users in TS contexts.
   */
  get seriesWithChartType() {
    return this.series.map((t) => ({
      ...t,
      type: this.type
    }));
  }
  /**
   * Global chart options applicable to all charts.
   */
  get chartOptions() {
    const t = this.hideLegendMetric, e = this.percentage, i = this.decimal, o = this.decimalPlaces, n = this.type, l = this.addBeaconModeToTooltipContainer.bind(this);
    return {
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      },
      chart: {
        animation: !1,
        colorCount: 12,
        events: {
          /**
           * @this Chart
           *
           * On redraw, we assign styles and classes to the legend items so they can match our design spec.
           * Since we use custom HTML in the formatter, this is not captured on a persistant basis by Highcharts.
           */
          redraw() {
            var L, D, j;
            if ("hasLoaded" in this && this.hasLoaded) {
              const I = (j = (D = (L = this.userOptions) == null ? void 0 : L.plotOptions) == null ? void 0 : D.custom) == null ? void 0 : j.host;
              if (I && I.staticLegend)
                return !1;
              const { allItems: B } = this.legend;
              B.forEach((R) => {
                if (R instanceof yi.Point && Eu(R) || R instanceof yi.Series && Mu(R)) {
                  const {
                    a11yProxyElement: {
                      target: { visual: N }
                    }
                  } = R;
                  if (I == null || I.style.setProperty(
                    "--legend-max-width",
                    N.style.getPropertyValue("width")
                  ), N.dataset.beaconRedrawEvent !== "attached") {
                    const x = N.firstElementChild;
                    N.addEventListener(
                      "mouseover",
                      (T) => {
                        x == null || x.classList.add(
                          "beacon-legend-item--hover"
                        ), (!T.x || !T.y) && (x == null || x.classList.add(
                          "beacon-legend-item--focus"
                        ));
                      }
                    ), N.addEventListener("mouseout", () => {
                      B.forEach((T) => {
                        var y;
                        if (T instanceof yi.Point && Eu(T) || T instanceof yi.Series && Mu(T)) {
                          const {
                            a11yProxyElement: {
                              target: { visual: S }
                            }
                          } = T;
                          (y = S == null ? void 0 : S.firstElementChild) == null || y.classList.remove(
                            "beacon-legend-item--hover",
                            "beacon-legend-item--focus"
                          );
                        }
                      });
                    });
                  }
                  N.dataset.beaconRedrawEvent = "attached", Ve.setLegendWidthVariable(this);
                }
              });
            }
            this.reflow();
          }
        },
        // Highcharts default is 400
        // Previous version of Charts didn't take Legend height into account
        // We increase the default height to counteract a possible squished chart
        height: _l.HEIGHT,
        styledMode: !0,
        type: this.type
      },
      credits: {
        enabled: !1
      },
      legend: {
        accessibility: {
          keyboardNavigation: {
            enabled: !this.staticLegend
          }
        },
        align: "center",
        alignColumns: !1,
        enabled: !this.disableLegend,
        labelFormatter() {
          return Ve.legendItemHTML(
            this,
            t,
            e,
            n,
            i,
            o
          );
        },
        itemDistance: parseFloat(Jd) * 16,
        itemMarginBottom: parseFloat(Jd) * 16,
        itemMarginTop: 0,
        layout: this.legendLayout.direction,
        navigation: {
          enabled: !1
        },
        symbolRadius: 0,
        symbolPadding: 0,
        symbolWidth: 0,
        useHTML: !0,
        verticalAlign: "bottom",
        width: "100%",
        events: {
          /**
           * @this Series
           *
           * We reverse click interaction on legend items. Instead of toggling off, we toggle isolation and "on" state.
           */
          itemClick: function(L) {
            var N, x, T;
            L.preventDefault();
            const { chart: D } = this, j = (T = (x = (N = D == null ? void 0 : D.userOptions) == null ? void 0 : N.plotOptions) == null ? void 0 : x.custom) == null ? void 0 : T.host;
            if (j && j.staticLegend)
              return !1;
            const { series: I } = D, B = I.filter((y) => y.visible).length === I.length, R = I.find(
              (y) => L.legendItem instanceof yi.Series && y.name === L.legendItem.name
            );
            R && (I.length > 1 && B ? I.forEach((y) => {
              L.legendItem instanceof yi.Series && y.update(
                {
                  visible: y.name === L.legendItem.name
                },
                !1
              );
            }) : R.update(
              {
                visible: !R.visible
              },
              !1
            ), D.redraw(), D.reflow());
          }
        }
      },
      plotOptions: {
        custom: {
          host: this
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              minWidth: parseInt($h, 10)
            },
            chartOptions: {
              legend: {
                align: this.legendLayout.horizontal,
                // center, right
                verticalAlign: Ve.setLegendVerticalAlignment(
                  this.legendLayout
                ),
                width: Ve.setLegendWidth(this.legendLayout)
              }
            }
          }
        ]
      },
      series: this.seriesWithChartType,
      subtitle: {
        text: void 0
      },
      symbols: [...Object.values(na)],
      title: {
        text: void 0
      },
      tooltip: {
        borderRadius: parseFloat(wA) * 16,
        className: this.getTooltipClasses(),
        footerFormat: Ve.tooltipFooterHTML(
          Ve.tooltipFooterContentHTML(this.tooltipFooter)
        ),
        headerFormat: Ve.tooltipHeaderHTML(this.tooltipTitle),
        outside: !0,
        padding: Ve.tooltipPadding(this.tooltipVariant),
        pointFormatter() {
          return l(), Ve.tooltipPointHTML(
            this,
            this.series.name,
            this.y,
            !1,
            n
          );
        },
        shadow: {
          color: xA
        },
        shared: this.tooltipVariant === Wr.MULTI_LINE,
        useHTML: !0
      }
    };
  }
  /**
   * Adds a beacon mode class to the Highcharts tooltip container.
   */
  addBeaconModeToTooltipContainer() {
    const t = this.closest('[class*="beacon-on"]');
    setTimeout(() => {
      const e = document.querySelector(
        ".highcharts-tooltip-container"
      );
      if (e && t) {
        const i = Array.from(e.classList).find(
          (n) => n.startsWith("beacon-on")
        ), o = Array.from(
          t.classList
        ).find((n) => n.startsWith("beacon-on"));
        i !== o && (i && e.classList.remove(i), o && e.classList.add(o));
      }
    }, 0);
  }
  /** Parses the legend layout from a string of options. */
  static createLegendLayout(t) {
    if (!t)
      return this.defaultLegendLayout;
    const e = af(t);
    if (!e)
      return this.defaultLegendLayout;
    const i = e.find(
      (l) => sC.includes(l)
    ) || this.defaultLegendLayout.vertical, o = e.find(
      (l) => lC.includes(l)
    ) || this.defaultLegendLayout.horizontal;
    let n = e.find(
      (l) => cC.includes(l)
    ) || this.defaultLegendLayout.direction;
    return e.includes("row") ? n = "horizontal" : e.includes("column") && (n = "vertical"), {
      vertical: i,
      horizontal: o,
      direction: n
    };
  }
  /**
   * Sets a CSS variable on the host that helps control the width of the legend items in a vertical state.
   *
   * Takes into account the active and max widths of the Legend, as well as what direction the Legend is in.
   */
  static setLegendWidthVariable(t, e = !1) {
    var R, N, x, T, y, S, u, A;
    const i = (N = (R = t.legend) == null ? void 0 : R.options) == null ? void 0 : N.layout, o = (T = (x = t.legend) == null ? void 0 : x.options) == null ? void 0 : T.align, n = dC(t.legend) ? t.legend.legendWidth : 0, l = hC(t.legend) ? (y = t.legend) == null ? void 0 : y.maxLegendWidth : 0, L = Math.min(l, n), D = (A = (u = (S = t.userOptions) == null ? void 0 : S.plotOptions) == null ? void 0 : u.custom) == null ? void 0 : A.host, j = D == null ? void 0 : D.style.getPropertyValue("--legend-width");
    e && (D == null || D.style.removeProperty("--legend-width"));
    let I = "auto", B;
    i === "vertical" && (B = L, j && (D == null || D.style.setProperty("--legend-width", B + "px")), j && o === "right" ? I = j : I = B ? B + "px" : "auto"), D == null || D.style.setProperty("--legend-width", I);
  }
  /** HTML for the Legend label. */
  static legendItemHTML(t, e, i, o, n, l) {
    var I, B;
    const { name: L, index: D } = t;
    let j = "";
    if (o === $t.GAUGE && !e) {
      const R = ((I = t == null ? void 0 : t.data[0]) == null ? void 0 : I.y) != null && t.yAxis.userOptions.min != null ? t.data[0].y - t.yAxis.userOptions.min : (B = t == null ? void 0 : t.data[0]) == null ? void 0 : B.y, N = t.yAxis.userOptions.max != null && t.yAxis.userOptions.min != null ? t.yAxis.userOptions.max - t.yAxis.userOptions.min : t.yAxis.userOptions.max;
      j = `<span class="beacon-legend-item__value">${Ve.percentageFormatter(i, R, N, n, l)}</span>`;
    }
    return o === $t.PIE && !e && (j = `<span class="beacon-legend-item__value">${Ve.percentageFormatter(i, t.y, t.total, n, l)}</span>`), o === $t.MAP && !e && (j = `<span class="beacon-legend-item__value">${t.value}</span>`), `
      <div class="beacon-legend-item beacon-legend-item--${D}" style="inline-size: var(--legend-width); max-inline-size: var(--legend-max-width, none);">
        <div class="beacon-legend-item__label">
          ${xd(D, !1, o)}
          <span class="beacon-legend-item__label-text">${L}</span>${j}
        </div>
      </div>
    `;
  }
  /** Forces Legend vertical alignment if necessary, but otherwise will return the requested value. */
  static setLegendVerticalAlignment({
    horizontal: t,
    vertical: e
  }) {
    return t === "center" ? "bottom" : e;
  }
  /** Set the width of the Legend which depends on both alignment and direction. */
  static setLegendWidth({
    horizontal: t,
    vertical: e,
    direction: i
  }) {
    if (i === "horizontal" && e !== "middle")
      return "100%";
    if (i === "vertical")
      return t === "center" ? "100%" : "33%";
  }
  /** HTML classes for the tooltip's elements. */
  getTooltipClasses() {
    return `beacon-chart-tooltip ${this.tooltipVariant} ${this.colorOrder}`.trim();
  }
  /** Sets the padding on the Tooltip based on variant. */
  static tooltipPadding(t) {
    const e = parseFloat(EA), i = parseFloat(
      yA
    );
    let o = e;
    return t !== Wr.SINGLE_LINE && (o = e + i), o * 16;
  }
  /**
   * HTML for the chart tooltip point.
   *
   * Can be used as a helper method for overrides to the point formatter.
   *
   * @example
   * ```ts
   * // Format the value before passing it to the tooltip.
   *
   * const options = {
   *   tooltip: {
   *    pointFormatter() {
   *      const { y } = this;
   *      const percentage = y / 100;
   *
   *      return BeaconChartBase.tooltipPointHTML(this, this.series.name, percentage);
   *    }
   *   }
   * }
   * ```
   */
  static tooltipPointHTML(t, e, i, o, n) {
    let l;
    return i && Number(i) < 0 ? l = "negative" : l = "positive", `
      <div class="beacon-chart-tooltip__point highcharts-color-${t.colorIndex} ${l}">
        <div class="beacon-chart-tooltip-point__label">
          ${o ? "" : xd(t.colorIndex || 0, !1, n)}
          <span class="beacon-chart-tooltip-point__label-text">${e}</span>
        </div>
        ${i ? `<div class="beacon-chart-tooltip__point-value">${i}</div>` : ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Title (Header). */
  static tooltipHeaderHTML(t) {
    return t ? `<div class="beacon-chart-tooltip__title">${t}</div>` : "";
  }
  /** HTML for the Tooltip's additional content slot (Footer). */
  static tooltipFooterContentHTML(t) {
    return t ? `<div class="beacon-chart-tooltip__additional-content">${t}</div>` : "";
  }
  /** HTML for the Tooltip footer that can include both multi-level content and the additional slot content. */
  static tooltipFooterHTML(t, e) {
    return !t && !e ? "" : `
      <div class="beacon-chart-tooltip__footer">
        ${e ? `<hr class="beacon-chart-tooltip__separator"/>${e}` : ""}
        ${t || ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Point belonging to multi-level tooltips. */
  static multiLevelTooltipPointHTML(t, e, i) {
    return `
      <div class="beacon-chart-tooltip__point beacon-chart-tooltip__point--multi-level">
        <div class="beacon-chart-tooltip-point__label">
          ${i ? "" : xd(0, !0)}
          <span class="beacon-chart-tooltip-point__label-text">${t}</span>
        </div>
        ${e ? `<div class="beacon-chart-tooltip__point-value">${e}</div>` : ""}
      </div>
    `;
  }
  /** Modify user-supplied options by filtering out keys not leveraged or not accessible by our component. */
  static filterChartOptions(t) {
    return H1(t, (e, i) => !this.disallowedChartOptions.includes(i));
  }
  /** Merge all possible chart options into a single object. */
  static createChartOptions(...t) {
    return _1(
      {},
      ...t,
      function(e, i) {
        if (ko(e))
          return e.concat(i);
      }
    );
  }
  /** Update Highcharts accessibility data when the caption changes. */
  handleCaptionSlotchange() {
    var t;
    (t = this.chart) == null || t.update({
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      }
    });
  }
  /**
   * Apply modifications and modules to the Highcharts package.
   *
   * @todo Exhaust any options for API-styling before DOM manipulation. Keep in mind the symbol is separate from the button of the text label.
   */
  initializeHighcharts(t) {
    t.AST.allowedAttributes.push("transform", "viewbox", "viewBox", "xmlns"), YA(t), t.addEvent(t.Legend, "afterRender", function() {
      "hasLoaded" in this.chart && this.chart.hasLoaded && (this.chart.reflow(), Ve.setLegendWidthVariable(this.chart));
    }), t.addEvent(t.Chart, "load", this.onChartLoad), t.addEvent(t.Chart, "redraw", this.onChartRedraw);
  }
  /**
   * Callback when Highcharts initially loads the chart.
   * @abstract
   */
  onChartLoad(t) {
  }
  /**
   * Callback when Highcharts redraws an existing chart.
   * @abstract
   */
  onChartRedraw(t) {
  }
  /**
   * Calculates total series for use in chart modifications or restrictions.
   *
   * Calculation of the series length may vary by type of chart.
   */
  calculateSeriesLength(t) {
    var e;
    return (e = t.series) == null ? void 0 : e.length;
  }
  /** Determines the color order by length of series in the chart. */
  static calculateColorOrder(t) {
    return typeof t == "number" && t > 6 ? mi.EXTENDED : mi.STANDARD;
  }
  /** Sets the class related to the color order on the host component. */
  applyColorOrder(t) {
    var e;
    switch (t) {
      case mi.EXTENDED:
        this.classList.toggle(mi.EXTENDED, !0);
        break;
      case mi.STANDARD:
      default:
        this.classList.toggle(mi.STANDARD, !0);
        break;
    }
    (e = this.chart) == null || e.update({
      tooltip: {
        className: this.getTooltipClasses()
      }
    });
  }
  setChart() {
    try {
      return this.chart = this.createChart(), this.chart;
    } catch (t) {
      return console.error(t), this.chart;
    }
  }
  setFilteredOptions() {
    this.filteredOptions = Ve.filterChartOptions(this.options);
  }
  createChart() {
    const t = Ve.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return vt.chart(this.chartContainer, t);
  }
  updateChart(t) {
    var e;
    (e = this.chart) == null || e.update(t, !0, !0), this.improveChartAccessibility();
  }
  static percentageFormatter(t, e, i, o, n) {
    let l;
    return t && e != null && i != null ? l = `${(100 * (e / (i || 100))).toFixed(o ? n : 0)}%` : e != null ? l = `${Math.round(e)}` : l = "N/A", l;
  }
  /* Since we are rendering highcharts tooltip outside of the shadow DOM, we need to append the lightDOM styles to body.
   */
  static appendLightDOMStyles() {
    var e;
    if (!document.getElementById("beacon-chart-light-DOM-styles")) {
      const i = document.createElement("style");
      i.id = "beacon-chart-light-DOM-styles", i.textContent = vl == null ? void 0 : vl.toString(), (e = document == null ? void 0 : document.body) == null || e.append(i);
    }
  }
  renderTitle() {
    return pe`<div class="title" id="title">
      <slot name="title" ${_e({ container: ".header" })}></slot>
    </div>`;
  }
  renderSubTitle() {
    return pe`<div class="subtitle" id="subtitle">
      <slot name="subtitle" ${_e({ container: ".header" })}></slot>
    </div>`;
  }
  renderHeader() {
    return pe`<div class="header">
      <div class="header-text">
        ${this.renderTitle()} ${this.renderSubTitle()}
      </div>
      <div class="menu"></div>
    </div>`;
  }
  chartBaseInit() {
    this.initializeHighcharts(vt), Ve.appendLightDOMStyles();
  }
  chartLoaded() {
    var t;
    this.setChart(), (t = this.chart) == null || t.reflow();
  }
  /**
   * Removes tab sequential navigation for a button element rendered from HighChart Accessibility module when using the Export Data HighCharts module.
   * We have a github issue open with HighCharts (https://github.com/highcharts/highcharts/issues/22682).
   * TODO: Remove when HighCharts fixes issue
   */
  improveChartAccessibility() {
    var e;
    const t = (e = this.chartContainer) == null ? void 0 : e.querySelector(
      "[id^=hc-linkto-highcharts-data-table-]"
    );
    t == null || t.setAttribute("tabindex", "-1"), t == null || t.setAttribute("aria-expanded", "false");
  }
  willUpdate(t) {
    var L;
    (L = super.willUpdate) == null || L.call(this, t);
    const e = this.hideLegendMetric, i = this.percentage, o = this.decimal, n = this.decimalPlaces, l = this.type;
    if (this.chart) {
      if (t.has("chart")) {
        const { chartHeight: D, chartWidth: j, plotHeight: I, plotWidth: B } = this.chart;
        this.chartSize = {
          chartHeight: D,
          chartWidth: j,
          plotHeight: I,
          plotWidth: B
        };
      }
      t.has("series") && this.updateChart({ series: this.seriesWithChartType }), this.seriesLength = this.calculateSeriesLength(this.chart), this.colorOrder = Ve.calculateColorOrder(this.seriesLength), this.applyColorOrder(this.colorOrder), this.chart.reflow();
    }
    t.has("options") && this.options && (this.setFilteredOptions(), this.updateChart(this.filteredOptions)), t.has("legendLayout") && this.legendLayout && this.updateChart({
      legend: {
        align: this.legendLayout.horizontal,
        layout: this.legendLayout.direction,
        labelFormatter() {
          return Ve.legendItemHTML(
            this,
            e,
            i,
            l,
            o,
            n
          );
        },
        verticalAlign: Ve.setLegendVerticalAlignment(
          this.legendLayout
        ),
        width: Ve.setLegendWidth(this.legendLayout)
      }
    }), (t.has("hideLegendMetric") || t.has("percentage") || t.has("decimal") || t.has("decimalPlaces")) && this.updateChart({
      legend: {
        labelFormatter() {
          return Ve.legendItemHTML(
            this,
            e,
            i,
            l,
            o,
            n
          );
        }
      }
    }), t.has("disableLegend") && this.updateChart({
      legend: { enabled: !this.disableLegend }
    }), t.has("tooltipTitle") && this.updateChart({
      tooltip: {
        headerFormat: Ve.tooltipHeaderHTML(this.tooltipTitle)
      }
    }), t.has("tooltipFooter") && this.updateChart({
      tooltip: {
        footerFormat: Ve.tooltipFooterHTML(this.tooltipFooter)
      }
    }), t.has("tooltipVariant") && this.tooltipVariant && this.updateChart({
      tooltip: {
        padding: Ve.tooltipPadding(this.tooltipVariant),
        shared: this.tooltipVariant === Wr.MULTI_LINE
      }
    });
  }
  render() {
    const t = {
      chart: !0,
      "highcharts-light": !0,
      "static-legend": this.staticLegend
    };
    t["chart--" + this.type] = !0;
    const e = {
      caption: !0
    };
    return pe`
      <figure class="base">
        ${this.renderHeader()}
        <!-- Force Highcharts light theme -->
        <div
          role="region"
          class=${Pe(t)}
          legend-layout="${Object.values(this.legendLayout).join(" ")}"
          aria-labelledby="title"
          aria-describedby="subtitle"></div>
        <figcaption class=${Pe(e)}>
          <slot
            name="caption"
            @slotchange=${this.handleCaptionSlotchange}
            ${_e({ useParent: !0 })}></slot>
        </figcaption>
      </figure>
    `;
  }
}, Ve.nestedComponents = [Xk], Ve.disallowedChartOptions = [
  "colors",
  "title",
  "caption",
  "subtitle"
], Ve.defaultLegendLayout = {
  direction: "horizontal",
  horizontal: "center",
  vertical: "bottom"
}, Ve);
Dt([
  ue({
    type: Array
  })
], kt.prototype, "series", 2);
Dt([
  ue({
    type: Object
  })
], kt.prototype, "options", 2);
Dt([
  ue({ attribute: "static-legend", type: Boolean, reflect: !0 })
], kt.prototype, "staticLegend", 2);
Dt([
  ue({ attribute: "disable-legend", type: Boolean })
], kt.prototype, "disableLegend", 2);
Dt([
  ue({ attribute: "hide-legend-metric", type: Boolean })
], kt.prototype, "hideLegendMetric", 2);
Dt([
  ue({
    attribute: "legend-layout",
    converter: (a) => kt.createLegendLayout(a)
  })
], kt.prototype, "legendLayout", 2);
Dt([
  ue({ attribute: "tooltip-title" })
], kt.prototype, "tooltipTitle", 2);
Dt([
  ue({ attribute: "tooltip-footer" })
], kt.prototype, "tooltipFooter", 2);
Dt([
  ue({ attribute: "tooltip-variant" })
], kt.prototype, "tooltipVariant", 2);
Dt([
  ue({ attribute: "disable-markers", type: Boolean })
], kt.prototype, "disableMarkers", 2);
Dt([
  ue({ type: Boolean })
], kt.prototype, "percentage", 2);
Dt([
  ue({ type: Boolean })
], kt.prototype, "decimal", 2);
Dt([
  ue({ attribute: "decimal-places", type: Number })
], kt.prototype, "decimalPlaces", 2);
Dt([
  Ce()
], kt.prototype, "chart", 2);
Dt([
  An('[slot="caption"]')
], kt.prototype, "linkedDescriptionNode", 2);
Dt([
  We(".chart")
], kt.prototype, "chartContainer", 2);
Dt([
  qe
], kt.prototype, "chartBaseInit", 1);
Dt([
  Re
], kt.prototype, "chartLoaded", 1);
let tt = kt;
var en = /* @__PURE__ */ ((a) => (a.HORIZONTAL = "horizontal", a.VERTICAL = "vertical", a.HORIZONTAL_LEFT = "horizontal-left", a.HORIZONTAL_RIGHT = "horizontal-right", a.VERTICAL_TOP = "vertical-top", a.VERTICAL_BOTTOM = "vertical-bottom", a))(en || {}), cb = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.WIDE = "wide", a))(cb || {}), fs = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.FULL_BLEED = "full-bleed", a.FULL_BLEED_WITH_PADDING = "full-bleed-with-padding", a))(fs || {}), Ef = /* @__PURE__ */ ((a) => (a.BLUE = "blue", a.BERRY = "berry", a.GREEN = "green", a.GOLD = "gold", a))(Ef || {});
const bC = ve`[beacon-tag-name*=tile] [slot=media]>img,[beacon-tag-name*=tile] [slot=media]:not(picture){border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);border-start-end-radius:var(--tile-media-start-end-radius);border-start-start-radius:var(--tile-media-start-start-radius);grid-column:var(--tile-media-grid-column);grid-row:var(--tile-media-grid-row)}[beacon-tag-name*=tile] [slot=header]{margin-block-end:var(--tile-header-margin-block-end);margin-block-start:var(--tile-header-margin-block-start);margin-inline-end:var(--tile-header-margin-inline-end);margin-inline-start:var(--tile-header-margin-inline-start)}[beacon-tag-name*=tile] [slot=header].beacon-tile__header--full-width{--tile-header-margin-inline-start: 0;--tile-header-margin-inline-end: 0}[beacon-tag-name*=tile] [slot=body]{margin-block-end:var(--tile-body-margin-block-end);margin-block-start:var(--tile-body-margin-block-start);margin-inline-end:var(--tile-body-margin-inline-end);margin-inline-start:var(--tile-body-margin-inline-start)}[beacon-tag-name*=tile] [slot=footer]{margin-block-end:var(--tile-footer-margin-block-end);margin-block-start:var(--tile-footer-margin-block-start);margin-inline-end:var(--tile-footer-margin-inline-end);margin-inline-start:var(--tile-footer-margin-inline-start)}[beacon-tag-name*=tile] [slot=footer].beacon-tile__footer--full-width{--tile-footer-margin-inline-start: 0;--tile-footer-margin-inline-end: 0}`, pC = ve`:host{--tile-content-padding-default: initial;--tile-media-template-padding: initial;--tile-content-padding-inline-start: var(--tile-content-padding-default);--tile-content-padding-inline-end: var(--tile-content-padding-default);--tile-content-padding-block-start: var(--tile-content-padding-default);--tile-content-padding-block-end: var(--tile-content-padding-default);--tile-content-padding-block-start-floating: initial;--tile-content-padding-block-end-floating: initial;--tile-header-margin-inline-start: var(--tile-content-padding-inline-start);--tile-body-margin-inline-start: var(--tile-content-padding-inline-start);--tile-footer-margin-inline-start: var(--tile-content-padding-inline-start);--tile-header-margin-inline-end: var(--tile-content-padding-inline-end);--tile-body-margin-inline-end: var(--tile-content-padding-inline-end);--tile-footer-margin-inline-end: var(--tile-content-padding-inline-end);background-color:var(--tile-full-bleed-background-color, var(--tile-host-background-color, var(--beacon-system-color-background-1)));border-radius:var(--tile-border-radius, var(--beacon-system-radius-corner-standard))}.container{block-size:100%;display:var(--tile-display, flex);flex-direction:var(--tile-flex-direction, column);grid-template-columns:var(--tile-grid-template-columns);grid-template-rows:var(--tile-grid-template-rows);margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.content-zone{align-self:var(--tile-content-align-self);background-color:var(--tile-content-background-color);border-end-end-radius:var(--tile-content-end-end-radius);border-end-start-radius:var(--tile-content-end-start-radius);border-start-end-radius:var(--tile-content-start-end-radius);border-start-start-radius:var(--tile-content-start-start-radius);display:var(--tile-content-display, flex);flex-direction:var(--tile-content-flex-direction, column);grid-column:var(--tile-content-grid-column);grid-row:var(--tile-content-grid-row);justify-content:var(--tile-content-justify-content);padding-block:var(--tile-content-padding-block-start) var(--tile-content-padding-block-end)}:host([media-template=full-bleed]){--tile-display: grid;--tile-grid-template-rows: auto;--tile-grid-template-columns: auto;--tile-media-grid-row: 1/2;--tile-media-grid-column: 1/2;--tile-content-grid-row: 1/2;--tile-content-grid-column: 1/2;--tile-content-align-self: end}:host([media-template=full-bleed-with-padding]){--tile-display: grid;--tile-grid-template-rows: var(--tile-media-template-padding) auto var(--tile-media-template-padding);--tile-grid-template-columns: var(--tile-media-template-padding) auto var(--tile-media-template-padding);--tile-media-grid-row: 1/4;--tile-media-grid-column: 1/4;--tile-content-grid-row: 2/3;--tile-content-grid-column: 2/3;--tile-content-align-self: end}:host([position=horizontal]),:host([position=horizontal-right]),:host([position=horizontal-left]){--tile-flex-direction: row}:host([position=vertical]),:host([position=vertical-bottom]),:host([position=vertical-top]){--tile-flex-direction: column}:host(:is([position=horizontal],[position=horizontal-right])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=horizontal-left]){--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard)}:host(:is([position=vertical],[position=vertical-bottom])){--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard)}:host([position=vertical][floating]),:host([position=vertical-bottom][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: var(--tile-content-padding-block-start-floating);--tile-content-padding-block-end: 0}:host([position=vertical-top][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: 0;--tile-content-padding-block-end: var(--tile-content-padding-block-end-floating)}:host([position=horizontal][floating]),:host([position=horizontal-right][floating]){--tile-content-padding-inline-end: 0;--tile-content-padding-block-start: 0}:host([position=horizontal-left][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-block-start: 0}:host([media-template=full-bleed-with-padding][floating]){--tile-content-padding-inline-start: 0;--tile-content-padding-inline-end: 0;--tile-padding-block-start: 0;--tile-padding-block-end: 0}:host([content-alignment=flex-start]){--tile-content-justify-content: flex-start}:host([content-alignment=flex-end]){--tile-content-justify-content: flex-end}:host([content-alignment=center]){--tile-content-justify-content: center}`;
var uC = Object.defineProperty, Mr = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && uC(t, e, o), o;
};
class li extends Le {
  constructor() {
    super(...arguments), this.position = en.VERTICAL, this.floating = !1, this.scale = Fo.NORMAL, this.layout = cb.STANDARD, this.mediaTemplate = fs.STANDARD;
  }
  static get styles() {
    return [super.styles, pC];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, bC];
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the header content.
   */
  renderHeader() {
    return pe`<slot name="header"></slot>`;
  }
  /**
   * Used with Render tile and a TilePosition to determine where to render the media slot.
   * @returns a `slot` containing the media content.
   */
  renderMedia() {
    return pe`<slot name="media"></slot>`;
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the body content.
   */
  renderBody() {
    return pe`<slot name="body"></slot>`;
  }
  /**
   * Used when overriding renderContentZone.
   * @returns a `slot` containing the footer content.
   */
  renderFooter() {
    return pe`<slot name="footer"></slot>`;
  }
  /**
   * Default content zone rendering containing the header, body, and footer slots.
   * Should be overridden from higher level components to remove
   * @returns a `div.content-zone` containing the header, body, and footer slots.
   */
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderHeader()} ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  /**
   * renders the `div.content-zone` and media slot based on the position of the tile,
   * to avoid using row-reverse etc.
   * NOTE: "container" class div element is necessary to cap max-inline-size of tiles at 1920px
   * but still allow for host element to span 100vw with a background color. This aligns with the Beacon Grid Spec.
   * @param position TilePosition with values 'Horizontal', 'Horizontal-Right', 'Horizontal-Left', 'Vertical', 'Vertical-Top', 'Vertical-Bottom'
   * @returns a `div.content-zone` containing the header, body, and footer slots. and
   */
  renderTile(t) {
    return t === en.HORIZONTAL_LEFT || t === en.VERTICAL_TOP ? pe`<div class="container">
        ${this.renderContentZone()} ${this.renderMedia()}
      </div>` : pe`<div class="container">
      ${this.renderMedia()} ${this.renderContentZone()}
    </div>`;
  }
}
Mr([
  ue({ type: en, attribute: "position", reflect: !0 })
], li.prototype, "position");
Mr([
  ue({ type: Boolean, reflect: !0 })
], li.prototype, "floating");
Mr([
  ue({ attribute: "content-alignment", reflect: !0 })
], li.prototype, "contentAlignment");
Mr([
  ue({ type: Fo, reflect: !0 })
], li.prototype, "scale");
Mr([
  ue({ type: cb, reflect: !0 })
], li.prototype, "layout");
Mr([
  ue({
    type: fs,
    attribute: "media-template",
    reflect: !0
  })
], li.prototype, "mediaTemplate");
const Tu = {
  beaconTagName: "beacon-accordion"
}, gC = ve`[beacon-tag-name=beacon-accordion]{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal);--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-3) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-jumbo: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-normal);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}[beacon-tag-name=beacon-accordion]:where([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-mini);--accordion-item-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100);--accordion-item-panel-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}[beacon-tag-name=beacon-accordion]:where([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo);--accordion-item-title-space-padding-block: var(--accordion-item-title-space-padding-block-jumbo);--accordion-item-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-100)}[beacon-tag-name=beacon-accordion] [beacon-tag-name=beacon-accordion-item]{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}@media (width >= 640px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1));--accordion-item-title-space-padding-block-mini: var(--beacon-reference-space-3);--accordion-item-title-space-padding-block-jumbo: var(--beacon-reference-space-2)}}@media (width >= 1280px){[beacon-tag-name=beacon-accordion]{--accordion-item-title-space-padding-block-normal: var(--beacon-reference-space-2);--accordion-item-title-space-padding-block-mini: calc(var(--beacon-reference-space-2) + var(--beacon-reference-space-1))}}`, mC = ve`:host{--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-normal)}:host .hide{display:none}:host([scale=mini]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-mini)}:host([scale=jumbo]){--accordion-item-grid-space-padding-block: var(--beacon-system-space-progression-jumbo)}`;
var fC = Object.defineProperty, vC = Object.getOwnPropertyDescriptor, Tr = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? vC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && fC(t, e, o), o;
};
const AC = [16, 24, 32, 40];
function yC(a) {
  return AC.includes(a);
}
var Os;
const Ib = class Ib extends Le {
  constructor() {
    super(...arguments);
    /** Private property for the icon size. */
    Ie(this, Os);
    this.beaconTagName = Tu.beaconTagName, this.singleOpen = !1, this.scale = ln.NORMAL, this._showAll = !0;
  }
  static get styles() {
    return [super.styles, mC];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, gC];
  }
  get iconSize() {
    return Te(this, Os);
  }
  set iconSize(e) {
    yC(e) ? (Be(this, Os, e), this.style.setProperty(
      "--accordion-icon-column-size",
      String(this.iconSize) + "px"
    )) : this.style.removeProperty("--accordion-icon-column-size");
  }
  get AllAccordionItemsOpen() {
    var e, i;
    return (i = (e = this.slottedAccordionItems) == null ? void 0 : e.every((o) => o.open)) != null ? i : !1;
  }
  get AllAccordionItemsClosed() {
    var e, i;
    return (i = (e = this.slottedAccordionItems) == null ? void 0 : e.every((o) => !o.open)) != null ? i : !1;
  }
  closeAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !1), this._showAll = !0);
  }
  openAllAccordionItems() {
    this.slottedAccordionItems && !this.singleOpen && (this.slottedAccordionItems.forEach((e) => e.open = !0), this._showAll = !1);
  }
  async setupAccordionItems() {
    await this.initializeShowAll(), this.findInitialOpenAccordionItem();
  }
  async initializeShowAll() {
    var e;
    await Promise.all(
      (e = this.slottedAccordionItems) == null ? void 0 : e.map((i) => i.updateComplete)
    ), this._showAll = !this.AllAccordionItemsOpen;
  }
  findInitialOpenAccordionItem() {
    this.singleOpen && this.slottedAccordionItems.forEach((e) => {
      e.open && (this.currentAccordionItemOpen = e);
    });
  }
  handleShowAllStateOnToggle() {
    this.AllAccordionItemsOpen && (this._showAll = !1), this.AllAccordionItemsClosed && (this._showAll = !0);
  }
  handleSingleOpenClick(e) {
    this.currentAccordionItemOpen && this.currentAccordionItemOpen !== e.target ? (this.currentAccordionItemOpen.removeAttribute("open"), this.currentAccordionItemOpen = e.target) : this.currentAccordionItemOpen = e.target;
  }
  /**
   * When `single-open` is set to true, maintains open/closed state of slotted in `<accordion-item>`'s
   */
  clickHandler(e) {
    this.singleOpen && e.target instanceof HTMLElement && e.target.getAttribute("beacon-tag-name") === "beacon-accordion-item" && this.handleSingleOpenClick(e);
  }
  render() {
    return pe`
      <slot name="action-zone"></slot>
      <slot
        name="show-all"
        class=${this._showAll ? "" : "hide"}
        @beacon-event-click=${this.openAllAccordionItems}></slot>
      <slot
        name="hide-all"
        class=${this._showAll ? "hide" : ""}
        @beacon-event-click=${this.closeAllAccordionItems}></slot>
      <slot
        @beacon-event-click=${this.clickHandler}
        @beacon-event-toggle=${this.handleShowAllStateOnToggle}></slot>
    `;
  }
};
Os = new WeakMap(), Ib.tagName = Tu.beaconTagName;
let Aa = Ib;
Tr([
  ue({ type: Boolean, attribute: "single-open" })
], Aa.prototype, "singleOpen", 2);
Tr([
  ue({ type: String, reflect: !0 })
], Aa.prototype, "scale", 2);
Tr([
  ue({ type: Number, attribute: "icon-size" })
], Aa.prototype, "iconSize", 1);
Tr([
  Ct({
    selector: '[beacon-tag-name="beacon-accordion-item"]'
  })
], Aa.prototype, "slottedAccordionItems", 2);
Tr([
  ue({ reflect: !0, attribute: "show-all", type: Boolean })
], Aa.prototype, "_showAll", 2);
Tr([
  Re
], Aa.prototype, "setupAccordionItems", 1);
const Lu = {
  beaconTagName: "beacon-accordion-item"
}, xC = ve`[beacon-tag-name=beacon-accordion-item] [slot=icon],[beacon-tag-name=beacon-accordion-item] [slot=icon]::part(internal--icon){block-size:var(--accordion-icon-column-size);inline-size:var(--accordion-icon-column-size)}[beacon-tag-name=beacon-accordion-item] [beacon-tag-name=beacon-icon]{display:block}[beacon-tag-name=beacon-accordion-item] [slot=title]{--accordion-item-title-margin-inline-start: calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4))}[beacon-tag-name=beacon-accordion-item] [slot=icon]~[slot=title]{--accordion-item-title-margin-inline-start: 0}`, wC = ve`:host([motion-state=enabled]) :is(summary){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:background-color;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}`;
var kC = Object.getOwnPropertyDescriptor, CC = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? kC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
const Ou = "cubic-bezier(0.05,0.7,0.1,1)", Pu = 50, Du = 150;
function SC(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.isClosing = !1, this.isOpening = !1;
    }
    static get AccordionItemMotionStyles() {
      return [wC];
    }
    get detailsElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector("details");
    }
    get summaryElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector("summary");
    }
    get panelElement() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(
        "details > .accordion-grid"
      );
    }
    /**
     * Calls custom open and collapse methods that manage open state and animations on the `<details>` element
     */
    summaryClickHandler(e) {
      var i, o, n;
      this.getAttribute("motion-state") !== "disabled" && (e.preventDefault(), (i = this.detailsElement) == null || i.style.setProperty("overflow", "hidden"), this.isClosing || !((o = this.detailsElement) != null && o.hasAttribute("open")) ? this.openDetails() : (this.isOpening || (n = this.detailsElement) != null && n.hasAttribute("open")) && this.collapse());
    }
    /**
     * Handles animation of accordion item when it is collapsing
     */
    collapse() {
      var o, n, l;
      this.isClosing = !0;
      const e = `${(o = this.detailsElement) == null ? void 0 : o.offsetHeight}px`, i = `${(n = this.summaryElement) == null ? void 0 : n.offsetHeight}px`;
      this.animation && this.animation.cancel(), this.animation = (l = this.detailsElement) == null ? void 0 : l.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [e, i]
        },
        {
          delay: Pu,
          duration: Du,
          easing: Ou
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!1)), this.animation && (this.animation.oncancel = () => this.isClosing = !1);
    }
    /**
     * Sets open attribute on `<details>` element and set's block-size to current height of `<details>` element in order for animations to occur
     */
    openDetails() {
      var e, i, o;
      (i = this.detailsElement) == null || i.style.setProperty(
        "block-size",
        `${(e = this.detailsElement) == null ? void 0 : e.offsetHeight}px`
      ), (o = this.detailsElement) == null || o.setAttribute("open", ""), window.requestAnimationFrame(() => this.expandDetails());
    }
    /**
     * Handles animation of accordion item when it is expanding
     */
    expandDetails() {
      var o, n, l, L;
      this.isOpening = !0;
      const e = `${(o = this.detailsElement) == null ? void 0 : o.offsetHeight}px`, i = `${((n = this.summaryElement) == null ? void 0 : n.offsetHeight) + ((l = this.panelElement) == null ? void 0 : l.offsetHeight)}px`;
      this.animation && this.animation.cancel(), this.animation = (L = this.detailsElement) == null ? void 0 : L.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [e, i]
        },
        {
          delay: Pu,
          duration: Du,
          easing: Ou
        }
      ), this.animation && (this.animation.onfinish = () => this.onAnimationFinish(!0)), this.animation && (this.animation.oncancel = () => this.isOpening = !1);
    }
    /**
     * Handles state of `<details>` element after expand/collapse animations have ocurred and resets animation state of component
     */
    onAnimationFinish(e) {
      var i, o, n, l;
      e ? (i = this.detailsElement) == null || i.setAttribute("open", "") : (o = this.detailsElement) == null || o.removeAttribute("open"), this.animation = void 0, this.isClosing = !1, this.isOpening = !1, (n = this.detailsElement) == null || n.style.setProperty("overflow", ""), (l = this.detailsElement) == null || l.style.setProperty("block-size", "");
    }
  };
  return t = CC([
    $e("AccordionItemMotion")
  ], t), t;
}
const EC = ve`:host{--accordion-chevron-color: var(--beacon-system-color-icon-secondary)}.accordion-grid{align-items:center;display:grid;grid-template-areas:"icon content chevron";grid-template-columns:auto 1fr auto;padding-block:var(--accordion-item-grid-space-padding-block);padding-inline-start:var(--beacon-reference-space-3)}.title{font:var(--accordion-item-title-font);margin-inline-end:var(--beacon-reference-space-4);padding-block:var(--accordion-item-title-space-padding-block)}::slotted([slot=title]){margin-inline-start:var(--accordion-item-title-margin-inline-start, initial)}details{color:var(--beacon-system-color-text-standard)}[open] summary{background:var(--beacon-system-color-background-secondary-hover)}[open] summary:active{background:var(--beacon-system-color-background-secondary-pressed)}[open] .chevron{transform:rotate(180deg)}summary{border-inline-start:var(--beacon-system-width-border-normal) solid transparent;cursor:pointer;list-style:none}summary:hover{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-hover);background:var(--beacon-system-color-background-secondary-hover);border-inline-start:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-link)}summary:active{--accordion-chevron-color: var(--beacon-system-color-icon-secondary-pressed);background:var(--beacon-system-color-background-secondary-pressed)}summary::-webkit-details-marker{display:none}.icon{grid-area:icon;margin-inline-end:var(--beacon-reference-space-4)}.chevron{align-self:start;color:var(--accordion-chevron-color);display:flex;grid-area:chevron;margin-inline-start:auto;padding:var(--beacon-reference-space-4);transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.panel{font:var(--accordion-item-panel-font);grid-area:content;margin-inline:calc(var(--accordion-icon-column-size) + var(--beacon-reference-space-4)) var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3)}.hide{display:none}`;
var MC = Object.defineProperty, TC = Object.getOwnPropertyDescriptor, yn = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? TC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && MC(t, e, o), o;
}, Yo;
const Ca = (Yo = class extends Ge(Le).with(
  SC
) {
  constructor() {
    super(...arguments), this.beaconTagName = Lu.beaconTagName, this.open = !1, this.hasIcon = !1;
  }
  static get styles() {
    return [super.styles, EC, this.AccordionItemMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, xC];
  }
  /**
   * Sets the `open` property based on the `open` attribute of the `<details>` element
   * and emits the state of the accordion-item after being toggled
   */
  toggleEventHandler() {
    this.open = this.details.hasAttribute("open"), this.emitToggle();
  }
  /**
   * Handles summary clicks and emits a beacon-event-click
   * to be used by parent beacon-accordion component to manage
   * state on single-open mode
   */
  clickEventHandler(t) {
    this.summaryClickHandler(t), this.emitClick();
  }
  iconSlotChange() {
    var t;
    this.hasIcon = !!((t = this.slottedIcon) != null && t.length), Yo.addAnalyticsAttributes(
      this.slottedIcon.find(
        (e) => typeof e < "u" && !(e instanceof ro)
      )
    );
  }
  titleSlotChange() {
    const t = this.slottedTitle.find(
      (e) => typeof e < "u"
    );
    Yo.addAnalyticsAttributes(t), t.textContent && this.summary.setAttribute(
      wo.TEXT,
      t.textContent
    );
  }
  renderIcon() {
    const t = {
      icon: !0,
      hide: !this.hasIcon
    };
    return pe`<div class=${Pe(t)}>
      <slot @slotchange=${this.iconSlotChange} name="icon"></slot>
    </div>`;
  }
  /**
   * Analytics attributes added to the `<summary>`, slotted in icon and slotted title element for analytics to capture tracking
   */
  static addAnalyticsAttributes(t) {
    t && (t.setAttribute(wo.TYPE, "EC"), t.setAttribute(wo.CLICKABLE, "true"));
  }
  addAnalytics() {
    Yo.addAnalyticsAttributes(this.summary);
  }
  render() {
    return ze`
      <details
        @toggle=${this.toggleEventHandler}
        ?open=${this.open}>
        <summary @click=${this.clickEventHandler}>
          <div class="accordion-grid">
            ${this.renderIcon()}
            <div class="title">
              <slot @slotchange=${this.titleSlotChange} name="title"></slot>
            </div>
            <div class="chevron">
              <${this.getScopedTag("beacon-icon")} name='expand' size='s'></${this.getScopedTag("beacon-icon")}>  
            </div>
          </div>
        </summary>
        <div class="accordion-grid">
          <div class="panel">
            <slot name="panel"></slot>
          </div>
        </div>
      </details>
    `;
  }
}, Yo.tagName = Lu.beaconTagName, Yo.nestedComponents = [ro], Yo);
yn([
  ue({ type: Boolean, reflect: !0 })
], Ca.prototype, "open", 2);
yn([
  ot("details")
], Ca.prototype, "details", 2);
yn([
  ot("summary")
], Ca.prototype, "summary", 2);
yn([
  Ce()
], Ca.prototype, "hasIcon", 2);
yn([
  De({ flatten: !0, slot: "icon" })
], Ca.prototype, "slottedIcon", 2);
yn([
  De({ flatten: !0, slot: "title" })
], Ca.prototype, "slottedTitle", 2);
yn([
  Re
], Ca.prototype, "addAnalytics", 1);
let GD = Ca;
const zu = {
  beaconTagName: "beacon-action-bar"
}, LC = ve`:host{background-color:var(--beacon-system-color-background-0);inline-size:100%;inset-block-end:0;position:sticky;z-index:3000}:host([inactive]){display:none}.base{align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--beacon-reference-space-5);padding-inline:var(--beacon-system-space-organism-maxi)}`;
var OC = Object.defineProperty, PC = Object.getOwnPropertyDescriptor, db = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? PC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && OC(t, e, o), o;
};
const Bb = class Bb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = zu.beaconTagName, this.inactive = !1, this.activeAtObserverEnter = new IntersectionObserver(
      (t, e) => {
        t.forEach((i) => {
          const {
            isIntersecting: o,
            boundingClientRect: { top: n }
          } = i;
          o && (this.inactive = !1), !o && n >= 0 && (this.inactive = !0);
        });
      }
    );
  }
  static get styles() {
    return [super.styles, LC];
  }
  get activeAtPoint() {
    var e;
    const t = this.getClosestHost();
    return t ? (e = t.shadowRoot) == null ? void 0 : e.querySelector(this.activeAt) : document.querySelector(this.activeAt);
  }
  handleActivation() {
    this.activeAtPoint && (this.inactive = !0, this.activeAtObserverEnter.observe(this.activeAtPoint));
  }
  render() {
    return pe`
      <div class="base" part="base">
        <div class="start">
          <slot name="start"></slot>
        </div>
        <div class="end">
          <slot name="end"></slot>
        </div>
      </div>
    `;
  }
};
Bb.tagName = zu.beaconTagName;
let vs = Bb;
db([
  ue({ type: Boolean, reflect: !0 })
], vs.prototype, "inactive", 2);
db([
  ue({ attribute: "active-at", reflect: !0 })
], vs.prototype, "activeAt", 2);
db([
  Re
], vs.prototype, "handleActivation", 1);
var Ci = /* @__PURE__ */ ((a) => (a.DOWN = "ArrowDown", a.UP = "ArrowUp", a.RIGHT = "ArrowRight", a.LEFT = "ArrowLeft", a))(Ci || {}), Di = /* @__PURE__ */ ((a) => (a.ESCAPE = "Escape", a.TAB = "Tab", a.ENTER = "Enter", a.SPACE = " ", a))(Di || {});
const jo = (a, t) => {
  let e;
  return function(...o) {
    const n = () => {
      clearTimeout(e), a(...o);
    };
    clearTimeout(e), e = setTimeout(n, t);
  };
};
typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
const Iu = {
  beaconTagName: "beacon-anchor-navigation"
}, DC = ve`[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs]{display:flex;inline-size:100%;justify-content:space-between;list-style:none;margin:0;padding:0}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li{display:grid;inline-size:100%}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li>*{grid-area:1/-1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:start;block-size:100%;display:grid;inline-size:100%;background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);padding:calc(2 * var(--beacon-system-space-cell-contained))}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:hover{background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:active{background:var(--beacon-system-color-background-primary-pressed);text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;text-decoration:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a:focus-visible:not(dialog){position:relative}@media (width >= 960px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li a{align-items:center;text-align:center}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a{--active-tab-background-color: var(--beacon-reference-palette-grayscale-white);--active-tab-color: var(--beacon-reference-palette-primary-midnight-navy-1);background-color:var(--active-tab-background-color);color:var(--active-tab-color);font-weight:700}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a:not([has-overflow-menu]){--active-tab-background-color: var(--beacon-system-color-background-1);--active-tab-color: var(--beacon-system-color-text-standard)}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]){display:var(--inactive-tab-display, none)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]) .progress-container{display:none}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container{align-self:end;display:grid;padding-block-end:var(--beacon-system-space-cell-contained);padding-inline:calc(2 * var(--beacon-system-space-cell-contained));pointer-events:none;z-index:1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-outer{block-size:var(--beacon-system-width-border-normal);display:grid}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-outer>*{grid-area:1/-1}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-bar{--progress-bar-background: var(--beacon-reference-palette-grayscale-light-gray-2);background:var(--progress-bar-background);inline-size:100%}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-bar:not([has-overflow-menu]){--progress-bar-background: var(--beacon-system-color-border-0)}}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li .progress-container .progress-value{background-color:var(--beacon-system-color-background-primary);inline-size:var(--reading-progress, 0)}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li.cta-item{background-color:var(--beacon-reference-palette-primary-midnight-navy-2);inline-size:auto;padding-block:var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container{align-items:center;display:flex;inline-size:max-content}[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container a,[beacon-tag-name=beacon-anchor-navigation] .cta-desktop-container button{inline-size:100%}@media (width >= 640px){[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li:not([active]){--inactive-tab-display: grid}[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li[active] a{background-color:var(--beacon-system-color-background-0)}[beacon-tag-name=beacon-anchor-navigation]:not([has-overflow-menu]) :is(ul,ol)[slot=tabs] li a{align-items:center;text-align:center}}@media (width >= 960px){[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li:not([active]){--inactive-tab-display: grid}[beacon-tag-name=beacon-anchor-navigation] :is(ul,ol)[slot=tabs] li[active] a{background-color:var(--beacon-system-color-background-0)}}`, zC = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) .menu-container .cta-mobile-container{transform:translateY(0);transition-duration:var(--beacon-reference-motion-duration-7);transition-property:transform;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .menu-container.is-scrolling .cta-mobile-container,:host([motion-state=enabled]) .menu-container.menu-open .cta-mobile-container,:host([motion-state=enabled]) .menu-container.not-active .cta-mobile-container{transform:translateY(100%)}}`;
var IC = Object.getOwnPropertyDescriptor, BC = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? IC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function RC(a) {
  let t = class extends a {
    static get AnchorNavigationMotionStyles() {
      return [zC];
    }
  };
  return t = BC([
    $e("AnchorNavigationMotion")
  ], t), t;
}
const NC = ve`:host{inline-size:100%;margin:auto;position:relative;z-index:1000}.tab-bar-wrapper{background-color:var(--beacon-reference-palette-primary-midnight-navy-2);border:var(--beacon-system-width-border-mini) solid var(--beacon-reference-palette-primary-midnight-navy-2);display:flex;flex-direction:column;gap:var(--beacon-reference-space-3);inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky;z-index:2}.jump-to-section{color:var(--beacon-reference-palette-grayscale-white);margin-block:0;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}.jump-to-section.hidden{display:none}@media (width >= 640px){:host(:not([has-overflow-menu])) .tab-bar-wrapper{border:0;padding:0}:host(:not([has-overflow-menu])) .jump-to-section{display:none}}@media (width >= 960px){.tab-bar-wrapper{background-color:inherit;border:0;padding:0}.tab-bar{inline-size:100%;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.jump-to-section{display:none}}.tab-bar{align-items:center;display:grid;grid-template-columns:1fr auto;inset-block-start:0}.tabs{inline-size:100%;z-index:1}.content{position:relative;z-index:1}.menu-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);block-size:100%;border:0;display:grid;inline-size:var(--beacon-reference-space-11);padding:0;place-items:center}.menu-button[aria-expanded=true] [beacon-tag-name=beacon-icon]{transform:rotate(180deg)}.menu-button [beacon-tag-name=beacon-icon]{color:var(--beacon-system-color-icon-primary)}.menu-button:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.menu-button:focus-visible:not(dialog){position:relative}.menu{background:var(--beacon-system-color-background-primary);box-shadow:0 var(--beacon-reference-space-5) var(--beacon-reference-space-7) calc(-1 * var(--beacon-reference-space-5)) var(--beacon-reference-palette-grayscale-shadow-3);color:var(--beacon-system-color-text-primary);inset-inline-end:var(--beacon-reference-space-3);inset-inline-start:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-organism-jumbo);position:absolute;text-align:center}.menu:not(.open){display:none}.menu .menu-title-wrapper{padding:var(--beacon-system-space-cell-free-floating)}.menu .menu-title-wrapper>.menu-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:inline-block;padding:var(--beacon-system-space-cell-contained)}.menu .menu-list{list-style:none;margin:0;padding:0}.menu a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);padding:calc(2 * var(--beacon-system-space-cell-contained))}.menu a:not(:hover,:focus){text-decoration:none}.menu a:hover{background-color:var(--beacon-system-color-background-primary-hover)}.menu a:active{background:var(--beacon-system-color-background-primary-pressed);text-decoration:none}.menu a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;text-decoration:none}.menu a:focus-visible:not(dialog){position:relative}.menu [active] a{background-color:var(--beacon-component-tab-menu-color-background-primary-active);font-weight:700}.menu-container{block-size:100%;z-index:2}.menu-container .cta-mobile-container{--override-button-inline-size: 100%;background:var(--beacon-reference-palette-primary-midnight-navy-2);inline-size:100%;inset-block-end:0;inset-inline-start:0;padding:var(--beacon-reference-space-3);position:fixed;visibility:visible}.menu-container .cta-mobile-container a,.menu-container .cta-mobile-container button{inline-size:100%}.menu-container.is-scrolling .cta-mobile-container,.menu-container.menu-open .cta-mobile-container,.menu-container.not-active .cta-mobile-container{visibility:hidden}@media (width >= 640px){:host(:not([has-overflow-menu])) .menu-container{display:none}}@media (width >= 960px){.menu-container{display:none}}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var FC = Object.defineProperty, jC = Object.getOwnPropertyDescriptor, St = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? jC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && FC(t, e, o), o;
}, po;
const yt = (po = class extends Ge(Le).with(
  RC
) {
  constructor() {
    super(...arguments), this.beaconTagName = Iu.beaconTagName, this._hasOverflowMenu = !1, this.debounceOnScroll = !1, this.menuIsOpen = !1, this.isScrolling = !1, this.isActive = !1, this.tabs = void 0, this.currentScrollPosition = window.scrollY, this.handleScrollStop = jo(() => {
      this.isScrolling = !1;
      const { top: t } = this.tabBar.getBoundingClientRect();
      t >= 0 && t < 100 ? this.isActive = !0 : this.isActive = !1;
    }, 800), this.handleWindowScrollDebounced = jo(() => {
      this.handleWindowScroll();
    }, 100), this.handleMenuKeydown = (t) => {
      const { key: e, target: i } = t;
      e === Di.ESCAPE && (i !== this.menuButton && this.menuButton.focus(), this.closeMenu());
    };
  }
  static get styles() {
    return [super.styles, NC, this.AnchorNavigationMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, DC];
  }
  get activeProgress() {
    var t, e;
    return (e = (t = this.activeTab) == null ? void 0 : t.parentElement) == null ? void 0 : e.querySelector(".progress-value");
  }
  static createProgressElement() {
    const t = document.createElement("template");
    return t.innerHTML = `
      <div class="progress-container">
        <div class="progress-outer">
          <div class="progress-bar"></div>
          <div class="progress-value"></div>
        </div>
      </div>
    `, t.content.cloneNode(!0);
  }
  static appendProgressIndicators(t) {
    t.forEach((e) => {
      if (!e.nextElementSibling || !e.nextElementSibling.classList.contains("progress-container")) {
        const i = this.createProgressElement();
        e.after(i);
      }
    });
  }
  overrideTabFocusStyles() {
    var t;
    (t = this.tabs) == null || t.forEach(
      (e) => e.setAttribute("focus-override", "")
    );
  }
  setFirstTabToActive() {
    var t, e, i;
    this.tabs && ((e = (t = this.tabs[0]) == null ? void 0 : t.closest("li")) == null || e.setAttribute("active", "")), (i = this.overflowMenu.querySelector("li")) == null || i.setAttribute("active", "");
  }
  handleSlottedCta() {
    if (this.slottedCta.length > 0) {
      const t = this.slottedCta[0], e = document.createElement("li");
      e.classList.add("cta-item");
      const i = document.createElement("div");
      i.classList.add("cta-desktop-container"), i.appendChild(t.cloneNode(!0)), e.appendChild(i), this.slottedTabLists[0].appendChild(e);
      const o = document.createElement("div");
      o.classList.add("cta-mobile-container"), o.appendChild(t), this.menuContainer.appendChild(o);
    }
  }
  handleSlottedTabs() {
    this.tabs = Array.from(this.slottedTabLists[0].querySelectorAll("a[href]")), this._hasOverflowMenu = this.tabs.length > po.overflowMenuTabThreshold, po.appendProgressIndicators(this.tabs), this.overrideTabFocusStyles(), this.setFirstTabToActive(), this.handleSlottedCta();
  }
  toggleMenu() {
    this.menuIsOpen = !this.menuIsOpen;
  }
  closeMenu() {
    this.menuIsOpen = !1;
  }
  removeActiveAttributeFromTabs() {
    const t = Array.from(
      this.slottedTabLists[0].querySelectorAll("li[active]")
    ), e = this.overflowMenu.querySelector("li[active]");
    [...t, e].forEach((o) => o == null ? void 0 : o.removeAttribute("active"));
  }
  addActiveAttributeToTabs() {
    var o, n, l;
    const t = (o = this.activeTab) == null ? void 0 : o.closest("li"), e = (l = this.overflowMenu.querySelector(`a[href="${(n = this.activeTab) == null ? void 0 : n.hash}"]`)) == null ? void 0 : l.closest("li");
    [t, e].forEach((L) => L == null ? void 0 : L.setAttribute("active", ""));
  }
  getCurrentVisibleSections() {
    var i;
    this.currentScrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const t = (i = this.offset) != null ? i : this.tabBar ? this.tabBar.offsetHeight : 0;
    return this.sections.filter(
      (o) => {
        const { top: n } = o.getBoundingClientRect();
        return n + this.currentScrollPosition - po.overflowScrollThreshold - t <= this.currentScrollPosition;
      }
    );
  }
  setActiveSection() {
    const t = this.getCurrentVisibleSections(), e = t[t.length - 1];
    this.activeSection = e;
  }
  setActiveTabAttributes() {
    var e;
    const t = (e = this.tabs) == null ? void 0 : e.find(
      (i) => {
        var o;
        return i.hash === `#${(o = this.activeSection) == null ? void 0 : o.id}`;
      }
    );
    this.activeTab !== t && (this.removeActiveAttributeFromTabs(), this.activeTab = t, this.addActiveAttributeToTabs()), this.activeTab === void 0 && this.setFirstTabToActive();
  }
  setActiveProgressValue() {
    if (this.activeProgress && this.activeTab && this.activeSection) {
      const { top: t, height: e } = this.activeSection.getBoundingClientRect(), i = t + this.currentScrollPosition - po.overflowScrollThreshold, n = Math.abs(t) / e * 100, l = Math.floor(n);
      this.currentScrollPosition >= i && Number.isInteger(l) && this.activeProgress.style.setProperty(
        "--reading-progress",
        `${l}%`
      );
    }
  }
  // Hide the jumpToSection when the tabBar is stuck to the top of the page.
  toggleJumpToSectionDisplay() {
    const { top: t } = this.tabBarWrapper.getBoundingClientRect();
    t <= 2 ? this.jumpToSection.classList.add("hidden") : this.jumpToSection.classList.remove("hidden");
  }
  // Delay for 800ms before showing CTA button to avoid rapid toggling.
  handleWindowScroll() {
    this.isScrolling = !0, this.toggleJumpToSectionDisplay(), this.setActiveSection(), this.setActiveTabAttributes(), this.setActiveProgressValue(), this.handleScrollStop();
  }
  intersectionObserverCallback(t) {
    for (const e of t)
      e.isIntersecting ? this.debounceOnScroll ? window.addEventListener("scroll", this.handleWindowScrollDebounced) : window.addEventListener("scroll", this.handleWindowScroll) : this.debounceOnScroll ? window.removeEventListener(
        "scroll",
        this.handleWindowScrollDebounced
      ) : window.removeEventListener("scroll", this.handleWindowScroll);
  }
  renderOverflowMenu() {
    return pe`
      <ol class="menu-list" @keydown=${this.handleMenuKeydown}>
        ${No(
      this.tabs,
      (t, e) => pe`
            <li class="menu-list-item" ?active=${e === 0} tabindex="0">
              <a focus-override @click=${this.closeMenu} href="${t == null ? void 0 : t.hash}"
                >${t == null ? void 0 : t.textContent}</a
              >
            </li>
          `
    )}
      </ol>
    `;
  }
  observeSelf() {
    this.observer = new IntersectionObserver(this.intersectionObserverCallback), this.observer.observe(this);
  }
  bindMethods() {
    this.intersectionObserverCallback = this.intersectionObserverCallback.bind(this), this.handleWindowScroll = this.handleWindowScroll.bind(this);
  }
  unobserveSelf() {
    var t;
    (t = this.observer) == null || t.disconnect();
  }
  render() {
    const t = this.menuIsOpen ? "Close" : "Open", e = {
      open: this.menuIsOpen,
      menu: !0
    }, i = {
      "menu-open": this.menuIsOpen,
      "is-scrolling": this.isScrolling,
      "not-active": !this.isActive,
      "menu-container": !0
    };
    return ze`
      <div class="tab-bar-wrapper">
        <p class="jump-to-section">
          <slot name="menu-title">Jump to a section:</slot>
        </p>
        <div class="tab-bar">
          <nav class="tabs" aria-label="on page">
            <slot name="tabs" @slotchange=${this.handleSlottedTabs}></slot>
            <slot name="cta" @slotchange=${this.handleSlottedCta}></slot>
          </nav>
          <div class="${Pe(i)}">
            <button
              class="menu-button"
              aria-controls="menu"
              aria-expanded="${this.menuIsOpen}"
              aria-label="Open navigation menu"
              @click=${this.toggleMenu}
              @keydown=${this.handleMenuKeydown}>
              <div class="visually-hidden">
                <slot name="visually-hidden-button-label"
                  >${t} Menu</slot
                >
              </div>
              <${this.getScopedTag("beacon-icon")} name='expand' size='s'></${this.getScopedTag("beacon-icon")}>
            </button>
            <nav
              id="menu"
              aria-describedby="menu-title"
              class="${Pe(e)}">
              ${this.renderOverflowMenu()}
            </nav>
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }
}, po.nestedComponents = [ro], po.tagName = Iu.beaconTagName, po.overflowMenuTabThreshold = 4, po.overflowScrollThreshold = 10, po);
St([
  ue({ attribute: "has-overflow-menu", reflect: !0, type: Boolean })
], yt.prototype, "_hasOverflowMenu", 2);
St([
  ue({ attribute: "debounce-on-scroll", type: Boolean })
], yt.prototype, "debounceOnScroll", 2);
St([
  ue({ attribute: "offset", type: Number })
], yt.prototype, "offset", 2);
St([
  Ce()
], yt.prototype, "menuIsOpen", 2);
St([
  Ce()
], yt.prototype, "isScrolling", 2);
St([
  Ce()
], yt.prototype, "isActive", 2);
St([
  Ct({ slot: "tabs", flatten: !0 })
], yt.prototype, "slottedTabLists", 2);
St([
  Ct({ selector: "[id]", flatten: !0 })
], yt.prototype, "sections", 2);
St([
  Ct({ slot: "cta", flatten: !0 })
], yt.prototype, "slottedCta", 2);
St([
  We(".menu-container")
], yt.prototype, "menuContainer", 2);
St([
  We(".cta-mobile-container")
], yt.prototype, "ctaMobileContainer", 2);
St([
  We(".menu")
], yt.prototype, "overflowMenu", 2);
St([
  We(".menu-button")
], yt.prototype, "menuButton", 2);
St([
  We(".tab-bar")
], yt.prototype, "tabBar", 2);
St([
  We(".tab-bar-wrapper")
], yt.prototype, "tabBarWrapper", 2);
St([
  We(".jump-to-section")
], yt.prototype, "jumpToSection", 2);
St([
  Ce()
], yt.prototype, "tabs", 2);
St([
  qe
], yt.prototype, "observeSelf", 1);
St([
  qe
], yt.prototype, "bindMethods", 1);
St([
  Pt
], yt.prototype, "unobserveSelf", 1);
let WD = yt;
function Mf(a, t = " ") {
  if (a)
    return af(a, t);
}
const _C = ve`.highcharts-axis-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-line,.highcharts-grid-line,.highcharts-plot-line.origin-line,.highcharts-tick{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-graph{stroke-width:var(--beacon-system-width-border-normal)}.highcharts-grid-line,.highcharts-axis-line{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-navigator-xaxis .highcharts-grid-line{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-plot-line.origin-line,.highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-major)}.highcharts-plot-band.negative-area{fill:var(--beacon-system-color-background-1);fill-opacity:1}`;
var UC = Object.defineProperty, $C = Object.getOwnPropertyDescriptor, In = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? $C(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && UC(t, e, o), o;
};
function Qs(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.yAxisLabel = "", this.xAxisLabel = "";
    }
    static get chartAreaStyles() {
      return _C;
    }
    get totalChartCategories() {
      var o, n, l, L, D;
      const e = (n = (o = this.chart) == null ? void 0 : o.series) == null ? void 0 : n.map(
        (j) => {
          var I;
          return (I = j == null ? void 0 : j.data) == null ? void 0 : I.length;
        }
      );
      if (!(e != null && e.length)) return;
      const i = Math.max(...e);
      return (D = (L = (l = this.categories) == null ? void 0 : l.length) != null ? L : i) != null ? D : void 0;
    }
    willUpdate(e) {
      var i;
      (i = super.willUpdate) == null || i.call(this, e), e.has("xAxisLabel") && this.updateChart({ xAxis: { title: { text: this.xAxisLabel } } }), e.has("yAxisLabel") && this.updateChart({ yAxis: { title: { text: this.yAxisLabel } } }), e.has("categories") && this.updateChart({ xAxis: { categories: this.categories } }), e.has("chart") && this._addPlotBands(), e.has("stacking") && this.updateChart({
        plotOptions: { series: { stacking: this.stacking } }
      });
    }
    // Apply the negative area of the chart after we can access the min of the y axis
    _addPlotBands() {
      var e;
      this.updateChart({
        yAxis: {
          plotBands: [
            {
              className: "negative-area",
              from: 0,
              to: (e = this.chart) == null ? void 0 : e.yAxis[0].min
            }
          ]
        }
      });
    }
    get localComponentOptions() {
      return tt.createChartOptions(super.localComponentOptions, {
        xAxis: {
          categories: this.categories,
          labels: {
            y: 24
          },
          tickLength: 4,
          title: {
            margin: 16,
            text: this.xAxisLabel
          }
        },
        yAxis: {
          labels: {
            formatter() {
              const { value: e } = this;
              return typeof e == "number" ? e < 1e3 ? `${e}` : e < 1e6 ? `${e / 1e3}k` : `${Math.round(e / 1e4) / 100}M` : e;
            }
          },
          plotLines: [
            // Origin Line
            {
              className: "origin-line",
              value: 0,
              zIndex: 5
              // Layers it over the other grid lines
            }
          ],
          title: {
            margin: 16,
            text: this.yAxisLabel
          }
        }
      });
    }
    getTooltipClasses() {
      var e;
      return `beacon-chart-tooltip ${this.colorOrder} ${this.type} ${((e = this.series) == null ? void 0 : e.length) === 1 ? "single-series-chart" : ""} ${this.stacking ? "stacked-chart" : ""}`.trim();
    }
  };
  return In([
    ue({ attribute: "y-axis-label" })
  ], t.prototype, "yAxisLabel", 2), In([
    ue({ attribute: "x-axis-label" })
  ], t.prototype, "xAxisLabel", 2), In([
    ue({
      converter: (e) => Mf(e, ",")
    })
  ], t.prototype, "categories", 2), In([
    ue({ reflect: !0 })
  ], t.prototype, "stacking", 2), In([
    Gt("series")
  ], t.prototype, "_addPlotBands", 1), t = In([
    $e("ChartArea")
  ], t), t;
}
var Tf = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Data module
  *
  * (c) 2012-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Core/HttpUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: l } = o, { discardElement: L, objectEach: D } = n, j = { ajax: function(I) {
        let B = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, R = new XMLHttpRequest();
        function N(x, T) {
          I.error && I.error(x, T);
        }
        if (!I.url) return !1;
        R.open((I.type || "get").toUpperCase(), I.url, !0), I.headers && I.headers["Content-Type"] || R.setRequestHeader("Content-Type", B[I.dataType || "json"] || B.text), D(I.headers, function(x, T) {
          R.setRequestHeader(T, x);
        }), I.responseType && (R.responseType = I.responseType), R.onreadystatechange = function() {
          let x;
          if (R.readyState === 4) {
            if (R.status === 200) {
              if (I.responseType !== "blob" && (x = R.responseText, I.dataType === "json")) try {
                x = JSON.parse(x);
              } catch (T) {
                if (T instanceof Error) return N(R, T);
              }
              return I.success && I.success(x, R);
            }
            N(R, R.responseText);
          }
        }, I.data && typeof I.data != "string" && (I.data = JSON.stringify(I.data)), R.send(I.data);
      }, getJSON: function(I, B) {
        j.ajax({ url: I, success: B, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(I, B, R) {
        let N = new l.FormData();
        D(B, function(y, S) {
          N.append(S, y);
        }), N.append("b64", "true");
        let { filename: x, type: T } = B;
        return l.fetch(I, { method: "POST", body: N, ...R }).then((y) => {
          y.ok && y.text().then((S) => {
            let u = document.createElement("a");
            u.href = `data:${T};base64,${S}`, u.download = x, u.click(), L(u);
          });
        });
      } };
      return j;
    }), i(e, "Extensions/Data.js", [e["Core/Axis/Axis.js"], e["Core/Chart/Chart.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { getOptions: R } = l, { doc: N } = L, { ajax: x } = D, { seriesTypes: T } = I, { addEvent: y, defined: S, extend: u, fireEvent: A, isNumber: M, merge: f, objectEach: m, pick: C, splat: F } = B;
      function _(w) {
        return !!(w && (w.rowsURL || w.csvURL || w.columnsURL));
      }
      class E {
        static data(d, r = {}, s) {
          return new E(d, r, s);
        }
        static rowsToColumns(d) {
          let r, s, p, b, c;
          if (d) for (r = 0, c = [], s = d.length; r < s; r++) for (p = 0, b = d[r].length; p < b; p++) c[p] || (c[p] = []), c[p][r] = d[r][p];
          return c;
        }
        constructor(d, r = {}, s) {
          this.rowsToColumns = E.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(p) {
            return p ? Date.UTC(+p[1], +p[2] - 1, +p[3]) : NaN;
          } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(p) {
            return p ? Date.UTC(+p[3], +p[2] - 1, +p[1]) : NaN;
          }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(p) {
            return p ? Date.UTC(+p[3], +p[1] - 1, +p[2]) : NaN;
          } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(p) {
            if (!p) return NaN;
            let b = /* @__PURE__ */ new Date(), c = +p[3];
            return c > b.getFullYear() - 2e3 ? c += 1900 : c += 2e3, Date.UTC(c, +p[2] - 1, +p[1]);
          }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(p) {
            return p ? Date.UTC(+p[3] + 2e3, +p[1] - 1, +p[2]) : NaN;
          } } }, this.chart = s, this.chartOptions = r, this.options = d, this.rawColumns = [], this.init(d, r, s);
        }
        init(d, r, s) {
          let p = d.decimalPoint, b;
          r && (this.chartOptions = r), s && (this.chart = s), p !== "." && p !== "," && (p = void 0), this.options = d, this.columns = d.columns || this.rowsToColumns(d.rows) || [], this.firstRowAsNames = C(d.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = p && RegExp("^(-?[0-9]+)" + p + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), b = !_(d)), b || (b = this.fetchLiveData()), b || (b = !!this.parseCSV().length), b || (b = !!this.parseTable().length), b || (b = this.parseGoogleSpreadsheet()), !b && d.afterComplete && d.afterComplete(this);
        }
        getColumnDistribution() {
          var z, W;
          let d = this.chartOptions, r = this.options, s = [], p = function(G = "line") {
            return (T[G].prototype.pointArrayMap || [0]).length;
          }, b = function(G = "line") {
            return T[G].prototype.pointArrayMap;
          }, c = (z = d == null ? void 0 : d.chart) == null ? void 0 : z.type, h = [], g = [], k = (r == null ? void 0 : r.seriesMapping) || ((W = d == null ? void 0 : d.series) == null ? void 0 : W.map(function() {
            return { x: 0 };
          })) || [], P = 0;
          ((d == null ? void 0 : d.series) || []).forEach((G) => {
            h.push(p(G.type || c));
          }), k.forEach((G) => {
            s.push(G.x || 0);
          }), s.length === 0 && s.push(0), k.forEach((G) => {
            var $, K;
            let Y = new v(), U = h[P] || p(c), H = (K = (($ = d == null ? void 0 : d.series) != null ? $ : [])[P]) != null ? K : {}, q = b(H.type || c), X = q != null ? q : ["y"];
            (S(G.x) || H.isCartesian || !q) && Y.addColumnReader(G.x, "x"), m(G, function(V, Q) {
              Q !== "x" && Y.addColumnReader(V, Q);
            });
            for (let V = 0; V < U; V++) Y.hasReader(X[V]) || Y.addColumnReader(void 0, X[V]);
            g.push(Y), P++;
          });
          let O = b(c);
          O === void 0 && (O = ["y"]), this.valueCount = { global: p(c), xColumns: s, individual: h, seriesBuilders: g, globalPointArrayMap: O };
        }
        dataFound() {
          this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
        }
        parseCSV(d) {
          let r = this, s = this.columns = [], p = d || this.options, b = p.startColumn || 0, c = p.endColumn || Number.MAX_VALUE, h = [], g = { ",": 0, ";": 0, "	": 0 }, k = p.csv, P = p.startRow || 0, O = p.endRow || Number.MAX_VALUE, z, W, G = 0;
          if (k && p.beforeParse && (k = p.beforeParse.call(this, k)), k) {
            if (W = k.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(p.lineDelimiter || `
`), (!P || P < 0) && (P = 0), (!O || O >= W.length) && (O = W.length - 1), p.itemDelimiter) z = p.itemDelimiter;
            else {
              let U, H, q;
              U = 0, H = 0, q = !1, W.some(function(X, $) {
                let K = !1, V, Q, Z, ee = "";
                if ($ > 13) return !0;
                for (let J = 0; J < X.length; J++) {
                  if (V = X[J], Q = X[J + 1], Z = X[J - 1], V === "#") return;
                  if (V === '"')
                    if (K) {
                      if (Z !== '"' && Q !== '"') {
                        for (; Q === " " && J < X.length; ) Q = X[++J];
                        g[Q] !== void 0 && g[Q]++, K = !1;
                      }
                    } else K = !0;
                  else g[V] !== void 0 ? (isNaN(Date.parse(ee = ee.trim())) ? (isNaN(ee) || !isFinite(ee)) && g[V]++ : g[V]++, ee = "") : ee += V;
                  V === "," && H++, V === "." && U++;
                }
              }), g[";"] > g[","] ? q = ";" : (g[","], g[";"], q = ","), p.decimalPoint || (U > H ? p.decimalPoint = "." : p.decimalPoint = ",", r.decimalRegex = RegExp("^(-?[0-9]+)" + p.decimalPoint + "([0-9]+)$")), z = q;
            }
            let Y = 0;
            for (G = P; G <= O; G++) W[G][0] === "#" ? Y++ : function(U, H, q, X) {
              let $ = 0, K = "", V = "", Q = "", Z = "", ee = 0, J = 0;
              function ie(he) {
                K = U[he], V = U[he - 1], Q = U[he + 1];
              }
              function re(he) {
                h.length < J + 1 && h.push([he]), h[J][h[J].length - 1] !== he && h[J].push(he);
              }
              function ce() {
                if (b > ee || ee > c) {
                  ++ee, Z = "";
                  return;
                }
                p.columnTypes || (!isNaN(parseFloat(Z)) && isFinite(Z) ? (Z = parseFloat(Z), re("number")) : isNaN(Date.parse(Z)) ? re("string") : (Z = Z.replace(/\//g, "-"), re("date"))), s.length < J + 1 && s.push([]), s[J][H] = Z, Z = "", ++J, ++ee;
              }
              if (U.trim().length && U.trim()[0] !== "#") {
                for (; $ < U.length; $++) if (ie($), K === '"') for (ie(++$); $ < U.length && (K !== '"' || V === '"' || Q === '"'); ) (K !== '"' || K === '"' && V !== '"') && (Z += K), ie(++$);
                else K === z ? ce() : Z += K;
                ce();
              }
            }(W[G], G - P - Y);
            (!p.columnTypes || p.columnTypes.length === 0) && h.length && h[0].length && h[0][1] === "date" && !p.dateFormat && (p.dateFormat = function(U, H) {
              var ie;
              let q = "YYYY/mm/dd", X = [], $ = [], K, V = [], Q, Z = 0, ee = !1, J;
              for ((!H || H > U.length) && (H = U.length); Z < H; Z++) if (U[Z] !== void 0 && ((ie = U[Z]) != null && ie.length)) for (J = 0, K = U[Z].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), V = ["", "", ""]; J < K.length; J++) J < V.length && (K[J] = parseInt(K[J], 10), K[J] && ($[J] = !$[J] || $[J] < K[J] ? K[J] : $[J], X[J] !== void 0 ? X[J] !== K[J] && (X[J] = !1) : X[J] = K[J], K[J] > 31 ? K[J] < 100 ? V[J] = "YY" : V[J] = "YYYY" : K[J] > 12 && K[J] <= 31 ? (V[J] = "dd", ee = !0) : V[J].length || (V[J] = "mm")));
              if (ee) {
                for (J = 0; J < X.length; J++) X[J] !== !1 ? $[J] > 12 && V[J] !== "YY" && V[J] !== "YYYY" && (V[J] = "YY") : $[J] > 12 && V[J] === "mm" && (V[J] = "dd");
                return V.length === 3 && V[1] === "dd" && V[2] === "dd" && (V[2] = "YY"), Q = V.join("/"), (p.dateFormats || r.dateFormats)[Q] ? Q : (A(r, "deduceDateFailed"), q);
              }
              return q;
            }(s[0])), this.dataFound();
          }
          return s;
        }
        parseTable() {
          let d = this.options, r = this.columns || [], s = d.startRow || 0, p = d.endRow || Number.MAX_VALUE, b = d.startColumn || 0, c = d.endColumn || Number.MAX_VALUE;
          if (d.table) {
            let h = d.table;
            typeof h == "string" && (h = N.getElementById(h)), [].forEach.call(h.getElementsByTagName("tr"), (g, k) => {
              k >= s && k <= p && [].forEach.call(g.children, (P, O) => {
                let z = r[O - b], W = 1;
                if ((P.tagName === "TD" || P.tagName === "TH") && O >= b && O <= c) for (r[O - b] || (r[O - b] = []), r[O - b][k - s] = P.innerHTML; k - s >= W && z[k - s - W] === void 0; ) z[k - s - W] = null, W++;
              });
            }), this.dataFound();
          }
          return r;
        }
        fetchLiveData() {
          let d = this, r = this.chart, s = this.options, p = s.enablePolling, b = f(s), c = 0, h = 1e3 * (s.dataRefreshRate || 2);
          return !!_(s) && (h < 1e3 && (h = 1e3), delete s.csvURL, delete s.rowsURL, delete s.columnsURL, function g(k) {
            function P(O, z, W) {
              if (!O || !/^(http|\/|\.\/|\.\.\/)/.test(O)) return O && s.error && s.error("Invalid URL"), !1;
              function G() {
                p && r.liveDataURL === O && (d.liveDataTimeout = setTimeout(g, h));
              }
              return k && (clearTimeout(d.liveDataTimeout), r.liveDataURL = O), x({ url: O, dataType: W || "json", success: function(Y) {
                r != null && r.series && z(Y), G();
              }, error: function(Y, U) {
                var H;
                return ++c < 3 && G(), (H = s.error) == null ? void 0 : H.call(s, U, Y);
              } }), !0;
            }
            P(b.csvURL, function(O) {
              r.update({ data: { csv: O } });
            }, "text") || P(b.rowsURL, function(O) {
              r.update({ data: { rows: O } });
            }) || P(b.columnsURL, function(O) {
              r.update({ data: { columns: O } });
            });
          }(!0), _(s));
        }
        parseGoogleSpreadsheet() {
          let d = this, r = this.options, s = r.googleSpreadsheetKey, p = this.chart, b = Math.max(1e3 * (r.dataRefreshRate || 2), 4e3), c = () => {
            if (r.googleSpreadsheetRange) return r.googleSpreadsheetRange;
            let h = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", g = (h.charAt(r.startColumn || 0) || "A") + ((r.startRow || 0) + 1), k = h.charAt(C(r.endColumn, -1)) || "ZZ";
            return S(r.endRow) && (k += r.endRow + 1), `${g}:${k}`;
          };
          return s && (delete r.googleSpreadsheetKey, function h(g) {
            x({ url: ["https://sheets.googleapis.com/v4/spreadsheets", s, "values", c(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + r.googleAPIKey].join("/"), dataType: "json", success: function(k) {
              g(k), r.enablePolling && (d.liveDataTimeout = setTimeout(function() {
                h(g);
              }, b));
            }, error: function(k, P) {
              var O;
              return (O = r.error) == null ? void 0 : O.call(r, P, k);
            } });
          }(function(h) {
            let g = h.values;
            if (!g || g.length === 0) return !1;
            let k = g.reduce((P, O) => Math.max(P, O.length), 0);
            g.forEach((P) => {
              for (let O = 0; O < k; O++) P[O] === void 0 && (P[O] = null);
            }), p != null && p.series ? p.update({ data: { columns: g } }) : (d.columns = g, d.dataFound());
          })), !1;
        }
        trim(d, r) {
          return typeof d == "string" && (d = d.replace(/^\s+|\s+$/g, ""), r && /[\d\s]+/.test(d) && (d = d.replace(/\s/g, "")), this.decimalRegex && (d = d.replace(this.decimalRegex, "$1.$2"))), d;
        }
        parseTypes() {
          let d = this.columns || [], r = d.length;
          for (; r--; ) this.parseColumn(d[r], r);
        }
        parseColumn(d, r) {
          var $;
          let s = this.rawColumns, p = this.columns = this.columns || [], b = this.firstRowAsNames, c = (($ = this.valueCount) == null ? void 0 : $.xColumns.indexOf(r)) !== -1, h = [], g = this.chartOptions, k = (this.options.columnTypes || [])[r], P = c && (g == null ? void 0 : g.xAxis) && F(g.xAxis)[0].type === "category" || k === "string", O = S(d.name), z = d.length, W, G, Y, U, H, q, X;
          for (s[r] || (s[r] = []); z--; ) W = h[z] || d[z], Y = this.trim(W), G = parseFloat(U = this.trim(W, !0)), s[r][z] === void 0 && (s[r][z] = Y), P || z === 0 && b && !O ? d[z] = "" + Y : +U === G ? (d[z] = G, G > 31536e6 && k !== "float" ? d.isDatetime = !0 : d.isNumeric = !0, d[z + 1] !== void 0 && (X = G > d[z + 1])) : (Y != null && Y.length && (H = this.parseDate(W)), c && M(H) && k !== "float" ? (h[z] = W, d[z] = H, d.isDatetime = !0, d[z + 1] !== void 0 && ((q = H > d[z + 1]) !== X && X !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, z = d.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : d.unsorted = !0), X = q)) : (d[z] = Y === "" ? null : Y, z !== 0 && (d.isDatetime || d.isNumeric) && (d.mixed = !0)));
          if (c && d.mixed && (p[r] = s[r]), c && X && this.options.sort) {
            for (r = 0; r < p.length; r++) if (p[r].reverse(), b) {
              let K = p[r].pop();
              K && p[r].unshift(K);
            }
          }
        }
        parseDate(d) {
          let r = this.options.parseDate, s, p, b, c = this.options.dateFormat || this.dateFormat, h;
          if (r) s = r(d);
          else if (typeof d == "string") {
            if (c) (b = this.dateFormats[c]) || (b = this.dateFormats["YYYY/mm/dd"]), (h = d.match(b.regex)) && (s = b.parser(h));
            else for (p in this.dateFormats) if (b = this.dateFormats[p], h = d.match(b.regex)) {
              this.dateFormat = c = p, this.alternativeFormat = b.alternative, s = b.parser(h);
              break;
            }
            !h && (d.match(/:.+(GMT|UTC|[Z+\-])/) && (d = d.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (h = Date.parse(d)) == "object" && h !== null && h.getTime ? s = h.getTime() - 6e4 * h.getTimezoneOffset() : M(h) && (s = h - 6e4 * new Date(h).getTimezoneOffset()));
          }
          return s;
        }
        getData() {
          var d;
          if (this.columns) return (d = this.rowsToColumns(this.columns)) == null ? void 0 : d.slice(1);
        }
        parsed() {
          if (this.options.parsed) return this.options.parsed.call(this, this.columns);
        }
        complete() {
          var U, H, q, X, $;
          let d = this.columns = this.columns || [], r = this.options, s = [], p = "linear", b, c, h, g, k, P, O, z, W, G, Y;
          if (d.length, r.complete || r.afterComplete) {
            if (this.firstRowAsNames) for (h = 0; h < d.length; h++) {
              let K = d[h];
              S(K.name) || (K.name = C(K.shift(), "").toString());
            }
            for (P = 0, b = [], W = function(K, V) {
              let Q, Z, ee, J = [], ie = [];
              for (Z = 0; Z < K; Z += 1) J.push(!0);
              for (Q = 0; Q < V.length; Q += 1) for (Z = 0, ee = V[Q].getReferencedColumnIndexes(); Z < ee.length; Z += 1) J[ee[Z]] = !1;
              for (Z = 0; Z < J.length; Z += 1) J[Z] && ie.push(Z);
              return ie;
            }((d == null ? void 0 : d.length) || 0, this.valueCount.seriesBuilders); P < this.valueCount.seriesBuilders.length; P++) (z = this.valueCount.seriesBuilders[P]).populateColumns(W) && s.push(z);
            for (; W.length > 0; ) {
              for ((z = new v()).addColumnReader(0, "x"), (Y = W.indexOf(0)) !== -1 && W.splice(Y, 1), h = 0; h < this.valueCount.global; h++) z.addColumnReader(void 0, this.valueCount.globalPointArrayMap[h]);
              z.populateColumns(W) && s.push(z);
            }
            if (s.length > 0 && s[0].readers.length > 0 && (G = d == null ? void 0 : d[(U = s[0].readers[0].columnIndex) != null ? U : -1]) !== void 0 && (G.isDatetime ? p = "datetime" : G.isNumeric || (p = "category")), p === "category") for (P = 0; P < s.length; P++) for (k = 0, z = s[P]; k < z.readers.length; k++) z.readers[k].configName === "x" && (z.readers[k].configName = "name");
            for (P = 0; P < s.length; P++) {
              for (g = 0, z = s[P], c = []; g < d[0].length; g++) c[g] = z.read(d, g);
              b[P] = { data: c, pointStart: c[0] && (z.pointIsArray ? (H = c[0]) == null ? void 0 : H[0] : (q = c[0]) == null ? void 0 : q.x) || void 0 }, z.name && (b[P].name = z.name), p === "category" && (b[P].turboThreshold = 0, b[P].pointStart = 0);
            }
            O = { series: b }, p !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== p ? (this.xAxisOptions = { type: p }, p === "category" && (this.xAxisOptions.uniqueNames = !1)) : p = this.xAxisOptions = void 0, this.chart || f(!0, O, { xAxis: this.xAxisOptions || {} }), (X = r.complete) == null || X.call(r, O), ($ = r.afterComplete) == null || $.call(r, this, O);
          }
        }
        xAxisUpdateHandler(d) {
          let r = this.xAxisOptions;
          r && (!d.options.type && r.type && (d.type = r.type), d.options.uniqueNames || r.uniqueNames !== !1 || (d.uniqueNames = r.uniqueNames));
        }
        update(d, r) {
          var b;
          let s = this.chart, p = s.options;
          d && (d.afterComplete = function(c, h) {
            if (!h) return;
            let g = s.xAxis[0], k = c.xAxisOptions;
            k && g && (g.type !== k.type && !g.options.type || g.uniqueNames && k.uniqueNames === !1 && g.options.uniqueNames === void 0) ? g.update({}, !1) : ((h == null ? void 0 : h.series) || []).forEach(function(P) {
              delete P.pointStart;
            }), s.update(h, r, !0);
          }, f(!0, p.data, d), (b = p.data) != null && b.googleSpreadsheetKey && !d.columns && delete p.data.columns, this.init(p.data || {}, p));
        }
      }
      y(o, "afterSetOptions", function() {
        var w;
        this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((w = this.chart.data) == null || w.xAxisUpdateHandler(this));
      }), y(n, "init", function(w) {
        let d = this, r = w.args[1], s = R().data, p = w.args[0] || {};
        if ((s || p && p.data) && !d.hasDataDef) {
          d.hasDataDef = !0;
          let b = f(s, p.data);
          d.data = new E(u(b, { afterComplete: function(c, h) {
            var P, O, z, W;
            let g, k;
            if (Object.hasOwnProperty.call(p, "series"))
              if (typeof p.series == "object") for (g = Math.max(p.series.length, (O = (P = h == null ? void 0 : h.series) == null ? void 0 : P.length) != null ? O : 0); g--; ) k = p.series[g] || {}, p.series[g] = f(k, (W = (z = h == null ? void 0 : h.series) == null ? void 0 : z[g]) != null ? W : {});
              else delete p.series;
            p = f(h, p), d.data = c, d.init(p, r);
          } }), p, d), w.preventDefault();
        }
      });
      class v {
        constructor() {
          this.readers = [], this.pointIsArray = !0;
        }
        populateColumns(d) {
          let r = !0;
          return this.readers.forEach((s) => {
            s.columnIndex === void 0 && (s.columnIndex = d.shift());
          }), this.readers.forEach((s) => {
            s.columnIndex === void 0 && (r = !1);
          }), r;
        }
        read(d, r) {
          let s = this.pointIsArray, p = s ? [] : {};
          if (this.readers.forEach((b) => {
            let c = d[b.columnIndex][r];
            s ? p.push(c) : b.configName.indexOf(".") > 0 ? j.prototype.setNestedProperty(p, c, b.configName) : p[b.configName] = c;
          }), this.name === void 0 && this.readers.length >= 2) {
            let b = [];
            this.readers.forEach(function(c) {
              (c.configName === "x" || c.configName === "name" || c.configName === "y") && c.columnIndex !== void 0 && b.push(c.columnIndex);
            }), b.length >= 2 && (b.shift(), b.sort(function(c, h) {
              return c - h;
            })), this.name = d[C(b.shift(), 0)].name;
          }
          return p;
        }
        addColumnReader(d, r) {
          this.readers.push({ columnIndex: d, configName: r }), r === "x" || r === "y" || r === void 0 || (this.pointIsArray = !1);
        }
        getReferencedColumnIndexes() {
          let d, r, s = [];
          for (d = 0; d < this.readers.length; d += 1) (r = this.readers[d]).columnIndex !== void 0 && s.push(r.columnIndex);
          return s;
        }
        hasReader(d) {
          let r;
          for (r = 0; r < this.readers.length; r += 1) if (this.readers[r].configName === d) return !0;
        }
      }
      return E;
    }), i(e, "masters/modules/data.src.js", [e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Extensions/Data.js"]], function(o, n, l) {
      return o.Data = o.Data || l, o.HttpUtilities = o.HttpUtilities || n, o.ajax = o.HttpUtilities.ajax, o.data = o.Data.data, o.getJSON = o.HttpUtilities.getJSON, o.post = o.HttpUtilities.post, o;
    });
  });
})(Tf);
var HC = Tf.exports;
const KC = /* @__PURE__ */ ri(HC);
var Lf = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Extensions/DownloadURL.js", [e["Core/Globals.js"]], function(o) {
      let { isSafari: n, win: l, win: { document: L } } = o, D = l.URL || l.webkitURL || l;
      function j(I) {
        let B = I.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (B && B.length > 3 && l.atob && l.ArrayBuffer && l.Uint8Array && l.Blob && D.createObjectURL) {
          let R = l.atob(B[3]), N = new l.ArrayBuffer(R.length), x = new l.Uint8Array(N);
          for (let T = 0; T < x.length; ++T) x[T] = R.charCodeAt(T);
          return D.createObjectURL(new l.Blob([x], { type: B[1] }));
        }
      }
      return { dataURLtoBlob: j, downloadURL: function(I, B) {
        let R = l.navigator, N = L.createElement("a");
        if (typeof I != "string" && !(I instanceof String) && R.msSaveOrOpenBlob) {
          R.msSaveOrOpenBlob(I, B);
          return;
        }
        if (I = "" + I, R.userAgent.length > 1e3) throw Error("Input too long");
        let x = /Edge\/\d+/.test(R.userAgent);
        if ((n && typeof I == "string" && I.indexOf("data:application/pdf") === 0 || x || I.length > 2e6) && !(I = j(I) || "")) throw Error("Failed to convert to blob");
        if (N.download !== void 0) N.href = I, N.download = B, L.body.appendChild(N), N.click(), L.body.removeChild(N);
        else try {
          if (!l.open(I, "chart")) throw Error("Failed to open window");
        } catch {
          l.location.href = I;
        }
      } };
    }), i(e, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), i(e, "Extensions/ExportData/ExportData.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Defaults.js"], e["Extensions/DownloadURL.js"], e["Extensions/ExportData/ExportDataDefaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { getOptions: I, setOptions: B } = n, { downloadURL: R } = l, { doc: N, win: x } = D, { addEvent: T, defined: y, extend: S, find: u, fireEvent: A, isNumber: M, pick: f } = j;
      function m(g) {
        var O;
        let k = !!((O = this.options.exporting) != null && O.showExportInProgress), P = x.requestAnimationFrame || setTimeout;
        P(() => {
          k && this.showLoading(this.options.lang.exportInProgress), P(() => {
            try {
              g.call(this);
            } finally {
              k && this.hideLoading();
            }
          });
        });
      }
      function C() {
        m.call(this, () => {
          let g = this.getCSV(!0);
          R(p(g, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(g), this.getFilename() + ".csv");
        });
      }
      function F() {
        m.call(this, () => {
          let g = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
          R(p(g, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + x.btoa(unescape(encodeURIComponent(g))), this.getFilename() + ".xls");
        });
      }
      function _(g) {
        let k = "", P = this.getDataRows(), O = this.options.exporting.csv, z = f(O.decimalPoint, O.itemDelimiter !== "," && g ? 1.1.toLocaleString()[1] : "."), W = f(O.itemDelimiter, z === "," ? ";" : ","), G = O.lineDelimiter;
        return P.forEach((Y, U) => {
          let H = "", q = Y.length;
          for (; q--; ) typeof (H = Y[q]) == "string" && (H = `"${H}"`), typeof H == "number" && z !== "." && (H = H.toString().replace(".", z)), Y[q] = H;
          Y.length = P.length ? P[0].length : 0, k += Y.join(W), U < P.length - 1 && (k += G);
        }), k;
      }
      function E(g) {
        let k, P, O = this.hasParallelCoordinates, z = this.time, W = this.options.exporting && this.options.exporting.csv || {}, G = this.xAxis, Y = {}, U = [], H = [], q = [], X = this.options.lang.exportData, $ = X.categoryHeader, K = X.categoryDatetimeHeader, V = function(oe, se, te) {
          if (W.columnHeaderFormatter) {
            let ae = W.columnHeaderFormatter(oe, se, te);
            if (ae !== !1) return ae;
          }
          return oe ? oe.bindAxes ? g ? { columnTitle: te > 1 ? se : oe.name, topLevelColumnTitle: oe.name } : oe.name + (te > 1 ? " (" + se + ")" : "") : oe.options.title && oe.options.title.text || (oe.dateTime ? K : $) : $;
        }, Q = function(oe, se, te) {
          let ae = {}, le = {};
          return se.forEach(function(de) {
            let be = (oe.keyToAxis && oe.keyToAxis[de] || de) + "Axis", ge = M(te) ? oe.chart[be][te] : oe[be];
            ae[de] = ge && ge.categories || [], le[de] = ge && ge.dateTime;
          }), { categoryMap: ae, dateTimeValueAxisMap: le };
        }, Z = function(oe, se) {
          let te = oe.pointArrayMap || ["y"];
          return oe.data.some((ae) => ae.y !== void 0 && ae.name) && se && !se.categories && oe.exportKey !== "name" ? ["x", ...te] : te;
        }, ee = [], J, ie, re, ce = 0, he, ne;
        for (he in this.series.forEach(function(oe) {
          let se = oe.options.keys, te = oe.xAxis, ae = se || Z(oe, te), le = ae.length, de = !oe.requireSorting && {}, be = G.indexOf(te), ge = Q(oe, ae), me, fe;
          if (oe.options.includeInDataExport !== !1 && !oe.options.isInternal && oe.visible !== !1) {
            for (u(ee, function(Ae) {
              return Ae[0] === be;
            }) || ee.push([be, ce]), fe = 0; fe < le; ) re = V(oe, ae[fe], ae.length), q.push(re.columnTitle || re), g && H.push(re.topLevelColumnTitle || re), fe++;
            me = { chart: oe.chart, autoIncrement: oe.autoIncrement, options: oe.options, pointArrayMap: oe.pointArrayMap, index: oe.index }, oe.options.data.forEach(function(Ae, ye) {
              var Ne;
              let xe, we, ke, Oe = { series: me };
              O && (ge = Q(oe, ae, ye)), oe.pointClass.prototype.applyOptions.apply(Oe, [Ae]);
              let Me = oe.data[ye] && oe.data[ye].name;
              if (xe = ((Ne = Oe.x) != null ? Ne : "") + "," + Me, fe = 0, (!te || oe.exportKey === "name" || !O && te && te.hasNames && Me) && (xe = Me), de && (de[xe] && (xe += "|" + ye), de[xe] = !0), Y[xe]) {
                let Ke = `${xe},${Y[xe].pointers[oe.index]}`, He = xe;
                Y[xe].pointers[oe.index] && (Y[Ke] || (Y[Ke] = [], Y[Ke].xValues = [], Y[Ke].pointers = []), xe = Ke), Y[He].pointers[oe.index] += 1;
              } else {
                Y[xe] = [], Y[xe].xValues = [];
                let Ke = [];
                for (let He = 0; He < oe.chart.series.length; He++) Ke[He] = 0;
                Y[xe].pointers = Ke, Y[xe].pointers[oe.index] = 1;
              }
              for (Y[xe].x = Oe.x, Y[xe].name = Me, Y[xe].xValues[be] = Oe.x; fe < le; ) ke = Oe[we = ae[fe]], Y[xe][ce + fe] = f(ge.categoryMap[we][ke], ge.dateTimeValueAxisMap[we] ? z.dateFormat(W.dateFormat, ke) : null, ke), fe++;
            }), ce += fe;
          }
        }), Y) Object.hasOwnProperty.call(Y, he) && U.push(Y[he]);
        for (ie = g ? [H, q] : [q], ce = ee.length; ce--; ) k = ee[ce][0], P = ee[ce][1], J = G[k], U.sort(function(oe, se) {
          return oe.xValues[k] - se.xValues[k];
        }), ne = V(J), ie[0].splice(P, 0, ne), g && ie[1] && ie[1].splice(P, 0, ne), U.forEach(function(oe) {
          let se = oe.name;
          J && !y(se) && (J.dateTime ? (oe.x instanceof Date && (oe.x = oe.x.getTime()), se = z.dateFormat(W.dateFormat, oe.x)) : se = J.categories ? f(J.names[oe.x], J.categories[oe.x], oe.x) : oe.x), oe.splice(P, 0, se);
        });
        return A(this, "exportData", { dataRows: ie = ie.concat(U) }), ie;
      }
      function v(g) {
        let k = (P) => {
          if (!P.tagName || P.tagName === "#text") return P.textContent || "";
          let O = P.attributes, z = `<${P.tagName}`;
          return O && Object.keys(O).forEach((W) => {
            let G = O[W];
            z += ` ${W}="${G}"`;
          }), z += ">" + (P.textContent || ""), (P.children || []).forEach((W) => {
            z += k(W);
          }), z += `</${P.tagName}>`;
        };
        return k(this.getTableAST(g));
      }
      function w(g) {
        let k = 0, P = [], O = this.options, z = g ? 1.1.toLocaleString()[1] : ".", W = f(O.exporting.useMultiLevelHeaders, !0), G = this.getDataRows(W), Y = W ? G.shift() : null, U = G.shift(), H = function(K, V) {
          let Q = K.length;
          if (V.length !== Q) return !1;
          for (; Q--; ) if (K[Q] !== V[Q]) return !1;
          return !0;
        }, q = function(K, V, Q, Z) {
          let ee = f(Z, ""), J = "highcharts-text" + (V ? " " + V : "");
          return typeof ee == "number" ? (ee = ee.toString(), z === "," && (ee = ee.replace(".", z)), J = "highcharts-number") : Z || (J = "highcharts-empty"), { tagName: K, attributes: Q = S({ class: J }, Q), textContent: ee };
        };
        O.exporting.tableCaption !== !1 && P.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: f(O.exporting.tableCaption, O.title.text ? O.title.text : "Chart") });
        for (let K = 0, V = G.length; K < V; ++K) G[K].length > k && (k = G[K].length);
        P.push(function(K, V, Q) {
          let Z = [], ee = 0, J = Q || V && V.length, ie, re = 0, ce;
          if (W && K && V && !H(K, V)) {
            let he = [];
            for (; ee < J; ++ee) if ((ie = K[ee]) === K[ee + 1]) ++re;
            else if (re) he.push(q("th", "highcharts-table-topheading", { scope: "col", colspan: re + 1 }, ie)), re = 0;
            else {
              ie === V[ee] ? O.exporting.useRowspanHeaders ? (ce = 2, delete V[ee]) : (ce = 1, V[ee] = "") : ce = 1;
              let ne = q("th", "highcharts-table-topheading", { scope: "col" }, ie);
              ce > 1 && ne.attributes && (ne.attributes.valign = "top", ne.attributes.rowspan = ce), he.push(ne);
            }
            Z.push({ tagName: "tr", children: he });
          }
          if (V) {
            let he = [];
            for (ee = 0, J = V.length; ee < J; ++ee) V[ee] !== void 0 && he.push(q("th", null, { scope: "col" }, V[ee]));
            Z.push({ tagName: "tr", children: he });
          }
          return { tagName: "thead", children: Z };
        }(Y, U, Math.max(k, U.length)));
        let X = [];
        G.forEach(function(K) {
          let V = [];
          for (let Q = 0; Q < k; Q++) V.push(q(Q ? "td" : "th", null, Q ? {} : { scope: "row" }, K[Q]));
          X.push({ tagName: "tr", children: V });
        }), P.push({ tagName: "tbody", children: X });
        let $ = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: P } };
        return A(this, "aftergetTableAST", $), $.tree;
      }
      function d() {
        this.toggleDataTable(!1);
      }
      function r(g) {
        let k = (g = f(g, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (k && (this.dataTableDiv = N.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let G = this.dataTableDiv.style, Y = G.display;
          G.display = g ? "block" : "none", g ? (this.dataTableDiv.innerHTML = o.emptyHTML, new o([this.getTableAST()]).addToDOM(this.dataTableDiv), A(this, "afterViewData", { element: this.dataTableDiv, wasHidden: k || Y !== G.display })) : A(this, "afterHideData");
        }
        this.isDataTableVisible = g;
        let P = this.exportDivElements, O = this.options.exporting, z = O && O.buttons && O.buttons.contextButton.menuItems, W = this.options.lang;
        if (O && O.menuItemDefinitions && W && W.viewData && W.hideData && z && P) {
          let G = P[z.indexOf("viewData")];
          G && o.setElementHTML(G, this.isDataTableVisible ? W.hideData : W.viewData);
        }
      }
      function s() {
        this.toggleDataTable(!0);
      }
      function p(g, k) {
        let P = x.navigator, O = x.URL || x.webkitURL || x;
        try {
          if (P.msSaveOrOpenBlob && x.MSBlobBuilder) {
            let z = new x.MSBlobBuilder();
            return z.append(g), z.getBlob("image/svg+xml");
          }
          return O.createObjectURL(new x.Blob(["\uFEFF" + g], { type: k }));
        } catch {
        }
      }
      function b() {
        let g = this, k = g.dataTableDiv, P = (z, W) => z.children[W].textContent, O = (z, W) => (G, Y) => {
          let U, H;
          return U = P(W ? G : Y, z), H = P(W ? Y : G, z), U === "" || H === "" || isNaN(U) || isNaN(H) ? U.toString().localeCompare(H) : U - H;
        };
        if (k && g.options.exporting && g.options.exporting.allowTableSorting) {
          let z = k.querySelector("thead tr");
          z && z.childNodes.forEach((W) => {
            let G = W.closest("table");
            W.addEventListener("click", function() {
              let Y = [...k.querySelectorAll("tr:not(thead tr)")], U = [...W.parentNode.children];
              Y.sort(O(U.indexOf(W), g.ascendingOrderInTable = !g.ascendingOrderInTable)).forEach((H) => {
                G.appendChild(H);
              }), U.forEach((H) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((q) => {
                  H.classList.contains(q) && H.classList.remove(q);
                });
              }), W.classList.add(g.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function c() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function h() {
        var g;
        (g = this.dataTableDiv) == null || g.remove();
      }
      return { compose: function(g, k) {
        let P = g.prototype;
        if (!P.getCSV) {
          let O = I().exporting;
          T(g, "afterViewData", b), T(g, "render", c), T(g, "destroy", h), P.downloadCSV = C, P.downloadXLS = F, P.getCSV = _, P.getDataRows = E, P.getTable = v, P.getTableAST = w, P.hideData = d, P.toggleDataTable = r, P.viewData = s, O && (S(O.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            m.call(this, this.toggleDataTable);
          } } }), O.buttons && O.buttons.contextButton.menuItems && O.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), B(L);
          let { arearange: z, gantt: W, map: G, mapbubble: Y, treemap: U, xrange: H } = k.types;
          z && (z.prototype.keyToAxis = { low: "y", high: "y" }), W && (W.prototype.exportKey = "name", W.prototype.keyToAxis = { start: "x", end: "x" }), G && (G.prototype.exportKey = "name"), Y && (Y.prototype.exportKey = "name"), U && (U.prototype.exportKey = "name"), H && (H.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), i(e, "masters/modules/export-data.src.js", [e["Core/Globals.js"], e["Extensions/DownloadURL.js"], e["Extensions/ExportData/ExportData.js"]], function(o, n, l) {
      return o.dataURLtoBlob = o.dataURLtoBlob || n.dataURLtoBlob, o.downloadURL = o.downloadURL || n.downloadURL, l.compose(o.Chart, o.Series), o;
    });
  });
})(Lf);
var GC = Lf.exports;
const WC = /* @__PURE__ */ ri(GC);
var Of = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var o;
      return function(n) {
        n.compose = function(L) {
          return L.navigation || (L.navigation = new l(L)), L;
        };
        class l {
          constructor(D) {
            this.updates = [], this.chart = D;
          }
          addUpdate(D) {
            this.chart.navigation.updates.push(D);
          }
          update(D, j) {
            this.updates.forEach((I) => {
              I.call(this.chart, D, j);
            });
          }
        }
        n.Additions = l;
      }(o || (o = {})), o;
    }), i(e, "Extensions/Exporting/ExportingDefaults.js", [e["Core/Globals.js"]], function(o) {
      let { isTouchDevice: n } = o;
      return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: n ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), i(e, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var o;
      return function(n) {
        let l = [];
        function L(j, I, B, R) {
          return [["M", j, I + 2.5], ["L", j + B, I + 2.5], ["M", j, I + R / 2 + 0.5], ["L", j + B, I + R / 2 + 0.5], ["M", j, I + R - 1.5], ["L", j + B, I + R - 1.5]];
        }
        function D(j, I, B, R) {
          let N = R / 3 - 2;
          return [].concat(this.circle(B - N, I, N, N), this.circle(B - N, I + N + 4, N, N), this.circle(B - N, I + 2 * (N + 4), N, N));
        }
        n.compose = function(j) {
          if (l.indexOf(j) === -1) {
            l.push(j);
            let I = j.prototype.symbols;
            I.menu = L, I.menuball = D.bind(I);
          }
        };
      }(o || (o = {})), o;
    }), i(e, "Extensions/Exporting/Fullscreen.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { composed: L } = n, { addEvent: D, fireEvent: j, pushUnique: I } = l;
      function B() {
        this.fullscreen = new R(this);
      }
      class R {
        static compose(x) {
          I(L, "Fullscreen") && D(x, "beforeRender", B);
        }
        constructor(x) {
          this.chart = x, this.isOpen = !1;
          let T = x.renderTo;
          !this.browserProps && (typeof T.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : T.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : T.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : T.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let x = this, T = x.chart, y = T.options.chart;
          j(T, "fullscreenClose", null, function() {
            x.isOpen && x.browserProps && T.container.ownerDocument instanceof Document && T.container.ownerDocument[x.browserProps.exitFullscreen](), x.unbindFullscreenEvent && (x.unbindFullscreenEvent = x.unbindFullscreenEvent()), T.setSize(x.origWidth, x.origHeight, !1), x.origWidth = void 0, x.origHeight = void 0, y.width = x.origWidthOption, y.height = x.origHeightOption, x.origWidthOption = void 0, x.origHeightOption = void 0, x.isOpen = !1, x.setButtonText();
          });
        }
        open() {
          let x = this, T = x.chart, y = T.options.chart;
          j(T, "fullscreenOpen", null, function() {
            if (y && (x.origWidthOption = y.width, x.origHeightOption = y.height), x.origWidth = T.chartWidth, x.origHeight = T.chartHeight, x.browserProps) {
              let S = D(T.container.ownerDocument, x.browserProps.fullscreenChange, function() {
                x.isOpen ? (x.isOpen = !1, x.close()) : (T.setSize(null, null, !1), x.isOpen = !0, x.setButtonText());
              }), u = D(T, "destroy", S);
              x.unbindFullscreenEvent = () => {
                S(), u();
              };
              let A = T.renderTo[x.browserProps.requestFullscreen]();
              A && A.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let x = this.chart, T = x.exportDivElements, y = x.options.exporting, S = y && y.buttons && y.buttons.contextButton.menuItems, u = x.options.lang;
          if (y && y.menuItemDefinitions && u && u.exitFullscreen && u.viewFullscreen && S && T) {
            let A = T[S.indexOf("viewFullscreen")];
            A && o.setElementHTML(A, this.isOpen ? u.exitFullscreen : y.menuItemDefinitions.viewFullscreen.text || u.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return R;
    }), i(e, "Core/HttpUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { win: l } = o, { discardElement: L, objectEach: D } = n, j = { ajax: function(I) {
        let B = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, R = new XMLHttpRequest();
        function N(x, T) {
          I.error && I.error(x, T);
        }
        if (!I.url) return !1;
        R.open((I.type || "get").toUpperCase(), I.url, !0), I.headers && I.headers["Content-Type"] || R.setRequestHeader("Content-Type", B[I.dataType || "json"] || B.text), D(I.headers, function(x, T) {
          R.setRequestHeader(T, x);
        }), I.responseType && (R.responseType = I.responseType), R.onreadystatechange = function() {
          let x;
          if (R.readyState === 4) {
            if (R.status === 200) {
              if (I.responseType !== "blob" && (x = R.responseText, I.dataType === "json")) try {
                x = JSON.parse(x);
              } catch (T) {
                if (T instanceof Error) return N(R, T);
              }
              return I.success && I.success(x, R);
            }
            N(R, R.responseText);
          }
        }, I.data && typeof I.data != "string" && (I.data = JSON.stringify(I.data)), R.send(I.data);
      }, getJSON: function(I, B) {
        j.ajax({ url: I, success: B, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(I, B, R) {
        let N = new l.FormData();
        D(B, function(y, S) {
          N.append(S, y);
        }), N.append("b64", "true");
        let { filename: x, type: T } = B;
        return l.fetch(I, { method: "POST", body: N, ...R }).then((y) => {
          y.ok && y.text().then((S) => {
            let u = document.createElement("a");
            u.href = `data:${T};base64,${S}`, u.download = x, u.click(), L(u);
          });
        });
      } };
      return j;
    }), i(e, "Extensions/Exporting/Exporting.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Chart/Chart.js"], e["Core/Chart/ChartNavigationComposition.js"], e["Core/Defaults.js"], e["Extensions/Exporting/ExportingDefaults.js"], e["Extensions/Exporting/ExportingSymbols.js"], e["Extensions/Exporting/Fullscreen.js"], e["Core/Globals.js"], e["Core/HttpUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R, N) {
      var x;
      let { defaultOptions: T } = L, { doc: y, SVG_NS: S, win: u } = B, { addEvent: A, css: M, createElement: f, discardElement: m, extend: C, find: F, fireEvent: _, isObject: E, merge: v, objectEach: w, pick: d, removeEvent: r, uniqueKey: s } = N;
      return function(p) {
        let b, c = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], h = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        p.inlineAllowlist = [];
        let g = ["clipPath", "defs", "desc"];
        function k(J) {
          let ie, re, ce = this, he = ce.renderer, ne = v(ce.options.navigation.buttonOptions, J), oe = ne.onclick, se = ne.menuItems, te = ne.symbolSize || 12;
          if (ce.btnCount || (ce.btnCount = 0), ce.exportDivElements || (ce.exportDivElements = [], ce.exportSVGElements = []), ne.enabled === !1 || !ne.theme) return;
          let ae = ce.styledMode ? {} : ne.theme;
          oe ? re = function(de) {
            de && de.stopPropagation(), oe.call(ce, de);
          } : se && (re = function(de) {
            de && de.stopPropagation(), ce.contextMenu(le.menuClassName, se, le.translateX || 0, le.translateY || 0, le.width || 0, le.height || 0, le), le.setState(2);
          }), ne.text && ne.symbol ? ae.paddingLeft = d(ae.paddingLeft, 30) : ne.text || C(ae, { width: ne.width, height: ne.height, padding: 0 });
          let le = he.button(ne.text, 0, 0, re, ae, void 0, void 0, void 0, void 0, ne.useHTML).addClass(J.className).attr({ title: d(ce.options.lang[ne._titleKey || ne.titleKey], "") });
          le.menuClassName = J.menuClassName || "highcharts-menu-" + ce.btnCount++, ne.symbol && (ie = he.symbol(ne.symbol, Math.round((ne.symbolX || 0) - te / 2), Math.round((ne.symbolY || 0) - te / 2), te, te, { width: te, height: te }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(le), ce.styledMode || ie.attr({ stroke: ne.symbolStroke, fill: ne.symbolFill, "stroke-width": ne.symbolStrokeWidth || 1 })), le.add(ce.exportingGroup).align(C(ne, { width: le.width, x: d(ne.x, ce.buttonOffset) }), !0, "spacingBox"), ce.buttonOffset += ((le.width || 0) + ne.buttonSpacing) * (ne.align === "right" ? -1 : 1), ce.exportSVGElements.push(le, ie);
        }
        function P() {
          if (!this.printReverseInfo) return;
          let { childNodes: J, origDisplay: ie, resetParams: re } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(J, function(ce, he) {
            ce.nodeType === 1 && (ce.style.display = ie[he] || "");
          }), this.isPrinting = !1, re && this.setSize.apply(this, re), delete this.printReverseInfo, b = void 0, _(this, "afterPrint");
        }
        function O() {
          var ce;
          let J = y.body, ie = this.options.exporting.printMaxWidth, re = { childNodes: J.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = !0, (ce = this.pointer) == null || ce.reset(void 0, 0), _(this, "beforePrint"), ie && this.chartWidth > ie && (re.resetParams = [this.options.chart.width, void 0, !1], this.setSize(ie, void 0, !1)), [].forEach.call(re.childNodes, function(he, ne) {
            he.nodeType === 1 && (re.origDisplay[ne] = he.style.display, he.style.display = "none");
          }), this.moveContainers(J), this.printReverseInfo = re;
        }
        function z(J) {
          J.renderExporting(), A(J, "redraw", J.renderExporting), A(J, "destroy", J.destroyExport);
        }
        function W(J, ie, re, ce, he, ne, oe) {
          var Ae, ye;
          let se = this, te = se.options.navigation, ae = se.chartWidth, le = se.chartHeight, de = "cache-" + J, be = Math.max(he, ne), ge, me = se[de];
          me || (se.exportContextMenu = se[de] = me = f("div", { className: J }, { position: "absolute", zIndex: 1e3, padding: be + "px", pointerEvents: "auto", ...se.renderer.style }, ((Ae = se.scrollablePlotArea) == null ? void 0 : Ae.fixedDiv) || se.container), ge = f("ul", { className: "highcharts-menu" }, se.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, me), se.styledMode || M(ge, C({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, te.menuStyle)), me.hideMenu = function() {
            M(me, { display: "none" }), oe && oe.setState(0), se.openMenu = !1, M(se.renderTo, { overflow: "hidden" }), M(se.container, { overflow: "hidden" }), N.clearTimeout(me.hideTimer), _(se, "exportMenuHidden");
          }, se.exportEvents.push(A(me, "mouseleave", function() {
            me.hideTimer = u.setTimeout(me.hideMenu, 500);
          }), A(me, "mouseenter", function() {
            N.clearTimeout(me.hideTimer);
          }), A(y, "mouseup", function(xe) {
            var we;
            (we = se.pointer) != null && we.inClass(xe.target, J) || me.hideMenu();
          }), A(me, "click", function() {
            se.openMenu && me.hideMenu();
          })), ie.forEach(function(xe) {
            if (typeof xe == "string" && (xe = se.options.exporting.menuItemDefinitions[xe]), E(xe, !0)) {
              let we;
              xe.separator ? we = f("hr", void 0, void 0, ge) : (xe.textKey === "viewData" && se.isDataTableVisible && (xe.textKey = "hideData"), we = f("li", { className: "highcharts-menu-item", onclick: function(ke) {
                ke && ke.stopPropagation(), me.hideMenu(), typeof xe != "string" && xe.onclick && xe.onclick.apply(se, arguments);
              } }, void 0, ge), o.setElementHTML(we, xe.text || se.options.lang[xe.textKey]), se.styledMode || (we.onmouseover = function() {
                M(this, te.menuItemHoverStyle);
              }, we.onmouseout = function() {
                M(this, te.menuItemStyle);
              }, M(we, C({ cursor: "pointer" }, te.menuItemStyle || {})))), se.exportDivElements.push(we);
            }
          }), se.exportDivElements.push(ge, me), se.exportMenuWidth = me.offsetWidth, se.exportMenuHeight = me.offsetHeight);
          let fe = { display: "block" };
          re + (se.exportMenuWidth || 0) > ae ? fe.right = ae - re - he - be + "px" : fe.left = re - be + "px", ce + ne + (se.exportMenuHeight || 0) > le && ((ye = oe.alignOptions) == null ? void 0 : ye.verticalAlign) !== "top" ? fe.bottom = le - ce - be + "px" : fe.top = ce + ne - be + "px", M(me, fe), M(se.renderTo, { overflow: "" }), M(se.container, { overflow: "" }), se.openMenu = !0, _(se, "exportMenuShown");
        }
        function G(J) {
          let ie, re = J ? J.target : this, ce = re.exportSVGElements, he = re.exportDivElements, ne = re.exportEvents;
          ce && (ce.forEach((oe, se) => {
            oe && (oe.onclick = oe.ontouchstart = null, re[ie = "cache-" + oe.menuClassName] && delete re[ie], ce[se] = oe.destroy());
          }), ce.length = 0), re.exportingGroup && (re.exportingGroup.destroy(), delete re.exportingGroup), he && (he.forEach(function(oe, se) {
            oe && (N.clearTimeout(oe.hideTimer), r(oe, "mouseleave"), he[se] = oe.onmouseout = oe.onmouseover = oe.ontouchstart = oe.onclick = null, m(oe));
          }), he.length = 0), ne && (ne.forEach(function(oe) {
            oe();
          }), ne.length = 0);
        }
        function Y(J, ie) {
          let re = this.getSVGForExport(J, ie);
          J = v(this.options.exporting, J), R.post(J.url, { filename: J.filename ? J.filename.replace(/\//g, "-") : this.getFilename(), type: J.type, width: J.width, scale: J.scale, svg: re }, J.fetchOptions);
        }
        function U() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function H() {
          let J = this.userOptions.title && this.userOptions.title.text, ie = this.options.exporting.filename;
          return ie ? ie.replace(/\//g, "-") : (typeof J == "string" && (ie = J.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!ie || ie.length < 5) && (ie = "chart"), ie);
        }
        function q(J) {
          let ie, re, ce = v(this.options, J);
          ce.plotOptions = v(this.userOptions.plotOptions, J && J.plotOptions), ce.time = v(this.userOptions.time, J && J.time);
          let he = f("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, y.body), ne = this.renderTo.style.width, oe = this.renderTo.style.height, se = ce.exporting.sourceWidth || ce.chart.width || /px$/.test(ne) && parseInt(ne, 10) || (ce.isGantt ? 800 : 600), te = ce.exporting.sourceHeight || ce.chart.height || /px$/.test(oe) && parseInt(oe, 10) || 400;
          C(ce.chart, { animation: !1, renderTo: he, forExport: !0, renderer: "SVGRenderer", width: se, height: te }), ce.exporting.enabled = !1, delete ce.data, ce.series = [], this.series.forEach(function(de) {
            (re = v(de.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: de.visible })).isInternal || ce.series.push(re);
          });
          let ae = {};
          this.axes.forEach(function(de) {
            de.userOptions.internalKey || (de.userOptions.internalKey = s()), de.options.isInternal || (ae[de.coll] || (ae[de.coll] = !0, ce[de.coll] = []), ce[de.coll].push(v(de.userOptions, { visible: de.visible, type: de.type, uniqueNames: de.uniqueNames })));
          }), ce.colorAxis = this.userOptions.colorAxis;
          let le = new this.constructor(ce, this.callback);
          return J && ["xAxis", "yAxis", "series"].forEach(function(de) {
            let be = {};
            J[de] && (be[de] = J[de], le.update(be));
          }), this.axes.forEach(function(de) {
            let be = F(le.axes, function(Ae) {
              return Ae.options.internalKey === de.userOptions.internalKey;
            }), ge = de.getExtremes(), me = ge.userMin, fe = ge.userMax;
            be && (me !== void 0 && me !== be.min || fe !== void 0 && fe !== be.max) && be.setExtremes(me, fe, !0, !1);
          }), ie = le.getChartHTML(), _(this, "getSVG", { chartCopy: le }), ie = this.sanitizeSVG(ie, ce), ce = null, le.destroy(), m(he), ie;
        }
        function X(J, ie) {
          let re = this.options.exporting;
          return this.getSVG(v({ chart: { borderRadius: 0 } }, re.chartOptions, ie, { exporting: { sourceWidth: J && J.sourceWidth || re.sourceWidth, sourceHeight: J && J.sourceHeight || re.sourceHeight } }));
        }
        function $() {
          let J, ie = p.inlineAllowlist, re = {}, ce = y.createElement("iframe");
          M(ce, { width: "1px", height: "1px", visibility: "hidden" }), y.body.appendChild(ce);
          let he = ce.contentWindow && ce.contentWindow.document;
          he && he.body.appendChild(he.createElementNS(S, "svg")), function ne(oe) {
            let se, te, ae, le, de, be, ge = {};
            if (he && oe.nodeType === 1 && g.indexOf(oe.nodeName) === -1) {
              if (se = u.getComputedStyle(oe, null), te = oe.nodeName === "svg" ? {} : u.getComputedStyle(oe.parentNode, null), !re[oe.nodeName]) {
                J = he.getElementsByTagName("svg")[0], ae = he.createElementNS(oe.namespaceURI, oe.nodeName), J.appendChild(ae);
                let me = u.getComputedStyle(ae, null), fe = {};
                for (let Ae in me) Ae.length < 1e3 && typeof me[Ae] == "string" && !/^\d+$/.test(Ae) && (fe[Ae] = me[Ae]);
                re[oe.nodeName] = fe, oe.nodeName === "text" && delete re.text.fill, J.removeChild(ae);
              }
              for (let me in se) (B.isFirefox || B.isMS || B.isSafari || Object.hasOwnProperty.call(se, me)) && function(fe, Ae) {
                if (le = de = !1, ie.length) {
                  for (be = ie.length; be-- && !de; ) de = ie[be].test(Ae);
                  le = !de;
                }
                for (Ae === "transform" && fe === "none" && (le = !0), be = c.length; be-- && !le; ) {
                  if (Ae.length > 1e3) throw Error("Input too long");
                  le = c[be].test(Ae) || typeof fe == "function";
                }
                !le && (te[Ae] !== fe || oe.nodeName === "svg") && re[oe.nodeName][Ae] !== fe && (h && h.indexOf(Ae) === -1 ? ge[Ae] = fe : fe && oe.setAttribute(Ae.replace(/[A-Z]/g, function(ye) {
                  return "-" + ye.toLowerCase();
                }), fe));
              }(se[me], me);
              if (M(oe, ge), oe.nodeName === "svg" && oe.setAttribute("stroke-width", "1px"), oe.nodeName === "text") return;
              [].forEach.call(oe.children || oe.childNodes, ne);
            }
          }(this.container.querySelector("svg")), J.parentNode.removeChild(J), ce.parentNode.removeChild(ce);
        }
        function K(J) {
          let { scrollablePlotArea: ie } = this;
          (ie ? [ie.fixedDiv, ie.scrollingContainer] : [this.container]).forEach(function(re) {
            J.appendChild(re);
          });
        }
        function V() {
          let J = this, ie = (re, ce, he) => {
            J.isDirtyExporting = !0, v(!0, J.options[re], ce), d(he, !0) && J.redraw();
          };
          J.exporting = { update: function(re, ce) {
            ie("exporting", re, ce);
          } }, l.compose(J).navigation.addUpdate((re, ce) => {
            ie("navigation", re, ce);
          });
        }
        function Q() {
          let J = this;
          J.isPrinting || (b = J, B.isSafari || J.beforePrint(), setTimeout(() => {
            u.focus(), u.print(), B.isSafari || setTimeout(() => {
              J.afterPrint();
            }, 1e3);
          }, 1));
        }
        function Z() {
          let J = this, ie = J.options.exporting, re = ie.buttons, ce = J.isDirtyExporting || !J.exportSVGElements;
          J.buttonOffset = 0, J.isDirtyExporting && J.destroyExport(), ce && ie.enabled !== !1 && (J.exportEvents = [], J.exportingGroup = J.exportingGroup || J.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), w(re, function(he) {
            J.addButton(he);
          }), J.isDirtyExporting = !1);
        }
        function ee(J, ie) {
          let re = J.indexOf("</svg>") + 6, ce = J.substr(re);
          return J = J.substr(0, re), ie && ie.exporting && ie.exporting.allowHTML && ce && (ce = '<foreignObject x="0" y="0" width="' + ie.chart.width + '" height="' + ie.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + ce.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", J = J.replace("</svg>", ce + "</svg>")), J = J.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        p.compose = function(J, ie) {
          j.compose(ie), I.compose(J);
          let re = J.prototype;
          re.exportChart || (re.afterPrint = P, re.exportChart = Y, re.inlineStyles = $, re.print = Q, re.sanitizeSVG = ee, re.getChartHTML = U, re.getSVG = q, re.getSVGForExport = X, re.getFilename = H, re.moveContainers = K, re.beforePrint = O, re.contextMenu = W, re.addButton = k, re.destroyExport = G, re.renderExporting = Z, re.callbacks.push(z), A(J, "init", V), B.isSafari && u.matchMedia("print").addListener(function(ce) {
            b && (ce.matches ? b.beforePrint() : b.afterPrint());
          }), T.exporting = v(D.exporting, T.exporting), T.lang = v(D.lang, T.lang), T.navigation = v(D.navigation, T.navigation));
        };
      }(x || (x = {})), x;
    }), i(e, "masters/modules/exporting.src.js", [e["Core/Globals.js"], e["Extensions/Exporting/Exporting.js"], e["Core/HttpUtilities.js"]], function(o, n, l) {
      return o.HttpUtilities = o.HttpUtilities || l, o.ajax = o.HttpUtilities.ajax, o.getJSON = o.HttpUtilities.getJSON, o.post = o.HttpUtilities.post, n.compose(o.Chart, o.Renderer), o;
    });
  });
})(Of);
var VC = Of.exports;
const qC = /* @__PURE__ */ ri(VC);
var YC = Object.defineProperty, XC = Object.getOwnPropertyDescriptor, wd = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? XC(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && YC(t, e, o), o;
};
function QC(a) {
  return !!(a.custom && a.custom.tableElement);
}
function xn(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.tableId = void 0, this.disableExporting = !1;
    }
    get localComponentOptions() {
      var e, i;
      return tt.createChartOptions(super.localComponentOptions, {
        data: {
          table: this.tableId
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.tableId ? t.exportMenuItemsLimited : t.exportMenuItemsDefault
            }
          },
          chartOptions: {
            chart: {
              styledMode: !1
              // Turned off because the exported images don't know the styles we apply
            }
          },
          enabled: !this.disableExporting,
          sourceHeight: (e = this.chartSize) == null ? void 0 : e.chartHeight,
          sourceWidth: (i = this.chartSize) == null ? void 0 : i.chartWidth
        },
        plotOptions: {
          custom: {
            tableElement: this.getScopedTagName("beacon-table")
          }
        }
      });
    }
    initializeHighcharts(e) {
      super.initializeHighcharts(e), qC(e), WC(e), KC(e), e.addEvent(e.Chart, "afterViewData", function() {
        const i = this, o = i.dataTableDiv.querySelector("table");
        if (!o) return;
        const {
          userOptions: { plotOptions: n }
        } = i;
        if (n && QC(n)) {
          const l = document.createElement(
            n.custom.tableElement
          );
          i.dataTableDiv.appendChild(l), l.appendChild(o);
        }
      });
    }
    willUpdate(e) {
      var i, o;
      (i = super.willUpdate) == null || i.call(this, e), e.has("disableExporting") && ((o = this.chart) == null || o.update({
        exporting: {
          enabled: !this.disableExporting
        }
      }));
    }
  };
  return t.exportMenuItemsDefault = [
    "viewFullscreen",
    "separator",
    "downloadCSV",
    "viewData"
  ], t.exportMenuItemsLimited = [
    "viewFullscreen",
    "separator",
    "downloadCSV"
  ], wd([
    ue({ attribute: "table-id" })
  ], t.prototype, "tableId", 2), wd([
    ue({ type: Boolean, attribute: "disable-exporting" })
  ], t.prototype, "disableExporting", 2), t = wd([
    $e("Exporting")
  ], t), t;
}
var Pf = { exports: {} };
(function(a) {
  /**
  * Highstock JS v11.4.8 (2024-08-29)
  *
  * Highcharts Stock as a plugin for Highcharts
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Series/DataModifyComposition.js", [e["Core/Axis/Axis.js"], e["Core/Series/Point.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { tooltipFormatter: j } = n.prototype, { addEvent: I, arrayMax: B, arrayMin: R, correctFloat: N, defined: x, isArray: T, isNumber: y, isString: S, pick: u } = L;
      return function(A) {
        function M(r, s, p) {
          !this.isXAxis && (this.series.forEach(function(b) {
            r === "compare" && typeof s != "boolean" ? b.setCompare(s, !1) : r !== "cumulative" || S(s) || b.setCumulative(s, !1);
          }), u(p, !0) && this.chart.redraw());
        }
        function f(r) {
          let s = this, { numberFormatter: p } = s.series.chart, b = function(c) {
            r = r.replace("{point." + c + "}", (s[c] > 0 && c === "change" ? "+" : "") + p(s[c], u(s.series.tooltipOptions.changeDecimals, 2)));
          };
          return x(s.change) && b("change"), x(s.cumulativeSum) && b("cumulativeSum"), j.apply(this, [r]);
        }
        function m() {
          let r, s = this.options.compare;
          (s === "percent" || s === "value" || this.options.cumulative) && (r = new d(this), s === "percent" || s === "value" ? r.initCompare(s) : r.initCumulative()), this.dataModify = r;
        }
        function C(r) {
          let s = r.dataExtremes, p = s.activeYData;
          if (this.dataModify && s) {
            let b;
            this.options.compare ? b = [this.dataModify.modifyValue(s.dataMin), this.dataModify.modifyValue(s.dataMax)] : this.options.cumulative && T(p) && p.length >= 2 && (b = d.getCumulativeExtremes(p)), b && (s.dataMin = R(b), s.dataMax = B(b));
          }
        }
        function F(r, s) {
          this.options.compare = this.userOptions.compare = r, this.update({}, u(s, !0)), this.dataModify && (r === "value" || r === "percent") ? this.dataModify.initCompare(r) : this.points.forEach((p) => {
            delete p.change;
          });
        }
        function _() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            let r = this.processedXData, s = this.processedYData, p = s.length, b = this.options.compareStart === !0 ? 0 : 1, c = -1, h;
            for (this.pointArrayMap && (c = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), h = 0; h < p - b; h++) {
              let g = s[h] && c > -1 ? s[h][c] : s[h];
              if (y(g) && g !== 0 && r[h + b] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = g;
                break;
              }
            }
          }
        }
        function E(r, s) {
          this.setModifier("compare", r, s);
        }
        function v(r, s) {
          r = u(r, !1), this.options.cumulative = this.userOptions.cumulative = r, this.update({}, u(s, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((p) => {
            delete p.cumulativeSum;
          });
        }
        function w(r, s) {
          this.setModifier("cumulative", r, s);
        }
        A.compose = function(r, s, p) {
          let b = s.prototype, c = p.prototype, h = r.prototype;
          return h.setCompare || (h.setCompare = F, h.setCumulative = v, I(r, "afterInit", m), I(r, "afterGetExtremes", C), I(r, "afterProcessData", _)), b.setCompare || (b.setCompare = E, b.setModifier = M, b.setCumulative = w, c.tooltipFormatter = f), r;
        };
        class d {
          constructor(s) {
            this.series = s;
          }
          modifyValue() {
            return 0;
          }
          static getCumulativeExtremes(s) {
            let p = 1 / 0, b = -1 / 0;
            return s.reduce((c, h) => {
              let g = c + h;
              return p = Math.min(p, g, c), b = Math.max(b, g, c), g;
            }), [p, b];
          }
          initCompare(s) {
            this.modifyValue = function(p, b) {
              p === null && (p = 0);
              let c = this.compareValue;
              if (p !== void 0 && c !== void 0) {
                if (s === "value" ? p -= c : p = p / c * 100 - (this.series.options.compareBase === 100 ? 0 : 100), b !== void 0) {
                  let h = this.series.points[b];
                  h && (h.change = p);
                }
                return p;
              }
              return 0;
            };
          }
          initCumulative() {
            this.modifyValue = function(s, p) {
              if (s === null && (s = 0), s !== void 0 && p !== void 0) {
                let b = p > 0 ? this.series.points[p - 1] : null;
                b && b.cumulativeSum && (s = N(b.cumulativeSum + s));
                let c = this.series.points[p], h = c.series.options.cumulativeStart, g = c.x <= this.series.xAxis.max && c.x >= this.series.xAxis.min;
                return c && (!h || g ? c.cumulativeSum = s : c.cumulativeSum = void 0), s;
              }
              return 0;
            };
          }
        }
        A.Additions = d;
      }(D || (D = {})), D;
    }), i(e, "Stock/Navigator/ChartNavigatorComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let l, { isTouchDevice: L } = o, { addEvent: D, merge: j, pick: I } = n, B = [];
      function R() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function N() {
        var F;
        let A, M, f, m = this.legend, C = this.navigator;
        if (C) {
          A = m && m.options, M = C.xAxis, f = C.yAxis;
          let { scrollbarHeight: _, scrollButtonSize: E } = C;
          this.inverted ? (C.left = C.opposite ? this.chartWidth - _ - C.height : this.spacing[3] + _, C.top = this.plotTop + E) : (C.left = I(M.left, this.plotLeft + E), C.top = C.navigatorOptions.top || this.chartHeight - C.height - _ - (((F = this.scrollbar) == null ? void 0 : F.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (A && A.verticalAlign === "bottom" && A.layout !== "proximate" && A.enabled && !A.floating ? m.legendHeight + I(A.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), M && f && (this.inverted ? M.options.left = f.options.left = C.left : M.options.top = f.options.top = C.top, M.setAxisSize(), f.setAxisSize());
        }
      }
      function x(A) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new l(this), I(A.redraw, !0) && this.redraw(A.animation));
      }
      function T() {
        let A = this.options;
        (A.navigator.enabled || A.scrollbar.enabled) && (this.scroller = this.navigator = new l(this));
      }
      function y() {
        let A = this.options, M = A.navigator, f = A.rangeSelector;
        if ((M && M.enabled || f && f.enabled) && (!L && this.zooming.type === "x" || L && this.zooming.pinchType === "x")) return !1;
      }
      function S(A) {
        let M = A.navigator;
        if (M && A.xAxis[0]) {
          let f = A.xAxis[0].getExtremes();
          M.render(f.min, f.max);
        }
      }
      function u(A) {
        let M = A.options.navigator || {}, f = A.options.scrollbar || {};
        !this.navigator && !this.scroller && (M.enabled || f.enabled) && (j(!0, this.options.navigator, M), j(!0, this.options.scrollbar, f), delete A.options.navigator, delete A.options.scrollbar);
      }
      return { compose: function(A, M) {
        if (n.pushUnique(B, A)) {
          let f = A.prototype;
          l = M, f.callbacks.push(S), D(A, "afterAddSeries", R), D(A, "afterSetChartSize", N), D(A, "afterUpdate", x), D(A, "beforeRender", T), D(A, "beforeShowResetZoom", y), D(A, "update", u);
        }
      } };
    }), i(e, "Core/Axis/NavigatorAxisComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { isTouchDevice: l } = o, { addEvent: L, correctFloat: D, defined: j, isNumber: I, pick: B } = n;
      function R() {
        this.navigatorAxis || (this.navigatorAxis = new x(this));
      }
      function N(T) {
        let y, S = this.chart, u = S.options, A = u.navigator, M = this.navigatorAxis, f = S.zooming.pinchType, m = u.rangeSelector, C = S.zooming.type;
        if (this.isXAxis && (A != null && A.enabled || m != null && m.enabled)) {
          if (C === "y" && T.trigger === "zoom") y = !1;
          else if ((T.trigger === "zoom" && C === "xy" || l && f === "xy") && this.options.range) {
            let F = M.previousZoom;
            j(T.min) ? M.previousZoom = [this.min, this.max] : F && (T.min = F[0], T.max = F[1], M.previousZoom = void 0);
          }
        }
        y !== void 0 && T.preventDefault();
      }
      class x {
        static compose(y) {
          y.keepProps.includes("navigatorAxis") || (y.keepProps.push("navigatorAxis"), L(y, "init", R), L(y, "setExtremes", N));
        }
        constructor(y) {
          this.axis = y;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(y, S, u, A) {
          let M = this.axis, f = (M.pointRange || 0) / 2, m = B(u, M.translate(y, !0, !M.horiz)), C = B(A, M.translate(S, !0, !M.horiz));
          return j(u) || (m = D(m + f)), j(A) || (C = D(C - f)), I(m) && I(C) || (m = C = void 0), { min: m, max: C };
        }
      }
      return x;
    }), i(e, "Stock/Navigator/NavigatorDefaults.js", [e["Core/Color/Color.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n) {
      let { parse: l } = o, { seriesTypes: L } = n;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: l("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: L.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), i(e, "Stock/Navigator/NavigatorSymbols.js", [e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function(o, n) {
      let { relativeLength: l } = n;
      return { "navigator-handle": function(L, D, j, I, B = {}) {
        let R = B.width ? B.width / 2 : j, N = l(B.borderRadius || 0, Math.min(2 * R, I));
        return [["M", -1.5, (I = B.height || I) / 2 - 3.5], ["L", -1.5, I / 2 + 4.5], ["M", 0.5, I / 2 - 3.5], ["L", 0.5, I / 2 + 4.5], ...o.rect(-R - 1, 0.5, 2 * R + 1, I, { r: N })];
      } };
    }), i(e, "Stock/Utilities/StockUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n } = o;
      return { setFixedRange: function(l) {
        let L = this.xAxis[0];
        n(L.dataMax) && n(L.dataMin) && l ? this.fixedRange = Math.min(l, L.dataMax - L.dataMin) : this.fixedRange = l;
      } };
    }), i(e, "Stock/Navigator/NavigatorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/Navigator/NavigatorSymbols.js"], e["Core/Renderer/RendererRegistry.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { setOptions: R } = o, { composed: N } = n, { getRendererType: x } = j, { setFixedRange: T } = I, { addEvent: y, extend: S, pushUnique: u } = B;
      function A() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(M, f, m) {
        l.compose(f), u(N, "Navigator") && (M.prototype.setFixedRange = T, S(x().prototype.symbols, D), y(m, "afterUpdate", A), R({ navigator: L }));
      } };
    }), i(e, "Core/Axis/ScrollbarAxis.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { composed: L } = o, { addEvent: D, defined: j, pick: I, pushUnique: B } = n;
      return function(R) {
        let N;
        function x(u) {
          let A = I(u.options && u.options.min, u.min), M = I(u.options && u.options.max, u.max);
          return { axisMin: A, axisMax: M, scrollMin: j(u.dataMin) ? Math.min(A, u.min, u.dataMin, I(u.threshold, 1 / 0)) : A, scrollMax: j(u.dataMax) ? Math.max(M, u.max, u.dataMax, I(u.threshold, -1 / 0)) : M };
        }
        function T() {
          let u = this.scrollbar, A = u && !u.options.opposite, M = this.horiz ? 2 : A ? 3 : 1;
          u && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[M] += u.size + (u.options.margin || 0));
        }
        function y() {
          let u = this;
          u.options && u.options.scrollbar && u.options.scrollbar.enabled && (u.options.scrollbar.vertical = !u.horiz, u.options.startOnTick = u.options.endOnTick = !1, u.scrollbar = new N(u.chart.renderer, u.options.scrollbar, u.chart), D(u.scrollbar, "changed", function(A) {
            let M, f, { axisMin: m, axisMax: C, scrollMin: F, scrollMax: _ } = x(u), E = _ - F;
            if (j(m) && j(C))
              if (u.horiz && !u.reversed || !u.horiz && u.reversed ? (M = F + E * this.to, f = F + E * this.from) : (M = F + E * (1 - this.from), f = F + E * (1 - this.to)), this.shouldUpdateExtremes(A.DOMType)) {
                let v = A.DOMType !== "mousemove" && A.DOMType !== "touchmove" && void 0;
                u.setExtremes(f, M, !0, v, A);
              } else this.setRange(this.from, this.to);
          }));
        }
        function S() {
          let u, A, M, { scrollMin: f, scrollMax: m } = x(this), C = this.scrollbar, F = this.axisTitleMargin + (this.titleOffset || 0), _ = this.chart.scrollbarsOffsets, E = this.options.margin || 0;
          if (C && _) {
            if (this.horiz) this.opposite || (_[1] += F), C.position(this.left, this.top + this.height + 2 + _[1] - (this.opposite ? E : 0), this.width, this.height), this.opposite || (_[1] += E), u = 1;
            else {
              let v;
              this.opposite && (_[0] += F), v = C.options.opposite ? this.left + this.width + 2 + _[0] - (this.opposite ? 0 : E) : this.opposite ? 0 : E, C.position(v, this.top, this.width, this.height), this.opposite && (_[0] += E), u = 0;
            }
            if (_[u] += C.size + (C.options.margin || 0), isNaN(f) || isNaN(m) || !j(this.min) || !j(this.max) || this.dataMin === this.dataMax) C.setRange(0, 1);
            else if (this.min === this.max) {
              let v = this.pointRange / (this.dataMax + 1);
              A = v * this.min, M = v * (this.max + 1), C.setRange(A, M);
            } else A = (this.min - f) / (m - f), M = (this.max - f) / (m - f), this.horiz && !this.reversed || !this.horiz && this.reversed ? C.setRange(A, M) : C.setRange(1 - M, 1 - A);
          }
        }
        R.compose = function(u, A) {
          B(L, "Axis.Scrollbar") && (N = A, D(u, "afterGetOffset", T), D(u, "afterInit", y), D(u, "afterRender", S));
        };
      }(l || (l = {})), l;
    }), i(e, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), i(e, "Stock/Scrollbar/Scrollbar.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/ScrollbarAxis.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { defaultOptions: j } = o, { addEvent: I, correctFloat: B, crisp: R, defined: N, destroyObjectProperties: x, fireEvent: T, merge: y, pick: S, removeEvent: u } = D;
      class A {
        static compose(f) {
          l.compose(f, A);
        }
        static swapXY(f, m) {
          return m && f.forEach((C) => {
            let F, _ = C.length;
            for (let E = 0; E < _; E += 2) typeof (F = C[E + 1]) == "number" && (C[E + 1] = C[E + 2], C[E + 2] = F);
          }), f;
        }
        constructor(f, m, C) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(f, m, C);
        }
        addEvents() {
          let f = this.options.inverted ? [1, 0] : [0, 1], m = this.scrollbarButtons, C = this.scrollbarGroup.element, F = this.track.element, _ = this.mouseDownHandler.bind(this), E = this.mouseMoveHandler.bind(this), v = this.mouseUpHandler.bind(this), w = [[m[f[0]].element, "click", this.buttonToMinClick.bind(this)], [m[f[1]].element, "click", this.buttonToMaxClick.bind(this)], [F, "click", this.trackClick.bind(this)], [C, "mousedown", _], [C.ownerDocument, "mousemove", E], [C.ownerDocument, "mouseup", v], [C, "touchstart", _], [C.ownerDocument, "touchmove", E], [C.ownerDocument, "touchend", v]];
          w.forEach(function(d) {
            I.apply(null, d);
          }), this._events = w;
        }
        buttonToMaxClick(f) {
          let m = (this.to - this.from) * S(this.options.step, 0.2);
          this.updatePosition(this.from + m, this.to + m), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        buttonToMinClick(f) {
          let m = B(this.to - this.from) * S(this.options.step, 0.2);
          this.updatePosition(B(this.from - m), B(this.to - m)), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        cursorToScrollbarPosition(f) {
          let m = this.options, C = m.minWidth > this.calculatedWidth ? m.minWidth : 0;
          return { chartX: (f.chartX - this.x - this.xOffset) / (this.barWidth - C), chartY: (f.chartY - this.y - this.yOffset) / (this.barWidth - C) };
        }
        destroy() {
          let f = this, m = f.chart.scroller;
          f.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(C) {
            f[C] && f[C].destroy && (f[C] = f[C].destroy());
          }), m && f === m.scrollbar && (m.scrollbar = null, x(m.scrollbarButtons));
        }
        drawScrollbarButton(f) {
          let m = this.renderer, C = this.scrollbarButtons, F = this.options, _ = this.size, E = m.g().add(this.group);
          if (C.push(E), F.buttonsEnabled) {
            let v = m.rect().addClass("highcharts-scrollbar-button").add(E);
            this.chart.styledMode || v.attr({ stroke: F.buttonBorderColor, "stroke-width": F.buttonBorderWidth, fill: F.buttonBackgroundColor }), v.attr(v.crisp({ x: -0.5, y: -0.5, width: _, height: _, r: F.buttonBorderRadius }, v.strokeWidth()));
            let w = m.path(A.swapXY([["M", _ / 2 + (f ? -1 : 1), _ / 2 - 3], ["L", _ / 2 + (f ? -1 : 1), _ / 2 + 3], ["L", _ / 2 + (f ? 2 : -2), _ / 2]], F.vertical)).addClass("highcharts-scrollbar-arrow").add(C[f]);
            this.chart.styledMode || w.attr({ fill: F.buttonArrowColor });
          }
        }
        init(f, m, C) {
          this.scrollbarButtons = [], this.renderer = f, this.userOptions = m, this.options = y(L, j.scrollbar, m), this.options.margin = S(this.options.margin, 10), this.chart = C, this.size = S(this.options.size, this.options.height), m.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(f) {
          var F;
          let m = ((F = this.chart.pointer) == null ? void 0 : F.normalize(f)) || f, C = this.cursorToScrollbarPosition(m);
          this.chartX = C.chartX, this.chartY = C.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(f) {
          var E;
          let m, C = ((E = this.chart.pointer) == null ? void 0 : E.normalize(f)) || f, F = this.options.vertical ? "chartY" : "chartX", _ = this.initPositions || [];
          this.grabbedCenter && (!f.touches || f.touches[0][F] !== 0) && (m = this.cursorToScrollbarPosition(C)[F] - this[F], this.hasDragged = !0, this.updatePosition(_[0] + m, _[1] + m), this.hasDragged && T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: f.type, DOMEvent: f }));
        }
        mouseUpHandler(f) {
          this.hasDragged && T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: f.type, DOMEvent: f }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(f, m, C, F) {
          let { buttonsEnabled: _, margin: E = 0, vertical: v } = this.options, w = this.rendered ? "animate" : "attr", d = F, r = 0;
          this.group.show(), this.x = f, this.y = m + this.trackBorderWidth, this.width = C, this.height = F, this.xOffset = d, this.yOffset = r, v ? (this.width = this.yOffset = C = r = this.size, this.xOffset = d = 0, this.yOffset = r = _ ? this.size : 0, this.barWidth = F - (_ ? 2 * C : 0), this.x = f += E) : (this.height = F = this.size, this.xOffset = d = _ ? this.size : 0, this.barWidth = C - (_ ? 2 * F : 0), this.y = this.y + E), this.group[w]({ translateX: f, translateY: this.y }), this.track[w]({ width: C, height: F }), this.scrollbarButtons[1][w]({ translateX: v ? 0 : C - d, translateY: v ? F - r : 0 });
        }
        removeEvents() {
          this._events.forEach(function(f) {
            u.apply(null, f);
          }), this._events.length = 0;
        }
        render() {
          let f = this.renderer, m = this.options, C = this.size, F = this.chart.styledMode, _ = f.g("scrollbar").attr({ zIndex: m.zIndex }).hide().add();
          this.group = _, this.track = f.rect().addClass("highcharts-scrollbar-track").attr({ r: m.trackBorderRadius || 0, height: C, width: C }).add(_), F || this.track.attr({ fill: m.trackBackgroundColor, stroke: m.trackBorderColor, "stroke-width": m.trackBorderWidth });
          let E = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -R(0, E), y: -R(0, E) }), this.scrollbarGroup = f.g().add(_), this.scrollbar = f.rect().addClass("highcharts-scrollbar-thumb").attr({ height: C - E, width: C - E, r: m.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = f.path(A.swapXY([["M", -3, C / 4], ["L", -3, 2 * C / 3], ["M", 0, C / 4], ["L", 0, 2 * C / 3], ["M", 3, C / 4], ["L", 3, 2 * C / 3]], m.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), F || (this.scrollbar.attr({ fill: m.barBackgroundColor, stroke: m.barBorderColor, "stroke-width": m.barBorderWidth }), this.scrollbarRifles.attr({ stroke: m.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-R(0, this.scrollbarStrokeWidth), -R(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(f, m) {
          let C, F, _ = this.options, E = _.vertical, v = _.minWidth, w = this.barWidth, d = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!N(w)) return;
          let r = w * Math.min(m, 1);
          C = Math.ceil(w * (f = Math.max(f, 0))), this.calculatedWidth = F = B(r - C), F < v && (C = (w - v + F) * f, F = v);
          let s = Math.floor(C + this.xOffset + this.yOffset), p = F / 2 - 0.5;
          this.from = f, this.to = m, E ? (this.scrollbarGroup[d]({ translateY: s }), this.scrollbar[d]({ height: F }), this.scrollbarRifles[d]({ translateY: p }), this.scrollbarTop = s, this.scrollbarLeft = 0) : (this.scrollbarGroup[d]({ translateX: s }), this.scrollbar[d]({ width: F }), this.scrollbarRifles[d]({ translateX: p }), this.scrollbarLeft = s, this.scrollbarTop = 0), F <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), _.showFull === !1 && (f <= 0 && m >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(f) {
          return S(this.options.liveRedraw, n.svg && !n.isTouchDevice && !this.chart.boosted) || f === "mouseup" || f === "touchend" || !N(f);
        }
        trackClick(f) {
          var E;
          let m = ((E = this.chart.pointer) == null ? void 0 : E.normalize(f)) || f, C = this.to - this.from, F = this.y + this.scrollbarTop, _ = this.x + this.scrollbarLeft;
          this.options.vertical && m.chartY > F || !this.options.vertical && m.chartX > _ ? this.updatePosition(this.from + C, this.to + C) : this.updatePosition(this.from - C, this.to - C), T(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: f });
        }
        update(f) {
          this.destroy(), this.init(this.chart.renderer, y(!0, this.options, f), this.chart);
        }
        updatePosition(f, m) {
          m > 1 && (f = B(1 - B(m - f)), m = 1), f < 0 && (m = B(m - f), f = 0), this.from = f, this.to = m;
        }
      }
      return A.defaultOptions = L, j.scrollbar = y(!0, A.defaultOptions, j.scrollbar), A;
    }), i(e, "Stock/Navigator/Navigator.js", [e["Core/Axis/Axis.js"], e["Stock/Navigator/ChartNavigatorComposition.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Axis/NavigatorAxisComposition.js"], e["Stock/Navigator/NavigatorComposition.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R) {
      let { defaultOptions: N } = l, { isTouchDevice: x } = L, { prototype: { symbols: T } } = B, { addEvent: y, clamp: S, correctFloat: u, defined: A, destroyObjectProperties: M, erase: f, extend: m, find: C, fireEvent: F, isArray: _, isNumber: E, merge: v, pick: w, removeEvent: d, splat: r } = R;
      function s(b, ...c) {
        let h = [].filter.call(c, E);
        if (h.length) return Math[b].apply(0, h);
      }
      class p {
        static compose(c, h, g) {
          n.compose(c, p), j.compose(c, h, g);
        }
        constructor(c) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(c);
        }
        drawHandle(c, h, g, k) {
          let P = this.navigatorOptions.handles.height;
          this.handles[h][k](g ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(c, 10) + 0.5 - P) } : { translateX: Math.round(this.left + parseInt(c, 10)), translateY: Math.round(this.top + this.height / 2 - P / 2 - 1) });
        }
        drawOutline(c, h, g, k) {
          let P = this.navigatorOptions.maskInside, O = this.outline.strokeWidth(), z = O / 2, W = O % 2 / 2, G = this.scrollButtonSize, Y = this.size, U = this.top, H = this.height, q = U - z, X = U + H, $ = this.left, K, V;
          g ? (K = U + h + W, h = U + c + W, V = [["M", $ + H, U - G - W], ["L", $ + H, K], ["L", $, K], ["M", $, h], ["L", $ + H, h], ["L", $ + H, U + Y + G]], P && V.push(["M", $ + H, K - z], ["L", $ + H, h + z])) : ($ -= G, c += $ + G - W, h += $ + G - W, V = [["M", $, q], ["L", c, q], ["L", c, X], ["M", h, X], ["L", h, q], ["L", $ + Y + 2 * G, q]], P && V.push(["M", c - z, q], ["L", h + z, q])), this.outline[k]({ d: V });
        }
        drawMasks(c, h, g, k) {
          let P, O, z, W, G = this.left, Y = this.top, U = this.height;
          g ? (z = [G, G, G], W = [Y, Y + c, Y + h], O = [U, U, U], P = [c, h - c, this.size - h]) : (z = [G, G + c, G + h], W = [Y, Y, Y], O = [c, h - c, this.size - h], P = [U, U, U]), this.shades.forEach((H, q) => {
            H[k]({ x: z[q], y: W[q], width: O[q], height: P[q] });
          });
        }
        renderElements() {
          var G, Y;
          let c = this, h = c.navigatorOptions, g = h.maskInside, k = c.chart, P = k.inverted, O = k.renderer, z = { cursor: P ? "ns-resize" : "ew-resize" }, W = (G = c.navigatorGroup) != null ? G : c.navigatorGroup = O.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!g, g, !g].forEach((U, H) => {
            var X;
            let q = (X = c.shades[H]) != null ? X : c.shades[H] = O.rect().addClass("highcharts-navigator-mask" + (H === 1 ? "-inside" : "-outside")).add(W);
            k.styledMode || (q.attr({ fill: U ? h.maskFill : "rgba(0,0,0,0)" }), H === 1 && q.css(z));
          }), c.outline || (c.outline = O.path().addClass("highcharts-navigator-outline").add(W)), k.styledMode || c.outline.attr({ "stroke-width": h.outlineWidth, stroke: h.outlineColor }), (Y = h.handles) == null ? void 0 : Y.enabled) {
            let U = h.handles, { height: H, width: q } = U;
            [0, 1].forEach((X) => {
              var K;
              let $ = U.symbols[X];
              if (c.handles[X] && c.handles[X].symbolUrl === $) {
                if (!c.handles[X].isImg && c.handles[X].symbolName !== $) {
                  let V = T[$].call(T, -q / 2 - 1, 0, q, H);
                  c.handles[X].attr({ d: V }), c.handles[X].symbolName = $;
                }
              } else (K = c.handles[X]) == null || K.destroy(), c.handles[X] = O.symbol($, -q / 2 - 1, 0, q, H, U), c.handles[X].attr({ zIndex: 7 - X }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][X]).add(W), c.addMouseEvents();
              k.inverted && c.handles[X].attr({ rotation: 90, rotationOriginX: Math.floor(-q / 2), rotationOriginY: (H + q) / 2 }), k.styledMode || c.handles[X].attr({ fill: U.backgroundColor, stroke: U.borderColor, "stroke-width": U.lineWidth, width: U.width, height: U.height, x: -q / 2 - 1, y: 0 }).css(z);
            });
          }
        }
        update(c, h = !1) {
          var P, O;
          let g = this.chart, k = g.options.chart.inverted !== ((P = g.scrollbar) == null ? void 0 : P.options.vertical);
          if (v(!0, g.options.navigator, c), this.navigatorOptions = g.options.navigator || {}, this.setOpposite(), A(c.enabled) || k) return this.destroy(), this.navigatorEnabled = c.enabled || this.navigatorEnabled, this.init(g);
          if (this.navigatorEnabled && (this.isDirty = !0, c.adaptToUpdatedData === !1 && this.baseSeries.forEach((z) => {
            d(z, "updatedData", this.updatedDataHandler);
          }, this), c.adaptToUpdatedData && this.baseSeries.forEach((z) => {
            z.eventsToUnbind.push(y(z, "updatedData", this.updatedDataHandler));
          }, this), (c.series || c.baseSeries) && this.setBaseSeries(void 0, !1), c.height || c.xAxis || c.yAxis)) {
            this.height = (O = c.height) != null ? O : this.height;
            let z = this.getXAxisOffsets();
            this.xAxis.update({ ...c.xAxis, offsets: z, [g.inverted ? "width" : "height"]: this.height, [g.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...c.yAxis, [g.inverted ? "width" : "height"]: this.height }, !1);
          }
          h && g.redraw();
        }
        render(c, h, g, k) {
          let P = this.chart, O = this.xAxis, z = O.pointRange || 0, W = O.navigatorAxis.fake ? P.xAxis[0] : O, G = this.navigatorEnabled, Y = this.rendered, U = P.inverted, H = P.xAxis[0].minRange, q = P.xAxis[0].options.maxRange, X = this.scrollButtonSize, $, K, V, Q = this.scrollbarHeight, Z, ee;
          if (this.hasDragged && !A(g)) return;
          if (this.isDirty && this.renderElements(), c = u(c - z / 2), h = u(h + z / 2), !E(c) || !E(h)) {
            if (!Y) return;
            g = 0, k = w(O.width, W.width);
          }
          this.left = w(O.left, P.plotLeft + X + (U ? P.plotWidth : 0));
          let J = this.size = Z = w(O.len, (U ? P.plotHeight : P.plotWidth) - 2 * X);
          $ = U ? Q : Z + 2 * X, g = w(g, O.toPixels(c, !0)), k = w(k, O.toPixels(h, !0)), E(g) && Math.abs(g) !== 1 / 0 || (g = 0, k = $);
          let ie = O.toValue(g, !0), re = O.toValue(k, !0), ce = Math.abs(u(re - ie));
          ce < H ? this.grabbedLeft ? g = O.toPixels(re - H - z, !0) : this.grabbedRight && (k = O.toPixels(ie + H + z, !0)) : A(q) && u(ce - z) > q && (this.grabbedLeft ? g = O.toPixels(re - q - z, !0) : this.grabbedRight && (k = O.toPixels(ie + q + z, !0))), this.zoomedMax = S(Math.max(g, k), 0, J), this.zoomedMin = S(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(g, k), 0, J), this.range = this.zoomedMax - this.zoomedMin, J = Math.round(this.zoomedMax);
          let he = Math.round(this.zoomedMin);
          G && (this.navigatorGroup.attr({ visibility: "inherit" }), ee = Y && !this.hasDragged ? "animate" : "attr", this.drawMasks(he, J, U, ee), this.drawOutline(he, J, U, ee), this.navigatorOptions.handles.enabled && (this.drawHandle(he, 0, U, ee), this.drawHandle(J, 1, U, ee))), this.scrollbar && (U ? (V = this.top - X, K = this.left - Q + (G || !W.opposite ? 0 : (W.titleOffset || 0) + W.axisTitleMargin), Q = Z + 2 * X) : (V = this.top + (G ? this.height : -Q), K = this.left - X), this.scrollbar.position(K, V, $, Q), this.scrollbar.setRange(this.zoomedMin / (Z || 1), this.zoomedMax / (Z || 1))), this.rendered = !0, this.isDirty = !1, F(this, "afterRender");
        }
        addMouseEvents() {
          let c = this, h = c.chart, g = h.container, k = [], P, O;
          c.mouseMoveHandler = P = function(z) {
            c.onMouseMove(z);
          }, c.mouseUpHandler = O = function(z) {
            c.onMouseUp(z);
          }, (k = c.getPartsEvents("mousedown")).push(y(h.renderTo, "mousemove", P), y(g.ownerDocument, "mouseup", O), y(h.renderTo, "touchmove", P), y(g.ownerDocument, "touchend", O)), k.concat(c.getPartsEvents("touchstart")), c.eventsToUnbind = k, c.series && c.series[0] && k.push(y(c.series[0].xAxis, "foundExtremes", function() {
            h.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(c) {
          let h = this, g = [];
          return ["shades", "handles"].forEach(function(k) {
            h[k].forEach(function(P, O) {
              g.push(y(P.element, c, function(z) {
                h[k + "Mousedown"](z, O);
              }));
            });
          }), g;
        }
        shadesMousedown(c, h) {
          var X;
          c = ((X = this.chart.pointer) == null ? void 0 : X.normalize(c)) || c;
          let g = this.chart, k = this.xAxis, P = this.zoomedMin, O = this.size, z = this.range, W = this.left, G = c.chartX, Y, U, H, q;
          g.inverted && (G = c.chartY, W = this.top), h === 1 ? (this.grabbedCenter = G, this.fixedWidth = z, this.dragOffset = G - P) : (q = G - W - z / 2, h === 0 ? q = Math.max(0, q) : h === 2 && q + z >= O && (q = O - z, this.reversedExtremes ? (q -= z, U = this.getUnionExtremes().dataMin) : Y = this.getUnionExtremes().dataMax), q !== P && (this.fixedWidth = z, A((H = k.navigatorAxis.toFixedRange(q, q + z, U, Y)).min) && F(this, "setRange", { min: Math.min(H.min, H.max), max: Math.max(H.min, H.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(c, h) {
          var O;
          c = ((O = this.chart.pointer) == null ? void 0 : O.normalize(c)) || c;
          let g = this.chart, k = g.xAxis[0], P = this.reversedExtremes;
          h === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = P ? k.min : k.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = P ? k.max : k.min), g.setFixedRange(void 0);
        }
        onMouseMove(c) {
          var Y;
          let h = this, g = h.chart, k = h.navigatorSize, P = h.range, O = h.dragOffset, z = g.inverted, W = h.left, G;
          (!c.touches || c.touches[0].pageX !== 0) && (G = (c = ((Y = g.pointer) == null ? void 0 : Y.normalize(c)) || c).chartX, z && (W = h.top, G = c.chartY), h.grabbedLeft ? (h.hasDragged = !0, h.render(0, 0, G - W, h.otherHandlePos)) : h.grabbedRight ? (h.hasDragged = !0, h.render(0, 0, h.otherHandlePos, G - W)) : h.grabbedCenter && (h.hasDragged = !0, G < O ? G = O : G > k + O - P && (G = k + O - P), h.render(0, 0, G - O, G - O + P)), h.hasDragged && h.scrollbar && w(h.scrollbar.options.liveRedraw, !x && !this.chart.boosted) && (c.DOMType = c.type, setTimeout(function() {
            h.onMouseUp(c);
          }, 0)));
        }
        onMouseUp(c) {
          let h, g, k, P, O, z, W = this.chart, G = this.xAxis, Y = this.scrollbar, U = c.DOMEvent || c, H = W.inverted, q = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Y || !Y.hasDragged) || c.trigger === "scrollbar") && (k = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? P = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (O = this.fixedExtreme), this.zoomedMax === this.size && (O = this.reversedExtremes ? k.dataMin : k.dataMax), this.zoomedMin === 0 && (P = this.reversedExtremes ? k.dataMax : k.dataMin), A((z = G.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, P, O)).min) && F(this, "setRange", { min: Math.min(z.min, z.max), max: Math.max(z.min, z.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: U } })), c.DOMType !== "mousemove" && c.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && E(this.zoomedMin) && E(this.zoomedMax) && (g = Math.round(this.zoomedMin), h = Math.round(this.zoomedMax), this.shades && this.drawMasks(g, h, H, q), this.outline && this.drawOutline(g, h, H, q), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(g, 0, H, q), this.drawHandle(h, 1, H, q)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(c) {
            c();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let c = this.baseSeries || [];
          this.navigatorEnabled && c[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && c.forEach(function(h) {
            d(h, "updatedData", this.updatedDataHandler);
          }, this), c[0].xAxis && d(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(c) {
          var $;
          let h = c.options, g = h.navigator || {}, k = g.enabled, P = h.scrollbar || {}, O = P.enabled, z = k && g.height || 0, W = O && P.height || 0, G = P.buttonsEnabled && W || 0;
          this.handles = [], this.shades = [], this.chart = c, this.setBaseSeries(), this.height = z, this.scrollbarHeight = W, this.scrollButtonSize = G, this.scrollbarEnabled = O, this.navigatorEnabled = k, this.navigatorOptions = g, this.scrollbarOptions = P, this.setOpposite();
          let Y = this, U = Y.baseSeries, H = c.xAxis.length, q = c.yAxis.length, X = U && U[0] && U[0].xAxis || c.xAxis[0] || { options: {} };
          if (c.isDirtyBox = !0, Y.navigatorEnabled) {
            let K = this.getXAxisOffsets();
            Y.xAxis = new o(c, v({ breaks: X.options.breaks, ordinal: X.options.ordinal, overscroll: X.options.overscroll }, g.xAxis, { type: "datetime", yAxis: ($ = g.yAxis) == null ? void 0 : $.id, index: H, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: X.options.ordinal ? 0 : X.options.minPadding, maxPadding: X.options.ordinal ? 0 : X.options.maxPadding, zoomEnabled: !1 }, c.inverted ? { offsets: K, width: z } : { offsets: K, height: z }), "xAxis"), Y.yAxis = new o(c, v(g.yAxis, { alignTicks: !1, offset: 0, index: q, isInternal: !0, reversed: w(g.yAxis && g.yAxis.reversed, c.yAxis[0] && c.yAxis[0].reversed, !1), zoomEnabled: !1 }, c.inverted ? { width: z } : { height: z }), "yAxis"), U || g.series.data ? Y.updateNavigatorSeries(!1) : c.series.length === 0 && (Y.unbindRedraw = y(c, "beforeRedraw", function() {
              c.series.length > 0 && !Y.series && (Y.setBaseSeries(), Y.unbindRedraw());
            })), Y.reversedExtremes = c.inverted && !Y.xAxis.reversed || !c.inverted && Y.xAxis.reversed, Y.renderElements(), Y.addMouseEvents();
          } else Y.xAxis = { chart: c, navigatorAxis: { fake: !0 }, translate: function(K, V) {
            let Q = c.xAxis[0], Z = Q.getExtremes(), ee = Q.len - 2 * G, J = s("min", Q.options.min, Z.dataMin), ie = s("max", Q.options.max, Z.dataMax) - J;
            return V ? K * ie / ee + J : ee * (K - J) / ie;
          }, toPixels: function(K) {
            return this.translate(K);
          }, toValue: function(K) {
            return this.translate(K, !0);
          } }, Y.xAxis.navigatorAxis.axis = Y.xAxis, Y.xAxis.navigatorAxis.toFixedRange = D.prototype.toFixedRange.bind(Y.xAxis.navigatorAxis);
          if (c.options.scrollbar.enabled) {
            let K = v(c.options.scrollbar, { vertical: c.inverted });
            !E(K.margin) && Y.navigatorEnabled && (K.margin = c.inverted ? -3 : 3), c.scrollbar = Y.scrollbar = new I(c.renderer, K, c), y(Y.scrollbar, "changed", function(V) {
              let Q = Y.size, Z = Q * this.to, ee = Q * this.from;
              Y.hasDragged = Y.scrollbar.hasDragged, Y.render(0, 0, ee, Z), this.shouldUpdateExtremes(V.DOMType) && setTimeout(function() {
                Y.onMouseUp(V);
              });
            });
          }
          Y.addBaseSeriesEvents(), Y.addChartEvents();
        }
        setOpposite() {
          let c = this.navigatorOptions, h = this.navigatorEnabled, g = this.chart;
          this.opposite = w(c.opposite, !!(!h && g.inverted));
        }
        getUnionExtremes(c) {
          let h, g = this.chart.xAxis[0], k = this.xAxis, P = k.options, O = g.options;
          return c && g.dataMin === null || (h = { dataMin: w(P && P.min, s("min", O.min, g.dataMin, k.dataMin, k.min)), dataMax: w(P && P.max, s("max", O.max, g.dataMax, k.dataMax, k.max)) }), h;
        }
        setBaseSeries(c, h) {
          let g = this.chart, k = this.baseSeries = [];
          c = c || g.options && g.options.navigator.baseSeries || (g.series.length ? C(g.series, (P) => !P.options.isInternal).index : 0), (g.series || []).forEach((P, O) => {
            !P.options.isInternal && (P.options.showInNavigator || (O === c || P.options.id === c) && P.options.showInNavigator !== !1) && k.push(P);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, h);
        }
        updateNavigatorSeries(c, h) {
          var H, q;
          let g = this, k = g.chart, P = g.baseSeries, O = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (H = this.navigatorOptions.xAxis) == null ? void 0 : H.id, yAxis: (q = this.navigatorOptions.yAxis) == null ? void 0 : q.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, z = g.series = (g.series || []).filter((X) => {
            let $ = X.baseSeries;
            return !(0 > P.indexOf($)) || ($ && (d($, "updatedData", g.updatedDataHandler), delete $.navigatorSeries), X.chart && X.destroy(), !1);
          }), W, G, Y = g.navigatorOptions.series, U;
          P && P.length && P.forEach((X) => {
            let $ = X.navigatorSeries, K = m({ color: X.color, visible: X.visible }, _(Y) ? N.navigator.series : Y);
            if ($ && g.navigatorOptions.adaptToUpdatedData === !1) return;
            O.name = "Navigator " + P.length, U = (W = X.options || {}).navigatorOptions || {}, K.dataLabels = r(K.dataLabels), (G = v(W, O, K, U)).pointRange = w(K.pointRange, U.pointRange, N.plotOptions[G.type || "line"].pointRange);
            let V = U.data || K.data;
            g.hasNavigatorData = g.hasNavigatorData || !!V, G.data = V || W.data && W.data.slice(0), $ && $.options ? $.update(G, h) : (X.navigatorSeries = k.initSeries(G), k.setSortedData(), X.navigatorSeries.baseSeries = X, z.push(X.navigatorSeries));
          }), (Y.data && !(P && P.length) || _(Y)) && (g.hasNavigatorData = !1, (Y = r(Y)).forEach((X, $) => {
            O.name = "Navigator " + (z.length + 1), (G = v(N.navigator.series, { color: k.series[$] && !k.series[$].options.isInternal && k.series[$].color || k.options.colors[$] || k.options.colors[0] }, O, X)).data = X.data, G.data && (g.hasNavigatorData = !0, z.push(k.initSeries(G)));
          })), c && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let c = this, h = c.baseSeries || [];
          h[0] && h[0].xAxis && h[0].eventsToUnbind.push(y(h[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), h.forEach((g) => {
            g.eventsToUnbind.push(y(g, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), g.eventsToUnbind.push(y(g, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && g.xAxis && g.eventsToUnbind.push(y(g, "updatedData", this.updatedDataHandler)), g.eventsToUnbind.push(y(g, "remove", function() {
              h && f(h, g), this.navigatorSeries && (f(c.series, this.navigatorSeries), A(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(c) {
          return this.baseSeries.reduce(function(h, g) {
            return Math.min(h, g.xData && g.xData.length ? g.xData[0] : h);
          }, c);
        }
        modifyNavigatorAxisExtremes() {
          let c = this.xAxis;
          if (c.getExtremes !== void 0) {
            let h = this.getUnionExtremes(!0);
            h && (h.dataMin !== c.min || h.dataMax !== c.max) && (c.min = h.dataMin, c.max = h.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var $;
          let c, h, g = this.chart.navigator, k = this.getExtremes(), P = k.min, O = k.max, z = k.dataMin, W = k.dataMax, G = O - P, Y = g.stickToMin, U = g.stickToMax, H = w(($ = this.ordinal) == null ? void 0 : $.convertOverscroll(this.options.overscroll), 0), q = g.series && g.series[0], X = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (Y && (c = (h = z) + G), U && (c = W + H, Y || (h = Math.max(z, c - G, g.getBaseSeriesMin(q && q.xData ? q.xData[0] : -Number.MAX_VALUE)))), X && (Y || U) && E(h) && (this.min = this.userMin = h, this.max = this.userMax = c)), g.stickToMin = g.stickToMax = null;
        }
        updatedDataHandler() {
          let c = this.chart.navigator, h = this.navigatorSeries, g = c.reversedExtremes ? Math.round(c.zoomedMin) === 0 : Math.round(c.zoomedMax) >= Math.round(c.size);
          c.stickToMax = w(this.chart.options.navigator && this.chart.options.navigator.stickToMax, g), c.stickToMin = c.shouldStickToMin(this, c), h && !c.hasNavigatorData && (h.options.pointStart = this.xData[0], h.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(c, h) {
          let g = h.getBaseSeriesMin(c.xData[0]), k = c.xAxis, P = k.max, O = k.min, z = k.options.range;
          return !!(E(P) && E(O)) && (z && P - g > 0 ? P - g < z : O <= g);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(y(this.chart, "redraw", function() {
            let c = this.navigator, h = c && (c.baseSeries && c.baseSeries[0] && c.baseSeries[0].xAxis || this.xAxis[0]);
            h && c.render(h.min, h.max);
          }), y(this.chart, "getMargins", function() {
            let c = this.navigator, h = c.opposite ? "plotTop" : "marginBottom";
            this.inverted && (h = c.opposite ? "marginRight" : "plotLeft"), this[h] = (this[h] || 0) + (c.navigatorEnabled || !this.inverted ? c.height + c.scrollbarHeight : 0) + c.navigatorOptions.margin;
          }), y(p, "setRange", function(c) {
            this.chart.xAxis[0].setExtremes(c.min, c.max, c.redraw, c.animation, c.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (f(this.chart.xAxis, this.xAxis), f(this.chart.axes, this.xAxis)), this.yAxis && (f(this.chart.yAxis, this.yAxis), f(this.chart.axes, this.yAxis)), (this.series || []).forEach((c) => {
            c.destroy && c.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((c) => {
            this[c] && this[c].destroy && this[c].destroy(), this[c] = null;
          }), [this.handles].forEach((c) => {
            M(c);
          }), this.navigatorEnabled = !1;
        }
      }
      return p;
    }), i(e, "Core/Axis/OrdinalAxis.js", [e["Core/Axis/Axis.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { addEvent: j, correctFloat: I, css: B, defined: R, error: N, isNumber: x, pick: T, timeUnits: y, isString: S } = L;
      return function(u) {
        function A(s, p, b, c, h = [], g = 0, k) {
          let P = {}, O = this.options.tickPixelInterval, z = this.chart.time, W = [], G, Y, U, H, q, X = 0, $ = [], K = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !h || h.length < 3 || p === void 0) return z.getTimeTicks.apply(z, arguments);
          let V = h.length;
          for (G = 0; G < V; G++) {
            if (q = G && h[G - 1] > b, h[G] < p && (X = G), G === V - 1 || h[G + 1] - h[G] > 5 * g || q) {
              if (h[G] > K) {
                for (Y = z.getTimeTicks(s, h[X], h[G], c); Y.length && Y[0] <= K; ) Y.shift();
                Y.length && (K = Y[Y.length - 1]), W.push($.length), $ = $.concat(Y);
              }
              X = G + 1;
            }
            if (q) break;
          }
          if (Y) {
            if (H = Y.info, k && H.unitRange <= y.hour) {
              for (X = 1, G = $.length - 1; X < G; X++) z.dateFormat("%d", $[X]) !== z.dateFormat("%d", $[X - 1]) && (P[$[X]] = "day", U = !0);
              U && (P[$[0]] = "day"), H.higherRanks = P;
            }
            H.segmentStarts = W, $.info = H;
          } else N(12, !1, this.chart);
          if (k && R(O)) {
            let Q = $.length, Z = [], ee = [], J, ie, re, ce, he, ne = Q;
            for (; ne--; ) ie = this.translate($[ne]), re && (ee[ne] = re - ie), Z[ne] = re = ie;
            for (ee.sort((oe, se) => oe - se), (ce = ee[Math.floor(ee.length / 2)]) < 0.6 * O && (ce = null), ne = $[Q - 1] > b ? Q - 1 : Q, re = void 0; ne--; ) he = Math.abs(re - (ie = Z[ne])), re && he < 0.8 * O && (ce === null || he < 0.8 * ce) ? (P[$[ne]] && !P[$[ne + 1]] ? (J = ne + 1, re = ie) : J = ne, $.splice(J, 1)) : re = ie;
          }
          return $;
        }
        function M(s) {
          let p = this.ordinal.positions;
          if (!p) return s;
          let b = p.length - 1, c;
          return s < 0 ? s = p[0] : s > b ? s = p[b] : (b = Math.floor(s), c = s - b), c !== void 0 && p[b] !== void 0 ? p[b] + (c ? c * (p[b + 1] - p[b]) : 0) : s;
        }
        function f(s) {
          let p = this.ordinal, b = this.old ? this.old.min : this.min, c = this.old ? this.old.transA : this.transA, h = p.getExtendedPositions();
          if (h && h.length) {
            let g = I((s - b) * c + this.minPixelPadding), k = I(p.getIndexOfPoint(g, h)), P = I(k % 1);
            if (k >= 0 && k <= h.length - 1) {
              let O = h[Math.floor(k)], z = h[Math.ceil(k)];
              return h[Math.floor(k)] + P * (z - O);
            }
          }
          return s;
        }
        function m(s, p) {
          let b = u.Additions.findIndexOf(s, p, !0);
          if (s[b] === p) return b;
          let c = (p - s[b]) / (s[b + 1] - s[b]);
          return b + c;
        }
        function C() {
          this.ordinal || (this.ordinal = new u.Additions(this));
        }
        function F() {
          let { eventArgs: s, options: p } = this;
          if (this.isXAxis && R(p.overscroll) && p.overscroll !== 0 && x(this.max) && x(this.min) && (this.options.ordinal && !this.ordinal.originalOrdinalRange && this.ordinal.getExtendedPositions(!1), this.max === this.dataMax && ((s == null ? void 0 : s.trigger) !== "pan" || this.isInternal) && (s == null ? void 0 : s.trigger) !== "navigator")) {
            let b = this.ordinal.convertOverscroll(p.overscroll);
            this.max += b, !this.isInternal && R(this.userMin) && (s == null ? void 0 : s.trigger) !== "mousewheel" && (this.min += b);
          }
        }
        function _() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function E() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function v(s) {
          let p = this.xAxis[0], b = p.ordinal.convertOverscroll(p.options.overscroll), c = s.originalEvent.chartX, h = this.options.chart.panning, g = !1;
          if (h && h.type !== "y" && p.options.ordinal && p.series.length && (!s.touches || s.touches.length <= 1)) {
            let k, P, O = this.mouseDownX, z = p.getExtremes(), W = z.dataMin, G = z.dataMax, Y = z.min, U = z.max, H = this.hoverPoints, q = p.closestPointRange || p.ordinal && p.ordinal.overscrollPointsRange, X = Math.round((O - c) / (p.translationSlope * (p.ordinal.slope || q))), $ = p.ordinal.getExtendedPositions(), K = { ordinal: { positions: $, extendedOrdinalPositions: $ } }, V = p.index2val, Q = p.val2lin;
            if (Y <= W && X < 0 || U + b >= G && X > 0) return;
            K.ordinal.positions ? Math.abs(X) > 1 && (H && H.forEach(function(Z) {
              Z.setState();
            }), G > (P = K.ordinal.positions)[P.length - 1] && P.push(G), this.setFixedRange(U - Y), (k = p.navigatorAxis.toFixedRange(void 0, void 0, V.apply(K, [Q.apply(K, [Y, !0]) + X]), V.apply(K, [Q.apply(K, [U, !0]) + X]))).min >= Math.min(z.dataMin, Y) && k.max <= Math.max(G, U) + b && p.setExtremes(k.min, k.max, !0, !1, { trigger: "pan" }), this.mouseDownX = c, B(this.container, { cursor: "move" })) : g = !0;
          } else g = !0;
          g || h && /y/.test(h.type) ? b && (p.max = p.dataMax + b) : s.preventDefault();
        }
        function w() {
          let s = this.xAxis;
          s && s.options.ordinal && (delete s.ordinal.index, delete s.ordinal.originalOrdinalRange);
        }
        function d(s, p) {
          let b, c = this.ordinal, h = c.positions, g = c.slope, k;
          if (!h) return s;
          let P = h.length;
          if (h[0] <= s && h[P - 1] >= s) b = m(h, s);
          else {
            if (!((k = c.getExtendedPositions && c.getExtendedPositions()) && k.length)) return s;
            let O = k.length;
            g || (g = (k[O - 1] - k[0]) / O);
            let z = m(k, h[0]);
            if (s >= k[0] && s <= k[O - 1]) b = m(k, s) - z;
            else {
              if (!p) return s;
              b = s < k[0] ? -z - (k[0] - s) / g : (s - k[O - 1]) / g + O - z;
            }
          }
          return p ? b : g * (b || 0) + c.offset;
        }
        u.compose = function(s, p, b) {
          let c = s.prototype;
          return c.ordinal2lin || (c.getTimeTicks = A, c.index2val = M, c.lin2val = f, c.val2lin = d, c.ordinal2lin = c.val2lin, j(s, "afterInit", C), j(s, "foundExtremes", F), j(s, "afterSetScale", _), j(s, "initialAxisTranslation", E), j(b, "pan", v), j(b, "touchpan", v), j(p, "updatedData", w)), s;
        };
        class r {
          constructor(p) {
            this.index = {}, this.axis = p;
          }
          beforeSetTickPositions() {
            var Q;
            let p = this.axis, b = p.ordinal, c = p.getExtremes(), h = c.min, g = c.max, k = (Q = p.brokenAxis) == null ? void 0 : Q.hasBreaks, P = p.options.ordinal, O, z, W, G, Y, U, H, q = [], X = Number.MAX_VALUE, $ = !1, K = !1, V = !1;
            if (P || k) {
              let Z = 0;
              if (p.series.forEach(function(ee, J) {
                if (z = [], J > 0 && ee.options.id !== "highcharts-navigator-series" && ee.processedXData.length > 1 && (K = Z !== ee.processedXData[1] - ee.processedXData[0]), Z = ee.processedXData[1] - ee.processedXData[0], ee.boosted && (V = ee.boosted), ee.reserveSpace() && (ee.takeOrdinalPosition !== !1 || k) && (O = (q = q.concat(ee.processedXData)).length, q.sort(function(ie, re) {
                  return ie - re;
                }), X = Math.min(X, T(ee.closestPointRange, X)), O)) {
                  for (J = 0; J < O - 1; ) q[J] !== q[J + 1] && z.push(q[J + 1]), J++;
                  z[0] !== q[0] && z.unshift(q[0]), q = z;
                }
              }), p.ordinal.originalOrdinalRange || (p.ordinal.originalOrdinalRange = (q.length - 1) * X), K && V && (q.pop(), q.shift()), (O = q.length) > 2) {
                for (W = q[1] - q[0], H = O - 1; H-- && !$; ) q[H + 1] - q[H] !== W && ($ = !0);
                !p.options.keepOrdinalPadding && (q[0] - h > W || g - q[q.length - 1] > W) && ($ = !0);
              } else p.options.overscroll && (O === 2 ? X = q[1] - q[0] : O === 1 ? (X = p.ordinal.convertOverscroll(p.options.overscroll), q = [q[0], q[0] + X]) : X = b.overscrollPointsRange);
              $ || p.forceOrdinal ? (p.options.overscroll && (b.overscrollPointsRange = X, q = q.concat(b.getOverscrollPositions())), b.positions = q, G = p.ordinal2lin(Math.max(h, q[0]), !0), Y = Math.max(p.ordinal2lin(Math.min(g, q[q.length - 1]), !0), 1), b.slope = U = (g - h) / (Y - G), b.offset = h - G * U) : (b.overscrollPointsRange = T(p.closestPointRange, b.overscrollPointsRange), b.positions = p.ordinal.slope = b.offset = void 0);
            }
            p.isOrdinal = P && $, b.groupIntervalFactor = null;
          }
          static findIndexOf(p, b, c) {
            let h = 0, g = p.length - 1, k;
            for (; h < g; ) p[k = Math.ceil((h + g) / 2)] <= b ? h = k : g = k - 1;
            return p[h] === b || c ? h : -1;
          }
          getExtendedPositions(p = !0) {
            var U;
            let b = this, c = b.axis, h = c.constructor.prototype, g = c.chart, k = (U = c.series[0]) == null ? void 0 : U.currentDataGrouping, P = k ? k.count + k.unitName : "raw", O = p ? c.ordinal.convertOverscroll(c.options.overscroll) : 0, z = c.getExtremes(), W, G, Y = b.index;
            return Y || (Y = b.index = {}), Y[P] || ((W = { series: [], chart: g, forceOrdinal: !1, getExtremes: function() {
              return { min: z.dataMin, max: z.dataMax + O };
            }, applyGrouping: h.applyGrouping, getGroupPixelWidth: h.getGroupPixelWidth, getTimeTicks: h.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: h.ordinal2lin, getIndexOfPoint: h.getIndexOfPoint, val2lin: h.val2lin }).ordinal.axis = W, c.series.forEach(function(H) {
              var q, X, $;
              G = { xAxis: W, xData: H.xData.slice(), chart: g, groupPixelWidth: H.groupPixelWidth, destroyGroupedData: n.noop, getProcessedData: l.prototype.getProcessedData, applyGrouping: l.prototype.applyGrouping, reserveSpace: l.prototype.reserveSpace, visible: H.visible }, p && (G.xData = G.xData.concat(b.getOverscrollPositions())), G.options = { dataGrouping: k ? { firstAnchor: (q = H.options.dataGrouping) == null ? void 0 : q.firstAnchor, anchor: (X = H.options.dataGrouping) == null ? void 0 : X.anchor, lastAnchor: ($ = H.options.dataGrouping) == null ? void 0 : $.firstAnchor, enabled: !0, forced: !0, approximation: "open", units: [[k.unitName, [k.count]]] } : { enabled: !1 } }, W.series.push(G), H.processData.apply(G);
            }), W.applyGrouping({ hasExtremesChanged: !0 }), (G == null ? void 0 : G.closestPointRange) !== (G == null ? void 0 : G.basePointRange) && G.currentDataGrouping && (W.forceOrdinal = !0), c.ordinal.beforeSetTickPositions.apply({ axis: W }), !c.ordinal.originalOrdinalRange && W.ordinal.originalOrdinalRange && (c.ordinal.originalOrdinalRange = W.ordinal.originalOrdinalRange), Y[P] = W.ordinal.positions), Y[P];
          }
          getGroupIntervalFactor(p, b, c) {
            let h = c.processedXData, g = h.length, k = [], P, O, z = this.groupIntervalFactor;
            if (!z) {
              for (O = 0; O < g - 1; O++) k[O] = h[O + 1] - h[O];
              k.sort(function(W, G) {
                return W - G;
              }), P = k[Math.floor(g / 2)], p = Math.max(p, h[0]), b = Math.min(b, h[g - 1]), this.groupIntervalFactor = z = g * P / (b - p);
            }
            return z;
          }
          getIndexOfPoint(p, b) {
            let c, h = this.axis, g = 0, k = function(z) {
              let { min: W, max: G } = h;
              return !!(R(W) && R(G)) && z.points.some((Y) => Y.x >= W && Y.x <= G);
            };
            h.series.forEach((z) => {
              var G;
              let W = (G = z.points) == null ? void 0 : G[0];
              R(W == null ? void 0 : W.plotX) && (W.plotX < c || !R(c)) && k(z) && (c = W.plotX, g = W.x);
            }), c != null || (c = h.minPixelPadding);
            let P = h.translationSlope * (this.slope || h.closestPointRange || this.overscrollPointsRange), O = I((p - c) / P);
            return r.findIndexOf(b, g, !0) + O;
          }
          getOverscrollPositions() {
            let p = this.axis, b = this.convertOverscroll(p.options.overscroll), c = this.overscrollPointsRange, h = [], g = p.dataMax;
            if (R(c)) for (; g <= p.dataMax + b; ) h.push(g += c);
            return h;
          }
          postProcessTickInterval(p) {
            let b = this.axis, c = this.slope;
            return c ? b.options.breaks ? b.closestPointRange || p : p / (c / b.closestPointRange) : p;
          }
          convertOverscroll(p = 0) {
            let b = this, c = b.axis, h = function(g) {
              return T(b.originalOrdinalRange, R(c.dataMax) && R(c.dataMin) ? c.dataMax - c.dataMin : 0) * g;
            };
            if (S(p)) {
              let g = parseInt(p, 10);
              if (/%$/.test(p)) return h(g / 100);
              if (/px/.test(p)) {
                let k = Math.min(g, 0.9 * c.len) / c.len;
                return h(k / (1 - k));
              }
              return 0;
            }
            return p;
          }
        }
        u.Additions = r;
      }(D || (D = {})), D;
    }), i(e, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
      return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%e %b %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#334eff", cursor: "pointer", fontSize: "0.8em" }, labelStyle: { color: "#666666", fontSize: "0.8em" } } };
    }), i(e, "Stock/RangeSelector/RangeSelectorComposition.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Stock/RangeSelector/RangeSelectorDefaults.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let D, { defaultOptions: j } = o, { composed: I } = n, { addEvent: B, defined: R, extend: N, isNumber: x, merge: T, pick: y, pushUnique: S } = L, u = [];
      function A() {
        let E, v, w = this.range, d = w.type, r = this.max, s = this.chart.time, p = function(c, h) {
          let g = d === "year" ? "FullYear" : "Month", k = new s.Date(c), P = s.get(g, k);
          return s.set(g, k, P + h), P === s.get(g, k) && s.set("Date", k, 0), k.getTime() - c;
        };
        x(w) ? (E = r - w, v = w) : w && (E = r + p(r, -(w.count || 1)), this.chart && this.chart.setFixedRange(r - E));
        let b = y(this.dataMin, Number.MIN_VALUE);
        return x(E) || (E = b), E <= b && (E = b, v === void 0 && (v = p(E, w.count)), this.newMax = Math.min(E + v, y(this.dataMax, Number.MAX_VALUE))), x(r) ? !x(w) && w && w._offsetMin && (E += w._offsetMin) : E = void 0, E;
      }
      function M() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new D(this));
      }
      function f() {
        let E = this.rangeSelector;
        if (E) {
          x(E.deferredYTDClick) && (E.clickButton(E.deferredYTDClick), delete E.deferredYTDClick);
          let v = E.options.verticalAlign;
          E.options.floating || (v === "bottom" ? this.extraBottomMargin = !0 : v === "middle" || (this.extraTopMargin = !0));
        }
      }
      function m() {
        let E, v = this.rangeSelector;
        if (!v) return;
        let w = this.xAxis[0].getExtremes(), d = this.legend, r = v && v.options.verticalAlign;
        x(w.min) && v.render(w.min, w.max), d.display && r === "top" && r === d.options.verticalAlign && (E = T(this.spacingBox), d.options.layout === "vertical" ? E.y = this.plotTop : E.y += v.getHeight(), d.group.placed = !1, d.align(E));
      }
      function C() {
        for (let E = 0, v = u.length; E < v; ++E) {
          let w = u[E];
          if (w[0] === this) {
            w[1].forEach((d) => d()), u.splice(E, 1);
            return;
          }
        }
      }
      function F() {
        let E = this.rangeSelector;
        if (E) {
          let v = E.getHeight();
          this.extraTopMargin && (this.plotTop += v), this.extraBottomMargin && (this.marginBottom += v);
        }
      }
      function _(E) {
        let v = E.options.rangeSelector, w = this.extraBottomMargin, d = this.extraTopMargin, r = this.rangeSelector;
        if (v && v.enabled && !R(r) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = r = new D(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, r) {
          let s = v && v.verticalAlign || r.options && r.options.verticalAlign;
          r.options.floating || (s === "bottom" ? this.extraBottomMargin = !0 : s === "middle" || (this.extraTopMargin = !0)), (this.extraBottomMargin !== w || this.extraTopMargin !== d) && (this.isDirtyBox = !0);
        }
      }
      return { compose: function(E, v, w) {
        if (D = w, S(I, "RangeSelector")) {
          let d = v.prototype;
          E.prototype.minFromRange = A, B(v, "afterGetContainer", M), B(v, "beforeRender", f), B(v, "destroy", C), B(v, "getMargins", F), B(v, "redraw", m), B(v, "update", _), d.callbacks.push(m), N(j, { rangeSelector: l.rangeSelector }), N(j.lang, l.lang);
        }
      } };
    }), i(e, "Stock/RangeSelector/RangeSelector.js", [e["Core/Axis/Axis.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Stock/RangeSelector/RangeSelectorComposition.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"], e["Core/Axis/OrdinalAxis.js"]], function(o, n, l, L, D, j, I) {
      let { defaultOptions: B } = n, { addEvent: R, createElement: N, css: x, defined: T, destroyObjectProperties: y, discardElement: S, extend: u, fireEvent: A, isNumber: M, merge: f, objectEach: m, pad: C, pick: F, pInt: _, splat: E } = j;
      class v {
        static compose(d, r) {
          L.compose(d, r, v);
        }
        constructor(d) {
          this.buttonOptions = v.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.init(d);
        }
        clickButton(d, r) {
          let s = this.chart, p = this.buttonOptions[d], b = s.xAxis[0], c = s.scroller && s.scroller.getUnionExtremes() || b || {}, h = p.type, g = p.dataGrouping, k = c.dataMin, P = c.dataMax, O, z = b && Math.round(Math.min(b.max, F(P, b.max))), W, G = p._range, Y, U, H, q = !0;
          if (k !== null && P !== null) {
            if (this.setSelected(d), g && (this.forcedDataGrouping = !0, o.prototype.setDataGrouping.call(b || { chart: this.chart }, g, !1), this.frozenStates = p.preserveDataGrouping), h === "month" || h === "year") b ? (U = { range: p, max: z, chart: s, dataMin: k, dataMax: P }, O = b.minFromRange.call(U), M(U.newMax) && (z = U.newMax), q = !1) : G = p;
            else if (G) z = Math.min((O = Math.max(z - G, k)) + G, P), q = !1;
            else if (h === "ytd")
              if (b) (P === void 0 || k === void 0) && (k = Number.MAX_VALUE, P = Number.MIN_VALUE, s.series.forEach((X) => {
                let $ = X.xData;
                $ && (k = Math.min($[0], k), P = Math.max($[$.length - 1], P));
              }), r = !1), O = Y = (H = this.getYTDExtremes(P, k, s.time.useUTC)).min, z = H.max;
              else {
                this.deferredYTDClick = d;
                return;
              }
            else h === "all" && b && (s.navigator && s.navigator.baseSeries[0] && (s.navigator.baseSeries[0].xAxis.options.range = void 0), O = k, z = P);
            if (q && p._offsetMin && T(O) && (O += p._offsetMin), p._offsetMax && T(z) && (z += p._offsetMax), this.dropdown && (this.dropdown.selectedIndex = d + 1), b) b.setExtremes(O, z, F(r, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: p }), s.setFixedRange(p._range);
            else {
              W = E(s.options.xAxis)[0];
              let X = R(s, "afterGetAxes", function() {
                let $ = s.xAxis[0];
                $.range = $.options.range = G, $.min = $.options.min = Y;
              });
              R(s, "load", function() {
                let $ = s.xAxis[0];
                s.setFixedRange(p._range), $.options.range = W.range, $.options.min = W.min, X();
              });
            }
            A(this, "afterBtnClick");
          }
        }
        setSelected(d) {
          this.selected = this.options.selected = d;
        }
        init(d) {
          let r = this, s = d.options.rangeSelector, p = s.buttons || r.defaultButtons.slice(), b = s.selected, c = function() {
            let h = r.minInput, g = r.maxInput;
            h && h.blur && A(h, "blur"), g && g.blur && A(g, "blur");
          };
          r.chart = d, r.options = s, r.buttons = [], r.buttonOptions = p, this.eventsToUnbind = [], this.eventsToUnbind.push(R(d.container, "mousedown", c)), this.eventsToUnbind.push(R(d, "resize", c)), p.forEach(r.computeButtonRange), b !== void 0 && p[b] && this.clickButton(b, !1), this.eventsToUnbind.push(R(d, "load", function() {
            d.xAxis && d.xAxis[0] && R(d.xAxis[0], "setExtremes", function(h) {
              M(this.max) && M(this.min) && this.max - this.min !== d.fixedRange && h.trigger !== "rangeSelectorButton" && h.trigger !== "updatedData" && r.forcedDataGrouping && !r.frozenStates && this.setDataGrouping(!1, !1);
            });
          })), this.createElements();
        }
        updateButtonStates() {
          let d = this, r = this.chart, s = this.dropdown, p = this.dropdownLabel, b = r.xAxis[0], c = Math.round(b.max - b.min), h = !b.hasVisibleSeries, g = 24 * 36e5, k = r.scroller && r.scroller.getUnionExtremes() || b, P = k.dataMin, O = k.dataMax, z = d.getYTDExtremes(O, P, r.time.useUTC), W = z.min, G = z.max, Y = d.selected, U = d.options.allButtonsEnabled, H = Array(d.buttonOptions.length).fill(0), q = M(Y), X = d.buttons, $ = !1, K = null;
          d.buttonOptions.forEach((V, Q) => {
            var ae;
            let Z = V._range, ee = V.type, J = V.count || 1, ie = V._offsetMax - V._offsetMin, re = Q === Y, ce = Z > O - P, he = Z < b.minRange, ne = !1, oe = Z === c;
            if (re && ce && ($ = !0), b.isOrdinal && ((ae = b.ordinal) == null ? void 0 : ae.positions) && Z && c < Z) {
              let le = b.ordinal.positions, de = I.Additions.findIndexOf(le, b.min, !0), be = Math.min(I.Additions.findIndexOf(le, b.max, !0) + 1, le.length - 1);
              le[be] - le[de] > Z && (oe = !0);
            } else (ee === "month" || ee === "year") && c + 36e5 >= { month: 28, year: 365 }[ee] * g * J - ie && c - 36e5 <= { month: 31, year: 366 }[ee] * g * J + ie ? oe = !0 : ee === "ytd" ? (oe = G - W + ie === c, ne = !re) : ee === "all" && (oe = b.max - b.min >= O - P);
            let se = !U && !($ && ee === "all") && (ce || he || h), te = $ && ee === "all" || !ne && oe || re && d.frozenStates;
            se ? H[Q] = 3 : te && (!q || Q === Y) && (K = Q);
          }), K !== null ? (H[K] = 2, d.setSelected(K)) : (d.setSelected(), p && (p.setState(0), p.attr({ text: (B.lang.rangeSelectorZoom || "") + " ▾" })));
          for (let V = 0; V < H.length; V++) {
            let Q = H[V], Z = X[V];
            if (Z.state !== Q && (Z.setState(Q), s)) {
              s.options[V + 1].disabled = Q === 3, Q === 2 && (p && (p.setState(2), p.attr({ text: d.buttonOptions[V].text + " ▾" })), s.selectedIndex = V + 1);
              let ee = p.getBBox();
              x(s, { width: `${ee.width}px`, height: `${ee.height}px` });
            }
          }
        }
        computeButtonRange(d) {
          let r = d.type, s = d.count || 1, p = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
          p[r] ? d._range = p[r] * s : (r === "month" || r === "year") && (d._range = 24 * { month: 30, year: 365 }[r] * 36e5 * s), d._offsetMin = F(d.offsetMin, 0), d._offsetMax = F(d.offsetMax, 0), d._range += d._offsetMax - d._offsetMin;
        }
        getInputValue(d) {
          let r = d === "min" ? this.minInput : this.maxInput, s = this.chart.options.rangeSelector, p = this.chart.time;
          return r ? (r.type === "text" && s.inputDateParser || this.defaultInputDateParser)(r.value, p.useUTC, p) : 0;
        }
        setInputValue(d, r) {
          let s = this.options, p = this.chart.time, b = d === "min" ? this.minInput : this.maxInput, c = d === "min" ? this.minDateBox : this.maxDateBox;
          if (b) {
            let h = b.getAttribute("data-hc-time"), g = T(h) ? Number(h) : void 0;
            if (T(r)) {
              let k = g;
              T(k) && b.setAttribute("data-hc-time-previous", k), b.setAttribute("data-hc-time", r), g = r;
            }
            b.value = p.dateFormat(this.inputTypeFormats[b.type] || s.inputEditDateFormat, g), c && c.attr({ text: p.dateFormat(s.inputDateFormat, g) });
          }
        }
        setInputExtremes(d, r, s) {
          let p = d === "min" ? this.minInput : this.maxInput;
          if (p) {
            let b = this.inputTypeFormats[p.type], c = this.chart.time;
            if (b) {
              let h = c.dateFormat(b, r);
              p.min !== h && (p.min = h);
              let g = c.dateFormat(b, s);
              p.max !== g && (p.max = g);
            }
          }
        }
        showInput(d) {
          let r = d === "min" ? this.minDateBox : this.maxDateBox, s = d === "min" ? this.minInput : this.maxInput;
          if (s && r && this.inputGroup) {
            let p = s.type === "text", { translateX: b = 0, translateY: c = 0 } = this.inputGroup, { x: h = 0, width: g = 0, height: k = 0 } = r, { inputBoxWidth: P } = this.options;
            x(s, { width: p ? g + (P ? -2 : 20) + "px" : "auto", height: k - 2 + "px", border: "2px solid silver" }), p && P ? x(s, { left: b + h + "px", top: c + "px" }) : x(s, { left: Math.min(Math.round(h + b - (s.offsetWidth - g) / 2), this.chart.chartWidth - s.offsetWidth) + "px", top: c - (s.offsetHeight - k) / 2 + "px" });
          }
        }
        hideInput(d) {
          let r = d === "min" ? this.minInput : this.maxInput;
          r && x(r, { top: "-9999em", border: 0, width: "1px", height: "1px" });
        }
        defaultInputDateParser(d, r, s) {
          let p = d.split("/").join("-").split(" ").join("T");
          if (p.indexOf("T") === -1 && (p += "T00:00"), r) p += "Z";
          else {
            let c;
            if (l.isSafari && !((c = p).length > 6 && (c.lastIndexOf("-") === c.length - 6 || c.lastIndexOf("+") === c.length - 6))) {
              let h = new Date(p).getTimezoneOffset() / 60;
              p += h <= 0 ? `+${C(-h)}:00` : `-${C(h)}:00`;
            }
          }
          let b = Date.parse(p);
          if (!M(b)) {
            let c = d.split("-");
            b = Date.UTC(_(c[0]), _(c[1]) - 1, _(c[2]));
          }
          return s && r && M(b) && (b += s.getTimezoneOffset(b)), b;
        }
        drawInput(d) {
          let { chart: r, div: s, inputGroup: p } = this, b = this, c = r.renderer.style || {}, h = r.renderer, g = r.options.rangeSelector, k = B.lang, P = d === "min";
          function O(H) {
            var J;
            let { maxInput: q, minInput: X } = b, $ = r.xAxis[0], K = ((J = r.scroller) == null ? void 0 : J.getUnionExtremes()) || $, V = K.dataMin, Q = K.dataMax, Z = r.xAxis[0].getExtremes()[H], ee = b.getInputValue(H);
            M(ee) && ee !== Z && (P && q && M(V) ? ee > Number(q.getAttribute("data-hc-time")) ? ee = void 0 : ee < V && (ee = V) : X && M(Q) && (ee < Number(X.getAttribute("data-hc-time")) ? ee = void 0 : ee > Q && (ee = Q)), ee !== void 0 && $.setExtremes(P ? ee : $.min, P ? $.max : ee, void 0, void 0, { trigger: "rangeSelectorInput" }));
          }
          let z = k[P ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", W = h.label(z, 0).addClass("highcharts-range-label").attr({ padding: z ? 2 : 0, height: z ? g.inputBoxHeight : 0 }).add(p), G = h.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: g.inputBoxWidth, height: g.inputBoxHeight, "text-align": "center" }).on("click", function() {
            b.showInput(d), b[d + "Input"].focus();
          });
          r.styledMode || G.attr({ stroke: g.inputBoxBorderColor, "stroke-width": 1 }), G.add(p);
          let Y = N("input", { name: d, className: "highcharts-range-selector" }, void 0, s);
          Y.setAttribute("type", function(H) {
            if (H.indexOf("%L") !== -1) return "text";
            let q = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some(($) => H.indexOf("%" + $) !== -1), X = ["H", "k", "I", "l", "M", "S"].some(($) => H.indexOf("%" + $) !== -1);
            return q && X ? "datetime-local" : q ? "date" : X ? "time" : "text";
          }(g.inputDateFormat || "%e %b %Y")), r.styledMode || (W.css(f(c, g.labelStyle)), G.css(f({ color: "#333333" }, c, g.inputStyle)), x(Y, u({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: c.fontSize, fontFamily: c.fontFamily, top: "-9999em" }, g.inputStyle))), Y.onfocus = () => {
            b.showInput(d);
          }, Y.onblur = () => {
            Y === l.doc.activeElement && O(d), b.hideInput(d), b.setInputValue(d), Y.blur();
          };
          let U = !1;
          return Y.onchange = () => {
            U || (O(d), b.hideInput(d), Y.blur());
          }, Y.onkeypress = (H) => {
            H.keyCode === 13 && O(d);
          }, Y.onkeydown = (H) => {
            U = !0, (H.key === "ArrowUp" || H.key === "ArrowDown" || H.key === "Tab") && O(d);
          }, Y.onkeyup = () => {
            U = !1;
          }, { dateBox: G, input: Y, label: W };
        }
        getPosition() {
          let d = this.chart, r = d.options.rangeSelector, s = r.verticalAlign === "top" ? d.plotTop - d.axisOffset[0] : 0;
          return { buttonTop: s + r.buttonPosition.y, inputTop: s + r.inputPosition.y - 10 };
        }
        getYTDExtremes(d, r, s) {
          let p = this.chart.time, b = new p.Date(d), c = p.get("FullYear", b), h = Math.max(r, s ? p.Date.UTC(c, 0, 1) : +new p.Date(c, 0, 1)), g = b.getTime();
          return { max: Math.min(d || g, g), min: h };
        }
        createElements() {
          var g;
          let d = this.chart, r = d.renderer, s = d.container, p = d.options, b = p.rangeSelector, c = b.inputEnabled, h = F((g = p.chart.style) == null ? void 0 : g.zIndex, 0) + 1;
          if (b.enabled !== !1 && (this.group = r.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = N("div", void 0, { position: "relative", height: 0, zIndex: h }), this.buttonOptions.length && this.renderButtons(), s.parentNode && s.parentNode.insertBefore(this.div, s), c)) {
            this.inputGroup = r.g("input-group").add(this.group);
            let k = this.drawInput("min");
            this.minDateBox = k.dateBox, this.minLabel = k.label, this.minInput = k.input;
            let P = this.drawInput("max");
            this.maxDateBox = P.dateBox, this.maxLabel = P.label, this.maxInput = P.input;
          }
        }
        render(d, r) {
          let s = this.chart, p = s.options.rangeSelector, b = p.inputEnabled;
          if (p.enabled !== !1) {
            if (b) {
              this.setInputValue("min", d), this.setInputValue("max", r);
              let c = s.scroller && s.scroller.getUnionExtremes() || s.xAxis[0] || {};
              if (T(c.dataMin) && T(c.dataMax)) {
                let h = s.xAxis[0].minRange || 0;
                this.setInputExtremes("min", c.dataMin, Math.min(c.dataMax, this.getInputValue("max")) - h), this.setInputExtremes("max", Math.max(c.dataMin, this.getInputValue("min")) + h, c.dataMax);
              }
              if (this.inputGroup) {
                let h = 0;
                [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach((g) => {
                  if (g) {
                    let { width: k } = g.getBBox();
                    k && (g.attr({ x: h }), h += k + p.inputSpacing);
                  }
                });
              }
            }
            this.alignElements(), this.updateButtonStates();
          }
        }
        renderButtons() {
          var W;
          let { buttons: d, chart: r, options: s } = this, p = B.lang, b = r.renderer, c = f(s.buttonTheme), h = c && c.states, g = c.width || 28;
          delete c.width, delete c.states, this.buttonGroup = b.g("range-selector-buttons").add(this.group);
          let k = this.dropdown = N("select", void 0, { position: "absolute", padding: 0, border: 0, cursor: "pointer", opacity: 1e-4 }, this.div), P = (W = r.userOptions.rangeSelector) == null ? void 0 : W.buttonTheme;
          this.dropdownLabel = b.button("", 0, 0, () => {
          }, f(c, { "stroke-width": F(c["stroke-width"], 0), width: "auto", paddingLeft: F(s.buttonTheme.paddingLeft, P == null ? void 0 : P.padding, 8), paddingRight: F(s.buttonTheme.paddingRight, P == null ? void 0 : P.padding, 8) }), h && h.hover, h && h.select, h && h.disabled).hide().add(this.group), R(k, "touchstart", () => {
            k.style.fontSize = "16px";
          });
          let O = l.isMS ? "mouseover" : "mouseenter", z = l.isMS ? "mouseout" : "mouseleave";
          R(k, O, () => {
            A(this.dropdownLabel.element, O);
          }), R(k, z, () => {
            A(this.dropdownLabel.element, z);
          }), R(k, "change", () => {
            A(this.buttons[k.selectedIndex - 1].element, "click");
          }), this.zoomText = b.label(p.rangeSelectorZoom || "", 0).attr({ padding: s.buttonTheme.padding, height: s.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(s.labelStyle), c["stroke-width"] = F(c["stroke-width"], 0)), N("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, k), this.buttonOptions.forEach((G, Y) => {
            N("option", { textContent: G.title || G.text }, void 0, k), d[Y] = b.button(G.text, 0, 0, (U) => {
              let H, q = G.events && G.events.click;
              q && (H = q.call(G, U)), H !== !1 && this.clickButton(Y), this.isActive = !0;
            }, c, h && h.hover, h && h.select, h && h.disabled).attr({ "text-align": "center", width: g }).add(this.buttonGroup), G.title && d[Y].attr("title", G.title);
          });
        }
        alignElements() {
          var Y;
          let { buttonGroup: d, buttons: r, chart: s, group: p, inputGroup: b, options: c, zoomText: h } = this, g = s.options, k = g.exporting && g.exporting.enabled !== !1 && g.navigation && g.navigation.buttonOptions, { buttonPosition: P, inputPosition: O, verticalAlign: z } = c, W = (U, H) => k && this.titleCollision(s) && z === "top" && H.align === "right" && H.y - U.getBBox().height - 12 < (k.y || 0) + (k.height || 0) + s.spacing[0] ? -40 : 0, G = s.plotLeft;
          if (p && P && O) {
            let U = P.x - s.spacing[3];
            if (d) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                let ee = 0;
                h && (ee += h.getBBox().width + 5), r.forEach((J, ie) => {
                  ee += J.width || 0, ie !== r.length - 1 && (ee += c.buttonSpacing);
                }), this.initialButtonGroupWidth = ee;
              }
              G -= s.spacing[3];
              let Z = W(d, P);
              this.alignButtonGroup(Z), (Y = this.buttonGroup) != null && Y.translateY && this.dropdownLabel.attr({ y: this.buttonGroup.translateY }), p.placed = d.placed = s.hasLoaded;
            }
            let H = 0;
            b && (H = W(b, O), O.align === "left" ? U = G : O.align === "right" && (U = -Math.max(s.axisOffset[1], -H)), b.align({ y: O.y, width: b.getBBox().width, align: O.align, x: O.x + U - 2 }, !0, s.spacingBox), b.placed = s.hasLoaded), this.handleCollision(H), p.align({ verticalAlign: z }, !0, s.spacingBox);
            let q = p.alignAttr.translateY, X = p.getBBox().height + 20, $ = 0;
            if (z === "bottom") {
              let Z = s.legend && s.legend.options;
              $ = q - (X = X + (Z && Z.verticalAlign === "bottom" && Z.enabled && !Z.floating ? s.legend.legendHeight + F(Z.margin, 10) : 0) - 20) - (c.floating ? 0 : c.y) - (s.titleOffset ? s.titleOffset[2] : 0) - 10;
            }
            z === "top" ? (c.floating && ($ = 0), s.titleOffset && s.titleOffset[0] && ($ = s.titleOffset[0]), $ += s.margin[0] - s.spacing[0] || 0) : z === "middle" && (O.y === P.y ? $ = q : (O.y || P.y) && (O.y < 0 || P.y < 0 ? $ -= Math.min(O.y, P.y) : $ = q - X)), p.translate(c.x, c.y + Math.floor($));
            let { minInput: K, maxInput: V, dropdown: Q } = this;
            c.inputEnabled && K && V && (K.style.marginTop = p.translateY + "px", V.style.marginTop = p.translateY + "px"), Q && (Q.style.marginTop = p.translateY + "px");
          }
        }
        alignButtonGroup(d, r) {
          let { chart: s, options: p, buttonGroup: b } = this, { buttonPosition: c } = p, h = s.plotLeft - s.spacing[3], g = c.x - s.spacing[3];
          c.align === "right" ? g += d - h : c.align === "center" && (g -= h / 2), b && b.align({ y: c.y, width: F(r, this.initialButtonGroupWidth), align: c.align, x: g }, !0, s.spacingBox);
        }
        positionButtons() {
          let { buttons: d, chart: r, options: s, zoomText: p } = this, b = r.hasLoaded ? "animate" : "attr", { buttonPosition: c } = s, h = r.plotLeft, g = h;
          p && p.visibility !== "hidden" && (p[b]({ x: F(h + c.x, h) }), g += c.x + p.getBBox().width + 5);
          for (let k = 0, P = this.buttonOptions.length; k < P; ++k) d[k].visibility !== "hidden" ? (d[k][b]({ x: g }), g += (d[k].width || 0) + s.buttonSpacing) : d[k][b]({ x: h });
        }
        handleCollision(d) {
          let { chart: r, buttonGroup: s, inputGroup: p } = this, { buttonPosition: b, dropdown: c, inputPosition: h } = this.options, g = () => {
            let O = 0;
            return this.buttons.forEach((z) => {
              let W = z.getBBox();
              W.width > O && (O = W.width);
            }), O;
          }, k = (O) => {
            if (p != null && p.alignOptions && s) {
              let z = p.alignAttr.translateX + p.alignOptions.x - d + p.getBBox().x + 2, W = p.alignOptions.width || 0, G = s.alignAttr.translateX + s.getBBox().x;
              return G + O > z && z + W > G && b.y < h.y + p.getBBox().height;
            }
            return !1;
          }, P = () => {
            p && s && p.attr({ translateX: p.alignAttr.translateX + (r.axisOffset[1] >= -d ? 0 : -d), translateY: p.alignAttr.translateY + s.getBBox().height + 10 });
          };
          if (s) {
            if (c === "always") {
              this.collapseButtons(), k(g()) && P();
              return;
            }
            c === "never" && this.expandButtons();
          }
          p && s ? h.align === b.align || k(this.initialButtonGroupWidth + 20) ? c === "responsive" ? (this.collapseButtons(), k(g()) && P()) : P() : c === "responsive" && this.expandButtons() : s && c === "responsive" && (this.initialButtonGroupWidth > r.plotWidth ? this.collapseButtons() : this.expandButtons());
        }
        collapseButtons() {
          let { buttons: d, zoomText: r } = this;
          this.isCollapsed !== !0 && (this.isCollapsed = !0, r.hide(), d.forEach((s) => void s.hide()), this.showDropdown());
        }
        expandButtons() {
          let { buttons: d, zoomText: r } = this;
          this.isCollapsed !== !1 && (this.isCollapsed = !1, this.hideDropdown(), r.show(), d.forEach((s) => void s.show()), this.positionButtons());
        }
        showDropdown() {
          let { buttonGroup: d, chart: r, dropdownLabel: s, dropdown: p } = this;
          if (d && p) {
            let { translateX: b = 0, translateY: c = 0 } = d, h = r.plotLeft + b;
            s.attr({ x: h, y: c }).show(), x(p, { left: h + "px", top: c + "px", visibility: "inherit" }), this.hasVisibleDropdown = !0;
          }
        }
        hideDropdown() {
          let { dropdown: d } = this;
          d && (this.dropdownLabel.hide(), x(d, { visibility: "hidden", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
        }
        getHeight() {
          let d = this.options, r = this.group, s = d.inputPosition, p = d.buttonPosition, b = d.y, c = p.y, h = s.y, g = 0;
          if (d.height) return d.height;
          this.alignElements(), g = r ? r.getBBox(!0).height + 13 + b : 0;
          let k = Math.min(h, c);
          return (h < 0 && c < 0 || h > 0 && c > 0) && (g += Math.abs(k)), g;
        }
        titleCollision(d) {
          return !(d.options.title.text || d.options.subtitle.text);
        }
        update(d, r = !0) {
          let s = this.chart;
          f(!0, s.options.rangeSelector, d), this.destroy(), this.init(s), r && this.render();
        }
        destroy() {
          let d = this, r = d.minInput, s = d.maxInput;
          d.eventsToUnbind && (d.eventsToUnbind.forEach((p) => p()), d.eventsToUnbind = void 0), y(d.buttons), r && (r.onfocus = r.onblur = r.onchange = null), s && (s.onfocus = s.onblur = s.onchange = null), m(d, function(p, b) {
            p && b !== "chart" && (p instanceof D ? p.destroy() : p instanceof window.HTMLElement && S(p)), p !== v.prototype[b] && (d[b] = null);
          }, this);
        }
      }
      return u(v.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), v;
    }), i(e, "Core/Chart/StockChart.js", [e["Core/Chart/Chart.js"], e["Core/Templating.js"], e["Core/Defaults.js"], e["Stock/Navigator/NavigatorDefaults.js"], e["Stock/RangeSelector/RangeSelectorDefaults.js"], e["Stock/Scrollbar/ScrollbarDefaults.js"], e["Stock/Utilities/StockUtilities.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { format: R } = n, { getOptions: N } = l, { setFixedRange: x } = I, { addEvent: T, clamp: y, crisp: S, defined: u, extend: A, find: M, isNumber: f, isString: m, merge: C, pick: F, splat: _ } = B;
      function E(d, r, s) {
        var p, b, c, h;
        return d === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0 } : d === "yAxis" ? { labels: { y: -2 }, opposite: (b = (p = s.opposite) != null ? p : r.opposite) != null ? b : !0, showLastLabel: !!(r.categories || r.type === "category"), title: { text: ((c = s.title) == null ? void 0 : c.text) !== "Values" ? (h = s.title) == null ? void 0 : h.text : null } } : {};
      }
      function v(d, r) {
        if (d === "xAxis") {
          let s = F(r.navigator && r.navigator.enabled, L.enabled, !0), p = { type: "datetime", categories: void 0 };
          return s && (p.startOnTick = !1, p.endOnTick = !1), p;
        }
        return {};
      }
      class w extends o {
        init(r, s) {
          let p = N(), b = r.xAxis, c = r.yAxis, h = F(r.navigator && r.navigator.enabled, L.enabled, !0);
          r.xAxis = r.yAxis = void 0;
          let g = C({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x", mouseWheel: { type: "x" } } }, navigator: { enabled: h }, scrollbar: { enabled: F(j.enabled, !0) }, rangeSelector: { enabled: F(D.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: F(p.tooltip && p.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, r, { isStock: !0 });
          r.xAxis = b, r.yAxis = c, g.xAxis = _(r.xAxis || {}).map((k) => C(E("xAxis", k, p.xAxis), k, v("xAxis", r))), g.yAxis = _(r.yAxis || {}).map((k) => C(E("yAxis", k, p.yAxis), k)), super.init(g, s);
        }
        createAxis(r, s) {
          return s.axis = C(E(r, s.axis, N()[r]), s.axis, v(r, this.userOptions)), super.createAxis(r, s);
        }
      }
      return T(o, "update", function(d) {
        let r = d.options;
        "scrollbar" in r && this.navigator && (C(!0, this.options.scrollbar, r.scrollbar), this.navigator.update({ enabled: !!this.navigator.navigatorEnabled }), delete r.scrollbar);
      }), function(d) {
        function r(P) {
          if (!this.crosshair || !this.crosshair.label || !this.crosshair.label.enabled || !this.cross || !f(this.min) || !f(this.max)) return;
          let O = this.chart, z = this.logarithmic, W = this.crosshair.label, G = this.horiz, Y = this.opposite, U = this.left, H = this.top, q = this.width, X = this.options.tickPosition === "inside", $ = this.crosshair.snap !== !1, K = P.e || this.cross && this.cross.e, V = P.point, Q = this.crossLabel, Z, ee, J = W.format, ie = "", re, ce = 0, he = this.min, ne = this.max;
          z && (he = z.lin2log(this.min), ne = z.lin2log(this.max));
          let oe = G ? "center" : Y ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center";
          Q || (Q = this.crossLabel = O.renderer.label("", 0, void 0, W.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (V && V.series ? V.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: W.align || oe, padding: F(W.padding, 8), r: F(W.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), O.styledMode || Q.attr({ fill: W.backgroundColor || V && V.series && V.series.color || "#666666", stroke: W.borderColor || "", "stroke-width": W.borderWidth || 0 }).css(A({ color: "#ffffff", fontWeight: "normal", fontSize: "0.7em", textAlign: "center" }, W.style || {}))), G ? (Z = $ ? (V.plotX || 0) + U : K.chartX, ee = H + (Y ? 0 : this.height)) : (Z = U + this.offset + (Y ? q : 0), ee = $ ? (V.plotY || 0) + H : K.chartY), J || W.formatter || (this.dateTime && (ie = "%b %d, %Y"), J = "{value" + (ie ? ":" + ie : "") + "}");
          let se = $ ? this.isXAxis ? V.x : V.y : this.toValue(G ? K.chartX : K.chartY), te = V && V.series ? V.series.isPointInside(V) : f(se) && se > he && se < ne, ae = "";
          J ? ae = R(J, { value: se }, O) : W.formatter && f(se) && (ae = W.formatter.call(this, se)), Q.attr({ text: ae, x: Z, y: ee, visibility: te ? "inherit" : "hidden" });
          let le = Q.getBBox();
          !f(Q.x) || G || Y || (Z = Q.x - le.width / 2), f(Q.y) && (G ? (X && !Y || !X && Y) && (ee = Q.y - le.height) : ee = Q.y - le.height / 2), re = G ? { left: U, right: U + this.width } : { left: this.labelAlign === "left" ? U : 0, right: this.labelAlign === "right" ? U + this.width : O.chartWidth };
          let de = Q.translateX || 0;
          de < re.left && (ce = re.left - de), de + le.width >= re.right && (ce = -(de + le.width - re.right)), Q.attr({ x: Z + ce, y: ee, anchorX: G ? Z : this.opposite ? 0 : O.chartWidth, anchorY: G ? this.opposite ? O.chartHeight : 0 : ee + le.height / 2 });
        }
        function s() {
          this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        }
        function p(P) {
          let O = this.chart, z = this.options, W = O._labelPanes = O._labelPanes || {}, G = z.labels;
          if (O.options.isStock && this.coll === "yAxis") {
            let Y = z.top + "," + z.height;
            !W[Y] && G.enabled && (G.distance === 15 && this.side === 1 && (G.distance = 0), G.align === void 0 && (G.align = "right"), W[Y] = this, P.align = "right", P.preventDefault());
          }
        }
        function b() {
          let P = this.chart, O = this.options && this.options.top + "," + this.options.height;
          O && P._labelPanes && P._labelPanes[O] === this && delete P._labelPanes[O];
        }
        function c(P) {
          let O = this, z = O.isLinked && !O.series && O.linkedParent ? O.linkedParent.series : O.series, W = O.chart, G = W.renderer, Y = O.left, U = O.top, H = [], q = P.translatedValue, X = P.value, $ = P.force, K, V, Q, Z, ee = [], J, ie;
          if (W.options.isStock && P.acrossPanes !== !1 && O.coll === "xAxis" || O.coll === "yAxis") {
            for (let re of (P.preventDefault(), ee = ((ce) => {
              let he = ce === "xAxis" ? "yAxis" : "xAxis", ne = O.options[he];
              return f(ne) ? [W[he][ne]] : m(ne) ? [W.get(ne)] : z.map((oe) => oe[he]);
            })(O.coll), O.isXAxis ? W.yAxis : W.xAxis)) if (!re.options.isInternal) {
              let ce = re.isXAxis ? "yAxis" : "xAxis";
              O === (u(re.options[ce]) ? W[ce][re.options[ce]] : W[ce][0]) && ee.push(re);
            }
            for (let re of (J = ee.length ? [] : [O.isXAxis ? W.yAxis[0] : W.xAxis[0]], ee)) J.indexOf(re) !== -1 || M(J, (ce) => ce.pos === re.pos && ce.len === re.len) || J.push(re);
            if (f(ie = F(q, O.translate(X || 0, void 0, void 0, P.old))))
              if (O.horiz) for (let re of J) {
                let ce;
                Z = (V = re.pos) + re.len, K = Q = Math.round(ie + O.transB), $ !== "pass" && (K < Y || K > Y + O.width) && ($ ? K = Q = y(K, Y, Y + O.width) : ce = !0), ce || H.push(["M", K, V], ["L", Q, Z]);
              }
              else for (let re of J) {
                let ce;
                Q = (K = re.pos) + re.len, V = Z = Math.round(U + O.height - ie), $ !== "pass" && (V < U || V > U + O.height) && ($ ? V = Z = y(V, U, U + O.height) : ce = !0), ce || H.push(["M", K, V], ["L", Q, Z]);
              }
            P.path = H.length > 0 ? G.crispPolyLine(H, P.lineWidth || 1) : void 0;
          }
        }
        function h(P) {
          if (this.chart.options.isStock) {
            let O;
            this.is("column") || this.is("columnrange") ? O = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (O = { marker: { enabled: !1, radius: 2 } }), O && (P.plotOptions[this.type] = C(P.plotOptions[this.type], O));
          }
        }
        function g() {
          let P = this.chart, O = this.options.dataGrouping;
          return this.allowDG !== !1 && O && F(O.enabled, P.options.isStock);
        }
        function k(P, O) {
          for (let z = 0; z < P.length; z += 2) {
            let W = P[z], G = P[z + 1];
            u(W[1]) && W[1] === G[1] && (W[1] = G[1] = S(W[1], O)), u(W[2]) && W[2] === G[2] && (W[2] = G[2] = S(W[2], O));
          }
          return P;
        }
        d.compose = function(P, O, z, W) {
          let G = z.prototype;
          G.forceCropping || (T(O, "afterDrawCrosshair", r), T(O, "afterHideCrosshair", s), T(O, "autoLabelAlign", p), T(O, "destroy", b), T(O, "getPlotLinePath", c), P.prototype.setFixedRange = x, G.forceCropping = g, T(z, "setOptions", h), W.prototype.crispPolyLine = k);
        }, d.stockChart = function(P, O, z) {
          return new d(P, O, z);
        };
      }(w || (w = {})), w;
    }), i(e, "Series/HLC/HLCPoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { column: { prototype: { pointClass: n } } } = o.seriesTypes;
      return class extends n {
      };
    }), i(e, "Series/HLC/HLCSeriesDefaults.js", [], function() {
      return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
    }), i(e, "Series/HLC/HLCSeries.js", [e["Series/HLC/HLCPoint.js"], e["Series/HLC/HLCSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { column: D } = l.seriesTypes, { crisp: j, extend: I, merge: B } = L;
      class R extends D {
        extendStem(x, T, y) {
          let S = x[0], u = x[1];
          typeof S[2] == "number" && (S[2] = Math.max(y + T, S[2])), typeof u[2] == "number" && (u[2] = Math.min(y - T, u[2]));
        }
        getPointPath(x, T) {
          let y = T.strokeWidth(), S = x.series, u = j(x.plotX || 0, y), A = Math.round(x.shapeArgs.width / 2), M = [["M", u, Math.round(x.yBottom)], ["L", u, Math.round(x.plotHigh)]];
          if (x.close !== null) {
            let f = j(x.plotClose, y);
            M.push(["M", u, f], ["L", u + A, f]), S.extendStem(M, y / 2, f);
          }
          return M;
        }
        drawSinglePoint(x) {
          let T = x.series, y = T.chart, S, u = x.graphic;
          x.plotY !== void 0 && (u || (x.graphic = u = y.renderer.path().add(T.group)), y.styledMode || u.attr(T.pointAttribs(x, x.selected && "select")), S = T.getPointPath(x, u), u[u ? "animate" : "attr"]({ d: S }).addClass(x.getClassName(), !0));
        }
        drawPoints() {
          this.points.forEach(this.drawSinglePoint);
        }
        init() {
          super.init.apply(this, arguments), this.options.stacking = void 0;
        }
        pointAttribs(x, T) {
          let y = super.pointAttribs.call(this, x, T);
          return delete y.fill, y;
        }
        toYData(x) {
          return [x.high, x.low, x.close];
        }
        translate() {
          let x = this, T = x.yAxis, y = this.pointArrayMap && this.pointArrayMap.slice() || [], S = y.map((u) => `plot${u.charAt(0).toUpperCase() + u.slice(1)}`);
          S.push("yBottom"), y.push("low"), super.translate.apply(x), x.points.forEach(function(u) {
            y.forEach(function(A, M) {
              let f = u[A];
              f !== null && (x.dataModify && (f = x.dataModify.modifyValue(f)), u[S[M]] = T.toPixels(f, !0));
            }), u.tooltipPos[1] = u.plotHigh + T.pos - x.chart.plotTop;
          });
        }
      }
      return R.defaultOptions = B(D.defaultOptions, n), I(R.prototype, { pointClass: o, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), l.registerSeriesType("hlc", R), R;
    }), i(e, "Series/OHLC/OHLCPoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { seriesTypes: { hlc: n } } = o;
      class l extends n.prototype.pointClass {
        getClassName() {
          return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
        resolveUpColor() {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }
        resolveColor() {
          super.resolveColor(), this.series.is("heikinashi") || this.resolveUpColor();
        }
        getZone() {
          let D = super.getZone();
          return this.resolveUpColor(), D;
        }
        applyOptions() {
          return super.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }
      }
      return l;
    }), i(e, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
      return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
    }), i(e, "Series/OHLC/OHLCSeries.js", [e["Core/Globals.js"], e["Series/OHLC/OHLCPoint.js"], e["Series/OHLC/OHLCSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { composed: j } = o, { hlc: I } = L.seriesTypes, { addEvent: B, crisp: R, extend: N, merge: x, pushUnique: T } = D;
      function y(A) {
        let M = A.options, f = M.dataGrouping;
        f && M.useOhlcData && M.id !== "highcharts-navigator-series" && (f.approximation = "ohlc");
      }
      function S(A) {
        let M = A.options;
        M.useOhlcData && M.id !== "highcharts-navigator-series" && N(this, { pointValKey: u.prototype.pointValKey, pointArrayMap: u.prototype.pointArrayMap, toYData: u.prototype.toYData });
      }
      class u extends I {
        static compose(M, ...f) {
          T(j, "OHLCSeries") && (B(M, "afterSetOptions", y), B(M, "init", S));
        }
        getPointPath(M, f) {
          let m = super.getPointPath(M, f), C = f.strokeWidth(), F = R(M.plotX || 0, C), _ = Math.round(M.shapeArgs.width / 2);
          if (M.open !== null) {
            let E = R(M.plotOpen, C);
            m.push(["M", F, E], ["L", F - _, E]), super.extendStem(m, C / 2, E);
          }
          return m;
        }
        pointAttribs(M, f) {
          let m = super.pointAttribs.call(this, M, f), C = this.options;
          return delete m.fill, !M.options.color && C.upColor && M.open < M.close && (m.stroke = C.upColor), m;
        }
        toYData(M) {
          return [M.open, M.high, M.low, M.close];
        }
      }
      return u.defaultOptions = x(I.defaultOptions, l), N(u.prototype, { pointClass: n, pointArrayMap: ["open", "high", "low", "close"] }), L.registerSeriesType("ohlc", u), u;
    }), i(e, "Series/Candlestick/CandlestickSeriesDefaults.js", [], function() {
      return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
    }), i(e, "Series/Candlestick/CandlestickSeries.js", [e["Series/Candlestick/CandlestickSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { column: L, ohlc: D } = n.seriesTypes, { crisp: j, merge: I } = l;
      class B extends D {
        pointAttribs(N, x) {
          let T = L.prototype.pointAttribs.call(this, N, x), y = this.options, S = N.open < N.close, u = y.lineColor || this.color, A = N.color || this.color;
          if (T["stroke-width"] = y.lineWidth, T.fill = N.options.color || S && y.upColor || A, T.stroke = N.options.lineColor || S && y.upLineColor || u, x) {
            let M = y.states[x];
            T.fill = M.color || T.fill, T.stroke = M.lineColor || T.stroke, T["stroke-width"] = M.lineWidth || T["stroke-width"];
          }
          return T;
        }
        drawPoints() {
          let N = this.points, x = this.chart, T = this.yAxis.reversed;
          for (let y of N) {
            let S = y.graphic, u, A, M, f, m, C, F, _, E, v = !S;
            if (y.plotY !== void 0) {
              S || (y.graphic = S = x.renderer.path().add(this.group)), this.chart.styledMode || S.attr(this.pointAttribs(y, y.selected && "select")).shadow(this.options.shadow);
              let w = S.strokeWidth();
              F = j(y.plotX || 0, w), M = Math.min(u = y.plotOpen, A = y.plotClose), f = Math.max(u, A), E = Math.round(y.shapeArgs.width / 2), m = T ? f !== y.yBottom : Math.round(M) !== Math.round(y.plotHigh || 0), C = T ? Math.round(M) !== Math.round(y.plotHigh || 0) : f !== y.yBottom, M = j(M, w), f = j(f, w), (_ = []).push(["M", F - E, f], ["L", F - E, M], ["L", F + E, M], ["L", F + E, f], ["Z"], ["M", F, M], ["L", F, m ? Math.round(T ? y.yBottom : y.plotHigh) : M], ["M", F, f], ["L", F, C ? Math.round(T ? y.plotHigh : y.yBottom) : f]), S[v ? "attr" : "animate"]({ d: _ }).addClass(y.getClassName(), !0);
            }
          }
        }
      }
      return B.defaultOptions = I(D.defaultOptions, { tooltip: D.defaultOptions.tooltip }, o), n.registerSeriesType("candlestick", B), B;
    }), i(e, "Series/Flags/FlagsPoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { column: { prototype: { pointClass: l } } } = o.seriesTypes, { isNumber: L } = n;
      return class extends l {
        constructor() {
          super(...arguments), this.ttBelow = !1;
        }
        isValid() {
          return L(this.y) || this.y === void 0;
        }
        hasNewShapeType() {
          let D = this.options.shape || this.series.options.shape;
          return this.graphic && D && D !== this.graphic.symbolKey;
        }
      };
    }), i(e, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
      return { borderRadius: 0, pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd3ff" } }, style: { fontSize: "0.7em", fontWeight: "bold" } };
    }), i(e, "Series/Flags/FlagsSymbols.js", [e["Core/Renderer/RendererRegistry.js"]], function(o) {
      var n;
      return function(l) {
        let L = [];
        function D(I, B, R, N, x) {
          let T = x && x.anchorX || I, y = x && x.anchorY || B, S = this.circle(T - 1, y - 1, 2, 2);
          return S.push(["M", T, y], ["L", I, B + N], ["L", I, B], ["L", I + R, B], ["L", I + R, B + N], ["L", I, B + N], ["Z"]), S;
        }
        function j(I, B) {
          I[B + "pin"] = function(R, N, x, T, y) {
            let S, u = y && y.anchorX, A = y && y.anchorY;
            if (B === "circle" && T > x && (R -= Math.round((T - x) / 2), x = T), S = I[B](R, N, x, T, y), u && A) {
              let M = u;
              if (B === "circle") M = R + x / 2;
              else {
                let m = S[0], C = S[1];
                m[0] === "M" && C[0] === "L" && (M = (m[1] + C[1]) / 2);
              }
              let f = N > A ? N : N + T;
              S.push(["M", M, f], ["L", u, A]), S = S.concat(I.circle(u - 1, A - 1, 2, 2));
            }
            return S;
          };
        }
        l.compose = function(I) {
          if (L.indexOf(I) === -1) {
            L.push(I);
            let R = I.prototype.symbols;
            R.flag = D, j(R, "circle"), j(R, "square");
          }
          let B = o.getRendererType();
          L.indexOf(B) && L.push(B);
        };
      }(n || (n = {})), n;
    }), i(e, "Series/OnSeriesComposition.js", [e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { composed: j } = n, { prototype: I } = o, { prototype: B } = l, { defined: R, pushUnique: N, stableSort: x } = L;
      return function(T) {
        function y(u) {
          return B.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, u);
        }
        function S() {
          var z, W;
          I.translate.apply(this);
          let u = this, A = u.options, M = u.chart, f = u.points, m = A.onSeries, C = m && M.get(m), F = C && C.options.step, _ = C && C.points, E = M.inverted, v = u.xAxis, w = u.yAxis, d = f.length - 1, r, s, p = A.onKey || "y", b = _ && _.length, c = 0, h, g, k, P, O;
          if (C && C.visible && b) {
            for (c = (C.pointXOffset || 0) + (C.barW || 0) / 2, P = C.currentDataGrouping, g = _[b - 1].x + (P ? P.totalRange : 0), x(f, (G, Y) => G.x - Y.x), p = "plot" + p[0].toUpperCase() + p.substr(1); b-- && f[d]; ) if (h = _[b], (r = f[d]).y = h.y, h.x <= r.x && h[p] !== void 0) {
              if (r.x <= g && (r.plotY = h[p], h.x < r.x && !F && (k = _[b + 1]) && k[p] !== void 0))
                if (R(r.plotX) && C.is("spline")) {
                  let G = [h.plotX || 0, h.plotY || 0], Y = [k.plotX || 0, k.plotY || 0], U = ((z = h.controlPoints) == null ? void 0 : z.high) || G, H = ((W = k.controlPoints) == null ? void 0 : W.low) || Y, q = (V, Q) => Math.pow(1 - V, 3) * G[Q] + 3 * (1 - V) * (1 - V) * V * U[Q] + 3 * (1 - V) * V * V * H[Q] + V * V * V * Y[Q], X = 0, $ = 1, K;
                  for (let V = 0; V < 100; V++) {
                    let Q = (X + $) / 2, Z = q(Q, 0);
                    if (Z === null) break;
                    if (0.25 > Math.abs(Z - r.plotX)) {
                      K = Q;
                      break;
                    }
                    Z < r.plotX ? X = Q : $ = Q;
                  }
                  R(K) && (r.plotY = q(K, 1), r.y = w.toValue(r.plotY, !0));
                } else O = (r.x - h.x) / (k.x - h.x), r.plotY += O * (k[p] - h[p]), r.y += O * (k.y - h.y);
              if (d--, b++, d < 0) break;
            }
          }
          f.forEach((G, Y) => {
            let U;
            G.plotX += c, (G.plotY === void 0 || E) && (G.plotX >= 0 && G.plotX <= v.len ? E ? (G.plotY = v.translate(G.x, 0, 1, 0, 1), G.plotX = R(G.y) ? w.translate(G.y, 0, 0, 0, 1) : 0) : G.plotY = (v.opposite ? 0 : u.yAxis.len) + v.offset : G.shapeArgs = {}), (s = f[Y - 1]) && s.plotX === G.plotX && (s.stackIndex === void 0 && (s.stackIndex = 0), U = s.stackIndex + 1), G.stackIndex = U;
          }), this.onSeries = C;
        }
        T.compose = function(u) {
          if (N(j, "OnSeries")) {
            let A = u.prototype;
            A.getPlotBox = y, A.translate = S;
          }
          return u;
        }, T.getPlotBox = y, T.translate = S;
      }(D || (D = {})), D;
    }), i(e, "Series/Flags/FlagsSeries.js", [e["Series/Flags/FlagsPoint.js"], e["Series/Flags/FlagsSeriesDefaults.js"], e["Series/Flags/FlagsSymbols.js"], e["Core/Globals.js"], e["Series/OnSeriesComposition.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R) {
      let { noop: N } = L, { distribute: x } = j, { series: T, seriesTypes: { column: y } } = I, { addEvent: S, defined: u, extend: A, isNumber: M, merge: f, objectEach: m, wrap: C } = R;
      class F extends y {
        animate(E) {
          E && this.setClip();
        }
        drawPoints() {
          var X, $;
          let E, v, w, d, r, s, p, b, c, h, g, k = this.points, P = this.chart, O = P.renderer, z = P.inverted, W = this.options, G = W.y, Y = this.yAxis, U = {}, H = [], q = M(W.borderRadius) ? W.borderRadius : 0;
          for (d = k.length; d--; ) r = k[d], h = (z ? r.plotY : r.plotX) > this.xAxis.len, E = r.plotX, p = r.stackIndex, w = r.options.shape || W.shape, (v = r.plotY) !== void 0 && (v = r.plotY + G - (p !== void 0 && p * W.stackDistance)), r.anchorX = p ? void 0 : r.plotX, b = p ? void 0 : r.plotY, g = w !== "flag", s = r.graphic, v !== void 0 && E >= 0 && !h ? (s && r.hasNewShapeType() && (s = s.destroy()), s || (s = r.graphic = O.label("", 0, void 0, w, void 0, void 0, W.useHTML).addClass("highcharts-point").add(this.markerGroup), r.graphic.div && (r.graphic.div.point = r), s.isNew = !0), s.attr({ align: g ? "center" : "left", width: W.width, height: W.height, "text-align": W.textAlign, r: q }), P.styledMode || s.attr(this.pointAttribs(r)).css(f(W.style, r.style)).shadow(W.shadow), E > 0 && (E -= s.strokeWidth() % 2), c = { y: v, anchorY: b }, W.allowOverlapX && (c.x = E, c.anchorX = r.anchorX), s.attr({ text: ($ = (X = r.options.title) != null ? X : W.title) != null ? $ : "A" })[s.isNew ? "attr" : "animate"](c), W.allowOverlapX || (U[r.plotX] ? U[r.plotX].size = Math.max(U[r.plotX].size, s.width || 0) : U[r.plotX] = { align: g ? 0.5 : 0, size: s.width || 0, target: E, anchorX: E }), r.tooltipPos = [E, v + Y.pos - P.plotTop]) : s && (r.graphic = s.destroy());
          if (!W.allowOverlapX) {
            let K = 100;
            for (let V of (m(U, function(Q) {
              Q.plotX = Q.anchorX, H.push(Q), K = Math.max(Q.size, K);
            }), x(H, z ? Y.len : this.xAxis.len, K), k)) {
              let Q = V.plotX, Z = V.graphic, ee = Z && U[Q];
              ee && Z && (u(ee.pos) ? Z[Z.isNew ? "attr" : "animate"]({ x: ee.pos + (ee.align || 0) * ee.size, anchorX: V.anchorX }).show().isNew = !1 : Z.hide().isNew = !0);
            }
          }
          W.useHTML && this.markerGroup && C(this.markerGroup, "on", function(K) {
            return B.prototype.on.apply(K.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }
        drawTracker() {
          let E = this.points;
          for (let v of (super.drawTracker(), E)) {
            let w = v.graphic;
            w && (v.unbindMouseOver && v.unbindMouseOver(), v.unbindMouseOver = S(w.element, "mouseover", function() {
              for (let d of (v.stackIndex > 0 && !v.raised && (v._y = w.y, w.attr({ y: v._y - 8 }), v.raised = !0), E)) d !== v && d.raised && d.graphic && (d.graphic.attr({ y: d._y }), d.raised = !1);
            }));
          }
        }
        pointAttribs(E, v) {
          let w = this.options, d = E && E.color || this.color, r = w.lineColor, s = E && E.lineWidth, p = E && E.fillColor || w.fillColor;
          return v && (p = w.states[v].fillColor, r = w.states[v].lineColor, s = w.states[v].lineWidth), { fill: p || d, stroke: r || d, "stroke-width": s || w.lineWidth || 0 };
        }
        setClip() {
          T.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }
      }
      return F.compose = l.compose, F.defaultOptions = f(y.defaultOptions, n), D.compose(F), A(F.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: o, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: N, init: T.prototype.init }), I.registerSeriesType("flags", F), F;
    }), i(e, "Core/Axis/BrokenAxis.js", [e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { addEvent: L, find: D, fireEvent: j, isArray: I, isNumber: B, pick: R } = n;
      return function(N) {
        function x() {
          this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function T() {
          var C;
          (C = this.brokenAxis) != null && C.hasBreaks && (this.options.ordinal = !1);
        }
        function y() {
          let C = this.brokenAxis;
          if (C != null && C.hasBreaks) {
            let F = this.tickPositions, _ = this.tickPositions.info, E = [];
            for (let v = 0; v < F.length; v++) C.isInAnyBreak(F[v]) || E.push(F[v]);
            this.tickPositions = E, this.tickPositions.info = _;
          }
        }
        function S() {
          this.brokenAxis || (this.brokenAxis = new m(this));
        }
        function u() {
          var w, d;
          let { isDirty: C, options: { connectNulls: F }, points: _, xAxis: E, yAxis: v } = this;
          if (C) {
            let r = _.length;
            for (; r--; ) {
              let s = _[r], p = !(s.y === null && F === !1) && (((w = E == null ? void 0 : E.brokenAxis) == null ? void 0 : w.isInAnyBreak(s.x, !0)) || ((d = v == null ? void 0 : v.brokenAxis) == null ? void 0 : d.isInAnyBreak(s.y, !0)));
              s.visible = !p && s.options.visible !== !1;
            }
          }
        }
        function A() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, R(this.pointArrayMap, ["y"]));
        }
        function M(C, F) {
          var r;
          let _, E, v, w = this, d = w.points;
          if ((r = C == null ? void 0 : C.brokenAxis) != null && r.hasBreaks) {
            let s = C.brokenAxis;
            F.forEach(function(p) {
              var c, h;
              _ = (s == null ? void 0 : s.breakArray) || [], E = C.isXAxis ? C.min : R(w.options.threshold, C.min);
              let b = (h = (c = C == null ? void 0 : C.options) == null ? void 0 : c.breaks) == null ? void 0 : h.filter(function(g) {
                let k = !0;
                for (let P = 0; P < _.length; P++) {
                  let O = _[P];
                  if (O.from === g.from && O.to === g.to) {
                    k = !1;
                    break;
                  }
                }
                return k;
              });
              d.forEach(function(g) {
                v = R(g["stack" + p.toUpperCase()], g[p]), _.forEach(function(k) {
                  if (B(E) && B(v)) {
                    let P = "";
                    E < k.from && v > k.to || E > k.from && v < k.from ? P = "pointBreak" : (E < k.from && v > k.from && v < k.to || E > k.from && v > k.to && v < k.from) && (P = "pointInBreak"), P && j(C, P, { point: g, brk: k });
                  }
                }), b == null || b.forEach(function(k) {
                  j(C, "pointOutsideOfBreak", { point: g, brk: k });
                });
              });
            });
          }
        }
        function f() {
          let C = this.currentDataGrouping, F = C == null ? void 0 : C.gapSize, _ = this.points.slice(), E = this.yAxis, v = this.options.gapSize, w = _.length - 1;
          if (v && w > 0) {
            let d, r;
            for (this.options.gapUnit !== "value" && (v *= this.basePointRange), F && F > v && F >= this.basePointRange && (v = F); w--; ) if (r && r.visible !== !1 || (r = _[w + 1]), d = _[w], r.visible !== !1 && d.visible !== !1) {
              if (r.x - d.x > v) {
                let s = (d.x + r.x) / 2;
                _.splice(w + 1, 0, { isNull: !0, x: s }), E.stacking && this.options.stacking && ((E.stacking.stacks[this.stackKey][s] = new o(E, E.options.stackLabels, !1, s, this.stack)).total = 0);
              }
              r = d;
            }
          }
          return this.getGraphPath(_);
        }
        N.compose = function(C, F) {
          if (!C.keepProps.includes("brokenAxis")) {
            C.keepProps.push("brokenAxis"), L(C, "init", S), L(C, "afterInit", x), L(C, "afterSetTickPositions", y), L(C, "afterSetOptions", T);
            let _ = F.prototype;
            _.drawBreaks = M, _.gappedPath = f, L(F, "afterGeneratePoints", u), L(F, "afterRender", A);
          }
          return C;
        };
        class m {
          static isInBreak(F, _) {
            let E = F.repeat || 1 / 0, v = F.from, w = F.to - F.from, d = _ >= v ? (_ - v) % E : E - (v - _) % E;
            return F.inclusive ? d <= w : d < w && d !== 0;
          }
          static lin2Val(F) {
            let _ = this.brokenAxis, E = _ && _.breakArray;
            if (!E || !B(F)) return F;
            let v = F, w, d;
            for (d = 0; d < E.length && !((w = E[d]).from >= v); d++) (w.to < v || m.isInBreak(w, v)) && (v += w.len);
            return v;
          }
          static val2Lin(F) {
            let _ = this.brokenAxis, E = _ && _.breakArray;
            if (!E || !B(F)) return F;
            let v = F, w, d;
            for (d = 0; d < E.length; d++) if ((w = E[d]).to <= F) v -= w.len;
            else {
              if (w.from >= F) break;
              if (m.isInBreak(w, F)) {
                v -= F - w.from;
                break;
              }
            }
            return v;
          }
          constructor(F) {
            this.hasBreaks = !1, this.axis = F;
          }
          findBreakAt(F, _) {
            return D(_, function(E) {
              return E.from < F && F < E.to;
            });
          }
          isInAnyBreak(F, _) {
            let E = this.axis, v = E.options.breaks || [], w = v.length, d, r, s;
            if (w && B(F)) {
              for (; w--; ) m.isInBreak(v[w], F) && (d = !0, r || (r = R(v[w].showPoints, !E.isXAxis)));
              s = d && _ ? d && !r : d;
            }
            return s;
          }
          setBreaks(F, _) {
            let E = this, v = E.axis, w = I(F) && !!F.length && !!Object.keys(F[0]).length;
            v.isDirty = E.hasBreaks !== w, E.hasBreaks = w, F !== v.options.breaks && (v.options.breaks = v.userOptions.breaks = F), v.forceRedraw = !0, v.series.forEach(function(d) {
              d.isDirty = !0;
            }), w || v.val2lin !== m.val2Lin || (delete v.val2lin, delete v.lin2val), w && (v.userOptions.ordinal = !1, v.lin2val = m.lin2Val, v.val2lin = m.val2Lin, v.setExtremes = function(d, r, s, p, b) {
              if (E.hasBreaks) {
                let c, h = this.options.breaks || [];
                for (; c = E.findBreakAt(d, h); ) d = c.to;
                for (; c = E.findBreakAt(r, h); ) r = c.from;
                r < d && (r = d);
              }
              v.constructor.prototype.setExtremes.call(this, d, r, s, p, b);
            }, v.setAxisTranslation = function() {
              if (v.constructor.prototype.setAxisTranslation.call(this), E.unitLength = void 0, E.hasBreaks) {
                let d = v.options.breaks || [], r = [], s = [], p = R(v.pointRangePadding, 0), b = 0, c, h, g = v.userMin || v.min, k = v.userMax || v.max, P, O;
                d.forEach(function(z) {
                  h = z.repeat || 1 / 0, B(g) && B(k) && (m.isInBreak(z, g) && (g += z.to % h - g % h), m.isInBreak(z, k) && (k -= k % h - z.from % h));
                }), d.forEach(function(z) {
                  if (P = z.from, h = z.repeat || 1 / 0, B(g) && B(k)) {
                    for (; P - h > g; ) P -= h;
                    for (; P < g; ) P += h;
                    for (O = P; O < k; O += h) r.push({ value: O, move: "in" }), r.push({ value: O + z.to - z.from, move: "out", size: z.breakSize });
                  }
                }), r.sort(function(z, W) {
                  return z.value === W.value ? (z.move === "in" ? 0 : 1) - (W.move === "in" ? 0 : 1) : z.value - W.value;
                }), c = 0, P = g, r.forEach(function(z) {
                  (c += z.move === "in" ? 1 : -1) === 1 && z.move === "in" && (P = z.value), c === 0 && B(P) && (s.push({ from: P, to: z.value, len: z.value - P - (z.size || 0) }), b += z.value - P - (z.size || 0));
                }), E.breakArray = s, B(g) && B(k) && B(v.min) && (E.unitLength = k - g - b + p, j(v, "afterBreaks"), v.staticScale ? v.transA = v.staticScale : E.unitLength && (v.transA *= (k - v.min + p) / E.unitLength), p && (v.minPixelPadding = v.transA * (v.minPointOffset || 0)), v.min = g, v.max = k);
              }
            }), R(_, !0) && v.chart.redraw();
          }
        }
        N.Additions = m;
      }(l || (l = {})), l;
    }), i(e, "masters/modules/broken-axis.src.js", [e["Core/Globals.js"], e["Core/Axis/BrokenAxis.js"]], function(o, n) {
      return o.BrokenAxis = o.BrokenAxis || n, o.BrokenAxis.compose(o.Axis, o.Series), o;
    }), i(e, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
      return {};
    }), i(e, "Extensions/DataGrouping/ApproximationDefaults.js", [e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { arrayMax: l, arrayMin: L, correctFloat: D, extend: j, isNumber: I } = n;
      function B(x) {
        let T = x.length, y = R(x);
        return I(y) && T && (y = D(y / T)), y;
      }
      function R(x) {
        let T = x.length, y;
        if (!T && x.hasNulls) y = null;
        else if (T) for (y = 0; T--; ) y += x[T];
        return y;
      }
      let N = { average: B, averages: function() {
        let x = [];
        return [].forEach.call(arguments, function(T) {
          x.push(B(T));
        }), x[0] === void 0 ? void 0 : x;
      }, close: function(x) {
        return x.length ? x[x.length - 1] : x.hasNulls ? null : void 0;
      }, high: function(x) {
        return x.length ? l(x) : x.hasNulls ? null : void 0;
      }, hlc: function(x, T, y) {
        if (x = o.high(x), T = o.low(T), y = o.close(y), I(x) || I(T) || I(y)) return [x, T, y];
      }, low: function(x) {
        return x.length ? L(x) : x.hasNulls ? null : void 0;
      }, ohlc: function(x, T, y, S) {
        if (x = o.open(x), T = o.high(T), y = o.low(y), S = o.close(S), I(x) || I(T) || I(y) || I(S)) return [x, T, y, S];
      }, open: function(x) {
        return x.length ? x[0] : x.hasNulls ? null : void 0;
      }, range: function(x, T) {
        return x = o.low(x), T = o.high(T), I(x) || I(T) ? [x, T] : x === null && T === null ? null : void 0;
      }, sum: R };
      return j(o, N), N;
    }), i(e, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
      return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %e %b, %H:%M:%S.%L", "%A, %e %b, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %e %b, %H:%M:%S", "%A, %e %b, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], hour: ["%A, %e %b, %H:%M", "%A, %e %b, %H:%M", "-%H:%M"], day: ["%A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], week: ["Week from %A, %e %b %Y", "%A, %e %b", "-%A, %e %b %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
    }), i(e, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Core/Utilities.js"]], function(o, n) {
      let l, { addEvent: L, extend: D, merge: j, pick: I } = n;
      function B(T) {
        let y = this, S = y.series;
        S.forEach(function(u) {
          u.groupPixelWidth = void 0;
        }), S.forEach(function(u) {
          u.groupPixelWidth = y.getGroupPixelWidth && y.getGroupPixelWidth(), u.groupPixelWidth && (u.hasProcessed = !0), u.applyGrouping(!!T.hasExtremesChanged);
        });
      }
      function R() {
        let T = this.series, y = T.length, S = 0, u = !1, A, M;
        for (; y--; ) (M = T[y].options.dataGrouping) && (S = Math.max(S, I(M.groupPixelWidth, o.common.groupPixelWidth)), A = (T[y].processedXData || T[y].data).length, (T[y].groupPixelWidth || A > this.chart.plotSizeX / S || A && M.forced) && (u = !0));
        return u ? S : 0;
      }
      function N() {
        this.series.forEach(function(T) {
          T.hasProcessed = !1;
        });
      }
      function x(T, y) {
        let S;
        if (y = I(y, !0), T || (T = { forced: !1, units: null }), this instanceof l) for (S = this.series.length; S--; ) this.series[S].update({ dataGrouping: T }, !1);
        else this.chart.options.series.forEach(function(u) {
          u.dataGrouping = typeof T == "boolean" ? T : j(T, u.dataGrouping);
        });
        this.ordinal && (this.ordinal.slope = void 0), y && this.chart.redraw();
      }
      return { compose: function(T) {
        l = T;
        let y = T.prototype;
        y.applyGrouping || (L(T, "afterSetScale", N), L(T, "postProcessData", B), D(y, { applyGrouping: B, getGroupPixelWidth: R, setDataGrouping: x }));
      } };
    }), i(e, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Core/Axis/DateTimeAxis.js"], e["Core/Defaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { series: { prototype: I } } = D, { addEvent: B, defined: R, error: N, extend: x, isNumber: T, merge: y, pick: S } = j, u = I.generatePoints;
      function A(_) {
        var E;
        let v, w, d = this.chart, r = this.options.dataGrouping, s = this.allowDG !== !1 && r && S(r.enabled, d.options.isStock), p = this.reserveSpace(), b = this.currentDataGrouping, c, h, g = !1;
        s && !this.requireSorting && (this.requireSorting = g = !0);
        let k = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !_) || !s;
        if (g && (this.requireSorting = !1), k) return;
        this.destroyGroupedData();
        let P = r.groupAll ? this.xData : this.processedXData, O = r.groupAll ? this.yData : this.processedYData, z = d.plotSizeX, W = this.xAxis, G = W.options.ordinal, Y = this.groupPixelWidth;
        if (Y && P && P.length && z) {
          w = !0, this.isDirty = !0, this.points = null;
          let U = W.getExtremes(), H = U.min, q = U.max, X = G && W.ordinal && W.ordinal.getGroupIntervalFactor(H, q, this) || 1, $ = Y * (q - H) / z * X, K = W.getTimeTicks(l.Additions.prototype.normalizeTimeTickInterval($, r.units || n.units), Math.min(H, P[0]), Math.max(q, P[P.length - 1]), W.options.startOfWeek, P, this.closestPointRange), V = I.groupData.apply(this, [P, O, K, r.approximation]), Q = V.groupedXData, Z = V.groupedYData, ee = 0;
          for (r && r.smoothed && Q.length && (r.firstAnchor = "firstPoint", r.anchor = "middle", r.lastAnchor = "lastPoint", N(32, !1, d, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), v = 1; v < K.length; v++) K.info.segmentStarts && K.info.segmentStarts.indexOf(v) !== -1 || (ee = Math.max(K[v] - K[v - 1], ee));
          (c = K.info).gapSize = ee, this.closestPointRange = K.info.totalRange, this.groupMap = V.groupMap, this.currentDataGrouping = c, function(J, ie, re) {
            let ce = J.options.dataGrouping, he = J.currentDataGrouping && J.currentDataGrouping.gapSize;
            if (!(ce && J.xData && he && J.groupMap)) return;
            let ne = ie.length - 1, oe = ce.anchor, se = ce.firstAnchor, te = ce.lastAnchor, ae = ie.length - 1, le = 0;
            if (se && J.xData[0] >= ie[0]) {
              let de;
              le++;
              let be = J.groupMap[0].start, ge = J.groupMap[0].length;
              T(be) && T(ge) && (de = be + (ge - 1)), ie[0] = { start: ie[0], middle: ie[0] + 0.5 * he, end: ie[0] + he, firstPoint: J.xData[0], lastPoint: de && J.xData[de] }[se];
            }
            if (ne > 0 && te && he && ie[ne] >= re - he) {
              ae--;
              let de = J.groupMap[J.groupMap.length - 1].start;
              ie[ne] = { start: ie[ne], middle: ie[ne] + 0.5 * he, end: ie[ne] + he, firstPoint: de && J.xData[de], lastPoint: J.xData[J.xData.length - 1] }[te];
            }
            if (oe && oe !== "start") {
              let de = he * { middle: 0.5, end: 1 }[oe];
              for (; ae >= le; ) ie[ae] += de, ae--;
            }
          }(this, Q, q), p && (R((E = Q)[0]) && T(W.min) && T(W.dataMin) && E[0] < W.min && ((!R(W.options.min) && W.min <= W.dataMin || W.min === W.dataMin) && (W.min = Math.min(E[0], W.min)), W.dataMin = Math.min(E[0], W.dataMin)), R(E[E.length - 1]) && T(W.max) && T(W.dataMax) && E[E.length - 1] > W.max && ((!R(W.options.max) && T(W.dataMax) && W.max >= W.dataMax || W.max === W.dataMax) && (W.max = Math.max(E[E.length - 1], W.max)), W.dataMax = Math.max(E[E.length - 1], W.dataMax))), r.groupAll && (this.allGroupedData = Z, Q = (h = this.cropData(Q, Z, W.min, W.max)).xData, Z = h.yData, this.cropStart = h.start), this.processedXData = Q, this.processedYData = Z;
        } else this.groupMap = null, this.currentDataGrouping = void 0;
        this.hasGroupedData = w, this.preventGraphAnimation = (b && b.totalRange) !== (c && c.totalRange);
      }
      function M() {
        this.groupedData && (this.groupedData.forEach(function(_, E) {
          _ && (this.groupedData[E] = _.destroy ? _.destroy() : null);
        }, this), this.groupedData.length = 0, delete this.allGroupedData);
      }
      function f() {
        u.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function m() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
      }
      function C(_, E, v, w) {
        let d = this, r = d.data, s = d.options && d.options.data, p = [], b = [], c = [], h = _.length, g = !!E, k = [], P = d.pointArrayMap, O = P && P.length, z = ["x"].concat(P || ["y"]), W = this.options.dataGrouping && this.options.dataGrouping.groupAll, G, Y, U, H = 0, q = 0, X = typeof w == "function" ? w : w && o[w] ? o[w] : o[d.getDGApproximation && d.getDGApproximation() || "average"];
        if (O) {
          let K = P.length;
          for (; K--; ) k.push([]);
        } else k.push([]);
        let $ = O || 1;
        for (let K = 0; K <= h; K++) if (!(_[K] < v[0])) {
          for (; v[H + 1] !== void 0 && _[K] >= v[H + 1] || K === h; ) {
            G = v[H], d.dataGroupInfo = { start: W ? q : d.cropStart + q, length: k[0].length, groupStart: G }, U = X.apply(d, k), d.pointClass && !R(d.dataGroupInfo.options) && (d.dataGroupInfo.options = y(d.pointClass.prototype.optionsToObject.call({ series: d }, d.options.data[d.cropStart + q])), z.forEach(function(V) {
              delete d.dataGroupInfo.options[V];
            })), U !== void 0 && (p.push(G), b.push(U), c.push(d.dataGroupInfo)), q = K;
            for (let V = 0; V < $; V++) k[V].length = 0, k[V].hasNulls = !1;
            if (H += 1, K === h) break;
          }
          if (K === h) break;
          if (P) {
            let V, Q = d.options.dataGrouping && d.options.dataGrouping.groupAll ? K : d.cropStart + K, Z = r && r[Q] || d.pointClass.prototype.applyOptions.apply({ series: d }, [s[Q]]);
            for (let ee = 0; ee < O; ee++) T(V = Z[P[ee]]) ? k[ee].push(V) : V === null && (k[ee].hasNulls = !0);
          } else T(Y = g ? E[K] : null) ? k[0].push(Y) : Y === null && (k[0].hasNulls = !0);
        }
        return { groupedXData: p, groupedYData: b, groupMap: c };
      }
      function F(_) {
        let E = _.options, v = this.type, w = this.chart.options.plotOptions, d = this.useCommonDataGrouping && n.common, r = n.seriesSpecific, s = L.defaultOptions.plotOptions[v].dataGrouping;
        if (w && (r[v] || d)) {
          let p = this.chart.rangeSelector;
          s || (s = y(n.common, r[v])), E.dataGrouping = y(d, s, w.series && w.series.dataGrouping, w[v].dataGrouping, this.userOptions.dataGrouping, !E.isInternal && p && T(p.selected) && p.buttonOptions[p.selected].dataGrouping);
        }
      }
      return { compose: function(_) {
        let E = _.prototype;
        E.applyGrouping || (B(_.prototype.pointClass, "update", function() {
          if (this.dataGroup) return N(24, !1, this.series.chart), !1;
        }), B(_, "afterSetOptions", F), B(_, "destroy", M), x(E, { applyGrouping: A, destroyGroupedData: M, generatePoints: f, getDGApproximation: m, groupData: C }));
      }, groupData: C };
    }), i(e, "Extensions/DataGrouping/DataGrouping.js", [e["Extensions/DataGrouping/DataGroupingAxisComposition.js"], e["Extensions/DataGrouping/DataGroupingDefaults.js"], e["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { format: I } = L, { composed: B } = D, { addEvent: R, extend: N, isNumber: x, pick: T, pushUnique: y } = j;
      function S(u) {
        var h;
        let A = this.chart, M = A.time, f = u.labelConfig, m = f.series, C = f.point, F = m.options, _ = m.tooltipOptions, E = F.dataGrouping, v = m.xAxis, w = _.xDateFormat, d, r, s, p, b, c = _[u.isFooter ? "footerFormat" : "headerFormat"];
        if (v && v.options.type === "datetime" && E && x(f.key)) {
          r = m.currentDataGrouping, s = E.dateTimeLabelFormats || n.common.dateTimeLabelFormats, r ? (p = s[r.unitName], r.count === 1 ? w = p[0] : (w = p[1], d = p[2])) : !w && s && v.dateTime && (w = v.dateTime.getXDateFormat(f.x, _.dateTimeLabelFormats));
          let g = T((h = m.groupMap) == null ? void 0 : h[C.index].groupStart, f.key), k = g + (r == null ? void 0 : r.totalRange) - 1;
          b = M.dateFormat(w, g), d && (b += M.dateFormat(d, k)), m.chart.styledMode && (c = this.styledModeFormat(c)), u.text = I(c, { point: N(f.point, { key: b }), series: m }, A), u.preventDefault();
        }
      }
      return { compose: function(u, A, M) {
        o.compose(u), l.compose(A), M && y(B, "DataGrouping") && R(M, "headerFormatter", S);
      }, groupData: l.groupData };
    }), i(e, "masters/modules/datagrouping.src.js", [e["Core/Globals.js"], e["Extensions/DataGrouping/ApproximationDefaults.js"], e["Extensions/DataGrouping/ApproximationRegistry.js"], e["Extensions/DataGrouping/DataGrouping.js"]], function(o, n, l, L) {
      return o.dataGrouping = o.dataGrouping || {}, o.dataGrouping.approximationDefaults = o.dataGrouping.approximationDefaults || n, o.dataGrouping.approximations = o.dataGrouping.approximations || l, L.compose(o.Axis, o.Series, o.Tooltip), o;
    }), i(e, "Extensions/Annotations/NavigationBindingsUtilities.js", [e["Core/Utilities.js"]], function(o) {
      let { defined: n, isNumber: l, pick: L } = o, D = { backgroundColor: "string", borderColor: "string", borderRadius: "string", color: "string", fill: "string", fontSize: "string", labels: "string", name: "string", stroke: "string", title: "string" };
      return { annotationsFieldsTypes: D, getAssignedAxis: function(j) {
        return j.filter((I) => {
          let B = I.axis.getExtremes(), R = B.min, N = B.max, x = L(I.axis.minPointOffset, 0);
          return l(R) && l(N) && I.value >= R - x && I.value <= N + x && !I.axis.options.isInternal;
        })[0];
      }, getFieldType: function(j, I) {
        let B = D[j], R = typeof I;
        return n(B) && (R = B), { string: "text", number: "number", boolean: "checkbox" }[R];
      } };
    }), i(e, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [e["Core/Utilities.js"], e["Extensions/Annotations/NavigationBindingsUtilities.js"]], function(o, n) {
      let l, { addEvent: L, isObject: D, pick: j, defined: I, merge: B } = o, { getAssignedAxis: R } = n, N = [], x = { enabled: !0, sensitivity: 1.1 }, T = (u) => (D(u) || (u = { enabled: u != null ? u : !0 }), B(x, u)), y = function(u, A, M, f, m, C, F) {
        let _ = j(F.type, u.zooming.type, ""), E = [];
        _ === "x" ? E = M : _ === "y" ? E = f : _ === "xy" && (E = u.axes);
        let v = u.transform({ axes: E, to: { x: m - 5, y: C - 5, width: 10, height: 10 }, from: { x: m - 5 * A, y: C - 5 * A, width: 10 * A, height: 10 * A }, trigger: "mousewheel" });
        return v && (I(l) && clearTimeout(l), l = setTimeout(() => {
          var w;
          (w = u.pointer) == null || w.drop();
        }, 400)), v;
      };
      function S() {
        let u = T(this.zooming.mouseWheel);
        u.enabled && L(this.container, "wheel", (A) => {
          var m, C;
          A = ((m = this.pointer) == null ? void 0 : m.normalize(A)) || A;
          let { pointer: M } = this, f = M && !M.inClass(A.target, "highcharts-no-mousewheel");
          if (this.isInsidePlot(A.chartX - this.plotLeft, A.chartY - this.plotTop) && f) {
            let F = u.sensitivity || 1.1, _ = A.detail || (A.deltaY || 0) / 120, E = R(M.getCoordinates(A).xAxis), v = R(M.getCoordinates(A).yAxis);
            y(this, Math.pow(F, _), E ? [E.axis] : this.xAxis, v ? [v.axis] : this.yAxis, A.chartX, A.chartY, u) && ((C = A.preventDefault) == null || C.call(A));
          }
        });
      }
      return { compose: function(u) {
        N.indexOf(u) === -1 && (N.push(u), L(u, "afterGetContainer", S));
      } };
    }), i(e, "masters/modules/mouse-wheel-zoom.src.js", [e["Core/Globals.js"], e["Extensions/MouseWheelZoom/MouseWheelZoom.js"]], function(o, n) {
      return o.MouseWheelZoom = o.MouseWheelZoom || n, o.MouseWheelZoom.compose(o.Chart), o;
    }), i(e, "masters/modules/stock.src.js", [e["Core/Globals.js"], e["Series/DataModifyComposition.js"], e["Stock/Navigator/Navigator.js"], e["Core/Axis/OrdinalAxis.js"], e["Stock/RangeSelector/RangeSelector.js"], e["Stock/Scrollbar/Scrollbar.js"], e["Core/Chart/StockChart.js"], e["Series/OHLC/OHLCSeries.js"], e["Series/Flags/FlagsSeries.js"]], function(o, n, l, L, D, j, I, B, R) {
      return o.Navigator = o.Navigator || l, o.OrdinalAxis = o.OrdinalAxis || L, o.RangeSelector = o.RangeSelector || D, o.Scrollbar = o.Scrollbar || j, o.stockChart = o.stockChart || I.stockChart, o.StockChart = o.StockChart || o.stockChart, o.extend(o.StockChart, I), n.compose(o.Series, o.Axis, o.Point), R.compose(o.Renderer), B.compose(o.Series), o.Navigator.compose(o.Chart, o.Axis, o.Series), o.OrdinalAxis.compose(o.Axis, o.Series, o.Chart), o.RangeSelector.compose(o.Axis, o.Chart), o.Scrollbar.compose(o.Axis), o.StockChart.compose(o.Chart, o.Axis, o.Series, o.SVGRenderer), o;
    });
  });
})(Pf);
var ZC = Pf.exports;
const Bu = /* @__PURE__ */ ri(ZC), JC = ve`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}`;
var eS = Object.defineProperty, tS = Object.getOwnPropertyDescriptor, Al = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? tS(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && eS(t, e, o), o;
};
function Zs(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.navigator = !1, this.stockChart = !1, this.hideNavigator = !1;
    }
    static get navigatorStyles() {
      return JC;
    }
    /**
     * SVG path of the left handle at non-small breakpoints
     */
    static leftHandlePath(e, i, o, n) {
      return [
        "M",
        0,
        0,
        "H",
        16,
        "V",
        n,
        "H",
        0,
        "V",
        i,
        "Z",
        "M",
        9,
        n / 2 + 4,
        "l",
        -4,
        -4,
        4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    /**
     * SVG path of the right handle at non-small breakpoints
     */
    static rightHandlePath(e, i, o, n) {
      return [
        "M",
        -16,
        0,
        "H",
        0,
        "V",
        n,
        "H",
        -16,
        "V",
        i,
        "Z",
        "M",
        -9,
        n / 2 + 4,
        "l",
        4,
        -4,
        -4,
        -4,
        "v",
        8,
        "Z"
      ];
    }
    get localComponentOptions() {
      return tt.createChartOptions(super.localComponentOptions, {
        navigator: {
          enabled: (this.navigator || this.stockChart) && !this.hideNavigator,
          handles: t.handleOptionsDefault
        },
        responsive: {
          rules: [
            {
              condition: {
                minWidth: parseInt($h, 10)
              },
              chartOptions: {
                navigator: {
                  height: 44,
                  handles: {
                    height: 44
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(Em, 10)
              },
              chartOptions: {
                navigator: {
                  height: 56,
                  handles: {
                    height: 56
                  }
                }
              }
            },
            {
              condition: {
                minWidth: parseInt(Mm, 10)
              },
              chartOptions: {
                navigator: {
                  height: 64,
                  handles: {
                    height: 64
                  }
                }
              }
            }
          ]
        },
        plotOptions: {
          series: {
            marker: {
              enabled: this.navigator ? !1 : !this.disableMarkers
            }
          }
        }
      });
    }
    initializeHighcharts(e) {
      super.initializeHighcharts(e), Bu(vt), e.SVGRenderer.prototype.symbols.righthandle = t.rightHandlePath, e.SVGRenderer.prototype.symbols.lefthandle = t.leftHandlePath;
    }
    createChart() {
      const e = tt.createChartOptions(
        this.chartOptions,
        this.localComponentOptions,
        this.filteredOptions
      );
      return this.navigator || this.stockChart ? (Bu(vt), vt.stockChart(this.chartContainer, e)) : vt.chart(this.chartContainer, e);
    }
    willUpdate(e) {
      var i;
      super.willUpdate(e), e.has("disableMarkers") && !this.navigator && ((i = this.chart) == null || i.update({
        plotOptions: {
          series: { marker: { enabled: !this.disableMarkers } }
        }
      }));
    }
  };
  return t.handleHeight = 40, t.handleOptionsDefault = {
    height: t.handleHeight,
    lineWidth: 0,
    symbols: ["lefthandle", "righthandle"],
    width: 16
  }, Al([
    ue({ type: Boolean })
  ], t.prototype, "navigator", 2), Al([
    ue({ type: Boolean, attribute: "stock-chart" })
  ], t.prototype, "stockChart", 2), Al([
    ue({ type: Boolean, attribute: "hide-navigator" })
  ], t.prototype, "hideNavigator", 2), t = Al([
    $e("Navigator")
  ], t), t;
}
const kd = {
  beaconTagName: "beacon-area-chart",
  crosshairZIndex: 3
}, oS = ve`.highcharts-navigator-handle,.highcharts-navigator-mask-inside,.highcharts-navigator-series{fill:var(--beacon-system-color-background-primary)}.highcharts-navigator-handle:hover{fill:var(--beacon-system-color-background-primary-hover)}.highcharts-navigator-mask-inside{fill:var(--beacon-system-color-background-secondary-hover);fill-opacity:1;stroke:var(--beacon-system-color-background-primary);stroke-width:var(--beacon-system-width-border-normal)}.highcharts-navigator-mask-outside{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-navigator-series{stroke:var(--beacon-system-color-data-viz-standard-1)}.highcharts-scrollbar-thumb{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb);fill:var(--thumb-color);stroke:var(--thumb-color)}.highcharts-scrollbar-thumb:hover{--thumb-color: var(--beacon-component-scrollbar-color-background-thumb-hover)}.highcharts-scrollbar-track{--track-color: var(--beacon-component-scrollbar-color-background-track);fill:var(--track-color);stroke:var(--track-color)}.highcharts-range-input,.highcharts-navigator-outline{stroke:none}.highcharts-navigator-series .highcharts-area{fill-opacity:.08}.highcharts-point{stroke:var(--beacon-system-color-border-0);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-crosshair{stroke:var(--beacon-component-data-viz-color-border-major);stroke-opacity:1;stroke-width:1px}.highcharts-series .highcharts-graph{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-area{fill-opacity:1}.highcharts-area-series{stroke:var(--beacon-system-color-border-0)}:host(:not([stacking])) .highcharts-area-series .highcharts-negative{stroke:var(--beacon-reference-palette-functional-red-3)}:host(:not([stacking])) .highcharts-area-series .highcharts-negative.highcharts-point{fill:var(--beacon-reference-palette-functional-red-3);stroke:transparent}:host(:not([stacking])) .highcharts-area.highcharts-negative{fill:var(--beacon-reference-palette-functional-red-3)}:host(:not([stacking])) .highcharts-area{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}:host(:not([stacking])) .highcharts-area-series{stroke:var(--beacon-reference-palette-functional-green-3)}:host(:not([stacking])) .highcharts-area-series .highcharts-point{fill:var(--beacon-reference-palette-functional-green-3)}`;
var iS = Object.defineProperty, aS = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && iS(t, e, o), o;
};
const Rb = class Rb extends Ge(tt).with(
  Qs,
  Zs,
  xn
) {
  constructor() {
    super(...arguments), this.beaconTagName = kd.beaconTagName, this.yThreshold = 0, this._type = $t.AREA;
  }
  static get styles() {
    return [super.styles, oS, this.chartAreaStyles, this.navigatorStyles];
  }
  /**
   * @returns Constants
   * local component options for area chart
   */
  get localComponentOptions() {
    return tt.createChartOptions(super.localComponentOptions, {
      chart: {
        styledMode: !0
      },
      plotOptions: {
        series: {
          // @ts-expect-error: Hightcharts documentation says in styled mode negativeColor can be boolean(true/false), but it throws error
          negativeColor: !0,
          threshold: this.stacking ? 0 : this.yThreshold,
          stickyTracking: !0,
          stacking: this.stacking
        }
      },
      xAxis: {
        crosshair: {
          zIndex: kd.crosshairZIndex
          // enables the crosshair to overlay the chart
        }
      }
    });
  }
};
Rb.tagName = kd.beaconTagName;
let vh = Rb;
aS([
  ue({ attribute: "y-threshold" })
], vh.prototype, "yThreshold");
const Ru = {
  beaconTagName: "beacon-article-tile"
}, nS = ve`@charset "UTF-8";[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:inline-block;padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow+.beacon-article-tile__eyebrow:before{content:"·";display:inline;margin-inline-end:.25rem}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);color:var(--beacon-system-color-text-standard);margin:0;padding:0}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title a,[beacon-tag-name=beacon-article-tile] a.beacon-article-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);color:var(--beacon-system-color-text-link);text-decoration:none}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__title a:is(:focus,:hover),[beacon-tag-name=beacon-article-tile] a:is(:focus,:hover).beacon-article-tile__title{text-decoration:underline}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);color:var(--beacon-system-color-text-standard);margin:0;padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__footer{--beacon-color-hyperlink-default: var(--beacon-system-color-text-link);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-article-tile] .beacon-action-zone{display:flex;flex-wrap:wrap;gap:var(--beacon-system-space-micro-jumbo);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-article-tile] .beacon-article-tile__footer .beacon-action-zone{padding:0}[beacon-tag-name=beacon-article-tile] [slot=body]{padding:var(--article-tile-content-body-padding);padding-block:var(--article-tile-content-body-padding-block-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-block-end, var(--article-tile-content-body-padding));padding-inline:var(--article-tile-content-body-padding-inline-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-inline-end, var(--article-tile-content-body-padding))}[beacon-tag-name=beacon-article-tile].beacon-article-tile__vertical-fill{--article-tile-content-block-size: 100%;--tile-footer-margin-block-start: auto}[beacon-tag-name=beacon-article-tile].beacon-article-tile__vertical-fill[position*=horizontal]{--article-tile-media-block-size: 100%;--article-tile-media-aspect-ratio: unset}[class*=b-grid-item] [beacon-tag-name=beacon-article-tile].beacon-article-tile__vertical-fill{block-size:100%}[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title a{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-body-100);display:var(--article-tile-mini-floating-display, block);margin:0;overflow:var(--article-tile-mini-floating-overflow, initial)}[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__eyebrow{padding-block-end:var(--beacon-reference-space-3)}@supports (-webkit-line-clamp: 1){[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=mini] .beacon-article-tile__title a{-webkit-box-orient:var(--article-tile-mini-floating-box-orient, initial);-webkit-line-clamp:var(--article-tile-mini-floating-line-clamp, initial)}[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-display: -webkit-box;--article-tile-mini-floating-line-clamp: 3;--article-tile-mini-floating-box-orient: vertical;--article-tile-mini-floating-overflow: hidden}@media (width >= 640px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 4}}@media (width >= 960px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 2}}@media (width >= 1280px){[beacon-tag-name=beacon-article-tile][scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]) .beacon-article-tile__title{--article-tile-mini-floating-line-clamp: 3}}}@media (width >= 640px){[beacon-tag-name=beacon-article-tile] .beacon-article-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}}@media (width >= 960px){[beacon-tag-name=beacon-article-tile][layout=wide][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left]).beacon-article-tile__wide-aspect-ratio-alternate{--article-tile-media-aspect-ratio: 3/2}[beacon-tag-name=beacon-article-tile][scale=maxi]:is([position=horizontal],[position=horizontal-left],[position=horizontal-right]) .beacon-article-tile__title,[beacon-tag-name=beacon-article-tile][scale=maxi]:is([position=horizontal],[position=horizontal-left],[position=horizontal-right]) .beacon-article-tile__title a{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-100)}}[beacon-tag-name=beacon-article-tile] [slot=media]>img,[beacon-tag-name=beacon-article-tile] [slot=media]:not(picture){align-self:var(--article-tile-media-align-self, initial);aspect-ratio:var(--article-tile-media-aspect-ratio, initial);block-size:var(--article-tile-media-block-size);flex:var(--article-tile-media-flex, initial);max-inline-size:min(var(--article-tile-media-inline-size, 100%));object-fit:var(--article-tile-media-object-fit, cover)}[beacon-tag-name=beacon-article-tile] picture[slot=media]{aspect-ratio:var(--article-tile-media-aspect-ratio, initial)}[beacon-tag-name=beacon-article-tile]:is([position=vertical]) [beacon-tag-name=beacon-video]{--override-video-aspect-ratio: var(--article-tile-media-aspect-ratio);--override-video-block-size: var(--article-tile-media-block-size);--override-video-inline-size: var(--article-tile-media-inline-size);--override-video-object-fit: var(--article-tile-media-object-fit);--override-video-border-start-start-radius: var(--tile-media-start-start-radius);--override-video-border-start-end-radius: var(--tile-start-end-radius);--override-video-border-end-start-radius: var(--tile-end-start-radius);--override-video-border-end-end-radius: var(--tile-end-end-radius)}`, rS = ve`:host{--article-tile-content-body-padding: var(--beacon-system-space-cell-contained);--article-tile-content-padding: var(--beacon-system-space-organism-normal);--tile-content-background-color: var(--beacon-system-color-background-1);--tile-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-start-start-radius: var(--beacon-system-radius-corner-standard);--override-video-block-size: var(--article-tile-media-block-size);--override-video-inline-size: var(--article-tile-media-inline-size);--override-video-vertical-inline-size: var(--article-tile-inline-size);--override-video-object-fit: var(--article-tile-media-object-fit);--override-video-aspect-ratio: var(--article-tile-media-aspect-ratio);block-size:var(--article-tile-block-size);color:var(--beacon-system-color-text-standard);inline-size:min(var(--article-tile-inline-size),100%)}.container{padding:var(--article-tile-container-padding)}.content-zone{block-size:var(--article-tile-content-block-size);flex:var(--article-tile-content-flex, initial);inline-size:min(var(--article-tile-content-inline-size),100%);padding:var(--article-tile-content-padding)}.content-zone ::slotted([slot=body]){padding:var(--article-tile-content-body-padding);padding-block:var(--article-tile-content-body-padding-block-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-block-end, var(--article-tile-content-body-padding));padding-inline:var(--article-tile-content-body-padding-inline-start, var(--article-tile-content-body-padding)) var(--article-tile-content-body-padding-inline-end, var(--article-tile-content-body-padding))}:host(:is([scale=maxi],[layout=wide]):is([position=vertical],[position=vertical-top],[position=vertical-bottom])),:host([layout=standard][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])),:host([layout=standard][scale=normal]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 2;--tile-body-margin-block-end: var(--beacon-system-space-micro-normal)}:host(:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--tile-flex-direction: column}:host([position=horizontal-left]),:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-flex-direction: column-reverse}:host(:is([position=horizontal],[position=horizontal-right])),:host(:is([position=vertical],[position=vertical-bottom])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0;--tile-content-start-end-radius: 0;--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard)}:host([scale=mini]){--article-tile-content-padding: 0;--tile-media-end-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-end-end-radius: 0;--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-border-radius: 0}:host([scale=mini][floating]){--tile-host-background-color: transparent;--tile-content-background-color: transparent}:host([scale=mini]:not([floating])){--article-tile-container-padding: var(--beacon-system-space-cell-contained)}:host([scale=mini]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 2;--article-tile-content-body-padding-inline-end: 0;--article-tile-content-body-padding-inline-start: 0}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--tile-flex-direction: row;--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-aspect-ratio: 1;--article-tile-block-size: 100px;--tile-content-justify-content: center}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 80px;--article-tile-media-align-self: center}:host([scale=mini]:is([position=horizontal],[position=horizontal-right])){--article-tile-content-body-padding-inline-start: var(--beacon-reference-space-5);--article-tile-content-body-padding-inline-end: 0}:host([scale=mini][position=horizontal-left]){--article-tile-content-body-padding-inline-start: 0}:host([scale=mini]:is([position=vertical],[position=vertical-bottom])){--article-tile-content-body-padding-block-start: var(--beacon-system-space-micro-normal);--article-tile-content-body-padding-block-end: 0}:host([scale=mini]:is([position=vertical-top])){--article-tile-content-body-padding-block-start: 0;--article-tile-content-body-padding-block-end: var(--beacon-system-space-micro-normal)}@media (width >= 640px){:host(:is([position=horizontal],[position=horizontal-right])){--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-content-end-start-radius: 0}:host([position=horizontal-left]){--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-content-end-end-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-end-start-radius: 0}:host(:is([position=vertical],[position=vertical-bottom])){--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: 0;--tile-media-end-start-radius: 0}:host([position=vertical-top]){--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-flex-direction: column}:host([position=horizontal]),:host([position=horizontal-right]),:host([position=horizontal-left]){--tile-flex-direction: row;--tile-footer-margin-block-start: auto;--tile-body-margin-block-end: initial}:host([layout=wide]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])),:host([layout=standard]:is([scale=normal],[scale=maxi]):is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--article-tile-media-aspect-ratio: 1}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-media-aspect-ratio: 2;--article-tile-block-size: 140px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: initial;--article-tile-media-align-self: initial}:host([scale=mini]){--tile-media-end-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-start-start-radius: 0;--tile-media-start-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-end-end-radius: 0;--tile-content-start-start-radius: 0;--tile-content-start-end-radius: 0;--tile-border-radius: 0}}@media (width >= 960px){:host(:is([scale=maxi],[layout=wide]):is([position=vertical],[position=vertical-top],[position=vertical-bottom])),:host([layout=standard][scale=normal]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([layout=standard][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 4)}:host([layout=standard][scale=maxi]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--article-tile-media-flex: 1;--article-tile-content-flex: 1;--article-tile-media-block-size: 100%}:host([layout=wide][scale=normal]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--article-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 8);--article-tile-media-aspect-ratio: 1}:host([scale=mini]:is([position=vertical],[position=vertical-top],[position=vertical-bottom])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--article-tile-media-aspect-ratio: 1;--article-tile-block-size: 88px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 80px;--article-tile-media-align-self: center}}@media (width >= 1280px){:host([scale=mini]:is([position=horizontal],[position=horizontal-right],[position=horizontal-left])){--article-tile-block-size: 116px}:host([scale=mini][position*=horizontal][floating]){--article-tile-media-block-size: 104px}}`, Nb = class Nb extends li {
  constructor() {
    super(...arguments), this.beaconTagName = Ru.beaconTagName;
  }
  static get styles() {
    return [super.styles, rS];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, nS];
  }
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  render() {
    return pe`${this.renderTile(this.position)}`;
  }
};
Nb.tagName = Ru.beaconTagName;
let Nu = Nb;
class Vn extends Le {
  // Brightcove components don't have named slots, so we can skip the need for waiting on slotchanges
  // which come with the queryAssigned decorators
  get video() {
    return this.querySelector("video-js");
  }
  get brightcovePlayer() {
    return Za(this, "_brightcovePlayer", () => {
      var t, e;
      if (this.video) {
        const i = this.video.id;
        return (e = (t = window.videojs) == null ? void 0 : t.getPlayer(i)) != null ? e : void 0;
      }
    });
  }
  static buildPlayerScriptURL({
    brightcoveBaseURL: t = "https://players.brightcove.net/",
    brightcoveScriptURL: e = "/index.min.js",
    accountNum: i = "0",
    dataPlayerID: o = "default",
    dataEmbed: n = "default"
  }) {
    return `${t}${i}/${o}_${n}${e}`;
  }
  static formatDuration(t) {
    if (!t) return "";
    const e = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), o = Math.floor(t % 60);
    let n = "";
    e > 0 && (n += `${e}`.padStart(2, "0") + ":");
    let l = `${i}`.padStart(2, "0");
    return e > 0 && i === 0 && (l = "00"), n += `${l}:${o < 10 ? "0" : ""}${o}`, n;
  }
  applyPlayerScript(t = this.video) {
    return new Promise((e) => {
      if (t) {
        const i = t.dataset.account, o = t.dataset.player, n = t.dataset.embed;
        if (!this.querySelector(
          "script#beacon-brightcove-player-script"
        )) {
          const L = Vn.buildPlayerScriptURL({
            accountNum: i,
            dataPlayerID: o,
            dataEmbed: n
          }), D = document.createElement("script");
          D.id = "beacon-brightcove-player-script", D.src = L, D.onload = () => e(), this.appendChild(D);
        }
      }
    });
  }
  applyVideoPlayerClass() {
    var t;
    (t = this.video) == null || t.classList.add(this.videoCSSClass);
  }
  brightcoveDefaultSlotchange() {
    this.applyPlayerScript(), this.applyVideoPlayerClass();
  }
  // opting for connectedCallback over firstUpdated so functionality happens as soon as possible
  // if we wait for firstUpdated, the component has to render before state changes may result in a re-render
  async connectedCallback() {
    super.connectedCallback(), await this.brightcoveInit();
  }
  renderBrightcoveDefaultSlot() {
    return pe`<slot @slotchange=${this.brightcoveDefaultSlotchange}></slot>`;
  }
}
const Fu = {
  beaconTagName: "beacon-audio"
}, sS = ve`[beacon-tag-name=beacon-audio] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200)}[beacon-tag-name=beacon-audio] .video-js,[beacon-tag-name=beacon-audio] .vjs-control-bar{background-color:transparent}[beacon-tag-name=beacon-audio] .video-js .vjs-progress-holder{background-color:var(--beacon-system-color-background-0)}[beacon-tag-name=beacon-audio] .video-js .vjs-play-progress{background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-audio] .vjs-icon-placeholder,[beacon-tag-name=beacon-audio] .vjs-volume-panel,[beacon-tag-name=beacon-audio] .vjs-volume-level{color:var(--beacon-system-color-icon-secondary)}[beacon-tag-name=beacon-audio] .vjs-volume-level{background-color:var(--beacon-system-color-icon-secondary)}[beacon-tag-name=beacon-audio] .video-js :is(.vjs-progress-control,.vjs-current-time,.vjs-time-control):not(.vjs-remaining-time){color:var(--beacon-system-color-text-standard);display:flex}[beacon-tag-name=beacon-audio] .video-js .vjs-time-control{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}[beacon-tag-name=beacon-audio] .vjs-control-bar{block-size:var(--beacon-reference-space-12)}[beacon-tag-name=beacon-audio] .vjs-play-control,[beacon-tag-name=beacon-audio] .vjs-mute-control,[beacon-tag-name=beacon-audio] .vjs-volume-panel{block-size:var(--beacon-reference-space-12);inline-size:var(--beacon-reference-space-12)}[beacon-tag-name=beacon-audio] .video-js .vjs-current-time{margin-inline-start:0;padding-inline-end:0;padding-inline-start:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-audio] .video-js .vjs-duration{padding-inline-start:0}[beacon-tag-name=beacon-audio] .vjs-time-control,[beacon-tag-name=beacon-audio] .vjs-volume-panel{align-items:center;display:flex}[beacon-tag-name=beacon-audio] .vjs-icon-placeholder:before{display:grid;font-size:var(--beacon-reference-font-scale-6);place-items:center}[beacon-tag-name=beacon-audio] .video-js .vjs-title-bar,[beacon-tag-name=beacon-audio] .video-js .vjs-playback-rate,[beacon-tag-name=beacon-audio] .video-js .vjs-remaining-time,[beacon-tag-name=beacon-audio] .video-js .vjs-big-play-button{display:none}`, lS = ve`.base{background-color:var(--beacon-system-color-background-1)}.title,.description{padding-block:var(--beacon-reference-space-2)}.description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.title{color:var(--beacon-system-color-text-title)}.transcript{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2);padding-inline-end:var(--beacon-system-space-cell-contained);padding-inline-start:calc(var(--beacon-system-space-cell-contained) + var(--beacon-reference-space-5))}.media{flex-shrink:0;inline-size:var(--image-size, 96px)}@media (width >= 1280px){.media{--image-size: 120px}}.metadata{display:flex;flex-direction:var(--metadata-flex-direction, column);gap:var(--beacon-system-space-organism-normal);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-normal)}@media (width >= 640px){.metadata{--metadata-flex-direction: row}}.audio-player{padding-inline:var(--beacon-system-space-organism-normal)}`, Fb = class Fb extends Vn {
  constructor() {
    super(...arguments), this.beaconTagName = Fu.beaconTagName, this.resetSpacing = !0, this.videoCSSClass = "beacon-audio-player";
  }
  static get styles() {
    return [super.styles, lS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, sS];
  }
  async brightcoveInit() {
    var t;
    await this.applyPlayerScript(), (t = this.brightcovePlayer) == null || t.ready(() => {
      var e;
      (e = this.brightcovePlayer) == null || e.audioOnlyMode(!0);
    });
  }
  render() {
    return pe`
      <div class="base">
        <div class="metadata">
          <div class="media">
            <slot name="media" ${_e({ useParent: !0 })}></slot>
          </div>
          <div class="text-content">
            <div class="title">
              <slot name="title"></slot>
            </div>
            <div class="description">
              <slot
                name="description"
                ${_e({ useParent: !0 })}></slot>
            </div>
          </div>
        </div>
        <div class="audio-player">${this.renderBrightcoveDefaultSlot()}</div>
        <div class="transcript">
          <slot name="transcript" ${_e({ useParent: !0 })}></slot>
        </div>
      </div>
    `;
  }
};
Fb.tagName = Fu.beaconTagName;
let ju = Fb;
const _u = {
  beaconTagName: "beacon-bar-chart"
}, Cd = {
  small: 531,
  medium: 795,
  large: 1051
}, Ka = {
  small: {
    end: 3,
    max: 468
  },
  medium: {
    end: 6,
    max: 768,
    start: 4
  },
  large: {
    max: 980
  },
  xLarge: {
    max: 1024
  }
}, cS = 3 * 4 + 48, dS = 2 * 4 + 36, hS = 38, bS = 3 * 4 + 32, pS = 2 * 4 + 24, uS = 28, gS = 3 * 4 + 16, mS = 2 * 4 + 12, fS = 20, vS = 3 * 8 + 64, AS = 2 * 8 + 48, yS = 58, xS = 3 * 6 + 40, wS = 2 * 6 + 30, kS = 38, CS = 3 * 6 + 24, SS = 2 * 6 + 18, ES = 30, MS = 3 * 10 + 80, TS = 2 * 10 + 60, LS = 68, OS = 3 * 8 + 48, PS = 2 * 8 + 36, DS = 48, zS = 3 * 8 + 32, IS = 2 * 8 + 24, BS = 40, RS = 3 * 12 + 80, NS = 2 * 12 + 60, FS = 68, jS = 3 * 8 + 48, _S = 2 * 8 + 36, US = 48, $S = 3 * 8 + 32, HS = 2 * 8 + 24, KS = 40, Sd = 20, Ed = 16, Md = 12, Td = 28, Ld = 24, Od = 24, Pd = 32, Dd = 28, zd = 28, Id = 36, Bd = 32, Rd = 32, Se = {
  small: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: cS,
            threeBars: dS,
            twoBars: hS
          },
          mediumRange: {
            fourBars: bS,
            threeBars: pS,
            twoBars: uS
          },
          largeRange: {
            fourBars: gS,
            threeBars: mS,
            twoBars: fS
          }
        },
        minusOne: {
          smallRange: {
            fourBars: Sd,
            threeBars: Sd,
            twoBars: Sd
          },
          mediumRange: {
            fourBars: Ed,
            threeBars: Ed,
            twoBars: Ed
          },
          largeRange: {
            fourBars: Md,
            threeBars: Md,
            twoBars: Md
          }
        }
      },
      max: Ka.small.max
    },
    width: Cd.small
  },
  medium: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: vS,
            threeBars: AS,
            twoBars: yS
          },
          mediumRange: {
            fourBars: xS,
            threeBars: wS,
            twoBars: kS
          },
          largeRange: {
            fourBars: CS,
            threeBars: SS,
            twoBars: ES
          }
        },
        minusOne: {
          smallRange: {
            fourBars: Td,
            threeBars: Td,
            twoBars: Td
          },
          mediumRange: {
            fourBars: Ld,
            threeBars: Ld,
            twoBars: Ld
          },
          largeRange: {
            fourBars: Od,
            threeBars: Od,
            twoBars: Od
          }
        }
      },
      max: Ka.medium.max
    },
    width: Cd.medium
  },
  large: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: MS,
            threeBars: TS,
            twoBars: LS
          },
          mediumRange: {
            fourBars: OS,
            threeBars: PS,
            twoBars: DS
          },
          largeRange: {
            fourBars: zS,
            threeBars: IS,
            twoBars: BS
          }
        },
        minusOne: {
          smallRange: {
            fourBars: Pd,
            threeBars: Pd,
            twoBars: Pd
          },
          mediumRange: {
            fourBars: Dd,
            threeBars: Dd,
            twoBars: Dd
          },
          largeRange: {
            fourBars: zd,
            threeBars: zd,
            twoBars: zd
          }
        }
      },
      max: Ka.large.max
    },
    width: Cd.large
  },
  xLarge: {
    height: {
      groupMultiplier: {
        normal: {
          smallRange: {
            fourBars: RS,
            threeBars: NS,
            twoBars: FS
          },
          mediumRange: {
            fourBars: jS,
            threeBars: _S,
            twoBars: US
          },
          largeRange: {
            fourBars: $S,
            threeBars: HS,
            twoBars: KS
          }
        },
        minusOne: {
          smallRange: {
            fourBars: Id,
            threeBars: Id,
            twoBars: Id
          },
          mediumRange: {
            fourBars: Bd,
            threeBars: Bd,
            twoBars: Bd
          },
          largeRange: {
            fourBars: Rd,
            threeBars: Rd,
            twoBars: Rd
          }
        }
      },
      max: Ka.xLarge.max
    }
  }
}, GS = ve`:is(.highcharts-column-series,.highcharts-bar-series) .highcharts-point{stroke:inherit}.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}:host([stacking]) :is(.highcharts-column-series,.highcharts-bar-series) .highcharts-point{stroke:var(--beacon-system-color-background-1)}.highcharts-point:hover{fill-opacity:1}`;
var WS = Object.defineProperty, VS = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && WS(t, e, o), o;
};
const jb = class jb extends Ge(tt).with(
  Qs,
  Zs,
  xn
) {
  constructor() {
    super(...arguments), this.beaconTagName = _u.beaconTagName, this.variant = as.HORIZONTAL;
  }
  static get styles() {
    return [super.styles, GS, this.chartAreaStyles, this.navigatorStyles];
  }
  /** The type of chart being rendered. */
  get type() {
    return this.variant === as.HORIZONTAL ? $t.BAR : $t.COLUMN;
  }
  /** Options specific to the Bar chart. */
  get localComponentOptions() {
    return tt.createChartOptions(super.localComponentOptions, {
      xAxis: {
        labels: {
          /**
           * @todo No clue why this works. It's the wrong type. Switching it to undefined or zero
           * breaks bar chart styles for the labels in either vertical or horizontal variant.
           *  */
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          y: null
        },
        tickLength: 0
      },
      plotOptions: {
        bar: {
          borderRadius: 0
        },
        column: {
          borderRadius: 0
        }
      }
    });
  }
  willUpdate(t) {
    var e;
    (e = super.willUpdate) == null || e.call(this, t), t.has("stacking") && this.updateChart({
      chart: { height: this.height },
      plotOptions: { series: { stacking: this.stacking } }
    }), t.has("variant") && this.updateChart({ chart: { type: this.type, height: this.height } }), t.has("tableId") && this.updateChart({ series: this.seriesWithChartType }), t.has("chart") && this.setLoadedChartOptions();
  }
  /** Size of the plotbox (not including axes). */
  get componentWidth() {
    var t;
    return (t = this.chartSize) == null ? void 0 : t.plotWidth;
  }
  /**
   * Updates chart options that depend on chartSize being initialized in chartBase
   */
  setLoadedChartOptions() {
    this.updateChart({
      chart: { type: this.type, height: this.height },
      plotOptions: { series: { stacking: this.stacking } }
    });
  }
  /**
   * Resolves the chart's height value based on the number of series. Charts are forced into a stacked variant at 5+ series, so conditions only check for variations in bar amount before stacking is enabled.
   *
   * @param heightValues Array of possible height values based on the numbers of bars, in order of 4, 3, 2
   * @returns The height value for the chart
   */
  determineHeightReturnValues(t) {
    if (this.seriesLength === 4) return t[0];
    if (this.seriesLength === 3) return t[1];
    if (this.seriesLength === 2) return t[2];
  }
  /**
   * Passes the available height values to a separate function based on total chart categories
   *
   * @see determineHeightReturnValues
   *
   * @param smallValues Possible values in the small range
   * @param mediumValues Possible values in the medium range
   * @param largeValues Possible values in the large range
   */
  determineHeightCutoffRoute(t, e, i) {
    if (this.totalChartCategories)
      return this.totalChartCategories <= Ka.small.end ? this.determineHeightReturnValues(t) : this.totalChartCategories >= Ka.medium.start && this.totalChartCategories <= Ka.medium.end ? this.determineHeightReturnValues(e) : this.determineHeightReturnValues(i);
  }
  /** Collection of heights based on small, medium, large, or xLarge charts. */
  get chartHeightValues() {
    if (this.variant !== as.VERTICAL)
      return {
        small: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.smallRange.fourBars,
              Se.small.height.groupMultiplier.minusOne.smallRange.fourBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.smallRange.threeBars,
              Se.small.height.groupMultiplier.minusOne.smallRange.threeBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.smallRange.twoBars,
              Se.small.height.groupMultiplier.minusOne.smallRange.twoBars,
              Se.small.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.mediumRange.fourBars,
              Se.small.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.mediumRange.threeBars,
              Se.small.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.mediumRange.twoBars,
              Se.small.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Se.small.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.largeRange.fourBars,
              Se.small.height.groupMultiplier.minusOne.largeRange.fourBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.largeRange.threeBars,
              Se.small.height.groupMultiplier.minusOne.largeRange.threeBars,
              Se.small.height.max
            ),
            this.calculateChartHeight(
              Se.small.height.groupMultiplier.normal.largeRange.twoBars,
              Se.small.height.groupMultiplier.minusOne.largeRange.twoBars,
              Se.small.height.max
            )
          ]
        ),
        medium: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.smallRange.fourBars,
              Se.medium.height.groupMultiplier.minusOne.smallRange.fourBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.smallRange.threeBars,
              Se.medium.height.groupMultiplier.minusOne.smallRange.threeBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.smallRange.twoBars,
              Se.medium.height.groupMultiplier.minusOne.smallRange.twoBars,
              Se.medium.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.mediumRange.fourBars,
              Se.medium.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.mediumRange.threeBars,
              Se.medium.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.mediumRange.twoBars,
              Se.medium.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Se.medium.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.largeRange.fourBars,
              Se.medium.height.groupMultiplier.minusOne.largeRange.fourBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.largeRange.threeBars,
              Se.medium.height.groupMultiplier.minusOne.largeRange.threeBars,
              Se.medium.height.max
            ),
            this.calculateChartHeight(
              Se.medium.height.groupMultiplier.normal.largeRange.twoBars,
              Se.medium.height.groupMultiplier.minusOne.largeRange.twoBars,
              Se.medium.height.max
            )
          ]
        ),
        large: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.smallRange.fourBars,
              Se.large.height.groupMultiplier.minusOne.smallRange.fourBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.smallRange.threeBars,
              Se.large.height.groupMultiplier.minusOne.smallRange.threeBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.smallRange.twoBars,
              Se.large.height.groupMultiplier.minusOne.smallRange.twoBars,
              Se.large.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.mediumRange.fourBars,
              Se.large.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.mediumRange.threeBars,
              Se.large.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.mediumRange.twoBars,
              Se.large.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Se.large.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.largeRange.fourBars,
              Se.large.height.groupMultiplier.minusOne.largeRange.fourBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.largeRange.threeBars,
              Se.large.height.groupMultiplier.minusOne.largeRange.threeBars,
              Se.large.height.max
            ),
            this.calculateChartHeight(
              Se.large.height.groupMultiplier.normal.largeRange.twoBars,
              Se.large.height.groupMultiplier.minusOne.largeRange.twoBars,
              Se.large.height.max
            )
          ]
        ),
        xLarge: this.determineHeightCutoffRoute(
          [
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.smallRange.fourBars,
              Se.xLarge.height.groupMultiplier.minusOne.smallRange.fourBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.smallRange.threeBars,
              Se.xLarge.height.groupMultiplier.minusOne.smallRange.threeBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.smallRange.twoBars,
              Se.xLarge.height.groupMultiplier.minusOne.smallRange.twoBars,
              Se.xLarge.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.mediumRange.fourBars,
              Se.xLarge.height.groupMultiplier.minusOne.mediumRange.fourBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.mediumRange.threeBars,
              Se.xLarge.height.groupMultiplier.minusOne.mediumRange.threeBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.mediumRange.twoBars,
              Se.xLarge.height.groupMultiplier.minusOne.mediumRange.twoBars,
              Se.xLarge.height.max
            )
          ],
          [
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.largeRange.fourBars,
              Se.xLarge.height.groupMultiplier.minusOne.largeRange.fourBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.largeRange.threeBars,
              Se.xLarge.height.groupMultiplier.minusOne.largeRange.threeBars,
              Se.xLarge.height.max
            ),
            this.calculateChartHeight(
              Se.xLarge.height.groupMultiplier.normal.largeRange.twoBars,
              Se.xLarge.height.groupMultiplier.minusOne.largeRange.twoBars,
              Se.xLarge.height.max
            )
          ]
        )
      };
  }
  /** The height of the chart. */
  get height() {
    var e, i, o, n;
    let t;
    return (this.stacking || !this.totalChartCategories || !this.seriesLength || !this.componentWidth) && (t = void 0), this.componentWidth <= Se.small.width && (t = (e = this.chartHeightValues) == null ? void 0 : e.small), this.componentWidth > Se.small.width && this.componentWidth <= Se.medium.width && (t = (i = this.chartHeightValues) == null ? void 0 : i.medium), this.componentWidth > Se.medium.width && this.componentWidth <= Se.large.width && (t = (o = this.chartHeightValues) == null ? void 0 : o.large), this.componentWidth > Se.large.width && (t = (n = this.chartHeightValues) == null ? void 0 : n.xLarge), t || void 0;
  }
  /**
   * Calculates the height a chart should be at given its categories, number of series, and the width of the chart.
   *
   * @param normalMultiplier Number to mulitply the total group count by
   * @param minusOneMultiplier Number to multiply (total group count - 1) by
   * @returns A height in pixels
   */
  calculateChartHeight(t, e, i) {
    var j, I;
    if (!((j = this.chartSize) != null && j.chartHeight) || !((I = this.chartSize) != null && I.plotHeight) || !this.totalChartCategories)
      return;
    const { chartHeight: o, plotHeight: n } = this.chartSize, l = o - n, L = this.totalChartCategories * t + (this.totalChartCategories - 1) * e, D = L > i ? i : L;
    return l + D;
  }
};
jb.tagName = _u.beaconTagName;
let Ah = jb;
VS([
  ue()
], Ah.prototype, "variant");
var fi = /* @__PURE__ */ ((a) => (a.VERTICAL = "vertical", a.HORIZONTAL = "horizontal", a.HORIZONTAL_WIDE = "horizontal-wide", a))(fi || {}), Wo = /* @__PURE__ */ ((a) => (a.VERTICAL = "vertical", a.SPLIT = "split", a.HORIZONTAL = "horizontal", a))(Wo || {}), hb = /* @__PURE__ */ ((a) => (a.LEFT = "left", a.RIGHT = "right", a.TOP = "top", a.BOTTOM = "bottom", a))(hb || {}), Vr = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.HERO = "hero", a))(Vr || {});
const qS = ve`:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-3);--data-list-accolade-image-size-max-block-size: var(--beacon-reference-space-7);--data-list-accolade-image-size-max-inline-size: var(--beacon-reference-space-15);--data-list-size-block-vertical: var(--beacon-reference-space-10)}@media (width >= 640px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-4);--data-list-size-block-vertical: var(--beacon-reference-space-11)}}@media (width >= 960px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-5);--data-list-accolade-image-size-max-block-size: 50px;--data-list-accolade-image-size-max-inline-size: 115px;--data-list-size-block-horizontal: var(--beacon-reference-space-12);--data-list-size-block-split: var(--beacon-reference-space-12);--data-list-size-block-vertical: var(--beacon-reference-space-12)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-data-list],:root [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"][beacon-tag-name=beacon-data-list],[beacon-version="4.4.0"] [beacon-tag-name=beacon-data-list]{--data-list-padding-block: var(--beacon-reference-space-6);--data-list-size-block-horizontal: var(--beacon-reference-space-13);--data-list-size-block-split: 65px;--data-list-size-block-vertical: 65px}}`, Uu = {
  beaconTagName: "beacon-data-list"
}, YS = ve`[beacon-tag-name=beacon-data-list]{--padding-block: var(--data-list-padding-block);--padding-inline: 0;--border-inline: 0;--border-block: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);--default-spacing: var(--beacon-reference-space-3);--padding-grid-block: 0;--block-size: var(--data-list-size-block-vertical)}[beacon-tag-name=beacon-data-list] [slot=list-item]{align-items:center;align-self:stretch;border-block-end:var(--border-block);border-inline-end:var(--border-inline);box-sizing:border-box;display:flex;justify-content:space-between;min-block-size:var(--block-size);padding-block:var(--padding-block);padding-inline:var(--padding-inline)}[beacon-tag-name=beacon-data-list] [slot=list-item]:last-child{border:0;padding-inline-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list] dd{align-items:center;display:flex;font-weight:var(--beacon-system-font-weight-bold);margin-inline-start:var(--default-spacing);text-align:end}[beacon-tag-name=beacon-data-list] dd img,[beacon-tag-name=beacon-data-list] dd svg{max-block-size:var(--override-data-list-list-item-accolade-image-max-block-size, var(--data-list-accolade-image-size-max-block-size));max-inline-size:var(--override-data-list-list-item-accolade-image-max-inline-size, var(--data-list-accolade-image-size-max-inline-size))}@media (width >= 960px){[beacon-tag-name=beacon-data-list][orientation=horizontal]{--padding-inline: var(--beacon-reference-space-7);--border-inline: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);--border-block: 0;--padding-block: 0;--block-size: var(--data-list-size-block-horizontal)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(2){grid-row:2/3}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(odd){padding-block-start:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:nth-of-type(2n){padding-block-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:first-of-type{padding-inline-start:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=horizontal] [slot=list-item]:last-of-type{border:0;padding-inline-end:var(--padding-grid-block)}[beacon-tag-name=beacon-data-list][orientation=split]{--border-block: 0;--padding-inline: var(--default-spacing);--padding-grid-block: var(--default-spacing);--block-size: var(--data-list-size-block-split)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(odd){margin-block:var(--default-spacing) 0;margin-inline:var(--default-spacing)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(2n){margin-block:0 var(--default-spacing);margin-inline:var(--default-spacing)}[beacon-tag-name=beacon-data-list][orientation=split] [slot=list-item]:nth-of-type(odd):not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1)}}`, XS = ve`dl{--cell-contained: var(--beacon-system-space-cell-contained);--flex: column;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:flex;flex-direction:var(--flex);margin:0;padding:var(--cell-contained);word-break:normal}@media (width >= 960px){.horizontal{--flex: row}.split{--cell-contained: 0;--padding-grid-block: var(--default-spacing);--flex: row;display:grid;grid-auto-flow:column;grid-column-gap:var(--beacon-reference-space-7);grid-template-rows:1fr 1fr}}`;
var QS = Object.defineProperty, Df = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && QS(t, e, o), o;
};
const _b = class _b extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Uu.beaconTagName, this.orientation = Wo.HORIZONTAL;
  }
  static get styles() {
    return [super.styles, XS];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, YS, qS];
  }
  /** Callback Method for beacon-event-render Event */
  onBeaconRender() {
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render - emits when a component is rendered
   */
  emitRender() {
    Fe(this, Ee.RENDER, void 0, this.onBeaconRender);
  }
  render() {
    return pe`<dl class=${this.orientation}>
      <slot name="list-item" @slotchange=${this.emitRender}></slot>
    </dl>`;
  }
};
_b.tagName = Uu.beaconTagName;
let tn = _b;
Df([
  Ct({ slot: "list-item" })
], tn.prototype, "listItems");
Df([
  ue({ reflect: !0 })
], tn.prototype, "orientation");
const ZS = ve`:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card]{--id-card-display-name-space-padding-block-start: 0;--id-card-avatar-size-mini: var(--beacon-reference-space-9);--id-card-description-padding-after: var(--beacon-reference-space-3);--id-card-name-space-padding-jumbo: calc(.75 * var(--beacon-reference-space-3));--id-card-name-space-padding-normal: var(--beacon-reference-space-1);--id-card-name-space-padding-mini: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card]{--id-card-avatar-size-mini: var(--beacon-reference-space-11);--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-2));--id-card-name-space-padding-mini: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card]{--id-card-description-padding-after: var(--beacon-reference-space-4);--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-2))}}@media (width >= 1280px){:root[beacon-tag-name=beacon-id-card],:root [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-id-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-id-card]{--id-card-name-space-padding-normal: 0;--id-card-name-space-padding-jumbo: calc(var(--beacon-reference-space-1));--id-card-name-space-padding-mini: var(--beacon-reference-space-1)}}`, Nd = {
  beaconTagName: "beacon-id-card",
  DEFAULT_NAME: "T. Rowe Price"
}, JS = ve`[beacon-tag-name=beacon-id-card] :is([slot=name]){color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-standard));font:var(--override-id-card-display-name-font, var(--display-name-font));margin:var(--id-card-space-margin, 0);padding-block-start:var(--id-card-display-name-space-padding-block-start, var(--display-name-space-padding-block-start))}[beacon-tag-name=beacon-id-card] :is([slot=name]):is(a),[beacon-tag-name=beacon-id-card] :is([slot=name]) a{color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-link))}[beacon-tag-name=beacon-id-card] :is([slot=name]):is(a):not(:is(:hover,:focus)),[beacon-tag-name=beacon-id-card] :is([slot=name]) a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-id-card] [slot=description]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-end:var(--override-description-margin-end, --id-card-description-padding-after);padding-block:var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-id-card] img[slot=avatar],[beacon-tag-name=beacon-id-card] [slot=avatar] img{aspect-ratio:var(--id-card-avatar-ratio, 1/1);background-color:var(--beacon-reference-palette-grayscale-white);block-size:var(--avatar-size);border-block-end:var(--id-card-avatar-border-block-end, 0);border-radius:var(--avatar-border-radius, 0);display:var(--id-card-avatar-display, grid);inline-size:var(--avatar-inline-size, var(--avatar-size));margin-inline:var(--avatar-inline-margin);object-fit:contain;object-position:right;place-items:center}[beacon-tag-name=beacon-id-card] .job-title,[beacon-tag-name=beacon-id-card] [slot=job-title]{font:var(--job-title-font)}[beacon-tag-name=beacon-id-card][free-floating] [slot=description]{padding:var(--beacon-system-space-cell-free-floating) 0}`, eE = ve`:host{--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-normal);--avatar-size: var(--beacon-reference-space-11);--avatar-space-margin: var(--beacon-reference-space-3);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);--id-card-component-padding: 0;padding:var(--id-card-component-padding)}:host p{margin:0}.id-card{background-color:var(--id-card-background-color, initial);color:var(--beacon-system-color-text-standard);column-gap:var(--avatar-space-margin);display:var(--override-id-card-display, grid);flex-direction:var(--override-id-card-flex-direction, initial);grid-template-columns:auto 1fr;margin:var(--id-card-space-margin, 0);margin-block-end:var(--override-id-card-margin-block-end, 0);padding:var(--bio-card-override-id-card-space-padding, var(--beacon-system-space-cell-contained));position:relative}.avatar{align-self:start;border:var(--id-card-avatar-border, var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2));display:var(--id-card-avatar-display, flex)}:host([free-floating]) .id-card{padding:var(--beacon-system-space-cell-free-floating) 0}.display-name{font:var(--override-id-card-display-name-font, var(--display-name-font));padding-block-start:var(--id-card-display-name-space-padding-block-start, var(--display-name-space-padding-block-start))}.display-name a{color:var(--bio-card-override-id-card-name-color-text, var(--beacon-system-color-text-link))}.text-content{align-self:var(--override-id-card-text-content-align-self, center);display:flex;flex-direction:column;inset-block-start:var(--id-card-top-position, unset);padding:var(--id-card-text-content-space-padding, 0);padding-block-start:var(--id-card-text-content-space-padding-block-start, 0);position:var(--id-card-content-position, static)}.multi-line{margin-block-start:calc(-1 * var(--beacon-reference-space-1))}.multi-line .display-name{padding-block-start:0}.job-title{font:var(--job-title-font)}::part(internal--icon){background-color:var(--beacon-component-avatar-icon-color-background);block-size:var(--avatar-size);color:var(--beacon-component-avatar-icon-color-avatar);inline-size:var(--avatar-size)}:host([scale=mini]){--display-name-font: var(--bio-card-override-id-card-name-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300));--display-name-space-padding-block-start: var(--id-card-name-space-padding-mini);--avatar-size: var(--bio-card-override-id-card-avatar-size-mini, var(--id-card-avatar-size-mini))}:host([scale=jumbo]){--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-jumbo);--avatar-size: var(--beacon-reference-space-13);--avatar-space-margin: var(--beacon-reference-space-5);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}:host([scale=maxi]){--avatar-size: var(--beacon-reference-space-15);--display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200);--display-name-space-padding-block-start: var(--id-card-name-space-padding-jumbo);--avatar-space-margin: var(--beacon-reference-space-5);--job-title-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200)}:host([scale=maxi]:not([free-floating])) .base,:host(:not([free-floating])) .base:has(.commentary-tile){background-color:var(--commentary-tile-background, var(--beacon-system-color-background-1));border:var(--id-card-border, var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2))}:host(:not([free-floating])) .base:has(.commentary-tile){padding:var(--commentary-tile-padding, var(--beacon-system-space-organism-normal))}:host([scale=maxi]:not([free-floating])){--id-card-background-color: var(--beacon-system-color-background-1)}@media (width >= 640px){:host([scale=maxi]){--avatar-size: var(--beacon-reference-space-20)}}@media (width >= 1280px){:host([scale=maxi]){--beacon-reference-space-25: 10rem;--avatar-size: var(--beacon-reference-space-25)}}`;
var tE = Object.defineProperty, wn = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && tE(t, e, o), o;
}, yr, zf, If;
const rc = class rc extends Le {
  constructor() {
    super(...arguments);
    Ie(this, yr);
    this.beaconTagName = Nd.beaconTagName, this.scale = Fo.NORMAL, this.freeFloating = !1, this.noAvatar = !1, this._hasAuthor = !1, this._hasDescription = !1;
  }
  static get styles() {
    return [super.styles, eE];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, JS, ZS];
  }
  get slottedAvatar() {
    return Za(
      this,
      "_slottedAvatar",
      () => {
        var e;
        return (e = this.querySelector('[slot="avatar"]')) != null ? e : void 0;
      }
    );
  }
  get slottedAvatarUrl() {
    var i, o;
    let e;
    return this.slottedAvatar instanceof HTMLPictureElement && (e = this.slottedAvatar.querySelector("img")), this.slottedAvatar instanceof HTMLImageElement && (e = this.slottedAvatar), !e && this.slottedAvatar && (e = (i = this.slottedAvatar) == null ? void 0 : i.querySelector("img")), (o = e == null ? void 0 : e.src) != null ? o : "";
  }
  get slottedFullName() {
    var e;
    return this.slottedName && ((e = this.slottedName[0]) == null ? void 0 : e.innerText);
  }
  render() {
    const e = {
      "commentary-tile": this._hasDescription,
      "id-card": !0
    };
    return pe`
      <div class="base">
        <div class="${Pe(e)}">
          ${this.noAvatar ? je : pe`
                <div class="avatar">
                  <slot name="avatar">
                    ${ze`<${this.getScopedTag("beacon-icon")} name="${this._hasAuthor ? "user" : "trusty"}"></${this.getScopedTag("beacon-icon")}>`}
                  </slot>
                </div>
              `}
          <div class="text-content">
            <p id="display-name" class="display-name">
              <slot name="name" @slotchange=${Ue(this, yr, zf)}
                >${Nd.DEFAULT_NAME}</slot
              >
            </p>
            <slot name="job-title"></slot>
          </div>
        </div>
        <slot
          name="description"
          @slotchange=${Ue(this, yr, If)}></slot>
      </div>
    `;
  }
};
yr = new WeakSet(), zf = function() {
  this._hasAuthor = this.slottedName.length > 0;
}, If = function() {
  this._hasDescription = this.slottedDescription.length > 0;
}, rc.tagName = Nd.beaconTagName, rc.nestedComponents = [ro];
let _o = rc;
wn([
  ue({ reflect: !0 })
], _o.prototype, "scale");
wn([
  ue({ attribute: "free-floating", type: Boolean })
], _o.prototype, "freeFloating");
wn([
  ue({ attribute: "no-avatar", type: Boolean })
], _o.prototype, "noAvatar");
wn([
  Ce()
], _o.prototype, "_hasAuthor");
wn([
  Ce()
], _o.prototype, "_hasDescription");
wn([
  De({ slot: "description" })
], _o.prototype, "slottedDescription");
wn([
  Ct({ slot: "name" })
], _o.prototype, "slottedName");
const oE = ve`:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]{--avatar-border-radius: var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0 0;--bio-card-avatar-size-inline-normal: auto;--bio-card-avatar-size-inline-wide: auto}:root[beacon-tag-name=beacon-bio-card]:not([template=hero]),:root [beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:not([template=hero]),[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:not([template=hero]),[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:not([template=hero]),[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:not([template=hero]){--avatar-border-radius: 0}:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]),[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide]){--aspect-ratio: 2/3}:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right],[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero][hero-position=right]{--avatar-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0}@media (width >= 640px){:root[beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],:root [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]:is([layout=horizontal],[layout=horizontal-wide])[template=hero]{--avatar-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard)}}@media (width >= 960px){:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]{--bio-card-avatar-size-inline-normal: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--bio-card-avatar-size-inline-wide: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 3 + var(--beacon-system-space-gutter) * 2)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-bio-card],:root [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"][beacon-tag-name=beacon-bio-card],[beacon-version="4.4.0"] [beacon-tag-name=beacon-bio-card]{--bio-card-avatar-size-inline-normal: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 3 + var(--beacon-system-space-gutter) * 2)}}`, Yi = {
  beaconTagName: "beacon-bio-card",
  dataListNodeName: "BEACON-DATA-LIST",
  dataListElement: "dl",
  dataListItemLimit: 3,
  bioCardLayoutProperty: "layout"
}, iE = ve`[beacon-tag-name=beacon-bio-card] [beacon-tag-name=beacon-id-card]{--override-padding: 0;--override-description-margin-end: 0;--override-id-card-margin-block-end: var(--beacon-reference-space-3);--override-id-card-text-content-align-self: start}[beacon-tag-name=beacon-bio-card] [beacon-tag-name=beacon-id-card] :where(img){max-inline-size:var(--override-id-card-img-max-inline-size, 100%)}[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card]{--id-card-top-position: 0;--avatar-inline-size: var(--bio-card-max-inline-size);--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1);--override-id-card-display-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);--override-id-card-img-max-inline-size: calc(100% + calc(var(--beacon-system-space-organism-normal) * 2))}[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card] [slot=name]:is(a):not(:is(:hover,:focus)),[beacon-tag-name=beacon-bio-card][template=hero] [beacon-tag-name=beacon-id-card] [slot=name] a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-bio-card] [beacon-tag-name=beacon-divided-list] [beacon-tag-name=beacon-divided-list-item]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-bio-card][template=hero][layout=vertical] [beacon-tag-name=beacon-id-card]{--avatar-inline-size: var(--bio-card-max-inline-size);--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1);--override-id-card-margin-block-end: 0;--override-id-card-img-max-inline-size: calc(100% + calc(var(--beacon-system-space-organism-normal) * 2))}@media (width >= 960px){[beacon-tag-name=beacon-bio-card][template=hero][layout=vertical] [beacon-tag-name=beacon-id-card]{--override-id-card-margin-block-end: var(--beacon-system-space-micro-mini)}}@media (width >= 640px){[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card]{--id-card-text-content-space-padding: 0;--id-card-text-content-space-padding-block-start: 0;--override-id-card-margin-block-end: 0}[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card] [slot=name]:is(a),[beacon-tag-name=beacon-bio-card][template=hero]:not([layout=vertical]) [beacon-tag-name=beacon-id-card] [slot=name] a{color:var(--beacon-system-color-text-link)}}[beacon-tag-name=beacon-bio-card] .footnote,[beacon-tag-name=beacon-bio-card] [slot=footnote]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0;padding:var(--beacon-system-space-cell-contained)}`, aE = ve`:host{--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--hero-direction: row;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2);border-radius:var(--beacon-system-radius-corner-standard, 0);max-inline-size:var(--bio-card-max-inline-size);padding:var(--beacon-system-space-organism-normal)}.avatar{--avatar-aspect-ratio: 1 / 2;--avatar-column: 50%;--avatar-inline-margin: calc(var(--beacon-system-space-organism-normal) * -1) 0;border-radius:var(--avatar-border-radius)}:host([template=hero]){--id-card-avatar-ratio: 2 / 1;--bio-card-override-id-card-avatar-size-mini: 100%;--bio-card-override-id-card-color-text: var(--beacon-reference-palette-greyscale-white);--override-id-card-display: flex;--override-id-card-flex-direction: column;--id-card-text-content-space-padding: var(--beacon-system-space-cell-contained);--id-card-text-content-space-padding-block-start: calc(var(--beacon-system-space-organism-normal) + var(--beacon-system-space-cell-contained));--id-card-avatar-border: 0;--bio-card-override-id-card-name-color-text: var(--beacon-custom-id-card-name-color-text, var(--beacon-system-color-text-link));--bio-card-override-id-card-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);--bio-card-override-id-card-name-font-line-height-mini: 1.43;--bio-card-override-id-card-name-font-size-mini: var(--beacon-reference-font-scale-3);--bio-card-override-id-card-space-padding: 0;--border-radius: var(--beacon-system-radius-corner-standard);padding-block-start:0}:host([template=hero]) .avatar{display:none}:host([hero-position=right]){--hero-direction: row-reverse}:host([hero-position=right]) .avatar{--avatar-inline-margin: 0 calc(var(--beacon-system-space-organism-normal) * -1)}.content{--content-column: 50%}.footnote,::slotted([slot=footnote]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);margin:0;padding:var(--beacon-system-space-cell-contained)}::slotted([beacon-tag-name=beacon-id-card]){--commentary-tile-background: transparent;--commentary-tile-padding: 0;--id-card-border: 0;--id-card-avatar-border-block-end: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}:host([template=standard]) ::slotted([beacon-tag-name=beacon-id-card]){--id-card-avatar-border-block-end: 0}::slotted([beacon-tag-name=beacon-divided-list]){padding:var(--beacon-system-space-cell-contained)}@media (width >= 640px){:host([layout=vertical]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--avatar-size: var(--bio-card-max-inline-size)}:host([template=hero]:not([layout=vertical])){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--id-card-avatar-display: none;--avatar-block-size: inherit;--id-card-content-position: relative;--bio-card-override-id-card-name-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);--bio-card-override-id-card-space-padding: var(--beacon-reference-space-3);display:flex;flex-direction:var(--hero-direction);padding:0}:host([template=hero]:not([layout=vertical])) .avatar{aspect-ratio:var(--aspect-ratio, var(--avatar-aspect-ratio));block-size:var(--avatar-block-size);display:block;inline-size:var(--avatar-column);object-fit:cover}:host([template=hero]:not([layout=vertical])) .avatar.left{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}:host([template=hero]:not([layout=vertical])) .avatar.right{border-inline-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-2)}:host([template=hero]:not([layout=vertical])) .content{display:flex;flex-direction:column;inline-size:var(--content-column);padding:var(--beacon-system-space-organism-normal)}:host([template=hero]:not([layout=vertical])) ::slotted([beacon-tag-name=beacon-id-card]){--id-card-avatar-border-block-end: 0}:host([template=hero]:not([layout=vertical][hero-position=left])){--border-radius: 100px 20px 40px 60px}}@media (width >= 960px){:host([layout=vertical]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host([layout=horizontal]){--bio-card-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9)}:host([template=hero]:not([layout=vertical])) .content{--content-column: auto}:host([template=hero]:not([layout=vertical])) .avatar{--avatar-column: var(--bio-card-avatar-size-inline-normal)}:host([template=hero][layout=horizontal-wide]) .avatar{--avatar-column: var(--bio-card-avatar-size-inline-wide)}:host([layout=horizontal-wide]){--bio-card-max-inline-size: 100%}:host([layout=horizontal-wide]) .content{column-gap:var(--beacon-reference-space-7);display:grid;grid-template-columns:8fr 4fr}}@media (width >= 1280px){.avatar{--avatar-aspect-ratio: 1 / 1}}`;
var nE = Object.defineProperty, Sa = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && nE(t, e, o), o;
};
const Ub = class Ub extends Le {
  constructor() {
    var t, e;
    super(...arguments), this.beaconTagName = Yi.beaconTagName, this.layout = fi.HORIZONTAL, this.template = Vr.STANDARD, this.heroPosition = hb.LEFT, this.DataList = this.SlottedDataList, this.ListItemsContainer = (t = this.DataList) == null ? void 0 : t.renderRoot.querySelector(Yi.dataListElement), this.ListItems = (e = this.DataList) == null ? void 0 : e.listItems;
  }
  static get styles() {
    return [super.styles, aE];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, oE, iE];
  }
  /** The first element in the @beaconQueryAssignedElements array */
  get SlottedIdCard() {
    return this.IdCard[0];
  }
  set SlottedIdCard(t) {
    this.IdCard = Array(t);
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   * The first element in the @beaconQueryAssignedElements array.
   */
  get SlottedDataList() {
    return this.DataLists[0];
  }
  /**
   * @returns null on initial load
   * @returns The avatar URL of the slotted Commentary Tile after firstUpdated()
   */
  get Avatar() {
    var t;
    return (t = this.SlottedIdCard) == null ? void 0 : t.slottedAvatarUrl;
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * returns the Updated Data-List after being set in firstUpdated()
   */
  get BeaconDataList() {
    return this.DataList;
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * Extract the data list from the slot, either alone or from a containing `<div>`.
   */
  set BeaconDataList(t) {
    var i;
    const e = this.getScopedTagName(Yi.dataListNodeName);
    (t == null ? void 0 : t.nodeName) !== e ? this.DataList = (i = this.SlottedDataList) == null ? void 0 : i.querySelector(
      e.toLowerCase()
    ) : this.DataList = t;
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * called any time the data list re-renders (i.e. if new items are added)
   */
  changeDataListOrientation() {
    if (this.BeaconDataList instanceof tn) {
      const t = this.BeaconDataList.listItems.length;
      if (this.template === Vr.STANDARD)
        switch (this.layout) {
          case fi.VERTICAL:
          case fi.HORIZONTAL_WIDE:
            this.BeaconDataList.orientation = Wo.VERTICAL;
            break;
          case fi.HORIZONTAL:
          default:
            this.BeaconDataList.orientation = t && t > Yi.dataListItemLimit ? Wo.SPLIT : Wo.HORIZONTAL;
            break;
        }
      else if (this.template === Vr.HERO)
        switch (this.layout) {
          case fi.VERTICAL:
            this.BeaconDataList.orientation = Wo.VERTICAL;
            break;
          case fi.HORIZONTAL_WIDE:
            this.BeaconDataList.orientation = t && t > Yi.dataListItemLimit ? Wo.SPLIT : Wo.HORIZONTAL;
            break;
          case fi.HORIZONTAL:
          default:
            this.BeaconDataList.orientation = t && t > Yi.dataListItemLimit ? Wo.SPLIT : Wo.VERTICAL;
            break;
        }
    }
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * Updates the data-list when the slotted component fires a render event.
   * @param event takes a custom Render event emitted by the data-list
   */
  handleRender() {
    this.updateDataList();
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * Safely updates the data-list orientation by waiting for update completion to the Datalist
   * and updates the updated data list's orientation.
   */
  async updateDataList() {
    this.BeaconDataList instanceof tn && (await this.BeaconDataList.updateComplete, this.changeDataListOrientation());
  }
  /**
   * @deprecated 2025-04-08: Data List is deprecated.
   *
   * overrides updated and checks to see if layout was changed after an update then, updated
   * then safely updated the data-list orientation.
   * @param changedProperties Internal Map object of changed properties during an update
   */
  updated(t) {
    t.has(Yi.bioCardLayoutProperty) && this.updateDataList();
  }
  /**
   * Checks to see if slotted Commentary tiles and Data-lists
   * are finished updated, then sets the bio-cards reference properties
   * to the Commentary Tile and Data-List. Updates Data-List orientation
   * also after waiting for its rendering.
   */
  async firstUpdated() {
    var t, e;
    this.SlottedIdCard instanceof _o && (this.SlottedIdCard.scale = Fo.MINI, this.requestUpdate("SlottedIdCard"), await this.updateComplete, await ((t = this.SlottedIdCard) == null ? void 0 : t.updateComplete), await this.updateComplete), this.BeaconDataList = this.SlottedDataList, this.BeaconDataList instanceof tn && (await ((e = this.BeaconDataList) == null ? void 0 : e.updateComplete), this.changeDataListOrientation()), super.firstUpdated();
  }
  render() {
    return pe`
      ${this.template === Vr.HERO && this.layout !== fi.VERTICAL ? pe`<img
            class="avatar ${this.heroPosition}"
            src="${this.Avatar}"
            alt="" />` : je}
      <div class="content">
        <slot name="id-card"></slot>
        <div class="list-content">
          <!-- @deprecated -->
          <slot
            name="data-list"
            @beacon-event-render=${this.handleRender}></slot>
          <slot name="list"></slot>
          <slot name="footnote" class="footnote"></slot>
        </div>
      </div>
    `;
  }
};
Ub.tagName = Yi.beaconTagName;
let oi = Ub;
Sa([
  ue({ reflect: !0 })
], oi.prototype, "layout");
Sa([
  ue({ reflect: !0 })
], oi.prototype, "template");
Sa([
  ue({ attribute: "hero-position" })
], oi.prototype, "heroPosition");
Sa([
  De({ flatten: !0, slot: "id-card" })
], oi.prototype, "IdCard");
Sa([
  De({ flatten: !0, slot: "data-list" })
], oi.prototype, "DataLists");
Sa([
  Ce()
], oi.prototype, "DataList");
Sa([
  Ce()
], oi.prototype, "ListItemsContainer");
Sa([
  Ce()
], oi.prototype, "ListItems");
class bb extends Ni {
  constructor(t) {
    if (super(t), t.type !== gn.EVENT || t.name !== "slotchange" || t.tagName !== "SLOT")
      throw new Error(
        "The `addListRole` directive must be used on a `<slot>` and the `slotchange` event"
      );
    this.part = t;
  }
  /**
   * Adds the list role to any <ul> or <ol> elements slotted into this slot
   * @param part
   */
  static addListRoleToSlotted(t) {
    if (t) {
      const e = (t == null ? void 0 : t.element).assignedElements();
      e == null || e.forEach((i) => {
        (i.tagName === "UL" || i.tagName === "OL") && (i.role = "list");
      });
    }
  }
  /**
   * Takes in a secondary function to be executed on slotchange. This is so that the user can still listen for slotchange
   * events when using this directive.
   * @param otherSlotChangeFunction Secondary slot change function to be called alongside this directive
   * @returns Empty string. When there is no return value, the event listeners are never properly attached.
   */
  render(t = void 0) {
    return this.part && (this.part.handleEvent = (e) => {
      this.part && bb.addListRoleToSlotted(this.part), t && t(e);
    }), "";
  }
}
const Js = Ri(bb);
function rE(a) {
  return parseFloat(a) * 16;
}
const $u = {
  beaconTagName: "beacon-menu"
}, sE = ve`[beacon-tag-name=beacon-menu] :is(li),[beacon-tag-name=beacon-menu] :is(li)>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);inline-size:auto;text-decoration:none;white-space:inherit}[beacon-tag-name=beacon-menu] :is(li):hover a{color:var(--beacon-system-color-text-link);text-decoration:underline}[beacon-tag-name=beacon-menu] :is(li){align-items:center;display:flex;flex-direction:row;gap:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-menu] :is(li) :is(svg){block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);stroke:var(--beacon-system-color-border-link)}[beacon-tag-name=beacon-menu] :is(li,h1,h2,h3,h4,h5,h6){padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-menu] [slot=title],[beacon-tag-name=beacon-menu] [slot=title]>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}`, lE = ve`:host ::slotted(ul),:host ::slotted(ol){display:flex;flex-direction:column;gap:var(--beacon-reference-space-3);inline-size:auto;list-style:none;margin:0;padding:0}`;
var cE = Object.defineProperty, Bf = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && cE(t, e, o), o;
};
const $b = class $b extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = $u.beaconTagName;
  }
  static get styles() {
    return [super.styles, lE];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, sE];
  }
  handleSlotChange() {
    if (this.slottedMenu) {
      const t = this.slottedMenu[0];
      t == null || t.setAttribute("role", "menu"), t == null || t.querySelectorAll("li").forEach((e) => {
        e.setAttribute("role", "menuitem");
      });
    }
  }
  /**
   * Assigns an ID to the slotted title, and applies
   * the ID to the menu as `aria-labelledby`.
   */
  handleTitleSlotChange() {
    var t, e;
    if ((t = this.slottedTitle) != null && t.length) {
      const i = this.slottedTitle[0], o = (e = this.slottedMenu) == null ? void 0 : e[0];
      if (o) {
        const n = _i();
        o.setAttribute("aria-labelledby", i.id || n), i.id = i.id || n;
      }
    }
  }
  render() {
    return pe`<slot
        name="title"
        @slotchange=${this.handleTitleSlotChange}></slot>
      <slot @slotchange=${this.handleSlotChange}></slot>`;
  }
};
$b.tagName = $u.beaconTagName;
let As = $b;
Bf([
  Ct({ slot: "", selector: "ul, ol" })
], As.prototype, "slottedMenu");
Bf([
  Ct({ slot: "title" })
], As.prototype, "slottedTitle");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Rf = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ul = /* @__PURE__ */ Rf.join(","), Nf = typeof Element > "u", cn = Nf ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, $l = !Nf && Element.prototype.getRootNode ? function(a) {
  var t;
  return a == null || (t = a.getRootNode) === null || t === void 0 ? void 0 : t.call(a);
} : function(a) {
  return a == null ? void 0 : a.ownerDocument;
}, Hl = function a(t, e) {
  var i;
  e === void 0 && (e = !0);
  var o = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "inert"), n = o === "" || o === "true", l = n || e && t && a(t.parentNode);
  return l;
}, dE = function(t) {
  var e, i = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
  return i === "" || i === "true";
}, Ff = function(t, e, i) {
  if (Hl(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Ul));
  return e && cn.call(t, Ul) && o.unshift(t), o = o.filter(i), o;
}, jf = function a(t, e, i) {
  for (var o = [], n = Array.from(t); n.length; ) {
    var l = n.shift();
    if (!Hl(l, !1))
      if (l.tagName === "SLOT") {
        var L = l.assignedElements(), D = L.length ? L : l.children, j = a(D, !0, i);
        i.flatten ? o.push.apply(o, j) : o.push({
          scopeParent: l,
          candidates: j
        });
      } else {
        var I = cn.call(l, Ul);
        I && i.filter(l) && (e || !t.includes(l)) && o.push(l);
        var B = l.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(l), R = !Hl(B, !1) && (!i.shadowRootFilter || i.shadowRootFilter(l));
        if (B && R) {
          var N = a(B === !0 ? l.children : B.children, !0, i);
          i.flatten ? o.push.apply(o, N) : o.push({
            scopeParent: l,
            candidates: N
          });
        } else
          n.unshift.apply(n, l.children);
      }
  }
  return o;
}, _f = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, ja = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || dE(t)) && !_f(t) ? 0 : t.tabIndex;
}, hE = function(t, e) {
  var i = ja(t);
  return i < 0 && e && !_f(t) ? 0 : i;
}, bE = function(t, e) {
  return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}, Uf = function(t) {
  return t.tagName === "INPUT";
}, pE = function(t) {
  return Uf(t) && t.type === "hidden";
}, uE = function(t) {
  var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return e;
}, gE = function(t, e) {
  for (var i = 0; i < t.length; i++)
    if (t[i].checked && t[i].form === e)
      return t[i];
}, mE = function(t) {
  if (!t.name)
    return !0;
  var e = t.form || $l(t), i = function(L) {
    return e.querySelectorAll('input[type="radio"][name="' + L + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = i(window.CSS.escape(t.name));
  else
    try {
      o = i(t.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var n = gE(o, t.form);
  return !n || n === t;
}, fE = function(t) {
  return Uf(t) && t.type === "radio";
}, vE = function(t) {
  return fE(t) && !mE(t);
}, AE = function(t) {
  var e, i = t && $l(t), o = (e = i) === null || e === void 0 ? void 0 : e.host, n = !1;
  if (i && i !== t) {
    var l, L, D;
    for (n = !!((l = o) !== null && l !== void 0 && (L = l.ownerDocument) !== null && L !== void 0 && L.contains(o) || t != null && (D = t.ownerDocument) !== null && D !== void 0 && D.contains(t)); !n && o; ) {
      var j, I, B;
      i = $l(o), o = (j = i) === null || j === void 0 ? void 0 : j.host, n = !!((I = o) !== null && I !== void 0 && (B = I.ownerDocument) !== null && B !== void 0 && B.contains(o));
    }
  }
  return n;
}, Hu = function(t) {
  var e = t.getBoundingClientRect(), i = e.width, o = e.height;
  return i === 0 && o === 0;
}, yE = function(t, e) {
  var i = e.displayCheck, o = e.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var n = cn.call(t, "details>summary:first-of-type"), l = n ? t.parentElement : t;
  if (cn.call(l, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof o == "function") {
      for (var L = t; t; ) {
        var D = t.parentElement, j = $l(t);
        if (D && !D.shadowRoot && o(D) === !0)
          return Hu(t);
        t.assignedSlot ? t = t.assignedSlot : !D && j !== t.ownerDocument ? t = j.host : t = D;
      }
      t = L;
    }
    if (AE(t))
      return !t.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return Hu(t);
  return !1;
}, xE = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var e = t.parentElement; e; ) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var i = 0; i < e.children.length; i++) {
          var o = e.children.item(i);
          if (o.tagName === "LEGEND")
            return cn.call(e, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
  return !1;
}, Kl = function(t, e) {
  return !(e.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Hl(e) || pE(e) || yE(e, t) || // For a details element with a summary, the summary element gets the focus
  uE(e) || xE(e));
}, yh = function(t, e) {
  return !(vE(e) || ja(e) < 0 || !Kl(t, e));
}, wE = function(t) {
  var e = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(e) || e >= 0);
}, kE = function a(t) {
  var e = [], i = [];
  return t.forEach(function(o, n) {
    var l = !!o.scopeParent, L = l ? o.scopeParent : o, D = hE(L, l), j = l ? a(o.candidates) : L;
    D === 0 ? l ? e.push.apply(e, j) : e.push(L) : i.push({
      documentOrder: n,
      tabIndex: D,
      item: o,
      isScope: l,
      content: j
    });
  }), i.sort(bE).reduce(function(o, n) {
    return n.isScope ? o.push.apply(o, n.content) : o.push(n.content), o;
  }, []).concat(e);
}, $f = function(t, e) {
  e = e || {};
  var i;
  return e.getShadowRoot ? i = jf([t], e.includeContainer, {
    filter: yh.bind(null, e),
    flatten: !1,
    getShadowRoot: e.getShadowRoot,
    shadowRootFilter: wE
  }) : i = Ff(t, e.includeContainer, yh.bind(null, e)), kE(i);
}, CE = function(t, e) {
  e = e || {};
  var i;
  return e.getShadowRoot ? i = jf([t], e.includeContainer, {
    filter: Kl.bind(null, e),
    flatten: !0,
    getShadowRoot: e.getShadowRoot
  }) : i = Ff(t, e.includeContainer, Kl.bind(null, e)), i;
}, Bn = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return cn.call(t, Ul) === !1 ? !1 : yh(e, t);
}, SE = /* @__PURE__ */ Rf.concat("iframe").join(","), Fd = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return cn.call(t, SE) === !1 ? !1 : Kl(e, t);
}, ys = /* @__PURE__ */ ((a) => (a.ENABLED = "enabled", a.DISABLED = "disabled", a))(ys || {}), pb = /* @__PURE__ */ ((a) => (a.VIEWED = "b-motion-viewed", a))(pb || {}), EE = Object.getOwnPropertyDescriptor, ME = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? EE(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function ub(a) {
  let t = class extends a {
    /**
     * Keyboard event handler for arrow control. Uses the element that we are currently
     * focused on to find order which removes any complexity that comes from tracking
     * the current index.
     *
     * To use the mixin, attach this event listener to each of the events to be
     * controlled with arrow control, then pass an array of those elements as arrowControlElements
     *
     * @param event
     * @param arrowControlElements elements to move focus between, in order
     * @param layoutDirection 'horizontal', 'vertical', or 'any' depending on which arrow keys should be used
     * @param focusCallback callback to when an element is focused. Allows element to autoselect or defer focus to a child
     */
    handleArrowControlKeydown(e, i, o, n) {
      let l = !1;
      if (e && e.isTrusted) {
        const L = t.calculateArrowIncrement(
          e,
          o
        );
        if (L != 0) {
          const D = i.indexOf(
            e.currentTarget
          );
          if (D != -1) {
            const j = t.ensureFocusIndexInRange(
              D + L,
              i.length
            );
            n.call(this, i[j]), l = !0;
          }
        }
      }
      return l;
    }
    /**
     * Calculates the index increment based on the input keys.
     * @param event
     * @param layoutDirection
     * @returns
     */
    static calculateArrowIncrement(e, i) {
      return e.key === Ci.LEFT && (i === "horizontal" || i === "any") || e.key === Ci.UP && (i === "vertical" || i === "any") ? -1 : e.key === Ci.RIGHT && (i === "horizontal" || i === "any") || e.key === Ci.DOWN && (i === "vertical" || i === "any") ? 1 : 0;
    }
    /**
     * Wraps the focus index around the ends of the array
     * @param focusIndex
     * @param numberOfElements
     * @returns
     */
    static ensureFocusIndexInRange(e, i) {
      return e < 0 ? i - 1 : e >= i ? 0 : e;
    }
  };
  return t = ME([
    $e("ArrowControl")
  ], t), t;
}
var Hf = /* @__PURE__ */ ((a) => (a.Anchor = "a", a.Button = "button", a.BeaconButton = '[beacon-tag-name="beacon-button"]', a.BeaconIconButton = '[beacon-tag-name="beacon-icon-button"]', a.tabIndex = '[tabindex]:not([tabindex="-1"])', a))(Hf || {});
function TE(a) {
  class t extends a {
    constructor() {
      super(...arguments), this._firstFocusableElement = null, this._lastFocusableElement = null, this._triggerElement = null, this._nextFocusableElement = null, this.handleFirstFocusableKeydown = (i) => {
        this.triggerElement && this.forwardFocusToPrevious(i, this.triggerElement);
      }, this.handleLastFocusableKeydown = (i) => {
        this.nextFocusableElement && this.forwardFocusToNext(i, this.nextFocusableElement);
      }, this.handleNextFocusableKeydown = (i) => {
        this.lastFocusableElement && this.forwardFocusToPrevious(i, this.lastFocusableElement);
      }, this.handleTriggerKeydown = (i) => {
        this.firstFocusableElement && this.forwardFocusToNext(i, this.firstFocusableElement);
      };
    }
    get firstFocusableElement() {
      return this._firstFocusableElement;
    }
    set firstFocusableElement(i) {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this._firstFocusableElement = i;
    }
    get lastFocusableElement() {
      return this._lastFocusableElement;
    }
    set lastFocusableElement(i) {
      this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this._lastFocusableElement = i;
    }
    get triggerElement() {
      return this._triggerElement;
    }
    set triggerElement(i) {
      this.triggerElement && this.triggerElement.removeEventListener(
        et.KEYDOWN,
        this.handleTriggerKeydown
      ), this._triggerElement = i;
    }
    get nextFocusableElement() {
      return this._nextFocusableElement;
    }
    set nextFocusableElement(i) {
      this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this._nextFocusableElement = i;
    }
    internalFocusableElements() {
      return Array.from(
        this.querySelectorAll(this.generateFocusableElementsSelector())
      );
    }
    forwardFocusToNext(i, o) {
      i.key === "Tab" && !i.shiftKey && (i.preventDefault(), o.focus());
    }
    forwardFocusToPrevious(i, o) {
      i.key === "Tab" && i.shiftKey && (i.preventDefault(), o.focus());
    }
    /**
     * Callback to initialize the focusable elements within the overlay
     * and set the first and last focusable elements for focus forwarding.
     */
    initializeInternalFocusableElements() {
    }
    /**
     * Callback to initialize the focusable elements outside of the overlay
     * and set the trigger element and next focusable element for focus forwarding.
     * @returns
     */
    initializeExternalFocusableElements() {
    }
    attachFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.addEventListener(
        et.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.addEventListener(
        et.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.addEventListener(
        et.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.addEventListener(
        et.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    removeFocusableElementListeners() {
      this.firstFocusableElement && this.firstFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleFirstFocusableKeydown
      ), this.lastFocusableElement && this.lastFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleLastFocusableKeydown
      ), this.nextFocusableElement && this.nextFocusableElement.removeEventListener(
        et.KEYDOWN,
        this.handleNextFocusableKeydown
      ), this.triggerElement && this.triggerElement.removeEventListener(
        et.KEYDOWN,
        this.handleTriggerKeydown
      );
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns the first matching element.
     * Note that this does not cross different shadowDOM boundaries, and logic is dependent upon being
     * within the same lightDOM or shadowDOM contexts.
     * @param selector
     * @returns The first found element or null
     */
    DOMContextQuerySelector(i, o = this.getClosestHost()) {
      return o ? o.shadowRoot.querySelector(
        i
      ) : document.querySelector(i);
    }
    /**
     * Queries the closest shadowRoot to the popover, if it exists,
     * or the document if the popover is at the document level, and returns all matching
     * @param selector
     * @returns A list of elements that match the selector, or undefined if none are found.
     */
    DOMContextQuerySelectorAll(i, o = this.getClosestHost()) {
      return o ? o.shadowRoot.querySelectorAll(i) : document.querySelectorAll(i);
    }
    generateFocusableElementsSelector() {
      return `:is(${Object.values(Hf).join(", ")})`;
    }
    /**
     * Returns a focusable element that follows the selector in the DOM as a sibling,
     * also includes focusable elements nested within a container, which are not direct siblings.
     * @param selector
     * @returns
     */
    siblingFocusableElements(i) {
      const o = `${i} ~ ${this.generateFocusableElementsSelector()}`, n = `:has(${i}) ~ :has(${this.generateFocusableElementsSelector()}) ${this.generateFocusableElementsSelector()}`;
      return {
        directSibling: this.DOMContextQuerySelector(
          o
        ),
        indirectSibling: this.DOMContextQuerySelector(
          n
        )
      };
    }
  }
  return t;
}
var LE = Object.getOwnPropertyDescriptor, OE = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? LE(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function PE(a) {
  let t = class extends a {
    extendFocus(e) {
      if (e) {
        const i = e.focus.bind(e);
        e.focus = function(o) {
          o != null && o.override && (e.classList.add("skip-focus-override"), e.addEventListener(
            "blur",
            () => {
              e.classList.remove("skip-focus-override");
            },
            { once: !0 }
          )), i(o);
        };
      } else
        console.log("Element is null");
    }
    overrideFocus(e) {
      e.forEach((i) => {
        this.extendFocus(i);
      });
    }
  };
  return t = OE([
    $e("FocusOptions")
  ], t), t;
}
const DE = ve`[class*=b-motion]{--b-motion-delay-default: 0ms;--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-fill-mode-default: both;--b-motion-iteration-count-default: 1;--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1);animation-delay:var(--b-motion-delay, var(--b-motion-delay-default));animation-duration:var(--b-motion-duration, var(--b-motion-duration-default));animation-fill-mode:var(--b-motion-fill-mode, var(--b-motion-fill-mode-default));animation-iteration-count:var(--b-motion-iteration-count, var(--b-motion-iteration-count-default));animation-timing-function:var(--b-motion-timing-function, var(--b-motion-timing-function-default))}.b-motion-duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}.b-motion-duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}.b-motion-duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}.b-motion-duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}.b-motion-duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}.b-motion-duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}.b-motion-duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}.b-motion-duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}.b-motion-duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}.b-motion-duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}.b-motion-duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}.b-motion-duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}.b-motion-delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}.b-motion-delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}.b-motion-delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}.b-motion-delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}.b-motion-delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}.b-motion-delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}.b-motion-delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}.b-motion-delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}.b-motion-delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}.b-motion-delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}.b-motion-delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}.b-motion-delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}.b-motion-ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}.b-motion-ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}.b-motion-ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}.b-motion-ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}.b-motion-ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}.b-motion-ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}.b-motion-ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}.b-motion-iteration--1{--b-motion-iteration-count: 1}.b-motion-iteration--2{--b-motion-iteration-count: 2}.b-motion-iteration--3{--b-motion-iteration-count: 3}.b-motion-iteration--4{--b-motion-iteration-count: 4}.b-motion-iteration--5{--b-motion-iteration-count: 5}@media (width >= 320px){[class*=b-motion-duration--].b-sm\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-sm\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-sm\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-sm\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-sm\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-sm\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-sm\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-sm\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-sm\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-sm\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-sm\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-sm\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-sm\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-sm\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-sm\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-sm\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-sm\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-sm\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-sm\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-sm\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-sm\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-sm\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-sm\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-sm\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-sm\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-sm\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 640px){[class*=b-motion-duration--].b-md\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-md\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-md\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-md\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-md\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-md\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-md\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-md\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-md\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-md\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-md\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-md\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-md\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-md\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-md\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-md\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-md\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-md\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-md\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-md\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-md\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-md\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-md\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-md\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-md\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-md\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-md\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 960px){[class*=b-motion-duration--].b-lg\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-lg\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-lg\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-lg\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-lg\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-lg\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-lg\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-lg\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-lg\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-lg\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-lg\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-lg\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-lg\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-lg\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-lg\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-lg\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-lg\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-lg\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-lg\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-lg\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-lg\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-lg\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-lg\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-lg\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-lg\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-lg\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1280px){[class*=b-motion-duration--].b-xl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1600px){[class*=b-motion-duration--].b-xxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}@media (width >= 1920px){[class*=b-motion-duration--].b-xxxl\\:duration--short-1{--b-motion-duration: var(--beacon-reference-motion-duration-1)}[class*=b-motion-duration--].b-xxxl\\:duration--short-2{--b-motion-duration: var(--beacon-reference-motion-duration-2)}[class*=b-motion-duration--].b-xxxl\\:duration--short-3{--b-motion-duration: var(--beacon-reference-motion-duration-3)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-1{--b-motion-duration: var(--beacon-reference-motion-duration-4)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-2{--b-motion-duration: var(--beacon-reference-motion-duration-5)}[class*=b-motion-duration--].b-xxxl\\:duration--medium-3{--b-motion-duration: var(--beacon-reference-motion-duration-6)}[class*=b-motion-duration--].b-xxxl\\:duration--long-1{--b-motion-duration: var(--beacon-reference-motion-duration-7)}[class*=b-motion-duration--].b-xxxl\\:duration--long-2{--b-motion-duration: var(--beacon-reference-motion-duration-8)}[class*=b-motion-duration--].b-xxxl\\:duration--long-3{--b-motion-duration: var(--beacon-reference-motion-duration-9)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-1{--b-motion-duration: var(--beacon-reference-motion-duration-10)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-2{--b-motion-duration: var(--beacon-reference-motion-duration-11)}[class*=b-motion-duration--].b-xxxl\\:duration--x-long-3{--b-motion-duration: var(--beacon-reference-motion-duration-12)}[class*=b-motion-delay--].b-xxxl\\:delay--short-1{--b-motion-delay: var(--beacon-reference-motion-duration-1)}[class*=b-motion-delay--].b-xxxl\\:delay--short-2{--b-motion-delay: var(--beacon-reference-motion-duration-2)}[class*=b-motion-delay--].b-xxxl\\:delay--short-3{--b-motion-delay: var(--beacon-reference-motion-duration-3)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-1{--b-motion-delay: var(--beacon-reference-motion-duration-4)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-2{--b-motion-delay: var(--beacon-reference-motion-duration-5)}[class*=b-motion-delay--].b-xxxl\\:delay--medium-3{--b-motion-delay: var(--beacon-reference-motion-duration-6)}[class*=b-motion-delay--].b-xxxl\\:delay--long-1{--b-motion-delay: var(--beacon-reference-motion-duration-7)}[class*=b-motion-delay--].b-xxxl\\:delay--long-2{--b-motion-delay: var(--beacon-reference-motion-duration-8)}[class*=b-motion-delay--].b-xxxl\\:delay--long-3{--b-motion-delay: var(--beacon-reference-motion-duration-9)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-1{--b-motion-delay: var(--beacon-reference-motion-duration-10)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-2{--b-motion-delay: var(--beacon-reference-motion-duration-11)}[class*=b-motion-delay--].b-xxxl\\:delay--x-long-3{--b-motion-delay: var(--beacon-reference-motion-duration-12)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--standard-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-standard-2)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--accelerate--emphasize-2{--b-motion-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-2)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--standard-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-standard-1)}[class*=b-motion-ease--].b-xxxl\\:ease--decelerate--emphasize-1{--b-motion-timing-function: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion-ease--].b-xxxl\\:ease--linear{--b-motion-timing-function: var(--beacon-system-motion-easing-linear)}}[class*=b-motion--intro-from-]{--b-motion-duration-default: var(--beacon-reference-motion-duration-9);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}[class*=b-motion--intro-from-offscreen]{--b-motion-duration-default: var(--beacon-reference-motion-duration-12);--b-motion-timing-function-default: var(--beacon-system-motion-easing-decelerate-emphasize-1)}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-left{animation:none}}@keyframes intro-from-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-left{animation-name:intro-from-left}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-right{animation:none}}@keyframes intro-from-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-right{animation-name:intro-from-right}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-top{animation:none}}@keyframes intro-from-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-top{animation-name:intro-from-top}@media screen and (prefers-reduced-motion: reduce){.b-motion--intro-from-bottom{animation:none}}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-bottom{animation-name:intro-from-bottom}@keyframes intro-from-offscreen-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-left{animation-name:intro-from-offscreen-left}@keyframes intro-from-offscreen-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}.b-motion--intro-from-offscreen-right{animation-name:intro-from-offscreen-right}@keyframes intro-from-offscreen-top{0%{opacity:0;transform:translateY(calc(-1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-top{animation-name:intro-from-offscreen-top}@keyframes intro-from-offscreen-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translateY(0)}}.b-motion--intro-from-offscreen-bottom{animation-name:intro-from-offscreen-bottom}@media (prefers-reduced-motion: reduce){*,*:before,*:after{animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}html{scroll-behavior:auto}}`;
var zE = Object.defineProperty, IE = Object.getOwnPropertyDescriptor, Kf = (a) => {
  throw TypeError(a);
}, Ro = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? IE(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && zE(t, e, o), o;
}, BE = (a, t, e) => t.has(a) || Kf("Cannot " + e), Xi = (a, t, e) => (BE(a, t, "read from private field"), e ? e.call(a) : t.get(a)), RE = (a, t, e) => t.has(a) ? Kf("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e);
function Lr(a = { autoRemoveMotionClasses: !0 }) {
  return function(e) {
    var i;
    let o = class extends e {
      constructor() {
        super(...arguments), this.inMotion = !1, this.motionMap = /* @__PURE__ */ new Map(), RE(this, i, ({ type: n, target: l }) => {
          if (!this.prefersReducedMotion) {
            if (this !== l && this.contains(l))
              return;
            (n === "animationstart" || n === "transitionstart") && this.motionMap.set(l, !0), (n === "animationend" || n === "transitionend") && this.motionMap.set(l, !1), Array.from(this.motionMap.values()).includes(!0) ? this.inMotion = !0 : this.inMotion = !1;
          }
        });
      }
      /**
       * Imports motion utility class stylesheet to enable usage of utility classes in shadowDOM
       */
      static get motionStyles() {
        return [DE];
      }
      /**
       * Empty function used to apply component-specific motion logic
       */
      applyMotionStyles() {
      }
      /**
       * Empty function used to handle animationstart events when listened from the root node.
       *
       * @abstract
       * @param e animationstart event object
       */
      hostAnimationStart(n) {
      }
      /**
       * Empty function used to handle animationend events when listened from the root node.
       *
       * @abstract
       * @param e animationend event object
       */
      hostAnimationEnd(n) {
      }
      /**
       * Empty function used to handle animationstart events when listened from the shadow root.
       *
       * @abstract
       * @param e animationstart event object
       */
      shadowRootAnimationStart(n) {
      }
      /**
       * Empty function used to handle animationend events when listened from the shadow root.
       *
       * @abstract
       * @param e animationend event object
       */
      shadowRootAnimationEnd(n) {
      }
      /**
       * Filter an element's classList property for all classes that use `b-motion`.
       *
       * @param element HTML element that finished an animation
       * @returns All class names with `b-motion` in the name
       */
      static findMotionClassesOnElement(n) {
        return Array.from(n.classList).filter(
          (l) => l.includes("b-motion")
        );
      }
      /**
       * Remove all `b-motion` classes from a given element.
       *
       * @param element HTML element that finished an animation
       */
      static removeMotionClassesFromElement(n) {
        n.classList.remove(
          ...o.findMotionClassesOnElement(n)
        );
      }
      /**
       * Called on host Animation End or ShadowRootAnimationEnd if this.
       * Motion class auto removal is enabled
       */
      cleanupClasses(n) {
        n.target instanceof HTMLElement && o.removeMotionClassesFromElement(n.target);
      }
      /*
       * Sets the animationEnd events to instead cleanupClasses if autoRemoval is enabled
       */
      autoRemoveClasses(n) {
        n && (this.hostAnimationEnd = this.cleanupClasses, this.shadowRootAnimationEnd = this.cleanupClasses);
      }
      bindMethods() {
        a && (a != null && a.autoRemoveMotionClasses) && this.autoRemoveClasses(a.autoRemoveMotionClasses), this.hostAnimationStart = this.hostAnimationStart.bind(this), this.hostAnimationEnd = this.hostAnimationEnd.bind(this), this.shadowRootAnimationStart = this.shadowRootAnimationStart.bind(this), this.shadowRootAnimationEnd = this.shadowRootAnimationEnd.bind(this);
      }
      prerenderAddHostEventListeners() {
        this.bindMethods(), this.addEventListener("animationstart", this.hostAnimationStart), this.addEventListener("animationstart", Xi(this, i)), this.addEventListener("animationend", this.hostAnimationEnd), this.addEventListener("animationend", Xi(this, i)), this.addEventListener("transitionstart", Xi(this, i)), this.addEventListener("transitionend", Xi(this, i));
      }
      postrenderAddShadowRootListeners() {
        var n, l, L, D, j, I;
        (n = this.shadowRoot) == null || n.addEventListener(
          "animationstart",
          this.shadowRootAnimationStart
        ), (l = this.shadowRoot) == null || l.addEventListener(
          "animationstart",
          Xi(this, i)
        ), (L = this.shadowRoot) == null || L.addEventListener(
          "animationend",
          this.shadowRootAnimationEnd
        ), (D = this.shadowRoot) == null || D.addEventListener("animationend", Xi(this, i)), (j = this.shadowRoot) == null || j.addEventListener(
          "transitionstart",
          Xi(this, i)
        ), (I = this.shadowRoot) == null || I.addEventListener(
          "transitionend",
          Xi(this, i)
        );
      }
    };
    return i = /* @__PURE__ */ new WeakMap(), Ro([
      ue({
        reflect: !0,
        attribute: "in-motion",
        type: Boolean
      })
    ], o.prototype, "inMotion", 2), Ro([
      Ce()
    ], o.prototype, "motionMap", 2), Ro([
      qe
    ], o.prototype, "prerenderAddHostEventListeners", 1), Ro([
      Re
    ], o.prototype, "postrenderAddShadowRootListeners", 1), o = Ro([
      $e("Motionable")
    ], o), o;
  };
}
function Gf(a = { autoRemoveMotionClasses: !0, threshold: 1 }) {
  return function(e) {
    const i = Lr(a)(e);
    let o = class extends i {
      constructor() {
        var n;
        super(...arguments), this.handleMotionStylesOnView = (l) => {
          for (const L of l)
            L.isIntersecting && (this.applyMotionStyles(), this.removeMotionIntersectionObserver());
        }, this.motionIntersectionObserverOptions = {
          threshold: (n = a.threshold) != null ? n : 1
        }, this.motionIntersectionObserver = new IntersectionObserver(
          this.handleMotionStylesOnView,
          this.motionIntersectionObserverOptions
        );
      }
      /**
       * Disconnects the motionInterSectionObserver.
       * Invoked after component comes into view and has triggered motion styles.
       * Also invoked during disconnectedCallback.
       */
      removeMotionIntersectionObserver() {
        this.motionIntersectionObserver.disconnect();
      }
      applyMotionIntersectionObserver() {
        this.motionIntersectionObserver.observe(this);
      }
      motionOnViewDestroy() {
        this.removeMotionIntersectionObserver();
      }
    };
    return Ro([
      Re
    ], o.prototype, "applyMotionIntersectionObserver", 1), Ro([
      Pt
    ], o.prototype, "motionOnViewDestroy", 1), o = Ro([
      $e("MotionableOnView")
    ], o), o;
  };
}
function Wf(a) {
  class t extends a {
    constructor() {
      super(...arguments), this.closing = !1, this.removeMotionHidingState = () => {
        this.closing && (this.closing = !1, this.closingAnimationCallback());
      };
    }
    /** @abstract */
    closingAnimationCallback() {
    }
    applyMotionEventListener() {
      var i;
      (i = this.shadowRoot) == null || i.addEventListener(
        "transitionend",
        this.removeMotionHidingState
      ), this.addEventListener("transitionend", this.removeMotionHidingState);
    }
    removeMotionEventListener() {
      var i;
      (i = this.shadowRoot) == null || i.removeEventListener(
        "transitionend",
        this.removeMotionHidingState
      ), this.removeEventListener("transitionend", this.removeMotionHidingState);
    }
  }
  return Ro([
    ue({ reflect: !0, type: Boolean })
  ], t.prototype, "closing", 2), Ro([
    qe
  ], t.prototype, "applyMotionEventListener", 1), Ro([
    Pt
  ], t.prototype, "removeMotionEventListener", 1), t;
}
var NE = Object.defineProperty, FE = Object.getOwnPropertyDescriptor, yl = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? FE(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && NE(t, e, o), o;
};
function gb(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.opensBy = "";
    }
    get opensByElements() {
      if (this.opensBy) {
        const e = this.opensBy.split(" "), i = /* @__PURE__ */ new Map();
        return e.forEach((o) => {
          const n = this.getClosestHost();
          n ? Array.from(
            n.shadowRoot.querySelectorAll(o)
          ).forEach(
            (L) => i.set(L, !0)
          ) : Array.from(document.querySelectorAll(o)).forEach(
            (L) => i.set(L, !0)
          );
        }), i;
      }
    }
    /** @abstract */
    runOpensBySetup() {
    }
    /** @abstract */
    runOpensByClean() {
    }
    setupOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensBySetup();
    }
    cleanOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensByClean();
    }
    /**
     * Public-facing API method to refresh opens-by elements.
     * Some apps do not have control over the order of loading the trigger element vs. the popover.
     * This allows discovery of trigger elements after page load.
     */
    refreshOpensByElements() {
      this.cleanOpensByElements(), this.setupOpensByElements();
    }
  };
  return yl([
    ue({ attribute: "opens-by" })
  ], t.prototype, "opensBy", 2), yl([
    Re
  ], t.prototype, "setupOpensByElements", 1), yl([
    Pt
  ], t.prototype, "cleanOpensByElements", 1), t = yl([
    $e("OpensBy")
  ], t), t;
}
const sr = Math.min, on = Math.max, Gl = Math.round, xl = Math.floor, Jo = (a) => ({
  x: a,
  y: a
}), jE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, _E = {
  start: "end",
  end: "start"
};
function xh(a, t, e) {
  return on(a, sr(t, e));
}
function el(a, t) {
  return typeof a == "function" ? a(t) : a;
}
function dn(a) {
  return a.split("-")[0];
}
function tl(a) {
  return a.split("-")[1];
}
function Vf(a) {
  return a === "x" ? "y" : "x";
}
function mb(a) {
  return a === "y" ? "height" : "width";
}
function lr(a) {
  return ["top", "bottom"].includes(dn(a)) ? "y" : "x";
}
function fb(a) {
  return Vf(lr(a));
}
function UE(a, t, e) {
  e === void 0 && (e = !1);
  const i = tl(a), o = fb(a), n = mb(o);
  let l = o === "x" ? i === (e ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[n] > t.floating[n] && (l = Wl(l)), [l, Wl(l)];
}
function $E(a) {
  const t = Wl(a);
  return [wh(a), t, wh(t)];
}
function wh(a) {
  return a.replace(/start|end/g, (t) => _E[t]);
}
function HE(a, t, e) {
  const i = ["left", "right"], o = ["right", "left"], n = ["top", "bottom"], l = ["bottom", "top"];
  switch (a) {
    case "top":
    case "bottom":
      return e ? t ? o : i : t ? i : o;
    case "left":
    case "right":
      return t ? n : l;
    default:
      return [];
  }
}
function KE(a, t, e, i) {
  const o = tl(a);
  let n = HE(dn(a), e === "start", i);
  return o && (n = n.map((l) => l + "-" + o), t && (n = n.concat(n.map(wh)))), n;
}
function Wl(a) {
  return a.replace(/left|right|bottom|top/g, (t) => jE[t]);
}
function GE(a) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...a
  };
}
function qf(a) {
  return typeof a != "number" ? GE(a) : {
    top: a,
    right: a,
    bottom: a,
    left: a
  };
}
function Vl(a) {
  const {
    x: t,
    y: e,
    width: i,
    height: o
  } = a;
  return {
    width: i,
    height: o,
    top: e,
    left: t,
    right: t + i,
    bottom: e + o,
    x: t,
    y: e
  };
}
function Ku(a, t, e) {
  let {
    reference: i,
    floating: o
  } = a;
  const n = lr(t), l = fb(t), L = mb(l), D = dn(t), j = n === "y", I = i.x + i.width / 2 - o.width / 2, B = i.y + i.height / 2 - o.height / 2, R = i[L] / 2 - o[L] / 2;
  let N;
  switch (D) {
    case "top":
      N = {
        x: I,
        y: i.y - o.height
      };
      break;
    case "bottom":
      N = {
        x: I,
        y: i.y + i.height
      };
      break;
    case "right":
      N = {
        x: i.x + i.width,
        y: B
      };
      break;
    case "left":
      N = {
        x: i.x - o.width,
        y: B
      };
      break;
    default:
      N = {
        x: i.x,
        y: i.y
      };
  }
  switch (tl(t)) {
    case "start":
      N[l] -= R * (e && j ? -1 : 1);
      break;
    case "end":
      N[l] += R * (e && j ? -1 : 1);
      break;
  }
  return N;
}
const WE = async (a, t, e) => {
  const {
    placement: i = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: l
  } = e, L = n.filter(Boolean), D = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let j = await l.getElementRects({
    reference: a,
    floating: t,
    strategy: o
  }), {
    x: I,
    y: B
  } = Ku(j, i, D), R = i, N = {}, x = 0;
  for (let T = 0; T < L.length; T++) {
    const {
      name: y,
      fn: S
    } = L[T], {
      x: u,
      y: A,
      data: M,
      reset: f
    } = await S({
      x: I,
      y: B,
      initialPlacement: i,
      placement: R,
      strategy: o,
      middlewareData: N,
      rects: j,
      platform: l,
      elements: {
        reference: a,
        floating: t
      }
    });
    I = u != null ? u : I, B = A != null ? A : B, N = {
      ...N,
      [y]: {
        ...N[y],
        ...M
      }
    }, f && x <= 50 && (x++, typeof f == "object" && (f.placement && (R = f.placement), f.rects && (j = f.rects === !0 ? await l.getElementRects({
      reference: a,
      floating: t,
      strategy: o
    }) : f.rects), {
      x: I,
      y: B
    } = Ku(j, R, D)), T = -1);
  }
  return {
    x: I,
    y: B,
    placement: R,
    strategy: o,
    middlewareData: N
  };
};
async function Yf(a, t) {
  var e;
  t === void 0 && (t = {});
  const {
    x: i,
    y: o,
    platform: n,
    rects: l,
    elements: L,
    strategy: D
  } = a, {
    boundary: j = "clippingAncestors",
    rootBoundary: I = "viewport",
    elementContext: B = "floating",
    altBoundary: R = !1,
    padding: N = 0
  } = el(t, a), x = qf(N), y = L[R ? B === "floating" ? "reference" : "floating" : B], S = Vl(await n.getClippingRect({
    element: (e = await (n.isElement == null ? void 0 : n.isElement(y))) == null || e ? y : y.contextElement || await (n.getDocumentElement == null ? void 0 : n.getDocumentElement(L.floating)),
    boundary: j,
    rootBoundary: I,
    strategy: D
  })), u = B === "floating" ? {
    x: i,
    y: o,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, A = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(L.floating)), M = await (n.isElement == null ? void 0 : n.isElement(A)) ? await (n.getScale == null ? void 0 : n.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, f = Vl(n.convertOffsetParentRelativeRectToViewportRelativeRect ? await n.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: L,
    rect: u,
    offsetParent: A,
    strategy: D
  }) : u);
  return {
    top: (S.top - f.top + x.top) / M.y,
    bottom: (f.bottom - S.bottom + x.bottom) / M.y,
    left: (S.left - f.left + x.left) / M.x,
    right: (f.right - S.right + x.right) / M.x
  };
}
const VE = (a) => ({
  name: "arrow",
  options: a,
  async fn(t) {
    const {
      x: e,
      y: i,
      placement: o,
      rects: n,
      platform: l,
      elements: L,
      middlewareData: D
    } = t, {
      element: j,
      padding: I = 0
    } = el(a, t) || {};
    if (j == null)
      return {};
    const B = qf(I), R = {
      x: e,
      y: i
    }, N = fb(o), x = mb(N), T = await l.getDimensions(j), y = N === "y", S = y ? "top" : "left", u = y ? "bottom" : "right", A = y ? "clientHeight" : "clientWidth", M = n.reference[x] + n.reference[N] - R[N] - n.floating[x], f = R[N] - n.reference[N], m = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(j));
    let C = m ? m[A] : 0;
    (!C || !await (l.isElement == null ? void 0 : l.isElement(m))) && (C = L.floating[A] || n.floating[x]);
    const F = M / 2 - f / 2, _ = C / 2 - T[x] / 2 - 1, E = sr(B[S], _), v = sr(B[u], _), w = E, d = C - T[x] - v, r = C / 2 - T[x] / 2 + F, s = xh(w, r, d), p = !D.arrow && tl(o) != null && r !== s && n.reference[x] / 2 - (r < w ? E : v) - T[x] / 2 < 0, b = p ? r < w ? r - w : r - d : 0;
    return {
      [N]: R[N] + b,
      data: {
        [N]: s,
        centerOffset: r - s - b,
        ...p && {
          alignmentOffset: b
        }
      },
      reset: p
    };
  }
}), qE = function(a) {
  return a === void 0 && (a = {}), {
    name: "flip",
    options: a,
    async fn(t) {
      var e, i;
      const {
        placement: o,
        middlewareData: n,
        rects: l,
        initialPlacement: L,
        platform: D,
        elements: j
      } = t, {
        mainAxis: I = !0,
        crossAxis: B = !0,
        fallbackPlacements: R,
        fallbackStrategy: N = "bestFit",
        fallbackAxisSideDirection: x = "none",
        flipAlignment: T = !0,
        ...y
      } = el(a, t);
      if ((e = n.arrow) != null && e.alignmentOffset)
        return {};
      const S = dn(o), u = lr(L), A = dn(L) === L, M = await (D.isRTL == null ? void 0 : D.isRTL(j.floating)), f = R || (A || !T ? [Wl(L)] : $E(L)), m = x !== "none";
      !R && m && f.push(...KE(L, T, x, M));
      const C = [L, ...f], F = await Yf(t, y), _ = [];
      let E = ((i = n.flip) == null ? void 0 : i.overflows) || [];
      if (I && _.push(F[S]), B) {
        const r = UE(o, l, M);
        _.push(F[r[0]], F[r[1]]);
      }
      if (E = [...E, {
        placement: o,
        overflows: _
      }], !_.every((r) => r <= 0)) {
        var v, w;
        const r = (((v = n.flip) == null ? void 0 : v.index) || 0) + 1, s = C[r];
        if (s)
          return {
            data: {
              index: r,
              overflows: E
            },
            reset: {
              placement: s
            }
          };
        let p = (w = E.filter((b) => b.overflows[0] <= 0).sort((b, c) => b.overflows[1] - c.overflows[1])[0]) == null ? void 0 : w.placement;
        if (!p)
          switch (N) {
            case "bestFit": {
              var d;
              const b = (d = E.filter((c) => {
                if (m) {
                  const h = lr(c.placement);
                  return h === u || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  h === "y";
                }
                return !0;
              }).map((c) => [c.placement, c.overflows.filter((h) => h > 0).reduce((h, g) => h + g, 0)]).sort((c, h) => c[1] - h[1])[0]) == null ? void 0 : d[0];
              b && (p = b);
              break;
            }
            case "initialPlacement":
              p = L;
              break;
          }
        if (o !== p)
          return {
            reset: {
              placement: p
            }
          };
      }
      return {};
    }
  };
};
async function YE(a, t) {
  const {
    placement: e,
    platform: i,
    elements: o
  } = a, n = await (i.isRTL == null ? void 0 : i.isRTL(o.floating)), l = dn(e), L = tl(e), D = lr(e) === "y", j = ["left", "top"].includes(l) ? -1 : 1, I = n && D ? -1 : 1, B = el(t, a);
  let {
    mainAxis: R,
    crossAxis: N,
    alignmentAxis: x
  } = typeof B == "number" ? {
    mainAxis: B,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: B.mainAxis || 0,
    crossAxis: B.crossAxis || 0,
    alignmentAxis: B.alignmentAxis
  };
  return L && typeof x == "number" && (N = L === "end" ? x * -1 : x), D ? {
    x: N * I,
    y: R * j
  } : {
    x: R * j,
    y: N * I
  };
}
const XE = function(a) {
  return a === void 0 && (a = 0), {
    name: "offset",
    options: a,
    async fn(t) {
      var e, i;
      const {
        x: o,
        y: n,
        placement: l,
        middlewareData: L
      } = t, D = await YE(t, a);
      return l === ((e = L.offset) == null ? void 0 : e.placement) && (i = L.arrow) != null && i.alignmentOffset ? {} : {
        x: o + D.x,
        y: n + D.y,
        data: {
          ...D,
          placement: l
        }
      };
    }
  };
}, QE = function(a) {
  return a === void 0 && (a = {}), {
    name: "shift",
    options: a,
    async fn(t) {
      const {
        x: e,
        y: i,
        placement: o
      } = t, {
        mainAxis: n = !0,
        crossAxis: l = !1,
        limiter: L = {
          fn: (y) => {
            let {
              x: S,
              y: u
            } = y;
            return {
              x: S,
              y: u
            };
          }
        },
        ...D
      } = el(a, t), j = {
        x: e,
        y: i
      }, I = await Yf(t, D), B = lr(dn(o)), R = Vf(B);
      let N = j[R], x = j[B];
      if (n) {
        const y = R === "y" ? "top" : "left", S = R === "y" ? "bottom" : "right", u = N + I[y], A = N - I[S];
        N = xh(u, N, A);
      }
      if (l) {
        const y = B === "y" ? "top" : "left", S = B === "y" ? "bottom" : "right", u = x + I[y], A = x - I[S];
        x = xh(u, x, A);
      }
      const T = L.fn({
        ...t,
        [R]: N,
        [B]: x
      });
      return {
        ...T,
        data: {
          x: T.x - e,
          y: T.y - i,
          enabled: {
            [R]: n,
            [B]: l
          }
        }
      };
    }
  };
};
function Rc() {
  return typeof window < "u";
}
function Or(a) {
  return Xf(a) ? (a.nodeName || "").toLowerCase() : "#document";
}
function uo(a) {
  var t;
  return (a == null || (t = a.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ci(a) {
  var t;
  return (t = (Xf(a) ? a.ownerDocument : a.document) || window.document) == null ? void 0 : t.documentElement;
}
function Xf(a) {
  return Rc() ? a instanceof Node || a instanceof uo(a).Node : !1;
}
function Uo(a) {
  return Rc() ? a instanceof Element || a instanceof uo(a).Element : !1;
}
function ii(a) {
  return Rc() ? a instanceof HTMLElement || a instanceof uo(a).HTMLElement : !1;
}
function Gu(a) {
  return !Rc() || typeof ShadowRoot > "u" ? !1 : a instanceof ShadowRoot || a instanceof uo(a).ShadowRoot;
}
function ol(a) {
  const {
    overflow: t,
    overflowX: e,
    overflowY: i,
    display: o
  } = $o(a);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + e) && !["inline", "contents"].includes(o);
}
function ZE(a) {
  return ["table", "td", "th"].includes(Or(a));
}
function Nc(a) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return a.matches(t);
    } catch {
      return !1;
    }
  });
}
function vb(a) {
  const t = Ab(), e = Uo(a) ? $o(a) : a;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((i) => e[i] ? e[i] !== "none" : !1) || (e.containerType ? e.containerType !== "normal" : !1) || !t && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !t && (e.filter ? e.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((i) => (e.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (e.contain || "").includes(i));
}
function JE(a) {
  let t = ya(a);
  for (; ii(t) && !cr(t); ) {
    if (vb(t))
      return t;
    if (Nc(t))
      return null;
    t = ya(t);
  }
  return null;
}
function Ab() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function cr(a) {
  return ["html", "body", "#document"].includes(Or(a));
}
function $o(a) {
  return uo(a).getComputedStyle(a);
}
function Fc(a) {
  return Uo(a) ? {
    scrollLeft: a.scrollLeft,
    scrollTop: a.scrollTop
  } : {
    scrollLeft: a.scrollX,
    scrollTop: a.scrollY
  };
}
function ya(a) {
  if (Or(a) === "html")
    return a;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    a.assignedSlot || // DOM Element detected.
    a.parentNode || // ShadowRoot detected.
    Gu(a) && a.host || // Fallback.
    ci(a)
  );
  return Gu(t) ? t.host : t;
}
function Qf(a) {
  const t = ya(a);
  return cr(t) ? a.ownerDocument ? a.ownerDocument.body : a.body : ii(t) && ol(t) ? t : Qf(t);
}
function xs(a, t, e) {
  var i;
  t === void 0 && (t = []), e === void 0 && (e = !0);
  const o = Qf(a), n = o === ((i = a.ownerDocument) == null ? void 0 : i.body), l = uo(o);
  if (n) {
    const L = kh(l);
    return t.concat(l, l.visualViewport || [], ol(o) ? o : [], L && e ? xs(L) : []);
  }
  return t.concat(o, xs(o, [], e));
}
function kh(a) {
  return a.parent && Object.getPrototypeOf(a.parent) ? a.frameElement : null;
}
function Zf(a) {
  const t = $o(a);
  let e = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const o = ii(a), n = o ? a.offsetWidth : e, l = o ? a.offsetHeight : i, L = Gl(e) !== n || Gl(i) !== l;
  return L && (e = n, i = l), {
    width: e,
    height: i,
    $: L
  };
}
function yb(a) {
  return Uo(a) ? a : a.contextElement;
}
function qn(a) {
  const t = yb(a);
  if (!ii(t))
    return Jo(1);
  const e = t.getBoundingClientRect(), {
    width: i,
    height: o,
    $: n
  } = Zf(t);
  let l = (n ? Gl(e.width) : e.width) / i, L = (n ? Gl(e.height) : e.height) / o;
  return (!l || !Number.isFinite(l)) && (l = 1), (!L || !Number.isFinite(L)) && (L = 1), {
    x: l,
    y: L
  };
}
const e2 = /* @__PURE__ */ Jo(0);
function Jf(a) {
  const t = uo(a);
  return !Ab() || !t.visualViewport ? e2 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function t2(a, t, e) {
  return t === void 0 && (t = !1), !e || t && e !== uo(a) ? !1 : t;
}
function hn(a, t, e, i) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  const o = a.getBoundingClientRect(), n = yb(a);
  let l = Jo(1);
  t && (i ? Uo(i) && (l = qn(i)) : l = qn(a));
  const L = t2(n, e, i) ? Jf(n) : Jo(0);
  let D = (o.left + L.x) / l.x, j = (o.top + L.y) / l.y, I = o.width / l.x, B = o.height / l.y;
  if (n) {
    const R = uo(n), N = i && Uo(i) ? uo(i) : i;
    let x = R, T = kh(x);
    for (; T && i && N !== x; ) {
      const y = qn(T), S = T.getBoundingClientRect(), u = $o(T), A = S.left + (T.clientLeft + parseFloat(u.paddingLeft)) * y.x, M = S.top + (T.clientTop + parseFloat(u.paddingTop)) * y.y;
      D *= y.x, j *= y.y, I *= y.x, B *= y.y, D += A, j += M, x = uo(T), T = kh(x);
    }
  }
  return Vl({
    width: I,
    height: B,
    x: D,
    y: j
  });
}
function xb(a, t) {
  const e = Fc(a).scrollLeft;
  return t ? t.left + e : hn(ci(a)).left + e;
}
function ev(a, t, e) {
  e === void 0 && (e = !1);
  const i = a.getBoundingClientRect(), o = i.left + t.scrollLeft - (e ? 0 : (
    // RTL <body> scrollbar.
    xb(a, i)
  )), n = i.top + t.scrollTop;
  return {
    x: o,
    y: n
  };
}
function o2(a) {
  let {
    elements: t,
    rect: e,
    offsetParent: i,
    strategy: o
  } = a;
  const n = o === "fixed", l = ci(i), L = t ? Nc(t.floating) : !1;
  if (i === l || L && n)
    return e;
  let D = {
    scrollLeft: 0,
    scrollTop: 0
  }, j = Jo(1);
  const I = Jo(0), B = ii(i);
  if ((B || !B && !n) && ((Or(i) !== "body" || ol(l)) && (D = Fc(i)), ii(i))) {
    const N = hn(i);
    j = qn(i), I.x = N.x + i.clientLeft, I.y = N.y + i.clientTop;
  }
  const R = l && !B && !n ? ev(l, D, !0) : Jo(0);
  return {
    width: e.width * j.x,
    height: e.height * j.y,
    x: e.x * j.x - D.scrollLeft * j.x + I.x + R.x,
    y: e.y * j.y - D.scrollTop * j.y + I.y + R.y
  };
}
function i2(a) {
  return Array.from(a.getClientRects());
}
function a2(a) {
  const t = ci(a), e = Fc(a), i = a.ownerDocument.body, o = on(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), n = on(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let l = -e.scrollLeft + xb(a);
  const L = -e.scrollTop;
  return $o(i).direction === "rtl" && (l += on(t.clientWidth, i.clientWidth) - o), {
    width: o,
    height: n,
    x: l,
    y: L
  };
}
function n2(a, t) {
  const e = uo(a), i = ci(a), o = e.visualViewport;
  let n = i.clientWidth, l = i.clientHeight, L = 0, D = 0;
  if (o) {
    n = o.width, l = o.height;
    const j = Ab();
    (!j || j && t === "fixed") && (L = o.offsetLeft, D = o.offsetTop);
  }
  return {
    width: n,
    height: l,
    x: L,
    y: D
  };
}
function r2(a, t) {
  const e = hn(a, !0, t === "fixed"), i = e.top + a.clientTop, o = e.left + a.clientLeft, n = ii(a) ? qn(a) : Jo(1), l = a.clientWidth * n.x, L = a.clientHeight * n.y, D = o * n.x, j = i * n.y;
  return {
    width: l,
    height: L,
    x: D,
    y: j
  };
}
function Wu(a, t, e) {
  let i;
  if (t === "viewport")
    i = n2(a, e);
  else if (t === "document")
    i = a2(ci(a));
  else if (Uo(t))
    i = r2(t, e);
  else {
    const o = Jf(a);
    i = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Vl(i);
}
function tv(a, t) {
  const e = ya(a);
  return e === t || !Uo(e) || cr(e) ? !1 : $o(e).position === "fixed" || tv(e, t);
}
function s2(a, t) {
  const e = t.get(a);
  if (e)
    return e;
  let i = xs(a, [], !1).filter((L) => Uo(L) && Or(L) !== "body"), o = null;
  const n = $o(a).position === "fixed";
  let l = n ? ya(a) : a;
  for (; Uo(l) && !cr(l); ) {
    const L = $o(l), D = vb(l);
    !D && L.position === "fixed" && (o = null), (n ? !D && !o : !D && L.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ol(l) && !D && tv(a, l)) ? i = i.filter((I) => I !== l) : o = L, l = ya(l);
  }
  return t.set(a, i), i;
}
function l2(a) {
  let {
    element: t,
    boundary: e,
    rootBoundary: i,
    strategy: o
  } = a;
  const l = [...e === "clippingAncestors" ? Nc(t) ? [] : s2(t, this._c) : [].concat(e), i], L = l[0], D = l.reduce((j, I) => {
    const B = Wu(t, I, o);
    return j.top = on(B.top, j.top), j.right = sr(B.right, j.right), j.bottom = sr(B.bottom, j.bottom), j.left = on(B.left, j.left), j;
  }, Wu(t, L, o));
  return {
    width: D.right - D.left,
    height: D.bottom - D.top,
    x: D.left,
    y: D.top
  };
}
function c2(a) {
  const {
    width: t,
    height: e
  } = Zf(a);
  return {
    width: t,
    height: e
  };
}
function d2(a, t, e) {
  const i = ii(t), o = ci(t), n = e === "fixed", l = hn(a, !0, n, t);
  let L = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const D = Jo(0);
  if (i || !i && !n)
    if ((Or(t) !== "body" || ol(o)) && (L = Fc(t)), i) {
      const R = hn(t, !0, n, t);
      D.x = R.x + t.clientLeft, D.y = R.y + t.clientTop;
    } else o && (D.x = xb(o));
  const j = o && !i && !n ? ev(o, L) : Jo(0), I = l.left + L.scrollLeft - D.x - j.x, B = l.top + L.scrollTop - D.y - j.y;
  return {
    x: I,
    y: B,
    width: l.width,
    height: l.height
  };
}
function jd(a) {
  return $o(a).position === "static";
}
function Vu(a, t) {
  if (!ii(a) || $o(a).position === "fixed")
    return null;
  if (t)
    return t(a);
  let e = a.offsetParent;
  return ci(a) === e && (e = e.ownerDocument.body), e;
}
function ov(a, t) {
  const e = uo(a);
  if (Nc(a))
    return e;
  if (!ii(a)) {
    let o = ya(a);
    for (; o && !cr(o); ) {
      if (Uo(o) && !jd(o))
        return o;
      o = ya(o);
    }
    return e;
  }
  let i = Vu(a, t);
  for (; i && ZE(i) && jd(i); )
    i = Vu(i, t);
  return i && cr(i) && jd(i) && !vb(i) ? e : i || JE(a) || e;
}
const h2 = async function(a) {
  const t = this.getOffsetParent || ov, e = this.getDimensions, i = await e(a.floating);
  return {
    reference: d2(a.reference, await t(a.floating), a.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function b2(a) {
  return $o(a).direction === "rtl";
}
const p2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: o2,
  getDocumentElement: ci,
  getClippingRect: l2,
  getOffsetParent: ov,
  getElementRects: h2,
  getClientRects: i2,
  getDimensions: c2,
  getScale: qn,
  isElement: Uo,
  isRTL: b2
};
function iv(a, t) {
  return a.x === t.x && a.y === t.y && a.width === t.width && a.height === t.height;
}
function u2(a, t) {
  let e = null, i;
  const o = ci(a);
  function n() {
    var L;
    clearTimeout(i), (L = e) == null || L.disconnect(), e = null;
  }
  function l(L, D) {
    L === void 0 && (L = !1), D === void 0 && (D = 1), n();
    const j = a.getBoundingClientRect(), {
      left: I,
      top: B,
      width: R,
      height: N
    } = j;
    if (L || t(), !R || !N)
      return;
    const x = xl(B), T = xl(o.clientWidth - (I + R)), y = xl(o.clientHeight - (B + N)), S = xl(I), A = {
      rootMargin: -x + "px " + -T + "px " + -y + "px " + -S + "px",
      threshold: on(0, sr(1, D)) || 1
    };
    let M = !0;
    function f(m) {
      const C = m[0].intersectionRatio;
      if (C !== D) {
        if (!M)
          return l();
        C ? l(!1, C) : i = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !iv(j, a.getBoundingClientRect()) && l(), M = !1;
    }
    try {
      e = new IntersectionObserver(f, {
        ...A,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(f, A);
    }
    e.observe(a);
  }
  return l(!0), n;
}
function g2(a, t, e, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: n = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: L = typeof IntersectionObserver == "function",
    animationFrame: D = !1
  } = i, j = yb(a), I = o || n ? [...j ? xs(j) : [], ...xs(t)] : [];
  I.forEach((S) => {
    o && S.addEventListener("scroll", e, {
      passive: !0
    }), n && S.addEventListener("resize", e);
  });
  const B = j && L ? u2(j, e) : null;
  let R = -1, N = null;
  l && (N = new ResizeObserver((S) => {
    let [u] = S;
    u && u.target === j && N && (N.unobserve(t), cancelAnimationFrame(R), R = requestAnimationFrame(() => {
      var A;
      (A = N) == null || A.observe(t);
    })), e();
  }), j && !D && N.observe(j), N.observe(t));
  let x, T = D ? hn(a) : null;
  D && y();
  function y() {
    const S = hn(a);
    T && !iv(T, S) && e(), T = S, x = requestAnimationFrame(y);
  }
  return e(), () => {
    var S;
    I.forEach((u) => {
      o && u.removeEventListener("scroll", e), n && u.removeEventListener("resize", e);
    }), B == null || B(), (S = N) == null || S.disconnect(), N = null, D && cancelAnimationFrame(x);
  };
}
const m2 = XE, f2 = QE, v2 = qE, A2 = VE, y2 = (a, t, e) => {
  const i = /* @__PURE__ */ new Map(), o = {
    platform: p2,
    ...e
  }, n = {
    ...o.platform,
    _c: i
  };
  return WE(a, t, {
    ...o,
    platform: n
  });
};
var jc = class extends Event {
  constructor(t, { oldState: e = "", newState: i = "", ...o } = {}) {
    super(t, o);
    id(this, "oldState");
    id(this, "newState");
    this.oldState = String(e || ""), this.newState = String(i || "");
  }
}, qu = /* @__PURE__ */ new WeakMap();
function av(a, t, e) {
  qu.set(
    a,
    setTimeout(() => {
      qu.has(a) && a.dispatchEvent(
        new jc("toggle", {
          cancelable: !1,
          oldState: t,
          newState: e
        })
      );
    }, 0)
  );
}
var wb = globalThis.ShadowRoot || function() {
}, x2 = globalThis.HTMLDialogElement || function() {
}, Pl = /* @__PURE__ */ new WeakMap(), Pi = /* @__PURE__ */ new WeakMap(), il = /* @__PURE__ */ new WeakMap();
function ql(a) {
  return il.get(a) || "hidden";
}
var Yl = /* @__PURE__ */ new WeakMap();
function w2(a) {
  const t = a.popoverTargetElement;
  if (!(t instanceof HTMLElement))
    return;
  const e = ql(t);
  a.popoverTargetAction === "show" && e === "showing" || a.popoverTargetAction === "hide" && e === "hidden" || (e === "showing" ? ws(t, !0, !0) : an(t, !1) && (Yl.set(t, a), Ch(t)));
}
function an(a, t) {
  return !(a.popover !== "auto" && a.popover !== "manual" || !a.isConnected || t && ql(a) !== "showing" || !t && ql(a) !== "hidden" || a instanceof x2 && a.hasAttribute("open") || document.fullscreenElement === a);
}
function Yu(a) {
  return a ? Array.from(Pi.get(a.ownerDocument) || []).indexOf(
    a
  ) + 1 : 0;
}
function k2(a) {
  const t = nv(a), e = C2(a);
  return Yu(t) > Yu(e) ? t : e;
}
function Xl(a) {
  const t = Pi.get(a);
  for (const e of t || [])
    if (!e.isConnected)
      t.delete(e);
    else
      return e;
  return null;
}
function dr(a) {
  return typeof a.getRootNode == "function" ? a.getRootNode() : a.parentNode ? dr(a.parentNode) : a;
}
function nv(a) {
  for (; a; ) {
    if (a instanceof HTMLElement && a.popover === "auto" && il.get(a) === "showing")
      return a;
    if (a = a instanceof Element && a.assignedSlot || a.parentElement || dr(a), a instanceof wb && (a = a.host), a instanceof Document) return;
  }
}
function C2(a) {
  for (; a; ) {
    const t = a.popoverTargetElement;
    if (t instanceof HTMLElement) return t;
    if (a = a.parentElement || dr(a), a instanceof wb && (a = a.host), a instanceof Document) return;
  }
}
function S2(a) {
  const t = /* @__PURE__ */ new Map();
  let e = 0;
  for (const n of Pi.get(a.ownerDocument) || [])
    t.set(n, e), e += 1;
  t.set(a, e), e += 1;
  let i = null;
  function o(n) {
    const l = nv(n);
    if (l === null) return null;
    const L = t.get(l);
    (i === null || t.get(i) < L) && (i = l);
  }
  return o(a.parentElement || dr(a)), i;
}
function E2(a) {
  return a.hidden || a instanceof wb || (a instanceof HTMLButtonElement || a instanceof HTMLInputElement || a instanceof HTMLSelectElement || a instanceof HTMLTextAreaElement || a instanceof HTMLOptGroupElement || a instanceof HTMLOptionElement || a instanceof HTMLFieldSetElement) && a.disabled || a instanceof HTMLInputElement && a.type === "hidden" || a instanceof HTMLAnchorElement && a.href === "" ? !1 : typeof a.tabIndex == "number" && a.tabIndex !== -1;
}
function M2(a) {
  if (a.shadowRoot && a.shadowRoot.delegatesFocus !== !0)
    return null;
  let t = a;
  t.shadowRoot && (t = t.shadowRoot);
  let e = t.querySelector("[autofocus]");
  if (e)
    return e;
  {
    const n = t.querySelectorAll("slot");
    for (const l of n) {
      const L = l.assignedElements({ flatten: !0 });
      for (const D of L) {
        if (D.hasAttribute("autofocus"))
          return D;
        if (e = D.querySelector("[autofocus]"), e)
          return e;
      }
    }
  }
  const i = a.ownerDocument.createTreeWalker(
    t,
    NodeFilter.SHOW_ELEMENT
  );
  let o = i.currentNode;
  for (; o; ) {
    if (E2(o))
      return o;
    o = i.nextNode();
  }
}
function T2(a) {
  var t;
  (t = M2(a)) == null || t.focus();
}
var Ql = /* @__PURE__ */ new WeakMap();
function Ch(a) {
  if (!an(a, !1))
    return;
  const t = a.ownerDocument;
  if (!a.dispatchEvent(
    new jc("beforetoggle", {
      cancelable: !0,
      oldState: "closed",
      newState: "open"
    })
  ) || !an(a, !1))
    return;
  let e = !1;
  if (a.popover === "auto") {
    const o = a.getAttribute("popover"), n = S2(a) || t;
    if (_c(n, !1, !0), o !== a.getAttribute("popover") || !an(a, !1))
      return;
  }
  Xl(t) || (e = !0), Ql.delete(a);
  const i = t.activeElement;
  a.classList.add(":popover-open"), il.set(a, "showing"), Pl.has(t) || Pl.set(t, /* @__PURE__ */ new Set()), Pl.get(t).add(a), T2(a), a.popover === "auto" && (Pi.has(t) || Pi.set(t, /* @__PURE__ */ new Set()), Pi.get(t).add(a), rv(Yl.get(a), !0)), e && i && a.popover === "auto" && Ql.set(a, i), av(a, "closed", "open");
}
function ws(a, t = !1, e = !1) {
  var n, l;
  if (!an(a, !0))
    return;
  const i = a.ownerDocument;
  if (a.popover === "auto" && (_c(a, t, e), !an(a, !0)) || (rv(Yl.get(a), !1), Yl.delete(a), e && (a.dispatchEvent(
    new jc("beforetoggle", {
      oldState: "open",
      newState: "closed"
    })
  ), !an(a, !0))))
    return;
  (n = Pl.get(i)) == null || n.delete(a), (l = Pi.get(i)) == null || l.delete(a), a.classList.remove(":popover-open"), il.set(a, "hidden"), e && av(a, "open", "closed");
  const o = Ql.get(a);
  o && (Ql.delete(a), t && o.focus());
}
function Xu(a, t = !1, e = !1) {
  let i = Xl(a);
  for (; i; )
    ws(i, t, e), i = Xl(a);
}
function _c(a, t, e) {
  var l;
  const i = a.ownerDocument || a;
  if (a instanceof Document)
    return Xu(i, t, e);
  let o = null, n = !1;
  for (const L of Pi.get(i) || [])
    if (L === a)
      n = !0;
    else if (n) {
      o = L;
      break;
    }
  if (!n)
    return Xu(i, t, e);
  for (; o && ql(o) === "showing" && ((l = Pi.get(i)) != null && l.size); )
    ws(o, t, e);
}
var _d = /* @__PURE__ */ new WeakMap();
function Qu(a) {
  if (!a.isTrusted) return;
  const t = a.composedPath()[0];
  if (!t) return;
  const e = t.ownerDocument;
  if (!Xl(e)) return;
  const o = k2(t);
  if (o && a.type === "pointerdown")
    _d.set(e, o);
  else if (a.type === "pointerup") {
    const n = _d.get(e) === o;
    _d.delete(e), n && _c(o || e, !1, !0);
  }
}
var Ud = /* @__PURE__ */ new WeakMap();
function rv(a, t = !1) {
  if (!a) return;
  Ud.has(a) || Ud.set(a, a.getAttribute("aria-expanded"));
  const e = a.popoverTargetElement;
  if (e instanceof HTMLElement && e.popover === "auto")
    a.setAttribute("aria-expanded", String(t));
  else {
    const i = Ud.get(a);
    i ? a.setAttribute("aria-expanded", i) : a.removeAttribute("aria-expanded");
  }
}
var Zu = globalThis.ShadowRoot || function() {
};
function L2() {
  return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
}
function za(a, t, e) {
  const i = a[t];
  Object.defineProperty(a, t, {
    value(o) {
      return i.call(this, e(o));
    }
  });
}
var O2 = /(^|[^\\]):popover-open\b/g;
function P2() {
  return typeof globalThis.CSSLayerBlockRule == "function";
}
function D2() {
  const a = P2();
  return `
${a ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${a ? "}" : ""}
`;
}
var Rn = null;
function $d(a) {
  const t = D2();
  if (Rn === null)
    try {
      Rn = new CSSStyleSheet(), Rn.replaceSync(t);
    } catch {
      Rn = !1;
    }
  if (Rn === !1) {
    const e = document.createElement("style");
    e.textContent = t, a instanceof Document ? a.head.prepend(e) : a.prepend(e);
  } else
    a.adoptedStyleSheets = [Rn, ...a.adoptedStyleSheets];
}
function z2() {
  if (typeof window > "u") return;
  window.ToggleEvent = window.ToggleEvent || jc;
  function a(D) {
    return D != null && D.includes(":popover-open") && (D = D.replace(
      O2,
      "$1.\\:popover-open"
    )), D;
  }
  za(Document.prototype, "querySelector", a), za(Document.prototype, "querySelectorAll", a), za(Element.prototype, "querySelector", a), za(Element.prototype, "querySelectorAll", a), za(Element.prototype, "matches", a), za(Element.prototype, "closest", a), za(
    DocumentFragment.prototype,
    "querySelectorAll",
    a
  ), Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: !0,
      configurable: !0,
      get() {
        if (!this.hasAttribute("popover")) return null;
        const D = (this.getAttribute("popover") || "").toLowerCase();
        return D === "" || D == "auto" ? "auto" : "manual";
      },
      set(D) {
        D === null ? this.removeAttribute("popover") : this.setAttribute("popover", D);
      }
    },
    showPopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        Ch(this);
      }
    },
    hidePopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        ws(this, !0, !0);
      }
    },
    togglePopover: {
      enumerable: !0,
      configurable: !0,
      value(D) {
        il.get(this) === "showing" && D === void 0 || D === !1 ? ws(this, !0, !0) : (D === void 0 || D === !0) && Ch(this);
      }
    }
  });
  const t = Element.prototype.attachShadow;
  t && Object.defineProperties(Element.prototype, {
    attachShadow: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value(D) {
        const j = t.call(this, D);
        return $d(j), j;
      }
    }
  });
  const e = HTMLElement.prototype.attachInternals;
  e && Object.defineProperties(HTMLElement.prototype, {
    attachInternals: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value() {
        const D = e.call(this);
        return D.shadowRoot && $d(D.shadowRoot), D;
      }
    }
  });
  const i = /* @__PURE__ */ new WeakMap();
  function o(D) {
    Object.defineProperties(D.prototype, {
      popoverTargetElement: {
        enumerable: !0,
        configurable: !0,
        set(j) {
          if (j === null)
            this.removeAttribute("popovertarget"), i.delete(this);
          else if (j instanceof Element)
            this.setAttribute("popovertarget", ""), i.set(this, j);
          else
            throw new TypeError(
              "popoverTargetElement must be an element or null"
            );
        },
        get() {
          if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit")
            return null;
          const j = i.get(this);
          if (j && j.isConnected)
            return j;
          if (j && !j.isConnected)
            return i.delete(this), null;
          const I = dr(this), B = this.getAttribute("popovertarget");
          return (I instanceof Document || I instanceof Zu) && B && I.getElementById(B) || null;
        }
      },
      popoverTargetAction: {
        enumerable: !0,
        configurable: !0,
        get() {
          const j = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          return j === "show" || j === "hide" ? j : "toggle";
        },
        set(j) {
          this.setAttribute("popovertargetaction", j);
        }
      }
    });
  }
  o(HTMLButtonElement), o(HTMLInputElement);
  const n = (D) => {
    const j = D.composedPath(), I = j[0];
    if (!(I instanceof Element) || I != null && I.shadowRoot)
      return;
    const B = dr(I);
    if (!(B instanceof Zu || B instanceof Document))
      return;
    const R = j.find(
      (N) => {
        var x;
        return (x = N.matches) == null ? void 0 : x.call(N, "[popovertargetaction],[popovertarget]");
      }
    );
    if (R) {
      w2(R), D.preventDefault();
      return;
    }
  }, l = (D) => {
    const j = D.key, I = D.target;
    !D.defaultPrevented && I && (j === "Escape" || j === "Esc") && _c(I.ownerDocument, !0, !0);
  };
  ((D) => {
    D.addEventListener("click", n), D.addEventListener("keydown", l), D.addEventListener("pointerdown", Qu), D.addEventListener("pointerup", Qu);
  })(document), $d(document);
}
const I2 = ve`:host{background-color:var(--beacon-system-color-background-1);border:0;border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);display:revert;inset:unset;margin:unset;overflow:unset;padding:var(--beacon-system-space-cell-contained);position:absolute}.arrow{position:absolute}`;
var B2 = Object.defineProperty, R2 = Object.getOwnPropertyDescriptor, sv = (a) => {
  throw TypeError(a);
}, vo = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? R2(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && B2(t, e, o), o;
}, lv = (a, t, e) => t.has(a) || sv("Cannot " + e), Hd = (a, t, e) => (lv(a, t, "read from private field"), e ? e.call(a) : t.get(a)), Ju = (a, t, e) => t.has(a) ? sv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), Kd = (a, t, e, i) => (lv(a, t, "write to private field"), t.set(a, e), e);
function cv(a) {
  var t, e;
  let i = class extends a {
    constructor() {
      super(...arguments), Ju(this, t), this.popover = "manual", this.placement = "top", this.fallbackPlacements = void 0, this.arrowPadding = void 0, this.popupTimeout = null, Ju(this, e, !1), this.show = (o) => {
        this.showCallback(o);
      }, this.showCallback = (o) => {
        this.open = !0, this.handleInteractionEvent(o), this.start();
      }, this.hide = (o) => {
        this.hideCallback(o);
      }, this.hideCallback = (o) => {
        this.open = !1, this.handleInteractionEvent(o), this.stop();
      }, this.toggle = (o) => {
        this.popupTimeout && (clearTimeout(this.popupTimeout), this.popupTimeout = null), this.open ? this.hide(o) : this.show(o), this.handleInteractionEvent(o);
      }, this.closeOnEscape = (o) => {
        o.key === "Escape" && this.open && this.hide(o);
      };
    }
    static get popupStyles() {
      return [I2];
    }
    get open() {
      return Hd(this, e);
    }
    set open(o) {
      Kd(this, e, o), this.open ? this.showPopover() : this.hidePopover();
    }
    // The use of the event for setting the active trigger is why popups differ from modal in that you need to call show, hide, or toggle directly over the open prop
    handleInteractionEvent(o) {
      if (o) {
        const { target: n } = o;
        n instanceof HTMLElement && (this._activeTrigger = n);
      }
    }
    start() {
      this._activeTrigger && (Kd(this, t, g2(
        this._activeTrigger,
        this,
        () => this.position()
      )), this.runOnStart());
    }
    stop() {
      Hd(this, t) && (Hd(this, t).call(this), Kd(this, t, null)), this.runOnStop();
    }
    /** @abstract */
    runOnStart() {
    }
    /** @abstract */
    runOnStop() {
    }
    getOffset(o) {
      return o.offsetHeight / 2;
    }
    getStaticSideArrowOffset(o, n) {
      return `-${o.offsetWidth}px`;
    }
    /**
     * @link https://codesandbox.io/s/mystifying-kare-ee3hmh?file=/src/index.js - examples of arrow positioning
     */
    position() {
      const o = this.arrow;
      y2(this._activeTrigger, this, {
        placement: this.placement,
        middleware: [
          m2(this.getOffset(o)),
          // fallback to the starting position of each axis first when flipping
          v2({
            fallbackAxisSideDirection: "start",
            fallbackPlacements: this.fallbackPlacements
          }),
          // specifying a padding will allow it to move with your screen the specified distance before it flips
          f2({ padding: 8 }),
          // Optional Arrow Padding override for the menu-popover to align with internal padding;
          A2({
            element: o,
            padding: this.arrowPadding ? parseInt(this.arrowPadding) : void 0
          })
        ]
      }).then(
        ({ x: n, y: l, middlewareData: L, placement: D }) => {
          Object.assign(this.style, {
            top: l + "px",
            left: n + "px"
          });
          const j = D.split("-")[0], I = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[j];
          if (L.arrow) {
            const { x: B, y: R } = L.arrow;
            Object.assign(o.style, {
              left: B != null ? `${B}px` : "",
              top: R != null ? `${R}px` : "",
              [I]: this.getStaticSideArrowOffset(o, I)
            }), o == null || o.setAttribute("data-side", j);
          }
        }
      );
    }
    _renderArrowHTML() {
      return pe`<div class="arrow"></div>`;
    }
    /** We need an ID to associate the popup as the describing element for triggers that aren't Beacon buttons. */
    assignAutoID() {
      this.id || (this.id = _i());
    }
    applyPopoverPolyfill() {
      L2() || z2();
    }
    handleEscapeToHide() {
      window.addEventListener("keydown", this.closeOnEscape);
    }
    removeEscapeToHide() {
      window.removeEventListener("keydown", this.closeOnEscape);
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap(), vo([
    ue({ reflect: !0 })
  ], i.prototype, "popover", 2), vo([
    ue()
  ], i.prototype, "placement", 2), vo([
    Ce()
  ], i.prototype, "fallbackPlacements", 2), vo([
    Ce()
  ], i.prototype, "arrowPadding", 2), vo([
    ue({ type: Boolean, reflect: !0 })
  ], i.prototype, "open", 1), vo([
    Ce()
  ], i.prototype, "_activeTrigger", 2), vo([
    We(".arrow")
  ], i.prototype, "arrow", 2), vo([
    qe
  ], i.prototype, "assignAutoID", 1), vo([
    qe
  ], i.prototype, "applyPopoverPolyfill", 1), vo([
    Re
  ], i.prototype, "handleEscapeToHide", 1), vo([
    Pt
  ], i.prototype, "removeEscapeToHide", 1), i = vo([
    $e("Popup")
  ], i), i;
}
function N2(a, t = "keys") {
  if (!a) return;
  let e;
  switch (t) {
    case "entries":
      e = a.entries().next().value;
      break;
    case "values":
      e = a.values().next().value;
      break;
    case "keys":
    default:
      e = a.keys().next().value;
  }
  return e;
}
const F2 = ve`[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6,p,ul,ol,blockquote){max-inline-size:85cqi}[beacon-tag-name=beacon-popover] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200);margin:0}[beacon-tag-name=beacon-popover]>:is(*):not([beacon-tag-name=beacon-menu]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);margin:0;padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-popover] :is([slot=action-zone]){padding:0}[beacon-tag-name=beacon-popover]:not(:has([slot=action-zone])){--bottom-padding: var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-popover] .media{inline-size:100%;max-block-size:20cqb;object-fit:cover;padding:var(--beacon-system-space-cell-contained)}`, j2 = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--popover-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--popover-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var _2 = Object.getOwnPropertyDescriptor, U2 = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? _2(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function $2(a) {
  let t = class extends a {
    static get PopoverMotionStyles() {
      return [j2];
    }
  };
  return t = U2([
    $e("PopoverMotion")
  ], t), t;
}
const H2 = ve`:host{container-type:inline-size;inline-size:100%;max-inline-size:var(--popover-max-inline-size, 17rem);min-inline-size:var(--popover-min-inline-size, 14rem);padding:initial;filter:drop-shadow(0rem 0rem var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));--bottom-padding: 0}.popover{display:grid;grid-template-rows:1fr auto;max-block-size:400px}.header{inset-block-start:var(--beacon-reference-space-3);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.body{overflow-y:auto;padding-inline:var(--beacon-system-space-micro-jumbo);padding-block-start:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--bottom-padding);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable;scrollbar-width:thin}.footer{padding-block-end:var(--beacon-system-space-micro-jumbo);margin-block-start:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-micro-jumbo)}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end;padding:var(--beacon-system-space-cell-contained)}.arrow{background-color:initial;display:flex;block-size:var(--beacon-reference-space-4);inline-size:var(--beacon-reference-space-8);--arrow-inline-size: var(--beacon-reference-space-8);--arrow-block-size: var(--beacon-reference-space-4);--mask-block-size: 8px;--drop-shadow-filter-radius: var(--beacon-reference-space-1);--mask-inline-size: calc(var(--arrow-inline-size) + calc(4 * var(--drop-shadow-filter-radius)))}.arrow[data-side=left]{transform:rotate(90deg)}.arrow[data-side=right]{transform:rotate(-90deg)}.arrow[data-side=top]{transform:rotate(180deg)}.arrow .arrow-vector{background-color:initial;position:absolute;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);bottom:-1px}@media (width >= 640px){:host{--popover-max-inline-size: 17.5rem;--popover-min-inline-size: 11.38rem}}@media (width >= 960px){:host{--popover-max-inline-size: 21.19rem;--popover-min-inline-size: 12.12rem}}@media (width >= 1280px){:host{--popover-max-inline-size: 29.56rem;--popover-min-inline-size: 17.06rem}}`;
var K2 = Object.defineProperty, G2 = Object.getOwnPropertyDescriptor, Hi = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? G2(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && K2(t, e, o), o;
};
class W2 extends Ge(Le).with(
  PE,
  TE,
  ub
) {
}
const sc = class sc extends Ge(W2).with(
  $2,
  Wf,
  cv,
  gb
) {
  constructor() {
    super(...arguments), this.beaconTagName = Ol.beaconTagName, this.hasCloseButton = !0, this.handleKeydown = (t) => {
      t.isTrusted && this.slottedMenu && this.handleArrowControlKeydown(
        t,
        this.getArrowControlElements(),
        "vertical",
        (e) => {
          e == null || e.focus();
        }
      );
    }, this.show = (t) => {
      this.attachPopoverPageListener(), !this.prefersReducedMotion && this.motionState === ys.ENABLED ? (this.closing = !1, this.showCallback(t)) : this.showCallback(t);
    }, this.handleCloseOnClickOut = (t) => {
      var i, o;
      const { isTrusted: e } = t;
      this.triggerElement && e && !((i = t == null ? void 0 : t.composedPath()) != null && i.includes(this)) && !((o = t == null ? void 0 : t.composedPath()) != null && o.includes(this.triggerElement)) && this.open && this.hide();
    }, this.hide = (t) => {
      !this.prefersReducedMotion && this.motionState === ys.ENABLED ? this.closing = !0 : this.hideCallback(t);
    }, this.onFocusOut = (t) => {
      var i;
      const { relatedTarget: e } = t;
      this.open && !this.contains(e) && !((i = this.shadowRoot) != null && i.contains(e)) && (this.popupTimeout = setTimeout(() => {
        this.hide();
      }, 200));
    }, this.closeOnEscape = (t) => {
      var e;
      t.key === "Escape" && this.open && (this.hide(t), (e = this.triggerElement) == null || e.focus({
        override: !0
      }));
    }, this.onCloseButtonKeyPress = (t) => {
      var e;
      (t.key === "Enter" || t.code === "Space") && !this.closing && ((e = this.triggerElement) == null || e.focus({
        override: !0
      }));
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, this.PopoverMotionStyles, H2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, F2];
  }
  getArrowControlElements() {
    return [this.closeButton, ...this.internalFocusableElements()];
  }
  attachArrowControlKeyboardListeners() {
    this.slottedMenu && this.getArrowControlElements().forEach((t) => {
      t.addEventListener(et.KEYDOWN, this.handleKeydown);
    });
  }
  runOpensBySetup() {
    this.opensByElements.forEach((t, e) => {
      e instanceof Ha && e.addEventListener("beacon-event-click", this.toggle), e instanceof Ha || e.addEventListener("click", this.toggle);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((t, e) => {
      (e instanceof HTMLButtonElement || e instanceof HTMLInputElement) && e.removeEventListener("click", this.toggle), e instanceof Ha && e.removeEventListener("beacon-event-click", this.toggle);
    });
  }
  _renderArrowHTML() {
    return pe`<div class="arrow">
      <svg
        aria-hidden="true"
        width="24"
        height="12"
        viewBox="0 0 24 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M24 12L12 0L0 12H24Z" />
      </svg>
    </div>`;
  }
  getOffset(t) {
    return t.offsetHeight;
  }
  getStaticSideArrowOffset(t, e) {
    return `-${e === "bottom" || e === "top" ? t.offsetHeight : t.offsetHeight + 8}px`;
  }
  setAriaExpanded() {
    var t;
    this._activeTrigger instanceof Ha ? this._activeTrigger.updateComplete.then(() => {
      var e;
      (e = this._activeTrigger.button) == null || e.setAttribute(
        "aria-expanded",
        String(this.open)
      );
    }) : (t = this._activeTrigger) == null || t.setAttribute("aria-expanded", String(this.open));
  }
  focusOnTrigger() {
    var t;
    (t = this._activeTrigger) == null || t.focus({ override: !0 });
  }
  focusOnCloseButton() {
    setTimeout(() => {
      var t;
      (t = this.closeButton) == null || t.focus({ override: !0 });
    }, 0);
  }
  initializeExternalFocusableElements() {
    this.triggerElement = this._activeTrigger;
  }
  initializeInternalFocusableElements() {
    var e, i;
    const t = this.internalFocusableElements();
    this.lastFocusableElement = (e = t[t.length - 1]) != null ? e : this.closeButton, this.firstFocusableElement = (i = this.closeButton) != null ? i : t[0];
  }
  runOnStart() {
    this.setAriaExpanded(), this.initializeInternalFocusableElements(), this.initializeExternalFocusableElements(), this.attachFocusableElementListeners(), this.overrideFocusableElements(), this.focusOnCloseButton(), this.findNextFocusableElement();
  }
  getShadowRootHost(t) {
    const e = t.getRootNode();
    return e instanceof ShadowRoot ? e.host : null;
  }
  isInShadowDOM(t) {
    return t.getRootNode() instanceof ShadowRoot;
  }
  /**
   * Tabbable will find all the elements from host and which can be nested through shadowDOM
   * This method is to filter out those elements and find the next focusable element
   */
  findNextFocusableElement() {
    var n;
    const i = $f(
      (n = this.getShadowRootHost(this.triggerElement)) != null ? n : document.body,
      {
        getShadowRoot: !0,
        includeContainer: !0
      }
    ).filter((l) => {
      const L = this.getShadowRootHost(l);
      let D;
      return L && (D = this.getShadowRootHost(L)), !this.contains(L) && !this.contains(l) && D !== this;
    }).map((l) => this.getShadowRootHost(l) === this.triggerElement ? this.triggerElement : l), o = i.indexOf(this.triggerElement);
    o + 1 < i.length && (this.nextFocusableElement = i[o + 1]);
  }
  runOnStop() {
    this.setAriaExpanded(), this.removeFocusableElementListeners();
  }
  setAriaHasPopup() {
    var t, e;
    (t = this.slottedMenu) != null && t.length && ((e = this._activeTrigger) == null || e.setAttribute("aria-haspopup", "menu"));
  }
  attachPopoverPageListener() {
    document.addEventListener("click", this.handleCloseOnClickOut);
  }
  removePopoverPageListener() {
    document.removeEventListener("click", this.handleCloseOnClickOut);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  renderCloseButton() {
    return ze`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @beacon-event-click=${this.hide}
      @keypress=${this.onCloseButtonKeyPress}>
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  overrideFocusableElements() {
    this.overrideFocus([
      this.closeButton,
      ...this.internalFocusableElements(),
      this.triggerElement
    ]);
  }
  openByDefault() {
    this._activeTrigger = N2(this.opensByElements), this.open && (this.show(), this.focusOnTrigger());
  }
  applyDatatMetricsLocation() {
    this.setAttribute(
      "data-metrics-location",
      Ol.DATA_METRICS_LOCATION_POPOVER
    );
  }
  async updateCloseButtonState() {
    var t;
    await this.updateComplete, (t = this.slottedMenu) != null && t.length && (this.hasCloseButton = !1);
  }
  render() {
    return pe`
      <div class="popover" @focusout=${this.onFocusOut}>
        <div class="header">
          ${this.hasCloseButton ? this.renderCloseButton() : je}
        </div>
        <div class="body" tabindex=${Ja()}>
          <slot ${_e({ useParent: !0 })}></slot>
        </div>
        <div class="footer">
          <div class="action-zone">
            <slot
              name="action-zone"
              ${_e({ container: ".footer" })}></slot>
          </div>
        </div>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
};
sc.nestedComponents = [Qt], sc.tagName = Ol.beaconTagName;
let Co = sc;
Hi([
  ot(".close-button")
], Co.prototype, "closeButton", 2);
Hi([
  Ce()
], Co.prototype, "hasCloseButton", 2);
Hi([
  De({
    slot: "",
    selector: '[beacon-tag-name="beacon-menu"]'
  })
], Co.prototype, "slottedMenu", 2);
Hi([
  Re
], Co.prototype, "attachArrowControlKeyboardListeners", 1);
Hi([
  Re
], Co.prototype, "setAriaHasPopup", 1);
Hi([
  Pt
], Co.prototype, "removePopoverPageListener", 1);
Hi([
  Re
], Co.prototype, "openByDefault", 1);
Hi([
  qe
], Co.prototype, "applyDatatMetricsLocation", 1);
Hi([
  Re
], Co.prototype, "updateCloseButtonState", 1);
const eg = {
  beaconTagName: "beacon-breadcrumbs"
}, V2 = ve`[beacon-tag-name=beacon-breadcrumbs]{--background-color: var(--beacon-system-color-background-0);background-color:var(--background-color);padding-block:var(--beacon-system-space-cell-free-floating);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-popover]{inline-size:auto}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu]{padding:0}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu [beacon-tag-name=beacon-icon]{display:none;flex-shrink:0}[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu li,[beacon-tag-name=beacon-breadcrumbs] [beacon-tag-name=beacon-menu] ol.beacon-breadcrumbs__popover-menu li>*{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}@media (width >= 640px){[beacon-tag-name=beacon-breadcrumbs] ol>li:nth-child(1)>[beacon-tag-name=beacon-icon]{display:none}}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger{background:none;border-style:none;display:flex;margin:0;padding:0;position:relative;white-space:nowrap}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger:before{block-size:var(--beacon-reference-space-7);content:"";inline-size:var(--beacon-reference-space-7);inset-block-start:calc(-3 * var(--beacon-reference-space-1));inset-inline-start:calc(-1 * var(--beacon-reference-space-1));position:absolute}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger span.ellipses-wrapper{align-items:center;align-self:center;block-size:var(--beacon-reference-space-4);display:flex;justify-content:center;padding-inline:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger:hover span{background-color:var(--beacon-system-color-background-secondary-hover)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger [beacon-tag-name=beacon-icon]{color:var(--beacon-system-color-icon-link)}[beacon-tag-name=beacon-breadcrumbs] .beacon-breadcrumbs__popover-trigger [beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-breadcrumbs]>ol{column-gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-breadcrumbs]>ol>li{align-items:center;display:flex;flex-shrink:0;gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child{overflow-x:hidden;text-overflow:ellipsis;flex-shrink:1;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child>a,[beacon-tag-name=beacon-breadcrumbs]>ol>li:last-child>span{overflow-x:hidden;text-overflow:ellipsis}[beacon-tag-name=beacon-breadcrumbs]>ol li>[beacon-tag-name=beacon-icon]{flex-shrink:0;stroke:var(--beacon-system-color-icon-standard)}[beacon-tag-name=beacon-breadcrumbs]>ol li>[beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-4)}@media (width < 640px){[beacon-tag-name=beacon-breadcrumbs]>ol>li:nth-last-child(2){overflow-x:hidden;text-overflow:ellipsis;flex-shrink:1}[beacon-tag-name=beacon-breadcrumbs]>ol>li:nth-last-child(2)>a{overflow-x:hidden;text-overflow:ellipsis}[beacon-tag-name=beacon-breadcrumbs]>ol>li:not(:nth-last-child(2)){display:none}[beacon-tag-name=beacon-breadcrumbs]>ol>li>[beacon-tag-name=beacon-icon]{transform:rotate(180deg)}}[beacon-tag-name=beacon-breadcrumbs]>ol:has(.beacon-breadcrumbs__popover-container)>li:not(:first-child,:last-child,:nth-child(2),:nth-last-child(2)){display:none}[beacon-tag-name=beacon-breadcrumbs] li:not(:last-child) a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-breadcrumbs] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-breadcrumbs] [aria-current=page]{color:var(--beacon-system-color-text-standard)}@media (width >= 640px){[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint]>ol>.beacon-breadcrumbs__popover-container~li:nth-last-child(2){display:none}}@media (width >= 960px){[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] [beacon-tag-name=beacon-menu]>ol>li:nth-last-child(1){display:none}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint]>ol>.beacon-breadcrumbs__popover-container~li:nth-last-child(2){display:flex}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] li.minimal-breadcrumbs-popover{display:none}[beacon-tag-name=beacon-breadcrumbs][use-extra-truncation-on-medium-breakpoint] li.minimal-breadcrumbs-popover+li{display:flex}}`, q2 = ve`::slotted(ol){align-items:center;display:flex;gap:var(--beacon-reference-space-3);white-space:nowrap}`;
var Y2 = Object.defineProperty, X2 = Object.getOwnPropertyDescriptor, Pr = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? X2(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && Y2(t, e, o), o;
}, Xo;
const kn = (Xo = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = eg.beaconTagName, this.label = "Breadcrumb", this.useExtraTruncationOnMediumBreakpoint = !1;
  }
  static get styles() {
    return [super.styles, q2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, V2];
  }
  get linkListItems() {
    return Za(
      this,
      "_linkListItems",
      () => Array.from(this.linkList.children).filter((t) => t instanceof HTMLLIElement).filter(
        (t) => !t.classList.contains("beacon-breadcrumbs__popover-container")
      )
    );
  }
  get links() {
    return Za(
      this,
      "_links",
      () => Array.from(this.querySelectorAll("a"))
    );
  }
  get overflowListItems() {
    return Za(this, "_overflowListItems", () => {
      if (this.useExtraTruncationOnMediumBreakpoint) {
        if (this.linkListItems.length > Xo.maxVisibleLinks - 1)
          return this.linkListItems.slice(1, this.linkListItems.length - 1);
      } else if (this.linkListItems.length > Xo.maxVisibleLinks)
        return this.linkListItems.slice(1, this.linkListItems.length - 2);
      return [];
    });
  }
  /**
   * @note doesn't use icon button because the styles differ significantly enough
   */
  createPopover(t) {
    return ze`
      <button class="beacon-breadcrumbs__popover-trigger" id="menu" aria-label="Open nested links">
        <span class="ellipses-wrapper">
          <${this.getScopedTag("beacon-icon")} name='overflow_horizontal' scale='s'></${this.getScopedTag("beacon-icon")}>
        </span>
      </button>
      <${this.getScopedTag("beacon-popover")} opens-by="#menu" class="beacon-breadcrumbs__popover" placement="bottom-start" .arrowPadding=${rE(CA)} .fallbackPlacements=${["top-start"]}>
        <${this.getScopedTag("beacon-menu")}>
          <ol class="beacon-breadcrumbs__popover-menu">
            ${No(t, (e) => pe`${e.cloneNode(!0)}`)}
          </ol>
        </${this.getScopedTag("beacon-menu")}>
      </${this.getScopedTag("beacon-popover")}>
    `;
  }
  insertPopover() {
    var t;
    this.overflowListItems.length > 0 && (this.linkListItems[0].insertAdjacentHTML(
      "afterend",
      `<li class="beacon-breadcrumbs__popover-container ${this.linkListItems.length === 4 ? "minimal-breadcrumbs-popover" : ""}"></li>`
    ), Ws(this.createPopover(this.overflowListItems), this.popoverContainer), (t = this.querySelector("button")) == null || t.insertAdjacentHTML(
      "beforebegin",
      this.chevronIcon()
    ));
  }
  addAriaCurrent() {
    this.links.length === this.linkListItems.length && this.links[this.links.length - 1].setAttribute("aria-current", "page");
  }
  /**
   * Wraps a text node inside of the last <li> in a <span> element to ensure text truncation behavior.
   * This function must come before injectSVGSeparators or else it will break the functionality.
   */
  wrapLastNodeInSpan() {
    if (this.links.length !== this.linkListItems.length) {
      const t = this.linkListItems[this.linkListItems.length - 1];
      t.innerHTML = `<span>${t.innerHTML}</span>`;
    }
  }
  injectSVGSeparators() {
    this.linkListItems.forEach((t) => {
      t.insertAdjacentHTML("afterbegin", this.chevronIcon());
    });
  }
  chevronIcon() {
    return `<${this.getScopedTagName("beacon-icon")} name='chevron_right_small' scale='s'></${this.getScopedTagName("beacon-icon")}>`;
  }
  modifyDOMElements() {
    this.wrapLastNodeInSpan(), this.injectSVGSeparators(), this.addAriaCurrent(), this.insertPopover();
  }
  render() {
    return pe`
      <nav class="base" aria-label="${this.label}">
        <slot @slotchange=${Js()}></slot>
      </nav>
    `;
  }
}, Xo.nestedComponents = [Co, As, ro], Xo.tagName = eg.beaconTagName, Xo.maxVisibleLinks = 4, Xo);
Pr([
  ue()
], kn.prototype, "label", 2);
Pr([
  An(".beacon-breadcrumbs__popover")
], kn.prototype, "beaconPopover", 2);
Pr([
  An(".beacon-breadcrumbs__popover-container")
], kn.prototype, "popoverContainer", 2);
Pr([
  An("ol")
], kn.prototype, "linkList", 2);
Pr([
  ue({
    type: Boolean,
    reflect: !0,
    attribute: "use-extra-truncation-on-medium-breakpoint"
  })
], kn.prototype, "useExtraTruncationOnMediumBreakpoint", 2);
Pr([
  Re
], kn.prototype, "modifyDOMElements", 1);
let VD = kn;
const Gd = {
  beaconTagName: "beacon-byline",
  zeroAuthorText: "T.Rowe Price"
}, Q2 = ve`[beacon-tag-name=beacon-byline] :is([slot=author]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}[beacon-tag-name=beacon-byline] :is([slot=author]) a{color:var(--beacon-system-color-text-link);font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-byline] :is([slot=author]) a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-byline] [slot=attribution-text]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;white-space:nowrap}`, Z2 = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:flex;margin:var(--hero-override-byline-margin, 0);margin-block:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--hero-override-byline-padding-block-start, 0)}::slotted([slot=attribution-text]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);display:block;white-space:nowrap}p{margin:0}.beacon-attribution-tag{display:block;margin-inline-end:var(--beacon-reference-space-2);white-space:nowrap}.beacon-author-list{display:block;list-style:none;margin:0;padding-inline-start:0}.beacon-author-list li{display:inline;font-weight:var(--beacon-system-font-weight-bold)}.beacon-author-list li:not(:last-of-type):after{content:", "}`;
var J2 = Object.defineProperty, dv = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && J2(t, e, o), o;
};
const Hb = class Hb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Gd.beaconTagName;
  }
  static get styles() {
    return [super.styles, Z2];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Q2];
  }
  /** slotChange handler  */
  attributionTextSlotChange() {
    this.requestUpdate("slottedAttributionText");
  }
  /** slotChange handler  */
  authorSlotChange() {
    this.requestUpdate("slottedAuthor");
  }
  render() {
    return pe` <slot
        @slotchange=${this.attributionTextSlotChange}
        name="attribution-text">
        By&nbsp
      </slot>
      <slot @slotchange=${this.authorSlotChange} name="author">
        <p>${Gd.zeroAuthorText}</p>
      </slot>`;
  }
};
Hb.tagName = Gd.beaconTagName;
let Zl = Hb;
dv([
  De({ slot: "attribution-text", flatten: !0 })
], Zl.prototype, "slottedAttributionText");
dv([
  De({ slot: "author", flatten: !0 })
], Zl.prototype, "slottedAuthor");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: eM } = WA, tg = (a, t) => (a == null ? void 0 : a._$litType$) !== void 0, tM = (a) => {
  var t;
  return ((t = a == null ? void 0 : a._$litType$) == null ? void 0 : t.h) != null;
}, og = () => document.createComment(""), _a = (a, t, e) => {
  var n;
  const i = a._$AA.parentNode, o = t === void 0 ? a._$AB : t._$AA;
  if (e === void 0) {
    const l = i.insertBefore(og(), o), L = i.insertBefore(og(), o);
    e = new eM(l, L, a, a.options);
  } else {
    const l = e._$AB.nextSibling, L = e._$AM, D = L !== a;
    if (D) {
      let j;
      (n = e._$AQ) == null || n.call(e, a), e._$AM = a, e._$AP !== void 0 && (j = a._$AU) !== L._$AU && e._$AP(j);
    }
    if (l !== o || D) {
      let j = e._$AA;
      for (; j !== l; ) {
        const I = j.nextSibling;
        i.insertBefore(j, o), j = I;
      }
    }
  }
  return e;
}, Ia = (a, t, e = a) => (a._$AI(t, e), a), oM = {}, Sh = (a, t = oM) => a._$AH = t, Eh = (a) => a._$AH, Wd = (a) => {
  var i;
  (i = a._$AP) == null || i.call(a, !1, !0);
  let t = a._$AA;
  const e = a._$AB.nextSibling;
  for (; t !== e; ) {
    const o = t.nextSibling;
    t.remove(), t = o;
  }
}, iM = (a) => {
  a._$AR();
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ig = (a, t, e) => {
  const i = /* @__PURE__ */ new Map();
  for (let o = t; o <= e; o++) i.set(a[o], o);
  return i;
}, hv = Ri(class extends Ni {
  constructor(a) {
    if (super(a), a.type !== gn.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(a, t, e) {
    let i;
    e === void 0 ? e = t : t !== void 0 && (i = t);
    const o = [], n = [];
    let l = 0;
    for (const L of a) o[l] = i ? i(L, l) : l, n[l] = e(L, l), l++;
    return { values: n, keys: o };
  }
  render(a, t, e) {
    return this.dt(a, t, e).values;
  }
  update(a, [t, e, i]) {
    var T;
    const o = Eh(a), { values: n, keys: l } = this.dt(t, e, i);
    if (!Array.isArray(o)) return this.ut = l, n;
    const L = (T = this.ut) != null ? T : this.ut = [], D = [];
    let j, I, B = 0, R = o.length - 1, N = 0, x = n.length - 1;
    for (; B <= R && N <= x; ) if (o[B] === null) B++;
    else if (o[R] === null) R--;
    else if (L[B] === l[N]) D[N] = Ia(o[B], n[N]), B++, N++;
    else if (L[R] === l[x]) D[x] = Ia(o[R], n[x]), R--, x--;
    else if (L[B] === l[x]) D[x] = Ia(o[B], n[x]), _a(a, D[x + 1], o[B]), B++, x--;
    else if (L[R] === l[N]) D[N] = Ia(o[R], n[N]), _a(a, o[B], o[R]), R--, N++;
    else if (j === void 0 && (j = ig(l, N, x), I = ig(L, B, R)), j.has(L[B])) if (j.has(L[R])) {
      const y = I.get(l[N]), S = y !== void 0 ? o[y] : null;
      if (S === null) {
        const u = _a(a, o[B]);
        Ia(u, n[N]), D[N] = u;
      } else D[N] = Ia(S, n[N]), _a(a, o[B], S), o[y] = null;
      N++;
    } else Wd(o[R]), R--;
    else Wd(o[B]), B++;
    for (; N <= x; ) {
      const y = _a(a, D[x + 1]);
      Ia(y, n[N]), D[N++] = y;
    }
    for (; B <= R; ) {
      const y = o[B++];
      y !== null && Wd(y);
    }
    return this.ut = l, Sh(a, D), ei;
  }
}), Ft = {
  BEACON_TAG_NAME: "beacon-carousel",
  DEFAULT_ACCESSIBLE_LABEL: "carousel",
  BEACON_ICON_BUTTON: "beacon-icon-button",
  CSS_VAR_STARTING_MASK: "--starting-mask-value",
  CSS_VAR_ENDING_MASK: "--ending-mask-value",
  CSS_ZERO_PERCENTAGE: "0%",
  CSS_MASK_VALUE: "calc(var(--grid-column-size-inline) + var(--beacon-system-space-gutter))",
  DATA_METRICS_LOCATION_CAROUSEL: "CAR"
}, aM = ve`[beacon-tag-name=beacon-carousel]{--carousel-container-scroll-padding-inline: var(--organism-inline-padding)}[beacon-tag-name=beacon-carousel] [beacon-tag-name*=tile],[beacon-tag-name=beacon-carousel] .carousel-wrapper a{inline-size:var(--tile-inline-size)}[beacon-tag-name=beacon-carousel] .beacon-scroll-snap-item{scroll-snap-align:start}[beacon-tag-name=beacon-carousel] [slot=carousel-title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-system-color-text-standard);margin:0}`, nM = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--modern-outlook-organism-padding: var(--beacon-system-space-organism-maxi);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-3);--modern-outlook-dot-size: var(--beacon-reference-space-3);--organism-inline-padding: var(--modern-outlook-organism-padding);--organism-block-padding: var(--beacon-system-space-organism-jumbo);--carousel-wrapper-space-gap: var(--beacon-system-space-gutter);--override-icon-button-outline-offset: var(--beacon-reference-space-2);--tile-inline-size: calc(100dvw - (2 * var(--organism-inline-padding)));background-color:var(--beacon-system-color-background-0)}:host .visually-hidden .visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.header{align-items:end;display:flex;gap:var(--beacon-reference-space-3);justify-content:space-between;margin-inline:auto;padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--organism-inline-padding)}.title-area{align-items:center;display:flex;flex-wrap:wrap}.component-shell{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--organism-block-padding)}.component-shell.small .footer{align-items:center;display:flex;gap:var(--beacon-reference-space-3);justify-content:space-between;padding-inline:var(--organism-inline-padding)}.component-shell.small .carousel-indicator{margin:0}.description-area{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);margin-block-start:var(--beacon-reference-space-4)}.description-area ::slotted(*){margin:0;padding:0}.action-zone{margin-block-start:var(--beacon-reference-space-4)}.item-count{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-50)}.title-text{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-system-color-text-standard);margin:0;padding-inline-end:var(--beacon-reference-space-3)}.incremental-nav{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}.carousel-container{--mask-gradient: linear-gradient(90deg, rgb(0 0 0 / 0%) 0%, rgb(0 0 0 / 100%) calc(0% + (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 100%) calc(100% - (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 0%) 100%);-webkit-mask-image:var(--mask-gradient);mask-image:var(--mask-gradient);overflow:auto;-ms-overflow-style:none;scroll-behavior:smooth;scroll-padding-inline:var(--carousel-container-scroll-padding-inline, initial);scroll-snap-type:x mandatory;scrollbar-width:none}.carousel-container::-webkit-scrollbar{display:none}.carousel-wrapper{display:flex;gap:var(--carousel-wrapper-space-gap);inline-size:fit-content;padding-block:var(--beacon-system-space-micro-jumbo) var(--beacon-system-space-micro-maxi);padding-inline:var(--organism-inline-padding)}.carousel-indicator{display:flex;gap:var(--modern-outlook-indicator-nav-gap);justify-content:center;margin-inline:auto;padding-block:var(--beacon-system-space-cell-free-floating)}.carousel-indicator-dot{background:none;block-size:var(--modern-outlook-dot-size);border:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-icon-secondary);border-radius:var(--beacon-system-radius-corner-circle);cursor:pointer;inline-size:var(--modern-outlook-dot-size);outline-offset:var(--beacon-reference-space-2);padding:0}.carousel-indicator-dot[aria-current=true]{background:var(--beacon-system-color-icon-secondary)}.carousel-indicator-dot:hover:not([aria-current=true]){background-clip:padding-box;background-color:var(--beacon-system-color-icon-secondary);border:3px double var(--beacon-system-color-icon-secondary)}@media (width >= 640px){:host{--tile-inline-size: calc(50dvw - (var(--organism-inline-padding) + (.5 * var(--carousel-wrapper-space-gap))))}}@media (width >= 960px){:host{--modern-outlook-dot-size: var(--beacon-reference-space-4);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-4)}}@media (width >= 1280px){:host{--tile-inline-size: calc((100dvw - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}@media (width >= 1920px){:host{--modern-outlook-organism-padding: 10rem;--tile-inline-size: calc((var(--beacon-system-breakpoint-xxx-large) - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}`;
var rM = Object.defineProperty, sM = Object.getOwnPropertyDescriptor, Nt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? sM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && rM(t, e, o), o;
}, Qo;
const zt = (Qo = class extends Ge(Le).with($i) {
  constructor() {
    super(...arguments), this.beaconTagName = Ft.BEACON_TAG_NAME, this.carouselPageMap = /* @__PURE__ */ new Map(), this.currentNavigatorIndex = 0, this.carouselTitle = "", this.accessibleLabel = Ft.DEFAULT_ACCESSIBLE_LABEL, this.dataMetricsLocation = Ft.DATA_METRICS_LOCATION_CAROUSEL, this.hideItemCount = !1, this.itemCount = 0, this.scrolling = !1, this.navButtonScrolling = !1, this.applyScrollBehavior = () => {
      this.toggleCarouselAlphaMasking(), this.navButtonScrolling || this.handleLiteralScrolling(), this.scrolling = !1;
    }, this.updateCarouselMap = () => {
      const t = this.createCarouselMap();
      (t == null ? void 0 : t.size) !== this.carouselPageMap.size && (this.carouselPageMap.clear(), this.carouselPageMap = new Map(t), this.currentNavigatorIndex = 0, this.removeCurrentlySelected(), this.addAriaCurrentRole(0), this.carouselContainer.scroll({ left: 0 }), this.requestUpdate());
    }, this.carouselResizeObserver = new ResizeObserver(
      this.updateCarouselMap
    ), this.carouselIntersectionObserver = new IntersectionObserver(
      (t) => {
        for (const e of t) {
          const i = e.target;
          e.intersectionRatio < 1 ? Qo.toggleCarouselItemAccessibility(i, !0) : Qo.toggleCarouselItemAccessibility(i, !1);
        }
      },
      { threshold: [0, 1], root: this }
    );
  }
  static get styles() {
    return [super.styles, nM];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, aM];
  }
  clearSnapClasses() {
    this.scrollSnapCarouselItems && this.scrollSnapCarouselItems.forEach((t) => {
      t.classList.remove("beacon-scroll-snap-item");
    });
  }
  static applySnapClass(t) {
    t.classList.add("beacon-scroll-snap-item");
  }
  /** Update itemCount and HTML on addition or removal of carousel objects. */
  handleCarouselSlotChange() {
    this.itemCount = this.slottedCarouselItems.length;
  }
  /**
   * Keeps the percentage values of the masking gradient to be aligned with the inline padding of the target ~ `carousel-container`.
   * Toggles the masking when scroll bar is at the start or end.
   */
  toggleCarouselAlphaMasking() {
    this.carouselContainer && (this.carouselContainer.scrollLeft !== 0 ? this.style.setProperty(
      Ft.CSS_VAR_STARTING_MASK,
      Ft.CSS_MASK_VALUE
    ) : this.style.setProperty(
      Ft.CSS_VAR_STARTING_MASK,
      Ft.CSS_ZERO_PERCENTAGE
    ), this.carouselContainer.scrollLeft + this.carouselContainer.clientWidth >= this.carouselContainer.scrollWidth ? this.style.setProperty(
      Ft.CSS_VAR_ENDING_MASK,
      Ft.CSS_ZERO_PERCENTAGE
    ) : this.style.setProperty(
      Ft.CSS_VAR_ENDING_MASK,
      Ft.CSS_MASK_VALUE
    ));
  }
  /**
   * When scrolling is not triggered by a nav button, perform the scroll logic below.
   * This logic is for when the user literally scrolls.
   * It checks where the scrollbar is (scrollLeft property) and creates
   * a currentScrolledRatio that is a percent of the total possible scrollable area.
   * This currentScrolledRatio is compared against the scrollZoneUpperLimit of a given
   * page of tiles to determine whether or not to update the currentNavigatorIndex.
   */
  handleLiteralScrolling() {
    var n, l, L;
    const t = ((n = this.carouselContainer) == null ? void 0 : n.scrollLeft) || 0, e = (((l = this.carouselContainer) == null ? void 0 : l.scrollWidth) || 0) - (((L = this.carouselContainer) == null ? void 0 : L.clientWidth) || 0), i = t / e;
    let o = this.currentNavigatorIndex;
    for (let D = 0; D < this.carouselPageMap.size; D += 1) {
      const j = this.carouselPageMap.get(D);
      if (j != null && j.startTile && j.scrollZoneUpperLimit && i <= j.scrollZoneUpperLimit) {
        o = D;
        break;
      }
    }
    this.currentNavigatorIndex = o, this.updateSelectedNavButton();
  }
  /**
   /* Scroll event listener applied to the carouselContainer.
   * It toggles alpha masking of peripheral carousel content,
   * updates scroll to appropriate page and updates selected nav buttons
   * when user scrolls literally.
   */
  handleCarouselScroll() {
    this.scrolling || (window.requestAnimationFrame(this.applyScrollBehavior), this.scrolling = !0);
  }
  /**
   * Click event handler to update scroll to appropriate page and update selected nav button
   * @param {number} index: index of carouselItem
   */
  carouselIndicatorClickHandler(t) {
    this.currentNavigatorIndex = t || 0, this.scrollToNavIndex(), this.updateSelectedNavButton();
  }
  /**
   * Sets an indicator nav dot element's `aria-current` label attribute to `true`
   *
   * @param {number} buttonIndex: index of the button to set
   */
  addAriaCurrentRole(t) {
    var e, i;
    (i = (e = this.carouselNavigator) == null ? void 0 : e.children[t]) == null || i.setAttribute(
      "aria-current",
      "true"
    );
  }
  /**
   * Click handler for increment navigation button.
   * Increases `currentNavigatorIndex` to the next page if available
   */
  incrementNavIndex() {
    this.currentNavigatorIndex >= this.carouselPageMap.size - 1 || (this.currentNavigatorIndex += 1, this.updateSelectedNavButton(), this.scrollToNavIndex());
  }
  /**
   * Click handler for decrement navigation button.
   * Decreases `currentNavigatorIndex` to the previous page if available
   */
  decrementNavIndex() {
    this.currentNavigatorIndex <= 0 || (this.currentNavigatorIndex -= 1, this.updateSelectedNavButton(), this.scrollToNavIndex());
  }
  /**
   * Removes the `aria-current` attribute from all navigation buttons
   */
  removeCurrentlySelected() {
    var e;
    const t = ((e = this.carouselNavigator) == null ? void 0 : e.children) || [];
    for (const i of t)
      i.removeAttribute("aria-current");
  }
  /**
   * triggered when a new navigation button is selected
   */
  updateSelectedNavButton() {
    this.removeCurrentlySelected(), this.addAriaCurrentRole(this.currentNavigatorIndex), this.updateAriaLiveRegion();
  }
  updateAriaLiveRegion() {
    var t;
    this.liveRegion.textContent = `Carousel page ${this.currentNavigatorIndex + 1} of ${(t = this.carouselNavigator) == null ? void 0 : t.children.length}`;
  }
  /**
   * Scrolls the appropriate card into view instead of using scrollIntoView(),
   * since scrollIntoView() can cause unintended scrolling on larger pages
   */
  scrollToNavIndex() {
    var t, e, i, o;
    if (this.currentNavigatorIndex === 0)
      (t = this.carouselContainer) == null || t.scroll({ left: 0, behavior: "smooth" });
    else {
      const n = (i = (e = this.carouselPageMap.get(
        this.currentNavigatorIndex
      )) == null ? void 0 : e.startTile) == null ? void 0 : i.offsetLeft;
      if (n !== void 0) {
        const l = getComputedStyle(
          this.carouselWrapper
        ).getPropertyValue("padding-inline");
        (o = this.carouselContainer) == null || o.scroll({
          left: n - parseInt(l, 10),
          behavior: "smooth"
        });
      }
    }
  }
  /**
   * Dot indicators.
   *
   * @date 2024-11-11: Change `<nav>` to `<div>` and removes `aria-label`.
   * @link https://rally1.rallydev.com/#/?detail=/defect/732798274309&fdp=true
   */
  renderCarouselNavigator() {
    return pe`
      <div class="carousel-indicator">
        ${hv(
      this.carouselPageMap,
      (t) => t[0],
      (t, e) => pe`
            <button
              class="carousel-indicator-dot"
              aria-current=${e === 0 ? "true" : je}
              aria-label="${this.navigatorButtonIndexPrefix} ${e + 1}"
              @click="${() => this.carouselIndicatorClickHandler(e)}"></button>
          `
    )}
      </div>
    `;
  }
  /**
   * Toggles the `inert` html attribute on the passed in `carouselItem`
   *
   * @param {HTMLElement} carouselItem Element to toggle `inert` attribute on
   * @param {boolean} hide boolean to add or remove `inert` attribute
   */
  static toggleCarouselItemAccessibility(t, e) {
    t.toggleAttribute("inert", e);
  }
  /**
   * Creates and populates a new `Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }` object by comparing page views against the `containerWidth`
   * @returns {Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }>} Map containing page numbers as keys and the startTile instances and the upper limit of the scroll zone for a give page as values.
   */
  createCarouselMap() {
    var o;
    const t = ((o = this.carouselContainer) == null ? void 0 : o.clientWidth) || 0, e = /* @__PURE__ */ new Map(), i = this.slottedCarouselItems.length;
    if (this.clearSnapClasses(), t < no.MEDIUM)
      this.slottedCarouselItems.forEach((n, l) => {
        e.set(l, {
          startTile: n,
          scrollZoneUpperLimit: (l + 1) / this.slottedCarouselItems.length
        });
      });
    else if (t < no.XLARGE) {
      const n = i % 2, l = n ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 2, L = n ? 2 : 1;
      let D = 0;
      for (let j = 0; j < i - n; j += 2)
        e.set(D, {
          startTile: this.slottedCarouselItems[j],
          scrollZoneUpperLimit: (D + 1) * L / l
        }), D += 1;
      n && e.set(D, {
        startTile: this.slottedCarouselItems[i - 1],
        scrollZoneUpperLimit: 1
      });
    } else {
      let n = 0;
      const l = i % 3, L = l ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 3, D = l ? 3 : 1;
      for (let j = 0; j < i - l; j += 3)
        e.set(n, {
          startTile: this.slottedCarouselItems[j],
          scrollZoneUpperLimit: (n + 1) * D / L
        }), n += 1;
      l && (l > 1 ? e.set(n, {
        startTile: this.slottedCarouselItems[i - 2],
        scrollZoneUpperLimit: 1
      }) : e.set(n, {
        startTile: this.slottedCarouselItems[i - 1],
        scrollZoneUpperLimit: 1
      }));
    }
    return e.forEach((n) => {
      Qo.applySnapClass(n.startTile);
    }), e;
  }
  postRenderCarouselSetup() {
    this.slottedCarouselItems && (this.itemCount = this.slottedCarouselItems.length), this.toggleCarouselAlphaMasking(), this.carouselResizeObserver.observe(this.carouselContainer);
    for (const t of this.slottedCarouselItems)
      this.carouselIntersectionObserver.observe(t);
  }
  renderHeaderTextAreas() {
    return pe`
      <div class="header-text">
        <div class="title-area">
          <span class="title-text"
            ><slot name="carousel-title">${this.carouselTitle}</slot></span
          >
          ${this.hideItemCount ? pe`` : pe`
                <span class="item-count"
                  >(${this.itemCount}
                  <slot name="item-label">items</slot>)</span
                >
              `}
        </div>
        <div class="description-area">
          <slot name="description" ${_e({ useParent: !0 })}></slot>
        </div>
        <div class="action-zone">
          <slot name="action-zone" ${_e({ useParent: !0 })}></slot>
        </div>
      </div>
    `;
  }
  renderIncrementalNav() {
    return pe`
      <nav aria-label="Carousel Pages" class="incremental-nav">
        ${ze`
          <${this.getScopedTag(Ft.BEACON_ICON_BUTTON)}
            @beacon-event-click=${this.decrementNavIndex}
            ?disabled=${this.currentNavigatorIndex === 0}
            class="increment-left" variant="secondary">
            <slot name="previous-button-text">Go to previous page</slot>
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M13 16.5L9 12.5L13 8.5" stroke="#086EA1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </${this.getScopedTag(Ft.BEACON_ICON_BUTTON)}>
        `} ${ze`
          <${this.getScopedTag(Ft.BEACON_ICON_BUTTON)}
            @beacon-event-click=${this.incrementNavIndex}
            ?disabled=${this.currentNavigatorIndex === this.carouselPageMap.size - 1}
            class="increment-right" variant="secondary">
            <slot name="next-button-text">Go to next page</slot>
            <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11 8.5L15 12.5L11 16.5" stroke="#086EA1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </${this.getScopedTag(Ft.BEACON_ICON_BUTTON)}>
        `}
      </nav>
    `;
  }
  render() {
    const t = {
      "component-shell": !0,
      small: this.matchesUpToSmall
    };
    return pe`
      <section
        aria-label="${this.accessibleLabel}"
        role="group"
        aria-roledescription="carousel"
        class="${Pe(t)}">
        <header class="header">
          ${this.matchesUpToSmall ? pe`${this.renderHeaderTextAreas()}` : pe`
                ${this.renderHeaderTextAreas()}
                ${this.carouselPageMap.size !== 1 ? pe` ${this.renderIncrementalNav()}` : je}
              `}
        </header>
        <div class="carousel-container" @scroll="${this.handleCarouselScroll}">
          <div
            class="carousel-wrapper"
            tabindex="${this.carouselPageMap.size > 1 ? "0" : je}">
            <slot @slotchange=${this.handleCarouselSlotChange}></slot>
          </div>
        </div>
        <footer class="footer">
          ${this.matchesUpToSmall ? pe`
                ${this.carouselPageMap.size !== 1 ? pe`${this.renderCarouselNavigator()}
                    ${this.renderIncrementalNav()}` : je}
              ` : pe`
                ${this.carouselPageMap.size !== 1 ? pe`${this.renderCarouselNavigator()}` : je}
              `}
        </footer>
        <div
          aria-live="polite"
          aria-atomic="true"
          class="live-region visually-hidden"></div>
      </section>
      <output class="visually-hidden announcement"
        >${this.navigatorButtonIndexPrefix}
        ${this.currentNavigatorIndex + 1}</output
      >
      <slot style="display: none;" name="navigator-button-text"></slot>
    `;
  }
}, Qo.tagName = Ft.BEACON_TAG_NAME, Qo.nestedComponents = [Qt], Qo);
Nt([
  Ce()
], zt.prototype, "carouselPageMap", 2);
Nt([
  Ce()
], zt.prototype, "currentNavigatorIndex", 2);
Nt([
  ue({ attribute: "carousel-title" })
], zt.prototype, "carouselTitle", 2);
Nt([
  ue({ attribute: "accessible-label" })
], zt.prototype, "accessibleLabel", 2);
Nt([
  ue({ attribute: "data-metrics-location", reflect: !0 })
], zt.prototype, "dataMetricsLocation", 2);
Nt([
  ue({ attribute: "hide-item-count", type: Boolean })
], zt.prototype, "hideItemCount", 2);
Nt([
  Ce()
], zt.prototype, "itemCount", 2);
Nt([
  De({ selector: ":not(style)" })
], zt.prototype, "slottedCarouselItems", 2);
Nt([
  ot(".carousel-container")
], zt.prototype, "carouselContainer", 2);
Nt([
  ot(".carousel-wrapper")
], zt.prototype, "carouselWrapper", 2);
Nt([
  ot(".component-shell")
], zt.prototype, "componentShell", 2);
Nt([
  ot(".header")
], zt.prototype, "header", 2);
Nt([
  ot(".carousel-indicator")
], zt.prototype, "carouselNavigator", 2);
Nt([
  ot(".live-region")
], zt.prototype, "liveRegion", 2);
Nt([
  De({ selector: ".beacon-scroll-snap-item" })
], zt.prototype, "scrollSnapCarouselItems", 2);
Nt([
  K1({
    slot: "navigator-button-text",
    defaultValue: "View Page"
  })
], zt.prototype, "navigatorButtonIndexPrefix", 2);
Nt([
  Re
], zt.prototype, "postRenderCarouselSetup", 1);
let qD = zt;
const ag = {
  beaconTagName: "beacon-collection-tile"
}, lM = ve`@charset "UTF-8";[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin:0}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);margin:0;padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-icon{block-size:16px;inline-size:16px}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);padding-inline-start:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag:not(:last-child):after{content:"•";padding-inline:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{display:block;margin:var(--beacon-system-space-cell-contained);margin-block-end:calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-micro-normal));min-block-size:var(--beacon-reference-space-14)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{align-items:center;border-block-start:1px solid var(--beacon-collection-tile-footer-color);display:grid;grid-template-columns:auto 1fr auto auto;margin:var(--beacon-system-space-cell-contained);padding-block:var(--beacon-reference-space-7) var(--beacon-reference-space-3)}[beacon-tag-name=beacon-collection-tile].beacon-collection-tile__vertical-fill{--collection-tile-content-block-size: 100%;block-size:100%}[class*=b-grid-item] [beacon-tag-name=beacon-collection-tile].beacon-collection-tile__vertical-fill{block-size:100%}a:focus-visible [beacon-tag-name=beacon-collection-tile]{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}a:focus-visible [beacon-tag-name=beacon-collection-tile]:not(dialog){position:relative}a [beacon-tag-name=beacon-collection-tile]:hover .beacon-collection-tile__title,a [beacon-tag-name=beacon-collection-tile]:focus .beacon-collection-tile__title{text-decoration:underline}@media (width >= 640px){[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__collection-label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-collection-tile][beacon-version] .beacon-collection-tile__tag{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{padding-block:var(--beacon-reference-space-6) 0}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{min-block-size:84px}[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal] [slot=media],[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-left] [slot=media],[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-right] [slot=media]{--collection-tile-aspect-ratio: 1/1;flex:1}}@media (width >= 960px){[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal] .beacon-collection-tile__title,[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-left] .beacon-collection-tile__title,[beacon-tag-name=beacon-collection-tile][beacon-version][position=horizontal-right] .beacon-collection-tile__title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-100)}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=footer]{padding-block:var(--beacon-reference-space-8) 0}[beacon-tag-name=beacon-collection-tile][beacon-version] [slot=body]{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){[beacon-tag-name=beacon-collection-tile] [slot=body]{min-block-size:96px}}[beacon-tag-name=beacon-collection-tile] [slot=media]>img,[beacon-tag-name=beacon-collection-tile] [slot=media]:not(picture){aspect-ratio:var(--collection-tile-aspect-ratio, 3/2);inline-size:var(--collection-tile-media-inline-size, 100%);object-fit:cover}`, cM = ve`:host{--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--collection-tile-color: var(--beacon-reference-palette-grayscale-white);--tile-content-display: flex;--tile-content-justify-content: space-between;--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-blue);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-blue);background-color:var(--beacon-collection-tile-background-color);border-radius:var(--beacon-system-radius-corner-standard);color:var(--collection-tile-color);inline-size:min(var(--collection-tile-inline-size),100%);text-decoration:none}.content-zone{block-size:var(--collection-tile-content-block-size);inline-size:var(--collection-tile-content-inline-size);padding:var(--beacon-system-space-organism-normal)}:host([position=horizontal-right]),:host([position=horizontal]){--tile-flex-direction: column}:host([position=horizontal-left]),:host([position=vertical-top]){--tile-flex-direction: column-reverse}:host([color-mode=green]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-green);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-green)}:host([color-mode=berry]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-berry);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-berry)}:host([color-mode=gold]){--beacon-collection-tile-background-color: var(--beacon-component-tile-collection-color-background-gold);--beacon-collection-tile-footer-color: var(--beacon-component-tile-collection-color-border-gold)}@media (width >= 640px){:host([position=horizontal-left]){--tile-flex-direction: row}:host([position=horizontal]),:host([position=horizontal-left]),:host([position=horizontal-right]){--tile-flex-direction: row;--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--collection-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--collection-tile-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}:host([position=horizontal]) .content-zone,:host([position=horizontal-left]) .content-zone,:host([position=horizontal-right]) .content-zone{display:var(--tile-content-display);justify-content:var(--tile-content-justify-content)}}@media (width >= 1280px){:host{--collection-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}}`;
var dM = Object.defineProperty, hM = Object.getOwnPropertyDescriptor, bv = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? hM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && dM(t, e, o), o;
};
const Kb = class Kb extends li {
  constructor() {
    super(...arguments), this.beaconTagName = ag.beaconTagName, this.focusOverride = !0, this.colorMode = Ef.BLUE;
  }
  static get styles() {
    return [super.styles, cM];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, lM];
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderMedia() {
    return pe`<slot name="media"></slot>`;
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderBody() {
    return pe`<slot name="body"></slot>`;
  }
  /**
   * Slot override to attach a click listener to the slot for Omnibug analytics purposes
   */
  renderFooter() {
    return pe`<slot name="footer"></slot>`;
  }
  renderHeader() {
    return pe``;
  }
  updateAnchorStyle() {
    this.onClosestAnchorElement();
  }
  /**
   * @description does checks if parent Element is <a> tag then apply text-decoration:none.
   * @todo Once we have support for `:has` then need to remove this and add below in lightDOM.
   * ```a:has([beacon-collection-tile]) {text-decoration:none}```
   */
  onClosestAnchorElement() {
    const t = this.closest("a");
    t && (t.style.textDecoration = "none");
  }
  renderTile(t) {
    return super.renderTile(t);
  }
  render() {
    return this.renderTile(this.position);
  }
};
Kb.tagName = ag.beaconTagName;
let Jl = Kb;
bv([
  ue({ attribute: "color-mode", reflect: !0 })
], Jl.prototype, "colorMode", 2);
bv([
  qe
], Jl.prototype, "updateAnchorStyle", 1);
const ng = {
  beaconTagName: "beacon-contact-tile"
}, bM = ve`[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__icon{--contact-tile-icon-size: var(--beacon-reference-space-11);block-size:var(--contact-tile-icon-size);inline-size:var(--contact-tile-icon-size);margin-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title,[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);display:block;margin:0;text-decoration:none}[beacon-tag-name=beacon-contact-tile] a.beacon-contact-tile__title,[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-contact-tile] a.beacon-contact-tile__title:is(:focus,:hover),[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__title>a:is(:focus,:hover){text-decoration:underline}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__job-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);display:block;margin-block-start:var(--beacon-reference-space-2);text-decoration:none}[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);display:block;margin-block-start:var(--beacon-reference-space-5);text-decoration:none}[beacon-tag-name=beacon-contact-tile] [slot=body]{padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-contact-tile] [slot=footer]{display:grid;grid-auto-flow:row;padding:var(--beacon-system-space-cell-contained);row-gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-contact-tile].beacon-contact-tile__vertical-fill{--contact-tile-content-zone-block-size: 100%;--tile-footer-margin-block-start: auto}[class*=b-grid-item] [beacon-tag-name=beacon-contact-tile].beacon-contact-tile__vertical-fill{block-size:100%}@media (width >= 1280px){[beacon-tag-name=beacon-contact-tile] .beacon-contact-tile__icon{--contact-tile-icon-size: var(--beacon-reference-space-13)}}`, pM = ve`:host{--contact-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--tile-footer-margin-block-start: var(--beacon-system-space-micro-normal);color:var(--beacon-system-color-text-standard);inline-size:min(var(--contact-tile-inline-size),100%)}.content-zone{--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);background-color:var(--beacon-system-color-background-1);block-size:var(--contact-tile-content-zone-block-size);padding:var(--beacon-system-space-organism-normal)}@media (width >= 960px){:host{--contact-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}}`, Gb = class Gb extends li {
  constructor() {
    super(...arguments), this.beaconTagName = ng.beaconTagName;
  }
  static get styles() {
    return [super.styles, pM];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, bM];
  }
  /**
   * renderContentZone override to remove `header` from the render
   */
  renderContentZone() {
    return pe`<div class="content-zone">
      ${this.renderBody()} ${this.renderFooter()}
    </div>`;
  }
  render() {
    return pe`${this.renderContentZone()}`;
  }
};
Gb.tagName = ng.beaconTagName;
let rg = Gb;
var pv = /* @__PURE__ */ ((a) => (a.PRIMARY = "primary", a.SECONDARY = "secondary", a))(pv || {}), uM = Object.defineProperty, gM = Object.getOwnPropertyDescriptor, sg = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? gM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && uM(t, e, o), o;
};
function kb(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.disabled = !1, this.allowableInteractiveKeys = ["Shift", "Tab"], this.preventDisabledEvents = (e) => {
        if (this.disabled)
          if (e instanceof KeyboardEvent) {
            const { key: i } = e;
            this.allowableInteractiveKeys.includes(i) || e.preventDefault();
          } else
            e.preventDefault();
      };
    }
    preventDisabledEventsOnElement(e, i = ["click", "keydown"]) {
      for (const o of i)
        e == null || e.addEventListener(o, this.preventDisabledEvents);
    }
  };
  return sg([
    ue({ type: Boolean, reflect: !0 })
  ], t.prototype, "disabled", 2), t = sg([
    $e("Disablable")
  ], t), t;
}
var mM = Object.defineProperty, fM = Object.getOwnPropertyDescriptor, uv = (a) => {
  throw TypeError(a);
}, Vd = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? fM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && mM(t, e, o), o;
}, gv = (a, t, e) => t.has(a) || uv("Cannot " + e), vM = (a, t, e) => (gv(a, t, "read from private field"), e ? e.call(a) : t.get(a)), AM = (a, t, e) => t.has(a) ? uv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), yM = (a, t, e, i) => (gv(a, t, "write to private field"), t.set(a, e), e);
function mv(a) {
  var t;
  let e = class extends a {
    constructor() {
      super(...arguments), this.invalid = !1, AM(this, t);
    }
    get errorElement() {
      return vM(this, t);
    }
    set errorElement(i) {
      yM(this, t, i), this.errorElement && !this.errorElement.id && (this.errorElement.id = _i()), this.postSetErrorElement();
    }
    postSetErrorElement() {
    }
    handleErrorSlotchange() {
      this.errorElement = this.errorElements[0];
    }
    renderErrorTemplate() {
      const i = {
        error: !0,
        visible: this.invalid
      };
      return ze`
        <${this.getScopedTag("beacon-error")} id="error" class="${Pe(i)}" role="alert">
          <slot name="error" @slotchange=${this.handleErrorSlotchange} ${_e({ useParent: !0 })}></slot>
        </${this.getScopedTag("beacon-error")}>
      `;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Vd([
    Ct({ flatten: !0, slot: "error" })
  ], e.prototype, "errorElements", 2), Vd([
    ue({ type: Boolean, reflect: !0 })
  ], e.prototype, "invalid", 2), e = Vd([
    $e("Errorable")
  ], e), e;
}
var xM = Object.defineProperty, wM = Object.getOwnPropertyDescriptor, fv = (a) => {
  throw TypeError(a);
}, qd = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? wM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && xM(t, e, o), o;
}, vv = (a, t, e) => t.has(a) || fv("Cannot " + e), kM = (a, t, e) => (vv(a, t, "read from private field"), e ? e.call(a) : t.get(a)), CM = (a, t, e) => t.has(a) ? fv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), SM = (a, t, e, i) => (vv(a, t, "write to private field"), t.set(a, e), e);
function Av(a) {
  var t;
  let e = class extends a {
    constructor() {
      super(...arguments), CM(this, t);
    }
    get fieldElement() {
      return kM(this, t);
    }
    set fieldElement(i) {
      SM(this, t, i), this.postSetFormControlElement();
    }
    get currentInputType() {
      if (this.fieldElement)
        return this.fieldElement.type;
    }
    postSetFormControlElement() {
    }
    postFormControlSlotchange() {
    }
    handleFormControlSlotchange() {
      this.fieldElement = this.fieldElements[0], this.postFormControlSlotchange();
    }
    setInputType() {
      this.fieldElement instanceof HTMLInputElement ? this._inputType = this.fieldElement.type : this._inputType = this.fieldElement.localName;
    }
    renderFormControlTemplate() {
      return pe`<slot
        @slotchange=${this.handleFormControlSlotchange}></slot>`;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), qd([
    Ct({ flatten: !0 })
  ], e.prototype, "fieldElements", 2), qd([
    Ce()
  ], e.prototype, "_inputType", 2), e = qd([
    $e("FormControl")
  ], e), e;
}
var EM = Object.defineProperty, MM = Object.getOwnPropertyDescriptor, yv = (a) => {
  throw TypeError(a);
}, lg = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? MM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && EM(t, e, o), o;
}, xv = (a, t, e) => t.has(a) || yv("Cannot " + e), TM = (a, t, e) => (xv(a, t, "read from private field"), e ? e.call(a) : t.get(a)), LM = (a, t, e) => t.has(a) ? yv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), OM = (a, t, e, i) => (xv(a, t, "write to private field"), t.set(a, e), e);
function Cb(a) {
  var t;
  let e = class extends a {
    constructor() {
      super(...arguments), LM(this, t);
    }
    get hintElement() {
      return TM(this, t);
    }
    set hintElement(i) {
      OM(this, t, i), this.hintElement && !this.hintElement.id && (this.hintElement.id = _i()), this.postSetHintElement();
    }
    postSetHintElement() {
    }
    handleHintSlotchange() {
      this.hintElement = this.hintElements[0];
    }
    renderHintTemplate() {
      return pe`
        <div id="hint" class="hint">
          <slot
            name="hint"
            @slotchange=${this.handleHintSlotchange}
            ${_e({ useParent: !0 })}></slot>
        </div>
      `;
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), lg([
    Ct({ flatten: !0, slot: "hint" })
  ], e.prototype, "hintElements", 2), e = lg([
    $e("Hintable")
  ], e), e;
}
const cg = {
  beaconTagName: "beacon-error"
}, PM = ve`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;display:grid;gap:var(--beacon-reference-space-3);grid-template-columns:auto 1fr}.error{align-self:start}`, lc = class lc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = cg.beaconTagName;
  }
  static get styles() {
    return [super.styles, PM];
  }
  static renderIcon() {
    return pe`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="error"
        role="img"
        aria-label="Error">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.57752 10.9999C1.22025 11.6187 1.22025 12.3811 1.57752 12.9999L5.92282 20.5262C6.28009 21.145 6.94034 21.5262 7.65487 21.5262H16.3455C17.06 21.5262 17.7203 21.145 18.0775 20.5262L22.4228 12.9999C22.7801 12.3811 22.7801 11.6187 22.4228 10.9999L18.0775 3.47363C17.7203 2.85483 17.06 2.47363 16.3455 2.47363H7.65487C6.94034 2.47363 6.28008 2.85483 5.92282 3.47363L1.57752 10.9999ZM11.2502 7.74989C11.2502 7.33568 11.586 6.99989 12.0002 6.99989C12.4144 6.99989 12.7502 7.33568 12.7502 7.74989V12.2499C12.7502 12.6641 12.4144 12.9999 12.0002 12.9999C11.586 12.9999 11.2502 12.6641 11.2502 12.2499V7.74989ZM13.0002 15.9999C13.0002 16.5522 12.5525 16.9999 12.0002 16.9999C11.4479 16.9999 11.0002 16.5522 11.0002 15.9999C11.0002 15.4476 11.4479 14.9999 12.0002 14.9999C12.5525 14.9999 13.0002 15.4476 13.0002 15.9999Z"
          fill="var(--beacon-system-color-icon-error, #DD3636)" />
      </svg>
    `;
  }
  render() {
    return pe`
      <slot name="icon">${lc.renderIcon()}</slot>
      <slot></slot>
    `;
  }
};
lc.tagName = cg.beaconTagName;
let ec = lc;
const dg = {
  beaconTagName: "beacon-control"
}, DM = ve`[beacon-tag-name=beacon-control]:has([type=hidden]){display:none}[beacon-tag-name=beacon-control] input:is(:-webkit-autofill,:autofill){border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control]:has(input:checked)::part(field){--hover-outline-color: var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input:checked)[invalid]::part(field){border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:has(input:checked)[disabled]:not([invalid])::part(field){border-color:transparent}[beacon-tag-name=beacon-control]:has(input:checked) [slot=label]{font-weight:var(--beacon-system-font-weight-bold)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);gap:var(--beacon-reference-space-4);inline-size:36px;min-block-size:var(--beacon-reference-space-10);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input.invalid{outline:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:hover{outline:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]):has([type=number]) input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-image:none;block-size:100%;border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);cursor:pointer;inline-size:100%;inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control]:has(input)[toggle-switch] [type=checkbox].beacon-control__field[disabled]{border:0}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field){block-size:var(--beacon-reference-space-8);border-radius:var(--beacon-system-radius-corner-round);inline-size:var(--beacon-reference-space-12);position:relative}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]::part(field):before{background-color:var(--beacon-system-color-background-2);block-size:var(--beacon-reference-space-5);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:50%;content:"";inline-size:var(--beacon-reference-space-5);inset-block-start:50%;inset-inline-start:var(--beacon-reference-space-2);pointer-events:none;position:absolute;transform:translateY(-50%)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field){background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):hover{--hover-outline-color: transparent;background-color:var(--beacon-system-color-background-primary-hover)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)::part(field):before{block-size:var(--beacon-reference-space-6);border:0;inline-size:var(--beacon-reference-space-6);inset-inline-start:calc(100% - var(--beacon-reference-space-6) - var(--beacon-reference-space-2))}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled] [slot=label]{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch][disabled]::part(field):before{border-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[aria-disabled=true]::part(field),[beacon-tag-name=beacon-control]:has(input)[toggle-switch]:has(input:checked)[disabled]::part(field){background-color:var(--beacon-component-form-color-foreground-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control]:has(textarea){--control-overflow: hidden}[beacon-tag-name=beacon-control]:has(textarea):not([non-resizable]){--control-resize: both}[beacon-tag-name=beacon-control]:has(textarea) textarea{block-size:100%;inline-size:100%;resize:none}[beacon-tag-name=beacon-control]:has([slot=prefix]){--control-padding-inline-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([slot=suffix]),[beacon-tag-name=beacon-control]:has([type=password]):not([disable-password-toggle]){--control-padding-inline-end: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-control]:has([aria-disabled=true]) [slot=label]{pointer-events:none}[beacon-tag-name=beacon-control] [slot=label]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control] [slot=label].option-label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]){background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}[beacon-tag-name=beacon-control]:not([stepper-variant=none]) .beacon-control__field:is([type=number]):is([aria-invalid=true],:invalid){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field{background-color:transparent;border:0;color:var(--beacon-system-color-text-standard);inline-size:100%;outline:0}[beacon-tag-name=beacon-control] .beacon-control__field:not([type=checkbox],[type=radio],select){padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] .beacon-control__field[aria-disabled=true],[beacon-tag-name=beacon-control] .beacon-control__field:disabled{caret-color:transparent;color:var(--beacon-system-color-text-inactive);cursor:not-allowed}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-8);cursor:pointer;inline-size:var(--beacon-reference-space-8)}[beacon-tag-name=beacon-control] .beacon-control__field:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-background-inactive);border:0}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=date]{block-size:var(--beacon-reference-space-10)}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]{border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){accent-color:var(--beacon-component-form-color-foreground-inactive)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){accent-color:var(--beacon-system-color-icon-error)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]){border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:is([aria-invalid=true]):hover{border-color:var(--beacon-system-color-border-error)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:focus-within{border-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=checkbox]:hover{border:2px solid var(--beacon-component-form-color-border-standard)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]{border-radius:50%;padding:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked{background-clip:content-box;background-color:var(--beacon-system-color-background-primary)}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-disabled=true],:disabled){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}[beacon-tag-name=beacon-control] .beacon-control__field[type=radio]:checked:is([aria-invalid=true],:invalid){background-color:var(--beacon-system-color-icon-error);border:0}[beacon-tag-name=beacon-control] .beacon-control__field:is(select){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;padding-block:var(--beacon-reference-space-3);padding-inline:var(--control-padding-inline-start, var(--beacon-reference-space-4)) var(--control-padding-inline-end, var(--beacon-reference-space-9))}[beacon-tag-name=beacon-control] .beacon-control__field:is(select) option{color:var(--beacon-reference-palette-grayscale-dark-gray-3)}[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[disabled],[beacon-tag-name=beacon-control] .beacon-control__field:is(select)[aria-disabled=true]{opacity:.7}[beacon-tag-name=beacon-control][data-mode=dark] :is(input,textarea,select){color-scheme:dark}`, zM = ve`:host{display:flex;flex-direction:column}.inline-wrapper{display:contents}.group{align-items:var(--control-alignment, start);display:flex;flex-direction:var(--beacon-custom-control-flex-direction, var(--control-direction, column));gap:var(--beacon-reference-space-3);inline-size:var(--control-group-inline-size, 100%);justify-content:start}.group.inline{--control-direction: row-reverse}.group.inline .field{flex-shrink:0}.group:has(.radio,.checkbox){--control-alignment: center;gap:var(--beacon-reference-space-4)}.group:has(.radio,.checkbox).inline .field{align-self:var(--override-control-checkbox-radio-align-self, start)}.group:has(.date){--control-group-inline-size: fit-content}.inline-wrapper.active:not(:has(.radio,.checkbox)){align-items:center;column-gap:var(--beacon-reference-space-4);display:grid;grid-template-columns:auto 1fr}.inline-wrapper.active:not(:has(.radio,.checkbox)) .group{display:contents}.inline-wrapper.active:not(:has(.radio,.checkbox)) .label{grid-column:1/2}.inline-wrapper.active:not(:has(.radio,.checkbox)) .field,.inline-wrapper.active:not(:has(.radio,.checkbox)) .hint,.inline-wrapper.active:not(:has(.radio,.checkbox)) .error{grid-column:2/3}.inline-wrapper.active:not(:has(.radio,.checkbox)) :where(.date){--control-inline-size: fit-content}.field{align-items:center;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);display:flex;font:var(--beacon-system-font-weight-light) var(--beacon-component-form-font-size-sans-serif-standard);overflow:var(--control-overflow, initial);resize:var(--control-resize, none)}.field:not(.radio,.checkbox){inline-size:var(--beacon-custom-control-inline-size, var(--control-inline-size, 100%))}.field.select{position:relative}.field.select .dropdown-icon{color:var(--beacon-system-color-icon-link);inset-inline-end:var(--beacon-reference-space-3);position:absolute}.field.disabled{background-color:var(--beacon-component-form-color-background-inactive);border-color:transparent;pointer-events:none}.field.disabled .dropdown-icon{color:var(--beacon-reference-palette-grayscale-light-gray-2)}.field.readonly{background-color:var(--beacon-system-color-background-0);border-color:var(--beacon-system-color-border-0)}.field.invalid{border-color:var(--beacon-system-color-border-error)}.field.invalid:not(.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-error)}.field.invalid:where(.number.stepper){outline:none}.field:hover:not(.invalid,:focus-within,.checkbox){outline:var(--beacon-system-width-border-mini) solid var(--hover-outline-color, var(--beacon-component-form-color-border-standard))}.field:focus-within{border-color:var(--beacon-system-color-border-primary)}.field:focus-within:not(:has([name=prefix]:focus-within)){outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}.field:focus-within.invalid{border-color:var(--beacon-system-color-border-error)}.field:focus-within.disabled{border-color:var(--beacon-system-color-border-primary)}.field:focus-within.readonly{border-color:var(--beacon-system-color-border-0)}.field:where(.date){--control-inline-size: 100%}.field:where(.select){--control-inline-size: 100%}@media (width >= 640px){.field:where(.select){--control-inline-size: fit-content}}.field:where(.radio){border-radius:50%}.field.number.stepper{background:transparent;border:0;gap:var(--beacon-reference-space-3)}.field.number.stepper:is(:hover,:focus-within){outline:none}.field.checkbox{border:0}.prefix,.suffix{flex-shrink:0}.prefix{margin-inline-start:var(--beacon-reference-space-4)}.suffix{margin-inline-end:var(--beacon-reference-space-4)}.suffix.password:not(.password-visible) .hide-password{display:none}.suffix.password.password-visible .show-password{display:none}.suffix.password ::part(standard-button){margin:0;padding:0;position:relative}.suffix.password ::part(standard-button):before{block-size:var(--beacon-reference-space-10);content:"";inline-size:var(--beacon-reference-space-10);inset-block-start:calc(-1 * var(--beacon-reference-space-4));position:absolute}.toggle-switch-label:not(.checkbox-checked) .switch-on-label{display:none}.toggle-switch-label.checkbox-checked .switch-off-label{display:none}.stepper{margin-inline:0}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.error:not(.visible){display:none}.hint,.error{margin-block-start:var(--beacon-reference-space-2)}.beacon-stepper-button{--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9);align-items:flex-start;display:flex;padding:var(--beacon-reference-space-2)}`;
var IM = Object.defineProperty, BM = Object.getOwnPropertyDescriptor, Jt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? BM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && IM(t, e, o), o;
}, Wa, Ps, Ti;
const qt = (Ti = class extends Ge(Le).with(
  Cb,
  mv,
  Av,
  kb
) {
  constructor() {
    super();
    Ie(this, Wa);
    Ie(this, Ps);
    this.beaconTagName = dg.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, this.inline = !1, this.disablePasswordToggle = !1, this.disableToggleSwitchLabel = !1, this.nonResizable = !1, this.toggleSwitch = !1, this.readOnly = !1, this.stepperVariant = pv.PRIMARY, this.passwordVisible = !1, this.isCheckboxChecked = !1, Be(this, Wa, void 0), this.handleFieldElementInvalid = this.handleFieldElementInvalid.bind(this), this.handleFieldElementOnChange = this.handleFieldElementOnChange.bind(this);
  }
  static get styles() {
    return [super.styles, zM];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, DM];
  }
  get labelElement() {
    return Te(this, Ps);
  }
  set labelElement(e) {
    Be(this, Ps, e);
  }
  postSetFormControlElement() {
    this.fieldElement && (Ti.applyClassNameToField(this.fieldElement), Fe(this, Ee.CONTROL_SET), this.setInputType(), this.setupSlottedFieldEventListeners(), this.setDisabledState(), this.setInvalidState(), this.setReadOnlyState(), this.setSwitchRole(), this.applyFieldElementObserver(), this.initializeIsCheckboxChecked());
  }
  get isStepper() {
    return this._inputType === "number" && this.stepperVariant !== "none";
  }
  get controlGroup() {
    return Za(
      this,
      "_controlGroup",
      () => this.closest(this.getScopedTagName("beacon-control-group"))
    );
  }
  getAriaDescribedByIds() {
    var i, o;
    const e = [this.dataset.hintId || ((i = this.hintElement) == null ? void 0 : i.id)];
    return this.invalid && e.push(this.dataset.errorId || ((o = this.errorElement) == null ? void 0 : o.id)), e;
  }
  postSetHintElement() {
    this.setFieldAriaDescribedBy();
  }
  postSetErrorElement() {
    this.associateErrorWithField();
  }
  setFieldAriaDescribedBy(e = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const i = e.filter((n) => n);
    if (i.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    const o = i.join(" ");
    this.fieldElement.setAttribute("aria-describedby", o);
  }
  associateErrorWithField(e = ((i) => (i = this.errorElement) == null ? void 0 : i.id)()) {
    if (!this.fieldElement) return;
    const o = this.dataset.errorId || e;
    this.invalid ? o && this.fieldElement.setAttribute("aria-errormessage", o) : this.fieldElement.removeAttribute("aria-errormessage"), this.setFieldAriaDescribedBy();
  }
  handleLabelSlotchange() {
    this.labelElement = Ti.setElementFromQuery(
      this.labelElements
    );
  }
  setupSlottedFieldEventListeners() {
    var e, i;
    this.preventDisabledEventsOnElement(this.fieldElement), (e = this.fieldElement) == null || e.addEventListener(
      "invalid",
      this.handleFieldElementInvalid
    ), (i = this.fieldElement) == null || i.addEventListener(
      "change",
      this.handleFieldElementOnChange
    );
  }
  postFormControlSlotchange() {
    this.isStepper && this.fieldElement instanceof HTMLInputElement && (this.updateStepperSlottedInputValue(), this.fieldElement.value || (this.fieldElement.value = this.fieldElement.min || "1"), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState());
  }
  handleFieldElementInvalid(e) {
    var i;
    (i = this.fieldElement) == null || i.setAttribute("aria-invalid", "true");
  }
  handleFieldElementOnChange(e) {
    const i = e == null ? void 0 : e.target;
    i && (i == null ? void 0 : i.type) === "checkbox" && (this.isCheckboxChecked = i == null ? void 0 : i.checked);
  }
  applyFieldElementObserver() {
    this.fieldElement && !Te(this, Wa) && (Be(this, Wa, new MutationObserver(
      (e) => {
        e.find(
          (l) => l.attributeName === "aria-disabled" || l.attributeName === "disabled"
        ) && this.setDisabledState(), e.find(
          (l) => l.attributeName === "aria-invalid"
        ) && this.setInvalidState(), e.find(
          (l) => l.attributeName === "readonly"
        ) && this.setReadOnlyState();
      }
    )), Te(this, Wa).observe(this.fieldElement, {
      attributes: !0
    }));
  }
  updateStepperSlottedInputValue() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.addEventListener("input", (i) => {
      const o = i.target;
      o && (this.fieldElement.value = o.value, this.validatedStepper());
    });
  }
  validatedStepper() {
    var e, i;
    if (this.isStepper && this.fieldElement instanceof HTMLInputElement) {
      const o = this.fieldElement.value, n = new CustomEvent("change", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          value: o
        }
      });
      this.fieldElement.dispatchEvent(n), o.length > 1 ? this.fieldElement.style.inlineSize = o.length + 3 + "ch" : this.fieldElement.style.inlineSize = "36px", (e = this.fieldElement.parentElement) != null && e.clientWidth && ((i = this.fieldElement.parentElement) == null ? void 0 : i.clientWidth) <= no.DEFAULT && (this.fieldElement.style.inlineSize = o.length + 3.5 + "ch"), this.fieldElement.setAttribute(
        "aria-invalid",
        String(this.setStepperValidity())
      ), this.disabledMinusValue = this.setMinusButtonState(), this.disabledPlusValue = this.setPlusButtonState();
    }
  }
  setStepperValidity() {
    if (this.fieldElement instanceof HTMLInputElement) {
      const { min: e, max: i, value: o } = this.fieldElement;
      return !!(e && Number(o) < Number(e) || i && Number(o) > Number(i));
    }
    return !1;
  }
  setMinusButtonState() {
    if (this.fieldElement instanceof HTMLInputElement) {
      if (this.fieldElement.min)
        return Number(this.fieldElement.min) >= Number(this.fieldElement.value);
      if (this.fieldElement.value === "0")
        return !0;
    }
    return !1;
  }
  setPlusButtonState() {
    return this.fieldElement instanceof HTMLInputElement && this.fieldElement.max ? Number(this.fieldElement.max) <= Number(this.fieldElement.value) : !1;
  }
  incrementStepper(e) {
    var i;
    if (this.fieldElement) {
      ((i = this.fieldElement) == null ? void 0 : i.value) === "" && (this.fieldElement.value = "0");
      const o = String(this.fieldElement.value), n = Number(o != null ? o : 0) + 1;
      this.fieldElement.value = String(n), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  decrementStepper(e) {
    var i;
    if (this.fieldElement) {
      ((i = this.fieldElement) == null ? void 0 : i.value) === "" && (this.fieldElement.value = "0");
      const o = String(this.fieldElement.value), n = Number(o != null ? o : 0) - 1;
      this.fieldElement.value = String(n), this.fieldElement.defaultValue = this.fieldElement.value, this.validatedStepper();
    }
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e = this.fieldElement.getAttribute("aria-disabled");
      e === null ? this.disabled = this.fieldElement.disabled : this.disabled = e === "true";
    }
  }
  setInvalidState() {
    if (this.fieldElement) {
      const e = this.fieldElement.getAttribute("aria-invalid");
      this.invalid = e === "true", this.associateErrorWithField(), this.controlGroup && (this.controlGroup.invalid = this.invalid);
    }
  }
  setReadOnlyState() {
    (this.fieldElement instanceof HTMLInputElement || this.fieldElement instanceof HTMLTextAreaElement) && (this.readOnly = this.fieldElement.readOnly);
  }
  // Initialize `isCheckboxChecked` to match the actual checked state
  initializeIsCheckboxChecked() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.isCheckboxChecked = this.fieldElement.checked);
  }
  setSwitchRole() {
    this.fieldElement instanceof HTMLInputElement && this.fieldElement.type === "checkbox" && (this.toggleSwitch ? this.fieldElement.setAttribute("role", "switch") : this.fieldElement.removeAttribute("role"));
  }
  static setElementFromQuery(e) {
    return e[0];
  }
  static applyClassNameToField(e) {
    e && e.classList.add("beacon-control__field");
  }
  renderLabelSlot() {
    if (this.toggleSwitch) {
      const e = {
        "checkbox-checked": this.isCheckboxChecked,
        "toggle-switch-label": !0,
        label: !0
      };
      return pe`
        <span class=${Pe(e)}>
          <slot name="label">
            <span class="switch-on-label">
              <slot name="switch-on-label"></slot>
            </span>
            <span class="switch-off-label">
              <slot name="switch-off-label"></slot>
            </span>
          </slot>
        </span>
      `;
    }
    return pe`
      <div class="label" part="label">
        <slot
          name="label"
          @slotchange=${this.handleLabelSlotchange}
          ${_e({ useParent: !0 })}></slot>
      </div>
    `;
  }
  renderIcon(e) {
    return e && e === "select" ? ze`<${this.getScopedTag("beacon-icon")} name="sorted_down" size="m" class="dropdown-icon"></${this.getScopedTag("beacon-icon")}>` : je;
  }
  renderPrefix() {
    return this.isStepper ? ze`
      <div class="${Pe({
      stepper: !0,
      prefix: !0
    })}">
        <slot name="prefix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}" 
          id="decrement"
          @beacon-event-click=${this.decrementStepper}
          ?disabled=${this.disabled || this.disabledMinusValue}>
          <${this.getScopedTag("beacon-icon")} name="remove" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> decrement button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : pe`
        <div class="prefix">
          <slot name="prefix" ${_e({ useParent: !0 })}></slot>
        </div>
      `;
  }
  renderSuffix() {
    const e = this.disablePasswordToggle || this.disabled || this.readOnly;
    if (this._inputType === "password" && !e) {
      const i = {
        password: !0,
        "password-visible": this.passwordVisible,
        suffix: !0
      };
      return ze`
        <div class="${Pe(i)}">
          <slot name="suffix">
            <${this.getScopedTag("beacon-button")} class="password-toggle" variant="tertiary" scale="mini" @beacon-event-click=${this.handleTogglePassword}>
              <span class="show-password">
                <slot name="show-password">Show</slot>
              </span>
              <span class="hide-password">
                <slot name="hide-password">Hide</slot>
              </span>
            </${this.getScopedTag("beacon-button")}>
          </slot>
        </div>
      `;
    }
    return this.isStepper ? ze`
      <div class="${Pe({
      stepper: !0,
      suffix: !0
    })}">
        <slot name="suffix">
          <${this.getScopedTag("beacon-icon-button")} 
          class="beacon-stepper-button" 
          variant="${this.stepperVariant}"
          id="increment" 
          @beacon-event-click=${this.incrementStepper}
          ?disabled=${this.disabled || this.disabledPlusValue}>
          <${this.getScopedTag("beacon-icon")} name="add" size="s" slot="icon"></${this.getScopedTag("beacon-icon")}> increment button
          </${this.getScopedTag("beacon-icon-button")}>
        </slot>
      </div>
      ` : pe`
        <div class="suffix">
          <slot name="suffix" ${_e({ useParent: !0 })}></slot>
        </div>
      `;
  }
  handleTogglePassword(e) {
    var i, o;
    this.passwordVisible = !this.passwordVisible, this.passwordVisible ? (i = this.fieldElement) == null || i.setAttribute("type", "text") : (o = this.fieldElement) == null || o.setAttribute("type", "password");
  }
  // helps with syncing the browser UI with our modes
  setColorSchemeCSS() {
    const e = this.closest('[class*="beacon-on"]');
    if (e) {
      const i = Array.from(
        e.classList
      ).find((o) => o.startsWith("beacon-on"));
      i != null && i.includes("dark") && (this.dataset.mode = "dark");
    }
  }
  render() {
    const e = {
      active: this.inline,
      "inline-wrapper": !0
    }, i = {
      group: !0,
      inline: this.inline
    }, o = {
      disabled: this.disabled,
      field: !0,
      readonly: this.readOnly,
      invalid: this.invalid,
      stepper: this.isStepper
    };
    return this._inputType && (o[this._inputType] = !0), pe`
      <div class="${Pe(e)}">
        <div class="${Pe(i)}">
          ${this.renderLabelSlot()}
          <!-- prettier-ignore -->
          <div class="${Pe(o)}" part="field">
          ${this.renderPrefix()}
          ${this.renderFormControlTemplate()}
          ${this.renderIcon(this._inputType)}
          ${this.renderSuffix()}
        </div>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </div>
    `;
  }
}, Wa = new WeakMap(), Ps = new WeakMap(), Ti.tagName = dg.beaconTagName, Ti.nestedComponents = [
  ec,
  Er,
  ro,
  Qt
], Ti);
Jt([
  ue({ type: Boolean })
], qt.prototype, "inline", 2);
Jt([
  ue({ type: Boolean, attribute: "disable-password-toggle" })
], qt.prototype, "disablePasswordToggle", 2);
Jt([
  ue({ type: Boolean, attribute: "disable-toggle-switch-label" })
], qt.prototype, "disableToggleSwitchLabel", 2);
Jt([
  ue({ type: Boolean, reflect: !0, attribute: "non-resizable" })
], qt.prototype, "nonResizable", 2);
Jt([
  ue({ type: Boolean, reflect: !0, attribute: "toggle-switch" })
], qt.prototype, "toggleSwitch", 2);
Jt([
  ue({ type: Boolean, reflect: !0 })
], qt.prototype, "readOnly", 2);
Jt([
  ue({ type: String, reflect: !0, attribute: "stepper-variant" })
], qt.prototype, "stepperVariant", 2);
Jt([
  Ce()
], qt.prototype, "disabledMinusValue", 2);
Jt([
  Ce()
], qt.prototype, "disabledPlusValue", 2);
Jt([
  Ce()
], qt.prototype, "passwordVisible", 2);
Jt([
  Ce()
], qt.prototype, "isCheckboxChecked", 2);
Jt([
  We("[toggle-password]")
], qt.prototype, "passwordToggleButton", 2);
Jt([
  Ct({ flatten: !0, slot: "label" })
], qt.prototype, "labelElements", 2);
Jt([
  Ct({
    flatten: !0,
    slot: "suffix",
    selector: "[toggle-password]"
  })
], qt.prototype, "togglePasswordButtons", 2);
Jt([
  Re
], qt.prototype, "setColorSchemeCSS", 1);
let Uc = qt;
const hg = {
  beaconTagName: "beacon-control-group"
}, RM = ve`[beacon-tag-name=beacon-control-group]>[slot=label]:not(label){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control] [slot=label]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input)[toggle-switch] [slot=label]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input[aria-disabled=true],:disabled) [slot=label]{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has([type=radio],[type=checkbox]){padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--beacon-reference-space-3)}`, NM = ve`fieldset{border:0;margin:0;padding:0}legend{margin-block-end:var(--beacon-reference-space-3);padding:0}.error:not(.visible){display:none}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.hint,.error{margin-block-start:var(--beacon-reference-space-3)}`;
var FM = Object.defineProperty, jM = Object.getOwnPropertyDescriptor, $c = (a, t, e, i) => {
  for (var o = jM(t, e), n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && FM(t, e, o), o;
}, Zn, Jn;
const cc = class cc extends Ge(Le).with(
  Cb,
  mv,
  kb
) {
  constructor() {
    super(...arguments);
    Ie(this, Zn);
    Ie(this, Jn);
    this.beaconTagName = hg.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, Be(this, Zn, !1), Be(this, Jn, "false");
  }
  static get styles() {
    return [super.styles, NM];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, RM];
  }
  get required() {
    return Te(this, Zn);
  }
  set required(e) {
    Be(this, Zn, e), this.controls.length > 0 && this.controls.forEach((i) => this.setRequiredToField(i));
  }
  _postSetDisabled() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setDisabledToField(e));
  }
  get isAriaDisabled() {
    return Te(this, Jn);
  }
  set isAriaDisabled(e) {
    Be(this, Jn, e), this.controls.length > 0 && this.controls.forEach((i) => this.setDisabledToField(i, "aria"));
  }
  _postSetInvalid() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setInvalidToField(e));
  }
  get controls() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-control"]')
    );
  }
  getAriaDescribedByIds() {
    var i, o;
    const e = [(i = this.hintElement) == null ? void 0 : i.id];
    return this.invalid && e.push((o = this.errorElement) == null ? void 0 : o.id), e;
  }
  handleSlottedControlFieldSet(e) {
    const { target: i } = e;
    i && (this.disabled && this.setDisabledToField(i), this.isAriaDisabled && this.setDisabledToField(i, "aria"), this.invalid && this.setInvalidToField(i), this.required && this.setRequiredToField(i), this.setHintDataId(i), i.setFieldAriaDescribedBy(
      this.getAriaDescribedByIds()
    ));
  }
  setRequiredToField(e) {
    e.fieldElement && (e.fieldElement.required = this.required);
  }
  setDisabledToField(e, i = "boolean") {
    e.fieldElement && (i === "boolean" && (e.fieldElement.disabled = this.disabled), i === "aria" && e.fieldElement.setAttribute(
      "aria-disabled",
      String(this.isAriaDisabled)
    ));
  }
  setInvalidToField(e) {
    var i;
    e.fieldElement && (e.dataset.errorId = (i = this.errorElement) == null ? void 0 : i.id, e.fieldElement.setAttribute("aria-invalid", String(this.invalid)));
  }
  setHintDataId(e) {
    var i, o;
    e.fieldElement && ((i = this.hintElement) != null && i.id) && (e.dataset.hintId = (o = this.hintElement) == null ? void 0 : o.id);
  }
  render() {
    return pe`
      <fieldset>
        <legend>
          <slot name="label" ${_e({ useParent: !0 })}></slot>
        </legend>
        <div class="controls">
          <slot
            @beacon-event-control-set=${this.handleSlottedControlFieldSet}></slot>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </fieldset>
    `;
  }
};
Zn = new WeakMap(), Jn = new WeakMap(), cc.tagName = hg.beaconTagName, cc.nestedComponents = [ec];
let hr = cc;
$c([
  ue({ type: Boolean, reflect: !0 })
], hr.prototype, "required");
$c([
  Gt("disabled")
], hr.prototype, "_postSetDisabled");
$c([
  ue({ attribute: "aria-disabled" })
], hr.prototype, "isAriaDisabled");
$c([
  Gt("invalid")
], hr.prototype, "_postSetInvalid");
const _M = /* @__PURE__ */ new Map([
  ["united_states", "usa"],
  ["mainland_china", "china"],
  ["asia_regional", "apac"]
]), UM = {
  irregularFlagNamesMap: _M
}, $M = ve`::slotted([slot=icon]),svg{block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-6)}`;
var HM = Object.defineProperty, KM = Object.getOwnPropertyDescriptor, wl = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? KM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && HM(t, e, o), o;
};
function GM(a) {
  let t = class extends a {
    static get flagStyles() {
      return [$M];
    }
    /** The text inside the element that is in the title slot */
    get title() {
      const e = this.querySelector('[slot="title"]');
      return e && e instanceof HTMLElement ? e.innerText : "";
    }
    get flagSVG() {
      var e;
      return (e = this.slottedFlag) != null ? e : this.shadowFlag;
    }
    /** Callback for on beacon-event-country-flag-change */
    onBeaconCountryFlagChange() {
    }
    emitFlagChange() {
      Fe(
        this,
        Ee.COUNTRY_FLAG_CHANGE,
        void 0,
        this.onBeaconCountryFlagChange
      );
    }
    handleFlagSlotchange() {
      this.emitFlagChange();
    }
    static createFlagName(e) {
      e = e.toLowerCase().replace(" ", "_");
      const i = UM.irregularFlagNamesMap.get(e);
      return Af.get(e) === "flags" ? e : i !== void 0 ? i : "usa";
    }
    renderFlagContainer() {
      const e = this.title, i = t.createFlagName(e);
      return ze`<slot name="icon" @slotchange=${this.handleFlagSlotchange}
        ><${this.getScopedTag("beacon-icon")} name="${i}" id="${i}"></${this.getScopedTag("beacon-icon")}></slot
      >`;
    }
    /** HTML for the title container. */
    renderTitleContainer() {
      return pe`<div class="title">
        <slot name="title"></slot>
      </div>`;
    }
    postrenderFlagChange() {
      this.emitFlagChange();
    }
  };
  return wl([
    We('slot[name="icon"] > *')
  ], t.prototype, "shadowFlag", 2), wl([
    An('[slot="icon"]')
  ], t.prototype, "slottedFlag", 2), wl([
    Re
  ], t.prototype, "postrenderFlagChange", 1), t = wl([
    $e("Flags")
  ], t), t;
}
function Dr(a, t) {
  return a.has(t) && typeof a.get(t) < "u";
}
function wv(a) {
  if (!a)
    return [];
  const t = [a];
  return a.children.length === 0 || Array.from(a.children).forEach((e) => {
    const i = wv(e);
    i && t.push(...i);
  }), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const bg = (a) => tM(a) ? a._$litType$.h : a.strings, WM = Ri(class extends Ni {
  constructor(a) {
    super(a), this.et = /* @__PURE__ */ new WeakMap();
  }
  render(a) {
    return [a];
  }
  update(a, [t]) {
    const e = tg(this.it) ? bg(this.it) : null, i = tg(t) ? bg(t) : null;
    if (e !== null && (i === null || e !== i)) {
      const o = Eh(a).pop();
      let n = this.et.get(e);
      if (n === void 0) {
        const l = document.createDocumentFragment();
        n = Ws(je, l), n.setConnected(!1), this.et.set(e, n);
      }
      Sh(n, [o]), _a(n, void 0, o);
    }
    if (i !== null) {
      if (e === null || e !== i) {
        const o = this.et.get(i);
        if (o !== void 0) {
          const n = Eh(o).pop();
          iM(a), _a(a, void 0, n), Sh(a, [n]);
        }
      }
      this.it = t;
    } else this.it = void 0;
    return this.render(t);
  }
});
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const kv = "important", VM = " !" + kv, Cv = Ri(class extends Ni {
  constructor(a) {
    var t;
    if (super(a), a.type !== gn.ATTRIBUTE || a.name !== "style" || ((t = a.strings) == null ? void 0 : t.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(a) {
    return Object.keys(a).reduce((t, e) => {
      const i = a[e];
      return i == null ? t : t + `${e = e.includes("-") ? e : e.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${i};`;
    }, "");
  }
  update(a, [t]) {
    const { style: e } = a.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
    for (const i of this.ft) t[i] == null && (this.ft.delete(i), i.includes("-") ? e.removeProperty(i) : e[i] = null);
    for (const i in t) {
      const o = t[i];
      if (o != null) {
        this.ft.add(i);
        const n = typeof o == "string" && o.endsWith(VM);
        i.includes("-") || n ? e.setProperty(i, n ? o.slice(0, -11) : o, n ? kv : "") : e[i] = o;
      }
    }
    return ei;
  }
}), qM = ve`:root,.beacon-on-light{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-skeleton-color-start-fallback: #CCCCCC;--beacon-component-skeleton-color-end-fallback: #8C8C8C;--beacon-component-form-color-background-inactive: #FFFFFFE0;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard-inverse: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-skeleton-color-start: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 20%, var(--beacon-reference-palette-grayscale-white));--beacon-component-skeleton-color-end: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 45%, var(--beacon-reference-palette-grayscale-white));--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-lighter{--beacon-system-color-background-tertiary-pressed: #0063AD1F;--beacon-system-color-background-tertiary-hover: #0063AD14;--beacon-system-color-background-secondary-pressed: #0063AD1F;--beacon-system-color-background-secondary-hover: #0063AD14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-skeleton-color-start-fallback: #CCCCCC;--beacon-component-skeleton-color-end-fallback: #8C8C8C;--beacon-component-form-color-background-inactive: #F4F5F6B8;--beacon-system-color-text-title: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-standard-inverse: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-text-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-text-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-grayscale-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-grayscale-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-grayscale-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-lt-5);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-lt-3);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-lt-5);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-lt-3);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-lt-5);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-lt-2);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-border-secondary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-black);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-border-2: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-border-1: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-system-color-border-0: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-1);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-2);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-3);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-background-1: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-system-color-background-0: var(--beacon-reference-palette-grayscale-white);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-6);--beacon-component-skeleton-color-start: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 20%, var(--beacon-reference-palette-grayscale-white));--beacon-component-skeleton-color-end: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 45%, var(--beacon-reference-palette-grayscale-white));--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-dark-gray-1);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-dark-gray-2);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-1);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-3);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-functional-blue-3);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-2);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-5);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-light-gray-2)}.beacon-on-dark{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-skeleton-color-start-fallback: #00467A;--beacon-component-skeleton-color-end-fallback: #4079A3;--beacon-component-form-color-background-inactive: #061937B8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard-inverse: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-skeleton-color-start: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 8%, var(--beacon-reference-palette-secondary-ocean-1));--beacon-component-skeleton-color-end: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-white) 25%, var(--beacon-reference-palette-secondary-ocean-1));--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}.beacon-on-darker{--beacon-system-color-background-tertiary-pressed: #FFFFFF1F;--beacon-system-color-background-tertiary-hover: #FFFFFF14;--beacon-system-color-background-secondary-pressed: #FFFFFF1F;--beacon-system-color-background-secondary-hover: #FFFFFF14;--beacon-system-color-background-blanket: #061937A3;--beacon-component-skeleton-color-start-fallback: #00467A;--beacon-component-skeleton-color-end-fallback: #4079A3;--beacon-component-form-color-background-inactive: #0C2A4DB8;--beacon-system-color-text-title: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-standard-inverse: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-text-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-text-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-text-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-text-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-text-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-shadow-low: 0rem 0rem var(--beacon-reference-space-2) 0rem var(--beacon-reference-palette-primary-shadow-1);--beacon-system-color-shadow-high: 0rem 0rem var(--beacon-reference-space-7) 0rem var(--beacon-reference-palette-primary-shadow-3);--beacon-system-color-shadow-medium: 0rem 0rem var(--beacon-reference-space-4) 0rem var(--beacon-reference-palette-primary-shadow-2);--beacon-system-color-icon-tertiary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-tertiary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-tertiary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-standard: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-white: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-set-navy: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-icon-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-icon-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-system-color-icon-primary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-icon-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-icon-link-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-icon-highlight: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-icon-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-data-viz-11: var(--beacon-reference-palette-charts-gray-dt-4);--beacon-system-color-data-viz-10: var(--beacon-reference-palette-charts-gray-dt-1);--beacon-system-color-data-viz-9: var(--beacon-reference-palette-charts-orange-dt-4);--beacon-system-color-data-viz-8: var(--beacon-reference-palette-charts-orange-dt-1);--beacon-system-color-data-viz-7: var(--beacon-reference-palette-charts-berry-dt-4);--beacon-system-color-data-viz-6: var(--beacon-reference-palette-charts-berry-dt-1);--beacon-system-color-border-secondary-pressed: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-border-secondary-hover: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-secondary: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-border-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-border-link-focus: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-link: var(--beacon-reference-palette-functional-blue-9);--beacon-system-color-border-focus-outer: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-border-focus-middle: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-focus-inner: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-error: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-border-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-border-active: var(--beacon-reference-palette-grayscale-white);--beacon-system-color-border-2: #FFFFFF33;--beacon-system-color-border-1: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-border-0: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-primary-pressed: var(--beacon-reference-palette-functional-blue-4);--beacon-system-color-background-primary-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-system-color-background-primary-hover: var(--beacon-reference-palette-functional-blue-5);--beacon-system-color-background-primary: var(--beacon-reference-palette-functional-blue-6);--beacon-system-color-background-positive-pressed: var(--beacon-reference-palette-functional-green-1);--beacon-system-color-background-positive-hover: var(--beacon-reference-palette-functional-green-2);--beacon-system-color-background-positive: var(--beacon-reference-palette-functional-green-3);--beacon-system-color-background-negative-pressed: var(--beacon-reference-palette-functional-red-1);--beacon-system-color-background-negative-hover: var(--beacon-reference-palette-functional-red-2);--beacon-system-color-background-negative: var(--beacon-reference-palette-functional-red-3);--beacon-system-color-background-link-focus: var(--beacon-reference-palette-secondary-gold-2);--beacon-system-color-background-brand: var(--beacon-reference-palette-primary-bright-blue-2);--beacon-system-color-background-2: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-system-color-background-1: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-system-color-background-0: var(--beacon-reference-palette-primary-midnight-navy-1);--beacon-component-tile-collection-color-border-green: var(--beacon-reference-palette-secondary-green-3);--beacon-component-tile-collection-color-border-gold: var(--beacon-reference-palette-secondary-gold-3);--beacon-component-tile-collection-color-border-blue: var(--beacon-reference-palette-secondary-ocean-3);--beacon-component-tile-collection-color-border-berry: var(--beacon-reference-palette-secondary-berry-3);--beacon-component-tile-collection-color-background-green: var(--beacon-reference-palette-secondary-green-1);--beacon-component-tile-collection-color-background-gold: var(--beacon-reference-palette-secondary-gold-1);--beacon-component-tile-collection-color-background-blue: var(--beacon-reference-palette-functional-blue-2);--beacon-component-tile-collection-color-background-berry: var(--beacon-reference-palette-secondary-berry-1);--beacon-component-table-color-border: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-tab-menu-color-background-primary-active: var(--beacon-reference-palette-functional-blue-3);--beacon-component-skeleton-color-start: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-black) 8%, var(--beacon-reference-palette-secondary-ocean-1));--beacon-component-skeleton-color-end: color-mix(in srgb-linear, var(--beacon-reference-palette-grayscale-white) 25%, var(--beacon-reference-palette-secondary-ocean-1));--beacon-component-scrollbar-color-background-track: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-scrollbar-color-background-thumb-pressed: var(--beacon-reference-palette-grayscale-light-gray-4);--beacon-component-scrollbar-color-background-thumb-hover: var(--beacon-reference-palette-grayscale-light-gray-3);--beacon-component-scrollbar-color-background-thumb: var(--beacon-reference-palette-grayscale-light-gray-2);--beacon-component-progress-indicator-color-background-incomplete: var(--beacon-reference-palette-grayscale-dark-gray-3);--beacon-component-progress-indicator-color-background-complete: var(--beacon-reference-palette-functional-blue-9);--beacon-component-notification-color-border-informational: var(--beacon-reference-palette-functional-blue-6);--beacon-component-notification-color-background-standard: var(--beacon-reference-palette-primary-midnight-navy-2);--beacon-component-primary-navigation-site-menu-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-primary-navigation-header-color-text-link: var(--beacon-reference-palette-grayscale-white);--beacon-component-form-color-foreground-inactive: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-form-color-border-standard: var(--beacon-reference-palette-grayscale-medium-gray-3);--beacon-component-data-viz-color-border-minor: var(--beacon-reference-palette-grayscale-medium-gray-1);--beacon-component-data-viz-color-border-major: var(--beacon-reference-palette-grayscale-medium-gray-4);--beacon-component-control-chip-color-background-default: var(--beacon-reference-palette-grayscale-dark-gray-4);--beacon-component-avatar-icon-color-background: var(--beacon-reference-palette-grayscale-light-gray-1);--beacon-component-avatar-icon-color-avatar: var(--beacon-reference-palette-grayscale-medium-gray-3)}`;
var YM = Object.defineProperty, XM = Object.getOwnPropertyDescriptor, Sv = (a) => {
  throw TypeError(a);
}, kl = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? XM(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && YM(t, e, o), o;
}, QM = (a, t, e) => t.has(a) || Sv("Cannot " + e), Hr = (a, t, e) => (QM(a, t, "read from private field"), e ? e.call(a) : t.get(a)), Cl = (a, t, e) => t.has(a) ? Sv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e);
const Ev = '[beacon-tag-name="beacon-navigation"]', pg = () => {
  throw new Error(
    "Component does not implement WatchMedia. Please use the WatchMedia mixin to correctly apply this method."
  );
}, ZM = {
  onReady: !0,
  removeLargeEvent: !1,
  selector: Ev
};
function JM(a) {
  return !!(a && a.currentMode);
}
function Sb({
  onReady: a,
  removeLargeEvent: t,
  selector: e
} = ZM) {
  const i = e != null ? e : Ev;
  return function(o) {
    var n, l, L, D;
    let j = class extends o {
      constructor() {
        super(...arguments), this.innerModeClass = "beacon-on-light", this.modeClasses = {
          "beacon-on-light": "beacon-on-darker",
          "beacon-on-lighter": "beacon-on-dark",
          "beacon-on-dark": "beacon-on-lighter",
          "beacon-on-darker": "beacon-on-light"
        }, this.setInverseModeState = () => {
          if (this.modeStoreComponent instanceof HTMLElement && "currentMode" in this.modeStoreComponent) {
            const { currentMode: I } = this.modeStoreComponent;
            this.innerModeClass = this.determineModeClass(I);
          }
        }, Cl(this, n, () => {
          this.innerModeClass && this.classList.add(this.innerModeClass);
        }), Cl(this, l, () => {
          this.innerModeClass && this.classList.remove(this.innerModeClass);
        }), Cl(this, L, ({ target: I }) => {
          I instanceof HTMLElement && this === I && (this.modeStoreComponent = this.findModeStore(this), this.setInverseModeState(), "isDesktop" in this ? this.isDesktop && a && Hr(this, n).call(this) : pg());
        }), Cl(this, D, ({ matches: I }) => {
          "isDesktop" in this && (I ? Hr(this, n).call(this) : Hr(this, l).call(this));
        });
      }
      static get inverseStyles() {
        return [qM];
      }
      /** Recursive method for finding the parent `<beacon-navigation>` component. */
      findModeStore(I) {
        var R;
        const B = I.closest(i) || ((R = this.getClosestHost()) == null ? void 0 : R.closest(i));
        return JM(B) ? B : null;
      }
      /** Return the opposite mode based on the current mode. */
      determineModeClass(I) {
        return this.modeClasses[I] || "beacon-on-light";
      }
      /** Returns only light mode opposites of the innerModeClass */
      determineModeClassOfOnlyLightModeOpposites() {
        return this.innerModeClass === "beacon-on-light" ? "beacon-on-light" : this.innerModeClass === "beacon-on-lighter" ? "beacon-on-lighter" : this.innerModeClass === "beacon-on-dark" ? "beacon-on-light" : "beacon-on-lighter";
      }
      prerenderInverseModeSetup() {
        this.addEventListener(
          Ee.ELEMENT_READY,
          Hr(this, L)
        ), "largeBreakpointWatcher" in this ? t || this.largeBreakpointWatcher.addEventListener(
          "change",
          Hr(this, D)
        ) : pg();
      }
    };
    return n = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), kl([
      Ce()
    ], j.prototype, "innerModeClass", 2), kl([
      Ce()
    ], j.prototype, "modeStoreComponent", 2), kl([
      qe
    ], j.prototype, "prerenderInverseModeSetup", 1), j = kl([
      $e("InverseMode")
    ], j), j;
  };
}
const eT = [
  "beacon-on-light",
  "beacon-on-lighter",
  "beacon-on-dark",
  "beacon-on-darker"
];
function tT(a) {
  return eT.includes(a);
}
var oT = Object.defineProperty, iT = Object.getOwnPropertyDescriptor, Yd = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? iT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && oT(t, e, o), o;
};
function aT(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.currentMode = "beacon-on-light";
    }
    setCurrentMode() {
      const e = '[class*="beacon-on-"]', i = this.getClosestHost();
      let o = null, n;
      return i ? o = i.closest(e) : o = this.closest(e), o && (n = Array.from(o.classList).find(
        (L) => L.startsWith("beacon-on-")
      )), n && tT(n) ? n : "beacon-on-light";
    }
    setCurrentContext({ target: e }) {
      e instanceof HTMLElement && this === e && (this.currentMode = this.setCurrentMode());
    }
    modeStoreInit() {
      this.setCurrentContext = this.setCurrentContext.bind(this), this.addEventListener(Ee.ELEMENT_READY, this.setCurrentContext);
    }
  };
  return Yd([
    Ce()
  ], t.prototype, "currentMode", 2), Yd([
    qe
  ], t.prototype, "modeStoreInit", 1), t = Yd([
    $e("ModeStore")
  ], t), t;
}
const Vo = {
  header: "HDR",
  siteNav: "TN"
}, Zi = {
  0: "Hdr_lvl0",
  1: "Hdr_lvl1"
}, Yn = {
  level_1: "TN_lvl1",
  level_2: "TN_lvl2",
  level_3: "TN_lvl3",
  level_4: "TN_lvl4"
}, It = {
  prefix: "data-metrics",
  get location() {
    return `${this.prefix}-location`;
  },
  get section() {
    return `${this.prefix}-section`;
  }
}, qo = {
  selectedLink: "Site_lvl0",
  links: "Site_lvl1_SiteSelector",
  level1LangSelector: "Site_lvl1_LocLangSelector",
  level2LangSelector: "Site_lvl2_LocLangSelector"
};
function ug(a) {
  switch (a) {
    case 1:
      return Yn.level_2;
    case 2:
      return Yn.level_3;
    case 3:
      return Yn.level_4;
    default:
      return null;
  }
}
const nT = `<svg xmlns="http://www.w3.org/2000/svg" width="2" height="16" viewBox="0 0 1 16" class="vertical-divider-brand" fill="none">
<rect width="2" height="16" fill="var(--beacon-system-color-border-brand)"/>
</svg>`, rT = `<svg xmlns="http://www.w3.org/2000/svg" width="1" height="16" viewBox="0 0 1 16" class="vertical-divider" fill="none">
<rect width="1" height="16" fill="var(--beacon-system-color-border-0)"/>
</svg>`, gg = `<svg width="132" height="24" viewBox="0 0 132 24" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
  <title>T. Rowe Price</title>
  <path d="M30.0123 1C33.5023 1 35.1214 2.61256 35.1214 5.21501C35.1214 8.95902 32.3506 9.95762 30.9819 10.3299C32.1888 11.5767 36.6237 19.1932 36.6237 19.1932C37.0076 19.8703 37.5432 20.4915 38.6695 20.4915L38.766 21.2317C38.4053 21.3138 37.9227 21.4894 36.8349 21.4894C34.5525 21.4894 33.236 20.9727 31.0073 17.3252C29.3664 14.6385 28.3439 12.3634 26.6624 9.79288H27.3634C29.6625 9.79288 31.2381 8.55624 31.2381 5.83695C31.2381 3.64672 30.6357 2.30195 27.9346 2.30195H26.2248C25.9171 2.30195 25.8184 2.43766 25.8184 2.75408V18.3216C25.8184 18.9406 26.5006 18.9559 27.4846 19.1417L27.7829 19.998H20.1069L20.4052 19.1417C21.3922 18.9559 22.0715 18.9406 22.0715 18.3216V2.68295C22.0715 2.06101 21.3922 2.04577 20.4052 1.85708L20.1069 1H30.0123ZM125.807 7.0344C130.506 7.0344 131.292 11.2857 131.39 12.7234L130.67 13.3917H123.341C123.341 16.5138 124.785 18.8202 127.503 18.8202C128.753 18.8202 129.777 18.2033 130.101 17.9994L130.199 18.8956C129.724 19.3093 128.393 20.4545 125.815 20.4545C121.567 20.4545 119.851 17.2519 119.851 13.743C119.851 11.5295 120.504 7.0344 125.807 7.0344ZM72.5122 7.0344C77.2149 7.0344 78.0067 11.2857 78.101 12.7234L77.3847 13.3917H70.0527C70.0527 16.5138 71.4948 18.8202 74.2162 18.8202C75.4645 18.8202 76.4834 18.2033 76.8158 17.9994L76.9108 18.8956C76.4362 19.3093 75.1023 20.4545 72.5296 20.4545C68.2791 20.4545 66.5598 17.2519 66.5598 13.743C66.5598 11.5295 67.2108 7.0344 72.5122 7.0344ZM43.3178 7.0344C47.3905 7.0344 49.5742 9.84876 49.5742 13.7372C49.5742 17.4631 47.5183 20.4545 43.3178 20.4545C39.1187 20.4545 37.0671 17.4957 37.0671 13.7372C37.0344 10.0984 39.0752 7.0344 43.3178 7.0344ZM115 7.0344C117.29 7.0344 118.76 7.57434 118.917 7.62078L118.274 11.6471H117.382C117.076 9.39954 116.397 8.25071 114.786 8.25071C112.671 8.25071 111.989 10.7385 111.989 13.2444C111.989 16.3542 113.669 18.8202 116.477 18.8202C117.591 18.8202 118.745 18.2352 119.119 17.9994L119.215 18.8956C118.797 19.2324 117.334 20.4509 114.977 20.4509C110.454 20.4509 108.485 17.1212 108.485 13.5507C108.485 9.15061 111.161 7.0344 115 7.0344ZM16 16.6024C16.9761 16.6024 17.7744 17.3934 17.7744 18.3746C17.7744 19.3565 16.9761 20.149 16 20.149C15.0116 20.149 14.2206 19.3565 14.2206 18.3746C14.2206 17.3934 15.0116 16.6024 16 16.6024ZM106.583 7.10044L106.578 18.5074C106.75 19.0263 107.57 18.9936 108.082 19.1417C108.269 19.4813 108.251 19.4174 108.446 19.998H101.612C101.882 19.5517 101.868 19.4682 102.048 19.1417C102.537 18.9087 103.2 18.9276 103.306 18.294V7.60119C104.356 7.40452 105.488 7.29276 106.583 7.10044ZM15.4957 1L15.7047 5.89574H14.7823C14.3403 3.82525 14.2481 2.70981 12.8802 2.70981H9.72616V18.3216C9.72616 18.9406 10.4054 18.9559 11.3888 19.1417L11.6907 19.998H4.01326L4.31298 19.1417C5.29344 18.9559 5.97852 18.9406 5.97852 18.3216V2.70981H2.81871C1.45217 2.70981 1.35856 3.82525 0.918041 5.89574H0L0.206831 1H15.4957ZM55.7487 7.48798L55.4454 8.34433C54.5542 8.50181 54.3277 8.74638 54.3277 9.17746C54.3277 9.47211 54.4431 9.92351 54.5505 10.3887L54.5823 10.5217C54.8805 11.7744 54.9399 12.1122 55.5832 14.6981L57.8199 7.48798H59.9485L62.1177 14.7496C62.1177 14.7496 62.9203 11.4657 63.3855 9.53597C63.4494 9.28415 63.4871 9.08094 63.4871 8.90241C63.4871 8.55624 63.1424 8.47787 62.4428 8.34433L62.1423 7.48798H67.2892L66.9909 8.34433C66.2013 8.48367 65.5743 8.52867 65.2884 9.47719L62.5067 19.998H60.3861L58.0115 12.5412L55.7342 19.998H53.6949L50.6694 9.0091C50.5462 8.59062 49.9835 8.48553 49.3897 8.38703L49.1345 8.34433L48.8318 7.48798H55.7487ZM90.0182 1C93.5706 1 95.1251 2.64739 95.1251 5.31588C95.1251 6.37762 94.8145 7.30219 94.5568 7.72529L97.3066 6.96546V9.37704C98.2 8.20935 99.7719 6.95094 101.849 7.03367L101.114 11.6471H100.225C100.043 10.3829 99.6681 9.67168 98.8821 9.67168C98.0127 9.67168 97.5657 10.343 97.3095 10.7131L97.311 18.3216C97.311 18.9406 97.9939 18.9559 98.9765 19.1417L99.2755 19.998H92.0705L92.3709 19.1417C93.355 18.9559 94.0401 18.9406 94.0401 18.3216V9.98447C94.0401 9.41115 93.8122 9.16876 93.4748 9.09183C92.9189 9.60274 90.7918 10.9881 88.6509 10.9881C88.0565 10.9881 87.5231 10.9105 87.3555 10.8887L86.6653 9.79288H87.4295C89.8411 9.79288 91.2388 8.36102 91.2388 5.81881C91.2388 3.63293 90.6292 2.30195 87.8461 2.30195H86.2313C85.9062 2.30195 85.8235 2.45725 85.8235 2.76206V18.3216C85.8235 18.9406 86.5027 18.9559 87.4897 19.1417L87.7865 19.998H80.1069L80.4103 19.1417C81.3922 18.9559 82.0715 18.9406 82.0715 18.3216V2.68295C82.0715 2.06101 81.3922 2.04577 80.4103 1.85708L80.1069 1H90.0182ZM43.3178 8.25071C41.0513 8.25071 40.7284 10.835 40.7284 13.7372C40.7284 17.6801 41.4831 19.236 43.3178 19.236C45.1916 19.236 45.913 17.5683 45.913 13.7372C45.913 10.0215 45.2605 8.25071 43.3178 8.25071ZM125.751 8.25071C123.689 8.25071 123.407 10.8648 123.407 12.2074H128.098C128.098 10.7247 127.736 8.25071 125.751 8.25071ZM72.4643 8.25071C70.4062 8.25071 70.121 10.8648 70.121 12.2074H74.8062C74.8062 10.7247 74.4514 8.25071 72.4643 8.25071ZM105 2.51459C105.991 2.51459 106.791 3.31796 106.791 4.3064C106.791 5.29266 105.991 6.09604 105 6.09604C104.011 6.09604 103.207 5.29266 103.207 4.3064C103.207 3.31796 104.011 2.51459 105 2.51459Z"/>
</svg>`;
var sT = Object.defineProperty, lT = Object.getOwnPropertyDescriptor, gi = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? lT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && sT(t, e, o), o;
};
const cT = {
  skipFirstUpdated: !1,
  runOnSlotchange: !1
};
function al({
  skipFirstUpdated: a,
  runOnSlotchange: t
} = cT) {
  return function(e) {
    let i = class extends e {
      /**
       * @abstract
       */
      updateAnalytics() {
      }
      prerenderAnalyticsSetup() {
        t && this.addEventListener("slotchange", this.updateAnalytics);
      }
      postrenderAnalyticsSetup() {
        a || this.updateAnalytics();
      }
      willUpdate(o) {
        super.willUpdate(o), o.has("metricsSection") && this.metricsSection && Fe(
          this,
          Ee.METRICS_SECTION_CHANGE,
          !!this.onBeaconAnalyticsSectionChange && this.onBeaconAnalyticsSectionChange()
        ), o.has("metricsLocation") && this.metricsLocation && Fe(
          this,
          Ee.METRICS_LOCATION_CHANGE,
          !!this.onBeaconAnalyticsLocationChange && this.onBeaconAnalyticsLocationChange()
        ), o.has("metricsID") && this.metricsID && Fe(
          this,
          Ee.METRICS_ID_CHANGE,
          !!this.onBeaconAnalyticsIdChange && this.onBeaconAnalyticsIdChange()
        );
      }
    };
    return gi([
      ue({ attribute: "data-metrics-section", reflect: !0 })
    ], i.prototype, "metricsSection", 2), gi([
      ue({ attribute: "data-metrics-location" })
    ], i.prototype, "metricsLocation", 2), gi([
      ue({ attribute: "data-id" })
    ], i.prototype, "metricsID", 2), gi([
      ue({ type: Function })
    ], i.prototype, "onBeaconAnalyticsSectionChange", 2), gi([
      ue({ type: Function })
    ], i.prototype, "onBeaconAnalyticsIdChange", 2), gi([
      ue({ type: Function })
    ], i.prototype, "onBeaconAnalyticsLocationChange", 2), gi([
      qe
    ], i.prototype, "prerenderAnalyticsSetup", 1), gi([
      Re
    ], i.prototype, "postrenderAnalyticsSetup", 1), i = gi([
      $e("Analytics")
    ], i), i;
  };
}
const mg = (a, t, e) => !e || a < e.left || a > e.right || t < e.top || t > e.bottom;
function Mh(a, t = 50) {
  a instanceof HTMLElement && setTimeout(() => {
    a.focus();
  }, t);
}
const qr = "beacon-scroll-block";
function Eb() {
  var a;
  if (!document.getElementById(qr)) {
    const t = document.createElement("style");
    t.setAttribute("id", qr), t.innerHTML = `.${qr}{
      block-size: 100dvh !important;
      overflow: hidden !important;
    }`, (a = document.querySelector("head")) == null || a.appendChild(t);
  }
  document.body.classList.add(qr);
}
function ks() {
  document.body.classList.remove(qr);
}
var dT = Object.defineProperty, hT = Object.getOwnPropertyDescriptor, Nn = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? hT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && dT(t, e, o), o;
};
function Mv(a) {
  let t = class extends a {
    constructor() {
      super(...arguments), this.isOpen = !1, this.handleActiveNavItemChange = ({ target: e }) => {
        this.associatedNavTrigger instanceof rt && e instanceof rt && this.associatedNavTrigger.isEqualNode(e) && (this.isOpen = !!this.associatedNavTrigger.active);
      }, this.updateNavItemOnEscape = ({ key: e }) => {
        e === Di.ESCAPE && this.associatedNavTrigger instanceof rt && this.associatedNavTrigger.active && this.handleMenuClose(!0);
      }, this.handleMenuCloseButton = ({ target: e }) => {
        e instanceof HTMLElement && this.isEqualNode(e) && this.associatedNavTrigger instanceof rt && this.handleMenuClose(!0);
      };
    }
    /** The outermost parent element to look for the associated navigation item. */
    get navItemRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The navigation button that triggers this popover. */
    get associatedNavTrigger() {
      var e;
      return (e = this.navItemRoot) == null ? void 0 : e.querySelector(`[opens="${this.opensBy}"]`);
    }
    /** Return a given expanded nav by its index in the slotted elements. */
    findExpandedNav(e = 0) {
      return this.slottedExpandedNavItems[e];
    }
    /** Handles closing of components that inherit this class. */
    handleMenuClose(e = !1) {
      this.associatedNavTrigger instanceof rt && (this.associatedNavTrigger.active = !1, e && this.associatedNavTrigger.button.focus());
    }
    /** Sets the nav item active state when focusing out of the popover. */
    handleFocusOut({ relatedTarget: e }) {
      e instanceof HTMLElement && this.associatedNavTrigger instanceof rt && !this.associatedNavTrigger.isEqualNode(e) && !this.contains(e) && this.associatedNavTrigger.isDesktop && this.associatedNavTrigger.active && this.handleMenuClose();
    }
    prerenderNavigationButtonTriggeredSetup() {
      document.addEventListener(
        Ee.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.addEventListener(et.KEYDOWN, this.updateNavItemOnEscape), this.addEventListener(
        Ee.CLOSE_ACTIVE_NAV_ITEM,
        this.handleMenuCloseButton
      ), this.addEventListener(et.FOCUSOUT, this.handleFocusOut);
    }
    teardownNavibationButtonTriggered() {
      document.removeEventListener(
        Ee.ACTIVE_NAV_ITEM,
        this.handleActiveNavItemChange
      ), document.removeEventListener(et.KEYDOWN, this.updateNavItemOnEscape);
    }
  };
  return Nn([
    ue({ attribute: "opens-by", reflect: !0 })
  ], t.prototype, "opensBy", 2), Nn([
    ue({ type: Boolean, reflect: !0, attribute: "is-open" })
  ], t.prototype, "isOpen", 2), Nn([
    De(
      { flatten: !0, selector: "beacon-navigation-expanded" },
      !0
    )
  ], t.prototype, "slottedExpandedNavItems", 2), Nn([
    qe
  ], t.prototype, "prerenderNavigationButtonTriggeredSetup", 1), Nn([
    Pt
  ], t.prototype, "teardownNavibationButtonTriggered", 1), t = Nn([
    $e("NavigationButtonTriggered")
  ], t), t;
}
const bT = ve`:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul{margin-block:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ul>li{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer])>:is(a,[beacon-tag-name=beacon-navigation-button]){display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}`, pT = ve`:host{color:var(--beacon-system-color-text-standard);inline-size:100%}[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating)}::slotted([slot=title]){color:var(--beacon-system-color-text-title);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}::slotted([slot=description]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-system-color-text-standard)}.title-area{padding-block:var(--beacon-system-space-cell-free-floating)}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap)}.slot-container{display:grid;gap:var(--beacon-reference-space-2)}@media (width >= 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7)}}`;
var uT = Object.defineProperty, gT = Object.getOwnPropertyDescriptor, Cn = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? gT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && uT(t, e, o), o;
};
const Ea = class Yr extends Le {
  constructor() {
    super(...arguments), this.level = 1, this.splitColumns = "true", this.hasNestedExpandedNavigations = !1, this.handleCurrentLink = () => {
      this.currentLink && Fe(
        this,
        Ee.HAS_CURRENT_LINK,
        void 0,
        this.onBeaconCurrentLink
      );
    };
  }
  static get styles() {
    return [super.styles, pT];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, bT];
  }
  /** Callback for on beacon-event-has-current-link */
  onBeaconCurrentLink() {
  }
  /** Anchor link representing the current page. */
  get currentLink() {
    return this.querySelector('a[aria-current="page"]');
  }
  get hasValidNestedItems() {
    return this.links.filter(
      (t) => (t instanceof Yr || t instanceof HTMLAnchorElement) && !(t instanceof HTMLStyleElement)
    );
  }
  postrenderHandleCurrentLink() {
    this.handleCurrentLink();
  }
  /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  setLevel() {
    this.level = 1 + (this.parentElement instanceof Yr ? this.parentElement.level : 0);
  }
  /** Updates based on this component having nested expanded navigations. */
  setNestedState() {
    this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = !0 : this.hasNestedExpandedNavigations = !1;
  }
  /** Calculate a number of CSS columns based on how many links are to be shown. */
  static calculateCSSColumns(t) {
    let e = "";
    return t < 6 ? e = "1" : t < 11 ? e = "2" : t < 22 ? e = "3" : e = "4", e;
  }
  /** Calculate the grid template based on how many sections are shown. */
  static calculateGridColumnTemplate(t) {
    let e = "";
    return t === 1 ? e = "1fr" : t === 2 ? e = "1fr 1fr" : t === 3 ? e = "1fr 1fr 1fr" : t >= 4 && (e = "1fr 1fr 1fr 1fr"), e;
  }
  setColumnsCSSProperty(t) {
    this.style.setProperty("--expanded-nav-grid-template", t);
  }
  setNestedGridTemplates(t) {
    const e = Yr.calculateCSSColumns(t);
    this.setColumnsCSSProperty(e);
  }
  setLevel1GridTemplate(t) {
    const e = Yr.calculateGridColumnTemplate(t);
    this.setColumnsCSSProperty(e);
  }
  setLevel2GridTemplate(t) {
    this.setNestedGridTemplates(t);
  }
  setGridTemplates() {
    let t = this.links.length;
    this.splitColumns === "false" && (t = 1), this.level === 1 ? this.setLevel1GridTemplate(t) : this.level === 2 ? this.setLevel2GridTemplate(t) : this.level === 3 && this.setNestedGridTemplates(t);
  }
  handleTitleSlotchange() {
    var t;
    this.titleSlotVal = (t = this.titleNodes) != null && t.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
  }
  handleDefaultSlotchange() {
    this.setNestedState(), this.setLevel(), this.setGridTemplates();
  }
  renderExpanded() {
    return pe`
      <section class="header-zone">
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              @slotchange=${this.handleTitleSlotchange}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <slot
          @slotchange=${Js(
      this.handleDefaultSlotchange.bind(this)
    )}></slot>
      </section>
    `;
  }
  render() {
    return pe`<div class="level-${this.level}">
      ${this.renderExpanded()}
    </div> `;
  }
};
Cn([
  ue({ reflect: !0 })
], Ea.prototype, "level", 2);
Cn([
  ue({ attribute: "split-columns", reflect: !0 })
], Ea.prototype, "splitColumns", 2);
Cn([
  Ce()
], Ea.prototype, "titleSlotVal", 2);
Cn([
  Ce()
], Ea.prototype, "hasNestedExpandedNavigations", 2);
Cn([
  De({ slot: "", flatten: !0 })
], Ea.prototype, "links", 2);
Cn([
  De({ slot: "title", flatten: !0 })
], Ea.prototype, "titleNodes", 2);
Cn([
  Re
], Ea.prototype, "postrenderHandleCurrentLink", 1);
let Tv = Ea;
var Ai = /* @__PURE__ */ ((a) => (a.CLICK = "click", a.HOVER = "hover", a.MANUAL = "manual", a))(Ai || {}), Ut = /* @__PURE__ */ ((a) => (a.START = "start", a.CENTER = "center", a.END = "end", a))(Ut || {}), Fa = /* @__PURE__ */ ((a) => (a.HORIZONTAL = "horizontal", a.VERTICAL = "vertical", a))(Fa || {}), ct = /* @__PURE__ */ ((a) => (a.BlockStart = "block-start", a.InlineStart = "inline-start", a.BlockEnd = "block-end", a.InlineEnd = "inline-end", a))(ct || {});
const Lv = {
  DOWN: pe`<svg
    class="tooltip-arrow arrow--down"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(180deg);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  LEFT: pe`<svg
    class="tooltip-arrow arrow--left"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(270deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  RIGHT: pe`<svg
    class="tooltip-arrow arrow--right"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(90deg) scale(2);">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  UP: pe`<svg
    class="tooltip-arrow arrow--up"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`
};
var mT = Object.defineProperty, fT = Object.getOwnPropertyDescriptor, pt = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? fT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && mT(t, e, o), o;
};
function vT(a = { disableDebounceOpen: !1 }) {
  return function(t) {
    let e = class extends t {
      constructor() {
        super(...arguments), this.orientation = Fa.VERTICAL, this.trigger = Ai.HOVER, this.isOpen = !1, this.content = "", this.alignment = Ut.CENTER, this.direction = ct.InlineStart, this.topOffset = 0, this.leftOffset = 0, this.RTL = !1, this.marginAdjust = 0, this.targetSelectorString = ".overlay-target", this.overlaySelector = ".overlay-wrapper", this.overlayName = "overlay", this.debouncedCalculateOffset = jo(this.calculateOffset.bind(this), 100), this.toggleClick = (i) => {
          i && i.isTrusted && (this.isOpen ? this.close() : this.open());
        }, this.intersectionObserver = new IntersectionObserver(
          this.debouncedCalculateOffset,
          { threshold: 1 }
        ), this.resizeObserver = new ResizeObserver(this.debouncedCalculateOffset), this.open = a && !a.disableDebounceOpen ? jo(async () => {
          this.calculateOffset(), this.isOpen = !0, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, 100) : async () => {
          this.calculateOffset(), this.isOpen = !0, this.attachOpenEventListeners(), await this.updateComplete, this.emitOpen();
        }, this.handleKeydown = (i) => {
          i.isTrusted && this.isOpen && (super.handleKeydown(), this.closeOnEscape(i));
        }, this.handleExternalClick = (i) => {
          i.isTrusted && !i.composedPath().includes(this.overlayEl) && this.isOpen && this.close();
        };
      }
      /** Callback for on beacon-event-close */
      onBeaconClose() {
      }
      /** Callback for on beacon-event-open */
      onBeaconOpen() {
      }
      get targetSelector() {
        return this.targetSelectorString;
      }
      set targetSelector(i) {
        this.targetSelectorString = i;
      }
      get viewportRect() {
        return {
          width: window.innerWidth || document.documentElement.clientWidth,
          height: window.innerHeight || document.documentElement.clientHeight
        };
      }
      set targetRect(i) {
        this.targetRectObj = i;
      }
      get scrollListeningContainer() {
        var i;
        return (i = this.scrollListeningContainerObj) != null ? i : window;
      }
      set scrollListeningContainer(i) {
        this.scrollListeningContainerObj = i;
      }
      get externalClickNode() {
        return this.getRootNode();
      }
      /**
       * Calculates margin adjustment for when the overlay component is visible
       * @param marginToken token representing the margin of the overlay component
       * @param arrowSizeToken token representing the size of the arrow on the overlay
       */
      computeMarginAdjustment(i, o) {
        this.marginAdjust = parseInt(i, 10) + parseInt(o, 10) / 2;
      }
      /**
       * Used to determine if the preferred direction and orientation are compatible,
       * when dynamically calculating the direction of the overlay with the preferred direction
       * @param direction The current direction of the overlay
       * @returns
       */
      static computeDirectionOrientation(i) {
        return i === ct.BlockStart || i === ct.BlockEnd ? Fa.VERTICAL : Fa.HORIZONTAL;
      }
      /**
       * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
       * @param target DOMRect of the target element
       * @param overlay DOMRect of the overlay element
       */
      computeDirection(i, o) {
        this.orientation === Fa.VERTICAL ? (this.computeVerticalDirection(i), this.computeAlignment(i)) : this.computeHorizontalDirection(i, o);
      }
      /**
       * Computes the vertical direction based on available space,
       * and a user provided preferred direction.
       * @param target DOMRect of the target element
       */
      computeVerticalDirection(i) {
        const o = this.viewportRect.height / 4, n = this.viewportRect, l = i.top < o, L = i.bottom > n.height - o, D = l ? ct.BlockStart : ct.BlockEnd;
        this.preferredDirection && e.computeDirectionOrientation(this.preferredDirection) === Fa.VERTICAL ? !l && this.preferredDirection == ct.BlockEnd ? this.direction = ct.BlockEnd : !L && this.preferredDirection == ct.BlockStart ? this.direction = ct.BlockStart : this.direction = D : this.direction = D;
      }
      /**
       * Computes the horizontal direction based on available space,
       * prioritizing the preferred-direction over default dynamic calculations
       * if it exists
       * @param target
       * @param overlay
       */
      computeHorizontalDirection(i, o) {
        this.alignment = Ut.CENTER;
        const n = i.x + i.width + o.width < this.viewportRect.width, l = i.x - o.width > 0, L = this.viewportRect.width < i.x, D = n ? ct.InlineStart : ct.InlineEnd;
        this.RTL ? L ? this.direction = ct.InlineEnd : this.direction = ct.InlineStart : this.preferredDirection && e.computeDirectionOrientation(
          this.preferredDirection
        ) === Fa.HORIZONTAL ? (n && this.preferredDirection === ct.InlineStart && (this.direction = ct.InlineStart), l && this.preferredDirection === ct.InlineEnd ? this.direction = ct.InlineEnd : this.direction = D) : this.direction = D;
      }
      /**
       * Aligns the arrow of the popover when vertically oriented, to ensure most
       * of the popover is visible in the viewport.
       * @param target
       */
      computeAlignment(i) {
        const o = i.x < this.viewportRect.width / 4, n = i.x > this.viewportRect.width * 3 / 4;
        o ? this.alignment = Ut.START : n ? this.alignment = Ut.END : this.alignment = Ut.CENTER;
      }
      /**
       * @param overlayWidth Width of the Overlay element
       * @param targetWidth Width of the Target Element
       * @returns Based on Alignment, will return leftOffset as number.
       */
      calculateHorizontalOffset(i, o) {
        const n = o - i, l = i / 2 - this.marginAdjust;
        switch (this.alignment) {
          case Ut.START:
            return n / 2 + l;
          case Ut.CENTER:
            return n / 2;
          case Ut.END:
            return n / 2 - l;
          default:
            return 0;
        }
      }
      /**
       * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
       * @abstract
       */
      calculateOffset() {
        var n, l, L;
        const i = (n = this.shadowRoot) == null ? void 0 : n.querySelector(this.targetSelector), o = (l = this.shadowRoot) == null ? void 0 : l.querySelector(this.overlaySelector);
        if (o && (i || this.targetRectObj)) {
          const D = (L = this.targetRectObj) != null ? L : i == null ? void 0 : i.getBoundingClientRect(), j = o.getBoundingClientRect();
          this.computeDirection(D, j);
          const { height: I, width: B } = D, { height: R, width: N } = j;
          switch (this.topOffset = 0, this.leftOffset = B, this.direction) {
            case ct.BlockEnd:
              this.topOffset = -1 * (I + R), this.leftOffset = this.calculateHorizontalOffset(
                N,
                B
              );
              break;
            case ct.BlockStart:
              this.leftOffset = this.calculateHorizontalOffset(
                N,
                B
              );
              break;
            case ct.InlineEnd:
              this.leftOffset = -1 * N, this.topOffset = -1 * (R + (I - R) / 2);
              break;
            case ct.InlineStart:
              this.topOffset = -1 * (R + (I - R) / 2);
              break;
          }
        }
      }
      /**
       * Enables overlay surface to reposition and reorient based on:
       * 1. When overlayWrapper is intersecting with viewport border
       * 2. When document body is resized
       * 3. When user scrolls
       */
      engageDynamicOverlayPositioning() {
        this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Disengages dynamic overlay positioning by unobserving by:
       * 1. Unobserving overlayWrapper intersections with viewport
       * 2. Unobserving resize of the document body
       * 3. Removing scroll event listener from scrollListeningContainer
       */
      disengageDynamicOverlayPositioning() {
        this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Destroys dynamic overlay positioning by:
       * 1. Disconnecting intersection observer
       * 2. Disconnecting resize observer
       * 3. Removing scroll event listener from scrollListeningContainer
       * This method is intended for use when disconnecting component.
       */
      destroyDynamicOverlayPositioning() {
        this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener(
          "scroll",
          this.debouncedCalculateOffset
        );
      }
      /**
       * Adds event listener to the document to close the overlay when clicked outside
       */
      attachOpenEventListeners() {
        setTimeout(() => {
          this.trigger === Ai.CLICK && document.addEventListener(et.CLICK, this.handleExternalClick);
        }, 100);
      }
      /**
       * Makes the overlay hidden.
       */
      close() {
        this.isOpen = !1, this.removeOpenEventListeners(), this.trigger === Ai.MANUAL && this.focusOnTrigger();
      }
      /**
       * Focuses on the element that opened the overlay,
       * used when the overlay is closed and the trigger is manual.
       */
      focusOnTrigger() {
        var o, n;
        const i = document.querySelector(this.targetSelector) || ((n = (o = this.getClosestHost()) == null ? void 0 : o.shadowRoot) == null ? void 0 : n.querySelector(this.targetSelector));
        i && i.focus();
      }
      removeOpenEventListeners() {
        this.trigger === Ai.CLICK && document.removeEventListener(et.CLICK, this.handleExternalClick);
      }
      /** Closes the popover when the key pressed is the escape key. */
      closeOnEscape(i) {
        i.key === Di.ESCAPE && this.close();
      }
      /**
       * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
       */
      emitClose() {
        Fe(this, Ee.CLOSE, void 0, this.onBeaconClose);
      }
      /**
       * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
       */
      emitOpen() {
        Fe(this, Ee.OPEN, void 0, this.onBeaconOpen);
      }
      /**
       * Lit lifecycle hook to handle changing of properties
       */
      updated(i) {
        Dr(i, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
      }
      overlayPrerender() {
        this.isOpen && this.open(), this.externalClickNode.addEventListener(
          et.KEYDOWN,
          this.handleKeydown
        );
      }
      overlayPostrender() {
        this.calculateOffset();
      }
      overlayDestroy() {
        this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(
          et.KEYDOWN,
          this.handleKeydown
        ), this.externalClickNode.removeEventListener(
          et.CLICK,
          this.handleExternalClick
        );
      }
      /**
       * Render template: slotted element
       */
      renderSlot() {
        return this.trigger === Ai.HOVER ? pe`<slot
            @mouseover=${this.open}
            @mouseout=${this.close}
            @focusin=${this.open}
            @focusout=${this.close}></slot>` : this.trigger === Ai.CLICK ? pe`<slot @click=${this.toggleClick}></slot>` : pe`<slot></slot>`;
      }
      /**
       * Render template: overlay content
       */
      renderOverlayContent() {
        return pe`<p>${this.content}</p>`;
      }
      /**
       * Render template: overlay content skeleton
       */
      renderContentWrapper() {
        return pe`<div class="tooltip-content">
          ${this.renderOverlayContent()}
        </div>`;
      }
      /**
       * Render template: arrow
       * @todo align the arrow implementation with the navigation popover arrow
       */
      renderArrow() {
        return pe`<span
          class="overlay-arrow ${this.alignment}"
          aria-hidden="true"
          >${Lv.UP}</span
        >`;
      }
      /**
       * Render template: entire overlay skeleton
       */
      renderOverlayWrapper() {
        return this.style.setProperty("--left-offset", `${this.leftOffset}px`), this.style.setProperty("--top-offset", `${this.topOffset}px`), this.topScreenOffset && this.style.setProperty(
          "--screen-offset-top",
          `${this.topScreenOffset}px`
        ), this.leftScreenOffset && this.style.setProperty(
          "--screen-offset-left",
          `${this.leftScreenOffset}px`
        ), pe`<div
          id="${this.overlayName}"
          aria-hidden="${mt(this.isOpen ? void 0 : "true")}"
          class="overlay-wrapper 
            ${this.direction}">
          ${this.renderArrow()} ${this.renderContentWrapper()}
        </div>`;
      }
      /**
       * Render template: overlay and target
       */
      render() {
        return pe`${this.trigger === Ai.MANUAL ? je : pe`<div
              class="overlay-target"
              aria-describedBy="${this.overlayName}">
              ${this.renderSlot()}
            </div>`}
        ${this.renderOverlayWrapper()}`;
      }
    };
    return pt([
      ue()
    ], e.prototype, "orientation", 2), pt([
      ue({ attribute: "preferred-direction" })
    ], e.prototype, "preferredDirection", 2), pt([
      ue({ reflect: !0 })
    ], e.prototype, "trigger", 2), pt([
      ue({ type: Boolean, reflect: !0, attribute: "is-open" })
    ], e.prototype, "isOpen", 2), pt([
      ue()
    ], e.prototype, "content", 2), pt([
      Ce()
    ], e.prototype, "alignment", 2), pt([
      Ce()
    ], e.prototype, "direction", 2), pt([
      Ce()
    ], e.prototype, "topOffset", 2), pt([
      Ce()
    ], e.prototype, "leftOffset", 2), pt([
      Ce()
    ], e.prototype, "topScreenOffset", 2), pt([
      Ce()
    ], e.prototype, "leftScreenOffset", 2), pt([
      Ce()
    ], e.prototype, "RTL", 2), pt([
      ot("div#tooltip")
    ], e.prototype, "overlayEl", 2), pt([
      We(".overlay-wrapper")
    ], e.prototype, "overlayWrapper", 2), pt([
      qe
    ], e.prototype, "overlayPrerender", 1), pt([
      Re
    ], e.prototype, "overlayPostrender", 1), pt([
      Pt
    ], e.prototype, "overlayDestroy", 1), e = pt([
      $e("Overlay")
    ], e), e;
  };
}
function AT(a = { disableDebounceOpen: !1 }) {
  return function(e) {
    const i = vT(a)(e);
    let o = class extends i {
      constructor() {
        super(...arguments), this.open = a && !a.disableDebounceOpen ? jo(async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.attachOpenEventListeners();
        }, 100) : async () => {
          this.calculateOffset(), this.engageDynamicOverlayPositioning(), this.activeElement = document.activeElement, await this.updateComplete, this.isOpen = !0, this.attachOpenEventListeners();
        };
      }
      /**
       * Handle close and return focus to active element.
       * Also removes listener and observer logic when overlay closed for better performance.
       */
      close() {
        super.close(), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
      }
      /**
       * Handle dark mode theming in action zone
       */
      setActionZoneDarkMode() {
        this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach((n) => {
          n.classList.contains("beacon-on-dark") || n.classList.add("beacon-on-dark");
        });
      }
      /**
       * Focuses on the previously active element
       */
      focusOnActiveElement() {
        var n;
        (n = this.activeElement) == null || n.focus();
      }
      /**
       * Render template: close icon button
       */
      renderCloseButton() {
        return ze`<${this.getScopedTag("beacon-icon-button")}
                        variant="tertiary"
                        class="beacon-popover-close-button beacon-on-dark"
                        @beacon-event-click="${this.close}"
                        >
                        Close Button
                        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"/>
                        </svg>
                        </${this.getScopedTag("beacon-icon-button")}>
                        `;
      }
      /**
       * Render template: adjusts content wrapper
       */
      renderContentWrapper() {
        return pe`<div class="beacon-popover-surface">
          ${this.renderCloseButton()}
          <div class="beacon-popover-zones-wrapper">
            ${this.renderOverlayContent()}
          </div>
        </div>`;
      }
      /**
       * Render template: slot with only click event
       */
      renderSlot() {
        return pe`<slot @click=${this.toggleClick}></slot>`;
      }
    };
    return pt([
      ot("div#overlay")
    ], o.prototype, "overlayEl", 2), pt([
      Ce()
    ], o.prototype, "activeElement", 2), pt([
      De({ flatten: !0, slot: "actionzone" })
    ], o.prototype, "slottedActionzone", 2), o = pt([
      $e("OverlayInteractive")
    ], o), o;
  };
}
const Sl = {
  beaconTagName: "beacon-navigation-popover",
  arrowSpaceMargin: "24px",
  arrowSizeInline: "12px"
}, yT = ve`[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-popover]{--navigation-popover-link-color: var(--beacon-system-color-text-link-active)}[beacon-tag-name=beacon-navigation-popover] [beacon-tag-name=beacon-navigation-expanded][level="1"] [beacon-tag-name=beacon-navigation-expanded]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-system-space-micro-jumbo)}}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]{align-items:center;color:var(--beacon-system-color-text-link-active);display:inline-flex;font-weight:var(--beacon-system-font-weight-bold);gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-popover][slot=site-selector] [beacon-tag-name=beacon-navigation-expanded] [selected-site]:after{block-size:1em;content:url('data:image/svg+xml,<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 9.01852L6.78947 13.5L15 2.5" stroke="%23248647" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');inline-size:1em}`, xT = ve`@media (width >= 960px){:host([motion-state=enabled]){--popover-motion-easing: var(--beacon-system-motion-easing-decelerate-emphasize-1);--popover-motion-duration: var(--beacon-reference-motion-duration-7);display:grid;grid-template-columns:min-content;transition-duration:var(--popover-motion-duration);transition-property:grid-template-rows;transition-timing-function:var(--popover-motion-easing)}:host([motion-state=enabled]) .overlay-wrapper{overflow:hidden;visibility:visible}:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:0;transition:opacity var(--popover-motion-duration) var(--popover-motion-easing) var(--popover-motion-duration)}}@media (width >= 960px) and (prefers-reduced-motion: reduce){:host([motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}@media (width >= 960px){:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .beacon-popover-zones-wrapper{opacity:1}}`, wT = ve`:host{--popover-color: var(--beacon-system-color-text-standard);--popover-visibility: hidden;color:var(--popover-color);inline-size:100%}@media (width >= 960px){:host{inline-size:unset;inset-block-start:var(--top-offset);inset-inline-start:var(--left-offset);position:absolute;z-index:var(--beacon-custom-popover-z-index, 1000)}}:host(:not([is-open])){display:none}::part(icon-button){--icon-color: var(--popover-color);--hover-icon: var(--popover-color);--active-icon: var(--popover-color)}:host([is-open]){--popover-visibility: visible}.overlay-wrapper{display:flex;flex-direction:var(--direction);visibility:var(--popover-visibility)}@media (width >= 960px){.overlay-wrapper{--arrow-block-size: 6px;--arrow-inline-size: var(--beacon-reference-space-4);--direction: column;inline-size:fit-content;max-inline-size:var(--navigation-popover-size-inline)}}.overlay-wrapper.block-start{--direction: column}.overlay-wrapper.block-end{--direction: column-reverse}.overlay-wrapper .overlay-arrow{--arrow-margin: var(--beacon-reference-space-7);display:flex}.overlay-wrapper .overlay-arrow.start{align-self:start;margin-inline-start:var(--arrow-margin)}.overlay-wrapper .overlay-arrow.center{align-self:center;margin:0}.overlay-wrapper .overlay-arrow.end{align-self:end;margin-inline-end:var(--arrow-margin)}.overlay-wrapper .overlay-arrow .tooltip-arrow{block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size)}@media (width >= 960px){.overlay-wrapper .beacon-popover-surface{background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-system-color-shadow-high);inline-size:var(--navigation-popover-content-size-inline);max-inline-size:var(--navigation-popover-content-size-inline);padding:var(--beacon-reference-space-7);position:relative}}.overlay-wrapper .beacon-popover-surface .beacon-popover-close-button{display:none}.overlay-wrapper .beacon-popover-surface .beacon-popover-zones-wrapper{display:flex;flex-direction:column}`;
var kT = Object.defineProperty, CT = Object.getOwnPropertyDescriptor, Hc = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? CT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && kT(t, e, o), o;
};
const Wb = class Wb extends Ge(Le).with(
  AT({ disableDebounceOpen: !0 }),
  Mv,
  Sb(),
  $i,
  Lr(),
  al({ skipFirstUpdated: !0 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Sl.beaconTagName, this.trigger = Ai.MANUAL, this.direction = ct.BlockStart, this.overflowOffset = 0;
  }
  static get styles() {
    return [super.styles, wT, xT];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, yT];
  }
  /** @override Only set Alignment in direction computation. */
  computeDirection(t, e) {
    if (this.slot === Mb.ACTION) {
      this.alignment = Ut.END;
      return;
    }
    const i = (t.left + t.right) / 2, o = e.width / 2;
    i + o > this.viewportRect.width ? this.alignment = Ut.END : i - o < 0 ? this.alignment = Ut.START : this.alignment = Ut.CENTER;
  }
  /**
   * @override Sets a different targetRectObj from the primitive.
   * @override Changes calculation to take into account the popover not being a wrapper of the target.
   */
  calculateOffset() {
    var i;
    this.associatedNavTrigger instanceof rt && (this.targetRectObj = this.associatedNavTrigger.getBoundingClientRect());
    const t = this.associatedNavTrigger, e = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".overlay-arrow");
    if (t && e) {
      const o = t.getBoundingClientRect(), n = this.getBoundingClientRect(), l = e.getBoundingClientRect(), L = document.body.getBoundingClientRect();
      this.computeDirection(o, n), this.topOffset = o.y + o.height;
      const D = o.x - n.width / 2 + o.width / 2, j = l.x - (n.x + n.width / 2) + l.width / 2, { width: I } = L, B = I > 1920 ? (I - 1920) / 2 : 0;
      switch (this.alignment) {
        case Ut.END:
        case Ut.START:
          this.leftOffset = D - j - B;
          break;
        case Ut.CENTER:
        default:
          this.leftOffset = D - B;
          break;
      }
    }
  }
  /** @override Focus returning is handled externally from this popover. */
  focusOnActiveElement() {
  }
  /** @override Includes SVG arrow in the markup instead of styling using CSS backgrounds. */
  renderArrow() {
    return pe`<span class="overlay-arrow ${this.alignment}" aria-hidden="true"
      >${Lv.UP}</span
    >`;
  }
  /** @override Close buttons don't exist here. */
  renderCloseButton() {
    return pe``;
  }
  /** @override Only a default slot is available. */
  renderOverlayContent() {
    return pe`<slot></slot>`;
  }
  prerenderNavigationPopoverSetup() {
    this.computeMarginAdjustment(
      Sl.arrowSpaceMargin,
      Sl.arrowSizeInline
    );
  }
  willUpdate(t) {
    if (t.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), Dr(t, "isOpen")) {
      const e = t.get("isOpen");
      this.motionState === "enabled" && !this.prefersReducedMotion && (e ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
    }
    super.willUpdate(t);
  }
};
Wb.tagName = Sl.beaconTagName;
let xa = Wb;
Hc([
  ue()
], xa.prototype, "trigger", 2);
Hc([
  ue()
], xa.prototype, "direction", 2);
Hc([
  Ce()
], xa.prototype, "overflowOffset", 2);
Hc([
  qe
], xa.prototype, "prerenderNavigationPopoverSetup", 1);
const ST = ve`:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-title-area-gap: var(--beacon-system-space-micro-normal);--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-5);--navigation-expanded-popover-header-zone-spacing: var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation-expanded],:root [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation-expanded],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation-expanded],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation-expanded]{--navigation-expanded-header-zone-spacing: var(--beacon-reference-space-9)}}`, Hn = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button"
}, ET = ve`[beacon-tag-name=beacon-navigation-expanded] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:baseline;display:flex;flex-direction:column;gap:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:1;inline-size:100%}@media (width >= 1280px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search :first-child{flex:unset;inline-size:calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi),var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 640px){[beacon-tag-name=beacon-navigation-expanded] .expanded__search{align-items:end;flex-direction:row}}[beacon-tag-name=beacon-navigation-expanded]>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}[beacon-tag-name=beacon-navigation-expanded]>[slot=description]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-navigation-expanded][show-drilldown]>:is([beacon-tag-name=beacon-navigation-expanded]:not([is-active],[show-drilldown]),[beacon-tag-name=beacon-navigation-button],a){display:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-expanded]:is([level="2"],[level="3"])>[slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-navigation-expanded]>[slot=promo]{border:0;padding-block-start:0}}`, MT = ve`:host([show-drilldown]) .promo-slot{display:none}.hide{display:none}.default-slot{display:contents}.header-zone.has-nested-expanded{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--navigation-expanded-header-zone-spacing);padding-block-end:var(--navigation-expanded-header-zone-spacing)}.header-zone.no-content{display:none}:host([show-drilldown]) .header-zone{display:none}.popover{color:var(--beacon-system-color-text-standard)}.collapsed-title-button{all:unset}@media (width >= 960px){:host([level="2"]){grid-column:span var(--expanded-nav-grid-span)}.expanded ::slotted([beacon-tag-name=beacon-navigation-button]),.expanded ::slotted(a){--font-weight: var(--beacon-system-font-weight-normal)}.expanded:is(.level-1,.level-2,.level-3) .slot-container{--grid-layout-gap: var(--beacon-system-space-micro-jumbo);--grid-column-count: 4;--gap-count: calc(var(--grid-column-count) - 1);--total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));--grid-item-max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));display:grid;gap:calc(var(--navigation-expanded-header-zone-spacing) * 2) var(--grid-layout-gap);grid-template-columns:repeat(auto-fit,minmax(var(--grid-item-max-width),1fr))}.expanded:not(.level-1) .header-zone{border:0;margin:0;padding:0}.expanded.level-2 .default-slot{columns:var(--expanded-nav-grid-template)}.expanded:is(.level-2,.level-3) .default-slot{columns:var(--expanded-nav-grid-template);display:block}.popover{color:var(--beacon-system-color-text-standard)}.popover.level-1 .header-zone.has-nested-expanded{margin-block-end:var(--navigation-expanded-popover-header-zone-spacing);padding-block-end:var(--navigation-expanded-popover-header-zone-spacing)}.popover.level-1 .title-area .primary-link-container{margin-block-start:var(--beacon-system-space-micro-mini)}.popover.level-1 .slot-container{gap:var(--beacon-system-space-micro-jumbo)}.popover:not(.level-1) ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.popover:not(.level-1) .header-zone{border:0;margin:0;padding:0}}`;
var TT = Object.defineProperty, LT = Object.getOwnPropertyDescriptor, Go = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? LT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && TT(t, e, o), o;
};
const OT = ["title", "description", "primary-link"];
function PT(a) {
  const t = a, e = OT.find(
    (i) => i === t
  );
  if (e)
    return e;
  throw new Error(`${a} is not a valid slot name in Expanded Navigation.`);
}
var yo;
const To = (yo = class extends Ge(
  Tv
).with($i, al({ skipFirstUpdated: !0 })) {
  constructor() {
    super(...arguments), this.beaconTagName = Hn.beaconTagName, this.showDrilldown = !1, this.isActive = !1, this.hasPrimaryLink = !1, this.hasDescription = !1, this.hasTitle = !1, this.hasPromo = !1, this.handleDrillup = (t) => {
      var e;
      if (t.target instanceof ss && this.activeExpandedNav instanceof yo) {
        this.activeExpandedNav.drillup(!0), (e = this.toolbelt) == null || e.handleDrillup();
        return;
      }
      this.showDrilldown && this.drillup();
    }, this.handleCloseEvents = ({ target: t }) => {
      t instanceof ss && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = !0, this.parentExpanded.showDrilldown = !1) : this.parentExpanded.drillup());
    }, this.handleAnalyticsChange = ({ target: t }) => {
      t === this.menuContext && this.updateAnalytics();
    };
  }
  static get styles() {
    return [super.styles, MT];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, ET, ST];
  }
  get hasOnlyLinks() {
    return !this.hasPrimaryLink && !this.hasDescription && !this.titleSlotVal;
  }
  get parentExpanded() {
    return this.parentElement instanceof yo ? this.parentElement : null;
  }
  /** The level value of whichever expanded navigation is currently active. */
  get activeLevel() {
    return this.isActive ? this.level : this.parentElement instanceof yo ? this.parentElement.activeLevel : 1;
  }
  /** True when an expanded navigation is somewhere inside a Navigation Popover. */
  get isInPopover() {
    return this.parentElement instanceof xa ? !0 : this.parentElement instanceof yo ? this.parentElement.isInPopover : !1;
  }
  get navPopover() {
    return this.closest('[beacon-tag-name="beacon-navigation-popover"]');
  }
  get toolbelt() {
    return this.closest('[beacon-tag-name="beacon-navigation-toolbelt"]');
  }
  get menuContext() {
    return this.navPopover ? this.navPopover : this.toolbelt ? this.toolbelt : null;
  }
  /** Collapsed expanded navigations are only true when it can be drilled into. */
  get isCollapsed() {
    if (this.isMobile && !this.isActive && !this.showDrilldown) {
      if (this.level > this.activeLevel)
        return !0;
    } else if (!this.isMobile && this.level > 2 && !this.isActive)
      return !0;
    return !1;
  }
  get activeExpandedNav() {
    return this.querySelector(
      '[beacon-tag-name="beacon-navigation-expanded"][is-active]'
    );
  }
  /** Runs when nested expanded navigations fire dirlldown events. */
  handleInternalDrilldown(t) {
    this.showDrilldown = !0, this.isActive = !1, this.setGridTemplates(), Fe(this, Ee.DRILLDOWN, t);
  }
  /** Runs when the navigation is requested to drilldown. */
  drilldown(t) {
    this.isActive = !0, Fe(this, Ee.DRILLDOWN, t);
  }
  /** Runs when the navigation is requested to drill up. */
  drillup(t = !1) {
    var e;
    t && this.parentExpanded && (this.parentExpanded.titleSlotVal ? (this.parentExpanded.isActive = !0, this.parentExpanded.showDrilldown = !1) : this.parentExpanded.hasOnlyLinks ? (this.parentExpanded.showDrilldown = !1, (e = this.parentExpanded.parentExpanded) == null || e.drillup()) : this.parentExpanded.drillup()), this.showDrilldown = !1, this.isActive = !1, this.links.filter((i) => i instanceof yo).forEach(
      (i) => i instanceof yo && (i.showDrilldown || i.isActive) && i.drillup(t)
    ), this.setGridTemplates();
  }
  /** Maps the name of the slot that changes to a state property for if it has nodes. */
  checkSlotForContent({ target: t }) {
    if (t instanceof HTMLSlotElement) {
      const i = t.assignedNodes().length > 0;
      switch (PT(t.name)) {
        case "title":
          this.hasTitle = i;
          break;
        case "description":
          this.hasDescription = i;
          break;
        case "primary-link":
          this.hasPrimaryLink = i;
          break;
      }
    }
  }
  handlePromoSlotchange() {
    this.hasPromo = !!this.promo.length;
  }
  updateAnalytics() {
    var t, e, i, o, n;
    if (super.updateAnalytics(), ((t = this.menuContext) == null ? void 0 : t.metricsLocation) === Vo.header && ((e = this.menuContext) == null ? void 0 : e.metricsSection) !== qo.links) {
      ((i = this.menuContext) == null ? void 0 : i.metricsSection) === qo.level1LangSelector ? this.metricsSection = qo.level2LangSelector : this.metricsSection = Zi[1];
      return;
    }
    if (((o = this.menuContext) == null ? void 0 : o.metricsSection) === qo.links && !this.hasAttribute("country-selector")) {
      this.metricsSection = qo.links;
      return;
    }
    if (this.hasAttribute("country-selector")) {
      this.metricsSection = qo.level1LangSelector;
      return;
    }
    if (((n = this.menuContext) == null ? void 0 : n.metricsLocation) === Vo.siteNav) {
      this.metricsSection = ug(this.level);
      return;
    }
  }
  expandedNavPrerender() {
    document.addEventListener(Ee.DRILLUP, this.handleDrillup), document.addEventListener(Ee.CLOSE, this.handleCloseEvents), document.addEventListener(
      Ee.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      Ee.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.addEventListener(
      Ee.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  expandedNavDestroy() {
    document.removeEventListener(Ee.DRILLUP, this.handleDrillup), document.removeEventListener(Ee.CLOSE, this.handleCloseEvents), document.removeEventListener(
      Ee.METRICS_LOCATION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      Ee.METRICS_SECTION_CHANGE,
      this.handleAnalyticsChange
    ), document.removeEventListener(
      Ee.METRICS_ID_CHANGE,
      this.handleAnalyticsChange
    );
  }
  /** Collapsed view differs based on the existence of content in the title slot. */
  renderCollapsed() {
    return this.titleSlotVal ? pe`
          ${ze`
          <${this.getScopedTag(Hn.navItemTagName)}
            @beacon-event-click=${this.drilldown}
            data-metrics-section="${mt(ug(this.level - 1))}"
            expanded-anchor>
            <button class="collapsed-title-button">
              <slot name="collapsed-title">${this.titleSlotVal}</slot>
            </button>
          </${this.getScopedTag(Hn.navItemTagName)}>`}
          <div class="hide">
            <slot name="title" @slotchange=${this.handleTitleSlotchange}></slot>
            <!-- this slot holds any links and other expanded navs, but it is hidden and so it doesn't need to listen for drilldown events -->
            <slot></slot>
          </div>
        ` : pe`
          <slot
            class="hide"
            name="title"
            @slotchange=${this.handleTitleSlotchange}></slot>
          <section class="slot-container">
            <slot
              @beacon-event-drilldown=${this.handleInternalDrilldown}></slot>
          </section>
        `;
  }
  setGridSpanForPromoTiles() {
    this.style.setProperty(
      "--expanded-nav-grid-span",
      `calc(${String(this.promo.length)} + var(--expanded-nav-grid-template))`
    );
  }
  setLevel1GridTemplate() {
  }
  setLevel2GridTemplate(t) {
    this.showDrilldown ? this.setColumnsCSSProperty("1") : (super.setLevel2GridTemplate(t), this.setGridSpanForPromoTiles());
  }
  renderExpanded() {
    const t = {
      "has-nested-expanded": this.hasNestedExpandedNavigations,
      "header-zone": !0,
      "no-content": !this.hasPrimaryLink && !this.hasDescription && !this.hasTitle
    };
    return pe` <section class=${Pe(t)}>
        <div class="title-area">
          <div class="title-container">
            <slot
              name="title"
              part="title"
              ${_e({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="description-container">
            <slot
              name="description"
              ${_e({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
          <div class="primary-link-container">
            <slot
              name="primary-link"
              role="list"
              ${_e({ useParent: !0 })}
              @slotchange=${this.checkSlotForContent}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <div class="default-slot">
          <slot
            @beacon-event-drilldown=${this.handleInternalDrilldown}
            @slotchange="${Js(
      this.handleDefaultSlotchange.bind(this)
    )}"></slot>
        </div>
        <slot
          class="promo-slot"
          name="promo"
          @slotchange=${this.handlePromoSlotchange}></slot>
      </section>`;
  }
  render() {
    const t = {
      popover: this.isInPopover,
      expanded: !this.isInPopover
    };
    return t[`level-${this.level}`] = !0, pe`<div class=${Pe(t)}>
      ${this.isCollapsed ? this.renderCollapsed() : this.renderExpanded()}
    </div> `;
  }
}, yo.tagName = Hn.beaconTagName, yo);
Go([
  ue({ type: Boolean, reflect: !0, attribute: "show-drilldown" })
], To.prototype, "showDrilldown", 2);
Go([
  ue({ type: Boolean, reflect: !0, attribute: "is-active" })
], To.prototype, "isActive", 2);
Go([
  Ce()
], To.prototype, "hasPrimaryLink", 2);
Go([
  Ce()
], To.prototype, "hasDescription", 2);
Go([
  Ce()
], To.prototype, "hasTitle", 2);
Go([
  Ce()
], To.prototype, "hasPromo", 2);
Go([
  De({ slot: "description", flatten: !0 })
], To.prototype, "descriptionNodes", 2);
Go([
  De({ slot: "primary-link", flatten: !0 })
], To.prototype, "primaryLinkNodes", 2);
Go([
  De({ slot: "promo", flatten: !0 })
], To.prototype, "promo", 2);
Go([
  qe
], To.prototype, "expandedNavPrerender", 1);
Go([
  Pt
], To.prototype, "expandedNavDestroy", 1);
let Ov = To;
const Fn = {
  beaconTagName: "beacon-navigation-toolbelt",
  buttonTagName: "beacon-button"
}, DT = ve`@media (width >= 960px){:host([motion-state=enabled]){display:grid;transition-duration:var(--beacon-reference-motion-duration-9);transition-property:grid-template-rows;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .content-wrapper{overflow:hidden}:host([motion-state=enabled]:not([is-open])){display:grid;grid-template-rows:0fr}:host([is-open][motion-state=enabled]){grid-template-rows:1fr}:host([is-open][motion-state=enabled]) .content-wrapper:focus-within{overflow:visible}}`;
var zT = Object.getOwnPropertyDescriptor, IT = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? zT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function BT(a) {
  let t = class extends a {
    static get navigationToolbeltMotionStyles() {
      return [DT];
    }
    willUpdate(e) {
      if (e.has("motionState") && this.motionState === "enabled" && !this.prefersReducedMotion && this.setAttribute("inert", ""), Dr(e, "isOpen")) {
        const i = e.get("isOpen");
        this.motionState === "enabled" && !this.prefersReducedMotion && (i ? this.setAttribute("inert", "") : this.removeAttribute("inert"));
      }
      super.willUpdate(e);
    }
  };
  return t = IT([
    $e("NavigationToolbeltMotion")
  ], t), t;
}
const RT = ve`:host{inline-size:100%}:host(:not([is-open])){display:none}.container{background-color:var(--beacon-system-color-background-1)}.container :first-child{position:relative}@media (width >= 960px){.container{box-shadow:0 16px 24px -16px #002f48;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);padding-block:var(--beacon-reference-space-10) var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.container.is-drilldown{background-color:var(--beacon-system-color-background-2)}}@media (width >= 1280px){.container{padding-block-start:var(--beacon-reference-space-12)}}.back-button [beacon-tag-name=beacon-icon]{align-self:center;margin-inline-end:var(--beacon-reference-space-3)}.close-button-wrapper{display:none}@media (width >= 960px){.close-button-wrapper{display:block}.close-button-wrapper:not(.action-wrapper){inset-inline-end:0;position:absolute}.close-button-wrapper.action-wrapper{align-items:center;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);display:flex;justify-content:space-between;margin-block-end:var(--beacon-reference-space-9);padding-block-end:var(--beacon-reference-space-9)}}.close-button [beacon-tag-name=beacon-icon]{padding-inline-start:var(--beacon-reference-space-2)}::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-link);gap:0}@media (width >= 960px){:host{inset-block-start:100%;inset-inline-start:0;position:absolute;z-index:1001}:host([site-navigation]){z-index:0}}`;
var NT = Object.defineProperty, FT = Object.getOwnPropertyDescriptor, Pv = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? FT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && NT(t, e, o), o;
};
const dc = class dc extends Ge(Le).with(
  Mv,
  $i,
  Sb(),
  al({ skipFirstUpdated: !0 }),
  BT,
  Lr()
) {
  constructor() {
    super(...arguments), this.beaconTagName = Fn.beaconTagName, this.isDrilldown = !1;
  }
  static get styles() {
    return [super.styles, RT, this.navigationToolbeltMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles];
  }
  /** Drills up from nested menus. */
  get backButton() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("#menu");
  }
  /** Closes the menu entirely while maintaining the current drilldown state when re-opening. */
  get closeButton() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("#close");
  }
  prerenderNavigationToolbeltSetup() {
    this.addEventListener(Ee.DRILLDOWN, this.handleDrilldown), this.addEventListener(Ee.DRILLUP, this.handleDrillup);
  }
  updated(t) {
    Dr(t, "isOpen") && !this.isOpen && this.opensBy === "country-selector" && Fe(this, Ee.COUNTRY_SELECTOR_CLOSE);
  }
  /** Handles drilldown events from child navigations. */
  handleDrilldown({ target: t }) {
    t instanceof Ov && (this.isDesktop ? (t.level === 2 && (this.isDrilldown = !0), Mh(this.backButton)) : t.level === 3 && (this.isDrilldown = !0));
  }
  /** Handles drillup events when pressing the back button. */
  handleDrillup() {
    this.isDrilldown = !1, Mh(this.closeButton);
  }
  // In the case of the toolbelt there's only one level to drill down so the drill up occurs at the highest level
  handleBack() {
    this.backButton instanceof HTMLElement && Fe(this.backButton, Ee.DRILLUP);
  }
  /**
   * Fires an event dedicated to closing the active nav item that is separate from toggling its state.
   *
   * This event helps issues in the popover that was capturing duplicate close events.
   *
   * @event beacon-event-close-active-nav-item
   */
  handleClose() {
    Fe(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
  }
  renderBackButton() {
    return this.isDrilldown ? ze`
        <${this.getScopedTag(Fn.buttonTagName)} 
          variant="tertiary" 
          id="menu"
          class="back-button"
          data-metrics-section="${Yn.level_4}"
          @beacon-event-click=${this.handleBack}>
          Back 
          <${this.getScopedTag("beacon-icon")} name="chevron_left_small" size="s" slot="prefix"></${this.getScopedTag("beacon-icon")}>
        </${this.getScopedTag(Fn.buttonTagName)}>` : pe``;
  }
  renderCloseButton() {
    return ze`
      <${this.getScopedTag(Fn.buttonTagName)} 
        variant="tertiary" 
        id="close"
        class="close-button"
        @beacon-event-click=${this.handleClose}>
        Close <${this.getScopedTag("beacon-icon")} name='close_small' size='m' slot='suffix'></${this.getScopedTag("beacon-icon")}>
      </${this.getScopedTag(Fn.buttonTagName)}>
    `;
  }
  render() {
    const t = {
      "action-wrapper": this.isDrilldown,
      "close-button-wrapper": !0
    }, e = {
      container: !0,
      "is-drilldown": this.isDrilldown
    };
    return pe`
      <div class="content-wrapper">
        <div class=${Pe(e)} part="toolbelt-container">
          <div class="content-wrapper">
            <div class=${Pe(t)}>
              ${this.renderBackButton()} ${this.renderCloseButton()}
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
};
dc.tagName = Fn.beaconTagName, dc.nestedComponents = [Er, ro];
let br = dc;
Pv([
  ue()
], br.prototype, "isDrilldown", 2);
Pv([
  qe
], br.prototype, "prerenderNavigationToolbeltSetup", 1);
const jT = ve`:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation]{--navigation-action-zone-size: var(--beacon-reference-space-12);--navigation-wrapper-block-size: var(--beacon-reference-space-13);--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-7);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-5);--navigation-header-zone-padding-inline: 0;--navigation-wordmark-inline-size: 118px;--navigation-skip-link-outline: none;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(17 * var(--beacon-reference-space-5))}@media (width >= 640px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation]{--navigation-brand-zone-padding-inline-start: var(--beacon-reference-space-9);--navigation-brand-zone-padding-inline-end: var(--beacon-reference-space-7);--navigation-popover-size-inline: calc(21.25 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(18 * var(--beacon-reference-space-5))}}@media (width >= 960px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation]{--navigation-wrapper-block-size: var(--beacon-reference-space-14);--navigation-brand-zone-padding-inline-start: 0;--navigation-brand-zone-padding-inline-end: 0;--navigation-popover-size-inline: calc(18 * var(--beacon-reference-space-5))}}@media (width >= 1280px){:root[beacon-tag-name=beacon-navigation],:root [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"][beacon-tag-name=beacon-navigation],[beacon-version="4.4.0"] [beacon-tag-name=beacon-navigation]{--navigation-wordmark-inline-size: 132px;--navigation-popover-size-inline: calc(24.75 * var(--beacon-reference-space-5));--navigation-popover-content-size-inline: calc(21.75 * var(--beacon-reference-space-5))}}`, Yt = {
  // Tag Names
  beaconTagName: "beacon-navigation",
  buttonTagName: "beacon-button",
  iconButtonTagName: "beacon-icon-button",
  // Slot Name
  localSlot: "local-zone",
  globalSlot: "global-zone",
  actionSlot: "action-zone",
  brandMarkSlot: "brandmark",
  wordMarkSlot: "wordmark",
  wordMarkAriaLabel: "T. Rowe Price - Home"
};
function jn(a) {
  const t = [
    "beacon-navigation-popover",
    "beacon-navigation-toolbelt"
  ];
  return a.hasAttribute("beacon-tag-name") && t.includes(a.getAttribute("beacon-tag-name"));
}
const _T = ve`[beacon-tag-name=beacon-navigation][menu-expanded] ::part(icon-button){color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation] a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);color:var(--beacon-component-primary-navigation-header-color-text-link)}[beacon-tag-name=beacon-navigation] a:not(:hover,:focus){text-decoration:none}@media (width < 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name=beacon-navigation] a:not([slot=skip-link]):focus-visible:not(dialog){position:relative}}@media (width >= 960px){[beacon-tag-name=beacon-navigation] a[aria-current=page]{border-block-end:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-brand)}}[beacon-tag-name=beacon-navigation] a[slot=wordmark]{color:inherit}[beacon-tag-name=beacon-navigation] a[slot=skip-link]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;color:var(--beacon-system-color-text-set-navy);display:inline-block;text-decoration:none;z-index:-1}[beacon-tag-name=beacon-navigation] a[slot=skip-link]:focus-visible{border:revert;clip:revert;block-size:revert;margin:revert;overflow:revert;padding:revert;position:revert;inline-size:revert;border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus);margin:var(--beacon-system-space-cell-contained);outline:var(--navigation-skip-link-outline, revert);z-index:auto}[beacon-tag-name=beacon-navigation] [slot=header-zone] svg{color:var(--beacon-system-color-icon-link, currentColor)}[beacon-tag-name=beacon-navigation] [slot=media]{max-inline-size:100%}[beacon-tag-name=beacon-navigation] [slot=media]>*{max-inline-size:100%}[beacon-tag-name=beacon-navigation][drilldown-expanded] :is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation]):not([beacon-tag-name=beacon-navigation-popover],[beacon-tag-name=beacon-navigation-toolbelt],div),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot=local-zone],[slot=global-zone],[slot=header-zone],[slot=site-selector],[slot=action-zone],[site-navigation])>:is([beacon-tag-name=beacon-navigation-button],a):not([active]),[beacon-tag-name=beacon-navigation][drilldown-expanded] div:is([slot],[site-navigation]) [active],[beacon-tag-name=beacon-navigation][drilldown-expanded] [country-selector]{display:none}[beacon-tag-name=beacon-navigation] div[slot=action-zone]>*{inline-size:100%}@media (width >= 960px){[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-button]{block-size:100%;display:grid}[beacon-tag-name=beacon-navigation] div[site-navigation]>[beacon-tag-name=beacon-navigation-toolbelt]{z-index:0}[beacon-tag-name=beacon-navigation] a[slot=local-zone],[beacon-tag-name=beacon-navigation] [slot=local-zone]>a{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]):not([beacon-tag-name=beacon-navigation-toolbelt],[beacon-tag-name=beacon-navigation-popover]){inline-size:max-content}[beacon-tag-name=beacon-navigation] div:is([slot=local-zone],[slot=global-zone])>*:not([beacon-tag-name=beacon-navigation-toolbelt]){inline-size:inherit}[beacon-tag-name=beacon-navigation] :is(a,[beacon-tag-name=beacon-icon-button]):is([slot=local-zone],[slot=global-zone]),[beacon-tag-name=beacon-navigation] :is([slot=local-zone],[slot=global-zone]) a{padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}[beacon-tag-name=beacon-navigation]>a:not([slot],[data-has-beacon-language-event],[selected-language]){align-items:center;block-size:100%;color:var(--beacon-component-primary-navigation-header-color-text-link);display:grid;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);padding-block-end:var(--beacon-system-space-cell-free-floating);padding-block-start:var(--beacon-system-space-cell-free-floating)}}div[site-navigation].aem-edit-mode{display:flex;flex-direction:row;gap:var(--beacon-reference-space-9)}`, UT = ve`@media (width >= 960px){:host{z-index:2000}.primary-wrapper{position:relative}:host([in-motion]) .primary-wrapper{z-index:-1}.sitenav-ul-wrapper{background-color:inherit}}`;
var $T = Object.defineProperty, HT = Object.getOwnPropertyDescriptor, fg = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? HT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && $T(t, e, o), o;
};
function KT(a) {
  let t = class extends a {
    static get navigationMotionStyles() {
      return [UT];
    }
    get siteNavWrapper() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".primary-wrapper");
    }
    get headerWrapper() {
      var e;
      return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".header-wrapper");
    }
    /**
     * Applies custom motion classes to the header and site nav wrappers.
     *
     * @param layer The layer order this element should appear where higher numbers are higher `z-index` values.
     * @param additionalClasses Arbitrary number of extra classes to apply to the class set.
     */
    generateMotionClasses(...e) {
      const i = [];
      return this.hasFieldAndValue("isMobile", !1) && i.push(
        "b-motion--intro-from-top",
        "b-motion-ease--decelerate--emphasize-1",
        "b-motion-duration--extra-long-2",
        ...e
      ), i;
    }
    applyNavigationMotionStyles({ target: e }) {
      var i, o;
      e === this && !this.prefersReducedMotion && ((i = this.headerWrapper) == null || i.classList.add(...this.generateMotionClasses()), (o = this.siteNavWrapper) == null || o.classList.add(
        ...this.generateMotionClasses("b-motion-delay--medium-2")
      ));
    }
    /**
     * Removes custom motion classes from the header and site nav wrappers.
     *
     * It gets triggered from site nav because these classes add `z-index` styles and prematurely removing those classes from the header - since it finishes animating first - cause visual overlap as the site nav fades in.
     *
     * To avoid that, site nav finishes animating first so the two elements remove their classes together.
     *
     * @param target Event target.
     */
    static removeNavigationMotionClasses({ target: e }) {
      e instanceof HTMLElement && e.previousElementSibling instanceof HTMLElement && [e, e.previousElementSibling].forEach(
        (i) => i.classList.remove(
          ...Array.from(i.classList).filter(
            (o) => o.includes("b-motion")
          )
        )
      );
    }
    attachAnimationendListener({ target: e }) {
      this.siteNavWrapper && e === this && this.siteNavWrapper.addEventListener(
        "animationend",
        t.removeNavigationMotionClasses
      );
    }
    prerenderNavigationMotionSetup() {
      this.addEventListener(
        Ee.ELEMENT_READY,
        this.applyNavigationMotionStyles
      ), this.addEventListener(
        Ee.ELEMENT_READY,
        this.attachAnimationendListener
      );
    }
  };
  return fg([
    qe
  ], t.prototype, "prerenderNavigationMotionSetup", 1), t = fg([
    $e("NavigationMotion")
  ], t), t;
}
const GT = ve`:host{--bg: var(--beacon-system-color-background-0);background-color:var(--bg);position:relative;z-index:2000}.skip-link-wrapper{background-color:var(--beacon-system-color-background-link-focus);inline-size:100%}.skip-link-wrapper .skip-link-container{margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}ul{margin:0;padding:0}.wordmark-container{color:var(--beacon-system-color-text-title);display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.wordmark-container svg,.wordmark-container ::slotted(svg){max-inline-size:var(--navigation-wordmark-inline-size)}.brand-zone-container{align-items:center;background-color:var(--beacon-system-color-background-0, );display:flex;justify-content:space-between;min-block-size:var(--navigation-wrapper-block-size);padding-inline-end:var(--navigation-brand-zone-padding-inline-end);padding-inline-start:var(--navigation-brand-zone-padding-inline-start)}.brand-zone-container ::slotted(svg){flex-shrink:0}.wordmark-container a,.brand-zone-container a{color:inherit;display:inline-flex}@media (width < 960px){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){.wordmark-container a:focus-visible,.brand-zone-container a:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.wordmark-container a:focus-visible:not(dialog),.brand-zone-container a:focus-visible:not(dialog){position:relative}}[name=trusty]::part(internal--icon){inline-size:100%;max-inline-size:72px}.local-header-global-container{inline-size:100%}.action-zone-wrapper{align-items:center;background-color:var(--beacon-system-color-background-2);display:flex;gap:var(--beacon-reference-space-5);inline-size:100%;inset-block-end:0;inset-inline-start:0;padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--beacon-system-space-organism-jumbo);position:fixed;z-index:var(--navigation-action-zone-z-index, 2)}::slotted([slot=action-zone]){inline-size:100%}.menu{background-color:var(--beacon-system-color-background-1);block-size:calc(100dvh - var(--navigation-wrapper-block-size) - var(--action-zone-size, 0))}.menu .action-zone-wrapper{min-block-size:var(--action-zone-size, auto)}.vertical-divider{display:none;inline-size:var(--beacon-system-width-border-mini)}.header-zone-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--navigation-header-zone-padding-inline)}.local-zone-container,.global-zone-container,.sitenav-ul-wrapper{align-items:start;border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;flex-direction:column;gap:var(--beacon-reference-space-5);padding-block:var(--beacon-reference-space-5)}.partner-logo-wrapper{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);margin-block-end:var(--beacon-system-space-micro-jumbo);padding-block-end:var(--beacon-system-space-micro-jumbo)}.partner-logo{--partner-logo-max-inline-size: 92px;max-inline-size:var(--beacon-custom-navigation-partner-logo-max-inline-size, var(--partner-logo-max-inline-size))}.site-selector-slot{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-end:var(--beacon-reference-space-5)}.country-selector-slot{padding-block-start:var(--beacon-reference-space-5)}::part(icon-button){color:var(--beacon-system-color-icon-link)}.drill-up::part(standard-button){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);--beacon-button-icon-align: center;align-items:center;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:0}.drill-up [beacon-tag-name=beacon-icon]{align-self:center;margin-inline-end:var(--beacon-reference-space-3)}:host([drilldown-expanded]) .local-zone-container,:host([drilldown-expanded]) .global-zone-container,:host([drilldown-expanded]) .sitenav-ul-wrapper,:host([drilldown-expanded]) .site-selector-slot{border:0}:host([drilldown-expanded]) .site-selector-slot{padding-block-start:var(--beacon-reference-space-5)}:host([menu-expanded]){--navigation-menu-expanded-navigation-button-color: var(--beacon-system-color-text-link)}:host([menu-expanded]) ::part(icon-button){color:var(--beacon-system-color-icon-link)}:host([menu-expanded]) .menu-zone-container{overflow-y:auto;padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .menu-zone-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}:host([menu-expanded]) .action .action-zone-wrapper{background-color:transparent;padding-block:var(--beacon-reference-space-5);padding-inline:0;position:static}.hide{display:none}::slotted(div[site-navigation]),::slotted(div[slot]){display:contents}.menu-closed.header-zone-only{display:none}.nav-dialog-overlay{block-size:100%;border:0;inline-size:100%;max-block-size:none;max-inline-size:none;padding:0;position:fixed}.skip-link{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;color:var(--beacon-system-color-text-set-navy);display:inline-block;text-decoration:none;z-index:-1}.skip-link:focus-visible{border:revert;clip:revert;block-size:revert;margin:revert;overflow:revert;padding:revert;position:revert;inline-size:revert;border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus);margin:var(--beacon-system-space-cell-contained);outline:var(--navigation-skip-link-outline, revert);z-index:auto}.a11y-skip-navigation-links{border:0;outline:0}@media (width >= 960px){.header-wrapper{background-color:var(--bg);display:flex;justify-content:space-between;margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);min-block-size:var(--navigation-wrapper-block-size);position:relative}.brand-zone-container{block-size:fit-content;gap:var(--beacon-reference-space-7)}.menu-zone-container:not(.hide){align-items:center;display:flex;min-block-size:inherit;padding-inline-end:var(--beacon-system-space-cell-contained)}.wordmark-container{padding:var(--beacon-system-space-cell-contained)}.action-zone-wrapper{background-color:inherit;margin-inline-start:var(--beacon-reference-space-5);padding:var(--beacon-system-space-cell-contained);padding-inline-end:0;position:static;z-index:auto}.global-zone-container,.local-zone-container{align-items:center;border:0;flex-direction:row;padding-block:var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained)}.site-selector-slot{display:contents}.ul-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-5)}::slotted([slot=action-zone]){inline-size:initial}::slotted([beacon-tag-name=beacon-button]){min-inline-size:max-content;word-break:keep-all}.primary-wrapper{background-color:var(--beacon-system-color-background-0);display:grid;gap:var(--beacon-reference-space-9);grid-template-columns:1fr auto 1fr;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.partner-logo-wrapper{border:0;grid-column:3/4;margin:0;padding-block:0;padding-inline-end:var(--beacon-reference-space-5);place-self:center end}.sitenav-ul-wrapper{align-items:center;block-size:var(--beacon-reference-space-13);border-block-end:0;flex-direction:row;gap:var(--beacon-reference-space-9);grid-column:2/3;justify-content:center;padding:0}.sitenav-ul-wrapper ::slotted([beacon-tag-name=beacon-navigation-button]){block-size:100%;display:grid}.vertical-divider{display:block}}@media (width >= 1280px){.partner-logo{--partner-logo-max-inline-size: 115px}}`;
var WT = Object.defineProperty, VT = Object.getOwnPropertyDescriptor, Ze = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? VT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && WT(t, e, o), o;
};
const qT = (a) => !!a && a.level === 2, YT = (a) => "isDrilldown" in a;
var io;
const Xe = (io = class extends Ge(Le).with(
  aT,
  Lr({ autoRemoveMotionClasses: !1 }),
  KT,
  $i,
  Sb({ onReady: !1, removeLargeEvent: !0 }),
  al({ skipFirstUpdated: !1, runOnSlotchange: !0 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Yt.beaconTagName, this.focusOverride = !0, this.isDrilldownExpanded = !1, this.wordmarkUrl = "", this.isMenuExpanded = !1, this.currentOpenSlot = jt.DEFAULT, this.isCustomWordmark = !1, this.isActionZone = !1, this.isGlobalZone = !1, this.isLocalZone = !1, this.isSiteNav = !1, this.isSiteSelector = !1, this.activeNavItem = null, this.activeNavItemClickAwayHandler = ({ x: t, y: e, target: i }) => {
      var o, n, l, L, D, j, I, B, R;
      if (this.activeNavItem) {
        const N = this.activeNavItem.getBoundingClientRect(), x = (n = (o = this.activeNavItem) == null ? void 0 : o.expandingElement) == null ? void 0 : n.getBoundingClientRect(), T = mg(t, e, N) && mg(t, e, x), y = this.activeNavItem.contains(i) || ((L = (l = this.activeNavItem) == null ? void 0 : l.expandingElement) == null ? void 0 : L.contains(i)) || ((j = (D = this.activeNavItem) == null ? void 0 : D.shadowRoot) == null ? void 0 : j.contains(i)) || ((R = (B = (I = this.activeNavItem) == null ? void 0 : I.expandingElement) == null ? void 0 : B.shadowRoot) == null ? void 0 : R.contains(
          i
        ));
        T && !y && Fe(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
      }
    }, this.handleBreakpointChanges = ({ matches: t }) => {
      var e, i, o, n;
      if (!t)
        this.setHeaderZoneElement("header-zone"), this.currentOpenSlot === jt.COUNTRY && io.resetOpenCountrySelector();
      else {
        this.isMenuExpanded = !1, this.isDrilldownExpanded = !1, ks(), this.setHeaderZoneElement("global-zone"), this.removeOnLightClasses(), this.invertOpenMenuMode(), ((i = Array.from((e = this.renderRoot) == null ? void 0 : e.children)) == null ? void 0 : i.find(
          (D) => D === this.headerEl
        )) || this.appendHeaderToRoot(), Mh(this.activeNavItem);
        const L = this.querySelector("[is-active]");
        if (qT(L)) {
          const D = L.closest(
            '[beacon-tag-name="beacon-navigation-toolbelt"]'
          );
          YT(D) && (D.isDrilldown = !1), (o = L.parentExpanded) == null || o.drillup(), (n = L.parentExpanded) == null || n.setGridTemplates();
        }
      }
      this.updateActionZoneScale();
    }, this.handleActiveNavItemChange = ({ target: t }) => {
      t instanceof rt && (this.activeNavItem = this.querySelector(
        '[beacon-tag-name="beacon-navigation-button"][active]'
      ), this.isMobile && this.updateDrilldownExpanded(t.active), this.currentOpenSlot = this.activeNavItem instanceof rt ? this.activeNavItem.navType : jt.DEFAULT);
    }, this.addEventToSkipLink = () => {
      var e, i;
      const t = ((e = this.skipLink[0]) == null ? void 0 : e.matches("a")) && this.skipLink[0] || ((i = this.skipLink[0]) == null ? void 0 : i.querySelector("a"));
      t == null || t.addEventListener("click", () => {
        Fe(t, Ee.SKIP_LINK_CLICK);
      });
    }, this.handleSkipLinkClick = () => {
      this.isMenuExpanded && this.updateMenuExpanded();
    }, this.handleClickFromAnyLink = () => {
      this.isMenuExpanded && this.updateMenuExpanded(), Fe(this, Ee.CLOSE_ACTIVE_NAV_ITEM);
    }, this.onNavKeyDown = (t) => {
      t.key === Di.ESCAPE && this.isMobile && this.isMenuExpanded && this.updateMenuExpanded();
    };
  }
  static get styles() {
    return [
      super.styles,
      this.motionStyles,
      this.inverseStyles,
      GT,
      this.navigationMotionStyles
    ];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, _T, jT];
  }
  // Excludes skip link and wordmark
  // Excludes _skip-link-anchor because vitest picks it up for some unknown reason
  get allSlottedContent() {
    return [...this.slottedZoneContent, ...this.slottedSiteNavigation].filter(
      (t) => t.localName !== "style" && t.slot !== "_skip-link-anchor"
    );
  }
  get slottedZoneContent() {
    return [
      ...this.slottedActionZone,
      ...this.slottedLocalZone,
      ...this.slottedGlobalZone,
      ...this.slottedHeaderZone
    ].filter((t) => t.localName !== "style");
  }
  /** Text to use as the ARIA label for the mobile menu button. */
  get menuAriaLabel() {
    return this.isMenuExpanded ? "Close Menu" : "Open Menu";
  }
  /** The header maintains some views as light-only, and this getter returns the correct light mode to use based on the current mode of the parent. */
  get lightModeClass() {
    var t;
    return ((t = this.modeStoreComponent) == null ? void 0 : t.currentMode) === "beacon-on-lighter" ? "beacon-on-lighter" : "beacon-on-light";
  }
  /** Query for the brand zone section. */
  get brandZoneContainer() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector(".brand-zone-container");
  }
  /** Query for the TRP Wordmark. */
  get defaultWordmark() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector(".wordmark");
  }
  get allLinks() {
    return Array.from(this.querySelectorAll("a"));
  }
  setCustomWordmarkState() {
    var t;
    this.isCustomWordmark = !!((t = this.slottedWordmark) != null && t.length);
  }
  setActionZoneState() {
    var t;
    this.isActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  setGlobalZoneState() {
    const t = this.slottedGlobalZone.find(
      (e) => e.getAttribute("beacon-tag-name") !== "beacon-navigation-toolbelt" || e.getAttribute("beacon-tag-name") !== "beacon-navigation-popover"
    );
    this.isGlobalZone = !!t;
  }
  setLocalZoneState() {
    var t;
    this.isLocalZone = !!((t = this.slottedLocalZone) != null && t.length);
  }
  setSiteNavigationState() {
    var t, e;
    this.isSiteNav = !!((t = this.slottedSiteNavigation) != null && t.length), (e = this.slottedSiteNavigation) == null || e.forEach(
      (i) => i.setAttribute("site-navigation", "")
    );
  }
  setSiteSelectorState() {
    var t;
    this.isSiteSelector = !!((t = this.slottedSiteSelector) != null && t.length);
  }
  /**
   * Actions taken when pressing the back button.
   *
   * @fires BeaconEvents beacon-event-drillup
   */
  handleBackButton() {
    Fe(this, Ee.DRILLUP);
  }
  /** Updates header state when the header zone item is clicked. */
  handleHeaderZoneClick() {
    this.updateMenuExpanded(), this.updateDrilldownExpanded(!0), this.invertOpenMenuMode();
  }
  /**
   * Appends the header to the dialog.
   */
  appendHeaderToDialog() {
    this.navigationDialogElement.appendChild(this.headerEl), this.navigationDialogElement.showModal();
  }
  /**
   * Appends the header to the root.
   */
  appendHeaderToRoot() {
    var t, e;
    (t = this.skipLinWrapperEl) == null || t.insertAdjacentElement("afterend", this.headerEl), (e = this.navigationDialogElement) == null || e.close();
  }
  /** Performed when the menu icon is interacted with. */
  handleMenuClick() {
    this.isMenuExpanded && this.handleBackButton(), this.updateMenuExpanded(), this.toggleActionZoneLightMode(), this.invertOpenMenuMode();
  }
  /**
   * Handles changes when the expanded menu opens or closes.
   *
   * @todo implement focus trapping when opening the menu so you can't tab into other elements on the page. could look at a dialog.showModal solution, adding `inert` to all non-this elements, maybe our focus-trap mixin, etc.
   */
  updateMenuExpanded() {
    if (this.isMenuExpanded = !this.isMenuExpanded, this.isMenuExpanded) {
      Fe(this, Ee.OPEN), Eb(), this.activeNavItem && this.updateDrilldownExpanded(!0);
      return;
    }
    Fe(this, Ee.CLOSE), ks(), this.updateDrilldownExpanded();
  }
  /** Sets the drilldown expanded state based on a supplied condition. */
  updateDrilldownExpanded(t = !1) {
    this.isDrilldownExpanded = t;
  }
  /** Forces slotted action zone elements into light mode when the menu opens. */
  toggleActionZoneLightMode() {
    this.slottedActionZone.length > 0 && this.slottedActionZone.forEach((t) => {
      this.isMenuExpanded ? t.classList.add(this.lightModeClass) : t.classList.remove(this.lightModeClass);
    });
  }
  /** Applies a light theme to the expanded menu. The menu is always light theme. */
  invertOpenMenuMode() {
    var e, i, o, n;
    let t;
    ((e = this.modeStoreComponent) == null ? void 0 : e.currentMode) === "beacon-on-darker" || ((i = this.modeStoreComponent) == null ? void 0 : i.currentMode) === "beacon-on-lighter" ? t = "beacon-on-lighter" : t = "beacon-on-light", this.isMenuExpanded && this.modeStoreComponent ? ((o = this.brandZoneContainer) == null || o.classList.add(
      this.modeStoreComponent.currentMode
    ), this.classList.add(t)) : this.modeStoreComponent && ((n = this.brandZoneContainer) == null || n.classList.remove(
      this.modeStoreComponent.currentMode
    ), this.classList.remove(t));
  }
  /** Sets the location of the header zone element. */
  setHeaderZoneElement(t) {
    const e = t === "header-zone" ? this.slottedGlobalZone.find((i) => i.hasAttribute("header-zone")) : this.slottedHeaderZone.find((i) => i.hasAttribute("header-zone"));
    e == null || e.setAttribute("slot", t);
  }
  /**
   * Due to the nature of cloning country components, we want to force the country selector closed when going from a desktop view to mobile view with the country selector active.
   */
  static resetOpenCountrySelector() {
    const t = document.querySelector(
      '[beacon-tag-name="beacon-navigation-toolbelt"][is-open]'
    ), e = document.querySelector(
      '[beacon-tag-name="beacon-navigation-button"][active]'
    );
    t instanceof br && e instanceof rt && (t.isOpen = !1, e.active = !1);
  }
  /**
   * Remove onLight Classes
   */
  removeOnLightClasses() {
    var t, e;
    this.slottedHeaderZone && ((t = this.slottedHeaderZone) != null && t.length) && this.slottedHeaderZone.forEach(
      (i) => i.classList.remove(this.lightModeClass)
    ), this.slottedActionZone && ((e = this.slottedActionZone) != null && e.length) && this.slottedActionZone.forEach(
      (i) => i.classList.remove(this.lightModeClass)
    );
  }
  /**
   * Update slottedActionZone Button scales based on breakpoint.
   */
  updateActionZoneScale() {
    var t;
    this.isMobile && ((t = this.slottedActionZone) != null && t.length) ? this.slottedActionZone.forEach((e) => e.setAttribute("scale", "mini")) : this.slottedActionZone.forEach((e) => e.setAttribute("scale", "normal"));
  }
  updateAnalytics() {
    super.updateAnalytics(), this.defaultWordmark && this.defaultWordmark.setAttribute(
      It.location,
      Vo.header
    ), this.isCustomWordmark && this.slottedWordmark.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.header
      );
    }), this.isLocalZone && this.slottedLocalZone.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.header
      ), jn(t) ? t.setAttribute(
        It.section,
        Zi[1]
      ) : t.setAttribute(
        It.section,
        Zi[0]
      );
    }), this.isGlobalZone && this.slottedGlobalZone.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.header
      ), jn(t) ? t.setAttribute(
        It.section,
        Zi[1]
      ) : t.setAttribute(
        It.section,
        Zi[0]
      );
    }), this.isActionZone && this.slottedActionZone.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.header
      ), jn(t) ? t.setAttribute(
        It.section,
        Zi[1]
      ) : t.setAttribute(
        It.section,
        Zi[0]
      );
    }), this.isSiteSelector && this.slottedSiteSelector.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.header
      ), jn(t) ? t.setAttribute(
        It.section,
        t.getAttribute("opens-by") === "country-selector" ? qo.level1LangSelector : qo.links
      ) : t.setAttribute(
        It.section,
        qo.selectedLink
      );
    }), this.isSiteNav && this.slottedSiteNavigation.forEach((t) => {
      t.setAttribute(
        It.location,
        Vo.siteNav
      ), jn(t) ? t.setAttribute(
        It.section,
        Yn.level_2
      ) : t.setAttribute(
        It.section,
        Yn.level_1
      );
    }), this.allSlottedContent.forEach((t) => {
      jn(t) && Q1(t) && t.updateAnalytics();
    });
  }
  /**
   * Appends aria role to be listitem
   */
  appendAriaRole() {
    this.allSlottedContent.forEach(
      (t) => io.setListItemRole(t)
    ), this.slottedSiteSelector.forEach(
      (t) => io.setListItemRole(t)
    );
  }
  /** Shorthand method for setting the listitem role on elements. */
  static setListItemRole(t) {
    t.setAttribute("role", "listitem");
  }
  calculateActionZoneSize() {
    return this.isActionZone ? this.isDrilldownExpanded ? "0px" : "var(--header-action-zone-size, 56px)" : "0px";
  }
  addClickEventsToAllLinks() {
    this.allLinks.length > 0 && this.allLinks.forEach((t) => {
      t.addEventListener("click", (e) => {
        Fe(t, Ee.NAVIGATION_LINK_CLICK, e);
      });
    });
  }
  updated(t) {
    var e, i;
    t.has("isMenuExpanded") && this.isMobile && (this.isMenuExpanded ? (this.appendHeaderToDialog(), (e = this.hamburgerIconButton) == null || e.button.focus()) : (this.appendHeaderToRoot(), (i = this.hamburgerIconButton) == null || i.button.focus()));
  }
  navigationPrerender() {
    this.addEventListener(
      Ee.ACTIVE_NAV_ITEM,
      this.handleActiveNavItemChange
    ), this.addEventListener(
      Ee.HEADER_ZONE_CLICK,
      this.handleHeaderZoneClick
    ), this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    ), window.addEventListener("click", this.activeNavItemClickAwayHandler), document.addEventListener(
      Ee.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.addEventListener(
      Ee.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.addEventListener(et.KEYDOWN, this.onNavKeyDown);
  }
  navigationPostRender() {
    this.appendAriaRole(), this.isMobile && this.setHeaderZoneElement("header-zone"), this.updateActionZoneScale(), this.addEventToSkipLink(), this.addClickEventsToAllLinks();
  }
  addBuiltInSkipLink() {
    const t = document.createElement("template");
    t.innerHTML = '<div slot="_skip-link-anchor" class="a11y-skip-navigation-links" id="a11y-skip-navigation-links"></div>';
    const e = t.content.cloneNode(!0);
    this.append(e);
  }
  setCurrentPage() {
    const { href: t } = window.location, e = this.allLinks.find(
      (i) => t.includes(i.href) ? i : void 0
    );
    e && (e.ariaCurrent = "page");
  }
  navigationDestroy() {
    window.removeEventListener("click", this.activeNavItemClickAwayHandler), document.removeEventListener(
      Ee.SKIP_LINK_CLICK,
      this.handleSkipLinkClick
    ), document.removeEventListener(
      Ee.NAVIGATION_LINK_CLICK,
      this.handleClickFromAnyLink
    ), document.removeEventListener(et.KEYDOWN, this.onNavKeyDown);
  }
  /**
   * Renders the brandmark slot with the appropriate default logo.
   */
  renderBrandMarkSlot() {
    const t = {
      "brandmark-slot": !0,
      hide: this.isMobile
    }, e = ze`<${this.getScopedTag("beacon-icon")} name="trusty" label="T. Rowe Price"></${this.getScopedTag("beacon-icon")}>`;
    return pe`<slot
      class=${Pe(t)}
      name="${Yt.brandMarkSlot}">
      ${this.wordmarkUrl ? pe`<a href="${this.wordmarkUrl}" class="trusty-link">${e}</a>` : pe`${e}`}</slot
    >`;
  }
  /**
   * Render the wordmark Slot or drill-up button.
   */
  renderWordMarkSlot() {
    return this.isMobile && this.isDrilldownExpanded && this.currentOpenSlot !== jt.HEADER ? ze`
      <${this.getScopedTag(Yt.buttonTagName)} variant="tertiary" class="drill-up" @beacon-event-click=${this.handleBackButton}>
        <${this.getScopedTag("beacon-icon")} name="chevron_left_small" size="s" slot="prefix"></${this.getScopedTag("beacon-icon")}>
        Back
      </${this.getScopedTag(Yt.buttonTagName)}>` : pe`
      <slot
        name="${Yt.wordMarkSlot}"
        class="wordmark-container"
        @slotchange=${this.setCustomWordmarkState}>
        ${this.wordmarkUrl ? pe`<a
              class="wordmark"
              href="${this.wordmarkUrl}"
              aria-label="${Yt.wordMarkAriaLabel}"
              >${gt(gg)}</a
            >` : pe`${gt(gg)}`}
      </slot>
    `;
  }
  /** Render the brand-colored vertical divider. */
  renderVerticalDividerBrand(t) {
    return this.isDesktop && t ? pe`<span aria-hidden="true"
        >${gt(nT)}</span
      >` : pe``;
  }
  /**
   * Render Vertical Divider based on any boolean condition.
   */
  static renderVerticalDivider(t) {
    return t ? pe`${gt(rT)}` : pe``;
  }
  /** Render the site selector slot. */
  renderSiteSelectorSlot() {
    let t = !1;
    this.currentOpenSlot === jt.SITE_SELECTOR && (t = !0), this.currentOpenSlot === jt.COUNTRY && (t = !0);
    const e = {
      hide: this.isDrilldownExpanded && !t,
      "site-selector-slot": !0
    };
    return pe`
      <div class=${Pe(e)} role="list">
        <slot
          name="site-selector"
          @slotchange=${this.setSiteSelectorState}
          ${_e({ useParent: !0 })}></slot>
      </div>
    `;
  }
  /**
   * Render the menu button area which also includes the header zone.
   */
  renderMenuButtonArea() {
    const t = this.slottedHeaderZone.length === 1 && this.slottedZoneContent.length <= 2, e = this.allSlottedContent.length > 0 || this.isSiteSelector, i = {
      hide: this.slottedHeaderZone.length === 0 || this.isMenuExpanded
    }, o = {
      "header-zone-wrapper": !0,
      hide: this.isDesktop
    };
    return pe`
      <div class=${Pe(o)}>
        <div role="list" class=${Pe(i)}>
          <slot name="header-zone"></slot>
        </div>
        ${e ? this.renderMenuButton(this.isMenuExpanded, t) : pe``}
      </div>
    `;
  }
  /**
   * Renders a cached version of the appropriate icon for the menu button.
   */
  renderMenuButtonIcon(t) {
    return ze`${WM(
      t ? ze`<${this.getScopedTag("beacon-icon")} name='close_small' size='m' slot='icon'></${this.getScopedTag("beacon-icon")}> Close Menu` : ze`<${this.getScopedTag("beacon-icon")} name='menu' size='s' slot='icon'></${this.getScopedTag("beacon-icon")}> Open Menu`
    )}`;
  }
  /** Renders the Icon Button component used to trigger the opening or closing of the mobile menu. */
  renderMenuButton(t, e) {
    const n = `${t ? "menu-open" : "menu-closed"} ${e ? "header-zone-only" : ""}`;
    return ze`
      <${this.getScopedTag(Yt.iconButtonTagName)}
        class="${n}"
        variant="tertiary" 
        id="menu"
        data-metrics-section="${Zi[0]}"
        data-metrics-location="${Vo.header}" 
        @beacon-event-click=${this.handleMenuClick}>
          ${this.renderMenuButtonIcon(t)};
      </${this.getScopedTag(Yt.iconButtonTagName)}>
    `;
  }
  // prettier-ignore
  renderMenuZone() {
    return pe`
      ${this.isMobile ? io.renderPartnerLogoSlot() : pe``}
      ${this.isMobile ? this.renderSiteSelectorSlot() : pe``}
      ${this.isMobile ? pe`<div class="sitenav-wrapper">${this.renderSiteNav()}</div>` : pe``}
      ${this.renderLocalHeaderGlobalSlots()}
      ${this.isMobile ? this.renderCountrySelector() : pe``}
      ${this.renderActionZone()}
    `;
  }
  /** Render the site navigation. */
  renderSiteNav() {
    const t = {
      "sitenav-ul-wrapper": !0,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== jt.PRIMARY
    };
    return pe`
      <nav class="primary-wrapper">
        <ul class=${Pe(t)}>
          <slot
            @slotchange=${this.setSiteNavigationState}
            ${_e({ useParent: !0 })}></slot>
        </ul>
        ${this.isDesktop ? io.renderPartnerLogoSlot() : pe``}
      </nav>
    `;
  }
  static renderPartnerLogoSlot() {
    return pe`
      <div class="partner-logo-wrapper">
        <div class="partner-logo">
          <slot
            name="media"
            ${_e({ container: ".partner-logo-wrapper" })}></slot>
        </div>
      </div>
    `;
  }
  setGlobalZoneVisibility() {
    return this.isMobile && this.isDrilldownExpanded ? this.currentOpenSlot === jt.HEADER || this.currentOpenSlot === jt.GLOBAL : this.isGlobalZone;
  }
  /**
   * Render slots for the local, header, and global zones.
   *
   * Users should not interact with the header-zone directly.
   */
  renderLocalHeaderGlobalSlots() {
    const t = {
      "local-zone-container": !0,
      hide: !this.isLocalZone || this.isDrilldownExpanded && this.currentOpenSlot !== jt.LOCAL
    }, e = {
      "global-zone-container": !0,
      hide: !this.setGlobalZoneVisibility()
    }, i = {
      "header-zone-container": !0,
      hide: this.isDrilldownExpanded && this.currentOpenSlot !== jt.HEADER
    }, o = this.isLocalZone && this.isGlobalZone, n = this.isLocalZone && this.isActionZone && !this.isGlobalZone || this.isActionZone && this.isGlobalZone;
    return pe`
      <nav class="local-header-global-container">
        <div class="ul-wrapper" role="list">
          <slot
            name="${Yt.localSlot}"
            class=${Pe(t)}
            @slotchange=${this.setLocalZoneState}></slot>
          ${io.renderVerticalDivider(o)}
          <slot name="header-zone" class=${Pe(i)}></slot>
          <slot
            name="${Yt.globalSlot}"
            class=${Pe(e)}
            @slotchange=${this.setGlobalZoneState}></slot>
          ${io.renderVerticalDivider(n)}
        </div>
      </nav>
    `;
  }
  /**
   * Render action-zone slot.
   */
  renderActionZone() {
    const t = {
      "action-zone-wrapper": !0,
      hide: !this.isActionZone || this.isDrilldownExpanded && this.currentOpenSlot !== jt.ACTION
    };
    return pe`
      <div role="list" class="${Pe(t)}">
        <slot
          name="${Yt.actionSlot}"
          @slotchange=${this.setActionZoneState}></slot>
      </div>
    `;
  }
  /**
   * Renders the mobile country selector.
   *
   * Users should not interact with this slot directly.
   */
  renderCountrySelector() {
    const t = {
      "country-selector-slot": !0,
      hide: this.isDrilldownExpanded
    };
    return pe`
      <div class=${Pe(t)}>
        <slot name="country-selector"></slot>
      </div>
    `;
  }
  render() {
    const t = {
      hide: this.slottedZoneContent.length === 0 && !this.slottedSiteSelector || !this.isMenuExpanded && this.isMobile,
      menu: this.isMenuExpanded && this.isMobile,
      "menu-zone-container": !0
    }, e = {
      "header-wrapper": !0
    };
    e[this.currentOpenSlot] = !0;
    const i = {
      "--action-zone-size": this.calculateActionZoneSize()
    };
    return pe`
      <div class="skip-link-wrapper">
        <div class="skip-link-container">
          <slot name="skip-link"><a class="skip-link" href="#a11y-skip-navigation-links">Skip navigation links.</a></slot>
        </div>
      </div>
      <header class=${Pe(e)}>
        <section class="brand-zone-container">
          ${this.renderBrandMarkSlot()}
          ${this.renderWordMarkSlot()}
          ${this.renderVerticalDividerBrand(this.isSiteSelector)}
          ${this.isDesktop ? this.renderSiteSelectorSlot() : pe``}
          ${this.renderMenuButtonArea()}
        </section>
        <section class=${Pe(t)} style=${Cv(i)}>
          ${this.renderMenuZone()}
        </section>
      </header>
      ${this.isDesktop ? this.renderSiteNav() : pe``}
      <dialog id="nav-dialog" class="nav-dialog-overlay" aria-modal="true" aria-labelledby="header-wrapper"></dialog>
      <slot name="_skip-link-anchor"></slot>
    `;
  }
}, io.tagName = Yt.beaconTagName, io.nestedComponents = [Er, Qt, ro], io);
Ze([
  ue({ type: Boolean, reflect: !0, attribute: "drilldown-expanded" })
], Xe.prototype, "isDrilldownExpanded", 2);
Ze([
  ue({ attribute: "wordmark-href" })
], Xe.prototype, "wordmarkUrl", 2);
Ze([
  ue({ type: Boolean, reflect: !0, attribute: "menu-expanded" })
], Xe.prototype, "isMenuExpanded", 2);
Ze([
  Ce()
], Xe.prototype, "currentOpenSlot", 2);
Ze([
  Ce()
], Xe.prototype, "isCustomWordmark", 2);
Ze([
  Ce()
], Xe.prototype, "isActionZone", 2);
Ze([
  Ce()
], Xe.prototype, "isGlobalZone", 2);
Ze([
  Ce()
], Xe.prototype, "isLocalZone", 2);
Ze([
  Ce()
], Xe.prototype, "isSiteNav", 2);
Ze([
  Ce()
], Xe.prototype, "isSiteSelector", 2);
Ze([
  Ce()
], Xe.prototype, "activeNavItem", 2);
Ze([
  De({ flatten: !0, slot: "wordmark" })
], Xe.prototype, "slottedWordmark", 2);
Ze([
  De({ flatten: !0, slot: Yt.localSlot })
], Xe.prototype, "slottedLocalZone", 2);
Ze([
  De({ flatten: !0, slot: Yt.globalSlot })
], Xe.prototype, "slottedGlobalZone", 2);
Ze([
  De({ flatten: !0, slot: Yt.actionSlot })
], Xe.prototype, "slottedActionZone", 2);
Ze([
  De({ flatten: !0, slot: "header-zone" })
], Xe.prototype, "slottedHeaderZone", 2);
Ze([
  De({ flatten: !0 })
], Xe.prototype, "slottedSiteNavigation", 2);
Ze([
  De({ flatten: !0, slot: "site-selector" })
], Xe.prototype, "slottedSiteSelector", 2);
Ze([
  De({ flatten: !0, slot: "skip-link" })
], Xe.prototype, "skipLink", 2);
Ze([
  ot("dialog#nav-dialog")
], Xe.prototype, "navigationDialogElement", 2);
Ze([
  ot(".skip-link-wrapper")
], Xe.prototype, "skipLinWrapperEl", 2);
Ze([
  ot("[beacon-tag-name='beacon-icon-button']#menu")
], Xe.prototype, "hamburgerIconButton", 2);
Ze([
  ot("header")
], Xe.prototype, "headerEl", 2);
Ze([
  We("#a11y-skip-navigation-links")
], Xe.prototype, "skipLinkAnchor", 2);
Ze([
  qe
], Xe.prototype, "navigationPrerender", 1);
Ze([
  Re
], Xe.prototype, "navigationPostRender", 1);
Ze([
  Re
], Xe.prototype, "addBuiltInSkipLink", 1);
Ze([
  Re
], Xe.prototype, "setCurrentPage", 1);
Ze([
  Pt
], Xe.prototype, "navigationDestroy", 1);
let ss = Xe;
var XT = Object.defineProperty, QT = Object.getOwnPropertyDescriptor, Dv = (a) => {
  throw TypeError(a);
}, Qi = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? QT(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && XT(t, e, o), o;
}, ZT = (a, t, e) => t.has(a) || Dv("Cannot " + e), vg = (a, t, e) => (ZT(a, t, "read from private field"), e ? e.call(a) : t.get(a)), JT = (a, t, e) => t.has(a) ? Dv("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(a) : t.set(a, e), jt = /* @__PURE__ */ ((a) => (a.GLOBAL = "global", a.PRIMARY = "site-nav", a.LOCAL = "local", a.DEFAULT = "default", a.HEADER = "header", a.ACTION = "action", a.SITE_SELECTOR = "site-selector", a.COUNTRY = "country-selector", a))(jt || {}), Mb = /* @__PURE__ */ ((a) => (a.GLOBAL = "global-zone", a.PRIMARY = "site-navigation", a.LOCAL = "local-zone", a.HEADER = "header-zone", a.ACTION = "action-zone", a.SITE_SELECTOR = "site-selector", a.COUNTRY_SELECTOR = "country-navigation-button", a))(Mb || {});
const eL = /* @__PURE__ */ new Map([
  [
    "global-zone",
    "global"
    /* GLOBAL */
  ],
  [
    "local-zone",
    "local"
    /* LOCAL */
  ],
  [
    "site-navigation",
    "site-nav"
    /* PRIMARY */
  ],
  [
    "header-zone",
    "header"
    /* HEADER */
  ],
  [
    "site-selector",
    "site-selector"
    /* SITE_SELECTOR */
  ],
  [
    "country-navigation-button",
    "country-selector"
    /* COUNTRY */
  ],
  [
    "action-zone",
    "action"
    /* ACTION */
  ]
]);
function tL(a) {
  var t;
  let e = class extends a {
    constructor() {
      super(...arguments), this.active = !1, this.hasExpandedAnchor = !1, this.activeInStyleOnly = !1, this.toggleActive = ({ target: i }) => {
        i instanceof Element && (this.active = !this.active);
      }, this.handleFocusOut = ({ relatedTarget: i }) => {
        i instanceof HTMLElement && (this.expandingElement instanceof xa || this.expandingElement instanceof br) && !this.expandingElement.contains(i) && !this.isEqualNode(i) && this.hasFieldAndValue("isDesktop", !0) && this.active && (this.active = !1);
      }, this.handleDrillupEvent = ({ target: i }) => {
        i instanceof ss && this.expandingElement instanceof HTMLElement && wv(
          this.expandingElement
        ).filter((n) => n instanceof Ov && n.isActive).length < 1 && this.active && (this.active = !1);
      }, this.handleHeaderClose = ({ target: i }) => {
        i instanceof ss && (this.active = !1);
      }, this.closeOnActiveChange = ({ target: i }) => {
        i && "active" in i && i.active && this !== i && this.active && (this.active = !1);
      }, this.handleClickAway = ({ target: i }) => {
        i instanceof ss && this.hasFieldAndValue("isDesktop", !0) && (this.active = !1);
      }, JT(this, t, /* @__PURE__ */ new Map([
        [Ee.DRILLUP, this.handleDrillupEvent],
        [Ee.CLOSE, this.handleHeaderClose],
        [Ee.ACTIVE_NAV_ITEM, this.closeOnActiveChange],
        [Ee.CLOSE_ACTIVE_NAV_ITEM, this.handleClickAway]
      ]));
    }
    /** Callback for on beacon-event-active-nav-item-change */
    onBeaconActiveNavItemChange() {
    }
    /** Reference to the internal button element. */
    get button() {
      var i;
      return (i = this.shadowRoot) == null ? void 0 : i.querySelector(".button");
    }
    get expandingElementRoot() {
      return this.closest('[beacon-tag-name="beacon-navigation"]');
    }
    /** The Popover or Toolbelt that this navigation button triggers. */
    get expandingElement() {
      return (this.expandingElementRoot ? this.expandingElementRoot : document).querySelector(`[opens-by="${this.opens}"]`);
    }
    get closestSlot() {
      var i, o;
      return (o = (i = this.closest("[slot]")) == null ? void 0 : i.slot) != null ? o : "";
    }
    /** Sets a type to the component based on what slot it is in. */
    get navType() {
      var i;
      return this.hasExpandedAnchor && this.closestSlot !== "country-navigation-button" ? "default" : (i = eL.get(this.closestSlot)) != null ? i : "site-nav";
    }
    prerenderNavigationMenuTriggerSetup() {
      this.addEventListener(Ee.CLICK, this.toggleActive), vg(this, t).forEach((i, o) => {
        document.addEventListener(o, i);
      });
    }
    postrenderAddFocusOutListener() {
      var i;
      (i = this.button) == null || i.addEventListener(
        "focusout",
        this.handleFocusOut
      );
    }
    updated(i) {
      Dr(i, "active") && Fe(
        this,
        Ee.ACTIVE_NAV_ITEM,
        void 0,
        this.onBeaconActiveNavItemChange
      );
    }
    tearDownNavigationMenuTrigger() {
      vg(this, t).forEach((i, o) => {
        document.removeEventListener(o, i);
      });
    }
  };
  return t = /* @__PURE__ */ new WeakMap(), Qi([
    ue({ type: Boolean, reflect: !0 })
  ], e.prototype, "active", 2), Qi([
    ue({ type: Boolean, attribute: "expanded-anchor", reflect: !0 })
  ], e.prototype, "hasExpandedAnchor", 2), Qi([
    ue({ reflect: !0 })
  ], e.prototype, "opens", 2), Qi([
    Ce()
  ], e.prototype, "activeInStyleOnly", 2), Qi([
    qe
  ], e.prototype, "prerenderNavigationMenuTriggerSetup", 1), Qi([
    Re
  ], e.prototype, "postrenderAddFocusOutListener", 1), Qi([
    Pt
  ], e.prototype, "tearDownNavigationMenuTrigger", 1), e = Qi([
    $e("NavigationMenuTrigger")
  ], e), e;
}
var oL = Object.defineProperty, iL = Object.getOwnPropertyDescriptor, Ag = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? iL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && oL(t, e, o), o;
};
function aL(a) {
  let t = class extends a {
  };
  return Ag([
    ue({ attribute: "beacon-aria-label", reflect: !0 })
  ], t.prototype, "beaconAriaLabel", 2), t = Ag([
    $e("Aria")
  ], t), t;
}
const yg = {
  // Tag Names
  beaconTagName: "beacon-navigation-button"
}, nL = ve`[beacon-tag-name=beacon-navigation-button] [slot=flag]{margin-inline-end:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-navigation-button] svg{pointer-events:none}@media (width >= 960px){[beacon-tag-name=beacon-navigation-button] .button:not(.beacon-button):is(.global,.site-nav) *{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`, rL = ve`@media (width >= 960px){:host([motion-state=enabled]) .motion-underline--grow-out{--border-color: var(--beacon-system-color-border-secondary);--link-transform: scaleX(0);position:relative}:host([motion-state=enabled]) .motion-underline--grow-out:after,:host([motion-state=enabled]) .motion-underline--grow-out:before{--underline-opacity: 0;--underline-size: 50%;background-color:var(--border-color);block-size:var(--beacon-system-width-border-normal);content:"";inline-size:var(--underline-size);inset-block-end:0;opacity:var(--underline-opacity);position:absolute;transform:var(--link-transform);transform-origin:var(--link-transform-origin);transition-duration:var(--beacon-reference-motion-duration-5);transition-property:transform,opacity;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .motion-underline--grow-out:before{--link-transform-origin: right;inset-inline-end:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:after{--link-transform-origin: left;inset-inline-start:var(--underline-size)}:host([motion-state=enabled]) .motion-underline--grow-out:hover,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible,:host([motion-state=enabled]) .motion-underline--grow-out.active,:host([motion-state=enabled]) .motion-underline--grow-out.current{--link-transform: scaleX(1);text-decoration:none}:host([motion-state=enabled]) .motion-underline--grow-out:hover:after,:host([motion-state=enabled]) .motion-underline--grow-out:hover:before,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:after,:host([motion-state=enabled]) .motion-underline--grow-out:focus-visible:before,:host([motion-state=enabled]) .motion-underline--grow-out.active:after,:host([motion-state=enabled]) .motion-underline--grow-out.active:before,:host([motion-state=enabled]) .motion-underline--grow-out.current:after,:host([motion-state=enabled]) .motion-underline--grow-out.current:before{--underline-opacity: 1}:host([motion-state=enabled]) .motion-underline--grow-out.current:not(.active){--border-color: var(--beacon-system-color-border-brand)}}`;
var sL = Object.defineProperty, lL = Object.getOwnPropertyDescriptor, xg = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? lL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && sL(t, e, o), o;
};
function cL(a) {
  let t = class extends a {
    static get navigationButtonMotionStyles() {
      return [rL];
    }
    /** Sets the motion class on the button element if it meets the condition of being a primary nav item. */
    static activeItemMotionClasses({ target: e }) {
      var i;
      if (e instanceof HTMLElement) {
        const o = (i = e.shadowRoot) == null ? void 0 : i.querySelector(
          t.activeElementQuery
        );
        if (o instanceof HTMLButtonElement) {
          const { classList: n } = o;
          Array.from(n).includes(jt.PRIMARY) && o.classList.add("motion-underline--grow-out");
        }
      }
    }
    prerenderNavigationButtonMotionSetup() {
      this.addEventListener(
        Ee.ELEMENT_READY,
        t.activeItemMotionClasses
      );
    }
  };
  return t.activeElementQuery = ".button", xg([
    qe
  ], t.prototype, "prerenderNavigationButtonMotionSetup", 1), t = xg([
    $e("NavigationButtonMotion")
  ], t), t;
}
const dL = ve`:host{inline-size:fit-content}@media (width < 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}}@media (width < 960px) and (forced-colors: active){:host(:not([expanded-anchor])) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}@media (width >= 960px){:host(:not([expanded-anchor])) :not(a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([expanded-anchor])) :not(a):focus-visible:not(dialog){position:relative}}:host([expanded-anchor]) :not(a):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host([expanded-anchor]) :not(a):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host([show-popover]){position:relative}.flag{display:none}::slotted([slot=flag]){margin-inline-end:var(--beacon-reference-space-2)}.mobile-site-selector-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);padding-block:var(--beacon-system-space-cell-free-floating)}.plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;color:var(--beacon-system-color-text-standard);cursor:not-allowed;display:flex;gap:var(--beacon-reference-space-2)}.plain-text .icon--default{display:flex}.plain-text svg{fill:var(--beacon-system-color-text-standard)}.chevron{--chevron-transform: 90deg;transform:rotate(var(--chevron-transform))}.icon--restricted{color:var(--beacon-system-color-text-standard);margin-block-end:var(--beacon-reference-space-0)}.icon--restricted::part(icon){inline-size:var(--beacon-reference-space-4)}:host([variant=standard]) [beacon-tag-name=beacon-icon]:not(.icon--restricted){color:var(--beacon-system-color-icon-link)}.button.beacon-button{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--bg-color);--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--hover-bg-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed);--active-border-color: var(--active-bg-color);--border-inline-start-width: var(--beacon-system-width-border-mini);--border-radius: var(--beacon-system-radius-corner-standard);--border-width: var(--beacon-system-width-border-mini);--default-gap: var(--beacon-reference-space-3);--font-weight: var(--beacon-system-font-weight-bold);--font-size: var(--beacon-reference-font-scale-4);--line-height: var(--beacon-reference-font-scale-4);background-color:var(--override-button-bg-color, var(--bg-color));border-color:var(--border-color);border-end-end-radius:var(--override-button-border-radius, var(--border-radius));border-end-start-radius:var(--override-button-border-radius, var(--border-radius));border-inline-start-width:var(--override-button-border-size-inline, var(--border-inline-start-width));border-start-end-radius:var(--override-button-border-radius, var(--border-radius));border-start-start-radius:var(--override-button-border-radius, var(--border-radius));border-style:solid;border-width:var(--override-button-border-width, var(--border-width));color:var(--text-color);display:inline-flex;flex-direction:var(--button-flex-direction, row);font:var(--font-weight) var(--beacon-component-button-normal-font-size-sans-serif-standard);gap:var(--override-button-icon-space-margin, var(--default-gap));inline-size:inherit;justify-content:center;outline-offset:1px;padding-block:var(--beacon-reference-space-4) var(--beacon-reference-space-4);padding-inline:var(--beacon-reference-space-5);text-align:start;text-decoration:none;word-break:initial;align-items:center}.button.beacon-button .contents{display:inherit;flex-direction:inherit;gap:inherit;justify-content:inherit}.button.beacon-button[aria-disabled=true]{background-color:var(--disabled-bg-color);border-color:var(--disabled-border-color);color:var(--disabled-text-color);cursor:not-allowed;text-decoration:none}.button.beacon-button:is(:hover,:focus-visible):not([aria-disabled=true]){background-color:var(--hover-bg-color);color:var(--hover-text-color);text-decoration:underline}.button.beacon-button:active:not([aria-disabled=true]){background-color:var(--active-bg-color);color:var(--active-text-color);text-decoration:none}.button.beacon-button.primary{--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--override-button-color-border-error, var(--bg-color));--text-color: var(--beacon-system-color-text-primary);--hover-bg-color: var(--beacon-system-color-background-primary-hover);--hover-text-color: var(--text-color);--disabled-bg-color: var(--beacon-system-color-background-primary-inactive);--disabled-text-color: var(--beacon-system-color-text-primary-inactive);--disabled-border-color: var(--disabled-bg-color);--active-bg-color: var(--beacon-system-color-background-primary-pressed);--active-text-color: var(--text-color)}.button.beacon-button.secondary{--bg-color: transparent;--border-color: var(--beacon-system-color-border-secondary);--text-color: var(--beacon-system-color-text-secondary);--hover-bg-color: var(--beacon-system-color-background-secondary-hover);--hover-border-color: var(--beacon-system-color-border-secondary-hover);--hover-text-color: var(--beacon-system-color-text-secondary-hover);--disabled-bg-color: var(--bg-color);--disabled-text-color: var(--beacon-system-color-text-secondary-inactive);--disabled-border-color: var(--beacon-system-color-border-secondary-inactive);--active-bg-color: var(--beacon-system-color-background-secondary-pressed);--active-text-color: var(--beacon-system-color-text-secondary-pressed)}.button.beacon-button.mini{--default-gap: var(--override-button-default-gap, var(--beacon-reference-space-2));--default-font-size: var(--beacon-component-button-mini-font-size-sans-serif-standard);--default-line-height: var(--beacon-component-button-mini-line-height-sans-serif-standard);--font-size: var(--override-button-font-size-mini, var(--default-font-size));--line-height: var(--override-button-font-line-height-mini, var(--default-line-height));font:var(--font-weight) var(--beacon-component-button-mini-font-size-sans-serif-standard);margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.button.beacon-button.normal{--default-padding-block-start: var(--beacon-reference-space-4);--default-padding-block-end: var(--beacon-reference-space-4);--default-padding-inline: var(--beacon-reference-space-5);--normal-font-size: var(--override-button-font-size-normal, var(--font-size));--normal-font-weight: var(--override-button-font-weight-normal, var(--font-weight));--component-font-size: var(--override-button-font-size, var(--beacon-component-button-normal-font-size-sans-serif-standard));font:var(--normal-font-weight) var(--component-font-size, var(--normal-font-size)/var(--line-height) var(--beacon-system-font-family-body));padding-block:var(--override-button-space-padding-block-start-normal, var(--default-padding-block-start)) var(--override-button-space-padding-block-end-normal, var(--default-padding-block-end));padding-inline:var(--override-button-space-padding-inline-normal, var(--default-padding-inline))}.button.beacon-button.jumbo{--font-size: var(--beacon-component-button-jumbo-font-size-sans-serif-standard);--line-height: var(--beacon-component-button-jumbo-line-height-sans-serif-standard);font:var(--font-weight) var(--beacon-component-button-jumbo-font-size-sans-serif-standard);padding-block:var(--beacon-reference-space-5) var(--beacon-reference-space-5);padding-inline:var(--beacon-reference-space-7)}.button.beacon-button .site-selector-slot{display:none}:host([is-icon-button]) .icon--default{display:none}.button:not(.beacon-button){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;background-color:transparent;border:0;color:var(--beacon-system-color-text-link);display:flex;gap:var(--beacon-reference-space-2);padding:0;text-align:start}.button:not(.beacon-button) .icon--default svg{color:var(--chevron-fill-color, var(--beacon-system-color-icon-link))}.button:not(.beacon-button):is(.global,.site-nav,.local,.site-selector){color:var(--header-menu-expanded-navigation-button-color, var(--beacon-component-primary-navigation-header-color-text-link))}.button:not(.beacon-button):is(.local,.site-nav){--chevron-fill-color: var(--beacon-system-color-icon-link)}.button:not(.beacon-button).beacon-icon-button{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative}.button:not(.beacon-button).beacon-icon-button .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.button:not(.beacon-button).beacon-icon-button[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.button:not(.beacon-button).beacon-icon-button svg,.button:not(.beacon-button).beacon-icon-button [beacon-tag-name=beacon-icon]{position:absolute}.button:not(.beacon-button).beacon-icon-button:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.button:not(.beacon-button).beacon-icon-button:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.button:not(.beacon-button).beacon-icon-button:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.button:not(.beacon-button).beacon-icon-button svg{position:static}.button:not(.beacon-button).beacon-icon-button.tertiary{--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0}.button:not(.beacon-button).site-selector .default-slot{display:none}.button:not(.beacon-button).header .default-slot{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;display:block}.button:not(.beacon-button).header .icon--default{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.button:not(.beacon-button):not(.site-selector) .site-selector-slot{display:none}.button:not(.beacon-button):is(:hover,:focus){text-decoration:underline}:host(:not([is-icon-button])) .button:not(.beacon-button) .icon--default{display:flex}:host(:not([slot=header-zone])) .button:not(.beacon-button).active{display:flex}:host(:not([slot=header-zone])) .active .chevron{--chevron-transform: 0deg}@media (width >= 960px){:host([is-icon-button]){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.mobile-site-selector-title{display:none}.flag{display:contents}.plain-text{gap:var(--beacon-reference-space-3)}.button:not(.beacon-button){gap:var(--beacon-reference-space-3);word-break:keep-all}.button:not(.beacon-button):is(.global,.site-nav,.local){padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}.button:not(.beacon-button):is(.local,.site-selector){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).site-selector{padding:var(--beacon-system-space-cell-contained)}.button:not(.beacon-button).site-selector .default-slot{display:contents}.button:not(.beacon-button).site-selector .site-selector-slot{display:none}.button:not(.beacon-button):is(.global,.site-nav),.button:not(.beacon-button):is(.global,.site-nav) ::slotted(*){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.button:not(.beacon-button).site-nav{border:0;color:var(--beacon-component-primary-navigation-header-color-text-link);gap:var(--beacon-reference-space-2)}.button:not(.beacon-button).global{color:var(--beacon-component-primary-navigation-header-color-text-link);font-weight:var(--beacon-system-font-weight-bold)}.button:not(.beacon-button).active{color:var(--beacon-system-color-text-link-active);font-weight:var(--beacon-system-font-weight-bold)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav{border-block-end:var(--beacon-system-width-border-normal) solid var(--navigation-button-border-color)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.current{--navigation-button-border-color: var(--beacon-system-color-border-brand)}:host([motion-state=disabled]) .button:not(.beacon-button).site-nav.active{--navigation-button-border-color: var(--beacon-system-color-border-secondary)}.chevron{--chevron-transform: 180deg}:host([site-navigation]) .plain-text{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}}`;
var hL = Object.defineProperty, bL = Object.getOwnPropertyDescriptor, Lo = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? bL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && hL(t, e, o), o;
}, er;
const hc = class hc extends Ge(Le).with(
  aL,
  cL,
  Lr(),
  $i,
  tL,
  mf({ clean: !0 })
) {
  constructor() {
    super(...arguments);
    Ie(this, er);
    this.beaconTagName = yg.beaconTagName, this.focusOverride = !0, this.restricted = !1, this.variant = "standard", this.scale = ln.NORMAL, this.hasIcon = !1, this.hasCountryFlag = !1, this.current = !1, this.handleCountrySelector = ({ type: e }) => {
      e === Ee.COUNTRY_SELECTOR_OPEN && this.closestSlot === Mb.SITE_SELECTOR && (this.activeInStyleOnly = !0), e === Ee.COUNTRY_SELECTOR_CLOSE && this.activeInStyleOnly && (this.activeInStyleOnly = !1);
    }, this.applyCurrentStyling = ({ target: e }) => {
      var i;
      (i = this.expandingElement) != null && i.contains(e) && (this.current = !0);
    }, Be(this, er, /* @__PURE__ */ new Map([
      [Ee.COUNTRY_SELECTOR_OPEN, this.handleCountrySelector],
      [Ee.COUNTRY_SELECTOR_CLOSE, this.handleCountrySelector],
      [Ee.HAS_CURRENT_LINK, this.applyCurrentStyling]
    ]));
  }
  static get styles() {
    return [super.styles, this.navigationButtonMotionStyles, dL];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, nL];
  }
  get icon() {
    return this.iconSlotNodes[0];
  }
  get flag() {
    return this.flagSlotNodes[0];
  }
  /** Reference to the built-in icon element. */
  get builtInIcon() {
    var e;
    return (e = this.shadowRoot) == null ? void 0 : e.querySelector(".icon--default");
  }
  /**
   * onClick handler to maintain active state
   * @param event
   */
  toggleOnClick() {
    this.emitClick(), this.navType === jt.HEADER && Fe(this, Ee.HEADER_ZONE_CLICK);
  }
  /** Applies a specific class for nav items that are only an icon to account for changes in CSS. */
  setIconSlotState() {
    this.iconSlotNodes.length > 0 && (this.hasIcon = !0);
  }
  /** Adds attribute to the flag slot to enable analytics tracking by attaching a data-metrics-text attribute */
  handleFlagSlotchange() {
    var i;
    const e = (i = this.beaconAriaLabel) != null ? i : this.defaultSlotText;
    ns(this.flag, e);
  }
  /**
   * Selects an internal icon based on the context the nav item is in.
   *
   * Could be a lock for restricted items, or chevrons based on expanded state.
   */
  buildIcon() {
    return this.restricted ? this.renderBuiltInIcon("locked", "icon--restricted") : this.hasExpandedAnchor ? this.renderBuiltInIcon("chevron_right_small", "icon--expanded") : this.renderBuiltInIcon("collapse", "icon--standard chevron");
  }
  renderBuiltInIcon(e, i) {
    return ze`<${this.getScopedTag("beacon-icon")}
      class="icon--default ${i}"
      aria-hidden="true"
      name='${e}'
      ></${this.getScopedTag("beacon-icon")}
    >`;
  }
  navItemPrerender() {
    Te(this, er).forEach((e, i) => {
      document.addEventListener(i, e);
    });
  }
  navItemDestroy() {
    Te(this, er).forEach((e, i) => {
      document.removeEventListener(i, e);
    });
  }
  renderSiteSelectorContent() {
    return this.navType === jt.SITE_SELECTOR ? pe`<div class="mobile-site-selector-title">
        ${this.defaultSlotText}
      </div>` : pe``;
  }
  render() {
    var o;
    const e = this.hasIcon && !this.defaultSlotText, i = {
      active: this.active || this.activeInStyleOnly,
      button: !0,
      "beacon-icon-button": e,
      "beacon-button": !e && this.variant !== "standard",
      current: this.current,
      tertiary: e,
      restricted: this.restricted
    };
    return i[this.navType] = !0, i[this.variant] = !0, i[this.scale] = !0, e ? this.setAttribute("is-icon-button", "") : this.removeAttribute("is-icon-button"), pe`
      ${this.renderSiteSelectorContent()}
      ${this.restricted ? pe`
            <div class="plain-text">
              <slot class="default-slot"></slot>
              ${this.buildIcon()}
            </div>
          ` : pe`
            <button
              aria-expanded="${this.active.toString()}"
              aria-label="${mt(this.beaconAriaLabel)}"
              data-metrics-link-text="${mt(
      (o = this.beaconAriaLabel) != null ? o : this.defaultSlotText
    )}"
              aria-haspopup="true"
              class="${Pe(i)}"
              id="${mt(this.metricsID)}"
              part="button"
              @click=${this.toggleOnClick}>
              <slot name="icon" @slotchange=${this.setIconSlotState}></slot>
              <slot
                class="flag"
                name="flag"
                @slotchange=${this.handleFlagSlotchange}
                aria-hidden="true"></slot>
              <slot
                class="default-slot"
                @slotchange=${this.setDefaultSlotText}></slot>
              <slot name="site-selector-text" class="site-selector-slot"
                >Change Site</slot
              >
              ${this.buildIcon()}
            </button>
          `}
    `;
  }
};
er = new WeakMap(), hc.tagName = yg.beaconTagName, hc.nestedComponents = [ro];
let rt = hc;
Lo([
  ue({ type: Boolean, reflect: !0 })
], rt.prototype, "restricted", 2);
Lo([
  ue({ reflect: !0 })
], rt.prototype, "variant", 2);
Lo([
  ue({ reflect: !0 })
], rt.prototype, "scale", 2);
Lo([
  Ce()
], rt.prototype, "hasIcon", 2);
Lo([
  Ce()
], rt.prototype, "hasCountryFlag", 2);
Lo([
  Ce()
], rt.prototype, "current", 2);
Lo([
  zc({ flatten: !0, slot: "icon" })
], rt.prototype, "iconSlotNodes", 2);
Lo([
  zc({ flatten: !0, slot: "flag" })
], rt.prototype, "flagSlotNodes", 2);
Lo([
  ot("button")
], rt.prototype, "button", 2);
Lo([
  ue({ attribute: "data-id" })
], rt.prototype, "metricsID", 2);
Lo([
  qe
], rt.prototype, "navItemPrerender", 1);
Lo([
  Pt
], rt.prototype, "navItemDestroy", 1);
const wg = {
  beaconTagName: "beacon-country"
}, pL = ve`[beacon-tag-name=beacon-country]{--country-link-color: var(--navigation-popover-country-color, var(--beacon-system-color-text-link));font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-country] [slot=icon][beacon-tag-name=beacon-icon]::part(internal--icon){block-size:var(--beacon-reference-space-5);margin:auto}[beacon-tag-name=beacon-country] a{color:var(--country-link-color)}[beacon-tag-name=beacon-country] a:not([selected-language]){text-decoration:underline}[beacon-tag-name=beacon-country] [selected-language]{color:var(--beacon-system-color-text-link-active);text-decoration:none}`, uL = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.header,.languages{align-items:center;display:flex;padding-block:var(--beacon-system-space-cell-free-floating)}.header{align-items:center;gap:var(--beacon-reference-space-3)}.languages{gap:var(--beacon-reference-space-5)}.title{color:var(--beacon-system-color-text-standard)}`;
var gL = Object.defineProperty, mL = Object.getOwnPropertyDescriptor, di = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? mL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && gL(t, e, o), o;
};
const bc = class bc extends Ge(Le).with(
  GM,
  $i
) {
  constructor() {
    super(...arguments), this.beaconTagName = wg.beaconTagName, this.reestSpacing = !0, this.isExpanded = !1, this.current = !1, this.clonedLocation = "", this.cloned = !1, this.eventAddedToNavItem = !1, this.currentCountryCreated = !1, this.handleBreakpointChanges = ({ matches: t }) => {
      t ? (this.clonedLocation === "popover" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens")) : (this.clonedLocation === "navigation" && this.slottedNavigationItem.setAttribute("opens", "country-selector"), this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"));
    }, this.addCurrentCountryFlag = () => {
      window.customElements.whenDefined(this.getScopedTagName("beacon-navigation-button")).then(() => {
        var i;
        const t = document.querySelector(
          '[opens="site-selector"]'
        ), e = t == null ? void 0 : t.querySelector('[slot="flag"]');
        if (t instanceof rt && !t.hasCountryFlag) {
          if (!e) {
            const o = (i = this.flagSVG) == null ? void 0 : i.cloneNode(!0);
            o == null || o.setAttribute("slot", "flag"), t == null || t.appendChild(o);
          }
          t.hasCountryFlag = !0;
        }
      });
    };
  }
  static get styles() {
    return [super.styles, this.flagStyles, uL];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, pL];
  }
  /** Callback for on beacon-event-language-select */
  onBeaconLanguageSelect() {
  }
  get selectedLanguage() {
    return this.selectedLanguages[0];
  }
  get slottedNavigationItem() {
    return this.navigationItems[0];
  }
  countryPreRender() {
    this.largeBreakpointWatcher.addEventListener(
      "change",
      this.handleBreakpointChanges
    );
  }
  /** Emits `beacon-event-language-select` from the given element. */
  emitLanguageSelect(t) {
    Fe(
      t,
      Ee.LANGUAGE_SELECT,
      void 0,
      this.onBeaconLanguageSelect
    );
  }
  /**
   * When countries are added to the default slot, we add click event listeners to each language link to emit a custom event.
   *
   * @see emitLanguageSelect
   */
  handleSlotchange() {
    var t;
    (t = this.languages) == null || t.forEach((e) => {
      e.dataset.hasBeaconLanguageEvent || (e.addEventListener("click", () => {
        this.emitLanguageSelect(e);
      }), e.dataset.hasBeaconLanguageEvent = "");
    }), this.selectedLanguage && !this.current && (Fe(this, Ee.NAV_LANGUAGE_SELECT, {
      detail: {
        country: this
      }
    }), this.current = !0);
  }
  createCurrentCountry(t) {
    if (t)
      return;
    const e = document.createElement("template");
    e.innerHTML = `
    <${this.getScopedTagName("beacon-navigation-button")}
      expanded-anchor
      slot="country-navigation-button"
      opens="country-selector">
      ${this.title}
    </${this.getScopedTagName("beacon-navigation-button")}>
    `, this.querySelector('[opens="country-selector"]') || this.appendChild(e.content.cloneNode(!0)), this.cloned || (this.moveCurrentCountry(), this.alterCanonicalCountryAttributes()), this.currentCountryCreated = !0;
  }
  moveCurrentCountry() {
    const t = document.querySelector("[country-selector]"), e = document.querySelector(
      this.getScopedTagName("beacon-navigation")
    );
    if (t && !t.querySelector('[opens="country-selector"]')) {
      const i = this.cloneNode(!0);
      i.cloned = !0, i.clonedLocation = "popover", t.appendChild(i), this.addCurrentCountryFlag();
    }
    if (e) {
      const i = this.cloneNode(!0);
      i.cloned = !0, i.setAttribute("slot", "country-selector"), i.clonedLocation = "navigation", e.appendChild(i);
    }
  }
  alterCanonicalCountryAttributes() {
    var t;
    this.style.display = "none", (t = this.slottedNavigationItem) == null || t.removeAttribute("opens");
  }
  /**
   * Updates attributes on slotted cloned navigation buttons to maintain open and close functionality across breakpoints.
   *
   * We directly remove attributes instead of setting values with their props because the property route was not working as intended.
   */
  handleNavItemSlotchange() {
    var t;
    this.slottedNavigationItem && (this.cloned || this.slottedNavigationItem.removeAttribute("opens"), this.isMobile && this.clonedLocation === "popover" && this.slottedNavigationItem.removeAttribute("opens"), this.isDesktop && this.clonedLocation === "navigation" && this.slottedNavigationItem.removeAttribute("opens"), this.eventAddedToNavItem || (t = this.slottedNavigationItem.button) == null || t.addEventListener("click", () => {
      Fe(
        this.slottedNavigationItem.button,
        Ee.COUNTRY_SELECTOR_OPEN
      ), this.eventAddedToNavItem = !0;
    }));
  }
  renderTitleContainer() {
    return this.current && !this.isExpanded ? (this.createCurrentCountry(this.currentCountryCreated), pe`
        <slot name="title" style="display: none;"></slot>
        <slot
          class="navigation-button-slot"
          name="country-navigation-button"
          @slotchange=${this.handleNavItemSlotchange}></slot>
      `) : super.renderTitleContainer();
  }
  render() {
    return pe`
      <div class="header">
        ${this.renderFlagContainer()} ${this.renderTitleContainer()}
      </div>
      <div class="languages">
        <slot @slotchange=${this.handleSlotchange}></slot>
      </div>
    `;
  }
};
bc.tagName = wg.beaconTagName, bc.nestedComponents = [ro];
let So = bc;
di([
  ue({ type: Boolean, reflect: !0, attribute: "is-expanded" })
], So.prototype, "isExpanded", 2);
di([
  ue({ type: Boolean, reflect: !0 })
], So.prototype, "current", 2);
di([
  Ce()
], So.prototype, "clonedLocation", 2);
di([
  Ce()
], So.prototype, "cloned", 2);
di([
  Ce()
], So.prototype, "eventAddedToNavItem", 2);
di([
  Ce()
], So.prototype, "currentCountryCreated", 2);
di([
  De({ selector: "a", flatten: !0 })
], So.prototype, "languages", 2);
di([
  De({
    selector: "[selected-language]",
    flatten: !0
  })
], So.prototype, "selectedLanguages", 2);
di([
  De({
    slot: "country-navigation-button",
    flatten: !0
  })
], So.prototype, "navigationItems", 2);
di([
  qe
], So.prototype, "countryPreRender", 1);
const kg = {
  beaconTagName: "beacon-country-selector"
}, fL = ve`[beacon-tag-name=beacon-country-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-country-selector] [beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, vL = ve`:host{display:grid;gap:var(--beacon-system-space-micro-jumbo);inline-size:100%}@media (width >= 960px){:host{gap:var(--beacon-reference-space-9)}}.current-selection{display:grid;gap:var(--beacon-system-space-micro-normal)}.current{padding-block:var(--beacon-system-space-cell-free-floating)}.current :is(h1,h2,h3,h4,h5,h6),.current ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50);color:var(--beacon-system-color-text-title);margin:0}@media (width >= 960px){a,::slotted(a){color:var(--beacon-system-color-text-link)}}`;
var AL = Object.defineProperty, yL = Object.getOwnPropertyDescriptor, Kc = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? yL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && AL(t, e, o), o;
};
const Vb = class Vb extends Ge(Le).with(
  al({ skipFirstUpdated: !1 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = kg.beaconTagName, this.expanded = !1, this.setSelectedCountry = ({ detail: t }) => {
      if (!this.selectedCountry) {
        const e = t.country.cloneNode(!0);
        this.selectedCountry = e, this.selectedCountry.isExpanded = !0, this.selectedCountry.setAttribute("slot", "current-country"), this.appendChild(this.selectedCountry);
      }
    };
  }
  static get styles() {
    return [super.styles, vL];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, fL];
  }
  countrySelectorPrerender() {
    this.addEventListener(
      Ee.NAV_LANGUAGE_SELECT,
      this.setSelectedCountry
    );
  }
  updateAnalytics() {
    super.updateAnalytics(), this.metricsSection = qo.level2LangSelector;
  }
  render() {
    return pe`
      <div class="current-selection">
        <div class="current">
          <slot name="title"><h3>Current selection</h3></slot>
        </div>
        <slot name="current-country"></slot>
      </div>
      <slot class="regions"></slot>
    `;
  }
};
Vb.tagName = kg.beaconTagName;
let pr = Vb;
Kc([
  De(
    { selector: "beacon-region-selector", flatten: !0 },
    !0
  )
], pr.prototype, "regions", 2);
Kc([
  ue({ type: Boolean, reflect: !0 })
], pr.prototype, "expanded", 2);
Kc([
  Ce()
], pr.prototype, "selectedCountry", 2);
Kc([
  qe
], pr.prototype, "countrySelectorPrerender", 1);
const xL = {
  Vertical: "vertical"
}, Cg = {
  beaconTagName: "beacon-divider"
}, zv = {
  Thin: "thin",
  Thick: "thick"
}, Iv = {
  Neutral: "neutral",
  Strong: "strong"
}, ea = {
  Horizontal: "horizontal",
  Vertical: "vertical"
}, wL = ve`:host{--divider-color: var(--beacon-system-color-border-2);--divider-size: var(--beacon-system-width-border-mini);background-color:var(--divider-color);block-size:var(--vertical-divider-block-size, var(--divider-size))!important;inline-size:var(--vertical-divider-inline-size, 100%)}:host([weight=thick]){--divider-size: var(--beacon-system-width-border-normal)}:host([color-mode=strong]){--divider-color: var(--beacon-system-color-border-brand)}:host([orientation=vertical][small-sectioning-mode=vertical]){--vertical-divider-block-size: var(--beacon-override-vertical-divider-block-size, auto);--vertical-divider-inline-size: var(--divider-size);align-self:stretch;display:inline-block}@media (width >= 640px){:host([orientation=vertical]){--vertical-divider-block-size: var(--beacon-override-vertical-divider-block-size, auto);--vertical-divider-inline-size: var(--divider-size);align-self:stretch;display:inline-block}}`;
var kL = Object.defineProperty, CL = Object.getOwnPropertyDescriptor, zr = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? CL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && kL(t, e, o), o;
};
const qb = class qb extends Ge(Le).with($i) {
  constructor() {
    super(...arguments), this.beaconTagName = Cg.beaconTagName, this.weight = zv.Thin, this.colorMode = Iv.Neutral, this.orientation = ea.Horizontal, this.smallSectioningMode = ea.Horizontal;
  }
  // TODO: use element internals when footnotes are merged
  setDividerARIA() {
    this.setAttribute("role", "separator");
  }
  _setAriaOrientation() {
    let t = ea.Horizontal;
    this.orientation === ea.Vertical && !(this.smallSectioningMode === ea.Horizontal && !this.isMediumBreakpoint) && (t = ea.Vertical), this.setAttribute("aria-orientation", t);
  }
  static get styles() {
    return [super.styles, wL];
  }
};
qb.tagName = Cg.beaconTagName;
let ai = qb;
zr([
  ue({ reflect: !0 })
], ai.prototype, "weight", 2);
zr([
  ue({ attribute: "color-mode", reflect: !0 })
], ai.prototype, "colorMode", 2);
zr([
  ue({ reflect: !0 })
], ai.prototype, "orientation", 2);
zr([
  ue({ attribute: "small-sectioning-mode", reflect: !0 })
], ai.prototype, "smallSectioningMode", 2);
zr([
  qe
], ai.prototype, "setDividerARIA", 1);
zr([
  Gt("isMediumBreakpoint")
], ai.prototype, "_setAriaOrientation", 1);
const Sg = {
  beaconTagName: "beacon-divided-list-item"
}, SL = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);display:flex;flex-flow:column;justify-content:space-between;word-break:normal}.wrapper{padding-block:var(--item-space, var(--beacon-reference-space-3))}@media (width >= 640px){.wrapper{--item-space: var(--beacon-reference-space-4)}}@media (width >= 960px){.wrapper{--item-space: var(--beacon-reference-space-5)}}@media (width >= 1280px){.wrapper{--item-space: var(--beacon-reference-space-6)}}.content{display:flex;gap:var(--beacon-reference-space-5);justify-content:space-between}.content ::slotted(*){flex-grow:1}.data-point{font-weight:var(--beacon-system-font-weight-bold)}.divider{display:var(--divider-display, block)}`, pc = class pc extends Le {
  constructor() {
    super(), this.beaconTagName = Sg.beaconTagName, this._internals && (this._internals.role = "listitem");
  }
  static get styles() {
    return [super.styles, SL];
  }
  render() {
    return pe`
      <div class="wrapper">
        <div class="content">
          <slot ${sb()}>
            <div class="supporting-text">
              <slot name="supporting-text"></slot>
            </div>
            <div class="data-point">
              <slot name="data-point"></slot>
            </div>
          </slot>
        </div>
      </div>
      ${ze`<${this.getScopedTag("beacon-divider")} class="divider"></${this.getScopedTag("beacon-divider")}>`}
    `;
  }
};
pc.tagName = Sg.beaconTagName, pc.nestedComponents = [ai];
let Th = pc;
const Eg = {
  beaconTagName: "beacon-divided-list"
}, EL = ve`:host{container:divided-list/inline-size}.base{padding-block:var(--beacon-system-space-cell-contained)}@container divided-list (inline-size >= 640px){.horizontal{column-gap:var(--beacon-reference-space-7);display:grid;grid-template-columns:1fr 1fr}.horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:only-child){grid-column:auto/span 2}@supports selector(:state(--customstate)){:host(:state(--divided-vertically)) .horizontal{position:relative}:host(:state(--divided-vertically)) .horizontal:after{background-color:var(--beacon-system-color-border-2);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-mini);inset-block-start:0;inset-inline-start:50%;position:absolute}}@supports not selector(:state(--customstate)){:host([state----divided-vertically]) .horizontal{position:relative}:host([state----divided-vertically]) .horizontal:after{background-color:var(--beacon-system-color-border-2);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-mini);inset-block-start:0;inset-inline-start:50%;position:absolute}}@supports selector(:state(--customstate)){:host(:state(--even-items)) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:nth-last-child(-n+2)){--divider-display: none}}@supports not selector(:state(--customstate)){:host([state----even-items]) .horizontal ::slotted([beacon-tag-name=beacon-divided-list-item]:nth-last-child(-n+2)){--divider-display: none}}}:is(.vertical,.horizontal) ::slotted([beacon-tag-name=beacon-divided-list-item]:last-of-type){--divider-display: none}`;
var ML = Object.defineProperty, TL = Object.getOwnPropertyDescriptor, Ir = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? TL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && ML(t, e, o), o;
}, uc, Bv;
const gc = class gc extends Le {
  constructor() {
    super();
    Ie(this, uc);
    this.beaconTagName = Eg.beaconTagName, this.orientation = xL.Vertical, this._dividedVertically = !1, this._hasEvenNumberOfItems = !1, this._internals && (this._internals.role = "list");
  }
  static get styles() {
    return [super.styles, EL];
  }
  _updateDividedState() {
    this.setState("--divided-vertically", this._dividedVertically);
  }
  _updateItemCountState() {
    this.setState("--even-items", this._hasEvenNumberOfItems);
  }
  render() {
    return pe`
      <div class="base">
        <div class="${this.orientation}">
          <slot @slotchange=${Ue(this, uc, Bv)}></slot>
        </div>
      </div>
    `;
  }
};
uc = new WeakSet(), Bv = function() {
  this._dividedVertically = this._slottedListItems.length === 2, this._hasEvenNumberOfItems = this._slottedListItems.length % 2 == 0;
}, gc.tagName = Eg.beaconTagName, gc.nestedComponents = [Th];
let wa = gc;
Ir([
  ue({ reflect: !0 })
], wa.prototype, "orientation", 2);
Ir([
  Ce()
], wa.prototype, "_dividedVertically", 2);
Ir([
  Ce()
], wa.prototype, "_hasEvenNumberOfItems", 2);
Ir([
  Gt("_dividedVertically")
], wa.prototype, "_updateDividedState", 1);
Ir([
  Gt("_hasEvenNumberOfItems")
], wa.prototype, "_updateItemCountState", 1);
Ir([
  Ct({
    selector: '[beacon-tag-name="beacon-divided-list-item"]'
  })
], wa.prototype, "_slottedListItems", 2);
const LL = ve`:root[beacon-tag-name=beacon-donut-chart][scale=mini],:root [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=mini],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=mini],[beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200)}:root[beacon-tag-name=beacon-donut-chart][scale=normal],:root [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=normal],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=normal],[beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400)}:root[beacon-tag-name=beacon-donut-chart][scale=jumbo],:root [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.4.0"][beacon-tag-name=beacon-donut-chart][scale=jumbo],[beacon-version="4.4.0"] [beacon-tag-name=beacon-donut-chart][scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600)}`, ut = {
  beaconTagName: "beacon-donut-chart",
  pieSizePercentage: "80%",
  minimumSizeJumbo: 180,
  // @MISSING_SYSTEM_TOKEN was Heritage Token: beaconDonutChartSizeWidthJumbo
  minimumSizeDefault: 160,
  attributes: {
    metricTotal: "metric-total",
    metricDescription: "metric-description",
    hideChartMetric: "hide-chart-metric",
    labelDistance: "label-distance",
    hideDataLabelConnectors: "hide-data-label-connectors",
    hideDataLabels: "hide-data-labels"
  },
  properties: {
    metricTotal: "metricTotal",
    metricDescription: "metricDescription",
    series: "series",
    disableLegend: "disableLegend"
  },
  metricWrapperClass: "metric-wrapper"
}, OL = ve`.metric-wrapper{display:var(--beacon-donut-chart-metric-display, block);inline-size:var(--metric-total-inline-size);overflow:hidden;text-align:center;white-space:initial;word-break:break-word}.metric-wrapper p{margin:0}.metric-wrapper .metric-total{font:var(--donut-chart-metric-total-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600))}.metric-wrapper .metric-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-light-headline-100)}:host[scale=mini]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-200)}:host[scale=normal]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-400)}:host[scale=jumbo]{--donut-chart-metric-total-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600)}.highcharts-data-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.highcharts-data-labels text{fill:var(--beacon-system-color-text-standard)}.highcharts-data-label-connector{fill:none;stroke:var(--beacon-reference-palette-grayscale-light-gray-1)}.highcharts-point{stroke:var(--beacon-reference-palette-grayscale-dark-gray-2)}.highcharts-point.highcharts-point-hover{fill-opacity:1}.transparent-connector.highcharts-data-label-connector{stroke:transparent}.deselected .metric-wrapper,.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-custom-circles circle{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini, 1px)}:host([hide-data-label-connectors]) .highcharts-data-label-connector{display:none}.highcharts-pie-series .highcharts-point{stroke:var(--beacon-system-color-background-1)}`;
var PL = Object.defineProperty, Ki = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && PL(t, e, o), o;
};
function DL(a) {
  return typeof a.itemHeight == "number";
}
function zL(a) {
  return typeof a.itemHeight == "number";
}
var nn;
const hi = (nn = class extends Ge(tt).with(xn) {
  constructor() {
    super(), this.beaconTagName = ut.beaconTagName, this.internalMetricTotal = "", this.metricTotal = "", this.metricDescription = "", this.scale = Fo.NORMAL, this.hideChartMetric = !1, this.labelDistance = 30, this.hideDataLabelConnectors = !1, this.hideDataLabels = !1, this.staticLegend = !0, this._type = $t.PIE, this.resizeObserver = new ResizeObserver(
      jo(() => {
        this.chart && (this.updateChartMetricOptions(), this.updateChartHeight());
      }, 200)
    ), this.updateChartMetricTotal = this.updateChartMetricTotal.bind(this);
  }
  static get styles() {
    return [super.styles, OL];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, LL];
  }
  /** Minimum size for the donut itself to be. */
  get minimumDonutSize() {
    return this.scale === Fo.JUMBO && !this.hideChartMetric ? ut.minimumSizeJumbo : ut.minimumSizeDefault;
  }
  /**
   * Setting Pie Chart related Configuration
   */
  get localComponentOptions() {
    const t = this;
    return tt.createChartOptions(super.localComponentOptions, {
      chart: {
        events: {
          render() {
            const e = this.series[0];
            if (e.center) {
              const [, i] = e.center, o = this.container.querySelector(
                `.${ut.metricWrapperClass}`
              );
              if (o) {
                const n = o.getBoundingClientRect().height;
                if (e && e.options) {
                  const l = e.options, D = parseInt(
                    l.innerSize || "0",
                    10
                  ) / 2;
                  this.subtitle.attr({
                    y: i - n / 2 + D / 2
                  });
                }
              }
            }
            t.updateChartMetricTotal(this), t.resizeObserver.observe(t), nn.createCustomCircles(this);
          }
        }
      },
      plotOptions: {
        pie: {
          center: ["50%", "50%"],
          borderRadius: 0,
          innerSize: `${ut.pieSizePercentage}`,
          minSize: this.minimumDonutSize,
          dataLabels: {
            enabled: !this.hideDataLabels,
            padding: 0,
            distance: this.labelDistance,
            formatter: function() {
              return tt.percentageFormatter(
                t.percentage,
                this.point.y,
                this.total,
                t.decimal,
                t.decimalPlaces
              );
            }
          }
        },
        series: {
          states: {
            hover: {
              halo: null
            }
          },
          // Displays the legend in the chart
          showInLegend: !0
        }
      },
      /**
       * Renders the chart metric with the subtitle instead,
       * to utilize default centering when the legend isn't rendered.
       */
      subtitle: {
        useHTML: !0,
        text: this.renderChartMetric(),
        floating: !0,
        verticalAlign: "middle",
        align: "center",
        y: 0
      },
      responsive: {
        rules: [
          {
            // Currently does nothing but can be used to dynamically adjust subtitle's y value, see this highcharts doc page
            // https://www.highcharts.com/docs/chart-concepts/responsive
            condition: {
              callback() {
                return window.innerWidth >= no.MEDIUM;
              }
            }
          }
        ]
      },
      tooltip: {
        headerFormat: "",
        pointFormatter() {
          const e = tt.percentageFormatter(
            t.percentage,
            this.options.y,
            this.total,
            t.decimal,
            t.decimalPlaces
          );
          return tt.tooltipPointHTML(this, this.name, e || "");
        }
      }
    });
  }
  /*
   * Metric width to be calculated as 64% of pie chart
   **/
  get MetricTotalInlineSize() {
    if (this.chart) {
      const t = this.chart.series[0].center[2];
      if (this.metricWrapper)
        return t * 0.64;
    }
    return 120;
  }
  /**
   * Non Lit Templated HTML render method used to render the chartMetric as the chart option's subtitle text.
   */
  renderChartMetric() {
    return this.internalMetricTotal && !this.hideChartMetric ? `
      <div class="${ut.metricWrapperClass}" style="inline-size: ${this.MetricTotalInlineSize}px">
      <p class="${ut.attributes.metricTotal}" aria-describedby="${ut.attributes.metricDescription}">
      ${this.internalMetricTotal}
    </p>
    <p class="${ut.attributes.metricDescription}" id="${ut.attributes.metricDescription}">
      ${this.metricDescription}
    </p></div>` : "";
  }
  /**
   * Overrides how color order is calculated, since donut charts only have one series,
   * you need the length of the data in that series for calculating the color-order
   */
  calculateSeriesLength(t) {
    var e;
    return (e = t.series[0]) == null ? void 0 : e.data.length;
  }
  /**
   * Updates the chart metric total value on chart load and redraw events,
   * as well as willUpdate. Extracted from the metric rendering method.
   * @param chart
   */
  updateChartMetricTotal(t) {
    if (this.metricTotal) {
      this.internalMetricTotal = this.metricTotal;
      return;
    }
    const i = t.series[0].total;
    i && (this.internalMetricTotal = i.toFixed(0));
  }
  /**
   * Used to update the metric chart options in willUpdate
   * when this.metricTotal is updated
   */
  updateChartMetricOptions() {
    this.updateChart({
      subtitle: {
        useHTML: !0,
        text: this.renderChartMetric(),
        verticalAlign: "middle",
        align: "center"
      }
    });
  }
  /**
   * This method changes the height of the chart based on the legend layout
   */
  updateChartHeight() {
    var t, e;
    if (this.chart) {
      const i = isNaN(Number((t = this.options.chart) == null ? void 0 : t.height)) ? void 0 : Number((e = this.options.chart) == null ? void 0 : e.height);
      if (this.legendLayout.direction === "vertical" || window.innerWidth < no.MEDIUM) {
        let o = 20;
        if (this.chart.legend.allItems.length > 0) {
          const j = this.chart.legend.allItems[0];
          (j instanceof yi.Point && zL(j) || j instanceof yi.Series && DL(j)) && (o = j.itemHeight);
        }
        const n = this.chart.legend.allItems.length, l = o * n, D = (i != null ? i : _l.HEIGHT) + l;
        this.chart.update({
          chart: {
            height: D
          }
        });
      } else
        this.chart.update({
          chart: {
            height: i != null ? i : _l.HEIGHT
          }
        });
      this.updateChartMetricOptions();
    }
  }
  /**
   * This method is to create custom circles (outer and inner) for the donut chart, so that we can apply border to both of them to meet design requirements
   */
  static createCustomCircles(t) {
    var l, L, D, j, I, B;
    t.customCircles && (t.customCircles.destroy(), t.customCircles = void 0);
    const e = t.renderer, i = t.plotLeft + (t == null ? void 0 : t.plotWidth) / 2, o = t.plotTop + (t == null ? void 0 : t.plotHeight) / 2, n = [
      (D = (L = (l = t.series[0]) == null ? void 0 : l.data[0]) == null ? void 0 : L.shapeArgs) == null ? void 0 : D.r,
      (B = (I = (j = t.series[0]) == null ? void 0 : j.data[0]) == null ? void 0 : I.shapeArgs) == null ? void 0 : B.innerR
    ];
    t.customCircles = t.renderer.g("custom-circles").add(), n.forEach((R) => {
      var N;
      e.circle(i, o, R).attr({
        fill: "none"
      }).add(t.customCircles), (N = t.customCircles) == null || N.attr({
        zIndex: 10
        // Adjust this value as needed
      }).add();
    });
  }
  /**
   * On Chart Load called on load event callback. Adds Metric Text and discription after chart load.
   * @param chart Highcharts.Chart
   */
  onChartLoad(t) {
    this.chart && (this.updateChartMetricTotal(t), this.updateChartMetricOptions());
  }
  /**
   * On Resizes updates the center text element of the chart.
   * @param chart Highcharts.Chart
   */
  onChartRedraw() {
    this.chart && this.updateChartMetricTotal(this.chart);
  }
  willUpdate(t) {
    var l;
    (l = super.willUpdate) == null || l.call(this, t);
    const e = this.hideLegendMetric, i = this.type, o = this.decimal, n = this.decimalPlaces;
    t.has(ut.properties.metricTotal) && this.updateChartMetricOptions(), t.has(ut.properties.metricDescription) && this.updateChartMetricOptions(), t.has(ut.properties.series) && this.chart && this.onChartLoad(this.chart), (t.has(ut.properties.disableLegend) || t.has("hideChartMetric")) && this.chart && this.updateChartMetricOptions(), t.has("legendLayout") && this.updateChart({
      legend: {
        labelFormatter() {
          return tt.legendItemHTML(
            this,
            e,
            !1,
            i,
            o,
            n
          );
        }
      }
    }), t.has("labelDistance") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            distance: this.labelDistance
          }
        }
      }
    }), t.has("hideDataLabels") && this.updateChart({
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: !this.hideDataLabels
          }
        }
      }
    });
  }
}, nn.tagName = ut.beaconTagName, nn);
Ki([
  Ce()
], hi.prototype, "internalMetricTotal");
Ki([
  ue({ attribute: ut.attributes.metricTotal })
], hi.prototype, "metricTotal");
Ki([
  ue({ attribute: ut.attributes.metricDescription })
], hi.prototype, "metricDescription");
Ki([
  ue({ reflect: !0 })
], hi.prototype, "scale");
Ki([
  ue({ attribute: ut.attributes.hideChartMetric, type: Boolean })
], hi.prototype, "hideChartMetric");
Ki([
  We(`.${ut.metricWrapperClass}`)
], hi.prototype, "metricWrapper");
Ki([
  ue({ type: Number, attribute: ut.attributes.labelDistance })
], hi.prototype, "labelDistance");
Ki([
  ue({
    attribute: ut.attributes.hideDataLabelConnectors,
    type: Boolean
  })
], hi.prototype, "hideDataLabelConnectors");
Ki([
  ue({ attribute: ut.attributes.hideDataLabels, type: Boolean })
], hi.prototype, "hideDataLabels");
let YD = hi;
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Lh(a, t) {
  (t == null || t > a.length) && (t = a.length);
  for (var e = 0, i = Array(t); e < t; e++) i[e] = a[e];
  return i;
}
function IL(a) {
  if (Array.isArray(a)) return Lh(a);
}
function BL(a, t, e) {
  return (t = _L(t)) in a ? Object.defineProperty(a, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[t] = e, a;
}
function RL(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null) return Array.from(a);
}
function NL() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mg(a, t) {
  var e = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(a);
    t && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(a, o).enumerable;
    })), e.push.apply(e, i);
  }
  return e;
}
function Tg(a) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mg(Object(e), !0).forEach(function(i) {
      BL(a, i, e[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(e)) : Mg(Object(e)).forEach(function(i) {
      Object.defineProperty(a, i, Object.getOwnPropertyDescriptor(e, i));
    });
  }
  return a;
}
function FL(a) {
  return IL(a) || RL(a) || UL(a) || NL();
}
function jL(a, t) {
  if (typeof a != "object" || !a) return a;
  var e = a[Symbol.toPrimitive];
  if (e !== void 0) {
    var i = e.call(a, t);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(a);
}
function _L(a) {
  var t = jL(a, "string");
  return typeof t == "symbol" ? t : t + "";
}
function UL(a, t) {
  if (a) {
    if (typeof a == "string") return Lh(a, t);
    var e = {}.toString.call(a).slice(8, -1);
    return e === "Object" && a.constructor && (e = a.constructor.name), e === "Map" || e === "Set" ? Array.from(a) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? Lh(a, t) : void 0;
  }
}
var Lg = {
  activateTrap: function(t, e) {
    if (t.length > 0) {
      var i = t[t.length - 1];
      i !== e && i._setPausedState(!0);
    }
    var o = t.indexOf(e);
    o === -1 || t.splice(o, 1), t.push(e);
  },
  deactivateTrap: function(t, e) {
    var i = t.indexOf(e);
    i !== -1 && t.splice(i, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, $L = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, HL = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, ls = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, KL = function(t) {
  return ls(t) && !t.shiftKey;
}, GL = function(t) {
  return ls(t) && t.shiftKey;
}, Og = function(t) {
  return setTimeout(t, 0);
}, Kr = function(t) {
  for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
    i[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, i) : t;
}, El = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, WL = [], Rv = function(t, e) {
  var i = (e == null ? void 0 : e.document) || document, o = (e == null ? void 0 : e.trapStack) || WL, n = Tg({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: KL,
    isKeyBackward: GL
  }, e), l = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, L, D = function(d, r, s) {
    return d && d[r] !== void 0 ? d[r] : n[s || r];
  }, j = function(d, r) {
    var s = typeof (r == null ? void 0 : r.composedPath) == "function" ? r.composedPath() : void 0;
    return l.containerGroups.findIndex(function(p) {
      var b = p.container, c = p.tabbableNodes;
      return b.contains(d) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (s == null ? void 0 : s.includes(b)) || c.find(function(h) {
        return h === d;
      });
    });
  }, I = function(d) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = r.hasFallback, p = s === void 0 ? !1 : s, b = r.params, c = b === void 0 ? [] : b, h = n[d];
    if (typeof h == "function" && (h = h.apply(void 0, FL(c))), h === !0 && (h = void 0), !h) {
      if (h === void 0 || h === !1)
        return h;
      throw new Error("`".concat(d, "` was specified but was not a node, or did not return a node"));
    }
    var g = h;
    if (typeof h == "string") {
      try {
        g = i.querySelector(h);
      } catch (k) {
        throw new Error("`".concat(d, '` appears to be an invalid selector; error="').concat(k.message, '"'));
      }
      if (!g && !p)
        throw new Error("`".concat(d, "` as selector refers to no known node"));
    }
    return g;
  }, B = function() {
    var d = I("initialFocus", {
      hasFallback: !0
    });
    if (d === !1)
      return !1;
    if (d === void 0 || d && !Fd(d, n.tabbableOptions))
      if (j(i.activeElement) >= 0)
        d = i.activeElement;
      else {
        var r = l.tabbableGroups[0], s = r && r.firstTabbableNode;
        d = s || I("fallbackFocus");
      }
    else d === null && (d = I("fallbackFocus"));
    if (!d)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return d;
  }, R = function() {
    if (l.containerGroups = l.containers.map(function(d) {
      var r = $f(d, n.tabbableOptions), s = CE(d, n.tabbableOptions), p = r.length > 0 ? r[0] : void 0, b = r.length > 0 ? r[r.length - 1] : void 0, c = s.find(function(k) {
        return Bn(k);
      }), h = s.slice().reverse().find(function(k) {
        return Bn(k);
      }), g = !!r.find(function(k) {
        return ja(k) > 0;
      });
      return {
        container: d,
        tabbableNodes: r,
        focusableNodes: s,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: g,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: p,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: b,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: c,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: h,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(P) {
          var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, z = r.indexOf(P);
          return z < 0 ? O ? s.slice(s.indexOf(P) + 1).find(function(W) {
            return Bn(W);
          }) : s.slice(0, s.indexOf(P)).reverse().find(function(W) {
            return Bn(W);
          }) : r[z + (O ? 1 : -1)];
        }
      };
    }), l.tabbableGroups = l.containerGroups.filter(function(d) {
      return d.tabbableNodes.length > 0;
    }), l.tabbableGroups.length <= 0 && !I("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (l.containerGroups.find(function(d) {
      return d.posTabIndexesFound;
    }) && l.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, N = function(d) {
    var r = d.activeElement;
    if (r)
      return r.shadowRoot && r.shadowRoot.activeElement !== null ? N(r.shadowRoot) : r;
  }, x = function(d) {
    if (d !== !1 && d !== N(document)) {
      if (!d || !d.focus) {
        x(B());
        return;
      }
      d.focus({
        preventScroll: !!n.preventScroll
      }), l.mostRecentlyFocusedNode = d, $L(d) && d.select();
    }
  }, T = function(d) {
    var r = I("setReturnFocus", {
      params: [d]
    });
    return r || (r === !1 ? !1 : d);
  }, y = function(d) {
    var r = d.target, s = d.event, p = d.isBackward, b = p === void 0 ? !1 : p;
    r = r || El(s), R();
    var c = null;
    if (l.tabbableGroups.length > 0) {
      var h = j(r, s), g = h >= 0 ? l.containerGroups[h] : void 0;
      if (h < 0)
        b ? c = l.tabbableGroups[l.tabbableGroups.length - 1].lastTabbableNode : c = l.tabbableGroups[0].firstTabbableNode;
      else if (b) {
        var k = l.tabbableGroups.findIndex(function(Y) {
          var U = Y.firstTabbableNode;
          return r === U;
        });
        if (k < 0 && (g.container === r || Fd(r, n.tabbableOptions) && !Bn(r, n.tabbableOptions) && !g.nextTabbableNode(r, !1)) && (k = h), k >= 0) {
          var P = k === 0 ? l.tabbableGroups.length - 1 : k - 1, O = l.tabbableGroups[P];
          c = ja(r) >= 0 ? O.lastTabbableNode : O.lastDomTabbableNode;
        } else ls(s) || (c = g.nextTabbableNode(r, !1));
      } else {
        var z = l.tabbableGroups.findIndex(function(Y) {
          var U = Y.lastTabbableNode;
          return r === U;
        });
        if (z < 0 && (g.container === r || Fd(r, n.tabbableOptions) && !Bn(r, n.tabbableOptions) && !g.nextTabbableNode(r)) && (z = h), z >= 0) {
          var W = z === l.tabbableGroups.length - 1 ? 0 : z + 1, G = l.tabbableGroups[W];
          c = ja(r) >= 0 ? G.firstTabbableNode : G.firstDomTabbableNode;
        } else ls(s) || (c = g.nextTabbableNode(r));
      }
    } else
      c = I("fallbackFocus");
    return c;
  }, S = function(d) {
    var r = El(d);
    if (!(j(r, d) >= 0)) {
      if (Kr(n.clickOutsideDeactivates, d)) {
        L.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: n.returnFocusOnDeactivate
        });
        return;
      }
      Kr(n.allowOutsideClick, d) || d.preventDefault();
    }
  }, u = function(d) {
    var r = El(d), s = j(r, d) >= 0;
    if (s || r instanceof Document)
      s && (l.mostRecentlyFocusedNode = r);
    else {
      d.stopImmediatePropagation();
      var p, b = !0;
      if (l.mostRecentlyFocusedNode)
        if (ja(l.mostRecentlyFocusedNode) > 0) {
          var c = j(l.mostRecentlyFocusedNode), h = l.containerGroups[c].tabbableNodes;
          if (h.length > 0) {
            var g = h.findIndex(function(k) {
              return k === l.mostRecentlyFocusedNode;
            });
            g >= 0 && (n.isKeyForward(l.recentNavEvent) ? g + 1 < h.length && (p = h[g + 1], b = !1) : g - 1 >= 0 && (p = h[g - 1], b = !1));
          }
        } else
          l.containerGroups.some(function(k) {
            return k.tabbableNodes.some(function(P) {
              return ja(P) > 0;
            });
          }) || (b = !1);
      else
        b = !1;
      b && (p = y({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: l.mostRecentlyFocusedNode,
        isBackward: n.isKeyBackward(l.recentNavEvent)
      })), x(p || l.mostRecentlyFocusedNode || B());
    }
    l.recentNavEvent = void 0;
  }, A = function(d) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    l.recentNavEvent = d;
    var s = y({
      event: d,
      isBackward: r
    });
    s && (ls(d) && d.preventDefault(), x(s));
  }, M = function(d) {
    (n.isKeyForward(d) || n.isKeyBackward(d)) && A(d, n.isKeyBackward(d));
  }, f = function(d) {
    HL(d) && Kr(n.escapeDeactivates, d) !== !1 && (d.preventDefault(), L.deactivate());
  }, m = function(d) {
    var r = El(d);
    j(r, d) >= 0 || Kr(n.clickOutsideDeactivates, d) || Kr(n.allowOutsideClick, d) || (d.preventDefault(), d.stopImmediatePropagation());
  }, C = function() {
    if (l.active)
      return Lg.activateTrap(o, L), l.delayInitialFocusTimer = n.delayInitialFocus ? Og(function() {
        x(B());
      }) : x(B()), i.addEventListener("focusin", u, !0), i.addEventListener("mousedown", S, {
        capture: !0,
        passive: !1
      }), i.addEventListener("touchstart", S, {
        capture: !0,
        passive: !1
      }), i.addEventListener("click", m, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", M, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", f), L;
  }, F = function() {
    if (l.active)
      return i.removeEventListener("focusin", u, !0), i.removeEventListener("mousedown", S, !0), i.removeEventListener("touchstart", S, !0), i.removeEventListener("click", m, !0), i.removeEventListener("keydown", M, !0), i.removeEventListener("keydown", f), L;
  }, _ = function(d) {
    var r = d.some(function(s) {
      var p = Array.from(s.removedNodes);
      return p.some(function(b) {
        return b === l.mostRecentlyFocusedNode;
      });
    });
    r && x(B());
  }, E = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(_) : void 0, v = function() {
    E && (E.disconnect(), l.active && !l.paused && l.containers.map(function(d) {
      E.observe(d, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return L = {
    get active() {
      return l.active;
    },
    get paused() {
      return l.paused;
    },
    activate: function(d) {
      if (l.active)
        return this;
      var r = D(d, "onActivate"), s = D(d, "onPostActivate"), p = D(d, "checkCanFocusTrap");
      p || R(), l.active = !0, l.paused = !1, l.nodeFocusedBeforeActivation = i.activeElement, r == null || r();
      var b = function() {
        p && R(), C(), v(), s == null || s();
      };
      return p ? (p(l.containers.concat()).then(b, b), this) : (b(), this);
    },
    deactivate: function(d) {
      if (!l.active)
        return this;
      var r = Tg({
        onDeactivate: n.onDeactivate,
        onPostDeactivate: n.onPostDeactivate,
        checkCanReturnFocus: n.checkCanReturnFocus
      }, d);
      clearTimeout(l.delayInitialFocusTimer), l.delayInitialFocusTimer = void 0, F(), l.active = !1, l.paused = !1, v(), Lg.deactivateTrap(o, L);
      var s = D(r, "onDeactivate"), p = D(r, "onPostDeactivate"), b = D(r, "checkCanReturnFocus"), c = D(r, "returnFocus", "returnFocusOnDeactivate");
      s == null || s();
      var h = function() {
        Og(function() {
          c && x(T(l.nodeFocusedBeforeActivation)), p == null || p();
        });
      };
      return c && b ? (b(T(l.nodeFocusedBeforeActivation)).then(h, h), this) : (h(), this);
    },
    pause: function(d) {
      return l.active ? (l.manuallyPaused = !0, this._setPausedState(!0, d)) : this;
    },
    unpause: function(d) {
      return l.active ? (l.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, d)) : this;
    },
    updateContainerElements: function(d) {
      var r = [].concat(d).filter(Boolean);
      return l.containers = r.map(function(s) {
        return typeof s == "string" ? i.querySelector(s) : s;
      }), l.active && R(), v(), this;
    }
  }, Object.defineProperties(L, {
    _isManuallyPaused: {
      value: function() {
        return l.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(d, r) {
        if (l.paused === d)
          return this;
        if (l.paused = d, d) {
          var s = D(r, "onPause"), p = D(r, "onPostPause");
          s == null || s(), F(), v(), p == null || p();
        } else {
          var b = D(r, "onUnpause"), c = D(r, "onPostUnpause");
          b == null || b(), R(), C(), v(), c == null || c();
        }
        return this;
      }
    }
  }), L.updateContainerElements(t), L;
};
function VL(a) {
  return typeof a == "function" && a.length === 1;
}
const qL = ve`:host(:not([focus-override])) .non-modal-dialog-background-wrapper+dialog:focus-visible{position:fixed;z-index:2}dialog{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);background-color:var(--beacon-system-color-background-1);border:0;color:unset;inline-size:var(--beacon-modal-override-width, var(--default-width, 100%));max-inline-size:var(--beacon-modal-override-max-width, var(--max-width));min-inline-size:var(--min-width);padding:0}dialog::backdrop{background-color:var(--beacon-system-color-background-blanket)}.block-size-wrapper{block-size:var(--beacon-modal-override-height, auto)}.non-modal-dialog-background-wrapper+dialog{position:fixed;z-index:2}.non-modal-dialog-background-wrapper{background-color:var(--beacon-system-color-background-blanket);block-size:100%;inline-size:100%;top:0;right:0;bottom:0;left:0;position:fixed;z-index:1}.wrapper{block-size:100%;display:grid;grid-template-rows:auto 1fr auto}.header{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;justify-content:var(--header-justification, end);padding:var(--beacon-system-space-cell-contained)}.body{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end}.footer{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding:var(--beacon-system-space-cell-contained)}`;
var YL = Object.defineProperty, XL = Object.getOwnPropertyDescriptor, Oo = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? XL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && YL(t, e, o), o;
}, tr;
const Yb = class Yb extends Ge(Le).with(gb) {
  constructor() {
    super(...arguments);
    Ie(this, tr);
    this._passthroughs = new Ic(this), this.closeOnClickOut = !1, this.persist = !1, Be(this, tr, !1);
  }
  static get styles() {
    return [super.styles, qL];
  }
  get open() {
    return Te(this, tr);
  }
  set open(e) {
    Be(this, tr, e), this.dialog && (this.open ? this.openModal() : this.closeModal());
  }
  handleEvent(e) {
    const i = this[`handle${e.type}`];
    VL(i) && i.bind(this)(e);
  }
  /**
   * External click handler used for the handleEvent method.
   *
   * @see handleEvent
   * @see setupOpensByListeners
   */
  handleclick({ target: e }) {
    var i;
    e instanceof HTMLElement && (i = this.opensByElements) != null && i.has(e) && this.show();
  }
  show() {
    this.open = !0;
  }
  close() {
    this.open = !1;
  }
  activateFocusTrap() {
    this.focusTrapObject && this.focusTrapObject.activate();
  }
  /*
   * TODO: Remove the OneTrust workaround.
   * We have worked with the Enterprise team to use dialog.show() instead of dialog.showModal() so that
   * they can have a separate modal pop above our modal. This is all a wacky workaround, so we will prefer
   * to find a different solution in the future. This change has resulted in the below if statement, as well
   * as the activateFocusTrap() method, and assorted CSS changes. For specific changes, look to MR 1900 in Beacon Foundation:
   * https://gitlab.awstrp.net/ui-kit/foundation/-/merge_requests/1900
   */
  openModal() {
    this.anyComputedZIndex ? this.dialog.show() : (this.dialog.showModal(), this.activateFocusTrap()), Eb(), Fe(this, Ee.OPEN);
  }
  closeModal() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.dialog.close(), ks(), Fe(this, Ee.CLOSE);
  }
  renderCloseButton() {
    return this.persist ? pe`` : ze`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @click=${this.close} id="${mt(this._passthroughs.attributes.get("id"))}">
        <${this.getScopedTag("beacon-icon")} slot="icon" name="close" size="s"></${this.getScopedTag("beacon-icon")}>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  handleDialogClick(e) {
    if (this.persist || !this.closeOnClickOut) return;
    e.composedPath().includes(this.contentWrapper) || this.close();
  }
  runOpensBySetup() {
    this.opensByElements.forEach(
      (e, i) => i.addEventListener(
        "click",
        this
      )
    );
  }
  runOpensByClean() {
    this.opensByElements.forEach(
      (e, i) => i.removeEventListener(
        "click",
        this
      )
    );
  }
  setupAnalyticsAttributes() {
    this.dataset.metricsLocation = "PU";
  }
  initializeAnyComputedZIndex() {
    this.anyComputedZIndex = window.getComputedStyle(this).getPropertyValue("z-index") !== "auto";
  }
  openModalOnLoad() {
    this.open && this.openModal();
  }
  initializeFocusTrap() {
    window.__beaconTrapStack || (window.__beaconTrapStack = []), this.focusTrapObject = Rv(this, {
      /** This global var enables multiple layers of focusTraps to determine which focusTrap takes precendence.
       * focus-trap will dynamically pause lower focusTrap layers in the stack.
       * https://github.com/focus-trap/focus-trap/blob/master/docs/js/global-trap-stack.js#L13
       * */
      trapStack: window.__beaconTrapStack,
      fallbackFocus: this.dialog,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // this is where escape key properly sets properties
      escapeDeactivates: () => (this.close(), !0)
    });
  }
  removeOpensByListeners() {
    this.opensByElements && this.opensByElements.size > 0 && this.opensByElements.forEach(
      (e, i) => i.removeEventListener(
        "click",
        this
      )
    );
  }
  closeWhenDisconnected() {
    this.open && (this.focusTrapObject && this.focusTrapObject.deactivate(), ks());
  }
};
tr = new WeakMap(), Yb.nestedComponents = [Qt, ro];
let Ht = Yb;
Oo([
  ue({ attribute: "close-on-click-out", type: Boolean })
], Ht.prototype, "closeOnClickOut", 2);
Oo([
  ue({ type: Boolean })
], Ht.prototype, "persist", 2);
Oo([
  ue({ type: Boolean, reflect: !0 })
], Ht.prototype, "open", 1);
Oo([
  We("dialog")
], Ht.prototype, "dialog", 2);
Oo([
  We(".wrapper")
], Ht.prototype, "contentWrapper", 2);
Oo([
  Ce()
], Ht.prototype, "anyComputedZIndex", 2);
Oo([
  qe
], Ht.prototype, "setupAnalyticsAttributes", 1);
Oo([
  qe
], Ht.prototype, "initializeAnyComputedZIndex", 1);
Oo([
  Re
], Ht.prototype, "openModalOnLoad", 1);
Oo([
  Re
], Ht.prototype, "initializeFocusTrap", 1);
Oo([
  Pt
], Ht.prototype, "removeOpensByListeners", 1);
Oo([
  Pt
], Ht.prototype, "closeWhenDisconnected", 1);
const Pg = {
  beaconTagName: "beacon-drawer"
}, QL = ve`@keyframes intro-from-offscreen-right{0%{opacity:0;transform:translate(calc(1 * var(--motion-translate-intro-macro)))}to{opacity:1;transform:translate(0)}}:host([motion-state=enabled]) .show{animation-name:intro-from-offscreen-right;animation-duration:var(--beacon-reference-motion-duration-5);animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .show::backdrop{animation-duration:var(--beacon-reference-motion-duration-5);animation-name:backdrop-fade;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .close{animation-name:intro-from-offscreen-right;animation-direction:reverse;animation-duration:var(--beacon-reference-motion-duration-4);animation-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}:host([motion-state=enabled]) .close::backdrop{animation-direction:reverse;animation-duration:var(--beacon-reference-motion-duration-4);animation-name:backdrop-fade;animation-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}@keyframes backdrop-fade{0%{opacity:0}to{opacity:1}}`;
var ZL = Object.defineProperty, JL = Object.getOwnPropertyDescriptor, Dg = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? JL(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && ZL(t, e, o), o;
};
function eO(a) {
  let t = class extends a {
    static get drawerMotionStyles() {
      return [QL];
    }
    /**
     * Overrides the default showModal and close methods of the dialog element with extra features.
     *
     * Calls the original methods when our extra features are completed.
     *
     * @link https://stackoverflow.com/questions/71744072/how-to-animate-css-backdrop-behind-html-dialog
     */
    drawerMotion() {
      if (this.motionState === "enabled") {
        const e = this.dialog, i = e.showModal, o = e.close;
        e.showModal = () => {
          e.classList.add("show"), i.call(e), e.addEventListener(
            "animationend",
            () => {
              e.classList.remove("show");
            },
            { once: !0 }
          );
        }, e.close = () => {
          e.classList.add("close"), e.addEventListener(
            "animationend",
            () => {
              o.call(e), e.classList.remove("close");
            },
            { once: !0 }
          );
        };
      }
    }
  };
  return Dg([
    Re
  ], t.prototype, "drawerMotion", 1), t = Dg([
    $e("DrawerMotion")
  ], t), t;
}
const tO = ve`:host,:host([variant=standard]){--drawer-padding: var(--beacon-system-space-organism-jumbo)}:host([variant=slim]){--drawer-padding: var(--beacon-system-space-organism-jumbo) var(--beacon-system-space-organism-normal)}dialog{--max-width: 100%;--min-width: 100%;block-size:100dvh;max-block-size:none}@media (width < 640px){dialog{margin-block:0}}@media (width >= 640px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);margin-inline-end:0}}@media (width >= 960px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 1280px){dialog{--max-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--min-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}}.wrapper{block-size:100dvh;max-block-size:100dvh}.body{padding:var(--drawer-padding)}`;
var oO = Object.defineProperty, iO = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && oO(t, e, o), o;
};
const Xb = class Xb extends Ge(Ht).with(eO) {
  constructor() {
    super(...arguments), this.beaconTagName = Pg.beaconTagName, this.variant = "standard";
  }
  static get styles() {
    return [super.styles, tO, this.drawerMotionStyles];
  }
  render() {
    return pe`
      <dialog @click=${this.handleDialogClick}>
        <div class="wrapper">
          <div class="header">${this.renderCloseButton()}</div>
          <div class="body" tabindex=${Ja()}>
            <slot></slot>
          </div>
          <div class="footer">
            <div class="action-zone">
              <slot
                name="action-zone"
                ${_e({ container: ".footer" })}></slot>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
Xb.tagName = Pg.beaconTagName;
let Oh = Xb;
iO([
  ue({ type: String, reflect: !0 })
], Oh.prototype, "variant");
const zg = {
  beaconTagName: "beacon-filter-chip"
}, aO = {
  Normal: "normal"
}, nO = ve`[beacon-tag-name=beacon-filter-chip]:not(:has([slot=icon])){--filter-chip-transition-property: inline-size, opacity}`, rO = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) .filter-chip{transition-duration:var(--beacon-reference-motion-duration-3);transition-property:background-color,color;transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}:host([motion-state=enabled]) .filter-chip .selected-icon{transition-duration:var(--beacon-reference-motion-duration-3),var(--beacon-reference-motion-duration-6);transition-property:var(--filter-chip-transition-property, none);transition-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1)}}`;
var sO = Object.getOwnPropertyDescriptor, lO = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? sO(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function cO(a) {
  let t = class extends a {
    static get FilterChipMotionStyles() {
      return [rO];
    }
  };
  return t = lO([
    $e("FilterChipMotion")
  ], t), t;
}
const dO = ve`:host{display:inline-block;position:relative}.filter-chip{--icon-color: var(--beacon-system-color-icon-secondary);--label-background: transparent;--label-border: var(--beacon-system-color-border-secondary);--label-color: var(--beacon-system-color-text-link);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard);--label-padding-block: var(--beacon-reference-space-4);--label-padding-inline: var(--beacon-reference-space-5);align-items:center;background-color:var(--label-background);border-color:var(--label-border);border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--label-color);display:flex;font:var(--label-font);inline-size:fit-content;padding-block:var(--label-padding-block);padding-inline:var(--label-padding-inline)}.filter-chip.mini{--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);--label-padding-block: var(--beacon-reference-space-3);--label-padding-inline: var(--beacon-reference-space-4)}.filter-chip svg,.filter-chip ::slotted(svg){block-size:var(--beacon-reference-space-5);color:var(--icon-color);display:block;fill:currentcolor;inline-size:var(--beacon-reference-space-5)}.filter-chip .icon{flex-shrink:0}input{opacity:0;pointer-events:none;position:absolute}input:focus-visible+label{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}input:focus-visible+label:not(dialog){position:relative}input:not(:disabled)+label{cursor:pointer}input:not(:disabled,:checked)+label:hover{--label-background: var(--beacon-system-color-background-secondary-hover)}input:disabled+label{--icon-color: var(--beacon-system-color-icon-secondary-inactive);--label-border: var(--beacon-system-color-border-secondary-inactive);--label-color: var(--beacon-system-color-text-secondary-inactive);cursor:not-allowed}input:active:not(:disabled,:checked)+label{--label-background: var(--beacon-system-color-background-secondary-pressed)}input:not(:checked)+label .custom-icon{inline-size:var(--beacon-reference-space-5);margin-inline-end:var(--beacon-reference-space-3);opacity:1}input:not(:checked)+label .selected-icon{inline-size:0;opacity:0;overflow:hidden}input:checked+label{--icon-color: var(--beacon-system-color-icon-primary);--label-background: var(--beacon-system-color-background-primary);--label-border: var(--beacon-system-color-border-primary);--label-color: var(--beacon-system-color-text-primary)}input:checked+label .custom-icon{inline-size:0;opacity:0;overflow:hidden}input:checked+label .selected-icon{inline-size:var(--beacon-reference-space-5);margin-inline-end:var(--beacon-reference-space-3)}input:checked+label:hover{--label-background: var(--beacon-system-color-background-primary-hover)}input:checked:active+label{--label-background: var(--beacon-system-color-background-primary-pressed)}input:checked:disabled+label{--icon-color: var(--beacon-system-color-icon-primary-inactive);--label-background: var(--beacon-system-color-background-primary-inactive);--label-border: var(--beacon-system-color-border-secondary-inactive);--label-color: var(--beacon-system-color-text-primary-inactive)}`;
var hO = Object.defineProperty, Tb = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && hO(t, e, o), o;
}, Va;
const Qb = class Qb extends Ge(Le).with(
  cO
) {
  constructor() {
    super(...arguments);
    Ie(this, Va);
    this.beaconTagName = zg.beaconTagName, this.focusOverride = !0, this._passthroughs = new Ic(this, {
      id: "filter"
    }), this.scale = aO.Normal, this.disabled = !1, this.selected = !1, Be(this, Va, !1);
  }
  static get styles() {
    return [super.styles, dO, this.FilterChipMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, nO];
  }
  toggleSelectedFromInput({ target: e }) {
    e instanceof HTMLInputElement && (Be(this, Va, !0), this.selected = e.checked);
  }
  emitInputEvent() {
    Te(this, Va) || Fe(this, "input"), Be(this, Va, !1);
  }
  willUpdate(e) {
    Dr(e, "selected") && this.emitInputEvent();
  }
  render() {
    return pe`
      <input
        type="checkbox"
        id="${this._passthroughs.attributes.get("id")}"
        name="filter"
        ?disabled=${this.disabled}
        aria-disabled="${this.disabled}"
        .checked=${this.selected}
        @change=${this.toggleSelectedFromInput} />
      <label
        class="${this.scale} filter-chip"
        for="${this._passthroughs.attributes.get("id")}">
        <div class="icon selected-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_198_2093)">
              <path
                d="M15.5826 0.187467C15.1338 -0.134495 14.5091 -0.0314642 14.1873 0.4176L4.83073 13.4705L1.70743 10.3427C1.45484 10.0898 1.08663 9.99099 0.741488 10.0834C0.396348 10.1759 0.126716 10.4455 0.0341606 10.7908C-0.058395 11.1361 0.040187 11.5046 0.292772 11.7575L4.24941 15.7157C4.45954 15.9181 4.74638 16.0204 5.03704 15.9966C5.32769 15.9729 5.59416 15.8254 5.76873 15.5917L15.8126 1.5836C16.1344 1.13452 16.0314 0.509462 15.5826 0.187467Z" />
            </g>
            <defs>
              <clipPath id="clip0_198_2093">
                <rect width="16" height="16" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="icon custom-icon">
          <slot name="icon" ${_e({ useParent: !0 })}></slot>
        </div>
        <div class="label">
          <slot></slot>
        </div>
      </label>
    `;
  }
};
Va = new WeakMap(), Qb.tagName = zg.beaconTagName;
let Cs = Qb;
Tb([
  ue()
], Cs.prototype, "scale");
Tb([
  ue({ type: Boolean })
], Cs.prototype, "disabled");
Tb([
  ue({ type: Boolean, reflect: !0 })
], Cs.prototype, "selected");
const bO = ve`:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: 0;--footer-links-padding-block: 0;--footer-links-gap: var(--beacon-system-space-micro-jumbo);--footer-mission-padding-block-end: var(--beacon-reference-space-5);--footer-mission-padding-block-start: 0;--footer-mission-zone-grid-gap: var(--beacon-system-space-micro-jumbo);--footer-socials-padding-block-start: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: var(--beacon-reference-space-7);--footer-mission-padding-block-end: var(--beacon-reference-space-9);--footer-mission-zone-grid-gap: var(--beacon-reference-space-9);--footer-socials-padding-block-start: var(--beacon-reference-space-9)}}@media (width >= 1920px){:root[beacon-tag-name=beacon-footer],:root [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-footer],[beacon-version="4.4.0"][beacon-tag-name=beacon-footer],[beacon-version="4.4.0"] [beacon-tag-name=beacon-footer]{--footer-links-gap: var(--beacon-reference-space-9)}}`, Xd = {
  beaconTagName: "beacon-footer",
  metricsLocationFooter: "FTR"
}, pO = ve`[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) p{margin-block:var(--beacon-system-font-paragraph-spacing-loose)}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :first-child{margin-block-start:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :last-child{margin-block-end:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-footer] sup{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);vertical-align:super}`, uO = ve`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}[class*=b-grid-item][class*="b-sm:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}[class*=b-grid-item][class*="b-md:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}[class*=b-grid-item][class*="b-lg:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-lg:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-lg\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}[class*=b-grid-item][class*="b-xl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}[class*=b-grid-item][class*="b-md-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}.b-grid-item--vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}.b-grid-item--vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}*,::slotted(*){margin:0}.zone{--fallback-grid-gap: var(--beacon-system-space-gutter);background-color:var(--zone-bg-color);padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-maxi)}.zone--mission-and-links{--b-grid-gap: var(--footer-mission-zone-grid-gap);--zone-bg-color: var(--beacon-system-color-background-0)}.zone--disclaimer{--zone-bg-color: var(--beacon-system-color-background-1);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-100)}.brand-wrapper,.socials{--container-border: var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0)}.brand-wrapper{border-block-end:var(--container-border)}.brand,.disclaimer,.copyright{padding-block:var(--beacon-system-space-cell-free-floating)}.disclaimer,.copyright{padding-inline-end:var(--footer-disclaimer-content-padding-inline-end)}.trademark{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);letter-spacing:var(--beacon-reference-font-letter-spacing-trademark);text-transform:uppercase}.keyline{background-color:var(--beacon-system-color-border-brand);block-size:var(--beacon-system-width-border-normal);border:0;inline-size:var(--beacon-reference-space-7);margin-block:var(--beacon-reference-space-5)}.mission{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-300);color:var(--beacon-system-color-text-title);padding-block:var(--footer-mission-padding-block-start) var(--footer-mission-padding-block-end)}.links{display:flex;flex-direction:var(--links-flex-direction, column);gap:var(--footer-links-gap, 0);padding-block:var(--footer-links-padding-block)}.socials{border-block-start:var(--container-border);padding-block-start:var(--footer-socials-padding-block-start)}.hide{display:none}@media (width >= 960px){.links{--links-flex-direction: row}}`;
var gO = Object.defineProperty, nl = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && gO(t, e, o), o;
};
const Zb = class Zb extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Xd.beaconTagName, this.showKeyline = !1, this.hideBrandWrapper = !0, this.dataMetricsLocation = Xd.metricsLocationFooter;
  }
  static get styles() {
    return [super.styles, uO];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, pO, bO];
  }
  checkForSlot() {
    this.showKeyline = !!this.slottedMissionContent.length && !!this.slottedTrademark.length, this.hideBrandWrapper = !this.slottedMissionContent.length && !this.slottedTrademark.length;
  }
  render() {
    return pe`<div class="zone zone--mission-and-links">
        <div class="b-grid">
          <div
            class="brand-wrapper b-grid b-grid-item--full-col ${this.hideBrandWrapper ? "hide" : ""}">
            <div class="brand b-grid-item--full-col b-md:10-col b-lg:8-col">
              <div class="trademark">
                <slot name="trademark" @slotchange=${this.checkForSlot}></slot>
              </div>
              <hr
                class=${this.showKeyline ? "keyline" : "hide"}
                aria-hidden="true" />
              <div class="mission">
                <slot name="mission" @slotchange=${this.checkForSlot}></slot>
              </div>
            </div>
          </div>
          <div class="links b-grid-item--full-col">
            <slot name="links" ${_e({ useParent: !0 })}></slot>
          </div>
          <div class="socials b-grid-item--full-col">
            <slot name="socials" ${_e({ useParent: !0 })}></slot>
          </div>
        </div>
      </div>
      <div class="zone zone--disclaimer">
        <div class="b-grid">
          <div class="disclaimer b-grid-item--full-col b-md:10-col b-lg:6-col">
            <slot name="disclaimer"></slot>
          </div>
          <div
            class="copyright b-grid-item--full-col b-md:10-col b-lg:5-col b-lg:start-8">
            <slot name="copyright"></slot>
          </div>
        </div>
      </div>`;
  }
};
Zb.tagName = Xd.beaconTagName;
let bn = Zb;
nl([
  De({ flatten: !0, slot: "mission" })
], bn.prototype, "slottedMissionContent");
nl([
  De({ flatten: !0, slot: "trademark" })
], bn.prototype, "slottedTrademark");
nl([
  Ce()
], bn.prototype, "showKeyline");
nl([
  Ce()
], bn.prototype, "hideBrandWrapper");
nl([
  ue({ attribute: "data-metrics-location", reflect: !0 })
], bn.prototype, "dataMetricsLocation");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Nv = class extends Event {
  constructor(t, e, i, o) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e, this.callback = i, this.subscribe = o != null ? o : !1;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let mO = class {
  constructor(t, e, i, o) {
    var n;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (l, L) => {
      this.unsubscribe && (this.unsubscribe !== L && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = l, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(l, L)), this.unsubscribe = L;
    }, this.host = t, e.context !== void 0) {
      const l = e;
      this.context = l.context, this.callback = l.callback, this.subscribe = (n = l.subscribe) != null ? n : !1;
    } else this.context = e, this.callback = i, this.subscribe = o != null ? o : !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new Nv(this.context, this.host, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class fO {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, e = !1) {
    const i = e || !Object.is(t, this.o);
    this.o = t, i && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [e, { disposer: i }] of this.subscriptions) e(this.o, i);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, e, i) {
    if (!i) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: e });
    const { disposer: o } = this.subscriptions.get(t);
    t(this.value, o);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class vO extends Event {
  constructor(t, e) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = e;
  }
}
class AO extends fO {
  constructor(t, e, i) {
    var o, n;
    super(e.context !== void 0 ? e.initialValue : i), this.onContextRequest = (l) => {
      var D;
      if (l.context !== this.context) return;
      const L = (D = l.contextTarget) != null ? D : l.composedPath()[0];
      L !== this.host && (l.stopPropagation(), this.addCallback(l.callback, L, l.subscribe));
    }, this.onProviderRequest = (l) => {
      var D;
      if (l.context !== this.context || ((D = l.contextTarget) != null ? D : l.composedPath()[0]) === this.host) return;
      const L = /* @__PURE__ */ new Set();
      for (const [j, { consumerHost: I }] of this.subscriptions) L.has(j) || (L.add(j), I.dispatchEvent(new Nv(this.context, I, j, !0)));
      l.stopPropagation();
    }, this.host = t, e.context !== void 0 ? this.context = e.context : this.context = e, this.attachListeners(), (n = (o = this.host).addController) == null || n.call(o, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new vO(this.context, this.host));
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* Ig(a, t) {
  const e = typeof t == "function";
  if (a !== void 0) {
    let i = -1;
    for (const o of a) i > -1 && (yield e ? t(i) : t), i++, yield o;
  }
}
const Fv = Symbol("footnotes"), Bg = {
  beaconTagName: "beacon-footnote-list"
}, Rg = {
  beaconTagName: "beacon-footnote"
}, yO = ve`@supports selector(:state(--customstate)){:host(:state(--inactive)){display:var(--inactive-footnote-display, none)}}@supports not selector(:state(--customstate)){:host([state----inactive]){display:var(--inactive-footnote-display, none)}}:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.shadow-anchor:focus-visible{border:0!important;box-shadow:none!important;outline:none!important}`;
var xO = Object.defineProperty, jv = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && xO(t, e, o), o;
}, Ds, At, Xr, or, mc, la, _v, Uv, $v, Dl, Hv, Kv, Gv;
const Lb = (la = class extends Le {
  constructor() {
    super();
    Ie(this, At);
    Ie(this, Ds);
    Ie(this, or);
    this.beaconTagName = Rg.beaconTagName, Be(this, Ds, new mO(this, {
      context: Fv,
      subscribe: !0,
      callback: (e) => {
        Ue(this, At, Uv).call(this), Ue(this, At, $v).call(this), Ue(this, At, Hv).call(this, this._refs);
      }
    })), Be(this, or, 0), this._refs = /* @__PURE__ */ new Map(), this._internals && (this._internals.role = "listitem");
  }
  static get styles() {
    return [super.styles, yO];
  }
  get _ref() {
    return Te(this, or);
  }
  set _ref(e) {
    Be(this, or, e), this.setState("--inactive", e === 0);
  }
  render() {
    return pe`
      <span id="shadow-anchor" class="shadow-anchor" tabindex="-1"></span>
      ${Ig(
      No(
        Ue(this, At, Gv).call(this),
        (e) => e
      ),
      pe`, `
    )}
      <slot></slot>
      <slot name="return-text">Return to</slot>
      ${Ig(
      No(
        Ue(this, At, Kv).call(this),
        (e) => e
      ),
      pe`, `
    )}
    `;
  }
}, Ds = new WeakMap(), At = new WeakSet(), Xr = function() {
  return Te(this, Ds).value;
}, or = new WeakMap(), mc = new WeakSet(), _v = function(e, i) {
  e.id || (e.id = e.hash.replace("#", "") + "_fn" + String.fromCharCode(i + 97));
}, Uv = function() {
  var e;
  this._ref = [...((e = Te(this, At, Xr)) == null ? void 0 : e.uniqueIds) || /* @__PURE__ */ new Set()].findIndex(
    (i) => i === `#${this.id}`
  ) + 1 || 0;
}, $v = function() {
  var o;
  const e = (o = Te(this, At, Xr)) == null ? void 0 : o.sources.filter(
    (n) => n.hash === `#${this.id}`
  ), i = /* @__PURE__ */ new Map();
  e == null || e.forEach(
    (n, l) => {
      var L;
      Ue(L = la, mc, _v).call(L, n, l), i.set(
        n,
        String.fromCharCode(l + 97)
      );
    }
  ), this._refs = i;
}, Dl = function(e) {
  var i;
  return ((i = Te(this, At, Xr)) == null ? void 0 : i.sourceCounts.get(`#${this.id}`)) === 1 ? "" : e;
}, Hv = function(e) {
  e.forEach((i, o) => {
    const n = Ue(this, At, Dl).call(this, i), l = `${this._ref}${n}`;
    o.dataset.beaconFootnote || (o.innerHTML = "", o.style.setProperty("text-decoration-line", "none"), o.style.setProperty("color", "var(--beacon-system-color-text-link)"), o.ariaLabel = `Footnote ${l}`, o.addEventListener("click", (L) => {
      this.scrollIntoView(), this._shadowAnchor.focus();
    })), Ws(
      pe`<sup style="color: inherit; text-decoration: underline;"
          >${l}</sup
        >`,
      o
    ), o.dataset.beaconFootnote = l;
  });
}, Kv = function() {
  const e = [];
  return this._refs.forEach((i, o) => {
    var D;
    const n = Ue(this, At, Dl).call(this, i), l = `${this._ref}${n}`;
    ((D = Te(this, At, Xr)) == null ? void 0 : D.sourceHosts.get(o)) ? e.push(
      pe`<a
            href="#${o.id}"
            class="backlink"
            @click=${() => {
        o.scrollIntoView(), o.focus();
      }}>
            ${l}
          </a>`
    ) : e.push(
      pe`<a class="backlink" href="#${o.id}">${l}</a>`
    );
  }), e;
}, Gv = function() {
  const e = [];
  return this._refs.forEach((i, o) => {
    const n = Ue(this, At, Dl).call(this, i);
    e.push(pe`${this._ref}${n}.`);
  }), e;
}, Ie(la, mc), la.tagName = Rg.beaconTagName, la);
jv([
  Ce()
], Lb.prototype, "_refs");
jv([
  We("#shadow-anchor")
], Lb.prototype, "_shadowAnchor");
let ZD = Lb;
var zs, Is, xr, Wv, Bs, Rs, Vv;
class wO extends AO {
  constructor() {
    super(...arguments);
    Ie(this, xr);
    Ie(this, zs);
    Ie(this, Is, []);
    Ie(this, Bs, (e) => {
      const { detail: i } = e, { source: o } = i;
      o instanceof HTMLAnchorElement ? this.sources = [...this.sources, o] : console.error(
        `Attempted to add ${o} to the Footnote List but it is not an HTMLAnchorElement.`
      );
    });
    Ie(this, Rs, (e) => {
      const { detail: i } = e, { source: o } = i;
      o instanceof HTMLAnchorElement ? this.sources = this.sources.filter(
        (n) => n !== o
      ) : console.error(
        `Attempted to remove ${o} from the Footnote List but it is not an HTMLAnchorElement.`
      );
    });
  }
  get sources() {
    return Te(this, Is);
  }
  set sources(e) {
    const i = e.toSorted(
      (D, j) => {
        const I = D.getBoundingClientRect(), B = j.getBoundingClientRect();
        return I.y === B.y ? I.x - B.x : I.y - B.y;
      }
    ), n = i.map(
      (D) => D.hash
    ).reduce(
      (D, j) => D.set(j, (D.get(j) || 0) + 1),
      /* @__PURE__ */ new Map()
    ), l = new Set(n.keys()), L = i.reduce(
      (D, j) => D.set(j, this.host.getClosestHost.call(j)),
      /* @__PURE__ */ new Map()
    );
    Be(this, Is, i), this.setValue(
      {
        sources: i,
        uniqueIds: l,
        sourceCounts: n,
        sourceHosts: L,
        listHost: Te(this, zs)
      },
      !0
    ), this.host.requestUpdate();
  }
  hostConnected() {
    Ue(this, xr, Vv).call(this), Be(this, zs, this.host.getClosestHost.call(this.host)), window.addEventListener(
      Ee.ADD_FOOTNOTE,
      Te(this, Bs)
    ), window.addEventListener(
      Ee.REMOVE_FOOTNOTE,
      Te(this, Rs)
    );
  }
  hostUpdated() {
    Ue(this, xr, Wv).call(this);
  }
  hostDisconnected() {
    window.removeEventListener(
      Ee.ADD_FOOTNOTE,
      Te(this, Bs)
    ), window.removeEventListener(
      Ee.REMOVE_FOOTNOTE,
      Te(this, Rs)
    );
  }
}
zs = new WeakMap(), Is = new WeakMap(), xr = new WeakSet(), Wv = function() {
  const i = [...this.host.querySelectorAll(
    this.host.getScopedTagName("beacon-footnote")
  )].toSorted(
    (o, n) => o._ref - n._ref
  );
  this.host.append(...i);
}, Bs = new WeakMap(), Rs = new WeakMap(), Vv = function() {
  const e = [
    .../* @__PURE__ */ new Set([
      ...document.querySelectorAll(
        this.host.getScopedTagName("beacon-footnote")
      ),
      ...this.host.querySelectorAll(
        this.host.getScopedTagName("beacon-footnote")
      )
    ])
  ].map((o) => o.id), i = [];
  for (const o of e) {
    const n = document.querySelectorAll(
      `a[href="#${o}"]`
    );
    n && i.push(...n);
  }
  this.sources = i;
};
const kO = ve`.list{display:flex;flex-flow:column;gap:var(--beacon-component-footnote-space)}`, Jb = class Jb extends Le {
  constructor() {
    super(), this.beaconTagName = Bg.beaconTagName, this._footnotes = new wO(this, {
      context: Fv
    }), this._internals && (this._internals.role = "list");
  }
  static get styles() {
    return [super.styles, kO];
  }
  /**
   * Emit event signalling that a given footnote should be added to or removed from the source list.
   *
   * If your footnote source is in the shadow root of a custom element, this method is necessary for adding them to the list.
   *
   * This method is always necessary when you have a footnote that should no longer participate in the overall collection.
   *
   * @example
   * ```js
   * // Get reference to the element acting as the footnote source.
   * const myFootnote = myComponent.querySelector('a[href="#footnote"]');
   *
   * // Get reference to footnote list
   * const list = document.querySelector('beacon-footnote-list');
   *
   * // Add footnote to collection
   * list.updateFootnotes({source: myFootnote, type: "add"});
   *
   * // Remove footnote from collection
   * list.updateFootnotes({source: myFootnote, type: "remove"});
   * ```
   */
  updateFootnotes({
    source: t,
    type: e = "add"
  }) {
    Fe(
      this,
      e === "remove" ? Ee.REMOVE_FOOTNOTE : Ee.ADD_FOOTNOTE,
      {
        detail: {
          source: t
        }
      }
    );
  }
  render() {
    return pe`
      <div class="list">
        <slot></slot>
      </div>
    `;
  }
};
Jb.tagName = Bg.beaconTagName;
let Ng = Jb;
var qv = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Extensions/Pane/PaneComposition.js", [e["Core/Utilities.js"]], function(o) {
      let { addEvent: n, correctFloat: l, defined: L, pick: D } = o;
      function j(x) {
        let T, y = this;
        return x && y.pane.forEach((S) => {
          I(x.chartX - y.plotLeft, x.chartY - y.plotTop, S.center) && (T = S);
        }), T;
      }
      function I(x, T, y, S, u) {
        let A = !0, M = y[0], f = y[1], m = Math.sqrt(Math.pow(x - M, 2) + Math.pow(T - f, 2));
        if (L(S) && L(u)) {
          let C = Math.atan2(l(T - f, 8), l(x - M, 8));
          u !== S && (A = S > u ? C >= S && C <= Math.PI || C <= u && C >= -Math.PI : C >= S && C <= l(u, 8));
        }
        return m <= Math.ceil(y[2] / 2) && A;
      }
      function B(x) {
        this.polar && (x.options.inverted && ([x.x, x.y] = [x.y, x.x]), x.isInsidePlot = this.pane.some((T) => I(x.x, x.y, T.center, T.axis && T.axis.normalizedStartAngleRad, T.axis && T.axis.normalizedEndAngleRad)));
      }
      function R(x) {
        let T = this.chart;
        x.hoverPoint && x.hoverPoint.plotX && x.hoverPoint.plotY && T.hoverPane && !I(x.hoverPoint.plotX, x.hoverPoint.plotY, T.hoverPane.center) && (x.hoverPoint = void 0);
      }
      function N(x) {
        let T = this.chart;
        T.polar ? (T.hoverPane = T.getHoverPane(x), x.filter = function(y) {
          return y.visible && !(!x.shared && y.directTouch) && D(y.options.enableMouseTracking, !0) && (!T.hoverPane || y.xAxis.pane === T.hoverPane);
        }) : T.hoverPane = void 0;
      }
      return { compose: function(x, T) {
        let y = x.prototype;
        y.getHoverPane || (y.collectionsWithUpdate.push("pane"), y.getHoverPane = j, n(x, "afterIsInsidePlot", B), n(T, "afterGetHoverData", R), n(T, "beforeGetHoverData", N));
      } };
    }), i(e, "Extensions/Pane/PaneDefaults.js", [], function() {
      return { pane: { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, background: { shape: "circle", borderRadius: 0, borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" } };
    }), i(e, "Extensions/Pane/Pane.js", [e["Series/CenteredUtilities.js"], e["Extensions/Pane/PaneComposition.js"], e["Extensions/Pane/PaneDefaults.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { extend: D, merge: j, splat: I } = L;
      class B {
        constructor(N, x) {
          this.coll = "pane", this.init(N, x);
        }
        init(N, x) {
          this.chart = x, this.background = [], x.pane.push(this), this.setOptions(N);
        }
        setOptions(N) {
          this.options = N = j(l.pane, this.chart.angular ? { background: {} } : void 0, N);
        }
        render() {
          let N = this.options, x = this.chart.renderer;
          this.group || (this.group = x.g("pane-group").attr({ zIndex: N.zIndex || 0 }).add()), this.updateCenter();
          let T = this.options.background;
          if (T) {
            let y = Math.max((T = I(T)).length, this.background.length || 0);
            for (let S = 0; S < y; S++) T[S] && this.axis ? this.renderBackground(j(l.background, T[S]), S) : this.background[S] && (this.background[S] = this.background[S].destroy(), this.background.splice(S, 1));
          }
        }
        renderBackground(N, x) {
          let T = { class: "highcharts-pane " + (N.className || "") }, y = "animate";
          this.chart.styledMode || D(T, { fill: N.backgroundColor, stroke: N.borderColor, "stroke-width": N.borderWidth }), this.background[x] || (this.background[x] = this.chart.renderer.path().add(this.group), y = "attr"), this.background[x][y]({ d: this.axis.getPlotBandPath(N.from, N.to, N) }).attr(T);
        }
        updateCenter(N) {
          this.center = (N || this.axis || {}).center = o.getCenter.call(this);
        }
        update(N, x) {
          j(!0, this.options, N), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(T) {
            T.pane === this && (T.pane = null, T.update({}, x));
          }, this);
        }
      }
      return B.compose = n.compose, B;
    }), i(e, "Series/AreaRange/AreaRangePoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { area: { prototype: { pointClass: l, pointClass: { prototype: L } } } } = o.seriesTypes, { defined: D, isNumber: j } = n;
      return class extends l {
        setState() {
          let I = this.state, B = this.series, R = B.chart.polar;
          D(this.plotHigh) || (this.plotHigh = B.yAxis.toPixels(this.high, !0)), D(this.plotLow) || (this.plotLow = this.plotY = B.yAxis.toPixels(this.low, !0)), B.lowerStateMarkerGraphic = B.stateMarkerGraphic, B.stateMarkerGraphic = B.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, R && j(this.plotHighX) && (this.plotX = this.plotHighX), L.setState.apply(this, arguments), this.state = I, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], R && j(this.plotLowX) && (this.plotX = this.plotLowX), B.upperStateMarkerGraphic = B.stateMarkerGraphic, B.stateMarkerGraphic = B.lowerStateMarkerGraphic, B.lowerStateMarkerGraphic = void 0;
          let N = B.modifyMarkerSettings();
          L.setState.apply(this, arguments), B.restoreMarkerSettings(N);
        }
        haloPath() {
          let I = this.series.chart.polar, B = [];
          return this.plotY = this.plotLow, I && j(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (B = L.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, I && j(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (B = B.concat(L.haloPath.apply(this, arguments))), B;
        }
        isValid() {
          return j(this.low) && j(this.high);
        }
      };
    }), i(e, "Series/AreaRange/AreaRangeSeries.js", [e["Series/AreaRange/AreaRangePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { noop: D } = n, { area: j, area: { prototype: I }, column: { prototype: B } } = l.seriesTypes, { addEvent: R, defined: N, extend: x, isArray: T, isNumber: y, pick: S, merge: u } = L;
      class A extends j {
        toYData(f) {
          return [f.low, f.high];
        }
        highToXY(f) {
          let m = this.chart, C = this.xAxis.postTranslate(f.rectPlotX || 0, this.yAxis.len - (f.plotHigh || 0));
          f.plotHighX = C.x - m.plotLeft, f.plotHigh = C.y - m.plotTop, f.plotLowX = f.plotX;
        }
        getGraphPath(f) {
          let m = [], C = [], F = I.getGraphPath, _ = this.options, E = this.chart.polar, v = E && _.connectEnds !== !1, w = _.connectNulls, d, r, s, p = _.step;
          for (d = (f = f || this.points).length; d--; ) {
            r = f[d];
            let k = E ? { plotX: r.rectPlotX, plotY: r.yBottom, doCurve: !1 } : { plotX: r.plotX, plotY: r.plotY, doCurve: !1 };
            r.isNull || v || w || f[d + 1] && !f[d + 1].isNull || C.push(k), s = { polarPlotY: r.polarPlotY, rectPlotX: r.rectPlotX, yBottom: r.yBottom, plotX: S(r.plotHighX, r.plotX), plotY: r.plotHigh, isNull: r.isNull }, C.push(s), m.push(s), r.isNull || v || w || f[d - 1] && !f[d - 1].isNull || C.push(k);
          }
          let b = F.call(this, f);
          p && (p === !0 && (p = "left"), _.step = { left: "right", center: "center", right: "left" }[p]);
          let c = F.call(this, m), h = F.call(this, C);
          _.step = p;
          let g = [].concat(b, c);
          return !this.chart.polar && h[0] && h[0][0] === "M" && (h[0] = ["L", h[0][1], h[0][2]]), this.graphPath = g, this.areaPath = b.concat(h), g.isArea = !0, g.xMap = b.xMap, this.areaPath.xMap = b.xMap, g;
        }
        drawDataLabels() {
          var s, p;
          let f, m, C, F, _, E = this.points, v = E.length, w = [], d = this.options.dataLabels, r = this.chart.inverted;
          if (d) {
            if (T(d) ? (F = d[0] || { enabled: !1 }, _ = d[1] || { enabled: !1 }) : ((F = x({}, d)).x = d.xHigh, F.y = d.yHigh, (_ = x({}, d)).x = d.xLow, _.y = d.yLow), F.enabled || ((s = this.hasDataLabels) == null ? void 0 : s.call(this))) {
              for (f = v; f--; ) if (m = E[f]) {
                let { plotHigh: b = 0, plotLow: c = 0 } = m;
                C = F.inside ? b < c : b > c, m.y = m.high, m._plotY = m.plotY, m.plotY = b, w[f] = m.dataLabel, m.dataLabel = m.dataLabelUpper, m.below = C, r ? F.align || (F.align = C ? "right" : "left") : F.verticalAlign || (F.verticalAlign = C ? "top" : "bottom");
              }
              for (this.options.dataLabels = F, I.drawDataLabels && I.drawDataLabels.apply(this, arguments), f = v; f--; ) (m = E[f]) && (m.dataLabelUpper = m.dataLabel, m.dataLabel = w[f], delete m.dataLabels, m.y = m.low, m.plotY = m._plotY);
            }
            if (_.enabled || (p = this.hasDataLabels) != null && p.call(this)) {
              for (f = v; f--; ) if (m = E[f]) {
                let { plotHigh: b = 0, plotLow: c = 0 } = m;
                C = _.inside ? b < c : b > c, m.below = !C, r ? _.align || (_.align = C ? "left" : "right") : _.verticalAlign || (_.verticalAlign = C ? "bottom" : "top");
              }
              this.options.dataLabels = _, I.drawDataLabels && I.drawDataLabels.apply(this, arguments);
            }
            if (F.enabled) for (f = v; f--; ) (m = E[f]) && (m.dataLabels = [m.dataLabelUpper, m.dataLabel].filter(function(b) {
              return !!b;
            }));
            this.options.dataLabels = d;
          }
        }
        alignDataLabel() {
          B.alignDataLabel.apply(this, arguments);
        }
        modifyMarkerSettings() {
          let f = { marker: this.options.marker, symbol: this.symbol };
          if (this.options.lowMarker) {
            let { options: { marker: m, lowMarker: C } } = this;
            this.options.marker = u(m, C), C.symbol && (this.symbol = C.symbol);
          }
          return f;
        }
        restoreMarkerSettings(f) {
          this.options.marker = f.marker, this.symbol = f.symbol;
        }
        drawPoints() {
          let f, m, C = this.points.length, F = this.modifyMarkerSettings();
          for (I.drawPoints.apply(this, arguments), this.restoreMarkerSettings(F), f = 0; f < C; ) (m = this.points[f]).graphics = m.graphics || [], m.origProps = { plotY: m.plotY, plotX: m.plotX, isInside: m.isInside, negative: m.negative, zone: m.zone, y: m.y }, (m.graphic || m.graphics[0]) && (m.graphics[0] = m.graphic), m.graphic = m.graphics[1], m.plotY = m.plotHigh, N(m.plotHighX) && (m.plotX = m.plotHighX), m.y = S(m.high, m.origProps.y), m.negative = m.y < (this.options.threshold || 0), this.zones.length && (m.zone = m.getZone()), this.chart.polar || (m.isInside = m.isTopInside = m.plotY !== void 0 && m.plotY >= 0 && m.plotY <= this.yAxis.len && m.plotX >= 0 && m.plotX <= this.xAxis.len), f++;
          for (I.drawPoints.apply(this, arguments), f = 0; f < C; ) (m = this.points[f]).graphics = m.graphics || [], (m.graphic || m.graphics[1]) && (m.graphics[1] = m.graphic), m.graphic = m.graphics[0], m.origProps && (x(m, m.origProps), delete m.origProps), f++;
        }
        hasMarkerChanged(f, m) {
          let C = f.lowMarker, F = m.lowMarker || {};
          return C && (C.enabled === !1 || F.symbol !== C.symbol || F.height !== C.height || F.width !== C.width) || super.hasMarkerChanged(f, m);
        }
      }
      return A.defaultOptions = u(j.defaultOptions, { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: !0, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }), R(A, "afterTranslate", function() {
        this.pointArrayMap.join(",") === "low,high" && this.points.forEach((M) => {
          let f = M.high, m = M.plotY;
          M.isNull ? M.plotY = void 0 : (M.plotLow = m, M.plotHigh = y(f) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(f) : f, !1, !0, void 0, !0) : void 0, this.dataModify && (M.yBottom = M.plotHigh));
        });
      }, { order: 0 }), R(A, "afterTranslate", function() {
        this.points.forEach((M) => {
          if (this.chart.polar) this.highToXY(M), M.plotLow = M.plotY, M.tooltipPos = [((M.plotHighX || 0) + (M.plotLowX || 0)) / 2, ((M.plotHigh || 0) + (M.plotLow || 0)) / 2];
          else {
            let f = M.pos(!1, M.plotLow), m = M.pos(!1, M.plotHigh);
            f && m && (f[0] = (f[0] + m[0]) / 2, f[1] = (f[1] + m[1]) / 2), M.tooltipPos = f;
          }
        });
      }, { order: 3 }), x(A.prototype, { deferTranslatePolar: !0, pointArrayMap: ["low", "high"], pointClass: o, pointValKey: "low", setStackedPoints: D }), l.registerSeriesType("arearange", A), A;
    }), i(e, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [e["Series/AreaRange/AreaRangeSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { spline: { prototype: L } } = n.seriesTypes, { merge: D, extend: j } = l;
      class I extends o {
      }
      return I.defaultOptions = D(o.defaultOptions), j(I.prototype, { getPointSpline: L.getPointSpline }), n.registerSeriesType("areasplinerange", I), I;
    }), i(e, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
      return { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 };
    }), i(e, "Series/BoxPlot/BoxPlotSeries.js", [e["Series/BoxPlot/BoxPlotSeriesDefaults.js"], e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { noop: j } = l, { crisp: I, extend: B, merge: R, pick: N } = D;
      class x extends n {
        pointAttribs() {
          return {};
        }
        translate() {
          let y = this.yAxis, S = this.pointArrayMap;
          super.translate.apply(this), this.points.forEach(function(u) {
            S.forEach(function(A) {
              u[A] !== null && (u[A + "Plot"] = y.translate(u[A], 0, 1, 0, 1));
            }), u.plotHigh = u.highPlot;
          });
        }
        drawPoints() {
          let y, S, u, A, M, f, m, C, F, _, E, v, w, d = this.points, r = this.options, s = this.chart, p = s.renderer, b = this.doQuartiles !== !1, c = this.options.whiskerLength;
          for (let h of d) {
            let g = (C = h.graphic) ? "animate" : "attr", k = h.shapeArgs, P = {}, O = {}, z = {}, W = {}, G = h.color || this.color;
            if (h.plotY !== void 0) {
              let Y;
              F = k.width, E = (_ = k.x) + F, v = F / 2, y = b ? h.q1Plot : h.lowPlot, S = b ? h.q3Plot : h.lowPlot, u = h.highPlot, A = h.lowPlot, C || (h.graphic = C = p.g("point").add(this.group), h.stem = p.path().addClass("highcharts-boxplot-stem").add(C), c && (h.whiskers = p.path().addClass("highcharts-boxplot-whisker").add(C)), b && (h.box = p.path(m).addClass("highcharts-boxplot-box").add(C)), h.medianShape = p.path(f).addClass("highcharts-boxplot-median").add(C)), s.styledMode || (O.stroke = h.stemColor || r.stemColor || G, O["stroke-width"] = N(h.stemWidth, r.stemWidth, r.lineWidth), O.dashstyle = h.stemDashStyle || r.stemDashStyle || r.dashStyle, h.stem.attr(O), c && (z.stroke = h.whiskerColor || r.whiskerColor || G, z["stroke-width"] = N(h.whiskerWidth, r.whiskerWidth, r.lineWidth), z.dashstyle = h.whiskerDashStyle || r.whiskerDashStyle || r.dashStyle, h.whiskers.attr(z)), b && (P.fill = h.fillColor || r.fillColor || G, P.stroke = r.lineColor || G, P["stroke-width"] = r.lineWidth || 0, P.dashstyle = h.boxDashStyle || r.boxDashStyle || r.dashStyle, h.box.attr(P)), W.stroke = h.medianColor || r.medianColor || G, W["stroke-width"] = N(h.medianWidth, r.medianWidth, r.lineWidth), W.dashstyle = h.medianDashStyle || r.medianDashStyle || r.dashStyle, h.medianShape.attr(W));
              let U = I((h.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, h.stem.strokeWidth());
              if (Y = [["M", U, S], ["L", U, u], ["M", U, y], ["L", U, A]], h.stem[g]({ d: Y }), b) {
                let H = h.box.strokeWidth();
                y = I(y, H), S = I(S, H), Y = [["M", _ = I(_, H), S], ["L", _, y], ["L", E = I(E, H), y], ["L", E, S], ["L", _, S], ["Z"]], h.box[g]({ d: Y });
              }
              if (c) {
                let H = h.whiskers.strokeWidth();
                u = I(h.highPlot, H), A = I(h.lowPlot, H), Y = [["M", I(U - (w = typeof c == "string" && /%$/.test(c) ? v * parseFloat(c) / 100 : Number(c) / 2)), u], ["L", I(U + w), u], ["M", I(U - w), A], ["L", I(U + w), A]], h.whiskers[g]({ d: Y });
              }
              Y = [["M", _, M = I(h.medianPlot, h.medianShape.strokeWidth())], ["L", E, M]], h.medianShape[g]({ d: Y });
            }
          }
        }
        toYData(y) {
          return [y.low, y.q1, y.median, y.q3, y.high];
        }
      }
      return x.defaultOptions = R(n.defaultOptions, o), B(x.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: j, setStackedPoints: j }), L.registerSeriesType("boxplot", x), x;
    }), i(e, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
      return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
    }), i(e, "Series/Bubble/BubbleLegendItem.js", [e["Core/Color/Color.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { parse: D } = o, { noop: j } = l, { arrayMax: I, arrayMin: B, isNumber: R, merge: N, pick: x, stableSort: T } = L;
      return class {
        constructor(y, S) {
          this.setState = j, this.init(y, S);
        }
        init(y, S) {
          this.options = y, this.visible = !0, this.chart = S.chart, this.legend = S;
        }
        addToLegend(y) {
          y.splice(this.options.legendIndex, 0, this);
        }
        drawLegendSymbol(y) {
          let S, u = x(y.options.itemDistance, 20), A = this.legendItem || {}, M = this.options, f = M.ranges, m = M.connectorDistance;
          if (!f || !f.length || !R(f[0].value)) {
            y.options.bubbleLegend.autoRanges = !0;
            return;
          }
          T(f, function(E, v) {
            return v.value - E.value;
          }), this.ranges = f, this.setOptions(), this.render();
          let C = this.getMaxLabelSize(), F = this.ranges[0].radius, _ = 2 * F;
          S = (S = m - F + C.width) > 0 ? S : 0, this.maxLabel = C, this.movementX = M.labels.align === "left" ? S : 0, A.labelWidth = _ + S + u, A.labelHeight = _ + C.height / 2;
        }
        setOptions() {
          let y = this.ranges, S = this.options, u = this.chart.series[S.seriesIndex], A = this.legend.baseline, M = { zIndex: S.zIndex, "stroke-width": S.borderWidth }, f = { zIndex: S.zIndex, "stroke-width": S.connectorWidth }, m = { align: this.legend.options.rtl || S.labels.align === "left" ? "right" : "left", zIndex: S.zIndex }, C = u.options.marker.fillOpacity, F = this.chart.styledMode;
          y.forEach(function(_, E) {
            F || (M.stroke = x(_.borderColor, S.borderColor, u.color), M.fill = x(_.color, S.color, C !== 1 ? D(u.color).setOpacity(C).get("rgba") : u.color), f.stroke = x(_.connectorColor, S.connectorColor, u.color)), y[E].radius = this.getRangeRadius(_.value), y[E] = N(y[E], { center: y[0].radius - y[E].radius + A }), F || N(!0, y[E], { bubbleAttribs: N(M), connectorAttribs: N(f), labelAttribs: m });
          }, this);
        }
        getRangeRadius(y) {
          let S = this.options, u = this.options.seriesIndex, A = this.chart.series[u], M = S.ranges[0].value, f = S.ranges[S.ranges.length - 1].value, m = S.minSize, C = S.maxSize;
          return A.getRadius.call(this, f, M, m, C, y);
        }
        render() {
          let y = this.legendItem || {}, S = this.chart.renderer, u = this.options.zThreshold;
          for (let A of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), y.symbol = S.g("bubble-legend"), y.label = S.g("bubble-legend-item").css(this.legend.itemStyle || {}), y.symbol.translateX = 0, y.symbol.translateY = 0, y.symbol.add(y.label), y.label.add(y.group), this.ranges)) A.value >= u && this.renderRange(A);
          this.hideOverlappingLabels();
        }
        renderRange(y) {
          let S = this.ranges[0], u = this.legend, A = this.options, M = A.labels, f = this.chart, m = f.series[A.seriesIndex], C = f.renderer, F = this.symbols, _ = F.labels, E = y.center, v = Math.abs(y.radius), w = A.connectorDistance || 0, d = M.align, r = u.options.rtl, s = A.borderWidth, p = A.connectorWidth, b = S.radius || 0, c = E - v - s / 2 + p / 2, h = (c % 1 ? 1 : 0.5) - (p % 2 ? 0 : 0.5), g = C.styledMode, k = r || d === "left" ? -w : w;
          d === "center" && (k = 0, A.connectorDistance = 0, y.labelAttribs.align = "center"), F.bubbleItems.push(C.circle(b, E + h, v).attr(g ? {} : y.bubbleAttribs).addClass((g ? "highcharts-color-" + m.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (A.className || "")).add(this.legendItem.symbol)), F.connectors.push(C.path(C.crispLine([["M", b, c], ["L", b + k, c]], A.connectorWidth)).attr(g ? {} : y.connectorAttribs).addClass((g ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (A.connectorClassName || "")).add(this.legendItem.symbol));
          let P = C.text(this.formatLabel(y)).attr(g ? {} : y.labelAttribs).css(g ? {} : M.style).addClass("highcharts-bubble-legend-labels " + (A.labels.className || "")).add(this.legendItem.symbol), O = { x: b + k + A.labels.x, y: c + A.labels.y + 0.4 * P.getBBox().height };
          P.attr(O), _.push(P), P.placed = !0, P.alignAttr = O;
        }
        getMaxLabelSize() {
          let y, S;
          return this.symbols.labels.forEach(function(u) {
            S = u.getBBox(!0), y = y ? S.width > y.width ? S : y : S;
          }), y || {};
        }
        formatLabel(y) {
          let S = this.options, u = S.labels.formatter, A = S.labels.format, { numberFormatter: M } = this.chart;
          return A ? n.format(A, y) : u ? u.call(y) : M(y.value, 1);
        }
        hideOverlappingLabels() {
          let y = this.chart, S = this.options.labels.allowOverlap, u = this.symbols;
          !S && u && (y.hideOverlappingLabels(u.labels), u.labels.forEach(function(A, M) {
            A.newOpacity ? A.newOpacity !== A.oldOpacity && u.connectors[M].show() : u.connectors[M].hide();
          }));
        }
        getRanges() {
          let y = this.legend.bubbleLegend, S = y.chart.series, u = y.options.ranges, A, M, f = Number.MAX_VALUE, m = -Number.MAX_VALUE;
          return S.forEach(function(C) {
            C.isBubble && !C.ignoreSeries && (M = C.zData.filter(R)).length && (f = x(C.options.zMin, Math.min(f, Math.max(B(M), C.options.displayNegative === !1 ? C.options.zThreshold : -Number.MAX_VALUE))), m = x(C.options.zMax, Math.max(m, I(M))));
          }), A = f === m ? [{ value: m }] : [{ value: f }, { value: (f + m) / 2 }, { value: m, autoRanges: !0 }], u.length && u[0].radius && A.reverse(), A.forEach(function(C, F) {
            u && u[F] && (A[F] = N(u[F], C));
          }), A;
        }
        predictBubbleSizes() {
          let y = this.chart, S = y.legend.options, u = S.floating, A = S.layout === "horizontal", M = A ? y.legend.lastLineHeight : 0, f = y.plotSizeX, m = y.plotSizeY, C = y.series[this.options.seriesIndex], F = C.getPxExtremes(), _ = Math.ceil(F.minPxSize), E = Math.ceil(F.maxPxSize), v = Math.min(m, f), w, d = C.options.maxSize;
          return u || !/%$/.test(d) ? w = E : (w = (v + M) * (d = parseFloat(d)) / 100 / (d / 100 + 1), (A && m - w >= f || !A && f - w >= m) && (w = E)), [_, Math.ceil(w)];
        }
        updateRanges(y, S) {
          let u = this.legend.options.bubbleLegend;
          u.minSize = y, u.maxSize = S, u.ranges = this.getRanges();
        }
        correctSizes() {
          let y = this.legend, S = this.chart.series[this.options.seriesIndex].getPxExtremes();
          Math.abs(Math.ceil(S.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, S.maxPxSize), y.render());
        }
      };
    }), i(e, "Series/Bubble/BubbleLegendComposition.js", [e["Series/Bubble/BubbleLegendDefaults.js"], e["Series/Bubble/BubbleLegendItem.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { setOptions: j } = l, { composed: I } = L, { addEvent: B, objectEach: R, pushUnique: N, wrap: x } = D;
      function T(f, m, C) {
        let F, _, E, v = this.legend, w = y(this) >= 0;
        v && v.options.enabled && v.bubbleLegend && v.options.bubbleLegend.autoRanges && w ? (F = v.bubbleLegend.options, _ = v.bubbleLegend.predictBubbleSizes(), v.bubbleLegend.updateRanges(_[0], _[1]), F.placed || (v.group.placed = !1, v.allItems.forEach((d) => {
          (E = d.legendItem || {}).group && (E.group.translateY = void 0);
        })), v.render(), F.placed || (this.getMargins(), this.axes.forEach(function(d) {
          d.visible && d.render(), F.placed || (d.setScale(), d.updateNames(), R(d.ticks, function(r) {
            r.isNew = !0, r.isNewLabel = !0;
          }));
        }), this.getMargins()), F.placed = !0, f.call(this, m, C), v.bubbleLegend.correctSizes(), M(v, S(v))) : (f.call(this, m, C), v && v.options.enabled && v.bubbleLegend && (v.render(), M(v, S(v))));
      }
      function y(f) {
        let m = f.series, C = 0;
        for (; C < m.length; ) {
          if (m[C] && m[C].isBubble && m[C].visible && m[C].zData.length) return C;
          C++;
        }
        return -1;
      }
      function S(f) {
        let m = f.allItems, C = [], F = m.length, _, E, v, w = 0, d = 0;
        for (w = 0; w < F; w++) if (E = m[w].legendItem || {}, v = (m[w + 1] || {}).legendItem || {}, E.labelHeight && (m[w].itemHeight = E.labelHeight), m[w] === m[F - 1] || E.y !== v.y) {
          for (C.push({ height: 0 }), _ = C[C.length - 1]; d <= w; d++) m[d].itemHeight > _.height && (_.height = m[d].itemHeight);
          _.step = w;
        }
        return C;
      }
      function u(f) {
        let m = this.bubbleLegend, C = this.options, F = C.bubbleLegend, _ = y(this.chart);
        m && m.ranges && m.ranges.length && (F.ranges.length && (F.autoRanges = !!F.ranges[0].autoRanges), this.destroyItem(m)), _ >= 0 && C.enabled && F.enabled && (F.seriesIndex = _, this.bubbleLegend = new n(F, this), this.bubbleLegend.addToLegend(f.allItems));
      }
      function A(f) {
        let m;
        if (f.defaultPrevented) return !1;
        let C = f.legendItem, F = this.chart, _ = C.visible;
        this && this.bubbleLegend && (C.visible = !_, C.ignoreSeries = _, m = y(F) >= 0, this.bubbleLegend.visible !== m && (this.update({ bubbleLegend: { enabled: m } }), this.bubbleLegend.visible = m), C.visible = _);
      }
      function M(f, m) {
        let C = f.allItems, F = f.options.rtl, _, E, v, w, d = 0;
        C.forEach((r, s) => {
          (w = r.legendItem || {}).group && (_ = w.group.translateX || 0, E = w.y || 0, ((v = r.movementX) || F && r.ranges) && (v = F ? _ - r.options.maxSize / 2 : _ + v, w.group.attr({ translateX: v })), s > m[d].step && d++, w.group.attr({ translateY: Math.round(E + m[d].height / 2) }), w.y = E + m[d].height / 2);
        });
      }
      return { compose: function(f, m) {
        N(I, "Series.BubbleLegend") && (j({ legend: { bubbleLegend: o } }), x(f.prototype, "drawChartBox", T), B(m, "afterGetAllItems", u), B(m, "itemClick", A));
      } };
    }), i(e, "Series/Bubble/BubblePoint.js", [e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { seriesTypes: { scatter: { prototype: { pointClass: L } } } } = n, { extend: D } = l;
      class j extends L {
        haloPath(B) {
          let R = (B && this.marker && this.marker.radius || 0) + B;
          if (this.series.chart.inverted) {
            let N = this.pos() || [0, 0], { xAxis: x, yAxis: T, chart: y } = this.series;
            return y.renderer.symbols.circle(x.len - N[1] - R, T.len - N[0] - R, 2 * R, 2 * R);
          }
          return o.prototype.haloPath.call(this, R);
        }
      }
      return D(j.prototype, { ttBelow: !1 }), j;
    }), i(e, "Series/Bubble/BubbleSeries.js", [e["Series/Bubble/BubbleLegendComposition.js"], e["Series/Bubble/BubblePoint.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { parse: I } = l, { composed: B, noop: R } = L, { series: N, seriesTypes: { column: { prototype: x }, scatter: T } } = D, { addEvent: y, arrayMax: S, arrayMin: u, clamp: A, extend: M, isNumber: f, merge: m, pick: C, pushUnique: F } = j;
      function _() {
        let v = this.len, { coll: w, isXAxis: d, min: r } = this, s = d ? "xData" : "yData", p = (this.max || 0) - (r || 0), b = 0, c = v, h = v / p, g;
        (w === "xAxis" || w === "yAxis") && (this.series.forEach((k) => {
          if (k.bubblePadding && k.reserveSpace()) {
            this.allowZoomOutside = !0, g = !0;
            let P = k[s];
            if (d && ((k.onPoint || k).getRadii(0, 0, k), k.onPoint && (k.radii = k.onPoint.radii)), p > 0) {
              let O = P.length;
              for (; O--; ) if (f(P[O]) && this.dataMin <= P[O] && P[O] <= this.max) {
                let z = k.radii && k.radii[O] || 0;
                b = Math.min((P[O] - r) * h - z, b), c = Math.max((P[O] - r) * h + z, c);
              }
            }
          }
        }), g && p > 0 && !this.logarithmic && (c -= v, h *= (v + Math.max(0, b) - Math.min(c, v)) / v, [["min", "userMin", b], ["max", "userMax", c]].forEach((k) => {
          C(this.options[k[0]], this[k[1]]) === void 0 && (this[k[0]] += k[2] / h);
        })));
      }
      class E extends T {
        static compose(w, d, r) {
          o.compose(d, r), F(B, "Series.Bubble") && y(w, "foundExtremes", _);
        }
        animate(w) {
          !w && this.points.length < this.options.animationLimit && this.points.forEach(function(d) {
            let { graphic: r, plotX: s = 0, plotY: p = 0 } = d;
            r && r.width && (this.hasRendered || r.attr({ x: s, y: p, width: 1, height: 1 }), r.animate(this.markerAttribs(d), this.options.animation));
          }, this);
        }
        getRadii() {
          let w = this.zData, d = this.yData, r = [], s, p, b, c = this.chart.bubbleZExtremes, { minPxSize: h, maxPxSize: g } = this.getPxExtremes();
          if (!c) {
            let k, P = Number.MAX_VALUE, O = -Number.MAX_VALUE;
            this.chart.series.forEach((z) => {
              if (z.bubblePadding && z.reserveSpace()) {
                let W = (z.onPoint || z).getZExtremes();
                W && (P = Math.min(C(P, W.zMin), W.zMin), O = Math.max(C(O, W.zMax), W.zMax), k = !0);
              }
            }), k ? (c = { zMin: P, zMax: O }, this.chart.bubbleZExtremes = c) : c = { zMin: 0, zMax: 0 };
          }
          for (p = 0, s = w.length; p < s; p++) b = w[p], r.push(this.getRadius(c.zMin, c.zMax, h, g, b, d && d[p]));
          this.radii = r;
        }
        getRadius(w, d, r, s, p, b) {
          let c = this.options, h = c.sizeBy !== "width", g = c.zThreshold, k = d - w, P = 0.5;
          if (b === null || p === null) return null;
          if (f(p)) {
            if (c.sizeByAbsoluteValue && (p = Math.abs(p - g), d = k = Math.max(d - g, Math.abs(w - g)), w = 0), p < w) return r / 2 - 1;
            k > 0 && (P = (p - w) / k);
          }
          return h && P >= 0 && (P = Math.sqrt(P)), Math.ceil(r + P * (s - r)) / 2;
        }
        hasData() {
          return !!this.processedXData.length;
        }
        markerAttribs(w, d) {
          let r = super.markerAttribs(w, d), { height: s = 0, width: p = 0 } = r;
          return this.chart.inverted ? M(r, { x: (w.plotX || 0) - p / 2, y: (w.plotY || 0) - s / 2 }) : r;
        }
        pointAttribs(w, d) {
          let r = this.options.marker.fillOpacity, s = N.prototype.pointAttribs.call(this, w, d);
          return r !== 1 && (s.fill = I(s.fill).setOpacity(r).get("rgba")), s;
        }
        translate() {
          super.translate.call(this), this.getRadii(), this.translateBubble();
        }
        translateBubble() {
          let { data: w, options: d, radii: r } = this, { minPxSize: s } = this.getPxExtremes(), p = w.length;
          for (; p--; ) {
            let b = w[p], c = r ? r[p] : 0;
            this.zoneAxis === "z" && (b.negative = (b.z || 0) < (d.zThreshold || 0)), f(c) && c >= s / 2 ? (b.marker = M(b.marker, { radius: c, width: 2 * c, height: 2 * c }), b.dlBox = { x: b.plotX - c, y: b.plotY - c, width: 2 * c, height: 2 * c }) : (b.shapeArgs = b.plotY = b.dlBox = void 0, b.isInside = !1);
          }
        }
        getPxExtremes() {
          let w = Math.min(this.chart.plotWidth, this.chart.plotHeight), d = (p) => {
            let b;
            return typeof p == "string" && (b = /%$/.test(p), p = parseInt(p, 10)), b ? w * p / 100 : p;
          }, r = d(C(this.options.minSize, 8)), s = Math.max(d(C(this.options.maxSize, "20%")), r);
          return { minPxSize: r, maxPxSize: s };
        }
        getZExtremes() {
          let w = this.options, d = (this.zData || []).filter(f);
          if (d.length) {
            let r = C(w.zMin, A(u(d), w.displayNegative === !1 ? w.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), s = C(w.zMax, S(d));
            if (f(r) && f(s)) return { zMin: r, zMax: s };
          }
        }
      }
      return E.defaultOptions = m(T.defaultOptions, { dataLabels: { formatter: function() {
        let { numberFormatter: v } = this.series.chart, { z: w } = this.point;
        return f(w) ? v(w, -1) : "";
      }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), M(E.prototype, { alignDataLabel: x.alignDataLabel, applyZones: R, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: n, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), y(E, "updatedData", (v) => {
        delete v.target.chart.bubbleZExtremes;
      }), y(E, "remove", (v) => {
        delete v.target.chart.bubbleZExtremes;
      }), D.registerSeriesType("bubble", E), E;
    }), i(e, "Series/ColumnRange/ColumnRangePoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { seriesTypes: { column: { prototype: { pointClass: { prototype: l } } }, arearange: { prototype: { pointClass: L } } } } = o, { extend: D, isNumber: j } = n;
      class I extends L {
        isValid() {
          return j(this.low);
        }
      }
      return D(I.prototype, { setState: l.setState }), I;
    }), i(e, "Series/ColumnRange/ColumnRangeSeries.js", [e["Series/ColumnRange/ColumnRangePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { noop: D } = n, { seriesTypes: { arearange: j, column: I, column: { prototype: B } } } = l, { addEvent: R, clamp: N, extend: x, isNumber: T, merge: y, pick: S } = L;
      class u extends j {
        setOptions() {
          return y(!0, arguments[0], { stacking: void 0 }), j.prototype.setOptions.apply(this, arguments);
        }
        translate() {
          return B.translate.apply(this);
        }
        pointAttribs() {
          return B.pointAttribs.apply(this, arguments);
        }
        translate3dPoints() {
          return B.translate3dPoints.apply(this, arguments);
        }
        translate3dShapes() {
          return B.translate3dShapes.apply(this, arguments);
        }
        afterColumnTranslate() {
          let M, f, m, C, F = this.yAxis, _ = this.xAxis, E = _.startAngleRad, v = this.chart, w = this.xAxis.isRadial, d = Math.max(v.chartWidth, v.chartHeight) + 999;
          this.points.forEach((r) => {
            let s = r.shapeArgs || {}, p = this.options.minPointLength, b = r.plotY, c = F.translate(r.high, 0, 1, 0, 1);
            if (T(c) && T(b))
              if (r.plotHigh = N(c, -d, d), r.plotLow = N(b, -d, d), C = r.plotHigh, Math.abs(M = S(r.rectPlotY, r.plotY) - r.plotHigh) < p ? (f = p - M, M += f, C -= f / 2) : M < 0 && (M *= -1, C -= M), w && this.polar) m = r.barX + E, r.shapeType = "arc", r.shapeArgs = this.polar.arc(C + M, C, m, m + r.pointWidth);
              else {
                s.height = M, s.y = C;
                let { x: h = 0, width: g = 0 } = s;
                r.shapeArgs = y(r.shapeArgs, this.crispCol(h, C, g, M)), r.tooltipPos = v.inverted ? [F.len + F.pos - v.plotLeft - C - M / 2, _.len + _.pos - v.plotTop - h - g / 2, M] : [_.left - v.plotLeft + h + g / 2, F.pos - v.plotTop + C + M / 2, M];
              }
          });
        }
      }
      return u.defaultOptions = y(I.defaultOptions, j.defaultOptions, { borderRadius: { where: "all" }, pointRange: null, legendSymbol: "rectangle", marker: null, states: { hover: { halo: !1 } } }), R(u, "afterColumnTranslate", function() {
        u.prototype.afterColumnTranslate.apply(this);
      }, { order: 5 }), x(u.prototype, { directTouch: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: B.adjustForMissingColumns, animate: B.animate, crispCol: B.crispCol, drawGraph: D, drawPoints: B.drawPoints, getSymbol: D, drawTracker: B.drawTracker, getColumnMetrics: B.getColumnMetrics }), l.registerSeriesType("columnrange", u), u;
    }), i(e, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
      return {};
    }), i(e, "Series/ColumnPyramid/ColumnPyramidSeries.js", [e["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { column: L } = n.seriesTypes, { clamp: D, merge: j, pick: I } = l;
      class B extends L {
        translate() {
          let N = this.chart, x = this.options, T = this.dense = this.closestPointRange * this.xAxis.transA < 2, y = this.borderWidth = I(x.borderWidth, T ? 0 : 1), S = this.yAxis, u = x.threshold, A = I(x.minPointLength, 5), M = this.getColumnMetrics(), f = M.width, m = this.pointXOffset = M.offset, C = this.translatedThreshold = S.getThreshold(u), F = this.barW = Math.max(f, 1 + 2 * y);
          for (let _ of (N.inverted && (C -= 0.5), x.pointPadding && (F = Math.ceil(F)), super.translate(), this.points)) {
            let E = I(_.yBottom, C), v = 999 + Math.abs(E), w = D(_.plotY, -v, S.len + v), d = F / 2, r = Math.min(w, E), s = Math.max(w, E) - r, p = _.plotX + m, b, c, h, g, k, P, O, z, W, G, Y;
            x.centerInCategory && (p = this.adjustForMissingColumns(p, f, _, M)), _.barX = p, _.pointWidth = f, _.tooltipPos = N.inverted ? [S.len + S.pos - N.plotLeft - w, this.xAxis.len - p - d, s] : [p + d, w + S.pos - N.plotTop, s], b = u + (_.total || _.y), x.stacking === "percent" && (b = u + (_.y < 0) ? -100 : 100);
            let U = S.toPixels(b, !0);
            h = (c = N.plotHeight - U - (N.plotHeight - C)) ? d * (r - U) / c : 0, g = c ? d * (r + s - U) / c : 0, P = p - h + d, O = p + h + d, z = p + g + d, W = p - g + d, G = r - A, Y = r + s, _.y < 0 && (G = r, Y = r + s + A), N.inverted && (k = S.width - r, c = U - (S.width - C), h = d * (U - k) / c, g = d * (U - (k - s)) / c, O = (P = p + d + h) - 2 * h, z = p - g + d, W = p + g + d, G = r, Y = r + s - A, _.y < 0 && (Y = r + s + A)), _.shapeType = "path", _.shapeArgs = { x: P, y: G, width: O - P, height: s, d: [["M", P, G], ["L", O, G], ["L", z, Y], ["L", W, Y], ["Z"]] };
          }
        }
      }
      return B.defaultOptions = j(L.defaultOptions, o), n.registerSeriesType("columnpyramid", B), B;
    }), i(e, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
      return { color: "#000000", grouping: !1, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
    }), i(e, "Series/ErrorBar/ErrorBarSeries.js", [e["Series/BoxPlot/BoxPlotSeries.js"], e["Series/Column/ColumnSeries.js"], e["Series/ErrorBar/ErrorBarSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { arearange: j } = L.seriesTypes, { addEvent: I, merge: B, extend: R } = D;
      class N extends o {
        getColumnMetrics() {
          return this.linkedParent && this.linkedParent.columnMetrics || n.prototype.getColumnMetrics.call(this);
        }
        drawDataLabels() {
          let T = this.pointValKey;
          if (j) for (let y of (j.prototype.drawDataLabels.call(this), this.points)) y.y = y[T];
        }
        toYData(T) {
          return [T.low, T.high];
        }
      }
      return N.defaultOptions = B(o.defaultOptions, l), I(N, "afterTranslate", function() {
        for (let x of this.points) x.plotLow = x.plotY;
      }, { order: 0 }), R(N.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: !1 }), L.registerSeriesType("errorbar", N), N;
    }), i(e, "Series/Gauge/GaugePoint.js", [e["Core/Series/SeriesRegistry.js"]], function(o) {
      let { series: { prototype: { pointClass: n } } } = o;
      return class extends n {
        setState(l) {
          this.state = l;
        }
      };
    }), i(e, "Series/Gauge/GaugeSeries.js", [e["Series/Gauge/GaugePoint.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { noop: D } = n, { series: j, seriesTypes: { column: I } } = l, { clamp: B, isNumber: R, extend: N, merge: x, pick: T, pInt: y, defined: S } = L;
      class u extends j {
        translate() {
          let M = this.yAxis, f = this.options, m = M.center;
          this.generatePoints(), this.points.forEach((C) => {
            let F = x(f.dial, C.dial), _ = y(F.radius) * m[2] / 200, E = y(F.baseLength) * _ / 100, v = y(F.rearLength) * _ / 100, w = F.baseWidth, d = F.topWidth, r = f.overshoot, s = M.startAngleRad + M.translate(C.y, void 0, void 0, void 0, !0);
            (R(r) || f.wrap === !1) && (r = R(r) ? r / 180 * Math.PI : 0, s = B(s, M.startAngleRad - r, M.endAngleRad + r)), s = 180 * s / Math.PI, C.shapeType = "path";
            let p = F.path || [["M", -v, -w / 2], ["L", E, -w / 2], ["L", _, -d / 2], ["L", _, d / 2], ["L", E, w / 2], ["L", -v, w / 2], ["Z"]];
            C.shapeArgs = { d: p, translateX: m[0], translateY: m[1], rotation: s }, C.plotX = m[0], C.plotY = m[1], S(C.y) && M.max - M.min && (C.percentage = (C.y - M.min) / (M.max - M.min) * 100);
          });
        }
        drawPoints() {
          let M = this, f = M.chart, m = M.yAxis.center, C = M.pivot, F = M.options, _ = F.pivot, E = f.renderer;
          M.points.forEach((v) => {
            let w = v.graphic, d = v.shapeArgs, r = d.d, s = x(F.dial, v.dial);
            w ? (w.animate(d), d.d = r) : v.graphic = E[v.shapeType](d).addClass("highcharts-dial").add(M.group), f.styledMode || v.graphic[w ? "animate" : "attr"]({ stroke: s.borderColor, "stroke-width": s.borderWidth, fill: s.backgroundColor });
          }), C ? C.animate({ translateX: m[0], translateY: m[1] }) : _ && (M.pivot = E.circle(0, 0, _.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(m[0], m[1]).add(M.group), f.styledMode || M.pivot.attr({ fill: _.backgroundColor, stroke: _.borderColor, "stroke-width": _.borderWidth }));
        }
        animate(M) {
          let f = this;
          M || f.points.forEach((m) => {
            let C = m.graphic;
            C && (C.attr({ rotation: 180 * f.yAxis.startAngleRad / Math.PI }), C.animate({ rotation: m.shapeArgs.rotation }, f.options.animation));
          });
        }
        render() {
          this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), j.prototype.render.call(this), this.group.clip(this.chart.clipRect);
        }
        setData(M, f) {
          j.prototype.setData.call(this, M, !1), this.processData(), this.generatePoints(), T(f, !0) && this.chart.redraw();
        }
        hasData() {
          return !!this.points.length;
        }
      }
      return u.defaultOptions = x(j.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: !1, defer: !1, enabled: !0, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: !1 }), N(u.prototype, { angular: !0, directTouch: !0, drawGraph: D, drawTracker: I.prototype.drawTracker, fixedBox: !0, forceDL: !0, noSharedTooltip: !0, pointClass: o, trackerGroups: ["group", "dataLabelsGroup"] }), l.registerSeriesType("gauge", u), u;
    }), i(e, "Series/DragNodesComposition.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { composed: l } = o, { addEvent: L, pushUnique: D } = n;
      function j() {
        let I, B, R, N = this;
        N.container && (I = L(N.container, "mousedown", (x) => {
          let T = N.hoverPoint;
          T && T.series && T.series.hasDraggableNodes && T.series.options.draggable && (T.series.onMouseDown(T, x), B = L(N.container, "mousemove", (y) => T && T.series && T.series.onMouseMove(T, y)), R = L(N.container.ownerDocument, "mouseup", (y) => (B(), R(), T && T.series && T.series.onMouseUp(T, y))));
        })), L(N, "destroy", function() {
          I();
        });
      }
      return { compose: function(I) {
        D(l, "DragNodes") && L(I, "load", j);
      }, onMouseDown: function(I, B) {
        var N;
        let R = ((N = this.chart.pointer) == null ? void 0 : N.normalize(B)) || B;
        I.fixedPosition = { chartX: R.chartX, chartY: R.chartY, plotX: I.plotX, plotY: I.plotY }, I.inDragMode = !0;
      }, onMouseMove: function(I, B) {
        var R;
        if (I.fixedPosition && I.inDragMode) {
          let N, x, T = this.chart, y = ((R = T.pointer) == null ? void 0 : R.normalize(B)) || B, S = I.fixedPosition.chartX - y.chartX, u = I.fixedPosition.chartY - y.chartY, A = T.graphLayoutsLookup;
          (Math.abs(S) > 5 || Math.abs(u) > 5) && (N = I.fixedPosition.plotX - S, x = I.fixedPosition.plotY - u, T.isInsidePlot(N, x) && (I.plotX = N, I.plotY = x, I.hasDragged = !0, this.redrawHalo(I), A.forEach((M) => {
            M.restartSimulation();
          })));
        }
      }, onMouseUp: function(I) {
        I.fixedPosition && (I.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), I.inDragMode = I.hasDragged = !1, this.options.fixedDraggable || delete I.fixedPosition);
      }, redrawHalo: function(I) {
        I && this.halo && this.halo.attr({ d: I.haloPath(this.options.states.hover.halo.size) });
      } };
    }), i(e, "Series/GraphLayoutComposition.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { setAnimation: L } = o, { composed: D } = n, { addEvent: j, pushUnique: I } = l;
      function B() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((T) => {
          T.updateSimulation();
        }), this.redraw());
      }
      function R() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((T) => {
          T.updateSimulation(!1);
        }), this.redraw());
      }
      function N() {
        this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((T) => {
          T.stop();
        });
      }
      function x() {
        let T, y = !1, S = (u) => {
          u.maxIterations-- && isFinite(u.temperature) && !u.isStable() && !u.enableSimulation && (u.beforeStep && u.beforeStep(), u.step(), T = !1, y = !0);
        };
        if (this.graphLayoutsLookup) {
          for (L(!1, this), this.graphLayoutsLookup.forEach((u) => u.start()); !T; ) T = !0, this.graphLayoutsLookup.forEach(S);
          y && this.series.forEach((u) => {
            u && u.layout && u.render();
          });
        }
      }
      return { compose: function(T) {
        I(D, "GraphLayout") && (j(T, "afterPrint", B), j(T, "beforePrint", R), j(T, "predraw", N), j(T, "render", x));
      }, integrations: {}, layouts: {} };
    }), i(e, "Series/PackedBubble/PackedBubblePoint.js", [e["Core/Chart/Chart.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"]], function(o, n, l) {
      let { seriesTypes: { bubble: { prototype: { pointClass: L } } } } = l;
      return class extends L {
        destroy() {
          var D;
          return (D = this.series) != null && D.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), n.prototype.destroy.apply(this, arguments);
        }
        firePointEvent() {
          let D = this.series.options;
          if (this.isParentNode && D.parentNode) {
            let j = D.allowPointSelect;
            D.allowPointSelect = D.parentNode.allowPointSelect, n.prototype.firePointEvent.apply(this, arguments), D.allowPointSelect = j;
          } else n.prototype.firePointEvent.apply(this, arguments);
        }
        select() {
          let D = this.series.chart;
          this.isParentNode ? (D.getSelectedPoints = D.getSelectedParentNodes, n.prototype.select.apply(this, arguments), D.getSelectedPoints = o.prototype.getSelectedPoints) : n.prototype.select.apply(this, arguments);
        }
      };
    }), i(e, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [e["Core/Utilities.js"]], function(o) {
      let { isNumber: n } = o;
      return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: !1, tooltip: { pointFormat: "Value: {point.value}" }, draggable: !0, useSimulation: !0, parentNode: { allowPointSelect: !1 }, dataLabels: { formatter: function() {
        let { numberFormatter: l } = this.series.chart, { value: L } = this.point;
        return n(L) ? l(L, -1) : "";
      }, parentNodeFormatter: function() {
        return this.name;
      }, parentNodeTextPath: { enabled: !0 }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: !1, seriesInteraction: !0, dragBetweenSeries: !1, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: !0, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: !0, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: !1, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
    }), i(e, "Series/Networkgraph/VerletIntegration.js", [], function() {
      return { attractive: function(o, n, l) {
        let L = o.getMass(), D = -l.x * n * this.diffTemperature, j = -l.y * n * this.diffTemperature;
        o.fromNode.fixedPosition || (o.fromNode.plotX -= D * L.fromNode / o.fromNode.degree, o.fromNode.plotY -= j * L.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.plotX += D * L.toNode / o.toNode.degree, o.toNode.plotY += j * L.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, n) {
        return (n - o) / o;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant || 0, n = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * o, l = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * o;
        this.nodes.forEach(function(L) {
          L.fixedPosition || (L.plotX -= n / L.mass / L.degree, L.plotY -= l / L.mass / L.degree);
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.5);
      }, integrate: function(o, n) {
        let l = -o.options.friction, L = o.options.maxSpeed, D = n.prevX, j = n.prevY, I = (n.plotX + n.dispX - D) * l, B = (n.plotY + n.dispY - j) * l, R = Math.abs, N = R(I) / (I || 1), x = R(B) / (B || 1), T = N * Math.min(L, Math.abs(I)), y = x * Math.min(L, Math.abs(B));
        n.prevX = n.plotX + n.dispX, n.prevY = n.plotY + n.dispY, n.plotX += T, n.plotY += y, n.temperature = o.vectorLength({ x: T, y });
      }, repulsive: function(o, n, l) {
        let L = n * this.diffTemperature / o.mass / o.degree;
        o.fixedPosition || (o.plotX += l.x * L, o.plotY += l.y * L);
      }, repulsiveForceFunction: function(o, n) {
        return (n - o) / o * (n > o ? 1 : 0);
      } };
    }), i(e, "Series/PackedBubble/PackedBubbleIntegration.js", [e["Core/Globals.js"], e["Series/Networkgraph/VerletIntegration.js"]], function(o, n) {
      let { noop: l } = o;
      return { barycenter: function() {
        let L, D, j = this.options.gravitationalConstant, I = this.box, B = this.nodes;
        for (let R of B) this.options.splitSeries && !R.isParentNode ? (L = R.series.parentNode.plotX, D = R.series.parentNode.plotY) : (L = I.width / 2, D = I.height / 2), R.fixedPosition || (R.plotX -= (R.plotX - L) * j / (R.mass * Math.sqrt(B.length)), R.plotY -= (R.plotY - D) * j / (R.mass * Math.sqrt(B.length)));
      }, getK: l, integrate: n.integrate, repulsive: function(L, D, j, I) {
        let B = D * this.diffTemperature / L.mass / L.degree, R = j.x * B, N = j.y * B;
        L.fixedPosition || (L.plotX += R, L.plotY += N), I.fixedPosition || (I.plotX -= R, I.plotY -= N);
      }, repulsiveForceFunction: function(L, D, j, I) {
        return Math.min(L, (j.marker.radius + I.marker.radius) / 2);
      } };
    }), i(e, "Series/Networkgraph/EulerIntegration.js", [], function() {
      return { attractive: function(o, n, l, L) {
        let D = o.getMass(), j = l.x / L * n, I = l.y / L * n;
        o.fromNode.fixedPosition || (o.fromNode.dispX -= j * D.fromNode / o.fromNode.degree, o.fromNode.dispY -= I * D.fromNode / o.fromNode.degree), o.toNode.fixedPosition || (o.toNode.dispX += j * D.toNode / o.toNode.degree, o.toNode.dispY += I * D.toNode / o.toNode.degree);
      }, attractiveForceFunction: function(o, n) {
        return o * o / n;
      }, barycenter: function() {
        let o = this.options.gravitationalConstant, n = this.barycenter.xFactor, l = this.barycenter.yFactor;
        this.nodes.forEach(function(L) {
          if (!L.fixedPosition) {
            let D = L.getDegree(), j = D * (1 + D / 2);
            L.dispX += (n - L.plotX) * o * j / L.degree, L.dispY += (l - L.plotY) * o * j / L.degree;
          }
        });
      }, getK: function(o) {
        return Math.pow(o.box.width * o.box.height / o.nodes.length, 0.3);
      }, integrate: function(o, n) {
        n.dispX += n.dispX * o.options.friction, n.dispY += n.dispY * o.options.friction;
        let l = n.temperature = o.vectorLength({ x: n.dispX, y: n.dispY });
        l !== 0 && (n.plotX += n.dispX / l * Math.min(Math.abs(n.dispX), o.temperature), n.plotY += n.dispY / l * Math.min(Math.abs(n.dispY), o.temperature));
      }, repulsive: function(o, n, l, L) {
        o.dispX += l.x / L * n / o.degree, o.dispY += l.y / L * n / o.degree;
      }, repulsiveForceFunction: function(o, n) {
        return n * n / o;
      } };
    }), i(e, "Series/Networkgraph/QuadTreeNode.js", [], function() {
      class o {
        constructor(l) {
          this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = l, this.boxSize = Math.min(l.width, l.height);
        }
        divideBox() {
          let l = this.box.width / 2, L = this.box.height / 2;
          this.nodes[0] = new o({ left: this.box.left, top: this.box.top, width: l, height: L }), this.nodes[1] = new o({ left: this.box.left + l, top: this.box.top, width: l, height: L }), this.nodes[2] = new o({ left: this.box.left + l, top: this.box.top + L, width: l, height: L }), this.nodes[3] = new o({ left: this.box.left, top: this.box.top + L, width: l, height: L });
        }
        getBoxPosition(l) {
          let L = l.plotX < this.box.left + this.box.width / 2, D = l.plotY < this.box.top + this.box.height / 2;
          return L ? D ? 0 : 3 : D ? 1 : 2;
        }
        insert(l, L) {
          let D;
          this.isInternal ? this.nodes[this.getBoxPosition(l)].insert(l, L - 1) : (this.isEmpty = !1, this.body ? L ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, L - 1), this.body = !0), this.nodes[this.getBoxPosition(l)].insert(l, L - 1)) : ((D = new o({ top: l.plotX || NaN, left: l.plotY || NaN, width: 0.1, height: 0.1 })).body = l, D.isInternal = !1, this.nodes.push(D)) : (this.isInternal = !1, this.body = l));
        }
        updateMassAndCenter() {
          let l = 0, L = 0, D = 0;
          if (this.isInternal) {
            for (let j of this.nodes) j.isEmpty || (l += j.mass, L += j.plotX * j.mass, D += j.plotY * j.mass);
            L /= l, D /= l;
          } else this.body && (l = this.body.mass, L = this.body.plotX, D = this.body.plotY);
          this.mass = l, this.plotX = L, this.plotY = D;
        }
      }
      return o;
    }), i(e, "Series/Networkgraph/QuadTree.js", [e["Series/Networkgraph/QuadTreeNode.js"]], function(o) {
      return class {
        constructor(n, l, L, D) {
          this.box = { left: n, top: l, width: L, height: D }, this.maxDepth = 25, this.root = new o(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
        }
        calculateMassAndCenter() {
          this.visitNodeRecursive(null, null, function(n) {
            n.updateMassAndCenter();
          });
        }
        insertNodes(n) {
          for (let l of n) this.root.insert(l, this.maxDepth);
        }
        visitNodeRecursive(n, l, L) {
          let D;
          if (n || (n = this.root), n === this.root && l && (D = l(n)), D !== !1) {
            for (let j of n.nodes) {
              if (j.isInternal) {
                if (l && (D = l(j)), D === !1) continue;
                this.visitNodeRecursive(j, l, L);
              } else j.body && l && l(j.body);
              L && L(j);
            }
            n === this.root && L && L(n);
          }
        }
      };
    }), i(e, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [e["Series/Networkgraph/EulerIntegration.js"], e["Core/Globals.js"], e["Series/GraphLayoutComposition.js"], e["Series/Networkgraph/QuadTree.js"], e["Core/Utilities.js"], e["Series/Networkgraph/VerletIntegration.js"]], function(o, n, l, L, D, j) {
      let { win: I } = n, { clamp: B, defined: R, isFunction: N, fireEvent: x, pick: T } = D;
      class y {
        constructor() {
          this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
        }
        static compose(u) {
          l.compose(u), l.integrations.euler = o, l.integrations.verlet = j, l.layouts["reingold-fruchterman"] = y;
        }
        init(u) {
          this.options = u, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(!0), this.integration = l.integrations[u.integration], this.enableSimulation = u.enableSimulation, this.attractiveForce = T(u.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = T(u.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = u.approximation;
        }
        updateSimulation(u) {
          this.enableSimulation = T(u, this.options.enableSimulation);
        }
        start() {
          let u = this.series, A = this.options;
          this.currentStep = 0, this.forces = u[0] && u[0].forces || [], this.chart = u[0] && u[0].chart, this.initialRendering && (this.initPositions(), u.forEach(function(M) {
            M.finishedAnimating = !0, M.render();
          })), this.setK(), this.resetSimulation(A), this.enableSimulation && this.step();
        }
        step() {
          let u = this.series;
          for (let A of (this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || [])) this[A + "Forces"](this.temperature);
          if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
            for (let A of u) A.chart && A.render();
            this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && I.cancelAnimationFrame(this.simulation), this.simulation = I.requestAnimationFrame(() => this.step())) : (this.simulation = !1, this.series.forEach((A) => {
              x(A, "afterSimulation");
            }));
          }
        }
        stop() {
          this.simulation && I.cancelAnimationFrame(this.simulation);
        }
        setArea(u, A, M, f) {
          this.box = { left: u, top: A, width: M, height: f };
        }
        setK() {
          this.k = this.options.linkLength || this.integration.getK(this);
        }
        addElementsToCollection(u, A) {
          for (let M of u) A.indexOf(M) === -1 && A.push(M);
        }
        removeElementFromCollection(u, A) {
          let M = A.indexOf(u);
          M !== -1 && A.splice(M, 1);
        }
        clear() {
          this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
        }
        resetSimulation() {
          this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
        }
        restartSimulation() {
          this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
        }
        setMaxIterations(u) {
          this.maxIterations = T(u, this.options.maxIterations);
        }
        setTemperature() {
          this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
        }
        setDiffTemperature() {
          this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
        }
        setInitialRendering(u) {
          this.initialRendering = u;
        }
        createQuadTree() {
          this.quadTree = new L(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
        }
        initPositions() {
          let u = this.options.initialPositions;
          if (N(u)) for (let A of (u.call(this), this.nodes)) R(A.prevX) || (A.prevX = A.plotX), R(A.prevY) || (A.prevY = A.plotY), A.dispX = 0, A.dispY = 0;
          else u === "circle" ? this.setCircularPositions() : this.setRandomPositions();
        }
        setCircularPositions() {
          let u, A = this.box, M = this.nodes, f = 2 * Math.PI / (M.length + 1), m = M.filter(function(v) {
            return v.linksTo.length === 0;
          }), C = {}, F = this.options.initialPositionRadius, _ = (v) => {
            for (let w of v.linksFrom || []) C[w.toNode.id] || (C[w.toNode.id] = !0, E.push(w.toNode), _(w.toNode));
          }, E = [];
          for (let v of m) E.push(v), _(v);
          if (E.length) for (let v of M) E.indexOf(v) === -1 && E.push(v);
          else E = M;
          for (let v = 0, w = E.length; v < w; ++v) (u = E[v]).plotX = u.prevX = T(u.plotX, A.width / 2 + F * Math.cos(v * f)), u.plotY = u.prevY = T(u.plotY, A.height / 2 + F * Math.sin(v * f)), u.dispX = 0, u.dispY = 0;
        }
        setRandomPositions() {
          let u, A = this.box, M = this.nodes, f = M.length + 1, m = (C) => {
            let F = C * C / Math.PI;
            return F - Math.floor(F);
          };
          for (let C = 0, F = M.length; C < F; ++C) (u = M[C]).plotX = u.prevX = T(u.plotX, A.width * m(C)), u.plotY = u.prevY = T(u.plotY, A.height * m(f + C)), u.dispX = 0, u.dispY = 0;
        }
        force(u, ...A) {
          this.integration[u].apply(this, A);
        }
        barycenterForces() {
          this.getBarycenter(), this.force("barycenter");
        }
        getBarycenter() {
          let u = 0, A = 0, M = 0;
          for (let f of this.nodes) A += f.plotX * f.mass, M += f.plotY * f.mass, u += f.mass;
          return this.barycenter = { x: A, y: M, xFactor: A / u, yFactor: M / u }, this.barycenter;
        }
        barnesHutApproximation(u, A) {
          let M, f, m = this.getDistXY(u, A), C = this.vectorLength(m);
          return u !== A && C !== 0 && (A.isInternal ? A.boxSize / C < this.options.theta && C !== 0 ? (f = this.repulsiveForce(C, this.k), this.force("repulsive", u, f * A.mass, m, C), M = !1) : M = !0 : (f = this.repulsiveForce(C, this.k), this.force("repulsive", u, f * A.mass, m, C))), M;
        }
        repulsiveForces() {
          if (this.approximation === "barnes-hut") for (let u of this.nodes) this.quadTree.visitNodeRecursive(null, (A) => this.barnesHutApproximation(u, A));
          else {
            let u, A, M;
            for (let f of this.nodes) for (let m of this.nodes) f === m || f.fixedPosition || (M = this.getDistXY(f, m), (A = this.vectorLength(M)) !== 0 && (u = this.repulsiveForce(A, this.k), this.force("repulsive", f, u * m.mass, M, A)));
          }
        }
        attractiveForces() {
          let u, A, M;
          for (let f of this.links) f.fromNode && f.toNode && (u = this.getDistXY(f.fromNode, f.toNode), (A = this.vectorLength(u)) !== 0 && (M = this.attractiveForce(A, this.k), this.force("attractive", f, M, u, A)));
        }
        applyLimits() {
          for (let u of this.nodes) u.fixedPosition || (this.integration.integrate(this, u), this.applyLimitBox(u, this.box), u.dispX = 0, u.dispY = 0);
        }
        applyLimitBox(u, A) {
          let M = u.radius;
          u.plotX = B(u.plotX, A.left + M, A.width - M), u.plotY = B(u.plotY, A.top + M, A.height - M);
        }
        coolDown(u, A, M) {
          return u - A * M;
        }
        isStable() {
          return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
        }
        getSystemTemperature() {
          let u = 0;
          for (let A of this.nodes) u += A.temperature;
          return u;
        }
        vectorLength(u) {
          return Math.sqrt(u.x * u.x + u.y * u.y);
        }
        getDistR(u, A) {
          let M = this.getDistXY(u, A);
          return this.vectorLength(M);
        }
        getDistXY(u, A) {
          let M = u.plotX - A.plotX, f = u.plotY - A.plotY;
          return { x: M, y: f, absX: Math.abs(M), absY: Math.abs(f) };
        }
      }
      return y;
    }), i(e, "Series/PackedBubble/PackedBubbleLayout.js", [e["Series/GraphLayoutComposition.js"], e["Series/PackedBubble/PackedBubbleIntegration.js"], e["Series/Networkgraph/ReingoldFruchtermanLayout.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { addEvent: D, pick: j } = L;
      function I() {
        let N = this.series, x = [];
        return N.forEach((T) => {
          T.parentNode && T.parentNode.selected && x.push(T.parentNode);
        }), x;
      }
      function B() {
        this.allDataPoints && delete this.allDataPoints;
      }
      class R extends l {
        constructor() {
          super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
        }
        static compose(x) {
          l.compose(x), o.integrations.packedbubble = n, o.layouts.packedbubble = R;
          let T = x.prototype;
          T.getSelectedParentNodes || (D(x, "beforeRedraw", B), T.getSelectedParentNodes = I);
        }
        beforeStep() {
          this.options.marker && this.series.forEach((x) => {
            x && x.calculateParentRadius();
          });
        }
        isStable() {
          let x = Math.abs(this.prevSystemTemperature - this.systemTemperature);
          return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && x < 1e-5 || this.temperature <= 0;
        }
        setCircularPositions() {
          let x = this.box, T = this.nodes, y = 2 * Math.PI / (T.length + 1), S = this.options.initialPositionRadius, u, A, M = 0;
          for (let f of T) this.options.splitSeries && !f.isParentNode ? (u = f.series.parentNode.plotX, A = f.series.parentNode.plotY) : (u = x.width / 2, A = x.height / 2), f.plotX = f.prevX = j(f.plotX, u + S * Math.cos(f.index || M * y)), f.plotY = f.prevY = j(f.plotY, A + S * Math.sin(f.index || M * y)), f.dispX = 0, f.dispY = 0, M++;
        }
        repulsiveForces() {
          let x, T, y, S = this, u = S.options.bubblePadding, A = S.nodes;
          A.forEach((M) => {
            M.degree = M.mass, M.neighbours = 0, A.forEach((f) => {
              x = 0, M !== f && !M.fixedPosition && (S.options.seriesInteraction || M.series === f.series) && (y = S.getDistXY(M, f), (T = S.vectorLength(y) - (M.marker.radius + f.marker.radius + u)) < 0 && (M.degree += 0.01, M.neighbours++, x = S.repulsiveForce(-T / Math.sqrt(M.neighbours), S.k, M, f)), S.force("repulsive", M, x * f.mass, y, f, T));
            });
          });
        }
        applyLimitBox(x, T) {
          let y, S;
          this.options.splitSeries && !x.isParentNode && this.options.parentNodeLimit && (y = this.getDistXY(x, x.series.parentNode), (S = x.series.parentNodeRadius - x.marker.radius - this.vectorLength(y)) < 0 && S > -2 * x.marker.radius && (x.plotX -= 0.01 * y.x, x.plotY -= 0.01 * y.y)), super.applyLimitBox(x, T);
        }
      }
      return o.layouts.packedbubble = R, R;
    }), i(e, "Series/SimulationSeriesUtilities.js", [e["Core/Utilities.js"], e["Core/Animation/AnimationUtilities.js"]], function(o, n) {
      let { merge: l, syncTimeout: L } = o, { animObject: D } = n;
      return { initDataLabels: function() {
        let j = this.options.dataLabels;
        if (!this.dataLabelsGroup) {
          let I = this.initDataLabelsGroup();
          return !this.chart.styledMode && (j != null && j.style) && I.css(j.style), I.attr({ opacity: 0 }), this.visible && I.show(), I;
        }
        return this.dataLabelsGroup.attr(l({ opacity: 1 }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
      }, initDataLabelsDefer: function() {
        var I;
        let j = this.options.dataLabels;
        j != null && j.defer && ((I = this.options.layoutAlgorithm) != null && I.enableSimulation) ? L(() => {
          this.deferDataLabels = !1;
        }, j ? D(j.animation).defer : 0) : this.deferDataLabels = !1;
      } };
    }), i(e, "Extensions/TextPath.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { deg2rad: l } = o, { addEvent: L, merge: D, uniqueKey: j, defined: I, extend: B } = n;
      function R(T, y) {
        y = D(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, y);
        let S = this.renderer.url, u = this.text || this, A = u.textPath, { attributes: M, enabled: f } = y;
        if (T = T || A && A.path, A && A.undo(), T && f) {
          let m = L(u, "afterModifyTree", (C) => {
            if (T && f) {
              let F = T.attr("id");
              F || T.attr("id", F = j());
              let _ = { x: 0, y: 0 };
              I(M.dx) && (_.dx = M.dx, delete M.dx), I(M.dy) && (_.dy = M.dy, delete M.dy), u.attr(_), this.attr({ transform: "" }), this.box && (this.box = this.box.destroy());
              let E = C.nodes.slice(0);
              C.nodes.length = 0, C.nodes[0] = { tagName: "textPath", attributes: B(M, { "text-anchor": M.textAnchor, href: `${S}#${F}` }), children: E };
            }
          });
          u.textPath = { path: T, undo: m };
        } else u.attr({ dx: 0, dy: 0 }), delete u.textPath;
        return this.added && (u.textCache = "", this.renderer.buildText(u)), this;
      }
      function N(T) {
        var u;
        let y = T.bBox, S = (u = this.element) == null ? void 0 : u.querySelector("textPath");
        if (S) {
          let A = [], { b: M, h: f } = this.renderer.fontMetrics(this.element), m = f - M, C = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), F = S.innerHTML.replace(C, "").split(/<tspan class="highcharts-br"[^>]*>/), _ = F.length, E = (v, w) => {
            let { x: d, y: r } = w, s = (S.getRotationOfChar(v) - 90) * l, p = Math.cos(s), b = Math.sin(s);
            return [[d - m * p, r - m * b], [d + M * p, r + M * b]];
          };
          for (let v = 0, w = 0; w < _; w++) {
            let d = F[w].length;
            for (let r = 0; r < d; r += 5) try {
              let s = v + r + w, [p, b] = E(s, S.getStartPositionOfChar(s));
              r === 0 ? (A.push(b), A.push(p)) : (w === 0 && A.unshift(b), w === _ - 1 && A.push(p));
            } catch {
              break;
            }
            v += d - 1;
            try {
              let r = v + w, s = S.getEndPositionOfChar(r), [p, b] = E(r, s);
              A.unshift(b), A.unshift(p);
            } catch {
              break;
            }
          }
          A.length && A.push(A[0].slice()), y.polygon = A;
        }
        return y;
      }
      function x(T) {
        var A;
        let y = T.labelOptions, S = T.point, u = y[S.formatPrefix + "TextPath"] || y.textPath;
        u && !y.useHTML && (this.setTextPath(((A = S.getDataLabelPath) == null ? void 0 : A.call(S, this)) || S.graphic, u), S.dataLabelPath && !u.enabled && (S.dataLabelPath = S.dataLabelPath.destroy()));
      }
      return { compose: function(T) {
        L(T, "afterGetBBox", N), L(T, "beforeAddingDataLabel", x);
        let y = T.prototype;
        y.setTextPath || (y.setTextPath = R);
      } };
    }), i(e, "Series/PackedBubble/PackedBubbleSeries.js", [e["Core/Color/Color.js"], e["Series/DragNodesComposition.js"], e["Series/GraphLayoutComposition.js"], e["Core/Globals.js"], e["Series/PackedBubble/PackedBubblePoint.js"], e["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], e["Series/PackedBubble/PackedBubbleLayout.js"], e["Core/Series/SeriesRegistry.js"], e["Series/SimulationSeriesUtilities.js"], e["Core/Utilities.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Extensions/TextPath.js"]], function(o, n, l, L, D, j, I, B, R, N, x, T) {
      let { parse: y } = o, { noop: S } = L, { series: { prototype: u }, seriesTypes: { bubble: A } } = B, { initDataLabels: M, initDataLabelsDefer: f } = R, { addEvent: m, clamp: C, defined: F, extend: _, fireEvent: E, isArray: v, isNumber: w, merge: d, pick: r } = N;
      T.compose(x);
      class s extends A {
        constructor() {
          super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
        }
        static compose(b, c, h) {
          A.compose(b, c, h), n.compose(c), I.compose(c);
        }
        accumulateAllPoints() {
          let b, c = this.chart, h = [];
          for (let g of c.series) if (g.is("packedbubble") && g.reserveSpace()) {
            b = g.yData || [];
            for (let k = 0; k < b.length; k++) h.push([null, null, b[k], g.index, k, { id: k, marker: { radius: 0 } }]);
          }
          return h;
        }
        addLayout() {
          let b = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, c = b.type || "packedbubble", h = this.chart.options.chart, g = this.chart.graphLayoutsStorage, k = this.chart.graphLayoutsLookup, P;
          g || (this.chart.graphLayoutsStorage = g = {}, this.chart.graphLayoutsLookup = k = []), (P = g[c]) || (b.enableSimulation = F(h.forExport) ? !h.forExport : b.enableSimulation, g[c] = P = new l.layouts[c](), P.init(b), k.splice(P.index, 0, P)), this.layout = P, this.points.forEach((O) => {
            O.mass = 2, O.degree = 1, O.collisionNmb = 1;
          }), P.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), P.addElementsToCollection([this], P.series), P.addElementsToCollection(this.points, P.nodes);
        }
        addSeriesLayout() {
          let b = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, c = b.type || "packedbubble", h = this.chart.graphLayoutsStorage, g = this.chart.graphLayoutsLookup, k = d(b, b.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), P = h[c + "-series"];
          P || (h[c + "-series"] = P = new l.layouts[c](), P.init(k), g.splice(P.index, 0, P)), this.parentNodeLayout = P, this.createParentNodes();
        }
        calculateParentRadius() {
          let b = this.seriesBox();
          this.parentNodeRadius = C(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, b ? Math.max(Math.sqrt(Math.pow(b.width, 2) + Math.pow(b.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
        }
        calculateZExtremes() {
          let b = this.chart.series, c = this.options.zMin, h = this.options.zMax, g = 1 / 0, k = -1 / 0;
          return c && h ? [c, h] : (b.forEach((P) => {
            P.yData.forEach((O) => {
              F(O) && (O > k && (k = O), O < g && (g = O));
            });
          }), [c = r(c, g), h = r(h, k)]);
        }
        checkOverlap(b, c) {
          let h = b[0] - c[0], g = b[1] - c[1];
          return Math.sqrt(h * h + g * g) - Math.abs(b[2] + c[2]) < -1e-3;
        }
        createParentNodes() {
          let b = this.pointClass, c = this.chart, h = this.parentNodeLayout, g = this.layout.options, k, P = this.parentNode, O = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: y(this.color).brighten(0.4).get() };
          g.parentNodeOptions && (O = d(g.parentNodeOptions.marker || {}, O)), this.parentNodeMass = 0, this.points.forEach((z) => {
            this.parentNodeMass += Math.PI * Math.pow(z.marker.radius, 2);
          }), this.calculateParentRadius(), h.nodes.forEach((z) => {
            z.seriesIndex === this.index && (k = !0);
          }), h.setArea(0, 0, c.plotWidth, c.plotHeight), k || (P || (P = new b(this, { mass: this.parentNodeRadius / 2, marker: O, dataLabels: { inside: !1 }, states: { normal: { marker: O }, hover: { marker: O } }, dataLabelOnNull: !0, degree: this.parentNodeRadius, isParentNode: !0, seriesIndex: this.index })), this.parentNode && (P.plotX = this.parentNode.plotX, P.plotY = this.parentNode.plotY), this.parentNode = P, h.addElementsToCollection([this], h.series), h.addElementsToCollection([P], h.nodes));
        }
        deferLayout() {
          let b = this.options.layoutAlgorithm;
          this.visible && (this.addLayout(), b.splitSeries && this.addSeriesLayout());
        }
        destroy() {
          this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((b) => {
            b.removeElementFromCollection(this, b.series);
          }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), u.destroy.apply(this, arguments);
        }
        drawDataLabels() {
          !this.deferDataLabels && (u.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", u.drawDataLabels.call(this, [this.parentNode])));
        }
        drawGraph() {
          var k;
          if (!this.layout || !this.layout.options.splitSeries) return;
          let b = this.chart, c = this.layout.options.parentNodeOptions.marker, h = { fill: c.fillColor || y(this.color).brighten(0.4).get(), opacity: c.fillOpacity, stroke: c.lineColor || this.color, "stroke-width": r(c.lineWidth, this.options.lineWidth) }, g = {};
          this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, b.seriesGroup), (k = this.group) == null || k.attr({ zIndex: 2 }), this.calculateParentRadius(), this.parentNode && F(this.parentNode.plotX) && F(this.parentNode.plotY) && F(this.parentNodeRadius) && (g = d({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, h), this.parentNode.graphic || (this.graph = this.parentNode.graphic = b.renderer.symbol(h.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(g));
        }
        drawTracker() {
          let b, c = this.parentNode;
          super.drawTracker(), c && (b = v(c.dataLabels) ? c.dataLabels : c.dataLabel ? [c.dataLabel] : [], c.graphic && (c.graphic.element.point = c), b.forEach((h) => {
            (h.div || h.element).point = c;
          }));
        }
        getPointRadius() {
          let b, c, h, g, k = this.chart, P = k.plotWidth, O = k.plotHeight, z = this.options, W = z.useSimulation, G = Math.min(P, O), Y = {}, U = [], H = k.allDataPoints || [], q = H.length;
          ["minSize", "maxSize"].forEach(($) => {
            let K = parseInt(z[$], 10), V = /%$/.test(z[$]);
            Y[$] = V ? G * K / 100 : K * Math.sqrt(q);
          }), k.minRadius = b = Y.minSize / Math.sqrt(q), k.maxRadius = c = Y.maxSize / Math.sqrt(q);
          let X = W ? this.calculateZExtremes() : [b, c];
          H.forEach(($, K) => {
            h = W ? C($[2], X[0], X[1]) : $[2], (g = this.getRadius(X[0], X[1], b, c, h)) === 0 && (g = null), H[K][2] = g, U.push(g);
          }), this.radii = U;
        }
        init() {
          return u.init.apply(this, arguments), f.call(this), this.eventsToUnbind.push(m(this, "updatedData", function() {
            this.chart.series.forEach((b) => {
              b.type === this.type && (b.isDirty = !0);
            }, this);
          })), this;
        }
        onMouseUp(b) {
          if (b.fixedPosition && !b.removed) {
            let c, h = this.layout, g = this.parentNodeLayout;
            g && h.options.dragBetweenSeries && g.nodes.forEach((k) => {
              b && b.marker && k !== b.series.parentNode && (c = h.getDistXY(b, k), h.vectorLength(c) - k.marker.radius - b.marker.radius < 0 && (k.series.addPoint(d(b.options, { plotX: b.plotX, plotY: b.plotY }), !1), h.removeElementFromCollection(b, h.nodes), b.remove()));
            }), n.onMouseUp.apply(this, arguments);
          }
        }
        placeBubbles(b) {
          let c = this.checkOverlap, h = this.positionBubble, g = [], k = 1, P = 0, O = 0, z, W = [], G, Y = b.sort((U, H) => H[2] - U[2]);
          if (Y.length) {
            if (g.push([[0, 0, Y[0][2], Y[0][3], Y[0][4]]]), Y.length > 1) for (g.push([[0, 0 - Y[1][2] - Y[0][2], Y[1][2], Y[1][3], Y[1][4]]]), G = 2; G < Y.length; G++) Y[G][2] = Y[G][2] || 1, c(z = h(g[k][P], g[k - 1][O], Y[G]), g[k][0]) ? (g.push([]), O = 0, g[k + 1].push(h(g[k][P], g[k][0], Y[G])), k++, P = 0) : k > 1 && g[k - 1][O + 1] && c(z, g[k - 1][O + 1]) ? (O++, g[k].push(h(g[k][P], g[k - 1][O], Y[G])), P++) : (P++, g[k].push(z));
            this.chart.stages = g, this.chart.rawPositions = [].concat.apply([], g), this.resizeRadius(), W = this.chart.rawPositions;
          }
          return W;
        }
        pointAttribs(b, c) {
          let h = this.options, g = b && b.isParentNode, k = h.marker;
          g && h.layoutAlgorithm && h.layoutAlgorithm.parentNodeOptions && (k = h.layoutAlgorithm.parentNodeOptions.marker);
          let P = k.fillOpacity, O = u.pointAttribs.call(this, b, c);
          return P !== 1 && (O["fill-opacity"] = P), O;
        }
        positionBubble(b, c, h) {
          let g = Math.asin, k = Math.acos, P = Math.pow, O = Math.abs, z = (0, Math.sqrt)(P(b[0] - c[0], 2) + P(b[1] - c[1], 2)), W = k((P(z, 2) + P(h[2] + c[2], 2) - P(h[2] + b[2], 2)) / (2 * (h[2] + c[2]) * z)), G = g(O(b[0] - c[0]) / z), Y = (b[1] - c[1] < 0 ? 0 : Math.PI) + W + G * ((b[0] - c[0]) * (b[1] - c[1]) < 0 ? 1 : -1), U = Math.cos(Y), H = Math.sin(Y);
          return [c[0] + (c[2] + h[2]) * H, c[1] - (c[2] + h[2]) * U, h[2], h[3], h[4]];
        }
        render() {
          let b = [];
          u.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((c) => {
            v(c.dataLabels) && c.dataLabels.forEach((h) => {
              b.push(h);
            });
          }), this.options.useSimulation && this.chart.hideOverlappingLabels(b));
        }
        resizeRadius() {
          let b, c, h, g, k, P = this.chart, O = P.rawPositions, z = Math.min, W = Math.max, G = P.plotLeft, Y = P.plotTop, U = P.plotHeight, H = P.plotWidth;
          for (let K of (b = h = Number.POSITIVE_INFINITY, c = g = Number.NEGATIVE_INFINITY, O)) k = K[2], b = z(b, K[0] - k), c = W(c, K[0] + k), h = z(h, K[1] - k), g = W(g, K[1] + k);
          let q = [c - b, g - h], X = [(H - G) / q[0], (U - Y) / q[1]], $ = z.apply([], X);
          if (Math.abs($ - 1) > 1e-10) {
            for (let K of O) K[2] *= $;
            this.placeBubbles(O);
          } else P.diffY = U / 2 + Y - h - (g - h) / 2, P.diffX = H / 2 + G - b - (c - b) / 2;
        }
        seriesBox() {
          let b, c = this.chart, h = this.data, g = Math.max, k = Math.min, P = [c.plotLeft, c.plotLeft + c.plotWidth, c.plotTop, c.plotTop + c.plotHeight];
          return h.forEach((O) => {
            F(O.plotX) && F(O.plotY) && O.marker.radius && (b = O.marker.radius, P[0] = k(P[0], O.plotX - b), P[1] = g(P[1], O.plotX + b), P[2] = k(P[2], O.plotY - b), P[3] = g(P[3], O.plotY + b));
          }), w(P.width / P.height) ? P : null;
        }
        setVisible() {
          let b = this;
          u.setVisible.apply(b, arguments), b.parentNodeLayout && b.graph ? b.visible ? (b.graph.show(), b.parentNode.dataLabel && b.parentNode.dataLabel.show()) : (b.graph.hide(), b.parentNodeLayout.removeElementFromCollection(b.parentNode, b.parentNodeLayout.nodes), b.parentNode.dataLabel && b.parentNode.dataLabel.hide()) : b.layout && (b.visible ? b.layout.addElementsToCollection(b.points, b.layout.nodes) : b.points.forEach((c) => {
            b.layout.removeElementFromCollection(c, b.layout.nodes);
          }));
        }
        translate() {
          let b, c, h, g = this.chart, k = this.data, P = this.index, O = this.options.useSimulation;
          for (let z of (this.processedXData = this.xData, this.generatePoints(), F(g.allDataPoints) || (g.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), O ? h = g.allDataPoints : (h = this.placeBubbles(g.allDataPoints), this.options.draggable = !1), h)) z[3] === P && (b = k[z[4]], c = r(z[2], void 0), O || (b.plotX = z[0] - g.plotLeft + g.diffX, b.plotY = z[1] - g.plotTop + g.diffY), w(c) && (b.marker = _(b.marker, { radius: c, width: 2 * c, height: 2 * c }), b.radius = c));
          O && this.deferLayout(), E(this, "afterTranslate");
        }
      }
      return s.defaultOptions = d(A.defaultOptions, j), _(s.prototype, { pointClass: D, axisTypes: [], directTouch: !0, forces: ["barycenter", "repulsive"], hasDraggableNodes: !0, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointArrayMap: ["value"], pointValKey: "value", requireSorting: !1, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], initDataLabels: M, alignDataLabel: u.alignDataLabel, indexateNodes: S, onMouseDown: n.onMouseDown, onMouseMove: n.onMouseMove, redrawHalo: n.redrawHalo, searchPoint: S }), B.registerSeriesType("packedbubble", s), s;
    }), i(e, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
      return { marker: { enabled: !1, states: { hover: { enabled: !1 } } }, stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "" }, trackByArea: !0, legendSymbol: "rectangle" };
    }), i(e, "Series/Polygon/PolygonSeries.js", [e["Core/Globals.js"], e["Series/Polygon/PolygonSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { noop: D } = o, { area: j, line: I, scatter: B } = l.seriesTypes, { extend: R, merge: N } = L;
      class x extends B {
        getGraphPath() {
          let y = I.prototype.getGraphPath.call(this), S = y.length + 1;
          for (; S--; ) (S === y.length || y[S][0] === "M") && S > 0 && y.splice(S, 0, ["Z"]);
          return this.areaPath = y, y;
        }
        drawGraph() {
          this.options.fillColor = this.color, j.prototype.drawGraph.call(this);
        }
      }
      return x.defaultOptions = N(B.defaultOptions, n), R(x.prototype, { type: "polygon", drawTracker: I.prototype.drawTracker, setStackedPoints: D }), l.registerSeriesType("polygon", x), x;
    }), i(e, "Core/Axis/RadialAxisDefaults.js", [], function() {
      return { circular: { gridLineWidth: 1, labels: { align: void 0, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: !1, tickLength: 0 }, radial: { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", padding: 5, x: -3, y: -2 }, showLastLabel: !1, title: { x: 4, text: null, rotation: 90 } }, radialGauge: { endOnTick: !1, gridLineWidth: 0, labels: { align: "center", distance: -25, x: 0, y: void 0 }, lineWidth: 1, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickPosition: "inside", tickWidth: 2, title: { rotation: 0, text: "" }, zIndex: 2 } };
    }), i(e, "Core/Axis/RadialAxis.js", [e["Core/Axis/RadialAxisDefaults.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { defaultOptions: j } = n, { composed: I, noop: B } = l, { addEvent: R, correctFloat: N, defined: x, extend: T, fireEvent: y, isObject: S, merge: u, pick: A, pushUnique: M, relativeLength: f, wrap: m } = L;
      return function(C) {
        function F() {
          this.autoConnect = this.isCircular && A(this.userMax, this.options.max) === void 0 && N(this.endAngleRad - this.startAngleRad) === N(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
        }
        function _() {
          return () => {
            if (this.isRadial && this.tickPositions && this.options.labels && this.options.labels.allowOverlap !== !0) return this.tickPositions.map((K) => this.ticks[K] && this.ticks[K].label).filter((K) => !!K);
          };
        }
        function E() {
          return B;
        }
        function v(K, V, Q) {
          let Z = this.pane.center, ee = K.value, J, ie, re;
          return this.isCircular ? (x(ee) ? K.point && (K.point.shapeArgs || {}).start && (ee = this.chart.inverted ? this.translate(K.point.rectPlotY, !0) : K.point.x) : (ie = K.chartX || 0, re = K.chartY || 0, ee = this.translate(Math.atan2(re - Q, ie - V) - this.startAngleRad, !0)), ie = (J = this.getPosition(ee)).x, re = J.y) : (x(ee) || (ie = K.chartX, re = K.chartY), x(ie) && x(re) && (Q = Z[1] + this.chart.plotTop, ee = this.translate(Math.min(Math.sqrt(Math.pow(ie - V, 2) + Math.pow(re - Q, 2)), Z[2] / 2) - Z[3] / 2, !0))), [ee, ie || 0, re || 0];
        }
        function w(K, V, Q) {
          let Z = this.pane.center, ee = this.chart, J = this.left || 0, ie = this.top || 0, re, ce = A(V, Z[2] / 2 - this.offset), he;
          return Q === void 0 && (Q = this.horiz ? 0 : this.center && -this.center[3] / 2), Q && (ce += Q), this.isCircular || V !== void 0 ? ((he = this.chart.renderer.symbols.arc(J + Z[0], ie + Z[1], ce, ce, { start: this.startAngleRad, end: this.endAngleRad, open: !0, innerR: 0 })).xBounds = [J + Z[0]], he.yBounds = [ie + Z[1] - ce]) : (re = this.postTranslate(this.angleRad, ce), he = [["M", this.center[0] + ee.plotLeft, this.center[1] + ee.plotTop], ["L", re.x, re.y]]), he;
        }
        function d() {
          this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
        }
        function r(K, V, Q) {
          let Z = this.chart, ee = (ye) => {
            if (typeof ye == "string") {
              let xe = parseInt(ye, 10);
              return oe.test(ye) && (xe = xe * re / 100), xe;
            }
            return ye;
          }, J = this.center, ie = this.startAngleRad, re = J[2] / 2, ce = Math.min(this.offset, 0), he = this.left || 0, ne = this.top || 0, oe = /%$/, se = this.isCircular, te, ae, le, de, be, ge, me = A(ee(Q.outerRadius), re), fe = ee(Q.innerRadius), Ae = A(ee(Q.thickness), 10);
          if (this.options.gridLineInterpolation === "polygon") ge = this.getPlotLinePath({ value: K }).concat(this.getPlotLinePath({ value: V, reverse: !0 }));
          else {
            K = Math.max(K, this.min), V = Math.min(V, this.max);
            let ye = this.translate(K), xe = this.translate(V);
            se || (me = ye || 0, fe = xe || 0), Q.shape !== "circle" && se ? (te = ie + (ye || 0), ae = ie + (xe || 0)) : (te = -Math.PI / 2, ae = 1.5 * Math.PI, be = !0), me -= ce, Ae -= ce, ge = Z.renderer.symbols.arc(he + J[0], ne + J[1], me, me, { start: Math.min(te, ae), end: Math.max(te, ae), innerR: A(fe, me - Ae), open: be, borderRadius: Q.borderRadius }), se && (le = (ae + te) / 2, de = he + J[0] + J[2] / 2 * Math.cos(le), ge.xBounds = le > -Math.PI / 2 && le < Math.PI / 2 ? [de, Z.plotWidth] : [0, de], ge.yBounds = [ne + J[1] + J[2] / 2 * Math.sin(le)], ge.yBounds[0] += le > -Math.PI && le < 0 || le > Math.PI ? -10 : 10);
          }
          return ge;
        }
        function s(K) {
          let V = this.pane.center, Q = this.chart, Z = Q.inverted, ee = K.reverse, J = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, ie = J.innerRadius || "0%", re = J.outerRadius || "100%", ce = V[0] + Q.plotLeft, he = V[1] + Q.plotTop, ne = this.height, oe = K.isCrosshair, se = V[3] / 2, te = K.value, ae, le, de, be, ge, me, fe, Ae, ye, xe = this.getPosition(te), we = xe.x, ke = xe.y;
          if (oe && (te = (Ae = this.getCrosshairPosition(K, ce, he))[0], we = Ae[1], ke = Ae[2]), this.isCircular) le = Math.sqrt(Math.pow(we - ce, 2) + Math.pow(ke - he, 2)), de = typeof ie == "string" ? f(ie, 1) : ie / le, be = typeof re == "string" ? f(re, 1) : re / le, V && se && (de < (ae = se / le) && (de = ae), be < ae && (be = ae)), ye = [["M", ce + de * (we - ce), he - de * (he - ke)], ["L", we - (1 - be) * (we - ce), ke + (1 - be) * (he - ke)]];
          else if ((te = this.translate(te)) && (te < 0 || te > ne) && (te = 0), this.options.gridLineInterpolation === "circle") ye = this.getLinePath(0, te, se);
          else if (ye = [], Q[Z ? "yAxis" : "xAxis"].forEach((Oe) => {
            Oe.pane === this.pane && (ge = Oe);
          }), ge) {
            fe = ge.tickPositions, ge.autoConnect && (fe = fe.concat([fe[0]])), ee && (fe = fe.slice().reverse()), te && (te += se);
            for (let Oe = 0; Oe < fe.length; Oe++) me = ge.getPosition(fe[Oe], te), ye.push(Oe ? ["L", me.x, me.y] : ["M", me.x, me.y]);
          }
          return ye;
        }
        function p(K, V) {
          let Q = this.translate(K);
          return this.postTranslate(this.isCircular ? Q : this.angleRad, A(this.isCircular ? V : Q < 0 ? 0 : Q, this.center[2] / 2) - this.offset);
        }
        function b() {
          let K = this.center, V = this.chart, Q = this.options.title;
          return { x: V.plotLeft + K[0] + (Q.x || 0), y: V.plotTop + K[1] - { high: 0.5, middle: 0.25, low: 0 }[Q.align] * K[2] + (Q.y || 0) };
        }
        function c(K) {
          K.beforeSetTickPositions = F, K.createLabelCollector = _, K.getCrosshairPosition = v, K.getLinePath = w, K.getOffset = d, K.getPlotBandPath = r, K.getPlotLinePath = s, K.getPosition = p, K.getTitlePosition = b, K.postTranslate = Y, K.setAxisSize = H, K.setAxisTranslation = q, K.setOptions = X;
        }
        function h() {
          let K = this.chart, V = this.options, Q = K.angular && this.isXAxis, Z = this.pane, ee = Z && Z.options;
          if (!Q && Z && (K.angular || K.polar)) {
            let J = 2 * Math.PI, ie = (A(ee.startAngle, 0) - 90) * Math.PI / 180, re = (A(ee.endAngle, A(ee.startAngle, 0) + 360) - 90) * Math.PI / 180;
            this.angleRad = (V.angle || 0) * Math.PI / 180, this.startAngleRad = ie, this.endAngleRad = re, this.offset = V.offset || 0;
            let ce = (ie % J + J) % J, he = (re % J + J) % J;
            ce > Math.PI && (ce -= J), he > Math.PI && (he -= J), this.normalizedStartAngleRad = ce, this.normalizedEndAngleRad = he;
          }
        }
        function g(K) {
          this.isRadial && (K.align = void 0, K.preventDefault());
        }
        function k() {
          if (this.chart && this.chart.labelCollectors) {
            let K = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
            K >= 0 && this.chart.labelCollectors.splice(K, 1);
          }
        }
        function P(K) {
          let V, Q = this.chart, Z = Q.angular, ee = Q.polar, J = this.isXAxis, ie = this.coll, re = K.userOptions.pane || 0, ce = this.pane = Q.pane && Q.pane[re];
          if (ie === "colorAxis") {
            this.isRadial = !1;
            return;
          }
          Z ? (Z && J ? (this.isHidden = !0, this.createLabelCollector = E, this.getOffset = B, this.redraw = U, this.render = U, this.setScale = B, this.setCategories = B, this.setTitle = B) : c(this), V = !J) : ee && (c(this), V = this.horiz), Z || ee ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && Q.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, ce && V && (ce.axis = this), this.isCircular = V;
        }
        function O() {
          this.isRadial && this.beforeSetTickPositions();
        }
        function z(K) {
          let V = this.label;
          if (!V) return;
          let Q = this.axis, Z = V.getBBox(), ee = Q.options.labels, J = (Q.translate(this.pos) + Q.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, ie = Math.round(J), re = x(ee.y) ? 0 : -(0.3 * Z.height), ce = ee.y, he, ne = 20, oe = ee.align, se = "end", te = ie < 0 ? ie + 360 : ie, ae = te, le = 0, de = 0;
          Q.isRadial && (he = Q.getPosition(this.pos, Q.center[2] / 2 + f(A(ee.distance, -25), Q.center[2] / 2, -Q.center[2] / 2)), ee.rotation === "auto" ? V.attr({ rotation: J }) : x(ce) || (ce = Q.chart.renderer.fontMetrics(V).b - Z.height / 2), x(oe) || (Q.isCircular ? (Z.width > Q.len * Q.tickInterval / (Q.max - Q.min) && (ne = 0), oe = J > ne && J < 180 - ne ? "left" : J > 180 + ne && J < 360 - ne ? "right" : "center") : oe = "center", V.attr({ align: oe })), oe === "auto" && Q.tickPositions.length === 2 && Q.isCircular && (te > 90 && te < 180 ? te = 180 - te : te > 270 && te <= 360 && (te = 540 - te), ae > 180 && ae <= 360 && (ae = 360 - ae), (Q.pane.options.startAngle === ie || Q.pane.options.startAngle === ie + 360 || Q.pane.options.startAngle === ie - 360) && (se = "start"), oe = ie >= -90 && ie <= 90 || ie >= -360 && ie <= -270 || ie >= 270 && ie <= 360 ? se === "start" ? "right" : "left" : se === "start" ? "left" : "right", ae > 70 && ae < 110 && (oe = "center"), te < 15 || te >= 180 && te < 195 ? le = 0.3 * Z.height : te >= 15 && te <= 35 ? le = se === "start" ? 0 : 0.75 * Z.height : te >= 195 && te <= 215 ? le = se === "start" ? 0.75 * Z.height : 0 : te > 35 && te <= 90 ? le = se === "start" ? -(0.25 * Z.height) : Z.height : te > 215 && te <= 270 && (le = se === "start" ? Z.height : -(0.25 * Z.height)), ae < 15 ? de = se === "start" ? -(0.15 * Z.height) : 0.15 * Z.height : ae > 165 && ae <= 180 && (de = se === "start" ? 0.15 * Z.height : -(0.15 * Z.height)), V.attr({ align: oe }), V.translate(de, le + re)), K.pos.x = he.x + (ee.x || 0), K.pos.y = he.y + (ce || 0));
        }
        function W(K) {
          this.axis.getPosition && T(K.pos, this.axis.getPosition(this.pos));
        }
        function G({ options: K }) {
          K.xAxis && u(!0, C.radialDefaultOptions.circular, K.xAxis), K.yAxis && u(!0, C.radialDefaultOptions.radialGauge, K.yAxis);
        }
        function Y(K, V) {
          let Q = this.chart, Z = this.center;
          return K = this.startAngleRad + K, { x: Q.plotLeft + Z[0] + Math.cos(K) * V, y: Q.plotTop + Z[1] + Math.sin(K) * V };
        }
        function U() {
          this.isDirty = !1;
        }
        function H() {
          let K, V;
          this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), K = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (V = this.postTranslate(this.angleRad, K[3] / 2), K[0] = V.x - this.chart.plotLeft, K[1] = V.y - this.chart.plotTop), this.len = this.width = this.height = (K[2] - K[3]) * A(this.sector, 1) / 2);
        }
        function q() {
          this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
        }
        function X(K) {
          let { coll: V } = this, { angular: Q, inverted: Z, polar: ee } = this.chart, J = {};
          Q ? this.isXAxis || (J = u(j.yAxis, C.radialDefaultOptions.radialGauge)) : ee && (J = this.horiz ? u(j.xAxis, C.radialDefaultOptions.circular) : u(V === "xAxis" ? j.xAxis : j.yAxis, C.radialDefaultOptions.radial)), Z && V === "yAxis" && (J.stackLabels = S(j.yAxis, !0) ? j.yAxis.stackLabels : {}, J.reversedStacks = !0);
          let ie = this.options = u(J, K);
          ie.plotBands || (ie.plotBands = []), y(this, "afterSetOptions");
        }
        function $(K, V, Q, Z, ee, J, ie) {
          let re, ce = this.axis;
          return ce.isRadial ? ["M", V, Q, "L", (re = ce.getPosition(this.pos, ce.center[2] / 2 + Z)).x, re.y] : K.call(this, V, Q, Z, ee, J, ie);
        }
        C.radialDefaultOptions = u(o), C.compose = function(K, V) {
          return M(I, "Axis.Radial") && (R(K, "afterInit", h), R(K, "autoLabelAlign", g), R(K, "destroy", k), R(K, "init", P), R(K, "initialAxisTranslation", O), R(V, "afterGetLabelPosition", z), R(V, "afterGetPosition", W), R(l, "setOptions", G), m(V.prototype, "getMarkPath", $)), K;
        };
      }(D || (D = {})), D;
    }), i(e, "Series/PolarComposition.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Globals.js"], e["Core/Series/Series.js"], e["Extensions/Pane/Pane.js"], e["Core/Axis/RadialAxis.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { animObject: I } = o, { composed: B } = n, { addEvent: R, defined: N, find: x, isNumber: T, merge: y, pick: S, pushUnique: u, relativeLength: A, splat: M, uniqueKey: f, wrap: m } = j;
      function C() {
        (this.pane || []).forEach((G) => {
          G.render();
        });
      }
      function F(G) {
        let Y = G.args[0].xAxis, U = G.args[0].yAxis, H = G.args[0].chart;
        Y && U && (U.gridLineInterpolation === "polygon" ? (Y.startOnTick = !0, Y.endOnTick = !0) : Y.gridLineInterpolation === "polygon" && H.inverted && (U.startOnTick = !0, U.endOnTick = !0));
      }
      function _() {
        this.pane || (this.pane = []), this.options.pane = M(this.options.pane), this.options.pane.forEach((G) => {
          new L(G, this);
        }, this);
      }
      function E(G) {
        let Y = G.args.marker, U = this.chart.xAxis[0], H = this.chart.yAxis[0], q = this.chart.inverted, X = q ? H : U, $ = q ? U : H;
        if (this.chart.polar) {
          G.preventDefault();
          let K = (Y.attr ? Y.attr("start") : Y.start) - X.startAngleRad, V = Y.attr ? Y.attr("r") : Y.r, Q = (Y.attr ? Y.attr("end") : Y.end) - X.startAngleRad, Z = Y.attr ? Y.attr("innerR") : Y.innerR;
          G.result.x = K + X.pos, G.result.width = Q - K, G.result.y = $.len + $.pos - V, G.result.height = V - Z;
        }
      }
      function v(G) {
        let Y = this.chart;
        if (Y.polar && Y.hoverPane && Y.hoverPane.axis) {
          G.preventDefault();
          let U = Y.hoverPane.center, H = Y.mouseDownX || 0, q = Y.mouseDownY || 0, X = G.args.chartY, $ = G.args.chartX, K = 2 * Math.PI, V = Y.hoverPane.axis.startAngleRad, Q = Y.hoverPane.axis.endAngleRad, Z = Y.inverted ? Y.xAxis[0] : Y.yAxis[0], ee = {}, J = "arc";
          if (ee.x = U[0] + Y.plotLeft, ee.y = U[1] + Y.plotTop, this.zoomHor) {
            let ie = V > 0 ? Q - V : Math.abs(V) + Math.abs(Q), re = Math.atan2(q - Y.plotTop - U[1], H - Y.plotLeft - U[0]) - V, ce = Math.atan2(X - Y.plotTop - U[1], $ - Y.plotLeft - U[0]) - V;
            ee.r = U[2] / 2, ee.innerR = U[3] / 2, re <= 0 && (re += K), ce <= 0 && (ce += K), ce < re && (ce = [re, re = ce][0]), ie < K && V + ce > Q + (K - ie) / 2 && (ce = re, re = V <= 0 ? V : 0);
            let he = ee.start = Math.max(re + V, V), ne = ee.end = Math.min(ce + V, Q);
            if (Z.options.gridLineInterpolation === "polygon") {
              let oe = Y.hoverPane.axis, se = he - oe.startAngleRad + oe.pos, te = Z.getPlotLinePath({ value: Z.max }), ae = oe.toValue(se), le = oe.toValue(se + (ne - he));
              if (ae < oe.getExtremes().min) {
                let { min: de, max: be } = oe.getExtremes();
                ae = be - (de - ae);
              }
              if (le < oe.getExtremes().min) {
                let { min: de, max: be } = oe.getExtremes();
                le = be - (de - le);
              }
              le < ae && (le = [ae, ae = le][0]), (te = s(te, ae, le, oe)).push(["L", U[0] + Y.plotLeft, Y.plotTop + U[1]]), ee.d = te, J = "path";
            }
          }
          if (this.zoomVert) {
            let ie = Y.inverted ? Y.xAxis[0] : Y.yAxis[0], re = Math.sqrt(Math.pow(H - Y.plotLeft - U[0], 2) + Math.pow(q - Y.plotTop - U[1], 2)), ce = Math.sqrt(Math.pow($ - Y.plotLeft - U[0], 2) + Math.pow(X - Y.plotTop - U[1], 2));
            if (ce < re && (re = [ce, ce = re][0]), ce > U[2] / 2 && (ce = U[2] / 2), re < U[3] / 2 && (re = U[3] / 2), this.zoomHor || (ee.start = V, ee.end = Q), ee.r = ce, ee.innerR = re, ie.options.gridLineInterpolation === "polygon") {
              let he = ie.toValue(ie.len + ie.pos - re), ne = ie.toValue(ie.len + ie.pos - ce), oe = ie.getPlotLinePath({ value: ne }).concat(ie.getPlotLinePath({ value: he, reverse: !0 }));
              ee.d = oe, J = "path";
            }
          }
          if (this.zoomHor && this.zoomVert && Z.options.gridLineInterpolation === "polygon") {
            let ie = Y.hoverPane.axis, re = ee.start || 0, ce = ee.end || 0, he = re - ie.startAngleRad + ie.pos, ne = ie.toValue(he), oe = ie.toValue(he + (ce - re));
            if (ee.d instanceof Array) {
              let se = ee.d.slice(0, ee.d.length / 2), te = ee.d.slice(ee.d.length / 2, ee.d.length);
              te = [...te].reverse();
              let ae = Y.hoverPane.axis;
              se = s(se, ne, oe, ae), (te = s(te, ne, oe, ae)) && (te[0][0] = "L"), te = [...te].reverse(), ee.d = se.concat(te), J = "path";
            }
          }
          G.attrs = ee, G.shapeType = J;
        }
      }
      function w() {
        let G = this.chart;
        G.polar && (this.polar = new W(this), G.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
      }
      function d() {
        if (this.chart.polar && this.xAxis) {
          let { xAxis: G, yAxis: Y } = this, U = this.chart;
          this.kdByAngle = U.tooltip && U.tooltip.shared, this.kdByAngle || U.inverted ? this.searchPoint = r : this.options.findNearestPointBy = "xy";
          let H = this.points, q = H.length;
          for (; q--; ) this.is("column") || this.is("columnrange") || this.polar.toXY(H[q]), U.hasParallelCoordinates || this.yAxis.reversed || (S(H[q].y, Number.MIN_VALUE) < Y.min || H[q].x < G.min || H[q].x > G.max ? (H[q].isNull = !0, H[q].plotY = NaN) : H[q].isNull = H[q].isValid && !H[q].isValid());
          this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(R(this, "afterRender", function() {
            let X;
            U.polar && this.options.clip !== !1 && (X = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: X[0], y: X[1], r: X[2] / 2, innerR: X[3] / 2 }) : this.clipCircle = function($, K, V, Q, Z) {
              let ee = f(), J = $.createElement("clipPath").attr({ id: ee }).add($.defs), ie = Z ? $.arc(K, V, Q, Z, 0, 2 * Math.PI).add(J) : $.circle(K, V, Q).add(J);
              return ie.id = ee, ie.clipPath = J, ie;
            }(U.renderer, X[0], X[1], X[2] / 2, X[3] / 2), this.group.clip(this.clipCircle), this.setClip = n.noop);
          })));
        }
      }
      function r(G) {
        let Y = this.chart, U = this.xAxis, H = this.yAxis, q = U.pane && U.pane.center, X = G.chartX - (q && q[0] || 0) - Y.plotLeft, $ = G.chartY - (q && q[1] || 0) - Y.plotTop, K = Y.inverted ? { clientX: G.chartX - H.pos, plotY: G.chartY - U.pos } : { clientX: 180 + -180 / Math.PI * Math.atan2(X, $) };
        return this.searchKDTree(K);
      }
      function s(G, Y, U, H) {
        let q = H.tickInterval, X = H.tickPositions, $ = x(X, (V) => V >= U), K = x([...X].reverse(), (V) => V <= Y);
        return N($) || ($ = X[X.length - 1]), N(K) || (K = X[0], $ += q, G[0][0] = "L", G.unshift(G[G.length - 3])), (G = G.slice(X.indexOf(K), X.indexOf($) + 1))[0][0] = "M", G;
      }
      function p(G, Y) {
        return x(this.pane || [], (U) => U.options.id === Y) || G.call(this, Y);
      }
      function b(G, Y, U, H, q, X) {
        let $, K, V, Q = this.chart, Z = S(H.inside, !!this.options.stacking);
        if (Q.polar) {
          if ($ = Y.rectPlotX / Math.PI * 180, Q.inverted) this.forceDL = Q.isInsidePlot(Y.plotX, Y.plotY), Z && Y.shapeArgs ? (K = Y.shapeArgs, q = y(q, { x: (V = this.yAxis.postTranslate(((K.start || 0) + (K.end || 0)) / 2 - this.xAxis.startAngleRad, Y.barX + Y.pointWidth / 2)).x - Q.plotLeft, y: V.y - Q.plotTop })) : Y.tooltipPos && (q = y(q, { x: Y.tooltipPos[0], y: Y.tooltipPos[1] })), H.align = S(H.align, "center"), H.verticalAlign = S(H.verticalAlign, "middle");
          else {
            var ee;
            let J, ie;
            (ee = H).align === null && (J = $ > 20 && $ < 160 ? "left" : $ > 200 && $ < 340 ? "right" : "center", ee.align = J), ee.verticalAlign === null && (ie = $ < 45 || $ > 315 ? "bottom" : $ > 135 && $ < 225 ? "top" : "middle", ee.verticalAlign = ie), H = ee;
          }
          l.prototype.alignDataLabel.call(this, Y, U, H, q, X), this.isRadialBar && Y.shapeArgs && Y.shapeArgs.start === Y.shapeArgs.end ? U.hide() : U.show();
        } else G.call(this, Y, U, H, q, X);
      }
      function c() {
        let G = this.options, Y = G.stacking, U = this.chart, H = this.xAxis, q = this.yAxis, X = q.reversed, $ = q.center, K = H.startAngleRad, V = H.endAngleRad - K, Q = G.threshold, Z = 0, ee, J, ie, re, ce, he = 0, ne = 0, oe, se, te, ae, le, de, be, ge;
        if (H.isRadial) for (ie = (ee = this.points).length, re = q.translate(q.min), ce = q.translate(q.max), Q = G.threshold || 0, U.inverted && T(Q) && N(Z = q.translate(Q)) && (Z < 0 ? Z = 0 : Z > V && (Z = V), this.translatedThreshold = Z + K); ie--; ) {
          if (de = (J = ee[ie]).barX, se = J.x, te = J.y, J.shapeType = "arc", U.inverted) {
            J.plotY = q.translate(te), Y && q.stacking ? (le = q.stacking.stacks[(te < 0 ? "-" : "") + this.stackKey], this.visible && le && le[se] && !J.isNull && (ae = le[se].points[this.getStackIndicator(void 0, se, this.index).key], he = q.translate(ae[0]), ne = q.translate(ae[1]), N(he) && (he = j.clamp(he, 0, V)))) : (he = Z, ne = J.plotY), he > ne && (ne = [he, he = ne][0]), X ? ne > re ? ne = re : he < ce ? he = ce : (he > re || ne < ce) && (he = ne = V) : he < re ? he = re : ne > ce ? ne = ce : (ne < re || he > ce) && (he = ne = 0), q.min > q.max && (he = ne = X ? V : 0), he += K, ne += K, $ && (J.barX = de += $[3] / 2), be = Math.max(de, 0), ge = Math.max(de + J.pointWidth, 0);
            let me = G.borderRadius, fe = A((typeof me == "object" ? me.radius : me) || 0, ge - be);
            J.shapeArgs = { x: $[0], y: $[1], r: ge, innerR: be, start: he, end: ne, borderRadius: fe }, J.opacity = he === ne ? 0 : void 0, J.plotY = (N(this.translatedThreshold) && (he < this.translatedThreshold ? he : ne)) - K;
          } else he = de + K, J.shapeArgs = this.polar.arc(J.yBottom, J.plotY, he, he + J.pointWidth), J.shapeArgs.borderRadius = 0;
          this.polar.toXY(J), U.inverted ? (oe = q.postTranslate(J.rectPlotY, de + J.pointWidth / 2), J.tooltipPos = [oe.x - U.plotLeft, oe.y - U.plotTop]) : J.tooltipPos = [J.plotX, J.plotY], $ && (J.ttBelow = J.plotY > $[1]);
        }
      }
      function h(G, Y) {
        let U, H, q = this;
        if (this.chart.polar) {
          Y = Y || this.points;
          for (let $ = 0; $ < Y.length; $++) if (!Y[$].isNull) {
            U = $;
            break;
          }
          this.options.connectEnds !== !1 && U !== void 0 && (this.connectEnds = !0, Y.splice(Y.length, 0, Y[U]), H = !0), Y.forEach(($) => {
            $.polarPlotY === void 0 && q.polar.toXY($);
          });
        }
        let X = G.apply(this, [].slice.call(arguments, 1));
        return H && Y.pop(), X;
      }
      function g(G, Y) {
        let U = this.chart, H = { xAxis: [], yAxis: [] };
        return U.polar ? U.axes.forEach((q) => {
          if (q.coll === "colorAxis") return;
          let X = q.isXAxis, $ = q.center, K = Y.chartX - $[0] - U.plotLeft, V = Y.chartY - $[1] - U.plotTop;
          H[X ? "xAxis" : "yAxis"].push({ axis: q, value: q.translate(X ? Math.PI - Math.atan2(K, V) : Math.sqrt(Math.pow(K, 2) + Math.pow(V, 2)), !0) });
        }) : H = G.call(this, Y), H;
      }
      function k(G, Y) {
        this.chart.polar || G.call(this, Y);
      }
      function P(G, Y) {
        let U = this, H = this.chart, q = this.group, X = this.markerGroup, $ = this.xAxis && this.xAxis.center, K = H.plotLeft, V = H.plotTop, Q = this.options.animation, Z, ee, J, ie, re, ce;
        H.polar ? U.isRadialBar ? Y || (U.startAngleRad = S(U.translatedThreshold, U.xAxis.startAngleRad), n.seriesTypes.pie.prototype.animate.call(U, Y)) : (Q = I(Q), U.is("column") ? Y || (ee = $[3] / 2, U.points.forEach((he) => {
          J = he.graphic, re = (ie = he.shapeArgs) && ie.r, ce = ie && ie.innerR, J && ie && (J.attr({ r: ee, innerR: ee }), J.animate({ r: re, innerR: ce }, U.options.animation));
        })) : Y ? (Z = { translateX: $[0] + K, translateY: $[1] + V, scaleX: 1e-3, scaleY: 1e-3 }, q.attr(Z), X && X.attr(Z)) : (Z = { translateX: K, translateY: V, scaleX: 1, scaleY: 1 }, q.animate(Z, Q), X && X.animate(Z, Q))) : G.call(this, Y);
      }
      function O(G, Y, U, H) {
        let q, X;
        if (this.chart.polar)
          if (H) {
            let $ = (X = function V(Q, Z, ee, J) {
              let ie, re, ce, he, ne, oe, se = J ? 1 : 0, te = (ie = Z >= 0 && Z <= Q.length - 1 ? Z : Z < 0 ? Q.length - 1 + Z : 0) - 1 < 0 ? Q.length - (1 + se) : ie - 1, ae = ie + 1 > Q.length - 1 ? se : ie + 1, le = Q[te], de = Q[ae], be = le.plotX, ge = le.plotY, me = de.plotX, fe = de.plotY, Ae = Q[ie].plotX, ye = Q[ie].plotY;
              re = (1.5 * Ae + be) / 2.5, ce = (1.5 * ye + ge) / 2.5, he = (1.5 * Ae + me) / 2.5, ne = (1.5 * ye + fe) / 2.5;
              let xe = Math.sqrt(Math.pow(re - Ae, 2) + Math.pow(ce - ye, 2)), we = Math.sqrt(Math.pow(he - Ae, 2) + Math.pow(ne - ye, 2)), ke = Math.atan2(ce - ye, re - Ae);
              oe = Math.PI / 2 + (ke + Math.atan2(ne - ye, he - Ae)) / 2, Math.abs(ke - oe) > Math.PI / 2 && (oe -= Math.PI), re = Ae + Math.cos(oe) * xe, ce = ye + Math.sin(oe) * xe;
              let Oe = { rightContX: he = Ae + Math.cos(Math.PI + oe) * we, rightContY: ne = ye + Math.sin(Math.PI + oe) * we, leftContX: re, leftContY: ce, plotX: Ae, plotY: ye };
              return ee && (Oe.prevPointCont = V(Q, te, !1, J)), Oe;
            }(Y, H, !0, this.connectEnds)).prevPointCont && X.prevPointCont.rightContX, K = X.prevPointCont && X.prevPointCont.rightContY;
            q = ["C", T($) ? $ : X.plotX, T(K) ? K : X.plotY, T(X.leftContX) ? X.leftContX : X.plotX, T(X.leftContY) ? X.leftContY : X.plotY, X.plotX, X.plotY];
          } else q = ["M", U.plotX, U.plotY];
        else q = G.call(this, Y, U, H);
        return q;
      }
      function z(G, Y, U = this.plotY) {
        if (!this.destroyed) {
          let { plotX: H, series: q } = this, { chart: X } = q;
          return X.polar && T(H) && T(U) ? [H + (Y ? X.plotLeft : 0), U + (Y ? X.plotTop : 0)] : G.call(this, Y, U);
        }
      }
      class W {
        static compose(Y, U, H, q, X, $, K, V, Q, Z) {
          if (L.compose(U, H), D.compose(Y, X), u(B, "Polar")) {
            let ee = U.prototype, J = $.prototype, ie = H.prototype, re = q.prototype;
            if (R(U, "afterDrawChartBox", C), R(U, "getAxes", _), R(U, "init", F), m(ee, "get", p), m(ie, "getCoordinates", g), m(ie, "pinch", k), R(H, "getSelectionMarkerAttrs", v), R(H, "getSelectionBox", E), R(q, "afterInit", w), R(q, "afterTranslate", d, { order: 2 }), R(q, "afterColumnTranslate", c, { order: 4 }), m(re, "animate", P), m(J, "pos", z), V) {
              let ce = V.prototype;
              m(ce, "alignDataLabel", b), m(ce, "animate", P);
            }
            if (Q && m(Q.prototype, "getGraphPath", h), Z) {
              let ce = Z.prototype;
              m(ce, "getPointSpline", O), K && (K.prototype.getPointSpline = ce.getPointSpline);
            }
          }
        }
        constructor(Y) {
          this.series = Y;
        }
        arc(Y, U, H, q) {
          let X = this.series, $ = X.xAxis.center, K = X.yAxis.len, V = $[3] / 2, Q = K - U + V, Z = K - S(Y, K) + V;
          return X.yAxis.reversed && (Q < 0 && (Q = V), Z < 0 && (Z = V)), { x: $[0], y: $[1], r: Q, innerR: Z, start: H, end: q };
        }
        toXY(Y) {
          let U = this.series, H = U.chart, q = U.xAxis, X = U.yAxis, $ = Y.plotX, K = H.inverted, V = Y.y, Q = Y.plotY, Z = K ? $ : X.len - Q, ee;
          if (K && U && !U.isRadialBar && (Y.plotY = Q = T(V) ? X.translate(V) : 0), Y.rectPlotX = $, Y.rectPlotY = Q, X.center && (Z += X.center[3] / 2), T(Q)) {
            let J = K ? X.postTranslate(Q, Z) : q.postTranslate($, Z);
            Y.plotX = Y.polarPlotX = J.x - H.plotLeft, Y.plotY = Y.polarPlotY = J.y - H.plotTop;
          }
          U.kdByAngle ? ((ee = ($ / Math.PI * 180 + q.pane.options.startAngle) % 360) < 0 && (ee += 360), Y.clientX = ee) : Y.clientX = Y.plotX;
        }
      }
      return W;
    }), i(e, "Core/Axis/WaterfallAxis.js", [e["Core/Globals.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L;
      let { composed: D } = o, { addEvent: j, objectEach: I, pushUnique: B } = l;
      return function(R) {
        function N() {
          let u = this.waterfall.stacks;
          u && (u.changed = !1, delete u.alreadyChanged);
        }
        function x() {
          let u = this.options.stackLabels;
          u && u.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
        }
        function T() {
          this.waterfall || (this.waterfall = new S(this));
        }
        function y() {
          let u = this.axes;
          for (let A of this.series) if (A.options.stacking) {
            for (let M of u) M.isXAxis || (M.waterfall.stacks.changed = !0);
            break;
          }
        }
        R.compose = function(u, A) {
          B(D, "Axis.Waterfall") && (j(u, "init", T), j(u, "afterBuildStacks", N), j(u, "afterRender", x), j(A, "beforeRedraw", y));
        };
        class S {
          constructor(A) {
            this.axis = A, this.stacks = { changed: !1 };
          }
          renderStackTotals() {
            let A = this.axis, M = A.waterfall.stacks, f = A.stacking && A.stacking.stackTotalGroup, m = new n(A, A.options.stackLabels || {}, !1, 0, void 0);
            this.dummyStackItem = m, f && I(M, (C) => {
              I(C, (F, _) => {
                m.total = F.stackTotal, m.x = +_, F.label && (m.label = F.label), n.prototype.render.call(m, f), F.label = m.label, delete m.label;
              });
            }), m.total = null;
          }
        }
        R.Composition = S;
      }(L || (L = {})), L;
    }), i(e, "Series/Waterfall/WaterfallPoint.js", [e["Series/Column/ColumnSeries.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { isNumber: L } = l;
      class D extends o.prototype.pointClass {
        getClassName() {
          let I = n.prototype.getClassName.call(this);
          return this.isSum ? I += " highcharts-sum" : this.isIntermediateSum && (I += " highcharts-intermediate-sum"), I;
        }
        isValid() {
          return L(this.y) || this.isSum || !!this.isIntermediateSum;
        }
      }
      return D;
    }), i(e, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
      return { dataLabels: { inside: !0 }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } };
    }), i(e, "Series/Waterfall/WaterfallSeries.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"], e["Core/Axis/WaterfallAxis.js"], e["Series/Waterfall/WaterfallPoint.js"], e["Series/Waterfall/WaterfallSeriesDefaults.js"]], function(o, n, l, L, D) {
      let { column: j, line: I } = o.seriesTypes, { addEvent: B, arrayMax: R, arrayMin: N, correctFloat: x, crisp: T, extend: y, isNumber: S, merge: u, objectEach: A, pick: M } = n;
      function f(C, F) {
        return Object.hasOwnProperty.call(C, F);
      }
      class m extends j {
        generatePoints() {
          j.prototype.generatePoints.apply(this);
          for (let F = 0, _ = this.points.length; F < _; F++) {
            let E = this.points[F], v = this.processedYData[F];
            S(v) && (E.isIntermediateSum || E.isSum) && (E.y = x(v));
          }
        }
        processData(F) {
          let _, E, v, w, d, r, s = this.options, p = this.yData, b = s.data, c = p.length, h = s.threshold || 0;
          v = E = w = d = 0;
          for (let g = 0; g < c; g++) r = p[g], _ = b && b[g] ? b[g] : {}, r === "sum" || _.isSum ? p[g] = x(v) : r === "intermediateSum" || _.isIntermediateSum ? (p[g] = x(E), E = 0) : (v += r, E += r), w = Math.min(v, w), d = Math.max(v, d);
          super.processData.call(this, F), s.stacking || (this.dataMin = w + h, this.dataMax = d);
        }
        toYData(F) {
          return F.isSum ? "sum" : F.isIntermediateSum ? "intermediateSum" : F.y;
        }
        updateParallelArrays(F, _) {
          super.updateParallelArrays.call(this, F, _), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
        }
        pointAttribs(F, _) {
          let E = this.options.upColor;
          E && !F.options.color && S(F.y) && (F.color = F.y > 0 ? E : void 0);
          let v = j.prototype.pointAttribs.call(this, F, _);
          return delete v.dashstyle, v;
        }
        getGraphPath() {
          return [["M", 0, 0]];
        }
        getCrispPath() {
          var p;
          let F = this.data.filter((b) => S(b.y)), _ = this.yAxis, E = F.length, v = ((p = this.graph) == null ? void 0 : p.strokeWidth()) || 0, w = this.xAxis.reversed, d = this.yAxis.reversed, r = this.options.stacking, s = [];
          for (let b = 1; b < E; b++) {
            if (!(this.options.connectNulls || S(this.data[F[b].index - 1].y))) continue;
            let c = F[b].box, h = F[b - 1], g = h.y || 0, k = F[b - 1].box;
            if (!c || !k) continue;
            let P = _.waterfall.stacks[this.stackKey], O = g > 0 ? -k.height : 0;
            if (P && k && c) {
              let z, W = P[b - 1];
              if (r) {
                let G = W.connectorThreshold;
                z = T(_.translate(G, !1, !0, !1, !0) + (d ? O : 0), v);
              } else z = T(k.y + (h.minPointLengthOffset || 0), v);
              s.push(["M", (k.x || 0) + (w ? 0 : k.width || 0), z], ["L", (c.x || 0) + (w && c.width || 0), z]);
            }
            if (k && s.length && (!r && g < 0 && !d || g > 0 && d)) {
              let z = s[s.length - 2];
              z && typeof z[2] == "number" && (z[2] += k.height || 0);
              let W = s[s.length - 1];
              W && typeof W[2] == "number" && (W[2] += k.height || 0);
            }
          }
          return s;
        }
        drawGraph() {
          I.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
        }
        setStackedPoints(F) {
          var q;
          let _ = this.options, E = (q = F.waterfall) == null ? void 0 : q.stacks, v = _.threshold || 0, w = this.stackKey, d = this.xData, r = d.length, s = v, p = s, b, c = 0, h = 0, g = 0, k, P, O, z, W, G, Y, U, H = (X, $, K, V) => {
            if (b) {
              if (k) for (; K < k; K++) b.stackState[K] += V;
              else b.stackState[0] = X, k = b.stackState.length;
              b.stackState.push(b.stackState[k - 1] + $);
            }
          };
          if (F.stacking && E && this.reserveSpace()) {
            U = E.changed, (Y = E.alreadyChanged) && 0 > Y.indexOf(w) && (U = !0), E[w] || (E[w] = {});
            let X = E[w];
            if (X) for (let $ = 0; $ < r; $++) (!X[G = d[$]] || U) && (X[G] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: U && X[G] ? X[G].label : void 0 }), b = X[G], (W = this.yData[$]) >= 0 ? b.posTotal += W : b.negTotal += W, z = _.data[$], P = b.absolutePos = b.posTotal, O = b.absoluteNeg = b.negTotal, b.stackTotal = P + O, k = b.stackState.length, z && z.isIntermediateSum ? (H(g, h, 0, g), g = h, h = v, s ^= p, p ^= s, s ^= p) : z && z.isSum ? (H(v, c, k, 0), s = v) : (H(s, W, 0, c), z && (c += W, h += W)), b.stateIndex++, b.threshold = s, s += b.stackTotal;
            E.changed = !1, E.alreadyChanged || (E.alreadyChanged = []), E.alreadyChanged.push(w);
          }
        }
        getExtremes() {
          let F, _, E, v = this.options.stacking;
          return v ? (F = this.yAxis.waterfall.stacks, _ = this.stackedYNeg = [], E = this.stackedYPos = [], v === "overlap" ? A(F[this.stackKey], function(w) {
            _.push(N(w.stackState)), E.push(R(w.stackState));
          }) : A(F[this.stackKey], function(w) {
            _.push(w.negTotal + w.threshold), E.push(w.posTotal + w.threshold);
          }), { dataMin: N(_), dataMax: R(E) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
        }
      }
      return m.defaultOptions = u(j.defaultOptions, D), m.compose = l.compose, y(m.prototype, { pointValKey: "y", showLine: !0, pointClass: L }), B(m, "afterColumnTranslate", function() {
        let { options: C, points: F, yAxis: _ } = this, E = M(C.minPointLength, 5), v = E / 2, w = C.threshold || 0, d = C.stacking, r = _.waterfall.stacks[this.stackKey], s = w, p = w, b, c, h, g;
        for (let k = 0; k < F.length; k++) {
          let P = F[k], O = this.processedYData[k], z = y({ x: 0, y: 0, width: 0, height: 0 }, P.shapeArgs || {});
          P.box = z;
          let W = [0, O], G = P.y || 0;
          if (d) {
            if (r) {
              let H = r[k];
              d === "overlap" ? (c = H.stackState[H.stateIndex--], b = G >= 0 ? c : c - G, f(H, "absolutePos") && delete H.absolutePos, f(H, "absoluteNeg") && delete H.absoluteNeg) : (G >= 0 ? (c = H.threshold + H.posTotal, H.posTotal -= G, b = c) : (c = H.threshold + H.negTotal, H.negTotal -= G, b = c - G), !H.posTotal && S(H.absolutePos) && f(H, "absolutePos") && (H.posTotal = H.absolutePos, delete H.absolutePos), !H.negTotal && S(H.absoluteNeg) && f(H, "absoluteNeg") && (H.negTotal = H.absoluteNeg, delete H.absoluteNeg)), P.isSum || (H.connectorThreshold = H.threshold + H.stackTotal), _.reversed ? (h = G >= 0 ? b - G : b + G, g = b) : (h = b, g = b - G), P.below = h <= w, z.y = _.translate(h, !1, !0, !1, !0), z.height = Math.abs(z.y - _.translate(g, !1, !0, !1, !0));
              let q = _.waterfall.dummyStackItem;
              q && (q.x = k, q.label = r[k].label, q.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[k], this.stackedYPos[k], void 0, this.xAxis));
            }
          } else b = Math.max(p, p + G) + W[0], z.y = _.translate(b, !1, !0, !1, !0), P.isSum ? (z.y = _.translate(W[1], !1, !0, !1, !0), z.height = Math.min(_.translate(W[0], !1, !0, !1, !0), _.len) - z.y, P.below = W[1] <= w) : P.isIntermediateSum ? (G >= 0 ? (h = W[1] + s, g = s) : (h = s, g = W[1] + s), _.reversed && (h ^= g, g ^= h, h ^= g), z.y = _.translate(h, !1, !0, !1, !0), z.height = Math.abs(z.y - Math.min(_.translate(g, !1, !0, !1, !0), _.len)), s += W[1], P.below = h <= w) : (z.height = O > 0 ? _.translate(p, !1, !0, !1, !0) - z.y : _.translate(p, !1, !0, !1, !0) - _.translate(p - O, !1, !0, !1, !0), p += O, P.below = p < w), z.height < 0 && (z.y += z.height, z.height *= -1);
          P.plotY = z.y, P.yBottom = z.y + z.height, z.height <= E && !P.isNull ? (z.height = E, z.y -= v, P.yBottom = z.y + z.height, P.plotY = z.y, G < 0 ? P.minPointLengthOffset = -v : P.minPointLengthOffset = v) : (P.isNull && (z.width = 0), P.minPointLengthOffset = 0);
          let Y = P.plotY + (P.negative ? z.height : 0);
          P.below && (P.plotY += z.height), P.tooltipPos && (this.chart.inverted ? P.tooltipPos[0] = _.len - Y : P.tooltipPos[1] = Y), P.isInside = this.isPointInside(P);
          let U = T(P.yBottom, this.borderWidth);
          z.y = T(z.y, this.borderWidth), z.height = U - z.y, u(!0, P.shapeArgs, z);
        }
      }, { order: 2 }), o.registerSeriesType("waterfall", m), m;
    }), i(e, "masters/highcharts-more.src.js", [e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Extensions/Pane/Pane.js"], e["Series/Bubble/BubbleSeries.js"], e["Series/PackedBubble/PackedBubbleSeries.js"], e["Series/PolarComposition.js"], e["Core/Axis/RadialAxis.js"], e["Series/Waterfall/WaterfallSeries.js"]], function(o, n, l, L, D, j, I, B) {
      return o.RadialAxis = I, L.compose(o.Axis, o.Chart, o.Legend), D.compose(o.Axis, o.Chart, o.Legend), l.compose(o.Chart, o.Pointer), j.compose(o.Axis, o.Chart, o.Pointer, o.Series, o.Tick, o.Point, n.seriesTypes.areasplinerange, n.seriesTypes.column, n.seriesTypes.line, n.seriesTypes.spline), B.compose(o.Axis, o.Chart), o;
    });
  });
})(qv);
var CO = qv.exports;
const SO = /* @__PURE__ */ ri(CO);
var Yv = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Solid angular gauge module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Core/Axis/Color/ColorAxisLike.js", [e["Core/Color/Color.js"], e["Core/Utilities.js"]], function(o, n) {
      var l, L;
      let { parse: D } = o, { merge: j } = n;
      return (L = l || (l = {})).initDataClasses = function(I) {
        let B = this.chart, R = this.legendItem = this.legendItem || {}, N = this.options, x = I.dataClasses || [], T, y, S = B.options.chart.colorCount, u = 0, A;
        this.dataClasses = y = [], R.labels = [];
        for (let M = 0, f = x.length; M < f; ++M) T = j(T = x[M]), y.push(T), (B.styledMode || !T.color) && (N.dataClassColor === "category" ? (B.styledMode || (S = (A = B.options.colors || []).length, T.color = A[u]), T.colorIndex = u, ++u === S && (u = 0)) : T.color = D(N.minColor).tweenTo(D(N.maxColor), f < 2 ? 0.5 : M / (f - 1)));
      }, L.initStops = function() {
        let I = this.options, B = this.stops = I.stops || [[0, I.minColor || ""], [1, I.maxColor || ""]];
        for (let R = 0, N = B.length; R < N; ++R) B[R].color = D(B[R][1]);
      }, L.normalizedValue = function(I) {
        let B = this.max || 0, R = this.min || 0;
        return this.logarithmic && (I = this.logarithmic.log2lin(I)), 1 - (B - I) / (B - R || 1);
      }, L.toColor = function(I, B) {
        let R, N, x, T, y, S, u = this.dataClasses, A = this.stops;
        if (u) {
          for (S = u.length; S--; ) if (N = (y = u[S]).from, x = y.to, (N === void 0 || I >= N) && (x === void 0 || I <= x)) {
            T = y.color, B && (B.dataClass = S, B.colorIndex = y.colorIndex);
            break;
          }
        } else {
          for (R = this.normalizedValue(I), S = A.length; S-- && !(R > A[S][0]); ) ;
          N = A[S] || A[S + 1], R = 1 - ((x = A[S + 1] || N)[0] - R) / (x[0] - N[0] || 1), T = N.color.tweenTo(x.color, R);
        }
        return T;
      }, l;
    }), i(e, "Core/Axis/SolidGaugeAxis.js", [e["Core/Axis/Color/ColorAxisLike.js"], e["Core/Utilities.js"]], function(o, n) {
      let { extend: l } = n;
      return { init: function(L) {
        l(L, o);
      } };
    }), i(e, "Series/SolidGauge/SolidGaugeSeriesDefaults.js", [], function() {
      return { colorByPoint: !0, dataLabels: { y: 0 } };
    }), i(e, "Series/SolidGauge/SolidGaugeSeries.js", [e["Extensions/BorderRadius.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Axis/SolidGaugeAxis.js"], e["Series/SolidGauge/SolidGaugeSeriesDefaults.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { gauge: j, pie: I } = n.seriesTypes, { clamp: B, extend: R, isNumber: N, merge: x, pick: T, pInt: y } = D;
      class S extends j {
        translate() {
          let A = this.yAxis;
          l.init(A), !A.dataClasses && A.options.dataClasses && A.initDataClasses(A.options), A.initStops(), j.prototype.translate.call(this);
        }
        drawPoints() {
          let A, M = this.yAxis, f = M.center, m = this.options, C = this.chart.renderer, F = m.overshoot, _ = m.rounded && m.borderRadius === void 0, E = N(F) ? F / 180 * Math.PI : 0;
          for (let v of (N(m.threshold) && (A = M.startAngleRad + M.translate(m.threshold, void 0, void 0, void 0, !0)), this.thresholdAngleRad = T(A, M.startAngleRad), this.points)) if (!v.isNull) {
            let w = y(T(v.options.radius, m.radius, 100)) * f[2] / 200, d = y(T(v.options.innerRadius, m.innerRadius, 60)) * f[2] / 200, r = Math.min(M.startAngleRad, M.endAngleRad), s = Math.max(M.startAngleRad, M.endAngleRad), p = v.graphic, b = M.startAngleRad + M.translate(v.y, void 0, void 0, void 0, !0), c, h, g = M.toColor(v.y, v);
            g === "none" && (g = v.color || this.color || "none"), g !== "none" && (v.color = g), b = B(b, r - E, s + E), m.wrap === !1 && (b = B(b, r, s));
            let k = _ ? (w - d) / 2 / w : 0, P = Math.min(b, this.thresholdAngleRad) - k, O = Math.max(b, this.thresholdAngleRad) + k;
            O - P > 2 * Math.PI && (O = P + 2 * Math.PI);
            let z = _ ? "50%" : 0;
            m.borderRadius && (z = o.optionsToObject(m.borderRadius).radius), v.shapeArgs = c = { x: f[0], y: f[1], r: w, innerR: d, start: P, end: O, borderRadius: z }, v.startR = w, p ? (h = c.d, p.animate(R({ fill: g }, c)), h && (c.d = h)) : v.graphic = p = C.arc(c).attr({ fill: g, "sweep-flag": 0 }).add(this.group), this.chart.styledMode || (m.linecap !== "square" && p.attr({ "stroke-linecap": "round", "stroke-linejoin": "round" }), p.attr({ stroke: m.borderColor || "none", "stroke-width": m.borderWidth || 0 })), p && p.addClass(v.getClassName(), !0);
          }
        }
        animate(A) {
          A || (this.startAngleRad = this.thresholdAngleRad, I.prototype.animate.call(this, A));
        }
      }
      return S.defaultOptions = x(j.defaultOptions, L), n.registerSeriesType("solidgauge", S), S;
    }), i(e, "masters/modules/solid-gauge.src.js", [e["Core/Globals.js"]], function(o) {
      return o;
    });
  });
})(Yv);
var EO = Yv.exports;
const MO = /* @__PURE__ */ ri(EO);
var vi = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.TARGET = "target", a.SUBDIVIDED = "subdivided", a))(vi || {}), Qr = /* @__PURE__ */ ((a) => (a.NORMAL = "normal", a.TINTED = "tinted", a.FUNCTIONAL = "functional", a))(Qr || {});
const it = {
  beaconTagName: "beacon-gauge-chart",
  attribute: {
    name: "name",
    value: "value",
    valueSuffix: "value-suffix",
    valuePrefix: "value-prefix",
    metricDescription: "metric-description",
    gaugeTarget: "target",
    targetRange: "target-range",
    gaugeMin: "min",
    gaugeMax: "max",
    metricScale: "metric-scale",
    colorType: "color-type",
    hideMetric: "hide-metric",
    disableSort: "disable-sort",
    gaugeLabels: "gauge-labels",
    subdividedBands: "subdivided-bands",
    labelDistance: "label-distance",
    sections: "sections",
    hideLabels: "hide-labels"
  },
  plotBandThickness: "20%",
  minimumSizeJumbo: 272,
  // Minimum width of gauge chart for jumbo variant
  minimumSizeDefault: 198,
  // Minimum width of gauge chart for mini and normal variant
  margin: 20
  //margin is to make sure the gauge chart is not touching the edge of the container
}, TO = ve`.highcharts-grid-line{display:none}.highcharts-yaxis .highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-dial,.highcharts-pivot,.highcharts-minor-grid-line,.highcharts-plot-lines-10,.hide-grid>.highcharts-grid-line{display:none}.gauge-value,.gauge-background,.gauge-target{cursor:pointer;fill-opacity:1}.gauge-tint-100{fill:var(--beacon-reference-palette-charts-dark-blue-dt-1)}.gauge-tint-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-200{fill:var(--beacon-reference-palette-charts-dark-blue-dt-2)}.gauge-tint-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-300{fill:var(--beacon-reference-palette-charts-dark-blue-dt-3)}.gauge-tint-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-400{fill:var(--beacon-reference-palette-charts-dark-blue-dt-4)}.gauge-tint-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-tint-500{fill:var(--beacon-reference-palette-charts-dark-blue-dt-5)}.gauge-tint-legend-500{--beacon-chart-override-drilldown-series-color-0: $color}:host(*){--gauge-chart-functional-color-fill-1: var(--beacon-reference-palette-functional-red-3);--gauge-chart-functional-color-fill-2: #ed6e11;--gauge-chart-functional-color-fill-3: #ffad00;--gauge-chart-functional-color-fill-4: #248647}:host(*) .gauge-functional-100{fill:var(--gauge-chart-functional-color-fill-1)}:host(*) .gauge-functional-legend-100{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-200{fill:var(--gauge-chart-functional-color-fill-2)}:host(*) .gauge-functional-legend-200{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-300{fill:var(--gauge-chart-functional-color-fill-3)}:host(*) .gauge-functional-legend-300{--beacon-chart-override-drilldown-series-color-0: $color}:host(*) .gauge-functional-400{fill:var(--gauge-chart-functional-color-fill-4)}:host(*) .gauge-functional-legend-400{--beacon-chart-override-drilldown-series-color-0: $color}.gauge-target{fill:var(--beacon-component-scrollbar-color-background-track)}.gauge-background{fill:var(--beacon-system-color-background-1);stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}.key-fact{text-align:center;transform:translateY(calc(-1 * var(--key-fact-transform)));white-space:normal;word-wrap:break-word}.key-fact.jumbo{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-600);--key-fact-transform: var(--beacon-reference-font-scale-13)}.key-fact.mini{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);--key-fact-transform: var(--beacon-reference-font-scale-7)}.key-fact.normal{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-400);--key-fact-transform: var(--beacon-reference-font-scale-9)}.key-fact-description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-100);overflow-wrap:break-word;white-space:pre-wrap;word-wrap:break-word}.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0)}`;
var LO = Object.defineProperty, Tt = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && LO(t, e, o), o;
};
function OO(a) {
  return !!Array.isArray(a.plotLinesAndBands);
}
function PO(a) {
  return typeof a.pane == "number";
}
function Fg(a) {
  return "metricHTML" in a;
}
function DO(a) {
  return a.html !== void 0;
}
const { beaconTagName: jg } = it;
SO(vt);
MO(vt);
var wt;
const Et = (wt = class extends Ge(tt).with(
  xn,
  Zs
) {
  constructor() {
    super(...arguments), this.beaconTagName = jg, this.gaugeName = "Standard", this.gaugeValueProp = 0, this.valueSuffix = "", this.valuePrefix = "", this.metricDescription = "", this.gaugeTarget = 0, this.targetRange = 0, this.gaugeMin = 0, this.gaugeMax = 100, this.variant = vi.STANDARD, this.metricScale = ln.NORMAL, this.colorType = Qr.NORMAL, this.hideMetric = !1, this.disableSort = !1, this.gaugeLabels = [], this.subdividedBandsProp = [], this.labelDistance = 12, this.sections = 2, this.hideLabels = !1, this.staticLegend = !0, this.isChartUpdated = !1, this.resizeObserver = new ResizeObserver(
      jo(() => {
        this.chart && (this.isChartUpdated || (this.chart.update({
          chart: {
            marginTop: this.calculateChartMarginTop()
          }
        }), this.isChartUpdated = !0), this.setMinimumGaugeSize(this.chart), this.renderMetric(this.chart), wt.renderTicks(this.chart, this.variant), this.chart.redraw(), this.variant === vi.SUBDIVIDED && wt.plotBandHover(this.chart));
      }, 200)
      // The debounce function delays the execution of the function by 200 milliseconds to avoid excessive computations when the size of the chart changes rapidly
    ), this._type = $t.GAUGE;
  }
  static get styles() {
    return [super.styles, TO];
  }
  /**
   * Hover state for plot band for Subdivided variant only
   */
  static plotBandHover(t) {
    const e = t.yAxis[0];
    OO(e) && e.plotLinesAndBands.forEach(function(i) {
      vt.addEvent(i.svgElem.element, "mouseover", function() {
        e.plotLinesAndBands.forEach(function(o) {
          o !== i && o.svgElem.element.classList.contains("gauge-value") && o.svgElem.attr({
            opacity: 0.2
          });
        });
      }), vt.addEvent(i.svgElem.element, "mouseout", function() {
        e.plotLinesAndBands.forEach(function(o) {
          o.svgElem.attr({
            opacity: 1
            // Restore the original opacity
          });
        });
      });
    });
  }
  /**
   * Sets the gauge value to the sum of the subdivided bands otherwise returns what is passed via the prop
   */
  get gaugeValue() {
    let t = 0;
    return this.variant === vi.SUBDIVIDED ? t = this.subdividedBands.reduce((e, i) => e + i[1], 0) : t = this.gaugeValueProp, t <= this.gaugeMax && t >= this.gaugeMin ? t : t > this.gaugeMax ? (console.error("Gauge value too large"), this.gaugeMax) : (console.error("Gauge value too small"), this.gaugeMin);
  }
  /**
   * Generates the series based on the variant, so that gauge chart can have multiple legends
   */
  generateSeries() {
    return this.variant === vi.SUBDIVIDED ? this.subdividedBands.map((t) => ({
      name: t[0],
      // use the first element of the band array as the name
      type: this.type,
      showInLegend: !0,
      data: [t[1]],
      // assuming band[1] is the band's value
      dataLabels: {
        enabled: !1
      }
    })) : [
      {
        name: this.variant.charAt(0).toUpperCase() + this.variant.slice(1),
        type: this.type,
        showInLegend: !0,
        data: [this.gaugeValue],
        dataLabels: {
          enabled: !1
        }
      }
    ];
  }
  /**
   * Calculates the interval between ticks based on the number of  sections.
   */
  get tickInterval() {
    return (this.gaugeMax - this.gaugeMin) / this.labelSections;
  }
  /**
   * Auto-sorts subdivided bands unless disableSort prop is set
   */
  get subdividedBands() {
    return this.disableSort ? this.subdividedBandsProp : [...this.subdividedBandsProp].sort((t, e) => e[1] - t[1]);
  }
  /**
   * Returns padded label array for Highcharts API
   */
  get labels() {
    return ["", ...this.gaugeLabels, ""];
  }
  formatLabels(t) {
    if (this.gaugeLabels.length > 0) {
      const e = Math.round(t.pos / this.tickInterval);
      return this.labels[e];
    } else
      return Math.round(t.pos).toString();
  }
  /**
   * When labels are more than 2 digit, then it overlaps the gauge chart.
   * To avoid this, we are setting the text-anchor attribute based on label position.
   * if label is on left side of the chart, then text-anchor will be 'end'
   * if
   */
  static setTextAnchor(t) {
    var i;
    const e = t.yAxis[0];
    for (const o in e.ticks) {
      const l = (i = e.ticks[o].label) == null ? void 0 : i.element;
      if (!l)
        return;
      const L = l.getBBox();
      let D = "middle";
      L.x < t.plotWidth / 2 ? D = "end" : L.x > t.plotWidth / 2 && (D = "start"), l.setAttribute("text-anchor", D);
    }
  }
  /**
   * This method adjusts the minimum size of the gauge chart based on the current chart size.
   * It calculates the chart width (which is the same as the pane size) and sets a minimum pane size.
   * If the size of the pane is less than the minimum size, it adjusts the size of the pane.
   * This ensures that the gauge chart is always displayed at an appropriate size, regardless of the size of the chart container.
   * @param chart - The Highcharts.Chart instance for which the minimum gauge size is to be set.
   */
  setMinimumGaugeSize(t) {
    const e = t.plotWidth, i = this.minimumGaugeSize;
    t.update({
      pane: {
        size: e < i ? i : "85%"
        // Diameter of the pane
      }
    });
  }
  /**
   * Set plot bands based on variant and band values
   */
  get plotBands() {
    const t = [
      wt.plotBandObject(
        this.gaugeMin,
        this.gaugeMax,
        "gauge-background"
      )
    ];
    return this.variant !== vi.SUBDIVIDED ? t.push(...this.singleColorMode()) : t.push(...this.subdividedColorMode()), t;
  }
  /**
   * Sets a tint based on the relative value of the gauge
   */
  get tintIndex() {
    let t;
    this.variant === vi.TARGET && this.gaugeTarget > this.gaugeValue ? t = (this.gaugeTarget - this.gaugeMin) / this.sections : t = (this.gaugeMax - this.gaugeMin) / this.sections;
    const e = Math.ceil((this.gaugeValue - this.gaugeMin) / t);
    return e > 4 ? 4 : e;
  }
  /**
   * Sets text labels sections when provided
   */
  get labelSections() {
    return this.gaugeLabels.length ? this.gaugeLabels.length + 1 : this.sections;
  }
  /**
   * Queries the plot band SVG element to find the center of the chart
   */
  get chartCenter() {
    var i;
    const t = (i = this.shadowRoot) == null ? void 0 : i.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return { x: 0, y: 0 };
    const e = t.getBBox();
    return {
      x: e.x + e.width / 2,
      y: e.y + e.height
    };
  }
  /**
   * This getter method retrieves the width of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The width of the bounding box is then returned as the width of the gauge chart.
   * @returns The width of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartWidth() {
    var i;
    const t = (i = this.shadowRoot) == null ? void 0 : i.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return 0;
    const e = t.getBBox();
    return Math.round(e.width);
  }
  /**
   * This getter method retrieves the height of the gauge chart.
   * It queries the SVG element of the gauge chart and retrieves its bounding box.
   * The height of the bounding box is then returned as the height of the gauge chart.
   * @returns The height of the gauge chart, or 0 if the SVG element of the gauge chart cannot be found.
   */
  get chartHeight() {
    var i;
    const t = (i = this.shadowRoot) == null ? void 0 : i.querySelector(
      ".highcharts-plot-bands-0"
    );
    if (!t)
      return 0;
    const e = t.getBBox();
    return Math.round(e.height);
  }
  /**
   * Formats display string for gauge metric value based on props provided
   */
  metricDisplayValue() {
    if (this.gaugeValue != null) {
      if (this.percentage) {
        const t = this.gaugeValue - this.gaugeMin, e = this.gaugeMax - this.gaugeMin;
        return (t / e * 100).toFixed(
          this.decimal ? this.decimalPlaces : 0
        ) + "%";
      }
      return `${this.valuePrefix}${this.gaugeValue.toFixed(this.decimal ? this.decimalPlaces : 0)}${this.valueSuffix}`;
    }
    return "N/A";
  }
  /**
   * Template string of the metric placed in the center of the chart
   */
  metricHTML(t) {
    return `<div class="key-fact ${this.metricScale}" style="width: ${t}px">
    <div class="key-fact-main">${this.metricDisplayValue()}</div>
    ${this.metricDescription ? `<div class="key-fact-description">${this.metricDescription}</div>` : ""}
  </div>`;
  }
  /**
   * Gauge specific component Highcharts API options
   */
  get localComponentOptions() {
    const t = this.variant, e = this;
    return tt.createChartOptions(super.localComponentOptions, {
      chart: {
        plotBorderWidth: 0,
        margin: it.margin,
        // this margin is to make sure the gauge chart is not touching the edge of the container
        events: {
          load: function() {
            wt.renderTicks(this, t), wt.setTextAnchor(this), e.resizeObserver.observe(e);
          },
          redraw: function() {
            wt.setTextAnchor(this);
          }
        }
      },
      series: this.generateSeries(),
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: void 0,
        center: ["50%", "50%"],
        size: "85%"
        // The 'size' property sets the diameter of the gauge chart as a percentage of the total plot area. Here, it is set to '85%', meaning the gauge chart will occupy 85% of the total plot area.
      },
      yAxis: {
        min: this.gaugeMin,
        max: this.gaugeMax,
        labels: {
          enabled: !this.hideLabels,
          distance: this.labelDistance,
          formatter: this.formatLabels.bind(this)
        },
        plotBands: this.plotBands,
        tickInterval: this.tickInterval,
        tickLength: 0
      }
    });
  }
  /**
   * This function calculates the top margin for the chart. It is specifically designed to handle the positioning of the gauge chart within its container.
   * The function calculates the difference between the current position of the gauge chart and the position of the container.
   * For smaller screens, the function adjusts the top margin to ensure that there is no overlap between the export button and the gauge chart.
   * The calculated margin is then applied to the chart to position it correctly within the container.
   */
  calculateChartMarginTop() {
    var t, e, i, o;
    if (this.chart) {
      const n = (t = this.chart) == null ? void 0 : t.legend;
      n && n.update({
        x: 0,
        y: 0
      });
      const l = (e = this.chartContainer) == null ? void 0 : e.querySelector(
        ".highcharts-plot-bands-0"
      ), L = l ? l.getBoundingClientRect().top : 0, D = (i = this.chartContainer) == null ? void 0 : i.getBoundingClientRect().top;
      let j = 0;
      return ((o = this.chartContainer) == null ? void 0 : o.clientWidth) < no.MEDIUM && (j = L - D + it.margin), this.calculateLegendOffset(this.chart), -j;
    } else
      return 0;
  }
  /**
   * This method calculates the offset required to correctly position the legend in the chart.
   * It is executed with a delay to ensure that all elements in the chart are fully rendered before the calculation.
   * It retrieves the current positions of the legend and the gauge chart, calculates the required offset,
   * and then updates the y property of the legend with the calculated offset.
   * Finally, it calls the `calculateChartBlockSize` function to adjust the size of the chart block based on the new position of the legends.
   * @param chart - The Highcharts.Chart instance for which the legend offset is to be calculated.
   */
  calculateLegendOffset(t) {
    t && setTimeout(() => {
      var L, D, j;
      const e = (D = (L = t == null ? void 0 : t.legend) == null ? void 0 : L.group) == null ? void 0 : D.element, i = e ? e.getBoundingClientRect().top : 0, o = (j = this.chartContainer) == null ? void 0 : j.querySelector(
        ".highcharts-plot-bands-0"
      ), n = o ? o.getBoundingClientRect().bottom : 0, l = i - n - it.margin;
      this.updateChart({
        legend: {
          y: -l
        }
      }), this.calculateChartBlockSize(t);
    }, 100);
  }
  /**
   * This method calculates the total height of the chart block and sets it as the block size of the chart.
   * The method first checks if the legend exists in the chart. If it does, it calculates the bottom position of the legends and the top position of the container,
   * and sets the difference as the block size of the chart. If the legend does not exist, it calculates the bottom position of the gauge chart and the top position of the container,
   * adds an offset of 20, and sets this value as the block size of the chart.
   * @param chart - The Highcharts.Chart instance for which the block size is to be calculated.
   */
  calculateChartBlockSize(t) {
    var o, n, l, L, D;
    if (!t) return;
    let e;
    const i = ((o = this.chartContainer) == null ? void 0 : o.getBoundingClientRect().top) || 0;
    if ((l = (n = t.legend) == null ? void 0 : n.group) != null && l.element) {
      const j = (L = this.chartContainer) == null ? void 0 : L.querySelector(
        ".highcharts-legend-box"
      );
      e = (j ? j.getBoundingClientRect().bottom : 0) - i;
    } else {
      const j = (D = this.chartContainer) == null ? void 0 : D.querySelector(
        ".highcharts-plot-bands-0"
      );
      e = (j ? j.getBoundingClientRect().bottom : 0) - i + it.margin;
    }
    this.chartContainer.style.blockSize = e + "px";
  }
  /**
   * This getter method retrieves the minimum size of the gauge chart.
   * The minimum size is determined based on the metric scale and whether the metric is hidden.
   * If the metric scale is 'JUMBO' and the metric is not hidden, the minimum size is set to the constant 'minimumSizeJumbo'.
   * Otherwise, the minimum size is set to the constant 'minimumSizeDefault'.
   * @returns The minimum size of the gauge chart.
   */
  get minimumGaugeSize() {
    return this.metricScale === ln.JUMBO && !this.hideMetric ? it.minimumSizeJumbo : it.minimumSizeDefault;
  }
  /**
   * Helper function to define gauge plot bands
   *
   * TODO: Add tooltip interaction in this function
   * @param from start of plot band
   * @param to end of plot band
   * @param className CSS class name applied to plot band
   * @param label to name the band
   * @returns object of plot band with tooltip data and positioning logic
   */
  static plotBandObject(t, e, i) {
    return {
      from: t,
      to: e,
      className: i,
      thickness: it.plotBandThickness
    };
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for single color gauge
   */
  singleColorMode() {
    const t = [], e = (i) => wt.plotBandObject(
      this.gaugeMin,
      this.gaugeValue,
      i
    );
    switch (this.variant === vi.TARGET && (this.targetRange > 0 ? t.push(
      wt.plotBandObject(
        this.gaugeTarget,
        this.gaugeTarget + this.targetRange,
        "gauge-target"
      )
    ) : t.push(
      wt.plotBandObject(
        this.gaugeValue,
        this.gaugeTarget,
        "gauge-target"
      )
    )), this.colorType) {
      case Qr.NORMAL:
        t.push(e("gauge-value highcharts-color-0"));
        break;
      case Qr.TINTED:
        t.push(e(`gauge-value gauge-tint-${this.tintIndex}00`));
        break;
      case Qr.FUNCTIONAL:
        t.push(
          e(`gauge-value gauge-functional-${this.tintIndex}00`)
        );
        break;
      default:
        t.push(e("gauge-value highcharts-color-0"));
        break;
    }
    return t;
  }
  /**
   * Logic to identify which plot bands are applied based on the gauge
   *
   * @returns plot band array for subdivided color gauge
   */
  subdividedColorMode() {
    const t = [];
    let e = this.gaugeMin;
    const i = parseFloat(Jd);
    for (const o in this.subdividedBands) {
      const n = this.subdividedBands[o];
      t.push(
        wt.plotBandObject(
          e,
          e + n[1] - i,
          `subdivided gauge-value highcharts-color-${o}`
        )
      ), e += n[1];
    }
    return t;
  }
  /**
   * Renders the ticks on the gauge chart
   * @param chart
   */
  static renderTicks(t, e) {
    var i, o;
    if (t && PO(t)) {
      let n = 0;
      const l = Array.isArray(t.pane) ? t.pane[0] : t.pane, { center: L } = l;
      L && L.length && (typeof L[2] == "number" ? n = L[2] / 2 : typeof L[2] == "string" && (n = parseInt(L[2], 10) / 2));
      let D = n * 0.2;
      e === vi.SUBDIVIDED && (D = 0), t.update({ yAxis: { tickLength: D } });
      const { ticks: j } = t.yAxis[0].ticks, I = Object.entries(j);
      I.length && ((i = I[0][1]) == null || i.mark.hide(), (o = I[I.length - 1][1]) == null || o.mark.hide());
    }
  }
  /**
   * Renders the metric based on the center of the chart
   *
   * @param chart Highcharts chart
   */
  renderMetric(t) {
    var e, i, o, n;
    if (this.hideMetric)
      Fg(t) && ((n = t.metricHTML) == null || n.css({
        display: "none"
      }));
    else {
      const { x: l, y: L } = this.chartCenter, D = this.metricDescription ? this.metricDescription.length : 0, j = (e = this.shadowRoot) == null ? void 0 : e.querySelector(
        ".highcharts-plot-bands-0"
      );
      let I = 0;
      const B = this.chartWidth * 0.64;
      j && (I = j.getBBox().height);
      const R = I * (this.metricDescription ? 0.05 : 0.07), N = (i = this.shadowRoot) == null ? void 0 : i.querySelector(
        ".key-fact-description"
      );
      let x = 0, T = 0;
      if (N) {
        const M = N.getBoundingClientRect();
        x = M.width, T = M.height;
      }
      let y = 0, S = 6;
      D >= 28 && (y = T > 28 ? x / D : 0, S = Math.min(D, 50));
      const u = D == 0 ? 0 : 24 + y, A = L + R - S - u;
      Fg(t) && t.metricHTML !== null ? t.metricHTML.attr({
        text: this.metricHTML(B),
        x: l,
        y: A,
        width: B
        // Set the width here
      }).css({
        display: "initial"
      }) : DO(t.renderer) && (t.metricHTML = (o = t.renderer) == null ? void 0 : o.html(this.metricHTML(B), l, A).attr({
        align: "center",
        width: B
        // Set the width here
      }).add());
    }
  }
  /**
   * Chart redraw lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartRedraw() {
    this.chart && (this.renderMetric(this.chart), wt.renderTicks(this.chart, this.variant), wt.setTextAnchor(this.chart));
  }
  /**
   * Chart load lifecycle hook to render metric
   *
   * @param chart Highcharts chart
   */
  onChartLoad() {
    this.chart && (this.renderMetric(this.chart), wt.renderTicks(this.chart, this.variant));
  }
  willUpdate(t) {
    var e;
    (e = super.willUpdate) == null || e.call(this, t), this.chart && ((t.has("metricDescription") || t.has("hideMetric") || t.has("metricScale") || t.has("disableLegend") || t.has("percentage") || t.has("decimal") || t.has("valuePrefix") || t.has("valueSuffix") || t.has("gaugeValueProp") || t.has("decimalPlaces")) && this.renderMetric(this.chart), (t.has("colorType") || t.has("variant") || t.has("gaugeTarget") || t.has("targetRange") || t.has("gaugeValueProp") || t.has("sections")) && this.updateChart({
      yAxis: { plotBands: this.plotBands, tickInterval: this.tickInterval }
    }), (t.has("disableLegend") || t.has("variant")) && wt.renderTicks(this.chart, this.variant), t.has("disableSort") && this.updateChart({
      yAxis: { plotBands: this.plotBands },
      series: this.generateSeries()
    }), t.has("labelDistance") && this.updateChart({
      yAxis: { labels: { distance: this.labelDistance } }
    }), t.has("labels") && this.updateChart({
      yAxis: { labels: { formatter: this.formatLabels.bind(this) } }
    }), t.has("hideLabels") && this.updateChart({ yAxis: { labels: { enabled: !this.hideLabels } } }));
  }
}, wt.tagName = jg, wt);
Tt([
  ue({ attribute: it.attribute.name })
], Et.prototype, "gaugeName");
Tt([
  ue({ attribute: it.attribute.value, type: Number })
], Et.prototype, "gaugeValueProp");
Tt([
  ue({ attribute: it.attribute.valueSuffix })
], Et.prototype, "valueSuffix");
Tt([
  ue({ attribute: it.attribute.valuePrefix })
], Et.prototype, "valuePrefix");
Tt([
  ue({ attribute: it.attribute.metricDescription })
], Et.prototype, "metricDescription");
Tt([
  ue({ attribute: it.attribute.gaugeTarget, type: Number })
], Et.prototype, "gaugeTarget");
Tt([
  ue({ attribute: it.attribute.targetRange, type: Number })
], Et.prototype, "targetRange");
Tt([
  ue({ attribute: it.attribute.gaugeMin, type: Number })
], Et.prototype, "gaugeMin");
Tt([
  ue({ attribute: it.attribute.gaugeMax, type: Number })
], Et.prototype, "gaugeMax");
Tt([
  ue()
], Et.prototype, "variant");
Tt([
  ue({ attribute: it.attribute.metricScale })
], Et.prototype, "metricScale");
Tt([
  ue({ attribute: it.attribute.colorType })
], Et.prototype, "colorType");
Tt([
  ue({ type: Boolean, attribute: it.attribute.hideMetric })
], Et.prototype, "hideMetric");
Tt([
  ue({ type: Boolean, attribute: it.attribute.disableSort })
], Et.prototype, "disableSort");
Tt([
  ue({ attribute: it.attribute.gaugeLabels, type: Object })
], Et.prototype, "gaugeLabels");
Tt([
  ue({ attribute: it.attribute.subdividedBands, type: Object })
], Et.prototype, "subdividedBandsProp");
Tt([
  ue({ type: Number, attribute: it.attribute.labelDistance })
], Et.prototype, "labelDistance");
Tt([
  ue({ type: Number, attribute: it.attribute.sections })
], Et.prototype, "sections");
Tt([
  ue({ type: Boolean, attribute: it.attribute.hideLabels })
], Et.prototype, "hideLabels");
let JD = Et;
var Xv = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.SIDE_BLOCK = "side-block", a.TABBED = "tabbed", a.SPLIT_MEDIA = "split-media", a))(Xv || {});
const Qv = (a, t = []) => {
  if (!a)
    return;
  for (const i of t) {
    const o = a.querySelector(i);
    if (o)
      return o;
  }
  const e = Array.from(a.children);
  if (e.length)
    for (const i of e) {
      const o = Qv(
        i,
        t
      );
      if (o)
        return o;
    }
}, zO = (a, t, e) => {
  if (a) {
    e();
    {
      const i = {
        childList: !0,
        subtree: !0
      };
      new MutationObserver(() => {
        e();
      }).observe(a, i);
    }
    return !1;
  }
  return !0;
}, IO = ve`:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]{--hero-media-inline-size-media-sizing: 100%;--hero-color-background: var(--beacon-system-color-background-0);--hero-content-padding-block-end: var(--beacon-system-space-organism-jumbo);--hero-content-padding-inline: var(--beacon-system-space-organism-jumbo);--hero-content-padding-block-start: var(--beacon-system-space-organism-jumbo);--hero-content-backdrop-filter: none;--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-500);--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-loose-300);--hero-info-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300);--hero-eyebrow-text-transform: none;--hero-container-padding: calc(var(--hero-content-padding-inline) * 2);--hero-notch-size: var(--beacon-system-radius-corner-standard);--hero-content-color-background: var(--beacon-system-color-background-0);--hero-space-overlap: initial;--hero-media-space-grid-rows: initial;--hero-title-space-margin: 0;--hero-media-space-grid-columns: initial;--hero-cta-space-gap: var(--beacon-reference-space-5);--hero-size-min-block-size: initial;--hero-notch-space: 0;--hero-no-notch-space-padding-block-end: 0;--hero-no-notch-space-padding-block-start: 0;--hero-media-size-jumbo: auto;--hero-media-size-normal: auto;--hero-media-size-mini: auto}:root[beacon-tag-name=beacon-hero][variant=split-media],:root [beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=split-media],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=split-media],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=split-media],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=split-media]{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-400);--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200)}:root[beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),:root [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.4.0"][beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])),[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]:not(:is([no-notch],[no-media])){--hero-content-max-inline-size: calc(var(--beacon-system-breakpoint-xx-large) + var(--hero-container-padding))}@media screen and (width >= 375px){:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-standfirst-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200)}}@media (width >= 640px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-600)}:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-standfirst-margin-block-start: var(--beacon-system-space-micro-mini)}}@media (width >= 960px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]{--hero-content-padding-block-end: var(--beacon-reference-space-9);--hero-content-padding-inline: var(--beacon-reference-space-9);--hero-content-padding-block-start: var(--beacon-reference-space-7);--hero-space-overlap: 68px;--hero-media-space-grid-rows: 56px;--hero-title-space-margin: 1.5rem;--hero-media-space-grid-columns: 56px;--hero-size-min-block-size: 468px;--hero-notch-size: var(--beacon-reference-space-2);--hero-notch-space: 4.25rem;--hero-no-notch-space-padding-block-end: var(--beacon-reference-space-9);--hero-no-notch-space-padding-block-start: var(--beacon-reference-space-16);--hero-media-size-jumbo: 29.25rem;--hero-media-size-normal: 24.25rem;--hero-media-size-mini: 19.25rem}:root[beacon-tag-name=beacon-hero][variant=side-block],:root [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block]{--hero-additional-content-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-content-color-background: var(--beacon-system-color-background-0);--hero-standfirst-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-info-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-title-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-eyebrow-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-cta-padding-inline: var(--beacon-system-space-cell-free-floating);--hero-content-padding-block-end: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7));--hero-content-padding-inline: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7));--hero-content-padding-block-start: calc(var(--beacon-system-space-organism-normal) + var(--beacon-reference-space-7))}:root[beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),:root [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=side-block]:not([contained]),[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=side-block]:not([contained]){--hero-content-color-background: var(--beacon-system-color-background-1)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]{--hero-content-padding-block-end: var(--beacon-reference-space-13);--hero-content-padding-inline: var(--beacon-reference-space-13);--hero-content-padding-block-start: var(--beacon-reference-space-12);--hero-space-overlap: 104px;--hero-media-space-grid-rows: 88px;--hero-media-space-grid-columns: 88px;--hero-cta-space-gap: var(--beacon-reference-space-7);--hero-size-min-block-size: 584px;--hero-notch-space: var(--beacon-reference-space-18);--hero-no-notch-space-padding-block-end: var(--beacon-reference-space-13);--hero-media-size-jumbo: 36.5rem;--hero-media-size-normal: 29rem;--hero-media-size-mini: 21.5rem}:root[beacon-tag-name=beacon-hero][variant=standard],:root [beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero][variant=standard],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=standard],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero][variant=standard],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero][variant=standard]{--hero-content-inline-size: calc(calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11) + var(--hero-container-padding))}}@media (width >= 1600px){:root[beacon-tag-name=beacon-hero],:root [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-hero],[beacon-version="4.4.0"][beacon-tag-name=beacon-hero],[beacon-version="4.4.0"] [beacon-tag-name=beacon-hero]{--hero-space-overlap: 176px;--hero-media-margin-inline: auto;--hero-media-space-grid-columns: calc((100% - calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11)) / 2);--media-inset-inline-start: 0;--media-inset-inline-end: 0}}`, Ba = {
  beaconTagName: "beacon-hero",
  withBylineClassName: "with-byline",
  mediaNodes: ["img", "video"],
  fullBleedClassName: "beacon-hero-img-full-bleed",
  DATA_METRICS_LOCATION_HERO: "MQ"
}, BO = ve`.beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: auto;aspect-ratio:2/1;box-sizing:border-box;display:block;inline-size:var(--hero-media-inline-size-media-sizing, 100vw);margin-inline:var(--hero-media-margin-inline, calc(50% - 50vw) );max-block-size:var(--hero-media-max-block-size-media-sizing);min-block-size:var(--hero-media-min-block-size-media-sizing);object-fit:cover}[beacon-tag-name=beacon-hero][variant=side-block] .beacon-hero-img-full-bleed{--min-hero-block-size: var(--hero-size-min-block-size);--hero-media-min-block-size-media-sizing: var(--min-hero-block-size)}[beacon-tag-name=beacon-hero][variant=side-block][contained] .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: 100%;--hero-media-min-block-size-media-sizing: var(--hero-size-min-block-size)}[beacon-tag-name=beacon-hero][scale=mini]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-mini)}[beacon-tag-name=beacon-hero][scale=normal]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}[beacon-tag-name=beacon-hero][scale=jumbo]:not([contained]) .beacon-hero-img-full-bleed{--hero-media-max-block-size-media-sizing: var(--hero-media-size-jumbo)}[beacon-tag-name=beacon-hero] [slot=media] *{block-size:100%;inline-size:100%}@supports (block-size: -webkit-fill-available){[beacon-tag-name=beacon-hero] [slot=media] .video-js{block-size:-webkit-fill-available}}[beacon-tag-name=beacon-hero] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-hero] a:not(:is(:hover,:focus)){text-decoration:none}[beacon-tag-name=beacon-hero] [slot=eyebrow]{color:var(--beacon-system-color-text-standard);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300);margin:0}[beacon-tag-name=beacon-hero] [slot=page-title]{color:var(--beacon-system-color-text-standard);font:var(--hero-title-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-500));margin:0}[beacon-tag-name=beacon-hero] .beacon-hero__standfirst,[beacon-tag-name=beacon-hero] [slot=standfirst]{color:var(--beacon-system-color-text-standard);font:var(--hero-standfirst-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300))}[beacon-tag-name=beacon-hero] [slot=details]{font:var(--hero-info-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300))}[beacon-tag-name=beacon-hero] [slot=cta]{inline-size:var(--cta-button-width, 100%)}[beacon-tag-name=beacon-hero][variant=split-media] [slot=eyebrow]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-200)}[beacon-tag-name=beacon-hero] p{margin:0}[beacon-tag-name=beacon-hero] img:not([beacon-tag-name=beacon-icon] *),[beacon-tag-name=beacon-hero] video{aspect-ratio:2/1;box-sizing:border-box;display:block;inline-size:var(--hero-media-inline-size-media-sizing, 100vw);margin-inline:var(--hero-media-margin-inline, calc(50% - 50vw) );max-block-size:var(--hero-media-max-block-size-media-sizing);min-block-size:var(--hero-media-min-block-size-media-sizing);object-fit:cover}[beacon-tag-name=beacon-hero] [slot=additionalContent]{grid-area:additional}[beacon-tag-name=beacon-hero] [slot=additionalContent]:not(.empty){margin-block-start:var(--beacon-system-space-micro-jumbo);padding-inline:var(--hero-additional-content-padding-inline, initial)}[beacon-tag-name=beacon-hero] [slot=toolbelt]{align-items:center;display:flex;grid-area:toolbelt;justify-content:var(--toolbelt-spacing)}[beacon-tag-name=beacon-hero] [slot=toolbelt]:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-toolbelt-padding-inline, 0)}[beacon-tag-name=beacon-hero] [slot=media]{grid-column:var(--media-grid-column, initial);grid-row:var(--media-grid-row, initial)}[beacon-tag-name=beacon-hero] [slot=media]>img,[beacon-tag-name=beacon-hero] [slot=media]:not(picture){background-color:var(--media-background-color);block-size:var(--media-block-size, initial);display:var(--media-display, block);inline-size:100%;inset-block-start:var(--media-inset-block-start, initial);inset-inline:var(--media-inset-inline-start, initial) var(--media-inset-inline-end, initial);justify-content:var(--media-justify-content, initial);margin:0;margin-inline:var(--hero-media-margin-inline, 0);max-inline-size:var(--media-max-inline-size, var(--beacon-system-breakpoint-xxx-large));position:var(--media-position, initial)}@media (width >= 640px){[beacon-tag-name=beacon-hero] [slot=toolbelt]{gap:var(--beacon-reference-space-1)}}@media (width >= 960px){[beacon-tag-name=beacon-hero][variant=split-media] :is(img,picture):not([beacon-tag-name=beacon-icon] *){block-size:100%;inline-size:100%;max-block-size:none;position:absolute}}`, RO = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]:is([variant=side-block],[variant=standard],[variant=split-media])) .content{animation-delay:var(--beacon-reference-motion-duration-7);animation-duration:var(--beacon-reference-motion-duration-12);animation-fill-mode:forwards;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1);opacity:var(--hero-content-opacity, initial)}}@media (prefers-reduced-motion: no-preference) and (width >= 640px){:host([motion-state=enabled]:is([variant=side-block],[variant=standard],[variant=split-media])){--hero-content-opacity: 0}:host([motion-state=enabled]:is([variant=standard],[variant=split-media],[variant=side-block]:not([contained])).b-motion-viewed) .content{animation-name:intro-from-bottom}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}:host([motion-state=enabled][variant=side-block][contained].b-motion-viewed) .content,:host([motion-state=enabled][variant=side-block][contained].intro-from-bottom.b-motion-viewed) .content,:host([motion-state=enabled][variant=side-block][contained].intro-from-left.b-motion-viewed) .content{animation-name:intro-from-bottom}}@media (prefers-reduced-motion: no-preference) and (width >= 960px){@keyframes intro-from-left{0%{opacity:0;transform:translate(calc(-1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translate(0)}}:host([motion-state=enabled][variant=side-block][contained].intro-from-left.b-motion-viewed) .content{animation-name:intro-from-left}}`;
var NO = Object.getOwnPropertyDescriptor, FO = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? NO(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function jO(a) {
  let t = class extends a {
    static get HeroMotionStyles() {
      return [RO];
    }
  };
  return t = FO([
    $e("HeroMotion")
  ], t), t;
}
const _O = ve`:host{--hero-media-max-block-size-media-sizing: auto;--hero-override-byline-padding-block-start: 0;--hero-override-byline-margin: 0;--hero-content-grid-template: "eyebrow eyebrow" "title title" "standfirst standfirst" "info toolbelt" "cta cta" "additional additional";--title-container-layout-margin: calc(2 * var(--hero-title-space-margin));--title-container-width: calc(100% - var(--title-container-layout-margin));--toolbelt-spacing: space-between;--hero-content-padding-block-end: var(--beacon-reference-space-7);--hero-content-padding-block-start: var(--beacon-reference-space-7);--max-grid-size: min(calc(100% - calc(2 * var(--hero-media-space-grid-columns))), var(--beacon-system-breakpoint-xx-large));background-color:var(--beacon-custom-hero-backdrop-color-background, var(--hero-color-background));display:var(--hero-display, block);grid-template-columns:var(--hero-content-grid-template-columns, initial);grid-template-rows:var(--hero-content-grid-template-rows, initial);min-block-size:var(--hero-size-min-block-size);position:var(--hero-position, initial)}:host *{margin:0}:host([variant=split-media]){min-block-size:0}.shell:not(.split-media){display:contents}.shell:not(.split-media) .media-wrapper{display:contents}.shell.split-media{background-color:var(--beacon-system-color-background-1);max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.shell.split-media .content{--hero-content-color-background: transparent;align-items:start;display:flex;flex-direction:column;justify-content:center;padding:var(--beacon-system-space-organism-jumbo)}.shell.split-media .media-wrapper{position:relative}@media (width >= 960px){.shell.split-media{display:grid;grid-auto-columns:1fr;grid-auto-flow:column;margin-inline:auto}.shell.split-media.right .media-wrapper{grid-column:2/3;grid-row:1/2}.shell.split-media.right .content{grid-column:1/2;grid-row:1/2}}.cta-wrapper{display:flex;flex-direction:var(--cta-direction, column);gap:var(--hero-cta-space-gap);grid-area:cta;grid-column:1/3}.cta-wrapper:not(.empty){margin-block-start:var(--beacon-system-space-micro-jumbo);padding-block:var(--beacon-system-space-cell-free-floating, initial);padding-inline:var(--hero-cta-padding-inline, initial)}.content{-webkit-backdrop-filter:var(--hero-content-backdrop-filter, blur(var(--beacon-reference-space-7)));backdrop-filter:var(--hero-content-backdrop-filter, blur(var(--beacon-reference-space-7)));background-color:var(--beacon-custom-hero-color-background, var(--hero-content-color-background, var(--hero-color-background)));block-size:var(--hero-content-block-size, initial);border-end-end-radius:var(--hero-content-border-end-end-radius, var(--hero-content-border-radius, initial));border-end-start-radius:var(--hero-content-border-end-start-radius, var(--hero-content-border-radius, initial));border-start-end-radius:var(--hero-content-border-start-end-radius, var(--hero-content-border-radius, var(--hero-notch-size)));border-start-start-radius:var(--hero-content-border-start-start-radius, var(--hero-content-border-radius, var(--hero-notch-size)));box-sizing:var(--hero-content-box-sizing, inherit);display:flex;flex-direction:column;grid-column:var(--hero-content-grid-column, initial);grid-row:var(--hero-content-grid-row, initial);inline-size:var(--hero-content-inline-size);justify-content:var(--hero-content-justify-content, initial);margin-inline:var(--hero-content-margin-inline);max-inline-size:var(--hero-content-max-inline-size, 1232px);place-self:var(--hero-content-vertical-align, initial) var(--hero-content-justify-self, initial);position:var(--hero-content-position, relative);z-index:1;padding-inline:var(--hero-content-padding-inline);padding-block-end:var(--hero-content-padding-block-end, initial);padding-block-start:var(--hero-content-padding-block-start, initial)}.content>*:not(:empty,.empty){padding-block:var(--hero-content-padding-block, var(--beacon-reference-space-2));padding-inline:var(--hero-content-padding-inline, 0)}.with-byline:after{content:" -"}@media (width < 960px){::slotted([slot=byline]){margin:0}}.eyebrow,::slotted([slot=eyebrow]){color:var(--beacon-system-color-text-standard, currentcolor);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300);grid-area:eyebrow;text-transform:var(--hero-eyebrow-text-transform, uppercase)}.eyebrow:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating, initial);padding-inline:var(--hero-eyebrow-padding-inline, initial)}.page-title,::slotted([slot=page-title]){color:var(--beacon-system-color-text-standard);font:var(--hero-title-font, var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-500));grid-area:title;margin:0}.page-title:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating) var(--hero-title-padding-block-end, var(--beacon-system-space-cell-free-floating));padding-inline:var(--hero-title-padding-inline, initial)}.standfirst,::slotted([slot=standfirst]){color:var(--beacon-system-color-text-standard);font:var(--hero-standfirst-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300));grid-area:standfirst;margin:0}.standfirst:not(.empty){margin-block-start:var(--hero-standfirst-margin-block-start, initial);padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-standfirst-padding-inline, initial)}.info,::slotted([slot=details]){color:var(--hero-info-color, currentcolor);display:flex;flex-direction:row;flex-wrap:wrap;font:var(--hero-info-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300));gap:var(--beacon-reference-space-2);grid-area:info}.info:not(.empty){padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:var(--hero-info-padding-inline, initial)}:host([scale=mini]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-mini)}:host([scale=normal]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}:host([scale=jumbo]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-jumbo)}@media screen and (width >= 375px){:host{--hero-title-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-600)}}@media (width >= 640px){:host{--toolbelt-spacing: end}:host([variant=side-block]),:host([variant=split-media]){--cta-direction: row;--cta-button-width: auto}.content{display:grid;grid-template-areas:var(--hero-content-grid-template)}::slotted([slot=toolbelt]){gap:var(--beacon-reference-space-1)}}@media (width >= 960px){:host([variant=standard]){--hero-content-inline-size: var(--title-container-width);--hero-content-margin-inline: auto}:host([variant=standard]:not(:is([no-notch],[no-media]))){--hero-content-border-radius: var(--hero-notch-size);--hero-display: grid;--hero-content-grid-template-rows: 1fr var(--hero-notch-space) auto;--hero-content-grid-template-columns: minmax(var(--max-grid-size), 1fr);--hero-content-grid-column: 1/2;--media-grid-column: 1/2;--media-grid-row: 1/3;--hero-content-grid-row: 2/4}:host([variant=standard]:is([no-notch],[no-media])){--hero-content-max-inline-size: 100%}:host([contained]){--hero-position: initial;--media-position: initial}.info{align-items:center;flex-direction:row;inline-size:max-content}:host([no-notch]),:host([no-media]),:host([variant=side-block]){--hero-content-position: static;--hero-content-padding-block-start: var(--hero-no-notch-space-padding-block-start);--hero-content-padding-block-end: var(--hero-no-notch-space-padding-block-end)}:host([variant=side-block][scale=mini]),:host([variant=side-block][scale=normal]){--hero-media-max-block-size-media-sizing: var(--hero-media-size-normal)}:host([variant=side-block]){--hero-backdrop-color-background: transparent;--hero-content-padding-inline: var(--beacon-reference-space-12);--hero-content-padding-block-start: var(--beacon-reference-space-12);--hero-content-padding-block-end: var(--beacon-reference-space-12);--hero-display: grid;--hero-content-border-radius: var(--hero-notch-size);--hero-content-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--hero-content-bottom-radius: var(--hero-notch-size);--hero-content-position: static;--media-block-size: 100%;--hero-title-padding-block-end: var(--beacon-system-space-cell-free-floating)}:host([variant=side-block]),:host([variant=split-media]){--cta-button-width: 100%;--cta-direction: column}:host([variant=side-block][orientation=left]){--hero-content-justify-self: start}:host([variant=side-block][orientation=right]){--hero-content-justify-self: end}:host([variant=side-block][contained]){--hero-content-grid-template-columns: minmax(var(--hero-media-space-grid-columns), 1fr) minmax(var(--max-grid-size), 1fr) minmax(var(--hero-media-space-grid-columns), 1fr);--hero-content-grid-template-rows: var(--hero-media-space-grid-rows) 1fr var(--hero-media-space-grid-rows) ;--hero-content-grid-column: 2/3;--hero-content-grid-row: 2/3;--hero-content-vertical-align: start;--media-grid-column: 1/4;--media-grid-row: 1/4;--hero-position: relative;--media-position: absolute;--media-inset-block-start: 0}:host([variant=side-block]:not([contained])){--hero-content-grid-template-columns: minmax(var(--hero-media-space-grid-columns), 1fr) minmax(var(--max-grid-size), 1fr) minmax(var(--hero-media-space-grid-columns), 1fr);--hero-content-grid-template-rows: var(--hero-media-space-grid-rows) 1fr var(--hero-space-overlap) ;--hero-content-grid-column: 2/3;--hero-content-grid-row: -1/-3;--hero-content-vertical-align: end;--media-grid-column: 1/4;--media-grid-row: 1/3}}@media (width >= 1280px){:host([variant=side-block]),:host([variant=split-media]){--cta-direction: row;--cta-button-width: auto}}@media (width >= 1920px){:host(:not([variant=side-block])){--hero-color-background: var(--beacon-system-color-background-0);--media-background-color: var(--hero-color-background);--media-display: flex;--media-justify-content: center}}`;
var UO = Object.defineProperty, $O = Object.getOwnPropertyDescriptor, ft = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? $O(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && UO(t, e, o), o;
};
const ep = class ep extends Ge(Le).with(
  jO,
  Gf({ autoRemoveMotionClasses: !1, threshold: 0.5 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = Ba.beaconTagName, this.scale = ln.NORMAL, this.hideNotch = !1, this.noMedia = !1, this.contained = !1, this.variant = Xv.STANDARD, this.dataMetricsLocation = Ba.DATA_METRICS_LOCATION_HERO, this.orientation = hb.LEFT, this.waitForMediaSlot = !0, this.addMutationObserver = !0, this.mediaSlotChange = () => {
      this.slottedMediaNode && this.waitForMediaSlot && (this.waitForMediaSlot = !1, this.slottedMediaNode.classList.add(Ba.fullBleedClassName));
    };
  }
  static get styles() {
    return [super.styles, _O, this.HeroMotionStyles, this.motionStyles];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, BO, IO];
  }
  get hasEyebrowContent() {
    return this.eyebrowSlot.length > 0;
  }
  get hasTitleContent() {
    return this.pageTitleSlot.length > 0;
  }
  get hasStandfirstContent() {
    return this.standfirstSlot.length > 0;
  }
  get hasCtaContent() {
    var t;
    return ((t = this.ctaSlot) == null ? void 0 : t.length) > 0;
  }
  get hasBylineContent() {
    var t;
    return ((t = this.byline) == null ? void 0 : t.length) > 0;
  }
  get hasDetailsContent() {
    var t;
    return ((t = this.detailsSlot) == null ? void 0 : t.length) > 0;
  }
  get hasInfoContent() {
    return this.hasDetailsContent || this.hasBylineContent;
  }
  get hasToolbeltContent() {
    var t;
    return ((t = this.toolbeltSlot) == null ? void 0 : t.length) > 0;
  }
  get hasAdditionalContent() {
    var t;
    return ((t = this.additionalContentSlot) == null ? void 0 : t.length) > 0;
  }
  /**
   * @returns the first slotted image or media element
   */
  get firstSlottedMedia() {
    return this.slottedMedia[0];
  }
  /**
   * searches for slotted img or video elements that are potentially nested in other tags
   */
  get slottedMediaNode() {
    return Qv(
      this.firstSlottedMedia,
      Ba.mediaNodes
    ) || this.firstSlottedMedia;
  }
  applyMotionStyles() {
    this.classList.add(pb.VIEWED);
  }
  applyMotionIntersectionObserver() {
    this.motionIntersectionObserver.observe(this.contentElement);
  }
  handleSlotChange() {
    this.addMutationObserver = zO(
      this.firstSlottedMedia,
      !0,
      this.mediaSlotChange
    ), this.requestUpdate();
  }
  /**
   * Toggles the with-byline class to conditionally render `-` character
   */
  handleBylineSlotChange() {
    const t = this.byline[0];
    this.detailsElement && (t ? this.detailsElement.classList.add(Ba.withBylineClassName) : this.detailsElement.classList.remove(Ba.withBylineClassName)), this.requestUpdate();
  }
  hideNotchIfNoMediaSlotted() {
    var t;
    (t = this.slottedMedia) != null && t.length || (this.hideNotch = !0);
  }
  render() {
    return pe`
      <div class="shell ${this.variant} ${this.orientation}">
        <div class="media-wrapper">
          <slot
            name="media"
            class="slotted-media-wrapper"
            @slotchange="${this.handleSlotChange}"
            ${_e({ useParent: !0 })}></slot>
        </div>
        <section class="content">
          <div class="eyebrow ${Pe({ empty: !this.hasEyebrowContent })}">
            <slot name="eyebrow" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div class="page-title ${Pe({ empty: !this.hasTitleContent })}">
            <slot name="page-title" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div
            class="standfirst ${Pe({
      empty: !this.hasStandfirstContent
    })}">
            <slot name="standfirst" @slotchange=${this.handleSlotChange}></slot>
          </div>
          <div
            class="info ${Pe({
      empty: !(this.hasInfoContent || this.hasBylineContent)
    })}">
            <slot
              name="details"
              class="details"
              @slotchange=${this.handleSlotChange}></slot>
            <slot
              name="byline"
              @slotchange=${this.handleBylineSlotChange}></slot>
          </div>
          <slot
            name="toolbelt"
            class="${Pe({ empty: !this.hasToolbeltContent })}"
            @slotchange=${this.handleSlotChange}></slot>
          <slot
            class="cta-wrapper ${Pe({ empty: !this.hasCtaContent })}"
            @slotchange=${this.handleSlotChange}
            name="cta"></slot>
          <slot
            name="additionalContent"
            class="${Pe({ empty: !this.hasAdditionalContent })}"
            @slotchange=${this.handleSlotChange}></slot>
        </section>
      </div>
    `;
  }
};
ep.tagName = Ba.beaconTagName;
let st = ep;
ft([
  ue({ reflect: !0 })
], st.prototype, "scale", 2);
ft([
  ue({ type: Boolean, attribute: "no-notch", reflect: !0 })
], st.prototype, "hideNotch", 2);
ft([
  ue({ type: Boolean, attribute: "no-media", reflect: !0 })
], st.prototype, "noMedia", 2);
ft([
  ue({ type: Boolean, reflect: !0 })
], st.prototype, "contained", 2);
ft([
  ue({ type: String, reflect: !0 })
], st.prototype, "variant", 2);
ft([
  ue({ attribute: wo.LOCATION, reflect: !0 })
], st.prototype, "dataMetricsLocation", 2);
ft([
  ue({ type: String, reflect: !0 })
], st.prototype, "orientation", 2);
ft([
  Ce()
], st.prototype, "waitForMediaSlot", 2);
ft([
  Ce()
], st.prototype, "addMutationObserver", 2);
ft([
  We(".details")
], st.prototype, "detailsElement", 2);
ft([
  We(".content")
], st.prototype, "contentElement", 2);
ft([
  Ho({ slot: "eyebrow", flatten: !0 })
], st.prototype, "eyebrowSlot", 2);
ft([
  Ho({ slot: "page-title", flatten: !0 })
], st.prototype, "pageTitleSlot", 2);
ft([
  Ho({ slot: "standfirst", flatten: !0 })
], st.prototype, "standfirstSlot", 2);
ft([
  Ho({ slot: "cta", flatten: !0 })
], st.prototype, "ctaSlot", 2);
ft([
  Ho({ slot: "details", flatten: !0 })
], st.prototype, "detailsSlot", 2);
ft([
  Ho({ slot: "toolbelt", flatten: !0 })
], st.prototype, "toolbeltSlot", 2);
ft([
  Ho({ slot: "additionalContent", flatten: !0 })
], st.prototype, "additionalContentSlot", 2);
ft([
  De({ slot: "byline" })
], st.prototype, "byline", 2);
ft([
  De({ flatten: !0, slot: "media" })
], st.prototype, "slottedMedia", 2);
ft([
  Re
], st.prototype, "applyMotionIntersectionObserver", 1);
ft([
  Re
], st.prototype, "hideNotchIfNoMediaSlotted", 1);
const _g = {
  beaconTagName: "beacon-input-chip"
}, HO = {
  Normal: "normal"
}, KO = ve`[beacon-tag-name=beacon-input-chip]{--icon-spacing: var(--beacon-reference-space-3);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard)}[beacon-tag-name=beacon-input-chip] :is(*:not([slot])){color:var(--input-chip-text-color, --beacon-system-color-text-standard);font:var(--label-font)}[beacon-tag-name=beacon-input-chip] :is([slot=icon]){block-size:var(--beacon-reference-space-4);color:var(--input-chip-icon-color, var(--beacon-system-color-icon-standard));fill:currentcolor;inline-size:var(--beacon-reference-space-4);margin-inline-end:var(--icon-spacing)}[beacon-tag-name=beacon-input-chip] :is([slot=icon]) *{fill:inherit}[beacon-tag-name=beacon-input-chip][disabled]{--input-chip-text-color: var(--beacon-system-color-text-secondary-inactive)}[beacon-tag-name=beacon-input-chip][scale=mini]{--icon-spacing: var(--beacon-reference-space-2);--label-font: var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard)}`, GO = ve`.input-chip,.input-chip.normal{--icon-color: var(--beacon-system-color-icon-standard);align-items:center;background-color:var(--input-chip-background-color, var(--beacon-component-control-chip-color-background-default));border-color:var(--input-chip-border-color, var(--beacon-system-color-border-2));border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);display:flex;flex-direction:row;inline-size:fit-content;padding-block:var(--input-chip-padding-block, var(--beacon-reference-space-4));padding-inline-end:var(--input-chip-padding-inline-end, var(--beacon-reference-space-3));padding-inline-start:var(--input-chip-padding-inline-start, var(--beacon-reference-space-4))}.input-chip .label,.input-chip.normal .label{cursor:inherit;display:flex}.input-chip .icon,.input-chip.normal .icon{align-items:center;display:flex}.input-chip .icon ::slotted([slot=icon]),.input-chip.normal .icon ::slotted([slot=icon]){block-size:var(--beacon-reference-space-5);color:var(--icon-color, var(--beacon-system-color-icon-standard));fill:currentcolor;inline-size:var(--beacon-reference-space-5)}.input-chip:has([disabled]),.input-chip.normal:has([disabled]){--icon-color: var(--beacon-system-color-icon-primary-inactive);--input-chip-text-color: var(--beacon-system-color-text-secondary-inactive);--input-chip-border-color: var(--beacon-component-control-chip-color-background-default);cursor:not-allowed}.input-chip .close,.input-chip.normal .close{align-items:center;background-color:var(--close-icon-background-color, transparent);block-size:var(--close-button-size, var(--beacon-reference-space-7));border:unset;border-radius:var(--beacon-system-radius-corner-round);cursor:inherit;display:flex;inline-size:var(--close-button-size, var(--beacon-reference-space-7));justify-content:center;margin-block:calc(-1 * var(--beacon-reference-space-2));margin-inline-start:var(--beacon-reference-space-3);position:relative}.input-chip .close:before,.input-chip.normal .close:before{block-size:var(--beacon-reference-space-7);content:"";inline-size:var(--beacon-reference-space-7);position:absolute}.input-chip .close:focus-visible,.input-chip.normal .close:focus-visible{outline:none}.input-chip .close:focus-visible:before,.input-chip.normal .close:focus-visible:before{border-radius:var(--beacon-system-radius-corner-round);outline:auto}.input-chip .close .close-small-icon,.input-chip.normal .close .close-small-icon{block-size:var(--beacon-reference-space-5);color:var(--close-icon-color, var(--beacon-system-color-icon-secondary));fill:currentcolor;flex-shrink:0;inline-size:var(--beacon-reference-space-5)}.input-chip .close:hover,.input-chip .close:focus-visible,.input-chip.normal .close:hover,.input-chip.normal .close:focus-visible{--close-icon-background-color: var(--beacon-system-color-background-secondary-hover);--close-icon-color: var(--beacon-system-color-icon-secondary-hover)}.input-chip .close:active,.input-chip.normal .close:active{--close-icon-background-color: var(--beacon-system-color-background-secondary-pressed);--close-icon-color: var(--beacon-system-color-icon-secondary-pressed)}.input-chip .close[disabled],.input-chip.normal .close[disabled]{--close-icon-background-color: transparent;--close-icon-color: var(--beacon-system-color-icon-secondary-inactive)}.input-chip.mini,.input-chip.normal.mini{--input-chip-padding-block: var(--beacon-reference-space-2);--input-chip-padding-inline-start: var(--beacon-reference-space-3);--input-chip-padding-inline-end: var(--beacon-reference-space-2);--close-button-size: var(--beacon-reference-space-5)}`;
var WO = Object.defineProperty, Zv = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && WO(t, e, o), o;
};
const tp = class tp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = _g.beaconTagName, this.focusOverride = !0, this._passthroughs = new Ic(this), this.scale = HO.Normal, this.disabled = !1;
  }
  static get styles() {
    return [super.styles, GO];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, KO];
  }
  dismiss(t) {
    Fe(this, Ee.DISMISS), this.remove();
  }
  render() {
    return pe`
      <output class="${this.scale} input-chip">
        <div class="icon">
          <slot name="icon" ${_e({ useParent: !0 })}></slot>
        </div>
        <div class="label">
          <slot></slot>
        </div>
        <button
          id="${mt(this._passthroughs.attributes.get("id"))}"
          class="close"
          @click=${this.dismiss}
          ?disabled=${this.disabled}
          aria-disabled="${this.disabled}"
          aria-label="close">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="close-small-icon">
            <g clip-path="url(#clip0_233_84)">
              <path
                d="M4.14636 11.1459C3.95115 11.3412 3.95122 11.6578 4.14653 11.853C4.34184 12.0482 4.65842 12.0481 4.85364 11.8528L7.94072 8.76618C7.95635 8.75051 7.97758 8.7417 7.99972 8.7417C8.02185 8.7417 8.04308 8.75051 8.05871 8.76618L11.1458 11.8535C11.2721 11.9798 11.4562 12.0292 11.6287 11.983C11.8013 11.9368 11.9361 11.8021 11.9824 11.6295C12.0286 11.457 11.9794 11.2729 11.8531 11.1466L8.76632 8.05861C8.75065 8.04297 8.74184 8.02175 8.74184 7.99961C8.74184 7.97748 8.75065 7.95625 8.76632 7.94062L11.8537 4.85367C12.049 4.65819 12.0487 4.34147 11.8532 4.14626C11.6577 3.95105 11.341 3.95128 11.1458 4.14676L8.05871 7.23304C8.04308 7.24871 8.02185 7.25752 7.99972 7.25752C7.97758 7.25752 7.95635 7.24871 7.94072 7.23304L4.85364 4.14676C4.65842 3.95146 4.34184 3.95138 4.14653 4.14659C3.95122 4.3418 3.95115 4.65837 4.14636 4.85367L7.23311 7.94062C7.24878 7.95625 7.25759 7.97748 7.25759 7.99961C7.25759 8.02175 7.24878 8.04297 7.23311 8.05861L4.14636 11.1459Z"
                fill="currentColor" />
            </g>
            <defs>
              <clipPath id="clip0_233_84">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </output>
    `;
  }
};
tp.tagName = _g.beaconTagName;
let Ss = tp;
Zv([
  ue({ reflect: !0 })
], Ss.prototype, "scale");
Zv([
  ue({ type: Boolean })
], Ss.prototype, "disabled");
var Ph = /* @__PURE__ */ ((a) => (a.LIST_ITEM = "list-item", a.CARD = "card", a))(Ph || {});
const $n = {
  beaconTagName: "beacon-key-facts",
  frostedGlassName: "frosted-glass",
  valueName: "value",
  labelName: "label"
}, VO = ve`:root,.beacon-on-light,.beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],.beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(255 255 255 / 64%)}.beacon-on-lighter,.beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],.beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(255 255 255 / 64%)}.beacon-on-dark,.beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],.beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],.beacon-on-darker,.beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],.beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-key-facts]{--key-facts-color-background-blurred: rgb(5 76 112 / 48%)}`, qO = ve`:host([scale=mini]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-200)}:host([scale=normal]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-400)}:host([scale=jumbo]){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-600)}:host{background-color:transparent;padding:var(--beacon-system-space-cell-contained)}:host([frosted-glass]){-webkit-backdrop-filter:blur(beacon-reference-space-13);backdrop-filter:blur(beacon-reference-space-13);background-color:var(--key-facts-color-background-blurred)}:host([variant=card]){background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);padding:var(--beacon-system-space-organism-normal)}.label{color:var(--key-facts-supporting-text-label-color);display:var(--key-facts-label-display);font:var(--key-facts-label-font)}.container{--key-facts-cell-padding: var(--beacon-system-space-cell-contained);align-items:flex-start;display:var(--key-facts-figure-display);flex-direction:var(--key-facts-figure-flex-dir, row);margin:0;padding:var(--key-facts-cell-padding);position:relative}.container.variant--list-item{--key-facts-label-display: inline;--key-facts-figure-display: inline-block;--key-facts-supporting-text-label-color: var(--beacon-system-color-text-title);--key-facts-divider-spacing-sides: var(--beacon-reference-space-4);--key-facts-divider-block-size-jumbo: var(--beacon-reference-space-9);--key-facts-divider-block-size-normal: var(--beacon-reference-space-7);--key-facts-divider-block-size-mini: var(--beacon-reference-space-5);--key-facts-divider-spacing-top-jumbo: 3px;--key-facts-divider-spacing-top-normal: 2px;--key-facts-divider-spacing-top-mini: 3px;--beacon-override-vertical-divider-block-size: var(--key-facts-divider-block-size)}@media (width >= 640px){.container.variant--list-item{--key-facts-divider-block-size-jumbo: calc(2.25 * var(--beacon-reference-space-5));--key-facts-divider-block-size-normal: var(--beacon-reference-space-8);--key-facts-divider-block-size-mini: var(--beacon-reference-space-6);--key-facts-divider-spacing-top-jumbo: 4px;--key-facts-divider-spacing-top-normal: 3px;--key-facts-divider-spacing-top-mini: 2px}}@media (width >= 1280px){.container.variant--list-item{--key-facts-divider-block-size-jumbo: var(--beacon-reference-space-10);--key-facts-divider-block-size-normal: var(--beacon-reference-space-9);--key-facts-divider-block-size-mini: var(--beacon-reference-space-7);--key-facts-divider-spacing-top-jumbo: 5px;--key-facts-divider-spacing-top-normal: 4px;--key-facts-divider-spacing-top-mini: 3px}}.container.variant--list-item.scale--mini{--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-100);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);--key-facts-divider-block-size: var(--key-facts-divider-block-size-mini);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-mini)}.container.variant--list-item.scale--normal{--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-300);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300);--key-facts-divider-block-size: var(--key-facts-divider-block-size-normal);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-normal)}.container.variant--list-item.scale--jumbo{--key-facts-divider-spacing-sides: var(--beacon-reference-space-5);--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-headline-500);--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-500);--key-facts-divider-block-size: var(--key-facts-divider-block-size-jumbo);--key-facts-divider-spacing-top: var(--key-facts-divider-spacing-top-jumbo)}.container.variant--list-item .divider{inset-block-start:var(--key-facts-divider-spacing-top);margin-inline:var(--key-facts-divider-spacing-sides);position:relative}.container.variant--card{--key-facts-label-display: block;--key-facts-figure-display: flex;--key-facts-supporting-text-label-color: var(--beacon-system-color-text-standard);--key-facts-figure-flex-dir: column;--key-facts-label-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);gap:var(--beacon-reference-space-3)}.container.variant--card.scale--mini{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.container.variant--card.scale--normal{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}.container.variant--card.scale--jumbo{--key-facts-value-font: var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-500)}.container.variant--card .divider{inline-size:var(--beacon-reference-space-7)}.figure-line,.figure-cell{display:inline-flex;flex-wrap:wrap}.figure-cell{font-weight:var(--beacon-system-font-weight-bold)}.field{display:inline-block}::slotted(*){display:inline;margin:0;padding:0}.value{color:var(--beacon-system-color-text-title);font:var(--key-facts-value-font)}`;
var YO = Object.defineProperty, XO = Object.getOwnPropertyDescriptor, Gc = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? XO(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && YO(t, e, o), o;
};
const fc = class fc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = $n.beaconTagName, this.componentModeStyles = [VO], this.variant = Ph.LIST_ITEM, this.scale = Fo.NORMAL;
  }
  static get styles() {
    return [super.styles, qO];
  }
  postrenderMethods() {
    this.renderComponentModeStyles();
  }
  render() {
    const t = this.variant === Ph.CARD ? ea.Horizontal : ea.Vertical;
    return pe`
      <figure class="container scale--${this.scale} variant--${this.variant}">
        <div class="figure-cell">
          <div class="figure-line">
            <div class="field ${$n.valueName}">
              <slot name="${$n.valueName}"></slot>
            </div>
          </div>
        </div>
        ${ze`<${this.getScopedTag("beacon-divider")}
            class="divider"
            small-sectioning-mode="${t}"
            orientation="${t}"
            color-mode="${Iv.Strong}"
            weight="${zv.Thick}"></${this.getScopedTag("beacon-divider")}>`}
        <figcaption class="label">
          <slot name="${$n.labelName}"></slot>
        </figcaption>
      </figure>
    `;
  }
};
fc.tagName = $n.beaconTagName, fc.nestedComponents = [ai];
let ur = fc;
Gc([
  ue({ reflect: !0 })
], ur.prototype, "variant", 2);
Gc([
  ue({ reflect: !0 })
], ur.prototype, "scale", 2);
Gc([
  ue({ attribute: $n.frostedGlassName, type: Boolean })
], ur.prototype, "frostedGlass", 2);
Gc([
  Re
], ur.prototype, "postrenderMethods", 1);
const Ug = {
  beaconTagName: "beacon-line-chart"
}, op = class op extends Ge(tt).with(
  Qs,
  Zs,
  xn
) {
  constructor() {
    super(...arguments), this.beaconTagName = Ug.beaconTagName;
  }
  static get styles() {
    return [super.styles, this.chartAreaStyles, this.navigatorStyles];
  }
};
op.tagName = Ug.beaconTagName;
let $g = op;
const QO = {
  Mini: "mini",
  Normal: "normal",
  Jumbo: "jumbo",
  Maxi: "maxi"
}, { Maxi: ez, ...Zr } = QO, Hg = {
  beaconTagName: "beacon-loading-spinner"
}, ZO = ve`@keyframes spin{to{transform:rotate(1turn)}}:host{--loader-base-size: 40px;--loader-multiplier: 1;--loader-size: calc(var(--loader-base-size) * var(--loader-multiplier));inline-size:var(--loader-size)!important}:host(:is([scale=normal],[scale=jumbo])){--loader-multiplier: 2}@media (width >= 640px){:host([scale=jumbo]){--loader-multiplier: 3}}.label{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.outer,.inner{fill:transparent;stroke-width:10}.outer{stroke:var(--beacon-system-color-background-secondary-hover)}.inner{animation:var(--beacon-reference-motion-duration-10) var(--beacon-system-motion-easing-linear) infinite spin;stroke:var(--beacon-system-color-icon-secondary);stroke-dasharray:282.744;stroke-dashoffset:70;transform-origin:50% 50%}`;
var JO = Object.defineProperty, eP = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && JO(t, e, o), o;
};
const ip = class ip extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Hg.beaconTagName, this.motionState = "enabled", this.scale = Zr.Normal;
  }
  static get styles() {
    return [super.styles, ZO];
  }
  render() {
    return pe`
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        role="progressbar"
        aria-labelledby="label">
        <circle class="outer" cx="50" cy="50" r="45" />
        <circle class="inner" cx="50" cy="50" r="45" />
      </svg>
      <div class="label" id="label">
        <slot></slot>
      </div>
    `;
  }
};
ip.tagName = Hg.beaconTagName;
let Dh = ip;
eP([
  ue({ reflect: !0 })
], Dh.prototype, "scale");
var Jv = { exports: {} };
(function(a) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Highcharts Drilldown module
  *
  * Author: Torstein Honsi
  * License: www.highcharts.com/license
  *
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Extensions/Breadcrumbs/BreadcrumbsDefaults.js", [], function() {
      return { lang: { mainBreadcrumb: "Main" }, options: { buttonTheme: { fill: "none", height: 18, padding: 2, "stroke-width": 0, zIndex: 7, states: { select: { fill: "none" } }, style: { color: "#334eff" } }, buttonSpacing: 5, floating: !1, format: void 0, relativeTo: "plotBox", rtl: !1, position: { align: "left", verticalAlign: "top", x: 0, y: void 0 }, separator: { text: "/", style: { color: "#666666", fontSize: "0.8em" } }, showFullPath: !0, style: {}, useHTML: !1, zIndex: 7 } };
    }), i(e, "Extensions/Breadcrumbs/Breadcrumbs.js", [e["Extensions/Breadcrumbs/BreadcrumbsDefaults.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { format: D } = n, { composed: j } = l, { addEvent: I, defined: B, extend: R, fireEvent: N, isString: x, merge: T, objectEach: y, pick: S, pushUnique: u } = L;
      function A() {
        if (this.breadcrumbs) {
          let _ = this.resetZoomButton && this.resetZoomButton.getBBox(), E = this.breadcrumbs.options;
          _ && E.position.align === "right" && E.relativeTo === "plotBox" && this.breadcrumbs.alignBreadcrumbsGroup(-_.width - E.buttonSpacing);
        }
      }
      function M() {
        this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
      }
      function f() {
        let _ = this.breadcrumbs;
        if (_ && !_.options.floating && _.level) {
          let E = _.options, v = E.buttonTheme, w = (v.height || 0) + 2 * (v.padding || 0) + E.buttonSpacing, d = E.position.verticalAlign;
          d === "bottom" ? (this.marginBottom = (this.marginBottom || 0) + w, _.yOffset = w) : d !== "middle" ? (this.plotTop += w, _.yOffset = -w) : _.yOffset = void 0;
        }
      }
      function m() {
        this.breadcrumbs && this.breadcrumbs.redraw();
      }
      function C(_) {
        _.resetSelection === !0 && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
      }
      class F {
        static compose(E, v) {
          u(j, "Breadcrumbs") && (I(E, "destroy", M), I(E, "afterShowResetZoom", A), I(E, "getMargins", f), I(E, "redraw", m), I(E, "selection", C), R(v.lang, o.lang));
        }
        constructor(E, v) {
          this.elementList = {}, this.isDirty = !0, this.level = 0, this.list = [];
          let w = T(E.options.drilldown && E.options.drilldown.drillUpButton, F.defaultOptions, E.options.navigation && E.options.navigation.breadcrumbs, v);
          this.chart = E, this.options = w || {};
        }
        updateProperties(E) {
          this.setList(E), this.setLevel(), this.isDirty = !0;
        }
        setList(E) {
          this.list = E;
        }
        setLevel() {
          this.level = this.list.length && this.list.length - 1;
        }
        getLevel() {
          return this.level;
        }
        getButtonText(E) {
          let v = this.chart, w = this.options, d = v.options.lang, r = S(w.format, w.showFullPath ? "{level.name}" : "← {level.name}"), s = d && S(d.drillUpText, d.mainBreadcrumb), p = w.formatter && w.formatter(E) || D(r, { level: E.levelOptions }, v) || "";
          return (x(p) && !p.length || p === "← ") && B(s) && (p = w.showFullPath ? s : "← " + s), p;
        }
        redraw() {
          this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
        }
        render() {
          let E = this.chart, v = this.options;
          !this.group && v && (this.group = E.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({ zIndex: v.zIndex }).add()), v.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
        }
        renderFullPathButtons() {
          this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
        }
        renderSingleButton() {
          let E = this.chart, v = this.list, w = this.options.buttonSpacing;
          this.destroyListElements();
          let d = this.group ? this.group.getBBox().width : w, r = v[v.length - 2];
          !E.drillUpButton && this.level > 0 ? E.drillUpButton = this.renderButton(r, d, w) : E.drillUpButton && (this.level > 0 ? this.updateSingleButton() : this.destroySingleButton());
        }
        alignBreadcrumbsGroup(E) {
          if (this.group) {
            let v = this.options, w = v.buttonTheme, d = v.position, r = v.relativeTo === "chart" || v.relativeTo === "spacingBox" ? void 0 : "plotBox", s = this.group.getBBox(), p = 2 * (w.padding || 0) + v.buttonSpacing;
            d.width = s.width + p, d.height = s.height + p;
            let b = T(d);
            E && (b.x += E), this.options.rtl && (b.x += d.width), b.y = S(b.y, this.yOffset, 0), this.group.align(b, !0, r);
          }
        }
        renderButton(E, v, w) {
          let d = this, r = this.chart, s = d.options, p = T(s.buttonTheme), b = r.renderer.button(d.getButtonText(E), v, w, function(c) {
            let h, g = s.events && s.events.click;
            g && (h = g.call(d, c, E)), h !== !1 && (s.showFullPath ? c.newLevel = E.level : c.newLevel = d.level - 1, N(d, "up", c));
          }, p).addClass("highcharts-breadcrumbs-button").add(d.group);
          return r.styledMode || b.attr(s.style), b;
        }
        renderSeparator(E, v) {
          let w = this.chart, d = this.options.separator, r = w.renderer.label(d.text, E, v, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group);
          return w.styledMode || r.css(d.style), r;
        }
        update(E) {
          T(!0, this.options, E), this.destroy(), this.isDirty = !0;
        }
        updateSingleButton() {
          let E = this.chart, v = this.list[this.level - 1];
          E.drillUpButton && E.drillUpButton.attr({ text: this.getButtonText(v) });
        }
        destroy() {
          this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
        }
        destroyListElements(E) {
          let v = this.elementList;
          y(v, (w, d) => {
            (E || !v[d].updated) && ((w = v[d]).button && w.button.destroy(), w.separator && w.separator.destroy(), delete w.button, delete w.separator, delete v[d]);
          }), E && (this.elementList = {});
        }
        destroySingleButton() {
          this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
        }
        resetElementListState() {
          y(this.elementList, (E) => {
            E.updated = !1;
          });
        }
        updateListElements() {
          let E = this.elementList, v = this.options.buttonSpacing, w = this.list, d = this.options.rtl, r = d ? -1 : 1, s = function(g, k) {
            return r * g.getBBox().width + r * k;
          }, p = function(g, k, P) {
            g.translate(k - g.getBBox().width, P);
          }, b = this.group ? s(this.group, v) : v, c, h;
          for (let g = 0, k = w.length; g < k; ++g) {
            let P, O, z = g === k - 1;
            E[(h = w[g]).level] ? (P = (c = E[h.level]).button, c.separator || z ? c.separator && z && (c.separator.destroy(), delete c.separator) : (b += r * v, c.separator = this.renderSeparator(b, v), d && p(c.separator, b, v), b += s(c.separator, v)), E[h.level].updated = !0) : (P = this.renderButton(h, b, v), d && p(P, b, v), b += s(P, v), z || (O = this.renderSeparator(b, v), d && p(O, b, v), b += s(O, v)), E[h.level] = { button: P, separator: O, updated: !0 }), P && P.setState(z ? 2 : 0);
          }
        }
      }
      return F.defaultOptions = o.options, F;
    }), i(e, "Extensions/Drilldown/DrilldownDefaults.js", [], function() {
      return { activeAxisLabelStyle: { cursor: "pointer", color: "#0022ff", fontWeight: "bold", textDecoration: "underline" }, activeDataLabelStyle: { cursor: "pointer", color: "#0022ff", fontWeight: "bold", textDecoration: "underline" }, animation: { duration: 500 }, drillUpButton: { position: { align: "right", x: -10, y: 10 } }, mapZooming: !0 };
    }), i(e, "Extensions/Drilldown/DrilldownSeries.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Utilities.js"]], function(o, n) {
      let { animObject: l } = o, { addEvent: L, extend: D, fireEvent: j, merge: I, pick: B, syncTimeout: R } = n;
      function N(d, r, s, p) {
        d[s ? "addClass" : "removeClass"]("highcharts-drilldown-point"), p || d.css({ cursor: r });
      }
      function x(d) {
        let r = this, s = r.chart, p = s.drilldownLevels, b = l((s.options.drilldown || {}).animation), c = this.xAxis, h = s.styledMode;
        if (!d) {
          let g;
          (p || []).forEach((k) => {
            r.options._ddSeriesId === k.lowerSeriesOptions._ddSeriesId && (g = k.shapeArgs, !h && g && (g.fill = k.color));
          }), g.x += B(c.oldPos, c.pos) - c.pos, r.points.forEach((k) => {
            let P = k.shapeArgs;
            h || (P.fill = k.color), k.graphic && k.graphic.attr(g).animate(D(k.shapeArgs, { fill: k.color || r.color }), b);
          }), s.drilldown && s.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate;
        }
      }
      function T(d) {
        let r = this, s = l((r.chart.options.drilldown || {}).animation);
        (r.trackerGroups || []).forEach((c) => {
          r[c] && r[c].on("mouseover");
        });
        let p = r.group, b = p !== r.chart.columnGroup;
        b && delete r.group, this.points.forEach((c) => {
          let h = c.graphic, g = d.shapeArgs;
          if (h && g) {
            let k = () => {
              h.destroy(), p && b && (p = p.destroy());
            };
            delete c.graphic, r.chart.styledMode || (g.fill = d.color), s.duration ? h.animate(g, I(s, { complete: k })) : (h.attr(g), k());
          }
        });
      }
      function y(d) {
        let r = this, s = r.drilldownLevel;
        d || (r.points.forEach((p) => {
          var c;
          let b = p.dataLabel;
          p.graphic && p.graphic.hide(), b && (b.hidden = b.attr("visibility") === "hidden", b.hidden || (b.hide(), (c = b.connector) == null || c.hide()));
        }), R(() => {
          if (r.points) {
            let p = [];
            r.data.forEach((b) => {
              p.push(b);
            }), r.nodes && (p = p.concat(r.nodes)), p.forEach((b, c) => {
              var k;
              let h = c === (s && s.pointIndex) ? "show" : "fadeIn", g = b.dataLabel;
              b.graphic && b.visible && b.graphic[h](h === "show" || void 0), g && !g.hidden && (g.fadeIn(), (k = g.connector) == null || k.fadeIn());
            });
          }
        }, Math.max(r.chart.options.drilldown.animation.duration - 50, 0)), delete this.animate);
      }
      function S(d) {
        let r = this, s = r.chart, p = r.group;
        s && p && r.options && s.options.drilldown && s.options.drilldown.animation && (d && s.mapView ? (p.attr({ opacity: 0.01 }), s.mapView.allowTransformAnimation = !1, r.options.inactiveOtherPoints = !0, r.options.enableMouseTracking = !1) : (p.animate({ opacity: 1 }, s.options.drilldown.animation, () => {
          r.options && (r.options.inactiveOtherPoints = !1, r.options.enableMouseTracking = B(r.userOptions && r.userOptions.enableMouseTracking, !0), r.isDirty = !0, s.redraw());
        }), s.drilldown && s.drilldown.fadeInGroup(this.dataLabelsGroup)));
      }
      function u() {
        let d = this.chart;
        d && d.mapView && (d.mapView.allowTransformAnimation = !1), this.options && (this.options.inactiveOtherPoints = !0);
      }
      function A(d) {
        let r = this.chart, s = this.group;
        r && s && (d ? (s.attr({ opacity: 0.01 }), this.options && (this.options.inactiveOtherPoints = !0)) : (s.animate({ opacity: 1 }, (r.options.drilldown || {}).animation), r.drilldown && r.drilldown.fadeInGroup(this.dataLabelsGroup)));
      }
      function M() {
        return this.drilldown && !this.unbindDrilldownClick && (this.unbindDrilldownClick = L(this, "click", m)), this;
      }
      function f() {
        let d = this.series, r = d.chart.styledMode;
        this.drilldown && d.halo && this.state === "hover" ? N(d.halo, "pointer", !0, r) : d.halo && N(d.halo, "auto", !1, r);
      }
      function m(d) {
        let r = this.series;
        r.xAxis && (r.chart.options.drilldown || {}).allowPointDrilldown === !1 ? r.xAxis.drilldownCategory(this.x, d) : this.runDrilldown(void 0, void 0, d);
      }
      function C(d) {
        let r = d.options || {};
        r.drilldown && !this.unbindDrilldownClick ? this.unbindDrilldownClick = L(this, "click", m) : !r.drilldown && r.drilldown !== void 0 && this.unbindDrilldownClick && (this.unbindDrilldownClick = this.unbindDrilldownClick());
      }
      function F() {
        let d = this.chart, r = d.options.drilldown.activeDataLabelStyle, s = d.renderer, p = d.styledMode;
        for (let b of this.points) {
          let c = b.options.dataLabels, h = B(b.dlOptions, c && c.style, {});
          b.drilldown && b.dataLabel && (r.color !== "contrast" || p || (h.color = s.getContrast(b.color || this.color)), c && c.color && (h.color = c.color), b.dataLabel.addClass("highcharts-drilldown-data-label"), p || b.dataLabel.css(r).css(h));
        }
      }
      function _() {
        let d = this.chart.styledMode;
        for (let r of this.points) r.drilldown && r.graphic && N(r.graphic, "pointer", !0, d);
      }
      function E(d) {
        let r = this.chart, s = this.points, p = r.drilldownLevels[r.drilldownLevels.length - 1], b = r.options.drilldown.animation;
        if (this.is("item") && (b.duration = 0), this.center) {
          let c = p.shapeArgs, h = c.start, g = (c.end - h) / this.points.length, k = r.styledMode;
          if (!d) {
            let P, O;
            for (let z = 0, W = s.length; z < W; ++z) P = (O = s[z]).shapeArgs, k || (c.fill = p.color, P.fill = O.color), O.graphic && O.graphic.attr(I(c, { start: h + z * g, end: h + (z + 1) * g }))[b ? "animate" : "attr"](P, b);
            r.drilldown && r.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate;
          }
        }
      }
      function v() {
        this.runDrilldown();
      }
      function w(d, r, s) {
        let p = this.series, b = p.chart, c = b.options.drilldown || {}, h = (c.series || []).length, g;
        for (b.ddDupes || (b.ddDupes = []), b.colorCounter = b.symbolCounter = 0; h-- && !g; ) c.series && c.series[h].id === this.drilldown && this.drilldown && b.ddDupes.indexOf(this.drilldown) === -1 && (g = c.series[h], b.ddDupes.push(this.drilldown));
        j(b, "drilldown", { point: this, seriesOptions: g, category: r, originalEvent: s, points: r !== void 0 && p.xAxis.getDDPoints(r).slice(0) }, (k) => {
          let P = k.point.series && k.point.series.chart, O = k.seriesOptions;
          P && O && (d ? P.addSingleSeriesAsDrilldown(k.point, O) : P.addSeriesAsDrilldown(k.point, O));
        });
      }
      return { compose: function(d, r) {
        let s = d.prototype.pointClass, p = s.prototype;
        if (!p.doDrilldown) {
          let { column: b, map: c, pie: h } = r;
          if (L(s, "afterInit", M), L(s, "afterSetState", f), L(s, "update", C), p.doDrilldown = v, p.runDrilldown = w, L(d, "afterDrawDataLabels", F), L(d, "afterDrawTracker", _), b) {
            let g = b.prototype;
            g.animateDrilldown = x, g.animateDrillupFrom = T, g.animateDrillupTo = y;
          }
          if (c) {
            let g = c.prototype;
            g.animateDrilldown = S, g.animateDrillupFrom = u, g.animateDrillupTo = A;
          }
          if (h) {
            let g = h.prototype;
            g.animateDrilldown = E, g.animateDrillupFrom = T, g.animateDrillupTo = y;
          }
        }
      } };
    }), i(e, "Extensions/Drilldown/Drilldown.js", [e["Core/Animation/AnimationUtilities.js"], e["Extensions/Breadcrumbs/Breadcrumbs.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Extensions/Drilldown/DrilldownDefaults.js"], e["Extensions/Drilldown/DrilldownSeries.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I) {
      var B;
      let { animObject: R } = o, { noop: N } = L, { addEvent: x, defined: T, diffObjects: y, extend: S, fireEvent: u, merge: A, objectEach: M, pick: f, removeEvent: m, syncTimeout: C } = I, F = 1;
      function _(d, r) {
        this.getDDPoints(d).forEach(function(s) {
          s && s.series && s.series.visible && s.runDrilldown && s.runDrilldown(!0, d, r);
        }), this.chart.applyDrilldown();
      }
      function E(d) {
        return this.ddPoints && this.ddPoints[d] || [];
      }
      function v(d) {
        let r = [], s = d.drilldownLevels;
        return s && s.length && (r[0] || r.push({ level: 0, levelOptions: s[0].seriesOptions }), s.forEach(function(p) {
          let b = r[r.length - 1];
          p.levelNumber + 1 > b.level && r.push({ level: p.levelNumber + 1, levelOptions: A({ name: p.lowerSeries.name }, p.pointOptions) });
        })), r;
      }
      class w {
        constructor(r) {
          this.chart = r;
        }
        addSeriesAsDrilldown(r, s) {
          let p = this.chart || this;
          if (u(this, "addSeriesAsDrilldown", { seriesOptions: s }), p.mapView)
            if (r.series.isDrilling = !0, p.series.forEach((b) => {
              var c;
              b.options.inactiveOtherPoints = !0, (c = b.dataLabelsGroup) == null || c.destroy(), delete b.dataLabelsGroup;
            }), p.options.drilldown && !p.mapView.projection.hasGeoProjection && D && !T(y(p.options.drilldown, D).mapZooming) && (p.options.drilldown.mapZooming = !1), p.options.drilldown && p.options.drilldown.animation && p.options.drilldown.mapZooming) {
              p.mapView.allowTransformAnimation = !0;
              let b = R(p.options.drilldown.animation);
              if (typeof b != "boolean") {
                let c = b.complete, h = function(g) {
                  g && g.applyDrilldown && p.mapView && (p.addSingleSeriesAsDrilldown(r, s), p.applyDrilldown(), p.mapView.allowTransformAnimation = !1);
                };
                b.complete = function() {
                  c && c.apply(this, arguments), h.apply(this, arguments);
                };
              }
              r.zoomTo(b);
            } else p.addSingleSeriesAsDrilldown(r, s), p.applyDrilldown();
          else p.addSingleSeriesAsDrilldown(r, s), p.applyDrilldown();
        }
        addSingleSeriesAsDrilldown(r, s) {
          let p = this.chart || this, b = r.series, c = b.xAxis, h = b.yAxis, g = p.styledMode ? { colorIndex: f(r.colorIndex, b.colorIndex) } : { color: r.color || b.color }, k = b.options._levelNumber || 0, P = b.points.indexOf(r);
          p.drilldownLevels || (p.drilldownLevels = []), s = S(S({ _ddSeriesId: F++ }, g), s);
          let O = [], z = [], W;
          (W = p.drilldownLevels[p.drilldownLevels.length - 1]) && W.levelNumber !== k && (W = void 0), b.chart.series.forEach((U) => {
            U.xAxis === c && (U.options._ddSeriesId = U.options._ddSeriesId || F++, U.options.colorIndex = U.colorIndex, U.options._levelNumber = U.options._levelNumber || k, W ? (O = W.levelSeries, z = W.levelSeriesOptions) : (O.push(U), U.purgedOptions = A({ _ddSeriesId: U.options._ddSeriesId, _levelNumber: U.options._levelNumber, selected: U.options.selected }, U.userOptions), z.push(U.purgedOptions)));
          });
          let G = S({ levelNumber: k, seriesOptions: b.options, seriesPurgedOptions: b.purgedOptions, levelSeriesOptions: z, levelSeries: O, shapeArgs: r.shapeArgs, bBox: r.graphic ? r.graphic.getBBox() : {}, color: r.isNull ? l.parse(g.color).setOpacity(0).get() : g.color, lowerSeriesOptions: s, pointOptions: b.options.data[P], pointIndex: P, oldExtremes: { xMin: c && c.userMin, xMax: c && c.userMax, yMin: h && h.userMin, yMax: h && h.userMax }, resetZoomButton: W && W.levelNumber === k ? void 0 : p.resetZoomButton }, g);
          p.drilldownLevels.push(G), c && c.names && (c.names.length = 0);
          let Y = G.lowerSeries = p.addSeries(s, !1);
          Y.options._levelNumber = k + 1, c && (c.oldPos = c.pos, c.userMin = c.userMax = null, h.userMin = h.userMax = null), Y.isDrilling = !0, b.type === Y.type && (Y.animate = Y.animateDrilldown || N, Y.options.animation = !0);
        }
        applyDrilldown() {
          var b;
          let r, s = this.chart || this, p = s.drilldownLevels;
          p && p.length > 0 && (r = p[p.length - 1].levelNumber, s.hasCartesianSeries = p.some((c) => c.lowerSeries.isCartesian), (s.drilldownLevels || []).forEach((c) => {
            s.mapView && s.options.drilldown && s.options.drilldown.mapZooming && (s.redraw(), c.lowerSeries.isDrilling = !1, s.mapView.fitToBounds(c.lowerSeries.bounds), c.lowerSeries.isDrilling = !0), c.levelNumber === r && c.levelSeries.forEach((h) => {
              if (s.mapView) {
                if (h.options && h.options._levelNumber === r && h.group) {
                  let g = {};
                  s.options.drilldown && (g = s.options.drilldown.animation), h.group.animate({ opacity: 0 }, g, () => {
                    var k;
                    h.remove(!1), c.levelSeries.filter((P) => Object.keys(P).length).length || (s.resetZoomButton && (s.resetZoomButton.hide(), delete s.resetZoomButton), (k = s.pointer) == null || k.reset(), u(s, "afterDrilldown"), s.mapView && (s.series.forEach((P) => {
                      P.isDirtyData = !0, P.isDrilling = !1;
                    }), s.mapView.fitToBounds(void 0, void 0), s.mapView.allowTransformAnimation = !0), u(s, "afterApplyDrilldown"));
                  });
                }
              } else h.options && h.options._levelNumber === r && h.remove(!1);
            });
          })), s.mapView || (s.resetZoomButton && (s.resetZoomButton.hide(), delete s.resetZoomButton), (b = s.pointer) == null || b.reset(), u(s, "afterDrilldown"), s.hasCartesianSeries || s.axes.forEach((c) => {
            c.destroy(!0), c.init(s, A(c.userOptions, c.options));
          }), s.redraw(), u(s, "afterApplyDrilldown"));
        }
        drillUp(r) {
          let s = this.chart || this;
          if (!s.drilldownLevels || s.drilldownLevels.length === 0) return;
          u(s, "beforeDrillUp");
          let p = s.drilldownLevels, b = p[p.length - 1].levelNumber, c = s.series, h = s.drilldownLevels.length, g = (G, Y) => {
            let U;
            if (c.forEach((H) => {
              H.options._ddSeriesId === G._ddSeriesId && (U = H);
            }), (U = U || s.addSeries(G, !1)).type === Y.type && U.animateDrillupTo && (U.animate = U.animateDrillupTo), G === z.seriesPurgedOptions) return U;
          }, k = (G) => {
            G.remove(!1), s.series.forEach((Y) => {
              Y.colorAxis && (Y.isDirtyData = !0), Y.options.inactiveOtherPoints = !1;
            }), s.redraw();
          }, P = p.length, O, z, W;
          for (s.symbolCounter = s.colorCounter = 0; P--; ) {
            let G, Y;
            if ((z = p[P]).levelNumber === b) {
              if (p.pop(), !(G = z.lowerSeries).chart) {
                for (O = c.length; O--; ) if (c[O].options.id === z.lowerSeriesOptions.id && c[O].options._levelNumber === b + 1) {
                  G = c[O];
                  break;
                }
              }
              G.xData = [], G.xAxis && G.xAxis.names && (h === 0 || P === h - 1) && (G.xAxis.names.length = 0), z.levelSeriesOptions.forEach((H) => {
                let q = g(H, G);
                q && (Y = q);
              }), u(s, "drillup", { seriesOptions: z.seriesPurgedOptions || z.seriesOptions }), Y && (Y.type === G.type && (Y.drilldownLevel = z, Y.options.animation = s.options.drilldown.animation, G.animateDrillupFrom && G.chart && G.animateDrillupFrom(z)), Y.options._levelNumber = b);
              let U = G;
              if (s.mapView || U.remove(!1), Y && Y.xAxis && (W = z.oldExtremes, Y.xAxis.setExtremes(W.xMin, W.xMax, !1), Y.yAxis.setExtremes(W.yMin, W.yMax, !1)), z.resetZoomButton && (s.resetZoomButton = z.resetZoomButton), s.mapView) {
                let H = z.levelNumber === b && r, q = s.options.drilldown && s.options.drilldown.animation && s.options.drilldown.mapZooming;
                H ? G.remove(!1) : (G.dataLabelsGroup && (G.dataLabelsGroup.destroy(), delete G.dataLabelsGroup), s.mapView && Y && (q && (G.isDrilling = !0, Y.isDrilling = !0, s.redraw(!1), s.mapView.fitToBounds(G.bounds, void 0, !0, !1)), s.mapView.allowTransformAnimation = !0, u(s, "afterDrillUp", { seriesOptions: Y ? Y.userOptions : void 0 }), q ? (s.mapView.setView(void 0, f(s.mapView.minZoom, 1), !0, { complete: function() {
                  Object.prototype.hasOwnProperty.call(this, "complete") && k(G);
                } }), Y._hasTracking = !1) : (s.mapView.allowTransformAnimation = !1, G.group ? G.group.animate({ opacity: 0 }, s.options.drilldown.animation, () => {
                  k(G), s.mapView && (s.mapView.allowTransformAnimation = !0);
                }) : (k(G), s.mapView.allowTransformAnimation = !0)), Y.isDrilling = !1));
              } else u(s, "afterDrillUp");
            }
          }
          s.mapView || s.redraw(), s.ddDupes && (s.ddDupes.length = 0), u(s, "drillupall");
        }
        fadeInGroup(r) {
          let s = R(this.chart.options.drilldown.animation);
          r && (r.hide(), C(() => {
            r && r.added && r.fadeIn();
          }, Math.max(s.duration - 50, 0)));
        }
        update(r, s) {
          let p = this.chart;
          A(!0, p.options.drilldown, r), f(s, !0) && p.redraw();
        }
      }
      return function(d) {
        function r(z) {
          let W = this.chart, G = this.getLevel() - z.newLevel, Y = G > 1;
          for (let U = 0; U < G; U++) U === G - 1 && (Y = !1), W.drillUp(Y);
        }
        function s() {
          let z = this.options.drilldown, W = z && z.breadcrumbs;
          this.breadcrumbs || (this.breadcrumbs = new n(this, W)), this.breadcrumbs.updateProperties(v(this));
        }
        function p() {
          this.breadcrumbs && this.breadcrumbs.updateProperties(v(this));
        }
        function b() {
          this.drilldown = new w(this);
        }
        function c() {
          this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy());
        }
        function h() {
          this.resetZoomButton && this.showResetZoom();
        }
        function g() {
          (this.xAxis || []).forEach((z) => {
            z.ddPoints = {}, z.series.forEach((W) => {
              let G = W.xData || [], Y = W.points;
              for (let U = 0, H = G.length, q; U < H; U++) if (typeof (q = W.options.data[U]) != "number" && (q = W.pointClass.prototype.optionsToObject.call({ series: W }, q)).drilldown) {
                z.ddPoints[G[U]] || (z.ddPoints[G[U]] = []);
                let X = U - (W.cropStart || 0);
                z.ddPoints[G[U]].push(!Y || !(X >= 0) || !(X < Y.length) || Y[X]);
              }
            }), M(z.ticks, (W) => W.drillable());
          });
        }
        function k(z) {
          let W = this.breadcrumbs, G = z.options.drilldown && z.options.drilldown.breadcrumbs;
          W && G && W.update(G);
        }
        function P(z) {
          this.attr({ opacity: 0.1, visibility: "inherit" }).animate({ opacity: f(this.newOpacity, 1) }, z || { duration: 250 });
        }
        function O() {
          let z = this.pos, W = this.label, G = this.axis, Y = G.coll === "xAxis" && G.getDDPoints, U = Y && G.getDDPoints(z), H = G.chart.styledMode;
          Y && (W && U && U.length ? (W.drillable = !0, W.basicStyles || H || (W.basicStyles = A(W.styles)), W.addClass("highcharts-drilldown-axis-label"), W.removeOnDrillableClick && m(W.element, "click"), W.removeOnDrillableClick = x(W.element, "click", function(q) {
            q.preventDefault(), G.drilldownCategory(z, q);
          }), !H && G.chart.options.drilldown && W.css(G.chart.options.drilldown.activeAxisLabelStyle || {})) : W && W.drillable && W.removeOnDrillableClick && (H || (W.styles = {}, W.element.removeAttribute("style"), W.css(W.basicStyles)), W.removeOnDrillableClick(), W.removeClass("highcharts-drilldown-axis-label")));
        }
        d.compose = function(z, W, G, Y, U, H, q) {
          j.compose(Y, U);
          let X = W.prototype;
          if (!X.drillUp) {
            let $ = H.prototype.Element, K = w.prototype, V = z.prototype, Q = $.prototype, Z = q.prototype;
            V.drilldownCategory = _, V.getDDPoints = E, n.compose(W, G), x(n, "up", r), X.addSeriesAsDrilldown = K.addSeriesAsDrilldown, X.addSingleSeriesAsDrilldown = K.addSingleSeriesAsDrilldown, X.applyDrilldown = K.applyDrilldown, X.drillUp = K.drillUp, x(W, "afterDrilldown", s), x(W, "afterDrillUp", p), x(W, "afterInit", b), x(W, "drillup", c), x(W, "drillupall", h), x(W, "render", g), x(W, "update", k), G.drilldown = D, Q.fadeIn = P, Z.drillable = O;
          }
        };
      }(B || (B = {})), B;
    }), i(e, "masters/modules/drilldown.src.js", [e["Core/Globals.js"], e["Extensions/Drilldown/Drilldown.js"], e["Extensions/Breadcrumbs/Breadcrumbs.js"]], function(o, n, l) {
      return o.Breadcrumbs = o.Breadcrumbs || l, n.compose(o.Axis, o.Chart, o.defaultOptions, o.Series, o.seriesTypes, o.SVGRenderer, o.Tick), o;
    });
  });
})(Jv);
var tP = Jv.exports;
const Kg = /* @__PURE__ */ ri(tP);
var eA = { exports: {} };
(function(a) {
  /**
  * Highmaps JS v11.4.8 (2024-08-29)
  *
  * Highmaps as a plugin for Highcharts or Highcharts Stock.
  *
  * (c) 2011-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(t) {
    a.exports ? (t.default = t, a.exports = t) : t(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(t) {
    var e = t ? t._modules : {};
    function i(o, n, l, L) {
      o.hasOwnProperty(n) || (o[n] = L.apply(null, l), typeof CustomEvent == "function" && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: n, module: o[n] } })));
    }
    i(e, "Core/Axis/Color/ColorAxisComposition.js", [e["Core/Color/Color.js"], e["Core/Utilities.js"]], function(o, n) {
      var l;
      let { parse: L } = o, { addEvent: D, extend: j, merge: I, pick: B, splat: R } = n;
      return function(N) {
        let x;
        function T() {
          let { userOptions: _ } = this;
          this.colorAxis = [], _.colorAxis && (_.colorAxis = R(_.colorAxis), _.colorAxis.map((E) => new x(this, E)));
        }
        function y(_) {
          let E = this.chart.colorAxis || [], v = (s) => {
            let p = _.allItems.indexOf(s);
            p !== -1 && (this.destroyItem(_.allItems[p]), _.allItems.splice(p, 1));
          }, w = [], d, r;
          for (E.forEach(function(s) {
            (d = s.options) && d.showInLegend && (d.dataClasses && d.visible ? w = w.concat(s.getDataClassLegendSymbols()) : d.visible && w.push(s), s.series.forEach(function(p) {
              (!p.options.showInLegend || d.dataClasses) && (p.options.legendType === "point" ? p.points.forEach(function(b) {
                v(b);
              }) : v(p));
            }));
          }), r = w.length; r--; ) _.allItems.unshift(w[r]);
        }
        function S(_) {
          _.visible && _.item.legendColor && _.item.legendItem.symbol.attr({ fill: _.item.legendColor });
        }
        function u(_) {
          var E;
          (E = this.chart.colorAxis) == null || E.forEach((v) => {
            v.update({}, _.redraw);
          });
        }
        function A() {
          (this.chart.colorAxis && this.chart.colorAxis.length || this.colorAttribs) && this.translateColors();
        }
        function M() {
          let _ = this.axisTypes;
          _ ? _.indexOf("colorAxis") === -1 && _.push("colorAxis") : this.axisTypes = ["colorAxis"];
        }
        function f(_) {
          let E = this, v = _ ? "show" : "hide";
          E.visible = E.options.visible = !!_, ["graphic", "dataLabel"].forEach(function(w) {
            E[w] && E[w][v]();
          }), this.series.buildKDTree();
        }
        function m() {
          let _ = this, E = this.getPointsCollection(), v = this.options.nullColor, w = this.colorAxis, d = this.colorKey;
          E.forEach((r) => {
            let s = r.getNestedProperty(d), p = r.options.color || (r.isNull || r.value === null ? v : w && s !== void 0 ? w.toColor(s, r) : r.color || _.color);
            p && r.color !== p && (r.color = p, _.options.legendType === "point" && r.legendItem && r.legendItem.label && _.chart.legend.colorizeItem(r, r.visible));
          });
        }
        function C() {
          this.elem.attr("fill", L(this.start).tweenTo(L(this.end), this.pos), void 0, !0);
        }
        function F() {
          this.elem.attr("stroke", L(this.start).tweenTo(L(this.end), this.pos), void 0, !0);
        }
        N.compose = function(_, E, v, w, d) {
          let r = E.prototype, s = v.prototype, p = d.prototype;
          r.collectionsWithUpdate.includes("colorAxis") || (x = _, r.collectionsWithUpdate.push("colorAxis"), r.collectionsWithInit.colorAxis = [r.addColorAxis], D(E, "afterGetAxes", T), function(b) {
            let c = b.prototype.createAxis;
            b.prototype.createAxis = function(h, g) {
              if (h !== "colorAxis") return c.apply(this, arguments);
              let k = new x(this, I(g.axis, { index: this[h].length, isX: !1 }));
              return this.isDirtyLegend = !0, this.axes.forEach((P) => {
                P.series = [];
              }), this.series.forEach((P) => {
                P.bindAxes(), P.isDirtyData = !0;
              }), B(g.redraw, !0) && this.redraw(g.animation), k;
            };
          }(E), s.fillSetter = C, s.strokeSetter = F, D(w, "afterGetAllItems", y), D(w, "afterColorizeItem", S), D(w, "afterUpdate", u), j(p, { optionalAxis: "colorAxis", translateColors: m }), j(p.pointClass.prototype, { setVisible: f }), D(d, "afterTranslate", A, { order: 1 }), D(d, "bindAxes", M));
        }, N.pointSetVisible = f;
      }(l || (l = {})), l;
    }), i(e, "Core/Axis/Color/ColorAxisDefaults.js", [], function() {
      return { lineWidth: 0, minPadding: 0, maxPadding: 0, gridLineColor: "#ffffff", gridLineWidth: 1, tickPixelInterval: 72, startOnTick: !0, endOnTick: !0, offset: 0, marker: { animation: { duration: 50 }, width: 0.01, color: "#999999" }, labels: { distance: 8, overflow: "justify", rotation: 0 }, minColor: "#e6e9ff", maxColor: "#0022ff", tickLength: 5, showInLegend: !0 };
    }), i(e, "Core/Axis/Color/ColorAxisLike.js", [e["Core/Color/Color.js"], e["Core/Utilities.js"]], function(o, n) {
      var l, L;
      let { parse: D } = o, { merge: j } = n;
      return (L = l || (l = {})).initDataClasses = function(I) {
        let B = this.chart, R = this.legendItem = this.legendItem || {}, N = this.options, x = I.dataClasses || [], T, y, S = B.options.chart.colorCount, u = 0, A;
        this.dataClasses = y = [], R.labels = [];
        for (let M = 0, f = x.length; M < f; ++M) T = j(T = x[M]), y.push(T), (B.styledMode || !T.color) && (N.dataClassColor === "category" ? (B.styledMode || (S = (A = B.options.colors || []).length, T.color = A[u]), T.colorIndex = u, ++u === S && (u = 0)) : T.color = D(N.minColor).tweenTo(D(N.maxColor), f < 2 ? 0.5 : M / (f - 1)));
      }, L.initStops = function() {
        let I = this.options, B = this.stops = I.stops || [[0, I.minColor || ""], [1, I.maxColor || ""]];
        for (let R = 0, N = B.length; R < N; ++R) B[R].color = D(B[R][1]);
      }, L.normalizedValue = function(I) {
        let B = this.max || 0, R = this.min || 0;
        return this.logarithmic && (I = this.logarithmic.log2lin(I)), 1 - (B - I) / (B - R || 1);
      }, L.toColor = function(I, B) {
        let R, N, x, T, y, S, u = this.dataClasses, A = this.stops;
        if (u) {
          for (S = u.length; S--; ) if (N = (y = u[S]).from, x = y.to, (N === void 0 || I >= N) && (x === void 0 || I <= x)) {
            T = y.color, B && (B.dataClass = S, B.colorIndex = y.colorIndex);
            break;
          }
        } else {
          for (R = this.normalizedValue(I), S = A.length; S-- && !(R > A[S][0]); ) ;
          N = A[S] || A[S + 1], R = 1 - ((x = A[S + 1] || N)[0] - R) / (x[0] - N[0] || 1), T = N.color.tweenTo(x.color, R);
        }
        return T;
      }, l;
    }), i(e, "Core/Axis/Color/ColorAxis.js", [e["Core/Axis/Axis.js"], e["Core/Axis/Color/ColorAxisComposition.js"], e["Core/Axis/Color/ColorAxisDefaults.js"], e["Core/Axis/Color/ColorAxisLike.js"], e["Core/Defaults.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { defaultOptions: R } = D, { series: N } = I, { defined: x, extend: T, fireEvent: y, isArray: S, isNumber: u, merge: A, pick: M, relativeLength: f } = B;
      R.colorAxis = A(R.xAxis, l);
      class m extends o {
        static compose(F, _, E, v) {
          n.compose(m, F, _, E, v);
        }
        constructor(F, _) {
          super(F, _), this.coll = "colorAxis", this.visible = !0, this.init(F, _);
        }
        init(F, _) {
          let E = F.options.legend || {}, v = _.layout ? _.layout !== "vertical" : E.layout !== "vertical";
          this.side = _.side || v ? 2 : 1, this.reversed = _.reversed || !v, this.opposite = !v, super.init(F, _, "colorAxis"), this.userOptions = _, S(F.userOptions.colorAxis) && (F.userOptions.colorAxis[this.index] = _), _.dataClasses && this.initDataClasses(_), this.initStops(), this.horiz = v, this.zoomEnabled = !1;
        }
        hasData() {
          return !!(this.tickPositions || []).length;
        }
        setTickPositions() {
          if (!this.dataClasses) return super.setTickPositions();
        }
        setOptions(F) {
          let _ = A(R.colorAxis, F, { showEmpty: !1, title: null, visible: this.chart.options.legend.enabled && F.visible !== !1 });
          super.setOptions(_), this.options.crosshair = this.options.marker;
        }
        setAxisSize() {
          var w;
          let F = this.chart, _ = (w = this.legendItem) == null ? void 0 : w.symbol, { width: E, height: v } = this.getSize();
          _ && (this.left = +_.attr("x"), this.top = +_.attr("y"), this.width = E = +_.attr("width"), this.height = v = +_.attr("height"), this.right = F.chartWidth - this.left - E, this.bottom = F.chartHeight - this.top - v, this.pos = this.horiz ? this.left : this.top), this.len = (this.horiz ? E : v) || m.defaultLegendLength;
        }
        getOffset() {
          var E;
          let F = (E = this.legendItem) == null ? void 0 : E.group, _ = this.chart.axisOffset[this.side];
          if (F) {
            this.axisParent = F, super.getOffset();
            let v = this.chart.legend;
            v.allItems.forEach(function(w) {
              w instanceof m && w.drawLegendSymbol(v, w);
            }), v.render(), this.chart.getMargins(!0), this.chart.series.some((w) => w.isDrilling) || (this.isDirty = !0), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = _;
          }
        }
        setLegendColor() {
          let F = this.horiz, _ = this.reversed, E = _ ? 1 : 0, v = _ ? 0 : 1, w = F ? [E, 0, v, 0] : [0, v, 0, E];
          this.legendColor = { linearGradient: { x1: w[0], y1: w[1], x2: w[2], y2: w[3] }, stops: this.stops };
        }
        drawLegendSymbol(F, _) {
          var h;
          let E = _.legendItem || {}, v = F.padding, w = F.options, d = this.options.labels, r = M(w.itemDistance, 10), s = this.horiz, { width: p, height: b } = this.getSize(), c = M(w.labelPadding, s ? 16 : 30);
          this.setLegendColor(), E.symbol || (E.symbol = this.chart.renderer.symbol("roundedRect").attr({ r: (h = w.symbolRadius) != null ? h : 3, zIndex: 1 }).add(E.group)), E.symbol.attr({ x: 0, y: (F.baseline || 0) - 11, width: p, height: b }), E.labelWidth = p + v + (s ? r : M(d.x, d.distance) + (this.maxLabelLength || 0)), E.labelHeight = b + v + (s ? c : 0);
        }
        setState(F) {
          this.series.forEach(function(_) {
            _.setState(F);
          });
        }
        setVisible() {
        }
        getSeriesExtremes() {
          let F = this.series, _, E, v, w, d, r, s = F.length, p, b;
          for (this.dataMin = 1 / 0, this.dataMax = -1 / 0; s--; ) {
            if (E = (r = F[s]).colorKey = M(r.options.colorKey, r.colorKey, r.pointValKey, r.zoneAxis, "y"), w = r.pointArrayMap, d = r[E + "Min"] && r[E + "Max"], r[E + "Data"]) _ = r[E + "Data"];
            else if (w) {
              if (_ = [], v = w.indexOf(E), p = r.yData, v >= 0 && p) for (b = 0; b < p.length; b++) _.push(M(p[b][v], p[b]));
            } else _ = r.yData;
            if (d) r.minColorValue = r[E + "Min"], r.maxColorValue = r[E + "Max"];
            else {
              let c = N.prototype.getExtremes.call(r, _);
              r.minColorValue = c.dataMin, r.maxColorValue = c.dataMax;
            }
            x(r.minColorValue) && x(r.maxColorValue) && (this.dataMin = Math.min(this.dataMin, r.minColorValue), this.dataMax = Math.max(this.dataMax, r.maxColorValue)), d || N.prototype.applyExtremes.call(r);
          }
        }
        drawCrosshair(F, _) {
          let E, v = this.legendItem || {}, w = _ && _.plotX, d = _ && _.plotY, r = this.pos, s = this.len;
          _ && ((E = this.toPixels(_.getNestedProperty(_.series.colorKey))) < r ? E = r - 2 : E > r + s && (E = r + s + 2), _.plotX = E, _.plotY = this.len - E, super.drawCrosshair(F, _), _.plotX = w, _.plotY = d, this.cross && !this.cross.addedToColorAxis && v.group && (this.cross.addClass("highcharts-coloraxis-marker").add(v.group), this.cross.addedToColorAxis = !0, this.chart.styledMode || typeof this.crosshair != "object" || this.cross.attr({ fill: this.crosshair.color })));
        }
        getPlotLinePath(F) {
          let _ = this.left, E = F.translatedValue, v = this.top;
          return u(E) ? this.horiz ? [["M", E - 4, v - 6], ["L", E + 4, v - 6], ["L", E, v], ["Z"]] : [["M", _, E], ["L", _ - 6, E + 6], ["L", _ - 6, E - 6], ["Z"]] : super.getPlotLinePath(F);
        }
        update(F, _) {
          let E = this.chart.legend;
          this.series.forEach((v) => {
            v.isDirtyData = !0;
          }), (F.dataClasses && E.allItems || this.dataClasses) && this.destroyItems(), super.update(F, _), this.legendItem && this.legendItem.label && (this.setLegendColor(), E.colorizeItem(this, !0));
        }
        destroyItems() {
          let F = this.chart, _ = this.legendItem || {};
          if (_.label) F.legend.destroyItem(this);
          else if (_.labels) for (let E of _.labels) F.legend.destroyItem(E);
          F.isDirtyLegend = !0;
        }
        destroy() {
          this.chart.isDirtyLegend = !0, this.destroyItems(), super.destroy(...[].slice.call(arguments));
        }
        remove(F) {
          this.destroyItems(), super.remove(F);
        }
        getDataClassLegendSymbols() {
          let F, _ = this, E = _.chart, v = _.legendItem && _.legendItem.labels || [], w = E.options.legend, d = M(w.valueDecimals, -1), r = M(w.valueSuffix, ""), s = (p) => _.series.reduce((b, c) => (b.push(...c.points.filter((h) => h.dataClass === p)), b), []);
          return v.length || _.dataClasses.forEach((p, b) => {
            let c = p.from, h = p.to, { numberFormatter: g } = E, k = !0;
            F = "", c === void 0 ? F = "< " : h === void 0 && (F = "> "), c !== void 0 && (F += g(c, d) + r), c !== void 0 && h !== void 0 && (F += " - "), h !== void 0 && (F += g(h, d) + r), v.push(T({ chart: E, name: F, options: {}, drawLegendSymbol: j.rectangle, visible: !0, isDataClass: !0, setState: (P) => {
              for (let O of s(b)) O.setState(P);
            }, setVisible: function() {
              this.visible = k = _.visible = !k;
              let P = [];
              for (let O of s(b)) O.setVisible(k), O.hiddenInDataClass = !k, P.indexOf(O.series) === -1 && P.push(O.series);
              E.legend.colorizeItem(this, k), P.forEach((O) => {
                y(O, "afterDataClassLegendClick");
              });
            } }, p));
          }), v;
        }
        getSize() {
          let { chart: F, horiz: _ } = this, { height: E, width: v } = this.options, { legend: w } = F.options;
          return { width: M(x(v) ? f(v, F.chartWidth) : void 0, w == null ? void 0 : w.symbolWidth, _ ? m.defaultLegendLength : 12), height: M(x(E) ? f(E, F.chartHeight) : void 0, w == null ? void 0 : w.symbolHeight, _ ? 12 : m.defaultLegendLength) };
        }
      }
      return m.defaultLegendLength = 200, m.keepProps = ["legendItem"], T(m.prototype, L), Array.prototype.push.apply(o.keepProps, m.keepProps), m;
    }), i(e, "masters/modules/coloraxis.src.js", [e["Core/Globals.js"], e["Core/Axis/Color/ColorAxis.js"]], function(o, n) {
      return o.ColorAxis = o.ColorAxis || n, o.ColorAxis.compose(o.Chart, o.Fx, o.Legend, o.Series), o;
    }), i(e, "Maps/MapNavigationDefaults.js", [], function() {
      return { lang: { zoomIn: "Zoom in", zoomOut: "Zoom out" }, mapNavigation: { buttonOptions: { alignTo: "plotBox", align: "left", verticalAlign: "top", x: 0, width: 18, height: 18, padding: 5, style: { color: "#666666", fontSize: "1em", fontWeight: "bold" }, theme: { fill: "#ffffff", stroke: "#e6e6e6", "stroke-width": 1, "text-align": "center" } }, buttons: { zoomIn: { onclick: function() {
        this.mapZoom(0.5);
      }, text: "+", y: 0 }, zoomOut: { onclick: function() {
        this.mapZoom(2);
      }, text: "-", y: 28 } }, mouseWheelSensitivity: 1.1 } };
    }), i(e, "Maps/MapPointer.js", [e["Core/Utilities.js"]], function(o) {
      var n;
      let { defined: l, extend: L, pick: D, wrap: j } = o;
      return function(I) {
        let B, R = 0;
        function N(S) {
          let u = this.chart;
          S = this.normalize(S), u.options.mapNavigation.enableDoubleClickZoomTo ? u.pointer.inClass(S.target, "highcharts-tracker") && u.hoverPoint && u.hoverPoint.zoomTo() : u.isInsidePlot(S.chartX - u.plotLeft, S.chartY - u.plotTop) && u.mapZoom(0.5, void 0, void 0, S.chartX, S.chartY);
        }
        function x(S) {
          let u = this.chart, A = l((S = this.normalize(S)).wheelDelta) && -S.wheelDelta / 120 || S.deltaY || S.detail;
          Math.abs(A) >= 1 && (R += Math.abs(A), B && clearTimeout(B), B = setTimeout(() => {
            R = 0;
          }, 50)), R < 10 && u.isInsidePlot(S.chartX - u.plotLeft, S.chartY - u.plotTop) && u.mapView && u.mapView.zoomBy(-((u.options.mapNavigation.mouseWheelSensitivity - 1) * A), void 0, [S.chartX, S.chartY], !(1 > Math.abs(A)) && void 0);
        }
        function T(S, u, A) {
          let M = this.chart;
          if (u = S.call(this, u, A), M && M.mapView) {
            let f = M.mapView.pixelsToLonLat({ x: u.chartX - M.plotLeft, y: u.chartY - M.plotTop });
            f && L(u, f);
          }
          return u;
        }
        function y(S) {
          let u = this.chart.options.mapNavigation;
          u && D(u.enableTouchZoom, u.enabled) && (this.chart.zooming.pinchType = "xy"), S.apply(this, [].slice.call(arguments, 1));
        }
        I.compose = function(S) {
          let u = S.prototype;
          u.onContainerDblClick || (L(u, { onContainerDblClick: N, onContainerMouseWheel: x }), j(u, "normalize", T), j(u, "zoomOption", y));
        };
      }(n || (n = {})), n;
    }), i(e, "Maps/MapSymbols.js", [], function() {
      let o;
      function n(L, D, j, I, B) {
        if (B) {
          let R = (B == null ? void 0 : B.r) || 0;
          B.brBoxY = D - R, B.brBoxHeight = I + R;
        }
        return o.roundedRect(L, D, j, I, B);
      }
      function l(L, D, j, I, B) {
        if (B) {
          let R = (B == null ? void 0 : B.r) || 0;
          B.brBoxHeight = I + R;
        }
        return o.roundedRect(L, D, j, I, B);
      }
      return { compose: function(L) {
        (o = L.prototype.symbols).bottombutton = n, o.topbutton = l;
      } };
    }), i(e, "Maps/MapNavigation.js", [e["Core/Defaults.js"], e["Core/Globals.js"], e["Maps/MapNavigationDefaults.js"], e["Maps/MapPointer.js"], e["Maps/MapSymbols.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { setOptions: I } = o, { composed: B } = n, { addEvent: R, extend: N, merge: x, objectEach: T, pick: y, pushUnique: S } = j;
      function u(M) {
        M && (M.preventDefault && M.preventDefault(), M.stopPropagation && M.stopPropagation(), M.cancelBubble = !0);
      }
      class A {
        static compose(f, m, C) {
          L.compose(m), D.compose(C), S(B, "Map.Navigation") && (R(f, "beforeRender", function() {
            this.mapNavigation = new A(this), this.mapNavigation.update();
          }), I(l));
        }
        constructor(f) {
          this.chart = f, this.navButtons = [];
        }
        update(f) {
          let m = this, C = m.chart, F = m.navButtons, _ = function(v) {
            this.handler.call(C, v), u(v);
          }, E = C.options.mapNavigation;
          for (f && (E = C.options.mapNavigation = x(C.options.mapNavigation, f)); F.length; ) F.pop().destroy();
          if (!C.renderer.forExport && y(E.enableButtons, E.enabled)) {
            m.navButtonsGroup || (m.navButtonsGroup = C.renderer.g().attr({ zIndex: 7 }).add()), T(E.buttons, (w, d) => {
              var g;
              let r = { padding: (w = x(E.buttonOptions, w)).padding };
              !C.styledMode && w.theme && (N(r, w.theme), r.style = x(w.theme.style, w.style));
              let { text: s, width: p = 0, height: b = 0, padding: c = 0 } = w, h = C.renderer.button(s !== "+" && s !== "-" && s || "", 0, 0, _, r, void 0, void 0, void 0, d === "zoomIn" ? "topbutton" : "bottombutton").addClass("highcharts-map-navigation highcharts-" + { zoomIn: "zoom-in", zoomOut: "zoom-out" }[d]).attr({ width: p, height: b, title: C.options.lang[d], zIndex: 5 }).add(m.navButtonsGroup);
              if (s === "+" || s === "-") {
                let k = p + 1, P = [["M", c + 3, c + b / 2], ["L", c + k - 3, c + b / 2]];
                s === "+" && P.push(["M", c + k / 2, c + 3], ["L", c + k / 2, c + b - 3]), C.renderer.path(P).addClass("highcharts-button-symbol").attr(C.styledMode ? {} : { stroke: (g = w.style) == null ? void 0 : g.color, "stroke-width": 3, "stroke-linecap": "round" }).add(h);
              }
              if (h.handler = w.onclick, R(h.element, "dblclick", u), F.push(h), N(w, { width: h.width, height: 2 * (h.height || 0) }), C.hasLoaded) h.align(w, !1, w.alignTo);
              else {
                let k = R(C, "load", () => {
                  h.element && h.align(w, !1, w.alignTo), k();
                });
              }
            });
            let v = (w, d) => !(d.x >= w.x + w.width || d.x + d.width <= w.x || d.y >= w.y + w.height || d.y + d.height <= w.y);
            C.hasLoaded || R(C, "render", function() {
              let w = C.exportingGroup && C.exportingGroup.getBBox();
              if (w) {
                let d = m.navButtonsGroup.getBBox();
                if (v(w, d)) {
                  let r = -d.y - d.height + w.y - 5, s = w.y + w.height - d.y + 5, p = E.buttonOptions && E.buttonOptions.verticalAlign;
                  m.navButtonsGroup.attr({ translateY: p === "bottom" ? r : s });
                }
              }
            });
          }
          this.updateEvents(E);
        }
        updateEvents(f) {
          let m = this.chart;
          y(f.enableDoubleClickZoom, f.enabled) || f.enableDoubleClickZoomTo ? this.unbindDblClick = this.unbindDblClick || R(m.container, "dblclick", function(C) {
            m.pointer.onContainerDblClick(C);
          }) : this.unbindDblClick && (this.unbindDblClick = this.unbindDblClick()), y(f.enableMouseWheelZoom, f.enabled) ? this.unbindMouseWheel = this.unbindMouseWheel || R(m.container, "wheel", function(C) {
            return m.pointer.inClass(C.target, "highcharts-no-mousewheel") || (m.pointer.onContainerMouseWheel(C), u(C)), !1;
          }) : this.unbindMouseWheel && (this.unbindMouseWheel = this.unbindMouseWheel());
        }
      }
      return A;
    }), i(e, "Series/ColorMapComposition.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L;
      let { column: { prototype: D } } = o.seriesTypes, { addEvent: j, defined: I } = l;
      return function(B) {
        function R(N) {
          let x = this.series, T = x.chart.renderer;
          this.moveToTopOnHover && this.graphic && (x.stateMarkerGraphic || (x.stateMarkerGraphic = new n(T, "use").css({ pointerEvents: "none" }).add(this.graphic.parentGroup)), (N == null ? void 0 : N.state) === "hover" ? (this.graphic.attr({ id: this.id }), x.stateMarkerGraphic.attr({ href: `${T.url}#${this.id}`, visibility: "visible" })) : x.stateMarkerGraphic.attr({ href: "" }));
        }
        B.pointMembers = { dataLabelOnNull: !0, moveToTopOnHover: !0, isValid: function() {
          return this.value !== null && this.value !== 1 / 0 && this.value !== -1 / 0 && (this.value === void 0 || !isNaN(this.value));
        } }, B.seriesMembers = { colorKey: "value", axisTypes: ["xAxis", "yAxis", "colorAxis"], parallelArrays: ["x", "y", "value"], pointArrayMap: ["value"], trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], colorAttribs: function(N) {
          let x = {};
          return I(N.color) && (!N.state || N.state === "normal") && (x[this.colorProp || "fill"] = N.color), x;
        }, pointAttribs: D.pointAttribs }, B.compose = function(N) {
          return j(N.prototype.pointClass, "afterSetState", R), N;
        };
      }(L || (L = {})), L;
    }), i(e, "Core/Chart/MapChart.js", [e["Core/Chart/Chart.js"], e["Core/Defaults.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      var D;
      let { getOptions: j } = n, { isNumber: I, merge: B, pick: R } = L;
      class N extends o {
        init(T, y) {
          let S = j().credits, u = B({ chart: { panning: { enabled: !0, type: "xy" }, type: "map" }, credits: { mapText: R(S.mapText, ' © <a href="{geojson.copyrightUrl}">{geojson.copyrightShort}</a>'), mapTextFull: R(S.mapTextFull, "{geojson.copyright}") }, mapView: {}, tooltip: { followTouchMove: !1 } }, T);
          super.init(u, y);
        }
        mapZoom(T, y, S, u, A) {
          this.mapView && (I(T) && (T = Math.log(T) / Math.log(0.5)), this.mapView.zoomBy(T, I(y) && I(S) ? this.mapView.projection.inverse([y, S]) : void 0, I(u) && I(A) ? [u, A] : void 0));
        }
        update(T) {
          var y;
          T.chart && "map" in T.chart && ((y = this.mapView) == null || y.recommendMapView(this, [T.chart.map, ...(this.options.series || []).map((S) => S.mapData)], !0)), super.update.apply(this, arguments);
        }
      }
      return (D = N || (N = {})).maps = {}, D.mapChart = function(x, T, y) {
        return new D(x, T, y);
      }, D.splitPath = function(x) {
        let T;
        return T = typeof x == "string" ? (x = x.replace(/([A-Z])/gi, " $1 ").replace(/^\s*/, "").replace(/\s*$/, "")).split(/[ ,;]+/).map((y) => /[A-Z]/i.test(y) ? y : parseFloat(y)) : x, l.prototype.pathToSegments(T);
      }, N;
    }), i(e, "Maps/MapUtilities.js", [], function() {
      return { boundsFromPath: function(o) {
        let n = -Number.MAX_VALUE, l = Number.MAX_VALUE, L = -Number.MAX_VALUE, D = Number.MAX_VALUE, j;
        if (o.forEach((I) => {
          let B = I[I.length - 2], R = I[I.length - 1];
          typeof B == "number" && typeof R == "number" && (l = Math.min(l, B), n = Math.max(n, B), D = Math.min(D, R), L = Math.max(L, R), j = !0);
        }), j) return { x1: l, y1: D, x2: n, y2: L };
      } };
    }), i(e, "Series/Map/MapPoint.js", [e["Series/ColorMapComposition.js"], e["Maps/MapUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { boundsFromPath: D } = n, j = l.seriesTypes.scatter.prototype.pointClass, { extend: I, isNumber: B, pick: R } = L;
      class N extends j {
        static getProjectedPath(T, y) {
          return T.projectedPath || (y && T.geometry ? (y.hasCoordinates = !0, T.projectedPath = y.path(T.geometry)) : T.projectedPath = T.path), T.projectedPath || [];
        }
        applyOptions(T, y) {
          var M;
          let S = this.series, u = super.applyOptions(T, y), A = S.joinBy;
          if (S.mapData && S.mapMap) {
            let f = A[1], m = super.getNestedProperty(f), C = m !== void 0 && S.mapMap[m];
            C ? I(u, { ...C, name: (M = u.name) != null ? M : C.name }) : S.pointArrayMap.indexOf("value") !== -1 && (u.value = u.value || null);
          }
          return u;
        }
        getProjectedBounds(T) {
          let y = D(N.getProjectedPath(this, T)), S = this.properties, u = this.series.chart.mapView;
          if (y) {
            let A = S && S["hc-middle-lon"], M = S && S["hc-middle-lat"];
            if (u && B(A) && B(M)) {
              let f = T.forward([A, M]);
              y.midX = f[0], y.midY = f[1];
            } else {
              let f = S && S["hc-middle-x"], m = S && S["hc-middle-y"];
              y.midX = y.x1 + (y.x2 - y.x1) * R(this.middleX, B(f) ? f : 0.5);
              let C = R(this.middleY, B(m) ? m : 0.5);
              this.geometry || (C = 1 - C), y.midY = y.y2 - (y.y2 - y.y1) * C;
            }
            return y;
          }
        }
        onMouseOver(T) {
          L.clearTimeout(this.colorInterval), !this.isNull && this.visible || this.series.options.nullInteraction ? super.onMouseOver.call(this, T) : this.series.onMouseOut();
        }
        setVisible(T) {
          this.visible = this.options.visible = !!T, this.dataLabel && this.dataLabel[T ? "show" : "hide"](), this.graphic && this.graphic.attr(this.series.pointAttribs(this));
        }
        zoomTo(T) {
          let y = this.series.chart, S = y.mapView, u = this.bounds;
          if (S && u) {
            let A = B(this.insetIndex) && S.insets[this.insetIndex];
            if (A) {
              let M = A.projectedUnitsToPixels({ x: u.x1, y: u.y1 }), f = A.projectedUnitsToPixels({ x: u.x2, y: u.y2 }), m = S.pixelsToProjectedUnits({ x: M.x, y: M.y }), C = S.pixelsToProjectedUnits({ x: f.x, y: f.y });
              u = { x1: m.x, y1: m.y, x2: C.x, y2: C.y };
            }
            S.fitToBounds(u, void 0, !1), this.series.isDirty = !0, y.redraw(T);
          }
        }
      }
      return I(N.prototype, { dataLabelOnNull: o.pointMembers.dataLabelOnNull, moveToTopOnHover: o.pointMembers.moveToTopOnHover, isValid: o.pointMembers.isValid }), N;
    }), i(e, "Series/Map/MapSeriesDefaults.js", [e["Core/Utilities.js"]], function(o) {
      let { isNumber: n } = o;
      return { affectsMapView: !0, animation: !1, dataLabels: { crop: !1, formatter: function() {
        let { numberFormatter: l } = this.series.chart, { value: L } = this.point;
        return n(L) ? l(L, -1) : this.point.name;
      }, inside: !0, overflow: !1, padding: 0, verticalAlign: "middle" }, linecap: "round", marker: null, nullColor: "#f7f7f7", stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "{point.name}: {point.value}<br/>" }, turboThreshold: 0, allAreas: !0, borderColor: "#e6e6e6", borderWidth: 1, joinBy: "hc-key", states: { hover: { halo: void 0, borderColor: "#666666", borderWidth: 2 }, normal: { animation: !0 }, select: { color: "#cccccc" } }, legendSymbol: "rectangle" };
    }), i(e, "Maps/MapViewDefaults.js", [], function() {
      return { center: [0, 0], fitToGeometry: void 0, maxZoom: void 0, padding: 0, projection: { name: void 0, parallels: void 0, rotation: void 0 }, zoom: void 0, insetOptions: { borderColor: "#cccccc", borderWidth: 1, padding: "10%", relativeTo: "mapBoundingBox", units: "percent" } };
    }), i(e, "Maps/GeoJSONComposition.js", [e["Core/Globals.js"], e["Core/Templating.js"], e["Core/Utilities.js"]], function(o, n, l) {
      var L;
      let { win: D } = o, { format: j } = n, { error: I, extend: B, merge: R, wrap: N } = l;
      return function(x) {
        function T(f) {
          return this.mapView && this.mapView.lonLatToProjectedUnits(f);
        }
        function y(f) {
          return this.mapView && this.mapView.projectedUnitsToLonLat(f);
        }
        function S(f, m) {
          let C = this.options.chart.proj4 || D.proj4;
          if (!C) {
            I(21, !1, this);
            return;
          }
          let { jsonmarginX: F = 0, jsonmarginY: _ = 0, jsonres: E = 1, scale: v = 1, xoffset: w = 0, xpan: d = 0, yoffset: r = 0, ypan: s = 0 } = m, p = C(m.crs, [f.lon, f.lat]), b = m.cosAngle || m.rotation && Math.cos(m.rotation), c = m.sinAngle || m.rotation && Math.sin(m.rotation), h = m.rotation ? [p[0] * b + p[1] * c, -p[0] * c + p[1] * b] : p;
          return { x: ((h[0] - w) * v + d) * E + F, y: -(((r - h[1]) * v + s) * E - _) };
        }
        function u(f, m) {
          let C = this.options.chart.proj4 || D.proj4;
          if (!C) {
            I(21, !1, this);
            return;
          }
          if (f.y === null) return;
          let { jsonmarginX: F = 0, jsonmarginY: _ = 0, jsonres: E = 1, scale: v = 1, xoffset: w = 0, xpan: d = 0, yoffset: r = 0, ypan: s = 0 } = m, p = { x: ((f.x - F) / E - d) / v + w, y: ((f.y - _) / E + s) / v + r }, b = m.cosAngle || m.rotation && Math.cos(m.rotation), c = m.sinAngle || m.rotation && Math.sin(m.rotation), h = C(m.crs, "WGS84", m.rotation ? { x: p.x * b + -(p.y * c), y: p.x * c + p.y * b } : p);
          return { lat: h.y, lon: h.x };
        }
        function A(f, m) {
          m || (m = Object.keys(f.objects)[0]);
          let C = f.objects[m];
          if (C["hc-decoded-geojson"] && C["hc-decoded-geojson"].title === f.title) return C["hc-decoded-geojson"];
          let F = f.arcs;
          if (f.transform) {
            let d, r, s, p = f.arcs, { scale: b, translate: c } = f.transform;
            F = [];
            for (let h = 0, g = p.length; h < g; ++h) {
              let k = p[h];
              F.push(d = []), r = 0, s = 0;
              for (let P = 0, O = k.length; P < O; ++P) d.push([(r += k[P][0]) * b[0] + c[0], (s += k[P][1]) * b[1] + c[1]]);
            }
          }
          let _ = (d) => typeof d[0] == "number" ? d.reduce((r, s, p) => {
            let b = s < 0 ? F[~s] : F[s];
            return s < 0 ? (b = b.slice(0, p === 0 ? b.length : b.length - 1)).reverse() : p && (b = b.slice(1)), r.concat(b);
          }, []) : d.map(_), E = C.geometries, v = [];
          for (let d = 0, r = E.length; d < r; ++d) v.push({ type: "Feature", properties: E[d].properties, geometry: { type: E[d].type, coordinates: E[d].coordinates || _(E[d].arcs) } });
          let w = { type: "FeatureCollection", copyright: f.copyright, copyrightShort: f.copyrightShort, copyrightUrl: f.copyrightUrl, features: v, "hc-recommended-mapview": C["hc-recommended-mapview"], bbox: f.bbox, title: f.title };
          return C["hc-decoded-geojson"] = w, w;
        }
        function M(f, m) {
          m = R(!0, this.options.credits, m), f.call(this, m), this.credits && this.mapCreditsFull && this.credits.attr({ title: this.mapCreditsFull });
        }
        x.compose = function(f) {
          let m = f.prototype;
          m.transformFromLatLon || (m.fromLatLonToPoint = T, m.fromPointToLatLon = y, m.transformFromLatLon = S, m.transformToLatLon = u, N(m, "addCredits", M));
        }, x.geojson = function(f, m = "map", C) {
          var v, w;
          let F = [], _ = f.type === "Topology" ? A(f) : f, E = _.features;
          for (let d = 0, r = E.length; d < r; ++d) {
            let s, p = E[d], b = p.geometry || {}, c = b.type, h = b.coordinates, g = p.properties;
            if ((m === "map" || m === "mapbubble") && (c === "Polygon" || c === "MultiPolygon") ? h.length && (s = { geometry: { coordinates: h, type: c } }) : m === "mapline" && (c === "LineString" || c === "MultiLineString") ? h.length && (s = { geometry: { coordinates: h, type: c } }) : m === "mappoint" && c === "Point" && h.length && (s = { geometry: { coordinates: h, type: c } }), s) {
              let k = g && (g.name || g.NAME), P = g && g.lon, O = g && g.lat;
              F.push(B(s, { lat: typeof O == "number" ? O : void 0, lon: typeof P == "number" ? P : void 0, name: typeof k == "string" ? k : void 0, properties: g }));
            }
          }
          return C && _.copyrightShort && (C.chart.mapCredits = j((v = C.chart.options.credits) == null ? void 0 : v.mapText, { geojson: _ }), C.chart.mapCreditsFull = j((w = C.chart.options.credits) == null ? void 0 : w.mapTextFull, { geojson: _ })), F;
        }, x.topo2geo = A;
      }(L || (L = {})), L;
    }), i(e, "Core/Geometry/PolygonClip.js", [], function() {
      function o(L, D, j = !0) {
        let I = D[D.length - 1], B, R, N, x = L;
        for (let T = 0; T < D.length; T++) {
          let y = x;
          B = D[T], x = [], R = j ? y[y.length - 1] : y[0];
          for (let S = 0; S < y.length; S++) n(I, B, N = y[S]) ? (n(I, B, R) || x.push(l(I, B, R, N)), x.push(N)) : n(I, B, R) && x.push(l(I, B, R, N)), R = N;
          I = B;
        }
        return x;
      }
      function n(L, D, j) {
        return (D[0] - L[0]) * (j[1] - L[1]) > (D[1] - L[1]) * (j[0] - L[0]);
      }
      function l(L, D, j, I) {
        let B = [L[0] - D[0], L[1] - D[1]], R = [j[0] - I[0], j[1] - I[1]], N = L[0] * D[1] - L[1] * D[0], x = j[0] * I[1] - j[1] * I[0], T = 1 / (B[0] * R[1] - B[1] * R[0]), y = [(N * R[0] - x * B[0]) * T, (N * R[1] - x * B[1]) * T];
        return y.isIntersection = !0, y;
      }
      return { clipLineString: function(L, D) {
        let j = [], I = o(L, D, !1);
        for (let B = 1; B < I.length; B++) I[B].isIntersection && I[B - 1].isIntersection && (j.push(I.splice(0, B)), B = 0), B === I.length - 1 && j.push(I);
        return j;
      }, clipPolygon: o };
    }), i(e, "Maps/Projections/LambertConformalConic.js", [], function() {
      let o = Math.sign || ((D) => D === 0 ? 0 : D > 0 ? 1 : -1), n = Math.PI / 180, l = Math.PI / 2, L = (D) => Math.tan((l + D) / 2);
      return class {
        constructor(D) {
          var x;
          let j = (D.parallels || []).map((T) => T * n), I = j[0] || 0, B = (x = j[1]) != null ? x : I, R = Math.cos(I);
          typeof D.projectedBounds == "object" && (this.projectedBounds = D.projectedBounds);
          let N = I === B ? Math.sin(I) : Math.log(R / Math.cos(B)) / Math.log(L(B) / L(I));
          1e-10 > Math.abs(N) && (N = 1e-10 * (o(N) || 1)), this.n = N, this.c = R * Math.pow(L(I), N) / N;
        }
        forward(D) {
          let { c: j, n: I, projectedBounds: B } = this, R = D[0] * n, N = D[1] * n;
          j > 0 ? N < -l + 1e-6 && (N = -l + 1e-6) : N > l - 1e-6 && (N = l - 1e-6);
          let x = j / Math.pow(L(N), I), T = x * Math.sin(I * R) * 63.78137, y = (j - x * Math.cos(I * R)) * 63.78137, S = [T, y];
          return B && (T < B.x1 || T > B.x2 || y < B.y1 || y > B.y2) && (S.outside = !0), S;
        }
        inverse(D) {
          let { c: j, n: I } = this, B = D[0] / 63.78137, R = j - D[1] / 63.78137, N = o(I) * Math.sqrt(B * B + R * R), x = Math.atan2(B, Math.abs(R)) * o(R);
          return R * I < 0 && (x -= Math.PI * o(B) * o(R)), [x / I / n, (2 * Math.atan(Math.pow(j / N, 1 / I)) - l) / n];
        }
      };
    }), i(e, "Maps/Projections/EqualEarth.js", [], function() {
      let o = Math.sqrt(3) / 2;
      return class {
        constructor() {
          this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -97.52595454902263, y2: 97.52595454902263 };
        }
        forward(n) {
          let l = Math.PI / 180, L = Math.asin(o * Math.sin(n[1] * l)), D = L * L, j = D * D * D;
          return [n[0] * l * Math.cos(L) * 74.03120656864502 / (o * (1.340264 + -0.24331799999999998 * D + j * (0.0062510000000000005 + 0.034164 * D))), 74.03120656864502 * L * (1.340264 + -0.081106 * D + j * (893e-6 + 3796e-6 * D))];
        }
        inverse(n) {
          let l = n[0] / 74.03120656864502, L = n[1] / 74.03120656864502, D = 180 / Math.PI, j = L, I, B, R, N;
          for (let y = 0; y < 12 && (B = (I = j * j) * I * I, R = j * (1.340264 + -0.081106 * I + B * (893e-6 + 3796e-6 * I)) - L, j -= N = R / (1.340264 + -0.24331799999999998 * I + B * (0.0062510000000000005 + 0.034164 * I)), !(1e-9 > Math.abs(N))); ++y) ;
          B = (I = j * j) * I * I;
          let x = D * o * l * (1.340264 + -0.24331799999999998 * I + B * (0.0062510000000000005 + 0.034164 * I)) / Math.cos(j), T = D * Math.asin(Math.sin(j) / o);
          return Math.abs(x) > 180 ? [NaN, NaN] : [x, T];
        }
      };
    }), i(e, "Maps/Projections/Miller.js", [], function() {
      let o = Math.PI / 4, n = Math.PI / 180;
      return class {
        constructor() {
          this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -146.91480769173063, y2: 146.91480769173063 };
        }
        forward(l) {
          return [l[0] * n * 63.78137, 79.7267125 * Math.log(Math.tan(o + 0.4 * l[1] * n))];
        }
        inverse(l) {
          return [l[0] / 63.78137 / n, 2.5 * (Math.atan(Math.exp(0.8 * (l[1] / 63.78137))) - o) / n];
        }
      };
    }), i(e, "Maps/Projections/Orthographic.js", [], function() {
      let o = Math.PI / 180;
      return class {
        constructor() {
          this.antimeridianCutting = !1, this.bounds = { x1: -63.78460826781007, x2: 63.78460826781007, y1: -63.78460826781007, y2: 63.78460826781007 };
        }
        forward(n) {
          let l = n[0], L = n[1] * o, D = [Math.cos(L) * Math.sin(l * o) * 63.78460826781007, 63.78460826781007 * Math.sin(L)];
          return (l < -90 || l > 90) && (D.outside = !0), D;
        }
        inverse(n) {
          let l = n[0] / 63.78460826781007, L = n[1] / 63.78460826781007, D = Math.sqrt(l * l + L * L), j = Math.asin(D), I = Math.sin(j);
          return [Math.atan2(l * I, D * Math.cos(j)) / o, Math.asin(D && L * I / D) / o];
        }
      };
    }), i(e, "Maps/Projections/WebMercator.js", [], function() {
      let o = Math.PI / 180;
      return class {
        constructor() {
          this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -200.3750834278071, y2: 200.3750834278071 }, this.maxLatitude = 85.0511287798;
        }
        forward(n) {
          let l = Math.sin(n[1] * o), L = [63.78137 * n[0] * o, 63.78137 * Math.log((1 + l) / (1 - l)) / 2];
          return Math.abs(n[1]) > this.maxLatitude && (L.outside = !0), L;
        }
        inverse(n) {
          return [n[0] / (63.78137 * o), (2 * Math.atan(Math.exp(n[1] / 63.78137)) - Math.PI / 2) / o];
        }
      };
    }), i(e, "Maps/Projections/ProjectionRegistry.js", [e["Maps/Projections/LambertConformalConic.js"], e["Maps/Projections/EqualEarth.js"], e["Maps/Projections/Miller.js"], e["Maps/Projections/Orthographic.js"], e["Maps/Projections/WebMercator.js"]], function(o, n, l, L, D) {
      return { EqualEarth: n, LambertConformalConic: o, Miller: l, Orthographic: L, WebMercator: D };
    }), i(e, "Maps/Projection.js", [e["Core/Geometry/PolygonClip.js"], e["Maps/Projections/ProjectionRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { clipLineString: L, clipPolygon: D } = o, { clamp: j, erase: I } = l, B = 2 * Math.PI / 360, R = (y) => (y < -180 && (y += 360), y > 180 && (y -= 360), y), N = (y) => (1 - Math.cos(y)) / 2, x = (y, S) => {
        let u = Math.cos, A = y[1] * B, M = y[0] * B, f = S[1] * B, m = S[0] * B;
        return N(f - A) + u(A) * u(f) * N(m - M);
      };
      class T {
        static add(S, u) {
          T.registry[S] = u;
        }
        static distance(S, u) {
          let { atan2: A, sqrt: M } = Math, f = x(S, u);
          return 6371e3 * (2 * A(M(f), M(1 - f)));
        }
        static geodesic(S, u, A, M = 5e5) {
          let { atan2: f, cos: m, sin: C, sqrt: F } = Math, _ = T.distance, E = S[1] * B, v = S[0] * B, w = u[1] * B, d = u[0] * B, r = m(E) * m(v), s = m(w) * m(d), p = m(E) * C(v), b = m(w) * C(d), c = C(E), h = C(w), g = _(S, u), k = g / 6371e3, P = C(k), O = Math.round(g / M), z = [];
          if (A && z.push(S), O > 1) {
            let W = 1 / O;
            for (let G = W; G < 0.999; G += W) {
              let Y = C((1 - G) * k) / P, U = C(G * k) / P, H = Y * r + U * s, q = Y * p + U * b, X = f(Y * c + U * h, F(H * H + q * q)), $ = f(q, H);
              z.push([$ / B, X / B]);
            }
          }
          return A && z.push(u), z;
        }
        static insertGeodesics(S) {
          let u = S.length - 1;
          for (; u--; ) if (Math.max(Math.abs(S[u][0] - S[u + 1][0]), Math.abs(S[u][1] - S[u + 1][1])) > 10) {
            let A = T.geodesic(S[u], S[u + 1]);
            A.length && S.splice(u + 1, 0, ...A);
          }
        }
        static toString(S) {
          let { name: u, rotation: A } = S || {};
          return [u, A && A.join(",")].join(";");
        }
        constructor(S = {}) {
          this.hasCoordinates = !1, this.hasGeoProjection = !1, this.maxLatitude = 90, this.options = S;
          let { name: u, projectedBounds: A, rotation: M } = S;
          this.rotator = M ? this.getRotator(M) : void 0;
          let f = u ? T.registry[u] : void 0;
          f && (this.def = new f(S));
          let { def: m, rotator: C } = this;
          m && (this.maxLatitude = m.maxLatitude || 90, this.hasGeoProjection = !0), C && m ? (this.forward = (F) => m.forward(C.forward(F)), this.inverse = (F) => C.inverse(m.inverse(F))) : m ? (this.forward = (F) => m.forward(F), this.inverse = (F) => m.inverse(F)) : C && (this.forward = C.forward, this.inverse = C.inverse), this.bounds = A === "world" ? m && m.bounds : A;
        }
        lineIntersectsBounds(S) {
          let { x1: u, x2: A, y1: M, y2: f } = this.bounds || {}, m = (_, E, v) => {
            let [w, d] = _, r = E ? 0 : 1;
            if (typeof v == "number" && w[E] >= v != d[E] >= v) {
              let s = (v - w[E]) / (d[E] - w[E]), p = w[r] + s * (d[r] - w[r]);
              return E ? [p, v] : [v, p];
            }
          }, C, F = S[0];
          return ((C = m(S, 0, u)) || (C = m(S, 0, A))) && (F = C, S[1] = C), ((C = m(S, 1, M)) || (C = m(S, 1, f))) && (F = C), F;
        }
        getRotator(S) {
          let u = S[0] * B, A = (S[1] || 0) * B, M = (S[2] || 0) * B, f = Math.cos(A), m = Math.sin(A), C = Math.cos(M), F = Math.sin(M);
          if (u !== 0 || A !== 0 || M !== 0) return { forward: (_) => {
            let E = _[0] * B + u, v = _[1] * B, w = Math.cos(v), d = Math.cos(E) * w, r = Math.sin(E) * w, s = Math.sin(v), p = s * f + d * m;
            return [Math.atan2(r * C - p * F, d * f - s * m) / B, Math.asin(p * C + r * F) / B];
          }, inverse: (_) => {
            let E = _[0] * B, v = _[1] * B, w = Math.cos(v), d = Math.cos(E) * w, r = Math.sin(E) * w, s = Math.sin(v), p = s * C - r * F;
            return [(Math.atan2(r * C + s * F, d * f + p * m) - u) / B, Math.asin(p * f - d * m) / B];
          } };
        }
        forward(S) {
          return S;
        }
        inverse(S) {
          return S;
        }
        cutOnAntimeridian(S, u) {
          let A, M = [], f = [S];
          for (let m = 0, C = S.length; m < C; ++m) {
            let F = S[m], _ = S[m - 1];
            if (!m) {
              if (!u) continue;
              _ = S[S.length - 1];
            }
            let E = _[0], v = F[0];
            if ((E < -90 || E > 90) && (v < -90 || v > 90) && E > 0 != v > 0) {
              let w = j((180 - (E + 360) % 360) / ((v + 360) % 360 - (E + 360) % 360), 0, 1), d = _[1] + w * (F[1] - _[1]);
              M.push({ i: m, lat: d, direction: E < 0 ? 1 : -1, previousLonLat: _, lonLat: F });
            }
          }
          if (M.length)
            if (u) {
              M.length % 2 == 1 && (A = M.slice().sort((C, F) => Math.abs(F.lat) - Math.abs(C.lat))[0], I(M, A));
              let m = M.length - 2;
              for (; m >= 0; ) {
                let C = M[m].i, F = R(180 + 1e-6 * M[m].direction), _ = R(180 - 1e-6 * M[m].direction), E = S.splice(C, M[m + 1].i - C, ...T.geodesic([F, M[m].lat], [F, M[m + 1].lat], !0));
                E.push(...T.geodesic([_, M[m + 1].lat], [_, M[m].lat], !0)), f.push(E), m -= 2;
              }
              if (A) for (let C = 0; C < f.length; C++) {
                let { direction: F, lat: _ } = A, E = f[C], v = E.indexOf(A.lonLat);
                if (v > -1) {
                  let w = (_ < 0 ? -1 : 1) * this.maxLatitude, d = R(180 + 1e-6 * F), r = R(180 - 1e-6 * F), s = T.geodesic([d, _], [d, w], !0);
                  for (let p = d + 120 * F; p > -180 && p < 180; p += 120 * F) s.push([p, w]);
                  s.push(...T.geodesic([r, w], [r, A.lat], !0)), E.splice(v, 0, ...s);
                  break;
                }
              }
            } else {
              let m = M.length;
              for (; m--; ) {
                let C = M[m].i, F = S.splice(C, S.length, [R(180 + 1e-6 * M[m].direction), M[m].lat]);
                F.unshift([R(180 - 1e-6 * M[m].direction), M[m].lat]), f.push(F);
              }
            }
          return f;
        }
        path(S) {
          let u, { bounds: A, def: M, rotator: f } = this, m = [], C = S.type === "Polygon" || S.type === "MultiPolygon", F = this.hasGeoProjection, _ = !M || M.antimeridianCutting !== !1, E = _ ? f : void 0, v = _ && M || this;
          A && (u = [[A.x1, A.y1], [A.x2, A.y1], [A.x2, A.y2], [A.x1, A.y2]]);
          let w = (d) => {
            let r = d.map((p) => {
              if (_) {
                E && (p = E.forward(p));
                let b = p[0];
                1e-6 > Math.abs(b - 180) && (b = b < 180 ? 179.999999 : 180.000001), p = [b, p[1]];
              }
              return p;
            }), s = [r];
            F && (T.insertGeodesics(r), _ && (s = this.cutOnAntimeridian(r, C))), s.forEach((p) => {
              let b, c;
              if (p.length < 2) return;
              let h = !1, g = !1, k = (W) => {
                h ? m.push(["L", W[0], W[1]]) : (m.push(["M", W[0], W[1]]), h = !0);
              }, P = !1, O = !1, z = p.map((W) => {
                let G = v.forward(W);
                return G.outside ? P = !0 : O = !0, G[1] === 1 / 0 ? G[1] = 1e10 : G[1] === -1 / 0 && (G[1] = -1e10), G;
              });
              if (_) {
                if (C && z.push(z[0]), P) {
                  if (!O) return;
                  if (u) {
                    if (C) z = D(z, u);
                    else if (A) {
                      L(z, u).forEach((W) => {
                        h = !1, W.forEach(k);
                      });
                      return;
                    }
                  }
                }
                z.forEach(k);
              } else for (let W = 0; W < z.length; W++) {
                let G = p[W], Y = z[W];
                Y.outside ? g = !0 : (C && !b && (b = G, p.push(G), z.push(Y)), g && c && (C && F ? T.geodesic(c, G).forEach((U) => k(v.forward(U))) : h = !1), k(Y), c = G, g = !1);
              }
            });
          };
          return S.type === "LineString" ? w(S.coordinates) : S.type === "MultiLineString" ? S.coordinates.forEach((d) => w(d)) : S.type === "Polygon" ? (S.coordinates.forEach((d) => w(d)), m.length && m.push(["Z"])) : S.type === "MultiPolygon" && (S.coordinates.forEach((d) => {
            d.forEach((r) => w(r));
          }), m.length && m.push(["Z"])), m;
        }
      }
      return T.registry = n, T;
    }), i(e, "Maps/MapView.js", [e["Core/Globals.js"], e["Maps/MapViewDefaults.js"], e["Maps/GeoJSONComposition.js"], e["Core/Geometry/GeometryUtilities.js"], e["Maps/MapUtilities.js"], e["Maps/Projection.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I) {
      let { composed: B } = o, { pointInPolygon: R } = L, { topo2geo: N } = l, { boundsFromPath: x } = D, { addEvent: T, clamp: y, crisp: S, fireEvent: u, isArray: A, isNumber: M, isObject: f, isString: m, merge: C, pick: F, pushUnique: _, relativeLength: E } = I, v = {};
      function w(p, b) {
        let { width: c, height: h } = b;
        return Math.log(400.979322 / Math.max((p.x2 - p.x1) / (c / 256), (p.y2 - p.y1) / (h / 256))) / Math.log(2);
      }
      function d(p) {
        var b, c;
        p.seriesOptions.mapData && ((c = this.mapView) == null || c.recommendMapView(this, [this.options.chart.map, p.seriesOptions.mapData], (b = this.options.drilldown) == null ? void 0 : b.mapZooming));
      }
      class r {
        static compose(b) {
          _(B, "MapView") && (v = b.maps, T(b, "afterInit", function() {
            this.mapView = new r(this, this.options.mapView);
          }, { order: 0 }), T(b, "addSeriesAsDrilldown", d), T(b, "afterDrillUp", d));
        }
        static compositeBounds(b) {
          if (b.length) return b.slice(1).reduce((c, h) => (c.x1 = Math.min(c.x1, h.x1), c.y1 = Math.min(c.y1, h.y1), c.x2 = Math.max(c.x2, h.x2), c.y2 = Math.max(c.y2, h.y2), c), C(b[0]));
        }
        static mergeInsets(b, c) {
          let h = (k) => {
            let P = {};
            return k.forEach((O, z) => {
              P[O && O.id || `i${z}`] = O;
            }), P;
          }, g = C(h(b), h(c));
          return Object.keys(g).map((k) => g[k]);
        }
        constructor(b, c) {
          var P;
          this.allowTransformAnimation = !0, this.eventsToUnbind = [], this.insets = [], this.padding = [0, 0, 0, 0], this.recommendedMapView = {}, this instanceof s || this.recommendMapView(b, [b.options.chart.map, ...(b.options.series || []).map((O) => O.mapData)]), this.userOptions = c || {};
          let h = C(n, this.recommendedMapView, c), g = (P = this.recommendedMapView) == null ? void 0 : P.insets, k = c && c.insets;
          g && k && (h.insets = r.mergeInsets(g, k)), this.chart = b, this.center = h.center, this.options = h, this.projection = new j(h.projection), this.playingField = b.plotBox, this.zoom = h.zoom || 0, this.minZoom = h.minZoom, this.createInsets(), this.eventsToUnbind.push(T(b, "afterSetChartSize", () => {
            this.playingField = this.getField(), (this.minZoom === void 0 || this.minZoom === this.zoom) && (this.fitToBounds(void 0, void 0, !1), !this.chart.hasRendered && M(this.userOptions.zoom) && (this.zoom = this.userOptions.zoom), this.userOptions.center && C(!0, this.center, this.userOptions.center));
          })), this.setUpEvents();
        }
        createInsets() {
          let b = this.options, c = b.insets;
          c && c.forEach((h) => {
            let g = new s(this, C(b.insetOptions, h));
            this.insets.push(g);
          });
        }
        fitToBounds(b, c, h = !0, g) {
          let k = b || this.getProjectedBounds();
          if (k) {
            let P = F(c, b ? 0 : this.options.padding), O = this.getField(!1), z = A(P) ? P : [P, P, P, P];
            this.padding = [E(z[0], O.height), E(z[1], O.width), E(z[2], O.height), E(z[3], O.width)], this.playingField = this.getField();
            let W = w(k, this.playingField);
            b || (this.minZoom = W);
            let G = this.projection.inverse([(k.x2 + k.x1) / 2, (k.y2 + k.y1) / 2]);
            this.setView(G, W, h, g);
          }
        }
        getField(b = !0) {
          let c = b ? this.padding : [0, 0, 0, 0];
          return { x: c[3], y: c[0], width: this.chart.plotWidth - c[1] - c[3], height: this.chart.plotHeight - c[0] - c[2] };
        }
        getGeoMap(b) {
          if (m(b)) return v[b] && v[b].type === "Topology" ? N(v[b]) : v[b];
          if (f(b, !0)) {
            if (b.type === "FeatureCollection") return b;
            if (b.type === "Topology") return N(b);
          }
        }
        getMapBBox() {
          let b = this.getProjectedBounds(), c = this.getScale();
          if (b) {
            let h = this.padding, g = this.projectedUnitsToPixels({ x: b.x1, y: b.y2 });
            return { width: (b.x2 - b.x1) * c + h[1] + h[3], height: (b.y2 - b.y1) * c + h[0] + h[2], x: g.x - h[3], y: g.y - h[0] };
          }
        }
        getProjectedBounds() {
          let b = this.projection, c = this.chart.series.reduce((g, k) => {
            let P = k.getProjectedBounds && k.getProjectedBounds();
            return P && k.options.affectsMapView !== !1 && g.push(P), g;
          }, []), h = this.options.fitToGeometry;
          if (h) {
            if (!this.fitToGeometryCache)
              if (h.type === "MultiPoint") {
                let g = h.coordinates.map((O) => b.forward(O)), k = g.map((O) => O[0]), P = g.map((O) => O[1]);
                this.fitToGeometryCache = { x1: Math.min.apply(0, k), x2: Math.max.apply(0, k), y1: Math.min.apply(0, P), y2: Math.max.apply(0, P) };
              } else this.fitToGeometryCache = x(b.path(h));
            return this.fitToGeometryCache;
          }
          return this.projection.bounds || r.compositeBounds(c);
        }
        getScale() {
          return 256 / 400.979322 * Math.pow(2, this.zoom);
        }
        getSVGTransform() {
          let { x: b, y: c, width: h, height: g } = this.playingField, k = this.projection.forward(this.center), P = this.projection.hasCoordinates ? -1 : 1, O = this.getScale(), z = O * P, W = b + h / 2 - k[0] * O, G = c + g / 2 - k[1] * z;
          return { scaleX: O, scaleY: z, translateX: W, translateY: G };
        }
        lonLatToPixels(b) {
          let c = this.lonLatToProjectedUnits(b);
          if (c) return this.projectedUnitsToPixels(c);
        }
        lonLatToProjectedUnits(b) {
          let c = this.chart, h = c.mapTransforms;
          if (h) {
            for (let k in h) if (Object.hasOwnProperty.call(h, k) && h[k].hitZone) {
              let P = c.transformFromLatLon(b, h[k]);
              if (P && R(P, h[k].hitZone.coordinates[0])) return P;
            }
            return c.transformFromLatLon(b, h.default);
          }
          for (let k of this.insets) if (k.options.geoBounds && R({ x: b.lon, y: b.lat }, k.options.geoBounds.coordinates[0])) {
            let P = k.projection.forward([b.lon, b.lat]), O = k.projectedUnitsToPixels({ x: P[0], y: P[1] });
            return this.pixelsToProjectedUnits(O);
          }
          let g = this.projection.forward([b.lon, b.lat]);
          if (!g.outside) return { x: g[0], y: g[1] };
        }
        projectedUnitsToLonLat(b) {
          let c = this.chart, h = c.mapTransforms;
          if (h) {
            for (let P in h) if (Object.hasOwnProperty.call(h, P) && h[P].hitZone && R(b, h[P].hitZone.coordinates[0])) return c.transformToLatLon(b, h[P]);
            return c.transformToLatLon(b, h.default);
          }
          let g = this.projectedUnitsToPixels(b);
          for (let P of this.insets) if (P.hitZone && R(g, P.hitZone.coordinates[0])) {
            let O = P.pixelsToProjectedUnits(g), z = P.projection.inverse([O.x, O.y]);
            return { lon: z[0], lat: z[1] };
          }
          let k = this.projection.inverse([b.x, b.y]);
          return { lon: k[0], lat: k[1] };
        }
        recommendMapView(b, c, h = !1) {
          var O;
          this.recommendedMapView = {};
          let g = c.map((z) => this.getGeoMap(z)), k = [];
          g.forEach((z) => {
            if (z && (Object.keys(this.recommendedMapView).length || (this.recommendedMapView = z["hc-recommended-mapview"] || {}), z.bbox)) {
              let [W, G, Y, U] = z.bbox;
              k.push({ x1: W, y1: G, x2: Y, y2: U });
            }
          });
          let P = k.length && r.compositeBounds(k);
          u(this, "onRecommendMapView", { geoBounds: P, chart: b }, function() {
            if (P && this.recommendedMapView) {
              if (!this.recommendedMapView.projection) {
                let { x1: z, y1: W, x2: G, y2: Y } = P;
                this.recommendedMapView.projection = G - z > 180 && Y - W > 90 ? { name: "EqualEarth", parallels: [0, 0], rotation: [0] } : { name: "LambertConformalConic", parallels: [W, Y], rotation: [-(z + G) / 2] };
              }
              this.recommendedMapView.insets || (this.recommendedMapView.insets = void 0);
            }
          }), this.geoMap = g[0], h && b.hasRendered && !((O = b.userOptions.mapView) != null && O.projection) && this.recommendedMapView && this.update(this.recommendedMapView);
        }
        redraw(b) {
          this.chart.series.forEach((c) => {
            c.useMapGeometry && (c.isDirty = !0);
          }), this.chart.redraw(b);
        }
        setView(b, c, h = !0, g) {
          b && (this.center = b), typeof c == "number" && (typeof this.minZoom == "number" && (c = Math.max(c, this.minZoom)), typeof this.options.maxZoom == "number" && (c = Math.min(c, this.options.maxZoom)), M(c) && (this.zoom = c));
          let k = this.getProjectedBounds();
          if (k) {
            let P = this.projection.forward(this.center), { x: O, y: z, width: W, height: G } = this.playingField, Y = this.getScale(), U = this.projectedUnitsToPixels({ x: k.x1, y: k.y1 }), H = this.projectedUnitsToPixels({ x: k.x2, y: k.y2 }), q = [(k.x1 + k.x2) / 2, (k.y1 + k.y2) / 2];
            if (!this.chart.series.some((X) => X.isDrilling)) {
              let X = U.x, $ = H.y, K = H.x, V = U.y;
              K - X < W ? P[0] = q[0] : X < O && K < O + W ? P[0] += Math.max(X - O, K - W - O) / Y : K > O + W && X > O && (P[0] += Math.min(K - W - O, X - O) / Y), V - $ < G ? P[1] = q[1] : $ < z && V < z + G ? P[1] -= Math.max($ - z, V - G - z) / Y : V > z + G && $ > z && (P[1] -= Math.min(V - G - z, $ - z) / Y), this.center = this.projection.inverse(P);
            }
            this.insets.forEach((X) => {
              X.options.field && (X.hitZone = X.getHitZone(), X.playingField = X.getField());
            }), this.render();
          }
          u(this, "afterSetView"), h && this.redraw(g);
        }
        projectedUnitsToPixels(b) {
          let c = this.getScale(), h = this.projection.forward(this.center), g = this.playingField, k = g.x + g.width / 2, P = g.y + g.height / 2;
          return { x: k - c * (h[0] - b.x), y: P + c * (h[1] - b.y) };
        }
        pixelsToLonLat(b) {
          return this.projectedUnitsToLonLat(this.pixelsToProjectedUnits(b));
        }
        pixelsToProjectedUnits(b) {
          let { x: c, y: h } = b, g = this.getScale(), k = this.projection.forward(this.center), P = this.playingField, O = P.x + P.width / 2, z = P.y + P.height / 2;
          return { x: k[0] + (c - O) / g, y: k[1] - (h - z) / g };
        }
        setUpEvents() {
          let b, c, h, { chart: g } = this, k = (P) => {
            let { lastTouches: O, pinchDown: z } = g.pointer, W = this.projection, G = P.touches, { mouseDownX: Y, mouseDownY: U } = g, H = 0;
            if ((z == null ? void 0 : z.length) === 1 ? (Y = z[0].chartX, U = z[0].chartY) : (z == null ? void 0 : z.length) === 2 && (Y = (z[0].chartX + z[1].chartX) / 2, U = (z[0].chartY + z[1].chartY) / 2), (G == null ? void 0 : G.length) === 2 && O && (H = Math.log(Math.sqrt(Math.pow(O[0].chartX - O[1].chartX, 2) + Math.pow(O[0].chartY - O[1].chartY, 2)) / Math.sqrt(Math.pow(G[0].chartX - G[1].chartX, 2) + Math.pow(G[0].chartY - G[1].chartY, 2))) / Math.log(0.5)), M(Y) && M(U)) {
              let q = `${Y},${U}`, { chartX: X, chartY: $ } = P.originalEvent;
              (G == null ? void 0 : G.length) === 2 && (X = (G[0].chartX + G[1].chartX) / 2, $ = (G[0].chartY + G[1].chartY) / 2), q !== c && (c = q, b = this.projection.forward(this.center), h = (this.projection.options.rotation || [0, 0]).slice());
              let K = W.def && W.def.bounds, V = K && w(K, this.playingField) || -1 / 0;
              if (W.options.name === "Orthographic" && 2 > ((G == null ? void 0 : G.length) || 0) && (this.minZoom || 1 / 0) < 1.3 * V) {
                let Q = 440 / (this.getScale() * Math.min(g.plotWidth, g.plotHeight));
                if (h) {
                  let Z = (Y - X) * Q - h[0], ee = y(-h[1] - (U - $) * Q, -80, 80), J = this.zoom;
                  this.update({ projection: { rotation: [-Z, -ee] } }, !1), this.fitToBounds(void 0, void 0, !1), this.zoom = J, g.redraw(!1);
                }
              } else if (M(X) && M($)) {
                let Q = this.getScale(), Z = this.projection.hasCoordinates ? 1 : -1, ee = this.projection.inverse([b[0] + (Y - X) / Q, b[1] - (U - $) / Q * Z]);
                isNaN(ee[0] + ee[1]) || this.zoomBy(H, ee, void 0, !1);
              }
              P.preventDefault();
            }
          };
          T(g, "pan", k), T(g, "touchpan", k), T(g, "selection", (P) => {
            if (P.resetSelection) this.zoomBy();
            else {
              let O = P.x - g.plotLeft, z = P.y - g.plotTop, { y: W, x: G } = this.pixelsToProjectedUnits({ x: O, y: z }), { y: Y, x: U } = this.pixelsToProjectedUnits({ x: O + P.width, y: z + P.height });
              this.fitToBounds({ x1: G, y1: W, x2: U, y2: Y }, void 0, !0, !P.originalEvent.touches && void 0), /^touch/.test(P.originalEvent.type) || g.showResetZoom(), P.preventDefault();
            }
          });
        }
        render() {
          this.group || (this.group = this.chart.renderer.g("map-view").attr({ zIndex: 4 }).add());
        }
        update(b, c = !0, h) {
          let g = b.projection, k = g && j.toString(g) !== j.toString(this.options.projection), P = !1;
          C(!0, this.userOptions, b), C(!0, this.options, b), "insets" in b && (this.insets.forEach((O) => O.destroy()), this.insets.length = 0, P = !0), (k || "fitToGeometry" in b) && delete this.fitToGeometryCache, (k || P) && (this.chart.series.forEach((O) => {
            let z = O.transformGroups;
            if (O.clearBounds && O.clearBounds(), O.isDirty = !0, O.isDirtyData = !0, P && z) for (; z.length > 1; ) {
              let W = z.pop();
              W && W.destroy();
            }
          }), k && (this.projection = new j(this.options.projection)), P && this.createInsets(), !b.center && Object.hasOwnProperty.call(b, "zoom") && !M(b.zoom) && this.fitToBounds(void 0, void 0, !1)), b.center || M(b.zoom) ? this.setView(this.options.center, b.zoom, !1) : "fitToGeometry" in b && this.fitToBounds(void 0, void 0, !1), c && this.chart.redraw(h);
        }
        zoomBy(b, c, h, g) {
          let k = this.chart, P = this.projection.forward(this.center);
          if (typeof b == "number") {
            let O, z, W, G = this.zoom + b;
            if (h) {
              let [Y, U] = h, H = this.getScale(), q = Y - k.plotLeft - k.plotWidth / 2, X = U - k.plotTop - k.plotHeight / 2;
              z = P[0] + q / H, W = P[1] + X / H;
            }
            if (typeof z == "number" && typeof W == "number") {
              let Y = 1 - Math.pow(2, this.zoom) / Math.pow(2, G), U = P[0] - z, H = P[1] - W;
              P[0] -= U * Y, P[1] += H * Y, O = this.projection.inverse(P);
            }
            this.setView(c || O, G, void 0, g);
          } else this.fitToBounds(void 0, void 0, void 0, g);
        }
      }
      class s extends r {
        constructor(b, c) {
          if (super(b.chart, c), this.id = c.id, this.mapView = b, this.options = C({ center: [0, 0] }, b.options.insetOptions, c), this.allBounds = [], this.options.geoBounds) {
            let h = b.projection.path(this.options.geoBounds);
            this.geoBoundsProjectedBox = x(h), this.geoBoundsProjectedPolygon = h.map((g) => [g[1] || 0, g[2] || 0]);
          }
        }
        getField(b = !0) {
          let c = this.hitZone;
          if (c) {
            let h = b ? this.padding : [0, 0, 0, 0], g = c.coordinates[0], k = g.map((Y) => Y[0]), P = g.map((Y) => Y[1]), O = Math.min.apply(0, k) + h[3], z = Math.max.apply(0, k) - h[1], W = Math.min.apply(0, P) + h[0], G = Math.max.apply(0, P) - h[2];
            if (M(O) && M(W)) return { x: O, y: W, width: z - O, height: G - W };
          }
          return super.getField.call(this, b);
        }
        getHitZone() {
          let { chart: b, mapView: c, options: h } = this, { coordinates: g } = h.field || {};
          if (g) {
            let k = g[0];
            if (h.units === "percent") {
              let P = h.relativeTo === "mapBoundingBox" && c.getMapBBox() || C(b.plotBox, { x: 0, y: 0 });
              k = k.map((O) => [E(`${O[0]}%`, P.width, P.x), E(`${O[1]}%`, P.height, P.y)]);
            }
            return { type: "Polygon", coordinates: [k] };
          }
        }
        getProjectedBounds() {
          return r.compositeBounds(this.allBounds);
        }
        isInside(b) {
          let { geoBoundsProjectedBox: c, geoBoundsProjectedPolygon: h } = this;
          return !!(c && b.x >= c.x1 && b.x <= c.x2 && b.y >= c.y1 && b.y <= c.y2 && h && R(b, h));
        }
        render() {
          let { chart: b, mapView: c, options: h } = this, g = h.borderPath || h.field;
          if (g && c.group) {
            let k = !0;
            this.border || (this.border = b.renderer.path().addClass("highcharts-mapview-inset-border").add(c.group), k = !1), b.styledMode || this.border.attr({ stroke: h.borderColor, "stroke-width": h.borderWidth });
            let P = this.border.strokeWidth(), O = h.relativeTo === "mapBoundingBox" && c.getMapBBox() || c.playingField, z = (g.coordinates || []).reduce((W, G) => G.reduce((Y, U, H) => {
              let [q, X] = U;
              return h.units === "percent" && (q = b.plotLeft + E(`${q}%`, O.width, O.x), X = b.plotTop + E(`${X}%`, O.height, O.y)), q = S(q, P), X = S(X, P), Y.push(H === 0 ? ["M", q, X] : ["L", q, X]), Y;
            }, W), []);
            this.border[k ? "animate" : "attr"]({ d: z });
          }
        }
        destroy() {
          this.border && (this.border = this.border.destroy()), this.eventsToUnbind.forEach((b) => b());
        }
        setUpEvents() {
        }
      }
      return r;
    }), i(e, "Series/Map/MapSeries.js", [e["Core/Animation/AnimationUtilities.js"], e["Series/ColorMapComposition.js"], e["Series/CenteredUtilities.js"], e["Core/Globals.js"], e["Core/Chart/MapChart.js"], e["Series/Map/MapPoint.js"], e["Series/Map/MapSeriesDefaults.js"], e["Maps/MapView.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j, I, B, R, N) {
      let { animObject: x, stop: T } = o, { noop: y } = L, { splitPath: S } = D, { column: u, scatter: A } = R.seriesTypes, { extend: M, find: f, fireEvent: m, getNestedProperty: C, isArray: F, defined: _, isNumber: E, isObject: v, merge: w, objectEach: d, pick: r, splat: s } = N;
      class p extends A {
        constructor() {
          super(...arguments), this.processedData = [];
        }
        animate(c) {
          let { chart: h, group: g } = this, k = x(this.options.animation);
          c ? g.attr({ translateX: h.plotLeft + h.plotWidth / 2, translateY: h.plotTop + h.plotHeight / 2, scaleX: 1e-3, scaleY: 1e-3 }) : g.animate({ translateX: h.plotLeft, translateY: h.plotTop, scaleX: 1, scaleY: 1 }, k);
        }
        clearBounds() {
          this.points.forEach((c) => {
            delete c.bounds, delete c.insetIndex, delete c.projectedPath;
          }), delete this.bounds;
        }
        doFullTranslate() {
          return !!(this.isDirtyData || this.chart.isResizing || !this.hasRendered);
        }
        drawMapDataLabels() {
          super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
        }
        drawPoints() {
          let c = this, { chart: h, group: g, transformGroups: k = [] } = this, { mapView: P, renderer: O } = h;
          if (P) {
            this.transformGroups = k, k[0] || (k[0] = O.g().add(g));
            for (let z = 0, W = P.insets.length; z < W; ++z) k[z + 1] || k.push(O.g().add(g));
            this.doFullTranslate() && (this.points.forEach((z) => {
              let { graphic: W } = z;
              z.group = k[typeof z.insetIndex == "number" ? z.insetIndex + 1 : 0], W && W.parentGroup !== z.group && W.add(z.group);
            }), u.prototype.drawPoints.apply(this), this.points.forEach((z) => {
              let W = z.graphic;
              if (W) {
                let G = W.animate, Y = "";
                z.name && (Y += "highcharts-name-" + z.name.replace(/ /g, "-").toLowerCase()), z.properties && z.properties["hc-key"] && (Y += " highcharts-key-" + z.properties["hc-key"].toString().toLowerCase()), Y && W.addClass(Y), h.styledMode && W.css(this.pointAttribs(z, z.selected && "select" || void 0)), W.attr({ visibility: !z.visible && (z.visible || z.isNull) ? "hidden" : "inherit" }), W.animate = function(U, H, q) {
                  let X = E(U["stroke-width"]) && !E(W["stroke-width"]), $ = E(W["stroke-width"]) && !E(U["stroke-width"]);
                  if (X || $) {
                    let K = r(c.getStrokeWidth(c.options), 1) / (h.mapView && h.mapView.getScale() || 1);
                    X && (W["stroke-width"] = K), $ && (U["stroke-width"] = K);
                  }
                  return G.call(W, U, H, $ ? function() {
                    W.element.removeAttribute("stroke-width"), delete W["stroke-width"], q && q.apply(this, arguments);
                  } : q);
                };
              }
            })), k.forEach((z, W) => {
              let G = (W === 0 ? P : P.insets[W - 1]).getSVGTransform(), Y = r(this.getStrokeWidth(this.options), 1), U = G.scaleX, H = G.scaleY > 0 ? 1 : -1, q = (X) => {
                (c.points || []).forEach(($) => {
                  let K, V = $.graphic;
                  V && V["stroke-width"] && (K = this.getStrokeWidth($.options)) && V.attr({ "stroke-width": K / X });
                });
              };
              if (O.globalAnimation && h.hasRendered && P.allowTransformAnimation) {
                let X = Number(z.attr("translateX")), $ = Number(z.attr("translateY")), K = Number(z.attr("scaleX")), V = (ee, J) => {
                  let ie = K + (U - K) * J.pos;
                  z.attr({ translateX: X + (G.translateX - X) * J.pos, translateY: $ + (G.translateY - $) * J.pos, scaleX: ie, scaleY: ie * H, "stroke-width": Y / ie }), q(ie);
                }, Q = w(x(O.globalAnimation)), Z = Q.step;
                Q.step = function() {
                  Z && Z.apply(this, arguments), V.apply(this, arguments);
                }, z.attr({ animator: 0 }).animate({ animator: 1 }, Q, (function() {
                  typeof O.globalAnimation != "boolean" && O.globalAnimation.complete && O.globalAnimation.complete({ applyDrilldown: !0 }), m(this, "mapZoomComplete");
                }).bind(this));
              } else T(z), z.attr(w(G, { "stroke-width": Y / U })), q(U);
            }), this.isDrilling || this.drawMapDataLabels();
          }
        }
        getProjectedBounds() {
          if (!this.bounds && this.chart.mapView) {
            let { insets: c, projection: h } = this.chart.mapView, g = [];
            (this.points || []).forEach((k) => {
              if (k.path || k.geometry) {
                if (typeof k.path == "string" ? k.path = S(k.path) : F(k.path) && k.path[0] === "M" && (k.path = this.chart.renderer.pathToSegments(k.path)), !k.bounds) {
                  let P = k.getProjectedBounds(h);
                  if (P) {
                    k.labelrank = r(k.labelrank, (P.x2 - P.x1) * (P.y2 - P.y1));
                    let { midX: O, midY: z } = P;
                    if (c && E(O) && E(z)) {
                      let W = f(c, (G) => G.isInside({ x: O, y: z }));
                      W && (delete k.projectedPath, (P = k.getProjectedBounds(W.projection)) && W.allBounds.push(P), k.insetIndex = c.indexOf(W));
                    }
                    k.bounds = P;
                  }
                }
                k.bounds && k.insetIndex === void 0 && g.push(k.bounds);
              }
            }), this.bounds = B.compositeBounds(g);
          }
          return this.bounds;
        }
        getStrokeWidth(c) {
          let h = this.pointAttrToOptions;
          return c[h && h["stroke-width"] || "borderWidth"];
        }
        hasData() {
          return !!this.processedXData.length;
        }
        pointAttribs(c, h) {
          var W;
          let { mapView: g, styledMode: k } = c.series.chart, P = k ? this.colorAttribs(c) : u.prototype.pointAttribs.call(this, c, h), O = this.getStrokeWidth(c.options);
          if (h) {
            let G = w(this.options.states && this.options.states[h], c.options.states && c.options.states[h] || {}), Y = this.getStrokeWidth(G);
            _(Y) && (O = Y), P.stroke = (W = G.borderColor) != null ? W : c.color;
          }
          O && g && (O /= g.getScale());
          let z = this.getStrokeWidth(this.options);
          return P.dashstyle && g && E(z) && (O = z / g.getScale()), c.visible || (P.fill = this.options.nullColor), _(O) ? P["stroke-width"] = O : delete P["stroke-width"], P["stroke-linecap"] = P["stroke-linejoin"] = this.options.linecap, P;
        }
        updateData() {
          return !this.processedData && super.updateData.apply(this, arguments);
        }
        setData(c, h = !0, g, k) {
          delete this.bounds, super.setData(c, !1, void 0, k), this.processData(), this.generatePoints(), h && this.chart.redraw(g);
        }
        processData() {
          let c, h, g, k = this.options, P = k.data, O = this.chart, z = O.options.chart, W = this.joinBy, G = k.keys || this.pointArrayMap, Y = [], U = {}, H = this.chart.mapView, q = H && (v(k.mapData, !0) ? H.getGeoMap(k.mapData) : H.geoMap), X = O.mapTransforms = z.mapTransforms || q && q["hc-transform"] || O.mapTransforms;
          X && d(X, (K) => {
            K.rotation && (K.cosAngle = Math.cos(K.rotation), K.sinAngle = Math.sin(K.rotation));
          }), F(k.mapData) ? g = k.mapData : q && q.type === "FeatureCollection" && (this.mapTitle = q.title, g = L.geojson(q, this.type, this)), this.processedData = [];
          let $ = this.processedData;
          if (P) {
            let K;
            for (let V = 0, Q = P.length; V < Q; ++V) {
              if (E(K = P[V])) $[V] = { value: K };
              else if (F(K)) {
                let Z = 0;
                $[V] = {}, !k.keys && K.length > G.length && typeof K[0] == "string" && ($[V]["hc-key"] = K[0], ++Z);
                for (let ee = 0; ee < G.length; ++ee, ++Z) G[ee] && K[Z] !== void 0 && (G[ee].indexOf(".") > 0 ? j.prototype.setNestedProperty($[V], K[Z], G[ee]) : $[V][G[ee]] = K[Z]);
              } else $[V] = P[V];
              W && W[0] === "_i" && ($[V]._i = V);
            }
          }
          if (g) {
            this.mapData = g, this.mapMap = {};
            for (let K = 0; K < g.length; K++) h = (c = g[K]).properties, c._i = K, W[0] && h && h[W[0]] && (c[W[0]] = h[W[0]]), U[c[W[0]]] = c;
            if (this.mapMap = U, W[1]) {
              let K = W[1];
              $.forEach((V) => {
                let Q = C(K, V);
                U[Q] && Y.push(U[Q]);
              });
            }
            if (k.allAreas) {
              if (W[1]) {
                let V = W[1];
                $.forEach((Q) => {
                  Y.push(C(V, Q));
                });
              }
              let K = "|" + Y.map(function(V) {
                return V && V[W[0]];
              }).join("|") + "|";
              g.forEach((V) => {
                W[0] && K.indexOf("|" + V[W[0]] + "|") !== -1 || $.push(w(V, { value: null }));
              });
            }
          }
          this.processedXData = Array($.length);
        }
        setOptions(c) {
          let h = super.setOptions(c), g = h.joinBy;
          return h.joinBy === null && (g = "_i"), (g = this.joinBy = s(g))[1] || (g[1] = g[0]), h;
        }
        translate() {
          let c = this.doFullTranslate(), h = this.chart.mapView, g = h && h.projection;
          if (this.chart.hasRendered && (this.isDirtyData || !this.hasRendered) && (this.processData(), this.generatePoints(), delete this.bounds, !h || h.userOptions.center || E(h.userOptions.zoom) || h.zoom !== h.minZoom ? this.getProjectedBounds() : h.fitToBounds(void 0, void 0, !1)), h) {
            let k = h.getSVGTransform();
            this.points.forEach((P) => {
              let O = E(P.insetIndex) && h.insets[P.insetIndex].getSVGTransform() || k;
              O && P.bounds && E(P.bounds.midX) && E(P.bounds.midY) && (P.plotX = P.bounds.midX * O.scaleX + O.translateX, P.plotY = P.bounds.midY * O.scaleY + O.translateY), c && (P.shapeType = "path", P.shapeArgs = { d: j.getProjectedPath(P, g) }), P.hiddenInDataClass || (P.projectedPath && !P.projectedPath.length ? P.setVisible(!1) : P.visible || P.setVisible(!0));
            });
          }
          m(this, "afterTranslate");
        }
        update(c) {
          var h;
          c.mapData && ((h = this.chart.mapView) == null || h.recommendMapView(this.chart, [this.chart.options.chart.map, ...(this.chart.options.series || []).map((g, k) => k === this._i ? c.mapData : g.mapData)], !0)), super.update.apply(this, arguments);
        }
      }
      return p.defaultOptions = w(A.defaultOptions, I), M(p.prototype, { type: "map", axisTypes: n.seriesMembers.axisTypes, colorAttribs: n.seriesMembers.colorAttribs, colorKey: n.seriesMembers.colorKey, directTouch: !0, drawDataLabels: y, drawGraph: y, forceDL: !0, getCenter: l.getCenter, getExtremesFromAll: !0, getSymbol: y, isCartesian: !1, parallelArrays: n.seriesMembers.parallelArrays, pointArrayMap: n.seriesMembers.pointArrayMap, pointClass: j, preserveAspectRatio: !0, searchPoint: y, trackerGroups: n.seriesMembers.trackerGroups, useMapGeometry: !0 }), n.compose(p), R.registerSeriesType("map", p), p;
    }), i(e, "Series/MapLine/MapLineSeriesDefaults.js", [], function() {
      return { lineWidth: 1, fillColor: "none", legendSymbol: "lineMarker" };
    }), i(e, "Series/MapLine/MapLineSeries.js", [e["Series/MapLine/MapLineSeriesDefaults.js"], e["Series/Map/MapSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { extend: D, merge: j } = L;
      class I extends n {
        pointAttribs(R, N) {
          let x = super.pointAttribs(R, N);
          return x.fill = this.options.fillColor, x;
        }
      }
      return I.defaultOptions = j(n.defaultOptions, o), D(I.prototype, { type: "mapline", colorProp: "stroke", pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" } }), l.registerSeriesType("mapline", I), I;
    }), i(e, "Series/MapPoint/MapPointPoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { scatter: l } = o.seriesTypes, { isNumber: L } = n;
      class D extends l.prototype.pointClass {
        isValid() {
          return !!(this.options.geometry || L(this.x) && L(this.y) || L(this.options.lon) && L(this.options.lat));
        }
      }
      return D;
    }), i(e, "Series/MapPoint/MapPointSeriesDefaults.js", [], function() {
      return { dataLabels: { crop: !1, defer: !1, enabled: !0, formatter: function() {
        return this.point.name;
      }, overflow: !1, style: { color: "#000000" } }, legendSymbol: "lineMarker" };
    }), i(e, "Series/MapPoint/MapPointSeries.js", [e["Core/Globals.js"], e["Series/MapPoint/MapPointPoint.js"], e["Series/MapPoint/MapPointSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { noop: I } = o, { map: B, scatter: R } = L.seriesTypes, { extend: N, fireEvent: x, isNumber: T, merge: y } = j;
      class S extends R {
        constructor() {
          super(...arguments), this.clearBounds = B.prototype.clearBounds;
        }
        drawDataLabels() {
          super.drawDataLabels(), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
        }
        projectPoint(A) {
          let M = this.chart.mapView;
          if (M) {
            let { geometry: f, lon: m, lat: C } = A, F = f && f.type === "Point" && f.coordinates;
            if (T(m) && T(C) && (F = [m, C]), F) return M.lonLatToProjectedUnits({ lon: F[0], lat: F[1] });
          }
        }
        translate() {
          let A = this.chart.mapView;
          if (this.processedXData || this.processData(), this.generatePoints(), this.getProjectedBounds && this.isDirtyData && (delete this.bounds, this.getProjectedBounds()), A) {
            let M = A.getSVGTransform(), { hasCoordinates: f } = A.projection;
            this.points.forEach((m) => {
              let C, { x: F, y: _ } = m, E = T(m.insetIndex) && A.insets[m.insetIndex].getSVGTransform() || M, v = this.projectPoint(m.options) || m.properties && this.projectPoint(m.properties);
              if (v ? (F = v.x, _ = v.y) : m.bounds && (F = m.bounds.midX, _ = m.bounds.midY, E && T(F) && T(_) && (m.plotX = F * E.scaleX + E.translateX, m.plotY = _ * E.scaleY + E.translateY, C = !0)), T(F) && T(_)) {
                if (!C) {
                  let w = A.projectedUnitsToPixels({ x: F, y: _ });
                  m.plotX = w.x, m.plotY = f ? w.y : this.chart.plotHeight - w.y;
                }
              } else m.y = m.plotX = m.plotY = void 0;
              m.isInside = this.isPointInside(m), m.zone = this.zones.length ? m.getZone() : void 0;
            });
          }
          x(this, "afterTranslate");
        }
      }
      return S.defaultOptions = y(R.defaultOptions, l), D.prototype.symbols.mapmarker = (u, A, M, f, m) => {
        let C, F, _ = m && m.context === "legend";
        _ ? (C = u + M / 2, F = A + f) : m && typeof m.anchorX == "number" && typeof m.anchorY == "number" ? (C = m.anchorX, F = m.anchorY) : (C = u + M / 2, F = A + f / 2, A -= f);
        let E = _ ? f / 3 : f / 2;
        return [["M", C, F], ["C", C, F, C - E, A + 1.5 * E, C - E, A + E], ["A", E, E, 1, 1, 1, C + E, A + E], ["C", C + E, A + 1.5 * E, C, F, C, F], ["Z"]];
      }, N(S.prototype, { type: "mappoint", axisTypes: ["colorAxis"], forceDL: !0, isCartesian: !1, pointClass: n, searchPoint: I, useMapGeometry: !0 }), L.registerSeriesType("mappoint", S), S;
    }), i(e, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
      return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "0.9em", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
    }), i(e, "Series/Bubble/BubbleLegendItem.js", [e["Core/Color/Color.js"], e["Core/Templating.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { parse: D } = o, { noop: j } = l, { arrayMax: I, arrayMin: B, isNumber: R, merge: N, pick: x, stableSort: T } = L;
      return class {
        constructor(y, S) {
          this.setState = j, this.init(y, S);
        }
        init(y, S) {
          this.options = y, this.visible = !0, this.chart = S.chart, this.legend = S;
        }
        addToLegend(y) {
          y.splice(this.options.legendIndex, 0, this);
        }
        drawLegendSymbol(y) {
          let S, u = x(y.options.itemDistance, 20), A = this.legendItem || {}, M = this.options, f = M.ranges, m = M.connectorDistance;
          if (!f || !f.length || !R(f[0].value)) {
            y.options.bubbleLegend.autoRanges = !0;
            return;
          }
          T(f, function(E, v) {
            return v.value - E.value;
          }), this.ranges = f, this.setOptions(), this.render();
          let C = this.getMaxLabelSize(), F = this.ranges[0].radius, _ = 2 * F;
          S = (S = m - F + C.width) > 0 ? S : 0, this.maxLabel = C, this.movementX = M.labels.align === "left" ? S : 0, A.labelWidth = _ + S + u, A.labelHeight = _ + C.height / 2;
        }
        setOptions() {
          let y = this.ranges, S = this.options, u = this.chart.series[S.seriesIndex], A = this.legend.baseline, M = { zIndex: S.zIndex, "stroke-width": S.borderWidth }, f = { zIndex: S.zIndex, "stroke-width": S.connectorWidth }, m = { align: this.legend.options.rtl || S.labels.align === "left" ? "right" : "left", zIndex: S.zIndex }, C = u.options.marker.fillOpacity, F = this.chart.styledMode;
          y.forEach(function(_, E) {
            F || (M.stroke = x(_.borderColor, S.borderColor, u.color), M.fill = x(_.color, S.color, C !== 1 ? D(u.color).setOpacity(C).get("rgba") : u.color), f.stroke = x(_.connectorColor, S.connectorColor, u.color)), y[E].radius = this.getRangeRadius(_.value), y[E] = N(y[E], { center: y[0].radius - y[E].radius + A }), F || N(!0, y[E], { bubbleAttribs: N(M), connectorAttribs: N(f), labelAttribs: m });
          }, this);
        }
        getRangeRadius(y) {
          let S = this.options, u = this.options.seriesIndex, A = this.chart.series[u], M = S.ranges[0].value, f = S.ranges[S.ranges.length - 1].value, m = S.minSize, C = S.maxSize;
          return A.getRadius.call(this, f, M, m, C, y);
        }
        render() {
          let y = this.legendItem || {}, S = this.chart.renderer, u = this.options.zThreshold;
          for (let A of (this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), y.symbol = S.g("bubble-legend"), y.label = S.g("bubble-legend-item").css(this.legend.itemStyle || {}), y.symbol.translateX = 0, y.symbol.translateY = 0, y.symbol.add(y.label), y.label.add(y.group), this.ranges)) A.value >= u && this.renderRange(A);
          this.hideOverlappingLabels();
        }
        renderRange(y) {
          let S = this.ranges[0], u = this.legend, A = this.options, M = A.labels, f = this.chart, m = f.series[A.seriesIndex], C = f.renderer, F = this.symbols, _ = F.labels, E = y.center, v = Math.abs(y.radius), w = A.connectorDistance || 0, d = M.align, r = u.options.rtl, s = A.borderWidth, p = A.connectorWidth, b = S.radius || 0, c = E - v - s / 2 + p / 2, h = (c % 1 ? 1 : 0.5) - (p % 2 ? 0 : 0.5), g = C.styledMode, k = r || d === "left" ? -w : w;
          d === "center" && (k = 0, A.connectorDistance = 0, y.labelAttribs.align = "center"), F.bubbleItems.push(C.circle(b, E + h, v).attr(g ? {} : y.bubbleAttribs).addClass((g ? "highcharts-color-" + m.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (A.className || "")).add(this.legendItem.symbol)), F.connectors.push(C.path(C.crispLine([["M", b, c], ["L", b + k, c]], A.connectorWidth)).attr(g ? {} : y.connectorAttribs).addClass((g ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (A.connectorClassName || "")).add(this.legendItem.symbol));
          let P = C.text(this.formatLabel(y)).attr(g ? {} : y.labelAttribs).css(g ? {} : M.style).addClass("highcharts-bubble-legend-labels " + (A.labels.className || "")).add(this.legendItem.symbol), O = { x: b + k + A.labels.x, y: c + A.labels.y + 0.4 * P.getBBox().height };
          P.attr(O), _.push(P), P.placed = !0, P.alignAttr = O;
        }
        getMaxLabelSize() {
          let y, S;
          return this.symbols.labels.forEach(function(u) {
            S = u.getBBox(!0), y = y ? S.width > y.width ? S : y : S;
          }), y || {};
        }
        formatLabel(y) {
          let S = this.options, u = S.labels.formatter, A = S.labels.format, { numberFormatter: M } = this.chart;
          return A ? n.format(A, y) : u ? u.call(y) : M(y.value, 1);
        }
        hideOverlappingLabels() {
          let y = this.chart, S = this.options.labels.allowOverlap, u = this.symbols;
          !S && u && (y.hideOverlappingLabels(u.labels), u.labels.forEach(function(A, M) {
            A.newOpacity ? A.newOpacity !== A.oldOpacity && u.connectors[M].show() : u.connectors[M].hide();
          }));
        }
        getRanges() {
          let y = this.legend.bubbleLegend, S = y.chart.series, u = y.options.ranges, A, M, f = Number.MAX_VALUE, m = -Number.MAX_VALUE;
          return S.forEach(function(C) {
            C.isBubble && !C.ignoreSeries && (M = C.zData.filter(R)).length && (f = x(C.options.zMin, Math.min(f, Math.max(B(M), C.options.displayNegative === !1 ? C.options.zThreshold : -Number.MAX_VALUE))), m = x(C.options.zMax, Math.max(m, I(M))));
          }), A = f === m ? [{ value: m }] : [{ value: f }, { value: (f + m) / 2 }, { value: m, autoRanges: !0 }], u.length && u[0].radius && A.reverse(), A.forEach(function(C, F) {
            u && u[F] && (A[F] = N(u[F], C));
          }), A;
        }
        predictBubbleSizes() {
          let y = this.chart, S = y.legend.options, u = S.floating, A = S.layout === "horizontal", M = A ? y.legend.lastLineHeight : 0, f = y.plotSizeX, m = y.plotSizeY, C = y.series[this.options.seriesIndex], F = C.getPxExtremes(), _ = Math.ceil(F.minPxSize), E = Math.ceil(F.maxPxSize), v = Math.min(m, f), w, d = C.options.maxSize;
          return u || !/%$/.test(d) ? w = E : (w = (v + M) * (d = parseFloat(d)) / 100 / (d / 100 + 1), (A && m - w >= f || !A && f - w >= m) && (w = E)), [_, Math.ceil(w)];
        }
        updateRanges(y, S) {
          let u = this.legend.options.bubbleLegend;
          u.minSize = y, u.maxSize = S, u.ranges = this.getRanges();
        }
        correctSizes() {
          let y = this.legend, S = this.chart.series[this.options.seriesIndex].getPxExtremes();
          Math.abs(Math.ceil(S.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, S.maxPxSize), y.render());
        }
      };
    }), i(e, "Series/Bubble/BubbleLegendComposition.js", [e["Series/Bubble/BubbleLegendDefaults.js"], e["Series/Bubble/BubbleLegendItem.js"], e["Core/Defaults.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n, l, L, D) {
      let { setOptions: j } = l, { composed: I } = L, { addEvent: B, objectEach: R, pushUnique: N, wrap: x } = D;
      function T(f, m, C) {
        let F, _, E, v = this.legend, w = y(this) >= 0;
        v && v.options.enabled && v.bubbleLegend && v.options.bubbleLegend.autoRanges && w ? (F = v.bubbleLegend.options, _ = v.bubbleLegend.predictBubbleSizes(), v.bubbleLegend.updateRanges(_[0], _[1]), F.placed || (v.group.placed = !1, v.allItems.forEach((d) => {
          (E = d.legendItem || {}).group && (E.group.translateY = void 0);
        })), v.render(), F.placed || (this.getMargins(), this.axes.forEach(function(d) {
          d.visible && d.render(), F.placed || (d.setScale(), d.updateNames(), R(d.ticks, function(r) {
            r.isNew = !0, r.isNewLabel = !0;
          }));
        }), this.getMargins()), F.placed = !0, f.call(this, m, C), v.bubbleLegend.correctSizes(), M(v, S(v))) : (f.call(this, m, C), v && v.options.enabled && v.bubbleLegend && (v.render(), M(v, S(v))));
      }
      function y(f) {
        let m = f.series, C = 0;
        for (; C < m.length; ) {
          if (m[C] && m[C].isBubble && m[C].visible && m[C].zData.length) return C;
          C++;
        }
        return -1;
      }
      function S(f) {
        let m = f.allItems, C = [], F = m.length, _, E, v, w = 0, d = 0;
        for (w = 0; w < F; w++) if (E = m[w].legendItem || {}, v = (m[w + 1] || {}).legendItem || {}, E.labelHeight && (m[w].itemHeight = E.labelHeight), m[w] === m[F - 1] || E.y !== v.y) {
          for (C.push({ height: 0 }), _ = C[C.length - 1]; d <= w; d++) m[d].itemHeight > _.height && (_.height = m[d].itemHeight);
          _.step = w;
        }
        return C;
      }
      function u(f) {
        let m = this.bubbleLegend, C = this.options, F = C.bubbleLegend, _ = y(this.chart);
        m && m.ranges && m.ranges.length && (F.ranges.length && (F.autoRanges = !!F.ranges[0].autoRanges), this.destroyItem(m)), _ >= 0 && C.enabled && F.enabled && (F.seriesIndex = _, this.bubbleLegend = new n(F, this), this.bubbleLegend.addToLegend(f.allItems));
      }
      function A(f) {
        let m;
        if (f.defaultPrevented) return !1;
        let C = f.legendItem, F = this.chart, _ = C.visible;
        this && this.bubbleLegend && (C.visible = !_, C.ignoreSeries = _, m = y(F) >= 0, this.bubbleLegend.visible !== m && (this.update({ bubbleLegend: { enabled: m } }), this.bubbleLegend.visible = m), C.visible = _);
      }
      function M(f, m) {
        let C = f.allItems, F = f.options.rtl, _, E, v, w, d = 0;
        C.forEach((r, s) => {
          (w = r.legendItem || {}).group && (_ = w.group.translateX || 0, E = w.y || 0, ((v = r.movementX) || F && r.ranges) && (v = F ? _ - r.options.maxSize / 2 : _ + v, w.group.attr({ translateX: v })), s > m[d].step && d++, w.group.attr({ translateY: Math.round(E + m[d].height / 2) }), w.y = E + m[d].height / 2);
        });
      }
      return { compose: function(f, m) {
        N(I, "Series.BubbleLegend") && (j({ legend: { bubbleLegend: o } }), x(f.prototype, "drawChartBox", T), B(m, "afterGetAllItems", u), B(m, "itemClick", A));
      } };
    }), i(e, "Series/Bubble/BubblePoint.js", [e["Core/Series/Point.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { seriesTypes: { scatter: { prototype: { pointClass: L } } } } = n, { extend: D } = l;
      class j extends L {
        haloPath(B) {
          let R = (B && this.marker && this.marker.radius || 0) + B;
          if (this.series.chart.inverted) {
            let N = this.pos() || [0, 0], { xAxis: x, yAxis: T, chart: y } = this.series;
            return y.renderer.symbols.circle(x.len - N[1] - R, T.len - N[0] - R, 2 * R, 2 * R);
          }
          return o.prototype.haloPath.call(this, R);
        }
      }
      return D(j.prototype, { ttBelow: !1 }), j;
    }), i(e, "Series/Bubble/BubbleSeries.js", [e["Series/Bubble/BubbleLegendComposition.js"], e["Series/Bubble/BubblePoint.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L, D, j) {
      let { parse: I } = l, { composed: B, noop: R } = L, { series: N, seriesTypes: { column: { prototype: x }, scatter: T } } = D, { addEvent: y, arrayMax: S, arrayMin: u, clamp: A, extend: M, isNumber: f, merge: m, pick: C, pushUnique: F } = j;
      function _() {
        let v = this.len, { coll: w, isXAxis: d, min: r } = this, s = d ? "xData" : "yData", p = (this.max || 0) - (r || 0), b = 0, c = v, h = v / p, g;
        (w === "xAxis" || w === "yAxis") && (this.series.forEach((k) => {
          if (k.bubblePadding && k.reserveSpace()) {
            this.allowZoomOutside = !0, g = !0;
            let P = k[s];
            if (d && ((k.onPoint || k).getRadii(0, 0, k), k.onPoint && (k.radii = k.onPoint.radii)), p > 0) {
              let O = P.length;
              for (; O--; ) if (f(P[O]) && this.dataMin <= P[O] && P[O] <= this.max) {
                let z = k.radii && k.radii[O] || 0;
                b = Math.min((P[O] - r) * h - z, b), c = Math.max((P[O] - r) * h + z, c);
              }
            }
          }
        }), g && p > 0 && !this.logarithmic && (c -= v, h *= (v + Math.max(0, b) - Math.min(c, v)) / v, [["min", "userMin", b], ["max", "userMax", c]].forEach((k) => {
          C(this.options[k[0]], this[k[1]]) === void 0 && (this[k[0]] += k[2] / h);
        })));
      }
      class E extends T {
        static compose(w, d, r) {
          o.compose(d, r), F(B, "Series.Bubble") && y(w, "foundExtremes", _);
        }
        animate(w) {
          !w && this.points.length < this.options.animationLimit && this.points.forEach(function(d) {
            let { graphic: r, plotX: s = 0, plotY: p = 0 } = d;
            r && r.width && (this.hasRendered || r.attr({ x: s, y: p, width: 1, height: 1 }), r.animate(this.markerAttribs(d), this.options.animation));
          }, this);
        }
        getRadii() {
          let w = this.zData, d = this.yData, r = [], s, p, b, c = this.chart.bubbleZExtremes, { minPxSize: h, maxPxSize: g } = this.getPxExtremes();
          if (!c) {
            let k, P = Number.MAX_VALUE, O = -Number.MAX_VALUE;
            this.chart.series.forEach((z) => {
              if (z.bubblePadding && z.reserveSpace()) {
                let W = (z.onPoint || z).getZExtremes();
                W && (P = Math.min(C(P, W.zMin), W.zMin), O = Math.max(C(O, W.zMax), W.zMax), k = !0);
              }
            }), k ? (c = { zMin: P, zMax: O }, this.chart.bubbleZExtremes = c) : c = { zMin: 0, zMax: 0 };
          }
          for (p = 0, s = w.length; p < s; p++) b = w[p], r.push(this.getRadius(c.zMin, c.zMax, h, g, b, d && d[p]));
          this.radii = r;
        }
        getRadius(w, d, r, s, p, b) {
          let c = this.options, h = c.sizeBy !== "width", g = c.zThreshold, k = d - w, P = 0.5;
          if (b === null || p === null) return null;
          if (f(p)) {
            if (c.sizeByAbsoluteValue && (p = Math.abs(p - g), d = k = Math.max(d - g, Math.abs(w - g)), w = 0), p < w) return r / 2 - 1;
            k > 0 && (P = (p - w) / k);
          }
          return h && P >= 0 && (P = Math.sqrt(P)), Math.ceil(r + P * (s - r)) / 2;
        }
        hasData() {
          return !!this.processedXData.length;
        }
        markerAttribs(w, d) {
          let r = super.markerAttribs(w, d), { height: s = 0, width: p = 0 } = r;
          return this.chart.inverted ? M(r, { x: (w.plotX || 0) - p / 2, y: (w.plotY || 0) - s / 2 }) : r;
        }
        pointAttribs(w, d) {
          let r = this.options.marker.fillOpacity, s = N.prototype.pointAttribs.call(this, w, d);
          return r !== 1 && (s.fill = I(s.fill).setOpacity(r).get("rgba")), s;
        }
        translate() {
          super.translate.call(this), this.getRadii(), this.translateBubble();
        }
        translateBubble() {
          let { data: w, options: d, radii: r } = this, { minPxSize: s } = this.getPxExtremes(), p = w.length;
          for (; p--; ) {
            let b = w[p], c = r ? r[p] : 0;
            this.zoneAxis === "z" && (b.negative = (b.z || 0) < (d.zThreshold || 0)), f(c) && c >= s / 2 ? (b.marker = M(b.marker, { radius: c, width: 2 * c, height: 2 * c }), b.dlBox = { x: b.plotX - c, y: b.plotY - c, width: 2 * c, height: 2 * c }) : (b.shapeArgs = b.plotY = b.dlBox = void 0, b.isInside = !1);
          }
        }
        getPxExtremes() {
          let w = Math.min(this.chart.plotWidth, this.chart.plotHeight), d = (p) => {
            let b;
            return typeof p == "string" && (b = /%$/.test(p), p = parseInt(p, 10)), b ? w * p / 100 : p;
          }, r = d(C(this.options.minSize, 8)), s = Math.max(d(C(this.options.maxSize, "20%")), r);
          return { minPxSize: r, maxPxSize: s };
        }
        getZExtremes() {
          let w = this.options, d = (this.zData || []).filter(f);
          if (d.length) {
            let r = C(w.zMin, A(u(d), w.displayNegative === !1 ? w.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), s = C(w.zMax, S(d));
            if (f(r) && f(s)) return { zMin: r, zMax: s };
          }
        }
      }
      return E.defaultOptions = m(T.defaultOptions, { dataLabels: { formatter: function() {
        let { numberFormatter: v } = this.series.chart, { z: w } = this.point;
        return f(w) ? v(w, -1) : "";
      }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), M(E.prototype, { alignDataLabel: x.alignDataLabel, applyZones: R, bubblePadding: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: n, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), y(E, "updatedData", (v) => {
        delete v.target.chart.bubbleZExtremes;
      }), y(E, "remove", (v) => {
        delete v.target.chart.bubbleZExtremes;
      }), D.registerSeriesType("bubble", E), E;
    }), i(e, "Series/MapBubble/MapBubblePoint.js", [e["Series/Bubble/BubblePoint.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l) {
      let { seriesTypes: { map: { prototype: { pointClass: { prototype: L } } } } } = n, { extend: D } = l;
      class j extends o {
        isValid() {
          return typeof this.z == "number";
        }
      }
      return D(j.prototype, { applyOptions: L.applyOptions, getProjectedBounds: L.getProjectedBounds }), j;
    }), i(e, "Series/MapBubble/MapBubbleSeries.js", [e["Series/Bubble/BubbleSeries.js"], e["Series/MapBubble/MapBubblePoint.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n, l, L) {
      let { seriesTypes: { map: { prototype: D }, mappoint: { prototype: j } } } = l, { extend: I, merge: B } = L;
      class R extends o {
        constructor() {
          super(...arguments), this.clearBounds = D.clearBounds;
        }
        searchPoint(x, T) {
          return this.searchKDTree({ plotX: x.chartX - this.chart.plotLeft, plotY: x.chartY - this.chart.plotTop }, T, x);
        }
        translate() {
          j.translate.call(this), this.getRadii(), this.translateBubble();
        }
        updateParallelArrays(x, T, y) {
          super.updateParallelArrays.call(this, x, T, y);
          let S = this.processedXData, u = this.xData;
          S && u && (S.length = u.length);
        }
      }
      return R.defaultOptions = B(o.defaultOptions, { lineWidth: 0, animationLimit: 500, joinBy: "hc-key", tooltip: { pointFormat: "{point.name}: {point.z}" } }), I(R.prototype, { type: "mapbubble", axisTypes: ["colorAxis"], getProjectedBounds: D.getProjectedBounds, isCartesian: !1, pointArrayMap: ["z"], pointClass: n, processData: D.processData, projectPoint: j.projectPoint, kdAxisArray: ["plotX", "plotY"], setData: D.setData, setOptions: D.setOptions, updateData: D.updateData, useMapGeometry: !0, xyFromShape: !0 }), l.registerSeriesType("mapbubble", R), R;
    }), i(e, "Series/Heatmap/HeatmapPoint.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function(o, n) {
      let { scatter: { prototype: { pointClass: l } } } = o.seriesTypes, { clamp: L, defined: D, extend: j, pick: I } = n;
      class B extends l {
        applyOptions(N, x) {
          return (this.isNull || this.value === null) && delete this.color, super.applyOptions(N, x), this.formatPrefix = this.isNull || this.value === null ? "null" : "point", this;
        }
        getCellAttributes() {
          let N = this.series, x = N.options, T = (x.colsize || 1) / 2, y = (x.rowsize || 1) / 2, S = N.xAxis, u = N.yAxis, A = this.options.marker || N.options.marker, M = N.pointPlacementToXValue(), f = I(this.pointPadding, x.pointPadding, 0), m = { x1: L(Math.round(S.len - S.translate(this.x - T, !1, !0, !1, !0, -M)), -S.len, 2 * S.len), x2: L(Math.round(S.len - S.translate(this.x + T, !1, !0, !1, !0, -M)), -S.len, 2 * S.len), y1: L(Math.round(u.translate(this.y - y, !1, !0, !1, !0)), -u.len, 2 * u.len), y2: L(Math.round(u.translate(this.y + y, !1, !0, !1, !0)), -u.len, 2 * u.len) };
          for (let C of [["width", "x"], ["height", "y"]]) {
            let F = C[0], _ = C[1], E = _ + "1", v = _ + "2", w = Math.abs(m[E] - m[v]), d = A && A.lineWidth || 0, r = Math.abs(m[E] + m[v]) / 2, s = A && A[F];
            if (D(s) && s < w) {
              let p = s / 2 + d / 2;
              m[E] = r - p, m[v] = r + p;
            }
            f && ((_ === "x" && S.reversed || _ === "y" && !u.reversed) && (E = v, v = _ + "1"), m[E] += f, m[v] -= f);
          }
          return m;
        }
        haloPath(N) {
          if (!N) return [];
          let { x = 0, y: T = 0, width: y = 0, height: S = 0 } = this.shapeArgs || {};
          return [["M", x - N, T - N], ["L", x - N, T + S + N], ["L", x + y + N, T + S + N], ["L", x + y + N, T - N], ["Z"]];
        }
        isValid() {
          return this.value !== 1 / 0 && this.value !== -1 / 0;
        }
      }
      return j(B.prototype, { dataLabelOnNull: !0, moveToTopOnHover: !0, ttBelow: !1 }), B;
    }), i(e, "Series/Heatmap/HeatmapSeriesDefaults.js", [e["Core/Utilities.js"]], function(o) {
      let { isNumber: n } = o;
      return { animation: !1, borderRadius: 0, borderWidth: 0, interpolation: !1, nullColor: "#f7f7f7", dataLabels: { formatter: function() {
        let { numberFormatter: l } = this.series.chart, { value: L } = this.point;
        return n(L) ? l(L, -1) : "";
      }, inside: !0, verticalAlign: "middle", crop: !1, overflow: "allow", padding: 0 }, marker: { symbol: "rect", radius: 0, lineColor: void 0, states: { hover: { lineWidthPlus: 0 }, select: {} } }, clip: !0, pointRange: null, tooltip: { pointFormat: "{point.x}, {point.y}: {point.value}<br/>" }, states: { hover: { halo: !1, brightness: 0.2 } }, legendSymbol: "rectangle" };
    }), i(e, "Series/InterpolationUtilities.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function(o, n) {
      let { doc: l } = o, { defined: L, pick: D } = n;
      return { colorFromPoint: function(j, I) {
        let B = I.series.colorAxis;
        if (B) {
          let R = B.toColor(j || 0, I).split(")")[0].split("(")[1].split(",").map((N) => D(parseFloat(N), parseInt(N, 10)));
          return R[3] = 255 * D(R[3], 1), L(j) && I.visible || (R[3] = 0), R;
        }
        return [0, 0, 0, 0];
      }, getContext: function(j) {
        let { canvas: I, context: B } = j;
        return I && B ? (B.clearRect(0, 0, I.width, I.height), B) : (j.canvas = l.createElement("canvas"), j.context = j.canvas.getContext("2d", { willReadFrequently: !0 }) || void 0, j.context);
      } };
    }), i(e, "Series/Heatmap/HeatmapSeries.js", [e["Core/Color/Color.js"], e["Series/ColorMapComposition.js"], e["Series/Heatmap/HeatmapPoint.js"], e["Series/Heatmap/HeatmapSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"], e["Series/InterpolationUtilities.js"]], function(o, n, l, L, D, j, I, B) {
      let { series: R, seriesTypes: { column: N, scatter: x } } = D, { prototype: { symbols: T } } = j, { addEvent: y, extend: S, fireEvent: u, isNumber: A, merge: M, pick: f } = I, { colorFromPoint: m, getContext: C } = B;
      class F extends x {
        constructor() {
          super(...arguments), this.valueMax = NaN, this.valueMin = NaN, this.isDirtyCanvas = !0;
        }
        drawPoints() {
          let E = this, v = E.options, w = v.interpolation, d = v.marker || {};
          if (w) {
            let { image: r, chart: s, xAxis: p, yAxis: b } = E, { reversed: c = !1, len: h } = p, { reversed: g = !1, len: k } = b, P = { width: h, height: k };
            if (!r || E.isDirtyData || E.isDirtyCanvas) {
              let O = C(E), { canvas: z, options: { colsize: W = 1, rowsize: G = 1 }, points: Y, points: { length: U } } = E, H = s.colorAxis && s.colorAxis[0];
              if (z && O && H) {
                let { min: q, max: X } = p.getExtremes(), { min: $, max: K } = b.getExtremes(), V = X - q, Q = K - $, Z = Math.round(V / W / 8 * 8), ee = Math.round(Q / G / 8 * 8), [J, ie] = [[Z, Z / V, c, "ceil"], [ee, ee / Q, !g, "floor"]].map(([se, te, ae, le]) => ae ? (de) => Math[le](se - te * de) : (de) => Math[le](te * de)), re = z.width = Z + 1, ce = re * (z.height = ee + 1), he = (U - 1) / ce, ne = new Uint8ClampedArray(4 * ce), oe = (se, te) => 4 * Math.ceil(re * ie(te - $) + J(se - q));
                E.buildKDTree();
                for (let se = 0; se < ce; se++) {
                  let te = Y[Math.ceil(he * se)], { x: ae, y: le } = te;
                  ne.set(m(te.value, te), oe(ae, le));
                }
                O.putImageData(new ImageData(ne, re), 0, 0), r ? r.attr({ ...P, href: z.toDataURL("image/png", 1) }) : (E.directTouch = !1, E.image = s.renderer.image(z.toDataURL("image/png", 1)).attr(P).add(E.group));
              }
              E.isDirtyCanvas = !1;
            } else (r.width !== h || r.height !== k) && r.attr(P);
          } else (d.enabled || E._hasPointMarkers) && (R.prototype.drawPoints.call(E), E.points.forEach((r) => {
            r.graphic && (r.graphic[E.chart.styledMode ? "css" : "animate"](E.colorAttribs(r)), r.value === null && r.graphic.addClass("highcharts-null-point"));
          }));
        }
        getExtremes() {
          let { dataMin: E, dataMax: v } = R.prototype.getExtremes.call(this, this.valueData);
          return A(E) && (this.valueMin = E), A(v) && (this.valueMax = v), R.prototype.getExtremes.call(this);
        }
        getValidPoints(E, v) {
          return R.prototype.getValidPoints.call(this, E, v, !0);
        }
        hasData() {
          return !!this.xData;
        }
        init() {
          super.init.apply(this, arguments);
          let E = this.options;
          E.pointRange = f(E.pointRange, E.colsize || 1), this.yAxis.axisPointRange = E.rowsize || 1, T.ellipse = T.circle, E.marker && A(E.borderRadius) && (E.marker.r = E.borderRadius);
        }
        markerAttribs(E, v) {
          let w = E.shapeArgs || {};
          if (E.hasImage) return { x: E.plotX, y: E.plotY };
          if (v && v !== "normal") {
            let d = E.options.marker || {}, r = this.options.marker || {}, s = r.states && r.states[v] || {}, p = d.states && d.states[v] || {}, b = (p.width || s.width || w.width || 0) + (p.widthPlus || s.widthPlus || 0), c = (p.height || s.height || w.height || 0) + (p.heightPlus || s.heightPlus || 0);
            return { x: (w.x || 0) + ((w.width || 0) - b) / 2, y: (w.y || 0) + ((w.height || 0) - c) / 2, width: b, height: c };
          }
          return w;
        }
        pointAttribs(E, v) {
          let w = R.prototype.pointAttribs.call(this, E, v), d = this.options || {}, r = this.chart.options.plotOptions || {}, s = r.series || {}, p = r.heatmap || {}, b = E && E.options.borderColor || d.borderColor || p.borderColor || s.borderColor, c = E && E.options.borderWidth || d.borderWidth || p.borderWidth || s.borderWidth || w["stroke-width"];
          if (w.stroke = E && E.marker && E.marker.lineColor || d.marker && d.marker.lineColor || b || this.color, w["stroke-width"] = c, v && v !== "normal") {
            let h = M(d.states && d.states[v], d.marker && d.marker.states && d.marker.states[v], E && E.options.states && E.options.states[v] || {});
            w.fill = h.color || o.parse(w.fill).brighten(h.brightness || 0).get(), w.stroke = h.lineColor || w.stroke;
          }
          return w;
        }
        translate() {
          let { borderRadius: E, marker: v } = this.options, w = v && v.symbol || "rect", d = T[w] ? w : "rect", r = ["circle", "square"].indexOf(d) !== -1;
          if (!this.processedXData) {
            let { xData: s, yData: p } = this.getProcessedData();
            this.processedXData = s, this.processedYData = p;
          }
          for (let s of (this.generatePoints(), this.points)) {
            let p = s.getCellAttributes(), b = Math.min(p.x1, p.x2), c = Math.min(p.y1, p.y2), h = Math.max(Math.abs(p.x2 - p.x1), 0), g = Math.max(Math.abs(p.y2 - p.y1), 0);
            if (s.hasImage = (s.marker && s.marker.symbol || w).indexOf("url") === 0, r) {
              let k = Math.abs(h - g);
              b = Math.min(p.x1, p.x2) + (h < g ? 0 : k / 2), c = Math.min(p.y1, p.y2) + (h < g ? k / 2 : 0), h = g = Math.min(h, g);
            }
            s.hasImage && (s.marker = { width: h, height: g }), s.plotX = s.clientX = (p.x1 + p.x2) / 2, s.plotY = (p.y1 + p.y2) / 2, s.shapeType = "path", s.shapeArgs = M(!0, { x: b, y: c, width: h, height: g }, { d: T[d](b, c, h, g, { r: A(E) ? E : 0 }) });
          }
          u(this, "afterTranslate");
        }
      }
      return F.defaultOptions = M(x.defaultOptions, L), y(F, "afterDataClassLegendClick", function() {
        this.isDirtyCanvas = !0, this.drawPoints();
      }), S(F.prototype, { axisTypes: n.seriesMembers.axisTypes, colorKey: n.seriesMembers.colorKey, directTouch: !0, getExtremesFromAll: !0, parallelArrays: n.seriesMembers.parallelArrays, pointArrayMap: ["y", "value"], pointClass: l, specialGroup: "group", trackerGroups: n.seriesMembers.trackerGroups, alignDataLabel: N.prototype.alignDataLabel, colorAttribs: n.seriesMembers.colorAttribs, getSymbol: R.prototype.getSymbol }), n.compose(F), D.registerSeriesType("heatmap", F), F;
    }), i(e, "masters/modules/map.src.js", [e["Core/Globals.js"], e["Maps/MapNavigation.js"], e["Series/ColorMapComposition.js"], e["Series/MapBubble/MapBubbleSeries.js"], e["Maps/GeoJSONComposition.js"], e["Core/Chart/MapChart.js"], e["Maps/MapView.js"], e["Maps/Projection.js"]], function(o, n, l, L, D, j, I, B) {
      return o.ColorMapComposition = l, o.MapChart = o.MapChart || j, o.MapNavigation = o.MapNavigation || n, o.MapView = o.MapView || I, o.Projection = o.Projection || B, o.mapChart = o.Map = o.MapChart.mapChart, o.maps = o.MapChart.maps, o.geojson = D.geojson, o.topo2geo = D.topo2geo, D.compose(o.Chart), L.compose(o.Axis, o.Chart, o.Legend), n.compose(j, o.Pointer, o.SVGRenderer), I.compose(j), o;
    });
  });
})(eA);
var oP = eA.exports;
const Gg = /* @__PURE__ */ ri(oP), _n = {
  beaconTagName: "beacon-map-chart",
  legendClass: "last-visible-legend-item",
  hoverClass: "chart-hovering"
}, iP = [
  "Feature",
  "FeatureCollection",
  "GeometryCollection",
  "LineString",
  "MultiLineString",
  "MultiPoint",
  "MultiPolygon",
  "Point",
  "Polygon"
], aP = ve`.chart{background-color:var(--beacon-system-color-background-1)}.highcharts-legend-item .highcharts-point,.highcharts-mapview-inset-border{display:none}.highcharts-data-label .beacon-data-label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);color:var(--beacon-system-color-text-standard);text-transform:uppercase}.highcharts-data-label .beacon-data-label:not(.null-label){color:var(--beacon-system-color-text-standard-inverse);text-shadow:-1px -1px 0 var(--beacon-system-color-text-standard),1px -1px 0 var(--beacon-system-color-text-standard),-1px 1px 0 var(--beacon-system-color-text-standard),1px 1px 0 var(--beacon-system-color-text-standard)}.highcharts-breadcrumbs-button text{fill:var(--beacon-system-color-text-standard)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item .beacon-legend-item.last-visible-legend-item,.static-legend[legend-layout*=vertical] .highcharts-legend-item .beacon-legend-item.last-visible-legend-item{border-inline-end:0}.base{--chart-base-background-color: var(--beacon-system-color-background-1);--chart-base-block-size: calc(var(--beacon-reference-space-5) * 18.75);--chart-base-display: grid;--chart-base-place-items: center;background-color:var(--chart-base-background-color);block-size:var(--chart-base-block-size);display:var(--chart-base-display);place-items:var(--chart-base-place-items)}.base .header,.base .chart{display:var(--chart-display, none)}.mobile-message,.mobile-message *{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);max-inline-size:27ch}.highcharts-map-series .highcharts-point{stroke:var(--beacon-component-data-viz-color-border-major)}.highcharts-point-hover:has(~.highcharts-focus-border){stroke:var(--beacon-system-color-border-focus-outer)}.highcharts-focus-border{display:none}.highcharts-null-point{fill:var(--beacon-system-color-background-0)!important}:host(.chart-hovering) .highcharts-point:not(.highcharts-point-hover,.highcharts-null-point){fill-opacity:.2}@-moz-document url-prefix(){.highcharts-point-hover{stroke-width:unset}}@media (width >= 640px){.mobile-message{display:none}.base{--chart-base-block-size: unset;--chart-base-display: unset;--chart-base-place-items: initial;--chart-display: flex}}`;
var nP = Object.defineProperty, rP = Object.getOwnPropertyDescriptor, mo = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? rP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && nP(t, e, o), o;
};
function Qd(a) {
  return sP(a) ? vt.geojson(a) : a;
}
function sP(a) {
  var t;
  return iP.includes((t = a.type) != null ? t : "");
}
var Ns, at, zh, tA, Jr, Ih, ao, ir, Fs, js, _s, Us, oA, iA, aA, wr, nA, rA, Bh, sA;
const so = (ao = class extends tt {
  constructor() {
    super(...arguments);
    Ie(this, at);
    Ie(this, Ns);
    Ie(this, Fs);
    Ie(this, js);
    Ie(this, _s);
    Ie(this, Us);
    this.beaconTagName = _n.beaconTagName, this.mapHref = void 0, this.customMap = void 0, this.filteredCountries = void 0, this.drilldown = void 0, Be(this, Ns, {
      duration: 500,
      easing: "easeInOutQuad"
    }), this.staticLegend = !0, this._internalMapJSON = void 0, Be(this, Fs, () => {
      vt.wrap(
        vt.Chart.prototype,
        "drillUp",
        function(e) {
          var L;
          const i = (L = this.mapView) == null ? void 0 : L.minZoom, o = 500, n = new Promise((D) => {
            var R;
            const I = this.mapView.getProjectedBounds();
            this.mapView.minZoom = Math.abs(i) * -1.2;
            const B = {
              x1: I.x1 * (1 - 0.2),
              x2: I.x2 * (1 + 0.2),
              y1: I.y1 * (1 - 0.2),
              y2: I.y2 * (1 + 0.2)
            };
            (R = this.mapView) == null || R.fitToBounds(B, 0, !0, {
              duration: o,
              easing: "linear",
              complete: () => {
                D(!0);
              }
            });
          }), l = new Promise((D) => {
            this.series && this.series.forEach((j) => {
              j.group && j.group.animate(
                { opacity: 0 },
                { duration: 500 },
                () => D(!0)
              );
            });
          });
          Promise.all([n, l]).then(() => {
            e.call(this), this.mapView.minZoom = i;
          });
        }
      );
    }), Be(this, js, () => {
      vt.wrap(
        vt.Legend.prototype,
        "getAllItems",
        function(e) {
          const i = new Map(
            e.call(this).filter(
              (o) => o.name && o.value
            ).map((o) => [o.name, o])
          );
          return Array.from(i.values());
        }
      );
    }), Be(this, _s, () => {
      this.classList.add(_n.hoverClass);
    }), Be(this, Us, () => {
      this.classList.remove(_n.hoverClass);
    }), this._type = $t.MAP;
  }
  static get styles() {
    return [super.styles, aP];
  }
  initializeHighcharts(e) {
    super.initializeHighcharts(e), Kg(vt), Gg(vt), Te(this, Fs).call(this), Te(this, js).call(this);
  }
  get userSeriesDataPoints() {
    var e;
    return (e = this.series[0]) == null ? void 0 : e.data;
  }
  get filteredPoints() {
    var e;
    return (e = this.userSeriesDataPoints) == null ? void 0 : e.filter(
      (i) => {
        var o, n;
        return Array.isArray(i) ? (o = this.filteredCountries) == null ? void 0 : o.includes(i[0]) : (n = this.filteredCountries) == null ? void 0 : n.includes(i["hc-key"]);
      }
    );
  }
  static labelDataFormatter() {
    return this.point.value ? `<span class="beacon-data-label">${this.point.name}</span>` : `<span class="beacon-data-label null-label">${this.point.name}</span>`;
  }
  _updateChartWithFilteredCountries() {
    var e;
    (e = this.chart) == null || e.update({
      series: [
        {
          type: "map",
          data: this.filteredPoints
        }
      ]
    });
  }
  _updateChartWithProcessedMap() {
    var e;
    (e = this.chart) == null || e.update({
      chart: {
        map: Te(this, at, Jr)
      },
      series: [
        {
          mapData: Te(this, at, Jr),
          type: "map"
        }
      ]
    });
  }
  _updateMapZoomOnClick() {
    var i;
    const e = this;
    (i = this.chart) == null || i.update(
      {
        plotOptions: {
          series: {
            point: {
              events: {
                click: (o) => {
                  var n;
                  e.zoomOnClick && !Object.hasOwn(o.point, "drilldown") && Te(n = ao, ir).call(n, o.point);
                }
              }
            }
          }
        }
      },
      !0
    );
  }
  _updateDataLabels() {
    var i;
    const e = this.showDataLabels;
    (i = this.chart) == null || i.update(
      {
        plotOptions: {
          map: {
            dataLabels: {
              enabled: e
            }
          }
        }
      },
      !0
    );
  }
  async _loadUserInputMap() {
    if (this.mapHref) {
      await this._processMapHref(), Ue(this, at, Bh).call(this);
      return;
    }
    if (this.customMap) {
      await Promise.resolve(), Ue(this, at, sA).call(this), Ue(this, at, Bh).call(this);
      return;
    }
  }
  async _processMapHref() {
    const e = await fetch(this.mapHref).then(
      (o) => o.json()
    ), i = Qd(e);
    i && Be(this, at, i, Ih);
  }
  createChart() {
    const e = tt.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return Kg(vt), Gg(vt), vt.mapChart(this.chartContainer, e);
  }
  get localComponentOptions() {
    const e = this;
    return tt.createChartOptions(super.localComponentOptions, {
      chart: {
        map: Te(this, at, Jr),
        panning: {
          enabled: !0,
          type: "xy"
        },
        events: {
          drilldown: function(i) {
            var o, n;
            Te(o = ao, ir).call(o, i.point, {
              duration: 500,
              easing: "easeOut"
            }), Ue(n = ao, wr, nA).call(n, i);
          },
          drillup: Ue(ao, wr, rA),
          render: function() {
            var i;
            Ue(i = e, at, aA).call(i);
          }
        }
      },
      mapNavigation: {
        enabled: !0
      },
      mapView: {
        maxZoom: 8
      },
      tooltip: {
        pointFormatter: function() {
          var i;
          return tt.tooltipPointHTML(
            this,
            this.name,
            (i = this.value) != null ? i : "unknown"
          );
        },
        followPointer: !0
      },
      legend: {
        enabled: !0,
        labelFormatter: function() {
          return this.value ? tt.legendItemHTML(
            this,
            e.hideLegendMetric,
            e.percentage,
            e.type,
            e.decimal,
            1
          ) : "";
        }
      },
      plotOptions: {
        map: {
          dataLabels: {
            enabled: e.showDataLabels,
            formatter: ao.labelDataFormatter,
            useHTML: !0
          },
          colorByPoint: !0,
          colorAxis: !1
        },
        series: {
          legendType: "point",
          point: {
            events: {
              click: (i) => {
                var o;
                e.zoomOnClick && !Object.hasOwn(i.point, "drilldown") && Te(o = ao, ir).call(o, i.point);
              },
              mouseOver: Te(e, _s),
              mouseOut: Te(e, Us)
            }
          }
        }
      },
      drilldown: {
        ...Te(this, at, tA),
        mapZooming: !1,
        animation: Te(e, Ns)
      }
    });
  }
  /**
   * Message displayed on mobile breakpoints,
   * defaults to "Map Highcharts.Chartis Unavailable on small Breakpoint"
   */
  renderMobileMessage() {
    return pe`<div class="mobile-message">
      <slot name="mobile-message"
        ><h2>
          This chart cannot be displayed on a small screen, try a larger device.
        </h2></slot
      >
    </div>`;
  }
  renderHeader() {
    return pe`<div class="header">
        <div class="header-text">
          ${this.renderTitle()} ${this.renderSubTitle()}
        </div>
        <div class="menu"></div>
      </div>
      ${this.renderMobileMessage()}`;
  }
}, Ns = new WeakMap(), at = new WeakSet(), zh = function() {
  if (this.legendItems)
    return this.legendItems[this.legendItems.length - 1];
}, tA = function() {
  if (this.drilldown)
    return typeof this.drilldown == "string" ? JSON.parse(this.drilldown) : this.drilldown;
}, Jr = function() {
  return this._internalMapJSON;
}, Ih = function(e) {
  const i = Qd(e);
  this._internalMapJSON = i;
}, ir = new WeakMap(), Fs = new WeakMap(), js = new WeakMap(), _s = new WeakMap(), Us = new WeakMap(), oA = function(e) {
  e == null || e.classList.add(_n.legendClass);
}, iA = function(e) {
  e == null || e.forEach((i) => i.classList.remove(_n.legendClass));
}, aA = function() {
  const e = this.legendItems;
  e && Te(this, at, zh) && (Ue(this, at, iA).call(this, e), Ue(this, at, oA).call(this, Te(this, at, zh)));
}, wr = new WeakSet(), nA = function(e) {
  var n, l;
  const i = e.point.series.chart, o = (l = (n = i.options.drilldown) == null ? void 0 : n.series) == null ? void 0 : l.find(
    (L) => L.id === e.point.drilldown
  );
  o && i.addSeriesAsDrilldown(e.point, o);
}, rA = function(e) {
  e.target.zoomOut();
}, Bh = function() {
  this.chart && (Te(this, at, Jr) && this._updateChartWithProcessedMap(), this.filteredCountries && this._updateChartWithFilteredCountries());
}, sA = function() {
  const e = JSON.parse(this.customMap), i = Qd(e);
  i && Be(this, at, i, Ih);
}, Ie(ao, wr), ao.tagName = _n.beaconTagName, Ie(ao, ir, (e, i = {
  duration: 500,
  easing: "easeOut"
}) => {
  var n;
  const o = e.series.chart;
  (n = o == null ? void 0 : o.mapView) == null || n.fitToBounds(e.bounds, 0, !0, i);
}), ao);
mo([
  ue({ attribute: "map-href" })
], so.prototype, "mapHref", 2);
mo([
  ue({ attribute: "custom-map" })
], so.prototype, "customMap", 2);
mo([
  ue({
    attribute: "filtered-countries",
    converter: (a) => Mf(a, ",")
  })
], so.prototype, "filteredCountries", 2);
mo([
  ue({ attribute: "zoom-on-click", type: Boolean })
], so.prototype, "zoomOnClick", 2);
mo([
  ue({ attribute: "show-data-labels", type: Boolean })
], so.prototype, "showDataLabels", 2);
mo([
  ue()
], so.prototype, "drilldown", 2);
mo([
  Ce()
], so.prototype, "_internalMapJSON", 2);
mo([
  Cr(".beacon-legend-item")
], so.prototype, "legendItems", 2);
mo([
  Gt(["series", "filteredCountries"])
], so.prototype, "_updateChartWithFilteredCountries", 1);
mo([
  Gt("internalMap")
], so.prototype, "_updateChartWithProcessedMap", 1);
mo([
  Gt("zoomOnClick")
], so.prototype, "_updateMapZoomOnClick", 1);
mo([
  Gt("showDataLabels")
], so.prototype, "_updateDataLabels", 1);
mo([
  qe
], so.prototype, "_loadUserInputMap", 1);
let tz = so;
var lA = /* @__PURE__ */ ((a) => (a.NORMAL = "normal", a.PERCENT = "percent", a))(lA || {});
const Wg = {
  beaconTagName: "beacon-meter-chart"
}, Gr = {
  mini: 20,
  normal: 24,
  jumbo: 28
}, to = {
  SPACING_TOP: 40,
  TOOLTIP_OFFSET: {
    X: 8,
    Y: 65
  },
  Y_AXIS: {
    MIN: 0,
    MAX: 100,
    TICK_AMOUNT: 2,
    LABEL_Y_OFFSET: -37
  },
  CHART_BORDER: 16,
  BAR: {
    BORDER_RADIUS: 0
  },
  LEGEND: {
    X: -6
  },
  NAVIGATION: {
    BUTTON_Y: -80
  }
}, lP = ve`.highcharts-legend .highcharts-legend-item .highcharts-point{display:none}.highcharts-axis-labels span .label{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-axis-labels span:last-child .label{font-weight:var(--beacon-system-font-weight-light)}.caption{margin-block-start:0}.header{margin-block-end:0}.highcharts-plot-border{fill:var(--beacon-system-color-background-1);stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-series-group .highcharts-column-series .highcharts-point,.highcharts-series-group .highcharts-bar-series .highcharts-point{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-plot-line,.highcharts-grid-line,.highcharts-plot-band,.highcharts-markers,.highcharts-axis,.highcharts-grid,.highcharts-pane-group,.highcharts-plot-background,.highcharts-background{display:none!important}.highcharts-root,.highcharts-container,.chart{overflow:visible!important}`;
var cP = Object.defineProperty, Sn = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && cP(t, e, o), o;
};
const ap = class ap extends Ge(tt).with(
  Qs,
  Zs,
  xn
) {
  constructor() {
    super(), this.beaconTagName = Wg.beaconTagName, this.tooltipPositioner = (t, e, i) => {
      let o = i.plotX - t / 2 + to.TOOLTIP_OFFSET.X, n = i.plotY + to.TOOLTIP_OFFSET.Y;
      const l = window.innerWidth, L = window.innerHeight;
      return o = Math.max(0, Math.min(o, l - t)), n = Math.max(0, Math.min(n, L - e)), { x: o, y: n };
    }, this.variant = as.HORIZONTAL, this.scale = ln.NORMAL, this.stacking = lA.PERCENT, this.percentage = !1, this.label1 = "Label 1", this.label2 = "Label 2", this.decimal = !1, this.resizeObserver = new ResizeObserver(
      jo(() => {
        this.chart && this.updateChartHeight();
      }, 200)
    );
  }
  static get styles() {
    return [super.styles, lP, this.chartAreaStyles, this.navigatorStyles];
  }
  get type() {
    return $t.BAR;
  }
  // Local component options for the chart
  get localComponentOptions() {
    const t = this;
    return tt.createChartOptions(
      super.localComponentOptions,
      {
        chart: {
          type: "bar",
          spacingTop: to.SPACING_TOP,
          spacingLeft: to.CHART_BORDER,
          spacingRight: to.CHART_BORDER,
          events: {
            render: function() {
              const i = this;
              i.series.forEach((L) => {
                L.points.forEach(
                  (D) => {
                    var j;
                    D.tooltipPos && (D.tooltipPos[0] -= ((j = D.shapeArgs) == null ? void 0 : j.height) / 2);
                  }
                );
              });
              const n = i.container.querySelector(
                ".highcharts-series-group"
              ), l = i.container.querySelector(
                ".highcharts-plot-border"
              );
              if (n && l && n.getBBox().width > 0) {
                const L = n.getBBox();
                l.setAttribute(
                  "height",
                  Gr[t.scale].toString()
                ), l.setAttribute(
                  "x",
                  to.CHART_BORDER.toString()
                ), l.setAttribute(
                  "y",
                  L.y.toString()
                );
              }
            },
            load: function() {
              const i = this;
              t.resizeObserver.observe(i.container), t.updateChartHeight(), vt.addEvent(i, "destroy", function() {
                t.resizeObserver.unobserve(i.container);
              });
            }
          }
        },
        xAxis: {
          visible: !1
        },
        yAxis: {
          min: to.Y_AXIS.MIN,
          max: to.Y_AXIS.MAX,
          tickAmount: to.Y_AXIS.TICK_AMOUNT,
          labels: {
            useHTML: !0,
            y: to.Y_AXIS.LABEL_Y_OFFSET,
            formatter: function() {
              var n;
              const i = [t.label1, t.label2];
              return `<span class="label">${(n = this.axis) != null && n.tickPositions && i[this.axis.tickPositions.indexOf(Number(this.value))] || ""}</span>`;
            }
          },
          reversedStacks: !1
        },
        tooltip: {
          positioner: this.tooltipPositioner,
          useHTML: !0,
          pointFormatter() {
            var n, l;
            const i = this, o = t.decimal ? (n = i.y) == null ? void 0 : n.toFixed(1) : (l = i.y) == null ? void 0 : l.toFixed(0);
            return tt.tooltipPointHTML(
              this,
              this.series.name,
              o + (t.percentage ? "%" : "")
            );
          }
        },
        plotOptions: {
          bar: {
            borderRadius: to.BAR.BORDER_RADIUS,
            pointWidth: this.getSeriesHeight()
          },
          series: {
            stacking: this.stacking
          }
        },
        legend: {
          x: to.LEGEND.X
        },
        navigation: {
          buttonOptions: {
            enabled: !0,
            y: to.NAVIGATION.BUTTON_Y
          }
        }
      }
    );
  }
  // Update chart options based on property changes
  willUpdate(t) {
    var e, i, o, n, l;
    (e = super.willUpdate) == null || e.call(this, t), t.has("stacking") && this.updateChart({
      plotOptions: { series: { stacking: this.stacking } }
    }), t.has("scale") && (this.updateChart({
      plotOptions: { bar: { pointWidth: this.getSeriesHeight() } }
    }), this.updateChartHeight()), t.has("chart") && this.setLoadedChartOptions(), t.has("percentage") && this.updateChart({
      tooltip: {
        pointFormatter: (i = this.localComponentOptions.tooltip) == null ? void 0 : i.pointFormatter
      }
    }), (t.has("label1") || t.has("label2")) && this.updateChart({
      yAxis: {
        labels: {
          formatter: (n = (o = this.localComponentOptions.yAxis) == null ? void 0 : o.labels) == null ? void 0 : n.formatter
        }
      }
    }), t.has("decimal") && this.updateChart({
      tooltip: {
        pointFormatter: (l = this.localComponentOptions.tooltip) == null ? void 0 : l.pointFormatter
      }
    });
  }
  // Sets the loaded chart options
  setLoadedChartOptions() {
    this.updateChart({ plotOptions: { series: { stacking: this.stacking } } });
  }
  // Gets the series height based on scale
  getSeriesHeight() {
    return Gr[this.scale];
  }
  // Update chart height based on the current scale
  updateChartHeight() {
    if (this.chart) {
      this.chart.update({
        chart: {
          height: Gr[this.scale] + (this.chart.chartHeight - this.chart.plotHeight)
        }
      });
      const t = this.chart.container.querySelector(
        ".highcharts-series-group"
      ), e = this.chart.container.querySelector(
        ".highcharts-plot-border"
      );
      if (t && e && t.getBBox().width > 0) {
        const i = t.getBBox();
        e.setAttribute(
          "height",
          Gr[this.scale].toString()
        ), e.setAttribute(
          "x",
          to.CHART_BORDER.toString()
        ), e.setAttribute(
          "y",
          i.y.toString()
        ), t.setAttribute(
          "height",
          Gr[this.scale].toString()
        ), t.setAttribute(
          "y",
          i.y.toString()
        );
      }
    }
  }
};
ap.tagName = Wg.beaconTagName;
let zi = ap;
Sn([
  ue()
], zi.prototype, "variant");
Sn([
  ue({ type: String, reflect: !0 })
], zi.prototype, "scale");
Sn([
  ue({ type: String, reflect: !0 })
], zi.prototype, "stacking");
Sn([
  ue({ type: Boolean, reflect: !0 })
], zi.prototype, "percentage");
Sn([
  ue({ type: String })
], zi.prototype, "label1");
Sn([
  ue({ type: String })
], zi.prototype, "label2");
Sn([
  ue({ type: Boolean })
], zi.prototype, "decimal");
const Vg = {
  beaconTagName: "beacon-modal"
}, dP = ve`[beacon-tag-name=beacon-modal] :where([slot=logo] :where(img,svg)){block-size:inherit;inline-size:inherit}`, hP = ve`:host{--header-justification: space-between;--modal-max-block-size: calc(100dvh - 2 * var(--beacon-system-space-gutter))}dialog{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: none;border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-system-color-shadow-high);max-block-size:var(--modal-max-block-size);overflow:hidden}@media (width >= 640px){dialog{--default-width: 100%}}.logo-slot{line-height:0}.persist .header{padding:0}.persist .logo-slot{padding:var(--beacon-system-space-cell-contained)}.normal{inset-block-end:var(--beacon-system-space-gutter);inset-block-start:initial}@media (width >= 640px){.normal{--max-width: 23.625rem;--min-width: 17.625rem;top:0;right:0;bottom:0;left:0}}@media (width >= 960px){.normal{--max-width: 45.5rem;--min-width: 26.5rem}}:is(.jumbo,.maxi){--max-width: 100%;--min-width: 100%;top:0;right:0;bottom:0;left:0}@media (width < 640px){:is(.jumbo,.maxi){block-size:100dvh;margin-block:0;max-block-size:none}:is(.jumbo,.maxi) .wrapper{block-size:100dvh;max-block-size:100dvh}}@media (width >= 640px){.jumbo{--max-width: 36rem;--min-width: none}}@media (width >= 960px){.jumbo{--max-width: 44rem}}@media (width >= 1280px){.jumbo{--max-width: 57rem}}@media (width >= 640px){.maxi{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: calc(100% - 2 * var(--beacon-system-space-gutter))}}.wrapper{max-block-size:var(--modal-max-block-size)}@media (width >= 1216px){.wrapper.maxi{grid-template-areas:"panel header" "panel content" "panel footer";grid-template-columns:4fr 8fr}.wrapper.maxi .body{display:contents}.wrapper.maxi .header{grid-area:header}.wrapper.maxi .panel{grid-area:panel}.wrapper.maxi .content{grid-area:content}.wrapper.maxi .footer{grid-area:footer}.wrapper.maxi .content,.wrapper.maxi .panel{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}}.content{padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-jumbo)}.panel{background-color:var(--beacon-system-color-background-2);padding:var(--beacon-system-space-organism-jumbo)}.close-button{margin-inline-start:auto}::slotted([slot=logo]){block-size:100%;inline-size:100%;max-block-size:var(--beacon-reference-space-10);max-inline-size:var(--beacon-reference-space-10)}`;
var bP = Object.defineProperty, pP = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && bP(t, e, o), o;
};
const np = class np extends Ht {
  constructor() {
    super(...arguments), this.beaconTagName = Vg.beaconTagName, this.scale = "normal";
  }
  static get styles() {
    return [super.styles, hP];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, dP];
  }
  /**
   * @todo 4.0.0 Rename to something other than `additional-content`
   */
  renderSidePanel() {
    return this.scale !== "maxi" ? pe`` : pe`
      <div class="panel" tabindex=${Ja()}>
        <slot
          name="additional-content"
          ${_e({ useParent: !0 })}></slot>
      </div>
    `;
  }
  render() {
    const t = {
      persist: this.persist
    };
    return t[this.scale] = !0, pe`
      ${this.anyComputedZIndex && this.open ? pe`<div class="non-modal-dialog-background-wrapper"></div>` : ""}
      <dialog
        @click=${this.handleDialogClick}
        class="${Pe(t)}">
        <div class="block-size-wrapper">
          <div class="wrapper ${this.scale}">
            <div class="header">
              <div class="logo-slot">
                <slot
                  name="logo"
                  aria-hidden="true"
                  ${_e({ useParent: !0 })}></slot>
              </div>
              ${this.renderCloseButton()}
            </div>
            <div class="body" tabindex=${Ja()}>
              <div class="content" tabindex=${Ja()}>
                <slot ${_e({ container: ".body" })}></slot>
              </div>
              ${this.renderSidePanel()}
            </div>
            <div class="footer">
              <div class="action-zone">
                <slot
                  name="action-zone"
                  ${_e({ container: ".footer" })}></slot>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
np.tagName = Vg.beaconTagName;
let tc = np;
pP([
  ue()
], tc.prototype, "scale");
const Rh = {
  beaconTagName: "beacon-multi-select-optgroup"
}, uP = ve`:host([beacon-tag-name=beacon-multi-select-optgroup]:not([is-visible])){display:none}.hidden{display:none}.title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200);padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.has-count::part(label){inline-size:100%}.has-count .option-label{display:flex;justify-content:space-between}.has-count .option-label .label{flex:1 1 auto}.has-count .option-label .count{align-self:center;flex:0 0 auto;font-size:var(--beacon-reference-font-scale-2);margin-inline-start:auto;padding-inline-start:var(--beacon-reference-space-4)}.option{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-4)}.option:hover{background-color:var(--beacon-reference-color-background-secondary-hover)}.option:active{background-color:var(--beacon-reference-color-background-secondary-pressed)}[beacon-tag-name=beacon-control]{padding-block:0}[beacon-tag-name=beacon-control] [slot=label]{display:block flex;inline-size:100%;padding-block:calc(var(--beacon-reference-space-4))}[beacon-tag-name=beacon-control] [slot=label] .label{inline-size:100%}[beacon-tag-name=beacon-control]::part(label){inline-size:100%}`;
var gP = Object.defineProperty, mP = Object.getOwnPropertyDescriptor, En = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? mP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && gP(t, e, o), o;
}, $s, Li;
const Ma = (Li = class extends Le {
  constructor() {
    super(...arguments);
    Ie(this, $s);
    this.beaconTagName = Rh.beaconTagName, this.focusOverride = !0, this.resetSpacing = !0, this.optionsList = [], this.value = /* @__PURE__ */ new Map(), this.isVisible = !0;
  }
  static get styles() {
    return [super.styles, uP];
  }
  get titleElement() {
    return Te(this, $s);
  }
  set titleElement(e) {
    Be(this, $s, e);
  }
  /**
   * Handles the selection of an option.
   */
  handleOptionSelection(e) {
    const i = e.target;
    i instanceof HTMLInputElement ? this.updateValue(i) : i instanceof HTMLElement && i.closest(this.getScopedTagName("beacon-control")) && Li.toggleCheckbox(i);
  }
  /**
   * Updates the value map based on the target input element.
   */
  updateValue(e) {
    const {
      checked: i,
      dataset: { value: o, count: n }
    } = e, l = new Map(this.value);
    i ? l.set(o, n) : l.delete(o), this.value = l, Fe(e, Ee.TOGGLE, {
      detail: {
        option: e,
        value: e.dataset.value,
        count: e.dataset.count,
        checked: e.checked
      }
    });
  }
  /**
   * Toggles the checkbox state of the target element.
   */
  static toggleCheckbox(e) {
    const i = e.querySelector(
      'input[type="checkbox"]'
    );
    i && (i.checked = !i.checked, i.dispatchEvent(new Event("input", { bubbles: !0 })), i.focus());
  }
  /**
   * When content changes in the default slot where options are slotted triggers fresh
   * render of the options.
   */
  handleOptionsUpdates() {
    this.optionsList = this.options;
    const e = this.options.filter(
      (i) => i.selected && i.label
    );
    e.length && this.setDefaultSelectedOptions(e);
  }
  handleTitleSlotchange() {
    this.titleElement = this.titleElements[0];
  }
  /**
   * Renders the list of options.
   */
  renderOptionsList() {
    return pe`
      ${hv(
      // safer version of map when working with keyed data items: https://lit.dev/docs/templates/directives/#repeat
      this.optionsList,
      (e) => e.controlId,
      // unique identifier of the option
      (e, i) => {
        const o = { "has-count": e.count, option: !0 };
        return ze`
          <${this.getScopedTag("beacon-control")} inline class="${Pe(o)}" id="${e.controlId}">
            <label slot="label" for="value-${i}" class="option-label">
              <span class="label">${e.label}</span>
              ${e.count ? pe`<span class="count">${e.count}</span>` : ""}
            </label>
            <input
              type="checkbox"
              name="selection"
              id="value-${i}"
              ?checked=${e.selected}
              data-value="${e.label}"
              data-count="${e.count}"
              @input=${this.handleOptionSelection}
            />
          </${this.getScopedTag("beacon-control")}>
        `;
      }
    )}
    `;
  }
  /**
   * Sets the initial selected values from the options.
   */
  setDefaultSelectedOptions(e) {
    const i = new Map(this.value);
    e.forEach((o) => {
      i.set(o.label, o.count);
    }), this.value = i, Fe(this, Ee.CHANGE);
  }
  initializeOptionsList() {
    this.handleOptionsUpdates();
  }
  /**
   * Keeps beacon-controls rendered in MSOG in sync with MSO's if any are removed from the DOM.
   */
  handleOptionRemoval() {
    const e = this.options.map(({ controlId: i }) => i);
    this.beaconControls.forEach((i) => {
      if (!e.includes(i.id)) {
        const o = i.querySelector("input");
        o && o.checked && (o.checked = !1, this.updateValue(o)), i.remove();
      }
    }), this.beaconControls.length && this.beaconControls[0].renderLightDOMStyles();
  }
  /**
   * Renders the component template.
   */
  render() {
    return pe`
      <slot
        style="display: none;"
        @slotchange=${this.handleOptionRemoval}
        @beacon-event-change=${this.handleOptionsUpdates}></slot>
      <div class="base">
        <div class="title">
          <slot
            name="title"
            @slotchange=${this.handleTitleSlotchange}
            ${_e({ useParent: !0 })}></slot>
        </div>
        ${this.renderOptionsList()}
      </div>
    `;
  }
}, $s = new WeakMap(), Li.tagName = Rh.beaconTagName, Li.nestedComponents = [Uc], Li.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, Li);
En([
  Ce()
], Ma.prototype, "optionsList", 2);
En([
  Ce()
], Ma.prototype, "value", 2);
En([
  ue({ reflect: !0, attribute: "is-visible", type: Boolean })
], Ma.prototype, "isVisible", 2);
En([
  De({ selector: "beacon-multi-select-option" }, !0)
], Ma.prototype, "options", 2);
En([
  Ct({ flatten: !0, slot: "title" })
], Ma.prototype, "titleElements", 2);
En([
  Cr('[beacon-tag-name="beacon-control"]')
], Ma.prototype, "beaconControls", 2);
En([
  Re
], Ma.prototype, "initializeOptionsList", 1);
let fP = Ma;
const qg = {
  beaconTagName: "beacon-multi-select"
}, vP = ve`::placeholder{color:var(--beacon-system-color-text-standard)}:host{--override-control-checkbox-radio-align-self: center;position:relative}.options{--beacon-multi-select-options-menu-z-index: 999;background-color:var(--beacon-system-color-background-1);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-block-start:0;border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard);inline-size:100%;max-block-size:368px;overflow:hidden;position:absolute;z-index:var(--beacon-multi-select-options-menu-z-index)}.options .beacon-multi-select-content{max-block-size:368px;overflow-y:auto;padding-block:var(--beacon-reference-space-3);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.options:not(.visible){display:none}.icon{--icon-color: var(--beacon-system-color-icon-link);color:var(--icon-color);display:flex;place-items:center}.no-results-message{font-weight:var(--beacon-system-font-weight-bold);padding-block:0 var(--beacon-reference-space-6);padding-inline:var(--beacon-reference-space-4)}.toggle-select{background:none;border-style:none;color:inherit;cursor:pointer;font:inherit;margin:0;padding-inline:var(--beacon-reference-space-4)}.toggle-select:focus{outline:none}[beacon-tag-name=beacon-input-chip]{--beacon-multi-select-filter-chip-max-width: 14ch}[beacon-tag-name=beacon-input-chip] .chip-label{color:var(--beacon-system-color-text-standard);cursor:default;display:inline-block;font-weight:var(--beacon-system-font-weight-bold);max-inline-size:var(--beacon-multi-select-filter-chip-max-width);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.hidden{display:none}.option{align-items:center;display:flex;justify-content:space-between;padding-inline:var(--beacon-reference-space-4)}.option:hover{background-color:var(--beacon-system-color-background-secondary-hover)}.option:active{background-color:var(--beacon-system-color-background-secondary-pressed)}@supports not ((scrollbar-color) and (scrollbar-width)){.options .beacon-multi-select-content::-webkit-scrollbar{background-color:var(--beacon-component-scrollbar-color-background-track);inline-size:var(--beacon-reference-space-5)}.options .beacon-multi-select-content::-webkit-scrollbar-track{background-color:var(--beacon-component-scrollbar-color-background-track)}.options .beacon-multi-select-content::-webkit-scrollbar-thumb{background-clip:content-box;background-color:var(--beacon-component-scrollbar-color-background-thumb);border:var(--beacon-reference-space-2) solid transparent;border-radius:var(--beacon-reference-space-4)}}.search.searching::part(field){--beacon-multi-select-search-bar-searching-z-index: 1;border-end-end-radius:0;border-end-start-radius:0;position:relative;z-index:var(--beacon-multi-select-search-bar-searching-z-index)}.search.searching .icon{transform:rotate(180deg)}.search.disabled .icon{--icon-color: var(--beacon-system-color-icon-primary-inactive)}.search.disabled ::placeholder{color:var(--beacon-system-color-text-inactive)}`;
var AP = Object.defineProperty, yP = Object.getOwnPropertyDescriptor, lo = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? yP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && AP(t, e, o), o;
}, qa, Bo;
const eo = (Bo = class extends Ge(Le).with(
  ub
) {
  constructor() {
    super(...arguments);
    Ie(this, qa);
    this.focusOverride = !0, this.resetSpacing = !0, this.beaconTagName = qg.beaconTagName, this.disabled = !1, this.placeholder = "Select", this.openPlaceholder = "Search", this.searching = !1, Be(this, qa, ""), this.value = /* @__PURE__ */ new Map(), this.hasSearchResults = !0, this.selectedValues = [], this.documentClickHandler = (e) => {
      e.composedPath().some((n) => n instanceof HTMLElement ? n.getAttribute("beacon-tag-name") === Rh.beaconTagName || n.classList.contains("toggle-select") || n.classList.contains("beacon-multi-select-content") : !1) || this.closeDialog();
    }, this.handleKeydown = (e) => {
      const { key: i } = e;
      i === "Escape" && (this.searchValue === "" ? this.closeDialog() : (this.searchValue = "", this.combobox.value = "", this.combobox.focus())), i === "Backspace" && this.searchValue.length === 0 && this.reset(), i === "Enter" && this.openDialog(), i === "Tab" && this.closeDialog(), super.handleKeydown(e);
    }, this.handleArrowKeydown = (e) => {
      if (e.isTrusted && e instanceof KeyboardEvent) {
        const { key: i } = e;
        if ((i === "Enter" || i === " ") && e.currentTarget && e.currentTarget.getAttribute("type") === "checkbox" && (e.currentTarget.click(), e.stopPropagation(), e.preventDefault()), this.handleArrowControlKeydown(
          e,
          this.getArrowControlElements(),
          "vertical",
          Bo.arrowControlFocusCallback
        ))
          return e.preventDefault(), e.stopPropagation(), !1;
      }
    };
  }
  static get styles() {
    return [super.styles, vP];
  }
  get dynamicPlaceholder() {
    let e = "";
    return this.value.size === 0 && (this.searching ? this.searchValue || (e = this.openPlaceholder) : e = this.placeholder), e;
  }
  get searchValue() {
    return Te(this, qa);
  }
  set searchValue(e) {
    Be(this, qa, e), this.filterSearchOptions();
  }
  /**
   * Function that should be used to open the dialog (dropdown). Adds an event listener
   * to the document to close the dialog on clickout. See the documentClickHandler comment for
   * an explanation why this was done.
   */
  openDialog() {
    this.searching = !0, document.addEventListener("mousedown", this.documentClickHandler);
  }
  /**
   * Function that should be used to close the dialog to remove the click listener from
   * the document. See the documentClickHandler comment for an explanation why this was done.
   *
   * Also clears the search value from the search bar.
   */
  closeDialog() {
    document.removeEventListener("mousedown", this.documentClickHandler), this.searching = !1, this.searchValue = "", this.combobox.value = "";
  }
  /**
   * Handles option selection events to update the selected values.
   */
  handleOptionSelection(e) {
    const {
      option: {
        checked: i,
        dataset: { value: o, count: n }
      }
    } = e.detail, l = new Map(this.value);
    i ? l.set(o, n) : l.delete(o), this.value = l;
  }
  /**
   * Captures the selected options from an optgroup that
   * were initialized via HTML.
   * @param event Beacon Change Event
   */
  handleDefaultSelectedValues(e) {
    const { target: i } = e;
    if (i instanceof fP) {
      const o = new Map(this.value);
      i.value.forEach((n, l) => {
        o.set(l, n);
      }), this.value = o;
    }
  }
  /**
   * Handles input events to update the search value and set searching state.
   */
  handleSearching(e) {
    const i = e.target;
    i && (this.searchValue = i.value, this.openDialog());
  }
  /**
   * Filters the search options based on the current search value.
   * This method updates the visibility of options and optgroups based on the search input.
   */
  filterSearchOptions() {
    const e = this.searchValue.toLowerCase();
    this.hasSearchResults = !1, this.optgroups.forEach((i) => {
      i.isVisible = !1, i.beaconControls.forEach((o) => {
        var L;
        const n = o.labelElement;
        if (!n) return;
        const l = (L = n.textContent) == null ? void 0 : L.trim().toLowerCase();
        l && l.includes(e) ? (o.classList.remove("hidden"), i.isVisible = !0, this.hasSearchResults = !0) : o.classList.add("hidden");
      });
    }), this.optgroups.forEach((i) => {
      var n;
      const o = i.titleElement;
      if (o) {
        const l = (n = o.textContent) == null ? void 0 : n.trim().toLowerCase();
        l != null && l.includes(e) && (i.isVisible = !0, this.hasSearchResults = !0, i.beaconControls.forEach(
          (L) => L.classList.remove("hidden")
        ));
      }
    });
  }
  /**
   * Resets the selected values and unchecks all options.
   */
  reset() {
    this.value = /* @__PURE__ */ new Map(), this.optgroups.forEach((e) => {
      e.beaconControls.forEach((i) => {
        const o = i.fieldElement;
        o && o.checked && (o.checked = !1);
      });
    }), this.selectedValues = [];
  }
  /**
   * Renders the prefix element showing the selected values.
   */
  renderPrefix() {
    let e;
    switch (this.value.size) {
      case 0:
        return pe``;
      case 1:
        e = pe`${this.value.keys().next().value}`;
        break;
      default:
        e = pe`${this.value.size}
          <slot name="filter-chip-text">Selected</slot>`;
    }
    return ze`
    <${this.getScopedTag("beacon-input-chip")} scale="mini" class="input-chip" slot="prefix">
      <span class="chip-label">${e}</span>
    </${this.getScopedTag("beacon-input-chip")}>`;
  }
  /**
   * Handles click events on the chevron button to toggle the searching state.
   */
  handleChevronClick(e) {
    e.preventDefault(), this.searching ? this.closeDialog() : this.openDialog();
  }
  /**
   * Renders the suffix element containing the chevron button.
   */
  renderSuffix() {
    return ze`
      <button
        tabindex="-1"
        class="toggle-select"
        @click=${this.handleChevronClick}
        aria-label="toggle">
        <${this.getScopedTag("beacon-icon")} name="sorted_down" size="m" slot="suffix" class="icon" variant="link"></${this.getScopedTag("beacon-icon")}>
      </button>
    `;
  }
  /**
   * Gets visible options to pass into the arrow control mixin
   */
  getArrowControlElements() {
    const e = [this.combobox];
    return this.optgroups.forEach((i) => {
      i.beaconControls.forEach((o) => {
        o.classList.contains("hidden") || o && e.push(o.fieldElement);
      });
    }), e;
  }
  /**
   * Moves focus onto the option determined by the arrow-control mixin
   * @param beaconControl
   */
  static arrowControlFocusCallback(e) {
    e instanceof HTMLElement && e.focus(), e.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  async addMultiSelectEventListeners() {
    this.addEventListener("keydown", this.handleKeydown), this.addEventListener("click", this.handleClick);
  }
  /**
   * When the blank space to the top right of the component is clicked, this ensures that the dialog closes.
   */
  handleClick(e) {
    e.target && e.target.matches(".group:not(.inline)") && (this.closeDialog(), this.blur());
  }
  async attachArrowControlKeyboardListeners() {
    this.combobox.addEventListener("keydown", this.handleArrowKeydown), await this.updateComplete, await this.optgroups.forEach(async (e) => {
      e.addEventListener(Ee.ELEMENT_READY, () => {
        e.beaconControls.forEach((i) => {
          var o;
          (o = i.fieldElement) == null || o.addEventListener(
            "keydown",
            this.handleArrowKeydown
          );
        });
      });
    });
  }
  async sortOptions() {
    await this.updateComplete;
    const e = this.optgroups;
    await e.forEach(async (i) => {
      await i.updateComplete;
    }), e.sort(
      (i, o) => {
        var L, D, j, I;
        const n = (D = (L = i.titleElement) == null ? void 0 : L.textContent) != null ? D : "", l = (I = (j = o.titleElement) == null ? void 0 : j.textContent) != null ? I : "";
        return n.localeCompare(l);
      }
    ), await e.forEach(async (i) => {
      i.remove(), this.appendChild(i);
      const o = [...i.options];
      await o.forEach(async (n) => {
        await n.updateComplete;
      }), o.sort((n, l) => {
        var j, I, B, R;
        const L = (I = (j = n.labelNode) == null ? void 0 : j.nodeValue) != null ? I : "", D = (R = (B = l.labelNode) == null ? void 0 : B.nodeValue) != null ? R : "";
        return L.localeCompare(D);
      }), o.forEach((n) => {
        n.remove(), i.appendChild(n);
      });
    });
  }
  initializeSelectedValues() {
    const e = new Map(this.value);
    this.optgroups.forEach((i) => {
      i.value.forEach((o, n) => {
        e.set(n, o);
      });
    }), this.value = e;
  }
  /**
   * Renders the search field element.
   */
  renderSearchField() {
    const e = {
      disabled: this.disabled,
      search: !0,
      searching: this.searching
    };
    return ze`
      <${this.getScopedTag("beacon-control")} class="${Pe(e)}"
      @beacon-event-dismiss=${this.reset}>
        <label slot="label" for="multi-select">
          <slot name="label"></slot>
        </label>
        ${this.renderPrefix()}
        <input
          role="combobox"
          aria-autocomplete="none"
          aria-expanded="${this.searching.toString()}"
          aria-controls="options"
          aria-haspopup="dialog"
          name="multi-select"
          id="multi-select"
          ?disabled=${this.disabled}
          placeholder="${this.dynamicPlaceholder}"
          autocomplete="off"
          @input=${this.handleSearching}
          @focus=${this.openDialog}
          @click=${this.openDialog}
        />
        ${this.renderSuffix()}
      </${this.getScopedTag("beacon-control")}>
    `;
  }
  /**
   * Renders the multi-select component.
   */
  render() {
    const e = {
      options: !0,
      visible: this.searching
    };
    return pe`
      ${this.renderSearchField()}
      <div role="dialog" id="options" class="${Pe(e)}">
        <div class="beacon-multi-select-content">
          <slot
            @beacon-event-toggle=${this.handleOptionSelection}
            @beacon-event-change=${this.handleDefaultSelectedValues}></slot>
        </div>
        ${this.hasSearchResults ? pe`` : pe`<div class="no-results-message">
              No results found for “${Te(this, qa)}”
            </div>`}
      </div>
    `;
  }
}, qa = new WeakMap(), Bo.tagName = qg.beaconTagName, Bo.nestedComponents = [Uc, Ss, ro], Bo.shadowRootOptions = {
  ...Sp(Bo, Bo, "shadowRootOptions"),
  delegatesFocus: !1
}, Bo);
lo([
  ue({ type: Boolean })
], eo.prototype, "disabled", 2);
lo([
  ue()
], eo.prototype, "placeholder", 2);
lo([
  ue({ attribute: "open-placeholder" })
], eo.prototype, "openPlaceholder", 2);
lo([
  Ce()
], eo.prototype, "searching", 2);
lo([
  Ce()
], eo.prototype, "value", 2);
lo([
  Ce()
], eo.prototype, "hasSearchResults", 2);
lo([
  ot('[role="combobox"]')
], eo.prototype, "combobox", 2);
lo([
  ot('[beacon-tag-name="beacon-multi-select"]')
], eo.prototype, "multiSelectComponent", 2);
lo([
  ot('[beacon-tag-name="beacon-control"]')
], eo.prototype, "beaconControl", 2);
lo([
  De({
    flatten: !0,
    selector: '[beacon-tag-name="beacon-multi-select-optgroup"]'
  })
], eo.prototype, "optgroups", 2);
lo([
  qe
], eo.prototype, "addMultiSelectEventListeners", 1);
lo([
  Re
], eo.prototype, "attachArrowControlKeyboardListeners", 1);
lo([
  Re
], eo.prototype, "sortOptions", 1);
lo([
  Re
], eo.prototype, "initializeSelectedValues", 1);
let oz = eo;
const Yg = {
  beaconTagName: "beacon-multi-select-option"
};
var xP = Object.defineProperty, Wc = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && xP(t, e, o), o;
}, Hs, ba;
const rl = (ba = class extends Le {
  constructor() {
    super(...arguments);
    Ie(this, Hs);
    this.beaconTagName = Yg.beaconTagName, this.selected = !1, this.controlId = this.id || _i();
  }
  get optionText() {
    return Te(this, Hs);
  }
  set labelNode(e) {
    Be(this, Hs, e);
  }
  static concatNodeTextContent(e) {
    return e.map((i) => {
      var o, n;
      return (n = (o = i == null ? void 0 : i.textContent) == null ? void 0 : o.trim()) != null ? n : "";
    }).join(" ").trim();
  }
  get label() {
    return ba.concatNodeTextContent(this.defaultSlotNodes);
  }
  get count() {
    return ba.concatNodeTextContent(this.countSlotNodes);
  }
  handleLabelSlotchange() {
    this.labelNode = this.labelNodes.find((e) => !!e), this.label && Fe(this, Ee.CHANGE);
  }
  render() {
    return ze`
      <slot @slotchange=${this.handleLabelSlotchange}></slot>
      <slot name="count"></slot>
    `;
  }
}, Hs = new WeakMap(), ba.tagName = Yg.beaconTagName, ba);
Wc([
  ue({ type: Boolean })
], rl.prototype, "selected");
Wc([
  Ho()
], rl.prototype, "defaultSlotNodes");
Wc([
  Ho({ slot: "count" })
], rl.prototype, "countSlotNodes");
Wc([
  Ho()
], rl.prototype, "labelNodes");
let iz = rl;
const wP = ve`[beacon-tag-name=beacon-navigation-footer] a,[beacon-tag-name=beacon-navigation-footer] li{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-navigation-footer] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-navigation-footer] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-jumbo)}@media (width >= 960px){[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:0;padding-block-end:0}}[beacon-tag-name=beacon-navigation-footer] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, kP = ve`::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}`, rp = class rp extends Tv {
  constructor() {
    super(...arguments), this.beaconTagName = Hn.beaconFooterNavTagName;
  }
  static get styles() {
    return [super.styles, kP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, wP];
  }
  setLevel() {
    this.level = 2;
  }
  setLevel2GridTemplate() {
    this.style.setProperty("--expanded-nav-grid-template", "1");
  }
};
rp.tagName = Hn.beaconFooterNavTagName;
let Xg = rp;
const CP = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M8 14L12 10L16 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, SP = `<svg class="icon--close" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z" fill="#0063AD"/>
</svg>
`, EP = `<svg class="icon--error" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Error">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.57752 11.0009C1.22025 11.6197 1.22025 12.3821 1.57752 13.0009L5.92282 20.5272C6.28009 21.146 6.94034 21.5272 7.65487 21.5272H16.3455C17.06 21.5272 17.7203 21.146 18.0775 20.5272L22.4228 13.0009C22.7801 12.3821 22.7801 11.6197 22.4228 11.0009L18.0775 3.47461C17.7203 2.85581 17.06 2.47461 16.3455 2.47461H7.65487C6.94034 2.47461 6.28008 2.85581 5.92282 3.47461L1.57752 11.0009ZM11.2502 7.75087C11.2502 7.33665 11.586 7.00087 12.0002 7.00087C12.4144 7.00087 12.7502 7.33665 12.7502 7.75087V12.2509C12.7502 12.6651 12.4144 13.0009 12.0002 13.0009C11.586 13.0009 11.2502 12.6651 11.2502 12.2509V7.75087ZM13.0002 16.0009C13.0002 16.5532 12.5525 17.0009 12.0002 17.0009C11.4479 17.0009 11.0002 16.5532 11.0002 16.0009C11.0002 15.4486 11.4479 15.0009 12.0002 15.0009C12.5525 15.0009 13.0002 15.4486 13.0002 16.0009Z" fill="#DD3636"/>
</svg>
`, MP = `<svg class="icon--informational" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Informational">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V11.75C11.25 11.3358 11.5858 11 12 11C12.4142 11 12.75 11.3358 12.75 11.75V16.25ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8Z" fill="#0063AD"/>
</svg>
`, TP = `<svg class="icon--success" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Succcess">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6081 9.43895C16.8506 9.10309 16.7748 8.6343 16.439 8.39187C16.1031 8.14944 15.6343 8.22519 15.3919 8.56105L10.8463 14.8586L8.52152 12.6092C8.22385 12.3211 7.74904 12.3289 7.46101 12.6266C7.17298 12.9243 7.1808 13.3991 7.47848 13.6871L10.4258 16.539C10.5823 16.6903 10.7967 16.7663 11.0135 16.7471C11.2303 16.7279 11.4281 16.6154 11.5555 16.439L16.6081 9.43895Z" fill="#248647"/>
</svg>
`, LP = `<svg class="icon--warning" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Warning">
  <path d="M10.0652 3C10.835 1.66667 12.7595 1.66667 13.5293 3L21.3235 16.5C22.0933 17.8333 21.131 19.5 19.5914 19.5H4.00298C2.46338 19.5 1.50113 17.8333 2.27093 16.5L10.0652 3Z" fill="#FFC42D"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C11.5858 7 11.25 7.33579 11.25 7.75V12.25C11.25 12.6642 11.5858 13 12 13C12.4142 13 12.75 12.6642 12.75 12.25V7.75C12.75 7.33579 12.4142 7 12 7ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="#061937"/>
</svg>
`, Qg = {
  beaconTagName: "beacon-notification"
}, OP = ve`:host([motion-state=enabled][in-motion]) .motion-wrap,:host([collapsed]) .motion-wrap{overflow:hidden}`;
var PP = Object.getOwnPropertyDescriptor, DP = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? PP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function zP(a) {
  let t = class extends a {
    static get NotificationMotionStyles() {
      return [OP];
    }
  };
  return t = DP([
    $e("NotificationMotion")
  ], t), t;
}
const IP = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{background-color:var(--notification-background-color, var(--beacon-component-notification-color-background-standard))}:host([variant=informational]){--notification-background-color: var(--beacon-component-notification-color-background-informational);--notification-border-color: var(--beacon-component-notification-color-border-informational)}:host([variant=warning]){--notification-background-color: var(--beacon-component-notification-color-background-warning);--notification-border-color: var(--beacon-component-notification-color-border-warning)}:host([variant=error]){--notification-background-color: var(--beacon-component-notification-color-background-error);--notification-border-color: var(--beacon-component-notification-color-border-error)}:host([variant=success]){--notification-background-color: var(--beacon-component-notification-color-background-success);--notification-border-color: var(--beacon-component-notification-color-border-success)}:host(:is([type=inline],[type=toast])){max-inline-size:var(--beacon-system-breakpoint-xxx-large)}.base{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large);position:relative}.base .shell{display:grid;grid-column-gap:var(--beacon-reference-space-4);grid-template-columns:auto 1fr;grid-template-rows:auto;padding:var(--beacon-system-space-cell-contained)}.base .shell .icon{align-self:center;display:grid;grid-area:1}.base .shell .description{grid-area:2/2}.base .shell .action-zone{grid-area:3/2}.base .shell .chevron,.base .shell .close-wrapper{align-self:baseline;grid-area:1/3}.base .shell .title{align-self:center}.base .shell:has(.icon.hide-slot-area){grid-template-columns:1fr auto}.base .shell:has(.icon.hide-slot-area) .description{grid-area:2}.base .shell:has(.icon.hide-slot-area) .action-zone{grid-area:3}.base .shell:has(.icon.hide-slot-area) .chevron{grid-area:1/2}.base:not(.standard){color:var(--beacon-system-color-text-set-navy)}.base:not(.standard) ::part(icon-button){color:var(--beacon-reference-palette-functional-blue-3)}.base:is(.alert,.banner){padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-maxi)}.base:is(.alert,.banner) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100)}.base:is(.alert,.banner) .description{margin-block-start:var(--beacon-reference-space-3)}.base:is(.alert,.banner) .action-zone{margin-block-start:var(--beacon-reference-space-5)}.base.inline{padding:var(--beacon-system-space-organism-normal)}.base.inline .shell,.base.inline .body{padding:var(--beacon-system-space-cell-contained)}.base.toast{box-shadow:var(--beacon-system-color-shadow-low);padding:var(--beacon-system-space-cell-contained)}.base.toast .shell{padding:var(--beacon-reference-space-2)}.base.toast .shell .icon{align-self:baseline}.base:is(.inline,.toast){border:var(--beacon-system-width-border-normal) solid var(--notification-border-color, var(--beacon-component-notification-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard)}.base:is(.inline,.toast) .title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.base:is(.inline,.toast) .description{margin-block-start:var(--beacon-reference-space-2)}.base:is(.inline,.toast) .action-zone{margin-block-start:var(--beacon-reference-space-3)}.base.banner:not(.expanded) .description,.base.banner:not(.expanded) .action-zone,.base.banner:not(.expanded) .body{margin:0;opacity:0}.base.banner .chevron{--active-bg: var(--beacon-system-color-background-primary-pressed);--active-border: var(--beacon-system-color-border-secondary-pressed);--active-icon: var(--beacon-system-color-icon-secondary-pressed);--bg-color: var(--beacon-system-color-background-primary);--border-color: var(--beacon-system-color-border-secondary);--border-width: var(--beacon-system-width-border-mini);--default-size: var(--beacon-reference-space-9);--disabled-bg: var(--beacon-system-color-background-primary-inactive);--disabled-border: var(--beacon-system-color-border-secondary-inactive);--disabled-icon: var(--beacon-system-color-icon-primary-inactive);--hover-bg: var(--beacon-system-color-background-primary-hover);--hover-border: var(--beacon-system-color-border-secondary-hover);--hover-icon: var(--beacon-system-color-icon-secondary-hover);--icon-color: var(--beacon-system-color-icon-primary);align-items:center;background-color:var(--override-icon-button-bg-color, var(--bg-color));block-size:var(--override-icon-button-wrapper-block-size, var(--beacon-reference-space-10));border:var(--border-width) solid var(--border-color);border-radius:var(--override-icon-button-border-radius, var(--beacon-system-radius-corner-circle));box-shadow:var(--override-icon-button-box-shadow, initial);color:var(--override-icon-button-color, var(--beacon-host-override-icon-button-color, var(--icon-color)));cursor:pointer;display:inline-flex;inline-size:var(--override-icon-button-wrapper-inline-size, var(--beacon-reference-space-10));justify-content:center;outline-offset:var(--override-icon-button-outline-offset);position:relative;--active-bg: var(--beacon-system-color-background-tertiary-pressed);--active-icon: var(--beacon-system-color-icon-tertiary-pressed);--bg-color: transparent;--default-hover-bg: var(--beacon-system-color-background-tertiary-hover);--default-hover-icon: var(--beacon-system-color-icon-tertiary-hover);--default-icon-color: var(--beacon-system-color-icon-tertiary);--disabled-bg: transparent;--disabled-icon: var(--beacon-system-color-icon-tertiary-inactive);--hover-bg: var(--override-icon-button-hover-bg, var(--default-hover-bg));--hover-icon: var(--override-icon-button-icon-color, var(--default-hover-icon));--icon-color: var(--override-icon-button-icon-color, var(--default-icon-color));border:0;transform:rotate(0);transition-duration:var(--beacon-reference-motion-duration-3);transition-property:transform}.base.banner .chevron .contents{align-items:inherit;display:inherit;justify-content:inherit;position:inherit}.base.banner .chevron[aria-disabled=true]{--icon-color: var(--disabled-icon);background-color:var(--disabled-bg);border-color:var(--disabled-border);color:var(--disabled-icon);cursor:not-allowed}.base.banner .chevron svg,.base.banner .chevron [beacon-tag-name=beacon-icon]{position:absolute}.base.banner .chevron:-webkit-direct-focus{outline:-webkit-focus-ring-color auto 0}.base.banner .chevron:hover:not([aria-disabled=true]){--icon-color: var(--hover-icon);background-color:var(--hover-bg);border-color:var(--hover-border);color:var(--hover-icon)}.base.banner .chevron:active:not([aria-disabled=true]){--icon-color: var(--active-icon);background-color:var(--active-bg);border-color:var(--active-border);color:var(--active-icon)}.base.banner.expanded .chevron{transform:rotate(180deg)}.base.banner:not(.standard) svg{color:var(--beacon-reference-palette-functional-blue-3)}.base.banner :is(.description,.body,.action-zone){display:grid;transition-property:var(--unroll-from-transition-direction);--unroll-from-transition-property: grid-template-rows;grid-template-rows:0fr;transition-duration:var(--beacon-reference-motion-duration-5);transition-property:margin,opacity;transition-timing-function:var(--beacon-system-motion-easing-accelerate-emphasize-1)}.base.banner :is(.description,.body,.action-zone) [class*=wrapper]{overflow:hidden}.base.banner.expanded :is(.description,.body,.action-zone){display:grid;grid-template-rows:1fr}.shell .icon{flex-shrink:0}.shell .icon svg,.shell .icon ::slotted(svg),.shell .icon ::slotted(img){max-block-size:var(--beacon-reference-space-7);max-inline-size:var(--beacon-reference-space-7)}.shell .content{flex-grow:1}.shell:has(.description.hide-slot-area):has(.action-zone.hide-slot-area){align-items:center}.description,.body{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 1920px){.base:is(.banner,.alert){padding-inline:0}}`;
var BP = Object.defineProperty, RP = Object.getOwnPropertyDescriptor, Br = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? RP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && BP(t, e, o), o;
}, Oi;
const Mn = (Oi = class extends Ge(Le).with(
  Lr({ autoRemoveMotionClasses: !1 }),
  zP
) {
  constructor() {
    super(...arguments), this.beaconTagName = Qg.beaconTagName, this.resetSpacing = !0, this.type = "inline", this.variant = "standard", this.dismissable = !1, this.collapsed = !1;
  }
  static get styles() {
    return [super.styles, IP, this.NotificationMotionStyles];
  }
  static renderIcon(t) {
    if (t === "standard")
      return pe`
        <div class="icon" aria-hidden="true">
          <slot ${_e({ useParent: !0 })} name="icon"></slot>
        </div>
      `;
    let e = pe``;
    switch (t) {
      case "informational":
        e = pe`${gt(MP)}`;
        break;
      case "success":
        e = pe`${gt(TP)}`;
        break;
      case "warning":
        e = pe`${gt(LP)}`;
        break;
      case "error":
        e = pe`${gt(EP)}`;
        break;
    }
    return pe`<div class="icon" aria-hidden="true">${e}</div>`;
  }
  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
  renderIconByType() {
    return this.type === "banner" ? pe`
        <button
          class="${Pe({
      chevron: !0
    })}"
          aria-expanded="${String(!this.collapsed)}"
          aria-controls="description action-zone body"
          @click=${this.toggleCollapsed}>
          <span class="visually-hidden">Notification Details</span>
          ${gt(CP)}
        </button>
      ` : this.type === "toast" || this.dismissable ? ze`
        <div class="close-wrapper">
          <${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.dismiss} class="close" variant="tertiary">${gt(SP)} Dismiss</${this.getScopedTag("beacon-icon-button")}>
        </div>
      ` : pe``;
  }
  renderBodySlot() {
    return this.type !== "toast" ? pe`
        <div
          class="body"
          id="body"
          ?inert=${mt(this.inertContentStatus())}>
          <div class="motion-wrap">
            <slot name="body" ${_e({ container: ".body" })}></slot>
          </div>
        </div>
      ` : pe``;
  }
  dismiss() {
    Fe(this, Ee.DISMISS), this.remove();
  }
  static getRelevantAriaRole(t) {
    if (t === "inline")
      return "status";
  }
  addAnalyticsAttributes() {
    const t = this.type === "toast" ? "PU" : "ALRT";
    this.dataset.metricsLocation = t;
  }
  /**
   * Non-standard notifications default to a light mode. This will find the closest variant of light mode and add it to the class list.
   */
  addLightModeClasses() {
    if (this.variant !== "standard") {
      const t = this.closest(
        '[class*="beacon-on-light"]'
      );
      if (t) {
        const e = Array.from(t.classList).find(
          (i) => i.startsWith("beacon-on-light")
        );
        this.classList.add(e != null ? e : "beacon-on-light");
      } else
        this.classList.add("beacon-on-light");
    }
  }
  inertContentStatus() {
    if (this.type === "banner" && this.collapsed) return !0;
  }
  // aria-role is added to the most important text area since live regions read out text within as a single string
  // so semantics of an anchor link or button will not be noted
  render() {
    const t = {
      base: !0,
      dismissable: this.dismissable || this.type === "toast",
      expanded: !this.collapsed
    };
    return t[this.variant] = !0, t[this.type] = !0, pe`
      <div class="${Pe(t)}">
        <div
          class="shell"
          role="${mt(
      Oi.getRelevantAriaRole(this.type)
    )}">
          ${Oi.renderIcon(this.variant)}
          <div class="title" id="title" role="heading" aria-level="2">
            <slot></slot>
          </div>
          <div
            class="description"
            id="description"
            ?inert=${mt(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="description"
                ${_e({ container: ".description" })}></slot>
            </div>
          </div>
          <div
            class="action-zone"
            id="action-zone"
            ?inert=${mt(this.inertContentStatus())}>
            <div class="motion-wrap">
              <slot
                name="action-zone"
                ${_e({ container: ".action-zone" })}></slot>
            </div>
          </div>
          ${this.renderIconByType()}
        </div>
        ${this.renderBodySlot()}
      </div>
    `;
  }
}, Oi.tagName = Qg.beaconTagName, Oi.nestedComponents = [Qt], Oi);
Br([
  ue({ reflect: !0 })
], Mn.prototype, "type", 2);
Br([
  ue({ reflect: !0 })
], Mn.prototype, "variant", 2);
Br([
  ue({ type: Boolean })
], Mn.prototype, "dismissable", 2);
Br([
  ue({ type: Boolean, reflect: !0 })
], Mn.prototype, "collapsed", 2);
Br([
  Re
], Mn.prototype, "addAnalyticsAttributes", 1);
Br([
  Re
], Mn.prototype, "addLightModeClasses", 1);
let az = Mn;
const Zg = {
  beaconTagName: "beacon-notification-group"
}, NP = ve`:where([beacon-tag-name=beacon-notification-group]):where([floating]) :where([beacon-tag-name=beacon-notification]){inline-size:100%;margin-inline:auto;max-inline-size:var(--notification-width, auto);pointer-events:auto}@media (width >= 640px){:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=right]){--notification-width: 340px}:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=right]) :where([beacon-tag-name=beacon-notification]){margin-inline-end:0}:where([beacon-tag-name=beacon-notification-group]):where([floating]):where([align=center]){--notification-width: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5)}}`, FP = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}.notifications{display:flex;flex-direction:column-reverse;gap:var(--beacon-reference-space-6)}.notifications.floating{inline-size:100%;inset-block-start:var(--notification-group-position, auto);padding-inline:var(--beacon-system-space-gutter);pointer-events:none;position:fixed;z-index:2500}`;
var jP = Object.defineProperty, Tn = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && jP(t, e, o), o;
}, pa;
const Ta = (pa = class extends Le {
  constructor() {
    super(), this.beaconTagName = Zg.beaconTagName, this.floating = !1, this.align = "right", this.anchor = '[beacon-tag-name="beacon-navigation"]', this.debounceOnScroll = !1, this.externalObserversApplied = !1, this.positionDebounced = jo(() => {
      this.setScreenPosition();
    }, 100), this.resizeObserverCallback = jo(() => {
      this.position();
    }, 100), this.position = this.position.bind(this);
  }
  static get styles() {
    return [super.styles, FP];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, NP];
  }
  getPositionOffset() {
    const t = document.querySelector(this.anchor);
    if (t) {
      const e = t.getBoundingClientRect(), { bottom: i } = e;
      return i <= 0 ? 0 : i;
    }
    return 0;
  }
  setScreenPosition() {
    const t = this.getPositionOffset();
    this.notificationsContainer.style.setProperty(
      "--notification-group-position",
      `calc(${t}px + ${pa.minimumScreenPosition})`
    );
  }
  position() {
    this.setScreenPosition();
  }
  addScrollEventToWindow() {
    this.debounceOnScroll ? window.addEventListener("scroll", this.positionDebounced) : window.addEventListener("scroll", this.position), this.externalObserversApplied = !0;
  }
  removeScrollEventFromWindow() {
    this.debounceOnScroll ? window.removeEventListener("scroll", this.positionDebounced) : window.removeEventListener("scroll", this.position), this.externalObserversApplied = !1;
  }
  startScrollTracking(t) {
    const { target: e } = t;
    e instanceof HTMLSlotElement && e.classList.contains("notification-group") && (this.notifications.length > 0 ? (this.externalObserversApplied || (this.addScrollEventToWindow(), this.applyResizeObserver()), this.position()) : (this.removeScrollEventFromWindow(), this.removeResizeObserver()));
  }
  handleSlotchange(t) {
    this.floating && this.startScrollTracking(t);
  }
  createResizeObserver() {
    this.observer || (this.observer = new ResizeObserver(this.resizeObserverCallback));
  }
  applyResizeObserver() {
    var t;
    this.createResizeObserver(), (t = this.observer) == null || t.observe(this);
  }
  removeResizeObserver() {
    var t;
    (t = this.observer) == null || t.unobserve(this);
  }
  /** Convenience method for adding new toasts to the group. */
  addToast(t, e = "standard") {
    const i = document.createElement(
      this.getScopedTagName("beacon-notification")
    );
    i.type = "toast", i.variant = e, i.innerHTML = t, this.append(i);
  }
  renderTitleSlot() {
    return this.floating ? pe`
        <div class="visually-hidden" id="title">
          <slot name="title">Notifications</slot>
        </div>
      ` : pe``;
  }
  render() {
    const t = this.floating ? "log" : void 0, e = this.floating ? "additions" : void 0, i = this.floating ? "title" : void 0, o = {
      floating: this.floating,
      notifications: !0
    };
    return o[this.align] = !0, pe`
      ${this.renderTitleSlot()}
      <div
        class="${Pe(o)}"
        role="${mt(t)}"
        aria-relevant="${mt(e)}"
        aria-labelledby="${mt(i)}">
        <slot
          class="notification-group"
          @slotchange=${this.handleSlotchange}></slot>
      </div>
    `;
  }
}, pa.tagName = Zg.beaconTagName, pa.minimumScreenPosition = kA, pa);
Tn([
  ue({ type: Boolean, reflect: !0 })
], Ta.prototype, "floating");
Tn([
  ue({ reflect: !0 })
], Ta.prototype, "align");
Tn([
  ue()
], Ta.prototype, "anchor");
Tn([
  ue({ attribute: "debounce-on-scroll", type: Boolean })
], Ta.prototype, "debounceOnScroll");
Tn([
  Ce()
], Ta.prototype, "externalObserversApplied");
Tn([
  De({ selector: "beacon-notification" }, !0)
], Ta.prototype, "notifications");
Tn([
  We(".notifications")
], Ta.prototype, "notificationsContainer");
let nz = Ta;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* cA(a, t, e = 1) {
  const i = t === void 0 ? 0 : a;
  t != null || (t = a);
  for (let o = i; e > 0 ? o < t : t < o; o += e) yield o;
}
const _P = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 8L12 12L16 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, UP = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8 8L12 12L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, $P = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14 16L10 12L14 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, HP = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Jg = {
  beaconTagName: "beacon-pagination-button"
}, KP = ve`[beacon-tag-name=beacon-pagination-button] button:hover,[beacon-tag-name=beacon-pagination-button] a:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}[beacon-tag-name=beacon-pagination-button] button:active,[beacon-tag-name=beacon-pagination-button] a:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}`, GP = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host button:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}:host button:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}:host button,:host ::slotted(a){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;block-size:var(--beacon-reference-space-7);border-color:transparent;border-inline-start-width:var(--beacon-system-width-border-mini);border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--beacon-system-color-text-standard);display:inline-flex;inline-size:var(--beacon-reference-space-7);justify-content:center;overflow:hidden;text-decoration:none;text-wrap:nowrap;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 640px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-8);inline-size:var(--beacon-reference-space-8)}}@media (width >= 1280px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-9);inline-size:var(--beacon-reference-space-9)}}:host .current button,:host .current ::slotted(a){background-color:var(--beacon-system-color-background-primary);border-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}:host .truncated-pagination{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}`;
var WP = Object.defineProperty, VP = Object.getOwnPropertyDescriptor, Rr = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? VP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && WP(t, e, o), o;
}, ra;
const sp = class sp extends Le {
  constructor() {
    super(...arguments);
    Ie(this, ra);
    this.beaconTagName = Jg.beaconTagName, this.isTruncating = !1, Be(this, ra, !1), this._isLink = !1, this.emitPaginateEvent = () => {
      Fe(this, Ee.PAGINATE, {
        detail: {
          page: this._value
        }
      });
    };
  }
  static get styles() {
    return [super.styles, GP];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, KP];
  }
  get _current() {
    return Te(this, ra);
  }
  set _current(e) {
    Be(this, ra, e), Te(this, ra) && this._slottedLink && this._slottedLink.setAttribute(
      "aria-current",
      Te(this, ra) ? "page" : "false"
    );
  }
  handlePaginate() {
    this.emitPaginateEvent();
  }
  handleDefaultSlotchange() {
    this._slottedLink && (this._isLink = !0, this._slottedLink.addEventListener("click", this.emitPaginateEvent));
  }
  render() {
    const e = {
      base: !0,
      current: this._current
    };
    return this.isTruncating ? (e["truncated-pagination"] = !0, pe` <div class="${Pe(e)}">...</div> `) : pe`
      <div class="${Pe(e)}">
        <slot @slotchange=${this.handleDefaultSlotchange}>
          <button
            aria-current="${this._current ? "page" : "false"}"
            @click=${this.handlePaginate}>
            <span>${this._value}</span>
            <span class="visually-hidden" id="total"
              >of ${this._totalPageCount}</span
            >
          </button>
        </slot>
      </div>
    `;
  }
};
ra = new WeakMap(), sp.tagName = Jg.beaconTagName;
let Ii = sp;
Rr([
  ue({ type: Number })
], Ii.prototype, "_value", 2);
Rr([
  ue({ attribute: "is-truncating", type: Boolean })
], Ii.prototype, "isTruncating", 2);
Rr([
  ue({ type: Boolean, reflect: !0, attribute: "current" })
], Ii.prototype, "_current", 1);
Rr([
  Ce()
], Ii.prototype, "_isLink", 2);
Rr([
  Ce()
], Ii.prototype, "_totalPageCount", 2);
Rr([
  An("a")
], Ii.prototype, "_slottedLink", 2);
const oo = {
  beaconTagName: "beacon-pagination",
  ICON_BUTTON_TAG: "beacon-icon-button",
  PAGINATION_BUTTON_TAG: "beacon-pagination-button"
}, qP = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--override-icon-button-block-size: var(--beacon-reference-space-7);--override-icon-button-inline-size: var(--beacon-reference-space-7);--override-icon-button-border-radius: var(--beacon-system-radius-corner-standard);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-7);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-7);--override-icon-button-display: flex}@media (width >= 640px){:host{--override-icon-button-block-size: var(--beacon-reference-space-8);--override-icon-button-inline-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-8)}}@media (width >= 1280px){:host{--override-icon-button-block-size: var(--beacon-reference-space-9);--override-icon-button-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9)}}:host .base{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.on-first .previous,:host .base.on-first .first{display:none}:host .base.on-last .next,:host .base.on-last .last{display:none}:host .base.input .search-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.input .total-pages{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);text-wrap:nowrap}:host .base.input input{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-9);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);inline-size:var(--beacon-reference-space-10);text-align:center}:host .base.input input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}:host .pagination-buttons,:host ::slotted(ol){align-items:center;display:flex;gap:var(--beacon-reference-space-3);list-style:none;margin:0;padding:0}:host .number-input{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host .number-input::-webkit-inner-spin-button,:host .number-input::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}:host .truncated{display:none}:host .truncated:has(+.last-page){display:revert}:host .first-page+.truncated,:host:has(+.last-page){display:revert}`;
var YP = Object.defineProperty, XP = Object.getOwnPropertyDescriptor, La = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? XP(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && YP(t, e, o), o;
}, Ks, sa, Lt;
const Gi = (Lt = class extends Le {
  constructor() {
    super(...arguments);
    Ie(this, Ks);
    Ie(this, sa);
    this.beaconTagName = oo.beaconTagName, this.variant = "default", Be(this, sa, 1), this.pageUpdatedByNavigation = !1, this.isKeyboardNavigation = !1, this.handleKeyDown = () => {
      this.isKeyboardNavigation = !0;
    }, this.handleMouseDown = () => {
      this.isKeyboardNavigation = !1;
    };
  }
  static get styles() {
    return [super.styles, qP];
  }
  get pages() {
    return Te(this, Ks);
  }
  set pages(e) {
    Be(this, Ks, e), this.currentPage > this.pages && (this.pageUpdatedByNavigation = !1, this.currentPage = this.pages);
  }
  get currentPage() {
    return Te(this, sa);
  }
  set currentPage(e) {
    e > this.totalPages ? (Lt.pageCountErrorLog(), Be(this, sa, 1)) : Te(this, sa) !== e && (Be(this, sa, Number(e)), Fe(this, Ee.CHANGE, {
      detail: {
        page: this.currentPage,
        interaction: this.pageUpdatedByNavigation
      }
    }), this.variant === "default" && (this.resetCurrentPage(), this.setCurrentPage()));
  }
  // doesn't use a query decorator since we're looking at child elements of a list
  get slottedPaginationButtons() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-pagination-button"]')
    );
  }
  get inUsePaginationButtons() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons : this.paginationButtons;
  }
  get totalPages() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons.length : this.pages;
  }
  get isOnLastPage() {
    return this.currentPage === this.totalPages;
  }
  get isOnFirstPage() {
    return this.currentPage === 1;
  }
  static pageCountErrorLog() {
    console.log(
      "Beacon Pagination tried to set a current page that is out of range of possible pages."
    );
  }
  incrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage++, this.isOnLastPage && this.handleOnLastPage();
  }
  decrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage--, this.isOnFirstPage && this.handleOnFirstPage();
  }
  skipToFirstPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = 1, this.handleOnFirstPage();
  }
  skipToLastPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = this.pages, this.handleOnLastPage();
  }
  handleOnFirstPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[0].focus());
  }
  handleOnLastPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[this.inUsePaginationButtons.length - 1].focus());
  }
  resetCurrentPage() {
    const e = this.inUsePaginationButtons, i = Array.from(e).find(
      (o) => o._current
    );
    i && (i._current = !1);
  }
  setCurrentPage() {
    const e = this.inUsePaginationButtons[this.currentPage - 1];
    e && (e._current = !0, e._isLink && this.pageUpdatedByNavigation && e._slottedLink.click());
  }
  handlePaginateEvent(e) {
    this.pageUpdatedByNavigation = !1, this.currentPage = e.detail.page;
  }
  handleDefaultSlotchange() {
    if (this.resetCurrentPage(), this.slottedPaginationButtons.forEach(
      (e, i) => {
        e._value = i + 1;
      }
    ), this.currentPage > this.totalPages)
      Lt.pageCountErrorLog(), this.currentPage = 1;
    else {
      const e = this.inUsePaginationButtons[this.currentPage - 1];
      e && !e._current && (e._current = !0);
    }
  }
  static renderPaginationButtonListItem(e, i) {
    return pe`<li class="${e}">${i}</li>`;
  }
  /**
   * Renders all the buttons in a pagination. Only the necessary pages are shown untruncated.
   *
   * Logic works as follows:
   *
   * - Current page visible
   * - First page visible
   * - Last page visible
   * - Previous page visible
   * - Next page visible
   * - Third page visible if the first page is the current page
   * - Third to last page visible if the last page is the current page
   */
  generateButtons() {
    return pe`
      <ol class="pagination-buttons" role="list">
        ${No(cA(this.pages), (e) => {
      const i = e + 1, o = ze`
            <${this.getScopedTag(oo.PAGINATION_BUTTON_TAG)}
              ._value="${i}"
              ._current=${this.currentPage === i}
              ._totalPageCount=${this.totalPages}
            ></${this.getScopedTag(oo.PAGINATION_BUTTON_TAG)}>
          `;
      return i === this.currentPage ? Lt.renderPaginationButtonListItem(
        "current-page",
        o
      ) : i === this.currentPage - 1 ? Lt.renderPaginationButtonListItem(
        "previous-page",
        o
      ) : i === this.currentPage + 1 ? Lt.renderPaginationButtonListItem(
        "next-page",
        o
      ) : i === 1 ? Lt.renderPaginationButtonListItem(
        "first-page",
        o
      ) : i === this.pages ? Lt.renderPaginationButtonListItem(
        "last-page",
        o
      ) : this.isOnFirstPage && i === 3 ? Lt.renderPaginationButtonListItem(
        "third-page",
        o
      ) : this.isOnLastPage && i === this.pages - 2 ? Lt.renderPaginationButtonListItem(
        "third-last-page",
        o
      ) : Lt.renderPaginationButtonListItem(
        "truncated",
        ze`<${this.getScopedTag(oo.PAGINATION_BUTTON_TAG)} is-truncating></${this.getScopedTag(oo.PAGINATION_BUTTON_TAG)}>`
      );
    })}
      </ol>
    `;
  }
  // TODO: replace all these with their respective icons
  renderPreviousPageButton() {
    return ze`<${this.getScopedTag(oo.ICON_BUTTON_TAG)} @beacon-event-click=${this.decrementPage} variant="tertiary"
      >Previous page${gt($P)}
    </${this.getScopedTag(oo.ICON_BUTTON_TAG)}>`;
  }
  renderNextPageButton() {
    return ze`<${this.getScopedTag(oo.ICON_BUTTON_TAG)} @beacon-event-click=${this.incrementPage} variant="tertiary"
      >Next page${gt(HP)}
    </${this.getScopedTag(oo.ICON_BUTTON_TAG)}>`;
  }
  renderFirstPageButton() {
    return ze`<${this.getScopedTag(oo.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToFirstPage} variant="tertiary"
      >Skip to first page${gt(_P)}
    </${this.getScopedTag(oo.ICON_BUTTON_TAG)}>`;
  }
  renderLastPageButton() {
    return ze`<${this.getScopedTag(oo.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToLastPage} variant="tertiary"
      >Skip to last page${gt(UP)}
    </${this.getScopedTag(oo.ICON_BUTTON_TAG)}>`;
  }
  // slotted link clicks do not emit beacon-event-paginate because they are links to new pages
  renderDefaultVariant() {
    return pe`
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <nav class="main" aria-labelledby="title">
        <span class="visually-hidden" id="title"
          ><slot name="title">Pagination</slot></span
        >
        <slot
          ${sb()}
          @beacon-event-paginate=${this.handlePaginateEvent}
          @slotchange=${Js(this.handleDefaultSlotchange.bind(this))}
          >${this.generateButtons()}</slot
        >
      </nav>
      <div class="next">${this.renderNextPageButton()}</div>
    `;
  }
  handleInputKeydown(e) {
    if (e.key === "Enter") {
      const i = parseInt(this.searchField.value, 10);
      !isNaN(i) && i >= 1 && i <= this.pages ? this.currentPage = i : this.searchField.value = String(this.currentPage);
    }
  }
  renderInputVariant() {
    return pe`
      <div class="first">${this.renderFirstPageButton()}</div>
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <search class="search-wrapper">
        <label for="search" class="visually-hidden">
          <slot name="search-label">Enter page number</slot>
        </label>
        <input
          class="skip-focus-override number-input"
          id="search"
          name="search"
          aria-describedby="total-pages"
          type="number"
          min="1"
          max="${this.pages}"
          inputmode="numeric"
          .value=${this.currentPage}
          @keydown=${this.handleInputKeydown} />
        <span id="total-pages" class="total-pages">of ${this.pages}</span>
      </search>
      <div class="next">${this.renderNextPageButton()}</div>
      <div class="last">${this.renderLastPageButton()}</div>
    `;
  }
  renderMainContent() {
    return this.variant === "input" ? this.renderInputVariant() : this.renderDefaultVariant();
  }
  registerNavigation() {
    this.addEventListener("keydown", this.handleKeyDown), this.addEventListener("mousedown", this.handleMouseDown);
  }
  tearDownNavigation() {
    this.removeEventListener("keydown", this.handleKeyDown), this.removeEventListener("mousedown", this.handleMouseDown);
  }
  render() {
    const e = {
      base: !0,
      "on-first": this.isOnFirstPage,
      "on-last": this.isOnLastPage
    };
    return e[this.variant] = !0, pe`<div class="${Pe(e)}">
      ${this.renderMainContent()}
    </div>`;
  }
}, Ks = new WeakMap(), sa = new WeakMap(), Lt.nestedComponents = [Ii, Qt], Lt.tagName = oo.beaconTagName, Lt.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, Lt);
La([
  ue({ type: Number })
], Gi.prototype, "pages", 1);
La([
  ue()
], Gi.prototype, "variant", 2);
La([
  ue({ type: Number, attribute: "current-page", reflect: !0 })
], Gi.prototype, "currentPage", 1);
La([
  Ce()
], Gi.prototype, "pageUpdatedByNavigation", 2);
La([
  We("input")
], Gi.prototype, "searchField", 2);
La([
  Cr('[beacon-tag-name="beacon-pagination-button"]')
], Gi.prototype, "paginationButtons", 2);
La([
  qe
], Gi.prototype, "registerNavigation", 1);
La([
  Pt
], Gi.prototype, "tearDownNavigation", 1);
let rz = Gi;
const em = {
  beaconTagName: "beacon-progress-indicator"
}, QP = ve`.header{align-items:center;display:flex;gap:var(--beacon-reference-space-5);justify-content:space-between;margin-block-end:var(--beacon-reference-space-5)}.title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.progress-bar{background-color:var(--beacon-component-progress-indicator-color-background-incomplete);block-size:var(--beacon-reference-space-3);inline-size:100%}.progress-value{background-color:var(--beacon-component-progress-indicator-color-background-complete);block-size:100%;inline-size:min(100%,var(--progress, 0))}`;
var ZP = Object.defineProperty, dA = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && ZP(t, e, o), o;
};
const lp = class lp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = em.beaconTagName, this.value = 0, this.max = 10;
  }
  static get styles() {
    return [super.styles, QP];
  }
  get ratio() {
    return this.value / this.max;
  }
  render() {
    const t = {
      "--progress": this.ratio * 100 + "%"
    };
    return pe`
      <div class="base">
        <div class="header" part="header">
          <div id="title" class="title">
            <slot name="title">Step ${this.value} of ${this.max}</slot>
          </div>
          <div class="action-zone">
            <slot name="action-zone" ${_e({ useParent: !0 })}></slot>
          </div>
        </div>
        <div
          class="progress-bar"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="${this.max}"
          aria-labelledby="title"
          aria-valuenow="${this.value}">
          <div class="progress-value" style="${Cv(t)}"></div>
        </div>
      </div>
    `;
  }
};
lp.tagName = em.beaconTagName;
let oc = lp;
dA([
  ue({ type: Number })
], oc.prototype, "value");
dA([
  ue({ type: Number })
], oc.prototype, "max");
const tm = {
  beaconTagName: "beacon-promo-tile"
}, JP = ve`[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard);display:block;margin:0;padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title{color:var(--beacon-system-color-text-standard)}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin:0;text-decoration:none}[beacon-tag-name=beacon-promo-tile] a.beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-promo-tile] a.beacon-promo-tile__title:is(:focus,:hover),[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__title>a:is(:focus,:hover){text-decoration:underline}[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__description{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-loose-200);color:var(--beacon-system-color-text-standard);margin:0;padding-block-start:var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-promo-tile] .beacon-action-zone{display:flex;flex-wrap:wrap;gap:var(--beacon-system-space-micro-jumbo);padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile] .tile__footer--full-width .beacon-action-zone{padding:0}[beacon-tag-name=beacon-promo-tile] [slot=body]{--tile-body-margin-block-end: var(--beacon-system-space-micro-normal);padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile] [slot=footer]{padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=body]{padding-inline:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 296px);max-inline-size:var(--override-promo-tile-max-inline-size, 592px)}@media (width >= 640px){[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]:is(picture){inline-size:min(var(--promo-tile-media-inline-size),100%)}}[beacon-tag-name=beacon-promo-tile][media-template=standard].beacon-promo-tile__vertical-fill{--promo-tile-content-zone-block-size: 100%}[class*=b-grid-item] [beacon-tag-name=beacon-promo-tile][media-template=standard].beacon-promo-tile__vertical-fill{block-size:100%}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-500)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 320px);max-inline-size:var(--override-promo-tile-max-inline-size, 640px)}[beacon-tag-name=beacon-promo-tile][position=vertical]{--promo-tile-media-vertical-block-size: auto}[beacon-tag-name=beacon-promo-tile] [slot=media]>img,[beacon-tag-name=beacon-promo-tile] [slot=media]:not(picture){aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);block-size:var(--promo-tile-media-vertical-block-size, 100%);inline-size:min(var(--promo-tile-media-inline-size),100%);object-fit:cover}@media (width >= 640px){[beacon-tag-name=beacon-promo-tile] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 456px);max-inline-size:var(--override-promo-tile-max-inline-size, 456px)}[beacon-tag-name=beacon-promo-tile][position*=horizontal][media-template=standard] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][position*=horizontal][media-template=standard] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-300)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] .beacon-promo-tile__eyebrow{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-loose-300)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 480px);max-inline-size:var(--override-promo-tile-max-inline-size, 960px)}}@media (width >= 960px){[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-loose-200)}[beacon-tag-name=beacon-promo-tile] [slot=media]:is(picture) img{aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);inline-size:min(var(--promo-tile-media-inline-size) * 2,100%);object-fit:cover}[beacon-tag-name=beacon-promo-tile] [slot=media]{inline-size:min(var(--promo-tile-media-inline-size),100%)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 400px);max-inline-size:var(--override-promo-tile-max-inline-size, 800px)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 600px);max-inline-size:var(--override-promo-tile-max-inline-size, 600px)}[beacon-tag-name=beacon-promo-tile][resize-to=content][position*=horizontal] :is([slot=media],[slot=media]>:is(picture,img)){--override-promo-tile-max-block-size: none;--override-promo-tile-max-inline-size: none;aspect-ratio:auto;block-size:100%;inline-size:100%;position:absolute}}@media (width >= 1280px){[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title,[beacon-tag-name=beacon-promo-tile][media-template=full-bleed][scale=jumbo] .beacon-promo-tile__title>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-display-loose-300)}[beacon-tag-name=beacon-promo-tile][media-template=standard] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 544px);max-inline-size:var(--override-promo-tile-max-inline-size, 1088px)}[beacon-tag-name=beacon-promo-tile][media-template=full-bleed] [slot=media]{max-block-size:var(--override-promo-tile-max-block-size, 800px);max-inline-size:var(--override-promo-tile-max-inline-size, 800px)}}@media (width >= 1600px){[media-template=full-bleed]{--promo-tile-content-zone-padding: 10rem;--promo-tile-content-zone-inline-size: 100%}[beacon-tag-name=beacon-promo-tile][position=horizontal] [slot=media]:is(picture) img{aspect-ratio:var(--promo-tile-media-aspect-ratio, initial);inline-size:unset;object-fit:cover}[beacon-tag-name=beacon-promo-tile] [slot=media]{inline-size:unset}}`, e4 = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]) ::slotted(:is([slot=body],[slot=footer])){--motion-translate-intro-override: var(--beacon-reference-space-3);animation-delay:var(--beacon-reference-motion-duration-7);animation-duration:var(--beacon-reference-motion-duration-12);animation-fill-mode:forwards;animation-timing-function:var(--beacon-system-motion-easing-decelerate-emphasize-1);opacity:var(--promo-tile-content-opacity, initial)}}@media (prefers-reduced-motion: no-preference) and (width >= 640px){:host([motion-state=enabled]){--promo-tile-content-opacity: 0}@keyframes intro-from-bottom{0%{opacity:0;transform:translateY(calc(1 * var(--motion-translate-intro-override, var(--motion-translate-intro-micro))))}to{opacity:1;transform:translateY(0)}}:host([motion-state=enabled].b-motion-viewed) ::slotted(:is([slot=body],[slot=footer])){animation-name:intro-from-bottom}}`;
var t4 = Object.getOwnPropertyDescriptor, o4 = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? t4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function i4(a) {
  let t = class extends a {
    static get PromoTileMotionStyles() {
      return [e4];
    }
  };
  return t = o4([
    $e("PromoTileMotion")
  ], t), t;
}
const a4 = ve`:host{--promo-tile-media-aspect-ratio: 2;--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--promo-tile-media-inline-size: 100%;--promo-tile-content-zone-inline-size: 100%;--promo-tile-content-zone-padding: var(--beacon-system-space-organism-normal);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-light-body-200);color:var(--beacon-system-color-text-standard);inline-size:min(var(--promo-tile-inline-size),100%)}.content-zone{background-color:var(--beacon-system-color-background-1);block-size:var(--promo-tile-content-zone-block-size);inline-size:min(var(--promo-tile-content-zone-inline-size),100%);padding:var(--promo-tile-content-zone-padding)}:host([beacon-tag-name=beacon-promo-tile]){--tile-flex-direction: column}:host([beacon-tag-name=beacon-promo-tile][media-template=full-bleed]){--tile-content-align-self: auto}:host([media-template=full-bleed]){--promo-tile-inline-size: 100vw;--promo-tile-content-zone-padding: var(--beacon-system-space-organism-maxi);--tile-display: flex;--tile-flex-direction: column-reverse;--tile-content-end-end-radius: 0;--tile-content-end-start-radius: 0;--tile-content-start-end-radius: 0;--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-end-start-radius: 0;--tile-media-start-end-radius: 0;--tile-media-start-start-radius: 0;--tile-border-radius: 0;max-block-size:800px}:host(:is([position=horizontal-left][media-template=standard],[position*=vertical-top][media-template=standard])){--tile-flex-direction: column-reverse}:host(:is([position*=horizontal][media-template=standard],[position=vertical-top][media-template=standard])){--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0}:host(:is([position=vertical-top][media-template=standard],[position=horizontal-left][media-template=standard])){--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0}.media-wrapper{display:contents}@media (width >= 640px){:host([position*=horizontal][media-template=standard]){--tile-flex-direction: row;--tile-content-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-end-start-radius: 0;--tile-content-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-start-radius: 0;--tile-media-end-end-radius: 0;--tile-media-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-end-radius: 0;--tile-media-start-start-radius: var(--beacon-system-radius-corner-standard);--promo-tile-media-aspect-ratio: 1;--promo-tile-content-zone-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--promo-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 6);--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 12 + var(--beacon-system-space-gutter) * 11);--tile-content-justify-content: center}:host([position=horizontal-left][media-template=standard]){--tile-content-end-end-radius: 0;--tile-content-end-start-radius: var(--beacon-system-radius-corner-standard);--tile-content-start-end-radius: 0;--tile-content-start-start-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-end-start-radius: 0;--tile-media-start-end-radius: var(--beacon-system-radius-corner-standard);--tile-media-start-start-radius: 0;--tile-flex-direction: row}}@media (width >= 960px){:host([position*=vertical][media-template=standard]){--promo-tile-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3)}:host(:is([position*=horizontal],[media-template=full-bleed])){--tile-content-justify-content: center}:host([media-template=full-bleed][position=horizontal-right]){--tile-flex-direction: row-reverse}:host([media-template=full-bleed]){--tile-flex-direction: row;--promo-tile-media-aspect-ratio: 1;--promo-tile-content-zone-inline-size: 50%;--promo-tile-media-inline-size: 50%}:host([position*=horizontal][media-template=standard][layout=wide]){--promo-tile-media-aspect-ratio: 2;--promo-tile-content-zone-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 4 + var(--beacon-system-space-gutter) * 3);--promo-tile-media-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 8)}.container.non-fixed:not(.vertical){display:grid;grid-auto-columns:1fr;grid-auto-flow:column;grid-template-columns:unset}.container.non-fixed:not(.vertical) .content-zone{grid-column:1/2;grid-row:1/2;inline-size:100%}.container.non-fixed:not(.vertical) .media-wrapper{display:unset;grid-column:2/3;grid-row:1/2;position:relative}.container.non-fixed:not(.vertical).horizontal-right .media-wrapper{grid-column:1/2}.container.non-fixed:not(.vertical).horizontal-right .content-zone{grid-column:2/3}.container.non-fixed:not(.vertical).wide{grid-template-columns:1fr 2fr}.container.non-fixed:not(.vertical).wide.horizontal-right{grid-template-columns:2fr 1fr}}@media (width >= 1600px){:host([media-template=full-bleed]){--promo-tile-content-zone-padding: 10rem;--promo-tile-content-zone-inline-size: 100%}}`;
var n4 = Object.defineProperty, r4 = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && n4(t, e, o), o;
};
const cp = class cp extends Ge(li).with(
  i4,
  Gf({ autoRemoveMotionClasses: !1 })
) {
  constructor() {
    super(...arguments), this.beaconTagName = tm.beaconTagName, this.resizeTo = "image";
  }
  static get styles() {
    return [super.styles, a4, this.PromoTileMotionStyles];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, JP];
  }
  applyMotionStyles() {
    this.classList.add(pb.VIEWED);
  }
  renderMedia() {
    return pe`
      <div class="${Pe({
      "media-wrapper": !0
    })}">
        <slot name="media"></slot>
      </div>
    `;
  }
  /**
   * Renders body and footer zones for full-bleed, and just body zone for standard mediaTemplate
   * @returns an HTML template
   */
  renderContentZone() {
    return this.mediaTemplate === fs.FULL_BLEED ? pe`<div class="content-zone">
        ${this.renderBody()} ${this.renderFooter()}
      </div>` : pe`<div class="content-zone">${this.renderBody()}</div>`;
  }
  /**
   * Overrides base renderTile to include exception ordering need for Full bleed mediaTemplate.
   * Necessary because Full bleed horizontal variant orients content zone to the left rather than the right
   * as it works in base tile.
   * @param position TilePosition value
   * @returns
   */
  renderTile(t) {
    const e = {
      container: !0,
      "non-fixed": this.resizeTo === "content"
    };
    return e[this.position] = !0, e[this.layout] = !0, this.mediaTemplate === fs.FULL_BLEED || t === en.HORIZONTAL_LEFT || t === en.VERTICAL_TOP ? pe`<div class="${Pe(e)}">
        ${this.renderContentZone()} ${this.renderMedia()}
      </div>` : pe`<div class="${Pe(e)}">
      ${this.renderMedia()} ${this.renderContentZone()}
    </div>`;
  }
  render() {
    return pe`${this.renderTile(this.position)}`;
  }
};
cp.tagName = tm.beaconTagName;
let Nh = cp;
r4([
  ue({ attribute: "resize-to", reflect: !0 })
], Nh.prototype, "resizeTo");
var es = /* @__PURE__ */ ((a) => (a.INLINE = "inline", a.STANDARD = "standard", a.HERO = "hero", a))(es || {}), Fh = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.CUTOUT = "cutout", a))(Fh || {});
const s4 = ve`:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block]{--quote-block-quote-container-padding-inline-start: 0;--quote-block-mini-hanging-quote-inset-inline-start: 0;--quote-block-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-1));--quote-block-normal-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-mini-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-jumbo-cutout-overlap-margin: var(--beacon-reference-space-5);--quote-block-cutout-full-bleed-overlap-margin-normal: var(--beacon-system-space-organism-maxi);--quote-block-cutout-full-bleed-overlap-margin-mini: var(--beacon-system-space-organism-maxi);--quote-block-cutout-full-bleed-overlap-margin-jumbo: var(--beacon-system-space-organism-maxi);--quote-block-media-inline-size-standard-mini: 0;--quote-block-media-inline-size-full-bleed-mini: 0;--quote-block-media-inline-size-standard-normal: 0;--quote-block-media-inline-size-full-bleed-normal: 0;--quote-block-media-inline-size-standard-jumbo: 0;--quote-block-media-block-size: 100%;--quote-block-media-block-size-default-jumbo: 0;--quote-block-media-block-size-default-normal: 0;--quote-block-media-block-size-default-mini: 0;--quote-block-media-block-size-full-bleed-normal: 0;--quote-block-media-block-size-full-bleed-mini: 0;--quote-block-media-max-block-size: none;--quote-block-media-display: block;--quote-block-space-padding-inline-end-default: var(--beacon-reference-space-3);--quote-block-space-padding-inline-end-full-bleed: 0}@media (width >= 640px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block]{--quote-block-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-2));--quote-block-normal-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-11));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-9));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-11));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-15));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-11));--quote-block-media-inline-size-standard-mini: 192px;--quote-block-media-inline-size-full-bleed-mini: 252px;--quote-block-media-inline-size-standard-normal: 192px;--quote-block-media-inline-size-full-bleed-normal: 204px;--quote-block-media-inline-size-standard-jumbo: 192px;--quote-block-media-inline-size-full-bleed-jumbo: 204px;--quote-block-media-block-size-default-jumbo: 512px;--quote-block-media-block-size-default-normal: 512px;--quote-block-media-block-size-default-mini: 512px;--quote-block-media-block-size-full-bleed-normal: 332px;--quote-block-media-block-size-full-bleed-mini: 262px}}@media (width >= 960px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block]{--quote-block-normal-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-14));--quote-block-jumbo-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-12));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-14));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-18));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-17));--quote-block-media-inline-size-standard-mini: 204px;--quote-block-media-inline-size-full-bleed-mini: 316px;--quote-block-media-inline-size-standard-normal: 256px;--quote-block-media-inline-size-full-bleed-normal: 360px;--quote-block-media-inline-size-standard-jumbo: 320px;--quote-block-media-inline-size-full-bleed-jumbo: 432px;--quote-block-media-block-size-default-jumbo: 800px;--quote-block-media-block-size-default-normal: 640px;--quote-block-space-padding-inline-end-full-bleed: var(--beacon-reference-space-12);--quote-block-media-block-size-full-bleed-normal: 424px;--quote-block-media-block-size-full-bleed-mini: 424px}}@media (width >= 1280px){:root[beacon-tag-name=beacon-quote-block],:root [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"][beacon-tag-name=beacon-quote-block],[beacon-version="4.4.0"] [beacon-tag-name=beacon-quote-block]{--quote-block-hanging-quote-inset-inline-start: calc(-.375 * var(--beacon-reference-space-5));--quote-block-mini-hanging-quote-inset-inline-start: calc(-1 * var(--beacon-reference-space-1));--quote-block-mini-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-jumbo-cutout-overlap-margin: calc(-1 * var(--beacon-reference-space-13));--quote-block-cutout-full-bleed-overlap-margin-normal: calc(-1 * var(--beacon-reference-space-16));--quote-block-cutout-full-bleed-overlap-margin-mini: calc(-1 * var(--beacon-reference-space-19));--quote-block-cutout-full-bleed-overlap-margin-jumbo: calc(-1 * var(--beacon-reference-space-18));--quote-block-media-inline-size-standard-mini: 245px;--quote-block-media-inline-size-full-bleed-mini: 368px;--quote-block-media-inline-size-standard-normal: 320px;--quote-block-media-inline-size-full-bleed-normal: 424px;--quote-block-media-inline-size-standard-jumbo: 400px;--quote-block-media-inline-size-full-bleed-jumbo: 480px;--quote-block-space-padding-inline-end-default: var(--beacon-reference-space-4);--quote-block-media-block-size-default-jumbo: 960px;--quote-block-media-block-size-default-normal: 840px;--quote-block-media-block-size-default-mini: 640px;--quote-block-space-padding-inline-end-full-bleed: var(--beacon-reference-space-16);--quote-block-media-block-size-full-bleed-normal: 552px;--quote-block-media-block-size-full-bleed-mini: 552px}}`, ic = {
  beaconTagName: "beacon-quote-block",
  signature: "signature",
  mediaSlot: "media"
}, l4 = ve`[beacon-tag-name=beacon-quote-block] [slot=media]>img,[beacon-tag-name=beacon-quote-block] [slot=media]:not(picture){block-size:var(--quote-block-media-block-size, none);inline-size:var(--quote-block-media-inline-size, none);max-block-size:var(--quote-block-media-block-size, var(--media-wrapper-max-block-size));object-fit:cover}[beacon-tag-name=beacon-quote-block] [slot=signature]{padding:0}[beacon-tag-name=beacon-quote-block] [beacon-tag-name=beacon-id-card]{--display-name-space-padding-block-start: 0;--id-card-avatar-display: none}[beacon-tag-name=beacon-quote-block] [slot=footnote]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-caption-loose-300)}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: unset}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card] :where(img [slot=media]){max-inline-size:none}[beacon-tag-name=beacon-quote-block][variant=hero] :where(img,picture){block-size:var(--quote-block-media-block-size, none);max-inline-size:none}@media (width >= 320px){[beacon-tag-name=beacon-quote-block] [slot=signature]{padding:0}}@media (width >= 640px){[beacon-tag-name=beacon-quote-block][image-variant=cutout]:not([full-bleed]) [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: unset}[beacon-tag-name=beacon-quote-block][variant=hero] [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: none}}@media (width >= 960px){[beacon-tag-name=beacon-quote-block][image-variant=cutout]:not([full-bleed]) [beacon-tag-name=beacon-id-card]{--id-card-avatar-display: none}}`, c4 = ve`@charset "UTF-8";:host{--media-wrapper-display: var(--quote-block-media-display, flex);--figure-align-self: inherit;--figure-padding-block: var(--beacon-system-space-organism-normal);--figure-padding-inline-end: var(--quote-block-space-padding-inline-end-default);--cutout-overlap-margin: var(--quote-block-normal-cutout-overlap-margin);--border-inline-style: solid;--container-padding-inline: var(--beacon-reference-space-2);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-normal);--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-normal);background:var(--beacon-custom-quote-block-background, var(--beacon-system-color-background-1))}:host .beacon-quote-container{border-inline-start:var(--beacon-system-width-border-jumbo) var(--border-inline-style) var(--beacon-system-color-border-brand);display:inline-flex}:host .beacon-quote-container p{margin:0}:host .beacon-quote-container figure{align-self:var(--figure-align-self);border:0;margin:0;margin-inline:var(--beacon-reference-space-5);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--beacon-system-space-organism-normal) var(--beacon-system-space-organism-normal)}:host .beacon-quote-container blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-200);border:0;margin:0;padding-block:var(--beacon-system-space-cell-contained) var(--beacon-system-space-cell-contained);padding-inline:var(--beacon-system-space-cell-contained);position:relative;word-break:break-word}:host .beacon-quote-container blockquote:before{content:"“";inset-block-start:var(--beacon-system-space-cell-contained);inset-inline-start:var(--quote-block-hanging-quote-inset-inline-start);position:absolute}:host .beacon-quote-container blockquote:after{content:"”";position:relative}:host .beacon-quote-container .cutout{margin-inline-end:var(--cutout-overlap-margin)}:host .beacon-quote-container .full-bleed-excessive{--figure-padding-block: var(--beacon-system-space-organism-normal);--figure-padding-inline-start: var(--beacon-system-space-organism-normal)}.media-wrapper{display:var(--media-wrapper-display)}.media-wrapper img{max-block-size:var(--quote-block-media-max-block-size, var(--media-wrapper-max-block-size));object-fit:cover}figcaption{border:0;padding:var(--beacon-system-space-cell-contained)}figcaption p{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}figcaption .beacon-signature{font-weight:var(--beacon-system-font-weight-bold)}.beacon-quote-container.hero figure{--figure-align-self: center}.beacon-quote-container.mini blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}.beacon-quote-container.mini blockquote:before{inset-inline-start:var(--quote-block-mini-hanging-quote-inset-inline-start)}.beacon-quote-container.mini .cutout{--cutout-overlap-margin: var(--quote-block-mini-cutout-overlap-margin)}.beacon-quote-container.mini .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-mini);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-mini)}.beacon-quote-container.jumbo blockquote{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-300)}.beacon-quote-container.jumbo .cutout{--cutout-overlap-margin: var(--quote-block-jumbo-cutout-overlap-margin)}.beacon-quote-container.jumbo .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-standard-jumbo);--media-wrapper-max-block-size: var(--quote-block-media-block-size-default-jumbo)}:host([full-bleed]) .beacon-quote-container{--border-inline-style: none;--container-padding-inline: 0;padding-inline-end:var(--quote-block-space-padding-inline-end-full-bleed)}:host([full-bleed]) .beacon-quote-container figure{--quote-block-figure-full-bleed-padding-inline: calc(var(--beacon-reference-space-5) + var(--beacon-system-space-organism-normal));--border-inline-style: solid;border-inline-start:var(--beacon-system-width-border-jumbo) var(--border-inline-style) var(--beacon-system-color-border-brand);margin-block:var(--beacon-system-space-organism-jumbo);margin-inline-start:var(--beacon-system-space-organism-maxi);padding-block:var(--beacon-system-space-organism-normal);padding-inline:var(--quote-block-figure-full-bleed-padding-inline, 0) var(--quote-block-figure-full-bleed-padding-inline, var(--figure-padding-inline-end))}:host([full-bleed]) .beacon-quote-container.normal .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-normal)}:host([full-bleed]) .beacon-quote-container.normal .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-normal);--media-wrapper-max-block-size: var(--quote-block-media-block-size-full-bleed-normal)}:host([full-bleed]) .beacon-quote-container.mini .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-mini)}:host([full-bleed]) .beacon-quote-container.mini .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-mini);--media-wrapper-max-block-size: var(--quote-block-media-block-size-full-bleed-mini)}:host([full-bleed]) .beacon-quote-container.jumbo .cutout{--cutout-overlap-margin: var(--quote-block-cutout-full-bleed-overlap-margin-jumbo)}:host([full-bleed]) .beacon-quote-container.jumbo .media-wrapper{--quote-block-media-inline-size: var(--quote-block-media-inline-size-full-bleed-jumbo);--media-wrapper-max-block-size: var(--quote-block-media-block-size)}::slotted([beacon-tag-name=beacon-id-card]){--id-card-avatar-border: 0}@media (width >= 320px){:host{--media-wrapper-display: none}}@media (width >= 640px){:host{--media-wrapper-display: var(--quote-block-media-display, flex)}:host([image-variant=cutout]:not([full-bleed])) .beacon-quote-container.jumbo{--media-wrapper-display: none}}@media (width >= 960px){:host([image-variant=cutout]:not([full-bleed])) .beacon-quote-container.jumbo{--media-wrapper-display: var(--quote-block-media-display, flex)}}@media (width >= 1920px){:host([variant=hero]){background-color:var(--beacon-system-color-background-1);display:flex;justify-content:center}:host([variant=hero]) .beacon-quote-container{max-inline-size:var(--beacon-system-breakpoint-xxx-large)}}`;
var d4 = Object.defineProperty, h4 = Object.getOwnPropertyDescriptor, Oa = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? h4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && d4(t, e, o), o;
};
const dp = class dp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = ic.beaconTagName, this.scale = Fo.NORMAL, this.variant = es.STANDARD, this.fullBleed = !1, this.imageVariant = Fh.STANDARD;
  }
  static get styles() {
    return [super.styles, c4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, s4, l4];
  }
  /** Template for caption(hero/standard variant) */
  getCaption() {
    return this.variant === es.HERO || this.variant === es.STANDARD ? pe`<figcaption>
        <slot
          @slotchange=${this.signatureSlotChange}
          name="signature"
          ${_e({ container: "figcaption" })}>
        </slot>
        <slot
          @slotchange=${this.footerSlotChange}
          name="footnote"
          ${_e({ container: "figcaption" })}>
        </slot>
      </figcaption>` : je;
  }
  /** Template for media (hero variant) */
  renderMedia() {
    return this.variant === es.HERO ? pe`<div class="media-wrapper">
        <slot name="media"></slot>
      </div>` : pe``;
  }
  /** slotChange handler  */
  signatureSlotChange() {
    this.requestUpdate("slottedSignature");
  }
  /** slotChange handler  */
  footerSlotChange() {
    this.requestUpdate("slottedFooter");
  }
  async cloneIdCardImage() {
    await this.updateComplete;
    const t = this.slottedSignature[0];
    if (t instanceof _o && t.slottedAvatar && this.slottedMedia.length === 0) {
      const e = t.slottedAvatar.cloneNode();
      e && e instanceof HTMLElement && (e.setAttribute("slot", "media"), this.insertAdjacentElement("beforeend", e));
    }
  }
  render() {
    const t = {
      cutout: !!(this.imageVariant === Fh.CUTOUT || this.fullBleed),
      "full-bleed-excessive": !!this.fullBleed
    };
    return pe`<div
      class="beacon-quote-container ${this.variant} ${this.scale}">
      <figure class=${Pe(t)}>
        <blockquote>
          <slot></slot>
        </blockquote>
        ${this.getCaption()}
      </figure>
      ${this.renderMedia()}
    </div>`;
  }
};
dp.tagName = ic.beaconTagName;
let ni = dp;
Oa([
  ue({ reflect: !0 })
], ni.prototype, "scale", 2);
Oa([
  ue()
], ni.prototype, "variant", 2);
Oa([
  ue({ type: Boolean, reflect: !0, attribute: "full-bleed" })
], ni.prototype, "fullBleed", 2);
Oa([
  ue({ type: String, attribute: "image-variant" })
], ni.prototype, "imageVariant", 2);
Oa([
  De({ slot: ic.signature, flatten: !0 })
], ni.prototype, "slottedSignature", 2);
Oa([
  De({ slot: ic.mediaSlot, flatten: !0 })
], ni.prototype, "slottedMedia", 2);
Oa([
  Ct({ slot: "" })
], ni.prototype, "defaultSlottedContent", 2);
Oa([
  Re
], ni.prototype, "cloneIdCardImage", 1);
const om = {
  beaconTagName: "beacon-region-selector"
}, b4 = ve`[beacon-tag-name=beacon-region-selector]{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding-block-start:var(--beacon-system-space-micro-jumbo)}[beacon-tag-name=beacon-region-selector] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}[beacon-tag-name=beacon-region-selector] [slot=title] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}@media (width >= 960px){[beacon-tag-name=beacon-region-selector]{padding-block-start:var(--beacon-reference-space-9)}}`, p4 = ve`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large)}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-vertical-fill [class*=b-grid-item] :first-child:not([class*=b-grid-item] [beacon-tag-name] *){block-size:100%}@media (width >= 320px){[class*=b-grid-item].b-sm\\:order-1{order:1}[class*=b-grid-item].b-sm\\:order-2{order:2}[class*=b-grid-item].b-sm\\:order-3{order:3}[class*=b-grid-item].b-sm\\:order-4{order:4}[class*=b-grid-item].b-sm\\:order-5{order:5}[class*=b-grid-item].b-sm\\:order-6{order:6}[class*=b-grid-item].b-sm\\:order-7{order:7}[class*=b-grid-item].b-sm\\:order-8{order:8}[class*=b-grid-item].b-sm\\:order-9{order:9}[class*=b-grid-item].b-sm\\:order-10{order:10}[class*=b-grid-item].b-sm\\:order-11{order:11}[class*=b-grid-item].b-sm\\:order-12{order:12}[class*=b-grid-item].b-sm\\:order-13{order:13}[class*=b-grid-item].b-sm\\:order-14{order:14}[class*=b-grid-item].b-sm\\:order-15{order:15}[class*=b-grid-item].b-sm\\:order-16{order:16}[class*=b-grid-item].b-sm\\:order-17{order:17}[class*=b-grid-item].b-sm\\:order-18{order:18}[class*=b-grid-item].b-sm\\:order-19{order:19}[class*=b-grid-item].b-sm\\:order-20{order:20}[class*=b-grid-item][class*="b-sm:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 640px){[class*=b-grid-item].b-md\\:order-1{order:1}[class*=b-grid-item].b-md\\:order-2{order:2}[class*=b-grid-item].b-md\\:order-3{order:3}[class*=b-grid-item].b-md\\:order-4{order:4}[class*=b-grid-item].b-md\\:order-5{order:5}[class*=b-grid-item].b-md\\:order-6{order:6}[class*=b-grid-item].b-md\\:order-7{order:7}[class*=b-grid-item].b-md\\:order-8{order:8}[class*=b-grid-item].b-md\\:order-9{order:9}[class*=b-grid-item].b-md\\:order-10{order:10}[class*=b-grid-item].b-md\\:order-11{order:11}[class*=b-grid-item].b-md\\:order-12{order:12}[class*=b-grid-item].b-md\\:order-13{order:13}[class*=b-grid-item].b-md\\:order-14{order:14}[class*=b-grid-item].b-md\\:order-15{order:15}[class*=b-grid-item].b-md\\:order-16{order:16}[class*=b-grid-item].b-md\\:order-17{order:17}[class*=b-grid-item].b-md\\:order-18{order:18}[class*=b-grid-item].b-md\\:order-19{order:19}[class*=b-grid-item].b-md\\:order-20{order:20}[class*=b-grid-item][class*="b-md:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 960px){[class*=b-grid-item].b-lg\\:order-1{order:1}[class*=b-grid-item].b-lg\\:order-2{order:2}[class*=b-grid-item].b-lg\\:order-3{order:3}[class*=b-grid-item].b-lg\\:order-4{order:4}[class*=b-grid-item].b-lg\\:order-5{order:5}[class*=b-grid-item].b-lg\\:order-6{order:6}[class*=b-grid-item].b-lg\\:order-7{order:7}[class*=b-grid-item].b-lg\\:order-8{order:8}[class*=b-grid-item].b-lg\\:order-9{order:9}[class*=b-grid-item].b-lg\\:order-10{order:10}[class*=b-grid-item].b-lg\\:order-11{order:11}[class*=b-grid-item].b-lg\\:order-12{order:12}[class*=b-grid-item].b-lg\\:order-13{order:13}[class*=b-grid-item].b-lg\\:order-14{order:14}[class*=b-grid-item].b-lg\\:order-15{order:15}[class*=b-grid-item].b-lg\\:order-16{order:16}[class*=b-grid-item].b-lg\\:order-17{order:17}[class*=b-grid-item].b-lg\\:order-18{order:18}[class*=b-grid-item].b-lg\\:order-19{order:19}[class*=b-grid-item].b-lg\\:order-20{order:20}[class*=b-grid-item][class*="b-lg:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-lg:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-lg\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-lg\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1280px){[class*=b-grid-item].b-xl\\:order-1{order:1}[class*=b-grid-item].b-xl\\:order-2{order:2}[class*=b-grid-item].b-xl\\:order-3{order:3}[class*=b-grid-item].b-xl\\:order-4{order:4}[class*=b-grid-item].b-xl\\:order-5{order:5}[class*=b-grid-item].b-xl\\:order-6{order:6}[class*=b-grid-item].b-xl\\:order-7{order:7}[class*=b-grid-item].b-xl\\:order-8{order:8}[class*=b-grid-item].b-xl\\:order-9{order:9}[class*=b-grid-item].b-xl\\:order-10{order:10}[class*=b-grid-item].b-xl\\:order-11{order:11}[class*=b-grid-item].b-xl\\:order-12{order:12}[class*=b-grid-item].b-xl\\:order-13{order:13}[class*=b-grid-item].b-xl\\:order-14{order:14}[class*=b-grid-item].b-xl\\:order-15{order:15}[class*=b-grid-item].b-xl\\:order-16{order:16}[class*=b-grid-item].b-xl\\:order-17{order:17}[class*=b-grid-item].b-xl\\:order-18{order:18}[class*=b-grid-item].b-xl\\:order-19{order:19}[class*=b-grid-item].b-xl\\:order-20{order:20}[class*=b-grid-item][class*="b-xl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1600px){[class*=b-grid-item].b-xxl\\:order-1{order:1}[class*=b-grid-item].b-xxl\\:order-2{order:2}[class*=b-grid-item].b-xxl\\:order-3{order:3}[class*=b-grid-item].b-xxl\\:order-4{order:4}[class*=b-grid-item].b-xxl\\:order-5{order:5}[class*=b-grid-item].b-xxl\\:order-6{order:6}[class*=b-grid-item].b-xxl\\:order-7{order:7}[class*=b-grid-item].b-xxl\\:order-8{order:8}[class*=b-grid-item].b-xxl\\:order-9{order:9}[class*=b-grid-item].b-xxl\\:order-10{order:10}[class*=b-grid-item].b-xxl\\:order-11{order:11}[class*=b-grid-item].b-xxl\\:order-12{order:12}[class*=b-grid-item].b-xxl\\:order-13{order:13}[class*=b-grid-item].b-xxl\\:order-14{order:14}[class*=b-grid-item].b-xxl\\:order-15{order:15}[class*=b-grid-item].b-xxl\\:order-16{order:16}[class*=b-grid-item].b-xxl\\:order-17{order:17}[class*=b-grid-item].b-xxl\\:order-18{order:18}[class*=b-grid-item].b-xxl\\:order-19{order:19}[class*=b-grid-item].b-xxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width >= 1920px){[class*=b-grid-item].b-xxxl\\:order-1{order:1}[class*=b-grid-item].b-xxxl\\:order-2{order:2}[class*=b-grid-item].b-xxxl\\:order-3{order:3}[class*=b-grid-item].b-xxxl\\:order-4{order:4}[class*=b-grid-item].b-xxxl\\:order-5{order:5}[class*=b-grid-item].b-xxxl\\:order-6{order:6}[class*=b-grid-item].b-xxxl\\:order-7{order:7}[class*=b-grid-item].b-xxxl\\:order-8{order:8}[class*=b-grid-item].b-xxxl\\:order-9{order:9}[class*=b-grid-item].b-xxxl\\:order-10{order:10}[class*=b-grid-item].b-xxxl\\:order-11{order:11}[class*=b-grid-item].b-xxxl\\:order-12{order:12}[class*=b-grid-item].b-xxxl\\:order-13{order:13}[class*=b-grid-item].b-xxxl\\:order-14{order:14}[class*=b-grid-item].b-xxxl\\:order-15{order:15}[class*=b-grid-item].b-xxxl\\:order-16{order:16}[class*=b-grid-item].b-xxxl\\:order-17{order:17}[class*=b-grid-item].b-xxxl\\:order-18{order:18}[class*=b-grid-item].b-xxxl\\:order-19{order:19}[class*=b-grid-item].b-xxxl\\:order-20{order:20}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-xxxl:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-xxxl\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (width < 640px){[class*=b-grid-item].b-sm-only\\:order-1{order:1}[class*=b-grid-item].b-sm-only\\:order-2{order:2}[class*=b-grid-item].b-sm-only\\:order-3{order:3}[class*=b-grid-item].b-sm-only\\:order-4{order:4}[class*=b-grid-item].b-sm-only\\:order-5{order:5}[class*=b-grid-item].b-sm-only\\:order-6{order:6}[class*=b-grid-item].b-sm-only\\:order-7{order:7}[class*=b-grid-item].b-sm-only\\:order-8{order:8}[class*=b-grid-item].b-sm-only\\:order-9{order:9}[class*=b-grid-item].b-sm-only\\:order-10{order:10}[class*=b-grid-item].b-sm-only\\:order-11{order:11}[class*=b-grid-item].b-sm-only\\:order-12{order:12}[class*=b-grid-item].b-sm-only\\:order-13{order:13}[class*=b-grid-item].b-sm-only\\:order-14{order:14}[class*=b-grid-item].b-sm-only\\:order-15{order:15}[class*=b-grid-item].b-sm-only\\:order-16{order:16}[class*=b-grid-item].b-sm-only\\:order-17{order:17}[class*=b-grid-item].b-sm-only\\:order-18{order:18}[class*=b-grid-item].b-sm-only\\:order-19{order:19}[class*=b-grid-item].b-sm-only\\:order-20{order:20}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-sm-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-sm-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}@media (640px <= width < 960px){[class*=b-grid-item].b-md-only\\:order-1{order:1}[class*=b-grid-item].b-md-only\\:order-2{order:2}[class*=b-grid-item].b-md-only\\:order-3{order:3}[class*=b-grid-item].b-md-only\\:order-4{order:4}[class*=b-grid-item].b-md-only\\:order-5{order:5}[class*=b-grid-item].b-md-only\\:order-6{order:6}[class*=b-grid-item].b-md-only\\:order-7{order:7}[class*=b-grid-item].b-md-only\\:order-8{order:8}[class*=b-grid-item].b-md-only\\:order-9{order:9}[class*=b-grid-item].b-md-only\\:order-10{order:10}[class*=b-grid-item].b-md-only\\:order-11{order:11}[class*=b-grid-item].b-md-only\\:order-12{order:12}[class*=b-grid-item].b-md-only\\:order-13{order:13}[class*=b-grid-item].b-md-only\\:order-14{order:14}[class*=b-grid-item].b-md-only\\:order-15{order:15}[class*=b-grid-item].b-md-only\\:order-16{order:16}[class*=b-grid-item].b-md-only\\:order-17{order:17}[class*=b-grid-item].b-md-only\\:order-18{order:18}[class*=b-grid-item].b-md-only\\:order-19{order:19}[class*=b-grid-item].b-md-only\\:order-20{order:20}[class*=b-grid-item][class*="b-md-only:vertical-divider"]{position:relative}[class*=b-grid-item][class*="b-md-only:vertical-divider"]:after{background-color:var(--b-grid-divider-color, var(--beacon-system-color-border-2));block-size:100%;content:"";inline-size:var(--b-grid-divider-size, var(--beacon-system-width-border-mini));inset-block-start:0;inset-inline-start:calc(100% + var(--b-default-grid-gap) / 2);position:absolute;z-index:1}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}[class*=b-grid-item].b-md-only\\:vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}}.b-grid-item--vertical-divider--thin--neutral{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thin--strong{--b-grid-divider-size: var(--beacon-system-width-border-mini);--b-grid-divider-color: var(--beacon-system-color-border-brand)}.b-grid-item--vertical-divider--thick--neutral{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-2)}.b-grid-item--vertical-divider--thick--strong{--b-grid-divider-size: var(--beacon-system-width-border-normal);--b-grid-divider-color: var(--beacon-system-color-border-brand)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (width >= 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (width >= 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (width >= 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (width >= 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (width >= 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}.wrapper{display:grid;gap:var(--beacon-system-space-micro-normal)}.header{align-items:baseline;display:flex;gap:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-contained)}.title{color:var(--beacon-system-color-text-title)}.title ::slotted(*){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)}.item-count{color:var(--beacon-system-color-text-standard);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.countries{--b-grid-columns: 1;--b-grid-gap: var(--beacon-system-space-micro-normal);margin-inline:0}@media (width >= 640px){.countries{--b-grid-columns: 2;--b-grid-gap: var(--beacon-system-space-micro-jumbo)}}@media (width >= 960px){.countries{--b-grid-columns: 4;row-gap:var(--beacon-system-space-micro-normal)}}`, hp = class hp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = om.beaconTagName, this.resetSpacing = !0;
  }
  static get styles() {
    return [super.styles, p4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, b4];
  }
  render() {
    return pe`<div class="wrapper">
      <header class="header">
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div class="item-count">
          <slot name="item-count"></slot>
        </div>
      </header>
      <section class="countries b-grid">
        <slot></slot>
      </section>
    </div>`;
  }
};
hp.tagName = om.beaconTagName;
let im = hp;
const am = {
  beaconTagName: "beacon-scatter-chart"
}, u4 = ve`.highcharts-series-inactive{opacity:1}.highcharts-crosshair{stroke:var(--beacon-component-data-viz-color-border-major);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-point-hover{stroke:var(--beacon-system-color-border-1);stroke-width:var(--beacon-system-width-border-normal)}:has(.highcharts-point-hover) .highcharts-point:not(.highcharts-point-hover){opacity:.2}`;
var g4 = Object.defineProperty, m4 = Object.getOwnPropertyDescriptor, hA = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? m4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && g4(t, e, o), o;
}, xo, ar, Gs, jh;
const Ob = (xo = class extends Ge(tt).with(
  Qs,
  xn
) {
  constructor() {
    super(...arguments), this.beaconTagName = am.beaconTagName, this._type = $t.SCATTER, this.scale = Zr.Mini;
  }
  static get styles() {
    return [super.styles, u4, this.chartAreaStyles];
  }
  get localComponentOptions() {
    var i;
    const t = this.addBeaconModeToTooltipContainer.bind(this), e = this._type;
    return tt.createChartOptions(super.localComponentOptions, {
      xAxis: {
        crosshair: !0
      },
      yAxis: {
        crosshair: !0
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: Te(xo, ar).get(this.scale)
          },
          states: {
            hover: {
              halo: {
                opacity: 0.6,
                size: Ue(i = xo, Gs, jh).call(i, this.scale)
              }
            }
          }
        }
      },
      tooltip: {
        pointFormatter() {
          return t(), tt.tooltipPointHTML(
            this,
            this.series.name,
            `${this.x}, ${this.y}`,
            !1,
            e
          );
        }
      }
    });
  }
  _updateScale() {
    var t;
    this.updateChart({
      plotOptions: {
        scatter: {
          marker: {
            radius: Te(xo, ar).get(this.scale)
          },
          states: {
            hover: {
              halo: {
                size: Ue(t = xo, Gs, jh).call(t, this.scale)
              }
            }
          }
        }
      }
    });
  }
}, ar = new WeakMap(), Gs = new WeakSet(), jh = function(t) {
  const e = Te(this, ar).get(t);
  return e ? e + 6 : void 0;
}, Ie(xo, Gs), xo.tagName = am.beaconTagName, Ie(xo, ar, /* @__PURE__ */ new Map([
  [Zr.Mini, 4],
  [Zr.Normal, 8],
  [Zr.Jumbo, 12]
])), xo);
hA([
  ue()
], Ob.prototype, "scale", 2);
hA([
  Gt("scale")
], Ob.prototype, "_updateScale", 1);
let sz = Ob;
const nm = {
  beaconTagName: "beacon-segmented-control"
};
var f4 = Object.defineProperty, v4 = Object.getOwnPropertyDescriptor, Vc = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? v4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && f4(t, e, o), o;
};
const bp = class bp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = nm.beaconTagName, this.selected = !1, this.value = "";
  }
  get text() {
    var t, e;
    return (e = (t = this.innerText) == null ? void 0 : t.trim()) != null ? e : "";
  }
  /** Normalized text content to remove any spaces so it remains a continuous string. */
  get normalizedValue() {
    return this.value || this.text.replace(" ", "-") || "";
  }
  get icon() {
    return this.icons[0];
  }
  handleSlotChange() {
    Fe(this, "beacon-event-change");
  }
  render() {
    return pe`
      <slot name="icon"></slot>
      <slot @slotchange="${this.handleSlotChange}></slot>
    `;
  }
};
bp.tagName = nm.beaconTagName;
let gr = bp;
Vc([
  ue({ type: Boolean })
], gr.prototype, "selected", 2);
Vc([
  ue()
], gr.prototype, "value", 2);
Vc([
  Ct({ slot: "icon" })
], gr.prototype, "icons", 2);
Vc([
  Re
], gr.prototype, "handleSlotChange", 1);
const rm = {
  beaconTagName: "beacon-segmented-controls"
}, A4 = ve`.radios{background-color:var(--beacon-system-color-background-1);border-color:var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);display:flex;gap:var(--beacon-reference-space-2);inline-size:fit-content;padding:var(--beacon-reference-space-2);position:relative}.radios .control{flex-shrink:0}.radios[inert]{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;padding:var(--beacon-reference-space-2)}[type=radio]{opacity:0;pointer-events:none;position:absolute}[type=radio]+label{align-items:center;border-radius:var(--beacon-system-radius-corner-round);color:var(--beacon-system-color-text-secondary);display:flex;gap:var(--beacon-reference-space-3)}[type=radio]+label svg{block-size:var(--beacon-reference-space-5);color:var(--beacon-system-color-icon-secondary);inline-size:var(--beacon-reference-space-5)}[type=radio]+label path{fill:currentcolor}[type=radio]:not(:disabled)+label{cursor:pointer}[type=radio]:not(:disabled):not(:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-hover)}[type=radio]:disabled+label{color:var(--beacon-system-color-text-secondary-inactive)}[type=radio]:disabled+label svg{color:var(--beacon-system-color-icon-secondary-inactive)}[type=radio]:active:not(:disabled,:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-pressed)}[type=radio]:checked+label{background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary)}[type=radio]:checked+label svg{color:var(--beacon-system-color-icon-primary)}[type=radio]:checked:disabled+label{background-color:var(--beacon-system-color-background-primary-inactive);color:var(--beacon-system-color-text-primary-inactive)}[type=radio]:checked:disabled+label svg{color:var(--beacon-system-color-icon-primary-inactive)}[type=radio]:focus-visible+label{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[type=radio]:focus-visible+label:not(dialog){position:relative}.title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50);margin:0;margin-block-end:var(--beacon-reference-space-3);padding:0}.base{border:0;margin:0;padding:0;position:relative}.base:not(.compact) .select{display:none}.base.normal label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard);padding:var(--beacon-reference-space-4)}.base.mini label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);padding:var(--beacon-reference-space-3)}.base.disabled .radios{border-color:var(--beacon-system-color-border-secondary-inactive)}select{color:var(--beacon-system-color-text-standard)}::part(field){inline-size:100%}::part(field):focus-within{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}`;
var y4 = Object.defineProperty, x4 = Object.getOwnPropertyDescriptor, co = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? x4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && y4(t, e, o), o;
};
const vc = class vc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = rm.beaconTagName, this.focusOverride = !0, this.resetSpacing = !0, this.scale = "normal", this.disabled = !1, this.value = void 0, this.controlsList = [], this.compact = !1;
  }
  static get styles() {
    return [super.styles, A4];
  }
  handleDefaultSlotchange() {
    this.controls.find(
      (e) => e.selected
    ) || (this.controls[0].selected = !0, this.setDefaultValue()), this.controlsList = [...this.controls];
  }
  renderRadioButtons() {
    return pe`${No(
      this.controlsList,
      (t) => pe`
        <div class="control">
          <input
            focus-override
            ?checked=${t.selected}
            type="radio"
            name="controls"
            id="control--${t.normalizedValue ? t.normalizedValue : t.value}"
            value="${t.normalizedValue ? t.normalizedValue : t.value}" />
          <label
            for="control--${t.normalizedValue}"
            id="label--${t.normalizedValue ? t.normalizedValue : t.value}">
            ${t.icon ? pe`${t.icon.cloneNode(!0)}` : pe``}
            <span class="label-text"
              >${t.text ? t.text : t.value}</span
            >
          </label>
        </div>
      `
    )}`;
  }
  renderSelectMenu() {
    const t = pe`${No(
      this.controlsList,
      (e) => pe`
        <option
          ?selected=${e.selected}
          id="option--${e.normalizedValue}"
          value="${e.normalizedValue}">
          ${e.text}
        </option>
      `
    )}`;
    return ze`
      <${this.getScopedTag("beacon-control")}>
        <select ?disabled=${this.disabled} aria-labelledby="title">
          ${t}
        </select>
      </${this.getScopedTag("beacon-control")}>
    `;
  }
  // this event won't fire when we use JS to check a radio button
  handleRadioInputEvent(t) {
    const { target: e } = t;
    if (!(e instanceof HTMLInputElement)) return;
    this.value = e.value;
    const o = Array.from(this.options).find(
      (n) => n.value === e.value
    );
    o.selected = !0, this.emitSegmentInput();
  }
  // this event won't fire when we use JS to select an option
  handleSelectInputEvent(t) {
    const { target: e } = t;
    if (!(e instanceof HTMLSelectElement)) return;
    this.value = e.value;
    const i = Array.from(this.radioButtons), o = e.selectedOptions[0], n = i.find(
      (l) => l.value === o.value
    );
    n.checked = !0, this.emitSegmentInput();
  }
  emitSegmentInput() {
    Fe(this, Ee.INPUT, {
      detail: {
        value: this.value
      }
    });
  }
  applyBaseResizeObserver() {
    const t = (i) => {
      for (const o of i) {
        const { target: n } = o, { clientWidth: l } = n, { scrollWidth: L } = this.radiosContainer;
        L > l ? this.compact = !0 : this.compact = !1;
        return;
      }
    }, e = new ResizeObserver(jo(t, 100));
    this.baseResizeObserver = e, this.baseResizeObserver.observe(this.base);
  }
  setDefaultValue() {
    const t = this.controls.find(
      (e) => e.selected
    );
    t && (this.value = t.value);
  }
  render() {
    const t = {
      base: !0,
      compact: this.compact,
      disabled: this.disabled
    };
    return t[this.scale] = !0, pe`
      <slot
        style="display: none;"
        @slotchange=${this.handleDefaultSlotchange}
        @beacon-event-change=${this.handleDefaultSlotchange}></slot>
      <fieldset class="${Pe(t)}" ?disabled=${this.disabled}>
        <legend class="title" id="title">
          <slot name="title" ${_e({ useParent: !0 })}></slot>
        </legend>
        <div
          ?inert=${this.compact}
          class="radios"
          @input=${this.handleRadioInputEvent}>
          ${this.renderRadioButtons()}
        </div>
        <div class="select" @input=${this.handleSelectInputEvent}>
          ${this.renderSelectMenu()}
        </div>
      </fieldset>
    `;
  }
};
vc.tagName = rm.beaconTagName, vc.nestedComponents = [Uc];
let Kt = vc;
co([
  ue()
], Kt.prototype, "scale", 2);
co([
  ue({ type: Boolean })
], Kt.prototype, "disabled", 2);
co([
  Ce()
], Kt.prototype, "value", 2);
co([
  Ce()
], Kt.prototype, "controlsList", 2);
co([
  Ce()
], Kt.prototype, "compact", 2);
co([
  We(".base")
], Kt.prototype, "base", 2);
co([
  We(".radios")
], Kt.prototype, "radiosContainer", 2);
co([
  We('[type="radio"]:checked')
], Kt.prototype, "checkedRadio", 2);
co([
  We("select")
], Kt.prototype, "select", 2);
co([
  Cr('[type="radio"]')
], Kt.prototype, "radioButtons", 2);
co([
  Cr("option")
], Kt.prototype, "options", 2);
co([
  De({ selector: "beacon-segmented-control" }, !0)
], Kt.prototype, "controls", 2);
co([
  Re
], Kt.prototype, "applyBaseResizeObserver", 1);
co([
  Re
], Kt.prototype, "setDefaultValue", 1);
const sm = {
  beaconTagName: "beacon-selection-tile"
}, w4 = ve`:where([beacon-tag-name=beacon-selection-tile]):has(:checked)::part(internal--tile){--selection-tile-background-color: var(--beacon-system-color-background-secondary-hover);--selection-tile-border-color: var(--beacon-system-color-border-active);outline:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-active)}:where([beacon-tag-name=beacon-selection-tile]):has(:checked)::part(internal--field){border-color:var(--beacon-system-color-background-primary)}:where([beacon-tag-name=beacon-selection-tile]):has(:active)::part(internal--tile){--selection-tile-background-color: var(--beacon-system-color-background-secondary-pressed)}:where([beacon-tag-name=beacon-selection-tile]):has(:disabled,[aria-disabled=true])::part(internal--field){border-color:var(--beacon-component-form-color-background-inactive)}:where([beacon-tag-name=beacon-selection-tile]):focus-within:has(input:focus-visible){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:where([beacon-tag-name=beacon-selection-tile]):focus-within:has(input:focus-visible):not(dialog){position:relative}`, k4 = ve`:host{border-radius:var(--beacon-system-radius-corner-standard)}.tile{background-color:var(--selection-tile-background-color, var(--beacon-system-color-background-1));block-size:100%;border:var(--selection-tile-border-width, var(--beacon-system-width-border-mini)) solid var(--selection-tile-border-color, var(--beacon-component-form-color-border-standard));border-radius:var(--beacon-system-radius-corner-standard);column-gap:var(--beacon-component-selection-tile-space-padding);display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto 1fr;padding:var(--beacon-component-selection-tile-space-padding);position:relative}.tile:hover{--selection-tile-background-color: var(--beacon-system-color-background-secondary-hover)}.tile.disabled{--selection-tile-background-color: transparent !important;--selection-tile-border-color: var(--beacon-system-color-border-inactive) !important}.tile.radio .field{border-radius:50%}.tile.checkbox .field{border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard)}.label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);grid-column:2/3;grid-row:1/2}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);block-size:fit-content;grid-column:2/3;grid-row:2/3;margin-block-start:var(--beacon-reference-space-3);pointer-events:none;position:relative;z-index:1}.field{align-self:center;background-color:var(--beacon-system-color-background-1);display:grid}::slotted(label):before{content:"";cursor:pointer;display:block;top:0;right:0;bottom:0;left:0;position:absolute}::slotted(input){margin:0;padding:0}::slotted(input:focus-visible){box-shadow:none!important;outline:0!important}::slotted(:is([type=checkbox],[type=radio])){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-component-selection-tile-icon-size);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);cursor:pointer;inline-size:var(--beacon-component-selection-tile-icon-size)}::slotted(:is([type=checkbox],[type=radio]):is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-background-inactive);border:0}::slotted([type=checkbox]){border:0;border-radius:var(--beacon-system-radius-corner-standard)}::slotted([type=checkbox]:checked){accent-color:var(--beacon-system-color-background-primary);-webkit-appearance:revert;-moz-appearance:revert;appearance:revert}::slotted([type=checkbox]:checked:is([aria-disabled=true],:disabled)){accent-color:var(--beacon-component-form-color-foreground-inactive)}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){::slotted([type=checkbox]:checked){-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-system-color-background-primary);background-image:url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.51852L5.78947 12L14 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");background-position:center;background-repeat:no-repeat;border-radius:unset}::slotted([type=checkbox]:checked:is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}}::slotted([type=radio]){border-radius:50%;padding:var(--beacon-reference-space-1)}::slotted([type=radio]:checked){background-clip:content-box;background-color:var(--beacon-system-color-background-primary);border-color:var(--beacon-system-color-background-primary)}::slotted([type=radio]:checked:is([aria-disabled=true],:disabled)){background-color:var(--beacon-component-form-color-foreground-inactive);border:0}`;
var Ya;
const Ac = class Ac extends Ge(Le).with(
  Cb,
  kb,
  Av
) {
  constructor() {
    super(...arguments);
    Ie(this, Ya);
    this.beaconTagName = sm.beaconTagName, Be(this, Ya, void 0);
  }
  static get styles() {
    return [super.styles, k4];
  }
  // Uses light DOM styles to control colors not otherwise accessible through ::slotted or events
  static get lightDOMStyles() {
    return [super.lightDOMStyles, w4];
  }
  postSetFormControlElement() {
    this.setDisabledState(), this.setInputType(), this.applyFieldElementObserver(), this.preventDisabledEventsOnElement(this.fieldElement);
  }
  postSetHintElement() {
    this.setFormControlAriaDescribedBy();
  }
  getAriaDescribedByIds() {
    var i;
    return [(i = this.hintElement) == null ? void 0 : i.id];
  }
  setFormControlAriaDescribedBy(e = this.getAriaDescribedByIds()) {
    if (!this.fieldElement) return;
    const i = e.filter(
      (o) => o
    );
    if (i.length === 0) {
      this.fieldElement.removeAttribute("aria-describedby");
      return;
    }
    this.fieldElement.setAttribute("aria-describedby", i.join(" "));
  }
  // component state is drived by changes to the slotted form element, i.e. disabled/aria-disabled
  applyFieldElementObserver() {
    this.fieldElement && !Te(this, Ya) && (Be(this, Ya, new MutationObserver(
      (e) => {
        e.find(
          (o) => o.attributeName === "aria-disabled" || o.attributeName === "disabled"
        ) && this.setDisabledState();
      }
    )), Te(this, Ya).observe(this.fieldElement, {
      attributes: !0
    }));
  }
  setDisabledState() {
    if (this.fieldElement) {
      if (this.fieldElement.disabled) {
        this.disabled = this.fieldElement.disabled;
        return;
      }
      const e = this.fieldElement.getAttribute("aria-disabled");
      e === null ? this.disabled = this.fieldElement.disabled : this.disabled = e === "true";
    }
  }
  render() {
    const e = {
      disabled: this.disabled,
      tile: !0
    };
    return this._inputType && (e[this._inputType] = !0), pe`
      <div class="${Pe(e)}" part="internal--tile">
        <div class="label" part="label">
          <slot name="label"></slot>
        </div>
        <div class="field" part="internal--field">
          ${this.renderFormControlTemplate()}
        </div>
        ${this.renderHintTemplate()}
      </div>
    `;
  }
};
Ya = new WeakMap(), Ac.tagName = sm.beaconTagName, Ac.nestedComponents = [Uc];
let lm = Ac;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const C4 = (a, t, e) => {
  for (const i of t) if (i[0] === a) return (0, i[1])();
  return e == null ? void 0 : e();
}, cm = {
  beaconTagName: "beacon-skeleton"
}, dm = {
  None: "none",
  Text: "text"
}, S4 = ve`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{block-size:100%;inline-size:100%}.template--text{display:flex;flex-direction:column;gap:.5em}.template--text>*:first-child{margin-block-end:var(--beacon-reference-space-5);min-block-size:2em}.template--text>*:last-child{inline-size:50%}.skeleton-indicator--image{aspect-ratio:2}.skeleton{block-size:inherit;display:flex;min-block-size:1em}.skeleton-indicator{animation-duration:calc(var(--beacon-reference-motion-duration-6) + var(--beacon-reference-motion-duration-12) * 2);animation-iteration-count:2;animation-name:wave;animation-timing-function:var(--beacon-system-motion-easing-wave-standard-1);background-color:var(--beacon-component-skeleton-color-start);flex:1 1 auto;inline-size:100%}.skeleton-indicator:not(.skeleton-indicator--image){border-radius:var(--beacon-system-radius-corner-standard)}@supports (background-color: color(from var(--beacon-component-skeleton-color-start) srgb-linear r g b)){@keyframes wave{0%{background-color:color(from var(--beacon-component-skeleton-color-start) srgb-linear r g b)}41%{background-color:color(from var(--beacon-component-skeleton-color-end) srgb-linear r g b);border:0}83%,to{background-color:color(from var(--beacon-component-skeleton-color-start) srgb-linear r g b)}}}@supports not (background-color: color(from var(--beacon-component-skeleton-color-start) srgb-linear r g b)){@keyframes wave{0%{background-color:var(--beacon-component-skeleton-color-start-fallback)}41%{background-color:var(--beacon-component-skeleton-color-end-fallback);border:0}83%,to{background-color:var(--beacon-component-skeleton-color-start-fallback)}}}`;
var E4 = Object.defineProperty, M4 = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && E4(t, e, o), o;
}, ca, yc, un, _h, pA;
const bA = (ca = class extends Le {
  constructor() {
    super();
    Ie(this, un);
    this.beaconTagName = cm.beaconTagName, this.motionState = "enabled", this.template = dm.None, this._internals && (this._internals.ariaHidden = "true");
  }
  static get styles() {
    return [super.styles, S4];
  }
  render() {
    return pe`
      ${C4(
      this.template,
      [
        [
          dm.Text,
          () => pe`
              <div class="template--${this.template}">
                ${No(
            cA(Te(ca, yc)),
            (e) => Ue(this, un, _h).call(this)
          )}
              </div>
            `
        ]
      ],
      () => Ue(this, un, _h).call(this)
    )}
    `;
  }
}, yc = new WeakMap(), un = new WeakSet(), _h = function() {
  return pe`
      <div
        class="skeleton skeleton--${this.template}"
        @animationstart=${Ue(this, un, pA)}>
        <div
          class="skeleton-indicator skeleton-indicator--${this.template}"></div>
      </div>
    `;
}, /**
 * Animations should end after 5 seconds per WCAG.
 * @link https://www.w3.org/WAI/WCAG22/quickref/?versions=2.1#pause-stop-hide
 */
pA = function(e) {
  setTimeout(() => this.motionState = "disabled", 5e3);
}, ca.tagName = cm.beaconTagName, /** For text templates. */
Ie(ca, yc, 4), ca);
M4([
  ue()
], bA.prototype, "template");
let lz = bA;
const T4 = ve`:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-3);--social-link-icon-container-size: var(--beacon-reference-space-5)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link],:root [beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-2);--social-link-icon-container-size: var(--beacon-reference-space-7)}}[beacon-tag-name=beacon-social-link]{--social-link-icon-instagram-pattern-url-heritage: url(#pattern0)}`, Zd = {
  beaconTagName: "beacon-social-link",
  iconMap: /* @__PURE__ */ new Map([
    [
      "facebook",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14217)">
          <path
            d="M16 8C16 3.58172 12.4183 -9.53674e-07 8 -9.53674e-07C3.58172 -9.53674e-07 0 3.58172 0 8C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94434 3.125 9.77172 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5537C9.55992 5.25 9.25 5.86667 9.25 6.49933V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z"
            fill="var(--social-link-facebook-color-fill-outside)" />
          <path
            d="M11.1141 10.3125L11.4688 8H9.25V6.49933C9.25 5.86667 9.55992 5.25 10.5537 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94434 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.1573 15.9667 7.57475 16 8 16C8.42525 16 8.8427 15.9667 9.25 15.9028V10.3125H11.1141Z"
            fill="var(--social-link-facebook-color-fill-inside)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14217">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "twitter",
      pe`<svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_2188_14227)">
          <path
            d="M14.3193 3.72903C14.329 3.86903 14.329 4.00903 14.329 4.15032C14.329 8.45548 11.0515 13.4206 5.05865 13.4206V13.4181C3.28832 13.4206 1.55478 12.9135 0.0644531 11.9574C0.321872 11.9884 0.580582 12.0039 0.839937 12.0045C2.30703 12.0058 3.73219 11.5135 4.88639 10.6071C3.49219 10.5806 2.26961 9.67161 1.84252 8.34451C2.3309 8.43871 2.83413 8.41935 3.31349 8.28838C1.79349 7.98129 0.699937 6.6458 0.699937 5.09484C0.699937 5.08064 0.699937 5.06709 0.699937 5.05354C1.15284 5.3058 1.65994 5.4458 2.17865 5.46129C0.747034 4.50451 0.305743 2.6 1.17026 1.11096C2.82445 3.14645 5.2651 4.38387 7.8851 4.51484C7.62252 3.38322 7.98123 2.19742 8.82768 1.40193C10.1399 0.168384 12.2038 0.23161 13.4374 1.54322C14.167 1.39935 14.8664 1.13161 15.5064 0.752255C15.2632 1.50645 14.7541 2.14709 14.0741 2.55419C14.7199 2.47806 15.3509 2.30516 15.9451 2.04129C15.5077 2.69677 14.9567 3.26774 14.3193 3.72903Z"
            fill="var(--social-link-twitter-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_2188_14227">
            <rect
              width="16"
              height="13.1613"
              fill="white"
              transform="translate(0 0.419998)" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "linkedin",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M14.8189 0H1.18111C0.867861 0 0.567441 0.124438 0.34594 0.34594C0.124438 0.567441 0 0.867861 0 1.18111V14.8189C0 15.1321 0.124438 15.4326 0.34594 15.6541C0.567441 15.8756 0.867861 16 1.18111 16H14.8189C15.1321 16 15.4326 15.8756 15.6541 15.6541C15.8756 15.4326 16 15.1321 16 14.8189V1.18111C16 0.867861 15.8756 0.567441 15.6541 0.34594C15.4326 0.124438 15.1321 0 14.8189 0ZM4.76889 13.63H2.36333V5.98889H4.76889V13.63ZM3.56445 4.93C3.29158 4.92846 3.02528 4.84613 2.79916 4.69339C2.57304 4.54065 2.39723 4.32435 2.29392 4.07179C2.19061 3.81923 2.16443 3.54173 2.21869 3.2743C2.27294 3.00688 2.4052 2.76152 2.59877 2.56919C2.79234 2.37686 3.03854 2.24618 3.30631 2.19364C3.57408 2.1411 3.85141 2.16906 4.1033 2.27399C4.35519 2.37892 4.57036 2.55611 4.72164 2.78321C4.87293 3.01031 4.95355 3.27713 4.95333 3.55C4.95591 3.73269 4.92167 3.91403 4.85267 4.0832C4.78368 4.25238 4.68132 4.40593 4.55171 4.53471C4.42211 4.66349 4.2679 4.76486 4.09828 4.83277C3.92867 4.90068 3.74711 4.93375 3.56445 4.93ZM13.6356 13.6367H11.2311V9.46222C11.2311 8.23111 10.7078 7.85111 10.0322 7.85111C9.31889 7.85111 8.61889 8.38889 8.61889 9.49333V13.6367H6.21333V5.99445H8.52667V7.05333H8.55778C8.79 6.58333 9.60333 5.78 10.8444 5.78C12.1867 5.78 13.6367 6.57667 13.6367 8.91L13.6356 13.6367Z"
          fill="var(--social-link-linkedin-color-fill)" />
      </svg>`
    ],
    [
      "youtube",
      pe`<svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <path
          d="M15.6656 2.14892C15.4816 1.46055 14.9395 0.918356 14.2511 0.73438C13.0033 0.400024 7.99996 0.400023 7.99996 0.400023C7.99996 0.400023 2.99666 0.400024 1.74888 0.73438C1.06052 0.918356 0.518326 1.46055 0.334352 2.14892C0 3.3967 0 6 0 6C0 6 0 8.60341 0.334352 9.85115C0.518326 10.5395 1.06052 11.0817 1.74888 11.2656C2.99666 11.6001 7.99996 11.6001 7.99996 11.6001C7.99996 11.6001 13.0033 11.6001 14.2511 11.2656C14.9395 11.0817 15.4816 10.5395 15.6656 9.85115C16 8.60341 16 6 16 6C16 6 16 3.3967 15.6656 2.14892Z"
          fill="var(--social-link-youtube-color-fill-outside)" />
        <path
          d="M6.40039 8.40002L10.5572 6.00004L6.40039 3.6V8.40002Z"
          fill="var(--social-link-youtube-color-fill-inside)" />
      </svg>`
    ],
    [
      "x",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="presentation">
        <g clip-path="url(#clip0_1286_254)">
          <path
            d="M9.48734 6.77491L15.3156 0H13.9345L8.87381 5.88256L4.83185 0H0.169922L6.28217 8.89547L0.169922 16H1.55112L6.89534 9.78782L11.164 16H15.8259L9.48701 6.77491H9.48734ZM7.59561 8.97384L6.97631 8.08805L2.04878 1.03974H4.17022L8.14679 6.72795L8.76609 7.61374L13.9352 15.0075H11.8137L7.59561 8.97418V8.97384Z"
            fill="var(--social-link-x-color-fill)" />
        </g>
        <defs>
          <clipPath id="clip0_1286_254">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "instagram",
      pe`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-hidden="true">
        <g clip-path="url(#clip0_2188_14249)">
          <mask
            id="mask0_2188_14249"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16">
            <path
              d="M4.70349 0.0949238C3.85651 0.1349 3.27802 0.270564 2.77251 0.468642C2.24921 0.672648 1.80561 0.946046 1.36433 1.38914C0.922524 1.83249 0.651202 2.27688 0.448748 2.8007C0.252733 3.3075 0.119906 3.88627 0.0825045 4.73377C0.0453702 5.58283 0.0368544 5.85363 0.0409937 8.01522C0.045117 10.1765 0.0546566 10.4479 0.0951453 11.2972C0.135632 12.1439 0.27079 12.7222 0.468867 13.2279C0.673131 13.7512 0.946248 14.1946 1.38959 14.6361C1.83269 15.0777 2.27733 15.3488 2.8014 15.5515C3.30768 15.7472 3.88669 15.8806 4.73393 15.9177C5.58298 15.9551 5.85403 15.9634 8.01507 15.9592C10.1771 15.9551 10.4482 15.9456 11.2972 15.9053C12.1442 15.8648 12.7222 15.7292 13.2282 15.5316C13.7515 15.3268 14.1951 15.0542 14.6364 14.6109C15.0777 14.1678 15.349 13.7231 15.5515 13.199C15.7475 12.6927 15.8808 12.1137 15.9177 11.267C15.9549 10.4174 15.9636 10.1461 15.9595 7.98478C15.9554 5.8232 15.9456 5.55239 15.9053 4.7036C15.8651 3.85609 15.7294 3.27811 15.5316 2.77208C15.3271 2.24877 15.0542 1.80567 14.6111 1.36387C14.1681 0.922574 13.7234 0.650729 13.1993 0.448785C12.6928 0.252768 12.1141 0.119166 11.2668 0.0825425C10.4178 0.0448876 10.1467 0.0366393 7.9849 0.0407642C5.8236 0.0448892 5.55255 0.0541772 4.70349 0.0949238ZM4.79635 14.485C4.02029 14.4512 3.59887 14.3222 3.31801 14.2142C2.94609 14.0703 2.68071 13.8977 2.40139 13.6205C2.12259 13.3422 1.94952 13.0776 1.80432 12.7064C1.69522 12.4255 1.56395 12.0046 1.52758 11.2286C1.48812 10.3896 1.4791 10.1378 1.47523 8.01237C1.4711 5.88742 1.47883 5.63569 1.51546 4.79593C1.54873 4.02038 1.67847 3.59843 1.78627 3.31782C1.93017 2.94539 2.1022 2.68051 2.37998 2.4012C2.65826 2.12187 2.92287 1.94933 3.29427 1.80412C3.57488 1.6945 3.99579 1.56426 4.77159 1.52738C5.61109 1.48766 5.86255 1.47915 7.98747 1.47502C10.1129 1.47089 10.3646 1.47838 11.2044 1.51526C11.9799 1.54904 12.4019 1.67749 12.6822 1.78607C13.0544 1.92998 13.3198 2.1015 13.5988 2.37979C13.8779 2.65808 14.051 2.92218 14.1962 3.29435C14.3058 3.57418 14.436 3.99562 14.4726 4.77117C14.5126 5.61068 14.5217 5.8624 14.5255 7.98736C14.5296 10.1128 14.5219 10.3646 14.485 11.2038C14.4512 11.9799 14.3225 12.4016 14.2142 12.6827C14.0703 13.0543 13.8983 13.3197 13.6202 13.5991C13.3422 13.8773 13.0776 14.0509 12.706 14.1961C12.4259 14.3055 12.0044 14.436 11.2292 14.4729C10.3897 14.5123 10.1382 14.5214 8.01249 14.5252C5.88756 14.5294 5.6361 14.5214 4.79635 14.485ZM11.2856 3.74493C11.2867 4.27211 11.7153 4.69896 12.2425 4.69792C12.7699 4.69689 13.1968 4.2685 13.196 3.74132C13.195 3.21414 12.7663 2.78704 12.2389 2.78807C11.7115 2.7891 11.2846 3.21775 11.2856 3.74493ZM3.91301 8.00773C3.91739 10.2653 5.75088 12.0913 8.00785 12.0869C10.2651 12.0825 12.0921 10.2495 12.0877 7.99201C12.0834 5.73526 10.2496 3.90819 7.99212 3.91257C5.73513 3.91696 3.90862 5.75073 3.91301 8.00773ZM5.34673 8.0049C5.34414 6.53969 6.53002 5.34942 7.99496 5.34683C9.46015 5.344 10.6507 6.52937 10.6535 7.99484C10.6563 9.46031 9.47047 10.6503 8.00501 10.6532C6.54008 10.656 5.34956 9.47037 5.34673 8.0049Z"
              fill="white" />
          </mask>
          <g mask="url(#mask0_2188_14249)">
            <mask
              id="mask1_2188_14249"
              style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="-1"
              y="-1"
              width="18"
              height="18">
              <path
                d="M16.5905 -0.583628H-0.603516V16.6106H16.5905V-0.583628Z"
                fill="white" />
            </mask>
            <g mask="url(#mask1_2188_14249)">
              <mask
                id="mask2_2188_14249"
                style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="-1"
                y="-1"
                width="18"
                height="18">
                <path
                  d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                  fill="white" />
              </mask>
              <g mask="url(#mask2_2188_14249)">
                <mask
                  id="mask3_2188_14249"
                  style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="-1"
                  y="-1"
                  width="18"
                  height="18">
                  <path
                    d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z"
                    fill="white" />
                </mask>
                <g mask="url(#mask3_2188_14249)">
                  <rect
                    x="-0.689453"
                    y="-0.665792"
                    width="17.3622"
                    height="17.3622"
                    fill="var(--social-link-instagram-color-fill)" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1">
            <use
              xlink:href="#image0_2188_14249"
              transform="scale(0.000439947)" />
          </pattern>
          <clipPath id="clip0_2188_14249">
            <rect width="16" height="16" fill="white" />
          </clipPath>
          <image
            id="image0_2188_14249"
            width="2273"
            height="2275"
            xlink:href="data:image/jpeg;base64,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" />
        </defs>
      </svg>`
    ]
  ])
}, L4 = ve`[beacon-tag-name=beacon-social-link]{padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-social-link] a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-social-link] a:not(:hover,:focus){text-decoration:none}`, O4 = ve`:root,.beacon-on-light,.beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],.beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-lighter,.beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],.beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-dark,.beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],.beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker,.beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: none;--social-link-facebook-color-fill-outside: #fff;--social-link-instagram-color-fill: #fff;--social-link-linkedin-color-fill: #fff;--social-link-twitter-color-fill: #fff;--social-link-x-color-fill: #fff;--social-link-youtube-color-fill-inside: #253746;--social-link-youtube-color-fill-outside: #fff}`, P4 = ve`:host{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);align-items:center;display:flex;gap:var(--social-link-flex-gap)}.icon-slot{--icon-container-size: var(--social-link-icon-container-size);block-size:var(--icon-container-size);display:flex;inline-size:var(--icon-container-size)}.icon-slot svg{--icon-size: var(--beacon-reference-space-5);block-size:var(--icon-size);inline-size:var(--icon-size);margin:auto}`;
var D4 = Object.defineProperty, z4 = Object.getOwnPropertyDescriptor, qc = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? z4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && D4(t, e, o), o;
};
const pp = class pp extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Zd.beaconTagName, this.componentModeStyles = [O4], this.icon = pe``;
  }
  static get styles() {
    return [super.styles, P4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, T4, L4];
  }
  /** The textContent of the first element in the title nodes. */
  get nameElementText() {
    var e;
    if (this.nameNodes.length < 1)
      return console.warn("No text found in the default slot."), "";
    const t = Array.from(this.nameNodes).find(
      (i) => i.nodeName === "A"
    );
    return (e = t == null ? void 0 : t.textContent) != null ? e : "";
  }
  /**
   * Renders the appropriate icon based on the text passed into the name slot.
   *
   * If the name can't be matched, no icon is rendered.
   */
  renderIcon() {
    const t = this.nameElementText.toLowerCase(), e = Zd.iconMap.get(t);
    this.icon = e || pe``;
  }
  postrenderMethods() {
    this.renderIcon(), this.renderComponentModeStyles();
  }
  render() {
    return pe` <div class="icon-slot">
        <slot name="icon">${this.icon}</slot>
      </div>
      <div class="name">
        <slot></slot>
      </div>`;
  }
};
pp.tagName = Zd.beaconTagName;
let mr = pp;
qc([
  Ce()
], mr.prototype, "icon", 2);
qc([
  Ct()
], mr.prototype, "nameNodes", 2);
qc([
  We(".icon-slot")
], mr.prototype, "iconSlot", 2);
qc([
  Re
], mr.prototype, "postrenderMethods", 1);
const I4 = ve`:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-2);--social-link-container-links-gap: var(--beacon-reference-space-2)}@media (width >= 960px){:root[beacon-tag-name=beacon-social-link-container],:root [beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-social-link-container],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"][beacon-tag-name=beacon-social-link-container],[beacon-version="4.4.0"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-6);--social-link-container-links-gap: var(--beacon-reference-space-7)}}`, hm = {
  beaconTagName: "beacon-social-link-container"
}, B4 = ve`:host,.links,.links ::slotted(ul){display:flex;flex-direction:var(--container-flex-direction, column);gap:var(--container-flex-gap)}:host{--container-flex-gap: var(--social-link-container-flex-gap)}.links{--container-flex-gap: var(--social-link-container-links-gap)}::slotted(*){margin:0}.text ::slotted([slot=text]){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-50)!important;margin-block:var(--social-link-container-text-margin-block-start, 0) var(--social-link-container-text-margin-block-end, 0)!important;padding-block:var(--beacon-system-space-cell-free-floating)!important}@media (width >= 960px){:host,.links{--container-flex-direction: row;align-items:center}}`, up = class up extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = hm.beaconTagName;
  }
  static get styles() {
    return [super.styles, B4];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, I4];
  }
  render() {
    return pe`<div class="text">
        <slot name="text"></slot>
      </div>
      <div class="links">
        <slot @slotchange=${Js()}></slot>
      </div>`;
  }
};
up.tagName = hm.beaconTagName;
let bm = up;
var ta = /* @__PURE__ */ ((a) => (a.STANDARD = "standard", a.INLINE_ICON = "inline-icon", a.STACKED_ICON = "stacked-icon", a))(ta || {}), Ao = /* @__PURE__ */ ((a) => (a.PRIMARY = "primary", a.SECONDARY = "secondary", a.TERTIARY = "tertiary", a.PAGINATION = "pagination", a.ZONED = "zoned", a))(Ao || {});
const oa = {
  beaconTagName: "beacon-tab",
  dataMetricsType: { TAB: "TAB" },
  dataMetricsClickable: !0,
  dataMetricsLocation: { PU: "PU" }
}, R4 = ve`:host{--tab-background-color: var(--beacon-system-color-background-primary);display:flex}:host .tab{--direction: row;--icon-size: var(--beacon-reference-space-5);--justified: center;--slot-display: none;--tab-block-size: var(--tabs-tab-size-block-size-default);--tab-font-color: var(--beacon-system-color-text-primary);--text-decoration: initial;--wrapping: var(--tabs-overflow-wrapping, initial);align-items:center;background-color:var(--tab-background-color);border:0;cursor:pointer;display:flex;flex-direction:var(--direction);gap:var(--beacon-reference-space-2);inline-size:inherit;justify-content:var(--justified);max-inline-size:var(--tabs-tab-size-max-inline-size);min-block-size:var(--tab-block-size);min-inline-size:var(--tabs-tab-size-min-inline-size);padding-block:var(--tab-padding);padding-inline:var(--tab-padding);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300)}:host .tab span,:host .tab ::slotted(*){color:var(--tab-font-color);display:block;margin-block:var(--tabs-tab-title-space-margin-block-start) var(--tabs-tab-title-space-margin-block-end);margin-inline:var(--tabs-tab-title-space-margin-inline);text-decoration:var(--text-decoration);white-space:var(--wrapping)}:host .tab [name=tab-icon]{align-items:flex-end;block-size:var(--icon-size);box-sizing:border-box;display:var(--slot-display);inline-size:var(--icon-size);justify-content:center;margin-block:var(--tabs-tab-icon-space-margin-block);margin-inline-start:var(--tabs-tab-icon-space-margin-inline-start)}:host .tab [slot=tab-icon][name=placeholder]{background-color:#79e6ff99;color:#8b57d94d}:host .tab.primary:active{--tab-background-color: var(--beacon-system-color-background-primary-pressed)}:host .tab:hover{--text-decoration: underline;--tab-background-color: var(--beacon-system-color-background-primary-hover)}:host .tab:is(.stacked-icon,.inline-icon){--justified: initial;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-with-icon);--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.stacked-icon{--direction: column;--icon-size: var(--beacon-reference-space-9)}:host .tab.inline-icon{--direction: var(--tabs-tab-flex-direction)}:host .tab:is(.secondary,.tertiary){--tab-font-color: var(--beacon-system-color-text-link);inline-size:revert;min-block-size:revert;padding-block:calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));padding-inline:0}:host .tab:is(.secondary,.tertiary) span{margin:0}:host .tab:is(.primary,.secondary,.tertiary):active{--text-decoration: none}:host :host([more]) [name=tab-icon]{background-color:initial;border-color:initial;border-style:initial;border-width:initial}:host .tab.selected,:host .tab.selected:is(.secondary,.tertiary){--tab-background-color: var(--beacon-system-color-background-0);--tab-font-color: unset;font-weight:var(--beacon-system-font-weight-bold)}:host .tab.standard{--wrapping: var(--tabs-overflow-wrapping, nowrap)}:host .tab.secondary{background-color:transparent;block-size:var(--tabs-size-block-size-secondary)}:host .tab.tertiary{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);background-color:transparent;block-size:var(--tabs-tab-size-block-size-tertiary);padding-block:var(--beacon-system-space-cell-free-floating) var(--beacon-system-space-cell-free-floating)}:host .tab.selected:is(.secondary,.tertiary){border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-brand)}:host .tab.secondary.inline-icon{--direction: row;--icon-size: var(--beacon-reference-space-5);padding-block:var(--tab-space-secondary-padding-block) var(--tab-space-secondary-padding-block)}:host .tab.secondary.inline-icon span,:host .tab.secondary.inline-icon ::slotted(*){align-self:var(--tab-span-align-self);margin-block-start:var(--tabs-tab-title-space-secondary-margin-block-start);margin-inline-start:var(--tabs-tab-title-space-secondary-margin-inline-start)}:host .tab.secondary.inline-icon [name=tab-icon]{align-self:var(--tab-icon-align-self);margin-block:0;margin-inline-start:0}:host(:focus-visible){outline:none}:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{--tab-font-color: var(--beacon-system-color-text-set-navy);background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:focus-visible) .tab:is(.secondary,.tertiary),:host(:focus-visible) .tab:is(.secondary,.tertiary).selected{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}:host(:focus-visible) .tab.primary{--inset-middle-border-width: calc(var(--beacon-system-width-border-maxi) - var(--beacon-system-width-border-normal));box-shadow:inset 0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-outer),inset 0 0 0 var(--inset-middle-border-width) var(--beacon-system-color-border-focus-middle);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:calc(var(--beacon-system-width-border-maxi) * -1)}@media (width >= 640px){:host .tab.inline-icon{--justified: center;--direction: row;--slot-display: flex;--tab-block-size: var(--tabs-tab-size-block-size-default)}}`;
var N4 = Object.defineProperty, F4 = Object.getOwnPropertyDescriptor, Po = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? F4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && N4(t, e, o), o;
};
const ds = class ds extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = oa.beaconTagName, this.focusOverride = !0, this.variant = Ao.PRIMARY, this.tabType = ta.STANDARD, this.ariaSelected = "false", this.more = !1, this.ariaControls = "tabpanel-0", this.getFallbackIcon = () => this.tabType === ta.INLINE_ICON ? ze`<${this.getScopedTag("beacon-icon")} name="placeholder" size="s" slot="tab-icon"></${this.getScopedTag("beacon-icon")}>` : this.tabType === ta.STACKED_ICON ? ze`<${this.getScopedTag("beacon-icon")} name="placeholder" size="m" slot="tab-icon"></${this.getScopedTag("beacon-icon")}>` : je, this.getTabTypeClass = () => this.variant === Ao.PRIMARY ? this.tabType : this.variant === Ao.SECONDARY && this.tabType !== ta.STANDARD ? ta.INLINE_ICON : ta.STANDARD;
  }
  static get styles() {
    return [super.styles, R4];
  }
  /**
   * Emits the click event when using the keyboard to navigate the tabs.
   * @param event Keyboard Event
   */
  handleKeydown(t) {
    ["Enter", " "].includes(t.key) && (this.emitClick(), t.preventDefault());
  }
  /**
   * Sets the tabindex property dependent on the this.ariaSelected property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(t) {
    t && t.has("ariaSelected") && (this.tabIndex = this.ariaSelected === "true" ? 0 : -1);
  }
  addIconAnalytics() {
    this.TabIcons.forEach((t) => {
      t.setAttribute(
        wo.TYPE,
        oa.dataMetricsType.TAB
      ), t.setAttribute(
        wo.CLICKABLE,
        `${oa.dataMetricsClickable}`
      ), t.setAttribute(wo.TEXT, this.label);
    });
  }
  addStyles() {
    this.setAttribute("role", "tab"), this.more && (this.removeAttribute("aria-controls"), this.setAttribute("aria-haspopup", "dialog"));
  }
  addEventListeners() {
    this.addEventListener("click", this.emitClick), this.addEventListener("keydown", this.handleKeydown);
  }
  /**
   * Tabs don't use button elements due to Axe Core rule for aria required children.
   * The tabs themselves need the `role` of "tab", not interior elements.
   * Otherwise, the tablist container doesn't know where tabs are since we are using Shadow DOM.
   *
   * It isn't enough to remove the role from the button element because that causes a separate a11y error
   * of having interactive elements contained inside interactive elements
   * (buttons inside an element with role of tab). We use `div`s with a `tabindex` or 0 to allow focus,
   * and listen for keydown events to select tabs on Enter or Spacebar.
   *
   * @link https://dequeuniversity.com/rules/axe/4.6/aria-required-children?application=axeAPI
   */
  render() {
    return pe`<div
      class="tab ${this.variant} ${this.getTabTypeClass()} ${this.ariaSelected === "true" ? "selected" : ""}"
      data-metrics-type="${oa.dataMetricsType.TAB}"
      data-metrics-clickable="${oa.dataMetricsClickable}">
      <slot name="tab-icon" @slotchange=${this.addIconAnalytics}
        >${this.getFallbackIcon()}</slot
      >
      <span>${this.label}</span>
    </div>`;
  }
};
ds.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, ds.tagName = oa.beaconTagName, ds.nestedComponents = [ro];
let Bt = ds;
Po([
  ue({ reflect: !0 })
], Bt.prototype, "variant", 2);
Po([
  ue({ reflect: !0, attribute: "tab-type" })
], Bt.prototype, "tabType", 2);
Po([
  ue({ type: String })
], Bt.prototype, "label", 2);
Po([
  ue({ reflect: !0 })
], Bt.prototype, "value", 2);
Po([
  ue({ reflect: !0, attribute: "aria-selected" })
], Bt.prototype, "ariaSelected", 2);
Po([
  ue({ type: Boolean })
], Bt.prototype, "more", 2);
Po([
  ue({ reflect: !0, attribute: "aria-controls" })
], Bt.prototype, "ariaControls", 2);
Po([
  De({ slot: "tab-icon", selector: "svg" })
], Bt.prototype, "TabIcons", 2);
Po([
  We(".tab")
], Bt.prototype, "tab", 2);
Po([
  Re
], Bt.prototype, "addIconAnalytics", 1);
Po([
  Re
], Bt.prototype, "addStyles", 1);
Po([
  Re
], Bt.prototype, "addEventListeners", 1);
const pm = {
  beaconTagName: "beacon-tab-panel"
}, j4 = ve`:host([aria-hidden=true]){display:none}:host(:focus-visible){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:focus-visible):not(dialog){position:relative}`;
var _4 = Object.defineProperty, Yc = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && _4(t, e, o), o;
};
const xc = class xc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = pm.beaconTagName, this.ariaHidden = "true", this.role = "tabpanel", this.tabIndex = -1;
  }
  static get styles() {
    return [super.styles, j4];
  }
  /**
   * Sets tabindex based on ariaHidden property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(t) {
    t && t.has("ariaHidden") && (this.tabIndex = this.ariaHidden === "true" ? -1 : 0);
  }
  render() {
    return pe`<slot></slot>`;
  }
};
xc.shadowRootOptions = {
  ...Le.shadowRootOptions,
  delegatesFocus: !1
}, xc.tagName = pm.beaconTagName;
let fr = xc;
Yc([
  ue({ reflect: !0 })
], fr.prototype, "value");
Yc([
  ue({ reflect: !0, attribute: "aria-hidden" })
], fr.prototype, "ariaHidden");
Yc([
  ue({ reflect: !0 })
], fr.prototype, "role");
Yc([
  ue({ reflect: !0, attribute: "tabindex" })
], fr.prototype, "tabIndex");
var Kn = /* @__PURE__ */ ((a) => (a[a.DEFAULT = 4] = "DEFAULT", a[a.MEDIUM = 5] = "MEDIUM", a[a.LARGE = 7] = "LARGE", a[a.XLARGE = 7] = "XLARGE", a))(Kn || {});
const U4 = ve`:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-5);--tabs-size-block-size-secondary: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating) + var(--caption-300-line-height) + var(--beacon-system-width-border-normal));--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-8);--tabs-menu-item-space-padding: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tabs-menu-item-space-margin-block-start: var(--beacon-reference-space-5);--tabs-menu-max-block-size: 100%;--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--tabs-menu-item-block-size: var(--beacon-reference-space-12);--tabs-tab-title-space-margin-block-end: 0;--tabs-tab-title-space-margin-block-start: 0;--tabs-tab-title-space-margin-inline: 0;--tabs-tab-icon-space-margin-block: 0;--tabs-tab-icon-space-margin-inline-start: 0;--tabs-tab-title-space-secondary-margin-block-start: 0;--tabs-tab-title-space-secondary-margin-inline-start: 0;--tabs-tab-size-block-size-default: var(--beacon-reference-space-11);--tabs-tab-size-block-size-with-icon: var(--beacon-reference-space-14);--tabs-menu-item-space-padding-block-start: 0;--tab-padding: calc(2 * var(--beacon-system-space-cell-contained));--tab-space-secondary-padding-block: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tab-icon-align-self: center;--tab-span-align-self: center;--tabs-tab-size-min-inline-size: fit-content;--tabs-tab-size-max-inline-size: unset;--tabs-tab-flex-direction: row}@media (width >= 640px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-6);--tabs-tab-size-block-size-default: 3.25rem;--tabs-menu-item-space-margin-block-start: 0;--tabs-menu-max-block-size: calc(var(--tabs-menu-item-block-size) * 9 + var(--beacon-reference-space-10) + 40px);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: 3.75rem;--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-9)}}@media (width >= 960px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-7);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"][beacon-tag-name=beacon-tabs],[beacon-version="4.4.0"] [beacon-tag-name=beacon-tabs]{--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-10);--tabs-tab-size-block-size-with-icon: calc(19 * var(--beacon-reference-space-2));--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: var(--beacon-reference-space-13)}}`;
function $4(a) {
  return a <= no.DEFAULT ? Kn.DEFAULT : a <= no.MEDIUM ? Kn.MEDIUM : a <= no.LARGE ? Kn.LARGE : Kn.XLARGE;
}
function H4(a, t) {
  const { scrollTop: e } = a, i = 0, o = "scrolled-close-button-row", n = t.classList.contains(o);
  e !== i && t.classList.add(o), e === i && n && t.classList.remove(o);
}
function K4(a) {
  return {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: a - 1
  };
}
function G4(a, t, e, i) {
  const o = t - 1, n = e - 1, l = i ? 1 : 0, L = {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: o - l
  };
  return e < t && (L.lastVisibleTabIndex = n), a >= t && (L.firstVisibleTabIndex = a - o, L.lastVisibleTabIndex = a - l), L;
}
function um(a, t, e, i, o) {
  return o ? K4(e) : G4(
    a,
    t,
    e,
    i
  );
}
const W4 = ve`[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab]{inline-size:100%}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary],[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]{inline-size:fit-content;margin-inline-end:var(--beacon-system-space-micro-maxi)}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary]:last-of-type,[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]:last-of-type{margin-inline-end:0}`, V4 = ve`:host{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}[beacon-tag-name=beacon-tab]{inline-size:100%}.tablist,.menu-tablist{display:flex;inline-size:100%}.tablist{-webkit-hyphens:auto;hyphens:auto;max-inline-size:100vw;overflow-wrap:anywhere}.menu-tablist{flex-direction:column;overflow:auto;padding-block-start:var(--beacon-system-space-cell-contained)}:host([tab-type=stacked-icon][scrollable]),:host([tab-type=inline-icon][scrollable]){--tab-width-non-scrollable: 100%}:host([tab-type=stacked-icon][scrollable]) .tablist,:host([tab-type=inline-icon][scrollable]) .tablist{inline-size:max-content}:host([tab-type=inline-icon][scrollable][variant=secondary]) .tablist{inline-size:100%}:host([variant=secondary]) .container{block-size:var(--tabs-size-block-size-secondary);border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-0);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=tertiary]) .container{block-size:var(--tabs-tab-size-block-size-tertiary);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=secondary]) .tablist:focus-within,:host([variant=tertiary]) .tablist:focus-within{block-size:calc(100% + var(--total-ring-width))}:host([variant=secondary][scrolled]) .container,:host([variant=tertiary][scrolled]) .container{inline-size:100vw;inset-inline-start:0;position:absolute}:host([variant=secondary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-size-block-size-secondary))}:host([variant=tertiary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-tab-size-block-size-tertiary))}:host([scrollable]){--scrollbar-visible: hidden;--scrollbar-hover-visible: hidden}:host([scrollable]) ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar{display:none}:host([scrollable]) .tablist{overflow-x:auto}:host([scrollable]) .tablist:hover{--scrollbar-visible: var(--scrollbar-hover-visible)}:host([scrollable]) ::-webkit-scrollbar-thumb{visibility:var(--scrollbar-visible)}:host(:not([scrollable])) dialog{--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-bg-color-hover: rgb(7 96 141 / 100%);--override-icon-button-bg-color-pressed: rgb(6 83 121 / 100%)}:host([overflowing-x=true]:not([scrollable])){--tabs-overflow-wrapping: normal}:host([tab-type=stacked-icon]:not([scrollable])){--tab-width-non-scrollable: 100%}.overlay{--close-button-padding-block: var(--beacon-reference-space-3) 0;align-items:center;background-color:#002f48a3;display:flex;flex-direction:column;inline-size:100%;top:0;right:0;bottom:0;left:0;justify-content:center;position:fixed}.overlay ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.overlay ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.overlay dialog{align-items:center;background-color:var(--beacon-system-color-background-primary);block-size:100dvh;border:0;box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8);box-sizing:border-box;display:flex;flex-direction:column;inline-size:var(--tabs-menu-max-inline-size);max-block-size:var(--tabs-menu-max-block-size);padding:0}.overlay dialog h2{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-reference-palette-grayscale-white);display:flex;margin:0}.overlay dialog .scrolled-close-button-row{--close-button-padding-block: var(--beacon-reference-space-3);box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8)}.close-button-row{background-color:var(--beacon-system-color-background-primary);display:flex;flex-direction:row-reverse;inline-size:100%;inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky}.close-button-row [beacon-tag-name=beacon-icon-button]{padding-block:var(--close-button-padding-block);padding-inline-end:var(--beacon-reference-space-3)}.menu-item{--menu-item-underline: initial;align-items:center;background-color:var(--beacon-system-color-background-primary);border:0;box-sizing:border-box;color:var(--beacon-system-color-text-primary);cursor:default;display:flex;inline-size:100%;justify-content:center;min-block-size:var(--tabs-menu-item-block-size);padding:var(--tabs-menu-item-space-padding)}.menu-item[aria-selected=true]{background-color:var(--beacon-component-tab-menu-color-background-primary-active)}.menu-item[aria-selected=true] span{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.menu-item span{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);padding-block-start:var(--tabs-menu-item-space-padding-block-start);text-decoration:var(--menu-item-underline)}.menu-item:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1;align-self:center;inline-size:calc(100% - var(--total-ring-width))}.menu-item:focus-visible:not(dialog){position:relative}.menu-item--btn{cursor:pointer}.menu-item:hover{--menu-item-underline: underline}.menu-item:first-of-type{margin-block-start:var(--tabs-menu-item-space-margin-block-start)}.menu-item:last-of-type{margin-block-end:var(--beacon-system-space-organism-jumbo)}.hide,::slotted(.hide){display:none}@media (width >= 320px){:host([tab-type=inline-icon]){--tab-width-non-scrollable: 100%}:host([tab-type=inline-icon]) .tablist{inline-size:100%}}@media (width >= 640px){:host([scrollable]) ::-webkit-scrollbar{display:block}:host([scrollable][variant=primary]){--scrollbar-hover-visible: visible}.overlay dialog{block-size:unset;max-block-size:100dvh}}`;
var q4 = Object.defineProperty, Y4 = Object.getOwnPropertyDescriptor, ht = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? Y4(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && q4(t, e, o), o;
};
const gm = "beacon-tabs", Ra = "hide", X4 = "1", Q4 = "", Z4 = "tabChildren", J4 = "currentMaxTabs", eD = "scrollable", tD = "tabType", oD = "variant", iD = "DIALOG", aD = "tab-list", nD = 320;
var Xa, Ot;
const lt = (Ot = class extends Ge(Le).with(ub) {
  constructor() {
    super(...arguments);
    Ie(this, Xa);
    this.beaconTagName = gm, this.focusOverride = !0, this.currentTotalTabs = 0, this.currentMaxTabs = Kn.XLARGE, this.scrollable = !1, this.scrolled = !1, this.closeOnClickOut = !0, this.variant = Ao.PRIMARY, this.tabType = ta.STACKED_ICON, this.menuTitle = "Choose a view:", Be(this, Xa, ""), this.menuOpen = !1, this.markedAsOverflowingX = !1, this.markedAsMenuOverFlowingY = !1, this.id = _i(), this.tabsResizeObserver = new ResizeObserver((e) => {
      var D, j;
      let i, o;
      const n = e.find(
        (I) => I
      ), { borderBoxSize: l, contentRect: L } = n;
      if (l && (o = Array.isArray(l) ? l[0] : l), ((D = n == null ? void 0 : n.target) == null ? void 0 : D.tagName) === iD && this.menuOpen && !this.markedAsMenuOverFlowingY) {
        const I = Math.ceil(o.blockSize || L.height), B = n.target.scrollHeight;
        this.observeHeight(I, B);
      } else (n == null ? void 0 : n.target.id) === aD ? (i = Math.ceil(o.inlineSize || L.width), this.observePrimaryTabsWidth(i)) : (i = Math.ceil((j = o.inlineSize || (L == null ? void 0 : L.width)) != null ? j : 0), this.observeBodyWidth(i));
    }), this.toggleTabListScrollClass = () => {
      const { scrollLeft: e } = this.tabListElement;
      e === 0 ? this.scrolled = !1 : this.scrolled = !0;
    }, this.buildTabMenuItem = (e) => pe`<button
      role="tab"
      data-metrics-type="${oa.dataMetricsType.TAB}"
      value="${e.value}"
      class="menu-item menu-item--btn"
      aria-selected="${e.ariaSelected}"
      @click=${this.handleMenuTabClick}>
      <span>${e.label}</span>
    </button>`, this.buildTabMenu = (e) => pe`${e.map((i) => this.buildTabMenuItem(i))}`, this.handleKeydown = (e) => {
      this.handleArrowControlKeydown(
        e,
        this.getArrowControlElements(),
        "horizontal",
        Ot.arrowControlFocusCallback
      );
    };
  }
  static get styles() {
    return [super.styles, V4];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, U4, W4];
  }
  get selected() {
    return Te(this, Xa);
  }
  set selected(e) {
    const i = parseInt(e, 10);
    if (isNaN(i)) {
      const o = this.querySelector(
        this.getScopedTagName("beacon-tab") + `#${e}`
      );
      Be(this, Xa, o instanceof Bt ? o.value : e);
    } else
      Be(this, Xa, i.toString());
  }
  /**
   * Getter for a Boolean property indicating whether the more button and more menu should be rendered
   */
  get shouldShowMore() {
    return !this.scrollable && this.currentTotalTabs > this.currentMaxTabs && this.variant === Ao.PRIMARY;
  }
  /**
   * Getter for the Scroll Width of the tab list, used in calculating overflow
   */
  get TabsWidth() {
    return this.tabListElement.scrollWidth;
  }
  /**
   * Observer logic to conditionally apply the overflow class
   * and update the max amount of visible tabs allowed based
   * on an input tabList width
   * @param width the width of the tablist contentRect
   */
  observePrimaryTabsWidth(e) {
    this.handleOverflowing();
    const i = $4(e);
    this.currentMaxTabs !== i && (this.currentMaxTabs = i, this.requestUpdate());
  }
  /**
   * Conditionally applies a scroll listener to the moreMenu if and only if the moreMenu is overflowing
   * for the first time
   * @param moreMenuHeight the height of the more menu currently visible on the screen
   * @param moreMenuScrollHeight the complete height of the more menu including what's vertically scrollable
   */
  observeHeight(e, i) {
    this.closeButtonRow && e < i && (this.markedAsMenuOverFlowingY = !0, this.tabMenu.addEventListener(et.SCROLL, () => {
      H4(this.tabMenu, this.closeButtonRow);
    }));
  }
  /**
   * Checks the width of the body element. If it's at mobile breakpoint width adds scroll listener that toggles
   * full-width 'scrolled' styles for tab-list. For performance reasons, removes scroll listener when width is
   * bigger than mobile breakpoint.
   * @param width of the body element
   */
  observeBodyWidth(e) {
    e <= nD ? (this.toggleTabListScrollClass(), this.tabListElement.addEventListener(
      et.SCROLL,
      this.toggleTabListScrollClass
    )) : (this.tabListElement.removeEventListener(
      et.SCROLL,
      this.toggleTabListScrollClass
    ), this.scrolled = !1);
  }
  /**
   * checks the scrollWidth of the tab list element,
   * then compares the scrollWidth to the window innerWidth
   * to determine if the tabs are overflowing.
   * Applies an overflow class to the tabs if they are overflowing.
   */
  handleOverflowing() {
    let e = !1;
    const i = Math.ceil(
      this.tabListElement.getBoundingClientRect().width
    );
    this.markedAsOverflowingX || (e = this.TabsWidth > i), e && !this.markedAsOverflowingX && (this.markedAsOverflowingX = !0);
  }
  tearDownTabs() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.tabsResizeObserver.disconnect(), (this.variant === Ao.SECONDARY || this.variant === Ao.TERTIARY) && this.tabListElement.removeEventListener(
      et.SCROLL,
      this.toggleTabListScrollClass
    );
  }
  /**
   * function attached to the more menu's close button
   * that hides the menu upon clicking.
   * @param event a user interaction generated Click event
   */
  handleClose(e) {
    e.stopPropagation(), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * sets the clicked tab to active,
   * and updates the rendering according to updateCurrentlyActiveTab
   * @param event a user interaction generated Click event
   */
  handleTabClick(e) {
    this.emitClick();
    const i = e.target;
    i.value && this.updateCurrentlyActiveTab(i.value);
  }
  /**
   * Sets the tabs selected attribute,
   * then sets the currently visible tab and tab panel
   * to match the selected attribute
   * @param selected the value attribute of a clicked tab or tab menu-item
   */
  updateCurrentlyActiveTab(e) {
    this.selected = e, this.deselectAllTabs(), this.hideAllTabPanels(), this.selectClickedTab(this.selected), this.displaySelectedTabPanel(this.selected);
  }
  /**
   * Closes the more menu and
   * Sets which tab is currently active based on the menu item clicked,
   * then shifts the visible tab range to match if the clicked tab value
   * is greater than what's currently visible.
   * @param event A user generated Click event
   */
  handleMenuTabClick(e) {
    const i = e.currentTarget;
    this.emitClick();
    const o = parseInt(i.value, 10), n = um(
      o,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    this.updateCurrentlyActiveTab(i.value), Ot.showTabsInRange(n, this.tabChildren), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * Sets the arrow-control arrowControlElements array to the currently visible elements
   * and the more button at the end if needed.
   */
  getArrowControlElements() {
    return this.shouldShowMore && this.moreButton != null ? [...Ot.getVisibleTabs(this.tabChildren), this.moreButton] : Ot.getVisibleTabs(this.tabChildren);
  }
  /**
   * Closes the more menu dialog, when the user clicks outside of the dialog and
   * the closeOnClickOut parameter is true.
   * @param event a user interaction generated Click event
   */
  handleMenuClickBlur(e) {
    this.closeOnClickOut && this.menuOpen && e.target === this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * Sets currently active tab of the slotted tabChildren based on the clicked tab's value
   * @param clickedValue the value attribute of a user clicked tab
   */
  selectClickedTab(e) {
    this.tabChildren.forEach((i) => {
      i.value === e && (i.ariaSelected = "true");
    });
  }
  /**
   * Sets focus to the currently selected tab after selecting the tab from the menu
   */
  focusSelectedTab() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected === "true" && e.focus();
    });
  }
  /**
   * sets the active value of each slotted tab to false
   */
  deselectAllTabs() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected = "false";
    });
  }
  /**
   * Removes the hide class from the tab panel with a value matching the input value attribute
   * @param clickedValue the value attribute of the tab clicked corresponding with the tab panel value
   */
  displaySelectedTabPanel(e) {
    this.tabPanels.forEach((i) => {
      i.value === e && (i.ariaHidden = "false");
    });
  }
  /**
   * Applies the hide class to each slotted tab panel
   * setting their display to none.
   */
  hideAllTabPanels() {
    this.tabPanels.forEach((e) => {
      e.ariaHidden = "true";
    });
  }
  /**
   * applies the hide css class to the overlay div
   * to hide the more menu modal.
   * Triggered by blur, the menu close button, or clicking an option
   */
  hideMenu() {
    this.tabMenuOverlay.classList.add(Ra), this.menuOpen = !1, this.focusTrapObject.deactivate(), this.tabsResizeObserver.unobserve(this.tabMenu), ks();
  }
  /**
   * remove the hide css class from the overlay div
   * to show the more menu modal.
   * Triggered by blur, or menu click
   * Focuses on first tabbable element within the more menu
   */
  showMenu() {
    var e, i;
    this.tabMenuOverlay.classList.remove(Ra), this.menuOpen = !0, this.focusTrapObject.activate(), this.tabsResizeObserver.observe(this.tabMenu), (i = (e = this.closeButton.shadowRoot) == null ? void 0 : e.querySelector("button")) == null || i.focus(), Eb();
  }
  /**
   * applies the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to hide
   */
  static hideTab(e) {
    e.classList.add(Ra);
  }
  /**
   * removes the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to show
   */
  static showTab(e) {
    e.classList.remove(Ra);
  }
  /**
   * Getter for all currently slotted tabs without the .hide class applied
   * @param tabs an Array of slotted Beacon Tab components
   * @returns an array of tabs without the .hide class applied
   */
  static getVisibleTabs(e) {
    return e.filter(
      (o) => !o.classList.contains(Ra)
    );
  }
  /**
   * Hides all tabs outside of the specified range
   * and shows all tabs inside the range by applying and
   * removing the hide class to the slotted tabChildren
   * @param firstVisibleTabIndex the inclusive starting index range to show tabs
   * @param lastVisibleTabIndex the inclusive ending index range to show tabs
   * @param tabs the slotted tabChildren
   */
  static showTabsInRange({
    firstVisibleTabIndex: e,
    lastVisibleTabIndex: i
  }, o) {
    o.forEach((n, l) => {
      l < e || l > i ? Ot.hideTab(n) : Ot.showTab(n);
    });
  }
  /**
   * Applies the .hide class setting display: none on
   * each slotted tab component.
   */
  hideAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.add(Ra);
    });
  }
  /**
   * Removes the .hide class from each slotted tab component.
   */
  showAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.remove(Ra);
    });
  }
  /**
   * Overridden.
   * checks if the amount of slotted tabChildren changed, to update the "watching"
   * currentTotalTab attribute accordingly.
   * Also calls updateShownTabs() to re-render tabs accordingly, when the max amount
   * of visible tabs allowed changes.
   * @param changedProperties Inherited Map of properties changed during a component's update lifeCycle
   */
  async willUpdate(e) {
    e.has(Z4) && (this.currentTotalTabs = this.tabChildren.length), e.has(J4) && this.updateShownTabs(), e.has(eD) && this.updateShownTabs(), e.has(tD) && this.applyTabType(this.tabChildren), e.has(oD) && this.applyTabVariant(this.tabChildren);
  }
  /**
   * Repeated update lifecyle logic to update tab visibility based on which value is currently selected.
   * Will shift the visible tab range downwards if the max tabs allowed decreases on a resize.
   */
  updateShownTabs() {
    const e = parseInt(this.selected, 10), i = um(
      e,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    Ot.showTabsInRange(i, this.tabChildren);
  }
  /**
   * Applies the variant attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabVariant(e) {
    e.forEach((i) => {
      i.variant = this.variant;
    });
  }
  /**
   * Applies the tabType attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabType(e) {
    (this.variant === Ao.PRIMARY || Ao.SECONDARY) && e.forEach((i) => {
      i.tabType = this.tabType;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabs the loaded Array of slotted Beacon Tab components
   */
  static initializeTabValues(e) {
    e.forEach((i, o) => {
      i.value = `${o + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   */
  static initializeTabPanelValues(e) {
    e.forEach((i, o) => {
      i.value = `${o + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabPanelIDs(e, i) {
    e.forEach((o) => {
      o.id || (o.id = `${i}-tabpanel-${o.value}`);
    });
  }
  /**
   * Iterates over the loaded tab components and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID. Also updates attributes dependent on the tab ID including
   * ariaControls.
   * @param tabPanels the loaded Array of slotted Beacon Tab components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabIDs(e, i, o) {
    e.forEach((n) => {
      var L;
      n.id || (n.id = `${i}-tab-${n.value}`);
      const l = `${i}-tabpanel-${n.value}`;
      if (o) {
        const D = o.find(
          (j) => j.value === n.value
        );
        n.ariaControls = (L = D == null ? void 0 : D.id) != null ? L : l;
      } else
        n.ariaControls = l;
    });
  }
  /**
   * Fallback case for the initially selected tab when the user selected value
   * is invalid or not supplied. Sets the first tab and tab panel to active.
   */
  setActiveToFirst() {
    this.updateCurrentlyActiveTab(X4);
  }
  /**
   * Sets the currently active tab to the string input,
   * if the string input is within the range of currently slotted tabs,
   * and sets the active tab to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeUserSelectedTab(e, i) {
    const o = parseInt(this.selected, 10);
    o > i || o < 0 ? this.setActiveToFirst() : this.updateCurrentlyActiveTab(e);
  }
  /**
   * Sets the currently active tab to the user supplied selected value
   * if it exists and is valid, or to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeSelectedTab(e, i) {
    e !== Q4 ? this.initializeUserSelectedTab(e, i) : this.setActiveToFirst();
  }
  removeArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((i) => {
      i.removeEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.removeEventListener("keydown", this.handleKeydown));
  }
  /**
   * Keyboard listeners for all arrow-controlled children. Makes the events
   * store a reference (event.currentTarget) to the focused tab to simplify logic
   */
  attachArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((i) => {
      i.addEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.addEventListener("keydown", this.handleKeydown));
  }
  /**
   * Basic focus callback for ArrowControl
   * @param tab
   */
  static arrowControlFocusCallback(e) {
    e instanceof Bt && e.focus();
  }
  async handleSlotChange() {
    await this.initializeTabs(), this.requestUpdate();
  }
  /**
   * When the tabs component first Updates or the slot changes, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async initializeTabs() {
    var e;
    await Promise.all(this.tabChildren.map((i) => i.updateComplete)), await Promise.all(this.tabPanels.map((i) => i.updateComplete)), this.shouldShowMore && await ((e = this.moreButton) == null ? void 0 : e.updateComplete), this.currentTotalTabs = this.tabChildren.length, Ot.initializeTabPanelValues(this.tabPanels), Ot.initializeTabValues(this.tabChildren), Ot.initializeTabPanelIDs(this.tabPanels, this.id), Ot.initializeTabIDs(this.tabChildren, this.id, this.tabPanels), this.updateShownTabs(), this.applyTabVariant(this.tabChildren), this.applyTabType(this.tabChildren), this.removeArrowControlKeyboardListeners(), this.attachArrowControlKeyboardListeners(), this.initializeSelectedTab(this.selected, this.currentTotalTabs), this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * When the tabs component first Updates, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async firstUpdated() {
    this.variant !== Ao.PRIMARY && (this.scrollable = !0), await this.initializeTabs(), this.variant === Ao.PRIMARY ? this.tabsResizeObserver.observe(this.tabListElement) : this.tabsResizeObserver.observe(document.body), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.shouldShowMore && (this.focusTrapObject = Rv(this.tabMenuOverlay, {
      fallbackFocus: this.closeButton,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // overrides keyForward and keyBackward events to include arrowKey navigation
      isKeyForward: (e) => e.key === Ci.DOWN || e.key === Ci.RIGHT || e.key === Di.TAB,
      isKeyBackward: (e) => e.key === Ci.UP || e.key === Ci.LEFT || e.shiftKey && e.key === Di.TAB,
      escapeDeactivates: () => (this.hideMenu(), !0)
    })), super.firstUpdated();
  }
  /**
   * renders a `<beacon-tab>` component with the more attribute set to true
   * and an icon matching the `<beacon-tabs>` tab type property
   * @returns An HTML `<beacon-tab>` with more attribute set to true and a slotted more icon
   */
  renderMoreButton() {
    return ze`<${this.getScopedTag("beacon-tab")}
      label="More"
      variant=${this.variant}
      tab-type=${this.tabType}
      value="-1"
      @beacon-event-click=${this.showMenu}
      more
      aria-haspopup="menu"
    >
      <${this.getScopedTag("beacon-icon")} size="s" name="overflow_horizontal" slot="tab-icon"></${this.getScopedTag("beacon-icon")}>
    </${this.getScopedTag("beacon-tab")}>`;
  }
  /**
   * Renders a dialog containing the mapped values of the slotted tabs
   * @returns an HTML dialog containing a tablist of mapped tab items
   */
  renderMoreMenu() {
    return pe`<div
      class="overlay hide"
      @click=${this.handleMenuClickBlur}
      id="menu"
      data-metrics-location="${oa.dataMetricsLocation.PU}">
      <dialog>
        <div class="close-button-row">
          ${ze`<${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.handleClose} label="close-button" variant="primary">
            <${this.getScopedTag("beacon-icon")} slot="icon" name="close" size="m"></${this.getScopedTag("beacon-icon")}>
          </${this.getScopedTag("beacon-icon-button")}>`}
        </div>
        <div class="menu-item">
          <h2>${this.menuTitle}</h2>
        </div>
        <div class="menu-tablist" role="tablist">
          ${this.buildTabMenu(this.tabChildren)}
        </div>
      </dialog>
    </div>`;
  }
  render() {
    return pe`<div class="container" part="base">
        <div id="tab-list" role="tablist" class="tablist">
          <slot
            name="tab-children"
            @beacon-event-click=${this.handleTabClick}
            @slotchange=${this.handleSlotChange}></slot>
          ${this.shouldShowMore ? this.renderMoreButton() : je}
        </div>
      </div>
      <div class="spacer"></div>
      <slot name="tab-panel" @slotchange=${this.handleSlotChange}></slot>
      ${this.shouldShowMore ? this.renderMoreMenu() : je}`;
  }
}, Xa = new WeakMap(), Ot.tagName = gm, Ot.nestedComponents = [Qt, Bt], Ot);
ht([
  ot("#menu")
], lt.prototype, "tabMenuOverlay", 2);
ht([
  ot("#menu dialog")
], lt.prototype, "tabMenu", 2);
ht([
  G1("#menu button.menu-item")
], lt.prototype, "menuTabs", 2);
ht([
  ot(
    '#menu dialog .close-button-row [beacon-tag-name="beacon-icon-button"]'
  )
], lt.prototype, "closeButton", 2);
ht([
  ot("#menu dialog .close-button-row")
], lt.prototype, "closeButtonRow", 2);
ht([
  ot("#tab-list")
], lt.prototype, "tabListElement", 2);
ht([
  ot("[more]")
], lt.prototype, "moreButton", 2);
ht([
  De(
    { slot: "tab-children", selector: "beacon-tab" },
    !0
  )
], lt.prototype, "tabChildren", 2);
ht([
  De(
    { slot: "tab-panel", selector: "beacon-tab-panel" },
    !0
  )
], lt.prototype, "tabPanels", 2);
ht([
  Ce()
], lt.prototype, "currentTotalTabs", 2);
ht([
  Ce()
], lt.prototype, "currentMaxTabs", 2);
ht([
  ue({ reflect: !0, type: Boolean })
], lt.prototype, "scrollable", 2);
ht([
  ue({ reflect: !0, type: Boolean })
], lt.prototype, "scrolled", 2);
ht([
  ue({ type: Boolean, attribute: "close-on-click-out" })
], lt.prototype, "closeOnClickOut", 2);
ht([
  ue({ reflect: !0 })
], lt.prototype, "variant", 2);
ht([
  ue({ reflect: !0, attribute: "tab-type" })
], lt.prototype, "tabType", 2);
ht([
  ue({ attribute: "menu-title" })
], lt.prototype, "menuTitle", 2);
ht([
  ue()
], lt.prototype, "selected", 1);
ht([
  Ce()
], lt.prototype, "menuOpen", 2);
ht([
  ue({ reflect: !0, attribute: "overflowing-x" })
], lt.prototype, "markedAsOverflowingX", 2);
ht([
  Ce()
], lt.prototype, "markedAsMenuOverFlowingY", 2);
ht([
  ue({ reflect: !0 })
], lt.prototype, "id", 2);
ht([
  Pt
], lt.prototype, "tearDownTabs", 1);
let cz = lt;
const mm = {
  beaconTagName: "beacon-tooltip"
}, rD = ve`[beacon-tag-name=beacon-tooltip] :where(*){margin:0;padding:0}`, sD = ve`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--tooltip-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--tooltip-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var lD = Object.getOwnPropertyDescriptor, cD = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? lD(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(o) || o);
  return o;
};
function dD(a) {
  let t = class extends a {
    static get TooltipMotionStyles() {
      return [sD];
    }
  };
  return t = cD([
    $e("TestTooltipMotion")
  ], t), t;
}
const hD = ve`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);filter:drop-shadow(0 0 var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));max-inline-size:15ch;min-inline-size:40px;padding:var(--beacon-system-space-cell-contained);text-align:center}.arrow{--arrow-inline-size: 6px;--arrow-block-size: 12px;background-color:initial;block-size:12px;inline-size:12px}.arrow[data-side=bottom]{transform:rotate(90deg)}.arrow[data-side=left]{transform:rotate(180deg)}.arrow[data-side=top]{transform:rotate(-90deg)}.arrow .arrow-vector{background-color:initial;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);inset-inline-end:-1px;position:absolute}`;
var bD = Object.defineProperty, pD = Object.getOwnPropertyDescriptor, sl = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? pD(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && bD(t, e, o), o;
}, ua;
const Nr = (ua = class extends Ge(Le).with(
  cv,
  gb,
  Wf,
  dD
) {
  constructor() {
    super(...arguments), this.beaconTagName = mm.beaconTagName, this._hovered = !1, this.show = (t) => {
      this.attachTooltipListeners(), !this.prefersReducedMotion && this.motionState === ys.ENABLED ? (this.closing = !1, this.showCallback(t)) : this.showCallback(t);
    }, this.hide = (t) => {
      this.removeTooltipListeners(), !this.prefersReducedMotion && this.motionState === ys.ENABLED ? this.closing = !0 : this.hideCallback(t);
    }, this.mouseOverTooltipListener = () => {
      this._hovered = !0, this.waitUntilMouseHoversTooltip && clearTimeout(this.waitUntilMouseHoversTooltip);
    }, this.mouseOutTooltipListener = (t) => {
      this._hovered = !1, this.hide(t);
    }, this.opensByMouseOutListener = (t) => {
      this.waitUntilMouseHoversTooltip = setTimeout(() => {
        this._hovered || this.hide(t);
      }, 100);
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, hD, this.TooltipMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, rD];
  }
  get text() {
    let t = "";
    return this.slottedElements ? (t = ua.getCleanTextContent(
      this.slottedElements
    ), t) : (this.slottedNodes && (t = ua.getCleanTextContent(this.slottedNodes)), t);
  }
  /**
   * Grabs the cleaned `.textContent` from the element's slotted content.
   * This is used to prevent `<style>` element contents from being assigned to the aria-description attribute.
   * @param slottedContent
   * @returns
   */
  static getCleanTextContent(t) {
    return [...t].reduce((e, i) => {
      var n, l;
      const o = (l = (n = i == null ? void 0 : i.textContent) == null ? void 0 : n.trim()) != null ? l : "";
      return e + o;
    }, "");
  }
  _renderArrowHTML() {
    return pe`<div class="arrow">
      <svg
        aria-hidden="true"
        width="6"
        height="12"
        viewBox="0 0 6 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M6 0L0 6L6 12V0Z" />
      </svg>
    </div>`;
  }
  runOpensBySetup() {
    this.opensByElements.forEach((t, e) => {
      e.addEventListener("mouseenter", this.show), e.addEventListener("mouseleave", this.opensByMouseOutListener), e.addEventListener("focus", this.show), e.addEventListener("blur", this.hide), e instanceof Ha ? e.updateComplete.then(() => {
        var i;
        (i = e.button) == null || i.setAttribute("aria-description", this.text);
      }) : e.setAttribute("aria-describedby", this.id);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((t, e) => {
      e.removeEventListener("mouseenter", this.show), e.removeEventListener("mouseleave", this.hide), e.removeEventListener("focus", this.show), e.removeEventListener("blur", this.hide);
    });
  }
  attachTooltipListeners() {
    this.addEventListener("mouseenter", this.mouseOverTooltipListener), this.addEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  removeTooltipListeners() {
    this.removeEventListener("mouseenter", this.mouseOverTooltipListener), this.removeEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  applyAriaRole() {
    this.setAttribute("role", "tooltip");
  }
  render() {
    return pe`
      <div id="tooltip">
        <slot></slot>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
}, ua.tagName = mm.beaconTagName, ua);
sl([
  Ct({ slot: "", selector: ":not(style)" })
], Nr.prototype, "slottedElements", 2);
sl([
  Ho({ slot: "", flatten: !0 })
], Nr.prototype, "slottedNodes", 2);
sl([
  ue({ attribute: "hovered", type: Boolean })
], Nr.prototype, "_hovered", 2);
sl([
  Pt
], Nr.prototype, "removeTooltipListeners", 1);
sl([
  Re
], Nr.prototype, "applyAriaRole", 1);
let dz = Nr;
const uD = `<svg width="33" height="32" viewBox="0 0 33 32" slot="icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="play-icon">
<path d="M32 16L8 29.8564L8 2.14359L32 16Z"  stroke-width="2" stroke-linejoin="round"/>
</svg>`, fm = {
  beaconTagName: "beacon-video"
}, gD = ve`.beacon-video-player .vjs-loading-spinner,.beacon-video-player .vjs-big-play-button,.beacon-video-player .vjs-title-bar{display:none}.beacon-video-player .vjs-poster{box-shadow:inset 0 0 0 100vw #1e2d3961}.beacon-video-player .vjs-play-progress,.beacon-video-player .vjs-volume-level{background-color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-video] video-js.beacon-video-player{grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);inline-size:100%}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag]{inset-block-start:var(--video-tag-inset-block-start);inset-inline-end:var(--video-tag-inset-inline-end);position:var(--video-tag-position, absolute)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="1:1"]{--video-tag-inset-inline-end: var(--beacon-reference-space-3);--video-tag-inset-block-start: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="2:1"]{--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal);--video-tag-inset-block-start: var(--beacon-system-space-micro-normal)}@media (width >= 960px){[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-tag][aspect-ratio="2:1"]{--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal);--video-tag-inset-block-start: var(--beacon-system-space-micro-normal)}}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript]{align-items:flex-start;align-self:stretch;background-color:var(--video-transcript-background-color);display:flex;flex-direction:column;gap:var(--beacon-system-space-micro-mini);padding:var(--video-transcript-padding);padding-inline-start:var(--override-transcript-padding, var(--video-transcript-padding))}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript] [beacon-tag-name=beacon-button]{--override-button-default-gap: 0;align-items:center;display:flex;justify-content:center}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-contained{--video-transcript-padding: var(--beacon-system-space-cell-contained);--video-transcript-background-color: var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-contained [beacon-tag-name=beacon-button]{padding-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-inline:var(--beacon-reference-space-5) 0}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-free-floating{--video-transcript-padding: var(--beacon-system-space-cell-free-floating) 0;--video-transcript-background-color: transparent}[beacon-tag-name=beacon-video] [beacon-tag-name=beacon-video-transcript].video-transcript-free-floating [beacon-tag-name=beacon-button]{padding:var(--beacon-reference-space-2) 0}[beacon-tag-name=beacon-article-tile]:is([position=horizontal],[position=horizontal-right]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-border-end-start-radius: var(--tile-media-end-start-radius);--override-video-thumbnail-border-start-start-radius: var(--tile-media-start-start-radius);--override-video-thumbnail-inline-size: var(--override-video-inline-size);--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-object-fit: var(--override-video-object-fit);--override-video-thumbnail-block-size: var(--override-video-block-size)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal],[position=horizontal-right]) [beacon-tag-name=beacon-video] img,[beacon-tag-name=beacon-article-tile]:is([position=horizontal],[position=horizontal-right]) [beacon-tag-name=beacon-video] picture{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);block-size:var(--override-video-thumbnail-block-size, 100%);border-end-start-radius:var(--override-video-thumbnail-border-end-start-radius);border-start-start-radius:var(--override-video-thumbnail-border-start-start-radius);inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal-left]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-border-start-end-radius: var(--tile-start-end-radius);--override-video-thumbnail-border-end-end-radius: var(--tile-end-end-radius);--override-video-thumbnail-inline-size: var(--override-video-inline-size);--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-object-fit: var(--override-video-object-fit);--override-video-thumbnail-block-size: var(--override-video-block-size)}[beacon-tag-name=beacon-article-tile]:is([position=horizontal-left]) [beacon-tag-name=beacon-video] img,[beacon-tag-name=beacon-article-tile]:is([position=horizontal-left]) [beacon-tag-name=beacon-video] picture{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);block-size:var(--override-video-thumbnail-block-size, 100%);border-end-end-radius:var(--override-video-thumbnail-border-end-end-radius);border-start-end-radius:var(--override-video-thumbnail-border-start-end-radius);inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-aspect-ratio: var(--override-video-aspect-ratio);--override-video-thumbnail-inline-size: var(--override-video-vertical-inline-size);--override-video-thumbnail-object-fit: var(--override-video-object-fit)}[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] img,[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] picture{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);border-start-end-radius:var(--tile-start-end-radius);border-start-start-radius:var(--tile-start-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}@media (width >= 640px){[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] img,[beacon-tag-name=beacon-article-tile]:is([position=vertical],[position=vertical-bottom]) [beacon-tag-name=beacon-video] picture{aspect-ratio:var(--override-video-thumbnail-aspect-ratio);border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}}[beacon-tag-name=beacon-article-tile]:is([position=vertical-top]) [beacon-tag-name=beacon-video]{--override-video-thumbnail-inline-size: var(--override-video-vertical-inline-size)}[beacon-tag-name=beacon-article-tile]:is([position=vertical-top]) [beacon-tag-name=beacon-video] img,[beacon-tag-name=beacon-article-tile]:is([position=vertical-top]) [beacon-tag-name=beacon-video] picture{aspect-ratio:var(--article-tile-media-aspect-ratio);border-end-end-radius:var(--tile-media-end-end-radius);border-end-start-radius:var(--tile-media-end-start-radius);display:block;inline-size:min(var(--override-video-thumbnail-inline-size, 100%));object-fit:var(--override-video-thumbnail-object-fit, cover)}`, mD = ve`:host{--video-overlay-column-span: 1/2;--overlay-z-index: 1;display:grid;grid-template-columns:auto;grid-template-rows:auto;inline-size:100%}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 48px;--override-icon-button-wrapper-block-size: 48px;--override-icon-button-block-size: 24px;--override-icon-button-inline-size: 24px}.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-11) / 2);--override-icon-button-box-shadow: var(--beacon-elevation-block-end-level-1);--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-color: var(--beacon-system-color-icon-primary);--override-icon-button-surface-size: calc(2 * var(--play-button-size-override));--override-icon-button-padding: var(--beacon-reference-space-4);display:flex;grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);place-self:center center;z-index:var(--overlay-z-index)}@media (width >= 640px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-13) / 2);--override-icon-button-padding: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 64px;--override-icon-button-wrapper-block-size: 64px;--override-icon-button-block-size: 32px;--override-icon-button-inline-size: 32px}}@media (width >= 960px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-15) / 2);--override-icon-button-padding: var(--beacon-reference-space-6)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 80px;--override-icon-button-wrapper-block-size: 80px;--override-icon-button-block-size: 40px;--override-icon-button-inline-size: 40px}}.timestamp-container{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);-webkit-backdrop-filter:blur(var(--beacon-reference-space-2));backdrop-filter:blur(var(--beacon-reference-space-2));background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);margin-block-end:var(--beacon-system-space-organism-normal);margin-inline-end:var(--beacon-system-space-organism-normal);padding:var(--beacon-system-space-cell-contained);place-self:end end;z-index:var(--overlay-z-index)}.timestamp-container .timestamp-tag{padding-block:var(--beacon-reference-space-1);padding-inline:var(--beacon-reference-space-3)}.hidden{display:none}.video-tag-container{display:inline-block;inline-size:fit-content;position:relative}`;
var fD = Object.defineProperty, Pb = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && fD(t, e, o), o;
};
const wc = class wc extends Vn {
  constructor() {
    super(...arguments), this.beaconTagName = fm.beaconTagName, this.showPrePlayInformation = !1, this.videoCSSClass = "beacon-video-player";
  }
  static get styles() {
    return [super.styles, mD];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, gD];
  }
  get thumbnails() {
    return Array.from(this.querySelectorAll("img, picture"));
  }
  getDuration() {
    return new Promise((t) => {
      var e, i;
      if (this.brightcovePlayer) {
        const o = (i = (e = this.brightcovePlayer) == null ? void 0 : e.mediainfo) == null ? void 0 : i.duration;
        o ? (this.duration = Vn.formatDuration(o), t()) : this.brightcovePlayer.on("loadedmetadata", () => {
          var n, l;
          this.duration = Vn.formatDuration(
            (l = (n = this.brightcovePlayer) == null ? void 0 : n.mediainfo) == null ? void 0 : l.duration
          ), t();
        });
      }
    });
  }
  handlePlayButtonPress() {
    var t;
    (t = this.brightcovePlayer) == null || t.play();
  }
  async brightcoveInit() {
    var t, e;
    if (this.thumbnails.length > 0 && (this.isLinkingExternally = !0), this.thumbnails.length === 0) {
      await this.applyPlayerScript(), (t = this.brightcovePlayer) == null || t.on("play", () => {
        this.showPrePlayInformation = !1;
      });
      const { tagAttributes: i } = this.brightcovePlayer;
      i != null && i.autoplay || (this.showPrePlayInformation = !0, await this.getDuration()), Fe(this, Ee.VIDEO_BRIGHTCOVE_READY), (e = this.brightcovePlayer) == null || e.ready(() => {
        var n;
        const o = (n = this.video) == null ? void 0 : n.id;
        Fe(document.body, "videoPlayerLoad", {
          detail: {
            videoPlayerId: o
          }
        });
      });
    }
  }
  render() {
    return this.isLinkingExternally ? pe`
        <div class="video-tag-container">
          ${this.renderBrightcoveDefaultSlot()}
        </div>
      ` : pe`
      ${this.showPrePlayInformation ? pe`
            ${ze`
          <${this.getScopedTag("beacon-icon-button")}
            class="video-play-button"
            exportparts="icon-button: play-button"
            @beacon-event-click=${this.handlePlayButtonPress}>
            Play Video
            ${gt(uD)}
          </${this.getScopedTag("beacon-icon-button")}>
        `}
            <div class="timestamp-container">
              <time
                class="timestamp-tag"
                part="timestamp"
                datetime="${this.duration}"
                >${this.duration}</time
              >
            </div>
          ` : pe``}
      ${this.renderBrightcoveDefaultSlot()}
    `;
  }
};
wc.tagName = fm.beaconTagName, wc.nestedComponents = [Qt];
let vr = wc;
Pb([
  Ce()
], vr.prototype, "isLinkingExternally");
Pb([
  Ce()
], vr.prototype, "duration");
Pb([
  Ce()
], vr.prototype, "showPrePlayInformation");
const vm = {
  beaconTagName: "beacon-video-playlist"
}, vD = ve`[beacon-tag-name=beacon-video-playlist]{--playlist-item-min-inline-size: 160px;--override-transcript-button-padding-inline-start: var(--beacon-reference-space-3);--override-transcript-padding: var(--beacon-system-space-organism-normal)}[beacon-tag-name=beacon-video-playlist] [beacon-tag-name=beacon-video-transcript]{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1)}[beacon-tag-name=beacon-video-playlist] .beacon-video-playlist__playlist-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-100);margin-inline-start:var(--beacon-reference-space-3);padding-block:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist{background-color:var(--beacon-system-color-background-1);padding-block:var(--beacon-system-space-organism-mini)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist .vjs-playlist-title-container{background-color:var(--beacon-system-color-background-1);border-radius:var(--beacon-system-width-border-normal);color:var(--beacon-system-color-text-standard);inline-size:unset;margin:var(--beacon-reference-space-2);padding:var(--beacon-system-space-organism-mini);text-shadow:none;font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-100)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist .vjs-playlist-name{line-height:initial;padding:unset}[beacon-tag-name=beacon-video-playlist] .vjs-selected,[beacon-tag-name=beacon-video-playlist] .vjs-mouse .vjs-selected{background:var(--beacon-reference-palette-primary-midnight-navy-1);background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='22' viewBox='0 0 18 22' fill='none'%3E%3Cpath d='M18 11.0005L-9.78799e-07 21.3928L-7.02746e-08 0.608183L18 11.0005Z' fill='white'/%3E%3C/svg%3E");background-position:center;background-repeat:no-repeat;border:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);box-shadow:inset 0 0 0 var(--beacon-system-width-border-normal) var(--beacon-system-color-border-focus-inner)}[beacon-tag-name=beacon-video-playlist] .vjs-selected img{opacity:.64}[beacon-tag-name=beacon-video-playlist] .vjs-selected .vjs-playlist-now-playing-text,[beacon-tag-name=beacon-video-playlist] .vjs-up-next .vjs-up-next-text,[beacon-tag-name=beacon-video-playlist] .vjs-playlist-duration{display:none}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-item img{min-inline-size:var(--playlist-item-min-inline-size)}[beacon-tag-name=beacon-video-playlist] .beacon-video-playlist__playlist-container{background-color:var(--beacon-system-color-background-1);padding:var(--beacon-system-space-organism-normal)}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-horizontal .vjs-playlist-item{margin-inline:var(--beacon-system-space-micro-normal) 0}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-horizontal .vjs-playlist-item:first-child{margin-inline-start:0}[beacon-tag-name=beacon-video-playlist] .vjs-playlist-item-list{background-color:var(--beacon-system-color-background-1);margin-block:var(--beacon-reference-space-3);margin-inline-start:var(--beacon-reference-space-3)}@media (width >= 960px){[beacon-tag-name=beacon-video-playlist]{--playlist-item-min-inline-size: 240px}}`, AD = ve`:host{border-radius:var(--beacon-system-radius-corner-standard);overflow:hidden}`;
var yD = Object.defineProperty, xD = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && yD(t, e, o), o;
}, nr;
const gp = class gp extends Le {
  constructor() {
    super(...arguments);
    Ie(this, nr);
    this.beaconTagName = vm.beaconTagName, Be(this, nr, []);
  }
  static get styles() {
    return [super.styles, AD];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, vD];
  }
  get playlistItems() {
    return Te(this, nr);
  }
  set playlistItems(e) {
    Be(this, nr, e), this.setPlaylistItemListeners();
  }
  setPlaylistItems({ target: e }) {
    var i;
    e instanceof vr && (this.playlistItems = Array.from(
      (i = e.brightcovePlayer.playlistMenu.el_) == null ? void 0 : i.querySelectorAll(
        "li.vjs-playlist-item"
      )
    ));
  }
  setPlaylistItemListeners() {
    this.playlistItems.forEach((e, i) => {
      e.addEventListener("click", () => {
        this.beaconVideoTranscript.setActiveTranscript(i);
      }), e.addEventListener("keydown", (o) => {
        (o.key == Di.ENTER || o.key == Di.SPACE) && this.beaconVideoTranscript.setActiveTranscript(i);
      });
    });
  }
  render() {
    return pe`<slot
      @beacon-event-video-brightcove-ready=${this.setPlaylistItems}></slot>`;
  }
};
nr = new WeakMap(), gp.tagName = vm.beaconTagName;
let Uh = gp;
xD([
  An('[beacon-tag-name="beacon-video-transcript"]')
], Uh.prototype, "beaconVideoTranscript");
const wD = `<svg class="play-icon" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M12 8L6 12L6 4L12 8Z" stroke-width="2" stroke-linejoin="round"/>
</svg>`, kD = `<svg class="play-icon" slot="prefix" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M12 8L6 12L6 4L12 8Z" stroke-width="2" stroke-linejoin="round"/>
</svg>`, CD = ve`:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-11)}@media (width >= 640px){:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-13)}}@media (width >= 960px){:root[beacon-tag-name=beacon-video-tag],:root [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"][beacon-tag-name=beacon-video-tag],[beacon-version="4.4.0"] [beacon-tag-name=beacon-video-tag]{--video-play-button-size-block-size-jumbo: var(--beacon-reference-space-15)}}`, SD = {
  RECTANGLE: "2:1"
}, ED = ve`[beacon-tag-name=beacon-button]{--override-button-bg-color: var(--beacon-system-color-background-primary);--override-button-border-radius: var(--beacon-reference-space-6);--override-button-font-size-normal: var(--beacon-component-video-tag-font-size-sans-serif-standard);--override-button-font-size: var(--beacon-component-video-tag-font-size-sans-serif-standard);--override-button-font-weight-normal: var(--beacon-system-font-weight-bold);--override-button-space-padding-inline-normal: var(--beacon-reference-space-4);--override-button-space-padding-block-end-normal: var(--beacon-reference-space-3);--override-button-space-padding-block-start-normal: var(--beacon-reference-space-3);--override-button-border-width: 0;align-items:center;display:flex}[beacon-tag-name=beacon-button]::part(standard-button),[beacon-tag-name=beacon-icon-button]::part(icon-button){align-items:center;display:flex}[beacon-tag-name=beacon-icon-button]::part(icon-button){block-size:var(--beacon-reference-space-8);inline-size:var(--beacon-reference-space-8)}.play-icon{--beacon-button-icon-align: center;--override-icon-button-block-size: var(--beacon-reference-space-5);--override-icon-button-inline-size: var(--beacon-reference-space-5);color:var(--beacon-system-color-icon-primary)}[beacon-tag-name=beacon-icon-button]{--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--play-button-size-override: calc(var(--video-tag-play-button-size-block-size-jumbo) / 2);--override-icon-button-box-shadow: var(--beacon-elevation-block-end-level-1);grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);place-self:center center;z-index:var(--overlay-z-index)}.video-tag-container{display:inline-block;position:relative}`;
var MD = Object.defineProperty, uA = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && MD(t, e, o), o;
};
const kc = class kc extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = "beacon-video-tag", this.linkHref = "";
  }
  static get styles() {
    return [super.styles, ED];
  }
  static get lightDOMstyles() {
    return [super.lightDOMStyles, CD];
  }
  openVideo() {
    window.open(this.linkHref, "_blank");
  }
  render() {
    return this.aspectRatio === SD.RECTANGLE ? pe`<div>
        ${ze`<${this.getScopedTag("beacon-button")} 
          class="video-tag-button-rect" 
          @beacon-event-click=${this.openVideo}
        ><slot></slot>
          ${sh(kD)}</${this.getScopedTag("beacon-button")}>`}
      </div>` : pe`
      ${ze`<${this.getScopedTag("beacon-icon-button")}  
        class="video-tag-button-icon-square" 
        @beacon-event-click=${this.openVideo}
      ><slot></slot>${sh(wD)}</${this.getScopedTag("beacon-icon-button")}>`}
    `;
  }
};
kc.tagName = "beacon-video-tag", kc.nestedComponents = [Er, Qt];
let ac = kc;
uA([
  ue({ attribute: "aspect-ratio", reflect: !0 })
], ac.prototype, "aspectRatio");
uA([
  ue({ attribute: "link-href", reflect: !0 })
], ac.prototype, "linkHref");
const Am = {
  beaconTagName: "beacon-video-tile"
}, TD = ve`[beacon-tag-name=beacon-video-tile] .beacon-video-tile__eyebrow{padding-block-end:var(--beacon-reference-space-5)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-11);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-11);--override-icon-button-block-size: var(--beacon-reference-space-7);--override-icon-button-inline-size: var(--beacon-reference-space-7)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .75rem/1rem var(--beacon-system-font-family-body);margin-block-end:.5rem;margin-inline-end:.5rem}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .beacon-video-player{background-color:currentcolor;block-size:100%;border-radius:var(--beacon-video-tile-border-radius, 0)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .vjs-dock-text{display:none}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video] .vjs-poster{background-color:currentcolor}@container (inline-size >= 640px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-13);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-13);--override-icon-button-block-size: var(--beacon-reference-space-9);--override-icon-button-inline-size: var(--beacon-reference-space-9)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1rem;margin-inline-end:1rem}}@container (inline-size >= 960px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(play-button){--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-15);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-15);--override-icon-button-block-size: var(--beacon-reference-space-10);--override-icon-button-inline-size: var(--beacon-reference-space-10)}[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1.5rem;margin-inline-end:1.5rem}}@container (inline-size >= 1280px){[beacon-tag-name=beacon-video-tile] [beacon-tag-name=beacon-video]::part(timestamp){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body);margin-block-end:1.5rem;margin-inline-end:1.5rem}}`, LD = ve`:host{--grid-template-columns: auto;--beacon-video-tile-border-radius: var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0 0;--content-container-border-radius: 0 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard);container-name:video-tile;container-type:inline-size}.video-tile{display:grid;grid-template-columns:var(--grid-template-columns, auto)}.video-tile .content-container{background:var(--beacon-system-color-background-1);border-radius:var(--content-container-border-radius);display:flex;flex-direction:column;justify-content:space-between;padding:.5rem}.video-tile .content-container .content{padding:var(--beacon-system-space-cell-contained)}.video-tile .content-container ::slotted([slot=eyebrow]),.video-tile .content-container ::slotted([slot=title]){padding-block-end:var(--beacon-reference-space-5)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .75rem/1rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.125rem/1.5rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container .transcript{padding:var(--beacon-system-space-cell-contained)}.video-tile .content-container .body{max-block-size:10lh;overflow:auto}.video-tile .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating .content-container{background-color:transparent;padding-block:.5rem 0;padding-inline:0}.video-tile.free-floating .content-container .content{padding-block:var(--beacon-system-space-cell-free-floating);padding-inline:0}.video-tile.free-floating .content-container .transcript{padding-block:var(--beacon-system-space-cell-contained);padding-inline:0}@container video-tile (inline-size >= 640px){.video-tile .content-container{padding:1rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.25rem/1.75rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.125rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container .body{max-block-size:6lh;overflow:auto}.video-tile .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating .content-container{padding-block:1rem 0;padding-inline:0}}@container video-tile (inline-size >= 960px){.video-tile{--grid-template-columns: 67% 33%;grid-template-areas:"video content"}.video-tile .video-slot{grid-area:slot}.video-tile .content-container{grid-area:content;padding:1.5rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.25rem/1.75rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) .875rem/1.25rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.125rem/1.5rem var(--beacon-system-font-family-body)}.video-tile.horizontal__right{--grid-template-columns: 33% 67%;--beacon-video-tile-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0;--content-container-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard);grid-template-areas:"content video"}.video-tile.horizontal__left{--grid-template-columns: 67% 33%;--beacon-video-tile-border-radius: var(--beacon-system-radius-corner-standard) 0 0 var(--beacon-system-radius-corner-standard);--content-container-border-radius: 0 var(--beacon-system-radius-corner-standard) var(--beacon-system-radius-corner-standard) 0;grid-template-areas:"video content"}.video-tile.horizontal__left .content-container .body,.video-tile.horizontal__right .content-container .body{max-block-size:6lh;overflow:auto}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar-thumb,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.vertical{--grid-template-columns: auto;grid-template-areas:none}.video-tile.vertical .content-container{grid-area:initial}.video-tile.free-floating.horizontal__left .content-container{padding-block:0;padding-inline:1.5rem 0}.video-tile.free-floating.horizontal__left .content{padding:0}.video-tile.free-floating.horizontal__right .content-container{padding-block:0;padding-inline:0 1.5rem}.video-tile.free-floating.horizontal__right .content{padding:0}.video-tile.free-floating.vertical .content-container{padding-block:1.5rem 0;padding-inline:0}.video-tile.free-floating.vertical .content{padding:0}}@container video-tile (inline-size >= 1280px){.video-tile .content-container{padding:1.5rem}.video-tile .content-container ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold) 1.5rem/2rem var(--beacon-system-font-family-heading)}.video-tile .content-container ::slotted([slot=eyebrow]){font:var(--beacon-system-font-weight-bold) 1rem/1.5rem var(--beacon-system-font-family-body)}.video-tile .content-container ::slotted([slot=body]),.video-tile .content-container .body{font:1.25rem/1.75rem var(--beacon-system-font-family-body)}.video-tile.horizontal__left .content-container .body,.video-tile.horizontal__right .content-container .body{max-block-size:6lh;overflow:auto}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.video-tile.horizontal__left .content-container .body ::-webkit-scrollbar-thumb,.video-tile.horizontal__right .content-container .body ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.video-tile.free-floating.horizontal__left .content-container{padding-block:0;padding-inline:1.5rem 0}.video-tile.free-floating.horizontal__left .content{padding:0}.video-tile.free-floating.horizontal__right .content-container{padding-block:0;padding-inline:0 0 1.5rem}.video-tile.free-floating.horizontal__right .content{padding:0}.video-tile.free-floating.vertical .content-container{padding-block:1.5rem 0;padding-inline:0}.video-tile.free-floating.vertical .content{padding:0}}`;
var OD = Object.defineProperty, gA = (a, t, e, i) => {
  for (var o = void 0, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = l(t, e, o) || o);
  return o && OD(t, e, o), o;
}, ga;
const Db = (ga = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Am.beaconTagName, this.position = "vertical", this.freeFloating = !1;
  }
  static get styles() {
    return [super.styles, LD];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, TD];
  }
  static renderBody() {
    return pe`<div class="body" tabindex="${Ja()}">
      <slot name="body"></slot>
    </div>`;
  }
  static renderEyebrow() {
    return pe`<slot name="eyebrow"></slot>`;
  }
  static renderTitle() {
    return pe`<slot name="title"></slot>`;
  }
  static renderTranscript() {
    return pe`<slot name="transcript"></slot>`;
  }
  static renderTile() {
    return pe`
      <div class="content-container">
        <div class="content">
          ${this.renderEyebrow()} ${this.renderTitle()} ${this.renderBody()}
        </div>
        <div class="transcript">${this.renderTranscript()}</div>
      </div>
    `;
  }
  static renderVideo() {
    return pe`<slot class="video-slot"></slot>`;
  }
  render() {
    const t = {
      horizontal__left: this.position === "horizontal-left",
      horizontal__right: this.position === "horizontal-right",
      vertical: this.position === "vertical",
      "free-floating": this.freeFloating
    };
    return pe` <div class="video-tile ${Pe(t)}">
      ${ga.renderVideo()} ${ga.renderTile()}
    </div>`;
  }
}, ga.tagName = Am.beaconTagName, ga);
gA([
  ue({ reflect: !0 })
], Db.prototype, "position");
gA([
  ue({ attribute: "free-floating", type: Boolean })
], Db.prototype, "freeFloating");
let hz = Db;
const PD = `<svg slot="suffix" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 3C4 2.44772 4.44772 2 5 2H15C15.5523 2 16 2.44772 16 3V10C16 10.5523 15.5523 11 15 11H5C4.44772 11 4 10.5523 4 10V3ZM15 4V3.5H5V4V9V10H6H14H15V9V4ZM0 7C0 6.44772 0.447715 6 1 6H2.5C2.77614 6 3 6.22386 3 6.5C3 6.77614 2.77614 7 2.5 7H1V14H11V12.5C11 12.2239 11.2239 12 11.5 12C11.7761 12 12 12.2239 12 12.5V14C12 14.5523 11.5523 15 11 15H1C0.447716 15 0 14.5523 0 14V7Z"/>
</svg>
`, DD = ve`:root[beacon-tag-name=beacon-video-transcript],:root [beacon-tag-name=beacon-video-transcript],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-video-transcript],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-video-transcript],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-video-transcript],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-video-transcript],[beacon-version="4.4.0"][beacon-tag-name=beacon-video-transcript],[beacon-version="4.4.0"] [beacon-tag-name=beacon-video-transcript]{--video-transcript-text-font: var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}`, Na = {
  beaconTagName: "beacon-video-transcript",
  videoTranscriptModalScale: "jumbo",
  variant: "tertiary",
  scale: "normal",
  inlineLabel: "Transcript",
  modalLabel: "View Transcript"
}, zD = ve`details>summary{align-items:center;cursor:pointer;display:flex;list-style-type:none}[open]>summary [slot=icon]{transform:rotate(180deg)}.video-transcript-beacon-modal{position:absolute}.transcript-label{text-transform:capitalize}.video-view-transcript{background-color:transparent;border-color:transparent;border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--beacon-system-color-text-tertiary);flex-direction:row;font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);gap:var(--override-button-default-gap, --beacon-reference-space-2);inline-size:inherit;margin-block:var(--beacon-reference-space-2);padding-block:var(--beacon-reference-space-3) var(--beacon-reference-space-3);padding-inline:0;text-align:start;word-break:initial}.video-view-transcript:is(:hover,:focus-visible):not([aria-disabled=true]){text-decoration:underline}.video-view-transcript span{display:flex}.video-view-transcript [aria-hidden=true]{display:contents}.video-view-transcript svg{color:var(--beacon-system-color-icon-tertiary);margin-inline:var(--beacon-reference-space-3) 0}.video-view-transcript svg:is(:hover,:focus-visible):not([aria-disabled=true]){color:var(--beacon-system-color-icon-tertiary-hover)}.video-view-transcript svg:active:not([aria-disabled=true]){color:var(--beacon-system-color-icon-tertiary-active)}.video-view-transcript [aria-disabled=true]{color:var(--beacon-system-color-icon-tertiary-inactive)}.transcript-text{font:var(--video-transcript-text-font, var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200))}:host{align-items:flex-start;align-self:stretch;background-color:var(--video-transcript-background-color);display:flex;flex-direction:column;gap:var(--beacon-system-space-micro-mini, 0)}:host .video-view-transcript,:host [beacon-tag-name=beacon-button]{--override-button-default-gap: 0;align-items:center;display:flex;justify-content:center}:host(.video-transcript-contained){--video-transcript-padding: var(--beacon-system-space-cell-contained);--video-transcript-background-color: var(--beacon-system-color-background-1)}:host(.video-transcript-contained) .video-view-transcript,:host(.video-transcript-contained) [beacon-tag-name=beacon-button]{padding-block:var(--beacon-reference-space-2) var(--beacon-reference-space-2);padding-inline:var(--override-transcript-button-padding-inline-start, var(--beacon-reference-space-5)) 0}:host(.video-transcript-free-floating){--video-transcript-padding: var(--beacon-system-space-cell-free-floating) 0;--video-transcript-background-color: transparent}:host(.video-transcript-free-floating) .video-view-transcript,:host(.video-transcript-free-floating) [beacon-tag-name=beacon-button]{padding:var(--beacon-reference-space-2) 0}.transcript-button ::part(standard-button){position:relative}.transcript-button ::part(standard-button):before{block-size:100%;content:"";inline-size:100%;position:absolute}`;
var ID = Object.defineProperty, BD = Object.getOwnPropertyDescriptor, Fr = (a, t, e, i) => {
  for (var o = i > 1 ? void 0 : i ? BD(t, e) : t, n = a.length - 1, l; n >= 0; n--)
    (l = a[n]) && (o = (i ? l(t, e, o) : l(o)) || o);
  return i && o && ID(t, e, o), o;
}, ma;
const Ln = (ma = class extends Le {
  constructor() {
    super(...arguments), this.beaconTagName = Na.beaconTagName, this.inline = !1, this.activeTranscriptIndex = 0;
  }
  static get styles() {
    return [super.styles, zD];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, DD];
  }
  handleClick() {
    this.modal ? this.modal.show() : console.error(
      "Beacon Modal with class 'video-transcript-beacon-modal' not found"
    );
  }
  addAnalyticsToIcon() {
    var t;
    if (this.inline) {
      const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector("svg");
      e && ns(e, "Video Transcript Icon - Inline");
    }
  }
  conditionallyRenderTranscripts() {
    var t;
    if (this.slottedTranscriptTexts && this.slottedTranscriptTexts.length > 1)
      for (let e = 1; e < this.slottedTranscriptTexts.length; e++)
        (t = this.slottedTranscriptTexts.at(e)) == null || t.style.setProperty("display", "none");
  }
  /**
   * Sets the index of `slottedTranscriptTexts` to `display: flex` and sets last active transcript element to `display:none`
   * @param {any} index: respective index of transcript text content
   */
  setActiveTranscript(t) {
    var e, i;
    this.activeTranscriptIndex === t || t >= this.slottedTranscriptTexts.length || ((e = this.slottedTranscriptTexts.at(this.activeTranscriptIndex)) == null || e.style.setProperty("display", "none"), (i = this.slottedTranscriptTexts.at(t)) == null || i.style.setProperty("display", ""), this.activeTranscriptIndex = t);
  }
  /** This function is called in render when inline is set to true which opens the transcript text below the video component */
  static renderInline() {
    return pe`<details>
      <summary>
        ${ze`
            <div
                class="video-view-transcript">
                <span class="transcript-label"><slot name="transcript-label">${Na.inlineLabel}</slot></span><span role="presentation">${gt(vf)}</span></div>`}
      </summary>
      <slot class="transcript-text"></slot>
    </details>`;
  }
  /** This function is called in render when inline is set to false which opens a modal with transcript text in it */
  renderModal() {
    return pe`${ze`<div class="transcript-button"><${this.getScopedTag("beacon-button")} variant="${Na.variant}" scale="${Na.scale}" class="video-view-transcript" @beacon-event-click=${this.handleClick}>
    <span class="transcript-label">
      <slot name="transcript-label">${Na.modalLabel}</slot>
    </span>
    ${gt(PD)}</${this.getScopedTag("beacon-button")}></div>
    <${this.getScopedTag("beacon-modal")} class="video-transcript-beacon-modal" scale="${Na.videoTranscriptModalScale}">
      <slot></slot>
    </${this.getScopedTag("beacon-modal")}>`}`;
  }
  render() {
    return pe`
      ${this.inline ? ma.renderInline() : this.renderModal()}
    `;
  }
}, ma.tagName = Na.beaconTagName, ma.nestedComponents = [tc, Er], ma);
Fr([
  ue({ type: Boolean })
], Ln.prototype, "inline", 2);
Fr([
  ot(".video-transcript-beacon-modal")
], Ln.prototype, "modal", 2);
Fr([
  De({ slot: "transcript-label", flatten: !0 })
], Ln.prototype, "slottedTranscriptLabel", 2);
Fr([
  Ct({ flatten: !0 })
], Ln.prototype, "slottedTranscriptTexts", 2);
Fr([
  Re
], Ln.prototype, "addAnalyticsToIcon", 1);
Fr([
  Re
], Ln.prototype, "conditionallyRenderTranscripts", 1);
let bz = Ln;
export {
  Aa as BeaconAccordion,
  GD as BeaconAccordionItem,
  vs as BeaconActionBar,
  WD as BeaconAnchorNavigation,
  vh as BeaconAreaChart,
  Nu as BeaconArticleTile,
  ju as BeaconAudio,
  Ah as BeaconBarChart,
  oi as BeaconBioCard,
  VD as BeaconBreadcrumbs,
  Er as BeaconButton,
  Zl as BeaconByline,
  qD as BeaconCarousel,
  tt as BeaconChartBase,
  Jl as BeaconCollectionTile,
  rg as BeaconContactTile,
  Uc as BeaconControl,
  hr as BeaconControlGroup,
  So as BeaconCountry,
  pr as BeaconCountrySelector,
  tn as BeaconDataList,
  wa as BeaconDividedList,
  Th as BeaconDividedListItem,
  ai as BeaconDivider,
  YD as BeaconDonutChart,
  Oh as BeaconDrawer,
  ec as BeaconError,
  Cs as BeaconFilterChip,
  bn as BeaconFooter,
  ZD as BeaconFootnote,
  Ng as BeaconFootnoteList,
  JD as BeaconGaugeChart,
  st as BeaconHero,
  ro as BeaconIcon,
  Qt as BeaconIconButton,
  _o as BeaconIdCard,
  Ss as BeaconInputChip,
  ur as BeaconKeyFacts,
  $g as BeaconLineChart,
  Dh as BeaconLoadingSpinner,
  tz as BeaconMapChart,
  As as BeaconMenu,
  zi as BeaconMeterChart,
  tc as BeaconModal,
  oz as BeaconMultiSelect,
  fP as BeaconMultiSelectOptgroup,
  iz as BeaconMultiSelectOption,
  ss as BeaconNavigation,
  rt as BeaconNavigationButton,
  Ov as BeaconNavigationExpanded,
  Xg as BeaconNavigationFooter,
  xa as BeaconNavigationPopover,
  br as BeaconNavigationToolbelt,
  az as BeaconNotification,
  nz as BeaconNotificationGroup,
  rz as BeaconPagination,
  Ii as BeaconPaginationButton,
  Co as BeaconPopover,
  oc as BeaconProgressIndicator,
  Nh as BeaconPromoTile,
  ni as BeaconQuoteBlock,
  im as BeaconRegionSelector,
  sz as BeaconScatterChart,
  gr as BeaconSegmentedControl,
  Kt as BeaconSegmentedControls,
  lm as BeaconSelectionTile,
  lz as BeaconSkeleton,
  mr as BeaconSocialLink,
  bm as BeaconSocialLinkContainer,
  Bt as BeaconTab,
  fr as BeaconTabPanel,
  Xk as BeaconTable,
  vd as BeaconTableHeader,
  Ad as BeaconTableRecord,
  fl as BeaconTableStub,
  cz as BeaconTabs,
  li as BeaconTile,
  dz as BeaconTooltip,
  vr as BeaconVideo,
  Uh as BeaconVideoPlaylist,
  ac as BeaconVideoTag,
  hz as BeaconVideoTile,
  bz as BeaconVideoTranscript
};
